var wue = Object.defineProperty;
var Cue = (e, t, n) => t in e ? wue(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Ki = (e, t, n) => Cue(e, typeof t != "symbol" ? t + "" : t, n);
import { jsx as d, Fragment as xe, jsxs as k } from "react/jsx-runtime";
import * as x from "react";
import F, { Fragment as Bs, forwardRef as te, createElement as dt, useState as re, useMemo as Je, useCallback as yr, useEffect as Pe, useRef as vt, useLayoutEffect as $g, createContext as Qt, useContext as en, Children as Wr, isValidElement as Pr, cloneElement as cn, useReducer as Sue, useImperativeHandle as Lg, useId as _ue, PureComponent as Yo, Component as rB, useDebugValue as iB } from "react";
import { a as of, M as ep, b as De, A as If } from "./conversations-B6_5aJ5K.js";
import { t as vi, h as oB, e as aB } from "./i18n-DoHK2p36.js";
import { f as jo, g as Eue } from "./localisationConfig-BfnSuGmH.js";
import { c as Ge, f as Nue } from "./react-COm4a01v.js";
import { c as z, a as at, b as Es, g as Rt } from "./tailwind-BXrsiEcF.js";
import { l as sB, k as bw, u as tn, j as ar, q as Aue, S as Oue, i as su, f as kue, h as lB, m as uB, n as cB, g as dB, a as Pue, d as Tue, P as St, e as Mue, b as Rue, p as Fg } from "./useGetSubdivisionType-CuJXxyQE.js";
import { useQueryClient as Due } from "@tanstack/react-query";
import "./services.gen-D7DK4RCL.js";
import { h as Iue, c as $ue, a as Lue, b as Fue, f as Bue, u as Bg } from "./useReviseConversationExpertResult-D8w2nkRT.js";
import * as go from "react-dom";
import Zo, { flushSync as fB } from "react-dom";
import { useFormContext as jue, Controller as Vue } from "react-hook-form";
import { FormProvider as itt, useController as ott, useFieldArray as att, useForm as stt, useFormContext as ltt, useWatch as utt } from "react-hook-form";
import { VicSmartEligibility as Vo } from "./types.js";
import { i as La, e as jA } from "./typePredicates-CHcjxMc5.js";
function que({
  template: e,
  renderFunctions: t
}) {
  const n = /\[\[([^\]]+)]]/g;
  return /* @__PURE__ */ d(xe, { children: (() => {
    const i = [];
    let o = 0, a;
    for (; (a = n.exec(e)) !== null; ) {
      const [s, l] = a, u = a.index;
      if (u > o) {
        const c = e.slice(o, u);
        i.push(
          /* @__PURE__ */ d(
            "span",
            {
              dangerouslySetInnerHTML: { __html: c }
            },
            `text-${o}`
          )
        );
      }
      t[l] ? i.push(
        /* @__PURE__ */ d(Bs, { children: t[l]() }, `${l}-${u}`)
      ) : i.push(
        /* @__PURE__ */ d(
          "span",
          {
            dangerouslySetInnerHTML: { __html: s }
          },
          `missing-${u}`
        )
      ), o = u + s.length;
    }
    if (o < e.length) {
      const s = e.slice(o);
      i.push(
        /* @__PURE__ */ d(
          "span",
          {
            dangerouslySetInnerHTML: { __html: s }
          },
          `text-${o}`
        )
      );
    }
    return i;
  })() });
}
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zue = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Wue = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, n, r) => r ? r.toUpperCase() : n.toLowerCase()
), VA = (e) => {
  const t = Wue(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, hB = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim(), Hue = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Uue = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gue = te(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: i = "",
    children: o,
    iconNode: a,
    ...s
  }, l) => dt(
    "svg",
    {
      ref: l,
      ...Uue,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: hB("lucide", i),
      ...!o && !Hue(s) && { "aria-hidden": "true" },
      ...s
    },
    [
      ...a.map(([u, c]) => dt(u, c)),
      ...Array.isArray(o) ? o : [o]
    ]
  )
);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ft = (e, t) => {
  const n = te(
    ({ className: r, ...i }, o) => dt(Gue, {
      ref: o,
      iconNode: t,
      className: hB(
        `lucide-${zue(VA(e))}`,
        `lucide-${e}`,
        r
      ),
      ...i
    })
  );
  return n.displayName = VA(e), n;
};
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kue = [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
], Yue = Ft("arrow-up", Kue);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zue = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], pB = Ft("calendar", Zue);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xue = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Gs = Ft("check", Xue);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jue = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], tp = Ft("chevron-down", Jue);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Que = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], ece = Ft("chevron-left", Que);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tce = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], mB = Ft("chevron-right", tce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nce = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], rce = Ft("chevron-up", nce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ice = [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
], oce = Ft("chevrons-up-down", ice);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ace = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], sce = Ft("circle-check", ace);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lce = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], uce = Ft("circle-question-mark", lce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cce = [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]], Yf = Ft("circle", cce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dce = [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], fce = Ft("eye-off", dce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hce = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M10 9H8", key: "b1mrlr" }],
  ["path", { d: "M16 13H8", key: "t4e002" }],
  ["path", { d: "M16 17H8", key: "z1uh3a" }]
], Nl = Ft("file-text", hce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pce = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], qA = Ft("frown", pce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mce = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], gce = Ft("info", mce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vce = [
  ["path", { d: "M10 12h11", key: "6m4ad9" }],
  ["path", { d: "M10 18h11", key: "11hvi2" }],
  ["path", { d: "M10 6h11", key: "c7qv1k" }],
  ["path", { d: "M4 10h2", key: "16xx2s" }],
  ["path", { d: "M4 6h1v4", key: "cnovpq" }],
  ["path", { d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1", key: "m9a95d" }]
], yce = Ft("list-ordered", vce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bce = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], Xo = Ft("loader-circle", bce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xce = [
  ["path", { d: "M3 12h.01", key: "nlz23k" }],
  ["path", { d: "M3 18h.01", key: "1tta3j" }],
  ["path", { d: "M3 6h.01", key: "1rqtza" }],
  ["path", { d: "M8 12h13", key: "1za7za" }],
  ["path", { d: "M8 18h13", key: "1lx6n3" }],
  ["path", { d: "M8 6h13", key: "ik3vkj" }]
], wce = Ft("list", xce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cce = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "8", x2: "16", y1: "15", y2: "15", key: "1xb1d9" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], zA = Ft("meh", Cce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sce = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }]
], _ce = Ft("panel-left", Sce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ece = [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["path", { d: "m9 20 3-6 3 6", key: "se2kox" }],
  ["path", { d: "m6 8 6 2 6-2", key: "4o3us4" }],
  ["path", { d: "M12 10v4", key: "1kjpxc" }]
], Al = Ft("person-standing", Ece);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nce = [
  ["line", { x1: "21", x2: "14", y1: "4", y2: "4", key: "obuewd" }],
  ["line", { x1: "10", x2: "3", y1: "4", y2: "4", key: "1q6298" }],
  ["line", { x1: "21", x2: "12", y1: "12", y2: "12", key: "1iu8h1" }],
  ["line", { x1: "8", x2: "3", y1: "12", y2: "12", key: "ntss68" }],
  ["line", { x1: "21", x2: "16", y1: "20", y2: "20", key: "14d8ph" }],
  ["line", { x1: "12", x2: "3", y1: "20", y2: "20", key: "m0wm8r" }],
  ["line", { x1: "14", x2: "14", y1: "2", y2: "6", key: "14e1ph" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "16", x2: "16", y1: "18", y2: "22", key: "1lctlv" }]
], Ace = Ft("sliders-horizontal", Nce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oce = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], WA = Ft("smile", Oce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kce = [
  ["path", { d: "M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6", key: "y09zxi" }],
  ["path", { d: "m21 3-9 9", key: "mpx6sq" }],
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }]
], Pce = Ft("square-arrow-out-up-right", kce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tce = [
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  [
    "path",
    {
      d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
      key: "m61m77"
    }
  ]
], mr = Ft("thumbs-down", Tce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mce = [
  ["path", { d: "M7 10v12", key: "1qc93n" }],
  [
    "path",
    {
      d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
      key: "emmmcr"
    }
  ]
], gr = Ft("thumbs-up", Mce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rce = [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], Dce = Ft("triangle-alert", Rce);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ice = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], np = Ft("x", Ice);
function $ce({
  content: e,
  onClickSubmit: t,
  onOpenChange: n,
  open: r,
  submitting: i,
  title: o,
  subTitle: a
}) {
  const [s, l] = re(!0), [u, c] = re(e);
  return /* @__PURE__ */ d(_2, { open: r, onOpenChange: n, children: /* @__PURE__ */ k(
    vp,
    {
      "aria-describedby": void 0,
      className: "flex max-h-[90%] flex-col gap-6 md:w-[80%] md:max-w-[80%] 2xl:max-w-[1280px]",
      children: [
        /* @__PURE__ */ k("div", { className: "flex flex-col gap-1", children: [
          /* @__PURE__ */ d(N2, { children: o }),
          a || null
        ] }),
        /* @__PURE__ */ d(
          tV,
          {
            value: u,
            onChange: (h) => {
              var m;
              Array.isArray(h.target.value) ? c(h.target.value.join(`
`)) : c(((m = h.target.value) == null ? void 0 : m.toString()) || "");
            }
          }
        ),
        /* @__PURE__ */ k("div", { className: "flex items-center gap-1", children: [
          /* @__PURE__ */ d("span", { className: "text-bodysm font-semibold", children: "Overwrite result: " }),
          /* @__PURE__ */ d(
            Np,
            {
              checked: s,
              onCheckedChange: l
            }
          )
        ] }),
        /* @__PURE__ */ k(E2, { children: [
          /* @__PURE__ */ d(
            et,
            {
              disabled: i,
              onClick: () => n(!1),
              variant: "outline",
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ k(et, { disabled: i, onClick: () => {
            t(u, s);
          }, children: [
            i ? /* @__PURE__ */ d(Xo, { className: "animate-spin" }) : null,
            "Amend"
          ] })
        ] })
      ]
    }
  ) });
}
function Lce({
  onOpenChange: e,
  open: t
}) {
  return /* @__PURE__ */ d(Jpe, { onOpenChange: e, open: t, children: /* @__PURE__ */ k(Xj, { children: [
    /* @__PURE__ */ d(Qj, { children: "You must create an issue first before amending" }),
    /* @__PURE__ */ d(Jj, { children: /* @__PURE__ */ d(eV, { autoFocus: !0, children: "Ok" }) })
  ] }) });
}
function gB({
  children: e,
  // conversation,
  expertName: t,
  noticeboardData: n,
  // outputKey,
  title: r,
  subTitle: i
}) {
  const o = Due(), [a, s] = re(!1), [l, u] = re(!1), { toast: c } = lY(), f = Je(() => {
    var y, w;
    return (y = n == null ? void 0 : n[t]) != null && y.raw_output ? (w = n == null ? void 0 : n[t]) == null ? void 0 : w.raw_output : "";
  }, [t, n]), { mutate: h, isPending: m } = Iue({
    onError: (y) => {
      console.error(
        "<EditExpertResultDialogContainer> useReviseConversationExpertResult()",
        y
      ), c({
        description: y.message,
        title: "Error updating expert result",
        variant: "destructive"
      });
    },
    onSuccess: () => {
      var y;
      console.log(
        "<EditExpertResultDialogContainer> useReviseConversationExpertResult()"
      ), o.invalidateQueries({
        queryKey: $ue({
          path: {
            conversation_id: ((y = n == null ? void 0 : n[t]) == null ? void 0 : y.conversation_id) || ""
          }
        })
      }), s(!1);
    }
  }), v = (y, w) => {
    const C = n == null ? void 0 : n[t];
    C && C.conversation_expert_result_id && h({
      body: {
        conversation_expert_result: C.conversation_expert_result_id,
        revision_type: w ? "OVERWRITE" : "REINSTRUCTED",
        text: y
      }
    });
  }, g = yr(() => {
    s(!0);
  }, []);
  return /* @__PURE__ */ k(xe, { children: [
    e({ setOpen: g }),
    /* @__PURE__ */ d(
      $ce,
      {
        content: f,
        onClickSubmit: v,
        onOpenChange: s,
        open: a,
        submitting: m,
        subTitle: i,
        title: r
      }
    ),
    /* @__PURE__ */ d(
      Lce,
      {
        onOpenChange: u,
        open: l
      }
    )
  ] });
}
const xw = 6048e5, Fce = 864e5, vB = 6e4, yB = 36e5, HA = Symbol.for("constructDateFrom");
function hn(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && HA in e ? e[HA](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function mt(e, t) {
  return hn(t || e, e);
}
function gn(e, t, n) {
  const r = mt(e, n == null ? void 0 : n.in);
  return isNaN(t) ? hn((n == null ? void 0 : n.in) || e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function ao(e, t, n) {
  const r = mt(e, n == null ? void 0 : n.in);
  if (isNaN(t)) return hn((n == null ? void 0 : n.in) || e, NaN);
  if (!t)
    return r;
  const i = r.getDate(), o = hn((n == null ? void 0 : n.in) || e, r.getTime());
  o.setMonth(r.getMonth() + t + 1, 0);
  const a = o.getDate();
  return i >= a ? o : (r.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    i
  ), r);
}
let Bce = {};
function rp() {
  return Bce;
}
function so(e, t) {
  var s, l, u, c;
  const n = rp(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((c = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, i = mt(e, t == null ? void 0 : t.in), o = i.getDay(), a = (o < r ? 7 : 0) + o - r;
  return i.setDate(i.getDate() - a), i.setHours(0, 0, 0, 0), i;
}
function Hl(e, t) {
  return so(e, { ...t, weekStartsOn: 1 });
}
function bB(e, t) {
  const n = mt(e, t == null ? void 0 : t.in), r = n.getFullYear(), i = hn(n, 0);
  i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
  const o = Hl(i), a = hn(n, 0);
  a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0);
  const s = Hl(a);
  return n.getTime() >= o.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function J1(e) {
  const t = mt(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function gd(e, ...t) {
  const n = hn.bind(
    null,
    e || t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function Ul(e, t) {
  const n = mt(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Po(e, t, n) {
  const [r, i] = gd(
    n == null ? void 0 : n.in,
    e,
    t
  ), o = Ul(r), a = Ul(i), s = +o - J1(o), l = +a - J1(a);
  return Math.round((s - l) / Fce);
}
function jce(e, t) {
  const n = bB(e, t), r = hn(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Hl(r);
}
function lx(e, t, n) {
  return gn(e, t * 7, n);
}
function Vce(e, t, n) {
  return ao(e, t * 12, n);
}
function qce(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((i) => {
    !r && typeof i == "object" && (r = hn.bind(null, i));
    const o = mt(i, r);
    (!n || n < o || isNaN(+o)) && (n = o);
  }), hn(r, n || NaN);
}
function zce(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((i) => {
    !r && typeof i == "object" && (r = hn.bind(null, i));
    const o = mt(i, r);
    (!n || n > o || isNaN(+o)) && (n = o);
  }), hn(r, n || NaN);
}
function Wce(e) {
  return hn(e, Date.now());
}
function Or(e, t, n) {
  const [r, i] = gd(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +Ul(r) == +Ul(i);
}
function ww(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Hce(e) {
  return !(!ww(e) && typeof e != "number" || isNaN(+mt(e)));
}
function Zf(e, t, n) {
  const [r, i] = gd(
    n == null ? void 0 : n.in,
    e,
    t
  ), o = r.getFullYear() - i.getFullYear(), a = r.getMonth() - i.getMonth();
  return o * 12 + a;
}
function Uce(e, t, n) {
  const [r, i] = gd(
    n == null ? void 0 : n.in,
    e,
    t
  ), o = so(r, n), a = so(i, n), s = +o - J1(o), l = +a - J1(a);
  return Math.round((s - l) / xw);
}
function UA(e, t) {
  const n = mt(e, t == null ? void 0 : t.in);
  return n.setHours(23, 59, 59, 999), n;
}
function Cw(e, t) {
  const n = mt(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Hr(e, t) {
  const n = mt(e, t == null ? void 0 : t.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function xB(e, t) {
  const n = mt(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Sw(e, t) {
  var s, l, u, c;
  const n = rp(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((c = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, i = mt(e, t == null ? void 0 : t.in), o = i.getDay(), a = (o < r ? -7 : 0) + 6 - (o - r);
  return i.setDate(i.getDate() + a), i.setHours(23, 59, 59, 999), i;
}
function wB(e, t) {
  return Sw(e, { ...t, weekStartsOn: 1 });
}
const Gce = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Kce = (e, t, n) => {
  let r;
  const i = Gce[e];
  return typeof i == "string" ? r = i : t === 1 ? r = i.one : r = i.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function bb(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const Yce = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Zce = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Xce = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Jce = {
  date: bb({
    formats: Yce,
    defaultWidth: "full"
  }),
  time: bb({
    formats: Zce,
    defaultWidth: "full"
  }),
  dateTime: bb({
    formats: Xce,
    defaultWidth: "full"
  })
}, Qce = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, ede = (e, t, n, r) => Qce[e];
function af(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let i;
    if (r === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : a;
      i = e.formattingValues[s] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[s] || e.values[a];
    }
    const o = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[o];
  };
}
const tde = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, nde = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, rde = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, ide = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, ode = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, ade = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, sde = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, lde = {
  ordinalNumber: sde,
  era: af({
    values: tde,
    defaultWidth: "wide"
  }),
  quarter: af({
    values: nde,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: af({
    values: rde,
    defaultWidth: "wide"
  }),
  day: af({
    values: ide,
    defaultWidth: "wide"
  }),
  dayPeriod: af({
    values: ode,
    defaultWidth: "wide",
    formattingValues: ade,
    defaultFormattingWidth: "wide"
  })
};
function sf(e) {
  return (t, n = {}) => {
    const r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = t.match(i);
    if (!o)
      return null;
    const a = o[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? cde(s, (f) => f.test(a)) : (
      // [TODO] -- I challenge you to fix the type
      ude(s, (f) => f.test(a))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(l) : l, u = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(u)
    ) : u;
    const c = t.slice(a.length);
    return { value: u, rest: c };
  };
}
function ude(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function cde(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function dde(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const i = r[0], o = t.match(e.parsePattern);
    if (!o) return null;
    let a = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const s = t.slice(i.length);
    return { value: a, rest: s };
  };
}
const fde = /^(\d+)(th|st|nd|rd)?/i, hde = /\d+/i, pde = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, mde = {
  any: [/^b/i, /^(a|c)/i]
}, gde = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, vde = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, yde = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, bde = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, xde = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, wde = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Cde = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Sde = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, _de = {
  ordinalNumber: dde({
    matchPattern: fde,
    parsePattern: hde,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: sf({
    matchPatterns: pde,
    defaultMatchWidth: "wide",
    parsePatterns: mde,
    defaultParseWidth: "any"
  }),
  quarter: sf({
    matchPatterns: gde,
    defaultMatchWidth: "wide",
    parsePatterns: vde,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: sf({
    matchPatterns: yde,
    defaultMatchWidth: "wide",
    parsePatterns: bde,
    defaultParseWidth: "any"
  }),
  day: sf({
    matchPatterns: xde,
    defaultMatchWidth: "wide",
    parsePatterns: wde,
    defaultParseWidth: "any"
  }),
  dayPeriod: sf({
    matchPatterns: Cde,
    defaultMatchWidth: "any",
    parsePatterns: Sde,
    defaultParseWidth: "any"
  })
}, CB = {
  code: "en-US",
  formatDistance: Kce,
  formatLong: Jce,
  formatRelative: ede,
  localize: lde,
  match: _de,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Ede(e, t) {
  const n = mt(e, t == null ? void 0 : t.in);
  return Po(n, xB(n)) + 1;
}
function SB(e, t) {
  const n = mt(e, t == null ? void 0 : t.in), r = +Hl(n) - +jce(n);
  return Math.round(r / xw) + 1;
}
function _B(e, t) {
  var c, f, h, m;
  const n = mt(e, t == null ? void 0 : t.in), r = n.getFullYear(), i = rp(), o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((m = (h = i.locale) == null ? void 0 : h.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, a = hn((t == null ? void 0 : t.in) || e, 0);
  a.setFullYear(r + 1, 0, o), a.setHours(0, 0, 0, 0);
  const s = so(a, t), l = hn((t == null ? void 0 : t.in) || e, 0);
  l.setFullYear(r, 0, o), l.setHours(0, 0, 0, 0);
  const u = so(l, t);
  return +n >= +s ? r + 1 : +n >= +u ? r : r - 1;
}
function Nde(e, t) {
  var s, l, u, c;
  const n = rp(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((c = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, i = _B(e, t), o = hn((t == null ? void 0 : t.in) || e, 0);
  return o.setFullYear(i, 0, r), o.setHours(0, 0, 0, 0), so(o, t);
}
function EB(e, t) {
  const n = mt(e, t == null ? void 0 : t.in), r = +so(n, t) - +Nde(n, t);
  return Math.round(r / xw) + 1;
}
function ht(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const ds = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return ht(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : ht(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return ht(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return ht(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return ht(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return ht(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return ht(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), i = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return ht(i, t.length);
  }
}, Ru = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, GA = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), i = r > 0 ? r : 1 - r;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return ds.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const i = _B(e, r), o = i > 0 ? i : 1 - i;
    if (t === "YY") {
      const a = o % 100;
      return ht(a, 2);
    }
    return t === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : ht(o, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = bB(e);
    return ht(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return ht(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return ht(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return ht(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return ds.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return ht(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const i = EB(e, r);
    return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : ht(i, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = SB(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : ht(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : ds.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = Ede(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : ht(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const i = e.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return ht(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const i = e.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return ht(o, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), i = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return ht(i, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const i = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let i;
    switch (r === 12 ? i = Ru.noon : r === 0 ? i = Ru.midnight : i = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let i;
    switch (r >= 17 ? i = Ru.evening : r >= 12 ? i = Ru.afternoon : r >= 4 ? i = Ru.morning : i = Ru.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return ds.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : ds.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : ht(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : ht(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : ds.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : ds.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return ds.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return YA(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return bl(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return bl(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return YA(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return bl(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return bl(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + KA(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + bl(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + KA(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + bl(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return ht(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return ht(+e, t.length);
  }
};
function KA(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.trunc(r / 60), o = r % 60;
  return o === 0 ? n + String(i) : n + String(i) + t + ht(o, 2);
}
function YA(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + ht(Math.abs(e) / 60, 2) : bl(e, t);
}
function bl(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = ht(Math.trunc(r / 60), 2), o = ht(r % 60, 2);
  return n + i + t + o;
}
const ZA = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, NB = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Ade = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
  if (!i)
    return ZA(e, t);
  let o;
  switch (r) {
    case "P":
      o = t.dateTime({ width: "short" });
      break;
    case "PP":
      o = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = t.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", ZA(r, t)).replace("{{time}}", NB(i, t));
}, Ode = {
  p: NB,
  P: Ade
}, kde = /^D+$/, Pde = /^Y+$/, Tde = ["D", "DD", "YY", "YYYY"];
function Mde(e) {
  return kde.test(e);
}
function Rde(e) {
  return Pde.test(e);
}
function Dde(e, t, n) {
  const r = Ide(e, t, n);
  if (console.warn(r), Tde.includes(e)) throw new RangeError(r);
}
function Ide(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const $de = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Lde = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Fde = /^'([^]*?)'?$/, Bde = /''/g, jde = /[a-zA-Z]/;
function sn(e, t, n) {
  var c, f, h, m, v, g, y, w;
  const r = rp(), i = (n == null ? void 0 : n.locale) ?? r.locale ?? CB, o = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((f = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((m = (h = r.locale) == null ? void 0 : h.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, a = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (v = n == null ? void 0 : n.locale) == null ? void 0 : v.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((w = (y = r.locale) == null ? void 0 : y.options) == null ? void 0 : w.weekStartsOn) ?? 0, s = mt(e, n == null ? void 0 : n.in);
  if (!Hce(s))
    throw new RangeError("Invalid time value");
  let l = t.match(Lde).map((C) => {
    const S = C[0];
    if (S === "p" || S === "P") {
      const N = Ode[S];
      return N(C, i.formatLong);
    }
    return C;
  }).join("").match($de).map((C) => {
    if (C === "''")
      return { isToken: !1, value: "'" };
    const S = C[0];
    if (S === "'")
      return { isToken: !1, value: Vde(C) };
    if (GA[S])
      return { isToken: !0, value: C };
    if (S.match(jde))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + S + "`"
      );
    return { isToken: !1, value: C };
  });
  i.localize.preprocessor && (l = i.localize.preprocessor(s, l));
  const u = {
    firstWeekContainsDate: o,
    weekStartsOn: a,
    locale: i
  };
  return l.map((C) => {
    if (!C.isToken) return C.value;
    const S = C.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Rde(S) || !(n != null && n.useAdditionalDayOfYearTokens) && Mde(S)) && Dde(S, t, String(e));
    const N = GA[S[0]];
    return N(s, S, i.localize, u);
  }).join("");
}
function Vde(e) {
  const t = e.match(Fde);
  return t ? t[1].replace(Bde, "'") : e;
}
function $f(e, t) {
  const n = mt(e, t == null ? void 0 : t.in);
  if (isNaN(+n))
    throw new RangeError("Invalid time value");
  let r = "", i = "";
  const o = "-", a = ":";
  {
    const s = ht(n.getDate(), 2), l = ht(n.getMonth() + 1, 2);
    r = `${ht(n.getFullYear(), 4)}${o}${l}${o}${s}`;
  }
  {
    const s = n.getTimezoneOffset();
    if (s !== 0) {
      const m = Math.abs(s), v = ht(Math.trunc(m / 60), 2), g = ht(m % 60, 2);
      i = `${s < 0 ? "+" : "-"}${v}:${g}`;
    } else
      i = "Z";
    const l = ht(n.getHours(), 2), u = ht(n.getMinutes(), 2), c = ht(n.getSeconds(), 2), f = r === "" ? "" : "T", h = [l, u, c].join(a);
    r = `${r}${f}${h}${i}`;
  }
  return r;
}
function qde(e, t) {
  const n = mt(e, t == null ? void 0 : t.in), r = n.getFullYear(), i = n.getMonth(), o = hn(n, 0);
  return o.setFullYear(r, i + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function zde(e) {
  return Math.trunc(+mt(e) / 1e3);
}
function Wde(e, t) {
  const n = mt(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(0, 0, 0, 0), mt(n, t == null ? void 0 : t.in);
}
function Hde(e, t) {
  const n = mt(e, t == null ? void 0 : t.in);
  return Uce(
    Wde(n, t),
    Hr(n, t),
    t
  ) + 1;
}
function ux(e, t) {
  return +mt(e) > +mt(t);
}
function AB(e, t) {
  return +mt(e) < +mt(t);
}
function _w(e, t, n) {
  const [r, i] = gd(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === i.getFullYear() && r.getMonth() === i.getMonth();
}
function Ude(e, t, n) {
  const [r, i] = gd(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === i.getFullYear();
}
function Gde(e, t) {
  return Or(
    hn(e, e),
    Wce(e)
  );
}
function xb(e, t, n) {
  return gn(e, -t, n);
}
function To(e, t) {
  const n = () => hn(t == null ? void 0 : t.in, NaN), i = Xde(e);
  let o;
  if (i.date) {
    const u = Jde(i.date, 2);
    o = Qde(u.restDateString, u.year);
  }
  if (!o || isNaN(+o)) return n();
  const a = +o;
  let s = 0, l;
  if (i.time && (s = efe(i.time), isNaN(s)))
    return n();
  if (i.timezone) {
    if (l = tfe(i.timezone), isNaN(l)) return n();
  } else {
    const u = new Date(a + s), c = mt(0, t == null ? void 0 : t.in);
    return c.setFullYear(
      u.getUTCFullYear(),
      u.getUTCMonth(),
      u.getUTCDate()
    ), c.setHours(
      u.getUTCHours(),
      u.getUTCMinutes(),
      u.getUTCSeconds(),
      u.getUTCMilliseconds()
    ), c;
  }
  return mt(a + s + l, t == null ? void 0 : t.in);
}
const T0 = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, Kde = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Yde = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, Zde = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Xde(e) {
  const t = {}, n = e.split(T0.dateTimeDelimiter);
  let r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], T0.timeZoneDelimiter.test(t.date) && (t.date = e.split(T0.timeZoneDelimiter)[0], r = e.substr(
    t.date.length,
    e.length
  ))), r) {
    const i = T0.timezone.exec(r);
    i ? (t.time = r.replace(i[1], ""), t.timezone = i[1]) : t.time = r;
  }
  return t;
}
function Jde(e, t) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), r = e.match(n);
  if (!r) return { year: NaN, restDateString: "" };
  const i = r[1] ? parseInt(r[1]) : null, o = r[2] ? parseInt(r[2]) : null;
  return {
    year: o === null ? i : o * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function Qde(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  const n = e.match(Kde);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const r = !!n[4], i = lf(n[1]), o = lf(n[2]) - 1, a = lf(n[3]), s = lf(n[4]), l = lf(n[5]) - 1;
  if (r)
    return afe(t, s, l) ? nfe(t, s, l) : /* @__PURE__ */ new Date(NaN);
  {
    const u = /* @__PURE__ */ new Date(0);
    return !ife(t, o, a) || !ofe(t, i) ? /* @__PURE__ */ new Date(NaN) : (u.setUTCFullYear(t, o, Math.max(i, a)), u);
  }
}
function lf(e) {
  return e ? parseInt(e) : 1;
}
function efe(e) {
  const t = e.match(Yde);
  if (!t) return NaN;
  const n = wb(t[1]), r = wb(t[2]), i = wb(t[3]);
  return sfe(n, r, i) ? n * yB + r * vB + i * 1e3 : NaN;
}
function wb(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function tfe(e) {
  if (e === "Z") return 0;
  const t = e.match(Zde);
  if (!t) return 0;
  const n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), i = t[3] && parseInt(t[3]) || 0;
  return lfe(r, i) ? n * (r * yB + i * vB) : NaN;
}
function nfe(e, t, n) {
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  const i = r.getUTCDay() || 7, o = (t - 1) * 7 + n + 1 - i;
  return r.setUTCDate(r.getUTCDate() + o), r;
}
const rfe = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function OB(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function ife(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (rfe[t] || (OB(e) ? 29 : 28));
}
function ofe(e, t) {
  return t >= 1 && t <= (OB(e) ? 366 : 365);
}
function afe(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function sfe(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function lfe(e, t) {
  return t >= 0 && t <= 59;
}
function D1(e, t, n) {
  const r = mt(e, n == null ? void 0 : n.in), i = r.getFullYear(), o = r.getDate(), a = hn(e, 0);
  a.setFullYear(i, t, 15), a.setHours(0, 0, 0, 0);
  const s = qde(a);
  return r.setMonth(t, Math.min(o, s)), r;
}
function ufe(e, t, n) {
  let r = mt(e, n == null ? void 0 : n.in);
  return isNaN(+r) ? hn(e, NaN) : (t.year != null && r.setFullYear(t.year), t.month != null && (r = D1(r, t.month)), t.date != null && r.setDate(t.date), t.hours != null && r.setHours(t.hours), t.minutes != null && r.setMinutes(t.minutes), t.seconds != null && r.setSeconds(t.seconds), t.milliseconds != null && r.setMilliseconds(t.milliseconds), r);
}
function XA(e, t, n) {
  const r = mt(e, n == null ? void 0 : n.in);
  return isNaN(+r) ? hn(e, NaN) : (r.setFullYear(t), r);
}
function cfe({
  onChangeSelectedRevisionId: e,
  revisions: t,
  selectedRevisionId: n
}) {
  const r = Je(() => t.map((i) => ({
    id: i.id,
    content: i.revised_by,
    icon: "",
    title: /* @__PURE__ */ k("div", { className: "flex gap-2 whitespace-nowrap", children: [
      i.created_at ? sn(i.created_at, "dd-MM-yyyy HH:mm") : "",
      /* @__PURE__ */ d(Owe, { className: "text-bodyxs", children: i.revision_type })
    ] })
  })), [t]);
  return /* @__PURE__ */ d(
    kwe,
    {
      itemClassName: "px-2 pt-2",
      items: r,
      onClick: e,
      selectedId: n
    }
  );
}
function dfe({
  onOpenChange: e,
  open: t,
  revisions: n,
  subTitle: r,
  title: i
}) {
  const [o, a] = re(
    null
  ), s = Je(() => n.find((l) => l.id === o), [n, o]);
  return Pe(() => {
    n.length > 0 && !o && n[0].id && a(n[0].id);
  }, [n, o]), /* @__PURE__ */ d(_2, { open: t, onOpenChange: e, children: /* @__PURE__ */ k(
    vp,
    {
      "aria-describedby": void 0,
      className: "flex h-full max-h-[90%] w-full flex-col gap-6 md:w-[80%] md:max-w-[80%] 2xl:max-w-[1280px]",
      disableAnimation: !0,
      onKeyDown: (l) => {
        console.log("onKeyDown", l.key), l.key === "ArrowUp" ? (l.preventDefault(), a((u) => {
          const c = n.findIndex((f) => f.id === u);
          return c > 0 ? n[c - 1].id : u;
        })) : l.key === "ArrowDown" && (l.preventDefault(), a((u) => {
          const c = n.findIndex((f) => f.id === u);
          return c < n.length - 1 ? n[c + 1].id : u;
        }));
      },
      children: [
        /* @__PURE__ */ k("div", { className: "flex flex-col gap-1", children: [
          /* @__PURE__ */ d(N2, { children: i }),
          r || null
        ] }),
        /* @__PURE__ */ k("div", { className: "flex h-full gap-2 overflow-hidden", children: [
          /* @__PURE__ */ d(
            cfe,
            {
              onChangeSelectedRevisionId: a,
              revisions: n || [],
              selectedRevisionId: o
            }
          ),
          /* @__PURE__ */ d("div", { className: "border-interfaceBorder h-full overflow-auto rounded border p-2", children: Ge((s == null ? void 0 : s.raw_output) || "") })
        ] }),
        /* @__PURE__ */ d(E2, { children: /* @__PURE__ */ d(et, { onClick: () => e(!1), children: "Close" }) })
      ]
    }
  ) });
}
function kB({
  children: e,
  expertName: t,
  noticeboardData: n,
  subTitle: r,
  title: i
}) {
  const [o, a] = re(!1), s = Je(() => {
    var l, u;
    return (l = n == null ? void 0 : n[t]) != null && l.revisions ? (u = n == null ? void 0 : n[t]) == null ? void 0 : u.revisions : [];
  }, [t, n]);
  return /* @__PURE__ */ k(xe, { children: [
    e({ setOpen: a }),
    /* @__PURE__ */ d(
      dfe,
      {
        onOpenChange: a,
        open: o,
        revisions: s,
        subTitle: r,
        title: i
      }
    )
  ] });
}
function qo({
  allowEditing: e,
  children: t,
  conversation: n,
  expertName: r,
  noticeboardData: i,
  outputKey: o
}) {
  const { hasRevisions: a } = sB({ expertName: r, noticeboardData: i });
  return e ? /* @__PURE__ */ k("div", { className: "relative my-1 p-1", children: [
    /* @__PURE__ */ k("div", { className: "bg-blueBorder absolute right-0 top-[-25px] flex items-center gap-2 rounded-sm p-1", children: [
      a && /* @__PURE__ */ d("div", { title: "This section has revisions", children: /* @__PURE__ */ d(Dce, { className: "h-4 w-4 text-orange-500" }) }),
      /* @__PURE__ */ k("span", { className: "text-bodyxs text-textPrimary font-semibold", children: [
        r,
        o && ` --> ${o}`
      ] }),
      /* @__PURE__ */ d(
        gB,
        {
          conversation: n,
          expertName: r,
          noticeboardData: i,
          outputKey: o,
          subTitle: /* @__PURE__ */ k("p", { className: "text-bodysm font-semibold", children: [
            "Expert:",
            " ",
            /* @__PURE__ */ k("span", { className: "text-textSubdued", children: [
              r,
              o && ` --> ${o}`
            ] })
          ] }),
          title: "Amend expert result",
          children: ({ setOpen: s }) => /* @__PURE__ */ d(
            et,
            {
              className: "text-bodyxs px-1",
              onClick: () => s(!0),
              size: "tight",
              variant: "outline",
              children: "Amend"
            }
          )
        }
      ),
      a ? /* @__PURE__ */ d(
        kB,
        {
          expertName: r,
          noticeboardData: i,
          subTitle: /* @__PURE__ */ k("p", { className: "text-bodysm font-semibold", children: [
            "Expert:",
            " ",
            /* @__PURE__ */ k("span", { className: "text-textSubdued", children: [
              r,
              o && ` --> ${o}`
            ] })
          ] }),
          title: "Expert result revisions",
          children: ({ setOpen: s }) => /* @__PURE__ */ d(
            et,
            {
              className: "text-bodyxs px-1",
              onClick: () => s(!0),
              size: "tight",
              variant: "outline",
              children: "Revisions"
            }
          )
        }
      ) : null
    ] }),
    /* @__PURE__ */ d("div", { className: "border-blueBorder rounded-xs pointer-events-none absolute inset-0 border border-dashed" }),
    t
  ] }) : /* @__PURE__ */ d(xe, { children: t });
}
const Du = {
  DEFAULT: "default",
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
  DANGER: "danger"
};
function uf(e) {
  const t = new CustomEvent(e);
  document.dispatchEvent(t);
}
function Ew({
  children: e,
  className: t,
  title: n,
  translate: r,
  type: i = Du.DEFAULT
}) {
  return /* @__PURE__ */ k(
    "div",
    {
      className: z(
        "text-textPrimary text-bodymd flex flex-col gap-1 rounded border-l-4 px-5 py-4",
        {
          "bg-interfaceBgDefault border-interfaceBorder": i === Du.DEFAULT
        },
        {
          "bg-greenBgLight border-greenDefault": i === Du.SUCCESS
        },
        {
          "bg-blueBgLight border-blueDefault": i === Du.INFO
        },
        {
          "bg-yellowBgLight border-yellowDefault": i === Du.WARNING
        },
        {
          "bg-redBgLight border-redDefault": i === Du.DANGER
        },
        t
      ),
      children: [
        /* @__PURE__ */ d("h3", { className: "text-headingmd", children: n }),
        typeof e == "string" ? /* @__PURE__ */ d("div", { children: /* @__PURE__ */ d(
          que,
          {
            template: e,
            renderFunctions: {
              navigate_permit_requirements: () => /* @__PURE__ */ d(
                "a",
                {
                  className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
                  onClick: () => {
                    uf(
                      of.SHOW_PERMIT_REQUIREMENTS
                    );
                  },
                  children: r == null ? void 0 : r.getText("permit requirements")
                }
              ),
              navigate_application_requirements: () => /* @__PURE__ */ d(
                "a",
                {
                  className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
                  onClick: () => {
                    uf(
                      of.SHOW_APPLICATION_REQUIREMENTS
                    );
                  },
                  children: r == null ? void 0 : r.getText("application requirements")
                }
              ),
              navigate_lot_and_proposal: () => /* @__PURE__ */ d(
                "a",
                {
                  className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
                  onClick: () => {
                    uf(
                      of.SHOW_LOT_AND_PROPOSAL
                    );
                  },
                  children: r == null ? void 0 : r.getText("lot and proposal")
                }
              ),
              navigate_next_steps: () => /* @__PURE__ */ d(
                "a",
                {
                  className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
                  onClick: () => {
                    uf(of.SHOW_NEXT_STEPS);
                  },
                  children: r == null ? void 0 : r.getText("next steps")
                }
              ),
              restart_conversation: () => /* @__PURE__ */ d(
                "a",
                {
                  className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
                  onClick: () => {
                    uf(
                      of.RESTART_CONVERSATION
                    );
                  },
                  children: r == null ? void 0 : r.getText("restart")
                }
              )
            }
          }
        ) }) : e
      ]
    }
  );
}
function ffe({
  conversation: e,
  translate: t
}) {
  const r = bw({
    messages: (e == null ? void 0 : e.messages) || [],
    messageType: ep.ROUTING_QUESTION
  }).at(0);
  if (!r) return;
  const i = r.question_data || {};
  if ("application_requirements_callouts" in i && Array.isArray(i.application_requirements_callouts))
    return i.application_requirements_callouts.map(
      (o) => /* @__PURE__ */ d(
        Ew,
        {
          title: o.title,
          translate: t,
          type: o.color,
          children: o.content
        },
        r.id
      )
    );
}
function hfe(e, t, n) {
  var a, s;
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), { content: i, parsedOutput: o = {} } = r(
    `${n}.vic_smart_eligibility`
  );
  return "<1>" in o && ((a = o["<1>"]) == null ? void 0 : a.toLowerCase()) !== "n/a" ? "eligible" : "<2>" in o && ((s = o["<2>"]) == null ? void 0 : s.toLowerCase()) !== "n/a" ? "ineligible" : parseInt(i) === 1 ? "eligible" : parseInt(i) === 2 ? "ineligible" : "unknown";
}
function pfe(e, t, n) {
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), { content: i } = r(
    `${n}.missing_information`
  );
  return i;
}
function mfe(e, t, n) {
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), {
    expert_name: i = "",
    output_key: o = "",
    content: a
  } = r(`${n}.application_requirements`);
  return { expert_name: i, output_key: o, applicationRequirementsText: a };
}
function gfe(e, t, n) {
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), {
    expert_name: i = "",
    output_key: o = "",
    content: a
  } = r(`${n}.report_abstract`);
  return { expert_name: i, output_key: o, reportAbstractText: a };
}
function vfe(e, t, n) {
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), {
    expert_name: i = "",
    output_key: o = "",
    content: a
  } = r(`${n}.report_heading`);
  return { expert_name: i, output_key: o, reportHeadingText: a };
}
function PB(e, t, n) {
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), {
    expert_name: i = "",
    output_key: o = "",
    content: a
  } = r(`${n}.mandatory_requirements`);
  return { expert_name: i, output_key: o, mandatoryRequirementsText: a };
}
function yfe(e, t, n) {
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), { parsedOutput: i = {} } = r(
    `${n}.show_mandatory_requirements`
  );
  return "<1>" in i ? !0 : !!("eligibility_status" in i && ["ELIGIBLE", "ELIGIBLE_MISSING_INFO", "ELIGIBLE_EXCEEDED"].includes(
    i.eligibility_status
  ));
}
function bfe(e, t, n) {
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), { parsedOutput: i = {} } = r(
    `${n}.design_and_sitting_clause`
  );
  return i.rescode;
}
function gQe(e, t, n) {
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), { content: i } = r(`${n}.features_in_testing`);
  return i;
}
function JA({
  allowEditing: e,
  configPrefix: t,
  conversation: n,
  noticeboardData: r
}) {
  const { getLocalisationEntry: i } = ar(n), o = i("councilOrdinanceLink"), a = (c) => Ge(c, {
    components: {
      h1({ children: f }) {
        return /* @__PURE__ */ d("h5", { className: "text-bodymd font-bold", children: f });
      },
      h2({ children: f }) {
        return /* @__PURE__ */ d("h5", { className: "text-bodymd font-bold", children: f });
      },
      h3({ children: f }) {
        return /* @__PURE__ */ d("h5", { className: "text-bodymd font-bold", children: f });
      },
      h4({ children: f }) {
        return /* @__PURE__ */ d("h5", { className: "text-bodymd font-bold", children: f });
      }
    },
    ordinanceLink: o
  }), { expert_name: s, output_key: l, applicationRequirementsText: u } = mfe(n, r, t);
  return /* @__PURE__ */ d(
    qo,
    {
      allowEditing: e,
      expertName: s,
      conversation: n,
      noticeboardData: r,
      outputKey: l,
      children: a(u)
    }
  );
}
function xfe({
  eligibility: e,
  translate: t = vi
}) {
  switch (e) {
    case Vo.eligible:
      return /* @__PURE__ */ d("span", { className: "text-bodymd bg-successBgDefault w-min whitespace-nowrap rounded-xl px-2 py-0.5 text-[#005C41]", children: t.getText("Potentially eligible") });
    case Vo.ineligible:
    default:
      return /* @__PURE__ */ d("span", { className: "text-bodymd text-destructiveText bg-destructiveBgDefault w-min whitespace-nowrap rounded-xl px-2 py-0.5", children: t.getText("Ineligible") });
  }
}
function QA({
  allowEditing: e,
  configPrefix: t,
  conversation: n,
  isVicSmartStandardApplicationRequirementsEnabled: r,
  messages: i,
  noticeboardData: o,
  printable: a,
  translate: s = vi
}) {
  var I, j;
  const { getConfig: l } = tn({
    conversation: n,
    noticeboardData: o
  }), {
    expert_name: u = "",
    output_key: c,
    content: f
  } = l(`${t}.vic_smart`), { content: h } = l(
    `${t}.vic_smart_application_requirements`
  ), { content: m } = l(
    `${t}.application_requirements`
  ), v = hfe(
    n,
    o,
    t
  ), g = v === Vo.eligible, { getLocalisationEntry: y } = ar(n), w = y("councilOrdinanceLink"), C = y("councilContactLink"), S = y(
    "councilApplicationGuideLink"
  ), N = Aue(n, o), E = !!N && N !== Oue["n/a"] && ((j = (I = n == null ? void 0 : n.address_data) == null ? void 0 : I.state) == null ? void 0 : j.toUpperCase()) === "VIC", A = (B) => Ge(B, {
    components: {
      h1({ children: q }) {
        return /* @__PURE__ */ d("h5", { className: "text-bodymd font-bold", children: q });
      },
      h2({ children: q }) {
        return /* @__PURE__ */ d("h5", { className: "text-bodymd font-bold", children: q });
      },
      h3({ children: q }) {
        return /* @__PURE__ */ d("h5", { className: "text-bodymd font-bold", children: q });
      },
      h4({ children: q }) {
        return /* @__PURE__ */ d("h5", { className: "text-bodymd font-bold", children: q });
      }
    },
    ordinanceLink: w
  }), O = () => /* @__PURE__ */ k(xe, { children: [
    /* @__PURE__ */ d("p", { children: s.getText(
      "When you apply for a planning permit through the standard pathway, what you need to provide will depend on your proposal, and the overlays and zone that apply to the property."
    ) }),
    /* @__PURE__ */ k(
      "a",
      {
        className: "text-textLink hover:text-textLinkHover flex cursor-pointer items-center gap-1 underline",
        href: S,
        rel: "noreferrer",
        tabIndex: 0,
        target: "_blank",
        children: [
          s.getText("Read our application guide"),
          " ",
          /* @__PURE__ */ d(Mqe, {})
        ]
      }
    )
  ] }), T = () => {
    var B;
    return /* @__PURE__ */ k(xe, { children: [
      /* @__PURE__ */ d("p", { children: s.interpolate(
        "{{contactLink}} to speak to one of our planners and discuss your standard application requirements. When you contact us, tell us your session ID:",
        {
          contactLink: /* @__PURE__ */ d(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
              href: C,
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: s.getText("Contact Council")
            }
          )
        }
      ) }),
      /* @__PURE__ */ d("span", { className: "text-bodylg border-interactiveBorder w-min rounded border px-2 py-1.5 font-medium tracking-[2.7px] whitespace-nowrap", children: ((B = n == null ? void 0 : n.identifier) == null ? void 0 : B.toUpperCase()) || "" })
    ] });
  }, M = () => m ? A(m) : /* @__PURE__ */ k("p", { className: "text-textPrimary text-bodylg flex items-center gap-1", children: [
    /* @__PURE__ */ d(Xo, { className: "animate-spin" }),
    " Generating..."
  ] }), L = () => /* @__PURE__ */ k("div", { className: "text-textPrimary", children: [
    /* @__PURE__ */ d("h3", { className: "text-headingmd", children: s == null ? void 0 : s.getText("☝️Check with a licensed land surveyor") }),
    /* @__PURE__ */ d("div", { className: "text-bodymd", children: s == null ? void 0 : s.getText(
      "Some types of subdivision can be applied for through VicSmart, such as:"
    ) }),
    /* @__PURE__ */ k("ul", { className: "text-bodymd mt-1 list-inside list-disc pl-4", children: [
      /* @__PURE__ */ d("li", { children: s == null ? void 0 : s.getText("realigning a common boundary") }),
      /* @__PURE__ */ d("li", { children: s == null ? void 0 : s.getText("subdividing buildings and car parking spaces") }),
      /* @__PURE__ */ d("li", { children: s == null ? void 0 : s.getText("some 2-lot subdivisions in rural areas") }),
      /* @__PURE__ */ d("li", { children: s == null ? void 0 : s.getText(
        "compliant 2-lot subdivisions in residential areas"
      ) })
    ] }),
    /* @__PURE__ */ d("div", { className: "text-bodymd mt-2", children: s == null ? void 0 : s.getText(
      "A licensed land surveyor can help you determine if your subdivision is eligible."
    ) })
  ] });
  return /* @__PURE__ */ k("div", { className: "flex flex-col gap-5", children: [
    /* @__PURE__ */ k("div", { className: "flex flex-col gap-0.5", children: [
      /* @__PURE__ */ d("h2", { className: "text-headingxl text-textPrimary", children: s.getText("VicSmart eligibility") }),
      /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued", children: s.getText(
        "VicSmart is a streamlined planning permit process for straightforward applications."
      ) })
    ] }),
    E ? L() : /* @__PURE__ */ k("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ d(
        xfe,
        {
          eligibility: v,
          translate: s
        }
      ),
      /* @__PURE__ */ d(
        qo,
        {
          allowEditing: e,
          expertName: u,
          conversation: n,
          noticeboardData: o,
          outputKey: c,
          children: A(f)
        }
      )
    ] }),
    /* @__PURE__ */ d(eu, { orientation: "horizontal" }),
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ d("h2", { className: "text-headingxl text-textPrimary", children: s.getText("Application checklist") }),
      /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued", children: s.getText(
        "What information you'll need to provide when you apply for a planning permit."
      ) })
    ] }),
    g && /* @__PURE__ */ k("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ d(
        zo,
        {
          collapsible: !0,
          defaultValue: a ? "vicsmart" : void 0,
          type: "single",
          children: /* @__PURE__ */ k(lo, { value: "vicsmart", children: [
            /* @__PURE__ */ d(uo, { className: "cursor-pointer !py-0", children: /* @__PURE__ */ k("div", { className: "flex flex-col gap-1 text-left", children: [
              /* @__PURE__ */ d("h3", { className: "text-headingmd text-textPrimary", children: s.getText("VicSmart requirements") }),
              /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued", children: s.getText(
                "Refer to this checklist if you meet the VicSmart eligibility criteria."
              ) })
            ] }) }),
            /* @__PURE__ */ d(co, { className: "mt-3", children: A(h) })
          ] })
        }
      ),
      /* @__PURE__ */ d(eu, { orientation: "horizontal", className: "my-2" }),
      /* @__PURE__ */ d(
        zo,
        {
          collapsible: !0,
          defaultValue: a ? "standard" : void 0,
          type: "single",
          children: /* @__PURE__ */ k(lo, { value: "standard", children: [
            /* @__PURE__ */ d(uo, { className: "cursor-pointer !py-0", children: /* @__PURE__ */ k("div", { className: "flex flex-col gap-1 text-left", children: [
              /* @__PURE__ */ d("h3", { className: "text-headingmd text-textPrimary", children: s.getText("Standard requirements") }),
              /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued", children: s.getText(
                "If you're ineligible for VicSmart, refer to this checklist."
              ) })
            ] }) }),
            /* @__PURE__ */ k(co, { className: "text-bodymd text-textPrimary mt-3 flex flex-col gap-3", children: [
              r && M(),
              !r && S && O(),
              !r && !S && T()
            ] })
          ] })
        }
      )
    ] }),
    r && !g && M(),
    !r && !g && S && O(),
    !r && !g && !S && T()
  ] });
}
function vQe({
  allowEditing: e,
  configPrefix: t,
  conversation: n,
  messages: r,
  noticeboardData: i,
  printable: o,
  translate: a = vi,
  showVicSmart: s,
  isVicSmartStandardApplicationRequirementsEnabled: l
}) {
  const { getLocalisationEntry: u } = ar(n), c = u("councilOrdinanceLink"), f = su(
    n,
    i,
    t
  ), h = f && f !== De.Prohibited, { getConfig: m } = tn({
    conversation: n,
    noticeboardData: i
  }), v = (y) => Ge(y, {
    components: {
      h1({ children: w }) {
        return /* @__PURE__ */ d("h5", { className: "text-bodymd font-bold", children: w });
      },
      h2({ children: w }) {
        return /* @__PURE__ */ d("h5", { className: "text-bodymd font-bold", children: w });
      },
      h3({ children: w }) {
        return /* @__PURE__ */ d("h5", { className: "text-bodymd font-bold", children: w });
      },
      h4({ children: w }) {
        return /* @__PURE__ */ d("h5", { className: "text-bodymd font-bold", children: w });
      }
    },
    ordinanceLink: c
  }), g = () => {
    const {
      expert_name: y = "",
      output_key: w,
      content: C
    } = m(`${t}.vic_smart`);
    switch (f) {
      case De.NoPermitRequired: {
        const S = u(
          "councilBuildingPermitLink"
        );
        return /* @__PURE__ */ k("div", { className: "flex flex-col gap-3", children: [
          /* @__PURE__ */ d("h2", { className: "text-headingxl text-textPrimary", children: a.getText(
            "No application requirements are relevant to your proposal"
          ) }),
          /* @__PURE__ */ d("p", { className: "text-bodylg text-textPrimary mb-1", children: a.getText(
            "Your proposal likely doesn't require a planning permit, so no application requirements have been generated."
          ) }),
          /* @__PURE__ */ d("p", { className: "text-bodylg text-textPrimary", children: a.getText(
            "However, you may still require other permits, such as a building permit. Building permits are issued separately from planning permits and are required to ensure construction work complies with national building regulations."
          ) }),
          S && /* @__PURE__ */ k(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover flex cursor-pointer items-center gap-1 underline",
              href: S,
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: [
                a.getText("Check if you need a building permit"),
                " ",
                /* @__PURE__ */ d(Pce, { className: "h-4 w-4" })
              ]
            }
          )
        ] });
      }
      case De.MoreInformationRequired:
        return s ? /* @__PURE__ */ d(
          QA,
          {
            allowEditing: e,
            configPrefix: t,
            conversation: n,
            isVicSmartStandardApplicationRequirementsEnabled: l,
            messages: r,
            noticeboardData: i,
            printable: o,
            translate: a
          }
        ) : /* @__PURE__ */ k("div", { className: "flex flex-col gap-3", children: [
          /* @__PURE__ */ d("h2", { className: "text-headingxl text-textPrimary", children: a.getText(
            "You need to apply through the standard pathway"
          ) }),
          /* @__PURE__ */ d(
            qo,
            {
              allowEditing: e,
              expertName: y,
              conversation: n,
              noticeboardData: i,
              outputKey: w,
              children: /* @__PURE__ */ d(
                Nt,
                {
                  className: "mt-2",
                  ...o && { maxHeight: 99999 },
                  translate: a,
                  children: v(C)
                }
              )
            }
          ),
          /* @__PURE__ */ d("div", { className: z("my-2 w-full border-b md:my-2.5") }),
          /* @__PURE__ */ k("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ d("h3", { className: "text-headinglg text-textPrimary", children: a.getText(
              "What you'll need to provide when you apply"
            ) }),
            /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued", children: a.getText(
              "This list should be used as a guide only. Always speak to a Council planner before preparing a planning permit application."
            ) })
          ] }),
          /* @__PURE__ */ d(
            JA,
            {
              allowEditing: e,
              configPrefix: t,
              conversation: n,
              noticeboardData: i
            }
          )
        ] });
      case De.RequiresPermit:
        return s ? /* @__PURE__ */ d(
          QA,
          {
            allowEditing: e,
            configPrefix: t,
            conversation: n,
            isVicSmartStandardApplicationRequirementsEnabled: l,
            messages: r,
            noticeboardData: i,
            printable: o,
            translate: a
          }
        ) : /* @__PURE__ */ k("div", { className: "flex flex-col gap-3", children: [
          /* @__PURE__ */ d("h2", { className: "text-headingxl text-textPrimary", children: a.getText(
            "You need to apply through the standard pathway"
          ) }),
          /* @__PURE__ */ d(
            qo,
            {
              allowEditing: e,
              expertName: y,
              conversation: n,
              noticeboardData: i,
              outputKey: w,
              children: /* @__PURE__ */ d(
                Nt,
                {
                  className: "mt-2",
                  ...o && { maxHeight: 99999 },
                  translate: a,
                  children: v(C)
                }
              )
            }
          ),
          /* @__PURE__ */ d("div", { className: z("my-2 w-full border-b md:my-2.5") }),
          /* @__PURE__ */ k("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ d("h3", { className: "text-headinglg text-textPrimary", children: a.getText(
              "What you'll need to provide when you apply"
            ) }),
            /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued", children: a.getText(
              "This list should be used as a guide only. Always speak to a Council planner before preparing a planning permit application."
            ) })
          ] }),
          /* @__PURE__ */ d(
            JA,
            {
              allowEditing: e,
              configPrefix: t,
              conversation: n,
              noticeboardData: i
            }
          )
        ] });
      case De.Prohibited:
        return /* @__PURE__ */ k("div", { className: "flex flex-col gap-3", children: [
          /* @__PURE__ */ d("h2", { className: "text-headingxl text-textPrimary", children: a.getText(
            "We haven't generated application requirements because your proposal is likely prohibited"
          ) }),
          /* @__PURE__ */ d("p", { className: "text-bodylg text-textPrimary", children: a.getText(
            "Based on our analysis of your responses, it's likely your proposal is prohibited. We don't recommend applying for a planning permit because it's unlikely Council will support your proposal."
          ) }),
          /* @__PURE__ */ d("p", { className: "text-bodylg text-textPrimary", children: a.interpolate(
            "If you have questions about your result, {{contactLink}} to talk to one of our planners.",
            {
              contactLink: /* @__PURE__ */ d(
                "a",
                {
                  className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
                  href: u("councilContactLink"),
                  rel: "noreferrer",
                  tabIndex: 0,
                  target: "_blank",
                  children: a.getText("contact Council")
                }
              )
            }
          ) })
        ] });
    }
  };
  return /* @__PURE__ */ k("div", { className: "flex flex-col gap-5", children: [
    h && /* @__PURE__ */ d("div", { className: "flex flex-col gap-6 empty:hidden", children: /* @__PURE__ */ d(
      ffe,
      {
        conversation: n,
        translate: a
      }
    ) }),
    /* @__PURE__ */ d(
      "div",
      {
        className: z(
          "border-interactiveBorder bg-textWhite flex flex-col gap-6 rounded-lg border border-l-[12px] p-5 md:p-8"
        ),
        "data-testid": "assessment-report",
        children: g()
      }
    )
  ] });
}
function wfe({
  conversation: e,
  reportColors: t,
  translate: n
}) {
  const i = bw({
    messages: (e == null ? void 0 : e.messages) || [],
    messageType: ep.ROUTING_QUESTION
  }).at(0);
  if (!i) return;
  const o = i.question_data || {};
  if ("inside_permit_requirements_callouts" in o && Array.isArray(o.inside_permit_requirements_callouts) && o.inside_permit_requirements_callouts.length > 0)
    return o.inside_permit_requirements_callouts.map(
      (a, s) => /* @__PURE__ */ d(
        Ew,
        {
          className: `${t.border} bg-textWhite`,
          title: a.title,
          translate: n,
          children: /* @__PURE__ */ d(
            "div",
            {
              className: "[&>a]:text-textLink [&>a]:hover:text-textLinkHover [&>a]:underline",
              dangerouslySetInnerHTML: { __html: a.content }
            }
          )
        },
        `${i.id}-${s}`
      )
    );
}
function M0({
  allowEditing: e,
  className: t,
  configPrefix: n,
  conversation: r,
  noticeboardData: i,
  reportColors: o,
  translate: a = vi
}) {
  const { getLocalisationEntry: s } = ar(r), l = s("councilOrdinanceLink"), { expert_name: u, output_key: c, reportAbstractText: f } = gfe(
    r,
    i,
    n
  );
  if (f)
    return /* @__PURE__ */ d(
      qo,
      {
        allowEditing: e,
        expertName: u,
        conversation: r,
        noticeboardData: i,
        outputKey: c,
        children: /* @__PURE__ */ k("div", { className: "flex flex-col gap-4", children: [
          /* @__PURE__ */ d("div", { className: z("text-bodylg text-textPrimary", t), children: Ge(f, {
            components: {
              h1({ children: h }) {
                return /* @__PURE__ */ d("h3", { className: "text-headingmd", children: h });
              },
              h2({ children: h }) {
                return /* @__PURE__ */ d("h3", { className: "text-headingmd", children: h });
              },
              h3({ children: h }) {
                return /* @__PURE__ */ d("h3", { className: "text-headingmd", children: h });
              },
              h4({ children: h }) {
                return /* @__PURE__ */ d("h3", { className: "text-headingmd", children: h });
              }
            },
            ordinanceLink: l
          }) }),
          /* @__PURE__ */ d(
            wfe,
            {
              conversation: r,
              reportColors: o,
              translate: a
            }
          )
        ] })
      }
    );
}
function Cfe({
  allowEditing: e,
  className: t,
  configPrefix: n,
  conversation: r,
  noticeboardData: i,
  translate: o = vi
}) {
  const { expert_name: a, output_key: s, reportHeadingText: l } = vfe(
    r,
    i,
    n
  ), u = Je(() => {
    if (r != null && r.address_data && r.address_data.state === "QLD")
      switch (r.report_outcome) {
        case "Accepted":
          return o.getText(
            "Your proposal likely qualifies as an Accepted Development"
          );
        case "Self assess":
          return o.getText(
            "Your proposal may qualify as an Accepted Development"
          );
        case "Code":
          return o.getText(
            "Your pathway likely requires a Code Assessment"
          );
        case "Impact":
          return o.getText(
            "Your pathway likely requires an Impact Assessment"
          );
        case "Prohibited":
          return o.getText("Your proposal is likely prohibited");
      }
    return l;
  }, [r, l, o]);
  return /* @__PURE__ */ d(
    qo,
    {
      allowEditing: e,
      expertName: a,
      conversation: r,
      noticeboardData: i,
      outputKey: s,
      children: /* @__PURE__ */ d(
        "h2",
        {
          className: z(
            "text-textPrimary text-heading2xl font-medium",
            t
          ),
          children: u
        }
      )
    }
  );
}
function Sfe({
  allowEditing: e,
  className: t,
  clause: n,
  configPrefix: r,
  conversation: i,
  noticeboardData: o,
  printable: a,
  translate: s = vi
}) {
  const { getLocalisationEntry: l } = ar(i), u = l("councilOrdinanceLink"), { expert_name: c, output_key: f, mandatoryRequirementsText: h } = PB(i, o, r), m = () => /* @__PURE__ */ k("div", { className: "text-bodymd text-textPrimary", children: [
    /* @__PURE__ */ d("h4", { className: "text-headingsm", children: s == null ? void 0 : s.getText("Additional design considerations") }),
    /* @__PURE__ */ d("p", { className: "text-bodymd", children: s == null ? void 0 : s.interpolate(
      "{{clause54Link}} applies to your proposal because you're proposing a dwelling. Check that you meet all of its applicable objectives.",
      {
        clause54Link: /* @__PURE__ */ d(
          "a",
          {
            className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
            href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/54",
            rel: "noreferrer",
            tabIndex: 0,
            target: "_blank",
            children: s == null ? void 0 : s.getText("Clause 54")
          }
        )
      }
    ) }),
    /* @__PURE__ */ k("ul", { className: "list-disc pl-5", children: [
      /* @__PURE__ */ d("li", { children: s == null ? void 0 : s.interpolate(
        "{{neighbourhoodCharacterLink}}: setbacks, the closeness of walls to site boundaries, fencing, canopy coverage and other factors related to neighbourhood character.",
        {
          neighbourhoodCharacterLink: /* @__PURE__ */ d(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
              href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/54.02",
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: s == null ? void 0 : s.getText("Neighbourhood character")
            }
          )
        }
      ) }),
      /* @__PURE__ */ d("li", { children: s == null ? void 0 : s.interpolate(
        "{{liveabilityLink}}: safety, accessibility, private open space and overall street integration.",
        {
          liveabilityLink: /* @__PURE__ */ d(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
              href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/54.03",
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: s == null ? void 0 : s.getText("Liveability")
            }
          )
        }
      ) }),
      /* @__PURE__ */ d("li", { children: s == null ? void 0 : s.interpolate(
        "{{externalAmenityLink}}: standards to ensure there is adequate daylight, solar access and privacy, and prevent avoidable overshadowing.",
        {
          externalAmenityLink: /* @__PURE__ */ d(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
              href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/54.04",
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: s == null ? void 0 : s.getText("External amenity")
            }
          )
        }
      ) }),
      /* @__PURE__ */ d("li", { children: s == null ? void 0 : s.interpolate(
        "{{sustainabilityLink}}: managing impacts of stormwater run-off, allowing for solar access, and considerations for sufficient shadowing and urban cooling.",
        {
          sustainabilityLink: /* @__PURE__ */ d(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
              href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/54.05",
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: s == null ? void 0 : s.getText("Sustainability")
            }
          )
        }
      ) })
    ] })
  ] }), v = () => /* @__PURE__ */ k("div", { className: "text-bodymd text-textPrimary", children: [
    /* @__PURE__ */ d("h4", { className: "text-headingsm", children: s == null ? void 0 : s.getText("Particular provisions") }),
    /* @__PURE__ */ d("p", { className: "text-bodymd", children: s == null ? void 0 : s.interpolate(
      "{{clause55Link}} applies to your proposal because you're proposing multiple dwellings on a lot. Check that you meet all of its applicable objectives.",
      {
        clause55Link: /* @__PURE__ */ d(
          "a",
          {
            className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
            href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/55",
            rel: "noreferrer",
            tabIndex: 0,
            target: "_blank",
            children: s == null ? void 0 : s.getText("Clause 55")
          }
        )
      }
    ) }),
    /* @__PURE__ */ k("ul", { className: "list-disc pl-5", children: [
      /* @__PURE__ */ d("li", { children: s == null ? void 0 : s.interpolate(
        "{{neighbourhoodCharacterLink}}: setbacks, the closeness of walls to site boundaries, fencing, canopy coverage and other factors related to neighbourhood character.",
        {
          neighbourhoodCharacterLink: /* @__PURE__ */ d(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
              href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/55.02",
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: s == null ? void 0 : s.getText("Neighbourhood character")
            }
          )
        }
      ) }),
      /* @__PURE__ */ d("li", { children: s == null ? void 0 : s.interpolate(
        "{{liveabilityLink}}: safety and access/entry, parking, dwelling diversity, ventilation, private open space and overall street integration.",
        {
          liveabilityLink: /* @__PURE__ */ d(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
              href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/55.03",
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: s == null ? void 0 : s.getText("Liveability")
            }
          )
        }
      ) }),
      /* @__PURE__ */ d("li", { children: s == null ? void 0 : s.interpolate(
        "{{externalAmenityLink}}: standards to ensure there is adequate daylight, solar access and privacy, internal views, and prevent avoidable overshadowing.",
        {
          externalAmenityLink: /* @__PURE__ */ d(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
              href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/55.04",
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: s == null ? void 0 : s.getText("External amenity")
            }
          )
        }
      ) }),
      /* @__PURE__ */ d("li", { children: s == null ? void 0 : s.interpolate(
        "{{sustainabilityLink}}: managing impacts of stormwater run-off, allowing for solar access, and considerations for waste management, sufficient shadowing and urban cooling.",
        {
          sustainabilityLink: /* @__PURE__ */ d(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
              href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/55.05",
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: s == null ? void 0 : s.getText("Sustainability")
            }
          )
        }
      ) })
    ] })
  ] });
  return /* @__PURE__ */ k(xe, { children: [
    /* @__PURE__ */ d("div", { className: z("w-full border-b", t) }),
    /* @__PURE__ */ d(
      zo,
      {
        collapsible: !0,
        type: "single",
        ...a && {
          collapsible: !1,
          value: "design-and-sitting-requirements"
        },
        children: /* @__PURE__ */ k(
          lo,
          {
            className: "border-b-0",
            value: "design-and-sitting-requirements",
            children: [
              /* @__PURE__ */ d(uo, { className: "!py-0", children: /* @__PURE__ */ k("div", { className: "text-left", children: [
                /* @__PURE__ */ d("h2", { className: "text-headingmd text-textPrimary", children: s.getText("Design and siting requirements") }),
                /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued", children: s.getText(
                  "Additional requirements from the zone, overlays, and particular provisions."
                ) })
              ] }) }),
              /* @__PURE__ */ k(co, { className: "!pb-0 pt-5", children: [
                /* @__PURE__ */ d(
                  qo,
                  {
                    allowEditing: e,
                    expertName: c,
                    conversation: i,
                    noticeboardData: o,
                    outputKey: f,
                    children: Ge(h, {
                      components: {
                        h1({ children: g }) {
                          return /* @__PURE__ */ d("h4", { className: "text-headingsm mb-2", children: g });
                        },
                        h2({ children: g }) {
                          return /* @__PURE__ */ d("h4", { className: "text-headingsm mb-2", children: g });
                        },
                        h3({ children: g }) {
                          return /* @__PURE__ */ d("h4", { className: "text-headingsm mb-2", children: g });
                        },
                        h4({ children: g }) {
                          return /* @__PURE__ */ d("h4", { className: "text-headingsm mb-2", children: g });
                        }
                      },
                      ordinanceLink: u
                    })
                  }
                ),
                n === "54" && m(),
                n === "55" && v()
              ] })
            ]
          }
        )
      }
    )
  ] });
}
function Cb({
  allowEditing: e,
  className: t,
  configPrefix: n,
  conversation: r,
  noticeboardData: i,
  printable: o,
  translate: a = vi
}) {
  const { getLocalisationEntry: s } = ar(r), l = s("councilOrdinanceLink"), u = yfe(
    r,
    i,
    n
  ), c = bfe(
    r,
    i,
    n
  ), f = ["54", "55"].includes(
    c || ""
  ), { expert_name: h, output_key: m, mandatoryRequirementsText: v } = PB(r, i, n);
  if (f)
    return /* @__PURE__ */ d(
      Sfe,
      {
        allowEditing: e,
        className: t,
        clause: c,
        configPrefix: n,
        conversation: r,
        noticeboardData: i
      }
    );
  if (!(!u || !v))
    return /* @__PURE__ */ k(xe, { children: [
      /* @__PURE__ */ d("div", { className: z("w-full border-b", t) }),
      /* @__PURE__ */ d(
        zo,
        {
          collapsible: !0,
          type: "single",
          ...o && {
            collapsible: !1,
            value: "mandatory-requirements"
          },
          children: /* @__PURE__ */ k(lo, { className: "border-b-0", value: "mandatory-requirements", children: [
            /* @__PURE__ */ d(uo, { className: "!py-0", children: /* @__PURE__ */ k("div", { className: "text-left", children: [
              /* @__PURE__ */ d("h2", { className: "text-headingmd text-textPrimary", children: a.getText("Mandatory requirements") }),
              /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued", children: a.getText(
                "Check your proposal complies with these requirements or it won't be accepted."
              ) })
            ] }) }),
            /* @__PURE__ */ d(co, { className: "!pb-0 pt-5", children: /* @__PURE__ */ d(
              qo,
              {
                allowEditing: e,
                expertName: h,
                conversation: r,
                noticeboardData: i,
                outputKey: m,
                children: Ge(v, {
                  ordinanceLink: l
                })
              }
            ) })
          ] })
        }
      )
    ] });
}
function _fe({
  conversation: e,
  translate: t
}) {
  const r = bw({
    messages: (e == null ? void 0 : e.messages) || [],
    messageType: ep.ROUTING_QUESTION
  }).at(0);
  if (!r) return;
  const i = r.question_data || {};
  if ("permit_requirements_callouts" in i && Array.isArray(i.permit_requirements_callouts))
    return i.permit_requirements_callouts.map(
      (o, a) => /* @__PURE__ */ d(
        Ew,
        {
          title: o.title,
          translate: t,
          type: o.color,
          children: o.content
        },
        `${r.id}-${a}`
      )
    );
}
function cx(e) {
  return !e || e.trim().toLowerCase().startsWith("no content") || /^no (.+) at this address/.test(e.trim().toLowerCase());
}
function Efe(e) {
  var t;
  return ((t = e == null ? void 0 : e.split(`
`)[0]) == null ? void 0 : t.trim()) || "";
}
function Nfe({
  configPrefix: e,
  conversation: t,
  noticeboardData: n,
  translate: r = vi
}) {
  const { getConfigs: i } = tn({
    conversation: t,
    noticeboardData: n
  }), o = i(`${e}.report_details`), a = Je(() => o.filter((l) => {
    const { content: u } = l;
    return !cx(u);
  }), [o]), s = () => a.map((l, u) => {
    const { content: c, title: f, parsedOutput: h } = l;
    if (cx(c))
      return null;
    const m = oB(
      (h == null ? void 0 : h.title) || f || Efe(c) || ""
    ), v = h == null ? void 0 : h.permit_determination_heading;
    return /* @__PURE__ */ k("li", { className: "not-first:mt-1", children: [
      /* @__PURE__ */ k(
        "a",
        {
          className: "text-bodymd text-textLink hover:text-textLinkHover underline",
          href: `#detailed-analysis-section-${u}`,
          children: [
            /* @__PURE__ */ k("span", { children: [
              u + 1,
              "."
            ] }),
            " ",
            m
          ]
        }
      ),
      v && ` | ${v}`
    ] }, u);
  });
  return /* @__PURE__ */ k("div", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ d("p", { className: "text-bodymd", children: r == null ? void 0 : r.getText("Jump to...") }),
    /* @__PURE__ */ d("ul", { className: "list-outside list-none pl-3", children: s() })
  ] });
}
function Afe({
  allowEditing: e,
  configPrefix: t,
  conversation: n,
  noticeboardData: r,
  printable: i,
  reportColors: o,
  translate: a = vi
}) {
  const { getLocalisationEntry: s } = ar(n), l = s("councilOrdinanceLink"), { getConfigs: u } = tn({
    conversation: n,
    noticeboardData: r
  }), c = Je(() => u(`${t}.report_details`).filter((m) => {
    const { content: v } = m;
    return !cx(v);
  }), [u, t]), f = () => /* @__PURE__ */ d("div", { className: "flex flex-col gap-5", children: c.map((h, m) => {
    const {
      expert_name: v = "",
      output_key: g,
      content: y,
      title: w,
      parsedOutput: C
    } = h, S = m === c.length - 1, N = oB(
      w || (C == null ? void 0 : C.title) || ""
    );
    return /* @__PURE__ */ k(Bs, { children: [
      /* @__PURE__ */ k(
        "div",
        {
          className: "flex flex-col gap-1",
          id: `detailed-analysis-section-${m}`,
          children: [
            N && /* @__PURE__ */ d("h3", { className: "text-headingsm text-textPrimary", children: N }),
            /* @__PURE__ */ d(
              qo,
              {
                allowEditing: e,
                expertName: v,
                conversation: n,
                noticeboardData: r,
                outputKey: g,
                children: Ge(y, {
                  components: {
                    h1({ children: E }) {
                      return /* @__PURE__ */ d("h4", { className: "text-headingsm mb-2", children: E });
                    },
                    h2({ children: E }) {
                      return /* @__PURE__ */ d("h4", { className: "text-headingsm mb-2", children: E });
                    },
                    h3({ children: E }) {
                      return /* @__PURE__ */ d("h4", { className: "text-headingsm mb-2", children: E });
                    },
                    h4({ children: E }) {
                      return /* @__PURE__ */ d("h4", { className: "text-headingsm mb-2", children: E });
                    }
                  },
                  ordinanceLink: l,
                  reportColors: o
                })
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ k(
        "a",
        {
          className: "text-bodymd text-textLink hover:text-textLinkHover flex cursor-pointer items-center",
          href: "#detailed-analysis-heading",
          children: [
            /* @__PURE__ */ d(Yue, { className: "size-5" }),
            " ",
            /* @__PURE__ */ d("span", { className: "underline", children: a.getText("Back to top") })
          ]
        }
      ),
      !S && /* @__PURE__ */ d("div", { className: z("w-full border-b", o.border) })
    ] }, m);
  }) });
  return /* @__PURE__ */ d(
    zo,
    {
      collapsible: !0,
      type: "single",
      ...i && { collapsible: !1, value: "detailed-analysis" },
      children: /* @__PURE__ */ k(lo, { className: "border-b-0", value: "detailed-analysis", children: [
        /* @__PURE__ */ d(uo, { className: "!py-0", children: /* @__PURE__ */ k("div", { children: [
          /* @__PURE__ */ d(
            "h2",
            {
              className: "text-headingmd text-textPrimary flex",
              id: "detailed-analysis-heading",
              children: a.getText("Detailed analysis")
            }
          ),
          /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued [text-align:initial]", children: a.getText(
            "Breakdown by the zone, overlays, and other controls relevant to your proposal."
          ) })
        ] }) }),
        /* @__PURE__ */ k(co, { className: "flex flex-col gap-5 !pb-0 pt-5", children: [
          /* @__PURE__ */ d(
            Nfe,
            {
              configPrefix: t,
              conversation: n,
              noticeboardData: r,
              translate: a
            }
          ),
          f()
        ] })
      ] })
    }
  );
}
function Ofe({
  allowEditing: e,
  configPrefix: t,
  conversation: n,
  noticeboardData: r,
  printable: i,
  reportColors: o,
  translate: a
}) {
  const { getLocalisationEntry: s } = ar(n), l = s("councilOrdinanceLink"), { getConfigs: u } = tn({
    conversation: n,
    noticeboardData: r
  }), [c, f] = re("0"), h = () => {
    switch (c) {
      case "0":
        return /* @__PURE__ */ d("p", { className: "text-bodymd pt-4", children: a == null ? void 0 : a.interpolate(
          "Some minor building renovations or works don't need any planning or building approval. In NSW, this is referred to as {{link}}.",
          {
            link: /* @__PURE__ */ d(
              "a",
              {
                className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
                href: "https://www.planning.nsw.gov.au/assess-and-regulate/development-assessment/planning-approval-pathways/exempt-development",
                rel: "noreferrer",
                tabIndex: 0,
                target: "_blank",
                children: "exempt development"
              }
            )
          }
        ) });
      case "1":
        return /* @__PURE__ */ d("p", { className: "text-bodymd pt-4", children: a == null ? void 0 : a.interpolate(
          "{{link}} is a combined planning and construction approval for straightforward development that can be determined through a fast-track assessment.",
          {
            link: /* @__PURE__ */ d(
              "a",
              {
                className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
                href: "https://www.planning.nsw.gov.au/assess-and-regulate/development-assessment/planning-approval-pathways/complying-development",
                rel: "noreferrer",
                tabIndex: 0,
                target: "_blank",
                children: "Complying development"
              }
            )
          }
        ) });
    }
  }, m = () => {
    const v = u(`${t}.report_details`);
    return /* @__PURE__ */ k(
      Ea,
      {
        className: "w-full overflow-hidden p-0",
        onValueChange: (g) => {
          f(g);
        },
        value: c,
        defaultValue: "0",
        children: [
          /* @__PURE__ */ d(Ro, { className: "bg-blueBgSelect flex w-full items-end justify-start rounded border-b-[1px] border-b-transparent p-0", children: v.map((g, y) => /* @__PURE__ */ d(
            jn,
            {
              type: void 0,
              value: y.toString(),
              className: "text-textPrimary text-bodysm data-[state=active]:bg-interfaceBgLightPaper m-1 grow rounded border-none px-4 py-2 font-normal",
              children: g.title
            },
            y
          )) }),
          v.map((g, y) => {
            const { expert_name: w = "", output_key: C, content: S } = g;
            return /* @__PURE__ */ d(Mn, { value: y.toString(), children: /* @__PURE__ */ k("div", { className: "flex flex-col gap-1", children: [
              h(),
              /* @__PURE__ */ d(
                qo,
                {
                  allowEditing: e,
                  expertName: w,
                  conversation: n,
                  noticeboardData: r,
                  outputKey: C,
                  children: /* @__PURE__ */ d("div", { className: "pt-6", children: Ge(S, {
                    components: {
                      h1({ children: N }) {
                        return /* @__PURE__ */ d("h4", { className: "text-headingsm", children: N });
                      },
                      h2({ children: N }) {
                        return /* @__PURE__ */ d("h4", { className: "text-headingsm", children: N });
                      },
                      h3({ children: N }) {
                        return /* @__PURE__ */ d("h4", { className: "text-headingsm", children: N });
                      },
                      h4({ children: N }) {
                        return /* @__PURE__ */ d("h4", { className: "text-headingsm", children: N });
                      }
                    },
                    ordinanceLink: l,
                    reportColors: o
                  }) })
                }
              )
            ] }) }, g.title);
          })
        ]
      }
    );
  };
  return /* @__PURE__ */ d(
    zo,
    {
      collapsible: !0,
      type: "single",
      ...i && { collapsible: !1, value: "detailed-analysis" },
      children: /* @__PURE__ */ k(lo, { className: "border-b-0", value: "detailed-analysis", children: [
        /* @__PURE__ */ d(uo, { className: "!py-0", children: /* @__PURE__ */ k("div", { className: "text-left", children: [
          /* @__PURE__ */ d("h2", { className: "text-headingmd text-textPrimary", children: a == null ? void 0 : a.getText("Detailed analysis") }),
          /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued", children: a == null ? void 0 : a.getText(
            "How your proposal was assessed against each of NSW's approval pathways."
          ) })
        ] }) }),
        /* @__PURE__ */ d(co, { className: "pt-5 !pb-0", children: m() })
      ] })
    }
  );
}
function Sb({
  allowEditing: e,
  configPrefix: t,
  conversation: n,
  noticeboardData: r,
  printable: i,
  reportColors: o,
  translate: a
}) {
  var u, c;
  const s = ((c = (u = n == null ? void 0 : n.address_data) == null ? void 0 : u.state) == null ? void 0 : c.toUpperCase()) || "";
  if (kue(
    n,
    t
  ))
    switch (s) {
      case "NSW":
        return /* @__PURE__ */ d(
          Ofe,
          {
            allowEditing: e,
            configPrefix: t,
            conversation: n,
            noticeboardData: r,
            printable: i,
            reportColors: o,
            translate: a
          }
        );
      default:
        return /* @__PURE__ */ d(
          Afe,
          {
            allowEditing: e,
            configPrefix: t,
            conversation: n,
            noticeboardData: r,
            printable: i,
            reportColors: o,
            translate: a
          }
        );
    }
}
const eO = {
  [De.NoPermitRequired]: {
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [De.MoreInformationRequired]: {
    text: "text-actionDefault",
    border: "border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [De.RequiresPermit]: {
    text: "text-warningHover",
    border: "border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  [De.Prohibited]: {
    text: "text-destructiveHover",
    border: "border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  },
  // forced report colours
  green: {
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  blue: {
    text: "text-actionDefault",
    border: "border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  orange: {
    text: "text-warningHover",
    border: "border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  red: {
    text: "text-destructiveHover",
    border: "border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  },
  grey: {
    text: "text-textPrimary",
    border: "border-interactiveBorder",
    bgLight: "bg-textWhite",
    bgDark: "bg-textWhite"
  }
};
function yQe({
  allowEditing: e,
  configPrefix: t,
  conversation: n,
  messages: r,
  noticeboardData: i,
  printable: o,
  translate: a = vi
}) {
  const [s, l] = re({
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  }), u = su(
    n,
    i,
    t
  ), c = u && u !== De.Prohibited;
  Pe(() => {
    n != null && n.forced_report_color ? l(eO[n.forced_report_color]) : u && ["1", "2", "3", "4"].includes(u.toString()) ? l(eO[u.toString()]) : l({
      text: "text-warningHover",
      border: "border-warningBorder",
      bgLight: "bg-warningBgLight",
      bgDark: "bg-warningBgDefault"
    });
  }, [
    u,
    n == null ? void 0 : n.forced_report_color,
    n == null ? void 0 : n.phase
  ]);
  const f = () => {
    switch (u) {
      case De.NoPermitRequired:
        return /* @__PURE__ */ k("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ d(
            M0,
            {
              allowEditing: e,
              configPrefix: t,
              conversation: n,
              noticeboardData: i,
              reportColors: s,
              translate: a
            }
          ),
          /* @__PURE__ */ d(
            Cb,
            {
              allowEditing: e,
              className: s.border,
              configPrefix: t,
              conversation: n,
              noticeboardData: i,
              printable: o,
              translate: a
            }
          ),
          /* @__PURE__ */ d("div", { className: z("w-full border-b last:hidden", s.border) }),
          /* @__PURE__ */ d(
            Sb,
            {
              allowEditing: e,
              configPrefix: t,
              conversation: n,
              noticeboardData: i,
              printable: o,
              reportColors: s,
              translate: a
            }
          )
        ] });
      case De.MoreInformationRequired:
        return /* @__PURE__ */ k("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ d(
            M0,
            {
              allowEditing: e,
              configPrefix: t,
              conversation: n,
              noticeboardData: i,
              reportColors: s,
              translate: a
            }
          ),
          /* @__PURE__ */ d(
            Cb,
            {
              allowEditing: e,
              className: s.border,
              configPrefix: t,
              conversation: n,
              noticeboardData: i,
              printable: o,
              translate: a
            }
          ),
          /* @__PURE__ */ d("div", { className: z("w-full border-b last:hidden", s.border) }),
          /* @__PURE__ */ d(
            Sb,
            {
              allowEditing: e,
              configPrefix: t,
              conversation: n,
              noticeboardData: i,
              printable: o,
              reportColors: s,
              translate: a
            }
          )
        ] });
      case De.RequiresPermit:
        return /* @__PURE__ */ k("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ d(
            M0,
            {
              allowEditing: e,
              configPrefix: t,
              conversation: n,
              noticeboardData: i,
              reportColors: s,
              translate: a
            }
          ),
          /* @__PURE__ */ d(
            Cb,
            {
              allowEditing: e,
              className: s.border,
              configPrefix: t,
              conversation: n,
              noticeboardData: i,
              printable: o,
              translate: a
            }
          ),
          /* @__PURE__ */ d("div", { className: z("w-full border-b last:hidden", s.border) }),
          /* @__PURE__ */ d(
            Sb,
            {
              allowEditing: e,
              configPrefix: t,
              conversation: n,
              noticeboardData: i,
              printable: o,
              reportColors: s,
              translate: a
            }
          )
        ] });
      case De.Prohibited:
        return /* @__PURE__ */ d("div", { className: "flex flex-col gap-6", children: /* @__PURE__ */ d(
          M0,
          {
            allowEditing: e,
            configPrefix: t,
            conversation: n,
            noticeboardData: i,
            reportColors: s,
            translate: a
          }
        ) });
    }
  };
  return /* @__PURE__ */ k("div", { className: "flex flex-col gap-5", children: [
    c && /* @__PURE__ */ d("div", { className: "flex flex-col gap-6 empty:hidden", children: /* @__PURE__ */ d(
      _fe,
      {
        conversation: n,
        translate: a
      }
    ) }),
    /* @__PURE__ */ k(
      "div",
      {
        className: z(
          "flex flex-col gap-6 rounded-lg border border-l-[12px] p-5 md:p-8",
          s.border,
          s.bgLight
        ),
        "data-testid": "assessment-report",
        children: [
          /* @__PURE__ */ d(
            Cfe,
            {
              allowEditing: e,
              configPrefix: t,
              conversation: n,
              noticeboardData: i,
              translate: a
            }
          ),
          f()
        ]
      }
    )
  ] });
}
function bQe({
  configPrefix: e,
  conversation: t,
  noticeboardData: n
}) {
  const { getLocalisationEntry: r } = ar(t), i = r("councilOrdinanceLink"), o = pfe(
    t,
    n,
    e
  );
  return /* @__PURE__ */ d("div", { className: "flex flex-col gap-5", children: Ge(o, {
    components: {
      h1({ children: a }) {
        return /* @__PURE__ */ d("h4", { className: "text-headingsm", children: a });
      },
      h2({ children: a }) {
        return /* @__PURE__ */ d("h4", { className: "text-headingsm", children: a });
      },
      h3({ children: a }) {
        return /* @__PURE__ */ d("h4", { className: "text-headingsm", children: a });
      },
      h4({ children: a }) {
        return /* @__PURE__ */ d("h4", { className: "text-headingsm", children: a });
      }
    },
    ordinanceLink: i
  }) });
}
function ip(e, t, n) {
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), { content: i } = r(
    `${n}.report_heading`
  );
  return i;
}
function kfe(e, t, n) {
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), { content: i } = r(
    `${n}.report_abstract`
  );
  return i;
}
function jg(e, t, n) {
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), { content: i } = r(
    `${n}.report_summary`
  );
  return i;
}
function Nw(e, t, n) {
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), { content: i } = r(
    `${n}.mandatory_requirements`
  );
  return i;
}
function Aw(e, t, n) {
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), { parsedOutput: i = {} } = r(
    `${n}.show_mandatory_requirements`
  );
  return "<1>" in i;
}
function Ow(e, t, n) {
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), { content: i } = r(
    `${n}.easy_read_report`
  );
  return i;
}
function kw(e, t, n) {
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), { content: i } = r(
    `${n}.application_requirements`
  );
  return i;
}
function Pfe(e, t, n) {
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), { content: i } = r(
    `${n}.lodgement_requirements`
  );
  return i;
}
function Tfe(e) {
  var t;
  return (t = e == null ? void 0 : e.vicsmart_classifier_combined) != null && t.parsed_output.vicsmart ? e.vicsmart_classifier_combined.parsed_output.vicsmart : "";
}
function Pw(e, t, n) {
  var o, a;
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), { parsedOutput: i = {} } = r(
    `${n}.vic_smart_eligibility`
  );
  return "<1>" in i && ((o = i["<1>"]) == null ? void 0 : o.toLowerCase()) !== "n/a" ? "eligible" : "<2>" in i && ((a = i["<2>"]) == null ? void 0 : a.toLowerCase()) !== "n/a" ? "ineligible" : "unknown";
}
function Tw(e, t, n) {
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), { content: i } = r(
    `${n}.vic_smart`
  );
  return i;
}
function Mfe(e, t, n) {
  const { getConfig: r } = tn({
    conversation: e,
    noticeboardData: t
  }), { content: i } = r(
    `${n}.vic_smart_application_requirements`
  );
  return i;
}
function Mw({
  eligibility: e
}) {
  switch (e) {
    case Vo.eligible:
      return /* @__PURE__ */ d("span", { className: "rounded-xl py-0.5 px-2 text-bodymd text-[#005C41] bg-successBgDefault", children: "Likely eligible" });
    case Vo.ineligible:
    default:
      return /* @__PURE__ */ d("span", { className: "rounded-xl py-0.5 px-2 text-bodymd text-destructiveText bg-destructiveBgDefault", children: "Likely ineligible" });
  }
}
function dx({
  configPrefix: e,
  conversation: t,
  noticeboardData: n,
  ordinanceLink: r
}) {
  const i = Pw(
    t,
    n,
    e
  ), o = Tw(
    t,
    n,
    e
  );
  if (lB() && i !== "unknown")
    return /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ d("h3", { className: "text-headingmd text-textPrimary mb-1", children: "VicSmart eligibility" }),
      /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued mb-2", children: "VicSmart is an approval pathway for straightforward planning applications. If you're eligible, lodging a VicSmart application will be much faster than the standard pathway." }),
      /* @__PURE__ */ d(Mw, { eligibility: i }),
      i === Vo.eligible ? /* @__PURE__ */ d(Nt, { className: "mt-2", children: Ge(o, {
        ordinanceLink: r
      }) }) : null
    ] });
}
function fx({
  configPrefix: e,
  conversation: t,
  noticeboardData: n,
  ordinanceLink: r
}) {
  const i = kw(
    t,
    n,
    e
  );
  return /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ d("h3", { className: "text-headingmd text-textPrimary mb-1", children: "Required documents and information" }),
    /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued mb-5", children: "If your proposal isn't eligible for VicSmart, you may need to provide the following documents when you submit a planning permit application. It is recommended that you speak to a planner to confirm if these documents are required for your proposal." }),
    /* @__PURE__ */ d(Nt, { children: Ge(i, {
      components: {
        h1({ children: o }) {
          return /* @__PURE__ */ d("h5", { className: "text-bodymd font-bold", children: o });
        },
        h2({ children: o }) {
          return /* @__PURE__ */ d("h5", { className: "text-bodymd font-bold", children: o });
        },
        h3({ children: o }) {
          return /* @__PURE__ */ d("h5", { className: "text-bodymd font-bold", children: o });
        },
        h4({ children: o }) {
          return /* @__PURE__ */ d("h5", { className: "text-bodymd font-bold", children: o });
        }
      },
      ordinanceLink: r
    }) })
  ] });
}
const Rfe = {
  [De.NoPermitRequired]: {
    text: "text-successHover",
    border: "!border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [De.MoreInformationRequired]: {
    text: "text-actionDefault",
    border: "!border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [De.RequiresPermit]: {
    text: "text-warningHover",
    border: "!border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  [De.Prohibited]: {
    text: "text-destructiveHover",
    border: "!border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  }
};
function xQe({
  configPrefix: e,
  conversation: t,
  messages: n,
  noticeboardData: r,
  onClickCheckExemptionCriteria: i,
  onClickApplicationRequirements: o,
  publicView: a = !1
}) {
  const [s, l] = re({
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  }), { getLocalisationEntry: u } = ar(t), c = u("councilOrdinanceLink"), f = uB({ messages: n }), h = cB({ conversation: t, messages: n }), m = dB(
    t,
    e
  );
  console.log("<AnalysisReport>", {
    isReportFinalised: f,
    isReportLocked: h,
    isFollowUpFlowEnabled: m,
    phase: t == null ? void 0 : t.phase
  });
  const v = su(
    t,
    r,
    e
  );
  Pe(() => {
    v && ["1", "2", "3", "4"].includes(v.toString()) ? l(Rfe[v.toString()]) : l({
      text: "text-warningHover",
      border: "border-warningBorder",
      bgLight: "bg-warningBgLight",
      bgDark: "bg-warningBgDefault"
    });
  }, [v, t == null ? void 0 : t.phase]);
  const g = Ow(
    t,
    r,
    e
  ), y = () => /* @__PURE__ */ d("div", { children: Ge(g, { ordinanceLink: c }) }), w = jg(
    t,
    r,
    e
  ), C = Nw(
    t,
    r,
    e
  ), S = Aw(
    t,
    r,
    e
  ), N = () => {
    switch (v) {
      case De.NoPermitRequired:
        return /* @__PURE__ */ k("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ k("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ d("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Why your proposal likely doesn't require a planning permit." }),
            /* @__PURE__ */ k(Ea, { defaultValue: "summary", children: [
              /* @__PURE__ */ k(Ro, { className: "pb-3", children: [
                /* @__PURE__ */ k(
                  jn,
                  {
                    className: "data-[state=active]:text-textLink flex gap-1 !bg-transparent px-2",
                    value: "summary",
                    children: [
                      /* @__PURE__ */ d(Nl, {}),
                      " Full assessment"
                    ]
                  }
                ),
                /* @__PURE__ */ k(
                  jn,
                  {
                    className: "data-[state=active]:text-textLink flex gap-1 !bg-transparent px-2",
                    value: "easy-read",
                    children: [
                      /* @__PURE__ */ d(Al, {}),
                      " Easy read"
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ d(Mn, { value: "easy-read", children: /* @__PURE__ */ d(Nt, { maxHeight: 300, children: y() }) }),
              /* @__PURE__ */ d(Mn, { value: "summary", children: /* @__PURE__ */ d(Nt, { maxHeight: 300, children: Ge(w, { ordinanceLink: c }) }) })
            ] })
          ] }),
          S && C ? /* @__PURE__ */ k("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ d("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Mandatory requirements" }),
            /* @__PURE__ */ d(Nt, { children: Ge(C, {
              ordinanceLink: c
            }) })
          ] }) : null
        ] });
      case De.MoreInformationRequired:
        return /* @__PURE__ */ k("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ k("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ d("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Why a planning permit could be required" }),
            /* @__PURE__ */ k(Ea, { defaultValue: "summary", children: [
              /* @__PURE__ */ k(Ro, { className: "pb-3", children: [
                /* @__PURE__ */ k(
                  jn,
                  {
                    className: "data-[state=active]:text-textLink flex gap-1 !bg-transparent px-2",
                    value: "summary",
                    children: [
                      /* @__PURE__ */ d(Nl, {}),
                      " Full assessment"
                    ]
                  }
                ),
                /* @__PURE__ */ k(
                  jn,
                  {
                    className: "data-[state=active]:text-textLink flex gap-1 !bg-transparent px-2",
                    value: "easy-read",
                    children: [
                      /* @__PURE__ */ d(Al, {}),
                      " Easy read"
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ d(Mn, { value: "easy-read", children: /* @__PURE__ */ d("div", { children: y() }) }),
              /* @__PURE__ */ d(Mn, { value: "summary", children: /* @__PURE__ */ d(Nt, { maxHeight: 300, children: Ge(w, { ordinanceLink: c }) }) })
            ] })
          ] }),
          S && C ? /* @__PURE__ */ k("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ d("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Mandatory requirements" }),
            /* @__PURE__ */ d(Nt, { children: Ge(C, {
              ordinanceLink: c
            }) })
          ] }) : null,
          m && !h && !f && !a ? /* @__PURE__ */ d(et, { className: "w-min", onClick: i, children: "Check exemption criteria" }) : null,
          m && f ? /* @__PURE__ */ k("div", { children: [
            /* @__PURE__ */ d(
              "div",
              {
                className: z("mb-6 w-full border-b", s.border)
              }
            ),
            /* @__PURE__ */ d(
              "h2",
              {
                className: "text-headinglg text-textPrimary mb-5",
                id: "application-requirements",
                children: "Application requirements"
              }
            ),
            /* @__PURE__ */ d(
              dx,
              {
                configPrefix: e,
                conversation: t,
                noticeboardData: r,
                ordinanceLink: c
              }
            ),
            /* @__PURE__ */ d("div", { className: "h-4" }),
            /* @__PURE__ */ d(
              fx,
              {
                configPrefix: e,
                conversation: t,
                noticeboardData: r,
                ordinanceLink: c
              }
            )
          ] }) : null
        ] });
      case De.RequiresPermit:
        return /* @__PURE__ */ k("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ k("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ d("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Why a permit is likely required" }),
            /* @__PURE__ */ k(Ea, { defaultValue: "summary", children: [
              /* @__PURE__ */ k(Ro, { className: "pb-3", children: [
                /* @__PURE__ */ k(
                  jn,
                  {
                    className: "data-[state=active]:text-textLink flex gap-1 !bg-transparent px-2",
                    value: "summary",
                    children: [
                      /* @__PURE__ */ d(Nl, {}),
                      " Full assessment"
                    ]
                  }
                ),
                /* @__PURE__ */ k(
                  jn,
                  {
                    className: "data-[state=active]:text-textLink flex gap-1 !bg-transparent px-2",
                    value: "easy-read",
                    children: [
                      /* @__PURE__ */ d(Al, {}),
                      " Easy read"
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ d(Mn, { value: "easy-read", children: /* @__PURE__ */ d(Nt, { maxHeight: 300, children: y() }) }),
              /* @__PURE__ */ d(Mn, { value: "summary", children: /* @__PURE__ */ d(Nt, { maxHeight: 300, children: Ge(w, { ordinanceLink: c }) }) })
            ] })
          ] }),
          S && C ? /* @__PURE__ */ k("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ d("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Mandatory requirements" }),
            /* @__PURE__ */ d(Nt, { children: Ge(C, {
              ordinanceLink: c
            }) })
          ] }) : null,
          m && !h && !f && !a ? /* @__PURE__ */ k("div", { children: [
            /* @__PURE__ */ d("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Ready to apply?" }),
            /* @__PURE__ */ d("p", { className: "text-bodymd text-textPrimary mb-3", children: "Check what information you'll need to provide to council when you apply." }),
            /* @__PURE__ */ d(
              et,
              {
                className: "w-min",
                onClick: o,
                children: "Check application requirements"
              }
            )
          ] }) : null,
          m && f ? /* @__PURE__ */ k("div", { children: [
            /* @__PURE__ */ d(
              "div",
              {
                className: z("mb-6 w-full border-b", s.border)
              }
            ),
            /* @__PURE__ */ d(
              "h2",
              {
                className: "text-headinglg text-textPrimary mb-5",
                id: "application-requirements",
                children: "Application requirements"
              }
            ),
            /* @__PURE__ */ d(
              dx,
              {
                configPrefix: e,
                conversation: t,
                noticeboardData: r,
                ordinanceLink: c
              }
            ),
            /* @__PURE__ */ d("div", { className: "h-4" }),
            /* @__PURE__ */ d(
              fx,
              {
                configPrefix: e,
                conversation: t,
                noticeboardData: r,
                ordinanceLink: c
              }
            )
          ] }) : null
        ] });
      case De.Prohibited:
        return /* @__PURE__ */ k("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ d("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Why your proposal is likely prohibited" }),
          /* @__PURE__ */ k(Ea, { defaultValue: "summary", children: [
            /* @__PURE__ */ k(Ro, { className: "pb-3", children: [
              /* @__PURE__ */ k(
                jn,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 !bg-transparent px-2",
                  value: "summary",
                  children: [
                    /* @__PURE__ */ d(Nl, {}),
                    " Full assessment"
                  ]
                }
              ),
              /* @__PURE__ */ k(
                jn,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 !bg-transparent px-2",
                  value: "easy-read",
                  children: [
                    /* @__PURE__ */ d(Al, {}),
                    " Easy read"
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ d(Mn, { value: "easy-read", children: /* @__PURE__ */ d(Nt, { maxHeight: 300, children: y() }) }),
            /* @__PURE__ */ d(Mn, { value: "summary", children: /* @__PURE__ */ d(Nt, { maxHeight: 300, children: Ge(w, { ordinanceLink: c }) }) })
          ] })
        ] });
    }
  };
  return /* @__PURE__ */ k(
    "div",
    {
      className: z(
        "flex flex-col gap-6 rounded-lg border border-l-[12px] p-5 md:p-8",
        s.border,
        s.bgLight
      ),
      "data-testid": "assessment-report",
      children: [
        /* @__PURE__ */ d(
          "h2",
          {
            className: `text-heading2xl font-medium ${s.text}`,
            children: ip(t, r, e)
          }
        ),
        N()
      ]
    }
  );
}
const Dfe = {
  [De.NoPermitRequired]: {
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [De.MoreInformationRequired]: {
    text: "text-actionDefault",
    border: "border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [De.RequiresPermit]: {
    text: "text-warningHover",
    border: "border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  [De.Prohibited]: {
    text: "text-destructiveHover",
    border: "border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  }
};
function wQe({
  configPrefix: e,
  conversation: t,
  expertMap: n,
  messages: r,
  noticeboardData: i,
  onClickCheckExemptionCriteria: o,
  onClickApplicationRequirements: a,
  publicView: s = !1
}) {
  const [l, u] = re({
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  }), { getLocalisationEntry: c } = ar(t), f = c("councilOrdinanceLink"), h = uB({ messages: r }), m = cB({ conversation: t, messages: r }), v = dB(
    t,
    e
  ), g = su(
    t,
    i,
    e
  );
  Pe(() => {
    g && ["1", "2", "3", "4"].includes(g.toString()) ? u(Dfe[g.toString()]) : u({
      text: "text-warningHover",
      border: "border-warningBorder",
      bgLight: "bg-warningBgLight",
      bgDark: "bg-warningBgDefault"
    });
  }, [g, t == null ? void 0 : t.phase]);
  const y = kfe(
    t,
    i,
    e
  ), w = () => {
    if (y)
      return /* @__PURE__ */ d("div", { className: "text-bodylg text-textPrimary mb-1", children: Ge(y, { ordinanceLink: f }) });
  }, C = Aw(
    t,
    i,
    e
  ), S = Nw(
    t,
    i,
    e
  ), N = () => {
    if (C && S)
      return /* @__PURE__ */ k(xe, { children: [
        /* @__PURE__ */ d("div", { className: z("w-full border-b", l.border) }),
        /* @__PURE__ */ d(zo, { collapsible: !0, type: "single", children: /* @__PURE__ */ k(
          lo,
          {
            className: "border-b-0",
            value: "mandatory-requirements",
            children: [
              /* @__PURE__ */ d(uo, { className: "!py-0", children: /* @__PURE__ */ k("div", { className: "text-left", children: [
                /* @__PURE__ */ d("h2", { className: "text-headingmd text-textPrimary", children: "Mandatory requirements" }),
                /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued", children: "Check your proposal complies with these requirements or it won't be accepted." })
              ] }) }),
              /* @__PURE__ */ d(co, { className: "!pb-0 pt-5", children: Ge(S, {
                ordinanceLink: f
              }) })
            ]
          }
        ) })
      ] });
  }, E = () => {
    let j = [
      {
        expert_name: "landuse_report",
        title: "Land use"
      },
      {
        expert_name: "zone_works_report",
        title: "Buildings and works"
      },
      {
        expert_name: "provisions_assessor_report",
        title: "Particular provisions"
      },
      {
        expert_name: "bmo_overlay_report",
        title: "Bushfire Management Overlay"
      },
      {
        expert_name: "ddo_overlay_report",
        title: "Design and Development Overlay"
      },
      {
        expert_name: "emo_overlay_report",
        title: "Erosion Management Overlay"
      },
      {
        expert_name: "eso_overlay_report",
        title: "Environmental Significance Overlay"
      },
      {
        expert_name: "ho_overlay_report",
        title: "Heritage Overlay"
      },
      {
        expert_name: "lsio_overlay_report",
        title: "Land Subject to Inundation Overlay"
      },
      {
        expert_name: "sbo_overlay_report",
        title: "Special Building Overlay"
      },
      {
        expert_name: "slo_overlay_report",
        title: "Significant Landscape Overlay"
      },
      {
        expert_name: "vpo_overlay_report",
        title: "Vegetation Protection Overlay"
      },
      {
        expert_name: "tree_policy_assessor",
        title: "Local policies"
      }
    ];
    return n && Array.isArray(n.report_details) && n.report_details.length > 0 && (j = n.report_details), /* @__PURE__ */ d("div", { className: "flex flex-col gap-5", children: j.map((B, q) => {
      var Z, de, ne, Y, le, be, pe, Ee, ge, Ce, ie, ye;
      const { expert_name: G = "", output_key: U = "", title: V } = B;
      let H = "";
      if (U && ((de = (Z = i == null ? void 0 : i[G]) == null ? void 0 : Z.parsed_output) != null && de[U]) ? H = (Y = (ne = i == null ? void 0 : i[G]) == null ? void 0 : ne.parsed_output) == null ? void 0 : Y[U] : (le = i == null ? void 0 : i[G]) != null && le.raw_output && (H = (be = i == null ? void 0 : i[G]) == null ? void 0 : be.raw_output), !H || H.trim().toLowerCase().startsWith("no content") || /^no (.+) at this address/.test(H.trim().toLowerCase()))
        return null;
      if (B.filter) {
        const { target: ve, operation: Q, output_key: Oe } = B.filter;
        let se = "";
        if (Oe && ((Ee = (pe = i == null ? void 0 : i[G]) == null ? void 0 : pe.parsed_output) != null && Ee[Oe]) ? se = (Ce = (ge = i == null ? void 0 : i[G]) == null ? void 0 : ge.parsed_output) == null ? void 0 : Ce[Oe] : (ie = i == null ? void 0 : i[G]) != null && ie.raw_output && (se = (ye = i == null ? void 0 : i[G]) == null ? void 0 : ye.raw_output), ve && Q === "includes" && se.includes(ve))
          return null;
      }
      return /* @__PURE__ */ k("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ d("h3", { className: "text-headingsm text-textPrimary", children: V }),
        Ge(H, {
          components: {
            h1({ children: ve }) {
              return /* @__PURE__ */ d("h4", { className: "text-headingsm", children: ve });
            },
            h2({ children: ve }) {
              return /* @__PURE__ */ d("h4", { className: "text-headingsm", children: ve });
            },
            h3({ children: ve }) {
              return /* @__PURE__ */ d("h4", { className: "text-headingsm", children: ve });
            },
            h4({ children: ve }) {
              return /* @__PURE__ */ d("h4", { className: "text-headingsm", children: ve });
            }
          },
          ordinanceLink: f
        })
      ] }, q);
    }) });
  }, A = () => /* @__PURE__ */ k(xe, { children: [
    /* @__PURE__ */ d("div", { className: z("w-full border-b", l.border) }),
    /* @__PURE__ */ d(zo, { collapsible: !0, type: "single", children: /* @__PURE__ */ k(lo, { className: "border-b-0", value: "detailed-analysis", children: [
      /* @__PURE__ */ d(uo, { className: "!py-0", children: /* @__PURE__ */ k("div", { className: "text-left", children: [
        /* @__PURE__ */ d("h2", { className: "text-headingmd text-textPrimary", children: "Detailed analysis" }),
        /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued", children: "Breakdown by the zone, overlays, and other controls relevant to your proposal." })
      ] }) }),
      /* @__PURE__ */ d(co, { className: "!pb-0 pt-5", children: /* @__PURE__ */ d(Nt, { maxHeight: 300, children: E() }) })
    ] }) })
  ] }), O = () => {
    if (v && !m && !h && !s)
      return /* @__PURE__ */ k(xe, { children: [
        /* @__PURE__ */ d("div", { className: z("w-full border-b", l.border) }),
        /* @__PURE__ */ d(et, { className: "w-min", onClick: o, children: "Check exemption criteria" })
      ] });
  }, T = () => {
    if (v && !m && !h && !s)
      return /* @__PURE__ */ k(xe, { children: [
        /* @__PURE__ */ d("div", { className: z("w-full border-b", l.border) }),
        /* @__PURE__ */ k("div", { children: [
          /* @__PURE__ */ d("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Ready to apply?" }),
          /* @__PURE__ */ d("p", { className: "text-bodymd text-textPrimary mb-3", children: "Check what information you'll need to provide to council when you apply." }),
          /* @__PURE__ */ d(et, { className: "w-min", onClick: a, children: "Check application requirements" })
        ] })
      ] });
  }, M = () => {
    if (v && h)
      return /* @__PURE__ */ k(xe, { children: [
        /* @__PURE__ */ d("div", { className: z("w-full border-b", l.border) }),
        /* @__PURE__ */ k("div", { className: "flex flex-col gap-5", children: [
          /* @__PURE__ */ d(
            "h2",
            {
              className: "text-headinglg text-textPrimary",
              id: "application-requirements",
              children: "Application requirements"
            }
          ),
          /* @__PURE__ */ d(
            dx,
            {
              configPrefix: e,
              conversation: t,
              noticeboardData: i,
              ordinanceLink: f
            }
          ),
          /* @__PURE__ */ d(
            fx,
            {
              configPrefix: e,
              conversation: t,
              noticeboardData: i,
              ordinanceLink: f
            }
          )
        ] })
      ] });
  }, L = () => {
    var I, j, B, q;
    switch (g) {
      case De.NoPermitRequired:
        return /* @__PURE__ */ k("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ k("div", { className: "flex flex-col gap-1", children: [
            ((I = t == null ? void 0 : t.address_data) == null ? void 0 : I.lga_name) !== "Sunshine Coast" ? /* @__PURE__ */ d("h2", { className: "text-headingmd text-textPrimary", children: "Why your proposal likely doesn't require a planning permit." }) : null,
            w()
          ] }),
          N(),
          A()
        ] });
      case De.MoreInformationRequired:
        return /* @__PURE__ */ k("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ k("div", { className: "flex flex-col gap-1", children: [
            ((j = t == null ? void 0 : t.address_data) == null ? void 0 : j.lga_name) !== "Sunshine Coast" ? /* @__PURE__ */ d("h2", { className: "text-headingmd text-textPrimary", children: "Why a planning permit could be required" }) : null,
            w()
          ] }),
          N(),
          A(),
          O(),
          M()
        ] });
      case De.RequiresPermit:
        return /* @__PURE__ */ k("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ k("div", { className: "flex flex-col gap-1", children: [
            ((B = t == null ? void 0 : t.address_data) == null ? void 0 : B.lga_name) !== "Sunshine Coast" ? /* @__PURE__ */ d("h2", { className: "text-headingmd text-textPrimary", children: "Why a permit is likely required" }) : null,
            w()
          ] }),
          N(),
          A(),
          M(),
          T()
        ] });
      case De.Prohibited:
        return /* @__PURE__ */ d("div", { className: "flex flex-col gap-6", children: /* @__PURE__ */ k("div", { className: "flex flex-col gap-1", children: [
          ((q = t == null ? void 0 : t.address_data) == null ? void 0 : q.lga_name) !== "Sunshine Coast" ? /* @__PURE__ */ d("h2", { className: "text-headingmd text-textPrimary", children: "Why your proposal is likely prohibited" }) : null,
          w()
        ] }) });
    }
  };
  return /* @__PURE__ */ k(
    "div",
    {
      className: z(
        "flex flex-col gap-6 rounded-lg border border-l-[12px] p-5 md:p-8",
        l.border,
        l.bgLight
      ),
      "data-testid": "assessment-report",
      children: [
        /* @__PURE__ */ d("h2", { className: "text-textPrimary text-heading2xl font-medium", children: ip(t, i, e) }),
        L()
      ]
    }
  );
}
function Ks(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = x.createContext(a), l = n.length;
    n = [...n, a];
    function u(f) {
      const { scope: h, children: m, ...v } = f, g = (h == null ? void 0 : h[e][l]) || s, y = x.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ d(g.Provider, { value: y, children: m });
    }
    function c(f, h) {
      const m = (h == null ? void 0 : h[e][l]) || s, v = x.useContext(m);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return u.displayName = o + "Provider", [u, c];
  }
  const i = () => {
    const o = n.map((a) => x.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return x.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, Ife(i, ...t)];
}
function Ife(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return x.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function $fe(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function TB(...e) {
  return (t) => e.forEach((n) => $fe(n, t));
}
function tt(...e) {
  return x.useCallback(TB(...e), e);
}
var Nc = x.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = x.Children.toArray(n), o = i.find(Ffe);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? x.Children.count(a) > 1 ? x.Children.only(null) : x.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ d(hx, { ...r, ref: t, children: x.isValidElement(a) ? x.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ d(hx, { ...r, ref: t, children: n });
});
Nc.displayName = "Slot";
var hx = x.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (x.isValidElement(n)) {
    const i = jfe(n);
    return x.cloneElement(n, {
      ...Bfe(r, n.props),
      // @ts-ignore
      ref: t ? TB(t, i) : i
    });
  }
  return x.Children.count(n) > 1 ? x.Children.only(null) : null;
});
hx.displayName = "SlotClone";
var Lfe = ({ children: e }) => /* @__PURE__ */ d(xe, { children: e });
function Ffe(e) {
  return x.isValidElement(e) && e.type === Lfe;
}
function Bfe(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function jfe(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Vg(e) {
  const t = e + "CollectionProvider", [n, r] = Ks(t), [i, o] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (m) => {
    const { scope: v, children: g } = m, y = F.useRef(null), w = F.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ d(i, { scope: v, itemMap: w, collectionRef: y, children: g });
  };
  a.displayName = t;
  const s = e + "CollectionSlot", l = F.forwardRef(
    (m, v) => {
      const { scope: g, children: y } = m, w = o(s, g), C = tt(v, w.collectionRef);
      return /* @__PURE__ */ d(Nc, { ref: C, children: y });
    }
  );
  l.displayName = s;
  const u = e + "CollectionItemSlot", c = "data-radix-collection-item", f = F.forwardRef(
    (m, v) => {
      const { scope: g, children: y, ...w } = m, C = F.useRef(null), S = tt(v, C), N = o(u, g);
      return F.useEffect(() => (N.itemMap.set(C, { ref: C, ...w }), () => void N.itemMap.delete(C))), /* @__PURE__ */ d(Nc, { [c]: "", ref: S, children: y });
    }
  );
  f.displayName = u;
  function h(m) {
    const v = o(e + "CollectionConsumer", m);
    return F.useCallback(() => {
      const y = v.collectionRef.current;
      if (!y) return [];
      const w = Array.from(y.querySelectorAll(`[${c}]`));
      return Array.from(v.itemMap.values()).sort(
        (N, E) => w.indexOf(N.ref.current) - w.indexOf(E.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: a, Slot: l, ItemSlot: f },
    h,
    r
  ];
}
function Me(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function Ie(e) {
  const t = x.useRef(e);
  return x.useEffect(() => {
    t.current = e;
  }), x.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function Kt({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, i] = Vfe({ defaultProp: t, onChange: n }), o = e !== void 0, a = o ? e : r, s = Ie(n), l = x.useCallback(
    (u) => {
      if (o) {
        const f = typeof u == "function" ? u(e) : u;
        f !== e && s(f);
      } else
        i(u);
    },
    [o, e, i, s]
  );
  return [a, l];
}
function Vfe({
  defaultProp: e,
  onChange: t
}) {
  const n = x.useState(e), [r] = n, i = x.useRef(r), o = Ie(t);
  return x.useEffect(() => {
    i.current !== r && (o(r), i.current = r);
  }, [r, i, o]), n;
}
var qfe = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Re = qfe.reduce((e, t) => {
  const n = x.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? Nc : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function qg(e, t) {
  e && go.flushSync(() => e.dispatchEvent(t));
}
var He = globalThis != null && globalThis.document ? x.useLayoutEffect : () => {
};
function zfe(e, t) {
  return x.useReducer((n, r) => t[n][r] ?? n, e);
}
var zg = (e) => {
  const { present: t, children: n } = e, r = Wfe(t), i = typeof n == "function" ? n({ present: r.isPresent }) : x.Children.only(n), o = tt(r.ref, Hfe(i));
  return typeof n == "function" || r.isPresent ? x.cloneElement(i, { ref: o }) : null;
};
zg.displayName = "Presence";
function Wfe(e) {
  const [t, n] = x.useState(), r = x.useRef({}), i = x.useRef(e), o = x.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = zfe(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return x.useEffect(() => {
    const u = R0(r.current);
    o.current = s === "mounted" ? u : "none";
  }, [s]), He(() => {
    const u = r.current, c = i.current;
    if (c !== e) {
      const h = o.current, m = R0(u);
      e ? l("MOUNT") : m === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(c && h !== m ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, l]), He(() => {
    if (t) {
      const u = (f) => {
        const m = R0(r.current).includes(f.animationName);
        f.target === t && m && go.flushSync(() => l("ANIMATION_END"));
      }, c = (f) => {
        f.target === t && (o.current = R0(r.current));
      };
      return t.addEventListener("animationstart", c), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", c), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: x.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function R0(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Hfe(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Ufe = x.useId || (() => {
}), Gfe = 0;
function ln(e) {
  const [t, n] = x.useState(Ufe());
  return He(() => {
    n((r) => r ?? String(Gfe++));
  }, [e]), t ? `radix-${t}` : "";
}
var Rw = "Collapsible", [Kfe, MB] = Ks(Rw), [Yfe, Dw] = Kfe(Rw), RB = x.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: i,
      disabled: o,
      onOpenChange: a,
      ...s
    } = e, [l = !1, u] = Kt({
      prop: r,
      defaultProp: i,
      onChange: a
    });
    return /* @__PURE__ */ d(
      Yfe,
      {
        scope: n,
        disabled: o,
        contentId: ln(),
        open: l,
        onOpenToggle: x.useCallback(() => u((c) => !c), [u]),
        children: /* @__PURE__ */ d(
          Re.div,
          {
            "data-state": $w(l),
            "data-disabled": o ? "" : void 0,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
RB.displayName = Rw;
var DB = "CollapsibleTrigger", IB = x.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, i = Dw(DB, n);
    return /* @__PURE__ */ d(
      Re.button,
      {
        type: "button",
        "aria-controls": i.contentId,
        "aria-expanded": i.open || !1,
        "data-state": $w(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        disabled: i.disabled,
        ...r,
        ref: t,
        onClick: Me(e.onClick, i.onOpenToggle)
      }
    );
  }
);
IB.displayName = DB;
var Iw = "CollapsibleContent", $B = x.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, i = Dw(Iw, e.__scopeCollapsible);
    return /* @__PURE__ */ d(zg, { present: n || i.open, children: ({ present: o }) => /* @__PURE__ */ d(Zfe, { ...r, ref: t, present: o }) });
  }
);
$B.displayName = Iw;
var Zfe = x.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: i, ...o } = e, a = Dw(Iw, n), [s, l] = x.useState(r), u = x.useRef(null), c = tt(t, u), f = x.useRef(0), h = f.current, m = x.useRef(0), v = m.current, g = a.open || s, y = x.useRef(g), w = x.useRef();
  return x.useEffect(() => {
    const C = requestAnimationFrame(() => y.current = !1);
    return () => cancelAnimationFrame(C);
  }, []), He(() => {
    const C = u.current;
    if (C) {
      w.current = w.current || {
        transitionDuration: C.style.transitionDuration,
        animationName: C.style.animationName
      }, C.style.transitionDuration = "0s", C.style.animationName = "none";
      const S = C.getBoundingClientRect();
      f.current = S.height, m.current = S.width, y.current || (C.style.transitionDuration = w.current.transitionDuration, C.style.animationName = w.current.animationName), l(r);
    }
  }, [a.open, r]), /* @__PURE__ */ d(
    Re.div,
    {
      "data-state": $w(a.open),
      "data-disabled": a.disabled ? "" : void 0,
      id: a.contentId,
      hidden: !g,
      ...o,
      ref: c,
      style: {
        "--radix-collapsible-content-height": h ? `${h}px` : void 0,
        "--radix-collapsible-content-width": v ? `${v}px` : void 0,
        ...e.style
      },
      children: g && i
    }
  );
});
function $w(e) {
  return e ? "open" : "closed";
}
var Xfe = RB, Jfe = IB, Qfe = $B, ehe = x.createContext(void 0);
function Bi(e) {
  const t = x.useContext(ehe);
  return e || t || "ltr";
}
var Ha = "Accordion", the = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [Lw, nhe, rhe] = Vg(Ha), [Wg, CQe] = Ks(Ha, [
  rhe,
  MB
]), Fw = MB(), LB = F.forwardRef(
  (e, t) => {
    const { type: n, ...r } = e, i = r, o = r;
    return /* @__PURE__ */ d(Lw.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ d(she, { ...o, ref: t }) : /* @__PURE__ */ d(ahe, { ...i, ref: t }) });
  }
);
LB.displayName = Ha;
var [FB, ihe] = Wg(Ha), [BB, ohe] = Wg(
  Ha,
  { collapsible: !1 }
), ahe = F.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: r,
      onValueChange: i = () => {
      },
      collapsible: o = !1,
      ...a
    } = e, [s, l] = Kt({
      prop: n,
      defaultProp: r,
      onChange: i
    });
    return /* @__PURE__ */ d(
      FB,
      {
        scope: e.__scopeAccordion,
        value: s ? [s] : [],
        onItemOpen: l,
        onItemClose: F.useCallback(() => o && l(""), [o, l]),
        children: /* @__PURE__ */ d(BB, { scope: e.__scopeAccordion, collapsible: o, children: /* @__PURE__ */ d(jB, { ...a, ref: t }) })
      }
    );
  }
), she = F.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: i = () => {
    },
    ...o
  } = e, [a = [], s] = Kt({
    prop: n,
    defaultProp: r,
    onChange: i
  }), l = F.useCallback(
    (c) => s((f = []) => [...f, c]),
    [s]
  ), u = F.useCallback(
    (c) => s((f = []) => f.filter((h) => h !== c)),
    [s]
  );
  return /* @__PURE__ */ d(
    FB,
    {
      scope: e.__scopeAccordion,
      value: a,
      onItemOpen: l,
      onItemClose: u,
      children: /* @__PURE__ */ d(BB, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ d(jB, { ...o, ref: t }) })
    }
  );
}), [lhe, Hg] = Wg(Ha), jB = F.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: r, dir: i, orientation: o = "vertical", ...a } = e, s = F.useRef(null), l = tt(s, t), u = nhe(n), f = Bi(i) === "ltr", h = Me(e.onKeyDown, (m) => {
      var T;
      if (!the.includes(m.key)) return;
      const v = m.target, g = u().filter((M) => {
        var L;
        return !((L = M.ref.current) != null && L.disabled);
      }), y = g.findIndex((M) => M.ref.current === v), w = g.length;
      if (y === -1) return;
      m.preventDefault();
      let C = y;
      const S = 0, N = w - 1, E = () => {
        C = y + 1, C > N && (C = S);
      }, A = () => {
        C = y - 1, C < S && (C = N);
      };
      switch (m.key) {
        case "Home":
          C = S;
          break;
        case "End":
          C = N;
          break;
        case "ArrowRight":
          o === "horizontal" && (f ? E() : A());
          break;
        case "ArrowDown":
          o === "vertical" && E();
          break;
        case "ArrowLeft":
          o === "horizontal" && (f ? A() : E());
          break;
        case "ArrowUp":
          o === "vertical" && A();
          break;
      }
      const O = C % w;
      (T = g[O].ref.current) == null || T.focus();
    });
    return /* @__PURE__ */ d(
      lhe,
      {
        scope: n,
        disabled: r,
        direction: i,
        orientation: o,
        children: /* @__PURE__ */ d(Lw.Slot, { scope: n, children: /* @__PURE__ */ d(
          Re.div,
          {
            ...a,
            "data-orientation": o,
            ref: l,
            onKeyDown: r ? void 0 : h
          }
        ) })
      }
    );
  }
), Q1 = "AccordionItem", [uhe, Bw] = Wg(Q1), VB = F.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: r, ...i } = e, o = Hg(Q1, n), a = ihe(Q1, n), s = Fw(n), l = ln(), u = r && a.value.includes(r) || !1, c = o.disabled || e.disabled;
    return /* @__PURE__ */ d(
      uhe,
      {
        scope: n,
        open: u,
        disabled: c,
        triggerId: l,
        children: /* @__PURE__ */ d(
          Xfe,
          {
            "data-orientation": o.orientation,
            "data-state": GB(u),
            ...s,
            ...i,
            ref: t,
            disabled: c,
            open: u,
            onOpenChange: (f) => {
              f ? a.onItemOpen(r) : a.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
VB.displayName = Q1;
var qB = "AccordionHeader", zB = F.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, i = Hg(Ha, n), o = Bw(qB, n);
    return /* @__PURE__ */ d(
      Re.h3,
      {
        "data-orientation": i.orientation,
        "data-state": GB(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
zB.displayName = qB;
var px = "AccordionTrigger", WB = F.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, i = Hg(Ha, n), o = Bw(px, n), a = ohe(px, n), s = Fw(n);
    return /* @__PURE__ */ d(Lw.ItemSlot, { scope: n, children: /* @__PURE__ */ d(
      Jfe,
      {
        "aria-disabled": o.open && !a.collapsible || void 0,
        "data-orientation": i.orientation,
        id: o.triggerId,
        ...s,
        ...r,
        ref: t
      }
    ) });
  }
);
WB.displayName = px;
var HB = "AccordionContent", UB = F.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, i = Hg(Ha, n), o = Bw(HB, n), a = Fw(n);
    return /* @__PURE__ */ d(
      Qfe,
      {
        role: "region",
        "aria-labelledby": o.triggerId,
        "data-orientation": i.orientation,
        ...a,
        ...r,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
UB.displayName = HB;
function GB(e) {
  return e ? "open" : "closed";
}
var che = LB, dhe = VB, fhe = zB, KB = WB, YB = UB;
const zo = che, lo = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  dhe,
  {
    ref: n,
    className: z("not-last:border-b border-border", e),
    ...t
  }
));
lo.displayName = "AccordionItem";
const uo = te(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ d(fhe, { className: "flex", children: /* @__PURE__ */ k(
  KB,
  {
    ref: r,
    className: z(
      "flex flex-1 items-center justify-between py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ d(
        tp,
        {
          "data-open-indicator": !0,
          className: "min-h-4 min-w-4 transition-transform duration-200"
        }
      )
    ]
  }
) }));
uo.displayName = KB.displayName;
const co = te(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ d(
  YB,
  {
    ref: r,
    className: "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down text-bodysm overflow-hidden transition-all",
    ...n,
    children: /* @__PURE__ */ d("div", { className: z("pb-4 pt-0", e), children: t })
  }
));
co.displayName = YB.displayName;
function SQe({
  onSelectSuggestion: e,
  placeholder: t,
  selectedAddressId: n
}) {
  var y;
  const [r, i] = re(!1), o = yr(() => i(!0), []), a = yr(() => i(!1), []), [s, l] = re(""), u = (w) => {
    w.key === "Escape" && a();
  }, {
    data: c,
    mutate: f,
    isPending: h
  } = Lue(), m = Pue(s, 500);
  Pe(() => {
    m && f({
      body: { address: m }
    });
  }, [m, f]);
  const v = Je(() => {
    var w;
    return ((w = c == null ? void 0 : c.data) == null ? void 0 : w.suggestions) || [];
  }, [(y = c == null ? void 0 : c.data) == null ? void 0 : y.suggestions]), g = Je(() => {
    if (!(!n || !Array.isArray(v)))
      return v.find(
        (w) => w.address_id === n
      );
  }, [v, n]);
  return /* @__PURE__ */ k(
    xd,
    {
      className: "h-auto overflow-visible",
      onKeyDown: u,
      shouldFilter: !1,
      children: [
        /* @__PURE__ */ d("div", { className: "bg-background ring-offset-background focus-within:ring-ring text-bodymd flex w-full items-center justify-between rounded-lg border focus-within:ring-2 focus-within:ring-offset-2", children: g ? /* @__PURE__ */ k("div", { className: "flex w-full cursor-pointer items-center py-3 pr-3", children: [
          /* @__PURE__ */ d("span", { className: "w-full grow px-3", children: g.address }),
          /* @__PURE__ */ d(np, { onClick: () => e("") })
        ] }) : /* @__PURE__ */ d(
          sr.Input,
          {
            className: z("w-full p-3 outline-none"),
            onBlur: a,
            onFocus: o,
            onValueChange: l,
            placeholder: t || "Enter address",
            value: s
          }
        ) }),
        /* @__PURE__ */ d("div", { className: "animate-in fade-in-0 zoom-in-95 relative h-auto", children: /* @__PURE__ */ d(cp, { children: r && /* @__PURE__ */ d("div", { className: "absolute top-1.5 z-50 w-full", children: /* @__PURE__ */ k(dp, { className: "bg-background relative z-50 h-auto min-w-[8rem] overflow-hidden rounded-md border shadow-md", children: [
          h ? /* @__PURE__ */ d("div", { className: "flex h-28 items-center justify-center", children: /* @__PURE__ */ d(Xo, { className: "size-6 animate-spin" }) }) : /* @__PURE__ */ d(xe, { children: v.map((w) => /* @__PURE__ */ d(
            fp,
            {
              className: "aria-selected:bg-accent aria-selected:text-accent-foreground hover:bg-accent hover:text-accent-foreground flex h-max cursor-pointer select-text flex-col items-start gap-0.5 rounded-md p-2 px-3",
              onMouseDown: (C) => C.preventDefault(),
              onSelect: () => {
                l(""), e(w.address_id), a();
              },
              value: w.address,
              children: w.address
            },
            w.address_id
          )) }),
          /* @__PURE__ */ d(cC, { children: !h && v.length === 0 && /* @__PURE__ */ d("div", { className: "flex items-center justify-center py-4", children: s === "" ? "Please enter an address" : "No address found" }) })
        ] }) }) }) })
      ]
    }
  );
}
const tO = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, nO = at, Jo = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return nO(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: i, defaultVariants: o } = t, a = Object.keys(i).map((u) => {
    const c = n == null ? void 0 : n[u], f = o == null ? void 0 : o[u];
    if (c === null) return null;
    const h = tO(c) || tO(f);
    return i[u][h];
  }), s = n && Object.entries(n).reduce((u, c) => {
    let [f, h] = c;
    return h === void 0 || (u[f] = h), u;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((u, c) => {
    let { class: f, className: h, ...m } = c;
    return Object.entries(m).every((v) => {
      let [g, y] = v;
      return Array.isArray(y) ? y.includes({
        ...o,
        ...s
      }[g]) : {
        ...o,
        ...s
      }[g] === y;
    }) ? [
      ...u,
      f,
      h
    ] : u;
  }, []);
  return nO(e, a, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, hhe = Jo(
  "relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), phe = te(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ d(
  "div",
  {
    ref: r,
    role: "alert",
    className: z(hhe({ variant: t }), e),
    ...n
  }
));
phe.displayName = "Alert";
const mhe = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "h5",
  {
    ref: n,
    className: z(
      "mb-1 font-medium leading-none tracking-tight",
      e
    ),
    ...t
  }
));
mhe.displayName = "AlertTitle";
const ghe = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "div",
  {
    ref: n,
    className: z("text-bodysm [&_p]:leading-relaxed", e),
    ...t
  }
));
ghe.displayName = "AlertDescription";
function vhe(e, t) {
  const n = x.createContext(t), r = (o) => {
    const { children: a, ...s } = o, l = x.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ d(n.Provider, { value: l, children: a });
  };
  r.displayName = e + "Provider";
  function i(o) {
    const a = x.useContext(n);
    if (a) return a;
    if (t !== void 0) return t;
    throw new Error(`\`${o}\` must be used within \`${e}\``);
  }
  return [r, i];
}
function ZB(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = x.createContext(a), l = n.length;
    n = [...n, a];
    const u = (f) => {
      var w;
      const { scope: h, children: m, ...v } = f, g = ((w = h == null ? void 0 : h[e]) == null ? void 0 : w[l]) || s, y = x.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ d(g.Provider, { value: y, children: m });
    };
    u.displayName = o + "Provider";
    function c(f, h) {
      var g;
      const m = ((g = h == null ? void 0 : h[e]) == null ? void 0 : g[l]) || s, v = x.useContext(m);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, c];
  }
  const i = () => {
    const o = n.map((a) => x.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return x.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, yhe(i, ...t)];
}
function yhe(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return x.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function rO(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function XB(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = rO(i, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : rO(e[i], null);
        }
      };
  };
}
function Ua(...e) {
  return x.useCallback(XB(...e), e);
}
function ka(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
var jw = x.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = x.Children.toArray(n), o = i.find(bhe);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? x.Children.count(a) > 1 ? x.Children.only(null) : x.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ d(mx, { ...r, ref: t, children: x.isValidElement(a) ? x.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ d(mx, { ...r, ref: t, children: n });
});
jw.displayName = "Slot";
var mx = x.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (x.isValidElement(n)) {
    const i = whe(n);
    return x.cloneElement(n, {
      ...xhe(r, n.props),
      // @ts-ignore
      ref: t ? XB(t, i) : i
    });
  }
  return x.Children.count(n) > 1 ? x.Children.only(null) : null;
});
mx.displayName = "SlotClone";
var JB = ({ children: e }) => /* @__PURE__ */ d(xe, { children: e });
function bhe(e) {
  return x.isValidElement(e) && e.type === JB;
}
function xhe(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function whe(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Che = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ga = Che.reduce((e, t) => {
  const n = x.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? jw : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function She(e, t) {
  e && go.flushSync(() => e.dispatchEvent(t));
}
function lu(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ie(e);
  x.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var _he = "DismissableLayer", gx = "dismissableLayer.update", Ehe = "dismissableLayer.pointerDownOutside", Nhe = "dismissableLayer.focusOutside", iO, QB = x.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), ej = x.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = e, u = x.useContext(QB), [c, f] = x.useState(null), h = (c == null ? void 0 : c.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = x.useState({}), v = Ua(t, (O) => f(O)), g = Array.from(u.layers), [y] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), w = g.indexOf(y), C = c ? g.indexOf(c) : -1, S = u.layersWithOutsidePointerEventsDisabled.size > 0, N = C >= w, E = khe((O) => {
      const T = O.target, M = [...u.branches].some((L) => L.contains(T));
      !N || M || (i == null || i(O), a == null || a(O), O.defaultPrevented || s == null || s());
    }, h), A = Phe((O) => {
      const T = O.target;
      [...u.branches].some((L) => L.contains(T)) || (o == null || o(O), a == null || a(O), O.defaultPrevented || s == null || s());
    }, h);
    return lu((O) => {
      C === u.layers.size - 1 && (r == null || r(O), !O.defaultPrevented && s && (O.preventDefault(), s()));
    }, h), x.useEffect(() => {
      if (c)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (iO = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(c)), u.layers.add(c), oO(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = iO);
        };
    }, [c, h, n, u]), x.useEffect(() => () => {
      c && (u.layers.delete(c), u.layersWithOutsidePointerEventsDisabled.delete(c), oO());
    }, [c, u]), x.useEffect(() => {
      const O = () => m({});
      return document.addEventListener(gx, O), () => document.removeEventListener(gx, O);
    }, []), /* @__PURE__ */ d(
      Ga.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: S ? N ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: ka(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: ka(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: ka(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
ej.displayName = _he;
var Ahe = "DismissableLayerBranch", Ohe = x.forwardRef((e, t) => {
  const n = x.useContext(QB), r = x.useRef(null), i = Ua(t, r);
  return x.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ d(Ga.div, { ...e, ref: i });
});
Ohe.displayName = Ahe;
function khe(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ie(e), r = x.useRef(!1), i = x.useRef(() => {
  });
  return x.useEffect(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          tj(
            Ehe,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = l, t.addEventListener("click", i.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Phe(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ie(e), r = x.useRef(!1);
  return x.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && tj(Nhe, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function oO() {
  const e = new CustomEvent(gx);
  document.dispatchEvent(e);
}
function tj(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? She(i, o) : i.dispatchEvent(o);
}
var _b = "focusScope.autoFocusOnMount", Eb = "focusScope.autoFocusOnUnmount", aO = { bubbles: !1, cancelable: !0 }, The = "FocusScope", nj = x.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o,
    ...a
  } = e, [s, l] = x.useState(null), u = Ie(i), c = Ie(o), f = x.useRef(null), h = Ua(t, (g) => l(g)), m = x.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  x.useEffect(() => {
    if (r) {
      let g = function(S) {
        if (m.paused || !s) return;
        const N = S.target;
        s.contains(N) ? f.current = N : fs(f.current, { select: !0 });
      }, y = function(S) {
        if (m.paused || !s) return;
        const N = S.relatedTarget;
        N !== null && (s.contains(N) || fs(f.current, { select: !0 }));
      }, w = function(S) {
        if (document.activeElement === document.body)
          for (const E of S)
            E.removedNodes.length > 0 && fs(s);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", y);
      const C = new MutationObserver(w);
      return s && C.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", y), C.disconnect();
      };
    }
  }, [r, s, m.paused]), x.useEffect(() => {
    if (s) {
      lO.add(m);
      const g = document.activeElement;
      if (!s.contains(g)) {
        const w = new CustomEvent(_b, aO);
        s.addEventListener(_b, u), s.dispatchEvent(w), w.defaultPrevented || (Mhe(Lhe(rj(s)), { select: !0 }), document.activeElement === g && fs(s));
      }
      return () => {
        s.removeEventListener(_b, u), setTimeout(() => {
          const w = new CustomEvent(Eb, aO);
          s.addEventListener(Eb, c), s.dispatchEvent(w), w.defaultPrevented || fs(g ?? document.body, { select: !0 }), s.removeEventListener(Eb, c), lO.remove(m);
        }, 0);
      };
    }
  }, [s, u, c, m]);
  const v = x.useCallback(
    (g) => {
      if (!n && !r || m.paused) return;
      const y = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, w = document.activeElement;
      if (y && w) {
        const C = g.currentTarget, [S, N] = Rhe(C);
        S && N ? !g.shiftKey && w === N ? (g.preventDefault(), n && fs(S, { select: !0 })) : g.shiftKey && w === S && (g.preventDefault(), n && fs(N, { select: !0 })) : w === C && g.preventDefault();
      }
    },
    [n, r, m.paused]
  );
  return /* @__PURE__ */ d(Ga.div, { tabIndex: -1, ...a, ref: h, onKeyDown: v });
});
nj.displayName = The;
function Mhe(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (fs(r, { select: t }), document.activeElement !== n) return;
}
function Rhe(e) {
  const t = rj(e), n = sO(t, e), r = sO(t.reverse(), e);
  return [n, r];
}
function rj(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function sO(e, t) {
  for (const n of e)
    if (!Dhe(n, { upTo: t })) return n;
}
function Dhe(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Ihe(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function fs(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && Ihe(e) && t && e.select();
  }
}
var lO = $he();
function $he() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = uO(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = uO(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function uO(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Lhe(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Fhe = "Portal", ij = x.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [i, o] = x.useState(!1);
  He(() => o(!0), []);
  const a = n || i && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return a ? Zo.createPortal(/* @__PURE__ */ d(Ga.div, { ...r, ref: t }), a) : null;
});
ij.displayName = Fhe;
function Bhe(e, t) {
  return x.useReducer((n, r) => t[n][r] ?? n, e);
}
var Ug = (e) => {
  const { present: t, children: n } = e, r = jhe(t), i = typeof n == "function" ? n({ present: r.isPresent }) : x.Children.only(n), o = Ua(r.ref, Vhe(i));
  return typeof n == "function" || r.isPresent ? x.cloneElement(i, { ref: o }) : null;
};
Ug.displayName = "Presence";
function jhe(e) {
  const [t, n] = x.useState(), r = x.useRef({}), i = x.useRef(e), o = x.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = Bhe(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return x.useEffect(() => {
    const u = D0(r.current);
    o.current = s === "mounted" ? u : "none";
  }, [s]), He(() => {
    const u = r.current, c = i.current;
    if (c !== e) {
      const h = o.current, m = D0(u);
      e ? l("MOUNT") : m === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(c && h !== m ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, l]), He(() => {
    if (t) {
      let u;
      const c = t.ownerDocument.defaultView ?? window, f = (m) => {
        const g = D0(r.current).includes(m.animationName);
        if (m.target === t && g && (l("ANIMATION_END"), !i.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = c.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, h = (m) => {
        m.target === t && (o.current = D0(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        c.clearTimeout(u), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: x.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function D0(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Vhe(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Nb = 0;
function Vw() {
  x.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? cO()), document.body.insertAdjacentElement("beforeend", e[1] ?? cO()), Nb++, () => {
      Nb === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Nb--;
    };
  }, []);
}
function cO() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Ke = function() {
  return Ke = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, Ke.apply(this, arguments);
};
function Qo(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function vd(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var I1 = "right-scroll-bar-position", $1 = "width-before-scroll-bar", qhe = "with-scroll-bars-hidden", zhe = "--removed-body-scroll-bar-size";
function Ab(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Whe(e, t) {
  var n = re(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var Hhe = typeof window < "u" ? x.useLayoutEffect : x.useEffect, dO = /* @__PURE__ */ new WeakMap();
function Uhe(e, t) {
  var n = Whe(null, function(r) {
    return e.forEach(function(i) {
      return Ab(i, r);
    });
  });
  return Hhe(function() {
    var r = dO.get(n);
    if (r) {
      var i = new Set(r), o = new Set(e), a = n.current;
      i.forEach(function(s) {
        o.has(s) || Ab(s, null);
      }), o.forEach(function(s) {
        i.has(s) || Ab(s, a);
      });
    }
    dO.set(n, e);
  }, [e]), n;
}
function Ghe(e) {
  return e;
}
function Khe(e, t) {
  t === void 0 && (t = Ghe);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(o) {
      var a = t(o, r);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(o);
      }
      n = {
        push: function(s) {
          return o(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(o), a = n;
      }
      var l = function() {
        var c = a;
        a = [], c.forEach(o);
      }, u = function() {
        return Promise.resolve().then(l);
      };
      u(), n = {
        push: function(c) {
          a.push(c), u();
        },
        filter: function(c) {
          return a = a.filter(c), n;
        }
      };
    }
  };
  return i;
}
function Yhe(e) {
  e === void 0 && (e = {});
  var t = Khe(null);
  return t.options = Ke({ async: !0, ssr: !1 }, e), t;
}
var oj = function(e) {
  var t = e.sideCar, n = Qo(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return x.createElement(r, Ke({}, n));
};
oj.isSideCarExport = !0;
function Zhe(e, t) {
  return e.useMedium(t), oj;
}
var aj = Yhe(), Ob = function() {
}, Gg = x.forwardRef(function(e, t) {
  var n = x.useRef(null), r = x.useState({
    onScrollCapture: Ob,
    onWheelCapture: Ob,
    onTouchMoveCapture: Ob
  }), i = r[0], o = r[1], a = e.forwardProps, s = e.children, l = e.className, u = e.removeScrollBar, c = e.enabled, f = e.shards, h = e.sideCar, m = e.noIsolation, v = e.inert, g = e.allowPinchZoom, y = e.as, w = y === void 0 ? "div" : y, C = e.gapMode, S = Qo(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), N = h, E = Uhe([n, t]), A = Ke(Ke({}, S), i);
  return x.createElement(
    x.Fragment,
    null,
    c && x.createElement(N, { sideCar: aj, removeScrollBar: u, shards: f, noIsolation: m, inert: v, setCallbacks: o, allowPinchZoom: !!g, lockRef: n, gapMode: C }),
    a ? x.cloneElement(x.Children.only(s), Ke(Ke({}, A), { ref: E })) : x.createElement(w, Ke({}, A, { className: l, ref: E }), s)
  );
});
Gg.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Gg.classNames = {
  fullWidth: $1,
  zeroRight: I1
};
var Kg = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Xhe() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Kg();
  return t && e.setAttribute("nonce", t), e;
}
function Jhe(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Qhe(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var epe = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Xhe()) && (Jhe(t, n), Qhe(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, tpe = function() {
  var e = epe();
  return function(t, n) {
    x.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, sj = function() {
  var e = tpe(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, npe = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, kb = function(e) {
  return parseInt(e || "", 10) || 0;
}, rpe = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [kb(n), kb(r), kb(i)];
}, ipe = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return npe;
  var t = rpe(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, ope = sj(), uc = "data-scroll-locked", ape = function(e, t, n, r) {
  var i = e.left, o = e.top, a = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(qhe, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(uc, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(I1, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat($1, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(I1, " .").concat(I1, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat($1, " .").concat($1, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(uc, `] {
    `).concat(zhe, ": ").concat(s, `px;
  }
`);
}, fO = function() {
  var e = parseInt(document.body.getAttribute(uc) || "0", 10);
  return isFinite(e) ? e : 0;
}, spe = function() {
  x.useEffect(function() {
    return document.body.setAttribute(uc, (fO() + 1).toString()), function() {
      var e = fO() - 1;
      e <= 0 ? document.body.removeAttribute(uc) : document.body.setAttribute(uc, e.toString());
    };
  }, []);
}, lpe = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
  spe();
  var o = x.useMemo(function() {
    return ipe(i);
  }, [i]);
  return x.createElement(ope, { styles: ape(o, !t, i, n ? "" : "!important") });
}, vx = !1;
if (typeof window < "u")
  try {
    var I0 = Object.defineProperty({}, "passive", {
      get: function() {
        return vx = !0, !0;
      }
    });
    window.addEventListener("test", I0, I0), window.removeEventListener("test", I0, I0);
  } catch {
    vx = !1;
  }
var Iu = vx ? { passive: !1 } : !1, upe = function(e) {
  return e.tagName === "TEXTAREA";
}, lj = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !upe(e) && n[t] === "visible")
  );
}, cpe = function(e) {
  return lj(e, "overflowY");
}, dpe = function(e) {
  return lj(e, "overflowX");
}, hO = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = uj(e, r);
    if (i) {
      var o = cj(e, r), a = o[1], s = o[2];
      if (a > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, fpe = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, hpe = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, uj = function(e, t) {
  return e === "v" ? cpe(t) : dpe(t);
}, cj = function(e, t) {
  return e === "v" ? fpe(t) : hpe(t);
}, ppe = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, mpe = function(e, t, n, r, i) {
  var o = ppe(e, window.getComputedStyle(t).direction), a = o * r, s = n.target, l = t.contains(s), u = !1, c = a > 0, f = 0, h = 0;
  do {
    var m = cj(e, s), v = m[0], g = m[1], y = m[2], w = g - y - o * v;
    (v || w) && uj(e, s) && (f += w, h += v), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (c && Math.abs(f) < 1 || !c && Math.abs(h) < 1) && (u = !0), u;
}, $0 = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, pO = function(e) {
  return [e.deltaX, e.deltaY];
}, mO = function(e) {
  return e && "current" in e ? e.current : e;
}, gpe = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, vpe = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, ype = 0, $u = [];
function bpe(e) {
  var t = x.useRef([]), n = x.useRef([0, 0]), r = x.useRef(), i = x.useState(ype++)[0], o = x.useState(sj)[0], a = x.useRef(e);
  x.useEffect(function() {
    a.current = e;
  }, [e]), x.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var g = vd([e.lockRef.current], (e.shards || []).map(mO), !0).filter(Boolean);
      return g.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), g.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = x.useCallback(function(g, y) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !a.current.allowPinchZoom;
    var w = $0(g), C = n.current, S = "deltaX" in g ? g.deltaX : C[0] - w[0], N = "deltaY" in g ? g.deltaY : C[1] - w[1], E, A = g.target, O = Math.abs(S) > Math.abs(N) ? "h" : "v";
    if ("touches" in g && O === "h" && A.type === "range")
      return !1;
    var T = hO(O, A);
    if (!T)
      return !0;
    if (T ? E = O : (E = O === "v" ? "h" : "v", T = hO(O, A)), !T)
      return !1;
    if (!r.current && "changedTouches" in g && (S || N) && (r.current = E), !E)
      return !0;
    var M = r.current || E;
    return mpe(M, y, g, M === "h" ? S : N);
  }, []), l = x.useCallback(function(g) {
    var y = g;
    if (!(!$u.length || $u[$u.length - 1] !== o)) {
      var w = "deltaY" in y ? pO(y) : $0(y), C = t.current.filter(function(E) {
        return E.name === y.type && (E.target === y.target || y.target === E.shadowParent) && gpe(E.delta, w);
      })[0];
      if (C && C.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!C) {
        var S = (a.current.shards || []).map(mO).filter(Boolean).filter(function(E) {
          return E.contains(y.target);
        }), N = S.length > 0 ? s(y, S[0]) : !a.current.noIsolation;
        N && y.cancelable && y.preventDefault();
      }
    }
  }, []), u = x.useCallback(function(g, y, w, C) {
    var S = { name: g, delta: y, target: w, should: C, shadowParent: xpe(w) };
    t.current.push(S), setTimeout(function() {
      t.current = t.current.filter(function(N) {
        return N !== S;
      });
    }, 1);
  }, []), c = x.useCallback(function(g) {
    n.current = $0(g), r.current = void 0;
  }, []), f = x.useCallback(function(g) {
    u(g.type, pO(g), g.target, s(g, e.lockRef.current));
  }, []), h = x.useCallback(function(g) {
    u(g.type, $0(g), g.target, s(g, e.lockRef.current));
  }, []);
  x.useEffect(function() {
    return $u.push(o), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, Iu), document.addEventListener("touchmove", l, Iu), document.addEventListener("touchstart", c, Iu), function() {
      $u = $u.filter(function(g) {
        return g !== o;
      }), document.removeEventListener("wheel", l, Iu), document.removeEventListener("touchmove", l, Iu), document.removeEventListener("touchstart", c, Iu);
    };
  }, []);
  var m = e.removeScrollBar, v = e.inert;
  return x.createElement(
    x.Fragment,
    null,
    v ? x.createElement(o, { styles: vpe(i) }) : null,
    m ? x.createElement(lpe, { gapMode: e.gapMode }) : null
  );
}
function xpe(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const wpe = Zhe(aj, bpe);
var dj = x.forwardRef(function(e, t) {
  return x.createElement(Gg, Ke({}, e, { ref: t, sideCar: wpe }));
});
dj.classNames = Gg.classNames;
var Cpe = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Lu = /* @__PURE__ */ new WeakMap(), L0 = /* @__PURE__ */ new WeakMap(), F0 = {}, Pb = 0, fj = function(e) {
  return e && (e.host || fj(e.parentNode));
}, Spe = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = fj(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, _pe = function(e, t, n, r) {
  var i = Spe(t, Array.isArray(e) ? e : [e]);
  F0[n] || (F0[n] = /* @__PURE__ */ new WeakMap());
  var o = F0[n], a = [], s = /* @__PURE__ */ new Set(), l = new Set(i), u = function(f) {
    !f || s.has(f) || (s.add(f), u(f.parentNode));
  };
  i.forEach(u);
  var c = function(f) {
    !f || l.has(f) || Array.prototype.forEach.call(f.children, function(h) {
      if (s.has(h))
        c(h);
      else
        try {
          var m = h.getAttribute(r), v = m !== null && m !== "false", g = (Lu.get(h) || 0) + 1, y = (o.get(h) || 0) + 1;
          Lu.set(h, g), o.set(h, y), a.push(h), g === 1 && v && L0.set(h, !0), y === 1 && h.setAttribute(n, "true"), v || h.setAttribute(r, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", h, w);
        }
    });
  };
  return c(t), s.clear(), Pb++, function() {
    a.forEach(function(f) {
      var h = Lu.get(f) - 1, m = o.get(f) - 1;
      Lu.set(f, h), o.set(f, m), h || (L0.has(f) || f.removeAttribute(r), L0.delete(f)), m || f.removeAttribute(n);
    }), Pb--, Pb || (Lu = /* @__PURE__ */ new WeakMap(), Lu = /* @__PURE__ */ new WeakMap(), L0 = /* @__PURE__ */ new WeakMap(), F0 = {});
  };
}, yd = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), i = Cpe(e);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), _pe(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, qw = "Dialog", [hj, pj] = ZB(qw), [Epe, vo] = hj(qw), mj = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    modal: a = !0
  } = e, s = x.useRef(null), l = x.useRef(null), [u = !1, c] = Kt({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ d(
    Epe,
    {
      scope: t,
      triggerRef: s,
      contentRef: l,
      contentId: ln(),
      titleId: ln(),
      descriptionId: ln(),
      open: u,
      onOpenChange: c,
      onOpenToggle: x.useCallback(() => c((f) => !f), [c]),
      modal: a,
      children: n
    }
  );
};
mj.displayName = qw;
var gj = "DialogTrigger", vj = x.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = vo(gj, n), o = Ua(t, i.triggerRef);
    return /* @__PURE__ */ d(
      Ga.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": Hw(i.open),
        ...r,
        ref: o,
        onClick: ka(e.onClick, i.onOpenToggle)
      }
    );
  }
);
vj.displayName = gj;
var zw = "DialogPortal", [Npe, yj] = hj(zw, {
  forceMount: void 0
}), bj = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: i } = e, o = vo(zw, t);
  return /* @__PURE__ */ d(Npe, { scope: t, forceMount: n, children: x.Children.map(r, (a) => /* @__PURE__ */ d(Ug, { present: n || o.open, children: /* @__PURE__ */ d(ij, { asChild: !0, container: i, children: a }) })) });
};
bj.displayName = zw;
var em = "DialogOverlay", xj = x.forwardRef(
  (e, t) => {
    const n = yj(em, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = vo(em, e.__scopeDialog);
    return o.modal ? /* @__PURE__ */ d(Ug, { present: r || o.open, children: /* @__PURE__ */ d(Ape, { ...i, ref: t }) }) : null;
  }
);
xj.displayName = em;
var Ape = x.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = vo(em, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ d(dj, { as: jw, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ d(
        Ga.div,
        {
          "data-state": Hw(i.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Gl = "DialogContent", wj = x.forwardRef(
  (e, t) => {
    const n = yj(Gl, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = vo(Gl, e.__scopeDialog);
    return /* @__PURE__ */ d(Ug, { present: r || o.open, children: o.modal ? /* @__PURE__ */ d(Ope, { ...i, ref: t }) : /* @__PURE__ */ d(kpe, { ...i, ref: t }) });
  }
);
wj.displayName = Gl;
var Ope = x.forwardRef(
  (e, t) => {
    const n = vo(Gl, e.__scopeDialog), r = x.useRef(null), i = Ua(t, n.contentRef, r);
    return x.useEffect(() => {
      const o = r.current;
      if (o) return yd(o);
    }, []), /* @__PURE__ */ d(
      Cj,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: ka(e.onCloseAutoFocus, (o) => {
          var a;
          o.preventDefault(), (a = n.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: ka(e.onPointerDownOutside, (o) => {
          const a = o.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || s) && o.preventDefault();
        }),
        onFocusOutside: ka(
          e.onFocusOutside,
          (o) => o.preventDefault()
        )
      }
    );
  }
), kpe = x.forwardRef(
  (e, t) => {
    const n = vo(Gl, e.__scopeDialog), r = x.useRef(!1), i = x.useRef(!1);
    return /* @__PURE__ */ d(
      Cj,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var a, s;
          (a = e.onCloseAutoFocus) == null || a.call(e, o), o.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), o.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (o) => {
          var l, u;
          (l = e.onInteractOutside) == null || l.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const a = o.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(a)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
        }
      }
    );
  }
), Cj = x.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, ...a } = e, s = vo(Gl, n), l = x.useRef(null), u = Ua(t, l);
    return Vw(), /* @__PURE__ */ k(xe, { children: [
      /* @__PURE__ */ d(
        nj,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: o,
          children: /* @__PURE__ */ d(
            ej,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": Hw(s.open),
              ...a,
              ref: u,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ k(xe, { children: [
        /* @__PURE__ */ d(Tpe, { titleId: s.titleId }),
        /* @__PURE__ */ d(Rpe, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Ww = "DialogTitle", Sj = x.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = vo(Ww, n);
    return /* @__PURE__ */ d(Ga.h2, { id: i.titleId, ...r, ref: t });
  }
);
Sj.displayName = Ww;
var _j = "DialogDescription", Ej = x.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = vo(_j, n);
    return /* @__PURE__ */ d(Ga.p, { id: i.descriptionId, ...r, ref: t });
  }
);
Ej.displayName = _j;
var Nj = "DialogClose", Aj = x.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = vo(Nj, n);
    return /* @__PURE__ */ d(
      Ga.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: ka(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
Aj.displayName = Nj;
function Hw(e) {
  return e ? "open" : "closed";
}
var Oj = "DialogTitleWarning", [Ppe, kj] = vhe(Oj, {
  contentName: Gl,
  titleName: Ww,
  docsSlug: "dialog"
}), Tpe = ({ titleId: e }) => {
  const t = kj(Oj), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return x.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, Mpe = "DialogDescriptionWarning", Rpe = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${kj(Mpe).contentName}}.`;
  return x.useEffect(() => {
    var o;
    const i = (o = e.current) == null ? void 0 : o.getAttribute("aria-describedby");
    t && i && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, Dpe = mj, Ipe = vj, $pe = bj, Lpe = xj, Fpe = wj, Bpe = Sj, jpe = Ej, Pj = Aj, Tj = "AlertDialog", [Vpe, _Qe] = ZB(Tj, [
  pj
]), Ka = pj(), Mj = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = Ka(t);
  return /* @__PURE__ */ d(Dpe, { ...r, ...n, modal: !0 });
};
Mj.displayName = Tj;
var qpe = "AlertDialogTrigger", Rj = x.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, i = Ka(n);
    return /* @__PURE__ */ d(Ipe, { ...i, ...r, ref: t });
  }
);
Rj.displayName = qpe;
var zpe = "AlertDialogPortal", Dj = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = Ka(t);
  return /* @__PURE__ */ d($pe, { ...r, ...n });
};
Dj.displayName = zpe;
var Wpe = "AlertDialogOverlay", Ij = x.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, i = Ka(n);
    return /* @__PURE__ */ d(Lpe, { ...i, ...r, ref: t });
  }
);
Ij.displayName = Wpe;
var cc = "AlertDialogContent", [Hpe, Upe] = Vpe(cc), $j = x.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, children: r, ...i } = e, o = Ka(n), a = x.useRef(null), s = Ua(t, a), l = x.useRef(null);
    return /* @__PURE__ */ d(
      Ppe,
      {
        contentName: cc,
        titleName: Lj,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ d(Hpe, { scope: n, cancelRef: l, children: /* @__PURE__ */ k(
          Fpe,
          {
            role: "alertdialog",
            ...o,
            ...i,
            ref: s,
            onOpenAutoFocus: ka(i.onOpenAutoFocus, (u) => {
              var c;
              u.preventDefault(), (c = l.current) == null || c.focus({ preventScroll: !0 });
            }),
            onPointerDownOutside: (u) => u.preventDefault(),
            onInteractOutside: (u) => u.preventDefault(),
            children: [
              /* @__PURE__ */ d(JB, { children: r }),
              /* @__PURE__ */ d(Kpe, { contentRef: a })
            ]
          }
        ) })
      }
    );
  }
);
$j.displayName = cc;
var Lj = "AlertDialogTitle", Fj = x.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, i = Ka(n);
    return /* @__PURE__ */ d(Bpe, { ...i, ...r, ref: t });
  }
);
Fj.displayName = Lj;
var Bj = "AlertDialogDescription", jj = x.forwardRef((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, i = Ka(n);
  return /* @__PURE__ */ d(jpe, { ...i, ...r, ref: t });
});
jj.displayName = Bj;
var Gpe = "AlertDialogAction", Vj = x.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, i = Ka(n);
    return /* @__PURE__ */ d(Pj, { ...i, ...r, ref: t });
  }
);
Vj.displayName = Gpe;
var qj = "AlertDialogCancel", zj = x.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, { cancelRef: i } = Upe(qj, n), o = Ka(n), a = Ua(t, i);
    return /* @__PURE__ */ d(Pj, { ...o, ...r, ref: a });
  }
);
zj.displayName = qj;
var Kpe = ({ contentRef: e }) => {
  const t = `\`${cc}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${cc}\` by passing a \`${Bj}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${cc}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
  return x.useEffect(() => {
    var r;
    document.getElementById(
      (r = e.current) == null ? void 0 : r.getAttribute("aria-describedby")
    ) || console.warn(t);
  }, [t, e]), null;
}, Ype = Mj, Zpe = Rj, Xpe = Dj, Wj = Ij, Hj = $j, Uj = Vj, Gj = zj, Kj = Fj, Yj = jj;
const Jpe = Ype, EQe = Zpe, Qpe = Xpe, Zj = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  Wj,
  {
    className: z(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0  fixed inset-0 z-50 bg-black/25",
      e
    ),
    ...t,
    ref: n
  }
));
Zj.displayName = Wj.displayName;
const Xj = te(({ className: e, ...t }, n) => /* @__PURE__ */ k(Qpe, { children: [
  /* @__PURE__ */ d(Zj, {}),
  /* @__PURE__ */ d(
    Hj,
    {
      ref: n,
      className: z(
        "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border p-6 shadow-lg duration-200 sm:rounded-lg",
        e
      ),
      ...t
    }
  )
] }));
Xj.displayName = Hj.displayName;
const e0e = ({
  className: e,
  ...t
}) => /* @__PURE__ */ d(
  "div",
  {
    className: z(
      "flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...t
  }
);
e0e.displayName = "AlertDialogHeader";
const Jj = ({
  className: e,
  ...t
}) => /* @__PURE__ */ d(
  "div",
  {
    className: z(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
Jj.displayName = "AlertDialogFooter";
const Qj = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  Kj,
  {
    ref: n,
    className: z("text-bodylg font-semibold", e),
    ...t
  }
));
Qj.displayName = Kj.displayName;
const t0e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  Yj,
  {
    ref: n,
    className: z("text-muted-foreground text-bodysm", e),
    ...t
  }
));
t0e.displayName = Yj.displayName;
const eV = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  Uj,
  {
    ref: n,
    className: z(Ac(), e),
    ...t
  }
));
eV.displayName = Uj.displayName;
const n0e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  Gj,
  {
    ref: n,
    className: z(
      Ac({ variant: "outline" }),
      "mt-2 sm:mt-0",
      e
    ),
    ...t
  }
));
n0e.displayName = Gj.displayName;
function NQe({
  className: e,
  onCompleteAnimation: t,
  pauseAnimation: n,
  text: r,
  textAnimationSpeed: i = 500
}) {
  const [o, a] = re(r), [s, l] = re(""), [u, c] = re(0), f = vt(null);
  return Pe(() => {
    a(r), l(""), c(0), f.current && clearTimeout(f.current);
  }, [r]), Pe(() => {
    if (!n)
      return f.current = setTimeout(() => {
        l((h) => h + (o[u] || "")), c((h) => h + 1);
      }, i), () => {
        f.current && clearTimeout(f.current);
      };
  }, [u, o, n, i]), Pe(() => {
    u > o.length && (l(""), c(0), o.length > 0 && t && t());
  }, [u, t, o]), /* @__PURE__ */ d("div", { className: e, children: s || /* @__PURE__ */ d(xe, { children: " " }) });
}
function yx() {
  return yx = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, yx.apply(null, arguments);
}
function r0e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.includes(r)) continue;
    n[r] = e[r];
  }
  return n;
}
var i0e = $g, o0e = function(t) {
  var n = x.useRef(t);
  return i0e(function() {
    n.current = t;
  }), n;
}, gO = function(t, n) {
  if (typeof t == "function") {
    t(n);
    return;
  }
  t.current = n;
}, a0e = function(t, n) {
  var r = vt();
  return yr(function(i) {
    t.current = i, r.current && gO(r.current, null), r.current = n, n && gO(n, i);
  }, [n]);
}, vO = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0",
  display: "block"
}, s0e = function(t) {
  Object.keys(vO).forEach(function(n) {
    t.style.setProperty(n, vO[n], "important");
  });
}, yO = s0e, Er = null, bO = function(t, n) {
  var r = t.scrollHeight;
  return n.sizingStyle.boxSizing === "border-box" ? r + n.borderSize : r - n.paddingSize;
};
function l0e(e, t, n, r) {
  n === void 0 && (n = 1), r === void 0 && (r = 1 / 0), Er || (Er = document.createElement("textarea"), Er.setAttribute("tabindex", "-1"), Er.setAttribute("aria-hidden", "true"), yO(Er)), Er.parentNode === null && document.body.appendChild(Er);
  var i = e.paddingSize, o = e.borderSize, a = e.sizingStyle, s = a.boxSizing;
  Object.keys(a).forEach(function(h) {
    var m = h;
    Er.style[m] = a[m];
  }), yO(Er), Er.value = t;
  var l = bO(Er, e);
  Er.value = t, l = bO(Er, e), Er.value = "x";
  var u = Er.scrollHeight - i, c = u * n;
  s === "border-box" && (c = c + i + o), l = Math.max(c, l);
  var f = u * r;
  return s === "border-box" && (f = f + i + o), l = Math.min(f, l), [l, u];
}
var xO = function() {
}, u0e = function(t, n) {
  return t.reduce(function(r, i) {
    return r[i] = n[i], r;
  }, {});
}, c0e = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak",
  "wordSpacing",
  "scrollbarGutter"
], d0e = !!document.documentElement.currentStyle, f0e = function(t) {
  var n = window.getComputedStyle(t);
  if (n === null)
    return null;
  var r = u0e(c0e, n), i = r.boxSizing;
  if (i === "")
    return null;
  d0e && i === "border-box" && (r.width = parseFloat(r.width) + parseFloat(r.borderRightWidth) + parseFloat(r.borderLeftWidth) + parseFloat(r.paddingRight) + parseFloat(r.paddingLeft) + "px");
  var o = parseFloat(r.paddingBottom) + parseFloat(r.paddingTop), a = parseFloat(r.borderBottomWidth) + parseFloat(r.borderTopWidth);
  return {
    sizingStyle: r,
    paddingSize: o,
    borderSize: a
  };
}, h0e = f0e;
function Uw(e, t, n) {
  var r = o0e(n);
  x.useLayoutEffect(function() {
    var i = function(a) {
      return r.current(a);
    };
    if (e)
      return e.addEventListener(t, i), function() {
        return e.removeEventListener(t, i);
      };
  }, []);
}
var p0e = function(t, n) {
  Uw(document.body, "reset", function(r) {
    t.current.form === r.target && n(r);
  });
}, m0e = function(t) {
  Uw(window, "resize", t);
}, g0e = function(t) {
  Uw(document.fonts, "loadingdone", t);
}, v0e = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], y0e = function(t, n) {
  var r = t.cacheMeasurements, i = t.maxRows, o = t.minRows, a = t.onChange, s = a === void 0 ? xO : a, l = t.onHeightChange, u = l === void 0 ? xO : l, c = r0e(t, v0e), f = c.value !== void 0, h = x.useRef(null), m = a0e(h, n), v = x.useRef(0), g = x.useRef(), y = function() {
    var S = h.current, N = r && g.current ? g.current : h0e(S);
    if (N) {
      g.current = N;
      var E = l0e(N, S.value || S.placeholder || "x", o, i), A = E[0], O = E[1];
      v.current !== A && (v.current = A, S.style.setProperty("height", A + "px", "important"), u(A, {
        rowHeight: O
      }));
    }
  }, w = function(S) {
    f || y(), s(S);
  };
  return x.useLayoutEffect(y), p0e(h, function() {
    if (!f) {
      var C = h.current.value;
      requestAnimationFrame(function() {
        var S = h.current;
        S && C !== S.value && y();
      });
    }
  }), m0e(y), g0e(y), /* @__PURE__ */ x.createElement("textarea", yx({}, c, {
    onChange: w,
    ref: m
  }));
}, Pa = /* @__PURE__ */ x.forwardRef(y0e);
const tV = te(
  ({ className: e, ...t }, n) => /* @__PURE__ */ d(
    Pa,
    {
      className: z(
        "border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring focus-visible:outline-hidden flex min-h-[80px] w-full rounded-md border px-3 py-2 text-[1rem] leading-[1.25rem] placeholder:text-[1rem] placeholder:leading-[1.25rem] focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ref: n,
      ...t
    }
  )
);
tV.displayName = "AutoResizeTextarea";
function wO(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function b0e(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = wO(i, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : wO(e[i], null);
        }
      };
  };
}
var pi = x.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = x.Children.toArray(n), o = i.find(w0e);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? x.Children.count(a) > 1 ? x.Children.only(null) : x.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ d(bx, { ...r, ref: t, children: x.isValidElement(a) ? x.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ d(bx, { ...r, ref: t, children: n });
});
pi.displayName = "Slot";
var bx = x.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (x.isValidElement(n)) {
    const i = S0e(n);
    return x.cloneElement(n, {
      ...C0e(r, n.props),
      // @ts-ignore
      ref: t ? b0e(t, i) : i
    });
  }
  return x.Children.count(n) > 1 ? x.Children.only(null) : null;
});
bx.displayName = "SlotClone";
var x0e = ({ children: e }) => /* @__PURE__ */ d(xe, { children: e });
function w0e(e) {
  return x.isValidElement(e) && e.type === x0e;
}
function C0e(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function S0e(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
const Ac = Jo(
  "cursor-pointer inline-flex items-center justify-center whitespace-nowrap rounded-md text-headingmd font-normal ring-offset-background transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 gap-2 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "bg-background border border-blueDefault text-blueDefault hover:bg-blueBgLight",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-textLink underline-offset-4 hover:underline",
        plain: ""
      },
      size: {
        default: "h-10 px-4 py-2",
        xs: "px-2 py-1 text-headingxs",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
        tight: ""
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), et = te(
  ({ className: e, variant: t, size: n, asChild: r = !1, ...i }, o) => /* @__PURE__ */ d(
    r ? pi : "button",
    {
      className: z(Ac({ variant: t, size: n }), e),
      ref: o,
      ...i
    }
  )
);
et.displayName = "Button";
const _0e = Jo(
  "inline-flex items-center rounded-full border border-border px-2.5 py-0.5 text-bodysm font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function Tn({ className: e, variant: t, ...n }) {
  return /* @__PURE__ */ d("div", { className: z(_0e({ variant: t }), e), ...n });
}
var Ue = function() {
  return Ue = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, Ue.apply(this, arguments);
};
function E0e(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function nV(e, t, n) {
  for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
function op(e) {
  return e.mode === "multiple";
}
function ap(e) {
  return e.mode === "range";
}
function Yg(e) {
  return e.mode === "single";
}
var N0e = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function A0e(e, t) {
  return sn(e, "LLLL y", t);
}
function O0e(e, t) {
  return sn(e, "d", t);
}
function k0e(e, t) {
  return sn(e, "LLLL", t);
}
function P0e(e) {
  return "".concat(e);
}
function T0e(e, t) {
  return sn(e, "cccccc", t);
}
function M0e(e, t) {
  return sn(e, "yyyy", t);
}
var R0e = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: A0e,
  formatDay: O0e,
  formatMonthCaption: k0e,
  formatWeekNumber: P0e,
  formatWeekdayName: T0e,
  formatYearCaption: M0e
}), D0e = function(e, t, n) {
  return sn(e, "do MMMM (EEEE)", n);
}, I0e = function() {
  return "Month: ";
}, $0e = function() {
  return "Go to next month";
}, L0e = function() {
  return "Go to previous month";
}, F0e = function(e, t) {
  return sn(e, "cccc", t);
}, B0e = function(e) {
  return "Week n. ".concat(e);
}, j0e = function() {
  return "Year: ";
}, V0e = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: D0e,
  labelMonthDropdown: I0e,
  labelNext: $0e,
  labelPrevious: L0e,
  labelWeekNumber: B0e,
  labelWeekday: F0e,
  labelYearDropdown: j0e
});
function q0e() {
  var e = "buttons", t = N0e, n = CB, r = {}, i = {}, o = 1, a = {}, s = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: t,
    formatters: R0e,
    labels: V0e,
    locale: n,
    modifiersClassNames: r,
    modifiers: i,
    numberOfMonths: o,
    styles: a,
    today: s,
    mode: "default"
  };
}
function z0e(e) {
  var t = e.fromYear, n = e.toYear, r = e.fromMonth, i = e.toMonth, o = e.fromDate, a = e.toDate;
  return r ? o = Hr(r) : t && (o = new Date(t, 0, 1)), i ? a = Cw(i) : n && (a = new Date(n, 11, 31)), {
    fromDate: o ? Ul(o) : void 0,
    toDate: a ? Ul(a) : void 0
  };
}
var rV = Qt(void 0);
function W0e(e) {
  var t, n = e.initialProps, r = q0e(), i = z0e(n), o = i.fromDate, a = i.toDate, s = (t = n.captionLayout) !== null && t !== void 0 ? t : r.captionLayout;
  s !== "buttons" && (!o || !a) && (s = "buttons");
  var l;
  (Yg(n) || op(n) || ap(n)) && (l = n.onSelect);
  var u = Ue(Ue(Ue({}, r), n), { captionLayout: s, classNames: Ue(Ue({}, r.classNames), n.classNames), components: Ue({}, n.components), formatters: Ue(Ue({}, r.formatters), n.formatters), fromDate: o, labels: Ue(Ue({}, r.labels), n.labels), mode: n.mode || r.mode, modifiers: Ue(Ue({}, r.modifiers), n.modifiers), modifiersClassNames: Ue(Ue({}, r.modifiersClassNames), n.modifiersClassNames), onSelect: l, styles: Ue(Ue({}, r.styles), n.styles), toDate: a });
  return d(rV.Provider, { value: u, children: e.children });
}
function Yt() {
  var e = en(rV);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function iV(e) {
  var t = Yt(), n = t.locale, r = t.classNames, i = t.styles, o = t.formatters.formatCaption;
  return d("div", { className: r.caption_label, style: i.caption_label, "aria-live": "polite", role: "presentation", id: e.id, children: o(e.displayMonth, { locale: n }) });
}
function H0e(e) {
  return d("svg", Ue({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e, { children: d("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function oV(e) {
  var t, n, r = e.onChange, i = e.value, o = e.children, a = e.caption, s = e.className, l = e.style, u = Yt(), c = (n = (t = u.components) === null || t === void 0 ? void 0 : t.IconDropdown) !== null && n !== void 0 ? n : H0e;
  return k("div", { className: s, style: l, children: [d("span", { className: u.classNames.vhidden, children: e["aria-label"] }), d("select", { name: e.name, "aria-label": e["aria-label"], className: u.classNames.dropdown, style: u.styles.dropdown, value: i, onChange: r, children: o }), k("div", { className: u.classNames.caption_label, style: u.styles.caption_label, "aria-hidden": "true", children: [a, d(c, { className: u.classNames.dropdown_icon, style: u.styles.dropdown_icon })] })] });
}
function U0e(e) {
  var t, n = Yt(), r = n.fromDate, i = n.toDate, o = n.styles, a = n.locale, s = n.formatters.formatMonthCaption, l = n.classNames, u = n.components, c = n.labels.labelMonthDropdown;
  if (!r)
    return d(xe, {});
  if (!i)
    return d(xe, {});
  var f = [];
  if (Ude(r, i))
    for (var h = Hr(r), m = r.getMonth(); m <= i.getMonth(); m++)
      f.push(D1(h, m));
  else
    for (var h = Hr(/* @__PURE__ */ new Date()), m = 0; m <= 11; m++)
      f.push(D1(h, m));
  var v = function(y) {
    var w = Number(y.target.value), C = D1(Hr(e.displayMonth), w);
    e.onChange(C);
  }, g = (t = u == null ? void 0 : u.Dropdown) !== null && t !== void 0 ? t : oV;
  return d(g, { name: "months", "aria-label": c(), className: l.dropdown_month, style: o.dropdown_month, onChange: v, value: e.displayMonth.getMonth(), caption: s(e.displayMonth, { locale: a }), children: f.map(function(y) {
    return d("option", { value: y.getMonth(), children: s(y, { locale: a }) }, y.getMonth());
  }) });
}
function G0e(e) {
  var t, n = e.displayMonth, r = Yt(), i = r.fromDate, o = r.toDate, a = r.locale, s = r.styles, l = r.classNames, u = r.components, c = r.formatters.formatYearCaption, f = r.labels.labelYearDropdown, h = [];
  if (!i)
    return d(xe, {});
  if (!o)
    return d(xe, {});
  for (var m = i.getFullYear(), v = o.getFullYear(), g = m; g <= v; g++)
    h.push(XA(xB(/* @__PURE__ */ new Date()), g));
  var y = function(C) {
    var S = XA(Hr(n), Number(C.target.value));
    e.onChange(S);
  }, w = (t = u == null ? void 0 : u.Dropdown) !== null && t !== void 0 ? t : oV;
  return d(w, { name: "years", "aria-label": f(), className: l.dropdown_year, style: s.dropdown_year, onChange: y, value: n.getFullYear(), caption: c(n, { locale: a }), children: h.map(function(C) {
    return d("option", { value: C.getFullYear(), children: c(C, { locale: a }) }, C.getFullYear());
  }) });
}
function K0e(e, t) {
  var n = re(e), r = n[0], i = n[1], o = t === void 0 ? r : t;
  return [o, i];
}
function Y0e(e) {
  var t = e.month, n = e.defaultMonth, r = e.today, i = t || n || r || /* @__PURE__ */ new Date(), o = e.toDate, a = e.fromDate, s = e.numberOfMonths, l = s === void 0 ? 1 : s;
  if (o && Zf(o, i) < 0) {
    var u = -1 * (l - 1);
    i = ao(o, u);
  }
  return a && Zf(i, a) < 0 && (i = a), Hr(i);
}
function Z0e() {
  var e = Yt(), t = Y0e(e), n = K0e(t, e.month), r = n[0], i = n[1], o = function(a) {
    var s;
    if (!e.disableNavigation) {
      var l = Hr(a);
      i(l), (s = e.onMonthChange) === null || s === void 0 || s.call(e, l);
    }
  };
  return [r, o];
}
function X0e(e, t) {
  for (var n = t.reverseMonths, r = t.numberOfMonths, i = Hr(e), o = Hr(ao(i, r)), a = Zf(o, i), s = [], l = 0; l < a; l++) {
    var u = ao(i, l);
    s.push(u);
  }
  return n && (s = s.reverse()), s;
}
function J0e(e, t) {
  if (!t.disableNavigation) {
    var n = t.toDate, r = t.pagedNavigation, i = t.numberOfMonths, o = i === void 0 ? 1 : i, a = r ? o : 1, s = Hr(e);
    if (!n)
      return ao(s, a);
    var l = Zf(n, e);
    if (!(l < o))
      return ao(s, a);
  }
}
function Q0e(e, t) {
  if (!t.disableNavigation) {
    var n = t.fromDate, r = t.pagedNavigation, i = t.numberOfMonths, o = i === void 0 ? 1 : i, a = r ? o : 1, s = Hr(e);
    if (!n)
      return ao(s, -a);
    var l = Zf(s, n);
    if (!(l <= 0))
      return ao(s, -a);
  }
}
var aV = Qt(void 0);
function e1e(e) {
  var t = Yt(), n = Z0e(), r = n[0], i = n[1], o = X0e(r, t), a = J0e(r, t), s = Q0e(r, t), l = function(f) {
    return o.some(function(h) {
      return _w(f, h);
    });
  }, u = function(f, h) {
    l(f) || (h && AB(f, h) ? i(ao(f, 1 + t.numberOfMonths * -1)) : i(f));
  }, c = {
    currentMonth: r,
    displayMonths: o,
    goToMonth: i,
    goToDate: u,
    previousMonth: s,
    nextMonth: a,
    isDateDisplayed: l
  };
  return d(aV.Provider, { value: c, children: e.children });
}
function sp() {
  var e = en(aV);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function CO(e) {
  var t, n = Yt(), r = n.classNames, i = n.styles, o = n.components, a = sp().goToMonth, s = function(c) {
    a(ao(c, e.displayIndex ? -e.displayIndex : 0));
  }, l = (t = o == null ? void 0 : o.CaptionLabel) !== null && t !== void 0 ? t : iV, u = d(l, { id: e.id, displayMonth: e.displayMonth });
  return k("div", { className: r.caption_dropdowns, style: i.caption_dropdowns, children: [d("div", { className: r.vhidden, children: u }), d(U0e, { onChange: s, displayMonth: e.displayMonth }), d(G0e, { onChange: s, displayMonth: e.displayMonth })] });
}
function t1e(e) {
  return d("svg", Ue({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: d("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function n1e(e) {
  return d("svg", Ue({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: d("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var tm = te(function(e, t) {
  var n = Yt(), r = n.classNames, i = n.styles, o = [r.button_reset, r.button];
  e.className && o.push(e.className);
  var a = o.join(" "), s = Ue(Ue({}, i.button_reset), i.button);
  return e.style && Object.assign(s, e.style), d("button", Ue({}, e, { ref: t, type: "button", className: a, style: s }));
});
function r1e(e) {
  var t, n, r = Yt(), i = r.dir, o = r.locale, a = r.classNames, s = r.styles, l = r.labels, u = l.labelPrevious, c = l.labelNext, f = r.components;
  if (!e.nextMonth && !e.previousMonth)
    return d(xe, {});
  var h = u(e.previousMonth, { locale: o }), m = [
    a.nav_button,
    a.nav_button_previous
  ].join(" "), v = c(e.nextMonth, { locale: o }), g = [
    a.nav_button,
    a.nav_button_next
  ].join(" "), y = (t = f == null ? void 0 : f.IconRight) !== null && t !== void 0 ? t : n1e, w = (n = f == null ? void 0 : f.IconLeft) !== null && n !== void 0 ? n : t1e;
  return k("div", { className: a.nav, style: s.nav, children: [!e.hidePrevious && d(tm, { name: "previous-month", "aria-label": h, className: m, style: s.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick, children: i === "rtl" ? d(y, { className: a.nav_icon, style: s.nav_icon }) : d(w, { className: a.nav_icon, style: s.nav_icon }) }), !e.hideNext && d(tm, { name: "next-month", "aria-label": v, className: g, style: s.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick, children: i === "rtl" ? d(w, { className: a.nav_icon, style: s.nav_icon }) : d(y, { className: a.nav_icon, style: s.nav_icon }) })] });
}
function SO(e) {
  var t = Yt().numberOfMonths, n = sp(), r = n.previousMonth, i = n.nextMonth, o = n.goToMonth, a = n.displayMonths, s = a.findIndex(function(v) {
    return _w(e.displayMonth, v);
  }), l = s === 0, u = s === a.length - 1, c = t > 1 && (l || !u), f = t > 1 && (u || !l), h = function() {
    r && o(r);
  }, m = function() {
    i && o(i);
  };
  return d(r1e, { displayMonth: e.displayMonth, hideNext: c, hidePrevious: f, nextMonth: i, previousMonth: r, onPreviousClick: h, onNextClick: m });
}
function i1e(e) {
  var t, n = Yt(), r = n.classNames, i = n.disableNavigation, o = n.styles, a = n.captionLayout, s = n.components, l = (t = s == null ? void 0 : s.CaptionLabel) !== null && t !== void 0 ? t : iV, u;
  return i ? u = d(l, { id: e.id, displayMonth: e.displayMonth }) : a === "dropdown" ? u = d(CO, { displayMonth: e.displayMonth, id: e.id }) : a === "dropdown-buttons" ? u = k(xe, { children: [d(CO, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id }), d(SO, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id })] }) : u = k(xe, { children: [d(l, { id: e.id, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), d(SO, { displayMonth: e.displayMonth, id: e.id })] }), d("div", { className: r.caption, style: o.caption, children: u });
}
function o1e(e) {
  var t = Yt(), n = t.footer, r = t.styles, i = t.classNames.tfoot;
  return n ? d("tfoot", { className: i, style: r.tfoot, children: d("tr", { children: d("td", { colSpan: 8, children: n }) }) }) : d(xe, {});
}
function a1e(e, t, n) {
  for (var r = n ? Hl(/* @__PURE__ */ new Date()) : so(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: t }), i = [], o = 0; o < 7; o++) {
    var a = gn(r, o);
    i.push(a);
  }
  return i;
}
function s1e() {
  var e = Yt(), t = e.classNames, n = e.styles, r = e.showWeekNumber, i = e.locale, o = e.weekStartsOn, a = e.ISOWeek, s = e.formatters.formatWeekdayName, l = e.labels.labelWeekday, u = a1e(i, o, a);
  return k("tr", { style: n.head_row, className: t.head_row, children: [r && d("td", { style: n.head_cell, className: t.head_cell }), u.map(function(c, f) {
    return d("th", { scope: "col", className: t.head_cell, style: n.head_cell, "aria-label": l(c, { locale: i }), children: s(c, { locale: i }) }, f);
  })] });
}
function l1e() {
  var e, t = Yt(), n = t.classNames, r = t.styles, i = t.components, o = (e = i == null ? void 0 : i.HeadRow) !== null && e !== void 0 ? e : s1e;
  return d("thead", { style: r.head, className: n.head, children: d(o, {}) });
}
function u1e(e) {
  var t = Yt(), n = t.locale, r = t.formatters.formatDay;
  return d(xe, { children: r(e.date, { locale: n }) });
}
var Gw = Qt(void 0);
function c1e(e) {
  if (!op(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return d(Gw.Provider, { value: t, children: e.children });
  }
  return d(d1e, { initialProps: e.initialProps, children: e.children });
}
function d1e(e) {
  var t = e.initialProps, n = e.children, r = t.selected, i = t.min, o = t.max, a = function(u, c, f) {
    var h, m;
    (h = t.onDayClick) === null || h === void 0 || h.call(t, u, c, f);
    var v = !!(c.selected && i && (r == null ? void 0 : r.length) === i);
    if (!v) {
      var g = !!(!c.selected && o && (r == null ? void 0 : r.length) === o);
      if (!g) {
        var y = r ? nV([], r) : [];
        if (c.selected) {
          var w = y.findIndex(function(C) {
            return Or(u, C);
          });
          y.splice(w, 1);
        } else
          y.push(u);
        (m = t.onSelect) === null || m === void 0 || m.call(t, y, u, c, f);
      }
    }
  }, s = {
    disabled: []
  };
  r && s.disabled.push(function(u) {
    var c = o && r.length > o - 1, f = r.some(function(h) {
      return Or(h, u);
    });
    return !!(c && !f);
  });
  var l = {
    selected: r,
    onDayClick: a,
    modifiers: s
  };
  return d(Gw.Provider, { value: l, children: n });
}
function Kw() {
  var e = en(Gw);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function f1e(e, t) {
  var n = t || {}, r = n.from, i = n.to;
  return r && i ? Or(i, e) && Or(r, e) ? void 0 : Or(i, e) ? { from: i, to: void 0 } : Or(r, e) ? void 0 : ux(r, e) ? { from: e, to: i } : { from: r, to: e } : i ? ux(e, i) ? { from: i, to: e } : { from: e, to: i } : r ? AB(e, r) ? { from: e, to: r } : { from: r, to: e } : { from: e, to: void 0 };
}
var Yw = Qt(void 0);
function h1e(e) {
  if (!ap(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return d(Yw.Provider, { value: t, children: e.children });
  }
  return d(p1e, { initialProps: e.initialProps, children: e.children });
}
function p1e(e) {
  var t = e.initialProps, n = e.children, r = t.selected, i = r || {}, o = i.from, a = i.to, s = t.min, l = t.max, u = function(m, v, g) {
    var y, w;
    (y = t.onDayClick) === null || y === void 0 || y.call(t, m, v, g);
    var C = f1e(m, r);
    (w = t.onSelect) === null || w === void 0 || w.call(t, C, m, v, g);
  }, c = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (o ? (c.range_start = [o], a ? (c.range_end = [a], Or(o, a) || (c.range_middle = [
    {
      after: o,
      before: a
    }
  ])) : c.range_end = [o]) : a && (c.range_start = [a], c.range_end = [a]), s && (o && !a && c.disabled.push({
    after: xb(o, s - 1),
    before: gn(o, s - 1)
  }), o && a && c.disabled.push({
    after: o,
    before: gn(o, s - 1)
  }), !o && a && c.disabled.push({
    after: xb(a, s - 1),
    before: gn(a, s - 1)
  })), l) {
    if (o && !a && (c.disabled.push({
      before: gn(o, -l + 1)
    }), c.disabled.push({
      after: gn(o, l - 1)
    })), o && a) {
      var f = Po(a, o) + 1, h = l - f;
      c.disabled.push({
        before: xb(o, h)
      }), c.disabled.push({
        after: gn(a, h)
      });
    }
    !o && a && (c.disabled.push({
      before: gn(a, -l + 1)
    }), c.disabled.push({
      after: gn(a, l - 1)
    }));
  }
  return d(Yw.Provider, { value: { selected: r, onDayClick: u, modifiers: c }, children: n });
}
function Zw() {
  var e = en(Yw);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function L1(e) {
  return Array.isArray(e) ? nV([], e) : e !== void 0 ? [e] : [];
}
function m1e(e) {
  var t = {};
  return Object.entries(e).forEach(function(n) {
    var r = n[0], i = n[1];
    t[r] = L1(i);
  }), t;
}
var fo;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(fo || (fo = {}));
var g1e = fo.Selected, va = fo.Disabled, v1e = fo.Hidden, y1e = fo.Today, Tb = fo.RangeEnd, Mb = fo.RangeMiddle, Rb = fo.RangeStart, b1e = fo.Outside;
function x1e(e, t, n) {
  var r, i = (r = {}, r[g1e] = L1(e.selected), r[va] = L1(e.disabled), r[v1e] = L1(e.hidden), r[y1e] = [e.today], r[Tb] = [], r[Mb] = [], r[Rb] = [], r[b1e] = [], r);
  return e.fromDate && i[va].push({ before: e.fromDate }), e.toDate && i[va].push({ after: e.toDate }), op(e) ? i[va] = i[va].concat(t.modifiers[va]) : ap(e) && (i[va] = i[va].concat(n.modifiers[va]), i[Rb] = n.modifiers[Rb], i[Mb] = n.modifiers[Mb], i[Tb] = n.modifiers[Tb]), i;
}
var sV = Qt(void 0);
function w1e(e) {
  var t = Yt(), n = Kw(), r = Zw(), i = x1e(t, n, r), o = m1e(t.modifiers), a = Ue(Ue({}, i), o);
  return d(sV.Provider, { value: a, children: e.children });
}
function lV() {
  var e = en(sV);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function C1e(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function S1e(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function _1e(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function E1e(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function N1e(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function A1e(e, t) {
  var n, r = t.from, i = t.to;
  if (r && i) {
    var o = Po(i, r) < 0;
    o && (n = [i, r], r = n[0], i = n[1]);
    var a = Po(e, r) >= 0 && Po(i, e) >= 0;
    return a;
  }
  return i ? Or(i, e) : r ? Or(r, e) : !1;
}
function O1e(e) {
  return ww(e);
}
function k1e(e) {
  return Array.isArray(e) && e.every(ww);
}
function P1e(e, t) {
  return t.some(function(n) {
    if (typeof n == "boolean")
      return n;
    if (O1e(n))
      return Or(e, n);
    if (k1e(n))
      return n.includes(e);
    if (S1e(n))
      return A1e(e, n);
    if (N1e(n))
      return n.dayOfWeek.includes(e.getDay());
    if (C1e(n)) {
      var r = Po(n.before, e), i = Po(n.after, e), o = r > 0, a = i < 0, s = ux(n.before, n.after);
      return s ? a && o : o || a;
    }
    return _1e(n) ? Po(e, n.after) > 0 : E1e(n) ? Po(n.before, e) > 0 : typeof n == "function" ? n(e) : !1;
  });
}
function Xw(e, t, n) {
  var r = Object.keys(t).reduce(function(o, a) {
    var s = t[a];
    return P1e(e, s) && o.push(a), o;
  }, []), i = {};
  return r.forEach(function(o) {
    return i[o] = !0;
  }), n && !_w(e, n) && (i.outside = !0), i;
}
function T1e(e, t) {
  for (var n = Hr(e[0]), r = Cw(e[e.length - 1]), i, o, a = n; a <= r; ) {
    var s = Xw(a, t), l = !s.disabled && !s.hidden;
    if (!l) {
      a = gn(a, 1);
      continue;
    }
    if (s.selected)
      return a;
    s.today && !o && (o = a), i || (i = a), a = gn(a, 1);
  }
  return o || i;
}
var M1e = 365;
function uV(e, t) {
  var n = t.moveBy, r = t.direction, i = t.context, o = t.modifiers, a = t.retry, s = a === void 0 ? { count: 0, lastFocused: e } : a, l = i.weekStartsOn, u = i.fromDate, c = i.toDate, f = i.locale, h = {
    day: gn,
    week: lx,
    month: ao,
    year: Vce,
    startOfWeek: function(y) {
      return i.ISOWeek ? Hl(y) : so(y, { locale: f, weekStartsOn: l });
    },
    endOfWeek: function(y) {
      return i.ISOWeek ? wB(y) : Sw(y, { locale: f, weekStartsOn: l });
    }
  }, m = h[n](e, r === "after" ? 1 : -1);
  r === "before" && u ? m = qce([u, m]) : r === "after" && c && (m = zce([c, m]));
  var v = !0;
  if (o) {
    var g = Xw(m, o);
    v = !g.disabled && !g.hidden;
  }
  return v ? m : s.count > M1e ? s.lastFocused : uV(m, {
    moveBy: n,
    direction: r,
    context: i,
    modifiers: o,
    retry: Ue(Ue({}, s), { count: s.count + 1 })
  });
}
var cV = Qt(void 0);
function R1e(e) {
  var t = sp(), n = lV(), r = re(), i = r[0], o = r[1], a = re(), s = a[0], l = a[1], u = T1e(t.displayMonths, n), c = i ?? (s && t.isDateDisplayed(s)) ? s : u, f = function() {
    l(i), o(void 0);
  }, h = function(y) {
    o(y);
  }, m = Yt(), v = function(y, w) {
    if (i) {
      var C = uV(i, {
        moveBy: y,
        direction: w,
        context: m,
        modifiers: n
      });
      Or(i, C) || (t.goToDate(C, i), h(C));
    }
  }, g = {
    focusedDay: i,
    focusTarget: c,
    blur: f,
    focus: h,
    focusDayAfter: function() {
      return v("day", "after");
    },
    focusDayBefore: function() {
      return v("day", "before");
    },
    focusWeekAfter: function() {
      return v("week", "after");
    },
    focusWeekBefore: function() {
      return v("week", "before");
    },
    focusMonthBefore: function() {
      return v("month", "before");
    },
    focusMonthAfter: function() {
      return v("month", "after");
    },
    focusYearBefore: function() {
      return v("year", "before");
    },
    focusYearAfter: function() {
      return v("year", "after");
    },
    focusStartOfWeek: function() {
      return v("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return v("endOfWeek", "after");
    }
  };
  return d(cV.Provider, { value: g, children: e.children });
}
function Jw() {
  var e = en(cV);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function D1e(e, t) {
  var n = lV(), r = Xw(e, n, t);
  return r;
}
var Qw = Qt(void 0);
function I1e(e) {
  if (!Yg(e.initialProps)) {
    var t = {
      selected: void 0
    };
    return d(Qw.Provider, { value: t, children: e.children });
  }
  return d($1e, { initialProps: e.initialProps, children: e.children });
}
function $1e(e) {
  var t = e.initialProps, n = e.children, r = function(o, a, s) {
    var l, u, c;
    if ((l = t.onDayClick) === null || l === void 0 || l.call(t, o, a, s), a.selected && !t.required) {
      (u = t.onSelect) === null || u === void 0 || u.call(t, void 0, o, a, s);
      return;
    }
    (c = t.onSelect) === null || c === void 0 || c.call(t, o, o, a, s);
  }, i = {
    selected: t.selected,
    onDayClick: r
  };
  return d(Qw.Provider, { value: i, children: n });
}
function dV() {
  var e = en(Qw);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function L1e(e, t) {
  var n = Yt(), r = dV(), i = Kw(), o = Zw(), a = Jw(), s = a.focusDayAfter, l = a.focusDayBefore, u = a.focusWeekAfter, c = a.focusWeekBefore, f = a.blur, h = a.focus, m = a.focusMonthBefore, v = a.focusMonthAfter, g = a.focusYearBefore, y = a.focusYearAfter, w = a.focusStartOfWeek, C = a.focusEndOfWeek, S = function(V) {
    var H, Z, de, ne;
    Yg(n) ? (H = r.onDayClick) === null || H === void 0 || H.call(r, e, t, V) : op(n) ? (Z = i.onDayClick) === null || Z === void 0 || Z.call(i, e, t, V) : ap(n) ? (de = o.onDayClick) === null || de === void 0 || de.call(o, e, t, V) : (ne = n.onDayClick) === null || ne === void 0 || ne.call(n, e, t, V);
  }, N = function(V) {
    var H;
    h(e), (H = n.onDayFocus) === null || H === void 0 || H.call(n, e, t, V);
  }, E = function(V) {
    var H;
    f(), (H = n.onDayBlur) === null || H === void 0 || H.call(n, e, t, V);
  }, A = function(V) {
    var H;
    (H = n.onDayMouseEnter) === null || H === void 0 || H.call(n, e, t, V);
  }, O = function(V) {
    var H;
    (H = n.onDayMouseLeave) === null || H === void 0 || H.call(n, e, t, V);
  }, T = function(V) {
    var H;
    (H = n.onDayPointerEnter) === null || H === void 0 || H.call(n, e, t, V);
  }, M = function(V) {
    var H;
    (H = n.onDayPointerLeave) === null || H === void 0 || H.call(n, e, t, V);
  }, L = function(V) {
    var H;
    (H = n.onDayTouchCancel) === null || H === void 0 || H.call(n, e, t, V);
  }, I = function(V) {
    var H;
    (H = n.onDayTouchEnd) === null || H === void 0 || H.call(n, e, t, V);
  }, j = function(V) {
    var H;
    (H = n.onDayTouchMove) === null || H === void 0 || H.call(n, e, t, V);
  }, B = function(V) {
    var H;
    (H = n.onDayTouchStart) === null || H === void 0 || H.call(n, e, t, V);
  }, q = function(V) {
    var H;
    (H = n.onDayKeyUp) === null || H === void 0 || H.call(n, e, t, V);
  }, G = function(V) {
    var H;
    switch (V.key) {
      case "ArrowLeft":
        V.preventDefault(), V.stopPropagation(), n.dir === "rtl" ? s() : l();
        break;
      case "ArrowRight":
        V.preventDefault(), V.stopPropagation(), n.dir === "rtl" ? l() : s();
        break;
      case "ArrowDown":
        V.preventDefault(), V.stopPropagation(), u();
        break;
      case "ArrowUp":
        V.preventDefault(), V.stopPropagation(), c();
        break;
      case "PageUp":
        V.preventDefault(), V.stopPropagation(), V.shiftKey ? g() : m();
        break;
      case "PageDown":
        V.preventDefault(), V.stopPropagation(), V.shiftKey ? y() : v();
        break;
      case "Home":
        V.preventDefault(), V.stopPropagation(), w();
        break;
      case "End":
        V.preventDefault(), V.stopPropagation(), C();
        break;
    }
    (H = n.onDayKeyDown) === null || H === void 0 || H.call(n, e, t, V);
  }, U = {
    onClick: S,
    onFocus: N,
    onBlur: E,
    onKeyDown: G,
    onKeyUp: q,
    onMouseEnter: A,
    onMouseLeave: O,
    onPointerEnter: T,
    onPointerLeave: M,
    onTouchCancel: L,
    onTouchEnd: I,
    onTouchMove: j,
    onTouchStart: B
  };
  return U;
}
function F1e() {
  var e = Yt(), t = dV(), n = Kw(), r = Zw(), i = Yg(e) ? t.selected : op(e) ? n.selected : ap(e) ? r.selected : void 0;
  return i;
}
function B1e(e) {
  return Object.values(fo).includes(e);
}
function j1e(e, t) {
  var n = [e.classNames.day];
  return Object.keys(t).forEach(function(r) {
    var i = e.modifiersClassNames[r];
    if (i)
      n.push(i);
    else if (B1e(r)) {
      var o = e.classNames["day_".concat(r)];
      o && n.push(o);
    }
  }), n;
}
function V1e(e, t) {
  var n = Ue({}, e.styles.day);
  return Object.keys(t).forEach(function(r) {
    var i;
    n = Ue(Ue({}, n), (i = e.modifiersStyles) === null || i === void 0 ? void 0 : i[r]);
  }), n;
}
function q1e(e, t, n) {
  var r, i, o, a = Yt(), s = Jw(), l = D1e(e, t), u = L1e(e, l), c = F1e(), f = !!(a.onDayClick || a.mode !== "default");
  Pe(function() {
    var A;
    l.outside || s.focusedDay && f && Or(s.focusedDay, e) && ((A = n.current) === null || A === void 0 || A.focus());
  }, [
    s.focusedDay,
    e,
    n,
    f,
    l.outside
  ]);
  var h = j1e(a, l).join(" "), m = V1e(a, l), v = !!(l.outside && !a.showOutsideDays || l.hidden), g = (o = (i = a.components) === null || i === void 0 ? void 0 : i.DayContent) !== null && o !== void 0 ? o : u1e, y = d(g, { date: e, displayMonth: t, activeModifiers: l }), w = {
    style: m,
    className: h,
    children: y,
    role: "gridcell"
  }, C = s.focusTarget && Or(s.focusTarget, e) && !l.outside, S = s.focusedDay && Or(s.focusedDay, e), N = Ue(Ue(Ue({}, w), (r = { disabled: l.disabled, role: "gridcell" }, r["aria-selected"] = l.selected, r.tabIndex = S || C ? 0 : -1, r)), u), E = {
    isButton: f,
    isHidden: v,
    activeModifiers: l,
    selectedDays: c,
    buttonProps: N,
    divProps: w
  };
  return E;
}
function z1e(e) {
  var t = vt(null), n = q1e(e.date, e.displayMonth, t);
  return n.isHidden ? d("div", { role: "gridcell" }) : n.isButton ? d(tm, Ue({ name: "day", ref: t }, n.buttonProps)) : d("div", Ue({}, n.divProps));
}
function W1e(e) {
  var t = e.number, n = e.dates, r = Yt(), i = r.onWeekNumberClick, o = r.styles, a = r.classNames, s = r.locale, l = r.labels.labelWeekNumber, u = r.formatters.formatWeekNumber, c = u(Number(t), { locale: s });
  if (!i)
    return d("span", { className: a.weeknumber, style: o.weeknumber, children: c });
  var f = l(Number(t), { locale: s }), h = function(m) {
    i(t, n, m);
  };
  return d(tm, { name: "week-number", "aria-label": f, className: a.weeknumber, style: o.weeknumber, onClick: h, children: c });
}
function H1e(e) {
  var t, n, r = Yt(), i = r.styles, o = r.classNames, a = r.showWeekNumber, s = r.components, l = (t = s == null ? void 0 : s.Day) !== null && t !== void 0 ? t : z1e, u = (n = s == null ? void 0 : s.WeekNumber) !== null && n !== void 0 ? n : W1e, c;
  return a && (c = d("td", { className: o.cell, style: i.cell, children: d(u, { number: e.weekNumber, dates: e.dates }) })), k("tr", { className: o.row, style: i.row, children: [c, e.dates.map(function(f) {
    return d("td", { className: o.cell, style: i.cell, role: "presentation", children: d(l, { displayMonth: e.displayMonth, date: f }) }, zde(f));
  })] });
}
function _O(e, t, n) {
  for (var r = n != null && n.ISOWeek ? wB(t) : Sw(t, n), i = n != null && n.ISOWeek ? Hl(e) : so(e, n), o = Po(r, i), a = [], s = 0; s <= o; s++)
    a.push(gn(i, s));
  var l = a.reduce(function(u, c) {
    var f = n != null && n.ISOWeek ? SB(c) : EB(c, n), h = u.find(function(m) {
      return m.weekNumber === f;
    });
    return h ? (h.dates.push(c), u) : (u.push({
      weekNumber: f,
      dates: [c]
    }), u);
  }, []);
  return l;
}
function U1e(e, t) {
  var n = _O(Hr(e), Cw(e), t);
  if (t != null && t.useFixedWeeks) {
    var r = Hde(e, t);
    if (r < 6) {
      var i = n[n.length - 1], o = i.dates[i.dates.length - 1], a = lx(o, 6 - r), s = _O(lx(o, 1), a, t);
      n.push.apply(n, s);
    }
  }
  return n;
}
function G1e(e) {
  var t, n, r, i = Yt(), o = i.locale, a = i.classNames, s = i.styles, l = i.hideHead, u = i.fixedWeeks, c = i.components, f = i.weekStartsOn, h = i.firstWeekContainsDate, m = i.ISOWeek, v = U1e(e.displayMonth, {
    useFixedWeeks: !!u,
    ISOWeek: m,
    locale: o,
    weekStartsOn: f,
    firstWeekContainsDate: h
  }), g = (t = c == null ? void 0 : c.Head) !== null && t !== void 0 ? t : l1e, y = (n = c == null ? void 0 : c.Row) !== null && n !== void 0 ? n : H1e, w = (r = c == null ? void 0 : c.Footer) !== null && r !== void 0 ? r : o1e;
  return k("table", { id: e.id, className: a.table, style: s.table, role: "grid", "aria-labelledby": e["aria-labelledby"], children: [!l && d(g, {}), d("tbody", { className: a.tbody, style: s.tbody, children: v.map(function(C) {
    return d(y, { displayMonth: e.displayMonth, dates: C.dates, weekNumber: C.weekNumber }, C.weekNumber);
  }) }), d(w, { displayMonth: e.displayMonth })] });
}
function K1e() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var Y1e = K1e() ? $g : Pe, Db = !1, Z1e = 0;
function EO() {
  return "react-day-picker-".concat(++Z1e);
}
function X1e(e) {
  var t, n = e ?? (Db ? EO() : null), r = re(n), i = r[0], o = r[1];
  return Y1e(function() {
    i === null && o(EO());
  }, []), Pe(function() {
    Db === !1 && (Db = !0);
  }, []), (t = e ?? i) !== null && t !== void 0 ? t : void 0;
}
function J1e(e) {
  var t, n, r = Yt(), i = r.dir, o = r.classNames, a = r.styles, s = r.components, l = sp().displayMonths, u = X1e(r.id ? "".concat(r.id, "-").concat(e.displayIndex) : void 0), c = r.id ? "".concat(r.id, "-grid-").concat(e.displayIndex) : void 0, f = [o.month], h = a.month, m = e.displayIndex === 0, v = e.displayIndex === l.length - 1, g = !m && !v;
  i === "rtl" && (t = [m, v], v = t[0], m = t[1]), m && (f.push(o.caption_start), h = Ue(Ue({}, h), a.caption_start)), v && (f.push(o.caption_end), h = Ue(Ue({}, h), a.caption_end)), g && (f.push(o.caption_between), h = Ue(Ue({}, h), a.caption_between));
  var y = (n = s == null ? void 0 : s.Caption) !== null && n !== void 0 ? n : i1e;
  return k("div", { className: f.join(" "), style: h, children: [d(y, { id: u, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), d(G1e, { id: c, "aria-labelledby": u, displayMonth: e.displayMonth })] }, e.displayIndex);
}
function Q1e(e) {
  var t = Yt(), n = t.classNames, r = t.styles;
  return d("div", { className: n.months, style: r.months, children: e.children });
}
function eme(e) {
  var t, n, r = e.initialProps, i = Yt(), o = Jw(), a = sp(), s = re(!1), l = s[0], u = s[1];
  Pe(function() {
    i.initialFocus && o.focusTarget && (l || (o.focus(o.focusTarget), u(!0)));
  }, [
    i.initialFocus,
    l,
    o.focus,
    o.focusTarget,
    o
  ]);
  var c = [i.classNames.root, i.className];
  i.numberOfMonths > 1 && c.push(i.classNames.multiple_months), i.showWeekNumber && c.push(i.classNames.with_weeknumber);
  var f = Ue(Ue({}, i.styles.root), i.style), h = Object.keys(r).filter(function(v) {
    return v.startsWith("data-");
  }).reduce(function(v, g) {
    var y;
    return Ue(Ue({}, v), (y = {}, y[g] = r[g], y));
  }, {}), m = (n = (t = r.components) === null || t === void 0 ? void 0 : t.Months) !== null && n !== void 0 ? n : Q1e;
  return d("div", Ue({ className: c.join(" "), style: f, dir: i.dir, id: i.id, nonce: r.nonce, title: r.title, lang: r.lang }, h, { children: d(m, { children: a.displayMonths.map(function(v, g) {
    return d(J1e, { displayIndex: g, displayMonth: v }, g);
  }) }) }));
}
function tme(e) {
  var t = e.children, n = E0e(e, ["children"]);
  return d(W0e, { initialProps: n, children: d(e1e, { children: d(I1e, { initialProps: n, children: d(c1e, { initialProps: n, children: d(h1e, { initialProps: n, children: d(w1e, { children: d(R1e, { children: t }) }) }) }) }) }) });
}
function nme(e) {
  return d(tme, Ue({}, e, { children: d(eme, { initialProps: e }) }));
}
function eC({
  className: e,
  classNames: t,
  showOutsideDays: n = !0,
  ...r
}) {
  return /* @__PURE__ */ d(
    nme,
    {
      showOutsideDays: n,
      className: z("p-3", e),
      classNames: {
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-bodysm font-medium",
        nav: "space-x-1 flex items-center",
        nav_button: z(
          Ac({ variant: "outline" }),
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"
        ),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",
        head_row: "flex",
        head_cell: "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]",
        row: "flex w-full mt-2",
        cell: "h-9 w-9 text-center text-bodysm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
        day: z(
          Ac({ variant: "ghost" }),
          "h-9 w-9 p-0 font-normal aria-selected:opacity-100"
        ),
        day_range_end: "day-range-end",
        day_selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
        day_today: "bg-accent text-accent-foreground",
        day_outside: "day-outside text-muted-foreground aria-selected:bg-accent/50 aria-selected:text-muted-foreground",
        day_disabled: "text-muted-foreground opacity-50",
        day_range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
        day_hidden: "invisible",
        ...t
      },
      components: {
        IconLeft: ({ className: i, ...o }) => /* @__PURE__ */ d(ece, { className: z("h-4 w-4", i), ...o }),
        IconRight: ({ className: i, ...o }) => /* @__PURE__ */ d(mB, { className: z("h-4 w-4", i), ...o })
      },
      ...r
    }
  );
}
eC.displayName = "Calendar";
function AQe({ children: e, className: t }) {
  return /* @__PURE__ */ d(
    "span",
    {
      className: z(
        "rounded-xs border-interfaceBorder bg-interfaceBgDarkPaper inline-block border-l-4 py-3 pl-4 pr-3",
        t
      ),
      children: e
    }
  );
}
const Pt = te(
  ({ className: e, ...t }, n) => /* @__PURE__ */ d(
    "div",
    {
      ref: n,
      className: z(
        "bg-card text-card-foreground border-border shadow-xs rounded-lg border",
        e
      ),
      ...t
    }
  )
);
Pt.displayName = "Card";
const Tt = te(
  ({ className: e, ...t }, n) => /* @__PURE__ */ d(
    "div",
    {
      ref: n,
      className: z("flex flex-col space-y-1.5 p-6", e),
      ...t
    }
  )
);
Tt.displayName = "CardHeader";
const Lt = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "h3",
  {
    ref: n,
    className: z(
      "text-heading2xl font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
Lt.displayName = "CardTitle";
const ir = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "p",
  {
    ref: n,
    className: z("text-muted-foreground text-bodysm", e),
    ...t
  }
));
ir.displayName = "CardDescription";
const Mt = te(
  ({ className: e, ...t }, n) => /* @__PURE__ */ d("div", { ref: n, className: z("p-6 pt-0", e), ...t })
);
Mt.displayName = "CardContent";
const tC = te(
  ({ className: e, ...t }, n) => /* @__PURE__ */ d(
    "div",
    {
      ref: n,
      className: z("flex items-center p-6 pt-0", e),
      ...t
    }
  )
);
tC.displayName = "CardFooter";
function NO(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function fV(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = NO(i, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : NO(e[i], null);
        }
      };
  };
}
function hV(...e) {
  return x.useCallback(fV(...e), e);
}
function rme(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = x.createContext(a), l = n.length;
    n = [...n, a];
    const u = (f) => {
      var w;
      const { scope: h, children: m, ...v } = f, g = ((w = h == null ? void 0 : h[e]) == null ? void 0 : w[l]) || s, y = x.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ d(g.Provider, { value: y, children: m });
    };
    u.displayName = o + "Provider";
    function c(f, h) {
      var g;
      const m = ((g = h == null ? void 0 : h[e]) == null ? void 0 : g[l]) || s, v = x.useContext(m);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, c];
  }
  const i = () => {
    const o = n.map((a) => x.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return x.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, ime(i, ...t)];
}
function ime(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return x.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function AO(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function bd(e) {
  const t = x.useRef({ value: e, previous: e });
  return x.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function uu(e) {
  const [t, n] = x.useState(void 0);
  return He(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const o = i[0];
        let a, s;
        if ("borderBoxSize" in o) {
          const l = o.borderBoxSize, u = Array.isArray(l) ? l[0] : l;
          a = u.inlineSize, s = u.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({ width: a, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
function ome(e, t) {
  return x.useReducer((n, r) => t[n][r] ?? n, e);
}
var pV = (e) => {
  const { present: t, children: n } = e, r = ame(t), i = typeof n == "function" ? n({ present: r.isPresent }) : x.Children.only(n), o = hV(r.ref, sme(i));
  return typeof n == "function" || r.isPresent ? x.cloneElement(i, { ref: o }) : null;
};
pV.displayName = "Presence";
function ame(e) {
  const [t, n] = x.useState(), r = x.useRef({}), i = x.useRef(e), o = x.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = ome(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return x.useEffect(() => {
    const u = B0(r.current);
    o.current = s === "mounted" ? u : "none";
  }, [s]), He(() => {
    const u = r.current, c = i.current;
    if (c !== e) {
      const h = o.current, m = B0(u);
      e ? l("MOUNT") : m === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(c && h !== m ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, l]), He(() => {
    if (t) {
      let u;
      const c = t.ownerDocument.defaultView ?? window, f = (m) => {
        const g = B0(r.current).includes(m.animationName);
        if (m.target === t && g && (l("ANIMATION_END"), !i.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = c.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, h = (m) => {
        m.target === t && (o.current = B0(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        c.clearTimeout(u), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: x.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function B0(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function sme(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var mV = x.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = x.Children.toArray(n), o = i.find(ume);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? x.Children.count(a) > 1 ? x.Children.only(null) : x.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ d(xx, { ...r, ref: t, children: x.isValidElement(a) ? x.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ d(xx, { ...r, ref: t, children: n });
});
mV.displayName = "Slot";
var xx = x.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (x.isValidElement(n)) {
    const i = dme(n);
    return x.cloneElement(n, {
      ...cme(r, n.props),
      // @ts-ignore
      ref: t ? fV(t, i) : i
    });
  }
  return x.Children.count(n) > 1 ? x.Children.only(null) : null;
});
xx.displayName = "SlotClone";
var lme = ({ children: e }) => /* @__PURE__ */ d(xe, { children: e });
function ume(e) {
  return x.isValidElement(e) && e.type === lme;
}
function cme(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function dme(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var fme = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], gV = fme.reduce((e, t) => {
  const n = x.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? mV : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), nC = "Checkbox", [hme, OQe] = rme(nC), [pme, mme] = hme(nC), vV = x.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: i,
      defaultChecked: o,
      required: a,
      disabled: s,
      value: l = "on",
      onCheckedChange: u,
      form: c,
      ...f
    } = e, [h, m] = x.useState(null), v = hV(t, (N) => m(N)), g = x.useRef(!1), y = h ? c || !!h.closest("form") : !0, [w = !1, C] = Kt({
      prop: i,
      defaultProp: o,
      onChange: u
    }), S = x.useRef(w);
    return x.useEffect(() => {
      const N = h == null ? void 0 : h.form;
      if (N) {
        const E = () => C(S.current);
        return N.addEventListener("reset", E), () => N.removeEventListener("reset", E);
      }
    }, [h, C]), /* @__PURE__ */ k(pme, { scope: n, state: w, disabled: s, children: [
      /* @__PURE__ */ d(
        gV.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": Rs(w) ? "mixed" : w,
          "aria-required": a,
          "data-state": xV(w),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...f,
          ref: v,
          onKeyDown: AO(e.onKeyDown, (N) => {
            N.key === "Enter" && N.preventDefault();
          }),
          onClick: AO(e.onClick, (N) => {
            C((E) => Rs(E) ? !0 : !E), y && (g.current = N.isPropagationStopped(), g.current || N.stopPropagation());
          })
        }
      ),
      y && /* @__PURE__ */ d(
        gme,
        {
          control: h,
          bubbles: !g.current,
          name: r,
          value: l,
          checked: w,
          required: a,
          disabled: s,
          form: c,
          style: { transform: "translateX(-100%)" },
          defaultChecked: Rs(o) ? !1 : o
        }
      )
    ] });
  }
);
vV.displayName = nC;
var yV = "CheckboxIndicator", bV = x.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...i } = e, o = mme(yV, n);
    return /* @__PURE__ */ d(pV, { present: r || Rs(o.state) || o.state === !0, children: /* @__PURE__ */ d(
      gV.span,
      {
        "data-state": xV(o.state),
        "data-disabled": o.disabled ? "" : void 0,
        ...i,
        ref: t,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
bV.displayName = yV;
var gme = (e) => {
  const { control: t, checked: n, bubbles: r = !0, defaultChecked: i, ...o } = e, a = x.useRef(null), s = bd(n), l = uu(t);
  x.useEffect(() => {
    const c = a.current, f = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(f, "checked").set;
    if (s !== n && m) {
      const v = new Event("click", { bubbles: r });
      c.indeterminate = Rs(n), m.call(c, Rs(n) ? !1 : n), c.dispatchEvent(v);
    }
  }, [s, n, r]);
  const u = x.useRef(Rs(n) ? !1 : n);
  return /* @__PURE__ */ d(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: i ?? u.current,
      ...o,
      tabIndex: -1,
      ref: a,
      style: {
        ...e.style,
        ...l,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Rs(e) {
  return e === "indeterminate";
}
function xV(e) {
  return Rs(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var wV = vV, vme = bV;
const Ol = x.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  wV,
  {
    ref: n,
    className: z(
      "ring-offset-background focus-visible:ring-ring data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground border-interactiveBorder peer h-6 w-6 shrink-0 rounded-xs border focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...t,
    children: /* @__PURE__ */ d(
      vme,
      {
        className: z("flex items-center justify-center text-current"),
        children: /* @__PURE__ */ d(Gs, { className: "h-4 w-4" })
      }
    )
  }
));
Ol.displayName = wV.displayName;
function kQe({
  className: e,
  options: t,
  onChange: n,
  values: r
}) {
  return /* @__PURE__ */ d("ul", { className: z("flex flex-col gap-2", e), children: t.map((i, o) => {
    const a = r.some((s) => s.value === i.value);
    return /* @__PURE__ */ d("li", { children: /* @__PURE__ */ k(qt, { className: z("flex gap-2", e), children: [
      /* @__PURE__ */ d(
        Ol,
        {
          checked: a,
          onCheckedChange: (s) => n(
            s ? [...r, i] : r.filter((l) => l.value !== i.value)
          )
        }
      ),
      i.label
    ] }) }, `${i.value}-${o}`);
  }) });
}
function PQe({
  noOptionsFoundMessage: e = "no options found.",
  onChange: t,
  options: n,
  placeholder: r,
  value: i
}) {
  var s;
  const [o, a] = re(!1);
  return /* @__PURE__ */ k(g2, { open: o, onOpenChange: a, children: [
    /* @__PURE__ */ d(v2, { asChild: !0, children: /* @__PURE__ */ k(
      et,
      {
        variant: "outline",
        role: "combobox",
        "aria-expanded": o,
        className: "w-[200px] justify-between",
        children: [
          i ? (s = n.find((l) => l.value === i)) == null ? void 0 : s.label : r,
          /* @__PURE__ */ d(oce, { className: "ml-2 h-4 w-4 shrink-0 opacity-50" })
        ]
      }
    ) }),
    /* @__PURE__ */ d(mp, { className: "w-[200px] p-0", children: /* @__PURE__ */ k(
      xd,
      {
        filter: (l, u, c) => c != null && c[0].includes(u) ? 1 : 0,
        children: [
          /* @__PURE__ */ d(WV, { placeholder: r }),
          /* @__PURE__ */ k(cp, { children: [
            /* @__PURE__ */ d(cC, { children: e }),
            /* @__PURE__ */ d(dp, { children: n.map((l) => /* @__PURE__ */ k(
              fp,
              {
                keywords: [l.label],
                value: l.value || "",
                onSelect: (u) => {
                  t(u === i ? "" : u), a(!1);
                },
                children: [
                  /* @__PURE__ */ d(
                    Gs,
                    {
                      className: z(
                        "mr-2 h-4 w-4",
                        i === l.value ? "opacity-100" : "opacity-0"
                      )
                    }
                  ),
                  l.label
                ]
              },
              l.value
            )) })
          ] })
        ]
      }
    ) })
  ] });
}
function Zg(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var yme = ["color"], bme = /* @__PURE__ */ te(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, i = Zg(e, yme);
  return dt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: t
  }), dt("path", {
    d: "M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), xme = ["color"], wme = /* @__PURE__ */ te(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, i = Zg(e, xme);
  return dt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: t
  }), dt("path", {
    d: "M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), Cme = ["color"], Sme = /* @__PURE__ */ te(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, i = Zg(e, Cme);
  return dt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: t
  }), dt("path", {
    d: "M3.625 7.5C3.625 8.12132 3.12132 8.625 2.5 8.625C1.87868 8.625 1.375 8.12132 1.375 7.5C1.375 6.87868 1.87868 6.375 2.5 6.375C3.12132 6.375 3.625 6.87868 3.625 7.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM12.5 8.625C13.1213 8.625 13.625 8.12132 13.625 7.5C13.625 6.87868 13.1213 6.375 12.5 6.375C11.8787 6.375 11.375 6.87868 11.375 7.5C11.375 8.12132 11.8787 8.625 12.5 8.625Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), _me = ["color"], Eme = /* @__PURE__ */ te(function(e, t) {
  var n = e.color, r = n === void 0 ? "currentColor" : n, i = Zg(e, _me);
  return dt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: t
  }), dt("path", {
    d: "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), OO = 1, Nme = 0.9, Ame = 0.8, Ome = 0.17, Ib = 0.1, $b = 0.999, kme = 0.9999, Pme = 0.99, Tme = /[\\\/_+.#"@\[\(\{&]/, Mme = /[\\\/_+.#"@\[\(\{&]/g, Rme = /[\s-]/, CV = /[\s-]/g;
function wx(e, t, n, r, i, o, a) {
  if (o === t.length) return i === e.length ? OO : Pme;
  var s = `${i},${o}`;
  if (a[s] !== void 0) return a[s];
  for (var l = r.charAt(o), u = n.indexOf(l, i), c = 0, f, h, m, v; u >= 0; ) f = wx(e, t, n, r, u + 1, o + 1, a), f > c && (u === i ? f *= OO : Tme.test(e.charAt(u - 1)) ? (f *= Ame, m = e.slice(i, u - 1).match(Mme), m && i > 0 && (f *= Math.pow($b, m.length))) : Rme.test(e.charAt(u - 1)) ? (f *= Nme, v = e.slice(i, u - 1).match(CV), v && i > 0 && (f *= Math.pow($b, v.length))) : (f *= Ome, i > 0 && (f *= Math.pow($b, u - i))), e.charAt(u) !== t.charAt(o) && (f *= kme)), (f < Ib && n.charAt(u - 1) === r.charAt(o + 1) || r.charAt(o + 1) === r.charAt(o) && n.charAt(u - 1) !== r.charAt(o)) && (h = wx(e, t, n, r, u + 1, o + 2, a), h * Ib > f && (f = h * Ib)), f > c && (c = f), u = n.indexOf(l, u + 1);
  return a[s] = c, c;
}
function kO(e) {
  return e.toLowerCase().replace(CV, " ");
}
function Dme(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, wx(e, t, kO(e), kO(t), 0, 0, {});
}
function Tr() {
  return Tr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Tr.apply(null, arguments);
}
function dc(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented) return t == null ? void 0 : t(i);
  };
}
function Ime(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function SV(...e) {
  return (t) => e.forEach(
    (n) => Ime(n, t)
  );
}
function lp(...e) {
  return yr(SV(...e), e);
}
function $me(e, t) {
  const n = /* @__PURE__ */ Qt(t);
  function r(o) {
    const { children: a, ...s } = o, l = Je(
      () => s,
      Object.values(s)
    );
    return /* @__PURE__ */ dt(n.Provider, {
      value: l
    }, a);
  }
  function i(o) {
    const a = en(n);
    if (a) return a;
    if (t !== void 0) return t;
    throw new Error(`\`${o}\` must be used within \`${e}\``);
  }
  return r.displayName = e + "Provider", [
    r,
    i
  ];
}
function Lme(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = /* @__PURE__ */ Qt(a), l = n.length;
    n = [
      ...n,
      a
    ];
    function u(f) {
      const { scope: h, children: m, ...v } = f, g = (h == null ? void 0 : h[e][l]) || s, y = Je(
        () => v,
        Object.values(v)
      );
      return /* @__PURE__ */ dt(g.Provider, {
        value: y
      }, m);
    }
    function c(f, h) {
      const m = (h == null ? void 0 : h[e][l]) || s, v = en(m);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return u.displayName = o + "Provider", [
      u,
      c
    ];
  }
  const i = () => {
    const o = n.map((a) => /* @__PURE__ */ Qt(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return Je(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: l
          }
        }),
        [
          s,
          l
        ]
      );
    };
  };
  return i.scopeName = e, [
    r,
    Fme(i, ...t)
  ];
}
function Fme(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map(
      (i) => ({
        useScope: i(),
        scopeName: i.scopeName
      })
    );
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return {
          ...s,
          ...f
        };
      }, {});
      return Je(
        () => ({
          [`__scope${t.scopeName}`]: a
        }),
        [
          a
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
const Cx = globalThis != null && globalThis.document ? $g : () => {
}, Bme = x.useId || (() => {
});
let jme = 0;
function Lb(e) {
  const [t, n] = x.useState(Bme());
  return Cx(() => {
    n(
      (r) => r ?? String(jme++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function Kl(e) {
  const t = vt(e);
  return Pe(() => {
    t.current = e;
  }), Je(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function Vme({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, i] = qme({
    defaultProp: t,
    onChange: n
  }), o = e !== void 0, a = o ? e : r, s = Kl(n), l = yr((u) => {
    if (o) {
      const f = typeof u == "function" ? u(e) : u;
      f !== e && s(f);
    } else i(u);
  }, [
    o,
    e,
    i,
    s
  ]);
  return [
    a,
    l
  ];
}
function qme({ defaultProp: e, onChange: t }) {
  const n = re(e), [r] = n, i = vt(r), o = Kl(t);
  return Pe(() => {
    i.current !== r && (o(r), i.current = r);
  }, [
    r,
    i,
    o
  ]), n;
}
const rC = /* @__PURE__ */ te((e, t) => {
  const { children: n, ...r } = e, i = Wr.toArray(n), o = i.find(Wme);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? Wr.count(a) > 1 ? Wr.only(null) : /* @__PURE__ */ Pr(a) ? a.props.children : null : l);
    return /* @__PURE__ */ dt(Sx, Tr({}, r, {
      ref: t
    }), /* @__PURE__ */ Pr(a) ? /* @__PURE__ */ cn(a, void 0, s) : null);
  }
  return /* @__PURE__ */ dt(Sx, Tr({}, r, {
    ref: t
  }), n);
});
rC.displayName = "Slot";
const Sx = /* @__PURE__ */ te((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ Pr(n) ? /* @__PURE__ */ cn(n, {
    ...Hme(r, n.props),
    ref: t ? SV(t, n.ref) : n.ref
  }) : Wr.count(n) > 1 ? Wr.only(null) : null;
});
Sx.displayName = "SlotClone";
const zme = ({ children: e }) => /* @__PURE__ */ dt(Bs, null, e);
function Wme(e) {
  return /* @__PURE__ */ Pr(e) && e.type === zme;
}
function Hme(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = {
      ...i,
      ...o
    } : r === "className" && (n[r] = [
      i,
      o
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const Ume = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ji = Ume.reduce((e, t) => {
  const n = /* @__PURE__ */ te((r, i) => {
    const { asChild: o, ...a } = r, s = o ? rC : t;
    return Pe(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ dt(s, Tr({}, a, {
      ref: i
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function Gme(e, t) {
  e && fB(
    () => e.dispatchEvent(t)
  );
}
function Kme(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Kl(e);
  Pe(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const _x = "dismissableLayer.update", Yme = "dismissableLayer.pointerDownOutside", Zme = "dismissableLayer.focusOutside";
let PO;
const Xme = /* @__PURE__ */ Qt({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Jme = /* @__PURE__ */ te((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: i, onPointerDownOutside: o, onFocusOutside: a, onInteractOutside: s, onDismiss: l, ...u } = e, c = en(Xme), [f, h] = re(null), m = (n = f == null ? void 0 : f.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, v] = re({}), g = lp(
    t,
    (T) => h(T)
  ), y = Array.from(c.layers), [w] = [
    ...c.layersWithOutsidePointerEventsDisabled
  ].slice(-1), C = y.indexOf(w), S = f ? y.indexOf(f) : -1, N = c.layersWithOutsidePointerEventsDisabled.size > 0, E = S >= C, A = Qme((T) => {
    const M = T.target, L = [
      ...c.branches
    ].some(
      (I) => I.contains(M)
    );
    !E || L || (o == null || o(T), s == null || s(T), T.defaultPrevented || l == null || l());
  }, m), O = ege((T) => {
    const M = T.target;
    [
      ...c.branches
    ].some(
      (I) => I.contains(M)
    ) || (a == null || a(T), s == null || s(T), T.defaultPrevented || l == null || l());
  }, m);
  return Kme((T) => {
    S === c.layers.size - 1 && (i == null || i(T), !T.defaultPrevented && l && (T.preventDefault(), l()));
  }, m), Pe(() => {
    if (f)
      return r && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (PO = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(f)), c.layers.add(f), TO(), () => {
        r && c.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = PO);
      };
  }, [
    f,
    m,
    r,
    c
  ]), Pe(() => () => {
    f && (c.layers.delete(f), c.layersWithOutsidePointerEventsDisabled.delete(f), TO());
  }, [
    f,
    c
  ]), Pe(() => {
    const T = () => v({});
    return document.addEventListener(_x, T), () => document.removeEventListener(_x, T);
  }, []), /* @__PURE__ */ dt(ji.div, Tr({}, u, {
    ref: g,
    style: {
      pointerEvents: N ? E ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: dc(e.onFocusCapture, O.onFocusCapture),
    onBlurCapture: dc(e.onBlurCapture, O.onBlurCapture),
    onPointerDownCapture: dc(e.onPointerDownCapture, A.onPointerDownCapture)
  }));
});
function Qme(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Kl(e), r = vt(!1), i = vt(() => {
  });
  return Pe(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let u = function() {
          _V(Yme, n, l, {
            discrete: !0
          });
        };
        const l = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = u, t.addEventListener("click", i.current, {
          once: !0
        })) : u();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function ege(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Kl(e), r = vt(!1);
  return Pe(() => {
    const i = (o) => {
      o.target && !r.current && _V(Zme, n, {
        originalEvent: o
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function TO() {
  const e = new CustomEvent(_x);
  document.dispatchEvent(e);
}
function _V(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && i.addEventListener(e, t, {
    once: !0
  }), r ? Gme(i, o) : i.dispatchEvent(o);
}
const Fb = "focusScope.autoFocusOnMount", Bb = "focusScope.autoFocusOnUnmount", MO = {
  bubbles: !1,
  cancelable: !0
}, tge = /* @__PURE__ */ te((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: i, onUnmountAutoFocus: o, ...a } = e, [s, l] = re(null), u = Kl(i), c = Kl(o), f = vt(null), h = lp(
    t,
    (g) => l(g)
  ), m = vt({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Pe(() => {
    if (r) {
      let g = function(S) {
        if (m.paused || !s) return;
        const N = S.target;
        s.contains(N) ? f.current = N : hs(f.current, {
          select: !0
        });
      }, y = function(S) {
        if (m.paused || !s) return;
        const N = S.relatedTarget;
        N !== null && (s.contains(N) || hs(f.current, {
          select: !0
        }));
      }, w = function(S) {
        if (document.activeElement === document.body)
          for (const E of S) E.removedNodes.length > 0 && hs(s);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", y);
      const C = new MutationObserver(w);
      return s && C.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", y), C.disconnect();
      };
    }
  }, [
    r,
    s,
    m.paused
  ]), Pe(() => {
    if (s) {
      DO.add(m);
      const g = document.activeElement;
      if (!s.contains(g)) {
        const w = new CustomEvent(Fb, MO);
        s.addEventListener(Fb, u), s.dispatchEvent(w), w.defaultPrevented || (nge(sge(EV(s)), {
          select: !0
        }), document.activeElement === g && hs(s));
      }
      return () => {
        s.removeEventListener(Fb, u), setTimeout(() => {
          const w = new CustomEvent(Bb, MO);
          s.addEventListener(Bb, c), s.dispatchEvent(w), w.defaultPrevented || hs(g ?? document.body, {
            select: !0
          }), s.removeEventListener(Bb, c), DO.remove(m);
        }, 0);
      };
    }
  }, [
    s,
    u,
    c,
    m
  ]);
  const v = yr((g) => {
    if (!n && !r || m.paused) return;
    const y = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, w = document.activeElement;
    if (y && w) {
      const C = g.currentTarget, [S, N] = rge(C);
      S && N ? !g.shiftKey && w === N ? (g.preventDefault(), n && hs(S, {
        select: !0
      })) : g.shiftKey && w === S && (g.preventDefault(), n && hs(N, {
        select: !0
      })) : w === C && g.preventDefault();
    }
  }, [
    n,
    r,
    m.paused
  ]);
  return /* @__PURE__ */ dt(ji.div, Tr({
    tabIndex: -1
  }, a, {
    ref: h,
    onKeyDown: v
  }));
});
function nge(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (hs(r, {
      select: t
    }), document.activeElement !== n) return;
}
function rge(e) {
  const t = EV(e), n = RO(t, e), r = RO(t.reverse(), e);
  return [
    n,
    r
  ];
}
function EV(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function RO(e, t) {
  for (const n of e)
    if (!ige(n, {
      upTo: t
    })) return n;
}
function ige(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function oge(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function hs(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && oge(e) && t && e.select();
  }
}
const DO = age();
function age() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = IO(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = IO(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function IO(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function sge(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const lge = /* @__PURE__ */ te((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...i } = e;
  return r ? /* @__PURE__ */ Zo.createPortal(/* @__PURE__ */ dt(ji.div, Tr({}, i, {
    ref: t
  })), r) : null;
});
function uge(e, t) {
  return Sue((n, r) => {
    const i = t[n][r];
    return i ?? n;
  }, e);
}
const Xg = (e) => {
  const { present: t, children: n } = e, r = cge(t), i = typeof n == "function" ? n({
    present: r.isPresent
  }) : Wr.only(n), o = lp(r.ref, i.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ cn(i, {
    ref: o
  }) : null;
};
Xg.displayName = "Presence";
function cge(e) {
  const [t, n] = re(), r = vt({}), i = vt(e), o = vt("none"), a = e ? "mounted" : "unmounted", [s, l] = uge(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Pe(() => {
    const u = j0(r.current);
    o.current = s === "mounted" ? u : "none";
  }, [
    s
  ]), Cx(() => {
    const u = r.current, c = i.current;
    if (c !== e) {
      const h = o.current, m = j0(u);
      e ? l("MOUNT") : m === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(c && h !== m ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [
    e,
    l
  ]), Cx(() => {
    if (t) {
      const u = (f) => {
        const m = j0(r.current).includes(f.animationName);
        f.target === t && m && fB(
          () => l("ANIMATION_END")
        );
      }, c = (f) => {
        f.target === t && (o.current = j0(r.current));
      };
      return t.addEventListener("animationstart", c), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", c), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      l("ANIMATION_END");
  }, [
    t,
    l
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: yr((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function j0(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
let jb = 0;
function dge() {
  Pe(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : $O()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : $O()), jb++, () => {
      jb === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), jb--;
    };
  }, []);
}
function $O() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var fc = "right-scroll-bar-position", hc = "width-before-scroll-bar", fge = "with-scroll-bars-hidden", hge = "--removed-body-scroll-bar-size";
function Vb(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function pge(e, t) {
  var n = re(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var mge = typeof window < "u" ? x.useLayoutEffect : x.useEffect, LO = /* @__PURE__ */ new WeakMap();
function iC(e, t) {
  var n = pge(null, function(r) {
    return e.forEach(function(i) {
      return Vb(i, r);
    });
  });
  return mge(function() {
    var r = LO.get(n);
    if (r) {
      var i = new Set(r), o = new Set(e), a = n.current;
      i.forEach(function(s) {
        o.has(s) || Vb(s, null);
      }), o.forEach(function(s) {
        i.has(s) || Vb(s, a);
      });
    }
    LO.set(n, e);
  }, [e]), n;
}
function gge(e) {
  return e;
}
function vge(e, t) {
  t === void 0 && (t = gge);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(o) {
      var a = t(o, r);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(o);
      }
      n = {
        push: function(s) {
          return o(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(o), a = n;
      }
      var l = function() {
        var c = a;
        a = [], c.forEach(o);
      }, u = function() {
        return Promise.resolve().then(l);
      };
      u(), n = {
        push: function(c) {
          a.push(c), u();
        },
        filter: function(c) {
          return a = a.filter(c), n;
        }
      };
    }
  };
  return i;
}
function oC(e) {
  e === void 0 && (e = {});
  var t = vge(null);
  return t.options = Ke({ async: !0, ssr: !1 }, e), t;
}
var NV = function(e) {
  var t = e.sideCar, n = Qo(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return x.createElement(r, Ke({}, n));
};
NV.isSideCarExport = !0;
function aC(e, t) {
  return e.useMedium(t), NV;
}
var AV = oC(), qb = function() {
}, Jg = x.forwardRef(function(e, t) {
  var n = x.useRef(null), r = x.useState({
    onScrollCapture: qb,
    onWheelCapture: qb,
    onTouchMoveCapture: qb
  }), i = r[0], o = r[1], a = e.forwardProps, s = e.children, l = e.className, u = e.removeScrollBar, c = e.enabled, f = e.shards, h = e.sideCar, m = e.noIsolation, v = e.inert, g = e.allowPinchZoom, y = e.as, w = y === void 0 ? "div" : y, C = Qo(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), S = h, N = iC([n, t]), E = Ke(Ke({}, C), i);
  return x.createElement(
    x.Fragment,
    null,
    c && x.createElement(S, { sideCar: AV, removeScrollBar: u, shards: f, noIsolation: m, inert: v, setCallbacks: o, allowPinchZoom: !!g, lockRef: n }),
    a ? x.cloneElement(x.Children.only(s), Ke(Ke({}, E), { ref: N })) : x.createElement(w, Ke({}, E, { className: l, ref: N }), s)
  );
});
Jg.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Jg.classNames = {
  fullWidth: hc,
  zeroRight: fc
};
function yge() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Kg();
  return t && e.setAttribute("nonce", t), e;
}
function bge(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function xge(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var wge = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = yge()) && (bge(t, n), xge(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Cge = function() {
  var e = wge();
  return function(t, n) {
    x.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Qg = function() {
  var e = Cge(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, Sge = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, zb = function(e) {
  return parseInt(e || "", 10) || 0;
}, _ge = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [zb(n), zb(r), zb(i)];
}, Ege = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Sge;
  var t = _ge(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Nge = Qg(), pc = "data-scroll-locked", Age = function(e, t, n, r) {
  var i = e.left, o = e.top, a = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(fge, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(pc, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(fc, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(hc, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(fc, " .").concat(fc, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(hc, " .").concat(hc, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(pc, `] {
    `).concat(hge, ": ").concat(s, `px;
  }
`);
}, FO = function() {
  var e = parseInt(document.body.getAttribute(pc) || "0", 10);
  return isFinite(e) ? e : 0;
}, Oge = function() {
  x.useEffect(function() {
    return document.body.setAttribute(pc, (FO() + 1).toString()), function() {
      var e = FO() - 1;
      e <= 0 ? document.body.removeAttribute(pc) : document.body.setAttribute(pc, e.toString());
    };
  }, []);
}, sC = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
  Oge();
  var o = x.useMemo(function() {
    return Ege(i);
  }, [i]);
  return x.createElement(Nge, { styles: Age(o, !t, i, n ? "" : "!important") });
}, Ex = !1;
if (typeof window < "u")
  try {
    var V0 = Object.defineProperty({}, "passive", {
      get: function() {
        return Ex = !0, !0;
      }
    });
    window.addEventListener("test", V0, V0), window.removeEventListener("test", V0, V0);
  } catch {
    Ex = !1;
  }
var Fu = Ex ? { passive: !1 } : !1, kge = function(e) {
  return e.tagName === "TEXTAREA";
}, OV = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !kge(e) && n[t] === "visible")
  );
}, Pge = function(e) {
  return OV(e, "overflowY");
}, Tge = function(e) {
  return OV(e, "overflowX");
}, BO = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = kV(e, n);
    if (r) {
      var i = PV(e, n), o = i[1], a = i[2];
      if (o > a)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, Mge = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Rge = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, kV = function(e, t) {
  return e === "v" ? Pge(t) : Tge(t);
}, PV = function(e, t) {
  return e === "v" ? Mge(t) : Rge(t);
}, Dge = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Ige = function(e, t, n, r, i) {
  var o = Dge(e, window.getComputedStyle(t).direction), a = o * r, s = n.target, l = t.contains(s), u = !1, c = a > 0, f = 0, h = 0;
  do {
    var m = PV(e, s), v = m[0], g = m[1], y = m[2], w = g - y - o * v;
    (v || w) && kV(e, s) && (f += w, h += v), s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (c && f === 0 || !c && h === 0) && (u = !0), u;
}, q0 = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, jO = function(e) {
  return [e.deltaX, e.deltaY];
}, VO = function(e) {
  return e && "current" in e ? e.current : e;
}, $ge = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Lge = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Fge = 0, Bu = [];
function Bge(e) {
  var t = x.useRef([]), n = x.useRef([0, 0]), r = x.useRef(), i = x.useState(Fge++)[0], o = x.useState(function() {
    return Qg();
  })[0], a = x.useRef(e);
  x.useEffect(function() {
    a.current = e;
  }, [e]), x.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var g = vd([e.lockRef.current], (e.shards || []).map(VO), !0).filter(Boolean);
      return g.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), g.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = x.useCallback(function(g, y) {
    if ("touches" in g && g.touches.length === 2)
      return !a.current.allowPinchZoom;
    var w = q0(g), C = n.current, S = "deltaX" in g ? g.deltaX : C[0] - w[0], N = "deltaY" in g ? g.deltaY : C[1] - w[1], E, A = g.target, O = Math.abs(S) > Math.abs(N) ? "h" : "v";
    if ("touches" in g && O === "h" && A.type === "range")
      return !1;
    var T = BO(O, A);
    if (!T)
      return !0;
    if (T ? E = O : (E = O === "v" ? "h" : "v", T = BO(O, A)), !T)
      return !1;
    if (!r.current && "changedTouches" in g && (S || N) && (r.current = E), !E)
      return !0;
    var M = r.current || E;
    return Ige(M, y, g, M === "h" ? S : N);
  }, []), l = x.useCallback(function(g) {
    var y = g;
    if (!(!Bu.length || Bu[Bu.length - 1] !== o)) {
      var w = "deltaY" in y ? jO(y) : q0(y), C = t.current.filter(function(E) {
        return E.name === y.type && E.target === y.target && $ge(E.delta, w);
      })[0];
      if (C && C.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!C) {
        var S = (a.current.shards || []).map(VO).filter(Boolean).filter(function(E) {
          return E.contains(y.target);
        }), N = S.length > 0 ? s(y, S[0]) : !a.current.noIsolation;
        N && y.cancelable && y.preventDefault();
      }
    }
  }, []), u = x.useCallback(function(g, y, w, C) {
    var S = { name: g, delta: y, target: w, should: C };
    t.current.push(S), setTimeout(function() {
      t.current = t.current.filter(function(N) {
        return N !== S;
      });
    }, 1);
  }, []), c = x.useCallback(function(g) {
    n.current = q0(g), r.current = void 0;
  }, []), f = x.useCallback(function(g) {
    u(g.type, jO(g), g.target, s(g, e.lockRef.current));
  }, []), h = x.useCallback(function(g) {
    u(g.type, q0(g), g.target, s(g, e.lockRef.current));
  }, []);
  x.useEffect(function() {
    return Bu.push(o), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, Fu), document.addEventListener("touchmove", l, Fu), document.addEventListener("touchstart", c, Fu), function() {
      Bu = Bu.filter(function(g) {
        return g !== o;
      }), document.removeEventListener("wheel", l, Fu), document.removeEventListener("touchmove", l, Fu), document.removeEventListener("touchstart", c, Fu);
    };
  }, []);
  var m = e.removeScrollBar, v = e.inert;
  return x.createElement(
    x.Fragment,
    null,
    v ? x.createElement(o, { styles: Lge(i) }) : null,
    m ? x.createElement(sC, { gapMode: "margin" }) : null
  );
}
const jge = aC(AV, Bge);
var TV = x.forwardRef(function(e, t) {
  return x.createElement(Jg, Ke({}, e, { ref: t, sideCar: jge }));
});
TV.classNames = Jg.classNames;
const MV = "Dialog", [RV, TQe] = Lme(MV), [Vge, cu] = RV(MV), qge = (e) => {
  const { __scopeDialog: t, children: n, open: r, defaultOpen: i, onOpenChange: o, modal: a = !0 } = e, s = vt(null), l = vt(null), [u = !1, c] = Vme({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ dt(Vge, {
    scope: t,
    triggerRef: s,
    contentRef: l,
    contentId: Lb(),
    titleId: Lb(),
    descriptionId: Lb(),
    open: u,
    onOpenChange: c,
    onOpenToggle: yr(
      () => c(
        (f) => !f
      ),
      [
        c
      ]
    ),
    modal: a
  }, n);
}, DV = "DialogPortal", [zge, IV] = RV(DV, {
  forceMount: void 0
}), Wge = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: i } = e, o = cu(DV, t);
  return /* @__PURE__ */ dt(zge, {
    scope: t,
    forceMount: n
  }, Wr.map(
    r,
    (a) => /* @__PURE__ */ dt(Xg, {
      present: n || o.open
    }, /* @__PURE__ */ dt(lge, {
      asChild: !0,
      container: i
    }, a))
  ));
}, Nx = "DialogOverlay", Hge = /* @__PURE__ */ te((e, t) => {
  const n = IV(Nx, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = cu(Nx, e.__scopeDialog);
  return o.modal ? /* @__PURE__ */ dt(Xg, {
    present: r || o.open
  }, /* @__PURE__ */ dt(Uge, Tr({}, i, {
    ref: t
  }))) : null;
}), Uge = /* @__PURE__ */ te((e, t) => {
  const { __scopeDialog: n, ...r } = e, i = cu(Nx, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ dt(TV, {
      as: rC,
      allowPinchZoom: !0,
      shards: [
        i.contentRef
      ]
    }, /* @__PURE__ */ dt(ji.div, Tr({
      "data-state": LV(i.open)
    }, r, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), Oc = "DialogContent", Gge = /* @__PURE__ */ te((e, t) => {
  const n = IV(Oc, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = cu(Oc, e.__scopeDialog);
  return /* @__PURE__ */ dt(Xg, {
    present: r || o.open
  }, o.modal ? /* @__PURE__ */ dt(Kge, Tr({}, i, {
    ref: t
  })) : /* @__PURE__ */ dt(Yge, Tr({}, i, {
    ref: t
  })));
}), Kge = /* @__PURE__ */ te((e, t) => {
  const n = cu(Oc, e.__scopeDialog), r = vt(null), i = lp(t, n.contentRef, r);
  return Pe(() => {
    const o = r.current;
    if (o) return yd(o);
  }, []), /* @__PURE__ */ dt($V, Tr({}, e, {
    ref: i,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: dc(e.onCloseAutoFocus, (o) => {
      var a;
      o.preventDefault(), (a = n.triggerRef.current) === null || a === void 0 || a.focus();
    }),
    onPointerDownOutside: dc(e.onPointerDownOutside, (o) => {
      const a = o.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
      (a.button === 2 || s) && o.preventDefault();
    }),
    onFocusOutside: dc(
      e.onFocusOutside,
      (o) => o.preventDefault()
    )
  }));
}), Yge = /* @__PURE__ */ te((e, t) => {
  const n = cu(Oc, e.__scopeDialog), r = vt(!1), i = vt(!1);
  return /* @__PURE__ */ dt($V, Tr({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (o) => {
      var a;
      if ((a = e.onCloseAutoFocus) === null || a === void 0 || a.call(e, o), !o.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), o.preventDefault();
      }
      r.current = !1, i.current = !1;
    },
    onInteractOutside: (o) => {
      var a, s;
      (a = e.onInteractOutside) === null || a === void 0 || a.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
      const l = o.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(l)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
    }
  }));
}), $V = /* @__PURE__ */ te((e, t) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, ...a } = e, s = cu(Oc, n), l = vt(null), u = lp(t, l);
  return dge(), /* @__PURE__ */ dt(Bs, null, /* @__PURE__ */ dt(tge, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o
  }, /* @__PURE__ */ dt(Jme, Tr({
    role: "dialog",
    id: s.contentId,
    "aria-describedby": s.descriptionId,
    "aria-labelledby": s.titleId,
    "data-state": LV(s.open)
  }, a, {
    ref: u,
    onDismiss: () => s.onOpenChange(!1)
  }))), !1);
}), Zge = "DialogTitle";
function LV(e) {
  return e ? "open" : "closed";
}
const Xge = "DialogTitleWarning";
$me(Xge, {
  contentName: Oc,
  titleName: Zge,
  docsSlug: "dialog"
});
const Jge = qge, Qge = Wge, e2e = Hge, t2e = Gge;
var cf = '[cmdk-group=""]', Wb = '[cmdk-group-items=""]', n2e = '[cmdk-group-heading=""]', lC = '[cmdk-item=""]', qO = `${lC}:not([aria-disabled="true"])`, Ax = "cmdk-item-select", Cl = "data-value", r2e = (e, t, n) => Dme(e, t, n), FV = x.createContext(void 0), up = () => x.useContext(FV), BV = x.createContext(void 0), uC = () => x.useContext(BV), jV = x.createContext(void 0), VV = x.forwardRef((e, t) => {
  let n = ec(() => {
    var Y, le;
    return { search: "", value: (le = (Y = e.value) != null ? Y : e.defaultValue) != null ? le : "", filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = ec(() => /* @__PURE__ */ new Set()), i = ec(() => /* @__PURE__ */ new Map()), o = ec(() => /* @__PURE__ */ new Map()), a = ec(() => /* @__PURE__ */ new Set()), s = qV(e), { label: l, children: u, value: c, onValueChange: f, filter: h, shouldFilter: m, loop: v, disablePointerSelection: g = !1, vimBindings: y = !0, ...w } = e, C = x.useId(), S = x.useId(), N = x.useId(), E = x.useRef(null), A = p2e();
  Yl(() => {
    if (c !== void 0) {
      let Y = c.trim();
      n.current.value = Y, O.emit();
    }
  }, [c]), Yl(() => {
    A(6, B);
  }, []);
  let O = x.useMemo(() => ({ subscribe: (Y) => (a.current.add(Y), () => a.current.delete(Y)), snapshot: () => n.current, setState: (Y, le, be) => {
    var pe, Ee, ge;
    if (!Object.is(n.current[Y], le)) {
      if (n.current[Y] = le, Y === "search") j(), L(), A(1, I);
      else if (Y === "value" && (be || A(5, B), ((pe = s.current) == null ? void 0 : pe.value) !== void 0)) {
        let Ce = le ?? "";
        (ge = (Ee = s.current).onValueChange) == null || ge.call(Ee, Ce);
        return;
      }
      O.emit();
    }
  }, emit: () => {
    a.current.forEach((Y) => Y());
  } }), []), T = x.useMemo(() => ({ value: (Y, le, be) => {
    var pe;
    le !== ((pe = o.current.get(Y)) == null ? void 0 : pe.value) && (o.current.set(Y, { value: le, keywords: be }), n.current.filtered.items.set(Y, M(le, be)), A(2, () => {
      L(), O.emit();
    }));
  }, item: (Y, le) => (r.current.add(Y), le && (i.current.has(le) ? i.current.get(le).add(Y) : i.current.set(le, /* @__PURE__ */ new Set([Y]))), A(3, () => {
    j(), L(), n.current.value || I(), O.emit();
  }), () => {
    o.current.delete(Y), r.current.delete(Y), n.current.filtered.items.delete(Y);
    let be = q();
    A(4, () => {
      j(), (be == null ? void 0 : be.getAttribute("id")) === Y && I(), O.emit();
    });
  }), group: (Y) => (i.current.has(Y) || i.current.set(Y, /* @__PURE__ */ new Set()), () => {
    o.current.delete(Y), i.current.delete(Y);
  }), filter: () => s.current.shouldFilter, label: l || e["aria-label"], disablePointerSelection: g, listId: C, inputId: N, labelId: S, listInnerRef: E }), []);
  function M(Y, le) {
    var be, pe;
    let Ee = (pe = (be = s.current) == null ? void 0 : be.filter) != null ? pe : r2e;
    return Y ? Ee(Y, n.current.search, le) : 0;
  }
  function L() {
    if (!n.current.search || s.current.shouldFilter === !1) return;
    let Y = n.current.filtered.items, le = [];
    n.current.filtered.groups.forEach((pe) => {
      let Ee = i.current.get(pe), ge = 0;
      Ee.forEach((Ce) => {
        let ie = Y.get(Ce);
        ge = Math.max(ie, ge);
      }), le.push([pe, ge]);
    });
    let be = E.current;
    G().sort((pe, Ee) => {
      var ge, Ce;
      let ie = pe.getAttribute("id"), ye = Ee.getAttribute("id");
      return ((ge = Y.get(ye)) != null ? ge : 0) - ((Ce = Y.get(ie)) != null ? Ce : 0);
    }).forEach((pe) => {
      let Ee = pe.closest(Wb);
      Ee ? Ee.appendChild(pe.parentElement === Ee ? pe : pe.closest(`${Wb} > *`)) : be.appendChild(pe.parentElement === be ? pe : pe.closest(`${Wb} > *`));
    }), le.sort((pe, Ee) => Ee[1] - pe[1]).forEach((pe) => {
      let Ee = E.current.querySelector(`${cf}[${Cl}="${encodeURIComponent(pe[0])}"]`);
      Ee == null || Ee.parentElement.appendChild(Ee);
    });
  }
  function I() {
    let Y = G().find((be) => be.getAttribute("aria-disabled") !== "true"), le = Y == null ? void 0 : Y.getAttribute(Cl);
    O.setState("value", le || void 0);
  }
  function j() {
    var Y, le, be, pe;
    if (!n.current.search || s.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let Ee = 0;
    for (let ge of r.current) {
      let Ce = (le = (Y = o.current.get(ge)) == null ? void 0 : Y.value) != null ? le : "", ie = (pe = (be = o.current.get(ge)) == null ? void 0 : be.keywords) != null ? pe : [], ye = M(Ce, ie);
      n.current.filtered.items.set(ge, ye), ye > 0 && Ee++;
    }
    for (let [ge, Ce] of i.current) for (let ie of Ce) if (n.current.filtered.items.get(ie) > 0) {
      n.current.filtered.groups.add(ge);
      break;
    }
    n.current.filtered.count = Ee;
  }
  function B() {
    var Y, le, be;
    let pe = q();
    pe && (((Y = pe.parentElement) == null ? void 0 : Y.firstChild) === pe && ((be = (le = pe.closest(cf)) == null ? void 0 : le.querySelector(n2e)) == null || be.scrollIntoView({ block: "nearest" })), pe.scrollIntoView({ block: "nearest" }));
  }
  function q() {
    var Y;
    return (Y = E.current) == null ? void 0 : Y.querySelector(`${lC}[aria-selected="true"]`);
  }
  function G() {
    var Y;
    return Array.from((Y = E.current) == null ? void 0 : Y.querySelectorAll(qO));
  }
  function U(Y) {
    let le = G()[Y];
    le && O.setState("value", le.getAttribute(Cl));
  }
  function V(Y) {
    var le;
    let be = q(), pe = G(), Ee = pe.findIndex((Ce) => Ce === be), ge = pe[Ee + Y];
    (le = s.current) != null && le.loop && (ge = Ee + Y < 0 ? pe[pe.length - 1] : Ee + Y === pe.length ? pe[0] : pe[Ee + Y]), ge && O.setState("value", ge.getAttribute(Cl));
  }
  function H(Y) {
    let le = q(), be = le == null ? void 0 : le.closest(cf), pe;
    for (; be && !pe; ) be = Y > 0 ? f2e(be, cf) : h2e(be, cf), pe = be == null ? void 0 : be.querySelector(qO);
    pe ? O.setState("value", pe.getAttribute(Cl)) : V(Y);
  }
  let Z = () => U(G().length - 1), de = (Y) => {
    Y.preventDefault(), Y.metaKey ? Z() : Y.altKey ? H(1) : V(1);
  }, ne = (Y) => {
    Y.preventDefault(), Y.metaKey ? U(0) : Y.altKey ? H(-1) : V(-1);
  };
  return x.createElement(ji.div, { ref: t, tabIndex: -1, ...w, "cmdk-root": "", onKeyDown: (Y) => {
    var le;
    if ((le = w.onKeyDown) == null || le.call(w, Y), !Y.defaultPrevented) switch (Y.key) {
      case "n":
      case "j": {
        y && Y.ctrlKey && de(Y);
        break;
      }
      case "ArrowDown": {
        de(Y);
        break;
      }
      case "p":
      case "k": {
        y && Y.ctrlKey && ne(Y);
        break;
      }
      case "ArrowUp": {
        ne(Y);
        break;
      }
      case "Home": {
        Y.preventDefault(), U(0);
        break;
      }
      case "End": {
        Y.preventDefault(), Z();
        break;
      }
      case "Enter":
        if (!Y.nativeEvent.isComposing && Y.keyCode !== 229) {
          Y.preventDefault();
          let be = q();
          if (be) {
            let pe = new Event(Ax);
            be.dispatchEvent(pe);
          }
        }
    }
  } }, x.createElement("label", { "cmdk-label": "", htmlFor: T.inputId, id: T.labelId, style: g2e }, l), e2(e, (Y) => x.createElement(BV.Provider, { value: O }, x.createElement(FV.Provider, { value: T }, Y))));
}), i2e = x.forwardRef((e, t) => {
  var n, r;
  let i = x.useId(), o = x.useRef(null), a = x.useContext(jV), s = up(), l = qV(e), u = (r = (n = l.current) == null ? void 0 : n.forceMount) != null ? r : a == null ? void 0 : a.forceMount;
  Yl(() => {
    if (!u) return s.item(i, a == null ? void 0 : a.id);
  }, [u]);
  let c = zV(i, o, [e.value, e.children, o], e.keywords), f = uC(), h = Zl((A) => A.value && A.value === c.current), m = Zl((A) => u || s.filter() === !1 ? !0 : A.search ? A.filtered.items.get(i) > 0 : !0);
  x.useEffect(() => {
    let A = o.current;
    if (!(!A || e.disabled)) return A.addEventListener(Ax, v), () => A.removeEventListener(Ax, v);
  }, [m, e.onSelect, e.disabled]);
  function v() {
    var A, O;
    g(), (O = (A = l.current).onSelect) == null || O.call(A, c.current);
  }
  function g() {
    f.setState("value", c.current, !0);
  }
  if (!m) return null;
  let { disabled: y, value: w, onSelect: C, forceMount: S, keywords: N, ...E } = e;
  return x.createElement(ji.div, { ref: Xf([o, t]), ...E, id: i, "cmdk-item": "", role: "option", "aria-disabled": !!y, "aria-selected": !!h, "data-disabled": !!y, "data-selected": !!h, onPointerMove: y || s.disablePointerSelection ? void 0 : g, onClick: y ? void 0 : v }, e.children);
}), o2e = x.forwardRef((e, t) => {
  let { heading: n, children: r, forceMount: i, ...o } = e, a = x.useId(), s = x.useRef(null), l = x.useRef(null), u = x.useId(), c = up(), f = Zl((m) => i || c.filter() === !1 ? !0 : m.search ? m.filtered.groups.has(a) : !0);
  Yl(() => c.group(a), []), zV(a, s, [e.value, e.heading, l]);
  let h = x.useMemo(() => ({ id: a, forceMount: i }), [i]);
  return x.createElement(ji.div, { ref: Xf([s, t]), ...o, "cmdk-group": "", role: "presentation", hidden: f ? void 0 : !0 }, n && x.createElement("div", { ref: l, "cmdk-group-heading": "", "aria-hidden": !0, id: u }, n), e2(e, (m) => x.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? u : void 0 }, x.createElement(jV.Provider, { value: h }, m))));
}), a2e = x.forwardRef((e, t) => {
  let { alwaysRender: n, ...r } = e, i = x.useRef(null), o = Zl((a) => !a.search);
  return !n && !o ? null : x.createElement(ji.div, { ref: Xf([i, t]), ...r, "cmdk-separator": "", role: "separator" });
}), s2e = x.forwardRef((e, t) => {
  let { onValueChange: n, ...r } = e, i = e.value != null, o = uC(), a = Zl((c) => c.search), s = Zl((c) => c.value), l = up(), u = x.useMemo(() => {
    var c;
    let f = (c = l.listInnerRef.current) == null ? void 0 : c.querySelector(`${lC}[${Cl}="${encodeURIComponent(s)}"]`);
    return f == null ? void 0 : f.getAttribute("id");
  }, []);
  return x.useEffect(() => {
    e.value != null && o.setState("search", e.value);
  }, [e.value]), x.createElement(ji.input, { ref: t, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": l.listId, "aria-labelledby": l.labelId, "aria-activedescendant": u, id: l.inputId, type: "text", value: i ? e.value : a, onChange: (c) => {
    i || o.setState("search", c.target.value), n == null || n(c.target.value);
  } });
}), l2e = x.forwardRef((e, t) => {
  let { children: n, label: r = "Suggestions", ...i } = e, o = x.useRef(null), a = x.useRef(null), s = up();
  return x.useEffect(() => {
    if (a.current && o.current) {
      let l = a.current, u = o.current, c, f = new ResizeObserver(() => {
        c = requestAnimationFrame(() => {
          let h = l.offsetHeight;
          u.style.setProperty("--cmdk-list-height", h.toFixed(1) + "px");
        });
      });
      return f.observe(l), () => {
        cancelAnimationFrame(c), f.unobserve(l);
      };
    }
  }, []), x.createElement(ji.div, { ref: Xf([o, t]), ...i, "cmdk-list": "", role: "listbox", "aria-label": r, id: s.listId }, e2(e, (l) => x.createElement("div", { ref: Xf([a, s.listInnerRef]), "cmdk-list-sizer": "" }, l)));
}), u2e = x.forwardRef((e, t) => {
  let { open: n, onOpenChange: r, overlayClassName: i, contentClassName: o, container: a, ...s } = e;
  return x.createElement(Jge, { open: n, onOpenChange: r }, x.createElement(Qge, { container: a }, x.createElement(e2e, { "cmdk-overlay": "", className: i }), x.createElement(t2e, { "aria-label": e.label, "cmdk-dialog": "", className: o }, x.createElement(VV, { ref: t, ...s }))));
}), c2e = x.forwardRef((e, t) => Zl((n) => n.filtered.count === 0) ? x.createElement(ji.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), d2e = x.forwardRef((e, t) => {
  let { progress: n, children: r, label: i = "Loading...", ...o } = e;
  return x.createElement(ji.div, { ref: t, ...o, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": i }, e2(e, (a) => x.createElement("div", { "aria-hidden": !0 }, a)));
}), sr = Object.assign(VV, { List: l2e, Item: i2e, Input: s2e, Group: o2e, Separator: a2e, Dialog: u2e, Empty: c2e, Loading: d2e });
function f2e(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.nextElementSibling;
  }
}
function h2e(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.previousElementSibling;
  }
}
function qV(e) {
  let t = x.useRef(e);
  return Yl(() => {
    t.current = e;
  }), t;
}
var Yl = typeof window > "u" ? x.useEffect : x.useLayoutEffect;
function ec(e) {
  let t = x.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function Xf(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
function Zl(e) {
  let t = uC(), n = () => e(t.snapshot());
  return x.useSyncExternalStore(t.subscribe, n, n);
}
function zV(e, t, n, r = []) {
  let i = x.useRef(), o = up();
  return Yl(() => {
    var a;
    let s = (() => {
      var u;
      for (let c of n) {
        if (typeof c == "string") return c.trim();
        if (typeof c == "object" && "current" in c) return c.current ? (u = c.current.textContent) == null ? void 0 : u.trim() : i.current;
      }
    })(), l = r.map((u) => u.trim());
    o.value(e, s, l), (a = t.current) == null || a.setAttribute(Cl, s), i.current = s;
  }), i;
}
var p2e = () => {
  let [e, t] = x.useState(), n = ec(() => /* @__PURE__ */ new Map());
  return Yl(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (r, i) => {
    n.current.set(r, i), t({});
  };
};
function m2e(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function e2({ asChild: e, children: t }, n) {
  return e && x.isValidElement(t) ? x.cloneElement(m2e(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var g2e = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const xd = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  sr,
  {
    ref: n,
    className: z(
      "bg-popover text-popover-foreground flex h-full w-full flex-col overflow-hidden rounded-md",
      e
    ),
    ...t
  }
));
xd.displayName = sr.displayName;
const MQe = ({ children: e, ...t }) => /* @__PURE__ */ d(_2, { ...t, children: /* @__PURE__ */ d(vp, { className: "overflow-hidden p-0", children: /* @__PURE__ */ d(xd, { className: "[&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5", children: e }) }) }), WV = te(({ className: e, wrapperClassName: t, ...n }, r) => /* @__PURE__ */ k(
  "div",
  {
    className: z("flex items-center border-b px-3", t),
    "cmdk-input-wrapper": "",
    children: [
      /* @__PURE__ */ d(Eme, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
      /* @__PURE__ */ d(
        sr.Input,
        {
          ref: r,
          className: z(
            "placeholder:text-muted-foreground outline-hidden flex h-10 w-full rounded-md bg-transparent py-3 text-bodysm disabled:cursor-not-allowed disabled:opacity-50",
            e
          ),
          ...n
        }
      )
    ]
  }
));
WV.displayName = sr.Input.displayName;
const cp = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  sr.List,
  {
    ref: n,
    className: z("max-h-[300px] overflow-y-auto overflow-x-hidden", e),
    ...t
  }
));
cp.displayName = sr.List.displayName;
const cC = te((e, t) => /* @__PURE__ */ d(
  sr.Empty,
  {
    ref: t,
    className: "py-6 text-center text-bodysm",
    ...e
  }
));
cC.displayName = sr.Empty.displayName;
const dp = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  sr.Group,
  {
    ref: n,
    className: z(
      "text-foreground [&_[cmdk-group-heading]]:text-muted-foreground overflow-hidden p-1 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-bodysm [&_[cmdk-group-heading]]:font-medium",
      e
    ),
    ...t
  }
));
dp.displayName = sr.Group.displayName;
const v2e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  sr.Separator,
  {
    ref: n,
    className: z("bg-border -mx-1 h-px", e),
    ...t
  }
));
v2e.displayName = sr.Separator.displayName;
const fp = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  sr.Item,
  {
    ref: n,
    className: z(
      "data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground rounded-xs outline-hidden relative flex cursor-default select-none items-center px-2 py-1.5 text-bodysm data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50",
      e
    ),
    ...t
  }
));
fp.displayName = sr.Item.displayName;
const y2e = ({
  className: e,
  ...t
}) => /* @__PURE__ */ d(
  "span",
  {
    className: z(
      "text-muted-foreground ml-auto text-bodysmxs tracking-widest",
      e
    ),
    ...t
  }
);
y2e.displayName = "CommandShortcut";
function t2(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = x.createContext(a), l = n.length;
    n = [...n, a];
    const u = (f) => {
      var w;
      const { scope: h, children: m, ...v } = f, g = ((w = h == null ? void 0 : h[e]) == null ? void 0 : w[l]) || s, y = x.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ d(g.Provider, { value: y, children: m });
    };
    u.displayName = o + "Provider";
    function c(f, h) {
      var g;
      const m = ((g = h == null ? void 0 : h[e]) == null ? void 0 : g[l]) || s, v = x.useContext(m);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, c];
  }
  const i = () => {
    const o = n.map((a) => x.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return x.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, b2e(i, ...t)];
}
function b2e(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return x.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function x2e(e, t) {
  return x.useReducer((n, r) => t[n][r] ?? n, e);
}
var HV = (e) => {
  const { present: t, children: n } = e, r = w2e(t), i = typeof n == "function" ? n({ present: r.isPresent }) : x.Children.only(n), o = tt(r.ref, C2e(i));
  return typeof n == "function" || r.isPresent ? x.cloneElement(i, { ref: o }) : null;
};
HV.displayName = "Presence";
function w2e(e) {
  const [t, n] = x.useState(), r = x.useRef({}), i = x.useRef(e), o = x.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = x2e(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return x.useEffect(() => {
    const u = z0(r.current);
    o.current = s === "mounted" ? u : "none";
  }, [s]), He(() => {
    const u = r.current, c = i.current;
    if (c !== e) {
      const h = o.current, m = z0(u);
      e ? l("MOUNT") : m === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(c && h !== m ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, l]), He(() => {
    if (t) {
      let u;
      const c = t.ownerDocument.defaultView ?? window, f = (m) => {
        const g = z0(r.current).includes(m.animationName);
        if (m.target === t && g && (l("ANIMATION_END"), !i.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = c.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, h = (m) => {
        m.target === t && (o.current = z0(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        c.clearTimeout(u), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: x.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function z0(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function C2e(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var dC = "Collapsible", [S2e, RQe] = t2(dC), [_2e, fC] = S2e(dC), UV = x.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: i,
      disabled: o,
      onOpenChange: a,
      ...s
    } = e, [l = !1, u] = Kt({
      prop: r,
      defaultProp: i,
      onChange: a
    });
    return /* @__PURE__ */ d(
      _2e,
      {
        scope: n,
        disabled: o,
        contentId: ln(),
        open: l,
        onOpenToggle: x.useCallback(() => u((c) => !c), [u]),
        children: /* @__PURE__ */ d(
          Re.div,
          {
            "data-state": pC(l),
            "data-disabled": o ? "" : void 0,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
UV.displayName = dC;
var GV = "CollapsibleTrigger", KV = x.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, i = fC(GV, n);
    return /* @__PURE__ */ d(
      Re.button,
      {
        type: "button",
        "aria-controls": i.contentId,
        "aria-expanded": i.open || !1,
        "data-state": pC(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        disabled: i.disabled,
        ...r,
        ref: t,
        onClick: Me(e.onClick, i.onOpenToggle)
      }
    );
  }
);
KV.displayName = GV;
var hC = "CollapsibleContent", YV = x.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, i = fC(hC, e.__scopeCollapsible);
    return /* @__PURE__ */ d(HV, { present: n || i.open, children: ({ present: o }) => /* @__PURE__ */ d(E2e, { ...r, ref: t, present: o }) });
  }
);
YV.displayName = hC;
var E2e = x.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: i, ...o } = e, a = fC(hC, n), [s, l] = x.useState(r), u = x.useRef(null), c = tt(t, u), f = x.useRef(0), h = f.current, m = x.useRef(0), v = m.current, g = a.open || s, y = x.useRef(g), w = x.useRef();
  return x.useEffect(() => {
    const C = requestAnimationFrame(() => y.current = !1);
    return () => cancelAnimationFrame(C);
  }, []), He(() => {
    const C = u.current;
    if (C) {
      w.current = w.current || {
        transitionDuration: C.style.transitionDuration,
        animationName: C.style.animationName
      }, C.style.transitionDuration = "0s", C.style.animationName = "none";
      const S = C.getBoundingClientRect();
      f.current = S.height, m.current = S.width, y.current || (C.style.transitionDuration = w.current.transitionDuration, C.style.animationName = w.current.animationName), l(r);
    }
  }, [a.open, r]), /* @__PURE__ */ d(
    Re.div,
    {
      "data-state": pC(a.open),
      "data-disabled": a.disabled ? "" : void 0,
      id: a.contentId,
      hidden: !g,
      ...o,
      ref: c,
      style: {
        "--radix-collapsible-content-height": h ? `${h}px` : void 0,
        "--radix-collapsible-content-width": v ? `${v}px` : void 0,
        ...e.style
      },
      children: g && i
    }
  );
});
function pC(e) {
  return e ? "open" : "closed";
}
var N2e = UV;
const DQe = N2e, IQe = KV, $Qe = YV;
function LQe({
  table: e
}) {
  const t = e == null ? void 0 : e.getAllLeafColumns().reduce((r, i) => i.getIsVisible() ? r : r + 1, 0), n = () => {
    const i = ((e == null ? void 0 : e.getAllLeafColumns()) || []).filter((o) => o.getCanHide());
    return /* @__PURE__ */ d("ul", { className: "flex flex-col gap-2", children: i.map((o) => /* @__PURE__ */ d("li", { children: /* @__PURE__ */ k(qt, { className: "text-bodymd flex items-center gap-1", children: [
      /* @__PURE__ */ d(
        Np,
        {
          checked: o.getIsVisible(),
          className: "!h-3 !w-6",
          onCheckedChange: (a) => o.toggleVisibility(a),
          thumbClassName: "!h-2 !w-2 data-[state=checked]:!translate-x-3"
        }
      ),
      " ",
      /* @__PURE__ */ d(xe, { children: o.columnDef.header })
    ] }) }, o.id)) });
  };
  return /* @__PURE__ */ k(g2, { children: [
    /* @__PURE__ */ d(v2, { asChild: !0, children: /* @__PURE__ */ k(
      et,
      {
        className: z(
          "text-textPrimary !rounded",
          t === 0 ? "!border-interactiveBorder" : "!border-blueBorder bg-blueBgDefault"
        ),
        variant: "outline",
        children: [
          /* @__PURE__ */ d(fce, {}),
          t === 0 ? "Hide fields" : `${t} hidden fields`
        ]
      }
    ) }),
    /* @__PURE__ */ k(
      mp,
      {
        align: "start",
        className: "flex flex-col gap-3",
        side: "bottom",
        children: [
          n(),
          /* @__PURE__ */ d(
            et,
            {
              className: "!border-interactiveBorder text-textPrimary !text-bodysm h-min w-full py-1.5",
              onClick: () => e == null ? void 0 : e.toggleAllColumnsVisible(!0),
              variant: "outline",
              children: "Show all"
            }
          )
        ]
      }
    )
  ] });
}
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function FQe() {
  return {
    accessor: (e, t) => typeof e == "function" ? {
      ...t,
      accessorFn: e
    } : {
      ...t,
      accessorKey: e
    },
    display: (e) => e,
    group: (e) => e
  };
}
function Ns(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function mi(e, t) {
  return (n) => {
    t.setState((r) => ({
      ...r,
      [e]: Ns(n, r[e])
    }));
  };
}
function n2(e) {
  return e instanceof Function;
}
function A2e(e) {
  return Array.isArray(e) && e.every((t) => typeof t == "number");
}
function O2e(e, t) {
  const n = [], r = (i) => {
    i.forEach((o) => {
      n.push(o);
      const a = t(o);
      a != null && a.length && r(a);
    });
  };
  return r(e), n;
}
function ze(e, t, n) {
  let r = [], i;
  return (o) => {
    let a;
    n.key && n.debug && (a = Date.now());
    const s = e(o);
    if (!(s.length !== r.length || s.some((c, f) => r[f] !== c)))
      return i;
    r = s;
    let u;
    if (n.key && n.debug && (u = Date.now()), i = t(...s), n == null || n.onChange == null || n.onChange(i), n.key && n.debug && n != null && n.debug()) {
      const c = Math.round((Date.now() - a) * 100) / 100, f = Math.round((Date.now() - u) * 100) / 100, h = f / 16, m = (v, g) => {
        for (v = String(v); v.length < g; )
          v = " " + v;
        return v;
      };
      console.info(`%c⏱ ${m(f, 5)} /${m(c, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * h, 120))}deg 100% 31%);`, n == null ? void 0 : n.key);
    }
    return i;
  };
}
function We(e, t, n, r) {
  return {
    debug: () => {
      var i;
      return (i = e == null ? void 0 : e.debugAll) != null ? i : e[t];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: r
  };
}
function k2e(e, t, n, r) {
  const i = () => {
    var a;
    return (a = o.getValue()) != null ? a : e.options.renderFallbackValue;
  }, o = {
    id: `${t.id}_${n.id}`,
    row: t,
    column: n,
    getValue: () => t.getValue(r),
    renderValue: i,
    getContext: ze(() => [e, n, t, o], (a, s, l, u) => ({
      table: a,
      column: s,
      row: l,
      cell: u,
      getValue: u.getValue,
      renderValue: u.renderValue
    }), We(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((a) => {
    a.createCell == null || a.createCell(o, n, t, e);
  }, {}), o;
}
function P2e(e, t, n, r) {
  var i, o;
  const s = {
    ...e._getDefaultColumnDef(),
    ...t
  }, l = s.accessorKey;
  let u = (i = (o = s.id) != null ? o : l ? typeof String.prototype.replaceAll == "function" ? l.replaceAll(".", "_") : l.replace(/\./g, "_") : void 0) != null ? i : typeof s.header == "string" ? s.header : void 0, c;
  if (s.accessorFn ? c = s.accessorFn : l && (l.includes(".") ? c = (h) => {
    let m = h;
    for (const g of l.split(".")) {
      var v;
      m = (v = m) == null ? void 0 : v[g], process.env.NODE_ENV !== "production" && m === void 0 && console.warn(`"${g}" in deeply nested key "${l}" returned undefined.`);
    }
    return m;
  } : c = (h) => h[s.accessorKey]), !u)
    throw process.env.NODE_ENV !== "production" ? new Error(s.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let f = {
    id: `${String(u)}`,
    accessorFn: c,
    parent: r,
    depth: n,
    columnDef: s,
    columns: [],
    getFlatColumns: ze(() => [!0], () => {
      var h;
      return [f, ...(h = f.columns) == null ? void 0 : h.flatMap((m) => m.getFlatColumns())];
    }, We(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: ze(() => [e._getOrderColumnsFn()], (h) => {
      var m;
      if ((m = f.columns) != null && m.length) {
        let v = f.columns.flatMap((g) => g.getLeafColumns());
        return h(v);
      }
      return [f];
    }, We(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const h of e._features)
    h.createColumn == null || h.createColumn(f, e);
  return f;
}
const dr = "debugHeaders";
function zO(e, t, n) {
  var r;
  let o = {
    id: (r = n.id) != null ? r : t.id,
    column: t,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const a = [], s = (l) => {
        l.subHeaders && l.subHeaders.length && l.subHeaders.map(s), a.push(l);
      };
      return s(o), a;
    },
    getContext: () => ({
      table: e,
      header: o,
      column: t
    })
  };
  return e._features.forEach((a) => {
    a.createHeader == null || a.createHeader(o, e);
  }), o;
}
const T2e = {
  createTable: (e) => {
    e.getHeaderGroups = ze(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, i) => {
      var o, a;
      const s = (o = r == null ? void 0 : r.map((f) => n.find((h) => h.id === f)).filter(Boolean)) != null ? o : [], l = (a = i == null ? void 0 : i.map((f) => n.find((h) => h.id === f)).filter(Boolean)) != null ? a : [], u = n.filter((f) => !(r != null && r.includes(f.id)) && !(i != null && i.includes(f.id)));
      return W0(t, [...s, ...u, ...l], e);
    }, We(e.options, dr, "getHeaderGroups")), e.getCenterHeaderGroups = ze(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, i) => (n = n.filter((o) => !(r != null && r.includes(o.id)) && !(i != null && i.includes(o.id))), W0(t, n, e, "center")), We(e.options, dr, "getCenterHeaderGroups")), e.getLeftHeaderGroups = ze(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (t, n, r) => {
      var i;
      const o = (i = r == null ? void 0 : r.map((a) => n.find((s) => s.id === a)).filter(Boolean)) != null ? i : [];
      return W0(t, o, e, "left");
    }, We(e.options, dr, "getLeftHeaderGroups")), e.getRightHeaderGroups = ze(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (t, n, r) => {
      var i;
      const o = (i = r == null ? void 0 : r.map((a) => n.find((s) => s.id === a)).filter(Boolean)) != null ? i : [];
      return W0(t, o, e, "right");
    }, We(e.options, dr, "getRightHeaderGroups")), e.getFooterGroups = ze(() => [e.getHeaderGroups()], (t) => [...t].reverse(), We(e.options, dr, "getFooterGroups")), e.getLeftFooterGroups = ze(() => [e.getLeftHeaderGroups()], (t) => [...t].reverse(), We(e.options, dr, "getLeftFooterGroups")), e.getCenterFooterGroups = ze(() => [e.getCenterHeaderGroups()], (t) => [...t].reverse(), We(e.options, dr, "getCenterFooterGroups")), e.getRightFooterGroups = ze(() => [e.getRightHeaderGroups()], (t) => [...t].reverse(), We(e.options, dr, "getRightFooterGroups")), e.getFlatHeaders = ze(() => [e.getHeaderGroups()], (t) => t.map((n) => n.headers).flat(), We(e.options, dr, "getFlatHeaders")), e.getLeftFlatHeaders = ze(() => [e.getLeftHeaderGroups()], (t) => t.map((n) => n.headers).flat(), We(e.options, dr, "getLeftFlatHeaders")), e.getCenterFlatHeaders = ze(() => [e.getCenterHeaderGroups()], (t) => t.map((n) => n.headers).flat(), We(e.options, dr, "getCenterFlatHeaders")), e.getRightFlatHeaders = ze(() => [e.getRightHeaderGroups()], (t) => t.map((n) => n.headers).flat(), We(e.options, dr, "getRightFlatHeaders")), e.getCenterLeafHeaders = ze(() => [e.getCenterFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), We(e.options, dr, "getCenterLeafHeaders")), e.getLeftLeafHeaders = ze(() => [e.getLeftFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), We(e.options, dr, "getLeftLeafHeaders")), e.getRightLeafHeaders = ze(() => [e.getRightFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), We(e.options, dr, "getRightLeafHeaders")), e.getLeafHeaders = ze(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (t, n, r) => {
      var i, o, a, s, l, u;
      return [...(i = (o = t[0]) == null ? void 0 : o.headers) != null ? i : [], ...(a = (s = n[0]) == null ? void 0 : s.headers) != null ? a : [], ...(l = (u = r[0]) == null ? void 0 : u.headers) != null ? l : []].map((c) => c.getLeafHeaders()).flat();
    }, We(e.options, dr, "getLeafHeaders"));
  }
};
function W0(e, t, n, r) {
  var i, o;
  let a = 0;
  const s = function(h, m) {
    m === void 0 && (m = 1), a = Math.max(a, m), h.filter((v) => v.getIsVisible()).forEach((v) => {
      var g;
      (g = v.columns) != null && g.length && s(v.columns, m + 1);
    }, 0);
  };
  s(e);
  let l = [];
  const u = (h, m) => {
    const v = {
      depth: m,
      id: [r, `${m}`].filter(Boolean).join("_"),
      headers: []
    }, g = [];
    h.forEach((y) => {
      const w = [...g].reverse()[0], C = y.column.depth === v.depth;
      let S, N = !1;
      if (C && y.column.parent ? S = y.column.parent : (S = y.column, N = !0), w && (w == null ? void 0 : w.column) === S)
        w.subHeaders.push(y);
      else {
        const E = zO(n, S, {
          id: [r, m, S.id, y == null ? void 0 : y.id].filter(Boolean).join("_"),
          isPlaceholder: N,
          placeholderId: N ? `${g.filter((A) => A.column === S).length}` : void 0,
          depth: m,
          index: g.length
        });
        E.subHeaders.push(y), g.push(E);
      }
      v.headers.push(y), y.headerGroup = v;
    }), l.push(v), m > 0 && u(g, m - 1);
  }, c = t.map((h, m) => zO(n, h, {
    depth: a,
    index: m
  }));
  u(c, a - 1), l.reverse();
  const f = (h) => h.filter((v) => v.column.getIsVisible()).map((v) => {
    let g = 0, y = 0, w = [0];
    v.subHeaders && v.subHeaders.length ? (w = [], f(v.subHeaders).forEach((S) => {
      let {
        colSpan: N,
        rowSpan: E
      } = S;
      g += N, w.push(E);
    })) : g = 1;
    const C = Math.min(...w);
    return y = y + C, v.colSpan = g, v.rowSpan = y, {
      colSpan: g,
      rowSpan: y
    };
  });
  return f((i = (o = l[0]) == null ? void 0 : o.headers) != null ? i : []), l;
}
const mC = (e, t, n, r, i, o, a) => {
  let s = {
    id: t,
    index: r,
    original: n,
    depth: i,
    parentId: a,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (l) => {
      if (s._valuesCache.hasOwnProperty(l))
        return s._valuesCache[l];
      const u = e.getColumn(l);
      if (u != null && u.accessorFn)
        return s._valuesCache[l] = u.accessorFn(s.original, r), s._valuesCache[l];
    },
    getUniqueValues: (l) => {
      if (s._uniqueValuesCache.hasOwnProperty(l))
        return s._uniqueValuesCache[l];
      const u = e.getColumn(l);
      if (u != null && u.accessorFn)
        return u.columnDef.getUniqueValues ? (s._uniqueValuesCache[l] = u.columnDef.getUniqueValues(s.original, r), s._uniqueValuesCache[l]) : (s._uniqueValuesCache[l] = [s.getValue(l)], s._uniqueValuesCache[l]);
    },
    renderValue: (l) => {
      var u;
      return (u = s.getValue(l)) != null ? u : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => O2e(s.subRows, (l) => l.subRows),
    getParentRow: () => s.parentId ? e.getRow(s.parentId, !0) : void 0,
    getParentRows: () => {
      let l = [], u = s;
      for (; ; ) {
        const c = u.getParentRow();
        if (!c) break;
        l.push(c), u = c;
      }
      return l.reverse();
    },
    getAllCells: ze(() => [e.getAllLeafColumns()], (l) => l.map((u) => k2e(e, s, u, u.id)), We(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: ze(() => [s.getAllCells()], (l) => l.reduce((u, c) => (u[c.column.id] = c, u), {}), We(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let l = 0; l < e._features.length; l++) {
    const u = e._features[l];
    u == null || u.createRow == null || u.createRow(s, e);
  }
  return s;
}, M2e = {
  createColumn: (e, t) => {
    e._getFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : t.getPreFilteredRowModel(), e._getFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, ZV = (e, t, n) => {
  var r, i;
  const o = n == null || (r = n.toString()) == null ? void 0 : r.toLowerCase();
  return !!(!((i = e.getValue(t)) == null || (i = i.toString()) == null || (i = i.toLowerCase()) == null) && i.includes(o));
};
ZV.autoRemove = (e) => io(e);
const XV = (e, t, n) => {
  var r;
  return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null) && r.includes(n));
};
XV.autoRemove = (e) => io(e);
const JV = (e, t, n) => {
  var r;
  return ((r = e.getValue(t)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === (n == null ? void 0 : n.toLowerCase());
};
JV.autoRemove = (e) => io(e);
const QV = (e, t, n) => {
  var r;
  return (r = e.getValue(t)) == null ? void 0 : r.includes(n);
};
QV.autoRemove = (e) => io(e) || !(e != null && e.length);
const eq = (e, t, n) => !n.some((r) => {
  var i;
  return !((i = e.getValue(t)) != null && i.includes(r));
});
eq.autoRemove = (e) => io(e) || !(e != null && e.length);
const tq = (e, t, n) => n.some((r) => {
  var i;
  return (i = e.getValue(t)) == null ? void 0 : i.includes(r);
});
tq.autoRemove = (e) => io(e) || !(e != null && e.length);
const nq = (e, t, n) => e.getValue(t) === n;
nq.autoRemove = (e) => io(e);
const rq = (e, t, n) => e.getValue(t) == n;
rq.autoRemove = (e) => io(e);
const gC = (e, t, n) => {
  let [r, i] = n;
  const o = e.getValue(t);
  return o >= r && o <= i;
};
gC.resolveFilterValue = (e) => {
  let [t, n] = e, r = typeof t != "number" ? parseFloat(t) : t, i = typeof n != "number" ? parseFloat(n) : n, o = t === null || Number.isNaN(r) ? -1 / 0 : r, a = n === null || Number.isNaN(i) ? 1 / 0 : i;
  if (o > a) {
    const s = o;
    o = a, a = s;
  }
  return [o, a];
};
gC.autoRemove = (e) => io(e) || io(e[0]) && io(e[1]);
const xa = {
  includesString: ZV,
  includesStringSensitive: XV,
  equalsString: JV,
  arrIncludes: QV,
  arrIncludesAll: eq,
  arrIncludesSome: tq,
  equals: nq,
  weakEquals: rq,
  inNumberRange: gC
};
function io(e) {
  return e == null || e === "";
}
const R2e = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: mi("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, t) => {
    e.getAutoFilterFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      return typeof r == "string" ? xa.includesString : typeof r == "number" ? xa.inNumberRange : typeof r == "boolean" || r !== null && typeof r == "object" ? xa.equals : Array.isArray(r) ? xa.arrIncludes : xa.weakEquals;
    }, e.getFilterFn = () => {
      var n, r;
      return n2(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (n = (r = t.options.filterFns) == null ? void 0 : r[e.columnDef.filterFn]) != null ? n : xa[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var n, r, i;
      return ((n = e.columnDef.enableColumnFilter) != null ? n : !0) && ((r = t.options.enableColumnFilters) != null ? r : !0) && ((i = t.options.enableFilters) != null ? i : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var n;
      return (n = t.getState().columnFilters) == null || (n = n.find((r) => r.id === e.id)) == null ? void 0 : n.value;
    }, e.getFilterIndex = () => {
      var n, r;
      return (n = (r = t.getState().columnFilters) == null ? void 0 : r.findIndex((i) => i.id === e.id)) != null ? n : -1;
    }, e.setFilterValue = (n) => {
      t.setColumnFilters((r) => {
        const i = e.getFilterFn(), o = r == null ? void 0 : r.find((c) => c.id === e.id), a = Ns(n, o ? o.value : void 0);
        if (WO(i, a, e)) {
          var s;
          return (s = r == null ? void 0 : r.filter((c) => c.id !== e.id)) != null ? s : [];
        }
        const l = {
          id: e.id,
          value: a
        };
        if (o) {
          var u;
          return (u = r == null ? void 0 : r.map((c) => c.id === e.id ? l : c)) != null ? u : [];
        }
        return r != null && r.length ? [...r, l] : [l];
      });
    };
  },
  createRow: (e, t) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (t) => {
      const n = e.getAllLeafColumns(), r = (i) => {
        var o;
        return (o = Ns(t, i)) == null ? void 0 : o.filter((a) => {
          const s = n.find((l) => l.id === a.id);
          if (s) {
            const l = s.getFilterFn();
            if (WO(l, a.value, s))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(r);
    }, e.resetColumnFilters = (t) => {
      var n, r;
      e.setColumnFilters(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.columnFilters) != null ? n : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function WO(e, t, n) {
  return (e && e.autoRemove ? e.autoRemove(t, n) : !1) || typeof t > "u" || typeof t == "string" && !t;
}
const D2e = (e, t, n) => n.reduce((r, i) => {
  const o = i.getValue(e);
  return r + (typeof o == "number" ? o : 0);
}, 0), I2e = (e, t, n) => {
  let r;
  return n.forEach((i) => {
    const o = i.getValue(e);
    o != null && (r > o || r === void 0 && o >= o) && (r = o);
  }), r;
}, $2e = (e, t, n) => {
  let r;
  return n.forEach((i) => {
    const o = i.getValue(e);
    o != null && (r < o || r === void 0 && o >= o) && (r = o);
  }), r;
}, L2e = (e, t, n) => {
  let r, i;
  return n.forEach((o) => {
    const a = o.getValue(e);
    a != null && (r === void 0 ? a >= a && (r = i = a) : (r > a && (r = a), i < a && (i = a)));
  }), [r, i];
}, F2e = (e, t) => {
  let n = 0, r = 0;
  if (t.forEach((i) => {
    let o = i.getValue(e);
    o != null && (o = +o) >= o && (++n, r += o);
  }), n) return r / n;
}, B2e = (e, t) => {
  if (!t.length)
    return;
  const n = t.map((o) => o.getValue(e));
  if (!A2e(n))
    return;
  if (n.length === 1)
    return n[0];
  const r = Math.floor(n.length / 2), i = n.sort((o, a) => o - a);
  return n.length % 2 !== 0 ? i[r] : (i[r - 1] + i[r]) / 2;
}, j2e = (e, t) => Array.from(new Set(t.map((n) => n.getValue(e))).values()), V2e = (e, t) => new Set(t.map((n) => n.getValue(e))).size, q2e = (e, t) => t.length, Hb = {
  sum: D2e,
  min: I2e,
  max: $2e,
  extent: L2e,
  mean: F2e,
  median: B2e,
  unique: j2e,
  uniqueCount: V2e,
  count: q2e
}, z2e = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var t, n;
      return (t = (n = e.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? t : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: mi("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, t) => {
    e.toggleGrouping = () => {
      t.setGrouping((n) => n != null && n.includes(e.id) ? n.filter((r) => r !== e.id) : [...n ?? [], e.id]);
    }, e.getCanGroup = () => {
      var n, r;
      return ((n = e.columnDef.enableGrouping) != null ? n : !0) && ((r = t.options.enableGrouping) != null ? r : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.includes(e.id);
    }, e.getGroupedIndex = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const n = e.getCanGroup();
      return () => {
        n && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      if (typeof r == "number")
        return Hb.sum;
      if (Object.prototype.toString.call(r) === "[object Date]")
        return Hb.extent;
    }, e.getAggregationFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return n2(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (n = (r = t.options.aggregationFns) == null ? void 0 : r[e.columnDef.aggregationFn]) != null ? n : Hb[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (t) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(t), e.resetGrouping = (t) => {
      var n, r;
      e.setGrouping(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.grouping) != null ? n : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, t) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (n) => {
      if (e._groupingValuesCache.hasOwnProperty(n))
        return e._groupingValuesCache[n];
      const r = t.getColumn(n);
      return r != null && r.columnDef.getGroupingValue ? (e._groupingValuesCache[n] = r.columnDef.getGroupingValue(e.original), e._groupingValuesCache[n]) : e.getValue(n);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, t, n, r) => {
    e.getIsGrouped = () => t.getIsGrouped() && t.id === n.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && t.getIsGrouped(), e.getIsAggregated = () => {
      var i;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((i = n.subRows) != null && i.length);
    };
  }
};
function W2e(e, t, n) {
  if (!(t != null && t.length) || !n)
    return e;
  const r = e.filter((o) => !t.includes(o.id));
  return n === "remove" ? r : [...t.map((o) => e.find((a) => a.id === o)).filter(Boolean), ...r];
}
const H2e = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: mi("columnOrder", e)
  }),
  createColumn: (e, t) => {
    e.getIndex = ze((n) => [Lf(t, n)], (n) => n.findIndex((r) => r.id === e.id), We(t.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (n) => {
      var r;
      return ((r = Lf(t, n)[0]) == null ? void 0 : r.id) === e.id;
    }, e.getIsLastColumn = (n) => {
      var r;
      const i = Lf(t, n);
      return ((r = i[i.length - 1]) == null ? void 0 : r.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (t) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(t), e.resetColumnOrder = (t) => {
      var n;
      e.setColumnOrder(t ? [] : (n = e.initialState.columnOrder) != null ? n : []);
    }, e._getOrderColumnsFn = ze(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (t, n, r) => (i) => {
      let o = [];
      if (!(t != null && t.length))
        o = i;
      else {
        const a = [...t], s = [...i];
        for (; s.length && a.length; ) {
          const l = a.shift(), u = s.findIndex((c) => c.id === l);
          u > -1 && o.push(s.splice(u, 1)[0]);
        }
        o = [...o, ...s];
      }
      return W2e(o, n, r);
    }, We(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, Ub = () => ({
  left: [],
  right: []
}), U2e = {
  getInitialState: (e) => ({
    columnPinning: Ub(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: mi("columnPinning", e)
  }),
  createColumn: (e, t) => {
    e.pin = (n) => {
      const r = e.getLeafColumns().map((i) => i.id).filter(Boolean);
      t.setColumnPinning((i) => {
        var o, a;
        if (n === "right") {
          var s, l;
          return {
            left: ((s = i == null ? void 0 : i.left) != null ? s : []).filter((f) => !(r != null && r.includes(f))),
            right: [...((l = i == null ? void 0 : i.right) != null ? l : []).filter((f) => !(r != null && r.includes(f))), ...r]
          };
        }
        if (n === "left") {
          var u, c;
          return {
            left: [...((u = i == null ? void 0 : i.left) != null ? u : []).filter((f) => !(r != null && r.includes(f))), ...r],
            right: ((c = i == null ? void 0 : i.right) != null ? c : []).filter((f) => !(r != null && r.includes(f)))
          };
        }
        return {
          left: ((o = i == null ? void 0 : i.left) != null ? o : []).filter((f) => !(r != null && r.includes(f))),
          right: ((a = i == null ? void 0 : i.right) != null ? a : []).filter((f) => !(r != null && r.includes(f)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((r) => {
      var i, o, a;
      return ((i = r.columnDef.enablePinning) != null ? i : !0) && ((o = (a = t.options.enableColumnPinning) != null ? a : t.options.enablePinning) != null ? o : !0);
    }), e.getIsPinned = () => {
      const n = e.getLeafColumns().map((s) => s.id), {
        left: r,
        right: i
      } = t.getState().columnPinning, o = n.some((s) => r == null ? void 0 : r.includes(s)), a = n.some((s) => i == null ? void 0 : i.includes(s));
      return o ? "left" : a ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const i = e.getIsPinned();
      return i ? (n = (r = t.getState().columnPinning) == null || (r = r[i]) == null ? void 0 : r.indexOf(e.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (e, t) => {
    e.getCenterVisibleCells = ze(() => [e._getAllVisibleCells(), t.getState().columnPinning.left, t.getState().columnPinning.right], (n, r, i) => {
      const o = [...r ?? [], ...i ?? []];
      return n.filter((a) => !o.includes(a.column.id));
    }, We(t.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = ze(() => [e._getAllVisibleCells(), t.getState().columnPinning.left], (n, r) => (r ?? []).map((o) => n.find((a) => a.column.id === o)).filter(Boolean).map((o) => ({
      ...o,
      position: "left"
    })), We(t.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = ze(() => [e._getAllVisibleCells(), t.getState().columnPinning.right], (n, r) => (r ?? []).map((o) => n.find((a) => a.column.id === o)).filter(Boolean).map((o) => ({
      ...o,
      position: "right"
    })), We(t.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (t) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(t), e.resetColumnPinning = (t) => {
      var n, r;
      return e.setColumnPinning(t ? Ub() : (n = (r = e.initialState) == null ? void 0 : r.columnPinning) != null ? n : Ub());
    }, e.getIsSomeColumnsPinned = (t) => {
      var n;
      const r = e.getState().columnPinning;
      if (!t) {
        var i, o;
        return !!((i = r.left) != null && i.length || (o = r.right) != null && o.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e.getLeftLeafColumns = ze(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (t, n) => (n ?? []).map((r) => t.find((i) => i.id === r)).filter(Boolean), We(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = ze(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (t, n) => (n ?? []).map((r) => t.find((i) => i.id === r)).filter(Boolean), We(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = ze(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r) => {
      const i = [...n ?? [], ...r ?? []];
      return t.filter((o) => !i.includes(o.id));
    }, We(e.options, "debugColumns", "getCenterLeafColumns"));
  }
}, H0 = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, Gb = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), G2e = {
  getDefaultColumnDef: () => H0,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: Gb(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: mi("columnSizing", e),
    onColumnSizingInfoChange: mi("columnSizingInfo", e)
  }),
  createColumn: (e, t) => {
    e.getSize = () => {
      var n, r, i;
      const o = t.getState().columnSizing[e.id];
      return Math.min(Math.max((n = e.columnDef.minSize) != null ? n : H0.minSize, (r = o ?? e.columnDef.size) != null ? r : H0.size), (i = e.columnDef.maxSize) != null ? i : H0.maxSize);
    }, e.getStart = ze((n) => [n, Lf(t, n), t.getState().columnSizing], (n, r) => r.slice(0, e.getIndex(n)).reduce((i, o) => i + o.getSize(), 0), We(t.options, "debugColumns", "getStart")), e.getAfter = ze((n) => [n, Lf(t, n), t.getState().columnSizing], (n, r) => r.slice(e.getIndex(n) + 1).reduce((i, o) => i + o.getSize(), 0), We(t.options, "debugColumns", "getAfter")), e.resetSize = () => {
      t.setColumnSizing((n) => {
        let {
          [e.id]: r,
          ...i
        } = n;
        return i;
      });
    }, e.getCanResize = () => {
      var n, r;
      return ((n = e.columnDef.enableResizing) != null ? n : !0) && ((r = t.options.enableColumnResizing) != null ? r : !0);
    }, e.getIsResizing = () => t.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, t) => {
    e.getSize = () => {
      let n = 0;
      const r = (i) => {
        if (i.subHeaders.length)
          i.subHeaders.forEach(r);
        else {
          var o;
          n += (o = i.column.getSize()) != null ? o : 0;
        }
      };
      return r(e), n;
    }, e.getStart = () => {
      if (e.index > 0) {
        const n = e.headerGroup.headers[e.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, e.getResizeHandler = (n) => {
      const r = t.getColumn(e.column.id), i = r == null ? void 0 : r.getCanResize();
      return (o) => {
        if (!r || !i || (o.persist == null || o.persist(), Kb(o) && o.touches && o.touches.length > 1))
          return;
        const a = e.getSize(), s = e ? e.getLeafHeaders().map((w) => [w.column.id, w.column.getSize()]) : [[r.id, r.getSize()]], l = Kb(o) ? Math.round(o.touches[0].clientX) : o.clientX, u = {}, c = (w, C) => {
          typeof C == "number" && (t.setColumnSizingInfo((S) => {
            var N, E;
            const A = t.options.columnResizeDirection === "rtl" ? -1 : 1, O = (C - ((N = S == null ? void 0 : S.startOffset) != null ? N : 0)) * A, T = Math.max(O / ((E = S == null ? void 0 : S.startSize) != null ? E : 0), -0.999999);
            return S.columnSizingStart.forEach((M) => {
              let [L, I] = M;
              u[L] = Math.round(Math.max(I + I * T, 0) * 100) / 100;
            }), {
              ...S,
              deltaOffset: O,
              deltaPercentage: T
            };
          }), (t.options.columnResizeMode === "onChange" || w === "end") && t.setColumnSizing((S) => ({
            ...S,
            ...u
          })));
        }, f = (w) => c("move", w), h = (w) => {
          c("end", w), t.setColumnSizingInfo((C) => ({
            ...C,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, m = n || typeof document < "u" ? document : null, v = {
          moveHandler: (w) => f(w.clientX),
          upHandler: (w) => {
            m == null || m.removeEventListener("mousemove", v.moveHandler), m == null || m.removeEventListener("mouseup", v.upHandler), h(w.clientX);
          }
        }, g = {
          moveHandler: (w) => (w.cancelable && (w.preventDefault(), w.stopPropagation()), f(w.touches[0].clientX), !1),
          upHandler: (w) => {
            var C;
            m == null || m.removeEventListener("touchmove", g.moveHandler), m == null || m.removeEventListener("touchend", g.upHandler), w.cancelable && (w.preventDefault(), w.stopPropagation()), h((C = w.touches[0]) == null ? void 0 : C.clientX);
          }
        }, y = K2e() ? {
          passive: !1
        } : !1;
        Kb(o) ? (m == null || m.addEventListener("touchmove", g.moveHandler, y), m == null || m.addEventListener("touchend", g.upHandler, y)) : (m == null || m.addEventListener("mousemove", v.moveHandler, y), m == null || m.addEventListener("mouseup", v.upHandler, y)), t.setColumnSizingInfo((w) => ({
          ...w,
          startOffset: l,
          startSize: a,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: s,
          isResizingColumn: r.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (t) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(t), e.setColumnSizingInfo = (t) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(t), e.resetColumnSizing = (t) => {
      var n;
      e.setColumnSizing(t ? {} : (n = e.initialState.columnSizing) != null ? n : {});
    }, e.resetHeaderSizeInfo = (t) => {
      var n;
      e.setColumnSizingInfo(t ? Gb() : (n = e.initialState.columnSizingInfo) != null ? n : Gb());
    }, e.getTotalSize = () => {
      var t, n;
      return (t = (n = e.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, i) => r + i.getSize(), 0)) != null ? t : 0;
    }, e.getLeftTotalSize = () => {
      var t, n;
      return (t = (n = e.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, i) => r + i.getSize(), 0)) != null ? t : 0;
    }, e.getCenterTotalSize = () => {
      var t, n;
      return (t = (n = e.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, i) => r + i.getSize(), 0)) != null ? t : 0;
    }, e.getRightTotalSize = () => {
      var t, n;
      return (t = (n = e.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, i) => r + i.getSize(), 0)) != null ? t : 0;
    };
  }
};
let U0 = null;
function K2e() {
  if (typeof U0 == "boolean") return U0;
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, t), window.removeEventListener("test", n);
  } catch {
    e = !1;
  }
  return U0 = e, U0;
}
function Kb(e) {
  return e.type === "touchstart";
}
const Y2e = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: mi("columnVisibility", e)
  }),
  createColumn: (e, t) => {
    e.toggleVisibility = (n) => {
      e.getCanHide() && t.setColumnVisibility((r) => ({
        ...r,
        [e.id]: n ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var n, r;
      const i = e.columns;
      return (n = i.length ? i.some((o) => o.getIsVisible()) : (r = t.getState().columnVisibility) == null ? void 0 : r[e.id]) != null ? n : !0;
    }, e.getCanHide = () => {
      var n, r;
      return ((n = e.columnDef.enableHiding) != null ? n : !0) && ((r = t.options.enableHiding) != null ? r : !0);
    }, e.getToggleVisibilityHandler = () => (n) => {
      e.toggleVisibility == null || e.toggleVisibility(n.target.checked);
    };
  },
  createRow: (e, t) => {
    e._getAllVisibleCells = ze(() => [e.getAllCells(), t.getState().columnVisibility], (n) => n.filter((r) => r.column.getIsVisible()), We(t.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = ze(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (n, r, i) => [...n, ...r, ...i], We(t.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const t = (n, r) => ze(() => [r(), r().filter((i) => i.getIsVisible()).map((i) => i.id).join("_")], (i) => i.filter((o) => o.getIsVisible == null ? void 0 : o.getIsVisible()), We(e.options, "debugColumns", n));
    e.getVisibleFlatColumns = t("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = t("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = t("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = t("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = t("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (n) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(n), e.resetColumnVisibility = (n) => {
      var r;
      e.setColumnVisibility(n ? {} : (r = e.initialState.columnVisibility) != null ? r : {});
    }, e.toggleAllColumnsVisible = (n) => {
      var r;
      n = (r = n) != null ? r : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((i, o) => ({
        ...i,
        [o.id]: n || !(o.getCanHide != null && o.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var r;
      e.toggleAllColumnsVisible((r = n.target) == null ? void 0 : r.checked);
    };
  }
};
function Lf(e, t) {
  return t ? t === "center" ? e.getCenterVisibleLeafColumns() : t === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const Z2e = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, X2e = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: mi("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (t) => {
      var n;
      const r = (n = e.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[t.id]) == null ? void 0 : n.getValue();
      return typeof r == "string" || typeof r == "number";
    }
  }),
  createColumn: (e, t) => {
    e.getCanGlobalFilter = () => {
      var n, r, i, o;
      return ((n = e.columnDef.enableGlobalFilter) != null ? n : !0) && ((r = t.options.enableGlobalFilter) != null ? r : !0) && ((i = t.options.enableFilters) != null ? i : !0) && ((o = t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(e)) != null ? o : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => xa.includesString, e.getGlobalFilterFn = () => {
      var t, n;
      const {
        globalFilterFn: r
      } = e.options;
      return n2(r) ? r : r === "auto" ? e.getGlobalAutoFilterFn() : (t = (n = e.options.filterFns) == null ? void 0 : n[r]) != null ? t : xa[r];
    }, e.setGlobalFilter = (t) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(t);
    }, e.resetGlobalFilter = (t) => {
      e.setGlobalFilter(t ? void 0 : e.initialState.globalFilter);
    };
  }
}, J2e = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: mi("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetExpanded = () => {
      var r, i;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (i = e.options.autoResetAll) != null ? i : e.options.autoResetExpanded) != null ? r : !e.options.manualExpanding) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetExpanded(), n = !1;
        });
      }
    }, e.setExpanded = (r) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(r), e.toggleAllRowsExpanded = (r) => {
      r ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (r) => {
      var i, o;
      e.setExpanded(r ? {} : (i = (o = e.initialState) == null ? void 0 : o.expanded) != null ? i : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((r) => r.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (r) => {
      r.persist == null || r.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const r = e.getState().expanded;
      return r === !0 || Object.values(r).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const r = e.getState().expanded;
      return typeof r == "boolean" ? r === !0 : !(!Object.keys(r).length || e.getRowModel().flatRows.some((i) => !i.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let r = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((o) => {
        const a = o.split(".");
        r = Math.max(r, a.length);
      }), r;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, t) => {
    e.toggleExpanded = (n) => {
      t.setExpanded((r) => {
        var i;
        const o = r === !0 ? !0 : !!(r != null && r[e.id]);
        let a = {};
        if (r === !0 ? Object.keys(t.getRowModel().rowsById).forEach((s) => {
          a[s] = !0;
        }) : a = r, n = (i = n) != null ? i : !o, !o && n)
          return {
            ...a,
            [e.id]: !0
          };
        if (o && !n) {
          const {
            [e.id]: s,
            ...l
          } = a;
          return l;
        }
        return r;
      });
    }, e.getIsExpanded = () => {
      var n;
      const r = t.getState().expanded;
      return !!((n = t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(e)) != null ? n : r === !0 || r != null && r[e.id]);
    }, e.getCanExpand = () => {
      var n, r, i;
      return (n = t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(e)) != null ? n : ((r = t.options.enableExpanding) != null ? r : !0) && !!((i = e.subRows) != null && i.length);
    }, e.getIsAllParentsExpanded = () => {
      let n = !0, r = e;
      for (; n && r.parentId; )
        r = t.getRow(r.parentId, !0), n = r.getIsExpanded();
      return n;
    }, e.getToggleExpandedHandler = () => {
      const n = e.getCanExpand();
      return () => {
        n && e.toggleExpanded();
      };
    };
  }
}, Ox = 0, kx = 10, Yb = () => ({
  pageIndex: Ox,
  pageSize: kx
}), Q2e = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...Yb(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: mi("pagination", e)
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetPageIndex = () => {
      var r, i;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (i = e.options.autoResetAll) != null ? i : e.options.autoResetPageIndex) != null ? r : !e.options.manualPagination) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetPageIndex(), n = !1;
        });
      }
    }, e.setPagination = (r) => {
      const i = (o) => Ns(r, o);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(i);
    }, e.resetPagination = (r) => {
      var i;
      e.setPagination(r ? Yb() : (i = e.initialState.pagination) != null ? i : Yb());
    }, e.setPageIndex = (r) => {
      e.setPagination((i) => {
        let o = Ns(r, i.pageIndex);
        const a = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return o = Math.max(0, Math.min(o, a)), {
          ...i,
          pageIndex: o
        };
      });
    }, e.resetPageIndex = (r) => {
      var i, o;
      e.setPageIndex(r ? Ox : (i = (o = e.initialState) == null || (o = o.pagination) == null ? void 0 : o.pageIndex) != null ? i : Ox);
    }, e.resetPageSize = (r) => {
      var i, o;
      e.setPageSize(r ? kx : (i = (o = e.initialState) == null || (o = o.pagination) == null ? void 0 : o.pageSize) != null ? i : kx);
    }, e.setPageSize = (r) => {
      e.setPagination((i) => {
        const o = Math.max(1, Ns(r, i.pageSize)), a = i.pageSize * i.pageIndex, s = Math.floor(a / o);
        return {
          ...i,
          pageIndex: s,
          pageSize: o
        };
      });
    }, e.setPageCount = (r) => e.setPagination((i) => {
      var o;
      let a = Ns(r, (o = e.options.pageCount) != null ? o : -1);
      return typeof a == "number" && (a = Math.max(-1, a)), {
        ...i,
        pageCount: a
      };
    }), e.getPageOptions = ze(() => [e.getPageCount()], (r) => {
      let i = [];
      return r && r > 0 && (i = [...new Array(r)].fill(null).map((o, a) => a)), i;
    }, We(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: r
      } = e.getState().pagination, i = e.getPageCount();
      return i === -1 ? !0 : i === 0 ? !1 : r < i - 1;
    }, e.previousPage = () => e.setPageIndex((r) => r - 1), e.nextPage = () => e.setPageIndex((r) => r + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var r;
      return (r = e.options.pageCount) != null ? r : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var r;
      return (r = e.options.rowCount) != null ? r : e.getPrePaginationRowModel().rows.length;
    };
  }
}, Zb = () => ({
  top: [],
  bottom: []
}), eve = {
  getInitialState: (e) => ({
    rowPinning: Zb(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: mi("rowPinning", e)
  }),
  createRow: (e, t) => {
    e.pin = (n, r, i) => {
      const o = r ? e.getLeafRows().map((l) => {
        let {
          id: u
        } = l;
        return u;
      }) : [], a = i ? e.getParentRows().map((l) => {
        let {
          id: u
        } = l;
        return u;
      }) : [], s = /* @__PURE__ */ new Set([...a, e.id, ...o]);
      t.setRowPinning((l) => {
        var u, c;
        if (n === "bottom") {
          var f, h;
          return {
            top: ((f = l == null ? void 0 : l.top) != null ? f : []).filter((g) => !(s != null && s.has(g))),
            bottom: [...((h = l == null ? void 0 : l.bottom) != null ? h : []).filter((g) => !(s != null && s.has(g))), ...Array.from(s)]
          };
        }
        if (n === "top") {
          var m, v;
          return {
            top: [...((m = l == null ? void 0 : l.top) != null ? m : []).filter((g) => !(s != null && s.has(g))), ...Array.from(s)],
            bottom: ((v = l == null ? void 0 : l.bottom) != null ? v : []).filter((g) => !(s != null && s.has(g)))
          };
        }
        return {
          top: ((u = l == null ? void 0 : l.top) != null ? u : []).filter((g) => !(s != null && s.has(g))),
          bottom: ((c = l == null ? void 0 : l.bottom) != null ? c : []).filter((g) => !(s != null && s.has(g)))
        };
      });
    }, e.getCanPin = () => {
      var n;
      const {
        enableRowPinning: r,
        enablePinning: i
      } = t.options;
      return typeof r == "function" ? r(e) : (n = r ?? i) != null ? n : !0;
    }, e.getIsPinned = () => {
      const n = [e.id], {
        top: r,
        bottom: i
      } = t.getState().rowPinning, o = n.some((s) => r == null ? void 0 : r.includes(s)), a = n.some((s) => i == null ? void 0 : i.includes(s));
      return o ? "top" : a ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const i = e.getIsPinned();
      if (!i) return -1;
      const o = (n = i === "top" ? t.getTopRows() : t.getBottomRows()) == null ? void 0 : n.map((a) => {
        let {
          id: s
        } = a;
        return s;
      });
      return (r = o == null ? void 0 : o.indexOf(e.id)) != null ? r : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (t) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(t), e.resetRowPinning = (t) => {
      var n, r;
      return e.setRowPinning(t ? Zb() : (n = (r = e.initialState) == null ? void 0 : r.rowPinning) != null ? n : Zb());
    }, e.getIsSomeRowsPinned = (t) => {
      var n;
      const r = e.getState().rowPinning;
      if (!t) {
        var i, o;
        return !!((i = r.top) != null && i.length || (o = r.bottom) != null && o.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e._getPinnedRows = (t, n, r) => {
      var i;
      return ((i = e.options.keepPinnedRows) == null || i ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((a) => {
          const s = e.getRow(a, !0);
          return s.getIsAllParentsExpanded() ? s : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((a) => t.find((s) => s.id === a))
      )).filter(Boolean).map((a) => ({
        ...a,
        position: r
      }));
    }, e.getTopRows = ze(() => [e.getRowModel().rows, e.getState().rowPinning.top], (t, n) => e._getPinnedRows(t, n, "top"), We(e.options, "debugRows", "getTopRows")), e.getBottomRows = ze(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (t, n) => e._getPinnedRows(t, n, "bottom"), We(e.options, "debugRows", "getBottomRows")), e.getCenterRows = ze(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (t, n, r) => {
      const i = /* @__PURE__ */ new Set([...n ?? [], ...r ?? []]);
      return t.filter((o) => !i.has(o.id));
    }, We(e.options, "debugRows", "getCenterRows"));
  }
}, tve = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: mi("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (t) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(t), e.resetRowSelection = (t) => {
      var n;
      return e.setRowSelection(t ? {} : (n = e.initialState.rowSelection) != null ? n : {});
    }, e.toggleAllRowsSelected = (t) => {
      e.setRowSelection((n) => {
        t = typeof t < "u" ? t : !e.getIsAllRowsSelected();
        const r = {
          ...n
        }, i = e.getPreGroupedRowModel().flatRows;
        return t ? i.forEach((o) => {
          o.getCanSelect() && (r[o.id] = !0);
        }) : i.forEach((o) => {
          delete r[o.id];
        }), r;
      });
    }, e.toggleAllPageRowsSelected = (t) => e.setRowSelection((n) => {
      const r = typeof t < "u" ? t : !e.getIsAllPageRowsSelected(), i = {
        ...n
      };
      return e.getRowModel().rows.forEach((o) => {
        Px(i, o.id, r, !0, e);
      }), i;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = ze(() => [e.getState().rowSelection, e.getCoreRowModel()], (t, n) => Object.keys(t).length ? Xb(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, We(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = ze(() => [e.getState().rowSelection, e.getFilteredRowModel()], (t, n) => Object.keys(t).length ? Xb(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, We(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = ze(() => [e.getState().rowSelection, e.getSortedRowModel()], (t, n) => Object.keys(t).length ? Xb(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, We(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const t = e.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = e.getState();
      let r = !!(t.length && Object.keys(n).length);
      return r && t.some((i) => i.getCanSelect() && !n[i.id]) && (r = !1), r;
    }, e.getIsAllPageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows.filter((i) => i.getCanSelect()), {
        rowSelection: n
      } = e.getState();
      let r = !!t.length;
      return r && t.some((i) => !n[i.id]) && (r = !1), r;
    }, e.getIsSomeRowsSelected = () => {
      var t;
      const n = Object.keys((t = e.getState().rowSelection) != null ? t : {}).length;
      return n > 0 && n < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : t.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (t) => {
      e.toggleAllRowsSelected(t.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (t) => {
      e.toggleAllPageRowsSelected(t.target.checked);
    };
  },
  createRow: (e, t) => {
    e.toggleSelected = (n, r) => {
      const i = e.getIsSelected();
      t.setRowSelection((o) => {
        var a;
        if (n = typeof n < "u" ? n : !i, e.getCanSelect() && i === n)
          return o;
        const s = {
          ...o
        };
        return Px(s, e.id, n, (a = r == null ? void 0 : r.selectChildren) != null ? a : !0, t), s;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return vC(e, n);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return Tx(e, n) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return Tx(e, n) === "all";
    }, e.getCanSelect = () => {
      var n;
      return typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(e) : (n = t.options.enableRowSelection) != null ? n : !0;
    }, e.getCanSelectSubRows = () => {
      var n;
      return typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(e) : (n = t.options.enableSubRowSelection) != null ? n : !0;
    }, e.getCanMultiSelect = () => {
      var n;
      return typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(e) : (n = t.options.enableMultiRowSelection) != null ? n : !0;
    }, e.getToggleSelectedHandler = () => {
      const n = e.getCanSelect();
      return (r) => {
        var i;
        n && e.toggleSelected((i = r.target) == null ? void 0 : i.checked);
      };
    };
  }
}, Px = (e, t, n, r, i) => {
  var o;
  const a = i.getRow(t, !0);
  n ? (a.getCanMultiSelect() || Object.keys(e).forEach((s) => delete e[s]), a.getCanSelect() && (e[t] = !0)) : delete e[t], r && (o = a.subRows) != null && o.length && a.getCanSelectSubRows() && a.subRows.forEach((s) => Px(e, s.id, n, r, i));
};
function Xb(e, t) {
  const n = e.getState().rowSelection, r = [], i = {}, o = function(a, s) {
    return a.map((l) => {
      var u;
      const c = vC(l, n);
      if (c && (r.push(l), i[l.id] = l), (u = l.subRows) != null && u.length && (l = {
        ...l,
        subRows: o(l.subRows)
      }), c)
        return l;
    }).filter(Boolean);
  };
  return {
    rows: o(t.rows),
    flatRows: r,
    rowsById: i
  };
}
function vC(e, t) {
  var n;
  return (n = t[e.id]) != null ? n : !1;
}
function Tx(e, t, n) {
  var r;
  if (!((r = e.subRows) != null && r.length)) return !1;
  let i = !0, o = !1;
  return e.subRows.forEach((a) => {
    if (!(o && !i) && (a.getCanSelect() && (vC(a, t) ? o = !0 : i = !1), a.subRows && a.subRows.length)) {
      const s = Tx(a, t);
      s === "all" ? o = !0 : (s === "some" && (o = !0), i = !1);
    }
  }), i ? "all" : o ? "some" : !1;
}
const Mx = /([0-9]+)/gm, nve = (e, t, n) => iq(js(e.getValue(n)).toLowerCase(), js(t.getValue(n)).toLowerCase()), rve = (e, t, n) => iq(js(e.getValue(n)), js(t.getValue(n))), ive = (e, t, n) => yC(js(e.getValue(n)).toLowerCase(), js(t.getValue(n)).toLowerCase()), ove = (e, t, n) => yC(js(e.getValue(n)), js(t.getValue(n))), ave = (e, t, n) => {
  const r = e.getValue(n), i = t.getValue(n);
  return r > i ? 1 : r < i ? -1 : 0;
}, sve = (e, t, n) => yC(e.getValue(n), t.getValue(n));
function yC(e, t) {
  return e === t ? 0 : e > t ? 1 : -1;
}
function js(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function iq(e, t) {
  const n = e.split(Mx).filter(Boolean), r = t.split(Mx).filter(Boolean);
  for (; n.length && r.length; ) {
    const i = n.shift(), o = r.shift(), a = parseInt(i, 10), s = parseInt(o, 10), l = [a, s].sort();
    if (isNaN(l[0])) {
      if (i > o)
        return 1;
      if (o > i)
        return -1;
      continue;
    }
    if (isNaN(l[1]))
      return isNaN(a) ? -1 : 1;
    if (a > s)
      return 1;
    if (s > a)
      return -1;
  }
  return n.length - r.length;
}
const df = {
  alphanumeric: nve,
  alphanumericCaseSensitive: rve,
  text: ive,
  textCaseSensitive: ove,
  datetime: ave,
  basic: sve
}, lve = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: mi("sorting", e),
    isMultiSortEvent: (t) => t.shiftKey
  }),
  createColumn: (e, t) => {
    e.getAutoSortingFn = () => {
      const n = t.getFilteredRowModel().flatRows.slice(10);
      let r = !1;
      for (const i of n) {
        const o = i == null ? void 0 : i.getValue(e.id);
        if (Object.prototype.toString.call(o) === "[object Date]")
          return df.datetime;
        if (typeof o == "string" && (r = !0, o.split(Mx).length > 1))
          return df.alphanumeric;
      }
      return r ? df.text : df.basic;
    }, e.getAutoSortDir = () => {
      const n = t.getFilteredRowModel().flatRows[0];
      return typeof (n == null ? void 0 : n.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return n2(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (n = (r = t.options.sortingFns) == null ? void 0 : r[e.columnDef.sortingFn]) != null ? n : df[e.columnDef.sortingFn];
    }, e.toggleSorting = (n, r) => {
      const i = e.getNextSortingOrder(), o = typeof n < "u" && n !== null;
      t.setSorting((a) => {
        const s = a == null ? void 0 : a.find((m) => m.id === e.id), l = a == null ? void 0 : a.findIndex((m) => m.id === e.id);
        let u = [], c, f = o ? n : i === "desc";
        if (a != null && a.length && e.getCanMultiSort() && r ? s ? c = "toggle" : c = "add" : a != null && a.length && l !== a.length - 1 ? c = "replace" : s ? c = "toggle" : c = "replace", c === "toggle" && (o || i || (c = "remove")), c === "add") {
          var h;
          u = [...a, {
            id: e.id,
            desc: f
          }], u.splice(0, u.length - ((h = t.options.maxMultiSortColCount) != null ? h : Number.MAX_SAFE_INTEGER));
        } else c === "toggle" ? u = a.map((m) => m.id === e.id ? {
          ...m,
          desc: f
        } : m) : c === "remove" ? u = a.filter((m) => m.id !== e.id) : u = [{
          id: e.id,
          desc: f
        }];
        return u;
      });
    }, e.getFirstSortDir = () => {
      var n, r;
      return ((n = (r = e.columnDef.sortDescFirst) != null ? r : t.options.sortDescFirst) != null ? n : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (n) => {
      var r, i;
      const o = e.getFirstSortDir(), a = e.getIsSorted();
      return a ? a !== o && ((r = t.options.enableSortingRemoval) == null || r) && // If enableSortRemove, enable in general
      (!(n && (i = t.options.enableMultiRemove) != null) || i) ? !1 : a === "desc" ? "asc" : "desc" : o;
    }, e.getCanSort = () => {
      var n, r;
      return ((n = e.columnDef.enableSorting) != null ? n : !0) && ((r = t.options.enableSorting) != null ? r : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var n, r;
      return (n = (r = e.columnDef.enableMultiSort) != null ? r : t.options.enableMultiSort) != null ? n : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var n;
      const r = (n = t.getState().sorting) == null ? void 0 : n.find((i) => i.id === e.id);
      return r ? r.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var n, r;
      return (n = (r = t.getState().sorting) == null ? void 0 : r.findIndex((i) => i.id === e.id)) != null ? n : -1;
    }, e.clearSorting = () => {
      t.setSorting((n) => n != null && n.length ? n.filter((r) => r.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const n = e.getCanSort();
      return (r) => {
        n && (r.persist == null || r.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(r) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (t) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(t), e.resetSorting = (t) => {
      var n, r;
      e.setSorting(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.sorting) != null ? n : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, uve = [
  T2e,
  Y2e,
  H2e,
  U2e,
  M2e,
  R2e,
  Z2e,
  //depends on ColumnFaceting
  X2e,
  //depends on ColumnFiltering
  lve,
  z2e,
  //depends on RowSorting
  J2e,
  Q2e,
  eve,
  tve,
  G2e
];
function cve(e) {
  var t, n;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const r = [...uve, ...(t = e._features) != null ? t : []];
  let i = {
    _features: r
  };
  const o = i._features.reduce((h, m) => Object.assign(h, m.getDefaultOptions == null ? void 0 : m.getDefaultOptions(i)), {}), a = (h) => i.options.mergeOptions ? i.options.mergeOptions(o, h) : {
    ...o,
    ...h
  };
  let l = {
    ...{},
    ...(n = e.initialState) != null ? n : {}
  };
  i._features.forEach((h) => {
    var m;
    l = (m = h.getInitialState == null ? void 0 : h.getInitialState(l)) != null ? m : l;
  });
  const u = [];
  let c = !1;
  const f = {
    _features: r,
    options: {
      ...o,
      ...e
    },
    initialState: l,
    _queue: (h) => {
      u.push(h), c || (c = !0, Promise.resolve().then(() => {
        for (; u.length; )
          u.shift()();
        c = !1;
      }).catch((m) => setTimeout(() => {
        throw m;
      })));
    },
    reset: () => {
      i.setState(i.initialState);
    },
    setOptions: (h) => {
      const m = Ns(h, i.options);
      i.options = a(m);
    },
    getState: () => i.options.state,
    setState: (h) => {
      i.options.onStateChange == null || i.options.onStateChange(h);
    },
    _getRowId: (h, m, v) => {
      var g;
      return (g = i.options.getRowId == null ? void 0 : i.options.getRowId(h, m, v)) != null ? g : `${v ? [v.id, m].join(".") : m}`;
    },
    getCoreRowModel: () => (i._getCoreRowModel || (i._getCoreRowModel = i.options.getCoreRowModel(i)), i._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => i.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (h, m) => {
      let v = (m ? i.getPrePaginationRowModel() : i.getRowModel()).rowsById[h];
      if (!v && (v = i.getCoreRowModel().rowsById[h], !v))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${h}`) : new Error();
      return v;
    },
    _getDefaultColumnDef: ze(() => [i.options.defaultColumn], (h) => {
      var m;
      return h = (m = h) != null ? m : {}, {
        header: (v) => {
          const g = v.header.column.columnDef;
          return g.accessorKey ? g.accessorKey : g.accessorFn ? g.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (v) => {
          var g, y;
          return (g = (y = v.renderValue()) == null || y.toString == null ? void 0 : y.toString()) != null ? g : null;
        },
        ...i._features.reduce((v, g) => Object.assign(v, g.getDefaultColumnDef == null ? void 0 : g.getDefaultColumnDef()), {}),
        ...h
      };
    }, We(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => i.options.columns,
    getAllColumns: ze(() => [i._getColumnDefs()], (h) => {
      const m = function(v, g, y) {
        return y === void 0 && (y = 0), v.map((w) => {
          const C = P2e(i, w, y, g), S = w;
          return C.columns = S.columns ? m(S.columns, C, y + 1) : [], C;
        });
      };
      return m(h);
    }, We(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: ze(() => [i.getAllColumns()], (h) => h.flatMap((m) => m.getFlatColumns()), We(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: ze(() => [i.getAllFlatColumns()], (h) => h.reduce((m, v) => (m[v.id] = v, m), {}), We(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: ze(() => [i.getAllColumns(), i._getOrderColumnsFn()], (h, m) => {
      let v = h.flatMap((g) => g.getLeafColumns());
      return m(v);
    }, We(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (h) => {
      const m = i._getAllFlatColumnsById()[h];
      return process.env.NODE_ENV !== "production" && !m && console.error(`[Table] Column with id '${h}' does not exist.`), m;
    }
  };
  Object.assign(i, f);
  for (let h = 0; h < i._features.length; h++) {
    const m = i._features[h];
    m == null || m.createTable == null || m.createTable(i);
  }
  return i;
}
function dve() {
  return (e) => ze(() => [e.options.data], (t) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, r = function(i, o, a) {
      o === void 0 && (o = 0);
      const s = [];
      for (let u = 0; u < i.length; u++) {
        const c = mC(e, e._getRowId(i[u], u, a), i[u], u, o, void 0, a == null ? void 0 : a.id);
        if (n.flatRows.push(c), n.rowsById[c.id] = c, s.push(c), e.options.getSubRows) {
          var l;
          c.originalSubRows = e.options.getSubRows(i[u], u), (l = c.originalSubRows) != null && l.length && (c.subRows = r(c.originalSubRows, o + 1, c));
        }
      }
      return s;
    };
    return n.rows = r(t), n;
  }, We(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function fve(e) {
  const t = [], n = (r) => {
    var i;
    t.push(r), (i = r.subRows) != null && i.length && r.getIsExpanded() && r.subRows.forEach(n);
  };
  return e.rows.forEach(n), {
    rows: t,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function hve(e, t, n) {
  return n.options.filterFromLeafRows ? pve(e, t, n) : mve(e, t, n);
}
function pve(e, t, n) {
  var r;
  const i = [], o = {}, a = (r = n.options.maxLeafRowFilterDepth) != null ? r : 100, s = function(l, u) {
    u === void 0 && (u = 0);
    const c = [];
    for (let h = 0; h < l.length; h++) {
      var f;
      let m = l[h];
      const v = mC(n, m.id, m.original, m.index, m.depth, void 0, m.parentId);
      if (v.columnFilters = m.columnFilters, (f = m.subRows) != null && f.length && u < a) {
        if (v.subRows = s(m.subRows, u + 1), m = v, t(m) && !v.subRows.length) {
          c.push(m), o[m.id] = m, i.push(m);
          continue;
        }
        if (t(m) || v.subRows.length) {
          c.push(m), o[m.id] = m, i.push(m);
          continue;
        }
      } else
        m = v, t(m) && (c.push(m), o[m.id] = m, i.push(m));
    }
    return c;
  };
  return {
    rows: s(e),
    flatRows: i,
    rowsById: o
  };
}
function mve(e, t, n) {
  var r;
  const i = [], o = {}, a = (r = n.options.maxLeafRowFilterDepth) != null ? r : 100, s = function(l, u) {
    u === void 0 && (u = 0);
    const c = [];
    for (let h = 0; h < l.length; h++) {
      let m = l[h];
      if (t(m)) {
        var f;
        if ((f = m.subRows) != null && f.length && u < a) {
          const g = mC(n, m.id, m.original, m.index, m.depth, void 0, m.parentId);
          g.subRows = s(m.subRows, u + 1), m = g;
        }
        c.push(m), i.push(m), o[m.id] = m;
      }
    }
    return c;
  };
  return {
    rows: s(e),
    flatRows: i,
    rowsById: o
  };
}
function gve() {
  return (e) => ze(() => [e.getPreFilteredRowModel(), e.getState().columnFilters, e.getState().globalFilter], (t, n, r) => {
    if (!t.rows.length || !(n != null && n.length) && !r) {
      for (let h = 0; h < t.flatRows.length; h++)
        t.flatRows[h].columnFilters = {}, t.flatRows[h].columnFiltersMeta = {};
      return t;
    }
    const i = [], o = [];
    (n ?? []).forEach((h) => {
      var m;
      const v = e.getColumn(h.id);
      if (!v)
        return;
      const g = v.getFilterFn();
      if (!g) {
        process.env.NODE_ENV !== "production" && console.warn(`Could not find a valid 'column.filterFn' for column with the ID: ${v.id}.`);
        return;
      }
      i.push({
        id: h.id,
        filterFn: g,
        resolvedValue: (m = g.resolveFilterValue == null ? void 0 : g.resolveFilterValue(h.value)) != null ? m : h.value
      });
    });
    const a = (n ?? []).map((h) => h.id), s = e.getGlobalFilterFn(), l = e.getAllLeafColumns().filter((h) => h.getCanGlobalFilter());
    r && s && l.length && (a.push("__global__"), l.forEach((h) => {
      var m;
      o.push({
        id: h.id,
        filterFn: s,
        resolvedValue: (m = s.resolveFilterValue == null ? void 0 : s.resolveFilterValue(r)) != null ? m : r
      });
    }));
    let u, c;
    for (let h = 0; h < t.flatRows.length; h++) {
      const m = t.flatRows[h];
      if (m.columnFilters = {}, i.length)
        for (let v = 0; v < i.length; v++) {
          u = i[v];
          const g = u.id;
          m.columnFilters[g] = u.filterFn(m, g, u.resolvedValue, (y) => {
            m.columnFiltersMeta[g] = y;
          });
        }
      if (o.length) {
        for (let v = 0; v < o.length; v++) {
          c = o[v];
          const g = c.id;
          if (c.filterFn(m, g, c.resolvedValue, (y) => {
            m.columnFiltersMeta[g] = y;
          })) {
            m.columnFilters.__global__ = !0;
            break;
          }
        }
        m.columnFilters.__global__ !== !0 && (m.columnFilters.__global__ = !1);
      }
    }
    const f = (h) => {
      for (let m = 0; m < a.length; m++)
        if (h.columnFilters[a[m]] === !1)
          return !1;
      return !0;
    };
    return hve(t.rows, f, e);
  }, We(e.options, "debugTable", "getFilteredRowModel", () => e._autoResetPageIndex()));
}
function vve(e) {
  return (t) => ze(() => [t.getState().pagination, t.getPrePaginationRowModel(), t.options.paginateExpandedRows ? void 0 : t.getState().expanded], (n, r) => {
    if (!r.rows.length)
      return r;
    const {
      pageSize: i,
      pageIndex: o
    } = n;
    let {
      rows: a,
      flatRows: s,
      rowsById: l
    } = r;
    const u = i * o, c = u + i;
    a = a.slice(u, c);
    let f;
    t.options.paginateExpandedRows ? f = {
      rows: a,
      flatRows: s,
      rowsById: l
    } : f = fve({
      rows: a,
      flatRows: s,
      rowsById: l
    }), f.flatRows = [];
    const h = (m) => {
      f.flatRows.push(m), m.subRows.length && m.subRows.forEach(h);
    };
    return f.rows.forEach(h), f;
  }, We(t.options, "debugTable", "getPaginationRowModel"));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function HO(e, t) {
  return e ? yve(e) ? /* @__PURE__ */ x.createElement(e, t) : e : null;
}
function yve(e) {
  return bve(e) || typeof e == "function" || xve(e);
}
function bve(e) {
  return typeof e == "function" && (() => {
    const t = Object.getPrototypeOf(e);
    return t.prototype && t.prototype.isReactComponent;
  })();
}
function xve(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function wve(e) {
  const t = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [n] = x.useState(() => ({
    current: cve(t)
  })), [r, i] = x.useState(() => n.current.initialState);
  return n.current.setOptions((o) => ({
    ...o,
    ...e,
    state: {
      ...r,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (a) => {
      i(a), e.onStateChange == null || e.onStateChange(a);
    }
  })), n.current;
}
const wd = te(
  ({ className: e, ...t }, n) => /* @__PURE__ */ d("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ d(
    "table",
    {
      ref: n,
      className: z("w-full caption-bottom text-bodysm", e),
      ...t
    }
  ) })
);
wd.displayName = "Table";
const Cd = te(({ className: e, ...t }, n) => /* @__PURE__ */ d("thead", { ref: n, className: z("[&_tr]:border-b", e), ...t }));
Cd.displayName = "TableHeader";
const Sd = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "tbody",
  {
    ref: n,
    className: z("[&_tr:last-child]:border-0", e),
    ...t
  }
));
Sd.displayName = "TableBody";
const Cve = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "tfoot",
  {
    ref: n,
    className: z("bg-primary text-primary-foreground font-medium", e),
    ...t
  }
));
Cve.displayName = "TableFooter";
const rr = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "tr",
  {
    ref: n,
    className: z(
      "hover:bg-muted/50 data-[state=selected]:bg-muted border-b transition-colors",
      e
    ),
    ...t
  }
));
rr.displayName = "TableRow";
const jt = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "th",
  {
    ref: n,
    className: z(
      "text-muted-foreground h-12 px-4 text-left align-middle font-medium [&:has([role=checkbox])]:pr-0",
      e
    ),
    ...t
  }
));
jt.displayName = "TableHead";
const Fe = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "td",
  {
    ref: n,
    className: z("p-4 align-middle [&:has([role=checkbox])]:pr-0", e),
    ...t
  }
));
Fe.displayName = "TableCell";
const Sve = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "caption",
  {
    ref: n,
    className: z("text-muted-foreground mt-4 text-bodysm", e),
    ...t
  }
));
Sve.displayName = "TableCaption";
function _ve({
  columnFilters: e,
  columns: t,
  columnVisibility: n,
  data: r,
  enableMultiRowSelection: i = !1,
  enableRowSelection: o = !1,
  getRowClassName: a,
  getRowId: s,
  manualPagination: l = !0,
  noResultsMessage: u = "No results",
  onColumnFiltersChange: c,
  onColumnVisibilityChange: f,
  onRowsSelected: h,
  state: m
}, v) {
  const g = m || {};
  e && (g.columnFilters = e), n && (g.columnVisibility = n);
  const y = wve({
    columns: t,
    data: r,
    enableRowSelection: o,
    enableMultiRowSelection: i,
    getCoreRowModel: dve(),
    getFilteredRowModel: gve(),
    getPaginationRowModel: vve(),
    getRowId: s,
    manualPagination: l,
    onColumnFiltersChange: c,
    onColumnVisibilityChange: f,
    state: g
  }), w = y.getRowModel().rows || [], C = y.getSelectedRowModel();
  return Pe(() => {
    h && h(C);
  }, [C]), Lg(
    v,
    () => ({
      table: y
    }),
    [y]
  ), /* @__PURE__ */ k(wd, { className: "border-interactiveBorder rounded-xs border ", children: [
    /* @__PURE__ */ d(Cd, { className: "px-3 py-0", children: y.getHeaderGroups().map((S) => /* @__PURE__ */ d(
      rr,
      {
        className: "border-interactiveBorder border bg-transparent p-0 hover:bg-transparent",
        children: S.headers.map((N) => /* @__PURE__ */ d(
          jt,
          {
            className: "text-textSubdued px-3 py-0 text-bodymd font-normal",
            children: N.isPlaceholder ? null : HO(
              N.column.columnDef.header,
              N.getContext()
            )
          },
          N.id
        ))
      },
      S.id
    )) }),
    /* @__PURE__ */ k(Sd, { children: [
      w.length > 0 ? w.map((S) => /* @__PURE__ */ d(
        rr,
        {
          className: z(
            "border-interfaceBorder bg-interfaceWhite cursor-pointer border-b hover:bg-[#F9F8F5]",
            a ? a(S) : ""
          ),
          id: `row-${S.id}`,
          "data-state": S.getIsSelected() && "selected",
          onClick: () => S.toggleSelected(),
          children: S.getVisibleCells().map((N) => /* @__PURE__ */ d(Fe, { className: "", children: HO(N.column.columnDef.cell, N.getContext()) }, N.id))
        },
        S.id
      )) : null,
      w.length === 0 ? /* @__PURE__ */ d(rr, { className: "border-interfaceBorder bg-interfaceWhite hover:bg-interfaceWhite border-b", children: /* @__PURE__ */ d(Fe, { colSpan: t.length, className: "text-center", children: u }) }) : null
    ] })
  ] });
}
const BQe = Nue(_ve), oq = ({ className: e, ...t }) => /* @__PURE__ */ d(
  "nav",
  {
    role: "navigation",
    "aria-label": "pagination",
    className: z("flex justify-center", e),
    ...t
  }
);
oq.displayName = "Pagination";
const aq = te(
  ({ className: e, ...t }, n) => /* @__PURE__ */ d(
    "ul",
    {
      ref: n,
      className: z("flex flex-row items-center gap-1", e),
      ...t
    }
  )
);
aq.displayName = "PaginationContent";
const Ef = te(
  ({ className: e, ...t }, n) => /* @__PURE__ */ d("li", { ref: n, className: z("", e), ...t })
);
Ef.displayName = "PaginationItem";
const r2 = ({
  className: e,
  isActive: t,
  onClick: n,
  size: r = "icon",
  ...i
}) => {
  const o = (a) => {
    n && !i.disabled && n(a);
  };
  return /* @__PURE__ */ d(
    "a",
    {
      "aria-current": t ? "page" : void 0,
      className: z(
        Ac({
          variant: t ? "outline" : "ghost",
          size: r
        }),
        e
      ),
      onClick: o,
      ...i
    }
  );
};
r2.displayName = "PaginationLink";
const sq = ({
  className: e,
  ...t
}) => /* @__PURE__ */ k(
  r2,
  {
    "aria-label": "Go to previous page",
    size: "default",
    className: z("gap-1 pl-2.5", e),
    ...t,
    children: [
      /* @__PURE__ */ d(bme, { className: "h-4 w-4" }),
      /* @__PURE__ */ d("span", { children: "Prev" })
    ]
  }
);
sq.displayName = "PaginationPrevious";
const lq = ({
  className: e,
  ...t
}) => /* @__PURE__ */ k(
  r2,
  {
    "aria-label": "Next page",
    size: "default",
    className: z("gap-1 pr-2.5", e),
    ...t,
    children: [
      /* @__PURE__ */ d("span", { children: "Next" }),
      /* @__PURE__ */ d(wme, { className: "h-4 w-4" })
    ]
  }
);
lq.displayName = "PaginationNext";
const uq = ({
  className: e,
  ...t
}) => /* @__PURE__ */ k(
  "span",
  {
    "aria-hidden": !0,
    className: z(
      "flex h-9 w-9 items-center justify-center",
      e
    ),
    ...t,
    children: [
      /* @__PURE__ */ d(Sme, { className: "h-4 w-4" }),
      /* @__PURE__ */ d("span", { className: "sr-only", children: "More pages" })
    ]
  }
);
uq.displayName = "PaginationEllipsis";
function Eve({
  className: e,
  onClickNext: t,
  onClickPageNumber: n,
  onClickPrevious: r,
  pageNumber: i,
  pageSize: o,
  totalRecords: a
}) {
  const s = Je(() => a < o ? 1 : Math.ceil(a / o), [o, a]), l = (f) => /* @__PURE__ */ d(Ef, { children: /* @__PURE__ */ d(
    r2,
    {
      isActive: i === f,
      onClick: () => n == null ? void 0 : n(f),
      children: f
    }
  ) }, f), u = () => /* @__PURE__ */ d(Ef, { children: /* @__PURE__ */ d(uq, {}) });
  return /* @__PURE__ */ d(oq, { className: e, children: /* @__PURE__ */ k(aq, { children: [
    /* @__PURE__ */ d(Ef, { children: /* @__PURE__ */ d(
      sq,
      {
        disabled: i === 1,
        onClick: r
      }
    ) }),
    s <= 5 ? Array.from(Array(s).keys()).map(
      (f) => l(f + 1)
    ) : s > 5 && i < 5 ? /* @__PURE__ */ k(xe, { children: [
      l(1),
      l(2),
      l(3),
      l(4),
      u(),
      l(s)
    ] }) : s > 5 && i > 4 && i <= s - 4 ? /* @__PURE__ */ k(xe, { children: [
      l(1),
      u(),
      Array.from({ length: 2 }, (f, h) => h).map(
        (f) => l(f + i)
      ),
      u(),
      l(s)
    ] }) : /* @__PURE__ */ k(xe, { children: [
      l(1),
      u(),
      l(s - 3),
      l(s - 2),
      l(s - 1),
      l(s)
    ] }),
    /* @__PURE__ */ d(Ef, { children: /* @__PURE__ */ d(
      lq,
      {
        disabled: i === s,
        onClick: t
      }
    ) })
  ] }) });
}
function jQe({
  modelLabel: e,
  page: t,
  pageSize: n,
  total: r
}) {
  const i = (t - 1) * n + 1, o = Math.min(t * n, r);
  return /* @__PURE__ */ k("div", { className: "text-bodysm text-textPrimary", children: [
    "Showing ",
    i,
    "–",
    o,
    " of ",
    r,
    " ",
    e
  ] });
}
function VQe({
  onPageChange: e,
  pageNumber: t,
  pageSize: n,
  totalRecords: r
}) {
  const i = (l) => {
    e(l);
  }, o = () => {
    e(t - 1);
  }, a = () => {
    e(t + 1);
  };
  return {
    DataTablePagination: () => /* @__PURE__ */ d(
      Eve,
      {
        onClickPageNumber: i,
        onClickPrevious: o,
        onClickNext: a,
        pageNumber: t,
        pageSize: n,
        totalRecords: r
      }
    )
  };
}
function Vr({
  title: e,
  subtitle: t,
  className: n,
  children: r
}) {
  return /* @__PURE__ */ k(Pt, { className: z("w-full", n), children: [
    /* @__PURE__ */ k(Tt, { className: "p-3 pb-2", children: [
      /* @__PURE__ */ d(Lt, { className: "text-bodylg font-medium", children: e }),
      t && /* @__PURE__ */ d(ir, { className: "text-bodysm", children: t })
    ] }),
    /* @__PURE__ */ d(Mt, { className: "p-3", children: /* @__PURE__ */ d("div", { className: "text-5xl font-semibold", children: r }) })
  ] });
}
function Nve(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = x.createContext(a), l = n.length;
    n = [...n, a];
    const u = (f) => {
      var w;
      const { scope: h, children: m, ...v } = f, g = ((w = h == null ? void 0 : h[e]) == null ? void 0 : w[l]) || s, y = x.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ d(g.Provider, { value: y, children: m });
    };
    u.displayName = o + "Provider";
    function c(f, h) {
      var g;
      const m = ((g = h == null ? void 0 : h[e]) == null ? void 0 : g[l]) || s, v = x.useContext(m);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, c];
  }
  const i = () => {
    const o = n.map((a) => x.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return x.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, Ave(i, ...t)];
}
function Ave(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return x.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var Ove = "DismissableLayer", Rx = "dismissableLayer.update", kve = "dismissableLayer.pointerDownOutside", Pve = "dismissableLayer.focusOutside", UO, cq = x.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), dq = x.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = e, u = x.useContext(cq), [c, f] = x.useState(null), h = (c == null ? void 0 : c.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = x.useState({}), v = tt(t, (O) => f(O)), g = Array.from(u.layers), [y] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), w = g.indexOf(y), C = c ? g.indexOf(c) : -1, S = u.layersWithOutsidePointerEventsDisabled.size > 0, N = C >= w, E = Rve((O) => {
      const T = O.target, M = [...u.branches].some((L) => L.contains(T));
      !N || M || (i == null || i(O), a == null || a(O), O.defaultPrevented || s == null || s());
    }, h), A = Dve((O) => {
      const T = O.target;
      [...u.branches].some((L) => L.contains(T)) || (o == null || o(O), a == null || a(O), O.defaultPrevented || s == null || s());
    }, h);
    return lu((O) => {
      C === u.layers.size - 1 && (r == null || r(O), !O.defaultPrevented && s && (O.preventDefault(), s()));
    }, h), x.useEffect(() => {
      if (c)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (UO = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(c)), u.layers.add(c), GO(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = UO);
        };
    }, [c, h, n, u]), x.useEffect(() => () => {
      c && (u.layers.delete(c), u.layersWithOutsidePointerEventsDisabled.delete(c), GO());
    }, [c, u]), x.useEffect(() => {
      const O = () => m({});
      return document.addEventListener(Rx, O), () => document.removeEventListener(Rx, O);
    }, []), /* @__PURE__ */ d(
      Re.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: S ? N ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Me(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: Me(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: Me(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
dq.displayName = Ove;
var Tve = "DismissableLayerBranch", Mve = x.forwardRef((e, t) => {
  const n = x.useContext(cq), r = x.useRef(null), i = tt(t, r);
  return x.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ d(Re.div, { ...e, ref: i });
});
Mve.displayName = Tve;
function Rve(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ie(e), r = x.useRef(!1), i = x.useRef(() => {
  });
  return x.useEffect(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          fq(
            kve,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = l, t.addEventListener("click", i.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Dve(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ie(e), r = x.useRef(!1);
  return x.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && fq(Pve, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function GO() {
  const e = new CustomEvent(Rx);
  document.dispatchEvent(e);
}
function fq(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? qg(i, o) : i.dispatchEvent(o);
}
var Jb = 0;
function Ive() {
  x.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? KO()), document.body.insertAdjacentElement("beforeend", e[1] ?? KO()), Jb++, () => {
      Jb === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Jb--;
    };
  }, []);
}
function KO() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Qb = "focusScope.autoFocusOnMount", e3 = "focusScope.autoFocusOnUnmount", YO = { bubbles: !1, cancelable: !0 }, $ve = "FocusScope", bC = x.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o,
    ...a
  } = e, [s, l] = x.useState(null), u = Ie(i), c = Ie(o), f = x.useRef(null), h = tt(t, (g) => l(g)), m = x.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  x.useEffect(() => {
    if (r) {
      let g = function(S) {
        if (m.paused || !s) return;
        const N = S.target;
        s.contains(N) ? f.current = N : ps(f.current, { select: !0 });
      }, y = function(S) {
        if (m.paused || !s) return;
        const N = S.relatedTarget;
        N !== null && (s.contains(N) || ps(f.current, { select: !0 }));
      }, w = function(S) {
        if (document.activeElement === document.body)
          for (const E of S)
            E.removedNodes.length > 0 && ps(s);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", y);
      const C = new MutationObserver(w);
      return s && C.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", y), C.disconnect();
      };
    }
  }, [r, s, m.paused]), x.useEffect(() => {
    if (s) {
      XO.add(m);
      const g = document.activeElement;
      if (!s.contains(g)) {
        const w = new CustomEvent(Qb, YO);
        s.addEventListener(Qb, u), s.dispatchEvent(w), w.defaultPrevented || (Lve(qve(hq(s)), { select: !0 }), document.activeElement === g && ps(s));
      }
      return () => {
        s.removeEventListener(Qb, u), setTimeout(() => {
          const w = new CustomEvent(e3, YO);
          s.addEventListener(e3, c), s.dispatchEvent(w), w.defaultPrevented || ps(g ?? document.body, { select: !0 }), s.removeEventListener(e3, c), XO.remove(m);
        }, 0);
      };
    }
  }, [s, u, c, m]);
  const v = x.useCallback(
    (g) => {
      if (!n && !r || m.paused) return;
      const y = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, w = document.activeElement;
      if (y && w) {
        const C = g.currentTarget, [S, N] = Fve(C);
        S && N ? !g.shiftKey && w === N ? (g.preventDefault(), n && ps(S, { select: !0 })) : g.shiftKey && w === S && (g.preventDefault(), n && ps(N, { select: !0 })) : w === C && g.preventDefault();
      }
    },
    [n, r, m.paused]
  );
  return /* @__PURE__ */ d(Re.div, { tabIndex: -1, ...a, ref: h, onKeyDown: v });
});
bC.displayName = $ve;
function Lve(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (ps(r, { select: t }), document.activeElement !== n) return;
}
function Fve(e) {
  const t = hq(e), n = ZO(t, e), r = ZO(t.reverse(), e);
  return [n, r];
}
function hq(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function ZO(e, t) {
  for (const n of e)
    if (!Bve(n, { upTo: t })) return n;
}
function Bve(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function jve(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function ps(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && jve(e) && t && e.select();
  }
}
var XO = Vve();
function Vve() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = JO(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = JO(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function JO(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function qve(e) {
  return e.filter((t) => t.tagName !== "A");
}
const zve = ["top", "right", "bottom", "left"], Mo = Math.min, ui = Math.max, nm = Math.round, G0 = Math.floor, Vs = (e) => ({
  x: e,
  y: e
}), Wve = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Hve = {
  start: "end",
  end: "start"
};
function Dx(e, t, n) {
  return ui(e, Mo(t, n));
}
function Fa(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ba(e) {
  return e.split("-")[0];
}
function _d(e) {
  return e.split("-")[1];
}
function xC(e) {
  return e === "x" ? "y" : "x";
}
function wC(e) {
  return e === "y" ? "height" : "width";
}
function qs(e) {
  return ["top", "bottom"].includes(Ba(e)) ? "y" : "x";
}
function CC(e) {
  return xC(qs(e));
}
function Uve(e, t, n) {
  n === void 0 && (n = !1);
  const r = _d(e), i = CC(e), o = wC(i);
  let a = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (a = rm(a)), [a, rm(a)];
}
function Gve(e) {
  const t = rm(e);
  return [Ix(e), t, Ix(t)];
}
function Ix(e) {
  return e.replace(/start|end/g, (t) => Hve[t]);
}
function Kve(e, t, n) {
  const r = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : r : t ? r : i;
    case "left":
    case "right":
      return t ? o : a;
    default:
      return [];
  }
}
function Yve(e, t, n, r) {
  const i = _d(e);
  let o = Kve(Ba(e), n === "start", r);
  return i && (o = o.map((a) => a + "-" + i), t && (o = o.concat(o.map(Ix)))), o;
}
function rm(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Wve[t]);
}
function Zve(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function pq(e) {
  return typeof e != "number" ? Zve(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function im(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
function QO(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const o = qs(t), a = CC(t), s = wC(a), l = Ba(t), u = o === "y", c = r.x + r.width / 2 - i.width / 2, f = r.y + r.height / 2 - i.height / 2, h = r[s] / 2 - i[s] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: c,
        y: r.y - i.height
      };
      break;
    case "bottom":
      m = {
        x: c,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      m = {
        x: r.x - i.width,
        y: f
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  switch (_d(t)) {
    case "start":
      m[a] -= h * (n && u ? -1 : 1);
      break;
    case "end":
      m[a] += h * (n && u ? -1 : 1);
      break;
  }
  return m;
}
const Xve = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: a
  } = n, s = o.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let u = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: c,
    y: f
  } = QO(u, r, l), h = r, m = {}, v = 0;
  for (let g = 0; g < s.length; g++) {
    const {
      name: y,
      fn: w
    } = s[g], {
      x: C,
      y: S,
      data: N,
      reset: E
    } = await w({
      x: c,
      y: f,
      initialPlacement: r,
      placement: h,
      strategy: i,
      middlewareData: m,
      rects: u,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = C ?? c, f = S ?? f, m = {
      ...m,
      [y]: {
        ...m[y],
        ...N
      }
    }, E && v <= 50 && (v++, typeof E == "object" && (E.placement && (h = E.placement), E.rects && (u = E.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : E.rects), {
      x: c,
      y: f
    } = QO(u, h, l)), g = -1);
  }
  return {
    x: c,
    y: f,
    placement: h,
    strategy: i,
    middlewareData: m
  };
};
async function Jf(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: a,
    elements: s,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: f = "floating",
    altBoundary: h = !1,
    padding: m = 0
  } = Fa(t, e), v = pq(m), y = s[h ? f === "floating" ? "reference" : "floating" : f], w = im(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(y))) == null || n ? y : y.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: l
  })), C = f === "floating" ? {
    x: r,
    y: i,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating)), N = await (o.isElement == null ? void 0 : o.isElement(S)) ? await (o.getScale == null ? void 0 : o.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, E = im(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: C,
    offsetParent: S,
    strategy: l
  }) : C);
  return {
    top: (w.top - E.top + v.top) / N.y,
    bottom: (E.bottom - w.bottom + v.bottom) / N.y,
    left: (w.left - E.left + v.left) / N.x,
    right: (E.right - w.right + v.right) / N.x
  };
}
const Jve = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: a,
      elements: s,
      middlewareData: l
    } = t, {
      element: u,
      padding: c = 0
    } = Fa(e, t) || {};
    if (u == null)
      return {};
    const f = pq(c), h = {
      x: n,
      y: r
    }, m = CC(i), v = wC(m), g = await a.getDimensions(u), y = m === "y", w = y ? "top" : "left", C = y ? "bottom" : "right", S = y ? "clientHeight" : "clientWidth", N = o.reference[v] + o.reference[m] - h[m] - o.floating[v], E = h[m] - o.reference[m], A = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(u));
    let O = A ? A[S] : 0;
    (!O || !await (a.isElement == null ? void 0 : a.isElement(A))) && (O = s.floating[S] || o.floating[v]);
    const T = N / 2 - E / 2, M = O / 2 - g[v] / 2 - 1, L = Mo(f[w], M), I = Mo(f[C], M), j = L, B = O - g[v] - I, q = O / 2 - g[v] / 2 + T, G = Dx(j, q, B), U = !l.arrow && _d(i) != null && q !== G && o.reference[v] / 2 - (q < j ? L : I) - g[v] / 2 < 0, V = U ? q < j ? q - j : q - B : 0;
    return {
      [m]: h[m] + V,
      data: {
        [m]: G,
        centerOffset: q - G - V,
        ...U && {
          alignmentOffset: V
        }
      },
      reset: U
    };
  }
}), Qve = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: o,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: u
      } = t, {
        mainAxis: c = !0,
        crossAxis: f = !0,
        fallbackPlacements: h,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: g = !0,
        ...y
      } = Fa(e, t);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const w = Ba(i), C = qs(s), S = Ba(s) === s, N = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), E = h || (S || !g ? [rm(s)] : Gve(s)), A = v !== "none";
      !h && A && E.push(...Yve(s, g, v, N));
      const O = [s, ...E], T = await Jf(t, y), M = [];
      let L = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (c && M.push(T[w]), f) {
        const q = Uve(i, a, N);
        M.push(T[q[0]], T[q[1]]);
      }
      if (L = [...L, {
        placement: i,
        overflows: M
      }], !M.every((q) => q <= 0)) {
        var I, j;
        const q = (((I = o.flip) == null ? void 0 : I.index) || 0) + 1, G = O[q];
        if (G)
          return {
            data: {
              index: q,
              overflows: L
            },
            reset: {
              placement: G
            }
          };
        let U = (j = L.filter((V) => V.overflows[0] <= 0).sort((V, H) => V.overflows[1] - H.overflows[1])[0]) == null ? void 0 : j.placement;
        if (!U)
          switch (m) {
            case "bestFit": {
              var B;
              const V = (B = L.filter((H) => {
                if (A) {
                  const Z = qs(H.placement);
                  return Z === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Z === "y";
                }
                return !0;
              }).map((H) => [H.placement, H.overflows.filter((Z) => Z > 0).reduce((Z, de) => Z + de, 0)]).sort((H, Z) => H[1] - Z[1])[0]) == null ? void 0 : B[0];
              V && (U = V);
              break;
            }
            case "initialPlacement":
              U = s;
              break;
          }
        if (i !== U)
          return {
            reset: {
              placement: U
            }
          };
      }
      return {};
    }
  };
};
function ek(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function tk(e) {
  return zve.some((t) => e[t] >= 0);
}
const eye = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...i
      } = Fa(e, t);
      switch (r) {
        case "referenceHidden": {
          const o = await Jf(t, {
            ...i,
            elementContext: "reference"
          }), a = ek(o, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: tk(a)
            }
          };
        }
        case "escaped": {
          const o = await Jf(t, {
            ...i,
            altBoundary: !0
          }), a = ek(o, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: tk(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function tye(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), a = Ba(n), s = _d(n), l = qs(n) === "y", u = ["left", "top"].includes(a) ? -1 : 1, c = o && l ? -1 : 1, f = Fa(t, e);
  let {
    mainAxis: h,
    crossAxis: m,
    alignmentAxis: v
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...f
  };
  return s && typeof v == "number" && (m = s === "end" ? v * -1 : v), l ? {
    x: m * c,
    y: h * u
  } : {
    x: h * u,
    y: m * c
  };
}
const nye = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: a,
        middlewareData: s
      } = t, l = await tye(t, e);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: i + l.x,
        y: o + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, rye = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i
      } = t, {
        mainAxis: o = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (y) => {
            let {
              x: w,
              y: C
            } = y;
            return {
              x: w,
              y: C
            };
          }
        },
        ...l
      } = Fa(e, t), u = {
        x: n,
        y: r
      }, c = await Jf(t, l), f = qs(Ba(i)), h = xC(f);
      let m = u[h], v = u[f];
      if (o) {
        const y = h === "y" ? "top" : "left", w = h === "y" ? "bottom" : "right", C = m + c[y], S = m - c[w];
        m = Dx(C, m, S);
      }
      if (a) {
        const y = f === "y" ? "top" : "left", w = f === "y" ? "bottom" : "right", C = v + c[y], S = v - c[w];
        v = Dx(C, v, S);
      }
      const g = s.fn({
        ...t,
        [h]: m,
        [f]: v
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r
        }
      };
    }
  };
}, iye = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: i,
        rects: o,
        middlewareData: a
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: u = !0
      } = Fa(e, t), c = {
        x: n,
        y: r
      }, f = qs(i), h = xC(f);
      let m = c[h], v = c[f];
      const g = Fa(s, t), y = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const S = h === "y" ? "height" : "width", N = o.reference[h] - o.floating[S] + y.mainAxis, E = o.reference[h] + o.reference[S] - y.mainAxis;
        m < N ? m = N : m > E && (m = E);
      }
      if (u) {
        var w, C;
        const S = h === "y" ? "width" : "height", N = ["top", "left"].includes(Ba(i)), E = o.reference[f] - o.floating[S] + (N && ((w = a.offset) == null ? void 0 : w[f]) || 0) + (N ? 0 : y.crossAxis), A = o.reference[f] + o.reference[S] + (N ? 0 : ((C = a.offset) == null ? void 0 : C[f]) || 0) - (N ? y.crossAxis : 0);
        v < E ? v = E : v > A && (v = A);
      }
      return {
        [h]: m,
        [f]: v
      };
    }
  };
}, oye = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: i,
        elements: o
      } = t, {
        apply: a = () => {
        },
        ...s
      } = Fa(e, t), l = await Jf(t, s), u = Ba(n), c = _d(n), f = qs(n) === "y", {
        width: h,
        height: m
      } = r.floating;
      let v, g;
      u === "top" || u === "bottom" ? (v = u, g = c === (await (i.isRTL == null ? void 0 : i.isRTL(o.floating)) ? "start" : "end") ? "left" : "right") : (g = u, v = c === "end" ? "top" : "bottom");
      const y = m - l.top - l.bottom, w = h - l.left - l.right, C = Mo(m - l[v], y), S = Mo(h - l[g], w), N = !t.middlewareData.shift;
      let E = C, A = S;
      if (f ? A = c || N ? Mo(S, w) : w : E = c || N ? Mo(C, y) : y, N && !c) {
        const T = ui(l.left, 0), M = ui(l.right, 0), L = ui(l.top, 0), I = ui(l.bottom, 0);
        f ? A = h - 2 * (T !== 0 || M !== 0 ? T + M : ui(l.left, l.right)) : E = m - 2 * (L !== 0 || I !== 0 ? L + I : ui(l.top, l.bottom));
      }
      await a({
        ...t,
        availableWidth: A,
        availableHeight: E
      });
      const O = await i.getDimensions(o.floating);
      return h !== O.width || m !== O.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ed(e) {
  return mq(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function fi(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ya(e) {
  var t;
  return (t = (mq(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function mq(e) {
  return e instanceof Node || e instanceof fi(e).Node;
}
function ho(e) {
  return e instanceof Element || e instanceof fi(e).Element;
}
function Wo(e) {
  return e instanceof HTMLElement || e instanceof fi(e).HTMLElement;
}
function nk(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof fi(e).ShadowRoot;
}
function hp(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = po(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function aye(e) {
  return ["table", "td", "th"].includes(Ed(e));
}
function i2(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function SC(e) {
  const t = _C(), n = ho(e) ? po(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function sye(e) {
  let t = zs(e);
  for (; Wo(t) && !kc(t); ) {
    if (SC(t))
      return t;
    if (i2(t))
      return null;
    t = zs(t);
  }
  return null;
}
function _C() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function kc(e) {
  return ["html", "body", "#document"].includes(Ed(e));
}
function po(e) {
  return fi(e).getComputedStyle(e);
}
function o2(e) {
  return ho(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function zs(e) {
  if (Ed(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    nk(e) && e.host || // Fallback.
    Ya(e)
  );
  return nk(t) ? t.host : t;
}
function gq(e) {
  const t = zs(e);
  return kc(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Wo(t) && hp(t) ? t : gq(t);
}
function Qf(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = gq(e), o = i === ((r = e.ownerDocument) == null ? void 0 : r.body), a = fi(i);
  if (o) {
    const s = $x(a);
    return t.concat(a, a.visualViewport || [], hp(i) ? i : [], s && n ? Qf(s) : []);
  }
  return t.concat(i, Qf(i, [], n));
}
function $x(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function vq(e) {
  const t = po(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = Wo(e), o = i ? e.offsetWidth : n, a = i ? e.offsetHeight : r, s = nm(n) !== o || nm(r) !== a;
  return s && (n = o, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function EC(e) {
  return ho(e) ? e : e.contextElement;
}
function mc(e) {
  const t = EC(e);
  if (!Wo(t))
    return Vs(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = vq(t);
  let a = (o ? nm(n.width) : n.width) / r, s = (o ? nm(n.height) : n.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const lye = /* @__PURE__ */ Vs(0);
function yq(e) {
  const t = fi(e);
  return !_C() || !t.visualViewport ? lye : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function uye(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== fi(e) ? !1 : t;
}
function Xl(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), o = EC(e);
  let a = Vs(1);
  t && (r ? ho(r) && (a = mc(r)) : a = mc(e));
  const s = uye(o, n, r) ? yq(o) : Vs(0);
  let l = (i.left + s.x) / a.x, u = (i.top + s.y) / a.y, c = i.width / a.x, f = i.height / a.y;
  if (o) {
    const h = fi(o), m = r && ho(r) ? fi(r) : r;
    let v = h, g = $x(v);
    for (; g && r && m !== v; ) {
      const y = mc(g), w = g.getBoundingClientRect(), C = po(g), S = w.left + (g.clientLeft + parseFloat(C.paddingLeft)) * y.x, N = w.top + (g.clientTop + parseFloat(C.paddingTop)) * y.y;
      l *= y.x, u *= y.y, c *= y.x, f *= y.y, l += S, u += N, v = fi(g), g = $x(v);
    }
  }
  return im({
    width: c,
    height: f,
    x: l,
    y: u
  });
}
function cye(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const o = i === "fixed", a = Ya(r), s = t ? i2(t.floating) : !1;
  if (r === a || s && o)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Vs(1);
  const c = Vs(0), f = Wo(r);
  if ((f || !f && !o) && ((Ed(r) !== "body" || hp(a)) && (l = o2(r)), Wo(r))) {
    const h = Xl(r);
    u = mc(r), c.x = h.x + r.clientLeft, c.y = h.y + r.clientTop;
  }
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - l.scrollLeft * u.x + c.x,
    y: n.y * u.y - l.scrollTop * u.y + c.y
  };
}
function dye(e) {
  return Array.from(e.getClientRects());
}
function bq(e) {
  return Xl(Ya(e)).left + o2(e).scrollLeft;
}
function fye(e) {
  const t = Ya(e), n = o2(e), r = e.ownerDocument.body, i = ui(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = ui(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + bq(e);
  const s = -n.scrollTop;
  return po(r).direction === "rtl" && (a += ui(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: a,
    y: s
  };
}
function hye(e, t) {
  const n = fi(e), r = Ya(e), i = n.visualViewport;
  let o = r.clientWidth, a = r.clientHeight, s = 0, l = 0;
  if (i) {
    o = i.width, a = i.height;
    const u = _C();
    (!u || u && t === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: o,
    height: a,
    x: s,
    y: l
  };
}
function pye(e, t) {
  const n = Xl(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, o = Wo(e) ? mc(e) : Vs(1), a = e.clientWidth * o.x, s = e.clientHeight * o.y, l = i * o.x, u = r * o.y;
  return {
    width: a,
    height: s,
    x: l,
    y: u
  };
}
function rk(e, t, n) {
  let r;
  if (t === "viewport")
    r = hye(e, n);
  else if (t === "document")
    r = fye(Ya(e));
  else if (ho(t))
    r = pye(t, n);
  else {
    const i = yq(e);
    r = {
      ...t,
      x: t.x - i.x,
      y: t.y - i.y
    };
  }
  return im(r);
}
function xq(e, t) {
  const n = zs(e);
  return n === t || !ho(n) || kc(n) ? !1 : po(n).position === "fixed" || xq(n, t);
}
function mye(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Qf(e, [], !1).filter((s) => ho(s) && Ed(s) !== "body"), i = null;
  const o = po(e).position === "fixed";
  let a = o ? zs(e) : e;
  for (; ho(a) && !kc(a); ) {
    const s = po(a), l = SC(a);
    !l && s.position === "fixed" && (i = null), (o ? !l && !i : !l && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || hp(a) && !l && xq(e, a)) ? r = r.filter((c) => c !== a) : i = s, a = zs(a);
  }
  return t.set(e, r), r;
}
function gye(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const a = [...n === "clippingAncestors" ? i2(t) ? [] : mye(t, this._c) : [].concat(n), r], s = a[0], l = a.reduce((u, c) => {
    const f = rk(t, c, i);
    return u.top = ui(f.top, u.top), u.right = Mo(f.right, u.right), u.bottom = Mo(f.bottom, u.bottom), u.left = ui(f.left, u.left), u;
  }, rk(t, s, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function vye(e) {
  const {
    width: t,
    height: n
  } = vq(e);
  return {
    width: t,
    height: n
  };
}
function yye(e, t, n) {
  const r = Wo(t), i = Ya(t), o = n === "fixed", a = Xl(e, !0, o, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Vs(0);
  if (r || !r && !o)
    if ((Ed(t) !== "body" || hp(i)) && (s = o2(t)), r) {
      const f = Xl(t, !0, o, t);
      l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
    } else i && (l.x = bq(i));
  const u = a.left + s.scrollLeft - l.x, c = a.top + s.scrollTop - l.y;
  return {
    x: u,
    y: c,
    width: a.width,
    height: a.height
  };
}
function t3(e) {
  return po(e).position === "static";
}
function ik(e, t) {
  return !Wo(e) || po(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function wq(e, t) {
  const n = fi(e);
  if (i2(e))
    return n;
  if (!Wo(e)) {
    let i = zs(e);
    for (; i && !kc(i); ) {
      if (ho(i) && !t3(i))
        return i;
      i = zs(i);
    }
    return n;
  }
  let r = ik(e, t);
  for (; r && aye(r) && t3(r); )
    r = ik(r, t);
  return r && kc(r) && t3(r) && !SC(r) ? n : r || sye(e) || n;
}
const bye = async function(e) {
  const t = this.getOffsetParent || wq, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: yye(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function xye(e) {
  return po(e).direction === "rtl";
}
const wye = {
  convertOffsetParentRelativeRectToViewportRelativeRect: cye,
  getDocumentElement: Ya,
  getClippingRect: gye,
  getOffsetParent: wq,
  getElementRects: bye,
  getClientRects: dye,
  getDimensions: vye,
  getScale: mc,
  isElement: ho,
  isRTL: xye
};
function Cye(e, t) {
  let n = null, r;
  const i = Ya(e);
  function o() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function a(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), o();
    const {
      left: u,
      top: c,
      width: f,
      height: h
    } = e.getBoundingClientRect();
    if (s || t(), !f || !h)
      return;
    const m = G0(c), v = G0(i.clientWidth - (u + f)), g = G0(i.clientHeight - (c + h)), y = G0(u), C = {
      rootMargin: -m + "px " + -v + "px " + -g + "px " + -y + "px",
      threshold: ui(0, Mo(1, l)) || 1
    };
    let S = !0;
    function N(E) {
      const A = E[0].intersectionRatio;
      if (A !== l) {
        if (!S)
          return a();
        A ? a(!1, A) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      S = !1;
    }
    try {
      n = new IntersectionObserver(N, {
        ...C,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(N, C);
    }
    n.observe(e);
  }
  return a(!0), o;
}
function a2(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, u = EC(e), c = i || o ? [...u ? Qf(u) : [], ...Qf(t)] : [];
  c.forEach((w) => {
    i && w.addEventListener("scroll", n, {
      passive: !0
    }), o && w.addEventListener("resize", n);
  });
  const f = u && s ? Cye(u, n) : null;
  let h = -1, m = null;
  a && (m = new ResizeObserver((w) => {
    let [C] = w;
    C && C.target === u && m && (m.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var S;
      (S = m) == null || S.observe(t);
    })), n();
  }), u && !l && m.observe(u), m.observe(t));
  let v, g = l ? Xl(e) : null;
  l && y();
  function y() {
    const w = Xl(e);
    g && (w.x !== g.x || w.y !== g.y || w.width !== g.width || w.height !== g.height) && n(), g = w, v = requestAnimationFrame(y);
  }
  return n(), () => {
    var w;
    c.forEach((C) => {
      i && C.removeEventListener("scroll", n), o && C.removeEventListener("resize", n);
    }), f == null || f(), (w = m) == null || w.disconnect(), m = null, l && cancelAnimationFrame(v);
  };
}
const Sye = nye, _ye = rye, Eye = Qve, Nye = oye, Aye = eye, ok = Jve, Oye = iye, kye = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: wye,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return Xve(e, t, {
    ...i,
    platform: o
  });
};
var F1 = typeof document < "u" ? $g : Pe;
function om(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!om(e[r], t[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const o = i[r];
      if (!(o === "_owner" && e.$$typeof) && !om(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Cq(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ak(e, t) {
  const n = Cq(e);
  return Math.round(t * n) / n;
}
function sk(e) {
  const t = x.useRef(e);
  return F1(() => {
    t.current = e;
  }), t;
}
function s2(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: o,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: u
  } = e, [c, f] = x.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, m] = x.useState(r);
  om(h, r) || m(r);
  const [v, g] = x.useState(null), [y, w] = x.useState(null), C = x.useCallback((V) => {
    V !== A.current && (A.current = V, g(V));
  }, []), S = x.useCallback((V) => {
    V !== O.current && (O.current = V, w(V));
  }, []), N = o || v, E = a || y, A = x.useRef(null), O = x.useRef(null), T = x.useRef(c), M = l != null, L = sk(l), I = sk(i), j = x.useCallback(() => {
    if (!A.current || !O.current)
      return;
    const V = {
      placement: t,
      strategy: n,
      middleware: h
    };
    I.current && (V.platform = I.current), kye(A.current, O.current, V).then((H) => {
      const Z = {
        ...H,
        isPositioned: !0
      };
      B.current && !om(T.current, Z) && (T.current = Z, go.flushSync(() => {
        f(Z);
      }));
    });
  }, [h, t, n, I]);
  F1(() => {
    u === !1 && T.current.isPositioned && (T.current.isPositioned = !1, f((V) => ({
      ...V,
      isPositioned: !1
    })));
  }, [u]);
  const B = x.useRef(!1);
  F1(() => (B.current = !0, () => {
    B.current = !1;
  }), []), F1(() => {
    if (N && (A.current = N), E && (O.current = E), N && E) {
      if (L.current)
        return L.current(N, E, j);
      j();
    }
  }, [N, E, j, L, M]);
  const q = x.useMemo(() => ({
    reference: A,
    floating: O,
    setReference: C,
    setFloating: S
  }), [C, S]), G = x.useMemo(() => ({
    reference: N,
    floating: E
  }), [N, E]), U = x.useMemo(() => {
    const V = {
      position: n,
      left: 0,
      top: 0
    };
    if (!G.floating)
      return V;
    const H = ak(G.floating, c.x), Z = ak(G.floating, c.y);
    return s ? {
      ...V,
      transform: "translate(" + H + "px, " + Z + "px)",
      ...Cq(G.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: H,
      top: Z
    };
  }, [n, s, G.floating, c.x, c.y]);
  return x.useMemo(() => ({
    ...c,
    update: j,
    refs: q,
    elements: G,
    floatingStyles: U
  }), [c, j, q, G, U]);
}
const Pye = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? ok({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? ok({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
}, l2 = (e, t) => ({
  ...Sye(e),
  options: [e, t]
}), u2 = (e, t) => ({
  ..._ye(e),
  options: [e, t]
}), c2 = (e, t) => ({
  ...Oye(e),
  options: [e, t]
}), d2 = (e, t) => ({
  ...Eye(e),
  options: [e, t]
}), f2 = (e, t) => ({
  ...Nye(e),
  options: [e, t]
}), h2 = (e, t) => ({
  ...Aye(e),
  options: [e, t]
}), p2 = (e, t) => ({
  ...Pye(e),
  options: [e, t]
});
var Tye = "Arrow", Sq = x.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: i = 5, ...o } = e;
  return /* @__PURE__ */ d(
    Re.svg,
    {
      ...o,
      ref: t,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ d("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Sq.displayName = Tye;
var Mye = Sq, NC = "Popper", [_q, Eq] = Ks(NC), [Rye, Nq] = _q(NC), Aq = (e) => {
  const { __scopePopper: t, children: n } = e, [r, i] = x.useState(null);
  return /* @__PURE__ */ d(Rye, { scope: t, anchor: r, onAnchorChange: i, children: n });
};
Aq.displayName = NC;
var Oq = "PopperAnchor", kq = x.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...i } = e, o = Nq(Oq, n), a = x.useRef(null), s = tt(t, a);
    return x.useEffect(() => {
      o.onAnchorChange((r == null ? void 0 : r.current) || a.current);
    }), r ? null : /* @__PURE__ */ d(Re.div, { ...i, ref: s });
  }
);
kq.displayName = Oq;
var AC = "PopperContent", [Dye, Iye] = _q(AC), Pq = x.forwardRef(
  (e, t) => {
    var ge, Ce, ie, ye, ve, Q;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: i = 0,
      align: o = "center",
      alignOffset: a = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: u = [],
      collisionPadding: c = 0,
      sticky: f = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: v,
      ...g
    } = e, y = Nq(AC, n), [w, C] = x.useState(null), S = tt(t, (Oe) => C(Oe)), [N, E] = x.useState(null), A = uu(N), O = (A == null ? void 0 : A.width) ?? 0, T = (A == null ? void 0 : A.height) ?? 0, M = r + (o !== "center" ? "-" + o : ""), L = typeof c == "number" ? c : { top: 0, right: 0, bottom: 0, left: 0, ...c }, I = Array.isArray(u) ? u : [u], j = I.length > 0, B = {
      padding: L,
      boundary: I.filter(Lye),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: j
    }, { refs: q, floatingStyles: G, placement: U, isPositioned: V, middlewareData: H } = s2({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: M,
      whileElementsMounted: (...Oe) => a2(...Oe, {
        animationFrame: m === "always"
      }),
      elements: {
        reference: y.anchor
      },
      middleware: [
        l2({ mainAxis: i + T, alignmentAxis: a }),
        l && u2({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? c2() : void 0,
          ...B
        }),
        l && d2({ ...B }),
        f2({
          ...B,
          apply: ({ elements: Oe, rects: se, availableWidth: nt, availableHeight: ut }) => {
            const { width: st, height: Nn } = se.reference, Dt = Oe.floating.style;
            Dt.setProperty("--radix-popper-available-width", `${nt}px`), Dt.setProperty("--radix-popper-available-height", `${ut}px`), Dt.setProperty("--radix-popper-anchor-width", `${st}px`), Dt.setProperty("--radix-popper-anchor-height", `${Nn}px`);
          }
        }),
        N && p2({ element: N, padding: s }),
        Fye({ arrowWidth: O, arrowHeight: T }),
        h && h2({ strategy: "referenceHidden", ...B })
      ]
    }), [Z, de] = Rq(U), ne = Ie(v);
    He(() => {
      V && (ne == null || ne());
    }, [V, ne]);
    const Y = (ge = H.arrow) == null ? void 0 : ge.x, le = (Ce = H.arrow) == null ? void 0 : Ce.y, be = ((ie = H.arrow) == null ? void 0 : ie.centerOffset) !== 0, [pe, Ee] = x.useState();
    return He(() => {
      w && Ee(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ d(
      "div",
      {
        ref: q.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...G,
          transform: V ? G.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: pe,
          "--radix-popper-transform-origin": [
            (ye = H.transformOrigin) == null ? void 0 : ye.x,
            (ve = H.transformOrigin) == null ? void 0 : ve.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Q = H.hide) == null ? void 0 : Q.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ d(
          Dye,
          {
            scope: n,
            placedSide: Z,
            onArrowChange: E,
            arrowX: Y,
            arrowY: le,
            shouldHideArrow: be,
            children: /* @__PURE__ */ d(
              Re.div,
              {
                "data-side": Z,
                "data-align": de,
                ...g,
                ref: S,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: V ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Pq.displayName = AC;
var Tq = "PopperArrow", $ye = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Mq = x.forwardRef(function(t, n) {
  const { __scopePopper: r, ...i } = t, o = Iye(Tq, r), a = $ye[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ d(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ d(
          Mye,
          {
            ...i,
            ref: n,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Mq.displayName = Tq;
function Lye(e) {
  return e !== null;
}
var Fye = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var y, w, C;
    const { placement: n, rects: r, middlewareData: i } = t, a = ((y = i.arrow) == null ? void 0 : y.centerOffset) !== 0, s = a ? 0 : e.arrowWidth, l = a ? 0 : e.arrowHeight, [u, c] = Rq(n), f = { start: "0%", center: "50%", end: "100%" }[c], h = (((w = i.arrow) == null ? void 0 : w.x) ?? 0) + s / 2, m = (((C = i.arrow) == null ? void 0 : C.y) ?? 0) + l / 2;
    let v = "", g = "";
    return u === "bottom" ? (v = a ? f : `${h}px`, g = `${-l}px`) : u === "top" ? (v = a ? f : `${h}px`, g = `${r.floating.height + l}px`) : u === "right" ? (v = `${-l}px`, g = a ? f : `${m}px`) : u === "left" && (v = `${r.floating.width + l}px`, g = a ? f : `${m}px`), { data: { x: v, y: g } };
  }
});
function Rq(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Bye = Aq, Dq = kq, jye = Pq, Vye = Mq, qye = "Portal", Iq = x.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [i, o] = x.useState(!1);
  He(() => o(!0), []);
  const a = n || i && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return a ? Zo.createPortal(/* @__PURE__ */ d(Re.div, { ...r, ref: t }), a) : null;
});
Iq.displayName = qye;
function zye(e, t) {
  return x.useReducer((n, r) => t[n][r] ?? n, e);
}
var OC = (e) => {
  const { present: t, children: n } = e, r = Wye(t), i = typeof n == "function" ? n({ present: r.isPresent }) : x.Children.only(n), o = tt(r.ref, Hye(i));
  return typeof n == "function" || r.isPresent ? x.cloneElement(i, { ref: o }) : null;
};
OC.displayName = "Presence";
function Wye(e) {
  const [t, n] = x.useState(), r = x.useRef({}), i = x.useRef(e), o = x.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = zye(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return x.useEffect(() => {
    const u = K0(r.current);
    o.current = s === "mounted" ? u : "none";
  }, [s]), He(() => {
    const u = r.current, c = i.current;
    if (c !== e) {
      const h = o.current, m = K0(u);
      e ? l("MOUNT") : m === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(c && h !== m ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, l]), He(() => {
    if (t) {
      let u;
      const c = t.ownerDocument.defaultView ?? window, f = (m) => {
        const g = K0(r.current).includes(m.animationName);
        if (m.target === t && g && (l("ANIMATION_END"), !i.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = c.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, h = (m) => {
        m.target === t && (o.current = K0(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        c.clearTimeout(u), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: x.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function K0(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Hye(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var $q = oC(), n3 = function() {
}, m2 = x.forwardRef(function(e, t) {
  var n = x.useRef(null), r = x.useState({
    onScrollCapture: n3,
    onWheelCapture: n3,
    onTouchMoveCapture: n3
  }), i = r[0], o = r[1], a = e.forwardProps, s = e.children, l = e.className, u = e.removeScrollBar, c = e.enabled, f = e.shards, h = e.sideCar, m = e.noIsolation, v = e.inert, g = e.allowPinchZoom, y = e.as, w = y === void 0 ? "div" : y, C = e.gapMode, S = Qo(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), N = h, E = iC([n, t]), A = Ke(Ke({}, S), i);
  return x.createElement(
    x.Fragment,
    null,
    c && x.createElement(N, { sideCar: $q, removeScrollBar: u, shards: f, noIsolation: m, inert: v, setCallbacks: o, allowPinchZoom: !!g, lockRef: n, gapMode: C }),
    a ? x.cloneElement(x.Children.only(s), Ke(Ke({}, A), { ref: E })) : x.createElement(w, Ke({}, A, { className: l, ref: E }), s)
  );
});
m2.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
m2.classNames = {
  fullWidth: hc,
  zeroRight: fc
};
var Lx = !1;
if (typeof window < "u")
  try {
    var Y0 = Object.defineProperty({}, "passive", {
      get: function() {
        return Lx = !0, !0;
      }
    });
    window.addEventListener("test", Y0, Y0), window.removeEventListener("test", Y0, Y0);
  } catch {
    Lx = !1;
  }
var ju = Lx ? { passive: !1 } : !1, Uye = function(e) {
  return e.tagName === "TEXTAREA";
}, Lq = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Uye(e) && n[t] === "visible")
  );
}, Gye = function(e) {
  return Lq(e, "overflowY");
}, Kye = function(e) {
  return Lq(e, "overflowX");
}, lk = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = Fq(e, r);
    if (i) {
      var o = Bq(e, r), a = o[1], s = o[2];
      if (a > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Yye = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Zye = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Fq = function(e, t) {
  return e === "v" ? Gye(t) : Kye(t);
}, Bq = function(e, t) {
  return e === "v" ? Yye(t) : Zye(t);
}, Xye = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Jye = function(e, t, n, r, i) {
  var o = Xye(e, window.getComputedStyle(t).direction), a = o * r, s = n.target, l = t.contains(s), u = !1, c = a > 0, f = 0, h = 0;
  do {
    var m = Bq(e, s), v = m[0], g = m[1], y = m[2], w = g - y - o * v;
    (v || w) && Fq(e, s) && (f += w, h += v), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (c && Math.abs(f) < 1 || !c && Math.abs(h) < 1) && (u = !0), u;
}, Z0 = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, uk = function(e) {
  return [e.deltaX, e.deltaY];
}, ck = function(e) {
  return e && "current" in e ? e.current : e;
}, Qye = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, ebe = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, tbe = 0, Vu = [];
function nbe(e) {
  var t = x.useRef([]), n = x.useRef([0, 0]), r = x.useRef(), i = x.useState(tbe++)[0], o = x.useState(Qg)[0], a = x.useRef(e);
  x.useEffect(function() {
    a.current = e;
  }, [e]), x.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var g = vd([e.lockRef.current], (e.shards || []).map(ck), !0).filter(Boolean);
      return g.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), g.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = x.useCallback(function(g, y) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !a.current.allowPinchZoom;
    var w = Z0(g), C = n.current, S = "deltaX" in g ? g.deltaX : C[0] - w[0], N = "deltaY" in g ? g.deltaY : C[1] - w[1], E, A = g.target, O = Math.abs(S) > Math.abs(N) ? "h" : "v";
    if ("touches" in g && O === "h" && A.type === "range")
      return !1;
    var T = lk(O, A);
    if (!T)
      return !0;
    if (T ? E = O : (E = O === "v" ? "h" : "v", T = lk(O, A)), !T)
      return !1;
    if (!r.current && "changedTouches" in g && (S || N) && (r.current = E), !E)
      return !0;
    var M = r.current || E;
    return Jye(M, y, g, M === "h" ? S : N);
  }, []), l = x.useCallback(function(g) {
    var y = g;
    if (!(!Vu.length || Vu[Vu.length - 1] !== o)) {
      var w = "deltaY" in y ? uk(y) : Z0(y), C = t.current.filter(function(E) {
        return E.name === y.type && (E.target === y.target || y.target === E.shadowParent) && Qye(E.delta, w);
      })[0];
      if (C && C.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!C) {
        var S = (a.current.shards || []).map(ck).filter(Boolean).filter(function(E) {
          return E.contains(y.target);
        }), N = S.length > 0 ? s(y, S[0]) : !a.current.noIsolation;
        N && y.cancelable && y.preventDefault();
      }
    }
  }, []), u = x.useCallback(function(g, y, w, C) {
    var S = { name: g, delta: y, target: w, should: C, shadowParent: rbe(w) };
    t.current.push(S), setTimeout(function() {
      t.current = t.current.filter(function(N) {
        return N !== S;
      });
    }, 1);
  }, []), c = x.useCallback(function(g) {
    n.current = Z0(g), r.current = void 0;
  }, []), f = x.useCallback(function(g) {
    u(g.type, uk(g), g.target, s(g, e.lockRef.current));
  }, []), h = x.useCallback(function(g) {
    u(g.type, Z0(g), g.target, s(g, e.lockRef.current));
  }, []);
  x.useEffect(function() {
    return Vu.push(o), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, ju), document.addEventListener("touchmove", l, ju), document.addEventListener("touchstart", c, ju), function() {
      Vu = Vu.filter(function(g) {
        return g !== o;
      }), document.removeEventListener("wheel", l, ju), document.removeEventListener("touchmove", l, ju), document.removeEventListener("touchstart", c, ju);
    };
  }, []);
  var m = e.removeScrollBar, v = e.inert;
  return x.createElement(
    x.Fragment,
    null,
    v ? x.createElement(o, { styles: ebe(i) }) : null,
    m ? x.createElement(sC, { gapMode: e.gapMode }) : null
  );
}
function rbe(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const ibe = aC($q, nbe);
var jq = x.forwardRef(function(e, t) {
  return x.createElement(m2, Ke({}, e, { ref: t, sideCar: ibe }));
});
jq.classNames = m2.classNames;
var kC = "Popover", [Vq, qQe] = Nve(kC, [
  Eq
]), pp = Eq(), [obe, Ys] = Vq(kC), qq = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    modal: a = !1
  } = e, s = pp(t), l = x.useRef(null), [u, c] = x.useState(!1), [f = !1, h] = Kt({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ d(Bye, { ...s, children: /* @__PURE__ */ d(
    obe,
    {
      scope: t,
      contentId: ln(),
      triggerRef: l,
      open: f,
      onOpenChange: h,
      onOpenToggle: x.useCallback(() => h((m) => !m), [h]),
      hasCustomAnchor: u,
      onCustomAnchorAdd: x.useCallback(() => c(!0), []),
      onCustomAnchorRemove: x.useCallback(() => c(!1), []),
      modal: a,
      children: n
    }
  ) });
};
qq.displayName = kC;
var zq = "PopoverAnchor", Wq = x.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = Ys(zq, n), o = pp(n), { onCustomAnchorAdd: a, onCustomAnchorRemove: s } = i;
    return x.useEffect(() => (a(), () => s()), [a, s]), /* @__PURE__ */ d(Dq, { ...o, ...r, ref: t });
  }
);
Wq.displayName = zq;
var Hq = "PopoverTrigger", Uq = x.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = Ys(Hq, n), o = pp(n), a = tt(t, i.triggerRef), s = /* @__PURE__ */ d(
      Re.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": Xq(i.open),
        ...r,
        ref: a,
        onClick: Me(e.onClick, i.onOpenToggle)
      }
    );
    return i.hasCustomAnchor ? s : /* @__PURE__ */ d(Dq, { asChild: !0, ...o, children: s });
  }
);
Uq.displayName = Hq;
var PC = "PopoverPortal", [abe, sbe] = Vq(PC, {
  forceMount: void 0
}), Gq = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: i } = e, o = Ys(PC, t);
  return /* @__PURE__ */ d(abe, { scope: t, forceMount: n, children: /* @__PURE__ */ d(OC, { present: n || o.open, children: /* @__PURE__ */ d(Iq, { asChild: !0, container: i, children: r }) }) });
};
Gq.displayName = PC;
var Pc = "PopoverContent", Kq = x.forwardRef(
  (e, t) => {
    const n = sbe(Pc, e.__scopePopover), { forceMount: r = n.forceMount, ...i } = e, o = Ys(Pc, e.__scopePopover);
    return /* @__PURE__ */ d(OC, { present: r || o.open, children: o.modal ? /* @__PURE__ */ d(lbe, { ...i, ref: t }) : /* @__PURE__ */ d(ube, { ...i, ref: t }) });
  }
);
Kq.displayName = Pc;
var lbe = x.forwardRef(
  (e, t) => {
    const n = Ys(Pc, e.__scopePopover), r = x.useRef(null), i = tt(t, r), o = x.useRef(!1);
    return x.useEffect(() => {
      const a = r.current;
      if (a) return yd(a);
    }, []), /* @__PURE__ */ d(jq, { as: Nc, allowPinchZoom: !0, children: /* @__PURE__ */ d(
      Yq,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Me(e.onCloseAutoFocus, (a) => {
          var s;
          a.preventDefault(), o.current || (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: Me(
          e.onPointerDownOutside,
          (a) => {
            const s = a.detail.originalEvent, l = s.button === 0 && s.ctrlKey === !0, u = s.button === 2 || l;
            o.current = u;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: Me(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), ube = x.forwardRef(
  (e, t) => {
    const n = Ys(Pc, e.__scopePopover), r = x.useRef(!1), i = x.useRef(!1);
    return /* @__PURE__ */ d(
      Yq,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var a, s;
          (a = e.onCloseAutoFocus) == null || a.call(e, o), o.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), o.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (o) => {
          var l, u;
          (l = e.onInteractOutside) == null || l.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const a = o.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(a)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
        }
      }
    );
  }
), Yq = x.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: i,
      onCloseAutoFocus: o,
      disableOutsidePointerEvents: a,
      onEscapeKeyDown: s,
      onPointerDownOutside: l,
      onFocusOutside: u,
      onInteractOutside: c,
      ...f
    } = e, h = Ys(Pc, n), m = pp(n);
    return Ive(), /* @__PURE__ */ d(
      bC,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: i,
        onUnmountAutoFocus: o,
        children: /* @__PURE__ */ d(
          dq,
          {
            asChild: !0,
            disableOutsidePointerEvents: a,
            onInteractOutside: c,
            onEscapeKeyDown: s,
            onPointerDownOutside: l,
            onFocusOutside: u,
            onDismiss: () => h.onOpenChange(!1),
            children: /* @__PURE__ */ d(
              jye,
              {
                "data-state": Xq(h.open),
                role: "dialog",
                id: h.contentId,
                ...m,
                ...f,
                ref: t,
                style: {
                  ...f.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), Zq = "PopoverClose", cbe = x.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = Ys(Zq, n);
    return /* @__PURE__ */ d(
      Re.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: Me(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
cbe.displayName = Zq;
var dbe = "PopoverArrow", fbe = x.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = pp(n);
    return /* @__PURE__ */ d(Vye, { ...i, ...r, ref: t });
  }
);
fbe.displayName = dbe;
function Xq(e) {
  return e ? "open" : "closed";
}
var hbe = qq, pbe = Wq, mbe = Uq, gbe = Gq, Jq = Kq;
const g2 = hbe, v2 = mbe, zQe = pbe, mp = te(
  ({ className: e, align: t = "center", sideOffset: n = 4, usePortal: r = !0, ...i }, o) => {
    const a = () => /* @__PURE__ */ d(
      Jq,
      {
        ref: o,
        align: t,
        sideOffset: n,
        className: z(
          "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 outline-hidden z-50 w-72 rounded-md border p-4 shadow-md",
          e
        ),
        ...i
      }
    );
    return r ? /* @__PURE__ */ d(gbe, { children: a() }) : a();
  }
);
mp.displayName = Jq.displayName;
function vbe({
  className: e,
  onChange: t,
  dateRange: n
}) {
  const r = /* @__PURE__ */ new Date();
  r.setHours(23, 59, 59, 999);
  const i = (a) => {
    const s = /* @__PURE__ */ new Date();
    s.setHours(23, 59, 59, 999);
    const l = gn(s, -a + 1);
    l.setHours(0, 0, 0, 0), t({
      from: l,
      to: s
    });
  }, o = () => {
    n && (n != null && n.from) && (n != null && n.to) && t({
      from: n.from,
      to: n.to
    });
  };
  return /* @__PURE__ */ d("div", { className: z("grid gap-2", e), children: /* @__PURE__ */ k("div", { className: "flex gap-2", children: [
    /* @__PURE__ */ k(g2, { children: [
      /* @__PURE__ */ d(v2, { asChild: !0, children: /* @__PURE__ */ k(
        et,
        {
          "data-testid": "date-picker",
          id: "date",
          variant: "outline",
          className: z(
            "w-[300px] justify-start text-left font-normal",
            !n && "text-muted-foreground"
          ),
          children: [
            /* @__PURE__ */ d(pB, {}),
            n != null && n.from ? n.to ? /* @__PURE__ */ k(xe, { children: [
              sn(n.from, "LLL dd, y"),
              " -",
              " ",
              sn(n.to, "LLL dd, y")
            ] }) : sn(n.from, "LLL dd, y") : /* @__PURE__ */ d("span", { children: "Pick a date" })
          ]
        }
      ) }),
      /* @__PURE__ */ d(mp, { className: "w-auto p-4", align: "start", children: /* @__PURE__ */ k("div", { className: "flex flex-col gap-4", children: [
        /* @__PURE__ */ k("div", { className: "flex flex-wrap gap-2", children: [
          /* @__PURE__ */ d(
            et,
            {
              "data-testid": "today",
              onClick: () => i(1),
              size: "xs",
              variant: "outline",
              children: "Today"
            }
          ),
          /* @__PURE__ */ d(
            et,
            {
              "data-testid": "yesterday",
              onClick: () => {
                const a = /* @__PURE__ */ new Date(), s = gn(a, -1);
                s.setHours(0, 0, 0, 0);
                const l = gn(a, -1);
                l.setHours(23, 59, 59, 999), t({
                  from: s,
                  to: l
                });
              },
              size: "xs",
              variant: "outline",
              children: "Yesterday"
            }
          ),
          /* @__PURE__ */ d(
            et,
            {
              "data-testid": "this-week",
              onClick: () => {
                const a = /* @__PURE__ */ new Date(), s = so(a), l = gn(a, -1);
                l.setHours(23, 59, 59, 999), t({
                  from: s,
                  to: l
                });
              },
              size: "xs",
              variant: "outline",
              children: "This week"
            }
          ),
          /* @__PURE__ */ d(
            et,
            {
              "data-testid": "last-week",
              onClick: () => i(7),
              size: "xs",
              variant: "outline",
              children: "Last Week"
            }
          ),
          /* @__PURE__ */ d(
            et,
            {
              "data-testid": "last-month",
              onClick: () => i(30),
              size: "xs",
              variant: "outline",
              children: "Last Month"
            }
          ),
          /* @__PURE__ */ d(
            et,
            {
              "data-testid": "last-3-months",
              onClick: () => i(90),
              size: "xs",
              variant: "outline",
              children: "Last 3 Months"
            }
          ),
          /* @__PURE__ */ d(
            et,
            {
              "data-testid": "last-12-months",
              onClick: () => i(365),
              size: "xs",
              variant: "outline",
              children: "Last 12 Months"
            }
          )
        ] }),
        /* @__PURE__ */ d(
          eC,
          {
            initialFocus: !0,
            mode: "range",
            defaultMonth: n == null ? void 0 : n.from,
            selected: n,
            onSelect: (a) => {
              t(a);
            },
            numberOfMonths: 2,
            disabled: { after: r },
            toDate: r
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ d(
      et,
      {
        "data-testid": "update-date-range",
        disabled: !n || !n.from || !n.to,
        onClick: o,
        children: "Update"
      }
    )
  ] }) });
}
function ybe(e, t) {
  const n = x.createContext(t), r = (o) => {
    const { children: a, ...s } = o, l = x.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ d(n.Provider, { value: l, children: a });
  };
  r.displayName = e + "Provider";
  function i(o) {
    const a = x.useContext(n);
    if (a) return a;
    if (t !== void 0) return t;
    throw new Error(`\`${o}\` must be used within \`${e}\``);
  }
  return [r, i];
}
function bbe(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = x.createContext(a), l = n.length;
    n = [...n, a];
    const u = (f) => {
      var w;
      const { scope: h, children: m, ...v } = f, g = ((w = h == null ? void 0 : h[e]) == null ? void 0 : w[l]) || s, y = x.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ d(g.Provider, { value: y, children: m });
    };
    u.displayName = o + "Provider";
    function c(f, h) {
      var g;
      const m = ((g = h == null ? void 0 : h[e]) == null ? void 0 : g[l]) || s, v = x.useContext(m);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, c];
  }
  const i = () => {
    const o = n.map((a) => x.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return x.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, xbe(i, ...t)];
}
function xbe(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return x.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var wbe = "DismissableLayer", Fx = "dismissableLayer.update", Cbe = "dismissableLayer.pointerDownOutside", Sbe = "dismissableLayer.focusOutside", dk, Qq = x.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), ez = x.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = e, u = x.useContext(Qq), [c, f] = x.useState(null), h = (c == null ? void 0 : c.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = x.useState({}), v = tt(t, (O) => f(O)), g = Array.from(u.layers), [y] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), w = g.indexOf(y), C = c ? g.indexOf(c) : -1, S = u.layersWithOutsidePointerEventsDisabled.size > 0, N = C >= w, E = Nbe((O) => {
      const T = O.target, M = [...u.branches].some((L) => L.contains(T));
      !N || M || (i == null || i(O), a == null || a(O), O.defaultPrevented || s == null || s());
    }, h), A = Abe((O) => {
      const T = O.target;
      [...u.branches].some((L) => L.contains(T)) || (o == null || o(O), a == null || a(O), O.defaultPrevented || s == null || s());
    }, h);
    return lu((O) => {
      C === u.layers.size - 1 && (r == null || r(O), !O.defaultPrevented && s && (O.preventDefault(), s()));
    }, h), x.useEffect(() => {
      if (c)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (dk = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(c)), u.layers.add(c), fk(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = dk);
        };
    }, [c, h, n, u]), x.useEffect(() => () => {
      c && (u.layers.delete(c), u.layersWithOutsidePointerEventsDisabled.delete(c), fk());
    }, [c, u]), x.useEffect(() => {
      const O = () => m({});
      return document.addEventListener(Fx, O), () => document.removeEventListener(Fx, O);
    }, []), /* @__PURE__ */ d(
      Re.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: S ? N ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Me(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: Me(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: Me(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
ez.displayName = wbe;
var _be = "DismissableLayerBranch", Ebe = x.forwardRef((e, t) => {
  const n = x.useContext(Qq), r = x.useRef(null), i = tt(t, r);
  return x.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ d(Re.div, { ...e, ref: i });
});
Ebe.displayName = _be;
function Nbe(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ie(e), r = x.useRef(!1), i = x.useRef(() => {
  });
  return x.useEffect(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          tz(
            Cbe,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = l, t.addEventListener("click", i.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Abe(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ie(e), r = x.useRef(!1);
  return x.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && tz(Sbe, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function fk() {
  const e = new CustomEvent(Fx);
  document.dispatchEvent(e);
}
function tz(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? qg(i, o) : i.dispatchEvent(o);
}
var Obe = "Portal", nz = x.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [i, o] = x.useState(!1);
  He(() => o(!0), []);
  const a = n || i && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return a ? Zo.createPortal(/* @__PURE__ */ d(Re.div, { ...r, ref: t }), a) : null;
});
nz.displayName = Obe;
function kbe(e, t) {
  return x.useReducer((n, r) => t[n][r] ?? n, e);
}
var y2 = (e) => {
  const { present: t, children: n } = e, r = Pbe(t), i = typeof n == "function" ? n({ present: r.isPresent }) : x.Children.only(n), o = tt(r.ref, Tbe(i));
  return typeof n == "function" || r.isPresent ? x.cloneElement(i, { ref: o }) : null;
};
y2.displayName = "Presence";
function Pbe(e) {
  const [t, n] = x.useState(), r = x.useRef({}), i = x.useRef(e), o = x.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = kbe(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return x.useEffect(() => {
    const u = X0(r.current);
    o.current = s === "mounted" ? u : "none";
  }, [s]), He(() => {
    const u = r.current, c = i.current;
    if (c !== e) {
      const h = o.current, m = X0(u);
      e ? l("MOUNT") : m === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(c && h !== m ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, l]), He(() => {
    if (t) {
      let u;
      const c = t.ownerDocument.defaultView ?? window, f = (m) => {
        const g = X0(r.current).includes(m.animationName);
        if (m.target === t && g && (l("ANIMATION_END"), !i.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = c.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, h = (m) => {
        m.target === t && (o.current = X0(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        c.clearTimeout(u), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: x.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function X0(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Tbe(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var r3 = 0;
function Mbe() {
  x.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? hk()), document.body.insertAdjacentElement("beforeend", e[1] ?? hk()), r3++, () => {
      r3 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), r3--;
    };
  }, []);
}
function hk() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var rz = oC(), i3 = function() {
}, b2 = x.forwardRef(function(e, t) {
  var n = x.useRef(null), r = x.useState({
    onScrollCapture: i3,
    onWheelCapture: i3,
    onTouchMoveCapture: i3
  }), i = r[0], o = r[1], a = e.forwardProps, s = e.children, l = e.className, u = e.removeScrollBar, c = e.enabled, f = e.shards, h = e.sideCar, m = e.noIsolation, v = e.inert, g = e.allowPinchZoom, y = e.as, w = y === void 0 ? "div" : y, C = e.gapMode, S = Qo(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), N = h, E = iC([n, t]), A = Ke(Ke({}, S), i);
  return x.createElement(
    x.Fragment,
    null,
    c && x.createElement(N, { sideCar: rz, removeScrollBar: u, shards: f, noIsolation: m, inert: v, setCallbacks: o, allowPinchZoom: !!g, lockRef: n, gapMode: C }),
    a ? x.cloneElement(x.Children.only(s), Ke(Ke({}, A), { ref: E })) : x.createElement(w, Ke({}, A, { className: l, ref: E }), s)
  );
});
b2.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
b2.classNames = {
  fullWidth: hc,
  zeroRight: fc
};
var Bx = !1;
if (typeof window < "u")
  try {
    var J0 = Object.defineProperty({}, "passive", {
      get: function() {
        return Bx = !0, !0;
      }
    });
    window.addEventListener("test", J0, J0), window.removeEventListener("test", J0, J0);
  } catch {
    Bx = !1;
  }
var qu = Bx ? { passive: !1 } : !1, Rbe = function(e) {
  return e.tagName === "TEXTAREA";
}, iz = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Rbe(e) && n[t] === "visible")
  );
}, Dbe = function(e) {
  return iz(e, "overflowY");
}, Ibe = function(e) {
  return iz(e, "overflowX");
}, pk = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = oz(e, r);
    if (i) {
      var o = az(e, r), a = o[1], s = o[2];
      if (a > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, $be = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Lbe = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, oz = function(e, t) {
  return e === "v" ? Dbe(t) : Ibe(t);
}, az = function(e, t) {
  return e === "v" ? $be(t) : Lbe(t);
}, Fbe = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Bbe = function(e, t, n, r, i) {
  var o = Fbe(e, window.getComputedStyle(t).direction), a = o * r, s = n.target, l = t.contains(s), u = !1, c = a > 0, f = 0, h = 0;
  do {
    var m = az(e, s), v = m[0], g = m[1], y = m[2], w = g - y - o * v;
    (v || w) && oz(e, s) && (f += w, h += v), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (c && Math.abs(f) < 1 || !c && Math.abs(h) < 1) && (u = !0), u;
}, Q0 = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, mk = function(e) {
  return [e.deltaX, e.deltaY];
}, gk = function(e) {
  return e && "current" in e ? e.current : e;
}, jbe = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Vbe = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, qbe = 0, zu = [];
function zbe(e) {
  var t = x.useRef([]), n = x.useRef([0, 0]), r = x.useRef(), i = x.useState(qbe++)[0], o = x.useState(Qg)[0], a = x.useRef(e);
  x.useEffect(function() {
    a.current = e;
  }, [e]), x.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var g = vd([e.lockRef.current], (e.shards || []).map(gk), !0).filter(Boolean);
      return g.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), g.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = x.useCallback(function(g, y) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !a.current.allowPinchZoom;
    var w = Q0(g), C = n.current, S = "deltaX" in g ? g.deltaX : C[0] - w[0], N = "deltaY" in g ? g.deltaY : C[1] - w[1], E, A = g.target, O = Math.abs(S) > Math.abs(N) ? "h" : "v";
    if ("touches" in g && O === "h" && A.type === "range")
      return !1;
    var T = pk(O, A);
    if (!T)
      return !0;
    if (T ? E = O : (E = O === "v" ? "h" : "v", T = pk(O, A)), !T)
      return !1;
    if (!r.current && "changedTouches" in g && (S || N) && (r.current = E), !E)
      return !0;
    var M = r.current || E;
    return Bbe(M, y, g, M === "h" ? S : N);
  }, []), l = x.useCallback(function(g) {
    var y = g;
    if (!(!zu.length || zu[zu.length - 1] !== o)) {
      var w = "deltaY" in y ? mk(y) : Q0(y), C = t.current.filter(function(E) {
        return E.name === y.type && (E.target === y.target || y.target === E.shadowParent) && jbe(E.delta, w);
      })[0];
      if (C && C.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!C) {
        var S = (a.current.shards || []).map(gk).filter(Boolean).filter(function(E) {
          return E.contains(y.target);
        }), N = S.length > 0 ? s(y, S[0]) : !a.current.noIsolation;
        N && y.cancelable && y.preventDefault();
      }
    }
  }, []), u = x.useCallback(function(g, y, w, C) {
    var S = { name: g, delta: y, target: w, should: C, shadowParent: Wbe(w) };
    t.current.push(S), setTimeout(function() {
      t.current = t.current.filter(function(N) {
        return N !== S;
      });
    }, 1);
  }, []), c = x.useCallback(function(g) {
    n.current = Q0(g), r.current = void 0;
  }, []), f = x.useCallback(function(g) {
    u(g.type, mk(g), g.target, s(g, e.lockRef.current));
  }, []), h = x.useCallback(function(g) {
    u(g.type, Q0(g), g.target, s(g, e.lockRef.current));
  }, []);
  x.useEffect(function() {
    return zu.push(o), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, qu), document.addEventListener("touchmove", l, qu), document.addEventListener("touchstart", c, qu), function() {
      zu = zu.filter(function(g) {
        return g !== o;
      }), document.removeEventListener("wheel", l, qu), document.removeEventListener("touchmove", l, qu), document.removeEventListener("touchstart", c, qu);
    };
  }, []);
  var m = e.removeScrollBar, v = e.inert;
  return x.createElement(
    x.Fragment,
    null,
    v ? x.createElement(o, { styles: Vbe(i) }) : null,
    m ? x.createElement(sC, { gapMode: e.gapMode }) : null
  );
}
function Wbe(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Hbe = aC(rz, zbe);
var sz = x.forwardRef(function(e, t) {
  return x.createElement(b2, Ke({}, e, { ref: t, sideCar: Hbe }));
});
sz.classNames = b2.classNames;
var TC = "Dialog", [lz, WQe] = bbe(TC), [Ube, yo] = lz(TC), uz = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    modal: a = !0
  } = e, s = x.useRef(null), l = x.useRef(null), [u = !1, c] = Kt({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ d(
    Ube,
    {
      scope: t,
      triggerRef: s,
      contentRef: l,
      contentId: ln(),
      titleId: ln(),
      descriptionId: ln(),
      open: u,
      onOpenChange: c,
      onOpenToggle: x.useCallback(() => c((f) => !f), [c]),
      modal: a,
      children: n
    }
  );
};
uz.displayName = TC;
var cz = "DialogTrigger", dz = x.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = yo(cz, n), o = tt(t, i.triggerRef);
    return /* @__PURE__ */ d(
      Re.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": DC(i.open),
        ...r,
        ref: o,
        onClick: Me(e.onClick, i.onOpenToggle)
      }
    );
  }
);
dz.displayName = cz;
var MC = "DialogPortal", [Gbe, fz] = lz(MC, {
  forceMount: void 0
}), hz = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: i } = e, o = yo(MC, t);
  return /* @__PURE__ */ d(Gbe, { scope: t, forceMount: n, children: x.Children.map(r, (a) => /* @__PURE__ */ d(y2, { present: n || o.open, children: /* @__PURE__ */ d(nz, { asChild: !0, container: i, children: a }) })) });
};
hz.displayName = MC;
var am = "DialogOverlay", pz = x.forwardRef(
  (e, t) => {
    const n = fz(am, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = yo(am, e.__scopeDialog);
    return o.modal ? /* @__PURE__ */ d(y2, { present: r || o.open, children: /* @__PURE__ */ d(Kbe, { ...i, ref: t }) }) : null;
  }
);
pz.displayName = am;
var Kbe = x.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = yo(am, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ d(sz, { as: Nc, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ d(
        Re.div,
        {
          "data-state": DC(i.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Jl = "DialogContent", mz = x.forwardRef(
  (e, t) => {
    const n = fz(Jl, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = yo(Jl, e.__scopeDialog);
    return /* @__PURE__ */ d(y2, { present: r || o.open, children: o.modal ? /* @__PURE__ */ d(Ybe, { ...i, ref: t }) : /* @__PURE__ */ d(Zbe, { ...i, ref: t }) });
  }
);
mz.displayName = Jl;
var Ybe = x.forwardRef(
  (e, t) => {
    const n = yo(Jl, e.__scopeDialog), r = x.useRef(null), i = tt(t, n.contentRef, r);
    return x.useEffect(() => {
      const o = r.current;
      if (o) return yd(o);
    }, []), /* @__PURE__ */ d(
      gz,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Me(e.onCloseAutoFocus, (o) => {
          var a;
          o.preventDefault(), (a = n.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: Me(e.onPointerDownOutside, (o) => {
          const a = o.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || s) && o.preventDefault();
        }),
        onFocusOutside: Me(
          e.onFocusOutside,
          (o) => o.preventDefault()
        )
      }
    );
  }
), Zbe = x.forwardRef(
  (e, t) => {
    const n = yo(Jl, e.__scopeDialog), r = x.useRef(!1), i = x.useRef(!1);
    return /* @__PURE__ */ d(
      gz,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var a, s;
          (a = e.onCloseAutoFocus) == null || a.call(e, o), o.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), o.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (o) => {
          var l, u;
          (l = e.onInteractOutside) == null || l.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const a = o.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(a)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
        }
      }
    );
  }
), gz = x.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, ...a } = e, s = yo(Jl, n), l = x.useRef(null), u = tt(t, l);
    return Mbe(), /* @__PURE__ */ k(xe, { children: [
      /* @__PURE__ */ d(
        bC,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: o,
          children: /* @__PURE__ */ d(
            ez,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": DC(s.open),
              ...a,
              ref: u,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ k(xe, { children: [
        /* @__PURE__ */ d(Xbe, { titleId: s.titleId }),
        /* @__PURE__ */ d(Qbe, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), RC = "DialogTitle", vz = x.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = yo(RC, n);
    return /* @__PURE__ */ d(Re.h2, { id: i.titleId, ...r, ref: t });
  }
);
vz.displayName = RC;
var yz = "DialogDescription", bz = x.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = yo(yz, n);
    return /* @__PURE__ */ d(Re.p, { id: i.descriptionId, ...r, ref: t });
  }
);
bz.displayName = yz;
var xz = "DialogClose", wz = x.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = yo(xz, n);
    return /* @__PURE__ */ d(
      Re.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: Me(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
wz.displayName = xz;
function DC(e) {
  return e ? "open" : "closed";
}
var Cz = "DialogTitleWarning", [HQe, Sz] = ybe(Cz, {
  contentName: Jl,
  titleName: RC,
  docsSlug: "dialog"
}), Xbe = ({ titleId: e }) => {
  const t = Sz(Cz), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return x.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, Jbe = "DialogDescriptionWarning", Qbe = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Sz(Jbe).contentName}}.`;
  return x.useEffect(() => {
    var o;
    const i = (o = e.current) == null ? void 0 : o.getAttribute("aria-describedby");
    t && i && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, _z = uz, Ez = dz, Nz = hz, x2 = pz, w2 = mz, gp = vz, C2 = bz, S2 = wz;
const _2 = _z, UQe = Ez, e3e = Nz, GQe = S2, Az = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  x2,
  {
    ref: n,
    className: z(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/25",
      e
    ),
    ...t
  }
));
Az.displayName = x2.displayName;
const vp = te(
  ({
    className: e,
    children: t,
    disableAnimation: n,
    hideCloseButton: r,
    portalContainer: i,
    ...o
  }, a) => /* @__PURE__ */ k(e3e, { container: i, children: [
    /* @__PURE__ */ d(Az, {}),
    /* @__PURE__ */ k(
      w2,
      {
        ref: a,
        className: z(
          "bg-background border-border fixed left-[50%] top-[50%] z-50 grid translate-x-[-50%] translate-y-[-50%] gap-4 border shadow-lg sm:rounded-lg",
          !n && "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-top-[48%] duration-200",
          "w-full max-w-[calc(100%-2.25rem)] p-6 md:max-w-lg",
          e
        ),
        ...o,
        children: [
          t,
          r ? null : /* @__PURE__ */ k(S2, { className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground rounded-xs focus:outline-hidden absolute right-4 top-4 opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none", children: [
            /* @__PURE__ */ d(np, { className: "h-4 w-4" }),
            /* @__PURE__ */ d("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] })
);
vp.displayName = w2.displayName;
const t3e = ({
  className: e,
  ...t
}) => /* @__PURE__ */ d(
  "div",
  {
    className: z(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      e
    ),
    ...t
  }
);
t3e.displayName = "DialogHeader";
const E2 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ d(
  "div",
  {
    className: z(
      "flex flex-col-reverse gap-3 sm:flex-row sm:justify-end",
      e
    ),
    ...t
  }
);
E2.displayName = "DialogFooter";
const N2 = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  gp,
  {
    ref: n,
    className: z("text-headingxl leading-none tracking-tight", e),
    ...t
  }
));
N2.displayName = gp.displayName;
const n3e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  C2,
  {
    ref: n,
    className: z("text-muted-foreground text-bodysm", e),
    ...t
  }
));
n3e.displayName = C2.displayName;
const r3e = "data:image/svg+xml,%3csvg%20width='63'%20height='63'%20viewBox='0%200%2063%2063'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M43.6098%2014.4513L40.9935%2017.0676L39.3672%2015.4413L46.2968%208.51164L47.9232%2010.138L45.3069%2012.7543L52.5901%2020.0375L50.893%2021.7345L43.6098%2014.4513Z'%20fill='black'%20fill-opacity='0.04'/%3e%3cpath%20d='M32.8652%2021.9434L38.8049%2016.0037L40.4313%2017.63L36.1886%2021.8726L38.3807%2024.0647L41.8455%2020.5999L43.4718%2022.2262L40.007%2025.691L43.4718%2029.1558L41.7748%2030.8529L32.8652%2021.9434Z'%20fill='black'%20fill-opacity='0.04'/%3e%3cpath%20d='M27.1335%2027.6754L28.6891%2026.1197L40.922%2031.7059L39.1543%2033.4737L36.6794%2032.2716L33.2853%2035.6657L34.4874%2038.1406L32.7196%2039.9083L27.1335%2027.6754ZM34.5581%2031.2816L30.174%2029.1603L32.2953%2033.5444L34.5581%2031.2816Z'%20fill='black'%20fill-opacity='0.04'/%3e%3cpath%20d='M16.8862%2037.9223L20.4218%2034.3868C20.846%2033.9625%2021.3127%2033.6467%2021.8218%2033.4392C22.331%2033.213%2022.8448%2033.0951%2023.3633%2033.0857C23.8819%2033.0763%2024.3863%2033.1658%2024.8765%2033.3544C25.3574%2033.5335%2025.7816%2033.8069%2026.1493%2034.1746C26.649%2034.6743%2026.9649%2035.1882%2027.0969%2035.7161C27.2288%2036.2441%2027.276%2036.7344%2027.2383%2037.1869C27.2006%2037.7149%2027.0733%2038.2193%2026.8564%2038.7001L32.5133%2040.1143L30.6041%2042.0235L25.5129%2040.6093L24.2401%2041.8821L27.4928%2045.1348L25.7958%2046.8318L16.8862%2037.9223ZM24.4523%2038.4173C24.8105%2038.059%2024.9944%2037.6395%2025.0038%2037.1586C25.0038%2036.6684%2024.8435%2036.263%2024.523%2035.9424C24.2024%2035.6218%2023.8017%2035.4663%2023.3209%2035.4757C22.8306%2035.4757%2022.4064%2035.6548%2022.0481%2036.0131L20.2096%2037.8516L22.6138%2040.2558L24.4523%2038.4173Z'%20fill='black'%20fill-opacity='0.04'/%3e%3cpath%20d='M8.32373%2046.4849L11.1522%2043.6565C11.7367%2043.072%2012.4155%2042.6383%2013.1886%2042.3554C13.9523%2042.0632%2014.7395%2041.917%2015.5504%2041.917C16.3612%2041.917%2017.1531%2042.0679%2017.9262%2042.3696C18.6993%2042.6713%2019.3876%2043.1238%2019.991%2043.7272C20.5944%2044.3306%2021.0469%2045.0189%2021.3486%2045.792C21.6503%2046.5651%2021.8012%2047.357%2021.8012%2048.1678C21.8012%2048.9787%2021.6598%2049.7706%2021.3769%2050.5437C21.0847%2051.3074%2020.6462%2051.9815%2020.0617%2052.566L17.2333%2055.3945L8.32373%2046.4849ZM18.4354%2050.9397C18.7842%2050.5909%2019.0435%2050.1807%2019.2132%2049.7093C19.3923%2049.2285%2019.4772%2048.7382%2019.4677%2048.2385C19.4677%2047.7294%2019.3687%2047.2345%2019.1707%2046.7536C18.9728%2046.2539%2018.6805%2045.8108%2018.2939%2045.4243C17.9074%2045.0377%2017.469%2044.7502%2016.9787%2044.5616C16.4885%2044.3542%2015.9888%2044.2505%2015.4797%2044.2505C14.98%2044.241%2014.4897%2044.3259%2014.0089%2044.505C13.5375%2044.6747%2013.1273%2044.934%2012.7785%2045.2828L11.6471%2046.4142L17.304%2052.0711L18.4354%2050.9397Z'%20fill='black'%20fill-opacity='0.04'/%3e%3c/svg%3e";
function i3e() {
  return /* @__PURE__ */ d(
    "div",
    {
      className: "absolute inset-0",
      style: {
        backgroundImage: `url("${r3e}")`,
        backgroundSize: "100px 100px",
        pointerEvents: "none"
      }
    }
  );
}
function sm(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function vk(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Oz(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = vk(i, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : vk(e[i], null);
        }
      };
  };
}
function o3e(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = x.createContext(a), l = n.length;
    n = [...n, a];
    const u = (f) => {
      var w;
      const { scope: h, children: m, ...v } = f, g = ((w = h == null ? void 0 : h[e]) == null ? void 0 : w[l]) || s, y = x.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ d(g.Provider, { value: y, children: m });
    };
    u.displayName = o + "Provider";
    function c(f, h) {
      var g;
      const m = ((g = h == null ? void 0 : h[e]) == null ? void 0 : g[l]) || s, v = x.useContext(m);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, c];
  }
  const i = () => {
    const o = n.map((a) => x.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return x.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, a3e(i, ...t)];
}
function a3e(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return x.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var kz = x.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = x.Children.toArray(n), o = i.find(l3e);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? x.Children.count(a) > 1 ? x.Children.only(null) : x.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ d(jx, { ...r, ref: t, children: x.isValidElement(a) ? x.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ d(jx, { ...r, ref: t, children: n });
});
kz.displayName = "Slot";
var jx = x.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (x.isValidElement(n)) {
    const i = c3e(n);
    return x.cloneElement(n, {
      ...u3e(r, n.props),
      // @ts-ignore
      ref: t ? Oz(t, i) : i
    });
  }
  return x.Children.count(n) > 1 ? x.Children.only(null) : null;
});
jx.displayName = "SlotClone";
var s3e = ({ children: e }) => /* @__PURE__ */ d(xe, { children: e });
function l3e(e) {
  return x.isValidElement(e) && e.type === s3e;
}
function u3e(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function c3e(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var d3e = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], f3e = d3e.reduce((e, t) => {
  const n = x.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? kz : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function At(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function A2(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = x.createContext(a), l = n.length;
    n = [...n, a];
    const u = (f) => {
      var w;
      const { scope: h, children: m, ...v } = f, g = ((w = h == null ? void 0 : h[e]) == null ? void 0 : w[l]) || s, y = x.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ d(g.Provider, { value: y, children: m });
    };
    u.displayName = o + "Provider";
    function c(f, h) {
      var g;
      const m = ((g = h == null ? void 0 : h[e]) == null ? void 0 : g[l]) || s, v = x.useContext(m);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, c];
  }
  const i = () => {
    const o = n.map((a) => x.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return x.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, h3e(i, ...t)];
}
function h3e(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return x.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function yk(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function IC(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = yk(i, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : yk(e[i], null);
        }
      };
  };
}
function Kr(...e) {
  return x.useCallback(IC(...e), e);
}
var eh = x.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = x.Children.toArray(n), o = i.find(m3e);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? x.Children.count(a) > 1 ? x.Children.only(null) : x.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ d(Vx, { ...r, ref: t, children: x.isValidElement(a) ? x.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ d(Vx, { ...r, ref: t, children: n });
});
eh.displayName = "Slot";
var Vx = x.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (x.isValidElement(n)) {
    const i = v3e(n);
    return x.cloneElement(n, {
      ...g3e(r, n.props),
      // @ts-ignore
      ref: t ? IC(t, i) : i
    });
  }
  return x.Children.count(n) > 1 ? x.Children.only(null) : null;
});
Vx.displayName = "SlotClone";
var p3e = ({ children: e }) => /* @__PURE__ */ d(xe, { children: e });
function m3e(e) {
  return x.isValidElement(e) && e.type === p3e;
}
function g3e(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function v3e(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Pz(e) {
  const t = e + "CollectionProvider", [n, r] = A2(t), [i, o] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (m) => {
    const { scope: v, children: g } = m, y = F.useRef(null), w = F.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ d(i, { scope: v, itemMap: w, collectionRef: y, children: g });
  };
  a.displayName = t;
  const s = e + "CollectionSlot", l = F.forwardRef(
    (m, v) => {
      const { scope: g, children: y } = m, w = o(s, g), C = Kr(v, w.collectionRef);
      return /* @__PURE__ */ d(eh, { ref: C, children: y });
    }
  );
  l.displayName = s;
  const u = e + "CollectionItemSlot", c = "data-radix-collection-item", f = F.forwardRef(
    (m, v) => {
      const { scope: g, children: y, ...w } = m, C = F.useRef(null), S = Kr(v, C), N = o(u, g);
      return F.useEffect(() => (N.itemMap.set(C, { ref: C, ...w }), () => void N.itemMap.delete(C))), /* @__PURE__ */ d(eh, { [c]: "", ref: S, children: y });
    }
  );
  f.displayName = u;
  function h(m) {
    const v = o(e + "CollectionConsumer", m);
    return F.useCallback(() => {
      const y = v.collectionRef.current;
      if (!y) return [];
      const w = Array.from(y.querySelectorAll(`[${c}]`));
      return Array.from(v.itemMap.values()).sort(
        (N, E) => w.indexOf(N.ref.current) - w.indexOf(E.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: a, Slot: l, ItemSlot: f },
    h,
    r
  ];
}
var y3e = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Qr = y3e.reduce((e, t) => {
  const n = x.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? eh : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Tz(e, t) {
  e && go.flushSync(() => e.dispatchEvent(t));
}
var b3e = "DismissableLayer", qx = "dismissableLayer.update", x3e = "dismissableLayer.pointerDownOutside", w3e = "dismissableLayer.focusOutside", bk, Mz = x.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Rz = x.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = e, u = x.useContext(Mz), [c, f] = x.useState(null), h = (c == null ? void 0 : c.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = x.useState({}), v = Kr(t, (O) => f(O)), g = Array.from(u.layers), [y] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), w = g.indexOf(y), C = c ? g.indexOf(c) : -1, S = u.layersWithOutsidePointerEventsDisabled.size > 0, N = C >= w, E = _3e((O) => {
      const T = O.target, M = [...u.branches].some((L) => L.contains(T));
      !N || M || (i == null || i(O), a == null || a(O), O.defaultPrevented || s == null || s());
    }, h), A = E3e((O) => {
      const T = O.target;
      [...u.branches].some((L) => L.contains(T)) || (o == null || o(O), a == null || a(O), O.defaultPrevented || s == null || s());
    }, h);
    return lu((O) => {
      C === u.layers.size - 1 && (r == null || r(O), !O.defaultPrevented && s && (O.preventDefault(), s()));
    }, h), x.useEffect(() => {
      if (c)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (bk = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(c)), u.layers.add(c), xk(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = bk);
        };
    }, [c, h, n, u]), x.useEffect(() => () => {
      c && (u.layers.delete(c), u.layersWithOutsidePointerEventsDisabled.delete(c), xk());
    }, [c, u]), x.useEffect(() => {
      const O = () => m({});
      return document.addEventListener(qx, O), () => document.removeEventListener(qx, O);
    }, []), /* @__PURE__ */ d(
      Qr.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: S ? N ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: At(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: At(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: At(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
Rz.displayName = b3e;
var C3e = "DismissableLayerBranch", S3e = x.forwardRef((e, t) => {
  const n = x.useContext(Mz), r = x.useRef(null), i = Kr(t, r);
  return x.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ d(Qr.div, { ...e, ref: i });
});
S3e.displayName = C3e;
function _3e(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ie(e), r = x.useRef(!1), i = x.useRef(() => {
  });
  return x.useEffect(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          Dz(
            x3e,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = l, t.addEventListener("click", i.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function E3e(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ie(e), r = x.useRef(!1);
  return x.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && Dz(w3e, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function xk() {
  const e = new CustomEvent(qx);
  document.dispatchEvent(e);
}
function Dz(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? Tz(i, o) : i.dispatchEvent(o);
}
var o3 = "focusScope.autoFocusOnMount", a3 = "focusScope.autoFocusOnUnmount", wk = { bubbles: !1, cancelable: !0 }, N3e = "FocusScope", Iz = x.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o,
    ...a
  } = e, [s, l] = x.useState(null), u = Ie(i), c = Ie(o), f = x.useRef(null), h = Kr(t, (g) => l(g)), m = x.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  x.useEffect(() => {
    if (r) {
      let g = function(S) {
        if (m.paused || !s) return;
        const N = S.target;
        s.contains(N) ? f.current = N : ms(f.current, { select: !0 });
      }, y = function(S) {
        if (m.paused || !s) return;
        const N = S.relatedTarget;
        N !== null && (s.contains(N) || ms(f.current, { select: !0 }));
      }, w = function(S) {
        if (document.activeElement === document.body)
          for (const E of S)
            E.removedNodes.length > 0 && ms(s);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", y);
      const C = new MutationObserver(w);
      return s && C.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", y), C.disconnect();
      };
    }
  }, [r, s, m.paused]), x.useEffect(() => {
    if (s) {
      Sk.add(m);
      const g = document.activeElement;
      if (!s.contains(g)) {
        const w = new CustomEvent(o3, wk);
        s.addEventListener(o3, u), s.dispatchEvent(w), w.defaultPrevented || (A3e(M3e($z(s)), { select: !0 }), document.activeElement === g && ms(s));
      }
      return () => {
        s.removeEventListener(o3, u), setTimeout(() => {
          const w = new CustomEvent(a3, wk);
          s.addEventListener(a3, c), s.dispatchEvent(w), w.defaultPrevented || ms(g ?? document.body, { select: !0 }), s.removeEventListener(a3, c), Sk.remove(m);
        }, 0);
      };
    }
  }, [s, u, c, m]);
  const v = x.useCallback(
    (g) => {
      if (!n && !r || m.paused) return;
      const y = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, w = document.activeElement;
      if (y && w) {
        const C = g.currentTarget, [S, N] = O3e(C);
        S && N ? !g.shiftKey && w === N ? (g.preventDefault(), n && ms(S, { select: !0 })) : g.shiftKey && w === S && (g.preventDefault(), n && ms(N, { select: !0 })) : w === C && g.preventDefault();
      }
    },
    [n, r, m.paused]
  );
  return /* @__PURE__ */ d(Qr.div, { tabIndex: -1, ...a, ref: h, onKeyDown: v });
});
Iz.displayName = N3e;
function A3e(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (ms(r, { select: t }), document.activeElement !== n) return;
}
function O3e(e) {
  const t = $z(e), n = Ck(t, e), r = Ck(t.reverse(), e);
  return [n, r];
}
function $z(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Ck(e, t) {
  for (const n of e)
    if (!k3e(n, { upTo: t })) return n;
}
function k3e(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function P3e(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function ms(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && P3e(e) && t && e.select();
  }
}
var Sk = T3e();
function T3e() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = _k(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = _k(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function _k(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function M3e(e) {
  return e.filter((t) => t.tagName !== "A");
}
var R3e = "Arrow", Lz = x.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: i = 5, ...o } = e;
  return /* @__PURE__ */ d(
    Qr.svg,
    {
      ...o,
      ref: t,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ d("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Lz.displayName = R3e;
var D3e = Lz, $C = "Popper", [Fz, Bz] = A2($C), [I3e, jz] = Fz($C), Vz = (e) => {
  const { __scopePopper: t, children: n } = e, [r, i] = x.useState(null);
  return /* @__PURE__ */ d(I3e, { scope: t, anchor: r, onAnchorChange: i, children: n });
};
Vz.displayName = $C;
var qz = "PopperAnchor", zz = x.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...i } = e, o = jz(qz, n), a = x.useRef(null), s = Kr(t, a);
    return x.useEffect(() => {
      o.onAnchorChange((r == null ? void 0 : r.current) || a.current);
    }), r ? null : /* @__PURE__ */ d(Qr.div, { ...i, ref: s });
  }
);
zz.displayName = qz;
var LC = "PopperContent", [$3e, L3e] = Fz(LC), Wz = x.forwardRef(
  (e, t) => {
    var ge, Ce, ie, ye, ve, Q;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: i = 0,
      align: o = "center",
      alignOffset: a = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: u = [],
      collisionPadding: c = 0,
      sticky: f = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: v,
      ...g
    } = e, y = jz(LC, n), [w, C] = x.useState(null), S = Kr(t, (Oe) => C(Oe)), [N, E] = x.useState(null), A = uu(N), O = (A == null ? void 0 : A.width) ?? 0, T = (A == null ? void 0 : A.height) ?? 0, M = r + (o !== "center" ? "-" + o : ""), L = typeof c == "number" ? c : { top: 0, right: 0, bottom: 0, left: 0, ...c }, I = Array.isArray(u) ? u : [u], j = I.length > 0, B = {
      padding: L,
      boundary: I.filter(B3e),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: j
    }, { refs: q, floatingStyles: G, placement: U, isPositioned: V, middlewareData: H } = s2({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: M,
      whileElementsMounted: (...Oe) => a2(...Oe, {
        animationFrame: m === "always"
      }),
      elements: {
        reference: y.anchor
      },
      middleware: [
        l2({ mainAxis: i + T, alignmentAxis: a }),
        l && u2({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? c2() : void 0,
          ...B
        }),
        l && d2({ ...B }),
        f2({
          ...B,
          apply: ({ elements: Oe, rects: se, availableWidth: nt, availableHeight: ut }) => {
            const { width: st, height: Nn } = se.reference, Dt = Oe.floating.style;
            Dt.setProperty("--radix-popper-available-width", `${nt}px`), Dt.setProperty("--radix-popper-available-height", `${ut}px`), Dt.setProperty("--radix-popper-anchor-width", `${st}px`), Dt.setProperty("--radix-popper-anchor-height", `${Nn}px`);
          }
        }),
        N && p2({ element: N, padding: s }),
        j3e({ arrowWidth: O, arrowHeight: T }),
        h && h2({ strategy: "referenceHidden", ...B })
      ]
    }), [Z, de] = Gz(U), ne = Ie(v);
    He(() => {
      V && (ne == null || ne());
    }, [V, ne]);
    const Y = (ge = H.arrow) == null ? void 0 : ge.x, le = (Ce = H.arrow) == null ? void 0 : Ce.y, be = ((ie = H.arrow) == null ? void 0 : ie.centerOffset) !== 0, [pe, Ee] = x.useState();
    return He(() => {
      w && Ee(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ d(
      "div",
      {
        ref: q.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...G,
          transform: V ? G.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: pe,
          "--radix-popper-transform-origin": [
            (ye = H.transformOrigin) == null ? void 0 : ye.x,
            (ve = H.transformOrigin) == null ? void 0 : ve.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Q = H.hide) == null ? void 0 : Q.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ d(
          $3e,
          {
            scope: n,
            placedSide: Z,
            onArrowChange: E,
            arrowX: Y,
            arrowY: le,
            shouldHideArrow: be,
            children: /* @__PURE__ */ d(
              Qr.div,
              {
                "data-side": Z,
                "data-align": de,
                ...g,
                ref: S,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: V ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Wz.displayName = LC;
var Hz = "PopperArrow", F3e = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Uz = x.forwardRef(function(t, n) {
  const { __scopePopper: r, ...i } = t, o = L3e(Hz, r), a = F3e[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ d(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ d(
          D3e,
          {
            ...i,
            ref: n,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Uz.displayName = Hz;
function B3e(e) {
  return e !== null;
}
var j3e = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var y, w, C;
    const { placement: n, rects: r, middlewareData: i } = t, a = ((y = i.arrow) == null ? void 0 : y.centerOffset) !== 0, s = a ? 0 : e.arrowWidth, l = a ? 0 : e.arrowHeight, [u, c] = Gz(n), f = { start: "0%", center: "50%", end: "100%" }[c], h = (((w = i.arrow) == null ? void 0 : w.x) ?? 0) + s / 2, m = (((C = i.arrow) == null ? void 0 : C.y) ?? 0) + l / 2;
    let v = "", g = "";
    return u === "bottom" ? (v = a ? f : `${h}px`, g = `${-l}px`) : u === "top" ? (v = a ? f : `${h}px`, g = `${r.floating.height + l}px`) : u === "right" ? (v = `${-l}px`, g = a ? f : `${m}px`) : u === "left" && (v = `${r.floating.width + l}px`, g = a ? f : `${m}px`), { data: { x: v, y: g } };
  }
});
function Gz(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Kz = Vz, V3e = zz, q3e = Wz, z3e = Uz, W3e = "Portal", Yz = x.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [i, o] = x.useState(!1);
  He(() => o(!0), []);
  const a = n || i && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return a ? Zo.createPortal(/* @__PURE__ */ d(Qr.div, { ...r, ref: t }), a) : null;
});
Yz.displayName = W3e;
function H3e(e, t) {
  return x.useReducer((n, r) => t[n][r] ?? n, e);
}
var yp = (e) => {
  const { present: t, children: n } = e, r = U3e(t), i = typeof n == "function" ? n({ present: r.isPresent }) : x.Children.only(n), o = Kr(r.ref, G3e(i));
  return typeof n == "function" || r.isPresent ? x.cloneElement(i, { ref: o }) : null;
};
yp.displayName = "Presence";
function U3e(e) {
  const [t, n] = x.useState(), r = x.useRef({}), i = x.useRef(e), o = x.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = H3e(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return x.useEffect(() => {
    const u = e1(r.current);
    o.current = s === "mounted" ? u : "none";
  }, [s]), He(() => {
    const u = r.current, c = i.current;
    if (c !== e) {
      const h = o.current, m = e1(u);
      e ? l("MOUNT") : m === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(c && h !== m ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, l]), He(() => {
    if (t) {
      let u;
      const c = t.ownerDocument.defaultView ?? window, f = (m) => {
        const g = e1(r.current).includes(m.animationName);
        if (m.target === t && g && (l("ANIMATION_END"), !i.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = c.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, h = (m) => {
        m.target === t && (o.current = e1(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        c.clearTimeout(u), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: x.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function e1(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function G3e(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var s3 = "rovingFocusGroup.onEntryFocus", K3e = { bubbles: !1, cancelable: !0 }, O2 = "RovingFocusGroup", [zx, Zz, Y3e] = Pz(O2), [Z3e, Xz] = A2(
  O2,
  [Y3e]
), [X3e, J3e] = Z3e(O2), Jz = x.forwardRef(
  (e, t) => /* @__PURE__ */ d(zx.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ d(zx.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ d(Q3e, { ...e, ref: t }) }) })
);
Jz.displayName = O2;
var Q3e = x.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: i = !1,
    dir: o,
    currentTabStopId: a,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: u,
    preventScrollOnEntryFocus: c = !1,
    ...f
  } = e, h = x.useRef(null), m = Kr(t, h), v = Bi(o), [g = null, y] = Kt({
    prop: a,
    defaultProp: s,
    onChange: l
  }), [w, C] = x.useState(!1), S = Ie(u), N = Zz(n), E = x.useRef(!1), [A, O] = x.useState(0);
  return x.useEffect(() => {
    const T = h.current;
    if (T)
      return T.addEventListener(s3, S), () => T.removeEventListener(s3, S);
  }, [S]), /* @__PURE__ */ d(
    X3e,
    {
      scope: n,
      orientation: r,
      dir: v,
      loop: i,
      currentTabStopId: g,
      onItemFocus: x.useCallback(
        (T) => y(T),
        [y]
      ),
      onItemShiftTab: x.useCallback(() => C(!0), []),
      onFocusableItemAdd: x.useCallback(
        () => O((T) => T + 1),
        []
      ),
      onFocusableItemRemove: x.useCallback(
        () => O((T) => T - 1),
        []
      ),
      children: /* @__PURE__ */ d(
        Qr.div,
        {
          tabIndex: w || A === 0 ? -1 : 0,
          "data-orientation": r,
          ...f,
          ref: m,
          style: { outline: "none", ...e.style },
          onMouseDown: At(e.onMouseDown, () => {
            E.current = !0;
          }),
          onFocus: At(e.onFocus, (T) => {
            const M = !E.current;
            if (T.target === T.currentTarget && M && !w) {
              const L = new CustomEvent(s3, K3e);
              if (T.currentTarget.dispatchEvent(L), !L.defaultPrevented) {
                const I = N().filter((U) => U.focusable), j = I.find((U) => U.active), B = I.find((U) => U.id === g), G = [j, B, ...I].filter(
                  Boolean
                ).map((U) => U.ref.current);
                tW(G, c);
              }
            }
            E.current = !1;
          }),
          onBlur: At(e.onBlur, () => C(!1))
        }
      )
    }
  );
}), Qz = "RovingFocusGroupItem", eW = x.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: i = !1,
      tabStopId: o,
      ...a
    } = e, s = ln(), l = o || s, u = J3e(Qz, n), c = u.currentTabStopId === l, f = Zz(n), { onFocusableItemAdd: h, onFocusableItemRemove: m } = u;
    return x.useEffect(() => {
      if (r)
        return h(), () => m();
    }, [r, h, m]), /* @__PURE__ */ d(
      zx.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: i,
        children: /* @__PURE__ */ d(
          Qr.span,
          {
            tabIndex: c ? 0 : -1,
            "data-orientation": u.orientation,
            ...a,
            ref: t,
            onMouseDown: At(e.onMouseDown, (v) => {
              r ? u.onItemFocus(l) : v.preventDefault();
            }),
            onFocus: At(e.onFocus, () => u.onItemFocus(l)),
            onKeyDown: At(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const g = n4e(v, u.orientation, u.dir);
              if (g !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let w = f().filter((C) => C.focusable).map((C) => C.ref.current);
                if (g === "last") w.reverse();
                else if (g === "prev" || g === "next") {
                  g === "prev" && w.reverse();
                  const C = w.indexOf(v.currentTarget);
                  w = u.loop ? r4e(w, C + 1) : w.slice(C + 1);
                }
                setTimeout(() => tW(w));
              }
            })
          }
        )
      }
    );
  }
);
eW.displayName = Qz;
var e4e = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function t4e(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function n4e(e, t, n) {
  const r = t4e(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return e4e[r];
}
function tW(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function r4e(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var i4e = Jz, o4e = eW, B1 = "right-scroll-bar-position", j1 = "width-before-scroll-bar", a4e = "with-scroll-bars-hidden", s4e = "--removed-body-scroll-bar-size";
function l3(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function l4e(e, t) {
  var n = re(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var u4e = typeof window < "u" ? x.useLayoutEffect : x.useEffect, Ek = /* @__PURE__ */ new WeakMap();
function c4e(e, t) {
  var n = l4e(null, function(r) {
    return e.forEach(function(i) {
      return l3(i, r);
    });
  });
  return u4e(function() {
    var r = Ek.get(n);
    if (r) {
      var i = new Set(r), o = new Set(e), a = n.current;
      i.forEach(function(s) {
        o.has(s) || l3(s, null);
      }), o.forEach(function(s) {
        i.has(s) || l3(s, a);
      });
    }
    Ek.set(n, e);
  }, [e]), n;
}
function d4e(e) {
  return e;
}
function f4e(e, t) {
  t === void 0 && (t = d4e);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(o) {
      var a = t(o, r);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(o);
      }
      n = {
        push: function(s) {
          return o(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(o), a = n;
      }
      var l = function() {
        var c = a;
        a = [], c.forEach(o);
      }, u = function() {
        return Promise.resolve().then(l);
      };
      u(), n = {
        push: function(c) {
          a.push(c), u();
        },
        filter: function(c) {
          return a = a.filter(c), n;
        }
      };
    }
  };
  return i;
}
function h4e(e) {
  e === void 0 && (e = {});
  var t = f4e(null);
  return t.options = Ke({ async: !0, ssr: !1 }, e), t;
}
var nW = function(e) {
  var t = e.sideCar, n = Qo(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return x.createElement(r, Ke({}, n));
};
nW.isSideCarExport = !0;
function p4e(e, t) {
  return e.useMedium(t), nW;
}
var rW = h4e(), u3 = function() {
}, k2 = x.forwardRef(function(e, t) {
  var n = x.useRef(null), r = x.useState({
    onScrollCapture: u3,
    onWheelCapture: u3,
    onTouchMoveCapture: u3
  }), i = r[0], o = r[1], a = e.forwardProps, s = e.children, l = e.className, u = e.removeScrollBar, c = e.enabled, f = e.shards, h = e.sideCar, m = e.noIsolation, v = e.inert, g = e.allowPinchZoom, y = e.as, w = y === void 0 ? "div" : y, C = e.gapMode, S = Qo(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), N = h, E = c4e([n, t]), A = Ke(Ke({}, S), i);
  return x.createElement(
    x.Fragment,
    null,
    c && x.createElement(N, { sideCar: rW, removeScrollBar: u, shards: f, noIsolation: m, inert: v, setCallbacks: o, allowPinchZoom: !!g, lockRef: n, gapMode: C }),
    a ? x.cloneElement(x.Children.only(s), Ke(Ke({}, A), { ref: E })) : x.createElement(w, Ke({}, A, { className: l, ref: E }), s)
  );
});
k2.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
k2.classNames = {
  fullWidth: j1,
  zeroRight: B1
};
function m4e() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Kg();
  return t && e.setAttribute("nonce", t), e;
}
function g4e(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function v4e(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var y4e = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = m4e()) && (g4e(t, n), v4e(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, b4e = function() {
  var e = y4e();
  return function(t, n) {
    x.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, iW = function() {
  var e = b4e(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, x4e = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, c3 = function(e) {
  return parseInt(e || "", 10) || 0;
}, w4e = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [c3(n), c3(r), c3(i)];
}, C4e = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return x4e;
  var t = w4e(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, S4e = iW(), gc = "data-scroll-locked", _4e = function(e, t, n, r) {
  var i = e.left, o = e.top, a = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(a4e, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(gc, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(B1, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(j1, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(B1, " .").concat(B1, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(j1, " .").concat(j1, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(gc, `] {
    `).concat(s4e, ": ").concat(s, `px;
  }
`);
}, Nk = function() {
  var e = parseInt(document.body.getAttribute(gc) || "0", 10);
  return isFinite(e) ? e : 0;
}, E4e = function() {
  x.useEffect(function() {
    return document.body.setAttribute(gc, (Nk() + 1).toString()), function() {
      var e = Nk() - 1;
      e <= 0 ? document.body.removeAttribute(gc) : document.body.setAttribute(gc, e.toString());
    };
  }, []);
}, N4e = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
  E4e();
  var o = x.useMemo(function() {
    return C4e(i);
  }, [i]);
  return x.createElement(S4e, { styles: _4e(o, !t, i, n ? "" : "!important") });
}, Wx = !1;
if (typeof window < "u")
  try {
    var t1 = Object.defineProperty({}, "passive", {
      get: function() {
        return Wx = !0, !0;
      }
    });
    window.addEventListener("test", t1, t1), window.removeEventListener("test", t1, t1);
  } catch {
    Wx = !1;
  }
var Wu = Wx ? { passive: !1 } : !1, A4e = function(e) {
  return e.tagName === "TEXTAREA";
}, oW = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !A4e(e) && n[t] === "visible")
  );
}, O4e = function(e) {
  return oW(e, "overflowY");
}, k4e = function(e) {
  return oW(e, "overflowX");
}, Ak = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = aW(e, r);
    if (i) {
      var o = sW(e, r), a = o[1], s = o[2];
      if (a > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, P4e = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, T4e = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, aW = function(e, t) {
  return e === "v" ? O4e(t) : k4e(t);
}, sW = function(e, t) {
  return e === "v" ? P4e(t) : T4e(t);
}, M4e = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, R4e = function(e, t, n, r, i) {
  var o = M4e(e, window.getComputedStyle(t).direction), a = o * r, s = n.target, l = t.contains(s), u = !1, c = a > 0, f = 0, h = 0;
  do {
    var m = sW(e, s), v = m[0], g = m[1], y = m[2], w = g - y - o * v;
    (v || w) && aW(e, s) && (f += w, h += v), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (c && Math.abs(f) < 1 || !c && Math.abs(h) < 1) && (u = !0), u;
}, n1 = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Ok = function(e) {
  return [e.deltaX, e.deltaY];
}, kk = function(e) {
  return e && "current" in e ? e.current : e;
}, D4e = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, I4e = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, $4e = 0, Hu = [];
function L4e(e) {
  var t = x.useRef([]), n = x.useRef([0, 0]), r = x.useRef(), i = x.useState($4e++)[0], o = x.useState(iW)[0], a = x.useRef(e);
  x.useEffect(function() {
    a.current = e;
  }, [e]), x.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var g = vd([e.lockRef.current], (e.shards || []).map(kk), !0).filter(Boolean);
      return g.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), g.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = x.useCallback(function(g, y) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !a.current.allowPinchZoom;
    var w = n1(g), C = n.current, S = "deltaX" in g ? g.deltaX : C[0] - w[0], N = "deltaY" in g ? g.deltaY : C[1] - w[1], E, A = g.target, O = Math.abs(S) > Math.abs(N) ? "h" : "v";
    if ("touches" in g && O === "h" && A.type === "range")
      return !1;
    var T = Ak(O, A);
    if (!T)
      return !0;
    if (T ? E = O : (E = O === "v" ? "h" : "v", T = Ak(O, A)), !T)
      return !1;
    if (!r.current && "changedTouches" in g && (S || N) && (r.current = E), !E)
      return !0;
    var M = r.current || E;
    return R4e(M, y, g, M === "h" ? S : N);
  }, []), l = x.useCallback(function(g) {
    var y = g;
    if (!(!Hu.length || Hu[Hu.length - 1] !== o)) {
      var w = "deltaY" in y ? Ok(y) : n1(y), C = t.current.filter(function(E) {
        return E.name === y.type && (E.target === y.target || y.target === E.shadowParent) && D4e(E.delta, w);
      })[0];
      if (C && C.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!C) {
        var S = (a.current.shards || []).map(kk).filter(Boolean).filter(function(E) {
          return E.contains(y.target);
        }), N = S.length > 0 ? s(y, S[0]) : !a.current.noIsolation;
        N && y.cancelable && y.preventDefault();
      }
    }
  }, []), u = x.useCallback(function(g, y, w, C) {
    var S = { name: g, delta: y, target: w, should: C, shadowParent: F4e(w) };
    t.current.push(S), setTimeout(function() {
      t.current = t.current.filter(function(N) {
        return N !== S;
      });
    }, 1);
  }, []), c = x.useCallback(function(g) {
    n.current = n1(g), r.current = void 0;
  }, []), f = x.useCallback(function(g) {
    u(g.type, Ok(g), g.target, s(g, e.lockRef.current));
  }, []), h = x.useCallback(function(g) {
    u(g.type, n1(g), g.target, s(g, e.lockRef.current));
  }, []);
  x.useEffect(function() {
    return Hu.push(o), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, Wu), document.addEventListener("touchmove", l, Wu), document.addEventListener("touchstart", c, Wu), function() {
      Hu = Hu.filter(function(g) {
        return g !== o;
      }), document.removeEventListener("wheel", l, Wu), document.removeEventListener("touchmove", l, Wu), document.removeEventListener("touchstart", c, Wu);
    };
  }, []);
  var m = e.removeScrollBar, v = e.inert;
  return x.createElement(
    x.Fragment,
    null,
    v ? x.createElement(o, { styles: I4e(i) }) : null,
    m ? x.createElement(N4e, { gapMode: e.gapMode }) : null
  );
}
function F4e(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const B4e = p4e(rW, L4e);
var lW = x.forwardRef(function(e, t) {
  return x.createElement(k2, Ke({}, e, { ref: t, sideCar: B4e }));
});
lW.classNames = k2.classNames;
var Hx = ["Enter", " "], j4e = ["ArrowDown", "PageUp", "Home"], uW = ["ArrowUp", "PageDown", "End"], V4e = [...j4e, ...uW], q4e = {
  ltr: [...Hx, "ArrowRight"],
  rtl: [...Hx, "ArrowLeft"]
}, z4e = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, bp = "Menu", [th, W4e, H4e] = Pz(bp), [du, cW] = A2(bp, [
  H4e,
  Bz,
  Xz
]), xp = Bz(), dW = Xz(), [fW, Zs] = du(bp), [U4e, wp] = du(bp), hW = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: i, onOpenChange: o, modal: a = !0 } = e, s = xp(t), [l, u] = x.useState(null), c = x.useRef(!1), f = Ie(o), h = Bi(i);
  return x.useEffect(() => {
    const m = () => {
      c.current = !0, document.addEventListener("pointerdown", v, { capture: !0, once: !0 }), document.addEventListener("pointermove", v, { capture: !0, once: !0 });
    }, v = () => c.current = !1;
    return document.addEventListener("keydown", m, { capture: !0 }), () => {
      document.removeEventListener("keydown", m, { capture: !0 }), document.removeEventListener("pointerdown", v, { capture: !0 }), document.removeEventListener("pointermove", v, { capture: !0 });
    };
  }, []), /* @__PURE__ */ d(Kz, { ...s, children: /* @__PURE__ */ d(
    fW,
    {
      scope: t,
      open: n,
      onOpenChange: f,
      content: l,
      onContentChange: u,
      children: /* @__PURE__ */ d(
        U4e,
        {
          scope: t,
          onClose: x.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: c,
          dir: h,
          modal: a,
          children: r
        }
      )
    }
  ) });
};
hW.displayName = bp;
var G4e = "MenuAnchor", FC = x.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, i = xp(n);
    return /* @__PURE__ */ d(V3e, { ...i, ...r, ref: t });
  }
);
FC.displayName = G4e;
var BC = "MenuPortal", [K4e, pW] = du(BC, {
  forceMount: void 0
}), mW = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: i } = e, o = Zs(BC, t);
  return /* @__PURE__ */ d(K4e, { scope: t, forceMount: n, children: /* @__PURE__ */ d(yp, { present: n || o.open, children: /* @__PURE__ */ d(Yz, { asChild: !0, container: i, children: r }) }) });
};
mW.displayName = BC;
var Ri = "MenuContent", [Y4e, jC] = du(Ri), gW = x.forwardRef(
  (e, t) => {
    const n = pW(Ri, e.__scopeMenu), { forceMount: r = n.forceMount, ...i } = e, o = Zs(Ri, e.__scopeMenu), a = wp(Ri, e.__scopeMenu);
    return /* @__PURE__ */ d(th.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ d(yp, { present: r || o.open, children: /* @__PURE__ */ d(th.Slot, { scope: e.__scopeMenu, children: a.modal ? /* @__PURE__ */ d(Z4e, { ...i, ref: t }) : /* @__PURE__ */ d(X4e, { ...i, ref: t }) }) }) });
  }
), Z4e = x.forwardRef(
  (e, t) => {
    const n = Zs(Ri, e.__scopeMenu), r = x.useRef(null), i = Kr(t, r);
    return x.useEffect(() => {
      const o = r.current;
      if (o) return yd(o);
    }, []), /* @__PURE__ */ d(
      VC,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: At(
          e.onFocusOutside,
          (o) => o.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), X4e = x.forwardRef((e, t) => {
  const n = Zs(Ri, e.__scopeMenu);
  return /* @__PURE__ */ d(
    VC,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), VC = x.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: i,
      onOpenAutoFocus: o,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: s,
      onEntryFocus: l,
      onEscapeKeyDown: u,
      onPointerDownOutside: c,
      onFocusOutside: f,
      onInteractOutside: h,
      onDismiss: m,
      disableOutsideScroll: v,
      ...g
    } = e, y = Zs(Ri, n), w = wp(Ri, n), C = xp(n), S = dW(n), N = W4e(n), [E, A] = x.useState(null), O = x.useRef(null), T = Kr(t, O, y.onContentChange), M = x.useRef(0), L = x.useRef(""), I = x.useRef(0), j = x.useRef(null), B = x.useRef("right"), q = x.useRef(0), G = v ? lW : x.Fragment, U = v ? { as: eh, allowPinchZoom: !0 } : void 0, V = (Z) => {
      var ge, Ce;
      const de = L.current + Z, ne = N().filter((ie) => !ie.disabled), Y = document.activeElement, le = (ge = ne.find((ie) => ie.ref.current === Y)) == null ? void 0 : ge.textValue, be = ne.map((ie) => ie.textValue), pe = u6e(be, de, le), Ee = (Ce = ne.find((ie) => ie.textValue === pe)) == null ? void 0 : Ce.ref.current;
      (function ie(ye) {
        L.current = ye, window.clearTimeout(M.current), ye !== "" && (M.current = window.setTimeout(() => ie(""), 1e3));
      })(de), Ee && setTimeout(() => Ee.focus());
    };
    x.useEffect(() => () => window.clearTimeout(M.current), []), Vw();
    const H = x.useCallback((Z) => {
      var ne, Y;
      return B.current === ((ne = j.current) == null ? void 0 : ne.side) && d6e(Z, (Y = j.current) == null ? void 0 : Y.area);
    }, []);
    return /* @__PURE__ */ d(
      Y4e,
      {
        scope: n,
        searchRef: L,
        onItemEnter: x.useCallback(
          (Z) => {
            H(Z) && Z.preventDefault();
          },
          [H]
        ),
        onItemLeave: x.useCallback(
          (Z) => {
            var de;
            H(Z) || ((de = O.current) == null || de.focus(), A(null));
          },
          [H]
        ),
        onTriggerLeave: x.useCallback(
          (Z) => {
            H(Z) && Z.preventDefault();
          },
          [H]
        ),
        pointerGraceTimerRef: I,
        onPointerGraceIntentChange: x.useCallback((Z) => {
          j.current = Z;
        }, []),
        children: /* @__PURE__ */ d(G, { ...U, children: /* @__PURE__ */ d(
          Iz,
          {
            asChild: !0,
            trapped: i,
            onMountAutoFocus: At(o, (Z) => {
              var de;
              Z.preventDefault(), (de = O.current) == null || de.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: a,
            children: /* @__PURE__ */ d(
              Rz,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: u,
                onPointerDownOutside: c,
                onFocusOutside: f,
                onInteractOutside: h,
                onDismiss: m,
                children: /* @__PURE__ */ d(
                  i4e,
                  {
                    asChild: !0,
                    ...S,
                    dir: w.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: E,
                    onCurrentTabStopIdChange: A,
                    onEntryFocus: At(l, (Z) => {
                      w.isUsingKeyboardRef.current || Z.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ d(
                      q3e,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": RW(y.open),
                        "data-radix-menu-content": "",
                        dir: w.dir,
                        ...C,
                        ...g,
                        ref: T,
                        style: { outline: "none", ...g.style },
                        onKeyDown: At(g.onKeyDown, (Z) => {
                          const ne = Z.target.closest("[data-radix-menu-content]") === Z.currentTarget, Y = Z.ctrlKey || Z.altKey || Z.metaKey, le = Z.key.length === 1;
                          ne && (Z.key === "Tab" && Z.preventDefault(), !Y && le && V(Z.key));
                          const be = O.current;
                          if (Z.target !== be || !V4e.includes(Z.key)) return;
                          Z.preventDefault();
                          const Ee = N().filter((ge) => !ge.disabled).map((ge) => ge.ref.current);
                          uW.includes(Z.key) && Ee.reverse(), s6e(Ee);
                        }),
                        onBlur: At(e.onBlur, (Z) => {
                          Z.currentTarget.contains(Z.target) || (window.clearTimeout(M.current), L.current = "");
                        }),
                        onPointerMove: At(
                          e.onPointerMove,
                          nh((Z) => {
                            const de = Z.target, ne = q.current !== Z.clientX;
                            if (Z.currentTarget.contains(de) && ne) {
                              const Y = Z.clientX > q.current ? "right" : "left";
                              B.current = Y, q.current = Z.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
gW.displayName = Ri;
var J4e = "MenuGroup", qC = x.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ d(Qr.div, { role: "group", ...r, ref: t });
  }
);
qC.displayName = J4e;
var Q4e = "MenuLabel", vW = x.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ d(Qr.div, { ...r, ref: t });
  }
);
vW.displayName = Q4e;
var lm = "MenuItem", Pk = "menu.itemSelect", P2 = x.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...i } = e, o = x.useRef(null), a = wp(lm, e.__scopeMenu), s = jC(lm, e.__scopeMenu), l = Kr(t, o), u = x.useRef(!1), c = () => {
      const f = o.current;
      if (!n && f) {
        const h = new CustomEvent(Pk, { bubbles: !0, cancelable: !0 });
        f.addEventListener(Pk, (m) => r == null ? void 0 : r(m), { once: !0 }), Tz(f, h), h.defaultPrevented ? u.current = !1 : a.onClose();
      }
    };
    return /* @__PURE__ */ d(
      yW,
      {
        ...i,
        ref: l,
        disabled: n,
        onClick: At(e.onClick, c),
        onPointerDown: (f) => {
          var h;
          (h = e.onPointerDown) == null || h.call(e, f), u.current = !0;
        },
        onPointerUp: At(e.onPointerUp, (f) => {
          var h;
          u.current || (h = f.currentTarget) == null || h.click();
        }),
        onKeyDown: At(e.onKeyDown, (f) => {
          const h = s.searchRef.current !== "";
          n || h && f.key === " " || Hx.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
P2.displayName = lm;
var yW = x.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: i, ...o } = e, a = jC(lm, n), s = dW(n), l = x.useRef(null), u = Kr(t, l), [c, f] = x.useState(!1), [h, m] = x.useState("");
    return x.useEffect(() => {
      const v = l.current;
      v && m((v.textContent ?? "").trim());
    }, [o.children]), /* @__PURE__ */ d(
      th.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: i ?? h,
        children: /* @__PURE__ */ d(o4e, { asChild: !0, ...s, focusable: !r, children: /* @__PURE__ */ d(
          Qr.div,
          {
            role: "menuitem",
            "data-highlighted": c ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...o,
            ref: u,
            onPointerMove: At(
              e.onPointerMove,
              nh((v) => {
                r ? a.onItemLeave(v) : (a.onItemEnter(v), v.defaultPrevented || v.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: At(
              e.onPointerLeave,
              nh((v) => a.onItemLeave(v))
            ),
            onFocus: At(e.onFocus, () => f(!0)),
            onBlur: At(e.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), e6e = "MenuCheckboxItem", bW = x.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...i } = e;
    return /* @__PURE__ */ d(_W, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ d(
      P2,
      {
        role: "menuitemcheckbox",
        "aria-checked": um(n) ? "mixed" : n,
        ...i,
        ref: t,
        "data-state": HC(n),
        onSelect: At(
          i.onSelect,
          () => r == null ? void 0 : r(um(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
bW.displayName = e6e;
var xW = "MenuRadioGroup", [t6e, n6e] = du(
  xW,
  { value: void 0, onValueChange: () => {
  } }
), wW = x.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...i } = e, o = Ie(r);
    return /* @__PURE__ */ d(t6e, { scope: e.__scopeMenu, value: n, onValueChange: o, children: /* @__PURE__ */ d(qC, { ...i, ref: t }) });
  }
);
wW.displayName = xW;
var CW = "MenuRadioItem", SW = x.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, i = n6e(CW, e.__scopeMenu), o = n === i.value;
    return /* @__PURE__ */ d(_W, { scope: e.__scopeMenu, checked: o, children: /* @__PURE__ */ d(
      P2,
      {
        role: "menuitemradio",
        "aria-checked": o,
        ...r,
        ref: t,
        "data-state": HC(o),
        onSelect: At(
          r.onSelect,
          () => {
            var a;
            return (a = i.onValueChange) == null ? void 0 : a.call(i, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
SW.displayName = CW;
var zC = "MenuItemIndicator", [_W, r6e] = du(
  zC,
  { checked: !1 }
), EW = x.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...i } = e, o = r6e(zC, n);
    return /* @__PURE__ */ d(
      yp,
      {
        present: r || um(o.checked) || o.checked === !0,
        children: /* @__PURE__ */ d(
          Qr.span,
          {
            ...i,
            ref: t,
            "data-state": HC(o.checked)
          }
        )
      }
    );
  }
);
EW.displayName = zC;
var i6e = "MenuSeparator", NW = x.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ d(
      Qr.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
NW.displayName = i6e;
var o6e = "MenuArrow", AW = x.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, i = xp(n);
    return /* @__PURE__ */ d(z3e, { ...i, ...r, ref: t });
  }
);
AW.displayName = o6e;
var WC = "MenuSub", [a6e, OW] = du(WC), kW = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: i } = e, o = Zs(WC, t), a = xp(t), [s, l] = x.useState(null), [u, c] = x.useState(null), f = Ie(i);
  return x.useEffect(() => (o.open === !1 && f(!1), () => f(!1)), [o.open, f]), /* @__PURE__ */ d(Kz, { ...a, children: /* @__PURE__ */ d(
    fW,
    {
      scope: t,
      open: r,
      onOpenChange: f,
      content: u,
      onContentChange: c,
      children: /* @__PURE__ */ d(
        a6e,
        {
          scope: t,
          contentId: ln(),
          triggerId: ln(),
          trigger: s,
          onTriggerChange: l,
          children: n
        }
      )
    }
  ) });
};
kW.displayName = WC;
var Nf = "MenuSubTrigger", PW = x.forwardRef(
  (e, t) => {
    const n = Zs(Nf, e.__scopeMenu), r = wp(Nf, e.__scopeMenu), i = OW(Nf, e.__scopeMenu), o = jC(Nf, e.__scopeMenu), a = x.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: l } = o, u = { __scopeMenu: e.__scopeMenu }, c = x.useCallback(() => {
      a.current && window.clearTimeout(a.current), a.current = null;
    }, []);
    return x.useEffect(() => c, [c]), x.useEffect(() => {
      const f = s.current;
      return () => {
        window.clearTimeout(f), l(null);
      };
    }, [s, l]), /* @__PURE__ */ d(FC, { asChild: !0, ...u, children: /* @__PURE__ */ d(
      yW,
      {
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": i.contentId,
        "data-state": RW(n.open),
        ...e,
        ref: IC(t, i.onTriggerChange),
        onClick: (f) => {
          var h;
          (h = e.onClick) == null || h.call(e, f), !(e.disabled || f.defaultPrevented) && (f.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: At(
          e.onPointerMove,
          nh((f) => {
            o.onItemEnter(f), !f.defaultPrevented && !e.disabled && !n.open && !a.current && (o.onPointerGraceIntentChange(null), a.current = window.setTimeout(() => {
              n.onOpenChange(!0), c();
            }, 100));
          })
        ),
        onPointerLeave: At(
          e.onPointerLeave,
          nh((f) => {
            var m, v;
            c();
            const h = (m = n.content) == null ? void 0 : m.getBoundingClientRect();
            if (h) {
              const g = (v = n.content) == null ? void 0 : v.dataset.side, y = g === "right", w = y ? -5 : 5, C = h[y ? "left" : "right"], S = h[y ? "right" : "left"];
              o.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: f.clientX + w, y: f.clientY },
                  { x: C, y: h.top },
                  { x: S, y: h.top },
                  { x: S, y: h.bottom },
                  { x: C, y: h.bottom }
                ],
                side: g
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => o.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (o.onTriggerLeave(f), f.defaultPrevented) return;
              o.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: At(e.onKeyDown, (f) => {
          var m;
          const h = o.searchRef.current !== "";
          e.disabled || h && f.key === " " || q4e[r.dir].includes(f.key) && (n.onOpenChange(!0), (m = n.content) == null || m.focus(), f.preventDefault());
        })
      }
    ) });
  }
);
PW.displayName = Nf;
var TW = "MenuSubContent", MW = x.forwardRef(
  (e, t) => {
    const n = pW(Ri, e.__scopeMenu), { forceMount: r = n.forceMount, ...i } = e, o = Zs(Ri, e.__scopeMenu), a = wp(Ri, e.__scopeMenu), s = OW(TW, e.__scopeMenu), l = x.useRef(null), u = Kr(t, l);
    return /* @__PURE__ */ d(th.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ d(yp, { present: r || o.open, children: /* @__PURE__ */ d(th.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ d(
      VC,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...i,
        ref: u,
        align: "start",
        side: a.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (c) => {
          var f;
          a.isUsingKeyboardRef.current && ((f = l.current) == null || f.focus()), c.preventDefault();
        },
        onCloseAutoFocus: (c) => c.preventDefault(),
        onFocusOutside: At(e.onFocusOutside, (c) => {
          c.target !== s.trigger && o.onOpenChange(!1);
        }),
        onEscapeKeyDown: At(e.onEscapeKeyDown, (c) => {
          a.onClose(), c.preventDefault();
        }),
        onKeyDown: At(e.onKeyDown, (c) => {
          var m;
          const f = c.currentTarget.contains(c.target), h = z4e[a.dir].includes(c.key);
          f && h && (o.onOpenChange(!1), (m = s.trigger) == null || m.focus(), c.preventDefault());
        })
      }
    ) }) }) });
  }
);
MW.displayName = TW;
function RW(e) {
  return e ? "open" : "closed";
}
function um(e) {
  return e === "indeterminate";
}
function HC(e) {
  return um(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function s6e(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function l6e(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function u6e(e, t, n) {
  const i = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, o = n ? e.indexOf(n) : -1;
  let a = l6e(e, Math.max(o, 0));
  i.length === 1 && (a = a.filter((u) => u !== n));
  const l = a.find(
    (u) => u.toLowerCase().startsWith(i.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function c6e(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let o = 0, a = t.length - 1; o < t.length; a = o++) {
    const s = t[o].x, l = t[o].y, u = t[a].x, c = t[a].y;
    l > r != c > r && n < (u - s) * (r - l) / (c - l) + s && (i = !i);
  }
  return i;
}
function d6e(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return c6e(n, t);
}
function nh(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var f6e = hW, h6e = FC, p6e = mW, m6e = gW, g6e = qC, v6e = vW, y6e = P2, b6e = bW, x6e = wW, w6e = SW, C6e = EW, S6e = NW, _6e = AW, E6e = kW, N6e = PW, A6e = MW, UC = "DropdownMenu", [O6e, KQe] = o3e(
  UC,
  [cW]
), br = cW(), [k6e, DW] = O6e(UC), IW = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: i,
    defaultOpen: o,
    onOpenChange: a,
    modal: s = !0
  } = e, l = br(t), u = x.useRef(null), [c = !1, f] = Kt({
    prop: i,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ d(
    k6e,
    {
      scope: t,
      triggerId: ln(),
      triggerRef: u,
      contentId: ln(),
      open: c,
      onOpenChange: f,
      onOpenToggle: x.useCallback(() => f((h) => !h), [f]),
      modal: s,
      children: /* @__PURE__ */ d(f6e, { ...l, open: c, onOpenChange: f, dir: r, modal: s, children: n })
    }
  );
};
IW.displayName = UC;
var $W = "DropdownMenuTrigger", LW = x.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...i } = e, o = DW($W, n), a = br(n);
    return /* @__PURE__ */ d(h6e, { asChild: !0, ...a, children: /* @__PURE__ */ d(
      f3e.button,
      {
        type: "button",
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": o.open,
        "aria-controls": o.open ? o.contentId : void 0,
        "data-state": o.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...i,
        ref: Oz(t, o.triggerRef),
        onPointerDown: sm(e.onPointerDown, (s) => {
          !r && s.button === 0 && s.ctrlKey === !1 && (o.onOpenToggle(), o.open || s.preventDefault());
        }),
        onKeyDown: sm(e.onKeyDown, (s) => {
          r || (["Enter", " "].includes(s.key) && o.onOpenToggle(), s.key === "ArrowDown" && o.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
LW.displayName = $W;
var P6e = "DropdownMenuPortal", FW = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = br(t);
  return /* @__PURE__ */ d(p6e, { ...r, ...n });
};
FW.displayName = P6e;
var BW = "DropdownMenuContent", jW = x.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = DW(BW, n), o = br(n), a = x.useRef(!1);
    return /* @__PURE__ */ d(
      m6e,
      {
        id: i.contentId,
        "aria-labelledby": i.triggerId,
        ...o,
        ...r,
        ref: t,
        onCloseAutoFocus: sm(e.onCloseAutoFocus, (s) => {
          var l;
          a.current || (l = i.triggerRef.current) == null || l.focus(), a.current = !1, s.preventDefault();
        }),
        onInteractOutside: sm(e.onInteractOutside, (s) => {
          const l = s.detail.originalEvent, u = l.button === 0 && l.ctrlKey === !0, c = l.button === 2 || u;
          (!i.modal || c) && (a.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
jW.displayName = BW;
var T6e = "DropdownMenuGroup", VW = x.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = br(n);
    return /* @__PURE__ */ d(g6e, { ...i, ...r, ref: t });
  }
);
VW.displayName = T6e;
var M6e = "DropdownMenuLabel", qW = x.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = br(n);
    return /* @__PURE__ */ d(v6e, { ...i, ...r, ref: t });
  }
);
qW.displayName = M6e;
var R6e = "DropdownMenuItem", zW = x.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = br(n);
    return /* @__PURE__ */ d(y6e, { ...i, ...r, ref: t });
  }
);
zW.displayName = R6e;
var D6e = "DropdownMenuCheckboxItem", WW = x.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = br(n);
  return /* @__PURE__ */ d(b6e, { ...i, ...r, ref: t });
});
WW.displayName = D6e;
var I6e = "DropdownMenuRadioGroup", HW = x.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = br(n);
  return /* @__PURE__ */ d(x6e, { ...i, ...r, ref: t });
});
HW.displayName = I6e;
var $6e = "DropdownMenuRadioItem", UW = x.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = br(n);
  return /* @__PURE__ */ d(w6e, { ...i, ...r, ref: t });
});
UW.displayName = $6e;
var L6e = "DropdownMenuItemIndicator", GW = x.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = br(n);
  return /* @__PURE__ */ d(C6e, { ...i, ...r, ref: t });
});
GW.displayName = L6e;
var F6e = "DropdownMenuSeparator", KW = x.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = br(n);
  return /* @__PURE__ */ d(S6e, { ...i, ...r, ref: t });
});
KW.displayName = F6e;
var B6e = "DropdownMenuArrow", j6e = x.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = br(n);
    return /* @__PURE__ */ d(_6e, { ...i, ...r, ref: t });
  }
);
j6e.displayName = B6e;
var V6e = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: i, defaultOpen: o } = e, a = br(t), [s = !1, l] = Kt({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ d(E6e, { ...a, open: s, onOpenChange: l, children: n });
}, q6e = "DropdownMenuSubTrigger", YW = x.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = br(n);
  return /* @__PURE__ */ d(N6e, { ...i, ...r, ref: t });
});
YW.displayName = q6e;
var z6e = "DropdownMenuSubContent", ZW = x.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = br(n);
  return /* @__PURE__ */ d(
    A6e,
    {
      ...i,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
ZW.displayName = z6e;
var W6e = IW, H6e = LW, XW = FW, JW = jW, U6e = VW, QW = qW, eH = zW, tH = WW, G6e = HW, nH = UW, rH = GW, iH = KW, K6e = V6e, oH = YW, aH = ZW;
const YQe = W6e, ZQe = H6e, XQe = U6e, JQe = XW, QQe = K6e, eet = G6e, Y6e = te(({ className: e, inset: t, children: n, ...r }, i) => /* @__PURE__ */ k(
  oH,
  {
    ref: i,
    className: z(
      "focus:bg-accent data-[state=open]:bg-accent text-bodysm flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 outline-none [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ d(mB, { className: "ml-auto" })
    ]
  }
));
Y6e.displayName = oH.displayName;
const Z6e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  aH,
  {
    ref: n,
    className: z(
      "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] overflow-hidden rounded-md border p-1 shadow-lg",
      e
    ),
    ...t
  }
));
Z6e.displayName = aH.displayName;
const X6e = te(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ d(XW, { children: /* @__PURE__ */ d(
  JW,
  {
    ref: r,
    sideOffset: t,
    className: z(
      "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 border-border z-50 min-w-[8rem] overflow-hidden rounded-md border p-1 shadow-md",
      e
    ),
    ...n
  }
) }));
X6e.displayName = JW.displayName;
const J6e = te(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ d(
  eH,
  {
    ref: r,
    className: z(
      "focus:bg-accent focus:text-accent-foreground text-bodysm relative flex cursor-pointer select-none items-center gap-2 rounded-sm px-2 py-1.5 outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...n
  }
));
J6e.displayName = eH.displayName;
const Q6e = te(({ className: e, children: t, checked: n, ...r }, i) => /* @__PURE__ */ k(
  tH,
  {
    ref: i,
    className: z(
      "focus:bg-accent focus:text-accent-foreground text-bodysm relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: n,
    ...r,
    children: [
      /* @__PURE__ */ d("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ d(rH, { children: /* @__PURE__ */ d(Gs, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
Q6e.displayName = tH.displayName;
const e5e = te(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ k(
  nH,
  {
    ref: r,
    className: z(
      "focus:bg-accent focus:text-accent-foreground text-bodysm relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ d("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ d(rH, { children: /* @__PURE__ */ d(Yf, { className: "h-2 w-2 fill-current" }) }) }),
      t
    ]
  }
));
e5e.displayName = nH.displayName;
const t5e = te(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ d(
  QW,
  {
    ref: r,
    className: z(
      "text-bodysm px-2 py-1.5 font-semibold",
      t && "pl-8",
      e
    ),
    ...n
  }
));
t5e.displayName = QW.displayName;
const n5e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  iH,
  {
    ref: n,
    className: z("bg-interactiveBorder -mx-1 my-1 h-px", e),
    ...t
  }
));
n5e.displayName = iH.displayName;
const r5e = ({
  className: e,
  ...t
}) => /* @__PURE__ */ d(
  "span",
  {
    className: z("ml-auto text-body tracking-widest opacity-60", e),
    ...t
  }
);
r5e.displayName = "DropdownMenuShortcut";
const sH = Qt(
  {}
), lH = Qt(
  {}
), T2 = () => {
  const e = en(sH), t = en(lH), { getFieldState: n, formState: r } = jue(), i = n(e.name, r);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const { id: o } = t;
  return {
    id: o,
    name: e.name,
    formItemId: `${o}-form-item`,
    formDescriptionId: `${o}-form-item-description`,
    formMessageId: `${o}-form-item-message`,
    ...i
  };
}, tet = ({
  ...e
}) => /* @__PURE__ */ d(sH.Provider, { value: { name: e.name }, children: /* @__PURE__ */ d(Vue, { ...e }) }), i5e = te(
  ({ className: e, ...t }, n) => {
    const r = _ue();
    return /* @__PURE__ */ d(lH.Provider, { value: { id: r }, children: /* @__PURE__ */ d("div", { ref: n, className: z("space-y-2", e), ...t }) });
  }
);
i5e.displayName = "FormItem";
const o5e = te(({ className: e, children: t, required: n, ...r }, i) => {
  const { error: o, formItemId: a } = T2();
  return /* @__PURE__ */ k(
    qt,
    {
      ref: i,
      className: z(o && "text-destructive", e),
      htmlFor: a,
      ...r,
      children: [
        t,
        n ? /* @__PURE__ */ d("span", { className: "text-destructive ml-1", children: "*" }) : null
      ]
    }
  );
});
o5e.displayName = "FormLabel";
const a5e = te(({ ...e }, t) => {
  const { error: n, formItemId: r, formDescriptionId: i, formMessageId: o } = T2();
  return /* @__PURE__ */ d(
    pi,
    {
      ref: t,
      id: r,
      "aria-describedby": n ? `${i} ${o}` : `${i}`,
      "aria-invalid": !!n,
      ...e
    }
  );
});
a5e.displayName = "FormControl";
const s5e = te(({ className: e, ...t }, n) => {
  const { formDescriptionId: r } = T2();
  return /* @__PURE__ */ d(
    "p",
    {
      ref: n,
      id: r,
      className: z("text-muted-foreground text-bodysm", e),
      ...t
    }
  );
});
s5e.displayName = "FormDescription";
const l5e = te(({ className: e, children: t, ...n }, r) => {
  const { error: i, invalid: o, formMessageId: a } = T2(), s = i != null && i.message ? String(i.message) : t;
  return !o || !s ? null : /* @__PURE__ */ d(
    "p",
    {
      ref: r,
      id: a,
      className: z("text-destructive text-bodysm font-medium", e),
      ...n,
      children: s
    }
  );
});
l5e.displayName = "FormMessage";
function uH(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = x.createContext(a), l = n.length;
    n = [...n, a];
    const u = (f) => {
      var w;
      const { scope: h, children: m, ...v } = f, g = ((w = h == null ? void 0 : h[e]) == null ? void 0 : w[l]) || s, y = x.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ d(g.Provider, { value: y, children: m });
    };
    u.displayName = o + "Provider";
    function c(f, h) {
      var g;
      const m = ((g = h == null ? void 0 : h[e]) == null ? void 0 : g[l]) || s, v = x.useContext(m);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, c];
  }
  const i = () => {
    const o = n.map((a) => x.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return x.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, u5e(i, ...t)];
}
function u5e(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return x.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var d3 = "rovingFocusGroup.onEntryFocus", c5e = { bubbles: !1, cancelable: !0 }, M2 = "RovingFocusGroup", [Ux, cH, d5e] = Vg(M2), [f5e, R2] = Ks(
  M2,
  [d5e]
), [h5e, p5e] = f5e(M2), dH = x.forwardRef(
  (e, t) => /* @__PURE__ */ d(Ux.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ d(Ux.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ d(m5e, { ...e, ref: t }) }) })
);
dH.displayName = M2;
var m5e = x.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: i = !1,
    dir: o,
    currentTabStopId: a,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: u,
    preventScrollOnEntryFocus: c = !1,
    ...f
  } = e, h = x.useRef(null), m = tt(t, h), v = Bi(o), [g = null, y] = Kt({
    prop: a,
    defaultProp: s,
    onChange: l
  }), [w, C] = x.useState(!1), S = Ie(u), N = cH(n), E = x.useRef(!1), [A, O] = x.useState(0);
  return x.useEffect(() => {
    const T = h.current;
    if (T)
      return T.addEventListener(d3, S), () => T.removeEventListener(d3, S);
  }, [S]), /* @__PURE__ */ d(
    h5e,
    {
      scope: n,
      orientation: r,
      dir: v,
      loop: i,
      currentTabStopId: g,
      onItemFocus: x.useCallback(
        (T) => y(T),
        [y]
      ),
      onItemShiftTab: x.useCallback(() => C(!0), []),
      onFocusableItemAdd: x.useCallback(
        () => O((T) => T + 1),
        []
      ),
      onFocusableItemRemove: x.useCallback(
        () => O((T) => T - 1),
        []
      ),
      children: /* @__PURE__ */ d(
        Re.div,
        {
          tabIndex: w || A === 0 ? -1 : 0,
          "data-orientation": r,
          ...f,
          ref: m,
          style: { outline: "none", ...e.style },
          onMouseDown: Me(e.onMouseDown, () => {
            E.current = !0;
          }),
          onFocus: Me(e.onFocus, (T) => {
            const M = !E.current;
            if (T.target === T.currentTarget && M && !w) {
              const L = new CustomEvent(d3, c5e);
              if (T.currentTarget.dispatchEvent(L), !L.defaultPrevented) {
                const I = N().filter((U) => U.focusable), j = I.find((U) => U.active), B = I.find((U) => U.id === g), G = [j, B, ...I].filter(
                  Boolean
                ).map((U) => U.ref.current);
                pH(G, c);
              }
            }
            E.current = !1;
          }),
          onBlur: Me(e.onBlur, () => C(!1))
        }
      )
    }
  );
}), fH = "RovingFocusGroupItem", hH = x.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: i = !1,
      tabStopId: o,
      ...a
    } = e, s = ln(), l = o || s, u = p5e(fH, n), c = u.currentTabStopId === l, f = cH(n), { onFocusableItemAdd: h, onFocusableItemRemove: m } = u;
    return x.useEffect(() => {
      if (r)
        return h(), () => m();
    }, [r, h, m]), /* @__PURE__ */ d(
      Ux.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: i,
        children: /* @__PURE__ */ d(
          Re.span,
          {
            tabIndex: c ? 0 : -1,
            "data-orientation": u.orientation,
            ...a,
            ref: t,
            onMouseDown: Me(e.onMouseDown, (v) => {
              r ? u.onItemFocus(l) : v.preventDefault();
            }),
            onFocus: Me(e.onFocus, () => u.onItemFocus(l)),
            onKeyDown: Me(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const g = y5e(v, u.orientation, u.dir);
              if (g !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let w = f().filter((C) => C.focusable).map((C) => C.ref.current);
                if (g === "last") w.reverse();
                else if (g === "prev" || g === "next") {
                  g === "prev" && w.reverse();
                  const C = w.indexOf(v.currentTarget);
                  w = u.loop ? b5e(w, C + 1) : w.slice(C + 1);
                }
                setTimeout(() => pH(w));
              }
            })
          }
        )
      }
    );
  }
);
hH.displayName = fH;
var g5e = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function v5e(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function y5e(e, t, n) {
  const r = v5e(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return g5e[r];
}
function pH(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function b5e(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var mH = dH, gH = hH;
function x5e(e, t) {
  return x.useReducer((n, r) => t[n][r] ?? n, e);
}
var vH = (e) => {
  const { present: t, children: n } = e, r = w5e(t), i = typeof n == "function" ? n({ present: r.isPresent }) : x.Children.only(n), o = tt(r.ref, C5e(i));
  return typeof n == "function" || r.isPresent ? x.cloneElement(i, { ref: o }) : null;
};
vH.displayName = "Presence";
function w5e(e) {
  const [t, n] = x.useState(), r = x.useRef({}), i = x.useRef(e), o = x.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = x5e(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return x.useEffect(() => {
    const u = r1(r.current);
    o.current = s === "mounted" ? u : "none";
  }, [s]), He(() => {
    const u = r.current, c = i.current;
    if (c !== e) {
      const h = o.current, m = r1(u);
      e ? l("MOUNT") : m === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(c && h !== m ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, l]), He(() => {
    if (t) {
      let u;
      const c = t.ownerDocument.defaultView ?? window, f = (m) => {
        const g = r1(r.current).includes(m.animationName);
        if (m.target === t && g && (l("ANIMATION_END"), !i.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = c.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, h = (m) => {
        m.target === t && (o.current = r1(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        c.clearTimeout(u), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: x.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function r1(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function C5e(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var GC = "Radio", [S5e, yH] = uH(GC), [_5e, E5e] = S5e(GC), bH = x.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: n,
      name: r,
      checked: i = !1,
      required: o,
      disabled: a,
      value: s = "on",
      onCheck: l,
      form: u,
      ...c
    } = e, [f, h] = x.useState(null), m = tt(t, (y) => h(y)), v = x.useRef(!1), g = f ? u || !!f.closest("form") : !0;
    return /* @__PURE__ */ k(_5e, { scope: n, checked: i, disabled: a, children: [
      /* @__PURE__ */ d(
        Re.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": i,
          "data-state": CH(i),
          "data-disabled": a ? "" : void 0,
          disabled: a,
          value: s,
          ...c,
          ref: m,
          onClick: Me(e.onClick, (y) => {
            i || l == null || l(), g && (v.current = y.isPropagationStopped(), v.current || y.stopPropagation());
          })
        }
      ),
      g && /* @__PURE__ */ d(
        N5e,
        {
          control: f,
          bubbles: !v.current,
          name: r,
          value: s,
          checked: i,
          required: o,
          disabled: a,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
bH.displayName = GC;
var xH = "RadioIndicator", wH = x.forwardRef(
  (e, t) => {
    const { __scopeRadio: n, forceMount: r, ...i } = e, o = E5e(xH, n);
    return /* @__PURE__ */ d(vH, { present: r || o.checked, children: /* @__PURE__ */ d(
      Re.span,
      {
        "data-state": CH(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...i,
        ref: t
      }
    ) });
  }
);
wH.displayName = xH;
var N5e = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...i } = e, o = x.useRef(null), a = bd(n), s = uu(t);
  return x.useEffect(() => {
    const l = o.current, u = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(u, "checked").set;
    if (a !== n && f) {
      const h = new Event("click", { bubbles: r });
      f.call(l, n), l.dispatchEvent(h);
    }
  }, [a, n, r]), /* @__PURE__ */ d(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: n,
      ...i,
      tabIndex: -1,
      ref: o,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function CH(e) {
  return e ? "checked" : "unchecked";
}
var A5e = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], KC = "RadioGroup", [O5e, net] = uH(KC, [
  R2,
  yH
]), SH = R2(), _H = yH(), [k5e, P5e] = O5e(KC), EH = x.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: n,
      name: r,
      defaultValue: i,
      value: o,
      required: a = !1,
      disabled: s = !1,
      orientation: l,
      dir: u,
      loop: c = !0,
      onValueChange: f,
      ...h
    } = e, m = SH(n), v = Bi(u), [g, y] = Kt({
      prop: o,
      defaultProp: i,
      onChange: f
    });
    return /* @__PURE__ */ d(
      k5e,
      {
        scope: n,
        name: r,
        required: a,
        disabled: s,
        value: g,
        onValueChange: y,
        children: /* @__PURE__ */ d(
          mH,
          {
            asChild: !0,
            ...m,
            orientation: l,
            dir: v,
            loop: c,
            children: /* @__PURE__ */ d(
              Re.div,
              {
                role: "radiogroup",
                "aria-required": a,
                "aria-orientation": l,
                "data-disabled": s ? "" : void 0,
                dir: v,
                ...h,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
EH.displayName = KC;
var NH = "RadioGroupItem", AH = x.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, disabled: r, ...i } = e, o = P5e(NH, n), a = o.disabled || r, s = SH(n), l = _H(n), u = x.useRef(null), c = tt(t, u), f = o.value === i.value, h = x.useRef(!1);
    return x.useEffect(() => {
      const m = (g) => {
        A5e.includes(g.key) && (h.current = !0);
      }, v = () => h.current = !1;
      return document.addEventListener("keydown", m), document.addEventListener("keyup", v), () => {
        document.removeEventListener("keydown", m), document.removeEventListener("keyup", v);
      };
    }, []), /* @__PURE__ */ d(
      gH,
      {
        asChild: !0,
        ...s,
        focusable: !a,
        active: f,
        children: /* @__PURE__ */ d(
          bH,
          {
            disabled: a,
            required: o.required,
            checked: f,
            ...l,
            ...i,
            name: o.name,
            ref: c,
            onCheck: () => o.onValueChange(i.value),
            onKeyDown: Me((m) => {
              m.key === "Enter" && m.preventDefault();
            }),
            onFocus: Me(i.onFocus, () => {
              var m;
              h.current && ((m = u.current) == null || m.click());
            })
          }
        )
      }
    );
  }
);
AH.displayName = NH;
var T5e = "RadioGroupIndicator", OH = x.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, ...r } = e, i = _H(n);
    return /* @__PURE__ */ d(wH, { ...i, ...r, ref: t });
  }
);
OH.displayName = T5e;
var Cp = EH, As = AH, M5e = OH;
function $l({
  options: e,
  radioValue: t,
  setRadioValue: n
}) {
  return /* @__PURE__ */ d(
    Cp,
    {
      className: "flex flex-row",
      value: t,
      onValueChange: (r) => {
        n(r);
      },
      "aria-label": "View density",
      children: /* @__PURE__ */ d("div", { className: "flex items-center gap-x-1", children: e.length > 0 && e.map((r, i) => /* @__PURE__ */ k(
        As,
        {
          className: z(
            "data-[state=unchecked]:border-interactiveBorder data-[state=unchecked]:bg-interfaceWhite data-[state=unchecked]:hover:border-interactiveBorderHover data-[state=unchecked]:hover:bg-interfaceBgDefault flex h-12 w-12 flex-col items-center justify-center rounded border p-2 data-[state=checked]:border-2",
            r.bgColor,
            r.borderColor,
            r.textColor
          ),
          onClick: () => {
            r.text === t && n("");
          },
          tabIndex: 1,
          value: r.text,
          children: [
            r.icon,
            /* @__PURE__ */ d("p", { className: "mt-1 text-bodysm font-normal", children: r.text })
          ]
        },
        i
      )) })
    }
  );
}
const YC = te(
  ({ className: e, type: t, ...n }, r) => /* @__PURE__ */ d(
    "input",
    {
      type: t,
      className: z(
        "border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring flex h-10 w-full rounded-md border px-3 py-2 text-[1rem] leading-[1.25rem] file:border-0 file:bg-transparent file:text-bodysm file:font-medium placeholder:text-[1rem] placeholder:leading-[1.25rem] focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ref: r,
      ...n
    }
  )
);
YC.displayName = "Input";
const R5e = Jo(
  "flex items-center h-10 w-full px-3 py-2 text-bodymd bg-transparent file:border-0 file:text-bodysm file:font-medium placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 border border-transparent focus-within:outline-none aria-invalid:ring-1 aria-invalid:ring-destructive aria-invalid:focus-within:ring-2 aria-invalid:focus-within:ring-destructive",
  {
    variants: {
      rounded: {
        none: "rounded-none",
        sm: "rounded-sm",
        md: "rounded-md"
      },
      variant: {
        outline: "border-interactiveBorder focus-within:border-primary focus-within:shadow-[0_0px_0px_1px_hsl(var(--primary))] aria-invalid:border-transparent",
        filled: "border-2 bg-background focus-within:border-primary focus-within:bg-transparent",
        underlined: "rounded-none border-b-border focus-within:border-b-primary focus-within:shadow-[0_1px_0px_0px_hsl(var(--primary))]",
        unstyled: ""
      }
    },
    defaultVariants: {
      rounded: "md",
      variant: "outline"
    }
  }
), D5e = te(
  ({
    className: e,
    endClassName: t,
    endContent: n,
    rounded: r,
    startClassName: i,
    startContent: o,
    variant: a,
    ...s
  }, l) => /* @__PURE__ */ k(
    "div",
    {
      "aria-invalid": s["aria-invalid"],
      className: z(
        R5e({ variant: a, rounded: r, className: e }),
        e
      ),
      children: [
        o && /* @__PURE__ */ d(
          "span",
          {
            className: z(
              "text-muted-foreground pointer-events-none flex items-center",
              i
            ),
            children: o
          }
        ),
        /* @__PURE__ */ d(
          "input",
          {
            ref: l,
            ...s,
            className: z(
              "w-full bg-transparent outline-none focus-visible:outline-none",
              {
                "pl-1.5": !!o,
                "pr-1.5": !!n
              }
            )
          }
        ),
        n && /* @__PURE__ */ d(
          "span",
          {
            className: z(
              "text-muted-foreground pointer-events-none flex items-center",
              t
            ),
            children: n
          }
        )
      ]
    }
  )
);
D5e.displayName = "Input2";
var I5e = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], $5e = I5e.reduce((e, t) => {
  const n = x.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? pi : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), L5e = "Label", kH = x.forwardRef((e, t) => /* @__PURE__ */ d(
  $5e.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var i;
      n.target.closest("button, input, select, textarea") || ((i = e.onMouseDown) == null || i.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
kH.displayName = L5e;
var PH = kH;
const F5e = Jo(
  "font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), qt = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  PH,
  {
    ref: n,
    className: z(F5e(), e),
    ...t
  }
));
qt.displayName = PH.displayName;
const TH = te(function({
  allowMultiSelect: t = !0,
  className: n,
  disabled: r,
  // noOptionsFoundMessage,
  filter: i,
  onChange: o,
  onInputChange: a,
  options: s,
  placeholder: l,
  values: u
}, c) {
  const f = vt(null), [h, m] = re(!1), [v, g] = re(""), y = yr(
    (C) => {
      const S = u.filter((N) => N.value !== C.value);
      o(S);
    },
    [o, u]
  ), w = yr(
    (C) => {
      const S = f.current;
      if (S) {
        if ((C.key === "Delete" || C.key === "Backspace") && S.value === "") {
          const N = [...u];
          N.pop(), o(N);
        }
        C.key === "Escape" && S.blur();
      }
    },
    [o, u]
  );
  return Lg(c, () => ({
    resetInput: () => {
      g("");
    }
  }), []), /* @__PURE__ */ k(
    xd,
    {
      className: "overflow-visible bg-transparent",
      filter: i,
      onKeyDown: w,
      children: [
        /* @__PURE__ */ d(
          "div",
          {
            className: z(
              "border-input bg-interfaceWhite ring-offset-background focus-within:ring-ring focus:outline-hidden group rounded-md border px-3 py-2 text-bodysm focus-within:ring-2 focus-within:ring-offset-2",
              n
            ),
            children: /* @__PURE__ */ k("div", { className: "flex flex-wrap gap-1", children: [
              u.map((C) => /* @__PURE__ */ k(Tn, { variant: "secondary", children: [
                C.label,
                /* @__PURE__ */ d(
                  "button",
                  {
                    className: "ring-offset-background focus:ring-ring outline-hidden ml-1 rounded-full focus:ring-2 focus:ring-offset-2",
                    onKeyDown: (S) => {
                      S.key === "Enter" && y(C);
                    },
                    onClick: () => y(C),
                    onMouseDown: (S) => {
                      S.preventDefault(), S.stopPropagation();
                    },
                    type: "button",
                    children: /* @__PURE__ */ d(np, { className: "text-muted-foreground hover:text-foreground h-3 w-3" })
                  }
                )
              ] }, C.value)),
              /* @__PURE__ */ d(
                sr.Input,
                {
                  className: "placeholder:text-muted-foreground outline-hidden ml-2 flex-1 bg-transparent",
                  disabled: r,
                  onBlur: () => m(!1),
                  onFocus: () => m(!0),
                  onValueChange: (C) => {
                    g(C), a == null || a(C);
                  },
                  placeholder: l,
                  ref: f,
                  value: v
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ d("div", { className: "relative", children: /* @__PURE__ */ d(cp, { children: h && s.length > 0 ? /* @__PURE__ */ d("div", { className: "bg-popover text-popover-foreground animate-in outline-hidden absolute top-0 z-10 mt-2 max-h-64 w-full overflow-auto rounded-md border shadow-md", children: /* @__PURE__ */ d(dp, { className: "h-full", children: s.map((C) => /* @__PURE__ */ d(
          fp,
          {
            className: "cursor-pointer",
            disabled: r,
            keywords: C.keywords,
            onMouseDown: (S) => {
              S.preventDefault(), S.stopPropagation();
            },
            onSelect: (S) => {
              if (g(""), a == null || a(""), !t)
                o([C]);
              else {
                if (u.some(
                  (E) => E.value === C.value
                )) return;
                o([...u, C]);
              }
            },
            children: C.label
          },
          C.value
        )) }) }) : null }) })
      ]
    }
  );
});
function MH(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = x.createContext(a), l = n.length;
    n = [...n, a];
    const u = (f) => {
      var w;
      const { scope: h, children: m, ...v } = f, g = ((w = h == null ? void 0 : h[e]) == null ? void 0 : w[l]) || s, y = x.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ d(g.Provider, { value: y, children: m });
    };
    u.displayName = o + "Provider";
    function c(f, h) {
      var g;
      const m = ((g = h == null ? void 0 : h[e]) == null ? void 0 : g[l]) || s, v = x.useContext(m);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, c];
  }
  const i = () => {
    const o = n.map((a) => x.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return x.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, B5e(i, ...t)];
}
function B5e(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return x.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function qn(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function Tk(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function ZC(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = Tk(i, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : Tk(e[i], null);
        }
      };
  };
}
function Ho(...e) {
  return x.useCallback(ZC(...e), e);
}
var cm = x.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = x.Children.toArray(n), o = i.find(V5e);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? x.Children.count(a) > 1 ? x.Children.only(null) : x.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ d(Gx, { ...r, ref: t, children: x.isValidElement(a) ? x.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ d(Gx, { ...r, ref: t, children: n });
});
cm.displayName = "Slot";
var Gx = x.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (x.isValidElement(n)) {
    const i = z5e(n);
    return x.cloneElement(n, {
      ...q5e(r, n.props),
      // @ts-ignore
      ref: t ? ZC(t, i) : i
    });
  }
  return x.Children.count(n) > 1 ? x.Children.only(null) : null;
});
Gx.displayName = "SlotClone";
var j5e = ({ children: e }) => /* @__PURE__ */ d(xe, { children: e });
function V5e(e) {
  return x.isValidElement(e) && e.type === j5e;
}
function q5e(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function z5e(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var W5e = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Yr = W5e.reduce((e, t) => {
  const n = x.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? cm : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Kx(e, t) {
  e && go.flushSync(() => e.dispatchEvent(t));
}
function H5e(e, t) {
  return x.useReducer((n, r) => t[n][r] ?? n, e);
}
var Sp = (e) => {
  const { present: t, children: n } = e, r = U5e(t), i = typeof n == "function" ? n({ present: r.isPresent }) : x.Children.only(n), o = Ho(r.ref, G5e(i));
  return typeof n == "function" || r.isPresent ? x.cloneElement(i, { ref: o }) : null;
};
Sp.displayName = "Presence";
function U5e(e) {
  const [t, n] = x.useState(), r = x.useRef({}), i = x.useRef(e), o = x.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = H5e(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return x.useEffect(() => {
    const u = i1(r.current);
    o.current = s === "mounted" ? u : "none";
  }, [s]), He(() => {
    const u = r.current, c = i.current;
    if (c !== e) {
      const h = o.current, m = i1(u);
      e ? l("MOUNT") : m === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(c && h !== m ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, l]), He(() => {
    if (t) {
      let u;
      const c = t.ownerDocument.defaultView ?? window, f = (m) => {
        const g = i1(r.current).includes(m.animationName);
        if (m.target === t && g && (l("ANIMATION_END"), !i.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = c.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, h = (m) => {
        m.target === t && (o.current = i1(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        c.clearTimeout(u), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: x.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function i1(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function G5e(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function RH(e) {
  const t = e + "CollectionProvider", [n, r] = MH(t), [i, o] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (m) => {
    const { scope: v, children: g } = m, y = F.useRef(null), w = F.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ d(i, { scope: v, itemMap: w, collectionRef: y, children: g });
  };
  a.displayName = t;
  const s = e + "CollectionSlot", l = F.forwardRef(
    (m, v) => {
      const { scope: g, children: y } = m, w = o(s, g), C = Ho(v, w.collectionRef);
      return /* @__PURE__ */ d(cm, { ref: C, children: y });
    }
  );
  l.displayName = s;
  const u = e + "CollectionItemSlot", c = "data-radix-collection-item", f = F.forwardRef(
    (m, v) => {
      const { scope: g, children: y, ...w } = m, C = F.useRef(null), S = Ho(v, C), N = o(u, g);
      return F.useEffect(() => (N.itemMap.set(C, { ref: C, ...w }), () => void N.itemMap.delete(C))), /* @__PURE__ */ d(cm, { [c]: "", ref: S, children: y });
    }
  );
  f.displayName = u;
  function h(m) {
    const v = o(e + "CollectionConsumer", m);
    return F.useCallback(() => {
      const y = v.collectionRef.current;
      if (!y) return [];
      const w = Array.from(y.querySelectorAll(`[${c}]`));
      return Array.from(v.itemMap.values()).sort(
        (N, E) => w.indexOf(N.ref.current) - w.indexOf(E.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: a, Slot: l, ItemSlot: f },
    h,
    r
  ];
}
var K5e = "DismissableLayer", Yx = "dismissableLayer.update", Y5e = "dismissableLayer.pointerDownOutside", Z5e = "dismissableLayer.focusOutside", Mk, DH = x.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), IH = x.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = e, u = x.useContext(DH), [c, f] = x.useState(null), h = (c == null ? void 0 : c.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = x.useState({}), v = Ho(t, (O) => f(O)), g = Array.from(u.layers), [y] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), w = g.indexOf(y), C = c ? g.indexOf(c) : -1, S = u.layersWithOutsidePointerEventsDisabled.size > 0, N = C >= w, E = Q5e((O) => {
      const T = O.target, M = [...u.branches].some((L) => L.contains(T));
      !N || M || (i == null || i(O), a == null || a(O), O.defaultPrevented || s == null || s());
    }, h), A = e8e((O) => {
      const T = O.target;
      [...u.branches].some((L) => L.contains(T)) || (o == null || o(O), a == null || a(O), O.defaultPrevented || s == null || s());
    }, h);
    return lu((O) => {
      C === u.layers.size - 1 && (r == null || r(O), !O.defaultPrevented && s && (O.preventDefault(), s()));
    }, h), x.useEffect(() => {
      if (c)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Mk = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(c)), u.layers.add(c), Rk(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = Mk);
        };
    }, [c, h, n, u]), x.useEffect(() => () => {
      c && (u.layers.delete(c), u.layersWithOutsidePointerEventsDisabled.delete(c), Rk());
    }, [c, u]), x.useEffect(() => {
      const O = () => m({});
      return document.addEventListener(Yx, O), () => document.removeEventListener(Yx, O);
    }, []), /* @__PURE__ */ d(
      Yr.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: S ? N ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: qn(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: qn(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: qn(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
IH.displayName = K5e;
var X5e = "DismissableLayerBranch", J5e = x.forwardRef((e, t) => {
  const n = x.useContext(DH), r = x.useRef(null), i = Ho(t, r);
  return x.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ d(Yr.div, { ...e, ref: i });
});
J5e.displayName = X5e;
function Q5e(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ie(e), r = x.useRef(!1), i = x.useRef(() => {
  });
  return x.useEffect(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          $H(
            Y5e,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = l, t.addEventListener("click", i.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function e8e(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ie(e), r = x.useRef(!1);
  return x.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && $H(Z5e, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Rk() {
  const e = new CustomEvent(Yx);
  document.dispatchEvent(e);
}
function $H(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? Kx(i, o) : i.dispatchEvent(o);
}
var t8e = "VisuallyHidden", LH = x.forwardRef(
  (e, t) => /* @__PURE__ */ d(
    Yr.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
LH.displayName = t8e;
var n8e = LH, Nd = "NavigationMenu", [XC, FH, r8e] = RH(Nd), [Zx, i8e, o8e] = RH(Nd), [JC, ret] = MH(
  Nd,
  [r8e, o8e]
), [a8e, Vi] = JC(Nd), [s8e, l8e] = JC(Nd), BH = x.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: r,
      onValueChange: i,
      defaultValue: o,
      delayDuration: a = 200,
      skipDelayDuration: s = 300,
      orientation: l = "horizontal",
      dir: u,
      ...c
    } = e, [f, h] = x.useState(null), m = Ho(t, (M) => h(M)), v = Bi(u), g = x.useRef(0), y = x.useRef(0), w = x.useRef(0), [C, S] = x.useState(!0), [N = "", E] = Kt({
      prop: r,
      onChange: (M) => {
        const L = M !== "", I = s > 0;
        L ? (window.clearTimeout(w.current), I && S(!1)) : (window.clearTimeout(w.current), w.current = window.setTimeout(
          () => S(!0),
          s
        )), i == null || i(M);
      },
      defaultProp: o
    }), A = x.useCallback(() => {
      window.clearTimeout(y.current), y.current = window.setTimeout(() => E(""), 150);
    }, [E]), O = x.useCallback(
      (M) => {
        window.clearTimeout(y.current), E(M);
      },
      [E]
    ), T = x.useCallback(
      (M) => {
        N === M ? window.clearTimeout(y.current) : g.current = window.setTimeout(() => {
          window.clearTimeout(y.current), E(M);
        }, a);
      },
      [N, E, a]
    );
    return x.useEffect(() => () => {
      window.clearTimeout(g.current), window.clearTimeout(y.current), window.clearTimeout(w.current);
    }, []), /* @__PURE__ */ d(
      VH,
      {
        scope: n,
        isRootMenu: !0,
        value: N,
        dir: v,
        orientation: l,
        rootNavigationMenu: f,
        onTriggerEnter: (M) => {
          window.clearTimeout(g.current), C ? T(M) : O(M);
        },
        onTriggerLeave: () => {
          window.clearTimeout(g.current), A();
        },
        onContentEnter: () => window.clearTimeout(y.current),
        onContentLeave: A,
        onItemSelect: (M) => {
          E((L) => L === M ? "" : M);
        },
        onItemDismiss: () => E(""),
        children: /* @__PURE__ */ d(
          Yr.nav,
          {
            "aria-label": "Main",
            "data-orientation": l,
            dir: v,
            ...c,
            ref: m
          }
        )
      }
    );
  }
);
BH.displayName = Nd;
var jH = "NavigationMenuSub", u8e = x.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: r,
      onValueChange: i,
      defaultValue: o,
      orientation: a = "horizontal",
      ...s
    } = e, l = Vi(jH, n), [u = "", c] = Kt({
      prop: r,
      onChange: i,
      defaultProp: o
    });
    return /* @__PURE__ */ d(
      VH,
      {
        scope: n,
        isRootMenu: !1,
        value: u,
        dir: l.dir,
        orientation: a,
        rootNavigationMenu: l.rootNavigationMenu,
        onTriggerEnter: (f) => c(f),
        onItemSelect: (f) => c(f),
        onItemDismiss: () => c(""),
        children: /* @__PURE__ */ d(Yr.div, { "data-orientation": a, ...s, ref: t })
      }
    );
  }
);
u8e.displayName = jH;
var VH = (e) => {
  const {
    scope: t,
    isRootMenu: n,
    rootNavigationMenu: r,
    dir: i,
    orientation: o,
    children: a,
    value: s,
    onItemSelect: l,
    onItemDismiss: u,
    onTriggerEnter: c,
    onTriggerLeave: f,
    onContentEnter: h,
    onContentLeave: m
  } = e, [v, g] = x.useState(null), [y, w] = x.useState(/* @__PURE__ */ new Map()), [C, S] = x.useState(null);
  return /* @__PURE__ */ d(
    a8e,
    {
      scope: t,
      isRootMenu: n,
      rootNavigationMenu: r,
      value: s,
      previousValue: bd(s),
      baseId: ln(),
      dir: i,
      orientation: o,
      viewport: v,
      onViewportChange: g,
      indicatorTrack: C,
      onIndicatorTrackChange: S,
      onTriggerEnter: Ie(c),
      onTriggerLeave: Ie(f),
      onContentEnter: Ie(h),
      onContentLeave: Ie(m),
      onItemSelect: Ie(l),
      onItemDismiss: Ie(u),
      onViewportContentChange: x.useCallback((N, E) => {
        w((A) => (A.set(N, E), new Map(A)));
      }, []),
      onViewportContentRemove: x.useCallback((N) => {
        w((E) => E.has(N) ? (E.delete(N), new Map(E)) : E);
      }, []),
      children: /* @__PURE__ */ d(XC.Provider, { scope: t, children: /* @__PURE__ */ d(s8e, { scope: t, items: y, children: a }) })
    }
  );
}, qH = "NavigationMenuList", zH = x.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...r } = e, i = Vi(qH, n), o = /* @__PURE__ */ d(Yr.ul, { "data-orientation": i.orientation, ...r, ref: t });
    return /* @__PURE__ */ d(Yr.div, { style: { position: "relative" }, ref: i.onIndicatorTrackChange, children: /* @__PURE__ */ d(XC.Slot, { scope: n, children: i.isRootMenu ? /* @__PURE__ */ d(QH, { asChild: !0, children: o }) : o }) });
  }
);
zH.displayName = qH;
var WH = "NavigationMenuItem", [c8e, HH] = JC(WH), UH = x.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, value: r, ...i } = e, o = ln(), a = r || o || "LEGACY_REACT_AUTO_VALUE", s = x.useRef(null), l = x.useRef(null), u = x.useRef(null), c = x.useRef(() => {
    }), f = x.useRef(!1), h = x.useCallback((v = "start") => {
      if (s.current) {
        c.current();
        const g = Jx(s.current);
        g.length && tS(v === "start" ? g : g.reverse());
      }
    }, []), m = x.useCallback(() => {
      if (s.current) {
        const v = Jx(s.current);
        v.length && (c.current = v8e(v));
      }
    }, []);
    return /* @__PURE__ */ d(
      c8e,
      {
        scope: n,
        value: a,
        triggerRef: l,
        contentRef: s,
        focusProxyRef: u,
        wasEscapeCloseRef: f,
        onEntryKeyDown: h,
        onFocusProxyEnter: h,
        onRootContentClose: m,
        onContentFocusOutside: m,
        children: /* @__PURE__ */ d(Yr.li, { ...i, ref: t })
      }
    );
  }
);
UH.displayName = WH;
var Xx = "NavigationMenuTrigger", GH = x.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, disabled: r, ...i } = e, o = Vi(Xx, e.__scopeNavigationMenu), a = HH(Xx, e.__scopeNavigationMenu), s = x.useRef(null), l = Ho(s, a.triggerRef, t), u = tU(o.baseId, a.value), c = nU(o.baseId, a.value), f = x.useRef(!1), h = x.useRef(!1), m = a.value === o.value;
  return /* @__PURE__ */ k(xe, { children: [
    /* @__PURE__ */ d(XC.ItemSlot, { scope: n, value: a.value, children: /* @__PURE__ */ d(eU, { asChild: !0, children: /* @__PURE__ */ d(
      Yr.button,
      {
        id: u,
        disabled: r,
        "data-disabled": r ? "" : void 0,
        "data-state": nS(m),
        "aria-expanded": m,
        "aria-controls": c,
        ...i,
        ref: l,
        onPointerEnter: qn(e.onPointerEnter, () => {
          h.current = !1, a.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: qn(
          e.onPointerMove,
          dm(() => {
            r || h.current || a.wasEscapeCloseRef.current || f.current || (o.onTriggerEnter(a.value), f.current = !0);
          })
        ),
        onPointerLeave: qn(
          e.onPointerLeave,
          dm(() => {
            r || (o.onTriggerLeave(), f.current = !1);
          })
        ),
        onClick: qn(e.onClick, () => {
          o.onItemSelect(a.value), h.current = m;
        }),
        onKeyDown: qn(e.onKeyDown, (v) => {
          const y = { horizontal: "ArrowDown", vertical: o.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[o.orientation];
          m && v.key === y && (a.onEntryKeyDown(), v.preventDefault());
        })
      }
    ) }) }),
    m && /* @__PURE__ */ k(xe, { children: [
      /* @__PURE__ */ d(
        n8e,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: a.focusProxyRef,
          onFocus: (v) => {
            const g = a.contentRef.current, y = v.relatedTarget, w = y === s.current, C = g == null ? void 0 : g.contains(y);
            (w || !C) && a.onFocusProxyEnter(w ? "start" : "end");
          }
        }
      ),
      o.viewport && /* @__PURE__ */ d("span", { "aria-owns": c })
    ] })
  ] });
});
GH.displayName = Xx;
var d8e = "NavigationMenuLink", Dk = "navigationMenu.linkSelect", KH = x.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, active: r, onSelect: i, ...o } = e;
    return /* @__PURE__ */ d(eU, { asChild: !0, children: /* @__PURE__ */ d(
      Yr.a,
      {
        "data-active": r ? "" : void 0,
        "aria-current": r ? "page" : void 0,
        ...o,
        ref: t,
        onClick: qn(
          e.onClick,
          (a) => {
            const s = a.target, l = new CustomEvent(Dk, {
              bubbles: !0,
              cancelable: !0
            });
            if (s.addEventListener(Dk, (u) => i == null ? void 0 : i(u), { once: !0 }), Kx(s, l), !l.defaultPrevented && !a.metaKey) {
              const u = new CustomEvent(V1, {
                bubbles: !0,
                cancelable: !0
              });
              Kx(s, u);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
KH.displayName = d8e;
var QC = "NavigationMenuIndicator", YH = x.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, i = Vi(QC, e.__scopeNavigationMenu), o = !!i.value;
  return i.indicatorTrack ? Zo.createPortal(
    /* @__PURE__ */ d(Sp, { present: n || o, children: /* @__PURE__ */ d(f8e, { ...r, ref: t }) }),
    i.indicatorTrack
  ) : null;
});
YH.displayName = QC;
var f8e = x.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, ...r } = e, i = Vi(QC, n), o = FH(n), [a, s] = x.useState(
    null
  ), [l, u] = x.useState(null), c = i.orientation === "horizontal", f = !!i.value;
  x.useEffect(() => {
    var g;
    const v = (g = o().find((y) => y.value === i.value)) == null ? void 0 : g.ref.current;
    v && s(v);
  }, [o, i.value]);
  const h = () => {
    a && u({
      size: c ? a.offsetWidth : a.offsetHeight,
      offset: c ? a.offsetLeft : a.offsetTop
    });
  };
  return Qx(a, h), Qx(i.indicatorTrack, h), l ? /* @__PURE__ */ d(
    Yr.div,
    {
      "aria-hidden": !0,
      "data-state": f ? "visible" : "hidden",
      "data-orientation": i.orientation,
      ...r,
      ref: t,
      style: {
        position: "absolute",
        ...c ? {
          left: 0,
          width: l.size + "px",
          transform: `translateX(${l.offset}px)`
        } : {
          top: 0,
          height: l.size + "px",
          transform: `translateY(${l.offset}px)`
        },
        ...r.style
      }
    }
  ) : null;
}), Tc = "NavigationMenuContent", ZH = x.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, i = Vi(Tc, e.__scopeNavigationMenu), o = HH(Tc, e.__scopeNavigationMenu), a = Ho(o.contentRef, t), s = o.value === i.value, l = {
    value: o.value,
    triggerRef: o.triggerRef,
    focusProxyRef: o.focusProxyRef,
    wasEscapeCloseRef: o.wasEscapeCloseRef,
    onContentFocusOutside: o.onContentFocusOutside,
    onRootContentClose: o.onRootContentClose,
    ...r
  };
  return i.viewport ? /* @__PURE__ */ d(h8e, { forceMount: n, ...l, ref: a }) : /* @__PURE__ */ d(Sp, { present: n || s, children: /* @__PURE__ */ d(
    XH,
    {
      "data-state": nS(s),
      ...l,
      ref: a,
      onPointerEnter: qn(e.onPointerEnter, i.onContentEnter),
      onPointerLeave: qn(
        e.onPointerLeave,
        dm(i.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !s && i.isRootMenu ? "none" : void 0,
        ...l.style
      }
    }
  ) });
});
ZH.displayName = Tc;
var h8e = x.forwardRef((e, t) => {
  const n = Vi(Tc, e.__scopeNavigationMenu), { onViewportContentChange: r, onViewportContentRemove: i } = n;
  return He(() => {
    r(e.value, {
      ref: t,
      ...e
    });
  }, [e, t, r]), He(() => () => i(e.value), [e.value, i]), null;
}), V1 = "navigationMenu.rootContentDismiss", XH = x.forwardRef((e, t) => {
  const {
    __scopeNavigationMenu: n,
    value: r,
    triggerRef: i,
    focusProxyRef: o,
    wasEscapeCloseRef: a,
    onRootContentClose: s,
    onContentFocusOutside: l,
    ...u
  } = e, c = Vi(Tc, n), f = x.useRef(null), h = Ho(f, t), m = tU(c.baseId, r), v = nU(c.baseId, r), g = FH(n), y = x.useRef(null), { onItemDismiss: w } = c;
  x.useEffect(() => {
    const S = f.current;
    if (c.isRootMenu && S) {
      const N = () => {
        var E;
        w(), s(), S.contains(document.activeElement) && ((E = i.current) == null || E.focus());
      };
      return S.addEventListener(V1, N), () => S.removeEventListener(V1, N);
    }
  }, [c.isRootMenu, e.value, i, w, s]);
  const C = x.useMemo(() => {
    const N = g().map((L) => L.value);
    c.dir === "rtl" && N.reverse();
    const E = N.indexOf(c.value), A = N.indexOf(c.previousValue), O = r === c.value, T = A === N.indexOf(r);
    if (!O && !T) return y.current;
    const M = (() => {
      if (E !== A) {
        if (O && A !== -1) return E > A ? "from-end" : "from-start";
        if (T && E !== -1) return E > A ? "to-start" : "to-end";
      }
      return null;
    })();
    return y.current = M, M;
  }, [c.previousValue, c.value, c.dir, g, r]);
  return /* @__PURE__ */ d(QH, { asChild: !0, children: /* @__PURE__ */ d(
    IH,
    {
      id: v,
      "aria-labelledby": m,
      "data-motion": C,
      "data-orientation": c.orientation,
      ...u,
      ref: h,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        var N;
        const S = new Event(V1, {
          bubbles: !0,
          cancelable: !0
        });
        (N = f.current) == null || N.dispatchEvent(S);
      },
      onFocusOutside: qn(e.onFocusOutside, (S) => {
        var E;
        l();
        const N = S.target;
        (E = c.rootNavigationMenu) != null && E.contains(N) && S.preventDefault();
      }),
      onPointerDownOutside: qn(e.onPointerDownOutside, (S) => {
        var O;
        const N = S.target, E = g().some((T) => {
          var M;
          return (M = T.ref.current) == null ? void 0 : M.contains(N);
        }), A = c.isRootMenu && ((O = c.viewport) == null ? void 0 : O.contains(N));
        (E || A || !c.isRootMenu) && S.preventDefault();
      }),
      onKeyDown: qn(e.onKeyDown, (S) => {
        var A;
        const N = S.altKey || S.ctrlKey || S.metaKey;
        if (S.key === "Tab" && !N) {
          const O = Jx(S.currentTarget), T = document.activeElement, M = O.findIndex((j) => j === T), I = S.shiftKey ? O.slice(0, M).reverse() : O.slice(M + 1, O.length);
          tS(I) ? S.preventDefault() : (A = o.current) == null || A.focus();
        }
      }),
      onEscapeKeyDown: qn(e.onEscapeKeyDown, (S) => {
        a.current = !0;
      })
    }
  ) });
}), eS = "NavigationMenuViewport", JH = x.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = !!Vi(eS, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ d(Sp, { present: n || o, children: /* @__PURE__ */ d(p8e, { ...r, ref: t }) });
});
JH.displayName = eS;
var p8e = x.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, children: r, ...i } = e, o = Vi(eS, n), a = Ho(t, o.onViewportChange), s = l8e(
    Tc,
    e.__scopeNavigationMenu
  ), [l, u] = x.useState(null), [c, f] = x.useState(null), h = l ? (l == null ? void 0 : l.width) + "px" : void 0, m = l ? (l == null ? void 0 : l.height) + "px" : void 0, v = !!o.value, g = v ? o.value : o.previousValue;
  return Qx(c, () => {
    c && u({ width: c.offsetWidth, height: c.offsetHeight });
  }), /* @__PURE__ */ d(
    Yr.div,
    {
      "data-state": nS(v),
      "data-orientation": o.orientation,
      ...i,
      ref: a,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !v && o.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": h,
        "--radix-navigation-menu-viewport-height": m,
        ...i.style
      },
      onPointerEnter: qn(e.onPointerEnter, o.onContentEnter),
      onPointerLeave: qn(e.onPointerLeave, dm(o.onContentLeave)),
      children: Array.from(s.items).map(([w, { ref: C, forceMount: S, ...N }]) => {
        const E = g === w;
        return /* @__PURE__ */ d(Sp, { present: S || E, children: /* @__PURE__ */ d(
          XH,
          {
            ...N,
            ref: ZC(C, (A) => {
              E && A && f(A);
            })
          }
        ) }, w);
      })
    }
  );
}), m8e = "FocusGroup", QH = x.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...r } = e, i = Vi(m8e, n);
    return /* @__PURE__ */ d(Zx.Provider, { scope: n, children: /* @__PURE__ */ d(Zx.Slot, { scope: n, children: /* @__PURE__ */ d(Yr.div, { dir: i.dir, ...r, ref: t }) }) });
  }
), Ik = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], g8e = "FocusGroupItem", eU = x.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...r } = e, i = i8e(n), o = Vi(g8e, n);
    return /* @__PURE__ */ d(Zx.ItemSlot, { scope: n, children: /* @__PURE__ */ d(
      Yr.button,
      {
        ...r,
        ref: t,
        onKeyDown: qn(e.onKeyDown, (a) => {
          if (["Home", "End", ...Ik].includes(a.key)) {
            let l = i().map((f) => f.ref.current);
            if ([o.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(a.key) && l.reverse(), Ik.includes(a.key)) {
              const f = l.indexOf(a.currentTarget);
              l = l.slice(f + 1);
            }
            setTimeout(() => tS(l)), a.preventDefault();
          }
        })
      }
    ) });
  }
);
function Jx(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function tS(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
function v8e(e) {
  return e.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((t) => {
      const n = t.dataset.tabindex;
      t.setAttribute("tabindex", n);
    });
  };
}
function Qx(e, t) {
  const n = Ie(t);
  He(() => {
    let r = 0;
    if (e) {
      const i = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return i.observe(e), () => {
        window.cancelAnimationFrame(r), i.unobserve(e);
      };
    }
  }, [e, n]);
}
function nS(e) {
  return e ? "open" : "closed";
}
function tU(e, t) {
  return `${e}-trigger-${t}`;
}
function nU(e, t) {
  return `${e}-content-${t}`;
}
function dm(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var rU = BH, iU = zH, y8e = UH, oU = GH, b8e = KH, aU = YH, sU = ZH, lU = JH;
const x8e = te(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ k(
  rU,
  {
    ref: r,
    className: z(
      "relative z-10 flex max-w-max flex-1 items-center justify-center",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ d(uU, {})
    ]
  }
));
x8e.displayName = rU.displayName;
const w8e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  iU,
  {
    ref: n,
    className: z(
      "group flex flex-1 list-none items-center justify-center space-x-1",
      e
    ),
    ...t
  }
));
w8e.displayName = iU.displayName;
const iet = y8e, C8e = Jo(
  "group inline-flex h-10 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-bodysm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-hidden disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50"
), S8e = te(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ k(
  oU,
  {
    ref: r,
    className: z(C8e(), "group", e),
    ...n,
    children: [
      t,
      " ",
      /* @__PURE__ */ d(
        tp,
        {
          className: "relative top-[1px] ml-1 h-3 w-3 transition duration-200 group-data-[state=open]:rotate-180",
          "aria-hidden": "true"
        }
      )
    ]
  }
));
S8e.displayName = oU.displayName;
const _8e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  sU,
  {
    ref: n,
    className: z(
      "data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52 left-0 top-0 w-full md:absolute md:w-auto ",
      e
    ),
    ...t
  }
));
_8e.displayName = sU.displayName;
const oet = b8e, uU = te(({ className: e, ...t }, n) => /* @__PURE__ */ d("div", { className: z("absolute left-0 top-full flex justify-center"), children: /* @__PURE__ */ d(
  lU,
  {
    className: z(
      "origin-top-center bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-90 relative mt-1.5 h-[var(--radix-navigation-menu-viewport-height)] w-full overflow-hidden rounded-md border shadow-lg md:w-[var(--radix-navigation-menu-viewport-width)]",
      e
    ),
    ref: n,
    ...t
  }
) }));
uU.displayName = lU.displayName;
const E8e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  aU,
  {
    ref: n,
    className: z(
      "data-[state=visible]:animate-in data-[state=hidden]:animate-out data-[state=hidden]:fade-out data-[state=visible]:fade-in top-full z-[1] flex h-1.5 items-end justify-center overflow-hidden",
      e
    ),
    ...t,
    children: /* @__PURE__ */ d("div", { className: "bg-border relative top-[60%] h-2 w-2 rotate-45 rounded-tl-sm shadow-md" })
  }
));
E8e.displayName = aU.displayName;
const N8e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  Cp,
  {
    className: z("grid gap-2", e),
    ...t,
    ref: n
  }
));
N8e.displayName = Cp.displayName;
const A8e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  As,
  {
    ref: n,
    className: z(
      "border-primary text-primary ring-offset-background focus-visible:ring-ring aspect-square h-4 w-4 rounded-full focus:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border",
      e
    ),
    ...t,
    children: /* @__PURE__ */ d(M5e, { className: "flex items-center justify-center", children: /* @__PURE__ */ d(Yf, { className: "h-2.5 w-2.5 fill-current text-current" }) })
  }
));
A8e.displayName = As.displayName;
function O8e({ checked: e, className: t }) {
  return /* @__PURE__ */ k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      className: t,
      children: [
        /* @__PURE__ */ d("rect", { x: "1", y: "1", width: "22", height: "22", rx: "11", fill: "none" }),
        /* @__PURE__ */ d(
          "rect",
          {
            x: "1",
            y: "1",
            width: "22",
            height: "22",
            rx: "11",
            stroke: "currentcolor",
            strokeWidth: "2"
          }
        ),
        /* @__PURE__ */ d("circle", { cx: "12", cy: "12", r: "8", fill: e ? "currentcolor" : "none" })
      ]
    }
  );
}
function cU({
  allowMultiSelect: e = !0,
  className: t,
  disabled: n,
  filter: r,
  hideHeader: i,
  hideSearch: o,
  onChange: a,
  onInputChange: s,
  options: l,
  placeholder: u,
  renderInline: c = !1,
  values: f
}) {
  const h = vt(null), [m, v] = re(c), [g, y] = re(""), w = yr(
    (C) => {
      const S = h.current;
      if (S) {
        if ((C.key === "Delete" || C.key === "Backspace") && S.value === "") {
          const N = [...f];
          N.pop(), a(N);
        }
        C.key === "Escape" && S.blur();
      }
    },
    [a, f]
  );
  return /* @__PURE__ */ k(
    xd,
    {
      className: "overflow-visible bg-transparent",
      filter: r,
      onKeyDown: w,
      children: [
        i ? null : /* @__PURE__ */ k(
          "div",
          {
            className: z(
              "border-input bg-interfaceWhite ring-offset-background focus-within:ring-ring text-bodysm focus:outline-hidden group flex w-full items-center justify-between rounded-md border px-3 py-2 focus-within:ring-2 focus-within:ring-offset-2",
              t
            ),
            ...o ? {
              tabIndex: 0,
              onBlur: () => {
                c || v(!1);
              },
              onFocus: () => v(!0)
            } : {},
            children: [
              /* @__PURE__ */ k("div", { className: "flex flex-wrap gap-1 text-ellipsis", children: [
                f.map((C, S) => {
                  const N = S === f.length - 1;
                  return /* @__PURE__ */ k("span", { children: [
                    C.label,
                    N ? null : ", "
                  ] }, C.value);
                }),
                u && o && f.length === 0 ? /* @__PURE__ */ d("span", { className: "text-muted-foreground bg-transparent", children: u }) : null,
                o ? null : /* @__PURE__ */ d(
                  sr.Input,
                  {
                    className: "placeholder:text-muted-foreground outline-hidden ml-2 flex-1 bg-transparent",
                    disabled: n,
                    onBlur: () => {
                      c || v(!1);
                    },
                    onFocus: () => v(!0),
                    onValueChange: (C) => {
                      y(C), s == null || s(C);
                    },
                    placeholder: u,
                    ref: h,
                    value: g
                  }
                )
              ] }),
              /* @__PURE__ */ d(
                "div",
                {
                  onClick: () => {
                    var C;
                    v((S) => !S), o || (C = h.current) == null || C.focus();
                  },
                  children: /* @__PURE__ */ d(tp, { className: "h-4 w-4" })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ d("div", { className: "relative", children: /* @__PURE__ */ d(cp, { children: m && l.length > 0 ? /* @__PURE__ */ d(
          "div",
          {
            className: z(
              "text-popover-foreground animate-in outline-hidden mt-2 max-h-64 w-full overflow-auto rounded-md shadow-md",
              c ? "" : "bg-popover border-border absolute top-0 z-10 border"
            ),
            children: /* @__PURE__ */ d(dp, { className: "h-full", children: l.map((C) => {
              const S = f.some((N) => N.value === C.value);
              return /* @__PURE__ */ k(
                fp,
                {
                  className: "text-bodymd cursor-pointer gap-2",
                  disabled: n,
                  keywords: C.keywords,
                  onMouseDown: (N) => {
                    N.preventDefault(), N.stopPropagation();
                  },
                  onSelect: (N) => {
                    if (y(""), s == null || s(""), !e)
                      a([C]);
                    else {
                      const E = f.some(
                        (A) => A.value === C.value
                      );
                      a(
                        E ? f.filter((A) => A.value !== C.value) : [...f, C]
                      );
                    }
                  },
                  children: [
                    e ? /* @__PURE__ */ d(Ol, { checked: S }) : /* @__PURE__ */ d(
                      O8e,
                      {
                        checked: S,
                        className: z(
                          "min-h-6 min-w-6",
                          S ? "text-textLink" : "text-interactiveBorder"
                        )
                      }
                    ),
                    C.label
                  ]
                },
                C.value
              );
            }) })
          }
        ) : null }) })
      ]
    }
  );
}
var k8e = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], e7 = k8e.reduce((e, t) => {
  const n = x.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? pi : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function vc(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function $k(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function P8e(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = $k(i, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : $k(e[i], null);
        }
      };
  };
}
function Lk(...e) {
  return x.useCallback(P8e(...e), e);
}
function T8e(e) {
  const t = e + "CollectionProvider", [n, r] = t2(t), [i, o] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (m) => {
    const { scope: v, children: g } = m, y = F.useRef(null), w = F.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ d(i, { scope: v, itemMap: w, collectionRef: y, children: g });
  };
  a.displayName = t;
  const s = e + "CollectionSlot", l = F.forwardRef(
    (m, v) => {
      const { scope: g, children: y } = m, w = o(s, g), C = Lk(v, w.collectionRef);
      return /* @__PURE__ */ d(pi, { ref: C, children: y });
    }
  );
  l.displayName = s;
  const u = e + "CollectionItemSlot", c = "data-radix-collection-item", f = F.forwardRef(
    (m, v) => {
      const { scope: g, children: y, ...w } = m, C = F.useRef(null), S = Lk(v, C), N = o(u, g);
      return F.useEffect(() => (N.itemMap.set(C, { ref: C, ...w }), () => void N.itemMap.delete(C))), /* @__PURE__ */ d(pi, { [c]: "", ref: S, children: y });
    }
  );
  f.displayName = u;
  function h(m) {
    const v = o(e + "CollectionConsumer", m);
    return F.useCallback(() => {
      const y = v.collectionRef.current;
      if (!y) return [];
      const w = Array.from(y.querySelectorAll(`[${c}]`));
      return Array.from(v.itemMap.values()).sort(
        (N, E) => w.indexOf(N.ref.current) - w.indexOf(E.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: a, Slot: l, ItemSlot: f },
    h,
    r
  ];
}
function Fk(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function M8e(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = Fk(i, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : Fk(e[i], null);
        }
      };
  };
}
function R8e(...e) {
  return x.useCallback(M8e(...e), e);
}
var D8e = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], dU = D8e.reduce((e, t) => {
  const n = x.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? pi : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), f3 = "rovingFocusGroup.onEntryFocus", I8e = { bubbles: !1, cancelable: !0 }, D2 = "RovingFocusGroup", [t7, fU, $8e] = T8e(D2), [L8e, hU] = t2(
  D2,
  [$8e]
), [F8e, B8e] = L8e(D2), pU = x.forwardRef(
  (e, t) => /* @__PURE__ */ d(t7.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ d(t7.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ d(j8e, { ...e, ref: t }) }) })
);
pU.displayName = D2;
var j8e = x.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: i = !1,
    dir: o,
    currentTabStopId: a,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: u,
    preventScrollOnEntryFocus: c = !1,
    ...f
  } = e, h = x.useRef(null), m = R8e(t, h), v = Bi(o), [g = null, y] = Kt({
    prop: a,
    defaultProp: s,
    onChange: l
  }), [w, C] = x.useState(!1), S = Ie(u), N = fU(n), E = x.useRef(!1), [A, O] = x.useState(0);
  return x.useEffect(() => {
    const T = h.current;
    if (T)
      return T.addEventListener(f3, S), () => T.removeEventListener(f3, S);
  }, [S]), /* @__PURE__ */ d(
    F8e,
    {
      scope: n,
      orientation: r,
      dir: v,
      loop: i,
      currentTabStopId: g,
      onItemFocus: x.useCallback(
        (T) => y(T),
        [y]
      ),
      onItemShiftTab: x.useCallback(() => C(!0), []),
      onFocusableItemAdd: x.useCallback(
        () => O((T) => T + 1),
        []
      ),
      onFocusableItemRemove: x.useCallback(
        () => O((T) => T - 1),
        []
      ),
      children: /* @__PURE__ */ d(
        dU.div,
        {
          tabIndex: w || A === 0 ? -1 : 0,
          "data-orientation": r,
          ...f,
          ref: m,
          style: { outline: "none", ...e.style },
          onMouseDown: vc(e.onMouseDown, () => {
            E.current = !0;
          }),
          onFocus: vc(e.onFocus, (T) => {
            const M = !E.current;
            if (T.target === T.currentTarget && M && !w) {
              const L = new CustomEvent(f3, I8e);
              if (T.currentTarget.dispatchEvent(L), !L.defaultPrevented) {
                const I = N().filter((U) => U.focusable), j = I.find((U) => U.active), B = I.find((U) => U.id === g), G = [j, B, ...I].filter(
                  Boolean
                ).map((U) => U.ref.current);
                vU(G, c);
              }
            }
            E.current = !1;
          }),
          onBlur: vc(e.onBlur, () => C(!1))
        }
      )
    }
  );
}), mU = "RovingFocusGroupItem", gU = x.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: i = !1,
      tabStopId: o,
      ...a
    } = e, s = ln(), l = o || s, u = B8e(mU, n), c = u.currentTabStopId === l, f = fU(n), { onFocusableItemAdd: h, onFocusableItemRemove: m } = u;
    return x.useEffect(() => {
      if (r)
        return h(), () => m();
    }, [r, h, m]), /* @__PURE__ */ d(
      t7.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: i,
        children: /* @__PURE__ */ d(
          dU.span,
          {
            tabIndex: c ? 0 : -1,
            "data-orientation": u.orientation,
            ...a,
            ref: t,
            onMouseDown: vc(e.onMouseDown, (v) => {
              r ? u.onItemFocus(l) : v.preventDefault();
            }),
            onFocus: vc(e.onFocus, () => u.onItemFocus(l)),
            onKeyDown: vc(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const g = z8e(v, u.orientation, u.dir);
              if (g !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let w = f().filter((C) => C.focusable).map((C) => C.ref.current);
                if (g === "last") w.reverse();
                else if (g === "prev" || g === "next") {
                  g === "prev" && w.reverse();
                  const C = w.indexOf(v.currentTarget);
                  w = u.loop ? W8e(w, C + 1) : w.slice(C + 1);
                }
                setTimeout(() => vU(w));
              }
            })
          }
        )
      }
    );
  }
);
gU.displayName = mU;
var V8e = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function q8e(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function z8e(e, t, n) {
  const r = q8e(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return V8e[r];
}
function vU(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function W8e(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var H8e = pU, U8e = gU;
function G8e(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
var K8e = "Toggle", yU = x.forwardRef((e, t) => {
  const { pressed: n, defaultPressed: r = !1, onPressedChange: i, ...o } = e, [a = !1, s] = Kt({
    prop: n,
    onChange: i,
    defaultProp: r
  });
  return /* @__PURE__ */ d(
    e7.button,
    {
      type: "button",
      "aria-pressed": a,
      "data-state": a ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...o,
      ref: t,
      onClick: G8e(e.onClick, () => {
        e.disabled || s(!a);
      })
    }
  );
});
yU.displayName = K8e;
var Ad = "ToggleGroup", [bU, aet] = t2(Ad, [
  hU
]), xU = hU(), rS = F.forwardRef((e, t) => {
  const { type: n, ...r } = e;
  if (n === "single")
    return /* @__PURE__ */ d(Y8e, { ...r, ref: t });
  if (n === "multiple")
    return /* @__PURE__ */ d(Z8e, { ...r, ref: t });
  throw new Error(`Missing prop \`type\` expected on \`${Ad}\``);
});
rS.displayName = Ad;
var [wU, CU] = bU(Ad), Y8e = F.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: i = () => {
    },
    ...o
  } = e, [a, s] = Kt({
    prop: n,
    defaultProp: r,
    onChange: i
  });
  return /* @__PURE__ */ d(
    wU,
    {
      scope: e.__scopeToggleGroup,
      type: "single",
      value: a ? [a] : [],
      onItemActivate: s,
      onItemDeactivate: F.useCallback(() => s(""), [s]),
      children: /* @__PURE__ */ d(SU, { ...o, ref: t })
    }
  );
}), Z8e = F.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: i = () => {
    },
    ...o
  } = e, [a = [], s] = Kt({
    prop: n,
    defaultProp: r,
    onChange: i
  }), l = F.useCallback(
    (c) => s((f = []) => [...f, c]),
    [s]
  ), u = F.useCallback(
    (c) => s((f = []) => f.filter((h) => h !== c)),
    [s]
  );
  return /* @__PURE__ */ d(
    wU,
    {
      scope: e.__scopeToggleGroup,
      type: "multiple",
      value: a,
      onItemActivate: l,
      onItemDeactivate: u,
      children: /* @__PURE__ */ d(SU, { ...o, ref: t })
    }
  );
});
rS.displayName = Ad;
var [X8e, J8e] = bU(Ad), SU = F.forwardRef(
  (e, t) => {
    const {
      __scopeToggleGroup: n,
      disabled: r = !1,
      rovingFocus: i = !0,
      orientation: o,
      dir: a,
      loop: s = !0,
      ...l
    } = e, u = xU(n), c = Bi(a), f = { role: "group", dir: c, ...l };
    return /* @__PURE__ */ d(X8e, { scope: n, rovingFocus: i, disabled: r, children: i ? /* @__PURE__ */ d(
      H8e,
      {
        asChild: !0,
        ...u,
        orientation: o,
        dir: c,
        loop: s,
        children: /* @__PURE__ */ d(e7.div, { ...f, ref: t })
      }
    ) : /* @__PURE__ */ d(e7.div, { ...f, ref: t }) });
  }
), fm = "ToggleGroupItem", _U = F.forwardRef(
  (e, t) => {
    const n = CU(fm, e.__scopeToggleGroup), r = J8e(fm, e.__scopeToggleGroup), i = xU(e.__scopeToggleGroup), o = n.value.includes(e.value), a = r.disabled || e.disabled, s = { ...e, pressed: o, disabled: a }, l = F.useRef(null);
    return r.rovingFocus ? /* @__PURE__ */ d(
      U8e,
      {
        asChild: !0,
        ...i,
        focusable: !a,
        active: o,
        ref: l,
        children: /* @__PURE__ */ d(Bk, { ...s, ref: t })
      }
    ) : /* @__PURE__ */ d(Bk, { ...s, ref: t });
  }
);
_U.displayName = fm;
var Bk = F.forwardRef(
  (e, t) => {
    const { __scopeToggleGroup: n, value: r, ...i } = e, o = CU(fm, n), a = { role: "radio", "aria-checked": e.pressed, "aria-pressed": void 0 }, s = o.type === "single" ? a : void 0;
    return /* @__PURE__ */ d(
      yU,
      {
        ...s,
        ...i,
        ref: t,
        onPressedChange: (l) => {
          l ? o.onItemActivate(r) : o.onItemDeactivate(r);
        }
      }
    );
  }
), Q8e = rS, exe = _U;
function txe({
  options: e,
  groupValue: t,
  setGroupValue: n
}) {
  return /* @__PURE__ */ d("div", { children: /* @__PURE__ */ d(
    Q8e,
    {
      className: "flex flex-row flex-wrap gap-1",
      type: "multiple",
      orientation: "horizontal",
      value: t,
      onValueChange: (r) => n(r),
      "aria-label": "Text alignment",
      children: e.length > 0 && e.map((r, i) => /* @__PURE__ */ k(
        exe,
        {
          className: "data-[state=on]:bg-actionBgSelect data-[state=on]:text-actionHover data-[state=on]:border-actionBorder border-interactiveBorder bg-interfaceWhite data-[state=off]:hover:bg-interfaceBgDefault data-[state=off]:hover:border-interactiveBorderHover flex flex-row items-center rounded-sm border px-3 py-2 text-bodymd font-normal data-[state=on]:border-2",
          value: r,
          children: [
            /* @__PURE__ */ d(
              "div",
              {
                className: `${t.includes(r) ? "bg-actionDefault border-none" : "bg-interfaceWhite"} border-interactiveBorder mr-1.5 flex h-3 w-3 items-center justify-center rounded-xs border`,
                children: t.includes(r) && /* @__PURE__ */ d(Gs, { className: "text-textWhite h-3 w-3" })
              }
            ),
            /* @__PURE__ */ d("div", { children: r })
          ]
        },
        i
      ))
    }
  ) });
}
function nxe(e, t) {
  return x.useReducer((n, r) => t[n][r] ?? n, e);
}
var _p = (e) => {
  const { present: t, children: n } = e, r = rxe(t), i = typeof n == "function" ? n({ present: r.isPresent }) : x.Children.only(n), o = tt(r.ref, ixe(i));
  return typeof n == "function" || r.isPresent ? x.cloneElement(i, { ref: o }) : null;
};
_p.displayName = "Presence";
function rxe(e) {
  const [t, n] = x.useState(), r = x.useRef({}), i = x.useRef(e), o = x.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = nxe(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return x.useEffect(() => {
    const u = o1(r.current);
    o.current = s === "mounted" ? u : "none";
  }, [s]), He(() => {
    const u = r.current, c = i.current;
    if (c !== e) {
      const h = o.current, m = o1(u);
      e ? l("MOUNT") : m === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(c && h !== m ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, l]), He(() => {
    if (t) {
      let u;
      const c = t.ownerDocument.defaultView ?? window, f = (m) => {
        const g = o1(r.current).includes(m.animationName);
        if (m.target === t && g && (l("ANIMATION_END"), !i.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = c.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, h = (m) => {
        m.target === t && (o.current = o1(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        c.clearTimeout(u), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: x.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function o1(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function ixe(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function oxe(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = x.createContext(a), l = n.length;
    n = [...n, a];
    const u = (f) => {
      var w;
      const { scope: h, children: m, ...v } = f, g = ((w = h == null ? void 0 : h[e]) == null ? void 0 : w[l]) || s, y = x.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ d(g.Provider, { value: y, children: m });
    };
    u.displayName = o + "Provider";
    function c(f, h) {
      var g;
      const m = ((g = h == null ? void 0 : h[e]) == null ? void 0 : g[l]) || s, v = x.useContext(m);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, c];
  }
  const i = () => {
    const o = n.map((a) => x.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return x.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, axe(i, ...t)];
}
function axe(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return x.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function rh(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function sxe(e, t) {
  return x.useReducer((n, r) => t[n][r] ?? n, e);
}
var iS = "ScrollArea", [EU, set] = oxe(iS), [lxe, qi] = EU(iS), NU = x.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: r = "hover",
      dir: i,
      scrollHideDelay: o = 600,
      ...a
    } = e, [s, l] = x.useState(null), [u, c] = x.useState(null), [f, h] = x.useState(null), [m, v] = x.useState(null), [g, y] = x.useState(null), [w, C] = x.useState(0), [S, N] = x.useState(0), [E, A] = x.useState(!1), [O, T] = x.useState(!1), M = tt(t, (I) => l(I)), L = Bi(i);
    return /* @__PURE__ */ d(
      lxe,
      {
        scope: n,
        type: r,
        dir: L,
        scrollHideDelay: o,
        scrollArea: s,
        viewport: u,
        onViewportChange: c,
        content: f,
        onContentChange: h,
        scrollbarX: m,
        onScrollbarXChange: v,
        scrollbarXEnabled: E,
        onScrollbarXEnabledChange: A,
        scrollbarY: g,
        onScrollbarYChange: y,
        scrollbarYEnabled: O,
        onScrollbarYEnabledChange: T,
        onCornerWidthChange: C,
        onCornerHeightChange: N,
        children: /* @__PURE__ */ d(
          Re.div,
          {
            dir: L,
            ...a,
            ref: M,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": S + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
NU.displayName = iS;
var AU = "ScrollAreaViewport", OU = x.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: r, nonce: i, ...o } = e, a = qi(AU, n), s = x.useRef(null), l = tt(t, s, a.onViewportChange);
    return /* @__PURE__ */ k(xe, { children: [
      /* @__PURE__ */ d(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: i
        }
      ),
      /* @__PURE__ */ d(
        Re.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...o,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: a.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: a.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ d("div", { ref: a.onContentChange, style: { minWidth: "100%", display: "table" }, children: r })
        }
      )
    ] });
  }
);
OU.displayName = AU;
var ea = "ScrollAreaScrollbar", oS = x.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, i = qi(ea, e.__scopeScrollArea), { onScrollbarXEnabledChange: o, onScrollbarYEnabledChange: a } = i, s = e.orientation === "horizontal";
    return x.useEffect(() => (s ? o(!0) : a(!0), () => {
      s ? o(!1) : a(!1);
    }), [s, o, a]), i.type === "hover" ? /* @__PURE__ */ d(uxe, { ...r, ref: t, forceMount: n }) : i.type === "scroll" ? /* @__PURE__ */ d(cxe, { ...r, ref: t, forceMount: n }) : i.type === "auto" ? /* @__PURE__ */ d(kU, { ...r, ref: t, forceMount: n }) : i.type === "always" ? /* @__PURE__ */ d(aS, { ...r, ref: t }) : null;
  }
);
oS.displayName = ea;
var uxe = x.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, i = qi(ea, e.__scopeScrollArea), [o, a] = x.useState(!1);
  return x.useEffect(() => {
    const s = i.scrollArea;
    let l = 0;
    if (s) {
      const u = () => {
        window.clearTimeout(l), a(!0);
      }, c = () => {
        l = window.setTimeout(() => a(!1), i.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", u), s.addEventListener("pointerleave", c), () => {
        window.clearTimeout(l), s.removeEventListener("pointerenter", u), s.removeEventListener("pointerleave", c);
      };
    }
  }, [i.scrollArea, i.scrollHideDelay]), /* @__PURE__ */ d(_p, { present: n || o, children: /* @__PURE__ */ d(
    kU,
    {
      "data-state": o ? "visible" : "hidden",
      ...r,
      ref: t
    }
  ) });
}), cxe = x.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, i = qi(ea, e.__scopeScrollArea), o = e.orientation === "horizontal", a = $2(() => l("SCROLL_END"), 100), [s, l] = sxe("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return x.useEffect(() => {
    if (s === "idle") {
      const u = window.setTimeout(() => l("HIDE"), i.scrollHideDelay);
      return () => window.clearTimeout(u);
    }
  }, [s, i.scrollHideDelay, l]), x.useEffect(() => {
    const u = i.viewport, c = o ? "scrollLeft" : "scrollTop";
    if (u) {
      let f = u[c];
      const h = () => {
        const m = u[c];
        f !== m && (l("SCROLL"), a()), f = m;
      };
      return u.addEventListener("scroll", h), () => u.removeEventListener("scroll", h);
    }
  }, [i.viewport, o, l, a]), /* @__PURE__ */ d(_p, { present: n || s !== "hidden", children: /* @__PURE__ */ d(
    aS,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...r,
      ref: t,
      onPointerEnter: Me(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: Me(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), kU = x.forwardRef((e, t) => {
  const n = qi(ea, e.__scopeScrollArea), { forceMount: r, ...i } = e, [o, a] = x.useState(!1), s = e.orientation === "horizontal", l = $2(() => {
    if (n.viewport) {
      const u = n.viewport.offsetWidth < n.viewport.scrollWidth, c = n.viewport.offsetHeight < n.viewport.scrollHeight;
      a(s ? u : c);
    }
  }, 10);
  return Mc(n.viewport, l), Mc(n.content, l), /* @__PURE__ */ d(_p, { present: r || o, children: /* @__PURE__ */ d(
    aS,
    {
      "data-state": o ? "visible" : "hidden",
      ...i,
      ref: t
    }
  ) });
}), aS = x.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...r } = e, i = qi(ea, e.__scopeScrollArea), o = x.useRef(null), a = x.useRef(0), [s, l] = x.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), u = DU(s.viewport, s.content), c = {
    ...r,
    sizes: s,
    onSizesChange: l,
    hasThumb: u > 0 && u < 1,
    onThumbChange: (h) => o.current = h,
    onThumbPointerUp: () => a.current = 0,
    onThumbPointerDown: (h) => a.current = h
  };
  function f(h, m) {
    return gxe(h, a.current, s, m);
  }
  return n === "horizontal" ? /* @__PURE__ */ d(
    dxe,
    {
      ...c,
      ref: t,
      onThumbPositionChange: () => {
        if (i.viewport && o.current) {
          const h = i.viewport.scrollLeft, m = jk(h, s, i.dir);
          o.current.style.transform = `translate3d(${m}px, 0, 0)`;
        }
      },
      onWheelScroll: (h) => {
        i.viewport && (i.viewport.scrollLeft = h);
      },
      onDragScroll: (h) => {
        i.viewport && (i.viewport.scrollLeft = f(h, i.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ d(
    fxe,
    {
      ...c,
      ref: t,
      onThumbPositionChange: () => {
        if (i.viewport && o.current) {
          const h = i.viewport.scrollTop, m = jk(h, s);
          o.current.style.transform = `translate3d(0, ${m}px, 0)`;
        }
      },
      onWheelScroll: (h) => {
        i.viewport && (i.viewport.scrollTop = h);
      },
      onDragScroll: (h) => {
        i.viewport && (i.viewport.scrollTop = f(h));
      }
    }
  ) : null;
}), dxe = x.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...i } = e, o = qi(ea, e.__scopeScrollArea), [a, s] = x.useState(), l = x.useRef(null), u = tt(t, l, o.onScrollbarXChange);
  return x.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ d(
    TU,
    {
      "data-orientation": "horizontal",
      ...i,
      ref: u,
      sizes: n,
      style: {
        bottom: 0,
        left: o.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: o.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": I2(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (c) => e.onThumbPointerDown(c.x),
      onDragScroll: (c) => e.onDragScroll(c.x),
      onWheelScroll: (c, f) => {
        if (o.viewport) {
          const h = o.viewport.scrollLeft + c.deltaX;
          e.onWheelScroll(h), $U(h, f) && c.preventDefault();
        }
      },
      onResize: () => {
        l.current && o.viewport && a && r({
          content: o.viewport.scrollWidth,
          viewport: o.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: pm(a.paddingLeft),
            paddingEnd: pm(a.paddingRight)
          }
        });
      }
    }
  );
}), fxe = x.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...i } = e, o = qi(ea, e.__scopeScrollArea), [a, s] = x.useState(), l = x.useRef(null), u = tt(t, l, o.onScrollbarYChange);
  return x.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ d(
    TU,
    {
      "data-orientation": "vertical",
      ...i,
      ref: u,
      sizes: n,
      style: {
        top: 0,
        right: o.dir === "ltr" ? 0 : void 0,
        left: o.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": I2(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (c) => e.onThumbPointerDown(c.y),
      onDragScroll: (c) => e.onDragScroll(c.y),
      onWheelScroll: (c, f) => {
        if (o.viewport) {
          const h = o.viewport.scrollTop + c.deltaY;
          e.onWheelScroll(h), $U(h, f) && c.preventDefault();
        }
      },
      onResize: () => {
        l.current && o.viewport && a && r({
          content: o.viewport.scrollHeight,
          viewport: o.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: pm(a.paddingTop),
            paddingEnd: pm(a.paddingBottom)
          }
        });
      }
    }
  );
}), [hxe, PU] = EU(ea), TU = x.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: r,
    hasThumb: i,
    onThumbChange: o,
    onThumbPointerUp: a,
    onThumbPointerDown: s,
    onThumbPositionChange: l,
    onDragScroll: u,
    onWheelScroll: c,
    onResize: f,
    ...h
  } = e, m = qi(ea, n), [v, g] = x.useState(null), y = tt(t, (M) => g(M)), w = x.useRef(null), C = x.useRef(""), S = m.viewport, N = r.content - r.viewport, E = Ie(c), A = Ie(l), O = $2(f, 10);
  function T(M) {
    if (w.current) {
      const L = M.clientX - w.current.left, I = M.clientY - w.current.top;
      u({ x: L, y: I });
    }
  }
  return x.useEffect(() => {
    const M = (L) => {
      const I = L.target;
      (v == null ? void 0 : v.contains(I)) && E(L, N);
    };
    return document.addEventListener("wheel", M, { passive: !1 }), () => document.removeEventListener("wheel", M, { passive: !1 });
  }, [S, v, N, E]), x.useEffect(A, [r, A]), Mc(v, O), Mc(m.content, O), /* @__PURE__ */ d(
    hxe,
    {
      scope: n,
      scrollbar: v,
      hasThumb: i,
      onThumbChange: Ie(o),
      onThumbPointerUp: Ie(a),
      onThumbPositionChange: A,
      onThumbPointerDown: Ie(s),
      children: /* @__PURE__ */ d(
        Re.div,
        {
          ...h,
          ref: y,
          style: { position: "absolute", ...h.style },
          onPointerDown: Me(e.onPointerDown, (M) => {
            M.button === 0 && (M.target.setPointerCapture(M.pointerId), w.current = v.getBoundingClientRect(), C.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", m.viewport && (m.viewport.style.scrollBehavior = "auto"), T(M));
          }),
          onPointerMove: Me(e.onPointerMove, T),
          onPointerUp: Me(e.onPointerUp, (M) => {
            const L = M.target;
            L.hasPointerCapture(M.pointerId) && L.releasePointerCapture(M.pointerId), document.body.style.webkitUserSelect = C.current, m.viewport && (m.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), hm = "ScrollAreaThumb", MU = x.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, i = PU(hm, e.__scopeScrollArea);
    return /* @__PURE__ */ d(_p, { present: n || i.hasThumb, children: /* @__PURE__ */ d(pxe, { ref: t, ...r }) });
  }
), pxe = x.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: r, ...i } = e, o = qi(hm, n), a = PU(hm, n), { onThumbPositionChange: s } = a, l = tt(
      t,
      (f) => a.onThumbChange(f)
    ), u = x.useRef(), c = $2(() => {
      u.current && (u.current(), u.current = void 0);
    }, 100);
    return x.useEffect(() => {
      const f = o.viewport;
      if (f) {
        const h = () => {
          if (c(), !u.current) {
            const m = vxe(f, s);
            u.current = m, s();
          }
        };
        return s(), f.addEventListener("scroll", h), () => f.removeEventListener("scroll", h);
      }
    }, [o.viewport, c, s]), /* @__PURE__ */ d(
      Re.div,
      {
        "data-state": a.hasThumb ? "visible" : "hidden",
        ...i,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...r
        },
        onPointerDownCapture: Me(e.onPointerDownCapture, (f) => {
          const m = f.target.getBoundingClientRect(), v = f.clientX - m.left, g = f.clientY - m.top;
          a.onThumbPointerDown({ x: v, y: g });
        }),
        onPointerUp: Me(e.onPointerUp, a.onThumbPointerUp)
      }
    );
  }
);
MU.displayName = hm;
var sS = "ScrollAreaCorner", RU = x.forwardRef(
  (e, t) => {
    const n = qi(sS, e.__scopeScrollArea), r = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && r ? /* @__PURE__ */ d(mxe, { ...e, ref: t }) : null;
  }
);
RU.displayName = sS;
var mxe = x.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...r } = e, i = qi(sS, n), [o, a] = x.useState(0), [s, l] = x.useState(0), u = !!(o && s);
  return Mc(i.scrollbarX, () => {
    var f;
    const c = ((f = i.scrollbarX) == null ? void 0 : f.offsetHeight) || 0;
    i.onCornerHeightChange(c), l(c);
  }), Mc(i.scrollbarY, () => {
    var f;
    const c = ((f = i.scrollbarY) == null ? void 0 : f.offsetWidth) || 0;
    i.onCornerWidthChange(c), a(c);
  }), u ? /* @__PURE__ */ d(
    Re.div,
    {
      ...r,
      ref: t,
      style: {
        width: o,
        height: s,
        position: "absolute",
        right: i.dir === "ltr" ? 0 : void 0,
        left: i.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function pm(e) {
  return e ? parseInt(e, 10) : 0;
}
function DU(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function I2(e) {
  const t = DU(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
  return Math.max(r, 18);
}
function gxe(e, t, n, r = "ltr") {
  const i = I2(n), o = i / 2, a = t || o, s = i - a, l = n.scrollbar.paddingStart + a, u = n.scrollbar.size - n.scrollbar.paddingEnd - s, c = n.content - n.viewport, f = r === "ltr" ? [0, c] : [c * -1, 0];
  return IU([l, u], f)(e);
}
function jk(e, t, n = "ltr") {
  const r = I2(t), i = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, o = t.scrollbar.size - i, a = t.content - t.viewport, s = o - r, l = n === "ltr" ? [0, a] : [a * -1, 0], u = rh(e, l);
  return IU([0, a], [0, s])(u);
}
function IU(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function $U(e, t) {
  return e > 0 && e < t;
}
var vxe = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, r = 0;
  return function i() {
    const o = { left: e.scrollLeft, top: e.scrollTop }, a = n.left !== o.left, s = n.top !== o.top;
    (a || s) && t(), n = o, r = window.requestAnimationFrame(i);
  }(), () => window.cancelAnimationFrame(r);
};
function $2(e, t) {
  const n = Ie(e), r = x.useRef(0);
  return x.useEffect(() => () => window.clearTimeout(r.current), []), x.useCallback(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(n, t);
  }, [n, t]);
}
function Mc(e, t) {
  const n = Ie(t);
  He(() => {
    let r = 0;
    if (e) {
      const i = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return i.observe(e), () => {
        window.cancelAnimationFrame(r), i.unobserve(e);
      };
    }
  }, [e, n]);
}
var LU = NU, yxe = OU, bxe = RU;
const xxe = te(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ k(
  LU,
  {
    ref: r,
    className: z("relative overflow-hidden", e),
    ...n,
    children: [
      /* @__PURE__ */ d(yxe, { className: "h-full w-full rounded-[inherit]", children: t }),
      /* @__PURE__ */ d(FU, {}),
      /* @__PURE__ */ d(bxe, {})
    ]
  }
));
xxe.displayName = LU.displayName;
const FU = te(({ className: e, orientation: t = "vertical", ...n }, r) => /* @__PURE__ */ d(
  oS,
  {
    ref: r,
    orientation: t,
    className: z(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...n,
    children: /* @__PURE__ */ d(MU, { className: "bg-border relative flex-1 rounded-full" })
  }
));
FU.displayName = oS.displayName;
function yn(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function lS(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = x.createContext(a), l = n.length;
    n = [...n, a];
    const u = (f) => {
      var w;
      const { scope: h, children: m, ...v } = f, g = ((w = h == null ? void 0 : h[e]) == null ? void 0 : w[l]) || s, y = x.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ d(g.Provider, { value: y, children: m });
    };
    u.displayName = o + "Provider";
    function c(f, h) {
      var g;
      const m = ((g = h == null ? void 0 : h[e]) == null ? void 0 : g[l]) || s, v = x.useContext(m);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, c];
  }
  const i = () => {
    const o = n.map((a) => x.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return x.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, wxe(i, ...t)];
}
function wxe(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return x.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Vk(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function BU(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = Vk(i, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : Vk(e[i], null);
        }
      };
  };
}
function or(...e) {
  return x.useCallback(BU(...e), e);
}
var ih = x.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = x.Children.toArray(n), o = i.find(Sxe);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? x.Children.count(a) > 1 ? x.Children.only(null) : x.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ d(n7, { ...r, ref: t, children: x.isValidElement(a) ? x.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ d(n7, { ...r, ref: t, children: n });
});
ih.displayName = "Slot";
var n7 = x.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (x.isValidElement(n)) {
    const i = Exe(n);
    return x.cloneElement(n, {
      ..._xe(r, n.props),
      // @ts-ignore
      ref: t ? BU(t, i) : i
    });
  }
  return x.Children.count(n) > 1 ? x.Children.only(null) : null;
});
n7.displayName = "SlotClone";
var Cxe = ({ children: e }) => /* @__PURE__ */ d(xe, { children: e });
function Sxe(e) {
  return x.isValidElement(e) && e.type === Cxe;
}
function _xe(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Exe(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Nxe(e) {
  const t = e + "CollectionProvider", [n, r] = lS(t), [i, o] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (m) => {
    const { scope: v, children: g } = m, y = F.useRef(null), w = F.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ d(i, { scope: v, itemMap: w, collectionRef: y, children: g });
  };
  a.displayName = t;
  const s = e + "CollectionSlot", l = F.forwardRef(
    (m, v) => {
      const { scope: g, children: y } = m, w = o(s, g), C = or(v, w.collectionRef);
      return /* @__PURE__ */ d(ih, { ref: C, children: y });
    }
  );
  l.displayName = s;
  const u = e + "CollectionItemSlot", c = "data-radix-collection-item", f = F.forwardRef(
    (m, v) => {
      const { scope: g, children: y, ...w } = m, C = F.useRef(null), S = or(v, C), N = o(u, g);
      return F.useEffect(() => (N.itemMap.set(C, { ref: C, ...w }), () => void N.itemMap.delete(C))), /* @__PURE__ */ d(ih, { [c]: "", ref: S, children: y });
    }
  );
  f.displayName = u;
  function h(m) {
    const v = o(e + "CollectionConsumer", m);
    return F.useCallback(() => {
      const y = v.collectionRef.current;
      if (!y) return [];
      const w = Array.from(y.querySelectorAll(`[${c}]`));
      return Array.from(v.itemMap.values()).sort(
        (N, E) => w.indexOf(N.ref.current) - w.indexOf(E.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: a, Slot: l, ItemSlot: f },
    h,
    r
  ];
}
var Axe = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], wn = Axe.reduce((e, t) => {
  const n = x.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? ih : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Oxe(e, t) {
  e && go.flushSync(() => e.dispatchEvent(t));
}
var kxe = "DismissableLayer", r7 = "dismissableLayer.update", Pxe = "dismissableLayer.pointerDownOutside", Txe = "dismissableLayer.focusOutside", qk, jU = x.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), VU = x.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = e, u = x.useContext(jU), [c, f] = x.useState(null), h = (c == null ? void 0 : c.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = x.useState({}), v = or(t, (O) => f(O)), g = Array.from(u.layers), [y] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), w = g.indexOf(y), C = c ? g.indexOf(c) : -1, S = u.layersWithOutsidePointerEventsDisabled.size > 0, N = C >= w, E = Dxe((O) => {
      const T = O.target, M = [...u.branches].some((L) => L.contains(T));
      !N || M || (i == null || i(O), a == null || a(O), O.defaultPrevented || s == null || s());
    }, h), A = Ixe((O) => {
      const T = O.target;
      [...u.branches].some((L) => L.contains(T)) || (o == null || o(O), a == null || a(O), O.defaultPrevented || s == null || s());
    }, h);
    return lu((O) => {
      C === u.layers.size - 1 && (r == null || r(O), !O.defaultPrevented && s && (O.preventDefault(), s()));
    }, h), x.useEffect(() => {
      if (c)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (qk = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(c)), u.layers.add(c), zk(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = qk);
        };
    }, [c, h, n, u]), x.useEffect(() => () => {
      c && (u.layers.delete(c), u.layersWithOutsidePointerEventsDisabled.delete(c), zk());
    }, [c, u]), x.useEffect(() => {
      const O = () => m({});
      return document.addEventListener(r7, O), () => document.removeEventListener(r7, O);
    }, []), /* @__PURE__ */ d(
      wn.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: S ? N ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: yn(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: yn(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: yn(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
VU.displayName = kxe;
var Mxe = "DismissableLayerBranch", Rxe = x.forwardRef((e, t) => {
  const n = x.useContext(jU), r = x.useRef(null), i = or(t, r);
  return x.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ d(wn.div, { ...e, ref: i });
});
Rxe.displayName = Mxe;
function Dxe(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ie(e), r = x.useRef(!1), i = x.useRef(() => {
  });
  return x.useEffect(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          qU(
            Pxe,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = l, t.addEventListener("click", i.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Ixe(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ie(e), r = x.useRef(!1);
  return x.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && qU(Txe, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function zk() {
  const e = new CustomEvent(r7);
  document.dispatchEvent(e);
}
function qU(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? Oxe(i, o) : i.dispatchEvent(o);
}
var h3 = "focusScope.autoFocusOnMount", p3 = "focusScope.autoFocusOnUnmount", Wk = { bubbles: !1, cancelable: !0 }, $xe = "FocusScope", zU = x.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o,
    ...a
  } = e, [s, l] = x.useState(null), u = Ie(i), c = Ie(o), f = x.useRef(null), h = or(t, (g) => l(g)), m = x.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  x.useEffect(() => {
    if (r) {
      let g = function(S) {
        if (m.paused || !s) return;
        const N = S.target;
        s.contains(N) ? f.current = N : gs(f.current, { select: !0 });
      }, y = function(S) {
        if (m.paused || !s) return;
        const N = S.relatedTarget;
        N !== null && (s.contains(N) || gs(f.current, { select: !0 }));
      }, w = function(S) {
        if (document.activeElement === document.body)
          for (const E of S)
            E.removedNodes.length > 0 && gs(s);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", y);
      const C = new MutationObserver(w);
      return s && C.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", y), C.disconnect();
      };
    }
  }, [r, s, m.paused]), x.useEffect(() => {
    if (s) {
      Uk.add(m);
      const g = document.activeElement;
      if (!s.contains(g)) {
        const w = new CustomEvent(h3, Wk);
        s.addEventListener(h3, u), s.dispatchEvent(w), w.defaultPrevented || (Lxe(qxe(WU(s)), { select: !0 }), document.activeElement === g && gs(s));
      }
      return () => {
        s.removeEventListener(h3, u), setTimeout(() => {
          const w = new CustomEvent(p3, Wk);
          s.addEventListener(p3, c), s.dispatchEvent(w), w.defaultPrevented || gs(g ?? document.body, { select: !0 }), s.removeEventListener(p3, c), Uk.remove(m);
        }, 0);
      };
    }
  }, [s, u, c, m]);
  const v = x.useCallback(
    (g) => {
      if (!n && !r || m.paused) return;
      const y = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, w = document.activeElement;
      if (y && w) {
        const C = g.currentTarget, [S, N] = Fxe(C);
        S && N ? !g.shiftKey && w === N ? (g.preventDefault(), n && gs(S, { select: !0 })) : g.shiftKey && w === S && (g.preventDefault(), n && gs(N, { select: !0 })) : w === C && g.preventDefault();
      }
    },
    [n, r, m.paused]
  );
  return /* @__PURE__ */ d(wn.div, { tabIndex: -1, ...a, ref: h, onKeyDown: v });
});
zU.displayName = $xe;
function Lxe(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (gs(r, { select: t }), document.activeElement !== n) return;
}
function Fxe(e) {
  const t = WU(e), n = Hk(t, e), r = Hk(t.reverse(), e);
  return [n, r];
}
function WU(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Hk(e, t) {
  for (const n of e)
    if (!Bxe(n, { upTo: t })) return n;
}
function Bxe(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function jxe(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function gs(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && jxe(e) && t && e.select();
  }
}
var Uk = Vxe();
function Vxe() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Gk(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Gk(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Gk(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function qxe(e) {
  return e.filter((t) => t.tagName !== "A");
}
var zxe = "Arrow", HU = x.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: i = 5, ...o } = e;
  return /* @__PURE__ */ d(
    wn.svg,
    {
      ...o,
      ref: t,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ d("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
HU.displayName = zxe;
var Wxe = HU, uS = "Popper", [UU, GU] = lS(uS), [Hxe, KU] = UU(uS), YU = (e) => {
  const { __scopePopper: t, children: n } = e, [r, i] = x.useState(null);
  return /* @__PURE__ */ d(Hxe, { scope: t, anchor: r, onAnchorChange: i, children: n });
};
YU.displayName = uS;
var ZU = "PopperAnchor", XU = x.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...i } = e, o = KU(ZU, n), a = x.useRef(null), s = or(t, a);
    return x.useEffect(() => {
      o.onAnchorChange((r == null ? void 0 : r.current) || a.current);
    }), r ? null : /* @__PURE__ */ d(wn.div, { ...i, ref: s });
  }
);
XU.displayName = ZU;
var cS = "PopperContent", [Uxe, Gxe] = UU(cS), JU = x.forwardRef(
  (e, t) => {
    var ge, Ce, ie, ye, ve, Q;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: i = 0,
      align: o = "center",
      alignOffset: a = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: u = [],
      collisionPadding: c = 0,
      sticky: f = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: v,
      ...g
    } = e, y = KU(cS, n), [w, C] = x.useState(null), S = or(t, (Oe) => C(Oe)), [N, E] = x.useState(null), A = uu(N), O = (A == null ? void 0 : A.width) ?? 0, T = (A == null ? void 0 : A.height) ?? 0, M = r + (o !== "center" ? "-" + o : ""), L = typeof c == "number" ? c : { top: 0, right: 0, bottom: 0, left: 0, ...c }, I = Array.isArray(u) ? u : [u], j = I.length > 0, B = {
      padding: L,
      boundary: I.filter(Yxe),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: j
    }, { refs: q, floatingStyles: G, placement: U, isPositioned: V, middlewareData: H } = s2({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: M,
      whileElementsMounted: (...Oe) => a2(...Oe, {
        animationFrame: m === "always"
      }),
      elements: {
        reference: y.anchor
      },
      middleware: [
        l2({ mainAxis: i + T, alignmentAxis: a }),
        l && u2({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? c2() : void 0,
          ...B
        }),
        l && d2({ ...B }),
        f2({
          ...B,
          apply: ({ elements: Oe, rects: se, availableWidth: nt, availableHeight: ut }) => {
            const { width: st, height: Nn } = se.reference, Dt = Oe.floating.style;
            Dt.setProperty("--radix-popper-available-width", `${nt}px`), Dt.setProperty("--radix-popper-available-height", `${ut}px`), Dt.setProperty("--radix-popper-anchor-width", `${st}px`), Dt.setProperty("--radix-popper-anchor-height", `${Nn}px`);
          }
        }),
        N && p2({ element: N, padding: s }),
        Zxe({ arrowWidth: O, arrowHeight: T }),
        h && h2({ strategy: "referenceHidden", ...B })
      ]
    }), [Z, de] = tG(U), ne = Ie(v);
    He(() => {
      V && (ne == null || ne());
    }, [V, ne]);
    const Y = (ge = H.arrow) == null ? void 0 : ge.x, le = (Ce = H.arrow) == null ? void 0 : Ce.y, be = ((ie = H.arrow) == null ? void 0 : ie.centerOffset) !== 0, [pe, Ee] = x.useState();
    return He(() => {
      w && Ee(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ d(
      "div",
      {
        ref: q.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...G,
          transform: V ? G.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: pe,
          "--radix-popper-transform-origin": [
            (ye = H.transformOrigin) == null ? void 0 : ye.x,
            (ve = H.transformOrigin) == null ? void 0 : ve.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Q = H.hide) == null ? void 0 : Q.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ d(
          Uxe,
          {
            scope: n,
            placedSide: Z,
            onArrowChange: E,
            arrowX: Y,
            arrowY: le,
            shouldHideArrow: be,
            children: /* @__PURE__ */ d(
              wn.div,
              {
                "data-side": Z,
                "data-align": de,
                ...g,
                ref: S,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: V ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
JU.displayName = cS;
var QU = "PopperArrow", Kxe = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, eG = x.forwardRef(function(t, n) {
  const { __scopePopper: r, ...i } = t, o = Gxe(QU, r), a = Kxe[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ d(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ d(
          Wxe,
          {
            ...i,
            ref: n,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
eG.displayName = QU;
function Yxe(e) {
  return e !== null;
}
var Zxe = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var y, w, C;
    const { placement: n, rects: r, middlewareData: i } = t, a = ((y = i.arrow) == null ? void 0 : y.centerOffset) !== 0, s = a ? 0 : e.arrowWidth, l = a ? 0 : e.arrowHeight, [u, c] = tG(n), f = { start: "0%", center: "50%", end: "100%" }[c], h = (((w = i.arrow) == null ? void 0 : w.x) ?? 0) + s / 2, m = (((C = i.arrow) == null ? void 0 : C.y) ?? 0) + l / 2;
    let v = "", g = "";
    return u === "bottom" ? (v = a ? f : `${h}px`, g = `${-l}px`) : u === "top" ? (v = a ? f : `${h}px`, g = `${r.floating.height + l}px`) : u === "right" ? (v = `${-l}px`, g = a ? f : `${m}px`) : u === "left" && (v = `${r.floating.width + l}px`, g = a ? f : `${m}px`), { data: { x: v, y: g } };
  }
});
function tG(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Xxe = YU, Jxe = XU, Qxe = JU, e7e = eG, t7e = "Portal", nG = x.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [i, o] = x.useState(!1);
  He(() => o(!0), []);
  const a = n || i && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return a ? Zo.createPortal(/* @__PURE__ */ d(wn.div, { ...r, ref: t }), a) : null;
});
nG.displayName = t7e;
var n7e = "VisuallyHidden", rG = x.forwardRef(
  (e, t) => /* @__PURE__ */ d(
    wn.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
rG.displayName = n7e;
var q1 = "right-scroll-bar-position", z1 = "width-before-scroll-bar", r7e = "with-scroll-bars-hidden", i7e = "--removed-body-scroll-bar-size";
function m3(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function o7e(e, t) {
  var n = re(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var a7e = typeof window < "u" ? x.useLayoutEffect : x.useEffect, Kk = /* @__PURE__ */ new WeakMap();
function s7e(e, t) {
  var n = o7e(null, function(r) {
    return e.forEach(function(i) {
      return m3(i, r);
    });
  });
  return a7e(function() {
    var r = Kk.get(n);
    if (r) {
      var i = new Set(r), o = new Set(e), a = n.current;
      i.forEach(function(s) {
        o.has(s) || m3(s, null);
      }), o.forEach(function(s) {
        i.has(s) || m3(s, a);
      });
    }
    Kk.set(n, e);
  }, [e]), n;
}
function l7e(e) {
  return e;
}
function u7e(e, t) {
  t === void 0 && (t = l7e);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(o) {
      var a = t(o, r);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(o);
      }
      n = {
        push: function(s) {
          return o(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(o), a = n;
      }
      var l = function() {
        var c = a;
        a = [], c.forEach(o);
      }, u = function() {
        return Promise.resolve().then(l);
      };
      u(), n = {
        push: function(c) {
          a.push(c), u();
        },
        filter: function(c) {
          return a = a.filter(c), n;
        }
      };
    }
  };
  return i;
}
function c7e(e) {
  e === void 0 && (e = {});
  var t = u7e(null);
  return t.options = Ke({ async: !0, ssr: !1 }, e), t;
}
var iG = function(e) {
  var t = e.sideCar, n = Qo(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return x.createElement(r, Ke({}, n));
};
iG.isSideCarExport = !0;
function d7e(e, t) {
  return e.useMedium(t), iG;
}
var oG = c7e(), g3 = function() {
}, L2 = x.forwardRef(function(e, t) {
  var n = x.useRef(null), r = x.useState({
    onScrollCapture: g3,
    onWheelCapture: g3,
    onTouchMoveCapture: g3
  }), i = r[0], o = r[1], a = e.forwardProps, s = e.children, l = e.className, u = e.removeScrollBar, c = e.enabled, f = e.shards, h = e.sideCar, m = e.noIsolation, v = e.inert, g = e.allowPinchZoom, y = e.as, w = y === void 0 ? "div" : y, C = e.gapMode, S = Qo(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), N = h, E = s7e([n, t]), A = Ke(Ke({}, S), i);
  return x.createElement(
    x.Fragment,
    null,
    c && x.createElement(N, { sideCar: oG, removeScrollBar: u, shards: f, noIsolation: m, inert: v, setCallbacks: o, allowPinchZoom: !!g, lockRef: n, gapMode: C }),
    a ? x.cloneElement(x.Children.only(s), Ke(Ke({}, A), { ref: E })) : x.createElement(w, Ke({}, A, { className: l, ref: E }), s)
  );
});
L2.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
L2.classNames = {
  fullWidth: z1,
  zeroRight: q1
};
function f7e() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Kg();
  return t && e.setAttribute("nonce", t), e;
}
function h7e(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function p7e(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var m7e = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = f7e()) && (h7e(t, n), p7e(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, g7e = function() {
  var e = m7e();
  return function(t, n) {
    x.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, aG = function() {
  var e = g7e(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, v7e = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, v3 = function(e) {
  return parseInt(e || "", 10) || 0;
}, y7e = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [v3(n), v3(r), v3(i)];
}, b7e = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return v7e;
  var t = y7e(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, x7e = aG(), yc = "data-scroll-locked", w7e = function(e, t, n, r) {
  var i = e.left, o = e.top, a = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(r7e, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(yc, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(q1, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(z1, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(q1, " .").concat(q1, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(z1, " .").concat(z1, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(yc, `] {
    `).concat(i7e, ": ").concat(s, `px;
  }
`);
}, Yk = function() {
  var e = parseInt(document.body.getAttribute(yc) || "0", 10);
  return isFinite(e) ? e : 0;
}, C7e = function() {
  x.useEffect(function() {
    return document.body.setAttribute(yc, (Yk() + 1).toString()), function() {
      var e = Yk() - 1;
      e <= 0 ? document.body.removeAttribute(yc) : document.body.setAttribute(yc, e.toString());
    };
  }, []);
}, S7e = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
  C7e();
  var o = x.useMemo(function() {
    return b7e(i);
  }, [i]);
  return x.createElement(x7e, { styles: w7e(o, !t, i, n ? "" : "!important") });
}, i7 = !1;
if (typeof window < "u")
  try {
    var a1 = Object.defineProperty({}, "passive", {
      get: function() {
        return i7 = !0, !0;
      }
    });
    window.addEventListener("test", a1, a1), window.removeEventListener("test", a1, a1);
  } catch {
    i7 = !1;
  }
var Uu = i7 ? { passive: !1 } : !1, _7e = function(e) {
  return e.tagName === "TEXTAREA";
}, sG = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !_7e(e) && n[t] === "visible")
  );
}, E7e = function(e) {
  return sG(e, "overflowY");
}, N7e = function(e) {
  return sG(e, "overflowX");
}, Zk = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = lG(e, r);
    if (i) {
      var o = uG(e, r), a = o[1], s = o[2];
      if (a > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, A7e = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, O7e = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, lG = function(e, t) {
  return e === "v" ? E7e(t) : N7e(t);
}, uG = function(e, t) {
  return e === "v" ? A7e(t) : O7e(t);
}, k7e = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, P7e = function(e, t, n, r, i) {
  var o = k7e(e, window.getComputedStyle(t).direction), a = o * r, s = n.target, l = t.contains(s), u = !1, c = a > 0, f = 0, h = 0;
  do {
    var m = uG(e, s), v = m[0], g = m[1], y = m[2], w = g - y - o * v;
    (v || w) && lG(e, s) && (f += w, h += v), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (c && Math.abs(f) < 1 || !c && Math.abs(h) < 1) && (u = !0), u;
}, s1 = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Xk = function(e) {
  return [e.deltaX, e.deltaY];
}, Jk = function(e) {
  return e && "current" in e ? e.current : e;
}, T7e = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, M7e = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, R7e = 0, Gu = [];
function D7e(e) {
  var t = x.useRef([]), n = x.useRef([0, 0]), r = x.useRef(), i = x.useState(R7e++)[0], o = x.useState(aG)[0], a = x.useRef(e);
  x.useEffect(function() {
    a.current = e;
  }, [e]), x.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var g = vd([e.lockRef.current], (e.shards || []).map(Jk), !0).filter(Boolean);
      return g.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), g.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = x.useCallback(function(g, y) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !a.current.allowPinchZoom;
    var w = s1(g), C = n.current, S = "deltaX" in g ? g.deltaX : C[0] - w[0], N = "deltaY" in g ? g.deltaY : C[1] - w[1], E, A = g.target, O = Math.abs(S) > Math.abs(N) ? "h" : "v";
    if ("touches" in g && O === "h" && A.type === "range")
      return !1;
    var T = Zk(O, A);
    if (!T)
      return !0;
    if (T ? E = O : (E = O === "v" ? "h" : "v", T = Zk(O, A)), !T)
      return !1;
    if (!r.current && "changedTouches" in g && (S || N) && (r.current = E), !E)
      return !0;
    var M = r.current || E;
    return P7e(M, y, g, M === "h" ? S : N);
  }, []), l = x.useCallback(function(g) {
    var y = g;
    if (!(!Gu.length || Gu[Gu.length - 1] !== o)) {
      var w = "deltaY" in y ? Xk(y) : s1(y), C = t.current.filter(function(E) {
        return E.name === y.type && (E.target === y.target || y.target === E.shadowParent) && T7e(E.delta, w);
      })[0];
      if (C && C.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!C) {
        var S = (a.current.shards || []).map(Jk).filter(Boolean).filter(function(E) {
          return E.contains(y.target);
        }), N = S.length > 0 ? s(y, S[0]) : !a.current.noIsolation;
        N && y.cancelable && y.preventDefault();
      }
    }
  }, []), u = x.useCallback(function(g, y, w, C) {
    var S = { name: g, delta: y, target: w, should: C, shadowParent: I7e(w) };
    t.current.push(S), setTimeout(function() {
      t.current = t.current.filter(function(N) {
        return N !== S;
      });
    }, 1);
  }, []), c = x.useCallback(function(g) {
    n.current = s1(g), r.current = void 0;
  }, []), f = x.useCallback(function(g) {
    u(g.type, Xk(g), g.target, s(g, e.lockRef.current));
  }, []), h = x.useCallback(function(g) {
    u(g.type, s1(g), g.target, s(g, e.lockRef.current));
  }, []);
  x.useEffect(function() {
    return Gu.push(o), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, Uu), document.addEventListener("touchmove", l, Uu), document.addEventListener("touchstart", c, Uu), function() {
      Gu = Gu.filter(function(g) {
        return g !== o;
      }), document.removeEventListener("wheel", l, Uu), document.removeEventListener("touchmove", l, Uu), document.removeEventListener("touchstart", c, Uu);
    };
  }, []);
  var m = e.removeScrollBar, v = e.inert;
  return x.createElement(
    x.Fragment,
    null,
    v ? x.createElement(o, { styles: M7e(i) }) : null,
    m ? x.createElement(S7e, { gapMode: e.gapMode }) : null
  );
}
function I7e(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const $7e = d7e(oG, D7e);
var cG = x.forwardRef(function(e, t) {
  return x.createElement(L2, Ke({}, e, { ref: t, sideCar: $7e }));
});
cG.classNames = L2.classNames;
var L7e = [" ", "Enter", "ArrowUp", "ArrowDown"], F7e = [" ", "Enter"], Ep = "Select", [F2, B2, B7e] = Nxe(Ep), [Od, uet] = lS(Ep, [
  B7e,
  GU
]), j2 = GU(), [j7e, Xs] = Od(Ep), [V7e, q7e] = Od(Ep), dG = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    value: a,
    defaultValue: s,
    onValueChange: l,
    dir: u,
    name: c,
    autoComplete: f,
    disabled: h,
    required: m,
    form: v
  } = e, g = j2(t), [y, w] = x.useState(null), [C, S] = x.useState(null), [N, E] = x.useState(!1), A = Bi(u), [O = !1, T] = Kt({
    prop: r,
    defaultProp: i,
    onChange: o
  }), [M, L] = Kt({
    prop: a,
    defaultProp: s,
    onChange: l
  }), I = x.useRef(null), j = y ? v || !!y.closest("form") : !0, [B, q] = x.useState(/* @__PURE__ */ new Set()), G = Array.from(B).map((U) => U.props.value).join(";");
  return /* @__PURE__ */ d(Xxe, { ...g, children: /* @__PURE__ */ k(
    j7e,
    {
      required: m,
      scope: t,
      trigger: y,
      onTriggerChange: w,
      valueNode: C,
      onValueNodeChange: S,
      valueNodeHasChildren: N,
      onValueNodeHasChildrenChange: E,
      contentId: ln(),
      value: M,
      onValueChange: L,
      open: O,
      onOpenChange: T,
      dir: A,
      triggerPointerDownPosRef: I,
      disabled: h,
      children: [
        /* @__PURE__ */ d(F2.Provider, { scope: t, children: /* @__PURE__ */ d(
          V7e,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: x.useCallback((U) => {
              q((V) => new Set(V).add(U));
            }, []),
            onNativeOptionRemove: x.useCallback((U) => {
              q((V) => {
                const H = new Set(V);
                return H.delete(U), H;
              });
            }, []),
            children: n
          }
        ) }),
        j ? /* @__PURE__ */ k(
          IG,
          {
            "aria-hidden": !0,
            required: m,
            tabIndex: -1,
            name: c,
            autoComplete: f,
            value: M,
            onChange: (U) => L(U.target.value),
            disabled: h,
            form: v,
            children: [
              M === void 0 ? /* @__PURE__ */ d("option", { value: "" }) : null,
              Array.from(B)
            ]
          },
          G
        ) : null
      ]
    }
  ) });
};
dG.displayName = Ep;
var fG = "SelectTrigger", hG = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...i } = e, o = j2(n), a = Xs(fG, n), s = a.disabled || r, l = or(t, a.onTriggerChange), u = B2(n), c = x.useRef("touch"), [f, h, m] = $G((g) => {
      const y = u().filter((S) => !S.disabled), w = y.find((S) => S.value === a.value), C = LG(y, g, w);
      C !== void 0 && a.onValueChange(C.value);
    }), v = (g) => {
      s || (a.onOpenChange(!0), m()), g && (a.triggerPointerDownPosRef.current = {
        x: Math.round(g.pageX),
        y: Math.round(g.pageY)
      });
    };
    return /* @__PURE__ */ d(Jxe, { asChild: !0, ...o, children: /* @__PURE__ */ d(
      wn.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": DG(a.value) ? "" : void 0,
        ...i,
        ref: l,
        onClick: yn(i.onClick, (g) => {
          g.currentTarget.focus(), c.current !== "mouse" && v(g);
        }),
        onPointerDown: yn(i.onPointerDown, (g) => {
          c.current = g.pointerType;
          const y = g.target;
          y.hasPointerCapture(g.pointerId) && y.releasePointerCapture(g.pointerId), g.button === 0 && g.ctrlKey === !1 && g.pointerType === "mouse" && (v(g), g.preventDefault());
        }),
        onKeyDown: yn(i.onKeyDown, (g) => {
          const y = f.current !== "";
          !(g.ctrlKey || g.altKey || g.metaKey) && g.key.length === 1 && h(g.key), !(y && g.key === " ") && L7e.includes(g.key) && (v(), g.preventDefault());
        })
      }
    ) });
  }
);
hG.displayName = fG;
var pG = "SelectValue", mG = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: i, children: o, placeholder: a = "", ...s } = e, l = Xs(pG, n), { onValueNodeHasChildrenChange: u } = l, c = o !== void 0, f = or(t, l.onValueNodeChange);
    return He(() => {
      u(c);
    }, [u, c]), /* @__PURE__ */ d(
      wn.span,
      {
        ...s,
        ref: f,
        style: { pointerEvents: "none" },
        children: DG(l.value) ? /* @__PURE__ */ d(xe, { children: a }) : o
      }
    );
  }
);
mG.displayName = pG;
var z7e = "SelectIcon", gG = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...i } = e;
    return /* @__PURE__ */ d(wn.span, { "aria-hidden": !0, ...i, ref: t, children: r || "▼" });
  }
);
gG.displayName = z7e;
var W7e = "SelectPortal", vG = (e) => /* @__PURE__ */ d(nG, { asChild: !0, ...e });
vG.displayName = W7e;
var Ql = "SelectContent", yG = x.forwardRef(
  (e, t) => {
    const n = Xs(Ql, e.__scopeSelect), [r, i] = x.useState();
    if (He(() => {
      i(new DocumentFragment());
    }, []), !n.open) {
      const o = r;
      return o ? go.createPortal(
        /* @__PURE__ */ d(bG, { scope: e.__scopeSelect, children: /* @__PURE__ */ d(F2.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ d("div", { children: e.children }) }) }),
        o
      ) : null;
    }
    return /* @__PURE__ */ d(xG, { ...e, ref: t });
  }
);
yG.displayName = Ql;
var Xi = 10, [bG, Js] = Od(Ql), H7e = "SelectContentImpl", xG = x.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: i,
      onEscapeKeyDown: o,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: s,
      sideOffset: l,
      align: u,
      alignOffset: c,
      arrowPadding: f,
      collisionBoundary: h,
      collisionPadding: m,
      sticky: v,
      hideWhenDetached: g,
      avoidCollisions: y,
      //
      ...w
    } = e, C = Xs(Ql, n), [S, N] = x.useState(null), [E, A] = x.useState(null), O = or(t, (ge) => N(ge)), [T, M] = x.useState(null), [L, I] = x.useState(
      null
    ), j = B2(n), [B, q] = x.useState(!1), G = x.useRef(!1);
    x.useEffect(() => {
      if (S) return yd(S);
    }, [S]), Vw();
    const U = x.useCallback(
      (ge) => {
        const [Ce, ...ie] = j().map((Q) => Q.ref.current), [ye] = ie.slice(-1), ve = document.activeElement;
        for (const Q of ge)
          if (Q === ve || (Q == null || Q.scrollIntoView({ block: "nearest" }), Q === Ce && E && (E.scrollTop = 0), Q === ye && E && (E.scrollTop = E.scrollHeight), Q == null || Q.focus(), document.activeElement !== ve)) return;
      },
      [j, E]
    ), V = x.useCallback(
      () => U([T, S]),
      [U, T, S]
    );
    x.useEffect(() => {
      B && V();
    }, [B, V]);
    const { onOpenChange: H, triggerPointerDownPosRef: Z } = C;
    x.useEffect(() => {
      if (S) {
        let ge = { x: 0, y: 0 };
        const Ce = (ye) => {
          var ve, Q;
          ge = {
            x: Math.abs(Math.round(ye.pageX) - (((ve = Z.current) == null ? void 0 : ve.x) ?? 0)),
            y: Math.abs(Math.round(ye.pageY) - (((Q = Z.current) == null ? void 0 : Q.y) ?? 0))
          };
        }, ie = (ye) => {
          ge.x <= 10 && ge.y <= 10 ? ye.preventDefault() : S.contains(ye.target) || H(!1), document.removeEventListener("pointermove", Ce), Z.current = null;
        };
        return Z.current !== null && (document.addEventListener("pointermove", Ce), document.addEventListener("pointerup", ie, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Ce), document.removeEventListener("pointerup", ie, { capture: !0 });
        };
      }
    }, [S, H, Z]), x.useEffect(() => {
      const ge = () => H(!1);
      return window.addEventListener("blur", ge), window.addEventListener("resize", ge), () => {
        window.removeEventListener("blur", ge), window.removeEventListener("resize", ge);
      };
    }, [H]);
    const [de, ne] = $G((ge) => {
      const Ce = j().filter((ve) => !ve.disabled), ie = Ce.find((ve) => ve.ref.current === document.activeElement), ye = LG(Ce, ge, ie);
      ye && setTimeout(() => ye.ref.current.focus());
    }), Y = x.useCallback(
      (ge, Ce, ie) => {
        const ye = !G.current && !ie;
        (C.value !== void 0 && C.value === Ce || ye) && (M(ge), ye && (G.current = !0));
      },
      [C.value]
    ), le = x.useCallback(() => S == null ? void 0 : S.focus(), [S]), be = x.useCallback(
      (ge, Ce, ie) => {
        const ye = !G.current && !ie;
        (C.value !== void 0 && C.value === Ce || ye) && I(ge);
      },
      [C.value]
    ), pe = r === "popper" ? o7 : wG, Ee = pe === o7 ? {
      side: s,
      sideOffset: l,
      align: u,
      alignOffset: c,
      arrowPadding: f,
      collisionBoundary: h,
      collisionPadding: m,
      sticky: v,
      hideWhenDetached: g,
      avoidCollisions: y
    } : {};
    return /* @__PURE__ */ d(
      bG,
      {
        scope: n,
        content: S,
        viewport: E,
        onViewportChange: A,
        itemRefCallback: Y,
        selectedItem: T,
        onItemLeave: le,
        itemTextRefCallback: be,
        focusSelectedItem: V,
        selectedItemText: L,
        position: r,
        isPositioned: B,
        searchRef: de,
        children: /* @__PURE__ */ d(cG, { as: ih, allowPinchZoom: !0, children: /* @__PURE__ */ d(
          zU,
          {
            asChild: !0,
            trapped: C.open,
            onMountAutoFocus: (ge) => {
              ge.preventDefault();
            },
            onUnmountAutoFocus: yn(i, (ge) => {
              var Ce;
              (Ce = C.trigger) == null || Ce.focus({ preventScroll: !0 }), ge.preventDefault();
            }),
            children: /* @__PURE__ */ d(
              VU,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: o,
                onPointerDownOutside: a,
                onFocusOutside: (ge) => ge.preventDefault(),
                onDismiss: () => C.onOpenChange(!1),
                children: /* @__PURE__ */ d(
                  pe,
                  {
                    role: "listbox",
                    id: C.contentId,
                    "data-state": C.open ? "open" : "closed",
                    dir: C.dir,
                    onContextMenu: (ge) => ge.preventDefault(),
                    ...w,
                    ...Ee,
                    onPlaced: () => q(!0),
                    ref: O,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...w.style
                    },
                    onKeyDown: yn(w.onKeyDown, (ge) => {
                      const Ce = ge.ctrlKey || ge.altKey || ge.metaKey;
                      if (ge.key === "Tab" && ge.preventDefault(), !Ce && ge.key.length === 1 && ne(ge.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(ge.key)) {
                        let ye = j().filter((ve) => !ve.disabled).map((ve) => ve.ref.current);
                        if (["ArrowUp", "End"].includes(ge.key) && (ye = ye.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(ge.key)) {
                          const ve = ge.target, Q = ye.indexOf(ve);
                          ye = ye.slice(Q + 1);
                        }
                        setTimeout(() => U(ye)), ge.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
xG.displayName = H7e;
var U7e = "SelectItemAlignedPosition", wG = x.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...i } = e, o = Xs(Ql, n), a = Js(Ql, n), [s, l] = x.useState(null), [u, c] = x.useState(null), f = or(t, (O) => c(O)), h = B2(n), m = x.useRef(!1), v = x.useRef(!0), { viewport: g, selectedItem: y, selectedItemText: w, focusSelectedItem: C } = a, S = x.useCallback(() => {
    if (o.trigger && o.valueNode && s && u && g && y && w) {
      const O = o.trigger.getBoundingClientRect(), T = u.getBoundingClientRect(), M = o.valueNode.getBoundingClientRect(), L = w.getBoundingClientRect();
      if (o.dir !== "rtl") {
        const ve = L.left - T.left, Q = M.left - ve, Oe = O.left - Q, se = O.width + Oe, nt = Math.max(se, T.width), ut = window.innerWidth - Xi, st = rh(Q, [
          Xi,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Xi, ut - nt)
        ]);
        s.style.minWidth = se + "px", s.style.left = st + "px";
      } else {
        const ve = T.right - L.right, Q = window.innerWidth - M.right - ve, Oe = window.innerWidth - O.right - Q, se = O.width + Oe, nt = Math.max(se, T.width), ut = window.innerWidth - Xi, st = rh(Q, [
          Xi,
          Math.max(Xi, ut - nt)
        ]);
        s.style.minWidth = se + "px", s.style.right = st + "px";
      }
      const I = h(), j = window.innerHeight - Xi * 2, B = g.scrollHeight, q = window.getComputedStyle(u), G = parseInt(q.borderTopWidth, 10), U = parseInt(q.paddingTop, 10), V = parseInt(q.borderBottomWidth, 10), H = parseInt(q.paddingBottom, 10), Z = G + U + B + H + V, de = Math.min(y.offsetHeight * 5, Z), ne = window.getComputedStyle(g), Y = parseInt(ne.paddingTop, 10), le = parseInt(ne.paddingBottom, 10), be = O.top + O.height / 2 - Xi, pe = j - be, Ee = y.offsetHeight / 2, ge = y.offsetTop + Ee, Ce = G + U + ge, ie = Z - Ce;
      if (Ce <= be) {
        const ve = I.length > 0 && y === I[I.length - 1].ref.current;
        s.style.bottom = "0px";
        const Q = u.clientHeight - g.offsetTop - g.offsetHeight, Oe = Math.max(
          pe,
          Ee + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (ve ? le : 0) + Q + V
        ), se = Ce + Oe;
        s.style.height = se + "px";
      } else {
        const ve = I.length > 0 && y === I[0].ref.current;
        s.style.top = "0px";
        const Oe = Math.max(
          be,
          G + g.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (ve ? Y : 0) + Ee
        ) + ie;
        s.style.height = Oe + "px", g.scrollTop = Ce - be + g.offsetTop;
      }
      s.style.margin = `${Xi}px 0`, s.style.minHeight = de + "px", s.style.maxHeight = j + "px", r == null || r(), requestAnimationFrame(() => m.current = !0);
    }
  }, [
    h,
    o.trigger,
    o.valueNode,
    s,
    u,
    g,
    y,
    w,
    o.dir,
    r
  ]);
  He(() => S(), [S]);
  const [N, E] = x.useState();
  He(() => {
    u && E(window.getComputedStyle(u).zIndex);
  }, [u]);
  const A = x.useCallback(
    (O) => {
      O && v.current === !0 && (S(), C == null || C(), v.current = !1);
    },
    [S, C]
  );
  return /* @__PURE__ */ d(
    K7e,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: m,
      onScrollButtonChange: A,
      children: /* @__PURE__ */ d(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: N
          },
          children: /* @__PURE__ */ d(
            wn.div,
            {
              ...i,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...i.style
              }
            }
          )
        }
      )
    }
  );
});
wG.displayName = U7e;
var G7e = "SelectPopperPosition", o7 = x.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: i = Xi,
    ...o
  } = e, a = j2(n);
  return /* @__PURE__ */ d(
    Qxe,
    {
      ...a,
      ...o,
      ref: t,
      align: r,
      collisionPadding: i,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...o.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
o7.displayName = G7e;
var [K7e, dS] = Od(Ql, {}), a7 = "SelectViewport", CG = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...i } = e, o = Js(a7, n), a = dS(a7, n), s = or(t, o.onViewportChange), l = x.useRef(0);
    return /* @__PURE__ */ k(xe, { children: [
      /* @__PURE__ */ d(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ d(F2.Slot, { scope: n, children: /* @__PURE__ */ d(
        wn.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...i,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...i.style
          },
          onScroll: yn(i.onScroll, (u) => {
            const c = u.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: h } = a;
            if (h != null && h.current && f) {
              const m = Math.abs(l.current - c.scrollTop);
              if (m > 0) {
                const v = window.innerHeight - Xi * 2, g = parseFloat(f.style.minHeight), y = parseFloat(f.style.height), w = Math.max(g, y);
                if (w < v) {
                  const C = w + m, S = Math.min(v, C), N = C - S;
                  f.style.height = S + "px", f.style.bottom === "0px" && (c.scrollTop = N > 0 ? N : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = c.scrollTop;
          })
        }
      ) })
    ] });
  }
);
CG.displayName = a7;
var SG = "SelectGroup", [Y7e, Z7e] = Od(SG), _G = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, i = ln();
    return /* @__PURE__ */ d(Y7e, { scope: n, id: i, children: /* @__PURE__ */ d(wn.div, { role: "group", "aria-labelledby": i, ...r, ref: t }) });
  }
);
_G.displayName = SG;
var EG = "SelectLabel", NG = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, i = Z7e(EG, n);
    return /* @__PURE__ */ d(wn.div, { id: i.id, ...r, ref: t });
  }
);
NG.displayName = EG;
var mm = "SelectItem", [X7e, AG] = Od(mm), OG = x.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: i = !1,
      textValue: o,
      ...a
    } = e, s = Xs(mm, n), l = Js(mm, n), u = s.value === r, [c, f] = x.useState(o ?? ""), [h, m] = x.useState(!1), v = or(
      t,
      (C) => {
        var S;
        return (S = l.itemRefCallback) == null ? void 0 : S.call(l, C, r, i);
      }
    ), g = ln(), y = x.useRef("touch"), w = () => {
      i || (s.onValueChange(r), s.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ d(
      X7e,
      {
        scope: n,
        value: r,
        disabled: i,
        textId: g,
        isSelected: u,
        onItemTextChange: x.useCallback((C) => {
          f((S) => S || ((C == null ? void 0 : C.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ d(
          F2.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: i,
            textValue: c,
            children: /* @__PURE__ */ d(
              wn.div,
              {
                role: "option",
                "aria-labelledby": g,
                "data-highlighted": h ? "" : void 0,
                "aria-selected": u && h,
                "data-state": u ? "checked" : "unchecked",
                "aria-disabled": i || void 0,
                "data-disabled": i ? "" : void 0,
                tabIndex: i ? void 0 : -1,
                ...a,
                ref: v,
                onFocus: yn(a.onFocus, () => m(!0)),
                onBlur: yn(a.onBlur, () => m(!1)),
                onClick: yn(a.onClick, () => {
                  y.current !== "mouse" && w();
                }),
                onPointerUp: yn(a.onPointerUp, () => {
                  y.current === "mouse" && w();
                }),
                onPointerDown: yn(a.onPointerDown, (C) => {
                  y.current = C.pointerType;
                }),
                onPointerMove: yn(a.onPointerMove, (C) => {
                  var S;
                  y.current = C.pointerType, i ? (S = l.onItemLeave) == null || S.call(l) : y.current === "mouse" && C.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: yn(a.onPointerLeave, (C) => {
                  var S;
                  C.currentTarget === document.activeElement && ((S = l.onItemLeave) == null || S.call(l));
                }),
                onKeyDown: yn(a.onKeyDown, (C) => {
                  var N;
                  ((N = l.searchRef) == null ? void 0 : N.current) !== "" && C.key === " " || (F7e.includes(C.key) && w(), C.key === " " && C.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
OG.displayName = mm;
var Af = "SelectItemText", kG = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: i, ...o } = e, a = Xs(Af, n), s = Js(Af, n), l = AG(Af, n), u = q7e(Af, n), [c, f] = x.useState(null), h = or(
      t,
      (w) => f(w),
      l.onItemTextChange,
      (w) => {
        var C;
        return (C = s.itemTextRefCallback) == null ? void 0 : C.call(s, w, l.value, l.disabled);
      }
    ), m = c == null ? void 0 : c.textContent, v = x.useMemo(
      () => /* @__PURE__ */ d("option", { value: l.value, disabled: l.disabled, children: m }, l.value),
      [l.disabled, l.value, m]
    ), { onNativeOptionAdd: g, onNativeOptionRemove: y } = u;
    return He(() => (g(v), () => y(v)), [g, y, v]), /* @__PURE__ */ k(xe, { children: [
      /* @__PURE__ */ d(wn.span, { id: l.textId, ...o, ref: h }),
      l.isSelected && a.valueNode && !a.valueNodeHasChildren ? go.createPortal(o.children, a.valueNode) : null
    ] });
  }
);
kG.displayName = Af;
var PG = "SelectItemIndicator", TG = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return AG(PG, n).isSelected ? /* @__PURE__ */ d(wn.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
TG.displayName = PG;
var s7 = "SelectScrollUpButton", J7e = x.forwardRef((e, t) => {
  const n = Js(s7, e.__scopeSelect), r = dS(s7, e.__scopeSelect), [i, o] = x.useState(!1), a = or(t, r.onScrollButtonChange);
  return He(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const u = l.scrollTop > 0;
        o(u);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ d(
    MG,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
J7e.displayName = s7;
var l7 = "SelectScrollDownButton", Q7e = x.forwardRef((e, t) => {
  const n = Js(l7, e.__scopeSelect), r = dS(l7, e.__scopeSelect), [i, o] = x.useState(!1), a = or(t, r.onScrollButtonChange);
  return He(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const u = l.scrollHeight - l.clientHeight, c = Math.ceil(l.scrollTop) < u;
        o(c);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ d(
    MG,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
Q7e.displayName = l7;
var MG = x.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...i } = e, o = Js("SelectScrollButton", n), a = x.useRef(null), s = B2(n), l = x.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return x.useEffect(() => () => l(), [l]), He(() => {
    var c;
    const u = s().find((f) => f.ref.current === document.activeElement);
    (c = u == null ? void 0 : u.ref.current) == null || c.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ d(
    wn.div,
    {
      "aria-hidden": !0,
      ...i,
      ref: t,
      style: { flexShrink: 0, ...i.style },
      onPointerDown: yn(i.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerMove: yn(i.onPointerMove, () => {
        var u;
        (u = o.onItemLeave) == null || u.call(o), a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerLeave: yn(i.onPointerLeave, () => {
        l();
      })
    }
  );
}), e9e = "SelectSeparator", RG = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ d(wn.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
RG.displayName = e9e;
var u7 = "SelectArrow", t9e = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, i = j2(n), o = Xs(u7, n), a = Js(u7, n);
    return o.open && a.position === "popper" ? /* @__PURE__ */ d(e7e, { ...i, ...r, ref: t }) : null;
  }
);
t9e.displayName = u7;
function DG(e) {
  return e === "" || e === void 0;
}
var IG = x.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, i = x.useRef(null), o = or(t, i), a = bd(n);
    return x.useEffect(() => {
      const s = i.current, l = window.HTMLSelectElement.prototype, c = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (a !== n && c) {
        const f = new Event("change", { bubbles: !0 });
        c.call(s, n), s.dispatchEvent(f);
      }
    }, [a, n]), /* @__PURE__ */ d(rG, { asChild: !0, children: /* @__PURE__ */ d("select", { ...r, ref: o, defaultValue: n }) });
  }
);
IG.displayName = "BubbleSelect";
function $G(e) {
  const t = Ie(e), n = x.useRef(""), r = x.useRef(0), i = x.useCallback(
    (a) => {
      const s = n.current + a;
      t(s), function l(u) {
        n.current = u, window.clearTimeout(r.current), u !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      }(s);
    },
    [t]
  ), o = x.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return x.useEffect(() => () => window.clearTimeout(r.current), []), [n, i, o];
}
function LG(e, t, n) {
  const i = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, o = n ? e.indexOf(n) : -1;
  let a = n9e(e, Math.max(o, 0));
  i.length === 1 && (a = a.filter((u) => u !== n));
  const l = a.find(
    (u) => u.textValue.toLowerCase().startsWith(i.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function n9e(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var r9e = dG, FG = hG, i9e = mG, o9e = gG, a9e = vG, BG = yG, s9e = CG, l9e = _G, jG = NG, VG = OG, u9e = kG, c9e = TG, qG = RG;
const d9e = r9e, cet = l9e, f9e = i9e, zG = te(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ k(
  FG,
  {
    ref: r,
    className: z(
      "border-input bg-background ring-offset-background placeholder:text-muted-foreground focus:ring-ring flex h-10 w-full items-center justify-between rounded-md border px-3 py-2 text-bodysm focus:outline-hidden focus:ring-2 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ d(o9e, { asChild: !0, children: /* @__PURE__ */ d(tp, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
zG.displayName = FG.displayName;
const WG = te(({ className: e, children: t, position: n = "popper", ...r }, i) => /* @__PURE__ */ d(a9e, { children: /* @__PURE__ */ d(
  BG,
  {
    ref: i,
    className: z(
      "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 min-w-[8rem] overflow-hidden rounded-md border border-border shadow-md",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...r,
    children: /* @__PURE__ */ d(
      s9e,
      {
        className: z(
          "p-1",
          n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
        ),
        children: t
      }
    )
  }
) }));
WG.displayName = BG.displayName;
const h9e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  jG,
  {
    ref: n,
    className: z("py-1.5 pl-8 pr-2 text-bodysm font-semibold", e),
    ...t
  }
));
h9e.displayName = jG.displayName;
const c7 = te(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ k(
  VG,
  {
    ref: r,
    className: z(
      "focus:bg-accent focus:text-accent-foreground relative flex w-full cursor-default select-none items-center rounded-xs py-1.5 pl-8 pr-2 text-bodysm outline-hidden data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ d("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ d(c9e, { children: /* @__PURE__ */ d(Gs, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ d(u9e, { children: t })
    ]
  }
));
c7.displayName = VG.displayName;
const p9e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  qG,
  {
    ref: n,
    className: z("bg-muted -mx-1 my-1 h-px", e),
    ...t
  }
));
p9e.displayName = qG.displayName;
var m9e = "Separator", Qk = "horizontal", g9e = ["horizontal", "vertical"], HG = x.forwardRef((e, t) => {
  const { decorative: n, orientation: r = Qk, ...i } = e, o = v9e(r) ? r : Qk, s = n ? { role: "none" } : { "aria-orientation": o === "vertical" ? o : void 0, role: "separator" };
  return /* @__PURE__ */ d(
    Re.div,
    {
      "data-orientation": o,
      ...s,
      ...i,
      ref: t
    }
  );
});
HG.displayName = m9e;
function v9e(e) {
  return g9e.includes(e);
}
var UG = HG;
const eu = te(
  ({ className: e, orientation: t = "horizontal", decorative: n = !0, ...r }, i) => /* @__PURE__ */ d(
    UG,
    {
      ref: i,
      decorative: n,
      orientation: t,
      className: z(
        "bg-border shrink-0",
        t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        e
      ),
      ...r
    }
  )
);
eu.displayName = UG.displayName;
const GG = _z, y9e = Ez, det = S2, b9e = Nz, KG = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  x2,
  {
    className: z(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/40",
      e
    ),
    ...t,
    ref: n
  }
));
KG.displayName = x2.displayName;
const x9e = Jo(
  "fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), fS = te(
  ({
    className: e,
    children: t,
    hideCloseButton: n,
    showOverlay: r = !0,
    side: i = "right",
    ...o
  }, a) => /* @__PURE__ */ k(b9e, { children: [
    r && /* @__PURE__ */ d(KG, {}),
    /* @__PURE__ */ k(
      w2,
      {
        "aria-describedby": void 0,
        ref: a,
        className: z(x9e({ side: i }), e),
        ...o,
        children: [
          o.title && /* @__PURE__ */ d(gp, { children: o.title }),
          t,
          !n && /* @__PURE__ */ k(S2, { className: "ring-offset-background focus:ring-ring data-[state=open]:bg-secondary rounded-xs focus:outline-hidden absolute right-4 top-4 opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none", children: [
            /* @__PURE__ */ d(np, { className: "h-4 w-4" }),
            /* @__PURE__ */ d("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] })
);
fS.displayName = w2.displayName;
const w9e = ({
  className: e,
  ...t
}) => /* @__PURE__ */ d(
  "div",
  {
    className: z(
      "flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...t
  }
);
w9e.displayName = "SheetHeader";
const YG = ({
  className: e,
  ...t
}) => /* @__PURE__ */ d(
  "div",
  {
    className: z(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
YG.displayName = "SheetFooter";
const ZG = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  gp,
  {
    ref: n,
    className: z("text-foreground text-bodylg font-semibold", e),
    ...t
  }
));
ZG.displayName = gp.displayName;
const C9e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  C2,
  {
    ref: n,
    className: z("text-muted-foreground text-bodysm", e),
    ...t
  }
));
C9e.displayName = C2.displayName;
var Of = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var S9e = Of.exports, eP;
function _9e() {
  return eP || (eP = 1, function(e, t) {
    (function() {
      var n, r = "4.17.21", i = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", s = "Invalid `variable` option passed into `_.template`", l = "__lodash_hash_undefined__", u = 500, c = "__lodash_placeholder__", f = 1, h = 2, m = 4, v = 1, g = 2, y = 1, w = 2, C = 4, S = 8, N = 16, E = 32, A = 64, O = 128, T = 256, M = 512, L = 30, I = "...", j = 800, B = 16, q = 1, G = 2, U = 3, V = 1 / 0, H = 9007199254740991, Z = 17976931348623157e292, de = NaN, ne = 4294967295, Y = ne - 1, le = ne >>> 1, be = [
        ["ary", O],
        ["bind", y],
        ["bindKey", w],
        ["curry", S],
        ["curryRight", N],
        ["flip", M],
        ["partial", E],
        ["partialRight", A],
        ["rearg", T]
      ], pe = "[object Arguments]", Ee = "[object Array]", ge = "[object AsyncFunction]", Ce = "[object Boolean]", ie = "[object Date]", ye = "[object DOMException]", ve = "[object Error]", Q = "[object Function]", Oe = "[object GeneratorFunction]", se = "[object Map]", nt = "[object Number]", ut = "[object Null]", st = "[object Object]", Nn = "[object Promise]", Dt = "[object Proxy]", Co = "[object RegExp]", An = "[object Set]", wr = "[object String]", Qa = "[object Symbol]", qd = "[object Undefined]", sa = "[object WeakMap]", qp = "[object WeakSet]", es = "[object ArrayBuffer]", yu = "[object DataView]", Jv = "[object Float32Array]", Qv = "[object Float64Array]", ey = "[object Int8Array]", ty = "[object Int16Array]", ny = "[object Int32Array]", ry = "[object Uint8Array]", iy = "[object Uint8ClampedArray]", oy = "[object Uint16Array]", ay = "[object Uint32Array]", qte = /\b__p \+= '';/g, zte = /\b(__p \+=) '' \+/g, Wte = /(__e\(.*?\)|\b__t\)) \+\n'';/g, dE = /&(?:amp|lt|gt|quot|#39);/g, fE = /[&<>"']/g, Hte = RegExp(dE.source), Ute = RegExp(fE.source), Gte = /<%-([\s\S]+?)%>/g, Kte = /<%([\s\S]+?)%>/g, hE = /<%=([\s\S]+?)%>/g, Yte = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Zte = /^\w*$/, Xte = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, sy = /[\\^$.*+?()[\]{}|]/g, Jte = RegExp(sy.source), ly = /^\s+/, Qte = /\s/, ene = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, tne = /\{\n\/\* \[wrapped with (.+)\] \*/, nne = /,? & /, rne = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, ine = /[()=,{}\[\]\/\s]/, one = /\\(\\)?/g, ane = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, pE = /\w*$/, sne = /^[-+]0x[0-9a-f]+$/i, lne = /^0b[01]+$/i, une = /^\[object .+?Constructor\]$/, cne = /^0o[0-7]+$/i, dne = /^(?:0|[1-9]\d*)$/, fne = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, zp = /($^)/, hne = /['\n\r\u2028\u2029\\]/g, Wp = "\\ud800-\\udfff", pne = "\\u0300-\\u036f", mne = "\\ufe20-\\ufe2f", gne = "\\u20d0-\\u20ff", mE = pne + mne + gne, gE = "\\u2700-\\u27bf", vE = "a-z\\xdf-\\xf6\\xf8-\\xff", vne = "\\xac\\xb1\\xd7\\xf7", yne = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", bne = "\\u2000-\\u206f", xne = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", yE = "A-Z\\xc0-\\xd6\\xd8-\\xde", bE = "\\ufe0e\\ufe0f", xE = vne + yne + bne + xne, uy = "['’]", wne = "[" + Wp + "]", wE = "[" + xE + "]", Hp = "[" + mE + "]", CE = "\\d+", Cne = "[" + gE + "]", SE = "[" + vE + "]", _E = "[^" + Wp + xE + CE + gE + vE + yE + "]", cy = "\\ud83c[\\udffb-\\udfff]", Sne = "(?:" + Hp + "|" + cy + ")", EE = "[^" + Wp + "]", dy = "(?:\\ud83c[\\udde6-\\uddff]){2}", fy = "[\\ud800-\\udbff][\\udc00-\\udfff]", bu = "[" + yE + "]", NE = "\\u200d", AE = "(?:" + SE + "|" + _E + ")", _ne = "(?:" + bu + "|" + _E + ")", OE = "(?:" + uy + "(?:d|ll|m|re|s|t|ve))?", kE = "(?:" + uy + "(?:D|LL|M|RE|S|T|VE))?", PE = Sne + "?", TE = "[" + bE + "]?", Ene = "(?:" + NE + "(?:" + [EE, dy, fy].join("|") + ")" + TE + PE + ")*", Nne = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Ane = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ME = TE + PE + Ene, One = "(?:" + [Cne, dy, fy].join("|") + ")" + ME, kne = "(?:" + [EE + Hp + "?", Hp, dy, fy, wne].join("|") + ")", Pne = RegExp(uy, "g"), Tne = RegExp(Hp, "g"), hy = RegExp(cy + "(?=" + cy + ")|" + kne + ME, "g"), Mne = RegExp([
        bu + "?" + SE + "+" + OE + "(?=" + [wE, bu, "$"].join("|") + ")",
        _ne + "+" + kE + "(?=" + [wE, bu + AE, "$"].join("|") + ")",
        bu + "?" + AE + "+" + OE,
        bu + "+" + kE,
        Ane,
        Nne,
        CE,
        One
      ].join("|"), "g"), Rne = RegExp("[" + NE + Wp + mE + bE + "]"), Dne = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Ine = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], $ne = -1, Xt = {};
      Xt[Jv] = Xt[Qv] = Xt[ey] = Xt[ty] = Xt[ny] = Xt[ry] = Xt[iy] = Xt[oy] = Xt[ay] = !0, Xt[pe] = Xt[Ee] = Xt[es] = Xt[Ce] = Xt[yu] = Xt[ie] = Xt[ve] = Xt[Q] = Xt[se] = Xt[nt] = Xt[st] = Xt[Co] = Xt[An] = Xt[wr] = Xt[sa] = !1;
      var Ht = {};
      Ht[pe] = Ht[Ee] = Ht[es] = Ht[yu] = Ht[Ce] = Ht[ie] = Ht[Jv] = Ht[Qv] = Ht[ey] = Ht[ty] = Ht[ny] = Ht[se] = Ht[nt] = Ht[st] = Ht[Co] = Ht[An] = Ht[wr] = Ht[Qa] = Ht[ry] = Ht[iy] = Ht[oy] = Ht[ay] = !0, Ht[ve] = Ht[Q] = Ht[sa] = !1;
      var Lne = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, Fne = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, Bne = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, jne = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, Vne = parseFloat, qne = parseInt, RE = typeof Es == "object" && Es && Es.Object === Object && Es, zne = typeof self == "object" && self && self.Object === Object && self, Zn = RE || zne || Function("return this")(), py = t && !t.nodeType && t, sl = py && !0 && e && !e.nodeType && e, DE = sl && sl.exports === py, my = DE && RE.process, yi = function() {
        try {
          var X = sl && sl.require && sl.require("util").types;
          return X || my && my.binding && my.binding("util");
        } catch {
        }
      }(), IE = yi && yi.isArrayBuffer, $E = yi && yi.isDate, LE = yi && yi.isMap, FE = yi && yi.isRegExp, BE = yi && yi.isSet, jE = yi && yi.isTypedArray;
      function ti(X, ae, ee) {
        switch (ee.length) {
          case 0:
            return X.call(ae);
          case 1:
            return X.call(ae, ee[0]);
          case 2:
            return X.call(ae, ee[0], ee[1]);
          case 3:
            return X.call(ae, ee[0], ee[1], ee[2]);
        }
        return X.apply(ae, ee);
      }
      function Wne(X, ae, ee, Ne) {
        for (var Xe = -1, wt = X == null ? 0 : X.length; ++Xe < wt; ) {
          var On = X[Xe];
          ae(Ne, On, ee(On), X);
        }
        return Ne;
      }
      function bi(X, ae) {
        for (var ee = -1, Ne = X == null ? 0 : X.length; ++ee < Ne && ae(X[ee], ee, X) !== !1; )
          ;
        return X;
      }
      function Hne(X, ae) {
        for (var ee = X == null ? 0 : X.length; ee-- && ae(X[ee], ee, X) !== !1; )
          ;
        return X;
      }
      function VE(X, ae) {
        for (var ee = -1, Ne = X == null ? 0 : X.length; ++ee < Ne; )
          if (!ae(X[ee], ee, X))
            return !1;
        return !0;
      }
      function ts(X, ae) {
        for (var ee = -1, Ne = X == null ? 0 : X.length, Xe = 0, wt = []; ++ee < Ne; ) {
          var On = X[ee];
          ae(On, ee, X) && (wt[Xe++] = On);
        }
        return wt;
      }
      function Up(X, ae) {
        var ee = X == null ? 0 : X.length;
        return !!ee && xu(X, ae, 0) > -1;
      }
      function gy(X, ae, ee) {
        for (var Ne = -1, Xe = X == null ? 0 : X.length; ++Ne < Xe; )
          if (ee(ae, X[Ne]))
            return !0;
        return !1;
      }
      function nn(X, ae) {
        for (var ee = -1, Ne = X == null ? 0 : X.length, Xe = Array(Ne); ++ee < Ne; )
          Xe[ee] = ae(X[ee], ee, X);
        return Xe;
      }
      function ns(X, ae) {
        for (var ee = -1, Ne = ae.length, Xe = X.length; ++ee < Ne; )
          X[Xe + ee] = ae[ee];
        return X;
      }
      function vy(X, ae, ee, Ne) {
        var Xe = -1, wt = X == null ? 0 : X.length;
        for (Ne && wt && (ee = X[++Xe]); ++Xe < wt; )
          ee = ae(ee, X[Xe], Xe, X);
        return ee;
      }
      function Une(X, ae, ee, Ne) {
        var Xe = X == null ? 0 : X.length;
        for (Ne && Xe && (ee = X[--Xe]); Xe--; )
          ee = ae(ee, X[Xe], Xe, X);
        return ee;
      }
      function yy(X, ae) {
        for (var ee = -1, Ne = X == null ? 0 : X.length; ++ee < Ne; )
          if (ae(X[ee], ee, X))
            return !0;
        return !1;
      }
      var Gne = by("length");
      function Kne(X) {
        return X.split("");
      }
      function Yne(X) {
        return X.match(rne) || [];
      }
      function qE(X, ae, ee) {
        var Ne;
        return ee(X, function(Xe, wt, On) {
          if (ae(Xe, wt, On))
            return Ne = wt, !1;
        }), Ne;
      }
      function Gp(X, ae, ee, Ne) {
        for (var Xe = X.length, wt = ee + (Ne ? 1 : -1); Ne ? wt-- : ++wt < Xe; )
          if (ae(X[wt], wt, X))
            return wt;
        return -1;
      }
      function xu(X, ae, ee) {
        return ae === ae ? sre(X, ae, ee) : Gp(X, zE, ee);
      }
      function Zne(X, ae, ee, Ne) {
        for (var Xe = ee - 1, wt = X.length; ++Xe < wt; )
          if (Ne(X[Xe], ae))
            return Xe;
        return -1;
      }
      function zE(X) {
        return X !== X;
      }
      function WE(X, ae) {
        var ee = X == null ? 0 : X.length;
        return ee ? wy(X, ae) / ee : de;
      }
      function by(X) {
        return function(ae) {
          return ae == null ? n : ae[X];
        };
      }
      function xy(X) {
        return function(ae) {
          return X == null ? n : X[ae];
        };
      }
      function HE(X, ae, ee, Ne, Xe) {
        return Xe(X, function(wt, On, Bt) {
          ee = Ne ? (Ne = !1, wt) : ae(ee, wt, On, Bt);
        }), ee;
      }
      function Xne(X, ae) {
        var ee = X.length;
        for (X.sort(ae); ee--; )
          X[ee] = X[ee].value;
        return X;
      }
      function wy(X, ae) {
        for (var ee, Ne = -1, Xe = X.length; ++Ne < Xe; ) {
          var wt = ae(X[Ne]);
          wt !== n && (ee = ee === n ? wt : ee + wt);
        }
        return ee;
      }
      function Cy(X, ae) {
        for (var ee = -1, Ne = Array(X); ++ee < X; )
          Ne[ee] = ae(ee);
        return Ne;
      }
      function Jne(X, ae) {
        return nn(ae, function(ee) {
          return [ee, X[ee]];
        });
      }
      function UE(X) {
        return X && X.slice(0, ZE(X) + 1).replace(ly, "");
      }
      function ni(X) {
        return function(ae) {
          return X(ae);
        };
      }
      function Sy(X, ae) {
        return nn(ae, function(ee) {
          return X[ee];
        });
      }
      function zd(X, ae) {
        return X.has(ae);
      }
      function GE(X, ae) {
        for (var ee = -1, Ne = X.length; ++ee < Ne && xu(ae, X[ee], 0) > -1; )
          ;
        return ee;
      }
      function KE(X, ae) {
        for (var ee = X.length; ee-- && xu(ae, X[ee], 0) > -1; )
          ;
        return ee;
      }
      function Qne(X, ae) {
        for (var ee = X.length, Ne = 0; ee--; )
          X[ee] === ae && ++Ne;
        return Ne;
      }
      var ere = xy(Lne), tre = xy(Fne);
      function nre(X) {
        return "\\" + jne[X];
      }
      function rre(X, ae) {
        return X == null ? n : X[ae];
      }
      function wu(X) {
        return Rne.test(X);
      }
      function ire(X) {
        return Dne.test(X);
      }
      function ore(X) {
        for (var ae, ee = []; !(ae = X.next()).done; )
          ee.push(ae.value);
        return ee;
      }
      function _y(X) {
        var ae = -1, ee = Array(X.size);
        return X.forEach(function(Ne, Xe) {
          ee[++ae] = [Xe, Ne];
        }), ee;
      }
      function YE(X, ae) {
        return function(ee) {
          return X(ae(ee));
        };
      }
      function rs(X, ae) {
        for (var ee = -1, Ne = X.length, Xe = 0, wt = []; ++ee < Ne; ) {
          var On = X[ee];
          (On === ae || On === c) && (X[ee] = c, wt[Xe++] = ee);
        }
        return wt;
      }
      function Kp(X) {
        var ae = -1, ee = Array(X.size);
        return X.forEach(function(Ne) {
          ee[++ae] = Ne;
        }), ee;
      }
      function are(X) {
        var ae = -1, ee = Array(X.size);
        return X.forEach(function(Ne) {
          ee[++ae] = [Ne, Ne];
        }), ee;
      }
      function sre(X, ae, ee) {
        for (var Ne = ee - 1, Xe = X.length; ++Ne < Xe; )
          if (X[Ne] === ae)
            return Ne;
        return -1;
      }
      function lre(X, ae, ee) {
        for (var Ne = ee + 1; Ne--; )
          if (X[Ne] === ae)
            return Ne;
        return Ne;
      }
      function Cu(X) {
        return wu(X) ? cre(X) : Gne(X);
      }
      function Wi(X) {
        return wu(X) ? dre(X) : Kne(X);
      }
      function ZE(X) {
        for (var ae = X.length; ae-- && Qte.test(X.charAt(ae)); )
          ;
        return ae;
      }
      var ure = xy(Bne);
      function cre(X) {
        for (var ae = hy.lastIndex = 0; hy.test(X); )
          ++ae;
        return ae;
      }
      function dre(X) {
        return X.match(hy) || [];
      }
      function fre(X) {
        return X.match(Mne) || [];
      }
      var hre = function X(ae) {
        ae = ae == null ? Zn : Su.defaults(Zn.Object(), ae, Su.pick(Zn, Ine));
        var ee = ae.Array, Ne = ae.Date, Xe = ae.Error, wt = ae.Function, On = ae.Math, Bt = ae.Object, Ey = ae.RegExp, pre = ae.String, xi = ae.TypeError, Yp = ee.prototype, mre = wt.prototype, _u = Bt.prototype, Zp = ae["__core-js_shared__"], Xp = mre.toString, kt = _u.hasOwnProperty, gre = 0, XE = function() {
          var p = /[^.]+$/.exec(Zp && Zp.keys && Zp.keys.IE_PROTO || "");
          return p ? "Symbol(src)_1." + p : "";
        }(), Jp = _u.toString, vre = Xp.call(Bt), yre = Zn._, bre = Ey(
          "^" + Xp.call(kt).replace(sy, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), Qp = DE ? ae.Buffer : n, is = ae.Symbol, e0 = ae.Uint8Array, JE = Qp ? Qp.allocUnsafe : n, t0 = YE(Bt.getPrototypeOf, Bt), QE = Bt.create, eN = _u.propertyIsEnumerable, n0 = Yp.splice, tN = is ? is.isConcatSpreadable : n, Wd = is ? is.iterator : n, ll = is ? is.toStringTag : n, r0 = function() {
          try {
            var p = hl(Bt, "defineProperty");
            return p({}, "", {}), p;
          } catch {
          }
        }(), xre = ae.clearTimeout !== Zn.clearTimeout && ae.clearTimeout, wre = Ne && Ne.now !== Zn.Date.now && Ne.now, Cre = ae.setTimeout !== Zn.setTimeout && ae.setTimeout, i0 = On.ceil, o0 = On.floor, Ny = Bt.getOwnPropertySymbols, Sre = Qp ? Qp.isBuffer : n, nN = ae.isFinite, _re = Yp.join, Ere = YE(Bt.keys, Bt), kn = On.max, ur = On.min, Nre = Ne.now, Are = ae.parseInt, rN = On.random, Ore = Yp.reverse, Ay = hl(ae, "DataView"), Hd = hl(ae, "Map"), Oy = hl(ae, "Promise"), Eu = hl(ae, "Set"), Ud = hl(ae, "WeakMap"), Gd = hl(Bt, "create"), a0 = Ud && new Ud(), Nu = {}, kre = pl(Ay), Pre = pl(Hd), Tre = pl(Oy), Mre = pl(Eu), Rre = pl(Ud), s0 = is ? is.prototype : n, Kd = s0 ? s0.valueOf : n, iN = s0 ? s0.toString : n;
        function D(p) {
          if (un(p) && !Qe(p) && !(p instanceof pt)) {
            if (p instanceof wi)
              return p;
            if (kt.call(p, "__wrapped__"))
              return oA(p);
          }
          return new wi(p);
        }
        var Au = /* @__PURE__ */ function() {
          function p() {
          }
          return function(b) {
            if (!an(b))
              return {};
            if (QE)
              return QE(b);
            p.prototype = b;
            var _ = new p();
            return p.prototype = n, _;
          };
        }();
        function l0() {
        }
        function wi(p, b) {
          this.__wrapped__ = p, this.__actions__ = [], this.__chain__ = !!b, this.__index__ = 0, this.__values__ = n;
        }
        D.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: Gte,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Kte,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: hE,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: D
          }
        }, D.prototype = l0.prototype, D.prototype.constructor = D, wi.prototype = Au(l0.prototype), wi.prototype.constructor = wi;
        function pt(p) {
          this.__wrapped__ = p, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = ne, this.__views__ = [];
        }
        function Dre() {
          var p = new pt(this.__wrapped__);
          return p.__actions__ = Lr(this.__actions__), p.__dir__ = this.__dir__, p.__filtered__ = this.__filtered__, p.__iteratees__ = Lr(this.__iteratees__), p.__takeCount__ = this.__takeCount__, p.__views__ = Lr(this.__views__), p;
        }
        function Ire() {
          if (this.__filtered__) {
            var p = new pt(this);
            p.__dir__ = -1, p.__filtered__ = !0;
          } else
            p = this.clone(), p.__dir__ *= -1;
          return p;
        }
        function $re() {
          var p = this.__wrapped__.value(), b = this.__dir__, _ = Qe(p), P = b < 0, R = _ ? p.length : 0, $ = Kie(0, R, this.__views__), W = $.start, K = $.end, J = K - W, ue = P ? K : W - 1, ce = this.__iteratees__, fe = ce.length, Se = 0, Te = ur(J, this.__takeCount__);
          if (!_ || !P && R == J && Te == J)
            return ON(p, this.__actions__);
          var Be = [];
          e:
            for (; J-- && Se < Te; ) {
              ue += b;
              for (var ot = -1, je = p[ue]; ++ot < fe; ) {
                var ft = ce[ot], gt = ft.iteratee, oi = ft.type, _r = gt(je);
                if (oi == G)
                  je = _r;
                else if (!_r) {
                  if (oi == q)
                    continue e;
                  break e;
                }
              }
              Be[Se++] = je;
            }
          return Be;
        }
        pt.prototype = Au(l0.prototype), pt.prototype.constructor = pt;
        function ul(p) {
          var b = -1, _ = p == null ? 0 : p.length;
          for (this.clear(); ++b < _; ) {
            var P = p[b];
            this.set(P[0], P[1]);
          }
        }
        function Lre() {
          this.__data__ = Gd ? Gd(null) : {}, this.size = 0;
        }
        function Fre(p) {
          var b = this.has(p) && delete this.__data__[p];
          return this.size -= b ? 1 : 0, b;
        }
        function Bre(p) {
          var b = this.__data__;
          if (Gd) {
            var _ = b[p];
            return _ === l ? n : _;
          }
          return kt.call(b, p) ? b[p] : n;
        }
        function jre(p) {
          var b = this.__data__;
          return Gd ? b[p] !== n : kt.call(b, p);
        }
        function Vre(p, b) {
          var _ = this.__data__;
          return this.size += this.has(p) ? 0 : 1, _[p] = Gd && b === n ? l : b, this;
        }
        ul.prototype.clear = Lre, ul.prototype.delete = Fre, ul.prototype.get = Bre, ul.prototype.has = jre, ul.prototype.set = Vre;
        function la(p) {
          var b = -1, _ = p == null ? 0 : p.length;
          for (this.clear(); ++b < _; ) {
            var P = p[b];
            this.set(P[0], P[1]);
          }
        }
        function qre() {
          this.__data__ = [], this.size = 0;
        }
        function zre(p) {
          var b = this.__data__, _ = u0(b, p);
          if (_ < 0)
            return !1;
          var P = b.length - 1;
          return _ == P ? b.pop() : n0.call(b, _, 1), --this.size, !0;
        }
        function Wre(p) {
          var b = this.__data__, _ = u0(b, p);
          return _ < 0 ? n : b[_][1];
        }
        function Hre(p) {
          return u0(this.__data__, p) > -1;
        }
        function Ure(p, b) {
          var _ = this.__data__, P = u0(_, p);
          return P < 0 ? (++this.size, _.push([p, b])) : _[P][1] = b, this;
        }
        la.prototype.clear = qre, la.prototype.delete = zre, la.prototype.get = Wre, la.prototype.has = Hre, la.prototype.set = Ure;
        function ua(p) {
          var b = -1, _ = p == null ? 0 : p.length;
          for (this.clear(); ++b < _; ) {
            var P = p[b];
            this.set(P[0], P[1]);
          }
        }
        function Gre() {
          this.size = 0, this.__data__ = {
            hash: new ul(),
            map: new (Hd || la)(),
            string: new ul()
          };
        }
        function Kre(p) {
          var b = w0(this, p).delete(p);
          return this.size -= b ? 1 : 0, b;
        }
        function Yre(p) {
          return w0(this, p).get(p);
        }
        function Zre(p) {
          return w0(this, p).has(p);
        }
        function Xre(p, b) {
          var _ = w0(this, p), P = _.size;
          return _.set(p, b), this.size += _.size == P ? 0 : 1, this;
        }
        ua.prototype.clear = Gre, ua.prototype.delete = Kre, ua.prototype.get = Yre, ua.prototype.has = Zre, ua.prototype.set = Xre;
        function cl(p) {
          var b = -1, _ = p == null ? 0 : p.length;
          for (this.__data__ = new ua(); ++b < _; )
            this.add(p[b]);
        }
        function Jre(p) {
          return this.__data__.set(p, l), this;
        }
        function Qre(p) {
          return this.__data__.has(p);
        }
        cl.prototype.add = cl.prototype.push = Jre, cl.prototype.has = Qre;
        function Hi(p) {
          var b = this.__data__ = new la(p);
          this.size = b.size;
        }
        function eie() {
          this.__data__ = new la(), this.size = 0;
        }
        function tie(p) {
          var b = this.__data__, _ = b.delete(p);
          return this.size = b.size, _;
        }
        function nie(p) {
          return this.__data__.get(p);
        }
        function rie(p) {
          return this.__data__.has(p);
        }
        function iie(p, b) {
          var _ = this.__data__;
          if (_ instanceof la) {
            var P = _.__data__;
            if (!Hd || P.length < i - 1)
              return P.push([p, b]), this.size = ++_.size, this;
            _ = this.__data__ = new ua(P);
          }
          return _.set(p, b), this.size = _.size, this;
        }
        Hi.prototype.clear = eie, Hi.prototype.delete = tie, Hi.prototype.get = nie, Hi.prototype.has = rie, Hi.prototype.set = iie;
        function oN(p, b) {
          var _ = Qe(p), P = !_ && ml(p), R = !_ && !P && cs(p), $ = !_ && !P && !R && Tu(p), W = _ || P || R || $, K = W ? Cy(p.length, pre) : [], J = K.length;
          for (var ue in p)
            (b || kt.call(p, ue)) && !(W && // Safari 9 has enumerable `arguments.length` in strict mode.
            (ue == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            R && (ue == "offset" || ue == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            $ && (ue == "buffer" || ue == "byteLength" || ue == "byteOffset") || // Skip index properties.
            ha(ue, J))) && K.push(ue);
          return K;
        }
        function aN(p) {
          var b = p.length;
          return b ? p[By(0, b - 1)] : n;
        }
        function oie(p, b) {
          return C0(Lr(p), dl(b, 0, p.length));
        }
        function aie(p) {
          return C0(Lr(p));
        }
        function ky(p, b, _) {
          (_ !== n && !Ui(p[b], _) || _ === n && !(b in p)) && ca(p, b, _);
        }
        function Yd(p, b, _) {
          var P = p[b];
          (!(kt.call(p, b) && Ui(P, _)) || _ === n && !(b in p)) && ca(p, b, _);
        }
        function u0(p, b) {
          for (var _ = p.length; _--; )
            if (Ui(p[_][0], b))
              return _;
          return -1;
        }
        function sie(p, b, _, P) {
          return as(p, function(R, $, W) {
            b(P, R, _(R), W);
          }), P;
        }
        function sN(p, b) {
          return p && _o(b, Ln(b), p);
        }
        function lie(p, b) {
          return p && _o(b, Br(b), p);
        }
        function ca(p, b, _) {
          b == "__proto__" && r0 ? r0(p, b, {
            configurable: !0,
            enumerable: !0,
            value: _,
            writable: !0
          }) : p[b] = _;
        }
        function Py(p, b) {
          for (var _ = -1, P = b.length, R = ee(P), $ = p == null; ++_ < P; )
            R[_] = $ ? n : cb(p, b[_]);
          return R;
        }
        function dl(p, b, _) {
          return p === p && (_ !== n && (p = p <= _ ? p : _), b !== n && (p = p >= b ? p : b)), p;
        }
        function Ci(p, b, _, P, R, $) {
          var W, K = b & f, J = b & h, ue = b & m;
          if (_ && (W = R ? _(p, P, R, $) : _(p)), W !== n)
            return W;
          if (!an(p))
            return p;
          var ce = Qe(p);
          if (ce) {
            if (W = Zie(p), !K)
              return Lr(p, W);
          } else {
            var fe = cr(p), Se = fe == Q || fe == Oe;
            if (cs(p))
              return TN(p, K);
            if (fe == st || fe == pe || Se && !R) {
              if (W = J || Se ? {} : ZN(p), !K)
                return J ? Bie(p, lie(W, p)) : Fie(p, sN(W, p));
            } else {
              if (!Ht[fe])
                return R ? p : {};
              W = Xie(p, fe, K);
            }
          }
          $ || ($ = new Hi());
          var Te = $.get(p);
          if (Te)
            return Te;
          $.set(p, W), EA(p) ? p.forEach(function(je) {
            W.add(Ci(je, b, _, je, p, $));
          }) : SA(p) && p.forEach(function(je, ft) {
            W.set(ft, Ci(je, b, _, ft, p, $));
          });
          var Be = ue ? J ? Zy : Yy : J ? Br : Ln, ot = ce ? n : Be(p);
          return bi(ot || p, function(je, ft) {
            ot && (ft = je, je = p[ft]), Yd(W, ft, Ci(je, b, _, ft, p, $));
          }), W;
        }
        function uie(p) {
          var b = Ln(p);
          return function(_) {
            return lN(_, p, b);
          };
        }
        function lN(p, b, _) {
          var P = _.length;
          if (p == null)
            return !P;
          for (p = Bt(p); P--; ) {
            var R = _[P], $ = b[R], W = p[R];
            if (W === n && !(R in p) || !$(W))
              return !1;
          }
          return !0;
        }
        function uN(p, b, _) {
          if (typeof p != "function")
            throw new xi(a);
          return nf(function() {
            p.apply(n, _);
          }, b);
        }
        function Zd(p, b, _, P) {
          var R = -1, $ = Up, W = !0, K = p.length, J = [], ue = b.length;
          if (!K)
            return J;
          _ && (b = nn(b, ni(_))), P ? ($ = gy, W = !1) : b.length >= i && ($ = zd, W = !1, b = new cl(b));
          e:
            for (; ++R < K; ) {
              var ce = p[R], fe = _ == null ? ce : _(ce);
              if (ce = P || ce !== 0 ? ce : 0, W && fe === fe) {
                for (var Se = ue; Se--; )
                  if (b[Se] === fe)
                    continue e;
                J.push(ce);
              } else $(b, fe, P) || J.push(ce);
            }
          return J;
        }
        var as = $N(So), cN = $N(My, !0);
        function cie(p, b) {
          var _ = !0;
          return as(p, function(P, R, $) {
            return _ = !!b(P, R, $), _;
          }), _;
        }
        function c0(p, b, _) {
          for (var P = -1, R = p.length; ++P < R; ) {
            var $ = p[P], W = b($);
            if (W != null && (K === n ? W === W && !ii(W) : _(W, K)))
              var K = W, J = $;
          }
          return J;
        }
        function die(p, b, _, P) {
          var R = p.length;
          for (_ = rt(_), _ < 0 && (_ = -_ > R ? 0 : R + _), P = P === n || P > R ? R : rt(P), P < 0 && (P += R), P = _ > P ? 0 : AA(P); _ < P; )
            p[_++] = b;
          return p;
        }
        function dN(p, b) {
          var _ = [];
          return as(p, function(P, R, $) {
            b(P, R, $) && _.push(P);
          }), _;
        }
        function Xn(p, b, _, P, R) {
          var $ = -1, W = p.length;
          for (_ || (_ = Qie), R || (R = []); ++$ < W; ) {
            var K = p[$];
            b > 0 && _(K) ? b > 1 ? Xn(K, b - 1, _, P, R) : ns(R, K) : P || (R[R.length] = K);
          }
          return R;
        }
        var Ty = LN(), fN = LN(!0);
        function So(p, b) {
          return p && Ty(p, b, Ln);
        }
        function My(p, b) {
          return p && fN(p, b, Ln);
        }
        function d0(p, b) {
          return ts(b, function(_) {
            return pa(p[_]);
          });
        }
        function fl(p, b) {
          b = ls(b, p);
          for (var _ = 0, P = b.length; p != null && _ < P; )
            p = p[Eo(b[_++])];
          return _ && _ == P ? p : n;
        }
        function hN(p, b, _) {
          var P = b(p);
          return Qe(p) ? P : ns(P, _(p));
        }
        function Cr(p) {
          return p == null ? p === n ? qd : ut : ll && ll in Bt(p) ? Gie(p) : aoe(p);
        }
        function Ry(p, b) {
          return p > b;
        }
        function fie(p, b) {
          return p != null && kt.call(p, b);
        }
        function hie(p, b) {
          return p != null && b in Bt(p);
        }
        function pie(p, b, _) {
          return p >= ur(b, _) && p < kn(b, _);
        }
        function Dy(p, b, _) {
          for (var P = _ ? gy : Up, R = p[0].length, $ = p.length, W = $, K = ee($), J = 1 / 0, ue = []; W--; ) {
            var ce = p[W];
            W && b && (ce = nn(ce, ni(b))), J = ur(ce.length, J), K[W] = !_ && (b || R >= 120 && ce.length >= 120) ? new cl(W && ce) : n;
          }
          ce = p[0];
          var fe = -1, Se = K[0];
          e:
            for (; ++fe < R && ue.length < J; ) {
              var Te = ce[fe], Be = b ? b(Te) : Te;
              if (Te = _ || Te !== 0 ? Te : 0, !(Se ? zd(Se, Be) : P(ue, Be, _))) {
                for (W = $; --W; ) {
                  var ot = K[W];
                  if (!(ot ? zd(ot, Be) : P(p[W], Be, _)))
                    continue e;
                }
                Se && Se.push(Be), ue.push(Te);
              }
            }
          return ue;
        }
        function mie(p, b, _, P) {
          return So(p, function(R, $, W) {
            b(P, _(R), $, W);
          }), P;
        }
        function Xd(p, b, _) {
          b = ls(b, p), p = eA(p, b);
          var P = p == null ? p : p[Eo(_i(b))];
          return P == null ? n : ti(P, p, _);
        }
        function pN(p) {
          return un(p) && Cr(p) == pe;
        }
        function gie(p) {
          return un(p) && Cr(p) == es;
        }
        function vie(p) {
          return un(p) && Cr(p) == ie;
        }
        function Jd(p, b, _, P, R) {
          return p === b ? !0 : p == null || b == null || !un(p) && !un(b) ? p !== p && b !== b : yie(p, b, _, P, Jd, R);
        }
        function yie(p, b, _, P, R, $) {
          var W = Qe(p), K = Qe(b), J = W ? Ee : cr(p), ue = K ? Ee : cr(b);
          J = J == pe ? st : J, ue = ue == pe ? st : ue;
          var ce = J == st, fe = ue == st, Se = J == ue;
          if (Se && cs(p)) {
            if (!cs(b))
              return !1;
            W = !0, ce = !1;
          }
          if (Se && !ce)
            return $ || ($ = new Hi()), W || Tu(p) ? GN(p, b, _, P, R, $) : Hie(p, b, J, _, P, R, $);
          if (!(_ & v)) {
            var Te = ce && kt.call(p, "__wrapped__"), Be = fe && kt.call(b, "__wrapped__");
            if (Te || Be) {
              var ot = Te ? p.value() : p, je = Be ? b.value() : b;
              return $ || ($ = new Hi()), R(ot, je, _, P, $);
            }
          }
          return Se ? ($ || ($ = new Hi()), Uie(p, b, _, P, R, $)) : !1;
        }
        function bie(p) {
          return un(p) && cr(p) == se;
        }
        function Iy(p, b, _, P) {
          var R = _.length, $ = R, W = !P;
          if (p == null)
            return !$;
          for (p = Bt(p); R--; ) {
            var K = _[R];
            if (W && K[2] ? K[1] !== p[K[0]] : !(K[0] in p))
              return !1;
          }
          for (; ++R < $; ) {
            K = _[R];
            var J = K[0], ue = p[J], ce = K[1];
            if (W && K[2]) {
              if (ue === n && !(J in p))
                return !1;
            } else {
              var fe = new Hi();
              if (P)
                var Se = P(ue, ce, J, p, b, fe);
              if (!(Se === n ? Jd(ce, ue, v | g, P, fe) : Se))
                return !1;
            }
          }
          return !0;
        }
        function mN(p) {
          if (!an(p) || toe(p))
            return !1;
          var b = pa(p) ? bre : une;
          return b.test(pl(p));
        }
        function xie(p) {
          return un(p) && Cr(p) == Co;
        }
        function wie(p) {
          return un(p) && cr(p) == An;
        }
        function Cie(p) {
          return un(p) && O0(p.length) && !!Xt[Cr(p)];
        }
        function gN(p) {
          return typeof p == "function" ? p : p == null ? jr : typeof p == "object" ? Qe(p) ? bN(p[0], p[1]) : yN(p) : FA(p);
        }
        function $y(p) {
          if (!tf(p))
            return Ere(p);
          var b = [];
          for (var _ in Bt(p))
            kt.call(p, _) && _ != "constructor" && b.push(_);
          return b;
        }
        function Sie(p) {
          if (!an(p))
            return ooe(p);
          var b = tf(p), _ = [];
          for (var P in p)
            P == "constructor" && (b || !kt.call(p, P)) || _.push(P);
          return _;
        }
        function Ly(p, b) {
          return p < b;
        }
        function vN(p, b) {
          var _ = -1, P = Fr(p) ? ee(p.length) : [];
          return as(p, function(R, $, W) {
            P[++_] = b(R, $, W);
          }), P;
        }
        function yN(p) {
          var b = Jy(p);
          return b.length == 1 && b[0][2] ? JN(b[0][0], b[0][1]) : function(_) {
            return _ === p || Iy(_, p, b);
          };
        }
        function bN(p, b) {
          return eb(p) && XN(b) ? JN(Eo(p), b) : function(_) {
            var P = cb(_, p);
            return P === n && P === b ? db(_, p) : Jd(b, P, v | g);
          };
        }
        function f0(p, b, _, P, R) {
          p !== b && Ty(b, function($, W) {
            if (R || (R = new Hi()), an($))
              _ie(p, b, W, _, f0, P, R);
            else {
              var K = P ? P(nb(p, W), $, W + "", p, b, R) : n;
              K === n && (K = $), ky(p, W, K);
            }
          }, Br);
        }
        function _ie(p, b, _, P, R, $, W) {
          var K = nb(p, _), J = nb(b, _), ue = W.get(J);
          if (ue) {
            ky(p, _, ue);
            return;
          }
          var ce = $ ? $(K, J, _ + "", p, b, W) : n, fe = ce === n;
          if (fe) {
            var Se = Qe(J), Te = !Se && cs(J), Be = !Se && !Te && Tu(J);
            ce = J, Se || Te || Be ? Qe(K) ? ce = K : pn(K) ? ce = Lr(K) : Te ? (fe = !1, ce = TN(J, !0)) : Be ? (fe = !1, ce = MN(J, !0)) : ce = [] : rf(J) || ml(J) ? (ce = K, ml(K) ? ce = OA(K) : (!an(K) || pa(K)) && (ce = ZN(J))) : fe = !1;
          }
          fe && (W.set(J, ce), R(ce, J, P, $, W), W.delete(J)), ky(p, _, ce);
        }
        function xN(p, b) {
          var _ = p.length;
          if (_)
            return b += b < 0 ? _ : 0, ha(b, _) ? p[b] : n;
        }
        function wN(p, b, _) {
          b.length ? b = nn(b, function($) {
            return Qe($) ? function(W) {
              return fl(W, $.length === 1 ? $[0] : $);
            } : $;
          }) : b = [jr];
          var P = -1;
          b = nn(b, ni(Le()));
          var R = vN(p, function($, W, K) {
            var J = nn(b, function(ue) {
              return ue($);
            });
            return { criteria: J, index: ++P, value: $ };
          });
          return Xne(R, function($, W) {
            return Lie($, W, _);
          });
        }
        function Eie(p, b) {
          return CN(p, b, function(_, P) {
            return db(p, P);
          });
        }
        function CN(p, b, _) {
          for (var P = -1, R = b.length, $ = {}; ++P < R; ) {
            var W = b[P], K = fl(p, W);
            _(K, W) && Qd($, ls(W, p), K);
          }
          return $;
        }
        function Nie(p) {
          return function(b) {
            return fl(b, p);
          };
        }
        function Fy(p, b, _, P) {
          var R = P ? Zne : xu, $ = -1, W = b.length, K = p;
          for (p === b && (b = Lr(b)), _ && (K = nn(p, ni(_))); ++$ < W; )
            for (var J = 0, ue = b[$], ce = _ ? _(ue) : ue; (J = R(K, ce, J, P)) > -1; )
              K !== p && n0.call(K, J, 1), n0.call(p, J, 1);
          return p;
        }
        function SN(p, b) {
          for (var _ = p ? b.length : 0, P = _ - 1; _--; ) {
            var R = b[_];
            if (_ == P || R !== $) {
              var $ = R;
              ha(R) ? n0.call(p, R, 1) : qy(p, R);
            }
          }
          return p;
        }
        function By(p, b) {
          return p + o0(rN() * (b - p + 1));
        }
        function Aie(p, b, _, P) {
          for (var R = -1, $ = kn(i0((b - p) / (_ || 1)), 0), W = ee($); $--; )
            W[P ? $ : ++R] = p, p += _;
          return W;
        }
        function jy(p, b) {
          var _ = "";
          if (!p || b < 1 || b > H)
            return _;
          do
            b % 2 && (_ += p), b = o0(b / 2), b && (p += p);
          while (b);
          return _;
        }
        function lt(p, b) {
          return rb(QN(p, b, jr), p + "");
        }
        function Oie(p) {
          return aN(Mu(p));
        }
        function kie(p, b) {
          var _ = Mu(p);
          return C0(_, dl(b, 0, _.length));
        }
        function Qd(p, b, _, P) {
          if (!an(p))
            return p;
          b = ls(b, p);
          for (var R = -1, $ = b.length, W = $ - 1, K = p; K != null && ++R < $; ) {
            var J = Eo(b[R]), ue = _;
            if (J === "__proto__" || J === "constructor" || J === "prototype")
              return p;
            if (R != W) {
              var ce = K[J];
              ue = P ? P(ce, J, K) : n, ue === n && (ue = an(ce) ? ce : ha(b[R + 1]) ? [] : {});
            }
            Yd(K, J, ue), K = K[J];
          }
          return p;
        }
        var _N = a0 ? function(p, b) {
          return a0.set(p, b), p;
        } : jr, Pie = r0 ? function(p, b) {
          return r0(p, "toString", {
            configurable: !0,
            enumerable: !1,
            value: hb(b),
            writable: !0
          });
        } : jr;
        function Tie(p) {
          return C0(Mu(p));
        }
        function Si(p, b, _) {
          var P = -1, R = p.length;
          b < 0 && (b = -b > R ? 0 : R + b), _ = _ > R ? R : _, _ < 0 && (_ += R), R = b > _ ? 0 : _ - b >>> 0, b >>>= 0;
          for (var $ = ee(R); ++P < R; )
            $[P] = p[P + b];
          return $;
        }
        function Mie(p, b) {
          var _;
          return as(p, function(P, R, $) {
            return _ = b(P, R, $), !_;
          }), !!_;
        }
        function h0(p, b, _) {
          var P = 0, R = p == null ? P : p.length;
          if (typeof b == "number" && b === b && R <= le) {
            for (; P < R; ) {
              var $ = P + R >>> 1, W = p[$];
              W !== null && !ii(W) && (_ ? W <= b : W < b) ? P = $ + 1 : R = $;
            }
            return R;
          }
          return Vy(p, b, jr, _);
        }
        function Vy(p, b, _, P) {
          var R = 0, $ = p == null ? 0 : p.length;
          if ($ === 0)
            return 0;
          b = _(b);
          for (var W = b !== b, K = b === null, J = ii(b), ue = b === n; R < $; ) {
            var ce = o0((R + $) / 2), fe = _(p[ce]), Se = fe !== n, Te = fe === null, Be = fe === fe, ot = ii(fe);
            if (W)
              var je = P || Be;
            else ue ? je = Be && (P || Se) : K ? je = Be && Se && (P || !Te) : J ? je = Be && Se && !Te && (P || !ot) : Te || ot ? je = !1 : je = P ? fe <= b : fe < b;
            je ? R = ce + 1 : $ = ce;
          }
          return ur($, Y);
        }
        function EN(p, b) {
          for (var _ = -1, P = p.length, R = 0, $ = []; ++_ < P; ) {
            var W = p[_], K = b ? b(W) : W;
            if (!_ || !Ui(K, J)) {
              var J = K;
              $[R++] = W === 0 ? 0 : W;
            }
          }
          return $;
        }
        function NN(p) {
          return typeof p == "number" ? p : ii(p) ? de : +p;
        }
        function ri(p) {
          if (typeof p == "string")
            return p;
          if (Qe(p))
            return nn(p, ri) + "";
          if (ii(p))
            return iN ? iN.call(p) : "";
          var b = p + "";
          return b == "0" && 1 / p == -1 / 0 ? "-0" : b;
        }
        function ss(p, b, _) {
          var P = -1, R = Up, $ = p.length, W = !0, K = [], J = K;
          if (_)
            W = !1, R = gy;
          else if ($ >= i) {
            var ue = b ? null : zie(p);
            if (ue)
              return Kp(ue);
            W = !1, R = zd, J = new cl();
          } else
            J = b ? [] : K;
          e:
            for (; ++P < $; ) {
              var ce = p[P], fe = b ? b(ce) : ce;
              if (ce = _ || ce !== 0 ? ce : 0, W && fe === fe) {
                for (var Se = J.length; Se--; )
                  if (J[Se] === fe)
                    continue e;
                b && J.push(fe), K.push(ce);
              } else R(J, fe, _) || (J !== K && J.push(fe), K.push(ce));
            }
          return K;
        }
        function qy(p, b) {
          return b = ls(b, p), p = eA(p, b), p == null || delete p[Eo(_i(b))];
        }
        function AN(p, b, _, P) {
          return Qd(p, b, _(fl(p, b)), P);
        }
        function p0(p, b, _, P) {
          for (var R = p.length, $ = P ? R : -1; (P ? $-- : ++$ < R) && b(p[$], $, p); )
            ;
          return _ ? Si(p, P ? 0 : $, P ? $ + 1 : R) : Si(p, P ? $ + 1 : 0, P ? R : $);
        }
        function ON(p, b) {
          var _ = p;
          return _ instanceof pt && (_ = _.value()), vy(b, function(P, R) {
            return R.func.apply(R.thisArg, ns([P], R.args));
          }, _);
        }
        function zy(p, b, _) {
          var P = p.length;
          if (P < 2)
            return P ? ss(p[0]) : [];
          for (var R = -1, $ = ee(P); ++R < P; )
            for (var W = p[R], K = -1; ++K < P; )
              K != R && ($[R] = Zd($[R] || W, p[K], b, _));
          return ss(Xn($, 1), b, _);
        }
        function kN(p, b, _) {
          for (var P = -1, R = p.length, $ = b.length, W = {}; ++P < R; ) {
            var K = P < $ ? b[P] : n;
            _(W, p[P], K);
          }
          return W;
        }
        function Wy(p) {
          return pn(p) ? p : [];
        }
        function Hy(p) {
          return typeof p == "function" ? p : jr;
        }
        function ls(p, b) {
          return Qe(p) ? p : eb(p, b) ? [p] : iA(Ct(p));
        }
        var Rie = lt;
        function us(p, b, _) {
          var P = p.length;
          return _ = _ === n ? P : _, !b && _ >= P ? p : Si(p, b, _);
        }
        var PN = xre || function(p) {
          return Zn.clearTimeout(p);
        };
        function TN(p, b) {
          if (b)
            return p.slice();
          var _ = p.length, P = JE ? JE(_) : new p.constructor(_);
          return p.copy(P), P;
        }
        function Uy(p) {
          var b = new p.constructor(p.byteLength);
          return new e0(b).set(new e0(p)), b;
        }
        function Die(p, b) {
          var _ = b ? Uy(p.buffer) : p.buffer;
          return new p.constructor(_, p.byteOffset, p.byteLength);
        }
        function Iie(p) {
          var b = new p.constructor(p.source, pE.exec(p));
          return b.lastIndex = p.lastIndex, b;
        }
        function $ie(p) {
          return Kd ? Bt(Kd.call(p)) : {};
        }
        function MN(p, b) {
          var _ = b ? Uy(p.buffer) : p.buffer;
          return new p.constructor(_, p.byteOffset, p.length);
        }
        function RN(p, b) {
          if (p !== b) {
            var _ = p !== n, P = p === null, R = p === p, $ = ii(p), W = b !== n, K = b === null, J = b === b, ue = ii(b);
            if (!K && !ue && !$ && p > b || $ && W && J && !K && !ue || P && W && J || !_ && J || !R)
              return 1;
            if (!P && !$ && !ue && p < b || ue && _ && R && !P && !$ || K && _ && R || !W && R || !J)
              return -1;
          }
          return 0;
        }
        function Lie(p, b, _) {
          for (var P = -1, R = p.criteria, $ = b.criteria, W = R.length, K = _.length; ++P < W; ) {
            var J = RN(R[P], $[P]);
            if (J) {
              if (P >= K)
                return J;
              var ue = _[P];
              return J * (ue == "desc" ? -1 : 1);
            }
          }
          return p.index - b.index;
        }
        function DN(p, b, _, P) {
          for (var R = -1, $ = p.length, W = _.length, K = -1, J = b.length, ue = kn($ - W, 0), ce = ee(J + ue), fe = !P; ++K < J; )
            ce[K] = b[K];
          for (; ++R < W; )
            (fe || R < $) && (ce[_[R]] = p[R]);
          for (; ue--; )
            ce[K++] = p[R++];
          return ce;
        }
        function IN(p, b, _, P) {
          for (var R = -1, $ = p.length, W = -1, K = _.length, J = -1, ue = b.length, ce = kn($ - K, 0), fe = ee(ce + ue), Se = !P; ++R < ce; )
            fe[R] = p[R];
          for (var Te = R; ++J < ue; )
            fe[Te + J] = b[J];
          for (; ++W < K; )
            (Se || R < $) && (fe[Te + _[W]] = p[R++]);
          return fe;
        }
        function Lr(p, b) {
          var _ = -1, P = p.length;
          for (b || (b = ee(P)); ++_ < P; )
            b[_] = p[_];
          return b;
        }
        function _o(p, b, _, P) {
          var R = !_;
          _ || (_ = {});
          for (var $ = -1, W = b.length; ++$ < W; ) {
            var K = b[$], J = P ? P(_[K], p[K], K, _, p) : n;
            J === n && (J = p[K]), R ? ca(_, K, J) : Yd(_, K, J);
          }
          return _;
        }
        function Fie(p, b) {
          return _o(p, Qy(p), b);
        }
        function Bie(p, b) {
          return _o(p, KN(p), b);
        }
        function m0(p, b) {
          return function(_, P) {
            var R = Qe(_) ? Wne : sie, $ = b ? b() : {};
            return R(_, p, Le(P, 2), $);
          };
        }
        function Ou(p) {
          return lt(function(b, _) {
            var P = -1, R = _.length, $ = R > 1 ? _[R - 1] : n, W = R > 2 ? _[2] : n;
            for ($ = p.length > 3 && typeof $ == "function" ? (R--, $) : n, W && Sr(_[0], _[1], W) && ($ = R < 3 ? n : $, R = 1), b = Bt(b); ++P < R; ) {
              var K = _[P];
              K && p(b, K, P, $);
            }
            return b;
          });
        }
        function $N(p, b) {
          return function(_, P) {
            if (_ == null)
              return _;
            if (!Fr(_))
              return p(_, P);
            for (var R = _.length, $ = b ? R : -1, W = Bt(_); (b ? $-- : ++$ < R) && P(W[$], $, W) !== !1; )
              ;
            return _;
          };
        }
        function LN(p) {
          return function(b, _, P) {
            for (var R = -1, $ = Bt(b), W = P(b), K = W.length; K--; ) {
              var J = W[p ? K : ++R];
              if (_($[J], J, $) === !1)
                break;
            }
            return b;
          };
        }
        function jie(p, b, _) {
          var P = b & y, R = ef(p);
          function $() {
            var W = this && this !== Zn && this instanceof $ ? R : p;
            return W.apply(P ? _ : this, arguments);
          }
          return $;
        }
        function FN(p) {
          return function(b) {
            b = Ct(b);
            var _ = wu(b) ? Wi(b) : n, P = _ ? _[0] : b.charAt(0), R = _ ? us(_, 1).join("") : b.slice(1);
            return P[p]() + R;
          };
        }
        function ku(p) {
          return function(b) {
            return vy($A(IA(b).replace(Pne, "")), p, "");
          };
        }
        function ef(p) {
          return function() {
            var b = arguments;
            switch (b.length) {
              case 0:
                return new p();
              case 1:
                return new p(b[0]);
              case 2:
                return new p(b[0], b[1]);
              case 3:
                return new p(b[0], b[1], b[2]);
              case 4:
                return new p(b[0], b[1], b[2], b[3]);
              case 5:
                return new p(b[0], b[1], b[2], b[3], b[4]);
              case 6:
                return new p(b[0], b[1], b[2], b[3], b[4], b[5]);
              case 7:
                return new p(b[0], b[1], b[2], b[3], b[4], b[5], b[6]);
            }
            var _ = Au(p.prototype), P = p.apply(_, b);
            return an(P) ? P : _;
          };
        }
        function Vie(p, b, _) {
          var P = ef(p);
          function R() {
            for (var $ = arguments.length, W = ee($), K = $, J = Pu(R); K--; )
              W[K] = arguments[K];
            var ue = $ < 3 && W[0] !== J && W[$ - 1] !== J ? [] : rs(W, J);
            if ($ -= ue.length, $ < _)
              return zN(
                p,
                b,
                g0,
                R.placeholder,
                n,
                W,
                ue,
                n,
                n,
                _ - $
              );
            var ce = this && this !== Zn && this instanceof R ? P : p;
            return ti(ce, this, W);
          }
          return R;
        }
        function BN(p) {
          return function(b, _, P) {
            var R = Bt(b);
            if (!Fr(b)) {
              var $ = Le(_, 3);
              b = Ln(b), _ = function(K) {
                return $(R[K], K, R);
              };
            }
            var W = p(b, _, P);
            return W > -1 ? R[$ ? b[W] : W] : n;
          };
        }
        function jN(p) {
          return fa(function(b) {
            var _ = b.length, P = _, R = wi.prototype.thru;
            for (p && b.reverse(); P--; ) {
              var $ = b[P];
              if (typeof $ != "function")
                throw new xi(a);
              if (R && !W && x0($) == "wrapper")
                var W = new wi([], !0);
            }
            for (P = W ? P : _; ++P < _; ) {
              $ = b[P];
              var K = x0($), J = K == "wrapper" ? Xy($) : n;
              J && tb(J[0]) && J[1] == (O | S | E | T) && !J[4].length && J[9] == 1 ? W = W[x0(J[0])].apply(W, J[3]) : W = $.length == 1 && tb($) ? W[K]() : W.thru($);
            }
            return function() {
              var ue = arguments, ce = ue[0];
              if (W && ue.length == 1 && Qe(ce))
                return W.plant(ce).value();
              for (var fe = 0, Se = _ ? b[fe].apply(this, ue) : ce; ++fe < _; )
                Se = b[fe].call(this, Se);
              return Se;
            };
          });
        }
        function g0(p, b, _, P, R, $, W, K, J, ue) {
          var ce = b & O, fe = b & y, Se = b & w, Te = b & (S | N), Be = b & M, ot = Se ? n : ef(p);
          function je() {
            for (var ft = arguments.length, gt = ee(ft), oi = ft; oi--; )
              gt[oi] = arguments[oi];
            if (Te)
              var _r = Pu(je), ai = Qne(gt, _r);
            if (P && (gt = DN(gt, P, R, Te)), $ && (gt = IN(gt, $, W, Te)), ft -= ai, Te && ft < ue) {
              var mn = rs(gt, _r);
              return zN(
                p,
                b,
                g0,
                je.placeholder,
                _,
                gt,
                mn,
                K,
                J,
                ue - ft
              );
            }
            var Gi = fe ? _ : this, ga = Se ? Gi[p] : p;
            return ft = gt.length, K ? gt = soe(gt, K) : Be && ft > 1 && gt.reverse(), ce && J < ft && (gt.length = J), this && this !== Zn && this instanceof je && (ga = ot || ef(ga)), ga.apply(Gi, gt);
          }
          return je;
        }
        function VN(p, b) {
          return function(_, P) {
            return mie(_, p, b(P), {});
          };
        }
        function v0(p, b) {
          return function(_, P) {
            var R;
            if (_ === n && P === n)
              return b;
            if (_ !== n && (R = _), P !== n) {
              if (R === n)
                return P;
              typeof _ == "string" || typeof P == "string" ? (_ = ri(_), P = ri(P)) : (_ = NN(_), P = NN(P)), R = p(_, P);
            }
            return R;
          };
        }
        function Gy(p) {
          return fa(function(b) {
            return b = nn(b, ni(Le())), lt(function(_) {
              var P = this;
              return p(b, function(R) {
                return ti(R, P, _);
              });
            });
          });
        }
        function y0(p, b) {
          b = b === n ? " " : ri(b);
          var _ = b.length;
          if (_ < 2)
            return _ ? jy(b, p) : b;
          var P = jy(b, i0(p / Cu(b)));
          return wu(b) ? us(Wi(P), 0, p).join("") : P.slice(0, p);
        }
        function qie(p, b, _, P) {
          var R = b & y, $ = ef(p);
          function W() {
            for (var K = -1, J = arguments.length, ue = -1, ce = P.length, fe = ee(ce + J), Se = this && this !== Zn && this instanceof W ? $ : p; ++ue < ce; )
              fe[ue] = P[ue];
            for (; J--; )
              fe[ue++] = arguments[++K];
            return ti(Se, R ? _ : this, fe);
          }
          return W;
        }
        function qN(p) {
          return function(b, _, P) {
            return P && typeof P != "number" && Sr(b, _, P) && (_ = P = n), b = ma(b), _ === n ? (_ = b, b = 0) : _ = ma(_), P = P === n ? b < _ ? 1 : -1 : ma(P), Aie(b, _, P, p);
          };
        }
        function b0(p) {
          return function(b, _) {
            return typeof b == "string" && typeof _ == "string" || (b = Ei(b), _ = Ei(_)), p(b, _);
          };
        }
        function zN(p, b, _, P, R, $, W, K, J, ue) {
          var ce = b & S, fe = ce ? W : n, Se = ce ? n : W, Te = ce ? $ : n, Be = ce ? n : $;
          b |= ce ? E : A, b &= ~(ce ? A : E), b & C || (b &= -4);
          var ot = [
            p,
            b,
            R,
            Te,
            fe,
            Be,
            Se,
            K,
            J,
            ue
          ], je = _.apply(n, ot);
          return tb(p) && tA(je, ot), je.placeholder = P, nA(je, p, b);
        }
        function Ky(p) {
          var b = On[p];
          return function(_, P) {
            if (_ = Ei(_), P = P == null ? 0 : ur(rt(P), 292), P && nN(_)) {
              var R = (Ct(_) + "e").split("e"), $ = b(R[0] + "e" + (+R[1] + P));
              return R = (Ct($) + "e").split("e"), +(R[0] + "e" + (+R[1] - P));
            }
            return b(_);
          };
        }
        var zie = Eu && 1 / Kp(new Eu([, -0]))[1] == V ? function(p) {
          return new Eu(p);
        } : gb;
        function WN(p) {
          return function(b) {
            var _ = cr(b);
            return _ == se ? _y(b) : _ == An ? are(b) : Jne(b, p(b));
          };
        }
        function da(p, b, _, P, R, $, W, K) {
          var J = b & w;
          if (!J && typeof p != "function")
            throw new xi(a);
          var ue = P ? P.length : 0;
          if (ue || (b &= -97, P = R = n), W = W === n ? W : kn(rt(W), 0), K = K === n ? K : rt(K), ue -= R ? R.length : 0, b & A) {
            var ce = P, fe = R;
            P = R = n;
          }
          var Se = J ? n : Xy(p), Te = [
            p,
            b,
            _,
            P,
            R,
            ce,
            fe,
            $,
            W,
            K
          ];
          if (Se && ioe(Te, Se), p = Te[0], b = Te[1], _ = Te[2], P = Te[3], R = Te[4], K = Te[9] = Te[9] === n ? J ? 0 : p.length : kn(Te[9] - ue, 0), !K && b & (S | N) && (b &= -25), !b || b == y)
            var Be = jie(p, b, _);
          else b == S || b == N ? Be = Vie(p, b, K) : (b == E || b == (y | E)) && !R.length ? Be = qie(p, b, _, P) : Be = g0.apply(n, Te);
          var ot = Se ? _N : tA;
          return nA(ot(Be, Te), p, b);
        }
        function HN(p, b, _, P) {
          return p === n || Ui(p, _u[_]) && !kt.call(P, _) ? b : p;
        }
        function UN(p, b, _, P, R, $) {
          return an(p) && an(b) && ($.set(b, p), f0(p, b, n, UN, $), $.delete(b)), p;
        }
        function Wie(p) {
          return rf(p) ? n : p;
        }
        function GN(p, b, _, P, R, $) {
          var W = _ & v, K = p.length, J = b.length;
          if (K != J && !(W && J > K))
            return !1;
          var ue = $.get(p), ce = $.get(b);
          if (ue && ce)
            return ue == b && ce == p;
          var fe = -1, Se = !0, Te = _ & g ? new cl() : n;
          for ($.set(p, b), $.set(b, p); ++fe < K; ) {
            var Be = p[fe], ot = b[fe];
            if (P)
              var je = W ? P(ot, Be, fe, b, p, $) : P(Be, ot, fe, p, b, $);
            if (je !== n) {
              if (je)
                continue;
              Se = !1;
              break;
            }
            if (Te) {
              if (!yy(b, function(ft, gt) {
                if (!zd(Te, gt) && (Be === ft || R(Be, ft, _, P, $)))
                  return Te.push(gt);
              })) {
                Se = !1;
                break;
              }
            } else if (!(Be === ot || R(Be, ot, _, P, $))) {
              Se = !1;
              break;
            }
          }
          return $.delete(p), $.delete(b), Se;
        }
        function Hie(p, b, _, P, R, $, W) {
          switch (_) {
            case yu:
              if (p.byteLength != b.byteLength || p.byteOffset != b.byteOffset)
                return !1;
              p = p.buffer, b = b.buffer;
            case es:
              return !(p.byteLength != b.byteLength || !$(new e0(p), new e0(b)));
            case Ce:
            case ie:
            case nt:
              return Ui(+p, +b);
            case ve:
              return p.name == b.name && p.message == b.message;
            case Co:
            case wr:
              return p == b + "";
            case se:
              var K = _y;
            case An:
              var J = P & v;
              if (K || (K = Kp), p.size != b.size && !J)
                return !1;
              var ue = W.get(p);
              if (ue)
                return ue == b;
              P |= g, W.set(p, b);
              var ce = GN(K(p), K(b), P, R, $, W);
              return W.delete(p), ce;
            case Qa:
              if (Kd)
                return Kd.call(p) == Kd.call(b);
          }
          return !1;
        }
        function Uie(p, b, _, P, R, $) {
          var W = _ & v, K = Yy(p), J = K.length, ue = Yy(b), ce = ue.length;
          if (J != ce && !W)
            return !1;
          for (var fe = J; fe--; ) {
            var Se = K[fe];
            if (!(W ? Se in b : kt.call(b, Se)))
              return !1;
          }
          var Te = $.get(p), Be = $.get(b);
          if (Te && Be)
            return Te == b && Be == p;
          var ot = !0;
          $.set(p, b), $.set(b, p);
          for (var je = W; ++fe < J; ) {
            Se = K[fe];
            var ft = p[Se], gt = b[Se];
            if (P)
              var oi = W ? P(gt, ft, Se, b, p, $) : P(ft, gt, Se, p, b, $);
            if (!(oi === n ? ft === gt || R(ft, gt, _, P, $) : oi)) {
              ot = !1;
              break;
            }
            je || (je = Se == "constructor");
          }
          if (ot && !je) {
            var _r = p.constructor, ai = b.constructor;
            _r != ai && "constructor" in p && "constructor" in b && !(typeof _r == "function" && _r instanceof _r && typeof ai == "function" && ai instanceof ai) && (ot = !1);
          }
          return $.delete(p), $.delete(b), ot;
        }
        function fa(p) {
          return rb(QN(p, n, lA), p + "");
        }
        function Yy(p) {
          return hN(p, Ln, Qy);
        }
        function Zy(p) {
          return hN(p, Br, KN);
        }
        var Xy = a0 ? function(p) {
          return a0.get(p);
        } : gb;
        function x0(p) {
          for (var b = p.name + "", _ = Nu[b], P = kt.call(Nu, b) ? _.length : 0; P--; ) {
            var R = _[P], $ = R.func;
            if ($ == null || $ == p)
              return R.name;
          }
          return b;
        }
        function Pu(p) {
          var b = kt.call(D, "placeholder") ? D : p;
          return b.placeholder;
        }
        function Le() {
          var p = D.iteratee || pb;
          return p = p === pb ? gN : p, arguments.length ? p(arguments[0], arguments[1]) : p;
        }
        function w0(p, b) {
          var _ = p.__data__;
          return eoe(b) ? _[typeof b == "string" ? "string" : "hash"] : _.map;
        }
        function Jy(p) {
          for (var b = Ln(p), _ = b.length; _--; ) {
            var P = b[_], R = p[P];
            b[_] = [P, R, XN(R)];
          }
          return b;
        }
        function hl(p, b) {
          var _ = rre(p, b);
          return mN(_) ? _ : n;
        }
        function Gie(p) {
          var b = kt.call(p, ll), _ = p[ll];
          try {
            p[ll] = n;
            var P = !0;
          } catch {
          }
          var R = Jp.call(p);
          return P && (b ? p[ll] = _ : delete p[ll]), R;
        }
        var Qy = Ny ? function(p) {
          return p == null ? [] : (p = Bt(p), ts(Ny(p), function(b) {
            return eN.call(p, b);
          }));
        } : vb, KN = Ny ? function(p) {
          for (var b = []; p; )
            ns(b, Qy(p)), p = t0(p);
          return b;
        } : vb, cr = Cr;
        (Ay && cr(new Ay(new ArrayBuffer(1))) != yu || Hd && cr(new Hd()) != se || Oy && cr(Oy.resolve()) != Nn || Eu && cr(new Eu()) != An || Ud && cr(new Ud()) != sa) && (cr = function(p) {
          var b = Cr(p), _ = b == st ? p.constructor : n, P = _ ? pl(_) : "";
          if (P)
            switch (P) {
              case kre:
                return yu;
              case Pre:
                return se;
              case Tre:
                return Nn;
              case Mre:
                return An;
              case Rre:
                return sa;
            }
          return b;
        });
        function Kie(p, b, _) {
          for (var P = -1, R = _.length; ++P < R; ) {
            var $ = _[P], W = $.size;
            switch ($.type) {
              case "drop":
                p += W;
                break;
              case "dropRight":
                b -= W;
                break;
              case "take":
                b = ur(b, p + W);
                break;
              case "takeRight":
                p = kn(p, b - W);
                break;
            }
          }
          return { start: p, end: b };
        }
        function Yie(p) {
          var b = p.match(tne);
          return b ? b[1].split(nne) : [];
        }
        function YN(p, b, _) {
          b = ls(b, p);
          for (var P = -1, R = b.length, $ = !1; ++P < R; ) {
            var W = Eo(b[P]);
            if (!($ = p != null && _(p, W)))
              break;
            p = p[W];
          }
          return $ || ++P != R ? $ : (R = p == null ? 0 : p.length, !!R && O0(R) && ha(W, R) && (Qe(p) || ml(p)));
        }
        function Zie(p) {
          var b = p.length, _ = new p.constructor(b);
          return b && typeof p[0] == "string" && kt.call(p, "index") && (_.index = p.index, _.input = p.input), _;
        }
        function ZN(p) {
          return typeof p.constructor == "function" && !tf(p) ? Au(t0(p)) : {};
        }
        function Xie(p, b, _) {
          var P = p.constructor;
          switch (b) {
            case es:
              return Uy(p);
            case Ce:
            case ie:
              return new P(+p);
            case yu:
              return Die(p, _);
            case Jv:
            case Qv:
            case ey:
            case ty:
            case ny:
            case ry:
            case iy:
            case oy:
            case ay:
              return MN(p, _);
            case se:
              return new P();
            case nt:
            case wr:
              return new P(p);
            case Co:
              return Iie(p);
            case An:
              return new P();
            case Qa:
              return $ie(p);
          }
        }
        function Jie(p, b) {
          var _ = b.length;
          if (!_)
            return p;
          var P = _ - 1;
          return b[P] = (_ > 1 ? "& " : "") + b[P], b = b.join(_ > 2 ? ", " : " "), p.replace(ene, `{
/* [wrapped with ` + b + `] */
`);
        }
        function Qie(p) {
          return Qe(p) || ml(p) || !!(tN && p && p[tN]);
        }
        function ha(p, b) {
          var _ = typeof p;
          return b = b ?? H, !!b && (_ == "number" || _ != "symbol" && dne.test(p)) && p > -1 && p % 1 == 0 && p < b;
        }
        function Sr(p, b, _) {
          if (!an(_))
            return !1;
          var P = typeof b;
          return (P == "number" ? Fr(_) && ha(b, _.length) : P == "string" && b in _) ? Ui(_[b], p) : !1;
        }
        function eb(p, b) {
          if (Qe(p))
            return !1;
          var _ = typeof p;
          return _ == "number" || _ == "symbol" || _ == "boolean" || p == null || ii(p) ? !0 : Zte.test(p) || !Yte.test(p) || b != null && p in Bt(b);
        }
        function eoe(p) {
          var b = typeof p;
          return b == "string" || b == "number" || b == "symbol" || b == "boolean" ? p !== "__proto__" : p === null;
        }
        function tb(p) {
          var b = x0(p), _ = D[b];
          if (typeof _ != "function" || !(b in pt.prototype))
            return !1;
          if (p === _)
            return !0;
          var P = Xy(_);
          return !!P && p === P[0];
        }
        function toe(p) {
          return !!XE && XE in p;
        }
        var noe = Zp ? pa : yb;
        function tf(p) {
          var b = p && p.constructor, _ = typeof b == "function" && b.prototype || _u;
          return p === _;
        }
        function XN(p) {
          return p === p && !an(p);
        }
        function JN(p, b) {
          return function(_) {
            return _ == null ? !1 : _[p] === b && (b !== n || p in Bt(_));
          };
        }
        function roe(p) {
          var b = N0(p, function(P) {
            return _.size === u && _.clear(), P;
          }), _ = b.cache;
          return b;
        }
        function ioe(p, b) {
          var _ = p[1], P = b[1], R = _ | P, $ = R < (y | w | O), W = P == O && _ == S || P == O && _ == T && p[7].length <= b[8] || P == (O | T) && b[7].length <= b[8] && _ == S;
          if (!($ || W))
            return p;
          P & y && (p[2] = b[2], R |= _ & y ? 0 : C);
          var K = b[3];
          if (K) {
            var J = p[3];
            p[3] = J ? DN(J, K, b[4]) : K, p[4] = J ? rs(p[3], c) : b[4];
          }
          return K = b[5], K && (J = p[5], p[5] = J ? IN(J, K, b[6]) : K, p[6] = J ? rs(p[5], c) : b[6]), K = b[7], K && (p[7] = K), P & O && (p[8] = p[8] == null ? b[8] : ur(p[8], b[8])), p[9] == null && (p[9] = b[9]), p[0] = b[0], p[1] = R, p;
        }
        function ooe(p) {
          var b = [];
          if (p != null)
            for (var _ in Bt(p))
              b.push(_);
          return b;
        }
        function aoe(p) {
          return Jp.call(p);
        }
        function QN(p, b, _) {
          return b = kn(b === n ? p.length - 1 : b, 0), function() {
            for (var P = arguments, R = -1, $ = kn(P.length - b, 0), W = ee($); ++R < $; )
              W[R] = P[b + R];
            R = -1;
            for (var K = ee(b + 1); ++R < b; )
              K[R] = P[R];
            return K[b] = _(W), ti(p, this, K);
          };
        }
        function eA(p, b) {
          return b.length < 2 ? p : fl(p, Si(b, 0, -1));
        }
        function soe(p, b) {
          for (var _ = p.length, P = ur(b.length, _), R = Lr(p); P--; ) {
            var $ = b[P];
            p[P] = ha($, _) ? R[$] : n;
          }
          return p;
        }
        function nb(p, b) {
          if (!(b === "constructor" && typeof p[b] == "function") && b != "__proto__")
            return p[b];
        }
        var tA = rA(_N), nf = Cre || function(p, b) {
          return Zn.setTimeout(p, b);
        }, rb = rA(Pie);
        function nA(p, b, _) {
          var P = b + "";
          return rb(p, Jie(P, loe(Yie(P), _)));
        }
        function rA(p) {
          var b = 0, _ = 0;
          return function() {
            var P = Nre(), R = B - (P - _);
            if (_ = P, R > 0) {
              if (++b >= j)
                return arguments[0];
            } else
              b = 0;
            return p.apply(n, arguments);
          };
        }
        function C0(p, b) {
          var _ = -1, P = p.length, R = P - 1;
          for (b = b === n ? P : b; ++_ < b; ) {
            var $ = By(_, R), W = p[$];
            p[$] = p[_], p[_] = W;
          }
          return p.length = b, p;
        }
        var iA = roe(function(p) {
          var b = [];
          return p.charCodeAt(0) === 46 && b.push(""), p.replace(Xte, function(_, P, R, $) {
            b.push(R ? $.replace(one, "$1") : P || _);
          }), b;
        });
        function Eo(p) {
          if (typeof p == "string" || ii(p))
            return p;
          var b = p + "";
          return b == "0" && 1 / p == -1 / 0 ? "-0" : b;
        }
        function pl(p) {
          if (p != null) {
            try {
              return Xp.call(p);
            } catch {
            }
            try {
              return p + "";
            } catch {
            }
          }
          return "";
        }
        function loe(p, b) {
          return bi(be, function(_) {
            var P = "_." + _[0];
            b & _[1] && !Up(p, P) && p.push(P);
          }), p.sort();
        }
        function oA(p) {
          if (p instanceof pt)
            return p.clone();
          var b = new wi(p.__wrapped__, p.__chain__);
          return b.__actions__ = Lr(p.__actions__), b.__index__ = p.__index__, b.__values__ = p.__values__, b;
        }
        function uoe(p, b, _) {
          (_ ? Sr(p, b, _) : b === n) ? b = 1 : b = kn(rt(b), 0);
          var P = p == null ? 0 : p.length;
          if (!P || b < 1)
            return [];
          for (var R = 0, $ = 0, W = ee(i0(P / b)); R < P; )
            W[$++] = Si(p, R, R += b);
          return W;
        }
        function coe(p) {
          for (var b = -1, _ = p == null ? 0 : p.length, P = 0, R = []; ++b < _; ) {
            var $ = p[b];
            $ && (R[P++] = $);
          }
          return R;
        }
        function doe() {
          var p = arguments.length;
          if (!p)
            return [];
          for (var b = ee(p - 1), _ = arguments[0], P = p; P--; )
            b[P - 1] = arguments[P];
          return ns(Qe(_) ? Lr(_) : [_], Xn(b, 1));
        }
        var foe = lt(function(p, b) {
          return pn(p) ? Zd(p, Xn(b, 1, pn, !0)) : [];
        }), hoe = lt(function(p, b) {
          var _ = _i(b);
          return pn(_) && (_ = n), pn(p) ? Zd(p, Xn(b, 1, pn, !0), Le(_, 2)) : [];
        }), poe = lt(function(p, b) {
          var _ = _i(b);
          return pn(_) && (_ = n), pn(p) ? Zd(p, Xn(b, 1, pn, !0), n, _) : [];
        });
        function moe(p, b, _) {
          var P = p == null ? 0 : p.length;
          return P ? (b = _ || b === n ? 1 : rt(b), Si(p, b < 0 ? 0 : b, P)) : [];
        }
        function goe(p, b, _) {
          var P = p == null ? 0 : p.length;
          return P ? (b = _ || b === n ? 1 : rt(b), b = P - b, Si(p, 0, b < 0 ? 0 : b)) : [];
        }
        function voe(p, b) {
          return p && p.length ? p0(p, Le(b, 3), !0, !0) : [];
        }
        function yoe(p, b) {
          return p && p.length ? p0(p, Le(b, 3), !0) : [];
        }
        function boe(p, b, _, P) {
          var R = p == null ? 0 : p.length;
          return R ? (_ && typeof _ != "number" && Sr(p, b, _) && (_ = 0, P = R), die(p, b, _, P)) : [];
        }
        function aA(p, b, _) {
          var P = p == null ? 0 : p.length;
          if (!P)
            return -1;
          var R = _ == null ? 0 : rt(_);
          return R < 0 && (R = kn(P + R, 0)), Gp(p, Le(b, 3), R);
        }
        function sA(p, b, _) {
          var P = p == null ? 0 : p.length;
          if (!P)
            return -1;
          var R = P - 1;
          return _ !== n && (R = rt(_), R = _ < 0 ? kn(P + R, 0) : ur(R, P - 1)), Gp(p, Le(b, 3), R, !0);
        }
        function lA(p) {
          var b = p == null ? 0 : p.length;
          return b ? Xn(p, 1) : [];
        }
        function xoe(p) {
          var b = p == null ? 0 : p.length;
          return b ? Xn(p, V) : [];
        }
        function woe(p, b) {
          var _ = p == null ? 0 : p.length;
          return _ ? (b = b === n ? 1 : rt(b), Xn(p, b)) : [];
        }
        function Coe(p) {
          for (var b = -1, _ = p == null ? 0 : p.length, P = {}; ++b < _; ) {
            var R = p[b];
            P[R[0]] = R[1];
          }
          return P;
        }
        function uA(p) {
          return p && p.length ? p[0] : n;
        }
        function Soe(p, b, _) {
          var P = p == null ? 0 : p.length;
          if (!P)
            return -1;
          var R = _ == null ? 0 : rt(_);
          return R < 0 && (R = kn(P + R, 0)), xu(p, b, R);
        }
        function _oe(p) {
          var b = p == null ? 0 : p.length;
          return b ? Si(p, 0, -1) : [];
        }
        var Eoe = lt(function(p) {
          var b = nn(p, Wy);
          return b.length && b[0] === p[0] ? Dy(b) : [];
        }), Noe = lt(function(p) {
          var b = _i(p), _ = nn(p, Wy);
          return b === _i(_) ? b = n : _.pop(), _.length && _[0] === p[0] ? Dy(_, Le(b, 2)) : [];
        }), Aoe = lt(function(p) {
          var b = _i(p), _ = nn(p, Wy);
          return b = typeof b == "function" ? b : n, b && _.pop(), _.length && _[0] === p[0] ? Dy(_, n, b) : [];
        });
        function Ooe(p, b) {
          return p == null ? "" : _re.call(p, b);
        }
        function _i(p) {
          var b = p == null ? 0 : p.length;
          return b ? p[b - 1] : n;
        }
        function koe(p, b, _) {
          var P = p == null ? 0 : p.length;
          if (!P)
            return -1;
          var R = P;
          return _ !== n && (R = rt(_), R = R < 0 ? kn(P + R, 0) : ur(R, P - 1)), b === b ? lre(p, b, R) : Gp(p, zE, R, !0);
        }
        function Poe(p, b) {
          return p && p.length ? xN(p, rt(b)) : n;
        }
        var Toe = lt(cA);
        function cA(p, b) {
          return p && p.length && b && b.length ? Fy(p, b) : p;
        }
        function Moe(p, b, _) {
          return p && p.length && b && b.length ? Fy(p, b, Le(_, 2)) : p;
        }
        function Roe(p, b, _) {
          return p && p.length && b && b.length ? Fy(p, b, n, _) : p;
        }
        var Doe = fa(function(p, b) {
          var _ = p == null ? 0 : p.length, P = Py(p, b);
          return SN(p, nn(b, function(R) {
            return ha(R, _) ? +R : R;
          }).sort(RN)), P;
        });
        function Ioe(p, b) {
          var _ = [];
          if (!(p && p.length))
            return _;
          var P = -1, R = [], $ = p.length;
          for (b = Le(b, 3); ++P < $; ) {
            var W = p[P];
            b(W, P, p) && (_.push(W), R.push(P));
          }
          return SN(p, R), _;
        }
        function ib(p) {
          return p == null ? p : Ore.call(p);
        }
        function $oe(p, b, _) {
          var P = p == null ? 0 : p.length;
          return P ? (_ && typeof _ != "number" && Sr(p, b, _) ? (b = 0, _ = P) : (b = b == null ? 0 : rt(b), _ = _ === n ? P : rt(_)), Si(p, b, _)) : [];
        }
        function Loe(p, b) {
          return h0(p, b);
        }
        function Foe(p, b, _) {
          return Vy(p, b, Le(_, 2));
        }
        function Boe(p, b) {
          var _ = p == null ? 0 : p.length;
          if (_) {
            var P = h0(p, b);
            if (P < _ && Ui(p[P], b))
              return P;
          }
          return -1;
        }
        function joe(p, b) {
          return h0(p, b, !0);
        }
        function Voe(p, b, _) {
          return Vy(p, b, Le(_, 2), !0);
        }
        function qoe(p, b) {
          var _ = p == null ? 0 : p.length;
          if (_) {
            var P = h0(p, b, !0) - 1;
            if (Ui(p[P], b))
              return P;
          }
          return -1;
        }
        function zoe(p) {
          return p && p.length ? EN(p) : [];
        }
        function Woe(p, b) {
          return p && p.length ? EN(p, Le(b, 2)) : [];
        }
        function Hoe(p) {
          var b = p == null ? 0 : p.length;
          return b ? Si(p, 1, b) : [];
        }
        function Uoe(p, b, _) {
          return p && p.length ? (b = _ || b === n ? 1 : rt(b), Si(p, 0, b < 0 ? 0 : b)) : [];
        }
        function Goe(p, b, _) {
          var P = p == null ? 0 : p.length;
          return P ? (b = _ || b === n ? 1 : rt(b), b = P - b, Si(p, b < 0 ? 0 : b, P)) : [];
        }
        function Koe(p, b) {
          return p && p.length ? p0(p, Le(b, 3), !1, !0) : [];
        }
        function Yoe(p, b) {
          return p && p.length ? p0(p, Le(b, 3)) : [];
        }
        var Zoe = lt(function(p) {
          return ss(Xn(p, 1, pn, !0));
        }), Xoe = lt(function(p) {
          var b = _i(p);
          return pn(b) && (b = n), ss(Xn(p, 1, pn, !0), Le(b, 2));
        }), Joe = lt(function(p) {
          var b = _i(p);
          return b = typeof b == "function" ? b : n, ss(Xn(p, 1, pn, !0), n, b);
        });
        function Qoe(p) {
          return p && p.length ? ss(p) : [];
        }
        function eae(p, b) {
          return p && p.length ? ss(p, Le(b, 2)) : [];
        }
        function tae(p, b) {
          return b = typeof b == "function" ? b : n, p && p.length ? ss(p, n, b) : [];
        }
        function ob(p) {
          if (!(p && p.length))
            return [];
          var b = 0;
          return p = ts(p, function(_) {
            if (pn(_))
              return b = kn(_.length, b), !0;
          }), Cy(b, function(_) {
            return nn(p, by(_));
          });
        }
        function dA(p, b) {
          if (!(p && p.length))
            return [];
          var _ = ob(p);
          return b == null ? _ : nn(_, function(P) {
            return ti(b, n, P);
          });
        }
        var nae = lt(function(p, b) {
          return pn(p) ? Zd(p, b) : [];
        }), rae = lt(function(p) {
          return zy(ts(p, pn));
        }), iae = lt(function(p) {
          var b = _i(p);
          return pn(b) && (b = n), zy(ts(p, pn), Le(b, 2));
        }), oae = lt(function(p) {
          var b = _i(p);
          return b = typeof b == "function" ? b : n, zy(ts(p, pn), n, b);
        }), aae = lt(ob);
        function sae(p, b) {
          return kN(p || [], b || [], Yd);
        }
        function lae(p, b) {
          return kN(p || [], b || [], Qd);
        }
        var uae = lt(function(p) {
          var b = p.length, _ = b > 1 ? p[b - 1] : n;
          return _ = typeof _ == "function" ? (p.pop(), _) : n, dA(p, _);
        });
        function fA(p) {
          var b = D(p);
          return b.__chain__ = !0, b;
        }
        function cae(p, b) {
          return b(p), p;
        }
        function S0(p, b) {
          return b(p);
        }
        var dae = fa(function(p) {
          var b = p.length, _ = b ? p[0] : 0, P = this.__wrapped__, R = function($) {
            return Py($, p);
          };
          return b > 1 || this.__actions__.length || !(P instanceof pt) || !ha(_) ? this.thru(R) : (P = P.slice(_, +_ + (b ? 1 : 0)), P.__actions__.push({
            func: S0,
            args: [R],
            thisArg: n
          }), new wi(P, this.__chain__).thru(function($) {
            return b && !$.length && $.push(n), $;
          }));
        });
        function fae() {
          return fA(this);
        }
        function hae() {
          return new wi(this.value(), this.__chain__);
        }
        function pae() {
          this.__values__ === n && (this.__values__ = NA(this.value()));
          var p = this.__index__ >= this.__values__.length, b = p ? n : this.__values__[this.__index__++];
          return { done: p, value: b };
        }
        function mae() {
          return this;
        }
        function gae(p) {
          for (var b, _ = this; _ instanceof l0; ) {
            var P = oA(_);
            P.__index__ = 0, P.__values__ = n, b ? R.__wrapped__ = P : b = P;
            var R = P;
            _ = _.__wrapped__;
          }
          return R.__wrapped__ = p, b;
        }
        function vae() {
          var p = this.__wrapped__;
          if (p instanceof pt) {
            var b = p;
            return this.__actions__.length && (b = new pt(this)), b = b.reverse(), b.__actions__.push({
              func: S0,
              args: [ib],
              thisArg: n
            }), new wi(b, this.__chain__);
          }
          return this.thru(ib);
        }
        function yae() {
          return ON(this.__wrapped__, this.__actions__);
        }
        var bae = m0(function(p, b, _) {
          kt.call(p, _) ? ++p[_] : ca(p, _, 1);
        });
        function xae(p, b, _) {
          var P = Qe(p) ? VE : cie;
          return _ && Sr(p, b, _) && (b = n), P(p, Le(b, 3));
        }
        function wae(p, b) {
          var _ = Qe(p) ? ts : dN;
          return _(p, Le(b, 3));
        }
        var Cae = BN(aA), Sae = BN(sA);
        function _ae(p, b) {
          return Xn(_0(p, b), 1);
        }
        function Eae(p, b) {
          return Xn(_0(p, b), V);
        }
        function Nae(p, b, _) {
          return _ = _ === n ? 1 : rt(_), Xn(_0(p, b), _);
        }
        function hA(p, b) {
          var _ = Qe(p) ? bi : as;
          return _(p, Le(b, 3));
        }
        function pA(p, b) {
          var _ = Qe(p) ? Hne : cN;
          return _(p, Le(b, 3));
        }
        var Aae = m0(function(p, b, _) {
          kt.call(p, _) ? p[_].push(b) : ca(p, _, [b]);
        });
        function Oae(p, b, _, P) {
          p = Fr(p) ? p : Mu(p), _ = _ && !P ? rt(_) : 0;
          var R = p.length;
          return _ < 0 && (_ = kn(R + _, 0)), k0(p) ? _ <= R && p.indexOf(b, _) > -1 : !!R && xu(p, b, _) > -1;
        }
        var kae = lt(function(p, b, _) {
          var P = -1, R = typeof b == "function", $ = Fr(p) ? ee(p.length) : [];
          return as(p, function(W) {
            $[++P] = R ? ti(b, W, _) : Xd(W, b, _);
          }), $;
        }), Pae = m0(function(p, b, _) {
          ca(p, _, b);
        });
        function _0(p, b) {
          var _ = Qe(p) ? nn : vN;
          return _(p, Le(b, 3));
        }
        function Tae(p, b, _, P) {
          return p == null ? [] : (Qe(b) || (b = b == null ? [] : [b]), _ = P ? n : _, Qe(_) || (_ = _ == null ? [] : [_]), wN(p, b, _));
        }
        var Mae = m0(function(p, b, _) {
          p[_ ? 0 : 1].push(b);
        }, function() {
          return [[], []];
        });
        function Rae(p, b, _) {
          var P = Qe(p) ? vy : HE, R = arguments.length < 3;
          return P(p, Le(b, 4), _, R, as);
        }
        function Dae(p, b, _) {
          var P = Qe(p) ? Une : HE, R = arguments.length < 3;
          return P(p, Le(b, 4), _, R, cN);
        }
        function Iae(p, b) {
          var _ = Qe(p) ? ts : dN;
          return _(p, A0(Le(b, 3)));
        }
        function $ae(p) {
          var b = Qe(p) ? aN : Oie;
          return b(p);
        }
        function Lae(p, b, _) {
          (_ ? Sr(p, b, _) : b === n) ? b = 1 : b = rt(b);
          var P = Qe(p) ? oie : kie;
          return P(p, b);
        }
        function Fae(p) {
          var b = Qe(p) ? aie : Tie;
          return b(p);
        }
        function Bae(p) {
          if (p == null)
            return 0;
          if (Fr(p))
            return k0(p) ? Cu(p) : p.length;
          var b = cr(p);
          return b == se || b == An ? p.size : $y(p).length;
        }
        function jae(p, b, _) {
          var P = Qe(p) ? yy : Mie;
          return _ && Sr(p, b, _) && (b = n), P(p, Le(b, 3));
        }
        var Vae = lt(function(p, b) {
          if (p == null)
            return [];
          var _ = b.length;
          return _ > 1 && Sr(p, b[0], b[1]) ? b = [] : _ > 2 && Sr(b[0], b[1], b[2]) && (b = [b[0]]), wN(p, Xn(b, 1), []);
        }), E0 = wre || function() {
          return Zn.Date.now();
        };
        function qae(p, b) {
          if (typeof b != "function")
            throw new xi(a);
          return p = rt(p), function() {
            if (--p < 1)
              return b.apply(this, arguments);
          };
        }
        function mA(p, b, _) {
          return b = _ ? n : b, b = p && b == null ? p.length : b, da(p, O, n, n, n, n, b);
        }
        function gA(p, b) {
          var _;
          if (typeof b != "function")
            throw new xi(a);
          return p = rt(p), function() {
            return --p > 0 && (_ = b.apply(this, arguments)), p <= 1 && (b = n), _;
          };
        }
        var ab = lt(function(p, b, _) {
          var P = y;
          if (_.length) {
            var R = rs(_, Pu(ab));
            P |= E;
          }
          return da(p, P, b, _, R);
        }), vA = lt(function(p, b, _) {
          var P = y | w;
          if (_.length) {
            var R = rs(_, Pu(vA));
            P |= E;
          }
          return da(b, P, p, _, R);
        });
        function yA(p, b, _) {
          b = _ ? n : b;
          var P = da(p, S, n, n, n, n, n, b);
          return P.placeholder = yA.placeholder, P;
        }
        function bA(p, b, _) {
          b = _ ? n : b;
          var P = da(p, N, n, n, n, n, n, b);
          return P.placeholder = bA.placeholder, P;
        }
        function xA(p, b, _) {
          var P, R, $, W, K, J, ue = 0, ce = !1, fe = !1, Se = !0;
          if (typeof p != "function")
            throw new xi(a);
          b = Ei(b) || 0, an(_) && (ce = !!_.leading, fe = "maxWait" in _, $ = fe ? kn(Ei(_.maxWait) || 0, b) : $, Se = "trailing" in _ ? !!_.trailing : Se);
          function Te(mn) {
            var Gi = P, ga = R;
            return P = R = n, ue = mn, W = p.apply(ga, Gi), W;
          }
          function Be(mn) {
            return ue = mn, K = nf(ft, b), ce ? Te(mn) : W;
          }
          function ot(mn) {
            var Gi = mn - J, ga = mn - ue, BA = b - Gi;
            return fe ? ur(BA, $ - ga) : BA;
          }
          function je(mn) {
            var Gi = mn - J, ga = mn - ue;
            return J === n || Gi >= b || Gi < 0 || fe && ga >= $;
          }
          function ft() {
            var mn = E0();
            if (je(mn))
              return gt(mn);
            K = nf(ft, ot(mn));
          }
          function gt(mn) {
            return K = n, Se && P ? Te(mn) : (P = R = n, W);
          }
          function oi() {
            K !== n && PN(K), ue = 0, P = J = R = K = n;
          }
          function _r() {
            return K === n ? W : gt(E0());
          }
          function ai() {
            var mn = E0(), Gi = je(mn);
            if (P = arguments, R = this, J = mn, Gi) {
              if (K === n)
                return Be(J);
              if (fe)
                return PN(K), K = nf(ft, b), Te(J);
            }
            return K === n && (K = nf(ft, b)), W;
          }
          return ai.cancel = oi, ai.flush = _r, ai;
        }
        var zae = lt(function(p, b) {
          return uN(p, 1, b);
        }), Wae = lt(function(p, b, _) {
          return uN(p, Ei(b) || 0, _);
        });
        function Hae(p) {
          return da(p, M);
        }
        function N0(p, b) {
          if (typeof p != "function" || b != null && typeof b != "function")
            throw new xi(a);
          var _ = function() {
            var P = arguments, R = b ? b.apply(this, P) : P[0], $ = _.cache;
            if ($.has(R))
              return $.get(R);
            var W = p.apply(this, P);
            return _.cache = $.set(R, W) || $, W;
          };
          return _.cache = new (N0.Cache || ua)(), _;
        }
        N0.Cache = ua;
        function A0(p) {
          if (typeof p != "function")
            throw new xi(a);
          return function() {
            var b = arguments;
            switch (b.length) {
              case 0:
                return !p.call(this);
              case 1:
                return !p.call(this, b[0]);
              case 2:
                return !p.call(this, b[0], b[1]);
              case 3:
                return !p.call(this, b[0], b[1], b[2]);
            }
            return !p.apply(this, b);
          };
        }
        function Uae(p) {
          return gA(2, p);
        }
        var Gae = Rie(function(p, b) {
          b = b.length == 1 && Qe(b[0]) ? nn(b[0], ni(Le())) : nn(Xn(b, 1), ni(Le()));
          var _ = b.length;
          return lt(function(P) {
            for (var R = -1, $ = ur(P.length, _); ++R < $; )
              P[R] = b[R].call(this, P[R]);
            return ti(p, this, P);
          });
        }), sb = lt(function(p, b) {
          var _ = rs(b, Pu(sb));
          return da(p, E, n, b, _);
        }), wA = lt(function(p, b) {
          var _ = rs(b, Pu(wA));
          return da(p, A, n, b, _);
        }), Kae = fa(function(p, b) {
          return da(p, T, n, n, n, b);
        });
        function Yae(p, b) {
          if (typeof p != "function")
            throw new xi(a);
          return b = b === n ? b : rt(b), lt(p, b);
        }
        function Zae(p, b) {
          if (typeof p != "function")
            throw new xi(a);
          return b = b == null ? 0 : kn(rt(b), 0), lt(function(_) {
            var P = _[b], R = us(_, 0, b);
            return P && ns(R, P), ti(p, this, R);
          });
        }
        function Xae(p, b, _) {
          var P = !0, R = !0;
          if (typeof p != "function")
            throw new xi(a);
          return an(_) && (P = "leading" in _ ? !!_.leading : P, R = "trailing" in _ ? !!_.trailing : R), xA(p, b, {
            leading: P,
            maxWait: b,
            trailing: R
          });
        }
        function Jae(p) {
          return mA(p, 1);
        }
        function Qae(p, b) {
          return sb(Hy(b), p);
        }
        function ese() {
          if (!arguments.length)
            return [];
          var p = arguments[0];
          return Qe(p) ? p : [p];
        }
        function tse(p) {
          return Ci(p, m);
        }
        function nse(p, b) {
          return b = typeof b == "function" ? b : n, Ci(p, m, b);
        }
        function rse(p) {
          return Ci(p, f | m);
        }
        function ise(p, b) {
          return b = typeof b == "function" ? b : n, Ci(p, f | m, b);
        }
        function ose(p, b) {
          return b == null || lN(p, b, Ln(b));
        }
        function Ui(p, b) {
          return p === b || p !== p && b !== b;
        }
        var ase = b0(Ry), sse = b0(function(p, b) {
          return p >= b;
        }), ml = pN(/* @__PURE__ */ function() {
          return arguments;
        }()) ? pN : function(p) {
          return un(p) && kt.call(p, "callee") && !eN.call(p, "callee");
        }, Qe = ee.isArray, lse = IE ? ni(IE) : gie;
        function Fr(p) {
          return p != null && O0(p.length) && !pa(p);
        }
        function pn(p) {
          return un(p) && Fr(p);
        }
        function use(p) {
          return p === !0 || p === !1 || un(p) && Cr(p) == Ce;
        }
        var cs = Sre || yb, cse = $E ? ni($E) : vie;
        function dse(p) {
          return un(p) && p.nodeType === 1 && !rf(p);
        }
        function fse(p) {
          if (p == null)
            return !0;
          if (Fr(p) && (Qe(p) || typeof p == "string" || typeof p.splice == "function" || cs(p) || Tu(p) || ml(p)))
            return !p.length;
          var b = cr(p);
          if (b == se || b == An)
            return !p.size;
          if (tf(p))
            return !$y(p).length;
          for (var _ in p)
            if (kt.call(p, _))
              return !1;
          return !0;
        }
        function hse(p, b) {
          return Jd(p, b);
        }
        function pse(p, b, _) {
          _ = typeof _ == "function" ? _ : n;
          var P = _ ? _(p, b) : n;
          return P === n ? Jd(p, b, n, _) : !!P;
        }
        function lb(p) {
          if (!un(p))
            return !1;
          var b = Cr(p);
          return b == ve || b == ye || typeof p.message == "string" && typeof p.name == "string" && !rf(p);
        }
        function mse(p) {
          return typeof p == "number" && nN(p);
        }
        function pa(p) {
          if (!an(p))
            return !1;
          var b = Cr(p);
          return b == Q || b == Oe || b == ge || b == Dt;
        }
        function CA(p) {
          return typeof p == "number" && p == rt(p);
        }
        function O0(p) {
          return typeof p == "number" && p > -1 && p % 1 == 0 && p <= H;
        }
        function an(p) {
          var b = typeof p;
          return p != null && (b == "object" || b == "function");
        }
        function un(p) {
          return p != null && typeof p == "object";
        }
        var SA = LE ? ni(LE) : bie;
        function gse(p, b) {
          return p === b || Iy(p, b, Jy(b));
        }
        function vse(p, b, _) {
          return _ = typeof _ == "function" ? _ : n, Iy(p, b, Jy(b), _);
        }
        function yse(p) {
          return _A(p) && p != +p;
        }
        function bse(p) {
          if (noe(p))
            throw new Xe(o);
          return mN(p);
        }
        function xse(p) {
          return p === null;
        }
        function wse(p) {
          return p == null;
        }
        function _A(p) {
          return typeof p == "number" || un(p) && Cr(p) == nt;
        }
        function rf(p) {
          if (!un(p) || Cr(p) != st)
            return !1;
          var b = t0(p);
          if (b === null)
            return !0;
          var _ = kt.call(b, "constructor") && b.constructor;
          return typeof _ == "function" && _ instanceof _ && Xp.call(_) == vre;
        }
        var ub = FE ? ni(FE) : xie;
        function Cse(p) {
          return CA(p) && p >= -9007199254740991 && p <= H;
        }
        var EA = BE ? ni(BE) : wie;
        function k0(p) {
          return typeof p == "string" || !Qe(p) && un(p) && Cr(p) == wr;
        }
        function ii(p) {
          return typeof p == "symbol" || un(p) && Cr(p) == Qa;
        }
        var Tu = jE ? ni(jE) : Cie;
        function Sse(p) {
          return p === n;
        }
        function _se(p) {
          return un(p) && cr(p) == sa;
        }
        function Ese(p) {
          return un(p) && Cr(p) == qp;
        }
        var Nse = b0(Ly), Ase = b0(function(p, b) {
          return p <= b;
        });
        function NA(p) {
          if (!p)
            return [];
          if (Fr(p))
            return k0(p) ? Wi(p) : Lr(p);
          if (Wd && p[Wd])
            return ore(p[Wd]());
          var b = cr(p), _ = b == se ? _y : b == An ? Kp : Mu;
          return _(p);
        }
        function ma(p) {
          if (!p)
            return p === 0 ? p : 0;
          if (p = Ei(p), p === V || p === -1 / 0) {
            var b = p < 0 ? -1 : 1;
            return b * Z;
          }
          return p === p ? p : 0;
        }
        function rt(p) {
          var b = ma(p), _ = b % 1;
          return b === b ? _ ? b - _ : b : 0;
        }
        function AA(p) {
          return p ? dl(rt(p), 0, ne) : 0;
        }
        function Ei(p) {
          if (typeof p == "number")
            return p;
          if (ii(p))
            return de;
          if (an(p)) {
            var b = typeof p.valueOf == "function" ? p.valueOf() : p;
            p = an(b) ? b + "" : b;
          }
          if (typeof p != "string")
            return p === 0 ? p : +p;
          p = UE(p);
          var _ = lne.test(p);
          return _ || cne.test(p) ? qne(p.slice(2), _ ? 2 : 8) : sne.test(p) ? de : +p;
        }
        function OA(p) {
          return _o(p, Br(p));
        }
        function Ose(p) {
          return p ? dl(rt(p), -9007199254740991, H) : p === 0 ? p : 0;
        }
        function Ct(p) {
          return p == null ? "" : ri(p);
        }
        var kse = Ou(function(p, b) {
          if (tf(b) || Fr(b)) {
            _o(b, Ln(b), p);
            return;
          }
          for (var _ in b)
            kt.call(b, _) && Yd(p, _, b[_]);
        }), kA = Ou(function(p, b) {
          _o(b, Br(b), p);
        }), P0 = Ou(function(p, b, _, P) {
          _o(b, Br(b), p, P);
        }), Pse = Ou(function(p, b, _, P) {
          _o(b, Ln(b), p, P);
        }), Tse = fa(Py);
        function Mse(p, b) {
          var _ = Au(p);
          return b == null ? _ : sN(_, b);
        }
        var Rse = lt(function(p, b) {
          p = Bt(p);
          var _ = -1, P = b.length, R = P > 2 ? b[2] : n;
          for (R && Sr(b[0], b[1], R) && (P = 1); ++_ < P; )
            for (var $ = b[_], W = Br($), K = -1, J = W.length; ++K < J; ) {
              var ue = W[K], ce = p[ue];
              (ce === n || Ui(ce, _u[ue]) && !kt.call(p, ue)) && (p[ue] = $[ue]);
            }
          return p;
        }), Dse = lt(function(p) {
          return p.push(n, UN), ti(PA, n, p);
        });
        function Ise(p, b) {
          return qE(p, Le(b, 3), So);
        }
        function $se(p, b) {
          return qE(p, Le(b, 3), My);
        }
        function Lse(p, b) {
          return p == null ? p : Ty(p, Le(b, 3), Br);
        }
        function Fse(p, b) {
          return p == null ? p : fN(p, Le(b, 3), Br);
        }
        function Bse(p, b) {
          return p && So(p, Le(b, 3));
        }
        function jse(p, b) {
          return p && My(p, Le(b, 3));
        }
        function Vse(p) {
          return p == null ? [] : d0(p, Ln(p));
        }
        function qse(p) {
          return p == null ? [] : d0(p, Br(p));
        }
        function cb(p, b, _) {
          var P = p == null ? n : fl(p, b);
          return P === n ? _ : P;
        }
        function zse(p, b) {
          return p != null && YN(p, b, fie);
        }
        function db(p, b) {
          return p != null && YN(p, b, hie);
        }
        var Wse = VN(function(p, b, _) {
          b != null && typeof b.toString != "function" && (b = Jp.call(b)), p[b] = _;
        }, hb(jr)), Hse = VN(function(p, b, _) {
          b != null && typeof b.toString != "function" && (b = Jp.call(b)), kt.call(p, b) ? p[b].push(_) : p[b] = [_];
        }, Le), Use = lt(Xd);
        function Ln(p) {
          return Fr(p) ? oN(p) : $y(p);
        }
        function Br(p) {
          return Fr(p) ? oN(p, !0) : Sie(p);
        }
        function Gse(p, b) {
          var _ = {};
          return b = Le(b, 3), So(p, function(P, R, $) {
            ca(_, b(P, R, $), P);
          }), _;
        }
        function Kse(p, b) {
          var _ = {};
          return b = Le(b, 3), So(p, function(P, R, $) {
            ca(_, R, b(P, R, $));
          }), _;
        }
        var Yse = Ou(function(p, b, _) {
          f0(p, b, _);
        }), PA = Ou(function(p, b, _, P) {
          f0(p, b, _, P);
        }), Zse = fa(function(p, b) {
          var _ = {};
          if (p == null)
            return _;
          var P = !1;
          b = nn(b, function($) {
            return $ = ls($, p), P || (P = $.length > 1), $;
          }), _o(p, Zy(p), _), P && (_ = Ci(_, f | h | m, Wie));
          for (var R = b.length; R--; )
            qy(_, b[R]);
          return _;
        });
        function Xse(p, b) {
          return TA(p, A0(Le(b)));
        }
        var Jse = fa(function(p, b) {
          return p == null ? {} : Eie(p, b);
        });
        function TA(p, b) {
          if (p == null)
            return {};
          var _ = nn(Zy(p), function(P) {
            return [P];
          });
          return b = Le(b), CN(p, _, function(P, R) {
            return b(P, R[0]);
          });
        }
        function Qse(p, b, _) {
          b = ls(b, p);
          var P = -1, R = b.length;
          for (R || (R = 1, p = n); ++P < R; ) {
            var $ = p == null ? n : p[Eo(b[P])];
            $ === n && (P = R, $ = _), p = pa($) ? $.call(p) : $;
          }
          return p;
        }
        function ele(p, b, _) {
          return p == null ? p : Qd(p, b, _);
        }
        function tle(p, b, _, P) {
          return P = typeof P == "function" ? P : n, p == null ? p : Qd(p, b, _, P);
        }
        var MA = WN(Ln), RA = WN(Br);
        function nle(p, b, _) {
          var P = Qe(p), R = P || cs(p) || Tu(p);
          if (b = Le(b, 4), _ == null) {
            var $ = p && p.constructor;
            R ? _ = P ? new $() : [] : an(p) ? _ = pa($) ? Au(t0(p)) : {} : _ = {};
          }
          return (R ? bi : So)(p, function(W, K, J) {
            return b(_, W, K, J);
          }), _;
        }
        function rle(p, b) {
          return p == null ? !0 : qy(p, b);
        }
        function ile(p, b, _) {
          return p == null ? p : AN(p, b, Hy(_));
        }
        function ole(p, b, _, P) {
          return P = typeof P == "function" ? P : n, p == null ? p : AN(p, b, Hy(_), P);
        }
        function Mu(p) {
          return p == null ? [] : Sy(p, Ln(p));
        }
        function ale(p) {
          return p == null ? [] : Sy(p, Br(p));
        }
        function sle(p, b, _) {
          return _ === n && (_ = b, b = n), _ !== n && (_ = Ei(_), _ = _ === _ ? _ : 0), b !== n && (b = Ei(b), b = b === b ? b : 0), dl(Ei(p), b, _);
        }
        function lle(p, b, _) {
          return b = ma(b), _ === n ? (_ = b, b = 0) : _ = ma(_), p = Ei(p), pie(p, b, _);
        }
        function ule(p, b, _) {
          if (_ && typeof _ != "boolean" && Sr(p, b, _) && (b = _ = n), _ === n && (typeof b == "boolean" ? (_ = b, b = n) : typeof p == "boolean" && (_ = p, p = n)), p === n && b === n ? (p = 0, b = 1) : (p = ma(p), b === n ? (b = p, p = 0) : b = ma(b)), p > b) {
            var P = p;
            p = b, b = P;
          }
          if (_ || p % 1 || b % 1) {
            var R = rN();
            return ur(p + R * (b - p + Vne("1e-" + ((R + "").length - 1))), b);
          }
          return By(p, b);
        }
        var cle = ku(function(p, b, _) {
          return b = b.toLowerCase(), p + (_ ? DA(b) : b);
        });
        function DA(p) {
          return fb(Ct(p).toLowerCase());
        }
        function IA(p) {
          return p = Ct(p), p && p.replace(fne, ere).replace(Tne, "");
        }
        function dle(p, b, _) {
          p = Ct(p), b = ri(b);
          var P = p.length;
          _ = _ === n ? P : dl(rt(_), 0, P);
          var R = _;
          return _ -= b.length, _ >= 0 && p.slice(_, R) == b;
        }
        function fle(p) {
          return p = Ct(p), p && Ute.test(p) ? p.replace(fE, tre) : p;
        }
        function hle(p) {
          return p = Ct(p), p && Jte.test(p) ? p.replace(sy, "\\$&") : p;
        }
        var ple = ku(function(p, b, _) {
          return p + (_ ? "-" : "") + b.toLowerCase();
        }), mle = ku(function(p, b, _) {
          return p + (_ ? " " : "") + b.toLowerCase();
        }), gle = FN("toLowerCase");
        function vle(p, b, _) {
          p = Ct(p), b = rt(b);
          var P = b ? Cu(p) : 0;
          if (!b || P >= b)
            return p;
          var R = (b - P) / 2;
          return y0(o0(R), _) + p + y0(i0(R), _);
        }
        function yle(p, b, _) {
          p = Ct(p), b = rt(b);
          var P = b ? Cu(p) : 0;
          return b && P < b ? p + y0(b - P, _) : p;
        }
        function ble(p, b, _) {
          p = Ct(p), b = rt(b);
          var P = b ? Cu(p) : 0;
          return b && P < b ? y0(b - P, _) + p : p;
        }
        function xle(p, b, _) {
          return _ || b == null ? b = 0 : b && (b = +b), Are(Ct(p).replace(ly, ""), b || 0);
        }
        function wle(p, b, _) {
          return (_ ? Sr(p, b, _) : b === n) ? b = 1 : b = rt(b), jy(Ct(p), b);
        }
        function Cle() {
          var p = arguments, b = Ct(p[0]);
          return p.length < 3 ? b : b.replace(p[1], p[2]);
        }
        var Sle = ku(function(p, b, _) {
          return p + (_ ? "_" : "") + b.toLowerCase();
        });
        function _le(p, b, _) {
          return _ && typeof _ != "number" && Sr(p, b, _) && (b = _ = n), _ = _ === n ? ne : _ >>> 0, _ ? (p = Ct(p), p && (typeof b == "string" || b != null && !ub(b)) && (b = ri(b), !b && wu(p)) ? us(Wi(p), 0, _) : p.split(b, _)) : [];
        }
        var Ele = ku(function(p, b, _) {
          return p + (_ ? " " : "") + fb(b);
        });
        function Nle(p, b, _) {
          return p = Ct(p), _ = _ == null ? 0 : dl(rt(_), 0, p.length), b = ri(b), p.slice(_, _ + b.length) == b;
        }
        function Ale(p, b, _) {
          var P = D.templateSettings;
          _ && Sr(p, b, _) && (b = n), p = Ct(p), b = P0({}, b, P, HN);
          var R = P0({}, b.imports, P.imports, HN), $ = Ln(R), W = Sy(R, $), K, J, ue = 0, ce = b.interpolate || zp, fe = "__p += '", Se = Ey(
            (b.escape || zp).source + "|" + ce.source + "|" + (ce === hE ? ane : zp).source + "|" + (b.evaluate || zp).source + "|$",
            "g"
          ), Te = "//# sourceURL=" + (kt.call(b, "sourceURL") ? (b.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++$ne + "]") + `
`;
          p.replace(Se, function(je, ft, gt, oi, _r, ai) {
            return gt || (gt = oi), fe += p.slice(ue, ai).replace(hne, nre), ft && (K = !0, fe += `' +
__e(` + ft + `) +
'`), _r && (J = !0, fe += `';
` + _r + `;
__p += '`), gt && (fe += `' +
((__t = (` + gt + `)) == null ? '' : __t) +
'`), ue = ai + je.length, je;
          }), fe += `';
`;
          var Be = kt.call(b, "variable") && b.variable;
          if (!Be)
            fe = `with (obj) {
` + fe + `
}
`;
          else if (ine.test(Be))
            throw new Xe(s);
          fe = (J ? fe.replace(qte, "") : fe).replace(zte, "$1").replace(Wte, "$1;"), fe = "function(" + (Be || "obj") + `) {
` + (Be ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (K ? ", __e = _.escape" : "") + (J ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + fe + `return __p
}`;
          var ot = LA(function() {
            return wt($, Te + "return " + fe).apply(n, W);
          });
          if (ot.source = fe, lb(ot))
            throw ot;
          return ot;
        }
        function Ole(p) {
          return Ct(p).toLowerCase();
        }
        function kle(p) {
          return Ct(p).toUpperCase();
        }
        function Ple(p, b, _) {
          if (p = Ct(p), p && (_ || b === n))
            return UE(p);
          if (!p || !(b = ri(b)))
            return p;
          var P = Wi(p), R = Wi(b), $ = GE(P, R), W = KE(P, R) + 1;
          return us(P, $, W).join("");
        }
        function Tle(p, b, _) {
          if (p = Ct(p), p && (_ || b === n))
            return p.slice(0, ZE(p) + 1);
          if (!p || !(b = ri(b)))
            return p;
          var P = Wi(p), R = KE(P, Wi(b)) + 1;
          return us(P, 0, R).join("");
        }
        function Mle(p, b, _) {
          if (p = Ct(p), p && (_ || b === n))
            return p.replace(ly, "");
          if (!p || !(b = ri(b)))
            return p;
          var P = Wi(p), R = GE(P, Wi(b));
          return us(P, R).join("");
        }
        function Rle(p, b) {
          var _ = L, P = I;
          if (an(b)) {
            var R = "separator" in b ? b.separator : R;
            _ = "length" in b ? rt(b.length) : _, P = "omission" in b ? ri(b.omission) : P;
          }
          p = Ct(p);
          var $ = p.length;
          if (wu(p)) {
            var W = Wi(p);
            $ = W.length;
          }
          if (_ >= $)
            return p;
          var K = _ - Cu(P);
          if (K < 1)
            return P;
          var J = W ? us(W, 0, K).join("") : p.slice(0, K);
          if (R === n)
            return J + P;
          if (W && (K += J.length - K), ub(R)) {
            if (p.slice(K).search(R)) {
              var ue, ce = J;
              for (R.global || (R = Ey(R.source, Ct(pE.exec(R)) + "g")), R.lastIndex = 0; ue = R.exec(ce); )
                var fe = ue.index;
              J = J.slice(0, fe === n ? K : fe);
            }
          } else if (p.indexOf(ri(R), K) != K) {
            var Se = J.lastIndexOf(R);
            Se > -1 && (J = J.slice(0, Se));
          }
          return J + P;
        }
        function Dle(p) {
          return p = Ct(p), p && Hte.test(p) ? p.replace(dE, ure) : p;
        }
        var Ile = ku(function(p, b, _) {
          return p + (_ ? " " : "") + b.toUpperCase();
        }), fb = FN("toUpperCase");
        function $A(p, b, _) {
          return p = Ct(p), b = _ ? n : b, b === n ? ire(p) ? fre(p) : Yne(p) : p.match(b) || [];
        }
        var LA = lt(function(p, b) {
          try {
            return ti(p, n, b);
          } catch (_) {
            return lb(_) ? _ : new Xe(_);
          }
        }), $le = fa(function(p, b) {
          return bi(b, function(_) {
            _ = Eo(_), ca(p, _, ab(p[_], p));
          }), p;
        });
        function Lle(p) {
          var b = p == null ? 0 : p.length, _ = Le();
          return p = b ? nn(p, function(P) {
            if (typeof P[1] != "function")
              throw new xi(a);
            return [_(P[0]), P[1]];
          }) : [], lt(function(P) {
            for (var R = -1; ++R < b; ) {
              var $ = p[R];
              if (ti($[0], this, P))
                return ti($[1], this, P);
            }
          });
        }
        function Fle(p) {
          return uie(Ci(p, f));
        }
        function hb(p) {
          return function() {
            return p;
          };
        }
        function Ble(p, b) {
          return p == null || p !== p ? b : p;
        }
        var jle = jN(), Vle = jN(!0);
        function jr(p) {
          return p;
        }
        function pb(p) {
          return gN(typeof p == "function" ? p : Ci(p, f));
        }
        function qle(p) {
          return yN(Ci(p, f));
        }
        function zle(p, b) {
          return bN(p, Ci(b, f));
        }
        var Wle = lt(function(p, b) {
          return function(_) {
            return Xd(_, p, b);
          };
        }), Hle = lt(function(p, b) {
          return function(_) {
            return Xd(p, _, b);
          };
        });
        function mb(p, b, _) {
          var P = Ln(b), R = d0(b, P);
          _ == null && !(an(b) && (R.length || !P.length)) && (_ = b, b = p, p = this, R = d0(b, Ln(b)));
          var $ = !(an(_) && "chain" in _) || !!_.chain, W = pa(p);
          return bi(R, function(K) {
            var J = b[K];
            p[K] = J, W && (p.prototype[K] = function() {
              var ue = this.__chain__;
              if ($ || ue) {
                var ce = p(this.__wrapped__), fe = ce.__actions__ = Lr(this.__actions__);
                return fe.push({ func: J, args: arguments, thisArg: p }), ce.__chain__ = ue, ce;
              }
              return J.apply(p, ns([this.value()], arguments));
            });
          }), p;
        }
        function Ule() {
          return Zn._ === this && (Zn._ = yre), this;
        }
        function gb() {
        }
        function Gle(p) {
          return p = rt(p), lt(function(b) {
            return xN(b, p);
          });
        }
        var Kle = Gy(nn), Yle = Gy(VE), Zle = Gy(yy);
        function FA(p) {
          return eb(p) ? by(Eo(p)) : Nie(p);
        }
        function Xle(p) {
          return function(b) {
            return p == null ? n : fl(p, b);
          };
        }
        var Jle = qN(), Qle = qN(!0);
        function vb() {
          return [];
        }
        function yb() {
          return !1;
        }
        function eue() {
          return {};
        }
        function tue() {
          return "";
        }
        function nue() {
          return !0;
        }
        function rue(p, b) {
          if (p = rt(p), p < 1 || p > H)
            return [];
          var _ = ne, P = ur(p, ne);
          b = Le(b), p -= ne;
          for (var R = Cy(P, b); ++_ < p; )
            b(_);
          return R;
        }
        function iue(p) {
          return Qe(p) ? nn(p, Eo) : ii(p) ? [p] : Lr(iA(Ct(p)));
        }
        function oue(p) {
          var b = ++gre;
          return Ct(p) + b;
        }
        var aue = v0(function(p, b) {
          return p + b;
        }, 0), sue = Ky("ceil"), lue = v0(function(p, b) {
          return p / b;
        }, 1), uue = Ky("floor");
        function cue(p) {
          return p && p.length ? c0(p, jr, Ry) : n;
        }
        function due(p, b) {
          return p && p.length ? c0(p, Le(b, 2), Ry) : n;
        }
        function fue(p) {
          return WE(p, jr);
        }
        function hue(p, b) {
          return WE(p, Le(b, 2));
        }
        function pue(p) {
          return p && p.length ? c0(p, jr, Ly) : n;
        }
        function mue(p, b) {
          return p && p.length ? c0(p, Le(b, 2), Ly) : n;
        }
        var gue = v0(function(p, b) {
          return p * b;
        }, 1), vue = Ky("round"), yue = v0(function(p, b) {
          return p - b;
        }, 0);
        function bue(p) {
          return p && p.length ? wy(p, jr) : 0;
        }
        function xue(p, b) {
          return p && p.length ? wy(p, Le(b, 2)) : 0;
        }
        return D.after = qae, D.ary = mA, D.assign = kse, D.assignIn = kA, D.assignInWith = P0, D.assignWith = Pse, D.at = Tse, D.before = gA, D.bind = ab, D.bindAll = $le, D.bindKey = vA, D.castArray = ese, D.chain = fA, D.chunk = uoe, D.compact = coe, D.concat = doe, D.cond = Lle, D.conforms = Fle, D.constant = hb, D.countBy = bae, D.create = Mse, D.curry = yA, D.curryRight = bA, D.debounce = xA, D.defaults = Rse, D.defaultsDeep = Dse, D.defer = zae, D.delay = Wae, D.difference = foe, D.differenceBy = hoe, D.differenceWith = poe, D.drop = moe, D.dropRight = goe, D.dropRightWhile = voe, D.dropWhile = yoe, D.fill = boe, D.filter = wae, D.flatMap = _ae, D.flatMapDeep = Eae, D.flatMapDepth = Nae, D.flatten = lA, D.flattenDeep = xoe, D.flattenDepth = woe, D.flip = Hae, D.flow = jle, D.flowRight = Vle, D.fromPairs = Coe, D.functions = Vse, D.functionsIn = qse, D.groupBy = Aae, D.initial = _oe, D.intersection = Eoe, D.intersectionBy = Noe, D.intersectionWith = Aoe, D.invert = Wse, D.invertBy = Hse, D.invokeMap = kae, D.iteratee = pb, D.keyBy = Pae, D.keys = Ln, D.keysIn = Br, D.map = _0, D.mapKeys = Gse, D.mapValues = Kse, D.matches = qle, D.matchesProperty = zle, D.memoize = N0, D.merge = Yse, D.mergeWith = PA, D.method = Wle, D.methodOf = Hle, D.mixin = mb, D.negate = A0, D.nthArg = Gle, D.omit = Zse, D.omitBy = Xse, D.once = Uae, D.orderBy = Tae, D.over = Kle, D.overArgs = Gae, D.overEvery = Yle, D.overSome = Zle, D.partial = sb, D.partialRight = wA, D.partition = Mae, D.pick = Jse, D.pickBy = TA, D.property = FA, D.propertyOf = Xle, D.pull = Toe, D.pullAll = cA, D.pullAllBy = Moe, D.pullAllWith = Roe, D.pullAt = Doe, D.range = Jle, D.rangeRight = Qle, D.rearg = Kae, D.reject = Iae, D.remove = Ioe, D.rest = Yae, D.reverse = ib, D.sampleSize = Lae, D.set = ele, D.setWith = tle, D.shuffle = Fae, D.slice = $oe, D.sortBy = Vae, D.sortedUniq = zoe, D.sortedUniqBy = Woe, D.split = _le, D.spread = Zae, D.tail = Hoe, D.take = Uoe, D.takeRight = Goe, D.takeRightWhile = Koe, D.takeWhile = Yoe, D.tap = cae, D.throttle = Xae, D.thru = S0, D.toArray = NA, D.toPairs = MA, D.toPairsIn = RA, D.toPath = iue, D.toPlainObject = OA, D.transform = nle, D.unary = Jae, D.union = Zoe, D.unionBy = Xoe, D.unionWith = Joe, D.uniq = Qoe, D.uniqBy = eae, D.uniqWith = tae, D.unset = rle, D.unzip = ob, D.unzipWith = dA, D.update = ile, D.updateWith = ole, D.values = Mu, D.valuesIn = ale, D.without = nae, D.words = $A, D.wrap = Qae, D.xor = rae, D.xorBy = iae, D.xorWith = oae, D.zip = aae, D.zipObject = sae, D.zipObjectDeep = lae, D.zipWith = uae, D.entries = MA, D.entriesIn = RA, D.extend = kA, D.extendWith = P0, mb(D, D), D.add = aue, D.attempt = LA, D.camelCase = cle, D.capitalize = DA, D.ceil = sue, D.clamp = sle, D.clone = tse, D.cloneDeep = rse, D.cloneDeepWith = ise, D.cloneWith = nse, D.conformsTo = ose, D.deburr = IA, D.defaultTo = Ble, D.divide = lue, D.endsWith = dle, D.eq = Ui, D.escape = fle, D.escapeRegExp = hle, D.every = xae, D.find = Cae, D.findIndex = aA, D.findKey = Ise, D.findLast = Sae, D.findLastIndex = sA, D.findLastKey = $se, D.floor = uue, D.forEach = hA, D.forEachRight = pA, D.forIn = Lse, D.forInRight = Fse, D.forOwn = Bse, D.forOwnRight = jse, D.get = cb, D.gt = ase, D.gte = sse, D.has = zse, D.hasIn = db, D.head = uA, D.identity = jr, D.includes = Oae, D.indexOf = Soe, D.inRange = lle, D.invoke = Use, D.isArguments = ml, D.isArray = Qe, D.isArrayBuffer = lse, D.isArrayLike = Fr, D.isArrayLikeObject = pn, D.isBoolean = use, D.isBuffer = cs, D.isDate = cse, D.isElement = dse, D.isEmpty = fse, D.isEqual = hse, D.isEqualWith = pse, D.isError = lb, D.isFinite = mse, D.isFunction = pa, D.isInteger = CA, D.isLength = O0, D.isMap = SA, D.isMatch = gse, D.isMatchWith = vse, D.isNaN = yse, D.isNative = bse, D.isNil = wse, D.isNull = xse, D.isNumber = _A, D.isObject = an, D.isObjectLike = un, D.isPlainObject = rf, D.isRegExp = ub, D.isSafeInteger = Cse, D.isSet = EA, D.isString = k0, D.isSymbol = ii, D.isTypedArray = Tu, D.isUndefined = Sse, D.isWeakMap = _se, D.isWeakSet = Ese, D.join = Ooe, D.kebabCase = ple, D.last = _i, D.lastIndexOf = koe, D.lowerCase = mle, D.lowerFirst = gle, D.lt = Nse, D.lte = Ase, D.max = cue, D.maxBy = due, D.mean = fue, D.meanBy = hue, D.min = pue, D.minBy = mue, D.stubArray = vb, D.stubFalse = yb, D.stubObject = eue, D.stubString = tue, D.stubTrue = nue, D.multiply = gue, D.nth = Poe, D.noConflict = Ule, D.noop = gb, D.now = E0, D.pad = vle, D.padEnd = yle, D.padStart = ble, D.parseInt = xle, D.random = ule, D.reduce = Rae, D.reduceRight = Dae, D.repeat = wle, D.replace = Cle, D.result = Qse, D.round = vue, D.runInContext = X, D.sample = $ae, D.size = Bae, D.snakeCase = Sle, D.some = jae, D.sortedIndex = Loe, D.sortedIndexBy = Foe, D.sortedIndexOf = Boe, D.sortedLastIndex = joe, D.sortedLastIndexBy = Voe, D.sortedLastIndexOf = qoe, D.startCase = Ele, D.startsWith = Nle, D.subtract = yue, D.sum = bue, D.sumBy = xue, D.template = Ale, D.times = rue, D.toFinite = ma, D.toInteger = rt, D.toLength = AA, D.toLower = Ole, D.toNumber = Ei, D.toSafeInteger = Ose, D.toString = Ct, D.toUpper = kle, D.trim = Ple, D.trimEnd = Tle, D.trimStart = Mle, D.truncate = Rle, D.unescape = Dle, D.uniqueId = oue, D.upperCase = Ile, D.upperFirst = fb, D.each = hA, D.eachRight = pA, D.first = uA, mb(D, function() {
          var p = {};
          return So(D, function(b, _) {
            kt.call(D.prototype, _) || (p[_] = b);
          }), p;
        }(), { chain: !1 }), D.VERSION = r, bi(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(p) {
          D[p].placeholder = D;
        }), bi(["drop", "take"], function(p, b) {
          pt.prototype[p] = function(_) {
            _ = _ === n ? 1 : kn(rt(_), 0);
            var P = this.__filtered__ && !b ? new pt(this) : this.clone();
            return P.__filtered__ ? P.__takeCount__ = ur(_, P.__takeCount__) : P.__views__.push({
              size: ur(_, ne),
              type: p + (P.__dir__ < 0 ? "Right" : "")
            }), P;
          }, pt.prototype[p + "Right"] = function(_) {
            return this.reverse()[p](_).reverse();
          };
        }), bi(["filter", "map", "takeWhile"], function(p, b) {
          var _ = b + 1, P = _ == q || _ == U;
          pt.prototype[p] = function(R) {
            var $ = this.clone();
            return $.__iteratees__.push({
              iteratee: Le(R, 3),
              type: _
            }), $.__filtered__ = $.__filtered__ || P, $;
          };
        }), bi(["head", "last"], function(p, b) {
          var _ = "take" + (b ? "Right" : "");
          pt.prototype[p] = function() {
            return this[_](1).value()[0];
          };
        }), bi(["initial", "tail"], function(p, b) {
          var _ = "drop" + (b ? "" : "Right");
          pt.prototype[p] = function() {
            return this.__filtered__ ? new pt(this) : this[_](1);
          };
        }), pt.prototype.compact = function() {
          return this.filter(jr);
        }, pt.prototype.find = function(p) {
          return this.filter(p).head();
        }, pt.prototype.findLast = function(p) {
          return this.reverse().find(p);
        }, pt.prototype.invokeMap = lt(function(p, b) {
          return typeof p == "function" ? new pt(this) : this.map(function(_) {
            return Xd(_, p, b);
          });
        }), pt.prototype.reject = function(p) {
          return this.filter(A0(Le(p)));
        }, pt.prototype.slice = function(p, b) {
          p = rt(p);
          var _ = this;
          return _.__filtered__ && (p > 0 || b < 0) ? new pt(_) : (p < 0 ? _ = _.takeRight(-p) : p && (_ = _.drop(p)), b !== n && (b = rt(b), _ = b < 0 ? _.dropRight(-b) : _.take(b - p)), _);
        }, pt.prototype.takeRightWhile = function(p) {
          return this.reverse().takeWhile(p).reverse();
        }, pt.prototype.toArray = function() {
          return this.take(ne);
        }, So(pt.prototype, function(p, b) {
          var _ = /^(?:filter|find|map|reject)|While$/.test(b), P = /^(?:head|last)$/.test(b), R = D[P ? "take" + (b == "last" ? "Right" : "") : b], $ = P || /^find/.test(b);
          R && (D.prototype[b] = function() {
            var W = this.__wrapped__, K = P ? [1] : arguments, J = W instanceof pt, ue = K[0], ce = J || Qe(W), fe = function(ft) {
              var gt = R.apply(D, ns([ft], K));
              return P && Se ? gt[0] : gt;
            };
            ce && _ && typeof ue == "function" && ue.length != 1 && (J = ce = !1);
            var Se = this.__chain__, Te = !!this.__actions__.length, Be = $ && !Se, ot = J && !Te;
            if (!$ && ce) {
              W = ot ? W : new pt(this);
              var je = p.apply(W, K);
              return je.__actions__.push({ func: S0, args: [fe], thisArg: n }), new wi(je, Se);
            }
            return Be && ot ? p.apply(this, K) : (je = this.thru(fe), Be ? P ? je.value()[0] : je.value() : je);
          });
        }), bi(["pop", "push", "shift", "sort", "splice", "unshift"], function(p) {
          var b = Yp[p], _ = /^(?:push|sort|unshift)$/.test(p) ? "tap" : "thru", P = /^(?:pop|shift)$/.test(p);
          D.prototype[p] = function() {
            var R = arguments;
            if (P && !this.__chain__) {
              var $ = this.value();
              return b.apply(Qe($) ? $ : [], R);
            }
            return this[_](function(W) {
              return b.apply(Qe(W) ? W : [], R);
            });
          };
        }), So(pt.prototype, function(p, b) {
          var _ = D[b];
          if (_) {
            var P = _.name + "";
            kt.call(Nu, P) || (Nu[P] = []), Nu[P].push({ name: b, func: _ });
          }
        }), Nu[g0(n, w).name] = [{
          name: "wrapper",
          func: n
        }], pt.prototype.clone = Dre, pt.prototype.reverse = Ire, pt.prototype.value = $re, D.prototype.at = dae, D.prototype.chain = fae, D.prototype.commit = hae, D.prototype.next = pae, D.prototype.plant = gae, D.prototype.reverse = vae, D.prototype.toJSON = D.prototype.valueOf = D.prototype.value = yae, D.prototype.first = D.prototype.head, Wd && (D.prototype[Wd] = mae), D;
      }, Su = hre();
      sl ? ((sl.exports = Su)._ = Su, py._ = Su) : Zn._ = Su;
    }).call(S9e);
  }(Of, Of.exports)), Of.exports;
}
var XG = _9e();
const JG = Qt([
  !1,
  () => {
  }
]), QG = Qt([
  0,
  () => {
  }
]);
function E9e({
  onBeforeExpand: e,
  translate: t = vi
}) {
  const [n, r] = en(JG), [i, o] = en(QG);
  return /* @__PURE__ */ d(xe, { children: i > 100 && /* @__PURE__ */ k(
    et,
    {
      className: "text-textLink items-center !justify-start pr-0 pl-0 underline",
      onClick: () => {
        e == null || e(!n), r(!n);
      },
      variant: "link",
      children: [
        n ? t.getText("Show less") : t.getText("Show more"),
        n ? /* @__PURE__ */ d(rce, { className: "h-4 w-4" }) : /* @__PURE__ */ d(tp, { className: "h-4 w-4" })
      ]
    }
  ) });
}
function Nt({
  children: e,
  className: t,
  maxHeight: n = 150,
  translate: r = vi
}) {
  const [i, o] = re(!1), [a, s] = re(0), l = vt(null);
  Pe(() => {
    l.current && s(l.current.scrollHeight);
  }, []);
  let u = XG.debounce(() => {
    l.current && s(l.current.scrollHeight);
  });
  return Pe(() => (window.addEventListener("resize", u), () => {
    window.removeEventListener("resize", u);
  })), /* @__PURE__ */ d(JG.Provider, { value: [i, o], children: /* @__PURE__ */ k(QG.Provider, { value: [a, s], children: [
    /* @__PURE__ */ d(
      "div",
      {
        className: z("overflow-hidden", t),
        ref: l,
        style: {
          maxHeight: i ? a : n,
          transition: "all .5s ease",
          ...!i && a >= n ? {
            maskImage: "linear-gradient(to bottom, black 50%, transparent 100%)"
          } : {}
        },
        children: e
      }
    ),
    a >= n ? /* @__PURE__ */ d(
      E9e,
      {
        onBeforeExpand: () => {
          u();
        },
        translate: r
      }
    ) : null
  ] }) });
}
const N9e = "sidebar_state", A9e = 60 * 60 * 24 * 7, O9e = "16rem", k9e = "18rem", P9e = "3rem", T9e = "b", eK = Qt(null);
function V2() {
  const e = en(eK);
  if (!e)
    throw new Error("useSidebar must be used within a SidebarProvider.");
  return e;
}
const M9e = te(
  ({
    defaultOpen: e = !0,
    open: t,
    onOpenChange: n,
    className: r,
    style: i,
    children: o,
    ...a
  }, s) => {
    const l = Tue(), [u, c] = re(!1), [f, h] = re(e), m = t ?? f, v = yr(
      (C) => {
        const S = typeof C == "function" ? C(m) : C;
        n ? n(S) : h(S), document.cookie = `${N9e}=${S}; path=/; max-age=${A9e}`;
      },
      [n, m]
    ), g = yr(() => l ? c((C) => !C) : v((C) => !C), [l, v, c]);
    Pe(() => {
      const C = (S) => {
        S.key === T9e && (S.metaKey || S.ctrlKey) && (S.preventDefault(), g());
      };
      return window.addEventListener("keydown", C), () => window.removeEventListener("keydown", C);
    }, [g]);
    const y = m ? "expanded" : "collapsed", w = Je(
      () => ({
        state: y,
        open: m,
        setOpen: v,
        isMobile: l,
        openMobile: u,
        setOpenMobile: c,
        toggleSidebar: g
      }),
      [
        y,
        m,
        v,
        l,
        u,
        c,
        g
      ]
    );
    return /* @__PURE__ */ d(eK.Provider, { value: w, children: /* @__PURE__ */ d(NS, { delayDuration: 0, children: /* @__PURE__ */ d(
      "div",
      {
        style: {
          "--sidebar-width": O9e,
          "--sidebar-width-icon": P9e,
          ...i
        },
        className: z(
          "group/sidebar-wrapper has-[[data-variant=inset]]:bg-sidebar flex min-h-svh w-full",
          r
        ),
        ref: s,
        ...a,
        children: o
      }
    ) }) });
  }
);
M9e.displayName = "SidebarProvider";
const R9e = te(
  ({
    side: e = "left",
    variant: t = "sidebar",
    collapsible: n = "offcanvas",
    className: r,
    children: i,
    ...o
  }, a) => {
    const { isMobile: s, state: l, openMobile: u, setOpenMobile: c } = V2();
    return n === "none" ? /* @__PURE__ */ d(
      "div",
      {
        className: z(
          "bg-sidebar text-sidebar-foreground flex h-full w-(--sidebar-width) flex-col",
          r
        ),
        ref: a,
        ...o,
        children: i
      }
    ) : s ? /* @__PURE__ */ d(GG, { open: u, onOpenChange: c, ...o, children: /* @__PURE__ */ d(
      fS,
      {
        "data-sidebar": "sidebar",
        "data-mobile": "true",
        className: "bg-sidebar text-sidebar-foreground w-(--sidebar-width) p-0 [&>button]:hidden",
        style: {
          "--sidebar-width": k9e
        },
        side: e,
        children: /* @__PURE__ */ d("div", { className: "flex h-full w-full flex-col", children: i })
      }
    ) }) : /* @__PURE__ */ k(
      "div",
      {
        ref: a,
        className: "text-sidebar-foreground group peer hidden md:block",
        "data-state": l,
        "data-collapsible": l === "collapsed" ? n : "",
        "data-variant": t,
        "data-side": e,
        children: [
          /* @__PURE__ */ d(
            "div",
            {
              className: z(
                "relative h-svh w-(--sidebar-width) bg-transparent transition-[width] duration-200 ease-linear",
                "group-data-[collapsible=offcanvas]:w-0",
                "group-data-[side=right]:rotate-180",
                t === "floating" || t === "inset" ? "group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)_+_theme(spacing.4))]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon)"
              )
            }
          ),
          /* @__PURE__ */ d(
            "div",
            {
              className: z(
                "fixed inset-y-0 z-10 hidden h-svh w-(--sidebar-width) transition-[left,right,width] duration-200 ease-linear md:flex",
                e === "left" ? "left-0 group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]" : "right-0 group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]",
                // Adjust the padding for floating and inset variants.
                t === "floating" || t === "inset" ? "p-2 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)_+_theme(spacing.4)_+2px)]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon) group-data-[side=left]:border-r group-data-[side=right]:border-l",
                r
              ),
              ...o,
              children: /* @__PURE__ */ d(
                "div",
                {
                  "data-sidebar": "sidebar",
                  className: "bg-sidebar group-data-[variant=floating]:border-sidebar-border flex h-full w-full flex-col group-data-[variant=floating]:rounded-lg group-data-[variant=floating]:border group-data-[variant=floating]:shadow",
                  children: i
                }
              )
            }
          )
        ]
      }
    );
  }
);
R9e.displayName = "Sidebar";
const D9e = te(({ className: e, onClick: t, ...n }, r) => {
  const { toggleSidebar: i } = V2();
  return /* @__PURE__ */ k(
    et,
    {
      ref: r,
      "data-sidebar": "trigger",
      variant: "ghost",
      size: "icon",
      className: z("h-7 w-7", e),
      onClick: (o) => {
        t == null || t(o), i();
      },
      ...n,
      children: [
        /* @__PURE__ */ d(_ce, {}),
        /* @__PURE__ */ d("span", { className: "sr-only", children: "Toggle Sidebar" })
      ]
    }
  );
});
D9e.displayName = "SidebarTrigger";
const I9e = te(({ className: e, ...t }, n) => {
  const { toggleSidebar: r } = V2();
  return /* @__PURE__ */ d(
    "button",
    {
      ref: n,
      "data-sidebar": "rail",
      "aria-label": "Toggle Sidebar",
      tabIndex: -1,
      onClick: r,
      title: "Toggle Sidebar",
      className: z(
        "hover:after:bg-sidebar-border absolute inset-y-0 z-20 hidden w-4 -translate-x-1/2 transition-all ease-linear after:absolute after:inset-y-0 after:left-1/2 after:w-[2px] group-data-[side=left]:-right-4 group-data-[side=right]:left-0 sm:flex",
        "[[data-side=left]_&]:cursor-w-resize [[data-side=right]_&]:cursor-e-resize",
        "[[data-side=left][data-state=collapsed]_&]:cursor-e-resize [[data-side=right][data-state=collapsed]_&]:cursor-w-resize",
        "group-data-[collapsible=offcanvas]:hover:bg-sidebar group-data-[collapsible=offcanvas]:translate-x-0 group-data-[collapsible=offcanvas]:after:left-full",
        "[[data-side=left][data-collapsible=offcanvas]_&]:-right-2",
        "[[data-side=right][data-collapsible=offcanvas]_&]:-left-2",
        e
      ),
      ...t
    }
  );
});
I9e.displayName = "SidebarRail";
const $9e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "main",
  {
    ref: n,
    className: z(
      "bg-background relative flex min-h-svh flex-1 flex-col",
      "peer-data-[variant=inset]:min-h-[calc(100svh-theme(spacing.4))] md:peer-data-[variant=inset]:m-2 md:peer-data-[state=collapsed]:peer-data-[variant=inset]:ml-2 md:peer-data-[variant=inset]:ml-0 md:peer-data-[variant=inset]:rounded-xl md:peer-data-[variant=inset]:shadow",
      e
    ),
    ...t
  }
));
$9e.displayName = "SidebarInset";
const L9e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  YC,
  {
    ref: n,
    "data-sidebar": "input",
    className: z(
      "bg-background focus-visible:ring-sidebar-ring h-8 w-full shadow-none focus-visible:ring-2",
      e
    ),
    ...t
  }
));
L9e.displayName = "SidebarInput";
const F9e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "div",
  {
    ref: n,
    "data-sidebar": "header",
    className: z("flex flex-col gap-2 p-2", e),
    ...t
  }
));
F9e.displayName = "SidebarHeader";
const B9e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "div",
  {
    ref: n,
    "data-sidebar": "footer",
    className: z("flex flex-col gap-2 p-2", e),
    ...t
  }
));
B9e.displayName = "SidebarFooter";
const j9e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  eu,
  {
    ref: n,
    "data-sidebar": "separator",
    className: z("bg-sidebar-border mx-2 w-auto", e),
    ...t
  }
));
j9e.displayName = "SidebarSeparator";
const V9e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "div",
  {
    ref: n,
    "data-sidebar": "content",
    className: z(
      "flex min-h-0 flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden",
      e
    ),
    ...t
  }
));
V9e.displayName = "SidebarContent";
const q9e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "div",
  {
    ref: n,
    "data-sidebar": "group",
    className: z("relative flex w-full min-w-0 flex-col p-2", e),
    ...t
  }
));
q9e.displayName = "SidebarGroup";
const z9e = te(({ className: e, asChild: t = !1, ...n }, r) => /* @__PURE__ */ d(
  t ? pi : "div",
  {
    ref: r,
    "data-sidebar": "group-label",
    className: z(
      "text-sidebar-foreground/70 ring-sidebar-ring flex h-8 shrink-0 items-center rounded-md px-2 text-bodysm font-medium outline-none transition-[margin,opa] duration-200 ease-linear focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
      "group-data-[collapsible=icon]:-mt-8 group-data-[collapsible=icon]:opacity-0",
      e
    ),
    ...n
  }
));
z9e.displayName = "SidebarGroupLabel";
const W9e = te(({ className: e, asChild: t = !1, ...n }, r) => /* @__PURE__ */ d(
  t ? pi : "button",
  {
    ref: r,
    "data-sidebar": "group-action",
    className: z(
      "text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground absolute right-3 top-3.5 flex aspect-square w-5 items-center justify-center rounded-md p-0 outline-none transition-transform focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
      // Increases the hit area of the button on mobile.
      "after:absolute after:-inset-2 after:md:hidden",
      "group-data-[collapsible=icon]:hidden",
      e
    ),
    ...n
  }
));
W9e.displayName = "SidebarGroupAction";
const H9e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "div",
  {
    ref: n,
    "data-sidebar": "group-content",
    className: z("w-full text-bodysm", e),
    ...t
  }
));
H9e.displayName = "SidebarGroupContent";
const U9e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "ul",
  {
    ref: n,
    "data-sidebar": "menu",
    className: z("flex w-full min-w-0 flex-col gap-1", e),
    ...t
  }
));
U9e.displayName = "SidebarMenu";
const G9e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "li",
  {
    ref: n,
    "data-sidebar": "menu-item",
    className: z("group/menu-item relative", e),
    ...t
  }
));
G9e.displayName = "SidebarMenuItem";
const K9e = Jo(
  "peer/menu-button flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-bodysm outline-none ring-sidebar-ring transition-[width,height,padding] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 group-has-[[data-sidebar=menu-action]]/menu-item:pr-8 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[active=true]:bg-sidebar-accent data-[active=true]:font-medium data-[active=true]:text-sidebar-accent-foreground data-[state=open]:hover:bg-sidebar-accent data-[state=open]:hover:text-sidebar-accent-foreground group-data-[collapsible=icon]:!size-8 group-data-[collapsible=icon]:!p-2 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "hover:bg-sidebar-accent hover:text-sidebar-accent-foreground",
        outline: "bg-background shadow-[0_0_0_1px_hsl(var(--sidebar-border))] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground hover:shadow-[0_0_0_1px_hsl(var(--sidebar-accent))]"
      },
      size: {
        default: "h-8 text-bodysm",
        sm: "h-7 text-bodysm",
        lg: "h-12 text-bodysm group-data-[collapsible=icon]:!p-0"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Y9e = te(
  ({
    asChild: e = !1,
    isActive: t = !1,
    variant: n = "default",
    size: r = "default",
    tooltip: i,
    className: o,
    ...a
  }, s) => {
    const l = e ? pi : "button", { isMobile: u, state: c } = V2(), f = /* @__PURE__ */ d(
      l,
      {
        ref: s,
        "data-sidebar": "menu-button",
        "data-size": r,
        "data-active": t,
        className: z(K9e({ variant: n, size: r }), o),
        ...a
      }
    );
    return i ? (typeof i == "string" && (i = {
      children: i
    }), /* @__PURE__ */ k(BY, { children: [
      /* @__PURE__ */ d(jY, { asChild: !0, children: f }),
      /* @__PURE__ */ d(
        VY,
        {
          side: "right",
          align: "center",
          hidden: c !== "collapsed" || u,
          ...i
        }
      )
    ] })) : f;
  }
);
Y9e.displayName = "SidebarMenuButton";
const Z9e = te(({ className: e, asChild: t = !1, showOnHover: n = !1, ...r }, i) => /* @__PURE__ */ d(
  t ? pi : "button",
  {
    ref: i,
    "data-sidebar": "menu-action",
    className: z(
      "text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground peer-hover/menu-button:text-sidebar-accent-foreground absolute right-1 top-1.5 flex aspect-square w-5 items-center justify-center rounded-md p-0 outline-none transition-transform focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
      // Increases the hit area of the button on mobile.
      "after:absolute after:-inset-2 after:md:hidden",
      "peer-data-[size=sm]/menu-button:top-1",
      "peer-data-[size=default]/menu-button:top-1.5",
      "peer-data-[size=lg]/menu-button:top-2.5",
      "group-data-[collapsible=icon]:hidden",
      n && "peer-data-[active=true]/menu-button:text-sidebar-accent-foreground group-focus-within/menu-item:opacity-100 group-hover/menu-item:opacity-100 data-[state=open]:opacity-100 md:opacity-0",
      e
    ),
    ...r
  }
));
Z9e.displayName = "SidebarMenuAction";
const X9e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "div",
  {
    ref: n,
    "data-sidebar": "menu-badge",
    className: z(
      "text-sidebar-foreground pointer-events-none absolute right-1 flex h-5 min-w-5 select-none items-center justify-center rounded-md px-1 text-bodysm font-medium tabular-nums",
      "peer-hover/menu-button:text-sidebar-accent-foreground peer-data-[active=true]/menu-button:text-sidebar-accent-foreground",
      "peer-data-[size=sm]/menu-button:top-1",
      "peer-data-[size=default]/menu-button:top-1.5",
      "peer-data-[size=lg]/menu-button:top-2.5",
      "group-data-[collapsible=icon]:hidden",
      e
    ),
    ...t
  }
));
X9e.displayName = "SidebarMenuBadge";
const J9e = te(({ className: e, showIcon: t = !1, ...n }, r) => {
  const i = Je(() => `${Math.floor(Math.random() * 40) + 50}%`, []);
  return /* @__PURE__ */ k(
    "div",
    {
      ref: r,
      "data-sidebar": "menu-skeleton",
      className: z("flex h-8 items-center gap-2 rounded-md px-2", e),
      ...n,
      children: [
        t && /* @__PURE__ */ d(
          me,
          {
            className: "size-4 rounded-md",
            "data-sidebar": "menu-skeleton-icon"
          }
        ),
        /* @__PURE__ */ d(
          me,
          {
            className: "h-4 max-w-(--skeleton-width) flex-1",
            "data-sidebar": "menu-skeleton-text",
            style: {
              "--skeleton-width": i
            }
          }
        )
      ]
    }
  );
});
J9e.displayName = "SidebarMenuSkeleton";
const Q9e = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "ul",
  {
    ref: n,
    "data-sidebar": "menu-sub",
    className: z(
      "border-sidebar-border mx-3.5 flex min-w-0 translate-x-px flex-col gap-1 border-l px-2.5 py-0.5",
      "group-data-[collapsible=icon]:hidden",
      e
    ),
    ...t
  }
));
Q9e.displayName = "SidebarMenuSub";
const ewe = te(({ ...e }, t) => /* @__PURE__ */ d("li", { ref: t, ...e }));
ewe.displayName = "SidebarMenuSubItem";
const twe = te(({ asChild: e = !1, size: t = "md", isActive: n, className: r, ...i }, o) => /* @__PURE__ */ d(
  e ? pi : "a",
  {
    ref: o,
    "data-sidebar": "menu-sub-button",
    "data-size": t,
    "data-active": n,
    className: z(
      "text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground active:bg-sidebar-accent active:text-sidebar-accent-foreground [&>svg]:text-sidebar-accent-foreground flex h-7 min-w-0 -translate-x-px items-center gap-2 overflow-hidden rounded-md px-2 outline-none focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0",
      "data-[active=true]:bg-sidebar-accent data-[active=true]:text-sidebar-accent-foreground",
      t === "sm" && "text-bodyxs",
      t === "md" && "text-bodysm",
      "group-data-[collapsible=icon]:hidden",
      r
    ),
    ...i
  }
));
twe.displayName = "SidebarMenuSubButton";
function me({ className: e, ...t }) {
  return /* @__PURE__ */ d(
    "div",
    {
      className: z("bg-muted animate-pulse rounded-md", e),
      ...t
    }
  );
}
function nwe(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = x.createContext(a), l = n.length;
    n = [...n, a];
    const u = (f) => {
      var w;
      const { scope: h, children: m, ...v } = f, g = ((w = h == null ? void 0 : h[e]) == null ? void 0 : w[l]) || s, y = x.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ d(g.Provider, { value: y, children: m });
    };
    u.displayName = o + "Provider";
    function c(f, h) {
      var g;
      const m = ((g = h == null ? void 0 : h[e]) == null ? void 0 : g[l]) || s, v = x.useContext(m);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, c];
  }
  const i = () => {
    const o = n.map((a) => x.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return x.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, rwe(i, ...t)];
}
function rwe(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return x.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var tK = ["PageUp", "PageDown"], nK = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], rK = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, kd = "Slider", [d7, iwe, owe] = Vg(kd), [iK, fet] = nwe(kd, [
  owe
]), [awe, q2] = iK(kd), oK = x.forwardRef(
  (e, t) => {
    const {
      name: n,
      min: r = 0,
      max: i = 100,
      step: o = 1,
      orientation: a = "horizontal",
      disabled: s = !1,
      minStepsBetweenThumbs: l = 0,
      defaultValue: u = [r],
      value: c,
      onValueChange: f = () => {
      },
      onValueCommit: h = () => {
      },
      inverted: m = !1,
      form: v,
      ...g
    } = e, y = x.useRef(/* @__PURE__ */ new Set()), w = x.useRef(0), S = a === "horizontal" ? swe : lwe, [N = [], E] = Kt({
      prop: c,
      defaultProp: u,
      onChange: (I) => {
        var B;
        (B = [...y.current][w.current]) == null || B.focus(), f(I);
      }
    }), A = x.useRef(N);
    function O(I) {
      const j = hwe(N, I);
      L(I, j);
    }
    function T(I) {
      L(I, w.current);
    }
    function M() {
      const I = A.current[w.current];
      N[w.current] !== I && h(N);
    }
    function L(I, j, { commit: B } = { commit: !1 }) {
      const q = vwe(o), G = ywe(Math.round((I - r) / o) * o + r, q), U = rh(G, [r, i]);
      E((V = []) => {
        const H = dwe(V, U, j);
        if (gwe(H, l * o)) {
          w.current = H.indexOf(U);
          const Z = String(H) !== String(V);
          return Z && B && h(H), Z ? H : V;
        } else
          return V;
      });
    }
    return /* @__PURE__ */ d(
      awe,
      {
        scope: e.__scopeSlider,
        name: n,
        disabled: s,
        min: r,
        max: i,
        valueIndexToChangeRef: w,
        thumbs: y.current,
        values: N,
        orientation: a,
        form: v,
        children: /* @__PURE__ */ d(d7.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ d(d7.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ d(
          S,
          {
            "aria-disabled": s,
            "data-disabled": s ? "" : void 0,
            ...g,
            ref: t,
            onPointerDown: Me(g.onPointerDown, () => {
              s || (A.current = N);
            }),
            min: r,
            max: i,
            inverted: m,
            onSlideStart: s ? void 0 : O,
            onSlideMove: s ? void 0 : T,
            onSlideEnd: s ? void 0 : M,
            onHomeKeyDown: () => !s && L(r, 0, { commit: !0 }),
            onEndKeyDown: () => !s && L(i, N.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: I, direction: j }) => {
              if (!s) {
                const G = tK.includes(I.key) || I.shiftKey && nK.includes(I.key) ? 10 : 1, U = w.current, V = N[U], H = o * G * j;
                L(V + H, U, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
oK.displayName = kd;
var [aK, sK] = iK(kd, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), swe = x.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: r,
      dir: i,
      inverted: o,
      onSlideStart: a,
      onSlideMove: s,
      onSlideEnd: l,
      onStepKeyDown: u,
      ...c
    } = e, [f, h] = x.useState(null), m = tt(t, (S) => h(S)), v = x.useRef(), g = Bi(i), y = g === "ltr", w = y && !o || !y && o;
    function C(S) {
      const N = v.current || f.getBoundingClientRect(), E = [0, N.width], O = hS(E, w ? [n, r] : [r, n]);
      return v.current = N, O(S - N.left);
    }
    return /* @__PURE__ */ d(
      aK,
      {
        scope: e.__scopeSlider,
        startEdge: w ? "left" : "right",
        endEdge: w ? "right" : "left",
        direction: w ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ d(
          lK,
          {
            dir: g,
            "data-orientation": "horizontal",
            ...c,
            ref: m,
            style: {
              ...c.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (S) => {
              const N = C(S.clientX);
              a == null || a(N);
            },
            onSlideMove: (S) => {
              const N = C(S.clientX);
              s == null || s(N);
            },
            onSlideEnd: () => {
              v.current = void 0, l == null || l();
            },
            onStepKeyDown: (S) => {
              const E = rK[w ? "from-left" : "from-right"].includes(S.key);
              u == null || u({ event: S, direction: E ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), lwe = x.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: r,
      inverted: i,
      onSlideStart: o,
      onSlideMove: a,
      onSlideEnd: s,
      onStepKeyDown: l,
      ...u
    } = e, c = x.useRef(null), f = tt(t, c), h = x.useRef(), m = !i;
    function v(g) {
      const y = h.current || c.current.getBoundingClientRect(), w = [0, y.height], S = hS(w, m ? [r, n] : [n, r]);
      return h.current = y, S(g - y.top);
    }
    return /* @__PURE__ */ d(
      aK,
      {
        scope: e.__scopeSlider,
        startEdge: m ? "bottom" : "top",
        endEdge: m ? "top" : "bottom",
        size: "height",
        direction: m ? 1 : -1,
        children: /* @__PURE__ */ d(
          lK,
          {
            "data-orientation": "vertical",
            ...u,
            ref: f,
            style: {
              ...u.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (g) => {
              const y = v(g.clientY);
              o == null || o(y);
            },
            onSlideMove: (g) => {
              const y = v(g.clientY);
              a == null || a(y);
            },
            onSlideEnd: () => {
              h.current = void 0, s == null || s();
            },
            onStepKeyDown: (g) => {
              const w = rK[m ? "from-bottom" : "from-top"].includes(g.key);
              l == null || l({ event: g, direction: w ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), lK = x.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: n,
      onSlideStart: r,
      onSlideMove: i,
      onSlideEnd: o,
      onHomeKeyDown: a,
      onEndKeyDown: s,
      onStepKeyDown: l,
      ...u
    } = e, c = q2(kd, n);
    return /* @__PURE__ */ d(
      Re.span,
      {
        ...u,
        ref: t,
        onKeyDown: Me(e.onKeyDown, (f) => {
          f.key === "Home" ? (a(f), f.preventDefault()) : f.key === "End" ? (s(f), f.preventDefault()) : tK.concat(nK).includes(f.key) && (l(f), f.preventDefault());
        }),
        onPointerDown: Me(e.onPointerDown, (f) => {
          const h = f.target;
          h.setPointerCapture(f.pointerId), f.preventDefault(), c.thumbs.has(h) ? h.focus() : r(f);
        }),
        onPointerMove: Me(e.onPointerMove, (f) => {
          f.target.hasPointerCapture(f.pointerId) && i(f);
        }),
        onPointerUp: Me(e.onPointerUp, (f) => {
          const h = f.target;
          h.hasPointerCapture(f.pointerId) && (h.releasePointerCapture(f.pointerId), o(f));
        })
      }
    );
  }
), uK = "SliderTrack", cK = x.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...r } = e, i = q2(uK, n);
    return /* @__PURE__ */ d(
      Re.span,
      {
        "data-disabled": i.disabled ? "" : void 0,
        "data-orientation": i.orientation,
        ...r,
        ref: t
      }
    );
  }
);
cK.displayName = uK;
var f7 = "SliderRange", dK = x.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...r } = e, i = q2(f7, n), o = sK(f7, n), a = x.useRef(null), s = tt(t, a), l = i.values.length, u = i.values.map(
      (h) => hK(h, i.min, i.max)
    ), c = l > 1 ? Math.min(...u) : 0, f = 100 - Math.max(...u);
    return /* @__PURE__ */ d(
      Re.span,
      {
        "data-orientation": i.orientation,
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: s,
        style: {
          ...e.style,
          [o.startEdge]: c + "%",
          [o.endEdge]: f + "%"
        }
      }
    );
  }
);
dK.displayName = f7;
var h7 = "SliderThumb", fK = x.forwardRef(
  (e, t) => {
    const n = iwe(e.__scopeSlider), [r, i] = x.useState(null), o = tt(t, (s) => i(s)), a = x.useMemo(
      () => r ? n().findIndex((s) => s.ref.current === r) : -1,
      [n, r]
    );
    return /* @__PURE__ */ d(uwe, { ...e, ref: o, index: a });
  }
), uwe = x.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, index: r, name: i, ...o } = e, a = q2(h7, n), s = sK(h7, n), [l, u] = x.useState(null), c = tt(t, (C) => u(C)), f = l ? a.form || !!l.closest("form") : !0, h = uu(l), m = a.values[r], v = m === void 0 ? 0 : hK(m, a.min, a.max), g = fwe(r, a.values.length), y = h == null ? void 0 : h[s.size], w = y ? pwe(y, v, s.direction) : 0;
    return x.useEffect(() => {
      if (l)
        return a.thumbs.add(l), () => {
          a.thumbs.delete(l);
        };
    }, [l, a.thumbs]), /* @__PURE__ */ k(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [s.startEdge]: `calc(${v}% + ${w}px)`
        },
        children: [
          /* @__PURE__ */ d(d7.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ d(
            Re.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || g,
              "aria-valuemin": a.min,
              "aria-valuenow": m,
              "aria-valuemax": a.max,
              "aria-orientation": a.orientation,
              "data-orientation": a.orientation,
              "data-disabled": a.disabled ? "" : void 0,
              tabIndex: a.disabled ? void 0 : 0,
              ...o,
              ref: c,
              style: m === void 0 ? { display: "none" } : e.style,
              onFocus: Me(e.onFocus, () => {
                a.valueIndexToChangeRef.current = r;
              })
            }
          ) }),
          f && /* @__PURE__ */ d(
            cwe,
            {
              name: i ?? (a.name ? a.name + (a.values.length > 1 ? "[]" : "") : void 0),
              form: a.form,
              value: m
            },
            r
          )
        ]
      }
    );
  }
);
fK.displayName = h7;
var cwe = (e) => {
  const { value: t, ...n } = e, r = x.useRef(null), i = bd(t);
  return x.useEffect(() => {
    const o = r.current, a = window.HTMLInputElement.prototype, l = Object.getOwnPropertyDescriptor(a, "value").set;
    if (i !== t && l) {
      const u = new Event("input", { bubbles: !0 });
      l.call(o, t), o.dispatchEvent(u);
    }
  }, [i, t]), /* @__PURE__ */ d("input", { style: { display: "none" }, ...n, ref: r, defaultValue: t });
};
function dwe(e = [], t, n) {
  const r = [...e];
  return r[n] = t, r.sort((i, o) => i - o);
}
function hK(e, t, n) {
  const o = 100 / (n - t) * (e - t);
  return rh(o, [0, 100]);
}
function fwe(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function hwe(e, t) {
  if (e.length === 1) return 0;
  const n = e.map((i) => Math.abs(i - t)), r = Math.min(...n);
  return n.indexOf(r);
}
function pwe(e, t, n) {
  const r = e / 2, o = hS([0, 50], [0, r]);
  return (r - o(t) * n) * n;
}
function mwe(e) {
  return e.slice(0, -1).map((t, n) => e[n + 1] - t);
}
function gwe(e, t) {
  if (t > 0) {
    const n = mwe(e);
    return Math.min(...n) >= t;
  }
  return !0;
}
function hS(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function vwe(e) {
  return (String(e).split(".")[1] || "").length;
}
function ywe(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
var pK = oK, bwe = cK, xwe = dK, wwe = fK;
const Cwe = te(({ className: e, ...t }, n) => /* @__PURE__ */ k(
  pK,
  {
    ref: n,
    className: z(
      "relative flex w-full touch-none select-none items-center",
      e
    ),
    ...t,
    children: [
      /* @__PURE__ */ d(bwe, { className: "bg-secondary relative h-2 w-full grow overflow-hidden rounded-full", children: /* @__PURE__ */ d(xwe, { className: "bg-blueBorder absolute h-full" }) }),
      /* @__PURE__ */ d(wwe, { className: "border-primary bg-background ring-offset-background focus-visible:ring-ring block h-5 w-5 rounded-full border-2 transition-colors focus-visible:outline-hidden focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50" })
    ]
  }
));
Cwe.displayName = pK.displayName;
var pS = "Switch", [Swe, het] = Ks(pS), [_we, Ewe] = Swe(pS), mK = x.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: i,
      defaultChecked: o,
      required: a,
      disabled: s,
      value: l = "on",
      onCheckedChange: u,
      ...c
    } = e, [f, h] = x.useState(null), m = tt(t, (C) => h(C)), v = x.useRef(!1), g = f ? !!f.closest("form") : !0, [y = !1, w] = Kt({
      prop: i,
      defaultProp: o,
      onChange: u
    });
    return /* @__PURE__ */ k(_we, { scope: n, checked: y, disabled: s, children: [
      /* @__PURE__ */ d(
        Re.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": y,
          "aria-required": a,
          "data-state": yK(y),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...c,
          ref: m,
          onClick: Me(e.onClick, (C) => {
            w((S) => !S), g && (v.current = C.isPropagationStopped(), v.current || C.stopPropagation());
          })
        }
      ),
      g && /* @__PURE__ */ d(
        Nwe,
        {
          control: f,
          bubbles: !v.current,
          name: r,
          value: l,
          checked: y,
          required: a,
          disabled: s,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
mK.displayName = pS;
var gK = "SwitchThumb", vK = x.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, i = Ewe(gK, n);
    return /* @__PURE__ */ d(
      Re.span,
      {
        "data-state": yK(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
vK.displayName = gK;
var Nwe = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...i } = e, o = x.useRef(null), a = bd(n), s = uu(t);
  return x.useEffect(() => {
    const l = o.current, u = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(u, "checked").set;
    if (a !== n && f) {
      const h = new Event("click", { bubbles: r });
      f.call(l, n), l.dispatchEvent(h);
    }
  }, [a, n, r]), /* @__PURE__ */ d(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...i,
      tabIndex: -1,
      ref: o,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function yK(e) {
  return e ? "checked" : "unchecked";
}
var bK = mK, Awe = vK;
const Np = te(({ className: e, thumbClassName: t, ...n }, r) => /* @__PURE__ */ d(
  bK,
  {
    className: z(
      "bg-interfaceBgDefault data-[state=checked]:bg-actionDefault focus-visible:ring-ring focus-visible:ring-offset-background data-[state=unchecked]:bg-input inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 peer",
      e
    ),
    ...n,
    ref: r,
    children: /* @__PURE__ */ d(
      Awe,
      {
        className: z(
          "bg-interfaceWhite pointer-events-none block h-5 w-5 rounded-full shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0",
          t
        )
      }
    )
  }
));
Np.displayName = bK.displayName;
function Owe({ children: e, className: t }) {
  return /* @__PURE__ */ d(
    "div",
    {
      className: z(
        "flex items-center text-bodysm w-min whitespace-nowrap rounded-xl border px-2",
        t
      ),
      children: e
    }
  );
}
function kwe({
  className: e,
  iconClassName: t,
  itemClassName: n,
  items: r,
  onClick: i,
  selectedId: o
}) {
  return /* @__PURE__ */ d("div", { className: z("flex flex-col", e), children: r.map((a, s) => {
    const l = s === r.length - 1;
    return /* @__PURE__ */ k(
      "div",
      {
        className: z(
          "data-[selected=true]:bg-blueBgSelect flex cursor-pointer gap-2 data-[selected=true]:rounded-lg",
          n
        ),
        "data-selected": o ? o === a.id : void 0,
        onClick: () => i == null ? void 0 : i(a.id || ""),
        children: [
          /* @__PURE__ */ k("div", { className: "flex flex-col items-center", children: [
            /* @__PURE__ */ d("div", { className: "flex min-h-[20px] items-center", children: /* @__PURE__ */ d(
              "div",
              {
                className: z(
                  "bg-blueDefault data-[disabled=true]:bg-blueDisabled text-textWhite flex h-4 w-4 items-center justify-center rounded-full",
                  t
                ),
                "data-disabled": a.disabled,
                "data-selected": o ? o === a.id : void 0,
                children: a.icon
              }
            ) }),
            /* @__PURE__ */ d(
              "div",
              {
                className: z(
                  "bg-blueDefault data-[disabled=true]:bg-blueDisabled h-full w-[2px]",
                  l && "hidden"
                ),
                "data-disabled": a.disabled
              }
            )
          ] }),
          /* @__PURE__ */ k("div", { children: [
            /* @__PURE__ */ d("div", { className: "text-headingsm text-textPrimary", children: a.title }),
            /* @__PURE__ */ d(
              "p",
              {
                className: z(
                  "text-bodymd text-textPrimary data-[disabled=true]:text-textSubdued",
                  (o !== void 0 || !l) && "mb-2"
                ),
                "data-disabled": a.disabled,
                children: a.content
              }
            )
          ] })
        ]
      },
      s
    );
  }) });
}
var mS = "Tabs", [Pwe, pet] = Ks(mS, [
  R2
]), xK = R2(), [Twe, gS] = Pwe(mS), wK = x.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: i,
      defaultValue: o,
      orientation: a = "horizontal",
      dir: s,
      activationMode: l = "automatic",
      ...u
    } = e, c = Bi(s), [f, h] = Kt({
      prop: r,
      onChange: i,
      defaultProp: o
    });
    return /* @__PURE__ */ d(
      Twe,
      {
        scope: n,
        baseId: ln(),
        value: f,
        onValueChange: h,
        orientation: a,
        dir: c,
        activationMode: l,
        children: /* @__PURE__ */ d(
          Re.div,
          {
            dir: c,
            "data-orientation": a,
            ...u,
            ref: t
          }
        )
      }
    );
  }
);
wK.displayName = mS;
var CK = "TabsList", SK = x.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: r = !0, ...i } = e, o = gS(CK, n), a = xK(n);
    return /* @__PURE__ */ d(
      mH,
      {
        asChild: !0,
        ...a,
        orientation: o.orientation,
        dir: o.dir,
        loop: r,
        children: /* @__PURE__ */ d(
          Re.div,
          {
            role: "tablist",
            "aria-orientation": o.orientation,
            ...i,
            ref: t
          }
        )
      }
    );
  }
);
SK.displayName = CK;
var _K = "TabsTrigger", EK = x.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, disabled: i = !1, ...o } = e, a = gS(_K, n), s = xK(n), l = OK(a.baseId, r), u = kK(a.baseId, r), c = r === a.value;
    return /* @__PURE__ */ d(
      gH,
      {
        asChild: !0,
        ...s,
        focusable: !i,
        active: c,
        children: /* @__PURE__ */ d(
          Re.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": c,
            "aria-controls": u,
            "data-state": c ? "active" : "inactive",
            "data-disabled": i ? "" : void 0,
            disabled: i,
            id: l,
            ...o,
            ref: t,
            onMouseDown: Me(e.onMouseDown, (f) => {
              !i && f.button === 0 && f.ctrlKey === !1 ? a.onValueChange(r) : f.preventDefault();
            }),
            onKeyDown: Me(e.onKeyDown, (f) => {
              [" ", "Enter"].includes(f.key) && a.onValueChange(r);
            }),
            onFocus: Me(e.onFocus, () => {
              const f = a.activationMode !== "manual";
              !c && !i && f && a.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
EK.displayName = _K;
var NK = "TabsContent", AK = x.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, forceMount: i, children: o, ...a } = e, s = gS(NK, n), l = OK(s.baseId, r), u = kK(s.baseId, r), c = r === s.value, f = x.useRef(c);
    return x.useEffect(() => {
      const h = requestAnimationFrame(() => f.current = !1);
      return () => cancelAnimationFrame(h);
    }, []), /* @__PURE__ */ d(zg, { present: i || c, children: ({ present: h }) => /* @__PURE__ */ d(
      Re.div,
      {
        "data-state": c ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !h,
        id: u,
        tabIndex: 0,
        ...a,
        ref: t,
        style: {
          ...e.style,
          animationDuration: f.current ? "0s" : void 0
        },
        children: h && o
      }
    ) });
  }
);
AK.displayName = NK;
function OK(e, t) {
  return `${e}-trigger-${t}`;
}
function kK(e, t) {
  return `${e}-content-${t}`;
}
var Mwe = wK, PK = SK, TK = EK, MK = AK;
const Ea = Mwe, Ro = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  PK,
  {
    ref: n,
    className: z("inline-flex items-center justify-center", e),
    ...t
  }
));
Ro.displayName = PK.displayName;
const jn = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  TK,
  {
    ref: n,
    className: z(
      "data-[state=active]:bg-background data-[state=active]:border-b-3 inline-flex items-center justify-center whitespace-nowrap border-b border-[#E3E2E1] py-3 text-bodymd font-semibold text-[#7D7C78] transition-all disabled:pointer-events-none disabled:opacity-50 data-[state=active]:border-[#0060EA] data-[state=active]:text-black",
      e
    ),
    ...t
  }
));
jn.displayName = TK.displayName;
const Mn = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  MK,
  {
    ref: n,
    className: z(
      "ring-offset-background focus-visible:ring-ring focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2",
      e
    ),
    ...t
  }
));
Mn.displayName = MK.displayName;
const Rwe = te(
  ({ className: e, ...t }, n) => /* @__PURE__ */ d(
    "textarea",
    {
      className: z(
        "border-input bg-background ring-offset-background placeholder:text-[1rem] placeholder:leading-[1.25rem] placeholder:text-muted-foreground focus-visible:ring-ring flex min-h-[80px] w-full rounded-md border px-3 py-2 text-[1rem] leading-[1.25rem] focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ref: n,
      ...t
    }
  )
);
Rwe.displayName = "Textarea";
var Dwe = "DismissableLayer", p7 = "dismissableLayer.update", Iwe = "dismissableLayer.pointerDownOutside", $we = "dismissableLayer.focusOutside", tP, RK = x.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), DK = x.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = e, u = x.useContext(RK), [c, f] = x.useState(null), h = (c == null ? void 0 : c.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = x.useState({}), v = tt(t, (O) => f(O)), g = Array.from(u.layers), [y] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), w = g.indexOf(y), C = c ? g.indexOf(c) : -1, S = u.layersWithOutsidePointerEventsDisabled.size > 0, N = C >= w, E = Fwe((O) => {
      const T = O.target, M = [...u.branches].some((L) => L.contains(T));
      !N || M || (i == null || i(O), a == null || a(O), O.defaultPrevented || s == null || s());
    }, h), A = Bwe((O) => {
      const T = O.target;
      [...u.branches].some((L) => L.contains(T)) || (o == null || o(O), a == null || a(O), O.defaultPrevented || s == null || s());
    }, h);
    return lu((O) => {
      C === u.layers.size - 1 && (r == null || r(O), !O.defaultPrevented && s && (O.preventDefault(), s()));
    }, h), x.useEffect(() => {
      if (c)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (tP = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(c)), u.layers.add(c), nP(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = tP);
        };
    }, [c, h, n, u]), x.useEffect(() => () => {
      c && (u.layers.delete(c), u.layersWithOutsidePointerEventsDisabled.delete(c), nP());
    }, [c, u]), x.useEffect(() => {
      const O = () => m({});
      return document.addEventListener(p7, O), () => document.removeEventListener(p7, O);
    }, []), /* @__PURE__ */ d(
      Re.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: S ? N ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Me(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: Me(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: Me(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
DK.displayName = Dwe;
var Lwe = "DismissableLayerBranch", IK = x.forwardRef((e, t) => {
  const n = x.useContext(RK), r = x.useRef(null), i = tt(t, r);
  return x.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ d(Re.div, { ...e, ref: i });
});
IK.displayName = Lwe;
function Fwe(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ie(e), r = x.useRef(!1), i = x.useRef(() => {
  });
  return x.useEffect(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          $K(
            Iwe,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = l, t.addEventListener("click", i.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Bwe(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ie(e), r = x.useRef(!1);
  return x.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && $K($we, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function nP() {
  const e = new CustomEvent(p7);
  document.dispatchEvent(e);
}
function $K(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? qg(i, o) : i.dispatchEvent(o);
}
var jwe = DK, Vwe = IK, qwe = "Portal", LK = x.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [i, o] = x.useState(!1);
  He(() => o(!0), []);
  const a = n || i && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return a ? Zo.createPortal(/* @__PURE__ */ d(Re.div, { ...r, ref: t }), a) : null;
});
LK.displayName = qwe;
var zwe = "VisuallyHidden", vS = x.forwardRef(
  (e, t) => /* @__PURE__ */ d(
    Re.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
vS.displayName = zwe;
var yS = "ToastProvider", [bS, Wwe, Hwe] = Vg("Toast"), [FK, met] = Ks("Toast", [Hwe]), [Uwe, z2] = FK(yS), BK = (e) => {
  const {
    __scopeToast: t,
    label: n = "Notification",
    duration: r = 5e3,
    swipeDirection: i = "right",
    swipeThreshold: o = 50,
    children: a
  } = e, [s, l] = x.useState(null), [u, c] = x.useState(0), f = x.useRef(!1), h = x.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${yS}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ d(bS.Provider, { scope: t, children: /* @__PURE__ */ d(
    Uwe,
    {
      scope: t,
      label: n,
      duration: r,
      swipeDirection: i,
      swipeThreshold: o,
      toastCount: u,
      viewport: s,
      onViewportChange: l,
      onToastAdd: x.useCallback(() => c((m) => m + 1), []),
      onToastRemove: x.useCallback(() => c((m) => m - 1), []),
      isFocusedToastEscapeKeyDownRef: f,
      isClosePausedRef: h,
      children: a
    }
  ) });
};
BK.displayName = yS;
var jK = "ToastViewport", Gwe = ["F8"], m7 = "toast.viewportPause", g7 = "toast.viewportResume", VK = x.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      hotkey: r = Gwe,
      label: i = "Notifications ({hotkey})",
      ...o
    } = e, a = z2(jK, n), s = Wwe(n), l = x.useRef(null), u = x.useRef(null), c = x.useRef(null), f = x.useRef(null), h = tt(t, f, a.onViewportChange), m = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), v = a.toastCount > 0;
    x.useEffect(() => {
      const y = (w) => {
        var S;
        r.every((N) => w[N] || w.code === N) && ((S = f.current) == null || S.focus());
      };
      return document.addEventListener("keydown", y), () => document.removeEventListener("keydown", y);
    }, [r]), x.useEffect(() => {
      const y = l.current, w = f.current;
      if (v && y && w) {
        const C = () => {
          if (!a.isClosePausedRef.current) {
            const A = new CustomEvent(m7);
            w.dispatchEvent(A), a.isClosePausedRef.current = !0;
          }
        }, S = () => {
          if (a.isClosePausedRef.current) {
            const A = new CustomEvent(g7);
            w.dispatchEvent(A), a.isClosePausedRef.current = !1;
          }
        }, N = (A) => {
          !y.contains(A.relatedTarget) && S();
        }, E = () => {
          y.contains(document.activeElement) || S();
        };
        return y.addEventListener("focusin", C), y.addEventListener("focusout", N), y.addEventListener("pointermove", C), y.addEventListener("pointerleave", E), window.addEventListener("blur", C), window.addEventListener("focus", S), () => {
          y.removeEventListener("focusin", C), y.removeEventListener("focusout", N), y.removeEventListener("pointermove", C), y.removeEventListener("pointerleave", E), window.removeEventListener("blur", C), window.removeEventListener("focus", S);
        };
      }
    }, [v, a.isClosePausedRef]);
    const g = x.useCallback(
      ({ tabbingDirection: y }) => {
        const C = s().map((S) => {
          const N = S.ref.current, E = [N, ...aCe(N)];
          return y === "forwards" ? E : E.reverse();
        });
        return (y === "forwards" ? C.reverse() : C).flat();
      },
      [s]
    );
    return x.useEffect(() => {
      const y = f.current;
      if (y) {
        const w = (C) => {
          var E, A, O;
          const S = C.altKey || C.ctrlKey || C.metaKey;
          if (C.key === "Tab" && !S) {
            const T = document.activeElement, M = C.shiftKey;
            if (C.target === y && M) {
              (E = u.current) == null || E.focus();
              return;
            }
            const j = g({ tabbingDirection: M ? "backwards" : "forwards" }), B = j.findIndex((q) => q === T);
            y3(j.slice(B + 1)) ? C.preventDefault() : M ? (A = u.current) == null || A.focus() : (O = c.current) == null || O.focus();
          }
        };
        return y.addEventListener("keydown", w), () => y.removeEventListener("keydown", w);
      }
    }, [s, g]), /* @__PURE__ */ k(
      Vwe,
      {
        ref: l,
        role: "region",
        "aria-label": i.replace("{hotkey}", m),
        tabIndex: -1,
        style: { pointerEvents: v ? void 0 : "none" },
        children: [
          v && /* @__PURE__ */ d(
            v7,
            {
              ref: u,
              onFocusFromOutsideViewport: () => {
                const y = g({
                  tabbingDirection: "forwards"
                });
                y3(y);
              }
            }
          ),
          /* @__PURE__ */ d(bS.Slot, { scope: n, children: /* @__PURE__ */ d(Re.ol, { tabIndex: -1, ...o, ref: h }) }),
          v && /* @__PURE__ */ d(
            v7,
            {
              ref: c,
              onFocusFromOutsideViewport: () => {
                const y = g({
                  tabbingDirection: "backwards"
                });
                y3(y);
              }
            }
          )
        ]
      }
    );
  }
);
VK.displayName = jK;
var qK = "ToastFocusProxy", v7 = x.forwardRef(
  (e, t) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: r, ...i } = e, o = z2(qK, n);
    return /* @__PURE__ */ d(
      vS,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...i,
        ref: t,
        style: { position: "fixed" },
        onFocus: (a) => {
          var u;
          const s = a.relatedTarget;
          !((u = o.viewport) != null && u.contains(s)) && r();
        }
      }
    );
  }
);
v7.displayName = qK;
var W2 = "Toast", Kwe = "toast.swipeStart", Ywe = "toast.swipeMove", Zwe = "toast.swipeCancel", Xwe = "toast.swipeEnd", zK = x.forwardRef(
  (e, t) => {
    const { forceMount: n, open: r, defaultOpen: i, onOpenChange: o, ...a } = e, [s = !0, l] = Kt({
      prop: r,
      defaultProp: i,
      onChange: o
    });
    return /* @__PURE__ */ d(zg, { present: n || s, children: /* @__PURE__ */ d(
      eCe,
      {
        open: s,
        ...a,
        ref: t,
        onClose: () => l(!1),
        onPause: Ie(e.onPause),
        onResume: Ie(e.onResume),
        onSwipeStart: Me(e.onSwipeStart, (u) => {
          u.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: Me(e.onSwipeMove, (u) => {
          const { x: c, y: f } = u.detail.delta;
          u.currentTarget.setAttribute("data-swipe", "move"), u.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${c}px`), u.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${f}px`);
        }),
        onSwipeCancel: Me(e.onSwipeCancel, (u) => {
          u.currentTarget.setAttribute("data-swipe", "cancel"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), u.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: Me(e.onSwipeEnd, (u) => {
          const { x: c, y: f } = u.detail.delta;
          u.currentTarget.setAttribute("data-swipe", "end"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), u.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${c}px`), u.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${f}px`), l(!1);
        })
      }
    ) });
  }
);
zK.displayName = W2;
var [Jwe, Qwe] = FK(W2, {
  onClose() {
  }
}), eCe = x.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      type: r = "foreground",
      duration: i,
      open: o,
      onClose: a,
      onEscapeKeyDown: s,
      onPause: l,
      onResume: u,
      onSwipeStart: c,
      onSwipeMove: f,
      onSwipeCancel: h,
      onSwipeEnd: m,
      ...v
    } = e, g = z2(W2, n), [y, w] = x.useState(null), C = tt(t, (q) => w(q)), S = x.useRef(null), N = x.useRef(null), E = i || g.duration, A = x.useRef(0), O = x.useRef(E), T = x.useRef(0), { onToastAdd: M, onToastRemove: L } = g, I = Ie(() => {
      var G;
      (y == null ? void 0 : y.contains(document.activeElement)) && ((G = g.viewport) == null || G.focus()), a();
    }), j = x.useCallback(
      (q) => {
        !q || q === 1 / 0 || (window.clearTimeout(T.current), A.current = (/* @__PURE__ */ new Date()).getTime(), T.current = window.setTimeout(I, q));
      },
      [I]
    );
    x.useEffect(() => {
      const q = g.viewport;
      if (q) {
        const G = () => {
          j(O.current), u == null || u();
        }, U = () => {
          const V = (/* @__PURE__ */ new Date()).getTime() - A.current;
          O.current = O.current - V, window.clearTimeout(T.current), l == null || l();
        };
        return q.addEventListener(m7, U), q.addEventListener(g7, G), () => {
          q.removeEventListener(m7, U), q.removeEventListener(g7, G);
        };
      }
    }, [g.viewport, E, l, u, j]), x.useEffect(() => {
      o && !g.isClosePausedRef.current && j(E);
    }, [o, E, g.isClosePausedRef, j]), x.useEffect(() => (M(), () => L()), [M, L]);
    const B = x.useMemo(() => y ? ZK(y) : null, [y]);
    return g.viewport ? /* @__PURE__ */ k(xe, { children: [
      B && /* @__PURE__ */ d(
        tCe,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: B
        }
      ),
      /* @__PURE__ */ d(Jwe, { scope: n, onClose: I, children: go.createPortal(
        /* @__PURE__ */ d(bS.ItemSlot, { scope: n, children: /* @__PURE__ */ d(
          jwe,
          {
            asChild: !0,
            onEscapeKeyDown: Me(s, () => {
              g.isFocusedToastEscapeKeyDownRef.current || I(), g.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ d(
              Re.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": o ? "open" : "closed",
                "data-swipe-direction": g.swipeDirection,
                ...v,
                ref: C,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: Me(e.onKeyDown, (q) => {
                  q.key === "Escape" && (s == null || s(q.nativeEvent), q.nativeEvent.defaultPrevented || (g.isFocusedToastEscapeKeyDownRef.current = !0, I()));
                }),
                onPointerDown: Me(e.onPointerDown, (q) => {
                  q.button === 0 && (S.current = { x: q.clientX, y: q.clientY });
                }),
                onPointerMove: Me(e.onPointerMove, (q) => {
                  if (!S.current) return;
                  const G = q.clientX - S.current.x, U = q.clientY - S.current.y, V = !!N.current, H = ["left", "right"].includes(g.swipeDirection), Z = ["left", "up"].includes(g.swipeDirection) ? Math.min : Math.max, de = H ? Z(0, G) : 0, ne = H ? 0 : Z(0, U), Y = q.pointerType === "touch" ? 10 : 2, le = { x: de, y: ne }, be = { originalEvent: q, delta: le };
                  V ? (N.current = le, l1(Ywe, f, be, {
                    discrete: !1
                  })) : rP(le, g.swipeDirection, Y) ? (N.current = le, l1(Kwe, c, be, {
                    discrete: !1
                  }), q.target.setPointerCapture(q.pointerId)) : (Math.abs(G) > Y || Math.abs(U) > Y) && (S.current = null);
                }),
                onPointerUp: Me(e.onPointerUp, (q) => {
                  const G = N.current, U = q.target;
                  if (U.hasPointerCapture(q.pointerId) && U.releasePointerCapture(q.pointerId), N.current = null, S.current = null, G) {
                    const V = q.currentTarget, H = { originalEvent: q, delta: G };
                    rP(G, g.swipeDirection, g.swipeThreshold) ? l1(Xwe, m, H, {
                      discrete: !0
                    }) : l1(
                      Zwe,
                      h,
                      H,
                      {
                        discrete: !0
                      }
                    ), V.addEventListener("click", (Z) => Z.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        g.viewport
      ) })
    ] }) : null;
  }
), tCe = (e) => {
  const { __scopeToast: t, children: n, ...r } = e, i = z2(W2, t), [o, a] = x.useState(!1), [s, l] = x.useState(!1);
  return iCe(() => a(!0)), x.useEffect(() => {
    const u = window.setTimeout(() => l(!0), 1e3);
    return () => window.clearTimeout(u);
  }, []), s ? null : /* @__PURE__ */ d(LK, { asChild: !0, children: /* @__PURE__ */ d(vS, { ...r, children: o && /* @__PURE__ */ k(xe, { children: [
    i.label,
    " ",
    n
  ] }) }) });
}, nCe = "ToastTitle", WK = x.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ d(Re.div, { ...r, ref: t });
  }
);
WK.displayName = nCe;
var rCe = "ToastDescription", HK = x.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ d(Re.div, { ...r, ref: t });
  }
);
HK.displayName = rCe;
var UK = "ToastAction", GK = x.forwardRef(
  (e, t) => {
    const { altText: n, ...r } = e;
    return n.trim() ? /* @__PURE__ */ d(YK, { altText: n, asChild: !0, children: /* @__PURE__ */ d(xS, { ...r, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${UK}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
GK.displayName = UK;
var KK = "ToastClose", xS = x.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e, i = Qwe(KK, n);
    return /* @__PURE__ */ d(YK, { asChild: !0, children: /* @__PURE__ */ d(
      Re.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: Me(e.onClick, i.onClose)
      }
    ) });
  }
);
xS.displayName = KK;
var YK = x.forwardRef((e, t) => {
  const { __scopeToast: n, altText: r, ...i } = e;
  return /* @__PURE__ */ d(
    Re.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...i,
      ref: t
    }
  );
});
function ZK(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), oCe(r)) {
      const i = r.ariaHidden || r.hidden || r.style.display === "none", o = r.dataset.radixToastAnnounceExclude === "";
      if (!i)
        if (o) {
          const a = r.dataset.radixToastAnnounceAlt;
          a && t.push(a);
        } else
          t.push(...ZK(r));
    }
  }), t;
}
function l1(e, t, n, { discrete: r }) {
  const i = n.originalEvent.currentTarget, o = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? qg(i, o) : i.dispatchEvent(o);
}
var rP = (e, t, n = 0) => {
  const r = Math.abs(e.x), i = Math.abs(e.y), o = r > i;
  return t === "left" || t === "right" ? o && r > n : !o && i > n;
};
function iCe(e = () => {
}) {
  const t = Ie(e);
  He(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
function oCe(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function aCe(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function y3(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
var sCe = BK, XK = VK, JK = zK, QK = WK, eY = HK, tY = GK, nY = xS;
const lCe = sCe, rY = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  XK,
  {
    ref: n,
    className: z(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
      e
    ),
    ...t
  }
));
rY.displayName = XK.displayName;
const uCe = Jo(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-background text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), iY = te(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ d(
  JK,
  {
    ref: r,
    className: z(uCe({ variant: t }), e),
    ...n
  }
));
iY.displayName = JK.displayName;
const cCe = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  tY,
  {
    ref: n,
    className: z(
      "ring-offset-background hover:bg-secondary focus:ring-ring group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-bodysm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
      e
    ),
    ...t
  }
));
cCe.displayName = tY.displayName;
const oY = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  nY,
  {
    ref: n,
    className: z(
      "text-foreground/50 hover:text-foreground absolute right-2 top-2 rounded-md p-1 opacity-0 transition-opacity focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
      e
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ d(np, { className: "h-4 w-4" })
  }
));
oY.displayName = nY.displayName;
const aY = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  QK,
  {
    ref: n,
    className: z("text-bodysm font-semibold", e),
    ...t
  }
));
aY.displayName = QK.displayName;
const sY = te(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  eY,
  {
    ref: n,
    className: z("text-bodysm opacity-90", e),
    ...t
  }
));
sY.displayName = eY.displayName;
const dCe = 1, fCe = 15e5;
let b3 = 0;
function hCe() {
  return b3 = (b3 + 1) % Number.MAX_VALUE, b3.toString();
}
const x3 = /* @__PURE__ */ new Map(), iP = (e) => {
  if (x3.has(e))
    return;
  const t = setTimeout(() => {
    x3.delete(e), Ff({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, fCe);
  x3.set(e, t);
}, pCe = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, dCe)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map(
          (n) => n.id === t.toast.id ? { ...n, ...t.toast } : n
        )
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = t;
      return n ? iP(n) : e.toasts.forEach((r) => {
        iP(r.id);
      }), {
        ...e,
        toasts: e.toasts.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((n) => n.id !== t.toastId)
      };
  }
}, W1 = [];
let H1 = { toasts: [] };
function Ff(e) {
  H1 = pCe(H1, e), W1.forEach((t) => {
    t(H1);
  });
}
function mCe({ ...e }) {
  const t = hCe(), n = (i) => Ff({
    type: "UPDATE_TOAST",
    toast: { ...i, id: t }
  }), r = () => Ff({ type: "DISMISS_TOAST", toastId: t });
  return Ff({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: (i) => {
        i || r();
      }
    }
  }), {
    id: t,
    dismiss: r,
    update: n
  };
}
function lY() {
  const [e, t] = re(H1);
  return Pe(() => (W1.push(t), () => {
    const n = W1.indexOf(t);
    n > -1 && W1.splice(n, 1);
  }), [e]), {
    ...e,
    toast: mCe,
    dismiss: (n) => Ff({ type: "DISMISS_TOAST", toastId: n })
  };
}
function get() {
  const { toasts: e } = lY();
  return /* @__PURE__ */ k(lCe, { children: [
    e.map(function({ id: t, title: n, description: r, action: i, ...o }) {
      return /* @__PURE__ */ k(iY, { ...o, children: [
        /* @__PURE__ */ k("div", { className: "grid gap-1", children: [
          n && /* @__PURE__ */ d(aY, { children: n }),
          r && /* @__PURE__ */ d(sY, { children: r })
        ] }),
        i,
        /* @__PURE__ */ d(oY, {})
      ] }, t);
    }),
    /* @__PURE__ */ d(rY, {})
  ] });
}
var gCe = "Toggle", uY = x.forwardRef((e, t) => {
  const { pressed: n, defaultPressed: r = !1, onPressedChange: i, ...o } = e, [a = !1, s] = Kt({
    prop: n,
    onChange: i,
    defaultProp: r
  });
  return /* @__PURE__ */ d(
    Re.button,
    {
      type: "button",
      "aria-pressed": a,
      "data-state": a ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...o,
      ref: t,
      onClick: Me(e.onClick, () => {
        e.disabled || s(!a);
      })
    }
  );
});
uY.displayName = gCe;
var cY = uY;
const vCe = Jo(
  "inline-flex items-center justify-center gap-1 rounded-lg text-textSubdued text-bodymd data-[state=on]:bg-textLink data-[state=on]:text-textWhite transition-colors hover:bg-interactiveBgHover focus-visible:outline-hidden data-[state=off]:focus-visible:!bg-interfaceWhite focus-visible:shadow-[0_0_2px_2px_rgba(1,87,255,0.75)] disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border-2 border-blueDisabled bg-transparent data-[state=on]:bg-textLink data-[state=on]:text-textWhite hover:border-blueDefault disabled:border-interactiveBorder data-[state=on]:border-textLink",
        rounded: "border-2 border-blueDisabled bg-transparent data-[state=on]:bg-textLink data-[state=on]:text-textWhite hover:border-blueDefault disabled:border-interactiveBorder data-[state=on]:border-textLink !rounded-[44px]"
      },
      size: {
        default: "h-auto px-2.5 py-1",
        sm: "h-9 px-1",
        lg: "h-11 px-5"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), yCe = te(
  ({ children: e, className: t, disabled: n, pressed: r, size: i, variant: o, ...a }, s) => /* @__PURE__ */ k(
    cY,
    {
      className: z(vCe({ variant: o, size: i, className: t })),
      disabled: n,
      pressed: r,
      ref: s,
      ...a,
      children: [
        r ? /* @__PURE__ */ d(sce, { className: "fill-interfaceWhite stroke-textLink h-4 w-4" }) : /* @__PURE__ */ d(
          Yf,
          {
            className: z(
              "text-textLink h-4 w-4",
              n ? "text-textSubdued" : ""
            )
          }
        ),
        e
      ]
    }
  )
);
yCe.displayName = cY.displayName;
function Sa(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function oP(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function dY(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = oP(i, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : oP(e[i], null);
        }
      };
  };
}
function fu(...e) {
  return x.useCallback(dY(...e), e);
}
function fY(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = x.createContext(a), l = n.length;
    n = [...n, a];
    const u = (f) => {
      var w;
      const { scope: h, children: m, ...v } = f, g = ((w = h == null ? void 0 : h[e]) == null ? void 0 : w[l]) || s, y = x.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ d(g.Provider, { value: y, children: m });
    };
    u.displayName = o + "Provider";
    function c(f, h) {
      var g;
      const m = ((g = h == null ? void 0 : h[e]) == null ? void 0 : g[l]) || s, v = x.useContext(m);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, c];
  }
  const i = () => {
    const o = n.map((a) => x.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return x.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, bCe(i, ...t)];
}
function bCe(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return x.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
// @__NO_SIDE_EFFECTS__
function xCe(e) {
  const t = /* @__PURE__ */ wCe(e), n = x.forwardRef((r, i) => {
    const { children: o, ...a } = r, s = x.Children.toArray(o), l = s.find(SCe);
    if (l) {
      const u = l.props.children, c = s.map((f) => f === l ? x.Children.count(u) > 1 ? x.Children.only(null) : x.isValidElement(u) ? u.props.children : null : f);
      return /* @__PURE__ */ d(t, { ...a, ref: i, children: x.isValidElement(u) ? x.cloneElement(u, void 0, c) : null });
    }
    return /* @__PURE__ */ d(t, { ...a, ref: i, children: o });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function wCe(e) {
  const t = x.forwardRef((n, r) => {
    const { children: i, ...o } = n;
    if (x.isValidElement(i)) {
      const a = ECe(i), s = _Ce(o, i.props);
      return i.type !== x.Fragment && (s.ref = r ? dY(r, a) : a), x.cloneElement(i, s);
    }
    return x.Children.count(i) > 1 ? x.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var hY = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function CCe(e) {
  const t = ({ children: n }) => /* @__PURE__ */ d(xe, { children: n });
  return t.displayName = `${e}.Slottable`, t.__radixId = hY, t;
}
function SCe(e) {
  return x.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === hY;
}
function _Ce(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      const l = o(...s);
      return i(...s), l;
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function ECe(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var NCe = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Qs = NCe.reduce((e, t) => {
  const n = /* @__PURE__ */ xCe(`Primitive.${t}`), r = x.forwardRef((i, o) => {
    const { asChild: a, ...s } = i, l = a ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(l, { ...s, ref: o });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function ACe(e, t) {
  e && go.flushSync(() => e.dispatchEvent(t));
}
function H2(e) {
  const t = x.useRef(e);
  return x.useEffect(() => {
    t.current = e;
  }), x.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function OCe(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = H2(e);
  x.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var kCe = "DismissableLayer", y7 = "dismissableLayer.update", PCe = "dismissableLayer.pointerDownOutside", TCe = "dismissableLayer.focusOutside", aP, pY = x.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), mY = x.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = e, u = x.useContext(pY), [c, f] = x.useState(null), h = (c == null ? void 0 : c.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = x.useState({}), v = fu(t, (O) => f(O)), g = Array.from(u.layers), [y] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), w = g.indexOf(y), C = c ? g.indexOf(c) : -1, S = u.layersWithOutsidePointerEventsDisabled.size > 0, N = C >= w, E = DCe((O) => {
      const T = O.target, M = [...u.branches].some((L) => L.contains(T));
      !N || M || (i == null || i(O), a == null || a(O), O.defaultPrevented || s == null || s());
    }, h), A = ICe((O) => {
      const T = O.target;
      [...u.branches].some((L) => L.contains(T)) || (o == null || o(O), a == null || a(O), O.defaultPrevented || s == null || s());
    }, h);
    return OCe((O) => {
      C === u.layers.size - 1 && (r == null || r(O), !O.defaultPrevented && s && (O.preventDefault(), s()));
    }, h), x.useEffect(() => {
      if (c)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (aP = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(c)), u.layers.add(c), sP(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = aP);
        };
    }, [c, h, n, u]), x.useEffect(() => () => {
      c && (u.layers.delete(c), u.layersWithOutsidePointerEventsDisabled.delete(c), sP());
    }, [c, u]), x.useEffect(() => {
      const O = () => m({});
      return document.addEventListener(y7, O), () => document.removeEventListener(y7, O);
    }, []), /* @__PURE__ */ d(
      Qs.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: S ? N ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Sa(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: Sa(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: Sa(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
mY.displayName = kCe;
var MCe = "DismissableLayerBranch", RCe = x.forwardRef((e, t) => {
  const n = x.useContext(pY), r = x.useRef(null), i = fu(t, r);
  return x.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ d(Qs.div, { ...e, ref: i });
});
RCe.displayName = MCe;
function DCe(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = H2(e), r = x.useRef(!1), i = x.useRef(() => {
  });
  return x.useEffect(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          gY(
            PCe,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = l, t.addEventListener("click", i.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function ICe(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = H2(e), r = x.useRef(!1);
  return x.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && gY(TCe, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function sP() {
  const e = new CustomEvent(y7);
  document.dispatchEvent(e);
}
function gY(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? ACe(i, o) : i.dispatchEvent(o);
}
var Ws = globalThis != null && globalThis.document ? x.useLayoutEffect : () => {
}, $Ce = x[" useId ".trim().toString()] || (() => {
}), LCe = 0;
function FCe(e) {
  const [t, n] = x.useState($Ce());
  return Ws(() => {
    n((r) => r ?? String(LCe++));
  }, [e]), t ? `radix-${t}` : "";
}
var BCe = "Arrow", vY = x.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: i = 5, ...o } = e;
  return /* @__PURE__ */ d(
    Qs.svg,
    {
      ...o,
      ref: t,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ d("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
vY.displayName = BCe;
var jCe = vY;
function VCe(e) {
  const [t, n] = x.useState(void 0);
  return Ws(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const o = i[0];
        let a, s;
        if ("borderBoxSize" in o) {
          const l = o.borderBoxSize, u = Array.isArray(l) ? l[0] : l;
          a = u.inlineSize, s = u.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({ width: a, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var wS = "Popper", [yY, bY] = fY(wS), [qCe, xY] = yY(wS), wY = (e) => {
  const { __scopePopper: t, children: n } = e, [r, i] = x.useState(null);
  return /* @__PURE__ */ d(qCe, { scope: t, anchor: r, onAnchorChange: i, children: n });
};
wY.displayName = wS;
var CY = "PopperAnchor", SY = x.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...i } = e, o = xY(CY, n), a = x.useRef(null), s = fu(t, a), l = x.useRef(null);
    return x.useEffect(() => {
      const u = l.current;
      l.current = (r == null ? void 0 : r.current) || a.current, u !== l.current && o.onAnchorChange(l.current);
    }), r ? null : /* @__PURE__ */ d(Qs.div, { ...i, ref: s });
  }
);
SY.displayName = CY;
var CS = "PopperContent", [zCe, WCe] = yY(CS), _Y = x.forwardRef(
  (e, t) => {
    var ge, Ce, ie, ye, ve, Q;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: i = 0,
      align: o = "center",
      alignOffset: a = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: u = [],
      collisionPadding: c = 0,
      sticky: f = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: v,
      ...g
    } = e, y = xY(CS, n), [w, C] = x.useState(null), S = fu(t, (Oe) => C(Oe)), [N, E] = x.useState(null), A = VCe(N), O = (A == null ? void 0 : A.width) ?? 0, T = (A == null ? void 0 : A.height) ?? 0, M = r + (o !== "center" ? "-" + o : ""), L = typeof c == "number" ? c : { top: 0, right: 0, bottom: 0, left: 0, ...c }, I = Array.isArray(u) ? u : [u], j = I.length > 0, B = {
      padding: L,
      boundary: I.filter(UCe),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: j
    }, { refs: q, floatingStyles: G, placement: U, isPositioned: V, middlewareData: H } = s2({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: M,
      whileElementsMounted: (...Oe) => a2(...Oe, {
        animationFrame: m === "always"
      }),
      elements: {
        reference: y.anchor
      },
      middleware: [
        l2({ mainAxis: i + T, alignmentAxis: a }),
        l && u2({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? c2() : void 0,
          ...B
        }),
        l && d2({ ...B }),
        f2({
          ...B,
          apply: ({ elements: Oe, rects: se, availableWidth: nt, availableHeight: ut }) => {
            const { width: st, height: Nn } = se.reference, Dt = Oe.floating.style;
            Dt.setProperty("--radix-popper-available-width", `${nt}px`), Dt.setProperty("--radix-popper-available-height", `${ut}px`), Dt.setProperty("--radix-popper-anchor-width", `${st}px`), Dt.setProperty("--radix-popper-anchor-height", `${Nn}px`);
          }
        }),
        N && p2({ element: N, padding: s }),
        GCe({ arrowWidth: O, arrowHeight: T }),
        h && h2({ strategy: "referenceHidden", ...B })
      ]
    }), [Z, de] = AY(U), ne = H2(v);
    Ws(() => {
      V && (ne == null || ne());
    }, [V, ne]);
    const Y = (ge = H.arrow) == null ? void 0 : ge.x, le = (Ce = H.arrow) == null ? void 0 : Ce.y, be = ((ie = H.arrow) == null ? void 0 : ie.centerOffset) !== 0, [pe, Ee] = x.useState();
    return Ws(() => {
      w && Ee(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ d(
      "div",
      {
        ref: q.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...G,
          transform: V ? G.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: pe,
          "--radix-popper-transform-origin": [
            (ye = H.transformOrigin) == null ? void 0 : ye.x,
            (ve = H.transformOrigin) == null ? void 0 : ve.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Q = H.hide) == null ? void 0 : Q.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ d(
          zCe,
          {
            scope: n,
            placedSide: Z,
            onArrowChange: E,
            arrowX: Y,
            arrowY: le,
            shouldHideArrow: be,
            children: /* @__PURE__ */ d(
              Qs.div,
              {
                "data-side": Z,
                "data-align": de,
                ...g,
                ref: S,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: V ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
_Y.displayName = CS;
var EY = "PopperArrow", HCe = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, NY = x.forwardRef(function(t, n) {
  const { __scopePopper: r, ...i } = t, o = WCe(EY, r), a = HCe[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ d(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ d(
          jCe,
          {
            ...i,
            ref: n,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
NY.displayName = EY;
function UCe(e) {
  return e !== null;
}
var GCe = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var y, w, C;
    const { placement: n, rects: r, middlewareData: i } = t, a = ((y = i.arrow) == null ? void 0 : y.centerOffset) !== 0, s = a ? 0 : e.arrowWidth, l = a ? 0 : e.arrowHeight, [u, c] = AY(n), f = { start: "0%", center: "50%", end: "100%" }[c], h = (((w = i.arrow) == null ? void 0 : w.x) ?? 0) + s / 2, m = (((C = i.arrow) == null ? void 0 : C.y) ?? 0) + l / 2;
    let v = "", g = "";
    return u === "bottom" ? (v = a ? f : `${h}px`, g = `${-l}px`) : u === "top" ? (v = a ? f : `${h}px`, g = `${r.floating.height + l}px`) : u === "right" ? (v = `${-l}px`, g = a ? f : `${m}px`) : u === "left" && (v = `${r.floating.width + l}px`, g = a ? f : `${m}px`), { data: { x: v, y: g } };
  }
});
function AY(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var KCe = wY, YCe = SY, ZCe = _Y, XCe = NY, JCe = "Portal", OY = x.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [i, o] = x.useState(!1);
  Ws(() => o(!0), []);
  const a = n || i && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return a ? Zo.createPortal(/* @__PURE__ */ d(Qs.div, { ...r, ref: t }), a) : null;
});
OY.displayName = JCe;
function QCe(e, t) {
  return x.useReducer((n, r) => t[n][r] ?? n, e);
}
var SS = (e) => {
  const { present: t, children: n } = e, r = eSe(t), i = typeof n == "function" ? n({ present: r.isPresent }) : x.Children.only(n), o = fu(r.ref, tSe(i));
  return typeof n == "function" || r.isPresent ? x.cloneElement(i, { ref: o }) : null;
};
SS.displayName = "Presence";
function eSe(e) {
  const [t, n] = x.useState(), r = x.useRef(null), i = x.useRef(e), o = x.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = QCe(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return x.useEffect(() => {
    const u = u1(r.current);
    o.current = s === "mounted" ? u : "none";
  }, [s]), Ws(() => {
    const u = r.current, c = i.current;
    if (c !== e) {
      const h = o.current, m = u1(u);
      e ? l("MOUNT") : m === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(c && h !== m ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, l]), Ws(() => {
    if (t) {
      let u;
      const c = t.ownerDocument.defaultView ?? window, f = (m) => {
        const g = u1(r.current).includes(CSS.escape(m.animationName));
        if (m.target === t && g && (l("ANIMATION_END"), !i.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = c.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, h = (m) => {
        m.target === t && (o.current = u1(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        c.clearTimeout(u), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: x.useCallback((u) => {
      r.current = u ? getComputedStyle(u) : null, n(u);
    }, [])
  };
}
function u1(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function tSe(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var nSe = x[" useInsertionEffect ".trim().toString()] || Ws;
function rSe({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [i, o, a] = iSe({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, l = s ? e : i;
  {
    const c = x.useRef(e !== void 0);
    x.useEffect(() => {
      const f = c.current;
      f !== s && console.warn(
        `${r} is changing from ${f ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), c.current = s;
    }, [s, r]);
  }
  const u = x.useCallback(
    (c) => {
      var f;
      if (s) {
        const h = oSe(c) ? c(e) : c;
        h !== e && ((f = a.current) == null || f.call(a, h));
      } else
        o(c);
    },
    [s, e, o, a]
  );
  return [l, u];
}
function iSe({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = x.useState(e), i = x.useRef(n), o = x.useRef(t);
  return nSe(() => {
    o.current = t;
  }, [t]), x.useEffect(() => {
    var a;
    i.current !== n && ((a = o.current) == null || a.call(o, n), i.current = n);
  }, [n, i]), [n, r, o];
}
function oSe(e) {
  return typeof e == "function";
}
var aSe = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), sSe = "VisuallyHidden", kY = x.forwardRef(
  (e, t) => /* @__PURE__ */ d(
    Qs.span,
    {
      ...e,
      ref: t,
      style: { ...aSe, ...e.style }
    }
  )
);
kY.displayName = sSe;
var lSe = kY, [U2, vet] = fY("Tooltip", [
  bY
]), G2 = bY(), PY = "TooltipProvider", uSe = 700, b7 = "tooltip.open", [cSe, _S] = U2(PY), TY = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = uSe,
    skipDelayDuration: r = 300,
    disableHoverableContent: i = !1,
    children: o
  } = e, a = x.useRef(!0), s = x.useRef(!1), l = x.useRef(0);
  return x.useEffect(() => {
    const u = l.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ d(
    cSe,
    {
      scope: t,
      isOpenDelayedRef: a,
      delayDuration: n,
      onOpen: x.useCallback(() => {
        window.clearTimeout(l.current), a.current = !1;
      }, []),
      onClose: x.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => a.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: s,
      onPointerInTransitChange: x.useCallback((u) => {
        s.current = u;
      }, []),
      disableHoverableContent: i,
      children: o
    }
  );
};
TY.displayName = PY;
var oh = "Tooltip", [dSe, Ap] = U2(oh), MY = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    disableHoverableContent: a,
    delayDuration: s
  } = e, l = _S(oh, e.__scopeTooltip), u = G2(t), [c, f] = x.useState(null), h = FCe(), m = x.useRef(0), v = a ?? l.disableHoverableContent, g = s ?? l.delayDuration, y = x.useRef(!1), [w, C] = rSe({
    prop: r,
    defaultProp: i ?? !1,
    onChange: (O) => {
      O ? (l.onOpen(), document.dispatchEvent(new CustomEvent(b7))) : l.onClose(), o == null || o(O);
    },
    caller: oh
  }), S = x.useMemo(() => w ? y.current ? "delayed-open" : "instant-open" : "closed", [w]), N = x.useCallback(() => {
    window.clearTimeout(m.current), m.current = 0, y.current = !1, C(!0);
  }, [C]), E = x.useCallback(() => {
    window.clearTimeout(m.current), m.current = 0, C(!1);
  }, [C]), A = x.useCallback(() => {
    window.clearTimeout(m.current), m.current = window.setTimeout(() => {
      y.current = !0, C(!0), m.current = 0;
    }, g);
  }, [g, C]);
  return x.useEffect(() => () => {
    m.current && (window.clearTimeout(m.current), m.current = 0);
  }, []), /* @__PURE__ */ d(KCe, { ...u, children: /* @__PURE__ */ d(
    dSe,
    {
      scope: t,
      contentId: h,
      open: w,
      stateAttribute: S,
      trigger: c,
      onTriggerChange: f,
      onTriggerEnter: x.useCallback(() => {
        l.isOpenDelayedRef.current ? A() : N();
      }, [l.isOpenDelayedRef, A, N]),
      onTriggerLeave: x.useCallback(() => {
        v ? E() : (window.clearTimeout(m.current), m.current = 0);
      }, [E, v]),
      onOpen: N,
      onClose: E,
      disableHoverableContent: v,
      children: n
    }
  ) });
};
MY.displayName = oh;
var x7 = "TooltipTrigger", RY = x.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, i = Ap(x7, n), o = _S(x7, n), a = G2(n), s = x.useRef(null), l = fu(t, s, i.onTriggerChange), u = x.useRef(!1), c = x.useRef(!1), f = x.useCallback(() => u.current = !1, []);
    return x.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ d(YCe, { asChild: !0, ...a, children: /* @__PURE__ */ d(
      Qs.button,
      {
        "aria-describedby": i.open ? i.contentId : void 0,
        "data-state": i.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: Sa(e.onPointerMove, (h) => {
          h.pointerType !== "touch" && !c.current && !o.isPointerInTransitRef.current && (i.onTriggerEnter(), c.current = !0);
        }),
        onPointerLeave: Sa(e.onPointerLeave, () => {
          i.onTriggerLeave(), c.current = !1;
        }),
        onPointerDown: Sa(e.onPointerDown, () => {
          i.open && i.onClose(), u.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: Sa(e.onFocus, () => {
          u.current || i.onOpen();
        }),
        onBlur: Sa(e.onBlur, i.onClose),
        onClick: Sa(e.onClick, i.onClose)
      }
    ) });
  }
);
RY.displayName = x7;
var ES = "TooltipPortal", [fSe, hSe] = U2(ES, {
  forceMount: void 0
}), DY = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: i } = e, o = Ap(ES, t);
  return /* @__PURE__ */ d(fSe, { scope: t, forceMount: n, children: /* @__PURE__ */ d(SS, { present: n || o.open, children: /* @__PURE__ */ d(OY, { asChild: !0, container: i, children: r }) }) });
};
DY.displayName = ES;
var Rc = "TooltipContent", IY = x.forwardRef(
  (e, t) => {
    const n = hSe(Rc, e.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...o } = e, a = Ap(Rc, e.__scopeTooltip);
    return /* @__PURE__ */ d(SS, { present: r || a.open, children: a.disableHoverableContent ? /* @__PURE__ */ d($Y, { side: i, ...o, ref: t }) : /* @__PURE__ */ d(pSe, { side: i, ...o, ref: t }) });
  }
), pSe = x.forwardRef((e, t) => {
  const n = Ap(Rc, e.__scopeTooltip), r = _S(Rc, e.__scopeTooltip), i = x.useRef(null), o = fu(t, i), [a, s] = x.useState(null), { trigger: l, onClose: u } = n, c = i.current, { onPointerInTransitChange: f } = r, h = x.useCallback(() => {
    s(null), f(!1);
  }, [f]), m = x.useCallback(
    (v, g) => {
      const y = v.currentTarget, w = { x: v.clientX, y: v.clientY }, C = ySe(w, y.getBoundingClientRect()), S = bSe(w, C), N = xSe(g.getBoundingClientRect()), E = CSe([...S, ...N]);
      s(E), f(!0);
    },
    [f]
  );
  return x.useEffect(() => () => h(), [h]), x.useEffect(() => {
    if (l && c) {
      const v = (y) => m(y, c), g = (y) => m(y, l);
      return l.addEventListener("pointerleave", v), c.addEventListener("pointerleave", g), () => {
        l.removeEventListener("pointerleave", v), c.removeEventListener("pointerleave", g);
      };
    }
  }, [l, c, m, h]), x.useEffect(() => {
    if (a) {
      const v = (g) => {
        const y = g.target, w = { x: g.clientX, y: g.clientY }, C = (l == null ? void 0 : l.contains(y)) || (c == null ? void 0 : c.contains(y)), S = !wSe(w, a);
        C ? h() : S && (h(), u());
      };
      return document.addEventListener("pointermove", v), () => document.removeEventListener("pointermove", v);
    }
  }, [l, c, a, u, h]), /* @__PURE__ */ d($Y, { ...e, ref: o });
}), [mSe, gSe] = U2(oh, { isInside: !1 }), vSe = /* @__PURE__ */ CCe("TooltipContent"), $Y = x.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": i,
      onEscapeKeyDown: o,
      onPointerDownOutside: a,
      ...s
    } = e, l = Ap(Rc, n), u = G2(n), { onClose: c } = l;
    return x.useEffect(() => (document.addEventListener(b7, c), () => document.removeEventListener(b7, c)), [c]), x.useEffect(() => {
      if (l.trigger) {
        const f = (h) => {
          const m = h.target;
          m != null && m.contains(l.trigger) && c();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [l.trigger, c]), /* @__PURE__ */ d(
      mY,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: o,
        onPointerDownOutside: a,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: c,
        children: /* @__PURE__ */ k(
          ZCe,
          {
            "data-state": l.stateAttribute,
            ...u,
            ...s,
            ref: t,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ d(vSe, { children: r }),
              /* @__PURE__ */ d(mSe, { scope: n, isInside: !0, children: /* @__PURE__ */ d(lSe, { id: l.contentId, role: "tooltip", children: i || r }) })
            ]
          }
        )
      }
    );
  }
);
IY.displayName = Rc;
var LY = "TooltipArrow", FY = x.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, i = G2(n);
    return gSe(
      LY,
      n
    ).isInside ? null : /* @__PURE__ */ d(XCe, { ...i, ...r, ref: t });
  }
);
FY.displayName = LY;
function ySe(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), o = Math.abs(t.left - e.x);
  switch (Math.min(n, r, i, o)) {
    case o:
      return "left";
    case i:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function bSe(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function xSe(e) {
  const { top: t, right: n, bottom: r, left: i } = e;
  return [
    { x: i, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: i, y: r }
  ];
}
function wSe(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let o = 0, a = t.length - 1; o < t.length; a = o++) {
    const s = t[o], l = t[a], u = s.x, c = s.y, f = l.x, h = l.y;
    c > r != h > r && n < (f - u) * (r - c) / (h - c) + u && (i = !i);
  }
  return i;
}
function CSe(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), SSe(t);
}
function SSe(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    for (; t.length >= 2; ) {
      const o = t[t.length - 1], a = t[t.length - 2];
      if ((o.x - a.x) * (i.y - a.y) >= (o.y - a.y) * (i.x - a.x)) t.pop();
      else break;
    }
    t.push(i);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r];
    for (; n.length >= 2; ) {
      const o = n[n.length - 1], a = n[n.length - 2];
      if ((o.x - a.x) * (i.y - a.y) >= (o.y - a.y) * (i.x - a.x)) n.pop();
      else break;
    }
    n.push(i);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var _Se = TY, ESe = MY, NSe = RY, ASe = DY, OSe = IY, kSe = FY;
function NS({
  delayDuration: e = 0,
  ...t
}) {
  return /* @__PURE__ */ d(
    _Se,
    {
      "data-slot": "tooltip-provider",
      delayDuration: e,
      ...t
    }
  );
}
function BY({
  ...e
}) {
  return /* @__PURE__ */ d(NS, { children: /* @__PURE__ */ d(ESe, { "data-slot": "tooltip", ...e }) });
}
function jY({
  ...e
}) {
  return /* @__PURE__ */ d(NSe, { "data-slot": "tooltip-trigger", ...e });
}
function VY({
  className: e,
  sideOffset: t = 4,
  children: n,
  ...r
}) {
  return /* @__PURE__ */ d(ASe, { children: /* @__PURE__ */ k(
    OSe,
    {
      "data-slot": "tooltip-content",
      sideOffset: t,
      className: z(
        "bg-popover text-popover-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-(--radix-tooltip-content-transform-origin) border-border text-bodysm z-50 max-w-[225px] overflow-hidden text-balance rounded-md px-3 py-1.5 shadow",
        e
      ),
      onPointerDownOutside: (i) => {
        i.preventDefault();
      },
      ...r,
      children: [
        n,
        /* @__PURE__ */ d(kSe, { className: "bg-popover fill-popover border-border z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]" })
      ]
    }
  ) });
}
function Dc({
  className: e,
  options: t,
  radioValue: n,
  setRadioValue: r
}) {
  return /* @__PURE__ */ d(
    Cp,
    {
      className: z("flex w-full flex-col", e),
      value: n,
      onValueChange: (i) => {
        r(i);
      },
      children: t.length > 0 && t.map((i) => /* @__PURE__ */ k(
        As,
        {
          className: z(
            "data-[state=unchecked]:border-interactiveBorder data-[state=unchecked]:bg-interfaceWhite data-[state=unchecked]:hover:border-interactiveBorderHover data-[state=unchecked]:hover:bg-interfaceBgDefault w-full rounded-sm border text-left data-[state=checked]:border-2",
            i.bgColor,
            i.borderColor,
            i.textColor
          ),
          onClick: () => {
            n === i.value && r("");
          },
          tabIndex: 1,
          value: i.value,
          children: [
            i.icon,
            i.text ? /* @__PURE__ */ d("p", { className: "mt-1 text-bodysm font-normal", children: i.text }) : null
          ]
        },
        i.value
      ))
    }
  );
}
function PSe({
  radioValue: e,
  setRadioValue: t
}) {
  return /* @__PURE__ */ k(
    Cp,
    {
      className: z(
        "flex w-full flex-col overflow-clip rounded border",
        e !== "" ? "border-actionBorder" : "border-interactiveBorder"
      ),
      value: e,
      onValueChange: (n) => {
        t(n);
      },
      "aria-label": "View density",
      children: [
        /* @__PURE__ */ d(
          As,
          {
            onClick: () => {
              e === "1" && t("");
            },
            className: "data-[state=checked]:border-actionBorder peer/1 data-[state=checked]:text-actionHover data-[state=checked]:bg-actionBgSelect data-[state=unchecked]:border-interactiveBorder data-[state=unchecked]:bg-interfaceWhite data-[state=unchecked]:hover:bg-interfaceBgDefault w-full border-t p-2 text-left first:border-t-0",
            value: "1",
            children: /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-x-2", children: [
              /* @__PURE__ */ d("div", { className: "text-[21px] font-normal", children: "😃" }),
              /* @__PURE__ */ k("div", { children: [
                /* @__PURE__ */ d("p", { className: "text-bodysm", children: "Mostly/all correct" }),
                /* @__PURE__ */ d(
                  "p",
                  {
                    className: z(
                      "text-bodysm font-normal",
                      e === "1" ? "text-actionHover" : "text-textSubdued"
                    ),
                    children: "Insignificant errors, if any"
                  }
                )
              ] })
            ] })
          }
        ),
        /* @__PURE__ */ d(
          As,
          {
            onClick: () => {
              e === "2" && t("");
            },
            className: "data-[state=checked]:border-actionBorder peer-data-[state=checked]/1:border-actionBorder peer/2 data-[state=checked]:text-actionHover data-[state=checked]:bg-actionBgSelect data-[state=unchecked]:border-interactiveBorder data-[state=unchecked]:bg-interfaceWhite data-[state=unchecked]:hover:bg-interfaceBgDefault w-full border-t p-2 text-left first:border-t-0",
            value: "2",
            children: /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-x-2", children: [
              /* @__PURE__ */ d("div", { className: "text-bodymd font-normal", children: "🙂" }),
              /* @__PURE__ */ k("div", { children: [
                /* @__PURE__ */ d("p", { className: "text-bodysm", children: "Partly correct" }),
                /* @__PURE__ */ d(
                  "p",
                  {
                    className: z(
                      "text-bodysm font-normal",
                      e === "2" ? "text-actionHover" : "text-textSubdued"
                    ),
                    children: "Correct outcome, but got there the wrong way"
                  }
                )
              ] })
            ] })
          }
        ),
        /* @__PURE__ */ d(
          As,
          {
            onClick: () => {
              e === "3" && t("");
            },
            className: "data-[state=checked]:border-actionBorder peer-data-[state=checked]/2:border-actionBorder peer/3 data-[state=checked]:text-actionHover data-[state=checked]:bg-actionBgSelect data-[state=unchecked]:border-interactiveBorder data-[state=unchecked]:bg-interfaceWhite data-[state=unchecked]:hover:bg-interfaceBgDefault w-full border-t p-2 text-left first:border-t-0",
            value: "3",
            children: /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-x-2", children: [
              /* @__PURE__ */ d("div", { className: "text-[21px] font-normal", children: "😕" }),
              /* @__PURE__ */ k("div", { children: [
                /* @__PURE__ */ d("p", { className: "text-bodysm", children: "Partly incorrect" }),
                /* @__PURE__ */ d(
                  "p",
                  {
                    className: z(
                      "text-bodysm font-normal",
                      e === "3" ? "text-actionHover" : "text-textSubdued"
                    ),
                    children: "Incorrect outcome, but some other correct reasoning"
                  }
                )
              ] })
            ] })
          }
        ),
        /* @__PURE__ */ d(
          As,
          {
            onClick: () => {
              e === "4" && t("");
            },
            className: "data-[state=checked]:border-actionBorder peer-data-[state=checked]/3:border-actionBorder peer/4 data-[state=checked]:text-actionHover data-[state=checked]:bg-actionBgSelect data-[state=unchecked]:border-interactiveBorder data-[state=unchecked]:bg-interfaceWhite data-[state=unchecked]:hover:bg-interfaceBgDefault w-full border-b border-t p-2 text-left first:border-t-0 last:border-b-0",
            value: "4",
            children: /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-x-2", children: [
              /* @__PURE__ */ d("div", { className: "text-bodymd font-normal", children: "☹️" }),
              /* @__PURE__ */ k("div", { children: [
                /* @__PURE__ */ d("p", { className: "text-bodysm", children: "Mostly incorrect" }),
                /* @__PURE__ */ d(
                  "p",
                  {
                    className: z(
                      "text-bodysm font-normal",
                      e === "4" ? "text-actionHover" : "text-textSubdued"
                    ),
                    children: "Major policy or reasoning issues that need resolution"
                  }
                )
              ] })
            ] })
          }
        )
      ]
    }
  );
}
const TSe = {
  [De.NoPermitRequired]: {
    text: "text-successHover",
    border: "!border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [De.MoreInformationRequired]: {
    text: "text-actionDefault",
    border: "!border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [De.RequiresPermit]: {
    text: "text-warningHover",
    border: "!border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  [De.Prohibited]: {
    text: "text-destructiveHover",
    border: "!border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  }
};
function yet({
  allowDraftWatermark: e = !0,
  configPrefix: t,
  conversation: n,
  noticeboardData: r,
  onClickAdjustReport: i
}) {
  const [o, a] = re({
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  }), [s, l] = re("assessment"), { getLocalisationEntry: u } = ar(n), c = u("councilOrdinanceLink"), f = su(
    n,
    r,
    t
  );
  Pe(() => {
    f && ["1", "2", "3", "4"].includes(f.toString()) ? a(TSe[f.toString()]) : a({
      text: "text-warningHover",
      border: "border-warningBorder",
      bgLight: "bg-warningBgLight",
      bgDark: "bg-warningBgDefault"
    });
  }, [f, n == null ? void 0 : n.phase]);
  const h = () => {
    let T = "";
    return n != null && n.created_at && (T = new Intl.DateTimeFormat("en-AU", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit"
    }).format(new Date(n.created_at))), T;
  }, m = () => {
    let T = "";
    return n != null && n.updated_at && (T = new Intl.DateTimeFormat("en-AU", {
      hour: "numeric",
      minute: "2-digit"
    }).format(new Date(n.updated_at))), T;
  }, v = jg(
    n,
    r,
    t
  ), g = Ow(
    n,
    r,
    t
  ), y = Pfe(
    n,
    r,
    t
  );
  Tfe(r);
  const w = ip(
    n,
    r,
    t
  ), C = () => /* @__PURE__ */ d("div", { children: Ge(g, { ordinanceLink: c }) }), S = () => {
    if (f)
      switch (f.toString()) {
        case De.NoPermitRequired:
          return /* @__PURE__ */ k("div", { children: [
            /* @__PURE__ */ d("p", { className: "text-textPrimary", children: "Based on your responses, it's likely you don't need to apply for a planning permit." }),
            /* @__PURE__ */ d("p", { className: "text-textPrimary", children: "However, you may still require a building permit. Building permits are issued separately from planning permits and are required to ensure construction work complies with national building regulations." }),
            /* @__PURE__ */ d(
              "a",
              {
                href: "https://www.yarraranges.vic.gov.au/Development/Building-advice/Do-I-need-a-building-permit",
                className: "text-blue-500 underline hover:text-blue-800",
                onClick: () => window.open(
                  "https://www.yarraranges.vic.gov.au/Development/Building-advice/Do-I-need-a-building-permit"
                ),
                tabIndex: 0,
                children: "Click here if you need a building permit"
              }
            )
          ] });
        case De.MoreInformationRequired:
          return /* @__PURE__ */ k("div", { children: [
            /* @__PURE__ */ d("p", { className: "text-textPrimary text-bodymd", children: "The application checklist tells you what documents you'll need to provide when you apply for a planning permit." }),
            /* @__PURE__ */ d("p", { className: "text-textPrimary mt-2 text-bodymd", children: "More information is needed to determine your personalised application checklist." }),
            /* @__PURE__ */ k("ul", { className: "mt-1 list-decimal pl-6", children: [
              /* @__PURE__ */ k("li", { className: "mb-1", children: [
                "Review the summary under",
                " ",
                /* @__PURE__ */ d(
                  "span",
                  {
                    className: "text-textLink cursor-pointer underline",
                    onClick: () => l("assessment"),
                    role: "button",
                    tabIndex: 0,
                    children: "Assessment"
                  }
                ),
                " ",
                "for any mention of further information required."
              ] }),
              /* @__PURE__ */ d("li", { className: "mb-1", children: "Gather the necessary information. You may need to consult a planning or building professional." }),
              /* @__PURE__ */ k("li", { className: "mb-1", children: [
                "Update these details by",
                " ",
                /* @__PURE__ */ d(
                  "span",
                  {
                    className: i ? "text-textLink cursor-pointer underline" : "",
                    onClick: i,
                    role: "button",
                    tabIndex: 0,
                    children: "adjusting your proposal"
                  }
                ),
                "."
              ] }),
              /* @__PURE__ */ d("li", { className: "mb-1", children: "Once completed, we'll determine if your proposal requires a planning permit or not, and if it does, generate an application checklist." })
            ] })
          ] });
        case De.RequiresPermit:
          return /* @__PURE__ */ k(xe, { children: [
            /* @__PURE__ */ d("p", { className: "text-textPrimary", children: "☝️ Use this checklist as a starting point only. Talk to a planner before preparing any reports or plans." }),
            /* @__PURE__ */ d(
              "div",
              {
                className: `mt-6 mb-7 h-px w-full border-t ${o.border}`
              }
            ),
            Ge(y, {
              ordinanceLink: c
            })
          ] });
        case De.Prohibited:
          return /* @__PURE__ */ k(xe, { children: [
            /* @__PURE__ */ d("p", { className: "text-textPrimary", children: "Based on your responses, it's likely your plans are prohibited. We don't recommend applying for a planning permit because it's unlikely Council will support your proposal." }),
            /* @__PURE__ */ k("p", { className: "text-textPrimary", children: [
              "If you have questions about your result,",
              " ",
              /* @__PURE__ */ d(
                "a",
                {
                  className: "text-blue-500 underline hover:text-blue-800",
                  href: "mailto:mail@yarraranges.vic.gov.au",
                  children: "contact Yarra Ranges Council"
                }
              ),
              " ",
              "to talk to one of our planners."
            ] })
          ] });
      }
  }, N = () => null, E = () => /* @__PURE__ */ k("div", { className: "", children: [
    /* @__PURE__ */ d(Nt, { children: Ge(v, { ordinanceLink: c }) }),
    N()
  ] }), A = () => w, O = () => /* @__PURE__ */ k(
    "div",
    {
      className: `content-start justify-start rounded-t-md border-x border-t ${o.border} ${o.bgLight} p-5 md:px-10 md:pt-8 md:pb-6`,
      children: [
        /* @__PURE__ */ d("div", { className: "mb-2 inline-flex", children: /* @__PURE__ */ d("div", { className: "", children: /* @__PURE__ */ d(
          "h2",
          {
            className: `text-headinglg font-semibold ${o.text}`,
            children: A()
          }
        ) }) }),
        /* @__PURE__ */ k("p", { className: "mb-2 text-bodysm", children: [
          "Generated at ",
          m(),
          " on ",
          h(),
          " using planning legislation accessed on 31/03/24"
        ] })
      ]
    }
  );
  return /* @__PURE__ */ d("div", { "data-testid": "assessment-report", children: /* @__PURE__ */ k("div", { className: "relative", children: [
    e && ["ready_for_assessment", "report_ready", "amendment"].includes(
      (n == null ? void 0 : n.phase) || ""
    ) ? /* @__PURE__ */ d(i3e, {}) : null,
    /* @__PURE__ */ d("div", { children: O() }),
    /* @__PURE__ */ d(
      "div",
      {
        className: `${o.border} border-interactiveBorder flex flex-col ${o.bgLight}`,
        children: /* @__PURE__ */ k(
          Ea,
          {
            className: `${o.border} w-full overflow-hidden rounded-b-lg border-x border-b`,
            onValueChange: (T) => l(T),
            value: s,
            children: [
              /* @__PURE__ */ k(
                Ro,
                {
                  className: `!flex w-full items-end justify-start ${o.border}`,
                  children: [
                    /* @__PURE__ */ d(
                      "div",
                      {
                        className: `w-5 self-end border-b md:w-10 ${o.border}`
                      }
                    ),
                    /* @__PURE__ */ d(
                      jn,
                      {
                        type: void 0,
                        value: "assessment",
                        className: `!rounded-tl !border !border-r-0 data-[state=active]:!border-r-0 ${o.bgDark} data-[state=active]:bg-interfaceWhite ${o.border} data-[state=active]:${o.border} text-textPrimary data-[state=active]:!border-b-interfaceWhite border-b px-4 py-2 text-bodylg font-semibold focus:outline-hidden data-[state=active]:border`,
                        children: "Assessment"
                      }
                    ),
                    /* @__PURE__ */ d(
                      jn,
                      {
                        type: void 0,
                        value: "easy-read",
                        className: `!rounded-tr-sm !border data-[state=active]:!border-l-0 ${o.bgDark} data-[state=active]:bg-interfaceWhite ${o.border} data-[state=active]:${o.border} text-textPrimary data-[state=active]:!border-b-interfaceWhite border-b px-4 py-2 text-bodylg font-semibold focus:outline-hidden data-[state=active]:border`,
                        children: "Easy read"
                      }
                    ),
                    /* @__PURE__ */ d(
                      "div",
                      {
                        className: `flex-1 self-end border-b ${o.border}`
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ k("div", { className: "bg-interfaceWhite px-5 py-4 md:px-10 md:py-8", children: [
                /* @__PURE__ */ d(Mn, { value: "assessment", className: "", children: E() }),
                /* @__PURE__ */ d(Mn, { value: "easy-read", className: "", children: /* @__PURE__ */ d("div", { children: C() }) }),
                /* @__PURE__ */ d(Mn, { value: "application", className: "", children: /* @__PURE__ */ d("div", { children: S() }) })
              ] })
            ]
          }
        )
      }
    )
  ] }) });
}
function lP({
  configPrefix: e,
  conversation: t,
  noticeboardData: n,
  ordinanceLink: r
}) {
  const i = kw(
    t,
    n,
    e
  );
  return /* @__PURE__ */ k(xe, { children: [
    /* @__PURE__ */ d("h3", { className: "text-headingmd text-textPrimary mb-1", children: "Required documents and information" }),
    /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued mb-5", children: "If your proposal requires a planning permit and isn't eligible for VicSmart, use this list to check off what you'll need to provide when you apply." }),
    /* @__PURE__ */ d(Nt, { children: Ge(i, {
      ordinanceLink: r
    }) })
  ] });
}
function uP({
  configPrefix: e,
  conversation: t,
  noticeboardData: n,
  ordinanceLink: r
}) {
  const i = Pw(
    t,
    n,
    e
  ), o = Tw(
    t,
    n,
    e
  ), a = i === void 0 || !o;
  return /* @__PURE__ */ k(xe, { children: [
    /* @__PURE__ */ d("h3", { className: "text-headingmd text-textPrimary mb-1", children: "VicSmart eligibility" }),
    /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued mb-5", children: "VicSmart is a faster approval process for straightforward planning applications. If your proposal requires a planning permit and meets certain criteria, you may be able to apply with VicSmart." }),
    a ? /* @__PURE__ */ k("div", { className: "mb-2 flex items-center gap-1", children: [
      /* @__PURE__ */ d(Xo, { className: "min-h-5 min-w-5 animate-spin" }),
      /* @__PURE__ */ d("span", { className: "text-bodymd text-textPrimary", children: "Assessing VicSmart eligibility" })
    ] }) : null,
    a ? null : /* @__PURE__ */ d("div", { className: "mb-2", children: /* @__PURE__ */ d(Mw, { eligibility: i }) }),
    !a && i === Vo.eligible ? /* @__PURE__ */ d(Nt, { children: Ge(o, {
      ordinanceLink: r
    }) }) : null,
    !a && i !== Vo.eligible ? /* @__PURE__ */ d("p", { className: "text-bodymd text-textPrimary", children: "Your proposal is likely ineligible for VicSmart because it doesn't meet the criteria, or you've triggered a planning requirement that has no associated VicSmart approval pathway." }) : null
  ] });
}
function qY({
  conversation: e
}) {
  const { getLocalisationEntry: t } = ar(e), n = t("councilContactLink");
  return /* @__PURE__ */ k("div", { className: "rounded border border-interfaceBorder bg-interfaceBgLight text-bodymd text-textPrimary px-6 py-5", children: [
    /* @__PURE__ */ d("h3", { className: "text-headingmd mb-1", children: "✨ This service uses AI to analyse proposals" }),
    /* @__PURE__ */ d("p", { className: "mb-2", children: "It can sometimes make mistakes. It also doesn't account for a few things, such as:" }),
    /* @__PURE__ */ k("ul", { className: "list-disc list-inside pl-2 mb-2", children: [
      /* @__PURE__ */ d("li", { children: "overlays only applying to part of a property" }),
      /* @__PURE__ */ k("li", { children: [
        "covenants, 173 agreements and other restrictions found on a",
        " ",
        /* @__PURE__ */ d(
          "a",
          {
            className: "text-textLink hover:text-textLinkHover inline-flex cursor-pointer underline",
            href: "https://www.land.vic.gov.au/land-registration/for-individuals/property-and-land-titles-information",
            rel: "noreferrer",
            tabIndex: 0,
            target: "_blank",
            children: "Certificate of Title"
          }
        )
      ] }),
      /* @__PURE__ */ d("li", { children: "factors introduced by past planning approvals or existing permit applications" }),
      /* @__PURE__ */ d("li", { children: "other approvals that may be required, such as building and asset protection permits." })
    ] }),
    /* @__PURE__ */ k("p", { children: [
      "This list is not exhaustive. The information provided by this service is intended as a helpful guide and is not a final planning decision.",
      " ",
      /* @__PURE__ */ d(
        "a",
        {
          className: "text-textLink hover:text-textLinkHover inline-flex cursor-pointer underline",
          href: n,
          rel: "noreferrer",
          tabIndex: 0,
          target: "_blank",
          children: "Contact council"
        }
      ),
      " ",
      "to talk to a planner if you're unsure about anything."
    ] })
  ] });
}
const MSe = {
  [De.NoPermitRequired]: {
    text: "text-successHover",
    border: "!border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [De.MoreInformationRequired]: {
    text: "text-actionDefault",
    border: "!border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [De.RequiresPermit]: {
    text: "text-warningHover",
    border: "!border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  [De.Prohibited]: {
    text: "text-destructiveHover",
    border: "!border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  }
};
function bet({
  configPrefix: e,
  conversation: t,
  noticeboardData: n
}) {
  const [r, i] = re({
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  }), { getLocalisationEntry: o } = ar(t), a = o("councilOrdinanceLink"), s = su(
    t,
    n,
    e
  );
  Pe(() => {
    s && ["1", "2", "3", "4"].includes(s.toString()) ? i(MSe[s.toString()]) : i({
      text: "text-warningHover",
      border: "border-warningBorder",
      bgLight: "bg-warningBgLight",
      bgDark: "bg-warningBgDefault"
    });
  }, [s, t == null ? void 0 : t.phase]);
  const l = () => {
    let v = "";
    return t != null && t.created_at && (v = new Intl.DateTimeFormat("en-AU", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit"
    }).format(new Date(t.created_at))), v;
  }, u = () => {
    let v = "";
    return t != null && t.updated_at && (v = new Intl.DateTimeFormat("en-AU", {
      hour: "numeric",
      minute: "2-digit"
    }).format(new Date(t.updated_at))), v;
  }, c = jg(
    t,
    n,
    e
  ), f = () => {
    switch (s) {
      case De.NoPermitRequired:
        return /* @__PURE__ */ k(xe, { children: [
          /* @__PURE__ */ d("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Permit triggers" }),
          /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued mb-5", children: "Why your proposal likely doesn't require a planning permit." }),
          /* @__PURE__ */ k(Ea, { defaultValue: "summary", children: [
            /* @__PURE__ */ k(Ro, { className: "pb-3", children: [
              /* @__PURE__ */ k(
                jn,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2",
                  value: "summary",
                  children: [
                    /* @__PURE__ */ d(Nl, {}),
                    " Full assessment"
                  ]
                }
              ),
              /* @__PURE__ */ k(
                jn,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2",
                  value: "easy-read",
                  children: [
                    /* @__PURE__ */ d(Al, {}),
                    " Easy read"
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ d(Mn, { value: "summary", children: /* @__PURE__ */ d(Nt, { maxHeight: 300, children: Ge(c, { ordinanceLink: a }) }) }),
            /* @__PURE__ */ d(Mn, { value: "easy-read", className: "", children: /* @__PURE__ */ d("div", { children: m() }) })
          ] })
        ] });
      case De.MoreInformationRequired:
        return /* @__PURE__ */ k(xe, { children: [
          /* @__PURE__ */ d("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Permit triggers" }),
          /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued mb-5", children: "Why your proposal may or may not need a planning permit." }),
          /* @__PURE__ */ k(Ea, { defaultValue: "summary", children: [
            /* @__PURE__ */ k(Ro, { className: "w-full items-stretch pb-3", children: [
              /* @__PURE__ */ k(
                jn,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2",
                  value: "summary",
                  children: [
                    /* @__PURE__ */ d(Nl, {}),
                    " Full assessment"
                  ]
                }
              ),
              /* @__PURE__ */ k(
                jn,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2",
                  value: "easy-read",
                  children: [
                    /* @__PURE__ */ d(Al, {}),
                    " Easy read"
                  ]
                }
              ),
              /* @__PURE__ */ d("div", { className: "w-full border-b" })
            ] }),
            /* @__PURE__ */ d(Mn, { value: "summary", children: /* @__PURE__ */ d(Nt, { maxHeight: 300, children: Ge(c, { ordinanceLink: a }) }) }),
            /* @__PURE__ */ d(Mn, { value: "easy-read", className: "", children: /* @__PURE__ */ d("div", { children: m() }) })
          ] }),
          /* @__PURE__ */ d("div", { className: z("my-6 w-full border-b", r.border) }),
          /* @__PURE__ */ d("h2", { className: "text-headinglg text-textPrimary mb-5", children: "Application requirements" }),
          /* @__PURE__ */ d(
            uP,
            {
              configPrefix: e,
              conversation: t,
              noticeboardData: n,
              ordinanceLink: a
            }
          ),
          /* @__PURE__ */ d("div", { className: "mt-4", children: /* @__PURE__ */ d(
            lP,
            {
              configPrefix: e,
              conversation: t,
              noticeboardData: n,
              ordinanceLink: a
            }
          ) })
        ] });
      case De.RequiresPermit:
        return /* @__PURE__ */ k(xe, { children: [
          /* @__PURE__ */ d("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Permit triggers" }),
          /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued mb-5", children: "Why it's likely your proposal requires a planning permit." }),
          /* @__PURE__ */ k(Ea, { defaultValue: "summary", children: [
            /* @__PURE__ */ k(Ro, { className: "w-full items-stretch pb-3", children: [
              /* @__PURE__ */ k(
                jn,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2",
                  value: "summary",
                  children: [
                    /* @__PURE__ */ d(Nl, {}),
                    " Full assessment"
                  ]
                }
              ),
              /* @__PURE__ */ k(
                jn,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2",
                  value: "easy-read",
                  children: [
                    /* @__PURE__ */ d(Al, {}),
                    " Easy read"
                  ]
                }
              ),
              /* @__PURE__ */ d("div", { className: "w-full border-b" })
            ] }),
            /* @__PURE__ */ d(Mn, { value: "summary", children: /* @__PURE__ */ d(Nt, { maxHeight: 300, children: Ge(c, { ordinanceLink: a }) }) }),
            /* @__PURE__ */ d(Mn, { value: "easy-read", className: "", children: /* @__PURE__ */ d("div", { children: m() }) })
          ] }),
          /* @__PURE__ */ d("div", { className: z("my-6 w-full border-b", r.border) }),
          /* @__PURE__ */ d("h2", { className: "text-headinglg text-textPrimary mb-5", children: "Application requirements" }),
          /* @__PURE__ */ d(
            uP,
            {
              configPrefix: e,
              conversation: t,
              noticeboardData: n,
              ordinanceLink: a
            }
          ),
          /* @__PURE__ */ d("div", { className: "mt-4", children: /* @__PURE__ */ d(
            lP,
            {
              configPrefix: e,
              conversation: t,
              noticeboardData: n,
              ordinanceLink: a
            }
          ) })
        ] });
      case De.Prohibited:
        return /* @__PURE__ */ k(xe, { children: [
          /* @__PURE__ */ d("h2", { className: "text-headinglg text-textPrimary", children: "Why your proposal is likely prohibited" }),
          /* @__PURE__ */ d(Nt, { maxHeight: 300, children: Ge(c, { ordinanceLink: a }) })
        ] });
    }
  }, h = Ow(
    t,
    n,
    e
  ), m = () => /* @__PURE__ */ d("div", { children: Ge(h, { ordinanceLink: a }) });
  return /* @__PURE__ */ k("div", { "data-testid": "assessment-report", children: [
    /* @__PURE__ */ k(
      "div",
      {
        className: z(
          "content-start justify-start rounded-t-lg border-x border-t p-5 md:px-10 md:pt-8 md:pb-6",
          r.border,
          r.bgLight
        ),
        children: [
          /* @__PURE__ */ d("div", { className: "mb-2 inline-flex", children: /* @__PURE__ */ d(
            "h2",
            {
              className: `text-headingxl font-semibold ${r.text}`,
              children: ip(t, n, e)
            }
          ) }),
          /* @__PURE__ */ k("p", { className: "text-bodysm mb-2", children: [
            "Generated at ",
            u(),
            " on ",
            l()
          ] })
        ]
      }
    ),
    /* @__PURE__ */ k(
      "div",
      {
        className: z(
          "border-interactiveBorder bg-interfaceWhite flex flex-col rounded-b-lg border px-5 py-4 md:px-10 md:py-8",
          r.border
        ),
        children: [
          f(),
          /* @__PURE__ */ d("div", { className: z("my-6 w-full border-b", r.border) }),
          /* @__PURE__ */ d(qY, { conversation: t })
        ]
      }
    )
  ] });
}
function w7({
  title: e,
  content: t
}) {
  const [n, r] = re(!1);
  return /* @__PURE__ */ d(
    zo,
    {
      type: "single",
      value: n ? "application_requirements" : "",
      children: /* @__PURE__ */ k(
        lo,
        {
          className: "border border-interactiveBorder rounded p-1",
          value: "application_requirements",
          children: [
            /* @__PURE__ */ d(
              uo,
              {
                className: "text-headingmd px-2 py-1",
                onClick: () => r((i) => !i),
                children: e
              }
            ),
            /* @__PURE__ */ d(co, { className: "px-2", children: t })
          ]
        }
      )
    }
  );
}
function cP({
  assessmentLights: e,
  configPrefix: t,
  conversation: n,
  noticeboardData: r,
  ordinanceLink: i
}) {
  const o = Pw(
    n,
    r,
    t
  ), a = Tw(
    n,
    r,
    t
  ), s = Mfe(
    n,
    r,
    t
  ), l = o === void 0 || !a;
  return /* @__PURE__ */ k(xe, { children: [
    /* @__PURE__ */ d("h2", { className: "text-headinglg text-textPrimary mb-1", children: "VicSmart eligibility" }),
    /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued mb-5", children: "VicSmart is a faster approval process for straightforward planning applications. If your proposal requires a planning permit and meets certain criteria, you may be able to apply with VicSmart." }),
    l ? /* @__PURE__ */ k("div", { className: "mb-2 flex items-center gap-1", children: [
      /* @__PURE__ */ d(Xo, { className: "min-h-5 min-w-5 animate-spin" }),
      /* @__PURE__ */ d("span", { className: "text-bodymd text-textPrimary", children: "Assessing VicSmart eligibility" })
    ] }) : null,
    l ? null : /* @__PURE__ */ d("div", { className: "mb-2", children: /* @__PURE__ */ d(Mw, { eligibility: o }) }),
    !l && o === Vo.eligible ? /* @__PURE__ */ k(xe, { children: [
      /* @__PURE__ */ d(Nt, { children: Ge(a, {
        ordinanceLink: i
      }) }),
      s ? /* @__PURE__ */ d("div", { className: "mt-4", children: /* @__PURE__ */ d(
        w7,
        {
          title: "Preparing your VicSmart application",
          content: /* @__PURE__ */ k(xe, { children: [
            e === De.MoreInformationRequired ? /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued", children: "If you've determined your proposal requires a planning permit and that it's eligible for VicSmart, use this checklist as a starting point for what information is likely required in your application." }) : null,
            e === De.RequiresPermit ? /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued", children: "If you've determined your proposal is eligible for VicSmart and you're ready to apply, use this checklist as a starting point for what information is likely required when you apply." }) : null,
            /* @__PURE__ */ d(eu, { className: "border-interactiveBorder my-3" }),
            /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued", children: Ge(s, {
              ordinanceLink: i
            }) })
          ] })
        }
      ) }) : null
    ] }) : null,
    !l && o !== Vo.eligible ? /* @__PURE__ */ d("p", { className: "text-bodymd text-textPrimary", children: "Your proposal is likely ineligible for VicSmart because it doesn't meet the criteria, or you've triggered a planning requirement that has no associated VicSmart approval pathway." }) : null
  ] });
}
const RSe = {
  [De.NoPermitRequired]: {
    text: "text-successHover",
    border: "!border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [De.MoreInformationRequired]: {
    text: "text-actionDefault",
    border: "!border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [De.RequiresPermit]: {
    text: "text-warningHover",
    border: "!border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  [De.Prohibited]: {
    text: "text-destructiveHover",
    border: "!border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  }
};
function xet({
  configPrefix: e,
  conversation: t,
  noticeboardData: n
}) {
  const [r, i] = re({
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  }), { getLocalisationEntry: o } = ar(t), a = o("councilOrdinanceLink"), s = su(
    t,
    n,
    e
  );
  Pe(() => {
    s && ["1", "2", "3", "4"].includes(s.toString()) ? i(RSe[s.toString()]) : i({
      text: "text-warningHover",
      border: "border-warningBorder",
      bgLight: "bg-warningBgLight",
      bgDark: "bg-warningBgDefault"
    });
  }, [s, t == null ? void 0 : t.phase]);
  const l = () => {
    let y = "";
    return t != null && t.created_at && (y = new Intl.DateTimeFormat("en-AU", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit"
    }).format(new Date(t.created_at))), y;
  }, u = () => {
    let y = "";
    return t != null && t.updated_at && (y = new Intl.DateTimeFormat("en-AU", {
      hour: "numeric",
      minute: "2-digit"
    }).format(new Date(t.updated_at))), y;
  }, c = kw(
    t,
    n,
    e
  ), f = Aw(
    t,
    n,
    e
  ), h = Nw(
    t,
    n,
    e
  ), m = jg(
    t,
    n,
    e
  ), v = lB(), g = () => {
    switch (s) {
      case De.NoPermitRequired:
        return /* @__PURE__ */ k(xe, { children: [
          /* @__PURE__ */ d("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Permit triggers" }),
          /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued mb-5", children: "Why your proposal likely doesn't require a planning permit." }),
          /* @__PURE__ */ d(Nt, { maxHeight: 300, children: Ge(m, { ordinanceLink: a }) }),
          f && h ? /* @__PURE__ */ k(xe, { children: [
            /* @__PURE__ */ d(
              "div",
              {
                className: z("my-6 w-full border-b", r.border)
              }
            ),
            /* @__PURE__ */ d("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Mandatory requirements" }),
            /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued mb-5", children: "Even though your proposal likely doesn't require a planning permit, it still likely needs to meet the following requirements for it to be permissible." }),
            /* @__PURE__ */ d(Nt, { children: Ge(h, {
              ordinanceLink: a
            }) })
          ] }) : null
        ] });
      case De.MoreInformationRequired:
        return /* @__PURE__ */ k(xe, { children: [
          /* @__PURE__ */ d("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Permit triggers" }),
          /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued mb-5", children: "Why your proposal may or may not need a planning permit." }),
          /* @__PURE__ */ d(Nt, { maxHeight: 300, children: Ge(m, { ordinanceLink: a }) }),
          c ? /* @__PURE__ */ d("div", { className: "mt-4", children: /* @__PURE__ */ d(
            w7,
            {
              title: "Preparing your planning permit application",
              content: /* @__PURE__ */ k(xe, { children: [
                /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued", children: "If you've determined your proposal requires a planning permit and you're ready to apply, use this checklist as a starting point for what information is likely required as part of your application." }),
                /* @__PURE__ */ d(eu, { className: "border-interactiveBorder my-3" }),
                /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued", children: Ge(c, {
                  ordinanceLink: a
                }) })
              ] })
            }
          ) }) : null,
          f && h ? /* @__PURE__ */ k(xe, { children: [
            /* @__PURE__ */ d(
              "div",
              {
                className: z("my-6 w-full border-b", r.border)
              }
            ),
            /* @__PURE__ */ d("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Mandatory requirements" }),
            /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued mb-5", children: "Regardless of whether your proposal requires a planning permit or not, it will also likely need to meet the following requirements for it to be permissible." }),
            /* @__PURE__ */ d(Nt, { children: Ge(h, {
              ordinanceLink: a
            }) })
          ] }) : null,
          v ? /* @__PURE__ */ k(xe, { children: [
            /* @__PURE__ */ d(
              "div",
              {
                className: z("my-6 w-full border-b", r.border)
              }
            ),
            /* @__PURE__ */ d(
              cP,
              {
                assessmentLights: s,
                configPrefix: e,
                conversation: t,
                noticeboardData: n,
                ordinanceLink: a
              }
            )
          ] }) : null
        ] });
      case De.RequiresPermit:
        return /* @__PURE__ */ k(xe, { children: [
          /* @__PURE__ */ d("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Permit triggers" }),
          /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued mb-5", children: "Why it's likely your proposal requires a planning permit." }),
          /* @__PURE__ */ d(Nt, { maxHeight: 300, children: Ge(m, { ordinanceLink: a }) }),
          c ? /* @__PURE__ */ d("div", { className: "mt-4", children: /* @__PURE__ */ d(
            w7,
            {
              title: "Preparing your planning permit application",
              content: /* @__PURE__ */ k(xe, { children: [
                /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued", children: "If you're ready to apply for a planning permit, use this checklist as a starting point for what information is likely required as part of your application." }),
                /* @__PURE__ */ d(eu, { className: "border-interactiveBorder my-3" }),
                /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued", children: Ge(c, {
                  ordinanceLink: a
                }) })
              ] })
            }
          ) }) : null,
          f && h ? /* @__PURE__ */ k(xe, { children: [
            /* @__PURE__ */ d(
              "div",
              {
                className: z("my-6 w-full border-b", r.border)
              }
            ),
            /* @__PURE__ */ d("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Mandatory requirements" }),
            /* @__PURE__ */ d("p", { className: "text-bodymd text-textSubdued mb-5", children: "Regardless of whether your proposal requires a planning permit or not, it will also likely need to meet the following requirements for it to be permissible." }),
            /* @__PURE__ */ d(Nt, { children: Ge(h, {
              ordinanceLink: a
            }) })
          ] }) : null,
          v ? /* @__PURE__ */ k(xe, { children: [
            /* @__PURE__ */ d(
              "div",
              {
                className: z("my-6 w-full border-b", r.border)
              }
            ),
            /* @__PURE__ */ d(
              cP,
              {
                assessmentLights: s,
                configPrefix: e,
                conversation: t,
                noticeboardData: n,
                ordinanceLink: a
              }
            )
          ] }) : null
        ] });
      case De.Prohibited:
        return /* @__PURE__ */ k(xe, { children: [
          /* @__PURE__ */ d("h2", { className: "text-headinglg text-textPrimary", children: "Why your proposal is likely prohibited" }),
          /* @__PURE__ */ d(Nt, { maxHeight: 300, children: Ge(m, { ordinanceLink: a }) })
        ] });
    }
  };
  return /* @__PURE__ */ k("div", { "data-testid": "assessment-report", children: [
    /* @__PURE__ */ k(
      "div",
      {
        className: z(
          "content-start justify-start rounded-t-lg border-x border-t p-5 md:px-10 md:pt-8 md:pb-6",
          r.border,
          r.bgLight
        ),
        children: [
          /* @__PURE__ */ d("div", { className: "mb-2 inline-flex", children: /* @__PURE__ */ d(
            "h2",
            {
              className: `text-headinglg font-semibold ${r.text}`,
              children: ip(t, n, e)
            }
          ) }),
          /* @__PURE__ */ k("p", { className: "text-bodysm mb-2", children: [
            "Generated at ",
            u(),
            " on ",
            l()
          ] })
        ]
      }
    ),
    /* @__PURE__ */ k(
      "div",
      {
        className: z(
          "border-interactiveBorder bg-interfaceWhite flex flex-col rounded-b-lg border px-5 py-4 md:px-10 md:py-8",
          r.border
        ),
        children: [
          g(),
          /* @__PURE__ */ d("div", { className: z("my-6 w-full border-b", r.border) }),
          /* @__PURE__ */ d(qY, { conversation: t })
        ]
      }
    )
  ] });
}
function wet() {
  return /* @__PURE__ */ k("div", { className: "rounded-lg border border-interfaceBorder bg-interfaceWhite flex flex-col", children: [
    /* @__PURE__ */ d("div", { className: "rounded-t-lg bg-interfaceBgLight border-b border-interfaceBorder flex items-center justify-center px-10 py-8", children: /* @__PURE__ */ d("h2", { className: "text-headingxl font-semibold text-textSubdued", children: "A report hasn't been generated for this conversation yet." }) }),
    /* @__PURE__ */ d("div", { className: "rounded-b-lg bg-interfaceWhite flex items-center justify-center px-10 py-8", children: /* @__PURE__ */ d("p", { className: "text-bodylg font-normal text-textSubdued", children: "A report is generated after the customer has answered all the questions in the chat. Once the customer has done this, allow 2–3 minutes for myLot to generate the report." }) })
  ] });
}
function rn({
  chartType: e,
  children: t,
  council: n,
  groupType: r,
  from: i,
  to: o,
  includeInternalUsers: a
}) {
  const { data: s, isLoading: l } = Fue({
    body: {
      council_code: n,
      chart_type: e,
      group_type: r,
      from_date: i,
      to_date: o,
      include_internal_users: a
    }
  });
  return t({
    data: s == null ? void 0 : s.data,
    isLoading: l
  });
}
var w3, dP;
function ei() {
  if (dP) return w3;
  dP = 1;
  var e = Array.isArray;
  return w3 = e, w3;
}
var C3, fP;
function zY() {
  if (fP) return C3;
  fP = 1;
  var e = typeof Es == "object" && Es && Es.Object === Object && Es;
  return C3 = e, C3;
}
var S3, hP;
function ta() {
  if (hP) return S3;
  hP = 1;
  var e = zY(), t = typeof self == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
  return S3 = n, S3;
}
var _3, pP;
function Op() {
  if (pP) return _3;
  pP = 1;
  var e = ta(), t = e.Symbol;
  return _3 = t, _3;
}
var E3, mP;
function DSe() {
  if (mP) return E3;
  mP = 1;
  var e = Op(), t = Object.prototype, n = t.hasOwnProperty, r = t.toString, i = e ? e.toStringTag : void 0;
  function o(a) {
    var s = n.call(a, i), l = a[i];
    try {
      a[i] = void 0;
      var u = !0;
    } catch {
    }
    var c = r.call(a);
    return u && (s ? a[i] = l : delete a[i]), c;
  }
  return E3 = o, E3;
}
var N3, gP;
function ISe() {
  if (gP) return N3;
  gP = 1;
  var e = Object.prototype, t = e.toString;
  function n(r) {
    return t.call(r);
  }
  return N3 = n, N3;
}
var A3, vP;
function Za() {
  if (vP) return A3;
  vP = 1;
  var e = Op(), t = DSe(), n = ISe(), r = "[object Null]", i = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function a(s) {
    return s == null ? s === void 0 ? i : r : o && o in Object(s) ? t(s) : n(s);
  }
  return A3 = a, A3;
}
var O3, yP;
function Xa() {
  if (yP) return O3;
  yP = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return O3 = e, O3;
}
var k3, bP;
function Pd() {
  if (bP) return k3;
  bP = 1;
  var e = Za(), t = Xa(), n = "[object Symbol]";
  function r(i) {
    return typeof i == "symbol" || t(i) && e(i) == n;
  }
  return k3 = r, k3;
}
var P3, xP;
function AS() {
  if (xP) return P3;
  xP = 1;
  var e = ei(), t = Pd(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function i(o, a) {
    if (e(o))
      return !1;
    var s = typeof o;
    return s == "number" || s == "symbol" || s == "boolean" || o == null || t(o) ? !0 : r.test(o) || !n.test(o) || a != null && o in Object(a);
  }
  return P3 = i, P3;
}
var T3, wP;
function el() {
  if (wP) return T3;
  wP = 1;
  function e(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  return T3 = e, T3;
}
var M3, CP;
function OS() {
  if (CP) return M3;
  CP = 1;
  var e = Za(), t = el(), n = "[object AsyncFunction]", r = "[object Function]", i = "[object GeneratorFunction]", o = "[object Proxy]";
  function a(s) {
    if (!t(s))
      return !1;
    var l = e(s);
    return l == r || l == i || l == n || l == o;
  }
  return M3 = a, M3;
}
var R3, SP;
function $Se() {
  if (SP) return R3;
  SP = 1;
  var e = ta(), t = e["__core-js_shared__"];
  return R3 = t, R3;
}
var D3, _P;
function LSe() {
  if (_P) return D3;
  _P = 1;
  var e = $Se(), t = function() {
    var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function n(r) {
    return !!t && t in r;
  }
  return D3 = n, D3;
}
var I3, EP;
function WY() {
  if (EP) return I3;
  EP = 1;
  var e = Function.prototype, t = e.toString;
  function n(r) {
    if (r != null) {
      try {
        return t.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return I3 = n, I3;
}
var $3, NP;
function FSe() {
  if (NP) return $3;
  NP = 1;
  var e = OS(), t = LSe(), n = el(), r = WY(), i = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, a = Function.prototype, s = Object.prototype, l = a.toString, u = s.hasOwnProperty, c = RegExp(
    "^" + l.call(u).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!n(h) || t(h))
      return !1;
    var m = e(h) ? c : o;
    return m.test(r(h));
  }
  return $3 = f, $3;
}
var L3, AP;
function BSe() {
  if (AP) return L3;
  AP = 1;
  function e(t, n) {
    return t == null ? void 0 : t[n];
  }
  return L3 = e, L3;
}
var F3, OP;
function hu() {
  if (OP) return F3;
  OP = 1;
  var e = FSe(), t = BSe();
  function n(r, i) {
    var o = t(r, i);
    return e(o) ? o : void 0;
  }
  return F3 = n, F3;
}
var B3, kP;
function K2() {
  if (kP) return B3;
  kP = 1;
  var e = hu(), t = e(Object, "create");
  return B3 = t, B3;
}
var j3, PP;
function jSe() {
  if (PP) return j3;
  PP = 1;
  var e = K2();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return j3 = t, j3;
}
var V3, TP;
function VSe() {
  if (TP) return V3;
  TP = 1;
  function e(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  return V3 = e, V3;
}
var q3, MP;
function qSe() {
  if (MP) return q3;
  MP = 1;
  var e = K2(), t = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function i(o) {
    var a = this.__data__;
    if (e) {
      var s = a[o];
      return s === t ? void 0 : s;
    }
    return r.call(a, o) ? a[o] : void 0;
  }
  return q3 = i, q3;
}
var z3, RP;
function zSe() {
  if (RP) return z3;
  RP = 1;
  var e = K2(), t = Object.prototype, n = t.hasOwnProperty;
  function r(i) {
    var o = this.__data__;
    return e ? o[i] !== void 0 : n.call(o, i);
  }
  return z3 = r, z3;
}
var W3, DP;
function WSe() {
  if (DP) return W3;
  DP = 1;
  var e = K2(), t = "__lodash_hash_undefined__";
  function n(r, i) {
    var o = this.__data__;
    return this.size += this.has(r) ? 0 : 1, o[r] = e && i === void 0 ? t : i, this;
  }
  return W3 = n, W3;
}
var H3, IP;
function HSe() {
  if (IP) return H3;
  IP = 1;
  var e = jSe(), t = VSe(), n = qSe(), r = zSe(), i = WSe();
  function o(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = n, o.prototype.has = r, o.prototype.set = i, H3 = o, H3;
}
var U3, $P;
function USe() {
  if ($P) return U3;
  $P = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return U3 = e, U3;
}
var G3, LP;
function kS() {
  if (LP) return G3;
  LP = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return G3 = e, G3;
}
var K3, FP;
function Y2() {
  if (FP) return K3;
  FP = 1;
  var e = kS();
  function t(n, r) {
    for (var i = n.length; i--; )
      if (e(n[i][0], r))
        return i;
    return -1;
  }
  return K3 = t, K3;
}
var Y3, BP;
function GSe() {
  if (BP) return Y3;
  BP = 1;
  var e = Y2(), t = Array.prototype, n = t.splice;
  function r(i) {
    var o = this.__data__, a = e(o, i);
    if (a < 0)
      return !1;
    var s = o.length - 1;
    return a == s ? o.pop() : n.call(o, a, 1), --this.size, !0;
  }
  return Y3 = r, Y3;
}
var Z3, jP;
function KSe() {
  if (jP) return Z3;
  jP = 1;
  var e = Y2();
  function t(n) {
    var r = this.__data__, i = e(r, n);
    return i < 0 ? void 0 : r[i][1];
  }
  return Z3 = t, Z3;
}
var X3, VP;
function YSe() {
  if (VP) return X3;
  VP = 1;
  var e = Y2();
  function t(n) {
    return e(this.__data__, n) > -1;
  }
  return X3 = t, X3;
}
var J3, qP;
function ZSe() {
  if (qP) return J3;
  qP = 1;
  var e = Y2();
  function t(n, r) {
    var i = this.__data__, o = e(i, n);
    return o < 0 ? (++this.size, i.push([n, r])) : i[o][1] = r, this;
  }
  return J3 = t, J3;
}
var Q3, zP;
function Z2() {
  if (zP) return Q3;
  zP = 1;
  var e = USe(), t = GSe(), n = KSe(), r = YSe(), i = ZSe();
  function o(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = n, o.prototype.has = r, o.prototype.set = i, Q3 = o, Q3;
}
var e4, WP;
function PS() {
  if (WP) return e4;
  WP = 1;
  var e = hu(), t = ta(), n = e(t, "Map");
  return e4 = n, e4;
}
var t4, HP;
function XSe() {
  if (HP) return t4;
  HP = 1;
  var e = HSe(), t = Z2(), n = PS();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (n || t)(),
      string: new e()
    };
  }
  return t4 = r, t4;
}
var n4, UP;
function JSe() {
  if (UP) return n4;
  UP = 1;
  function e(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  return n4 = e, n4;
}
var r4, GP;
function X2() {
  if (GP) return r4;
  GP = 1;
  var e = JSe();
  function t(n, r) {
    var i = n.__data__;
    return e(r) ? i[typeof r == "string" ? "string" : "hash"] : i.map;
  }
  return r4 = t, r4;
}
var i4, KP;
function QSe() {
  if (KP) return i4;
  KP = 1;
  var e = X2();
  function t(n) {
    var r = e(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return i4 = t, i4;
}
var o4, YP;
function e_e() {
  if (YP) return o4;
  YP = 1;
  var e = X2();
  function t(n) {
    return e(this, n).get(n);
  }
  return o4 = t, o4;
}
var a4, ZP;
function t_e() {
  if (ZP) return a4;
  ZP = 1;
  var e = X2();
  function t(n) {
    return e(this, n).has(n);
  }
  return a4 = t, a4;
}
var s4, XP;
function n_e() {
  if (XP) return s4;
  XP = 1;
  var e = X2();
  function t(n, r) {
    var i = e(this, n), o = i.size;
    return i.set(n, r), this.size += i.size == o ? 0 : 1, this;
  }
  return s4 = t, s4;
}
var l4, JP;
function TS() {
  if (JP) return l4;
  JP = 1;
  var e = XSe(), t = QSe(), n = e_e(), r = t_e(), i = n_e();
  function o(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = n, o.prototype.has = r, o.prototype.set = i, l4 = o, l4;
}
var u4, QP;
function HY() {
  if (QP) return u4;
  QP = 1;
  var e = TS(), t = "Expected a function";
  function n(r, i) {
    if (typeof r != "function" || i != null && typeof i != "function")
      throw new TypeError(t);
    var o = function() {
      var a = arguments, s = i ? i.apply(this, a) : a[0], l = o.cache;
      if (l.has(s))
        return l.get(s);
      var u = r.apply(this, a);
      return o.cache = l.set(s, u) || l, u;
    };
    return o.cache = new (n.Cache || e)(), o;
  }
  return n.Cache = e, u4 = n, u4;
}
var c4, eT;
function r_e() {
  if (eT) return c4;
  eT = 1;
  var e = HY(), t = 500;
  function n(r) {
    var i = e(r, function(a) {
      return o.size === t && o.clear(), a;
    }), o = i.cache;
    return i;
  }
  return c4 = n, c4;
}
var d4, tT;
function i_e() {
  if (tT) return d4;
  tT = 1;
  var e = r_e(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = e(function(i) {
    var o = [];
    return i.charCodeAt(0) === 46 && o.push(""), i.replace(t, function(a, s, l, u) {
      o.push(l ? u.replace(n, "$1") : s || a);
    }), o;
  });
  return d4 = r, d4;
}
var f4, nT;
function MS() {
  if (nT) return f4;
  nT = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length, o = Array(i); ++r < i; )
      o[r] = n(t[r], r, t);
    return o;
  }
  return f4 = e, f4;
}
var h4, rT;
function o_e() {
  if (rT) return h4;
  rT = 1;
  var e = Op(), t = MS(), n = ei(), r = Pd(), i = e ? e.prototype : void 0, o = i ? i.toString : void 0;
  function a(s) {
    if (typeof s == "string")
      return s;
    if (n(s))
      return t(s, a) + "";
    if (r(s))
      return o ? o.call(s) : "";
    var l = s + "";
    return l == "0" && 1 / s == -1 / 0 ? "-0" : l;
  }
  return h4 = a, h4;
}
var p4, iT;
function UY() {
  if (iT) return p4;
  iT = 1;
  var e = o_e();
  function t(n) {
    return n == null ? "" : e(n);
  }
  return p4 = t, p4;
}
var m4, oT;
function GY() {
  if (oT) return m4;
  oT = 1;
  var e = ei(), t = AS(), n = i_e(), r = UY();
  function i(o, a) {
    return e(o) ? o : t(o, a) ? [o] : n(r(o));
  }
  return m4 = i, m4;
}
var g4, aT;
function J2() {
  if (aT) return g4;
  aT = 1;
  var e = Pd();
  function t(n) {
    if (typeof n == "string" || e(n))
      return n;
    var r = n + "";
    return r == "0" && 1 / n == -1 / 0 ? "-0" : r;
  }
  return g4 = t, g4;
}
var v4, sT;
function RS() {
  if (sT) return v4;
  sT = 1;
  var e = GY(), t = J2();
  function n(r, i) {
    i = e(i, r);
    for (var o = 0, a = i.length; r != null && o < a; )
      r = r[t(i[o++])];
    return o && o == a ? r : void 0;
  }
  return v4 = n, v4;
}
var y4, lT;
function KY() {
  if (lT) return y4;
  lT = 1;
  var e = RS();
  function t(n, r, i) {
    var o = n == null ? void 0 : e(n, r);
    return o === void 0 ? i : o;
  }
  return y4 = t, y4;
}
var a_e = KY();
const Di = /* @__PURE__ */ Rt(a_e);
var b4, uT;
function s_e() {
  if (uT) return b4;
  uT = 1;
  function e(t) {
    return t == null;
  }
  return b4 = e, b4;
}
var l_e = s_e();
const yt = /* @__PURE__ */ Rt(l_e);
var x4, cT;
function u_e() {
  if (cT) return x4;
  cT = 1;
  var e = Za(), t = ei(), n = Xa(), r = "[object String]";
  function i(o) {
    return typeof o == "string" || !t(o) && n(o) && e(o) == r;
  }
  return x4 = i, x4;
}
var c_e = u_e();
const kp = /* @__PURE__ */ Rt(c_e);
var d_e = OS();
const Ye = /* @__PURE__ */ Rt(d_e);
var f_e = el();
const Td = /* @__PURE__ */ Rt(f_e);
var c1 = { exports: {} }, _t = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dT;
function h_e() {
  if (dT) return _t;
  dT = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), v;
  v = Symbol.for("react.module.reference");
  function g(y) {
    if (typeof y == "object" && y !== null) {
      var w = y.$$typeof;
      switch (w) {
        case e:
          switch (y = y.type, y) {
            case n:
            case i:
            case r:
            case u:
            case c:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case a:
                case l:
                case h:
                case f:
                case o:
                  return y;
                default:
                  return w;
              }
          }
        case t:
          return w;
      }
    }
  }
  return _t.ContextConsumer = a, _t.ContextProvider = o, _t.Element = e, _t.ForwardRef = l, _t.Fragment = n, _t.Lazy = h, _t.Memo = f, _t.Portal = t, _t.Profiler = i, _t.StrictMode = r, _t.Suspense = u, _t.SuspenseList = c, _t.isAsyncMode = function() {
    return !1;
  }, _t.isConcurrentMode = function() {
    return !1;
  }, _t.isContextConsumer = function(y) {
    return g(y) === a;
  }, _t.isContextProvider = function(y) {
    return g(y) === o;
  }, _t.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, _t.isForwardRef = function(y) {
    return g(y) === l;
  }, _t.isFragment = function(y) {
    return g(y) === n;
  }, _t.isLazy = function(y) {
    return g(y) === h;
  }, _t.isMemo = function(y) {
    return g(y) === f;
  }, _t.isPortal = function(y) {
    return g(y) === t;
  }, _t.isProfiler = function(y) {
    return g(y) === i;
  }, _t.isStrictMode = function(y) {
    return g(y) === r;
  }, _t.isSuspense = function(y) {
    return g(y) === u;
  }, _t.isSuspenseList = function(y) {
    return g(y) === c;
  }, _t.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === i || y === r || y === u || y === c || y === m || typeof y == "object" && y !== null && (y.$$typeof === h || y.$$typeof === f || y.$$typeof === o || y.$$typeof === a || y.$$typeof === l || y.$$typeof === v || y.getModuleId !== void 0);
  }, _t.typeOf = g, _t;
}
var Et = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fT;
function p_e() {
  return fT || (fT = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), v = !1, g = !1, y = !1, w = !1, C = !1, S;
    S = Symbol.for("react.module.reference");
    function N(se) {
      return !!(typeof se == "string" || typeof se == "function" || se === n || se === i || C || se === r || se === u || se === c || w || se === m || v || g || y || typeof se == "object" && se !== null && (se.$$typeof === h || se.$$typeof === f || se.$$typeof === o || se.$$typeof === a || se.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      se.$$typeof === S || se.getModuleId !== void 0));
    }
    function E(se) {
      if (typeof se == "object" && se !== null) {
        var nt = se.$$typeof;
        switch (nt) {
          case e:
            var ut = se.type;
            switch (ut) {
              case n:
              case i:
              case r:
              case u:
              case c:
                return ut;
              default:
                var st = ut && ut.$$typeof;
                switch (st) {
                  case s:
                  case a:
                  case l:
                  case h:
                  case f:
                  case o:
                    return st;
                  default:
                    return nt;
                }
            }
          case t:
            return nt;
        }
      }
    }
    var A = a, O = o, T = e, M = l, L = n, I = h, j = f, B = t, q = i, G = r, U = u, V = c, H = !1, Z = !1;
    function de(se) {
      return H || (H = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ne(se) {
      return Z || (Z = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Y(se) {
      return E(se) === a;
    }
    function le(se) {
      return E(se) === o;
    }
    function be(se) {
      return typeof se == "object" && se !== null && se.$$typeof === e;
    }
    function pe(se) {
      return E(se) === l;
    }
    function Ee(se) {
      return E(se) === n;
    }
    function ge(se) {
      return E(se) === h;
    }
    function Ce(se) {
      return E(se) === f;
    }
    function ie(se) {
      return E(se) === t;
    }
    function ye(se) {
      return E(se) === i;
    }
    function ve(se) {
      return E(se) === r;
    }
    function Q(se) {
      return E(se) === u;
    }
    function Oe(se) {
      return E(se) === c;
    }
    Et.ContextConsumer = A, Et.ContextProvider = O, Et.Element = T, Et.ForwardRef = M, Et.Fragment = L, Et.Lazy = I, Et.Memo = j, Et.Portal = B, Et.Profiler = q, Et.StrictMode = G, Et.Suspense = U, Et.SuspenseList = V, Et.isAsyncMode = de, Et.isConcurrentMode = ne, Et.isContextConsumer = Y, Et.isContextProvider = le, Et.isElement = be, Et.isForwardRef = pe, Et.isFragment = Ee, Et.isLazy = ge, Et.isMemo = Ce, Et.isPortal = ie, Et.isProfiler = ye, Et.isStrictMode = ve, Et.isSuspense = Q, Et.isSuspenseList = Oe, Et.isValidElementType = N, Et.typeOf = E;
  }()), Et;
}
var hT;
function m_e() {
  return hT || (hT = 1, process.env.NODE_ENV === "production" ? c1.exports = h_e() : c1.exports = p_e()), c1.exports;
}
var g_e = m_e(), w4, pT;
function YY() {
  if (pT) return w4;
  pT = 1;
  var e = Za(), t = Xa(), n = "[object Number]";
  function r(i) {
    return typeof i == "number" || t(i) && e(i) == n;
  }
  return w4 = r, w4;
}
var C4, mT;
function v_e() {
  if (mT) return C4;
  mT = 1;
  var e = YY();
  function t(n) {
    return e(n) && n != +n;
  }
  return C4 = t, C4;
}
var y_e = v_e();
const Pp = /* @__PURE__ */ Rt(y_e);
var b_e = YY();
const x_e = /* @__PURE__ */ Rt(b_e);
var no = function(t) {
  return t === 0 ? 0 : t > 0 ? 1 : -1;
}, kl = function(t) {
  return kp(t) && t.indexOf("%") === t.length - 1;
}, we = function(t) {
  return x_e(t) && !Pp(t);
}, Dn = function(t) {
  return we(t) || kp(t);
}, w_e = 0, Q2 = function(t) {
  var n = ++w_e;
  return "".concat(t || "").concat(n);
}, ro = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!we(t) && !kp(t))
    return r;
  var o;
  if (kl(t)) {
    var a = t.indexOf("%");
    o = n * parseFloat(t.slice(0, a)) / 100;
  } else
    o = +t;
  return Pp(o) && (o = r), i && o > n && (o = n), o;
}, Cs = function(t) {
  if (!t)
    return null;
  var n = Object.keys(t);
  return n && n.length ? t[n[0]] : null;
}, C_e = function(t) {
  if (!Array.isArray(t))
    return !1;
  for (var n = t.length, r = {}, i = 0; i < n; i++)
    if (!r[t[i]])
      r[t[i]] = !0;
    else
      return !0;
  return !1;
}, ko = function(t, n) {
  return we(t) && we(n) ? function(r) {
    return t + r * (n - t);
  } : function() {
    return n;
  };
};
function C7(e, t, n) {
  return !e || !e.length ? null : e.find(function(r) {
    return r && (typeof t == "function" ? t(r) : Di(r, t)) === n;
  });
}
function bc(e, t) {
  for (var n in e)
    if ({}.hasOwnProperty.call(e, n) && (!{}.hasOwnProperty.call(t, n) || e[n] !== t[n]))
      return !1;
  for (var r in t)
    if ({}.hasOwnProperty.call(t, r) && !{}.hasOwnProperty.call(e, r))
      return !1;
  return !0;
}
function S7(e) {
  "@babel/helpers - typeof";
  return S7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, S7(e);
}
var S_e = ["viewBox", "children"], __e = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], gT = ["points", "pathLength"], S4 = {
  svg: S_e,
  polygon: gT,
  polyline: gT
}, DS = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], gm = function(t, n) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var r = t;
  if (/* @__PURE__ */ Pr(t) && (r = t.props), !Td(r))
    return null;
  var i = {};
  return Object.keys(r).forEach(function(o) {
    DS.includes(o) && (i[o] = n || function(a) {
      return r[o](r, a);
    });
  }), i;
}, E_e = function(t, n, r) {
  return function(i) {
    return t(n, r, i), null;
  };
}, Ic = function(t, n, r) {
  if (!Td(t) || S7(t) !== "object")
    return null;
  var i = null;
  return Object.keys(t).forEach(function(o) {
    var a = t[o];
    DS.includes(o) && typeof a == "function" && (i || (i = {}), i[o] = E_e(a, n, r));
  }), i;
}, N_e = ["children"], A_e = ["children"];
function vT(e, t) {
  if (e == null) return {};
  var n = O_e(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function O_e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var yT = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart",
  contextmenu: "onContextMenu",
  dblclick: "onDoubleClick"
}, Ta = function(t) {
  return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
}, bT = null, _4 = null, IS = function e(t) {
  if (t === bT && Array.isArray(_4))
    return _4;
  var n = [];
  return Wr.forEach(t, function(r) {
    yt(r) || (g_e.isFragment(r) ? n = n.concat(e(r.props.children)) : n.push(r));
  }), _4 = n, bT = t, n;
};
function oo(e, t) {
  var n = [], r = [];
  return Array.isArray(t) ? r = t.map(function(i) {
    return Ta(i);
  }) : r = [Ta(t)], IS(e).forEach(function(i) {
    var o = Di(i, "type.displayName") || Di(i, "type.name");
    r.indexOf(o) !== -1 && n.push(i);
  }), n;
}
function li(e, t) {
  var n = oo(e, t);
  return n && n[0];
}
var xT = function(t) {
  if (!t || !t.props)
    return !1;
  var n = t.props, r = n.width, i = n.height;
  return !(!we(r) || r <= 0 || !we(i) || i <= 0);
}, k_e = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], P_e = function(t) {
  return t && t.type && kp(t.type) && k_e.indexOf(t.type) >= 0;
}, T_e = function(t, n, r, i) {
  var o, a = (o = S4 == null ? void 0 : S4[i]) !== null && o !== void 0 ? o : [];
  return !Ye(t) && (i && a.includes(n) || __e.includes(n)) || r && DS.includes(n);
}, qe = function(t, n, r) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var i = t;
  if (/* @__PURE__ */ Pr(t) && (i = t.props), !Td(i))
    return null;
  var o = {};
  return Object.keys(i).forEach(function(a) {
    var s;
    T_e((s = i) === null || s === void 0 ? void 0 : s[a], a, n, r) && (o[a] = i[a]);
  }), o;
}, _7 = function e(t, n) {
  if (t === n)
    return !0;
  var r = Wr.count(t);
  if (r !== Wr.count(n))
    return !1;
  if (r === 0)
    return !0;
  if (r === 1)
    return wT(Array.isArray(t) ? t[0] : t, Array.isArray(n) ? n[0] : n);
  for (var i = 0; i < r; i++) {
    var o = t[i], a = n[i];
    if (Array.isArray(o) || Array.isArray(a)) {
      if (!e(o, a))
        return !1;
    } else if (!wT(o, a))
      return !1;
  }
  return !0;
}, wT = function(t, n) {
  if (yt(t) && yt(n))
    return !0;
  if (!yt(t) && !yt(n)) {
    var r = t.props || {}, i = r.children, o = vT(r, N_e), a = n.props || {}, s = a.children, l = vT(a, A_e);
    return i && s ? bc(o, l) && _7(i, s) : !i && !s ? bc(o, l) : !1;
  }
  return !1;
}, CT = function(t, n) {
  var r = [], i = {};
  return IS(t).forEach(function(o, a) {
    if (P_e(o))
      r.push(o);
    else if (o) {
      var s = Ta(o.type), l = n[s] || {}, u = l.handler, c = l.once;
      if (u && (!c || !i[s])) {
        var f = u(o, s, a);
        r.push(f), i[s] = !0;
      }
    }
  }), r;
}, M_e = function(t) {
  var n = t && t.type;
  return n && yT[n] ? yT[n] : null;
}, R_e = function(t, n) {
  return IS(n).indexOf(t);
}, D_e = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function E7() {
  return E7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, E7.apply(this, arguments);
}
function I_e(e, t) {
  if (e == null) return {};
  var n = $_e(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function $_e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function N7(e) {
  var t = e.children, n = e.width, r = e.height, i = e.viewBox, o = e.className, a = e.style, s = e.title, l = e.desc, u = I_e(e, D_e), c = i || {
    width: n,
    height: r,
    x: 0,
    y: 0
  }, f = at("recharts-surface", o);
  return /* @__PURE__ */ F.createElement("svg", E7({}, qe(u, !0, "svg"), {
    className: f,
    width: n,
    height: r,
    style: a,
    viewBox: "".concat(c.x, " ").concat(c.y, " ").concat(c.width, " ").concat(c.height)
  }), /* @__PURE__ */ F.createElement("title", null, s), /* @__PURE__ */ F.createElement("desc", null, l), t);
}
var L_e = ["children", "className"];
function A7() {
  return A7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, A7.apply(this, arguments);
}
function F_e(e, t) {
  if (e == null) return {};
  var n = B_e(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function B_e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var zt = /* @__PURE__ */ F.forwardRef(function(e, t) {
  var n = e.children, r = e.className, i = F_e(e, L_e), o = at("recharts-layer", r);
  return /* @__PURE__ */ F.createElement("g", A7({
    className: o
  }, qe(i, !0), {
    ref: t
  }), n);
}), j_e = process.env.NODE_ENV !== "production", Ma = function(t, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++)
    i[o - 2] = arguments[o];
  if (j_e && typeof console < "u" && console.warn && (n === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (n === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var a = 0;
      console.warn(n.replace(/%s/g, function() {
        return i[a++];
      }));
    }
}, E4, ST;
function V_e() {
  if (ST) return E4;
  ST = 1;
  function e(t, n, r) {
    var i = -1, o = t.length;
    n < 0 && (n = -n > o ? 0 : o + n), r = r > o ? o : r, r < 0 && (r += o), o = n > r ? 0 : r - n >>> 0, n >>>= 0;
    for (var a = Array(o); ++i < o; )
      a[i] = t[i + n];
    return a;
  }
  return E4 = e, E4;
}
var N4, _T;
function q_e() {
  if (_T) return N4;
  _T = 1;
  var e = V_e();
  function t(n, r, i) {
    var o = n.length;
    return i = i === void 0 ? o : i, !r && i >= o ? n : e(n, r, i);
  }
  return N4 = t, N4;
}
var A4, ET;
function ZY() {
  if (ET) return A4;
  ET = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", n = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", i = t + n + r, o = "\\ufe0e\\ufe0f", a = "\\u200d", s = RegExp("[" + a + e + i + o + "]");
  function l(u) {
    return s.test(u);
  }
  return A4 = l, A4;
}
var O4, NT;
function z_e() {
  if (NT) return O4;
  NT = 1;
  function e(t) {
    return t.split("");
  }
  return O4 = e, O4;
}
var k4, AT;
function W_e() {
  if (AT) return k4;
  AT = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", n = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", i = t + n + r, o = "\\ufe0e\\ufe0f", a = "[" + e + "]", s = "[" + i + "]", l = "\\ud83c[\\udffb-\\udfff]", u = "(?:" + s + "|" + l + ")", c = "[^" + e + "]", f = "(?:\\ud83c[\\udde6-\\uddff]){2}", h = "[\\ud800-\\udbff][\\udc00-\\udfff]", m = "\\u200d", v = u + "?", g = "[" + o + "]?", y = "(?:" + m + "(?:" + [c, f, h].join("|") + ")" + g + v + ")*", w = g + v + y, C = "(?:" + [c + s + "?", s, f, h, a].join("|") + ")", S = RegExp(l + "(?=" + l + ")|" + C + w, "g");
  function N(E) {
    return E.match(S) || [];
  }
  return k4 = N, k4;
}
var P4, OT;
function H_e() {
  if (OT) return P4;
  OT = 1;
  var e = z_e(), t = ZY(), n = W_e();
  function r(i) {
    return t(i) ? n(i) : e(i);
  }
  return P4 = r, P4;
}
var T4, kT;
function U_e() {
  if (kT) return T4;
  kT = 1;
  var e = q_e(), t = ZY(), n = H_e(), r = UY();
  function i(o) {
    return function(a) {
      a = r(a);
      var s = t(a) ? n(a) : void 0, l = s ? s[0] : a.charAt(0), u = s ? e(s, 1).join("") : a.slice(1);
      return l[o]() + u;
    };
  }
  return T4 = i, T4;
}
var M4, PT;
function G_e() {
  if (PT) return M4;
  PT = 1;
  var e = U_e(), t = e("toUpperCase");
  return M4 = t, M4;
}
var K_e = G_e();
const ev = /* @__PURE__ */ Rt(K_e);
function Ut(e) {
  return function() {
    return e;
  };
}
const XY = Math.cos, vm = Math.sin, bo = Math.sqrt, ym = Math.PI, tv = 2 * ym, O7 = Math.PI, k7 = 2 * O7, xl = 1e-6, Y_e = k7 - xl;
function JY(e) {
  this._ += e[0];
  for (let t = 1, n = e.length; t < n; ++t)
    this._ += arguments[t] + e[t];
}
function Z_e(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return JY;
  const n = 10 ** t;
  return function(r) {
    this._ += r[0];
    for (let i = 1, o = r.length; i < o; ++i)
      this._ += Math.round(arguments[i] * n) / n + r[i];
  };
}
class X_e {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? JY : Z_e(t);
  }
  moveTo(t, n) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, n) {
    this._append`L${this._x1 = +t},${this._y1 = +n}`;
  }
  quadraticCurveTo(t, n, r, i) {
    this._append`Q${+t},${+n},${this._x1 = +r},${this._y1 = +i}`;
  }
  bezierCurveTo(t, n, r, i, o, a) {
    this._append`C${+t},${+n},${+r},${+i},${this._x1 = +o},${this._y1 = +a}`;
  }
  arcTo(t, n, r, i, o) {
    if (t = +t, n = +n, r = +r, i = +i, o = +o, o < 0) throw new Error(`negative radius: ${o}`);
    let a = this._x1, s = this._y1, l = r - t, u = i - n, c = a - t, f = s - n, h = c * c + f * f;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = n}`;
    else if (h > xl) if (!(Math.abs(f * l - u * c) > xl) || !o)
      this._append`L${this._x1 = t},${this._y1 = n}`;
    else {
      let m = r - a, v = i - s, g = l * l + u * u, y = m * m + v * v, w = Math.sqrt(g), C = Math.sqrt(h), S = o * Math.tan((O7 - Math.acos((g + h - y) / (2 * w * C))) / 2), N = S / C, E = S / w;
      Math.abs(N - 1) > xl && this._append`L${t + N * c},${n + N * f}`, this._append`A${o},${o},0,0,${+(f * m > c * v)},${this._x1 = t + E * l},${this._y1 = n + E * u}`;
    }
  }
  arc(t, n, r, i, o, a) {
    if (t = +t, n = +n, r = +r, a = !!a, r < 0) throw new Error(`negative radius: ${r}`);
    let s = r * Math.cos(i), l = r * Math.sin(i), u = t + s, c = n + l, f = 1 ^ a, h = a ? i - o : o - i;
    this._x1 === null ? this._append`M${u},${c}` : (Math.abs(this._x1 - u) > xl || Math.abs(this._y1 - c) > xl) && this._append`L${u},${c}`, r && (h < 0 && (h = h % k7 + k7), h > Y_e ? this._append`A${r},${r},0,1,${f},${t - s},${n - l}A${r},${r},0,1,${f},${this._x1 = u},${this._y1 = c}` : h > xl && this._append`A${r},${r},0,${+(h >= O7)},${f},${this._x1 = t + r * Math.cos(o)},${this._y1 = n + r * Math.sin(o)}`);
  }
  rect(t, n, r, i) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}h${r = +r}v${+i}h${-r}Z`;
  }
  toString() {
    return this._;
  }
}
function $S(e) {
  let t = 3;
  return e.digits = function(n) {
    if (!arguments.length) return t;
    if (n == null)
      t = null;
    else {
      const r = Math.floor(n);
      if (!(r >= 0)) throw new RangeError(`invalid digits: ${n}`);
      t = r;
    }
    return e;
  }, () => new X_e(t);
}
function LS(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function QY(e) {
  this._context = e;
}
QY.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function nv(e) {
  return new QY(e);
}
function eZ(e) {
  return e[0];
}
function tZ(e) {
  return e[1];
}
function nZ(e, t) {
  var n = Ut(!0), r = null, i = nv, o = null, a = $S(s);
  e = typeof e == "function" ? e : e === void 0 ? eZ : Ut(e), t = typeof t == "function" ? t : t === void 0 ? tZ : Ut(t);
  function s(l) {
    var u, c = (l = LS(l)).length, f, h = !1, m;
    for (r == null && (o = i(m = a())), u = 0; u <= c; ++u)
      !(u < c && n(f = l[u], u, l)) === h && ((h = !h) ? o.lineStart() : o.lineEnd()), h && o.point(+e(f, u, l), +t(f, u, l));
    if (m) return o = null, m + "" || null;
  }
  return s.x = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : Ut(+l), s) : e;
  }, s.y = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : Ut(+l), s) : t;
  }, s.defined = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : Ut(!!l), s) : n;
  }, s.curve = function(l) {
    return arguments.length ? (i = l, r != null && (o = i(r)), s) : i;
  }, s.context = function(l) {
    return arguments.length ? (l == null ? r = o = null : o = i(r = l), s) : r;
  }, s;
}
function d1(e, t, n) {
  var r = null, i = Ut(!0), o = null, a = nv, s = null, l = $S(u);
  e = typeof e == "function" ? e : e === void 0 ? eZ : Ut(+e), t = typeof t == "function" ? t : Ut(t === void 0 ? 0 : +t), n = typeof n == "function" ? n : n === void 0 ? tZ : Ut(+n);
  function u(f) {
    var h, m, v, g = (f = LS(f)).length, y, w = !1, C, S = new Array(g), N = new Array(g);
    for (o == null && (s = a(C = l())), h = 0; h <= g; ++h) {
      if (!(h < g && i(y = f[h], h, f)) === w)
        if (w = !w)
          m = h, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), v = h - 1; v >= m; --v)
            s.point(S[v], N[v]);
          s.lineEnd(), s.areaEnd();
        }
      w && (S[h] = +e(y, h, f), N[h] = +t(y, h, f), s.point(r ? +r(y, h, f) : S[h], n ? +n(y, h, f) : N[h]));
    }
    if (C) return s = null, C + "" || null;
  }
  function c() {
    return nZ().defined(i).curve(a).context(o);
  }
  return u.x = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : Ut(+f), r = null, u) : e;
  }, u.x0 = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : Ut(+f), u) : e;
  }, u.x1 = function(f) {
    return arguments.length ? (r = f == null ? null : typeof f == "function" ? f : Ut(+f), u) : r;
  }, u.y = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : Ut(+f), n = null, u) : t;
  }, u.y0 = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : Ut(+f), u) : t;
  }, u.y1 = function(f) {
    return arguments.length ? (n = f == null ? null : typeof f == "function" ? f : Ut(+f), u) : n;
  }, u.lineX0 = u.lineY0 = function() {
    return c().x(e).y(t);
  }, u.lineY1 = function() {
    return c().x(e).y(n);
  }, u.lineX1 = function() {
    return c().x(r).y(t);
  }, u.defined = function(f) {
    return arguments.length ? (i = typeof f == "function" ? f : Ut(!!f), u) : i;
  }, u.curve = function(f) {
    return arguments.length ? (a = f, o != null && (s = a(o)), u) : a;
  }, u.context = function(f) {
    return arguments.length ? (f == null ? o = s = null : s = a(o = f), u) : o;
  }, u;
}
class rZ {
  constructor(t, n) {
    this._context = t, this._x = n;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, n) {
    switch (t = +t, n = +n, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, n) : this._context.moveTo(t, n);
        break;
      }
      case 1:
        this._point = 2;
      // falls through
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, n, t, n) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + n) / 2, t, this._y0, t, n);
        break;
      }
    }
    this._x0 = t, this._y0 = n;
  }
}
function J_e(e) {
  return new rZ(e, !0);
}
function Q_e(e) {
  return new rZ(e, !1);
}
const FS = {
  draw(e, t) {
    const n = bo(t / ym);
    e.moveTo(n, 0), e.arc(0, 0, n, 0, tv);
  }
}, eEe = {
  draw(e, t) {
    const n = bo(t / 5) / 2;
    e.moveTo(-3 * n, -n), e.lineTo(-n, -n), e.lineTo(-n, -3 * n), e.lineTo(n, -3 * n), e.lineTo(n, -n), e.lineTo(3 * n, -n), e.lineTo(3 * n, n), e.lineTo(n, n), e.lineTo(n, 3 * n), e.lineTo(-n, 3 * n), e.lineTo(-n, n), e.lineTo(-3 * n, n), e.closePath();
  }
}, iZ = bo(1 / 3), tEe = iZ * 2, nEe = {
  draw(e, t) {
    const n = bo(t / tEe), r = n * iZ;
    e.moveTo(0, -n), e.lineTo(r, 0), e.lineTo(0, n), e.lineTo(-r, 0), e.closePath();
  }
}, rEe = {
  draw(e, t) {
    const n = bo(t), r = -n / 2;
    e.rect(r, r, n, n);
  }
}, iEe = 0.8908130915292852, oZ = vm(ym / 10) / vm(7 * ym / 10), oEe = vm(tv / 10) * oZ, aEe = -XY(tv / 10) * oZ, sEe = {
  draw(e, t) {
    const n = bo(t * iEe), r = oEe * n, i = aEe * n;
    e.moveTo(0, -n), e.lineTo(r, i);
    for (let o = 1; o < 5; ++o) {
      const a = tv * o / 5, s = XY(a), l = vm(a);
      e.lineTo(l * n, -s * n), e.lineTo(s * r - l * i, l * r + s * i);
    }
    e.closePath();
  }
}, R4 = bo(3), lEe = {
  draw(e, t) {
    const n = -bo(t / (R4 * 3));
    e.moveTo(0, n * 2), e.lineTo(-R4 * n, -n), e.lineTo(R4 * n, -n), e.closePath();
  }
}, Ni = -0.5, Ai = bo(3) / 2, P7 = 1 / bo(12), uEe = (P7 / 2 + 1) * 3, cEe = {
  draw(e, t) {
    const n = bo(t / uEe), r = n / 2, i = n * P7, o = r, a = n * P7 + n, s = -o, l = a;
    e.moveTo(r, i), e.lineTo(o, a), e.lineTo(s, l), e.lineTo(Ni * r - Ai * i, Ai * r + Ni * i), e.lineTo(Ni * o - Ai * a, Ai * o + Ni * a), e.lineTo(Ni * s - Ai * l, Ai * s + Ni * l), e.lineTo(Ni * r + Ai * i, Ni * i - Ai * r), e.lineTo(Ni * o + Ai * a, Ni * a - Ai * o), e.lineTo(Ni * s + Ai * l, Ni * l - Ai * s), e.closePath();
  }
};
function dEe(e, t) {
  let n = null, r = $S(i);
  e = typeof e == "function" ? e : Ut(e || FS), t = typeof t == "function" ? t : Ut(t === void 0 ? 64 : +t);
  function i() {
    let o;
    if (n || (n = o = r()), e.apply(this, arguments).draw(n, +t.apply(this, arguments)), o) return n = null, o + "" || null;
  }
  return i.type = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : Ut(o), i) : e;
  }, i.size = function(o) {
    return arguments.length ? (t = typeof o == "function" ? o : Ut(+o), i) : t;
  }, i.context = function(o) {
    return arguments.length ? (n = o ?? null, i) : n;
  }, i;
}
function bm() {
}
function xm(e, t, n) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + n) / 6
  );
}
function aZ(e) {
  this._context = e;
}
aZ.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        xm(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        xm(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function fEe(e) {
  return new aZ(e);
}
function sZ(e) {
  this._context = e;
}
sZ.prototype = {
  areaStart: bm,
  areaEnd: bm,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        xm(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function hEe(e) {
  return new sZ(e);
}
function lZ(e) {
  this._context = e;
}
lZ.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var n = (this._x0 + 4 * this._x1 + e) / 6, r = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        xm(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function pEe(e) {
  return new lZ(e);
}
function uZ(e) {
  this._context = e;
}
uZ.prototype = {
  areaStart: bm,
  areaEnd: bm,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function mEe(e) {
  return new uZ(e);
}
function TT(e) {
  return e < 0 ? -1 : 1;
}
function MT(e, t, n) {
  var r = e._x1 - e._x0, i = t - e._x1, o = (e._y1 - e._y0) / (r || i < 0 && -0), a = (n - e._y1) / (i || r < 0 && -0), s = (o * i + a * r) / (r + i);
  return (TT(o) + TT(a)) * Math.min(Math.abs(o), Math.abs(a), 0.5 * Math.abs(s)) || 0;
}
function RT(e, t) {
  var n = e._x1 - e._x0;
  return n ? (3 * (e._y1 - e._y0) / n - t) / 2 : t;
}
function D4(e, t, n) {
  var r = e._x0, i = e._y0, o = e._x1, a = e._y1, s = (o - r) / 3;
  e._context.bezierCurveTo(r + s, i + s * t, o - s, a - s * n, o, a);
}
function wm(e) {
  this._context = e;
}
wm.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        D4(this, this._t0, RT(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var n = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, D4(this, RT(this, n = MT(this, e, t)), n);
          break;
        default:
          D4(this, this._t0, n = MT(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = n;
    }
  }
};
function cZ(e) {
  this._context = new dZ(e);
}
(cZ.prototype = Object.create(wm.prototype)).point = function(e, t) {
  wm.prototype.point.call(this, t, e);
};
function dZ(e) {
  this._context = e;
}
dZ.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, n, r, i, o) {
    this._context.bezierCurveTo(t, e, r, n, o, i);
  }
};
function gEe(e) {
  return new wm(e);
}
function vEe(e) {
  return new cZ(e);
}
function fZ(e) {
  this._context = e;
}
fZ.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length;
    if (n)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), n === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var r = DT(e), i = DT(t), o = 0, a = 1; a < n; ++o, ++a)
          this._context.bezierCurveTo(r[0][o], i[0][o], r[1][o], i[1][o], e[a], t[a]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function DT(e) {
  var t, n = e.length - 1, r, i = new Array(n), o = new Array(n), a = new Array(n);
  for (i[0] = 0, o[0] = 2, a[0] = e[0] + 2 * e[1], t = 1; t < n - 1; ++t) i[t] = 1, o[t] = 4, a[t] = 4 * e[t] + 2 * e[t + 1];
  for (i[n - 1] = 2, o[n - 1] = 7, a[n - 1] = 8 * e[n - 1] + e[n], t = 1; t < n; ++t) r = i[t] / o[t - 1], o[t] -= r, a[t] -= r * a[t - 1];
  for (i[n - 1] = a[n - 1] / o[n - 1], t = n - 2; t >= 0; --t) i[t] = (a[t] - i[t + 1]) / o[t];
  for (o[n - 1] = (e[n] + i[n - 1]) / 2, t = 0; t < n - 1; ++t) o[t] = 2 * e[t + 1] - i[t + 1];
  return [i, o];
}
function yEe(e) {
  return new fZ(e);
}
function rv(e, t) {
  this._context = e, this._t = t;
}
rv.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var n = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function bEe(e) {
  return new rv(e, 0.5);
}
function xEe(e) {
  return new rv(e, 0);
}
function wEe(e) {
  return new rv(e, 1);
}
function $c(e, t) {
  if ((a = e.length) > 1)
    for (var n = 1, r, i, o = e[t[0]], a, s = o.length; n < a; ++n)
      for (i = o, o = e[t[n]], r = 0; r < s; ++r)
        o[r][1] += o[r][0] = isNaN(i[r][1]) ? i[r][0] : i[r][1];
}
function T7(e) {
  for (var t = e.length, n = new Array(t); --t >= 0; ) n[t] = t;
  return n;
}
function CEe(e, t) {
  return e[t];
}
function SEe(e) {
  const t = [];
  return t.key = e, t;
}
function _Ee() {
  var e = Ut([]), t = T7, n = $c, r = CEe;
  function i(o) {
    var a = Array.from(e.apply(this, arguments), SEe), s, l = a.length, u = -1, c;
    for (const f of o)
      for (s = 0, ++u; s < l; ++s)
        (a[s][u] = [0, +r(f, a[s].key, u, o)]).data = f;
    for (s = 0, c = LS(t(a)); s < l; ++s)
      a[c[s]].index = s;
    return n(a, c), a;
  }
  return i.keys = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : Ut(Array.from(o)), i) : e;
  }, i.value = function(o) {
    return arguments.length ? (r = typeof o == "function" ? o : Ut(+o), i) : r;
  }, i.order = function(o) {
    return arguments.length ? (t = o == null ? T7 : typeof o == "function" ? o : Ut(Array.from(o)), i) : t;
  }, i.offset = function(o) {
    return arguments.length ? (n = o ?? $c, i) : n;
  }, i;
}
function EEe(e, t) {
  if ((r = e.length) > 0) {
    for (var n, r, i = 0, o = e[0].length, a; i < o; ++i) {
      for (a = n = 0; n < r; ++n) a += e[n][i][1] || 0;
      if (a) for (n = 0; n < r; ++n) e[n][i][1] /= a;
    }
    $c(e, t);
  }
}
function NEe(e, t) {
  if ((i = e.length) > 0) {
    for (var n = 0, r = e[t[0]], i, o = r.length; n < o; ++n) {
      for (var a = 0, s = 0; a < i; ++a) s += e[a][n][1] || 0;
      r[n][1] += r[n][0] = -s / 2;
    }
    $c(e, t);
  }
}
function AEe(e, t) {
  if (!(!((a = e.length) > 0) || !((o = (i = e[t[0]]).length) > 0))) {
    for (var n = 0, r = 1, i, o, a; r < o; ++r) {
      for (var s = 0, l = 0, u = 0; s < a; ++s) {
        for (var c = e[t[s]], f = c[r][1] || 0, h = c[r - 1][1] || 0, m = (f - h) / 2, v = 0; v < s; ++v) {
          var g = e[t[v]], y = g[r][1] || 0, w = g[r - 1][1] || 0;
          m += y - w;
        }
        l += f, u += m * f;
      }
      i[r - 1][1] += i[r - 1][0] = n, l && (n -= u / l);
    }
    i[r - 1][1] += i[r - 1][0] = n, $c(e, t);
  }
}
function ah(e) {
  "@babel/helpers - typeof";
  return ah = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ah(e);
}
var OEe = ["type", "size", "sizeType"];
function M7() {
  return M7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, M7.apply(this, arguments);
}
function IT(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $T(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? IT(Object(n), !0).forEach(function(r) {
      kEe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : IT(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function kEe(e, t, n) {
  return t = PEe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function PEe(e) {
  var t = TEe(e, "string");
  return ah(t) == "symbol" ? t : t + "";
}
function TEe(e, t) {
  if (ah(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ah(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function MEe(e, t) {
  if (e == null) return {};
  var n = REe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function REe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var hZ = {
  symbolCircle: FS,
  symbolCross: eEe,
  symbolDiamond: nEe,
  symbolSquare: rEe,
  symbolStar: sEe,
  symbolTriangle: lEe,
  symbolWye: cEe
}, DEe = Math.PI / 180, IEe = function(t) {
  var n = "symbol".concat(ev(t));
  return hZ[n] || FS;
}, $Ee = function(t, n, r) {
  if (n === "area")
    return t;
  switch (r) {
    case "cross":
      return 5 * t * t / 9;
    case "diamond":
      return 0.5 * t * t / Math.sqrt(3);
    case "square":
      return t * t;
    case "star": {
      var i = 18 * DEe;
      return 1.25 * t * t * (Math.tan(i) - Math.tan(i * 2) * Math.pow(Math.tan(i), 2));
    }
    case "triangle":
      return Math.sqrt(3) * t * t / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * t * t / 8;
    default:
      return Math.PI * t * t / 4;
  }
}, LEe = function(t, n) {
  hZ["symbol".concat(ev(t))] = n;
}, BS = function(t) {
  var n = t.type, r = n === void 0 ? "circle" : n, i = t.size, o = i === void 0 ? 64 : i, a = t.sizeType, s = a === void 0 ? "area" : a, l = MEe(t, OEe), u = $T($T({}, l), {}, {
    type: r,
    size: o,
    sizeType: s
  }), c = function() {
    var y = IEe(r), w = dEe().type(y).size($Ee(o, s, r));
    return w();
  }, f = u.className, h = u.cx, m = u.cy, v = qe(u, !0);
  return h === +h && m === +m && o === +o ? /* @__PURE__ */ F.createElement("path", M7({}, v, {
    className: at("recharts-symbols", f),
    transform: "translate(".concat(h, ", ").concat(m, ")"),
    d: c()
  })) : null;
};
BS.registerSymbol = LEe;
function Lc(e) {
  "@babel/helpers - typeof";
  return Lc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Lc(e);
}
function R7() {
  return R7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, R7.apply(this, arguments);
}
function LT(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function FEe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? LT(Object(n), !0).forEach(function(r) {
      sh(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : LT(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function BEe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function jEe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, mZ(r.key), r);
  }
}
function VEe(e, t, n) {
  return t && jEe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function qEe(e, t, n) {
  return t = Cm(t), zEe(e, pZ() ? Reflect.construct(t, n || [], Cm(e).constructor) : t.apply(e, n));
}
function zEe(e, t) {
  if (t && (Lc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return WEe(e);
}
function WEe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function pZ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (pZ = function() {
    return !!e;
  })();
}
function Cm(e) {
  return Cm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Cm(e);
}
function HEe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && D7(e, t);
}
function D7(e, t) {
  return D7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, D7(e, t);
}
function sh(e, t, n) {
  return t = mZ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function mZ(e) {
  var t = UEe(e, "string");
  return Lc(t) == "symbol" ? t : t + "";
}
function UEe(e, t) {
  if (Lc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Lc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Yi = 32, jS = /* @__PURE__ */ function(e) {
  function t() {
    return BEe(this, t), qEe(this, t, arguments);
  }
  return HEe(t, e), VEe(t, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(r) {
        var i = this.props.inactiveColor, o = Yi / 2, a = Yi / 6, s = Yi / 3, l = r.inactive ? i : r.color;
        if (r.type === "plainline")
          return /* @__PURE__ */ F.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: l,
            strokeDasharray: r.payload.strokeDasharray,
            x1: 0,
            y1: o,
            x2: Yi,
            y2: o,
            className: "recharts-legend-icon"
          });
        if (r.type === "line")
          return /* @__PURE__ */ F.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: l,
            d: "M0,".concat(o, "h").concat(s, `
            A`).concat(a, ",").concat(a, ",0,1,1,").concat(2 * s, ",").concat(o, `
            H`).concat(Yi, "M").concat(2 * s, ",").concat(o, `
            A`).concat(a, ",").concat(a, ",0,1,1,").concat(s, ",").concat(o),
            className: "recharts-legend-icon"
          });
        if (r.type === "rect")
          return /* @__PURE__ */ F.createElement("path", {
            stroke: "none",
            fill: l,
            d: "M0,".concat(Yi / 8, "h").concat(Yi, "v").concat(Yi * 3 / 4, "h").concat(-32, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ F.isValidElement(r.legendIcon)) {
          var u = FEe({}, r);
          return delete u.legendIcon, /* @__PURE__ */ F.cloneElement(r.legendIcon, u);
        }
        return /* @__PURE__ */ F.createElement(BS, {
          fill: l,
          cx: o,
          cy: o,
          size: Yi,
          sizeType: "diameter",
          type: r.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var r = this, i = this.props, o = i.payload, a = i.iconSize, s = i.layout, l = i.formatter, u = i.inactiveColor, c = {
        x: 0,
        y: 0,
        width: Yi,
        height: Yi
      }, f = {
        display: s === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, h = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return o.map(function(m, v) {
        var g = m.formatter || l, y = at(sh(sh({
          "recharts-legend-item": !0
        }, "legend-item-".concat(v), !0), "inactive", m.inactive));
        if (m.type === "none")
          return null;
        var w = Ye(m.value) ? null : m.value;
        Ma(
          !Ye(m.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var C = m.inactive ? u : m.color;
        return /* @__PURE__ */ F.createElement("li", R7({
          className: y,
          style: f,
          key: "legend-item-".concat(v)
        }, Ic(r.props, m, v)), /* @__PURE__ */ F.createElement(N7, {
          width: a,
          height: a,
          viewBox: c,
          style: h
        }, r.renderIcon(m)), /* @__PURE__ */ F.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: C
          }
        }, g ? g(w, m, v) : w));
      });
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.payload, o = r.layout, a = r.align;
      if (!i || !i.length)
        return null;
      var s = {
        padding: 0,
        margin: 0,
        textAlign: o === "horizontal" ? a : "left"
      };
      return /* @__PURE__ */ F.createElement("ul", {
        className: "recharts-default-legend",
        style: s
      }, this.renderItems());
    }
  }]);
}(Yo);
sh(jS, "displayName", "Legend");
sh(jS, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var I4, FT;
function GEe() {
  if (FT) return I4;
  FT = 1;
  var e = Z2();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return I4 = t, I4;
}
var $4, BT;
function KEe() {
  if (BT) return $4;
  BT = 1;
  function e(t) {
    var n = this.__data__, r = n.delete(t);
    return this.size = n.size, r;
  }
  return $4 = e, $4;
}
var L4, jT;
function YEe() {
  if (jT) return L4;
  jT = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return L4 = e, L4;
}
var F4, VT;
function ZEe() {
  if (VT) return F4;
  VT = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return F4 = e, F4;
}
var B4, qT;
function XEe() {
  if (qT) return B4;
  qT = 1;
  var e = Z2(), t = PS(), n = TS(), r = 200;
  function i(o, a) {
    var s = this.__data__;
    if (s instanceof e) {
      var l = s.__data__;
      if (!t || l.length < r - 1)
        return l.push([o, a]), this.size = ++s.size, this;
      s = this.__data__ = new n(l);
    }
    return s.set(o, a), this.size = s.size, this;
  }
  return B4 = i, B4;
}
var j4, zT;
function gZ() {
  if (zT) return j4;
  zT = 1;
  var e = Z2(), t = GEe(), n = KEe(), r = YEe(), i = ZEe(), o = XEe();
  function a(s) {
    var l = this.__data__ = new e(s);
    this.size = l.size;
  }
  return a.prototype.clear = t, a.prototype.delete = n, a.prototype.get = r, a.prototype.has = i, a.prototype.set = o, j4 = a, j4;
}
var V4, WT;
function JEe() {
  if (WT) return V4;
  WT = 1;
  var e = "__lodash_hash_undefined__";
  function t(n) {
    return this.__data__.set(n, e), this;
  }
  return V4 = t, V4;
}
var q4, HT;
function QEe() {
  if (HT) return q4;
  HT = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return q4 = e, q4;
}
var z4, UT;
function vZ() {
  if (UT) return z4;
  UT = 1;
  var e = TS(), t = JEe(), n = QEe();
  function r(i) {
    var o = -1, a = i == null ? 0 : i.length;
    for (this.__data__ = new e(); ++o < a; )
      this.add(i[o]);
  }
  return r.prototype.add = r.prototype.push = t, r.prototype.has = n, z4 = r, z4;
}
var W4, GT;
function yZ() {
  if (GT) return W4;
  GT = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length; ++r < i; )
      if (n(t[r], r, t))
        return !0;
    return !1;
  }
  return W4 = e, W4;
}
var H4, KT;
function bZ() {
  if (KT) return H4;
  KT = 1;
  function e(t, n) {
    return t.has(n);
  }
  return H4 = e, H4;
}
var U4, YT;
function xZ() {
  if (YT) return U4;
  YT = 1;
  var e = vZ(), t = yZ(), n = bZ(), r = 1, i = 2;
  function o(a, s, l, u, c, f) {
    var h = l & r, m = a.length, v = s.length;
    if (m != v && !(h && v > m))
      return !1;
    var g = f.get(a), y = f.get(s);
    if (g && y)
      return g == s && y == a;
    var w = -1, C = !0, S = l & i ? new e() : void 0;
    for (f.set(a, s), f.set(s, a); ++w < m; ) {
      var N = a[w], E = s[w];
      if (u)
        var A = h ? u(E, N, w, s, a, f) : u(N, E, w, a, s, f);
      if (A !== void 0) {
        if (A)
          continue;
        C = !1;
        break;
      }
      if (S) {
        if (!t(s, function(O, T) {
          if (!n(S, T) && (N === O || c(N, O, l, u, f)))
            return S.push(T);
        })) {
          C = !1;
          break;
        }
      } else if (!(N === E || c(N, E, l, u, f))) {
        C = !1;
        break;
      }
    }
    return f.delete(a), f.delete(s), C;
  }
  return U4 = o, U4;
}
var G4, ZT;
function eNe() {
  if (ZT) return G4;
  ZT = 1;
  var e = ta(), t = e.Uint8Array;
  return G4 = t, G4;
}
var K4, XT;
function tNe() {
  if (XT) return K4;
  XT = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(i, o) {
      r[++n] = [o, i];
    }), r;
  }
  return K4 = e, K4;
}
var Y4, JT;
function VS() {
  if (JT) return Y4;
  JT = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(i) {
      r[++n] = i;
    }), r;
  }
  return Y4 = e, Y4;
}
var Z4, QT;
function nNe() {
  if (QT) return Z4;
  QT = 1;
  var e = Op(), t = eNe(), n = kS(), r = xZ(), i = tNe(), o = VS(), a = 1, s = 2, l = "[object Boolean]", u = "[object Date]", c = "[object Error]", f = "[object Map]", h = "[object Number]", m = "[object RegExp]", v = "[object Set]", g = "[object String]", y = "[object Symbol]", w = "[object ArrayBuffer]", C = "[object DataView]", S = e ? e.prototype : void 0, N = S ? S.valueOf : void 0;
  function E(A, O, T, M, L, I, j) {
    switch (T) {
      case C:
        if (A.byteLength != O.byteLength || A.byteOffset != O.byteOffset)
          return !1;
        A = A.buffer, O = O.buffer;
      case w:
        return !(A.byteLength != O.byteLength || !I(new t(A), new t(O)));
      case l:
      case u:
      case h:
        return n(+A, +O);
      case c:
        return A.name == O.name && A.message == O.message;
      case m:
      case g:
        return A == O + "";
      case f:
        var B = i;
      case v:
        var q = M & a;
        if (B || (B = o), A.size != O.size && !q)
          return !1;
        var G = j.get(A);
        if (G)
          return G == O;
        M |= s, j.set(A, O);
        var U = r(B(A), B(O), M, L, I, j);
        return j.delete(A), U;
      case y:
        if (N)
          return N.call(A) == N.call(O);
    }
    return !1;
  }
  return Z4 = E, Z4;
}
var X4, eM;
function wZ() {
  if (eM) return X4;
  eM = 1;
  function e(t, n) {
    for (var r = -1, i = n.length, o = t.length; ++r < i; )
      t[o + r] = n[r];
    return t;
  }
  return X4 = e, X4;
}
var J4, tM;
function rNe() {
  if (tM) return J4;
  tM = 1;
  var e = wZ(), t = ei();
  function n(r, i, o) {
    var a = i(r);
    return t(r) ? a : e(a, o(r));
  }
  return J4 = n, J4;
}
var Q4, nM;
function iNe() {
  if (nM) return Q4;
  nM = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length, o = 0, a = []; ++r < i; ) {
      var s = t[r];
      n(s, r, t) && (a[o++] = s);
    }
    return a;
  }
  return Q4 = e, Q4;
}
var e6, rM;
function oNe() {
  if (rM) return e6;
  rM = 1;
  function e() {
    return [];
  }
  return e6 = e, e6;
}
var t6, iM;
function aNe() {
  if (iM) return t6;
  iM = 1;
  var e = iNe(), t = oNe(), n = Object.prototype, r = n.propertyIsEnumerable, i = Object.getOwnPropertySymbols, o = i ? function(a) {
    return a == null ? [] : (a = Object(a), e(i(a), function(s) {
      return r.call(a, s);
    }));
  } : t;
  return t6 = o, t6;
}
var n6, oM;
function sNe() {
  if (oM) return n6;
  oM = 1;
  function e(t, n) {
    for (var r = -1, i = Array(t); ++r < t; )
      i[r] = n(r);
    return i;
  }
  return n6 = e, n6;
}
var r6, aM;
function lNe() {
  if (aM) return r6;
  aM = 1;
  var e = Za(), t = Xa(), n = "[object Arguments]";
  function r(i) {
    return t(i) && e(i) == n;
  }
  return r6 = r, r6;
}
var i6, sM;
function qS() {
  if (sM) return i6;
  sM = 1;
  var e = lNe(), t = Xa(), n = Object.prototype, r = n.hasOwnProperty, i = n.propertyIsEnumerable, o = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(a) {
    return t(a) && r.call(a, "callee") && !i.call(a, "callee");
  };
  return i6 = o, i6;
}
var kf = { exports: {} }, o6, lM;
function uNe() {
  if (lM) return o6;
  lM = 1;
  function e() {
    return !1;
  }
  return o6 = e, o6;
}
kf.exports;
var uM;
function CZ() {
  return uM || (uM = 1, function(e, t) {
    var n = ta(), r = uNe(), i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, s = a ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, u = l || r;
    e.exports = u;
  }(kf, kf.exports)), kf.exports;
}
var a6, cM;
function zS() {
  if (cM) return a6;
  cM = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function n(r, i) {
    var o = typeof r;
    return i = i ?? e, !!i && (o == "number" || o != "symbol" && t.test(r)) && r > -1 && r % 1 == 0 && r < i;
  }
  return a6 = n, a6;
}
var s6, dM;
function WS() {
  if (dM) return s6;
  dM = 1;
  var e = 9007199254740991;
  function t(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= e;
  }
  return s6 = t, s6;
}
var l6, fM;
function cNe() {
  if (fM) return l6;
  fM = 1;
  var e = Za(), t = WS(), n = Xa(), r = "[object Arguments]", i = "[object Array]", o = "[object Boolean]", a = "[object Date]", s = "[object Error]", l = "[object Function]", u = "[object Map]", c = "[object Number]", f = "[object Object]", h = "[object RegExp]", m = "[object Set]", v = "[object String]", g = "[object WeakMap]", y = "[object ArrayBuffer]", w = "[object DataView]", C = "[object Float32Array]", S = "[object Float64Array]", N = "[object Int8Array]", E = "[object Int16Array]", A = "[object Int32Array]", O = "[object Uint8Array]", T = "[object Uint8ClampedArray]", M = "[object Uint16Array]", L = "[object Uint32Array]", I = {};
  I[C] = I[S] = I[N] = I[E] = I[A] = I[O] = I[T] = I[M] = I[L] = !0, I[r] = I[i] = I[y] = I[o] = I[w] = I[a] = I[s] = I[l] = I[u] = I[c] = I[f] = I[h] = I[m] = I[v] = I[g] = !1;
  function j(B) {
    return n(B) && t(B.length) && !!I[e(B)];
  }
  return l6 = j, l6;
}
var u6, hM;
function SZ() {
  if (hM) return u6;
  hM = 1;
  function e(t) {
    return function(n) {
      return t(n);
    };
  }
  return u6 = e, u6;
}
var Pf = { exports: {} };
Pf.exports;
var pM;
function dNe() {
  return pM || (pM = 1, function(e, t) {
    var n = zY(), r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, a = o && n.process, s = function() {
      try {
        var l = i && i.require && i.require("util").types;
        return l || a && a.binding && a.binding("util");
      } catch {
      }
    }();
    e.exports = s;
  }(Pf, Pf.exports)), Pf.exports;
}
var c6, mM;
function _Z() {
  if (mM) return c6;
  mM = 1;
  var e = cNe(), t = SZ(), n = dNe(), r = n && n.isTypedArray, i = r ? t(r) : e;
  return c6 = i, c6;
}
var d6, gM;
function fNe() {
  if (gM) return d6;
  gM = 1;
  var e = sNe(), t = qS(), n = ei(), r = CZ(), i = zS(), o = _Z(), a = Object.prototype, s = a.hasOwnProperty;
  function l(u, c) {
    var f = n(u), h = !f && t(u), m = !f && !h && r(u), v = !f && !h && !m && o(u), g = f || h || m || v, y = g ? e(u.length, String) : [], w = y.length;
    for (var C in u)
      (c || s.call(u, C)) && !(g && // Safari 9 has enumerable `arguments.length` in strict mode.
      (C == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      m && (C == "offset" || C == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      v && (C == "buffer" || C == "byteLength" || C == "byteOffset") || // Skip index properties.
      i(C, w))) && y.push(C);
    return y;
  }
  return d6 = l, d6;
}
var f6, vM;
function hNe() {
  if (vM) return f6;
  vM = 1;
  var e = Object.prototype;
  function t(n) {
    var r = n && n.constructor, i = typeof r == "function" && r.prototype || e;
    return n === i;
  }
  return f6 = t, f6;
}
var h6, yM;
function EZ() {
  if (yM) return h6;
  yM = 1;
  function e(t, n) {
    return function(r) {
      return t(n(r));
    };
  }
  return h6 = e, h6;
}
var p6, bM;
function pNe() {
  if (bM) return p6;
  bM = 1;
  var e = EZ(), t = e(Object.keys, Object);
  return p6 = t, p6;
}
var m6, xM;
function mNe() {
  if (xM) return m6;
  xM = 1;
  var e = hNe(), t = pNe(), n = Object.prototype, r = n.hasOwnProperty;
  function i(o) {
    if (!e(o))
      return t(o);
    var a = [];
    for (var s in Object(o))
      r.call(o, s) && s != "constructor" && a.push(s);
    return a;
  }
  return m6 = i, m6;
}
var g6, wM;
function Tp() {
  if (wM) return g6;
  wM = 1;
  var e = OS(), t = WS();
  function n(r) {
    return r != null && t(r.length) && !e(r);
  }
  return g6 = n, g6;
}
var v6, CM;
function iv() {
  if (CM) return v6;
  CM = 1;
  var e = fNe(), t = mNe(), n = Tp();
  function r(i) {
    return n(i) ? e(i) : t(i);
  }
  return v6 = r, v6;
}
var y6, SM;
function gNe() {
  if (SM) return y6;
  SM = 1;
  var e = rNe(), t = aNe(), n = iv();
  function r(i) {
    return e(i, n, t);
  }
  return y6 = r, y6;
}
var b6, _M;
function vNe() {
  if (_M) return b6;
  _M = 1;
  var e = gNe(), t = 1, n = Object.prototype, r = n.hasOwnProperty;
  function i(o, a, s, l, u, c) {
    var f = s & t, h = e(o), m = h.length, v = e(a), g = v.length;
    if (m != g && !f)
      return !1;
    for (var y = m; y--; ) {
      var w = h[y];
      if (!(f ? w in a : r.call(a, w)))
        return !1;
    }
    var C = c.get(o), S = c.get(a);
    if (C && S)
      return C == a && S == o;
    var N = !0;
    c.set(o, a), c.set(a, o);
    for (var E = f; ++y < m; ) {
      w = h[y];
      var A = o[w], O = a[w];
      if (l)
        var T = f ? l(O, A, w, a, o, c) : l(A, O, w, o, a, c);
      if (!(T === void 0 ? A === O || u(A, O, s, l, c) : T)) {
        N = !1;
        break;
      }
      E || (E = w == "constructor");
    }
    if (N && !E) {
      var M = o.constructor, L = a.constructor;
      M != L && "constructor" in o && "constructor" in a && !(typeof M == "function" && M instanceof M && typeof L == "function" && L instanceof L) && (N = !1);
    }
    return c.delete(o), c.delete(a), N;
  }
  return b6 = i, b6;
}
var x6, EM;
function yNe() {
  if (EM) return x6;
  EM = 1;
  var e = hu(), t = ta(), n = e(t, "DataView");
  return x6 = n, x6;
}
var w6, NM;
function bNe() {
  if (NM) return w6;
  NM = 1;
  var e = hu(), t = ta(), n = e(t, "Promise");
  return w6 = n, w6;
}
var C6, AM;
function NZ() {
  if (AM) return C6;
  AM = 1;
  var e = hu(), t = ta(), n = e(t, "Set");
  return C6 = n, C6;
}
var S6, OM;
function xNe() {
  if (OM) return S6;
  OM = 1;
  var e = hu(), t = ta(), n = e(t, "WeakMap");
  return S6 = n, S6;
}
var _6, kM;
function wNe() {
  if (kM) return _6;
  kM = 1;
  var e = yNe(), t = PS(), n = bNe(), r = NZ(), i = xNe(), o = Za(), a = WY(), s = "[object Map]", l = "[object Object]", u = "[object Promise]", c = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", m = a(e), v = a(t), g = a(n), y = a(r), w = a(i), C = o;
  return (e && C(new e(new ArrayBuffer(1))) != h || t && C(new t()) != s || n && C(n.resolve()) != u || r && C(new r()) != c || i && C(new i()) != f) && (C = function(S) {
    var N = o(S), E = N == l ? S.constructor : void 0, A = E ? a(E) : "";
    if (A)
      switch (A) {
        case m:
          return h;
        case v:
          return s;
        case g:
          return u;
        case y:
          return c;
        case w:
          return f;
      }
    return N;
  }), _6 = C, _6;
}
var E6, PM;
function CNe() {
  if (PM) return E6;
  PM = 1;
  var e = gZ(), t = xZ(), n = nNe(), r = vNe(), i = wNe(), o = ei(), a = CZ(), s = _Z(), l = 1, u = "[object Arguments]", c = "[object Array]", f = "[object Object]", h = Object.prototype, m = h.hasOwnProperty;
  function v(g, y, w, C, S, N) {
    var E = o(g), A = o(y), O = E ? c : i(g), T = A ? c : i(y);
    O = O == u ? f : O, T = T == u ? f : T;
    var M = O == f, L = T == f, I = O == T;
    if (I && a(g)) {
      if (!a(y))
        return !1;
      E = !0, M = !1;
    }
    if (I && !M)
      return N || (N = new e()), E || s(g) ? t(g, y, w, C, S, N) : n(g, y, O, w, C, S, N);
    if (!(w & l)) {
      var j = M && m.call(g, "__wrapped__"), B = L && m.call(y, "__wrapped__");
      if (j || B) {
        var q = j ? g.value() : g, G = B ? y.value() : y;
        return N || (N = new e()), S(q, G, w, C, N);
      }
    }
    return I ? (N || (N = new e()), r(g, y, w, C, S, N)) : !1;
  }
  return E6 = v, E6;
}
var N6, TM;
function HS() {
  if (TM) return N6;
  TM = 1;
  var e = CNe(), t = Xa();
  function n(r, i, o, a, s) {
    return r === i ? !0 : r == null || i == null || !t(r) && !t(i) ? r !== r && i !== i : e(r, i, o, a, n, s);
  }
  return N6 = n, N6;
}
var A6, MM;
function SNe() {
  if (MM) return A6;
  MM = 1;
  var e = gZ(), t = HS(), n = 1, r = 2;
  function i(o, a, s, l) {
    var u = s.length, c = u, f = !l;
    if (o == null)
      return !c;
    for (o = Object(o); u--; ) {
      var h = s[u];
      if (f && h[2] ? h[1] !== o[h[0]] : !(h[0] in o))
        return !1;
    }
    for (; ++u < c; ) {
      h = s[u];
      var m = h[0], v = o[m], g = h[1];
      if (f && h[2]) {
        if (v === void 0 && !(m in o))
          return !1;
      } else {
        var y = new e();
        if (l)
          var w = l(v, g, m, o, a, y);
        if (!(w === void 0 ? t(g, v, n | r, l, y) : w))
          return !1;
      }
    }
    return !0;
  }
  return A6 = i, A6;
}
var O6, RM;
function AZ() {
  if (RM) return O6;
  RM = 1;
  var e = el();
  function t(n) {
    return n === n && !e(n);
  }
  return O6 = t, O6;
}
var k6, DM;
function _Ne() {
  if (DM) return k6;
  DM = 1;
  var e = AZ(), t = iv();
  function n(r) {
    for (var i = t(r), o = i.length; o--; ) {
      var a = i[o], s = r[a];
      i[o] = [a, s, e(s)];
    }
    return i;
  }
  return k6 = n, k6;
}
var P6, IM;
function OZ() {
  if (IM) return P6;
  IM = 1;
  function e(t, n) {
    return function(r) {
      return r == null ? !1 : r[t] === n && (n !== void 0 || t in Object(r));
    };
  }
  return P6 = e, P6;
}
var T6, $M;
function ENe() {
  if ($M) return T6;
  $M = 1;
  var e = SNe(), t = _Ne(), n = OZ();
  function r(i) {
    var o = t(i);
    return o.length == 1 && o[0][2] ? n(o[0][0], o[0][1]) : function(a) {
      return a === i || e(a, i, o);
    };
  }
  return T6 = r, T6;
}
var M6, LM;
function NNe() {
  if (LM) return M6;
  LM = 1;
  function e(t, n) {
    return t != null && n in Object(t);
  }
  return M6 = e, M6;
}
var R6, FM;
function ANe() {
  if (FM) return R6;
  FM = 1;
  var e = GY(), t = qS(), n = ei(), r = zS(), i = WS(), o = J2();
  function a(s, l, u) {
    l = e(l, s);
    for (var c = -1, f = l.length, h = !1; ++c < f; ) {
      var m = o(l[c]);
      if (!(h = s != null && u(s, m)))
        break;
      s = s[m];
    }
    return h || ++c != f ? h : (f = s == null ? 0 : s.length, !!f && i(f) && r(m, f) && (n(s) || t(s)));
  }
  return R6 = a, R6;
}
var D6, BM;
function ONe() {
  if (BM) return D6;
  BM = 1;
  var e = NNe(), t = ANe();
  function n(r, i) {
    return r != null && t(r, i, e);
  }
  return D6 = n, D6;
}
var I6, jM;
function kNe() {
  if (jM) return I6;
  jM = 1;
  var e = HS(), t = KY(), n = ONe(), r = AS(), i = AZ(), o = OZ(), a = J2(), s = 1, l = 2;
  function u(c, f) {
    return r(c) && i(f) ? o(a(c), f) : function(h) {
      var m = t(h, c);
      return m === void 0 && m === f ? n(h, c) : e(f, m, s | l);
    };
  }
  return I6 = u, I6;
}
var $6, VM;
function Md() {
  if (VM) return $6;
  VM = 1;
  function e(t) {
    return t;
  }
  return $6 = e, $6;
}
var L6, qM;
function PNe() {
  if (qM) return L6;
  qM = 1;
  function e(t) {
    return function(n) {
      return n == null ? void 0 : n[t];
    };
  }
  return L6 = e, L6;
}
var F6, zM;
function TNe() {
  if (zM) return F6;
  zM = 1;
  var e = RS();
  function t(n) {
    return function(r) {
      return e(r, n);
    };
  }
  return F6 = t, F6;
}
var B6, WM;
function MNe() {
  if (WM) return B6;
  WM = 1;
  var e = PNe(), t = TNe(), n = AS(), r = J2();
  function i(o) {
    return n(o) ? e(r(o)) : t(o);
  }
  return B6 = i, B6;
}
var j6, HM;
function na() {
  if (HM) return j6;
  HM = 1;
  var e = ENe(), t = kNe(), n = Md(), r = ei(), i = MNe();
  function o(a) {
    return typeof a == "function" ? a : a == null ? n : typeof a == "object" ? r(a) ? t(a[0], a[1]) : e(a) : i(a);
  }
  return j6 = o, j6;
}
var V6, UM;
function kZ() {
  if (UM) return V6;
  UM = 1;
  function e(t, n, r, i) {
    for (var o = t.length, a = r + (i ? 1 : -1); i ? a-- : ++a < o; )
      if (n(t[a], a, t))
        return a;
    return -1;
  }
  return V6 = e, V6;
}
var q6, GM;
function RNe() {
  if (GM) return q6;
  GM = 1;
  function e(t) {
    return t !== t;
  }
  return q6 = e, q6;
}
var z6, KM;
function DNe() {
  if (KM) return z6;
  KM = 1;
  function e(t, n, r) {
    for (var i = r - 1, o = t.length; ++i < o; )
      if (t[i] === n)
        return i;
    return -1;
  }
  return z6 = e, z6;
}
var W6, YM;
function INe() {
  if (YM) return W6;
  YM = 1;
  var e = kZ(), t = RNe(), n = DNe();
  function r(i, o, a) {
    return o === o ? n(i, o, a) : e(i, t, a);
  }
  return W6 = r, W6;
}
var H6, ZM;
function $Ne() {
  if (ZM) return H6;
  ZM = 1;
  var e = INe();
  function t(n, r) {
    var i = n == null ? 0 : n.length;
    return !!i && e(n, r, 0) > -1;
  }
  return H6 = t, H6;
}
var U6, XM;
function LNe() {
  if (XM) return U6;
  XM = 1;
  function e(t, n, r) {
    for (var i = -1, o = t == null ? 0 : t.length; ++i < o; )
      if (r(n, t[i]))
        return !0;
    return !1;
  }
  return U6 = e, U6;
}
var G6, JM;
function FNe() {
  if (JM) return G6;
  JM = 1;
  function e() {
  }
  return G6 = e, G6;
}
var K6, QM;
function BNe() {
  if (QM) return K6;
  QM = 1;
  var e = NZ(), t = FNe(), n = VS(), r = 1 / 0, i = e && 1 / n(new e([, -0]))[1] == r ? function(o) {
    return new e(o);
  } : t;
  return K6 = i, K6;
}
var Y6, eR;
function jNe() {
  if (eR) return Y6;
  eR = 1;
  var e = vZ(), t = $Ne(), n = LNe(), r = bZ(), i = BNe(), o = VS(), a = 200;
  function s(l, u, c) {
    var f = -1, h = t, m = l.length, v = !0, g = [], y = g;
    if (c)
      v = !1, h = n;
    else if (m >= a) {
      var w = u ? null : i(l);
      if (w)
        return o(w);
      v = !1, h = r, y = new e();
    } else
      y = u ? [] : g;
    e:
      for (; ++f < m; ) {
        var C = l[f], S = u ? u(C) : C;
        if (C = c || C !== 0 ? C : 0, v && S === S) {
          for (var N = y.length; N--; )
            if (y[N] === S)
              continue e;
          u && y.push(S), g.push(C);
        } else h(y, S, c) || (y !== g && y.push(S), g.push(C));
      }
    return g;
  }
  return Y6 = s, Y6;
}
var Z6, tR;
function VNe() {
  if (tR) return Z6;
  tR = 1;
  var e = na(), t = jNe();
  function n(r, i) {
    return r && r.length ? t(r, e(i, 2)) : [];
  }
  return Z6 = n, Z6;
}
var qNe = VNe();
const nR = /* @__PURE__ */ Rt(qNe);
function PZ(e, t, n) {
  return t === !0 ? nR(e, n) : Ye(t) ? nR(e, t) : e;
}
function Fc(e) {
  "@babel/helpers - typeof";
  return Fc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fc(e);
}
var zNe = ["ref"];
function rR(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ya(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? rR(Object(n), !0).forEach(function(r) {
      ov(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rR(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function WNe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function iR(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, MZ(r.key), r);
  }
}
function HNe(e, t, n) {
  return t && iR(e.prototype, t), n && iR(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function UNe(e, t, n) {
  return t = Sm(t), GNe(e, TZ() ? Reflect.construct(t, n || [], Sm(e).constructor) : t.apply(e, n));
}
function GNe(e, t) {
  if (t && (Fc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return KNe(e);
}
function KNe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function TZ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (TZ = function() {
    return !!e;
  })();
}
function Sm(e) {
  return Sm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Sm(e);
}
function YNe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && I7(e, t);
}
function I7(e, t) {
  return I7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, I7(e, t);
}
function ov(e, t, n) {
  return t = MZ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function MZ(e) {
  var t = ZNe(e, "string");
  return Fc(t) == "symbol" ? t : t + "";
}
function ZNe(e, t) {
  if (Fc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Fc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function XNe(e, t) {
  if (e == null) return {};
  var n = JNe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function JNe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function QNe(e) {
  return e.value;
}
function eAe(e, t) {
  if (/* @__PURE__ */ F.isValidElement(e))
    return /* @__PURE__ */ F.cloneElement(e, t);
  if (typeof e == "function")
    return /* @__PURE__ */ F.createElement(e, t);
  t.ref;
  var n = XNe(t, zNe);
  return /* @__PURE__ */ F.createElement(jS, n);
}
var oR = 1, Ur = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    WNe(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = UNe(this, t, [].concat(i)), ov(n, "lastBoundingBox", {
      width: -1,
      height: -1
    }), n;
  }
  return YNe(t, e), HNe(t, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var r = this.wrapperNode.getBoundingClientRect();
        return r.height = this.wrapperNode.offsetHeight, r.width = this.wrapperNode.offsetWidth, r;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var r = this.props.onBBoxUpdate, i = this.getBBox();
      i ? (Math.abs(i.width - this.lastBoundingBox.width) > oR || Math.abs(i.height - this.lastBoundingBox.height) > oR) && (this.lastBoundingBox.width = i.width, this.lastBoundingBox.height = i.height, r && r(i)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, r && r(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? ya({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(r) {
      var i = this.props, o = i.layout, a = i.align, s = i.verticalAlign, l = i.margin, u = i.chartWidth, c = i.chartHeight, f, h;
      if (!r || (r.left === void 0 || r.left === null) && (r.right === void 0 || r.right === null))
        if (a === "center" && o === "vertical") {
          var m = this.getBBoxSnapshot();
          f = {
            left: ((u || 0) - m.width) / 2
          };
        } else
          f = a === "right" ? {
            right: l && l.right || 0
          } : {
            left: l && l.left || 0
          };
      if (!r || (r.top === void 0 || r.top === null) && (r.bottom === void 0 || r.bottom === null))
        if (s === "middle") {
          var v = this.getBBoxSnapshot();
          h = {
            top: ((c || 0) - v.height) / 2
          };
        } else
          h = s === "bottom" ? {
            bottom: l && l.bottom || 0
          } : {
            top: l && l.top || 0
          };
      return ya(ya({}, f), h);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.content, a = i.width, s = i.height, l = i.wrapperStyle, u = i.payloadUniqBy, c = i.payload, f = ya(ya({
        position: "absolute",
        width: a || "auto",
        height: s || "auto"
      }, this.getDefaultPosition(l)), l);
      return /* @__PURE__ */ F.createElement("div", {
        className: "recharts-legend-wrapper",
        style: f,
        ref: function(m) {
          r.wrapperNode = m;
        }
      }, eAe(o, ya(ya({}, this.props), {}, {
        payload: PZ(c, u, QNe)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(r, i) {
      var o = ya(ya({}, this.defaultProps), r.props), a = o.layout;
      return a === "vertical" && we(r.props.height) ? {
        height: r.props.height
      } : a === "horizontal" ? {
        width: r.props.width || i
      } : null;
    }
  }]);
}(Yo);
ov(Ur, "displayName", "Legend");
ov(Ur, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var X6, aR;
function tAe() {
  if (aR) return X6;
  aR = 1;
  var e = Op(), t = qS(), n = ei(), r = e ? e.isConcatSpreadable : void 0;
  function i(o) {
    return n(o) || t(o) || !!(r && o && o[r]);
  }
  return X6 = i, X6;
}
var J6, sR;
function RZ() {
  if (sR) return J6;
  sR = 1;
  var e = wZ(), t = tAe();
  function n(r, i, o, a, s) {
    var l = -1, u = r.length;
    for (o || (o = t), s || (s = []); ++l < u; ) {
      var c = r[l];
      i > 0 && o(c) ? i > 1 ? n(c, i - 1, o, a, s) : e(s, c) : a || (s[s.length] = c);
    }
    return s;
  }
  return J6 = n, J6;
}
var Q6, lR;
function nAe() {
  if (lR) return Q6;
  lR = 1;
  function e(t) {
    return function(n, r, i) {
      for (var o = -1, a = Object(n), s = i(n), l = s.length; l--; ) {
        var u = s[t ? l : ++o];
        if (r(a[u], u, a) === !1)
          break;
      }
      return n;
    };
  }
  return Q6 = e, Q6;
}
var e5, uR;
function rAe() {
  if (uR) return e5;
  uR = 1;
  var e = nAe(), t = e();
  return e5 = t, e5;
}
var t5, cR;
function DZ() {
  if (cR) return t5;
  cR = 1;
  var e = rAe(), t = iv();
  function n(r, i) {
    return r && e(r, i, t);
  }
  return t5 = n, t5;
}
var n5, dR;
function iAe() {
  if (dR) return n5;
  dR = 1;
  var e = Tp();
  function t(n, r) {
    return function(i, o) {
      if (i == null)
        return i;
      if (!e(i))
        return n(i, o);
      for (var a = i.length, s = r ? a : -1, l = Object(i); (r ? s-- : ++s < a) && o(l[s], s, l) !== !1; )
        ;
      return i;
    };
  }
  return n5 = t, n5;
}
var r5, fR;
function US() {
  if (fR) return r5;
  fR = 1;
  var e = DZ(), t = iAe(), n = t(e);
  return r5 = n, r5;
}
var i5, hR;
function IZ() {
  if (hR) return i5;
  hR = 1;
  var e = US(), t = Tp();
  function n(r, i) {
    var o = -1, a = t(r) ? Array(r.length) : [];
    return e(r, function(s, l, u) {
      a[++o] = i(s, l, u);
    }), a;
  }
  return i5 = n, i5;
}
var o5, pR;
function oAe() {
  if (pR) return o5;
  pR = 1;
  function e(t, n) {
    var r = t.length;
    for (t.sort(n); r--; )
      t[r] = t[r].value;
    return t;
  }
  return o5 = e, o5;
}
var a5, mR;
function aAe() {
  if (mR) return a5;
  mR = 1;
  var e = Pd();
  function t(n, r) {
    if (n !== r) {
      var i = n !== void 0, o = n === null, a = n === n, s = e(n), l = r !== void 0, u = r === null, c = r === r, f = e(r);
      if (!u && !f && !s && n > r || s && l && c && !u && !f || o && l && c || !i && c || !a)
        return 1;
      if (!o && !s && !f && n < r || f && i && a && !o && !s || u && i && a || !l && a || !c)
        return -1;
    }
    return 0;
  }
  return a5 = t, a5;
}
var s5, gR;
function sAe() {
  if (gR) return s5;
  gR = 1;
  var e = aAe();
  function t(n, r, i) {
    for (var o = -1, a = n.criteria, s = r.criteria, l = a.length, u = i.length; ++o < l; ) {
      var c = e(a[o], s[o]);
      if (c) {
        if (o >= u)
          return c;
        var f = i[o];
        return c * (f == "desc" ? -1 : 1);
      }
    }
    return n.index - r.index;
  }
  return s5 = t, s5;
}
var l5, vR;
function lAe() {
  if (vR) return l5;
  vR = 1;
  var e = MS(), t = RS(), n = na(), r = IZ(), i = oAe(), o = SZ(), a = sAe(), s = Md(), l = ei();
  function u(c, f, h) {
    f.length ? f = e(f, function(g) {
      return l(g) ? function(y) {
        return t(y, g.length === 1 ? g[0] : g);
      } : g;
    }) : f = [s];
    var m = -1;
    f = e(f, o(n));
    var v = r(c, function(g, y, w) {
      var C = e(f, function(S) {
        return S(g);
      });
      return { criteria: C, index: ++m, value: g };
    });
    return i(v, function(g, y) {
      return a(g, y, h);
    });
  }
  return l5 = u, l5;
}
var u5, yR;
function uAe() {
  if (yR) return u5;
  yR = 1;
  function e(t, n, r) {
    switch (r.length) {
      case 0:
        return t.call(n);
      case 1:
        return t.call(n, r[0]);
      case 2:
        return t.call(n, r[0], r[1]);
      case 3:
        return t.call(n, r[0], r[1], r[2]);
    }
    return t.apply(n, r);
  }
  return u5 = e, u5;
}
var c5, bR;
function cAe() {
  if (bR) return c5;
  bR = 1;
  var e = uAe(), t = Math.max;
  function n(r, i, o) {
    return i = t(i === void 0 ? r.length - 1 : i, 0), function() {
      for (var a = arguments, s = -1, l = t(a.length - i, 0), u = Array(l); ++s < l; )
        u[s] = a[i + s];
      s = -1;
      for (var c = Array(i + 1); ++s < i; )
        c[s] = a[s];
      return c[i] = o(u), e(r, this, c);
    };
  }
  return c5 = n, c5;
}
var d5, xR;
function dAe() {
  if (xR) return d5;
  xR = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return d5 = e, d5;
}
var f5, wR;
function $Z() {
  if (wR) return f5;
  wR = 1;
  var e = hu(), t = function() {
    try {
      var n = e(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch {
    }
  }();
  return f5 = t, f5;
}
var h5, CR;
function fAe() {
  if (CR) return h5;
  CR = 1;
  var e = dAe(), t = $Z(), n = Md(), r = t ? function(i, o) {
    return t(i, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : n;
  return h5 = r, h5;
}
var p5, SR;
function hAe() {
  if (SR) return p5;
  SR = 1;
  var e = 800, t = 16, n = Date.now;
  function r(i) {
    var o = 0, a = 0;
    return function() {
      var s = n(), l = t - (s - a);
      if (a = s, l > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return i.apply(void 0, arguments);
    };
  }
  return p5 = r, p5;
}
var m5, _R;
function pAe() {
  if (_R) return m5;
  _R = 1;
  var e = fAe(), t = hAe(), n = t(e);
  return m5 = n, m5;
}
var g5, ER;
function mAe() {
  if (ER) return g5;
  ER = 1;
  var e = Md(), t = cAe(), n = pAe();
  function r(i, o) {
    return n(t(i, o, e), i + "");
  }
  return g5 = r, g5;
}
var v5, NR;
function av() {
  if (NR) return v5;
  NR = 1;
  var e = kS(), t = Tp(), n = zS(), r = el();
  function i(o, a, s) {
    if (!r(s))
      return !1;
    var l = typeof a;
    return (l == "number" ? t(s) && n(a, s.length) : l == "string" && a in s) ? e(s[a], o) : !1;
  }
  return v5 = i, v5;
}
var y5, AR;
function gAe() {
  if (AR) return y5;
  AR = 1;
  var e = RZ(), t = lAe(), n = mAe(), r = av(), i = n(function(o, a) {
    if (o == null)
      return [];
    var s = a.length;
    return s > 1 && r(o, a[0], a[1]) ? a = [] : s > 2 && r(a[0], a[1], a[2]) && (a = [a[0]]), t(o, e(a, 1), []);
  });
  return y5 = i, y5;
}
var vAe = gAe();
const GS = /* @__PURE__ */ Rt(vAe);
function lh(e) {
  "@babel/helpers - typeof";
  return lh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, lh(e);
}
function $7() {
  return $7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $7.apply(this, arguments);
}
function yAe(e, t) {
  return CAe(e) || wAe(e, t) || xAe(e, t) || bAe();
}
function bAe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xAe(e, t) {
  if (e) {
    if (typeof e == "string") return OR(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return OR(e, t);
  }
}
function OR(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function wAe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, u = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (c) {
      u = !0, i = c;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw i;
      }
    }
    return s;
  }
}
function CAe(e) {
  if (Array.isArray(e)) return e;
}
function kR(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function b5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? kR(Object(n), !0).forEach(function(r) {
      SAe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : kR(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function SAe(e, t, n) {
  return t = _Ae(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _Ae(e) {
  var t = EAe(e, "string");
  return lh(t) == "symbol" ? t : t + "";
}
function EAe(e, t) {
  if (lh(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (lh(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function NAe(e) {
  return Array.isArray(e) && Dn(e[0]) && Dn(e[1]) ? e.join(" ~ ") : e;
}
var AAe = function(t) {
  var n = t.separator, r = n === void 0 ? " : " : n, i = t.contentStyle, o = i === void 0 ? {} : i, a = t.itemStyle, s = a === void 0 ? {} : a, l = t.labelStyle, u = l === void 0 ? {} : l, c = t.payload, f = t.formatter, h = t.itemSorter, m = t.wrapperClassName, v = t.labelClassName, g = t.label, y = t.labelFormatter, w = t.accessibilityLayer, C = w === void 0 ? !1 : w, S = function() {
    if (c && c.length) {
      var j = {
        padding: 0,
        margin: 0
      }, B = (h ? GS(c, h) : c).map(function(q, G) {
        if (q.type === "none")
          return null;
        var U = b5({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: q.color || "#000"
        }, s), V = q.formatter || f || NAe, H = q.value, Z = q.name, de = H, ne = Z;
        if (V && de != null && ne != null) {
          var Y = V(H, Z, q, G, c);
          if (Array.isArray(Y)) {
            var le = yAe(Y, 2);
            de = le[0], ne = le[1];
          } else
            de = Y;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ F.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(G),
            style: U
          }, Dn(ne) ? /* @__PURE__ */ F.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, ne) : null, Dn(ne) ? /* @__PURE__ */ F.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, r) : null, /* @__PURE__ */ F.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, de), /* @__PURE__ */ F.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, q.unit || ""))
        );
      });
      return /* @__PURE__ */ F.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: j
      }, B);
    }
    return null;
  }, N = b5({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, o), E = b5({
    margin: 0
  }, u), A = !yt(g), O = A ? g : "", T = at("recharts-default-tooltip", m), M = at("recharts-tooltip-label", v);
  A && y && c !== void 0 && c !== null && (O = y(g, c));
  var L = C ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ F.createElement("div", $7({
    className: T,
    style: N
  }, L), /* @__PURE__ */ F.createElement("p", {
    className: M,
    style: E
  }, /* @__PURE__ */ F.isValidElement(O) ? O : "".concat(O)), S());
};
function uh(e) {
  "@babel/helpers - typeof";
  return uh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, uh(e);
}
function f1(e, t, n) {
  return t = OAe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function OAe(e) {
  var t = kAe(e, "string");
  return uh(t) == "symbol" ? t : t + "";
}
function kAe(e, t) {
  if (uh(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (uh(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ff = "recharts-tooltip-wrapper", PAe = {
  visibility: "hidden"
};
function TAe(e) {
  var t = e.coordinate, n = e.translateX, r = e.translateY;
  return at(ff, f1(f1(f1(f1({}, "".concat(ff, "-right"), we(n) && t && we(t.x) && n >= t.x), "".concat(ff, "-left"), we(n) && t && we(t.x) && n < t.x), "".concat(ff, "-bottom"), we(r) && t && we(t.y) && r >= t.y), "".concat(ff, "-top"), we(r) && t && we(t.y) && r < t.y));
}
function PR(e) {
  var t = e.allowEscapeViewBox, n = e.coordinate, r = e.key, i = e.offsetTopLeft, o = e.position, a = e.reverseDirection, s = e.tooltipDimension, l = e.viewBox, u = e.viewBoxDimension;
  if (o && we(o[r]))
    return o[r];
  var c = n[r] - s - i, f = n[r] + i;
  if (t[r])
    return a[r] ? c : f;
  if (a[r]) {
    var h = c, m = l[r];
    return h < m ? Math.max(f, l[r]) : Math.max(c, l[r]);
  }
  var v = f + s, g = l[r] + u;
  return v > g ? Math.max(c, l[r]) : Math.max(f, l[r]);
}
function MAe(e) {
  var t = e.translateX, n = e.translateY, r = e.useTranslate3d;
  return {
    transform: r ? "translate3d(".concat(t, "px, ").concat(n, "px, 0)") : "translate(".concat(t, "px, ").concat(n, "px)")
  };
}
function RAe(e) {
  var t = e.allowEscapeViewBox, n = e.coordinate, r = e.offsetTopLeft, i = e.position, o = e.reverseDirection, a = e.tooltipBox, s = e.useTranslate3d, l = e.viewBox, u, c, f;
  return a.height > 0 && a.width > 0 && n ? (c = PR({
    allowEscapeViewBox: t,
    coordinate: n,
    key: "x",
    offsetTopLeft: r,
    position: i,
    reverseDirection: o,
    tooltipDimension: a.width,
    viewBox: l,
    viewBoxDimension: l.width
  }), f = PR({
    allowEscapeViewBox: t,
    coordinate: n,
    key: "y",
    offsetTopLeft: r,
    position: i,
    reverseDirection: o,
    tooltipDimension: a.height,
    viewBox: l,
    viewBoxDimension: l.height
  }), u = MAe({
    translateX: c,
    translateY: f,
    useTranslate3d: s
  })) : u = PAe, {
    cssProperties: u,
    cssClasses: TAe({
      translateX: c,
      translateY: f,
      coordinate: n
    })
  };
}
function Bc(e) {
  "@babel/helpers - typeof";
  return Bc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bc(e);
}
function TR(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function MR(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? TR(Object(n), !0).forEach(function(r) {
      F7(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : TR(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function DAe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function IAe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, FZ(r.key), r);
  }
}
function $Ae(e, t, n) {
  return t && IAe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function LAe(e, t, n) {
  return t = _m(t), FAe(e, LZ() ? Reflect.construct(t, n || [], _m(e).constructor) : t.apply(e, n));
}
function FAe(e, t) {
  if (t && (Bc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return BAe(e);
}
function BAe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function LZ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (LZ = function() {
    return !!e;
  })();
}
function _m(e) {
  return _m = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, _m(e);
}
function jAe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && L7(e, t);
}
function L7(e, t) {
  return L7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, L7(e, t);
}
function F7(e, t, n) {
  return t = FZ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function FZ(e) {
  var t = VAe(e, "string");
  return Bc(t) == "symbol" ? t : t + "";
}
function VAe(e, t) {
  if (Bc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Bc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var RR = 1, qAe = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    DAe(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = LAe(this, t, [].concat(i)), F7(n, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), F7(n, "handleKeyDown", function(a) {
      if (a.key === "Escape") {
        var s, l, u, c;
        n.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (s = (l = n.props.coordinate) === null || l === void 0 ? void 0 : l.x) !== null && s !== void 0 ? s : 0,
            y: (u = (c = n.props.coordinate) === null || c === void 0 ? void 0 : c.y) !== null && u !== void 0 ? u : 0
          }
        });
      }
    }), n;
  }
  return jAe(t, e), $Ae(t, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var r = this.wrapperNode.getBoundingClientRect();
        (Math.abs(r.width - this.state.lastBoundingBox.width) > RR || Math.abs(r.height - this.state.lastBoundingBox.height) > RR) && this.setState({
          lastBoundingBox: {
            width: r.width,
            height: r.height
          }
        });
      } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var r, i;
      this.props.active && this.updateBBox(), this.state.dismissed && (((r = this.props.coordinate) === null || r === void 0 ? void 0 : r.x) !== this.state.dismissedAtCoordinate.x || ((i = this.props.coordinate) === null || i === void 0 ? void 0 : i.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.active, a = i.allowEscapeViewBox, s = i.animationDuration, l = i.animationEasing, u = i.children, c = i.coordinate, f = i.hasPayload, h = i.isAnimationActive, m = i.offset, v = i.position, g = i.reverseDirection, y = i.useTranslate3d, w = i.viewBox, C = i.wrapperStyle, S = RAe({
        allowEscapeViewBox: a,
        coordinate: c,
        offsetTopLeft: m,
        position: v,
        reverseDirection: g,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: y,
        viewBox: w
      }), N = S.cssClasses, E = S.cssProperties, A = MR(MR({
        transition: h && o ? "transform ".concat(s, "ms ").concat(l) : void 0
      }, E), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && o && f ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, C);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ F.createElement("div", {
          tabIndex: -1,
          className: N,
          style: A,
          ref: function(T) {
            r.wrapperNode = T;
          }
        }, u)
      );
    }
  }]);
}(Yo), zAe = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, Rd = {
  isSsr: zAe()
};
function jc(e) {
  "@babel/helpers - typeof";
  return jc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, jc(e);
}
function DR(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function IR(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? DR(Object(n), !0).forEach(function(r) {
      KS(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : DR(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function WAe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function HAe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, jZ(r.key), r);
  }
}
function UAe(e, t, n) {
  return t && HAe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function GAe(e, t, n) {
  return t = Em(t), KAe(e, BZ() ? Reflect.construct(t, n || [], Em(e).constructor) : t.apply(e, n));
}
function KAe(e, t) {
  if (t && (jc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return YAe(e);
}
function YAe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function BZ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (BZ = function() {
    return !!e;
  })();
}
function Em(e) {
  return Em = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Em(e);
}
function ZAe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && B7(e, t);
}
function B7(e, t) {
  return B7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, B7(e, t);
}
function KS(e, t, n) {
  return t = jZ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function jZ(e) {
  var t = XAe(e, "string");
  return jc(t) == "symbol" ? t : t + "";
}
function XAe(e, t) {
  if (jc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (jc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function JAe(e) {
  return e.dataKey;
}
function QAe(e, t) {
  return /* @__PURE__ */ F.isValidElement(e) ? /* @__PURE__ */ F.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ F.createElement(e, t) : /* @__PURE__ */ F.createElement(AAe, t);
}
var Oo = /* @__PURE__ */ function(e) {
  function t() {
    return WAe(this, t), GAe(this, t, arguments);
  }
  return ZAe(t, e), UAe(t, [{
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.active, a = i.allowEscapeViewBox, s = i.animationDuration, l = i.animationEasing, u = i.content, c = i.coordinate, f = i.filterNull, h = i.isAnimationActive, m = i.offset, v = i.payload, g = i.payloadUniqBy, y = i.position, w = i.reverseDirection, C = i.useTranslate3d, S = i.viewBox, N = i.wrapperStyle, E = v ?? [];
      f && E.length && (E = PZ(v.filter(function(O) {
        return O.value != null && (O.hide !== !0 || r.props.includeHidden);
      }), g, JAe));
      var A = E.length > 0;
      return /* @__PURE__ */ F.createElement(qAe, {
        allowEscapeViewBox: a,
        animationDuration: s,
        animationEasing: l,
        isAnimationActive: h,
        active: o,
        coordinate: c,
        hasPayload: A,
        offset: m,
        position: y,
        reverseDirection: w,
        useTranslate3d: C,
        viewBox: S,
        wrapperStyle: N
      }, QAe(u, IR(IR({}, this.props), {}, {
        payload: E
      })));
    }
  }]);
}(Yo);
KS(Oo, "displayName", "Tooltip");
KS(Oo, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !Rd.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var x5, $R;
function eOe() {
  if ($R) return x5;
  $R = 1;
  var e = ta(), t = function() {
    return e.Date.now();
  };
  return x5 = t, x5;
}
var w5, LR;
function tOe() {
  if (LR) return w5;
  LR = 1;
  var e = /\s/;
  function t(n) {
    for (var r = n.length; r-- && e.test(n.charAt(r)); )
      ;
    return r;
  }
  return w5 = t, w5;
}
var C5, FR;
function nOe() {
  if (FR) return C5;
  FR = 1;
  var e = tOe(), t = /^\s+/;
  function n(r) {
    return r && r.slice(0, e(r) + 1).replace(t, "");
  }
  return C5 = n, C5;
}
var S5, BR;
function VZ() {
  if (BR) return S5;
  BR = 1;
  var e = nOe(), t = el(), n = Pd(), r = NaN, i = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, a = /^0o[0-7]+$/i, s = parseInt;
  function l(u) {
    if (typeof u == "number")
      return u;
    if (n(u))
      return r;
    if (t(u)) {
      var c = typeof u.valueOf == "function" ? u.valueOf() : u;
      u = t(c) ? c + "" : c;
    }
    if (typeof u != "string")
      return u === 0 ? u : +u;
    u = e(u);
    var f = o.test(u);
    return f || a.test(u) ? s(u.slice(2), f ? 2 : 8) : i.test(u) ? r : +u;
  }
  return S5 = l, S5;
}
var _5, jR;
function rOe() {
  if (jR) return _5;
  jR = 1;
  var e = el(), t = eOe(), n = VZ(), r = "Expected a function", i = Math.max, o = Math.min;
  function a(s, l, u) {
    var c, f, h, m, v, g, y = 0, w = !1, C = !1, S = !0;
    if (typeof s != "function")
      throw new TypeError(r);
    l = n(l) || 0, e(u) && (w = !!u.leading, C = "maxWait" in u, h = C ? i(n(u.maxWait) || 0, l) : h, S = "trailing" in u ? !!u.trailing : S);
    function N(B) {
      var q = c, G = f;
      return c = f = void 0, y = B, m = s.apply(G, q), m;
    }
    function E(B) {
      return y = B, v = setTimeout(T, l), w ? N(B) : m;
    }
    function A(B) {
      var q = B - g, G = B - y, U = l - q;
      return C ? o(U, h - G) : U;
    }
    function O(B) {
      var q = B - g, G = B - y;
      return g === void 0 || q >= l || q < 0 || C && G >= h;
    }
    function T() {
      var B = t();
      if (O(B))
        return M(B);
      v = setTimeout(T, A(B));
    }
    function M(B) {
      return v = void 0, S && c ? N(B) : (c = f = void 0, m);
    }
    function L() {
      v !== void 0 && clearTimeout(v), y = 0, c = g = f = v = void 0;
    }
    function I() {
      return v === void 0 ? m : M(t());
    }
    function j() {
      var B = t(), q = O(B);
      if (c = arguments, f = this, g = B, q) {
        if (v === void 0)
          return E(g);
        if (C)
          return clearTimeout(v), v = setTimeout(T, l), N(g);
      }
      return v === void 0 && (v = setTimeout(T, l)), m;
    }
    return j.cancel = L, j.flush = I, j;
  }
  return _5 = a, _5;
}
var E5, VR;
function iOe() {
  if (VR) return E5;
  VR = 1;
  var e = rOe(), t = el(), n = "Expected a function";
  function r(i, o, a) {
    var s = !0, l = !0;
    if (typeof i != "function")
      throw new TypeError(n);
    return t(a) && (s = "leading" in a ? !!a.leading : s, l = "trailing" in a ? !!a.trailing : l), e(i, o, {
      leading: s,
      maxWait: o,
      trailing: l
    });
  }
  return E5 = r, E5;
}
var oOe = iOe();
const qZ = /* @__PURE__ */ Rt(oOe);
function ch(e) {
  "@babel/helpers - typeof";
  return ch = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ch(e);
}
function qR(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function h1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qR(Object(n), !0).forEach(function(r) {
      aOe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qR(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function aOe(e, t, n) {
  return t = sOe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function sOe(e) {
  var t = lOe(e, "string");
  return ch(t) == "symbol" ? t : t + "";
}
function lOe(e, t) {
  if (ch(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ch(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function uOe(e, t) {
  return hOe(e) || fOe(e, t) || dOe(e, t) || cOe();
}
function cOe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function dOe(e, t) {
  if (e) {
    if (typeof e == "string") return zR(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return zR(e, t);
  }
}
function zR(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function fOe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, u = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (c) {
      u = !0, i = c;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw i;
      }
    }
    return s;
  }
}
function hOe(e) {
  if (Array.isArray(e)) return e;
}
var pOe = /* @__PURE__ */ te(function(e, t) {
  var n = e.aspect, r = e.initialDimension, i = r === void 0 ? {
    width: -1,
    height: -1
  } : r, o = e.width, a = o === void 0 ? "100%" : o, s = e.height, l = s === void 0 ? "100%" : s, u = e.minWidth, c = u === void 0 ? 0 : u, f = e.minHeight, h = e.maxHeight, m = e.children, v = e.debounce, g = v === void 0 ? 0 : v, y = e.id, w = e.className, C = e.onResize, S = e.style, N = S === void 0 ? {} : S, E = vt(null), A = vt();
  A.current = C, Lg(t, function() {
    return Object.defineProperty(E.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), E.current;
      },
      configurable: !0
    });
  });
  var O = re({
    containerWidth: i.width,
    containerHeight: i.height
  }), T = uOe(O, 2), M = T[0], L = T[1], I = yr(function(B, q) {
    L(function(G) {
      var U = Math.round(B), V = Math.round(q);
      return G.containerWidth === U && G.containerHeight === V ? G : {
        containerWidth: U,
        containerHeight: V
      };
    });
  }, []);
  Pe(function() {
    var B = function(Z) {
      var de, ne = Z[0].contentRect, Y = ne.width, le = ne.height;
      I(Y, le), (de = A.current) === null || de === void 0 || de.call(A, Y, le);
    };
    g > 0 && (B = qZ(B, g, {
      trailing: !0,
      leading: !1
    }));
    var q = new ResizeObserver(B), G = E.current.getBoundingClientRect(), U = G.width, V = G.height;
    return I(U, V), q.observe(E.current), function() {
      q.disconnect();
    };
  }, [I, g]);
  var j = Je(function() {
    var B = M.containerWidth, q = M.containerHeight;
    if (B < 0 || q < 0)
      return null;
    Ma(kl(a) || kl(l), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, a, l), Ma(!n || n > 0, "The aspect(%s) must be greater than zero.", n);
    var G = kl(a) ? B : a, U = kl(l) ? q : l;
    n && n > 0 && (G ? U = G / n : U && (G = U * n), h && U > h && (U = h)), Ma(G > 0 || U > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, G, U, a, l, c, f, n);
    var V = !Array.isArray(m) && Ta(m.type).endsWith("Chart");
    return F.Children.map(m, function(H) {
      return /* @__PURE__ */ F.isValidElement(H) ? /* @__PURE__ */ cn(H, h1({
        width: G,
        height: U
      }, V ? {
        style: h1({
          height: "100%",
          width: "100%",
          maxHeight: U,
          maxWidth: G
        }, H.props.style)
      } : {})) : H;
    });
  }, [n, m, l, h, f, c, M, a]);
  return /* @__PURE__ */ F.createElement("div", {
    id: y ? "".concat(y) : void 0,
    className: at("recharts-responsive-container", w),
    style: h1(h1({}, N), {}, {
      width: a,
      height: l,
      minWidth: c,
      minHeight: f,
      maxHeight: h
    }),
    ref: E
  }, j);
}), zZ = function(t) {
  return null;
};
zZ.displayName = "Cell";
function dh(e) {
  "@babel/helpers - typeof";
  return dh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, dh(e);
}
function WR(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function j7(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? WR(Object(n), !0).forEach(function(r) {
      mOe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : WR(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function mOe(e, t, n) {
  return t = gOe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function gOe(e) {
  var t = vOe(e, "string");
  return dh(t) == "symbol" ? t : t + "";
}
function vOe(e, t) {
  if (dh(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (dh(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ku = {
  widthCache: {},
  cacheCount: 0
}, yOe = 2e3, bOe = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, HR = "recharts_measurement_span";
function xOe(e) {
  var t = j7({}, e);
  return Object.keys(t).forEach(function(n) {
    t[n] || delete t[n];
  }), t;
}
var Bf = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || Rd.isSsr)
    return {
      width: 0,
      height: 0
    };
  var r = xOe(n), i = JSON.stringify({
    text: t,
    copyStyle: r
  });
  if (Ku.widthCache[i])
    return Ku.widthCache[i];
  try {
    var o = document.getElementById(HR);
    o || (o = document.createElement("span"), o.setAttribute("id", HR), o.setAttribute("aria-hidden", "true"), document.body.appendChild(o));
    var a = j7(j7({}, bOe), r);
    Object.assign(o.style, a), o.textContent = "".concat(t);
    var s = o.getBoundingClientRect(), l = {
      width: s.width,
      height: s.height
    };
    return Ku.widthCache[i] = l, ++Ku.cacheCount > yOe && (Ku.cacheCount = 0, Ku.widthCache = {}), l;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, wOe = function(t) {
  return {
    top: t.top + window.scrollY - document.documentElement.clientTop,
    left: t.left + window.scrollX - document.documentElement.clientLeft
  };
};
function fh(e) {
  "@babel/helpers - typeof";
  return fh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fh(e);
}
function Nm(e, t) {
  return EOe(e) || _Oe(e, t) || SOe(e, t) || COe();
}
function COe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function SOe(e, t) {
  if (e) {
    if (typeof e == "string") return UR(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return UR(e, t);
  }
}
function UR(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function _Oe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, u = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        l = !1;
      } else for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (c) {
      u = !0, i = c;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw i;
      }
    }
    return s;
  }
}
function EOe(e) {
  if (Array.isArray(e)) return e;
}
function NOe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function GR(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, OOe(r.key), r);
  }
}
function AOe(e, t, n) {
  return t && GR(e.prototype, t), n && GR(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function OOe(e) {
  var t = kOe(e, "string");
  return fh(t) == "symbol" ? t : t + "";
}
function kOe(e, t) {
  if (fh(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (fh(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var KR = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, YR = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, POe = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, TOe = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, WZ = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, MOe = Object.keys(WZ), rc = "NaN";
function ROe(e, t) {
  return e * WZ[t];
}
var p1 = /* @__PURE__ */ function() {
  function e(t, n) {
    NOe(this, e), this.num = t, this.unit = n, this.num = t, this.unit = n, Number.isNaN(t) && (this.unit = ""), n !== "" && !POe.test(n) && (this.num = NaN, this.unit = ""), MOe.includes(n) && (this.num = ROe(t, n), this.unit = "px");
  }
  return AOe(e, [{
    key: "add",
    value: function(n) {
      return this.unit !== n.unit ? new e(NaN, "") : new e(this.num + n.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(n) {
      return this.unit !== n.unit ? new e(NaN, "") : new e(this.num - n.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(n) {
      return this.unit !== "" && n.unit !== "" && this.unit !== n.unit ? new e(NaN, "") : new e(this.num * n.num, this.unit || n.unit);
    }
  }, {
    key: "divide",
    value: function(n) {
      return this.unit !== "" && n.unit !== "" && this.unit !== n.unit ? new e(NaN, "") : new e(this.num / n.num, this.unit || n.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(n) {
      var r, i = (r = TOe.exec(n)) !== null && r !== void 0 ? r : [], o = Nm(i, 3), a = o[1], s = o[2];
      return new e(parseFloat(a), s ?? "");
    }
  }]);
}();
function HZ(e) {
  if (e.includes(rc))
    return rc;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var n, r = (n = KR.exec(t)) !== null && n !== void 0 ? n : [], i = Nm(r, 4), o = i[1], a = i[2], s = i[3], l = p1.parse(o ?? ""), u = p1.parse(s ?? ""), c = a === "*" ? l.multiply(u) : l.divide(u);
    if (c.isNaN())
      return rc;
    t = t.replace(KR, c.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var f, h = (f = YR.exec(t)) !== null && f !== void 0 ? f : [], m = Nm(h, 4), v = m[1], g = m[2], y = m[3], w = p1.parse(v ?? ""), C = p1.parse(y ?? ""), S = g === "+" ? w.add(C) : w.subtract(C);
    if (S.isNaN())
      return rc;
    t = t.replace(YR, S.toString());
  }
  return t;
}
var ZR = /\(([^()]*)\)/;
function DOe(e) {
  for (var t = e; t.includes("("); ) {
    var n = ZR.exec(t), r = Nm(n, 2), i = r[1];
    t = t.replace(ZR, HZ(i));
  }
  return t;
}
function IOe(e) {
  var t = e.replace(/\s+/g, "");
  return t = DOe(t), t = HZ(t), t;
}
function $Oe(e) {
  try {
    return IOe(e);
  } catch {
    return rc;
  }
}
function N5(e) {
  var t = $Oe(e.slice(5, -1));
  return t === rc ? "" : t;
}
var LOe = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], FOe = ["dx", "dy", "angle", "className", "breakAll"];
function V7() {
  return V7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, V7.apply(this, arguments);
}
function XR(e, t) {
  if (e == null) return {};
  var n = BOe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function BOe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function JR(e, t) {
  return zOe(e) || qOe(e, t) || VOe(e, t) || jOe();
}
function jOe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function VOe(e, t) {
  if (e) {
    if (typeof e == "string") return QR(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return QR(e, t);
  }
}
function QR(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function qOe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, u = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        l = !1;
      } else for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (c) {
      u = !0, i = c;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw i;
      }
    }
    return s;
  }
}
function zOe(e) {
  if (Array.isArray(e)) return e;
}
var UZ = /[ \f\n\r\t\v\u2028\u2029]+/, GZ = function(t) {
  var n = t.children, r = t.breakAll, i = t.style;
  try {
    var o = [];
    yt(n) || (r ? o = n.toString().split("") : o = n.toString().split(UZ));
    var a = o.map(function(l) {
      return {
        word: l,
        width: Bf(l, i).width
      };
    }), s = r ? 0 : Bf(" ", i).width;
    return {
      wordsWithComputedWidth: a,
      spaceWidth: s
    };
  } catch {
    return null;
  }
}, WOe = function(t, n, r, i, o) {
  var a = t.maxLines, s = t.children, l = t.style, u = t.breakAll, c = we(a), f = s, h = function() {
    var G = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return G.reduce(function(U, V) {
      var H = V.word, Z = V.width, de = U[U.length - 1];
      if (de && (i == null || o || de.width + Z + r < Number(i)))
        de.words.push(H), de.width += Z + r;
      else {
        var ne = {
          words: [H],
          width: Z
        };
        U.push(ne);
      }
      return U;
    }, []);
  }, m = h(n), v = function(G) {
    return G.reduce(function(U, V) {
      return U.width > V.width ? U : V;
    });
  };
  if (!c)
    return m;
  for (var g = "…", y = function(G) {
    var U = f.slice(0, G), V = GZ({
      breakAll: u,
      style: l,
      children: U + g
    }).wordsWithComputedWidth, H = h(V), Z = H.length > a || v(H).width > Number(i);
    return [Z, H];
  }, w = 0, C = f.length - 1, S = 0, N; w <= C && S <= f.length - 1; ) {
    var E = Math.floor((w + C) / 2), A = E - 1, O = y(A), T = JR(O, 2), M = T[0], L = T[1], I = y(E), j = JR(I, 1), B = j[0];
    if (!M && !B && (w = E + 1), M && B && (C = E - 1), !M && B) {
      N = L;
      break;
    }
    S++;
  }
  return N || m;
}, eD = function(t) {
  var n = yt(t) ? [] : t.toString().split(UZ);
  return [{
    words: n
  }];
}, HOe = function(t) {
  var n = t.width, r = t.scaleToFit, i = t.children, o = t.style, a = t.breakAll, s = t.maxLines;
  if ((n || r) && !Rd.isSsr) {
    var l, u, c = GZ({
      breakAll: a,
      children: i,
      style: o
    });
    if (c) {
      var f = c.wordsWithComputedWidth, h = c.spaceWidth;
      l = f, u = h;
    } else
      return eD(i);
    return WOe({
      breakAll: a,
      children: i,
      maxLines: s,
      style: o
    }, l, u, n, r);
  }
  return eD(i);
}, tD = "#808080", Vc = function(t) {
  var n = t.x, r = n === void 0 ? 0 : n, i = t.y, o = i === void 0 ? 0 : i, a = t.lineHeight, s = a === void 0 ? "1em" : a, l = t.capHeight, u = l === void 0 ? "0.71em" : l, c = t.scaleToFit, f = c === void 0 ? !1 : c, h = t.textAnchor, m = h === void 0 ? "start" : h, v = t.verticalAnchor, g = v === void 0 ? "end" : v, y = t.fill, w = y === void 0 ? tD : y, C = XR(t, LOe), S = Je(function() {
    return HOe({
      breakAll: C.breakAll,
      children: C.children,
      maxLines: C.maxLines,
      scaleToFit: f,
      style: C.style,
      width: C.width
    });
  }, [C.breakAll, C.children, C.maxLines, f, C.style, C.width]), N = C.dx, E = C.dy, A = C.angle, O = C.className, T = C.breakAll, M = XR(C, FOe);
  if (!Dn(r) || !Dn(o))
    return null;
  var L = r + (we(N) ? N : 0), I = o + (we(E) ? E : 0), j;
  switch (g) {
    case "start":
      j = N5("calc(".concat(u, ")"));
      break;
    case "middle":
      j = N5("calc(".concat((S.length - 1) / 2, " * -").concat(s, " + (").concat(u, " / 2))"));
      break;
    default:
      j = N5("calc(".concat(S.length - 1, " * -").concat(s, ")"));
      break;
  }
  var B = [];
  if (f) {
    var q = S[0].width, G = C.width;
    B.push("scale(".concat((we(G) ? G / q : 1) / q, ")"));
  }
  return A && B.push("rotate(".concat(A, ", ").concat(L, ", ").concat(I, ")")), B.length && (M.transform = B.join(" ")), /* @__PURE__ */ F.createElement("text", V7({}, qe(M, !0), {
    x: L,
    y: I,
    className: at("recharts-text", O),
    textAnchor: m,
    fill: w.includes("url") ? tD : w
  }), S.map(function(U, V) {
    var H = U.words.join(T ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ F.createElement("tspan", {
        x: L,
        dy: V === 0 ? j : s,
        key: "".concat(H, "-").concat(V)
      }, H)
    );
  }));
};
function Ds(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function UOe(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function YS(e) {
  let t, n, r;
  e.length !== 2 ? (t = Ds, n = (s, l) => Ds(e(s), l), r = (s, l) => e(s) - l) : (t = e === Ds || e === UOe ? e : GOe, n = e, r = e);
  function i(s, l, u = 0, c = s.length) {
    if (u < c) {
      if (t(l, l) !== 0) return c;
      do {
        const f = u + c >>> 1;
        n(s[f], l) < 0 ? u = f + 1 : c = f;
      } while (u < c);
    }
    return u;
  }
  function o(s, l, u = 0, c = s.length) {
    if (u < c) {
      if (t(l, l) !== 0) return c;
      do {
        const f = u + c >>> 1;
        n(s[f], l) <= 0 ? u = f + 1 : c = f;
      } while (u < c);
    }
    return u;
  }
  function a(s, l, u = 0, c = s.length) {
    const f = i(s, l, u, c - 1);
    return f > u && r(s[f - 1], l) > -r(s[f], l) ? f - 1 : f;
  }
  return { left: i, center: a, right: o };
}
function GOe() {
  return 0;
}
function KZ(e) {
  return e === null ? NaN : +e;
}
function* KOe(e, t) {
  for (let n of e)
    n != null && (n = +n) >= n && (yield n);
}
const YOe = YS(Ds), Mp = YOe.right;
YS(KZ).center;
class nD extends Map {
  constructor(t, n = JOe) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), t != null) for (const [r, i] of t) this.set(r, i);
  }
  get(t) {
    return super.get(rD(this, t));
  }
  has(t) {
    return super.has(rD(this, t));
  }
  set(t, n) {
    return super.set(ZOe(this, t), n);
  }
  delete(t) {
    return super.delete(XOe(this, t));
  }
}
function rD({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : n;
}
function ZOe({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : (e.set(r, n), n);
}
function XOe({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) && (n = e.get(r), e.delete(r)), n;
}
function JOe(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function QOe(e = Ds) {
  if (e === Ds) return YZ;
  if (typeof e != "function") throw new TypeError("compare is not a function");
  return (t, n) => {
    const r = e(t, n);
    return r || r === 0 ? r : (e(n, n) === 0) - (e(t, t) === 0);
  };
}
function YZ(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const eke = Math.sqrt(50), tke = Math.sqrt(10), nke = Math.sqrt(2);
function Am(e, t, n) {
  const r = (t - e) / Math.max(0, n), i = Math.floor(Math.log10(r)), o = r / Math.pow(10, i), a = o >= eke ? 10 : o >= tke ? 5 : o >= nke ? 2 : 1;
  let s, l, u;
  return i < 0 ? (u = Math.pow(10, -i) / a, s = Math.round(e * u), l = Math.round(t * u), s / u < e && ++s, l / u > t && --l, u = -u) : (u = Math.pow(10, i) * a, s = Math.round(e / u), l = Math.round(t / u), s * u < e && ++s, l * u > t && --l), l < s && 0.5 <= n && n < 2 ? Am(e, t, n * 2) : [s, l, u];
}
function q7(e, t, n) {
  if (t = +t, e = +e, n = +n, !(n > 0)) return [];
  if (e === t) return [e];
  const r = t < e, [i, o, a] = r ? Am(t, e, n) : Am(e, t, n);
  if (!(o >= i)) return [];
  const s = o - i + 1, l = new Array(s);
  if (r)
    if (a < 0) for (let u = 0; u < s; ++u) l[u] = (o - u) / -a;
    else for (let u = 0; u < s; ++u) l[u] = (o - u) * a;
  else if (a < 0) for (let u = 0; u < s; ++u) l[u] = (i + u) / -a;
  else for (let u = 0; u < s; ++u) l[u] = (i + u) * a;
  return l;
}
function z7(e, t, n) {
  return t = +t, e = +e, n = +n, Am(e, t, n)[2];
}
function W7(e, t, n) {
  t = +t, e = +e, n = +n;
  const r = t < e, i = r ? z7(t, e, n) : z7(e, t, n);
  return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function iD(e, t) {
  let n;
  for (const r of e)
    r != null && (n < r || n === void 0 && r >= r) && (n = r);
  return n;
}
function oD(e, t) {
  let n;
  for (const r of e)
    r != null && (n > r || n === void 0 && r >= r) && (n = r);
  return n;
}
function ZZ(e, t, n = 0, r = 1 / 0, i) {
  if (t = Math.floor(t), n = Math.floor(Math.max(0, n)), r = Math.floor(Math.min(e.length - 1, r)), !(n <= t && t <= r)) return e;
  for (i = i === void 0 ? YZ : QOe(i); r > n; ) {
    if (r - n > 600) {
      const l = r - n + 1, u = t - n + 1, c = Math.log(l), f = 0.5 * Math.exp(2 * c / 3), h = 0.5 * Math.sqrt(c * f * (l - f) / l) * (u - l / 2 < 0 ? -1 : 1), m = Math.max(n, Math.floor(t - u * f / l + h)), v = Math.min(r, Math.floor(t + (l - u) * f / l + h));
      ZZ(e, t, m, v, i);
    }
    const o = e[t];
    let a = n, s = r;
    for (hf(e, n, t), i(e[r], o) > 0 && hf(e, n, r); a < s; ) {
      for (hf(e, a, s), ++a, --s; i(e[a], o) < 0; ) ++a;
      for (; i(e[s], o) > 0; ) --s;
    }
    i(e[n], o) === 0 ? hf(e, n, s) : (++s, hf(e, s, r)), s <= t && (n = s + 1), t <= s && (r = s - 1);
  }
  return e;
}
function hf(e, t, n) {
  const r = e[t];
  e[t] = e[n], e[n] = r;
}
function rke(e, t, n) {
  if (e = Float64Array.from(KOe(e)), !(!(r = e.length) || isNaN(t = +t))) {
    if (t <= 0 || r < 2) return oD(e);
    if (t >= 1) return iD(e);
    var r, i = (r - 1) * t, o = Math.floor(i), a = iD(ZZ(e, o).subarray(0, o + 1)), s = oD(e.subarray(o + 1));
    return a + (s - a) * (i - o);
  }
}
function ike(e, t, n = KZ) {
  if (!(!(r = e.length) || isNaN(t = +t))) {
    if (t <= 0 || r < 2) return +n(e[0], 0, e);
    if (t >= 1) return +n(e[r - 1], r - 1, e);
    var r, i = (r - 1) * t, o = Math.floor(i), a = +n(e[o], o, e), s = +n(e[o + 1], o + 1, e);
    return a + (s - a) * (i - o);
  }
}
function oke(e, t, n) {
  e = +e, t = +t, n = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +n;
  for (var r = -1, i = Math.max(0, Math.ceil((t - e) / n)) | 0, o = new Array(i); ++r < i; )
    o[r] = e + r * n;
  return o;
}
function zi(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function Ja(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const H7 = Symbol("implicit");
function ZS() {
  var e = new nD(), t = [], n = [], r = H7;
  function i(o) {
    let a = e.get(o);
    if (a === void 0) {
      if (r !== H7) return r;
      e.set(o, a = t.push(o) - 1);
    }
    return n[a % n.length];
  }
  return i.domain = function(o) {
    if (!arguments.length) return t.slice();
    t = [], e = new nD();
    for (const a of o)
      e.has(a) || e.set(a, t.push(a) - 1);
    return i;
  }, i.range = function(o) {
    return arguments.length ? (n = Array.from(o), i) : n.slice();
  }, i.unknown = function(o) {
    return arguments.length ? (r = o, i) : r;
  }, i.copy = function() {
    return ZS(t, n).unknown(r);
  }, zi.apply(i, arguments), i;
}
function hh() {
  var e = ZS().unknown(void 0), t = e.domain, n = e.range, r = 0, i = 1, o, a, s = !1, l = 0, u = 0, c = 0.5;
  delete e.unknown;
  function f() {
    var h = t().length, m = i < r, v = m ? i : r, g = m ? r : i;
    o = (g - v) / Math.max(1, h - l + u * 2), s && (o = Math.floor(o)), v += (g - v - o * (h - l)) * c, a = o * (1 - l), s && (v = Math.round(v), a = Math.round(a));
    var y = oke(h).map(function(w) {
      return v + o * w;
    });
    return n(m ? y.reverse() : y);
  }
  return e.domain = function(h) {
    return arguments.length ? (t(h), f()) : t();
  }, e.range = function(h) {
    return arguments.length ? ([r, i] = h, r = +r, i = +i, f()) : [r, i];
  }, e.rangeRound = function(h) {
    return [r, i] = h, r = +r, i = +i, s = !0, f();
  }, e.bandwidth = function() {
    return a;
  }, e.step = function() {
    return o;
  }, e.round = function(h) {
    return arguments.length ? (s = !!h, f()) : s;
  }, e.padding = function(h) {
    return arguments.length ? (l = Math.min(1, u = +h), f()) : l;
  }, e.paddingInner = function(h) {
    return arguments.length ? (l = Math.min(1, h), f()) : l;
  }, e.paddingOuter = function(h) {
    return arguments.length ? (u = +h, f()) : u;
  }, e.align = function(h) {
    return arguments.length ? (c = Math.max(0, Math.min(1, h)), f()) : c;
  }, e.copy = function() {
    return hh(t(), [r, i]).round(s).paddingInner(l).paddingOuter(u).align(c);
  }, zi.apply(f(), arguments);
}
function XZ(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return XZ(t());
  }, e;
}
function jf() {
  return XZ(hh.apply(null, arguments).paddingInner(1));
}
function XS(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function JZ(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t) n[r] = t[r];
  return n;
}
function Rp() {
}
var ph = 0.7, Om = 1 / ph, xc = "\\s*([+-]?\\d+)\\s*", mh = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Fo = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", ake = /^#([0-9a-f]{3,8})$/, ske = new RegExp(`^rgb\\(${xc},${xc},${xc}\\)$`), lke = new RegExp(`^rgb\\(${Fo},${Fo},${Fo}\\)$`), uke = new RegExp(`^rgba\\(${xc},${xc},${xc},${mh}\\)$`), cke = new RegExp(`^rgba\\(${Fo},${Fo},${Fo},${mh}\\)$`), dke = new RegExp(`^hsl\\(${mh},${Fo},${Fo}\\)$`), fke = new RegExp(`^hsla\\(${mh},${Fo},${Fo},${mh}\\)$`), aD = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
XS(Rp, gh, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: sD,
  // Deprecated! Use color.formatHex.
  formatHex: sD,
  formatHex8: hke,
  formatHsl: pke,
  formatRgb: lD,
  toString: lD
});
function sD() {
  return this.rgb().formatHex();
}
function hke() {
  return this.rgb().formatHex8();
}
function pke() {
  return QZ(this).formatHsl();
}
function lD() {
  return this.rgb().formatRgb();
}
function gh(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = ake.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? uD(t) : n === 3 ? new qr(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? m1(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? m1(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = ske.exec(e)) ? new qr(t[1], t[2], t[3], 1) : (t = lke.exec(e)) ? new qr(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = uke.exec(e)) ? m1(t[1], t[2], t[3], t[4]) : (t = cke.exec(e)) ? m1(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = dke.exec(e)) ? fD(t[1], t[2] / 100, t[3] / 100, 1) : (t = fke.exec(e)) ? fD(t[1], t[2] / 100, t[3] / 100, t[4]) : aD.hasOwnProperty(e) ? uD(aD[e]) : e === "transparent" ? new qr(NaN, NaN, NaN, 0) : null;
}
function uD(e) {
  return new qr(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function m1(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new qr(e, t, n, r);
}
function mke(e) {
  return e instanceof Rp || (e = gh(e)), e ? (e = e.rgb(), new qr(e.r, e.g, e.b, e.opacity)) : new qr();
}
function U7(e, t, n, r) {
  return arguments.length === 1 ? mke(e) : new qr(e, t, n, r ?? 1);
}
function qr(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
XS(qr, U7, JZ(Rp, {
  brighter(e) {
    return e = e == null ? Om : Math.pow(Om, e), new qr(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? ph : Math.pow(ph, e), new qr(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new qr(Ll(this.r), Ll(this.g), Ll(this.b), km(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: cD,
  // Deprecated! Use color.formatHex.
  formatHex: cD,
  formatHex8: gke,
  formatRgb: dD,
  toString: dD
}));
function cD() {
  return `#${Pl(this.r)}${Pl(this.g)}${Pl(this.b)}`;
}
function gke() {
  return `#${Pl(this.r)}${Pl(this.g)}${Pl(this.b)}${Pl((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function dD() {
  const e = km(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${Ll(this.r)}, ${Ll(this.g)}, ${Ll(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function km(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function Ll(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Pl(e) {
  return e = Ll(e), (e < 16 ? "0" : "") + e.toString(16);
}
function fD(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new eo(e, t, n, r);
}
function QZ(e) {
  if (e instanceof eo) return new eo(e.h, e.s, e.l, e.opacity);
  if (e instanceof Rp || (e = gh(e)), !e) return new eo();
  if (e instanceof eo) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = Math.min(t, n, r), o = Math.max(t, n, r), a = NaN, s = o - i, l = (o + i) / 2;
  return s ? (t === o ? a = (n - r) / s + (n < r) * 6 : n === o ? a = (r - t) / s + 2 : a = (t - n) / s + 4, s /= l < 0.5 ? o + i : 2 - o - i, a *= 60) : s = l > 0 && l < 1 ? 0 : a, new eo(a, s, l, e.opacity);
}
function vke(e, t, n, r) {
  return arguments.length === 1 ? QZ(e) : new eo(e, t, n, r ?? 1);
}
function eo(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
XS(eo, vke, JZ(Rp, {
  brighter(e) {
    return e = e == null ? Om : Math.pow(Om, e), new eo(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? ph : Math.pow(ph, e), new eo(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, i = 2 * n - r;
    return new qr(
      A5(e >= 240 ? e - 240 : e + 120, i, r),
      A5(e, i, r),
      A5(e < 120 ? e + 240 : e - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new eo(hD(this.h), g1(this.s), g1(this.l), km(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = km(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${hD(this.h)}, ${g1(this.s) * 100}%, ${g1(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function hD(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function g1(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function A5(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const JS = (e) => () => e;
function yke(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function bke(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function xke(e) {
  return (e = +e) == 1 ? eX : function(t, n) {
    return n - t ? bke(t, n, e) : JS(isNaN(t) ? n : t);
  };
}
function eX(e, t) {
  var n = t - e;
  return n ? yke(e, n) : JS(isNaN(e) ? t : e);
}
const pD = function e(t) {
  var n = xke(t);
  function r(i, o) {
    var a = n((i = U7(i)).r, (o = U7(o)).r), s = n(i.g, o.g), l = n(i.b, o.b), u = eX(i.opacity, o.opacity);
    return function(c) {
      return i.r = a(c), i.g = s(c), i.b = l(c), i.opacity = u(c), i + "";
    };
  }
  return r.gamma = e, r;
}(1);
function wke(e, t) {
  t || (t = []);
  var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), i;
  return function(o) {
    for (i = 0; i < n; ++i) r[i] = e[i] * (1 - o) + t[i] * o;
    return r;
  };
}
function Cke(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function Ske(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, i = new Array(r), o = new Array(n), a;
  for (a = 0; a < r; ++a) i[a] = Dd(e[a], t[a]);
  for (; a < n; ++a) o[a] = t[a];
  return function(s) {
    for (a = 0; a < r; ++a) o[a] = i[a](s);
    return o;
  };
}
function _ke(e, t) {
  var n = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(r) {
    return n.setTime(e * (1 - r) + t * r), n;
  };
}
function Pm(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
function Eke(e, t) {
  var n = {}, r = {}, i;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in e ? n[i] = Dd(e[i], t[i]) : r[i] = t[i];
  return function(o) {
    for (i in n) r[i] = n[i](o);
    return r;
  };
}
var G7 = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, O5 = new RegExp(G7.source, "g");
function Nke(e) {
  return function() {
    return e;
  };
}
function Ake(e) {
  return function(t) {
    return e(t) + "";
  };
}
function Oke(e, t) {
  var n = G7.lastIndex = O5.lastIndex = 0, r, i, o, a = -1, s = [], l = [];
  for (e = e + "", t = t + ""; (r = G7.exec(e)) && (i = O5.exec(t)); )
    (o = i.index) > n && (o = t.slice(n, o), s[a] ? s[a] += o : s[++a] = o), (r = r[0]) === (i = i[0]) ? s[a] ? s[a] += i : s[++a] = i : (s[++a] = null, l.push({ i: a, x: Pm(r, i) })), n = O5.lastIndex;
  return n < t.length && (o = t.slice(n), s[a] ? s[a] += o : s[++a] = o), s.length < 2 ? l[0] ? Ake(l[0].x) : Nke(t) : (t = l.length, function(u) {
    for (var c = 0, f; c < t; ++c) s[(f = l[c]).i] = f.x(u);
    return s.join("");
  });
}
function Dd(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? JS(t) : (n === "number" ? Pm : n === "string" ? (r = gh(t)) ? (t = r, pD) : Oke : t instanceof gh ? pD : t instanceof Date ? _ke : Cke(t) ? wke : Array.isArray(t) ? Ske : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? Eke : Pm)(e, t);
}
function QS(e, t) {
  return e = +e, t = +t, function(n) {
    return Math.round(e * (1 - n) + t * n);
  };
}
function kke(e, t) {
  t === void 0 && (t = e, e = Dd);
  for (var n = 0, r = t.length - 1, i = t[0], o = new Array(r < 0 ? 0 : r); n < r; ) o[n] = e(i, i = t[++n]);
  return function(a) {
    var s = Math.max(0, Math.min(r - 1, Math.floor(a *= r)));
    return o[s](a - s);
  };
}
function Pke(e) {
  return function() {
    return e;
  };
}
function Tm(e) {
  return +e;
}
var mD = [0, 1];
function kr(e) {
  return e;
}
function K7(e, t) {
  return (t -= e = +e) ? function(n) {
    return (n - e) / t;
  } : Pke(isNaN(t) ? NaN : 0.5);
}
function Tke(e, t) {
  var n;
  return e > t && (n = e, e = t, t = n), function(r) {
    return Math.max(e, Math.min(t, r));
  };
}
function Mke(e, t, n) {
  var r = e[0], i = e[1], o = t[0], a = t[1];
  return i < r ? (r = K7(i, r), o = n(a, o)) : (r = K7(r, i), o = n(o, a)), function(s) {
    return o(r(s));
  };
}
function Rke(e, t, n) {
  var r = Math.min(e.length, t.length) - 1, i = new Array(r), o = new Array(r), a = -1;
  for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++a < r; )
    i[a] = K7(e[a], e[a + 1]), o[a] = n(t[a], t[a + 1]);
  return function(s) {
    var l = Mp(e, s, 1, r) - 1;
    return o[l](i[l](s));
  };
}
function Dp(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function sv() {
  var e = mD, t = mD, n = Dd, r, i, o, a = kr, s, l, u;
  function c() {
    var h = Math.min(e.length, t.length);
    return a !== kr && (a = Tke(e[0], e[h - 1])), s = h > 2 ? Rke : Mke, l = u = null, f;
  }
  function f(h) {
    return h == null || isNaN(h = +h) ? o : (l || (l = s(e.map(r), t, n)))(r(a(h)));
  }
  return f.invert = function(h) {
    return a(i((u || (u = s(t, e.map(r), Pm)))(h)));
  }, f.domain = function(h) {
    return arguments.length ? (e = Array.from(h, Tm), c()) : e.slice();
  }, f.range = function(h) {
    return arguments.length ? (t = Array.from(h), c()) : t.slice();
  }, f.rangeRound = function(h) {
    return t = Array.from(h), n = QS, c();
  }, f.clamp = function(h) {
    return arguments.length ? (a = h ? !0 : kr, c()) : a !== kr;
  }, f.interpolate = function(h) {
    return arguments.length ? (n = h, c()) : n;
  }, f.unknown = function(h) {
    return arguments.length ? (o = h, f) : o;
  }, function(h, m) {
    return r = h, i = m, c();
  };
}
function e_() {
  return sv()(kr, kr);
}
function Dke(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function Mm(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var n, r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function qc(e) {
  return e = Mm(Math.abs(e)), e ? e[1] : NaN;
}
function Ike(e, t) {
  return function(n, r) {
    for (var i = n.length, o = [], a = 0, s = e[0], l = 0; i > 0 && s > 0 && (l + s + 1 > r && (s = Math.max(1, r - l)), o.push(n.substring(i -= s, i + s)), !((l += s + 1) > r)); )
      s = e[a = (a + 1) % e.length];
    return o.reverse().join(t);
  };
}
function $ke(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
var Lke = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function vh(e) {
  if (!(t = Lke.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new t_({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
vh.prototype = t_.prototype;
function t_(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
t_.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function Fke(e) {
  e: for (var t = e.length, n = 1, r = -1, i; n < t; ++n)
    switch (e[n]) {
      case ".":
        r = i = n;
        break;
      case "0":
        r === 0 && (r = n), i = n;
        break;
      default:
        if (!+e[n]) break e;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? e.slice(0, r) + e.slice(i + 1) : e;
}
var tX;
function Bke(e, t) {
  var n = Mm(e, t);
  if (!n) return e + "";
  var r = n[0], i = n[1], o = i - (tX = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, a = r.length;
  return o === a ? r : o > a ? r + new Array(o - a + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + Mm(e, Math.max(0, t + o - 1))[0];
}
function gD(e, t) {
  var n = Mm(e, t);
  if (!n) return e + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const vD = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: Dke,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => gD(e * 100, t),
  r: gD,
  s: Bke,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function yD(e) {
  return e;
}
var bD = Array.prototype.map, xD = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function jke(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? yD : Ike(bD.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", i = e.decimal === void 0 ? "." : e.decimal + "", o = e.numerals === void 0 ? yD : $ke(bD.call(e.numerals, String)), a = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", l = e.nan === void 0 ? "NaN" : e.nan + "";
  function u(f) {
    f = vh(f);
    var h = f.fill, m = f.align, v = f.sign, g = f.symbol, y = f.zero, w = f.width, C = f.comma, S = f.precision, N = f.trim, E = f.type;
    E === "n" ? (C = !0, E = "g") : vD[E] || (S === void 0 && (S = 12), N = !0, E = "g"), (y || h === "0" && m === "=") && (y = !0, h = "0", m = "=");
    var A = g === "$" ? n : g === "#" && /[boxX]/.test(E) ? "0" + E.toLowerCase() : "", O = g === "$" ? r : /[%p]/.test(E) ? a : "", T = vD[E], M = /[defgprs%]/.test(E);
    S = S === void 0 ? 6 : /[gprs]/.test(E) ? Math.max(1, Math.min(21, S)) : Math.max(0, Math.min(20, S));
    function L(I) {
      var j = A, B = O, q, G, U;
      if (E === "c")
        B = T(I) + B, I = "";
      else {
        I = +I;
        var V = I < 0 || 1 / I < 0;
        if (I = isNaN(I) ? l : T(Math.abs(I), S), N && (I = Fke(I)), V && +I == 0 && v !== "+" && (V = !1), j = (V ? v === "(" ? v : s : v === "-" || v === "(" ? "" : v) + j, B = (E === "s" ? xD[8 + tX / 3] : "") + B + (V && v === "(" ? ")" : ""), M) {
          for (q = -1, G = I.length; ++q < G; )
            if (U = I.charCodeAt(q), 48 > U || U > 57) {
              B = (U === 46 ? i + I.slice(q + 1) : I.slice(q)) + B, I = I.slice(0, q);
              break;
            }
        }
      }
      C && !y && (I = t(I, 1 / 0));
      var H = j.length + I.length + B.length, Z = H < w ? new Array(w - H + 1).join(h) : "";
      switch (C && y && (I = t(Z + I, Z.length ? w - B.length : 1 / 0), Z = ""), m) {
        case "<":
          I = j + I + B + Z;
          break;
        case "=":
          I = j + Z + I + B;
          break;
        case "^":
          I = Z.slice(0, H = Z.length >> 1) + j + I + B + Z.slice(H);
          break;
        default:
          I = Z + j + I + B;
          break;
      }
      return o(I);
    }
    return L.toString = function() {
      return f + "";
    }, L;
  }
  function c(f, h) {
    var m = u((f = vh(f), f.type = "f", f)), v = Math.max(-8, Math.min(8, Math.floor(qc(h) / 3))) * 3, g = Math.pow(10, -v), y = xD[8 + v / 3];
    return function(w) {
      return m(g * w) + y;
    };
  }
  return {
    format: u,
    formatPrefix: c
  };
}
var v1, n_, nX;
Vke({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function Vke(e) {
  return v1 = jke(e), n_ = v1.format, nX = v1.formatPrefix, v1;
}
function qke(e) {
  return Math.max(0, -qc(Math.abs(e)));
}
function zke(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(qc(t) / 3))) * 3 - qc(Math.abs(e)));
}
function Wke(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, qc(t) - qc(e)) + 1;
}
function rX(e, t, n, r) {
  var i = W7(e, t, n), o;
  switch (r = vh(r ?? ",f"), r.type) {
    case "s": {
      var a = Math.max(Math.abs(e), Math.abs(t));
      return r.precision == null && !isNaN(o = zke(i, a)) && (r.precision = o), nX(r, a);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(o = Wke(i, Math.max(Math.abs(e), Math.abs(t)))) && (r.precision = o - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(o = qke(i)) && (r.precision = o - (r.type === "%") * 2);
      break;
    }
  }
  return n_(r);
}
function tl(e) {
  var t = e.domain;
  return e.ticks = function(n) {
    var r = t();
    return q7(r[0], r[r.length - 1], n ?? 10);
  }, e.tickFormat = function(n, r) {
    var i = t();
    return rX(i[0], i[i.length - 1], n ?? 10, r);
  }, e.nice = function(n) {
    n == null && (n = 10);
    var r = t(), i = 0, o = r.length - 1, a = r[i], s = r[o], l, u, c = 10;
    for (s < a && (u = a, a = s, s = u, u = i, i = o, o = u); c-- > 0; ) {
      if (u = z7(a, s, n), u === l)
        return r[i] = a, r[o] = s, t(r);
      if (u > 0)
        a = Math.floor(a / u) * u, s = Math.ceil(s / u) * u;
      else if (u < 0)
        a = Math.ceil(a * u) / u, s = Math.floor(s * u) / u;
      else
        break;
      l = u;
    }
    return e;
  }, e;
}
function Rm() {
  var e = e_();
  return e.copy = function() {
    return Dp(e, Rm());
  }, zi.apply(e, arguments), tl(e);
}
function iX(e) {
  var t;
  function n(r) {
    return r == null || isNaN(r = +r) ? t : r;
  }
  return n.invert = n, n.domain = n.range = function(r) {
    return arguments.length ? (e = Array.from(r, Tm), n) : e.slice();
  }, n.unknown = function(r) {
    return arguments.length ? (t = r, n) : t;
  }, n.copy = function() {
    return iX(e).unknown(t);
  }, e = arguments.length ? Array.from(e, Tm) : [0, 1], tl(n);
}
function oX(e, t) {
  e = e.slice();
  var n = 0, r = e.length - 1, i = e[n], o = e[r], a;
  return o < i && (a = n, n = r, r = a, a = i, i = o, o = a), e[n] = t.floor(i), e[r] = t.ceil(o), e;
}
function wD(e) {
  return Math.log(e);
}
function CD(e) {
  return Math.exp(e);
}
function Hke(e) {
  return -Math.log(-e);
}
function Uke(e) {
  return -Math.exp(-e);
}
function Gke(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function Kke(e) {
  return e === 10 ? Gke : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function Yke(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function SD(e) {
  return (t, n) => -e(-t, n);
}
function r_(e) {
  const t = e(wD, CD), n = t.domain;
  let r = 10, i, o;
  function a() {
    return i = Yke(r), o = Kke(r), n()[0] < 0 ? (i = SD(i), o = SD(o), e(Hke, Uke)) : e(wD, CD), t;
  }
  return t.base = function(s) {
    return arguments.length ? (r = +s, a()) : r;
  }, t.domain = function(s) {
    return arguments.length ? (n(s), a()) : n();
  }, t.ticks = (s) => {
    const l = n();
    let u = l[0], c = l[l.length - 1];
    const f = c < u;
    f && ([u, c] = [c, u]);
    let h = i(u), m = i(c), v, g;
    const y = s == null ? 10 : +s;
    let w = [];
    if (!(r % 1) && m - h < y) {
      if (h = Math.floor(h), m = Math.ceil(m), u > 0) {
        for (; h <= m; ++h)
          for (v = 1; v < r; ++v)
            if (g = h < 0 ? v / o(-h) : v * o(h), !(g < u)) {
              if (g > c) break;
              w.push(g);
            }
      } else for (; h <= m; ++h)
        for (v = r - 1; v >= 1; --v)
          if (g = h > 0 ? v / o(-h) : v * o(h), !(g < u)) {
            if (g > c) break;
            w.push(g);
          }
      w.length * 2 < y && (w = q7(u, c, y));
    } else
      w = q7(h, m, Math.min(m - h, y)).map(o);
    return f ? w.reverse() : w;
  }, t.tickFormat = (s, l) => {
    if (s == null && (s = 10), l == null && (l = r === 10 ? "s" : ","), typeof l != "function" && (!(r % 1) && (l = vh(l)).precision == null && (l.trim = !0), l = n_(l)), s === 1 / 0) return l;
    const u = Math.max(1, r * s / t.ticks().length);
    return (c) => {
      let f = c / o(Math.round(i(c)));
      return f * r < r - 0.5 && (f *= r), f <= u ? l(c) : "";
    };
  }, t.nice = () => n(oX(n(), {
    floor: (s) => o(Math.floor(i(s))),
    ceil: (s) => o(Math.ceil(i(s)))
  })), t;
}
function aX() {
  const e = r_(sv()).domain([1, 10]);
  return e.copy = () => Dp(e, aX()).base(e.base()), zi.apply(e, arguments), e;
}
function _D(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function ED(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function i_(e) {
  var t = 1, n = e(_D(t), ED(t));
  return n.constant = function(r) {
    return arguments.length ? e(_D(t = +r), ED(t)) : t;
  }, tl(n);
}
function sX() {
  var e = i_(sv());
  return e.copy = function() {
    return Dp(e, sX()).constant(e.constant());
  }, zi.apply(e, arguments);
}
function ND(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function Zke(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function Xke(e) {
  return e < 0 ? -e * e : e * e;
}
function o_(e) {
  var t = e(kr, kr), n = 1;
  function r() {
    return n === 1 ? e(kr, kr) : n === 0.5 ? e(Zke, Xke) : e(ND(n), ND(1 / n));
  }
  return t.exponent = function(i) {
    return arguments.length ? (n = +i, r()) : n;
  }, tl(t);
}
function a_() {
  var e = o_(sv());
  return e.copy = function() {
    return Dp(e, a_()).exponent(e.exponent());
  }, zi.apply(e, arguments), e;
}
function Jke() {
  return a_.apply(null, arguments).exponent(0.5);
}
function AD(e) {
  return Math.sign(e) * e * e;
}
function Qke(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function lX() {
  var e = e_(), t = [0, 1], n = !1, r;
  function i(o) {
    var a = Qke(e(o));
    return isNaN(a) ? r : n ? Math.round(a) : a;
  }
  return i.invert = function(o) {
    return e.invert(AD(o));
  }, i.domain = function(o) {
    return arguments.length ? (e.domain(o), i) : e.domain();
  }, i.range = function(o) {
    return arguments.length ? (e.range((t = Array.from(o, Tm)).map(AD)), i) : t.slice();
  }, i.rangeRound = function(o) {
    return i.range(o).round(!0);
  }, i.round = function(o) {
    return arguments.length ? (n = !!o, i) : n;
  }, i.clamp = function(o) {
    return arguments.length ? (e.clamp(o), i) : e.clamp();
  }, i.unknown = function(o) {
    return arguments.length ? (r = o, i) : r;
  }, i.copy = function() {
    return lX(e.domain(), t).round(n).clamp(e.clamp()).unknown(r);
  }, zi.apply(i, arguments), tl(i);
}
function uX() {
  var e = [], t = [], n = [], r;
  function i() {
    var a = 0, s = Math.max(1, t.length);
    for (n = new Array(s - 1); ++a < s; ) n[a - 1] = ike(e, a / s);
    return o;
  }
  function o(a) {
    return a == null || isNaN(a = +a) ? r : t[Mp(n, a)];
  }
  return o.invertExtent = function(a) {
    var s = t.indexOf(a);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? n[s - 1] : e[0],
      s < n.length ? n[s] : e[e.length - 1]
    ];
  }, o.domain = function(a) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let s of a) s != null && !isNaN(s = +s) && e.push(s);
    return e.sort(Ds), i();
  }, o.range = function(a) {
    return arguments.length ? (t = Array.from(a), i()) : t.slice();
  }, o.unknown = function(a) {
    return arguments.length ? (r = a, o) : r;
  }, o.quantiles = function() {
    return n.slice();
  }, o.copy = function() {
    return uX().domain(e).range(t).unknown(r);
  }, zi.apply(o, arguments);
}
function cX() {
  var e = 0, t = 1, n = 1, r = [0.5], i = [0, 1], o;
  function a(l) {
    return l != null && l <= l ? i[Mp(r, l, 0, n)] : o;
  }
  function s() {
    var l = -1;
    for (r = new Array(n); ++l < n; ) r[l] = ((l + 1) * t - (l - n) * e) / (n + 1);
    return a;
  }
  return a.domain = function(l) {
    return arguments.length ? ([e, t] = l, e = +e, t = +t, s()) : [e, t];
  }, a.range = function(l) {
    return arguments.length ? (n = (i = Array.from(l)).length - 1, s()) : i.slice();
  }, a.invertExtent = function(l) {
    var u = i.indexOf(l);
    return u < 0 ? [NaN, NaN] : u < 1 ? [e, r[0]] : u >= n ? [r[n - 1], t] : [r[u - 1], r[u]];
  }, a.unknown = function(l) {
    return arguments.length && (o = l), a;
  }, a.thresholds = function() {
    return r.slice();
  }, a.copy = function() {
    return cX().domain([e, t]).range(i).unknown(o);
  }, zi.apply(tl(a), arguments);
}
function dX() {
  var e = [0.5], t = [0, 1], n, r = 1;
  function i(o) {
    return o != null && o <= o ? t[Mp(e, o, 0, r)] : n;
  }
  return i.domain = function(o) {
    return arguments.length ? (e = Array.from(o), r = Math.min(e.length, t.length - 1), i) : e.slice();
  }, i.range = function(o) {
    return arguments.length ? (t = Array.from(o), r = Math.min(e.length, t.length - 1), i) : t.slice();
  }, i.invertExtent = function(o) {
    var a = t.indexOf(o);
    return [e[a - 1], e[a]];
  }, i.unknown = function(o) {
    return arguments.length ? (n = o, i) : n;
  }, i.copy = function() {
    return dX().domain(e).range(t).unknown(n);
  }, zi.apply(i, arguments);
}
const k5 = /* @__PURE__ */ new Date(), P5 = /* @__PURE__ */ new Date();
function In(e, t, n, r) {
  function i(o) {
    return e(o = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+o)), o;
  }
  return i.floor = (o) => (e(o = /* @__PURE__ */ new Date(+o)), o), i.ceil = (o) => (e(o = new Date(o - 1)), t(o, 1), e(o), o), i.round = (o) => {
    const a = i(o), s = i.ceil(o);
    return o - a < s - o ? a : s;
  }, i.offset = (o, a) => (t(o = /* @__PURE__ */ new Date(+o), a == null ? 1 : Math.floor(a)), o), i.range = (o, a, s) => {
    const l = [];
    if (o = i.ceil(o), s = s == null ? 1 : Math.floor(s), !(o < a) || !(s > 0)) return l;
    let u;
    do
      l.push(u = /* @__PURE__ */ new Date(+o)), t(o, s), e(o);
    while (u < o && o < a);
    return l;
  }, i.filter = (o) => In((a) => {
    if (a >= a) for (; e(a), !o(a); ) a.setTime(a - 1);
  }, (a, s) => {
    if (a >= a)
      if (s < 0) for (; ++s <= 0; )
        for (; t(a, -1), !o(a); )
          ;
      else for (; --s >= 0; )
        for (; t(a, 1), !o(a); )
          ;
  }), n && (i.count = (o, a) => (k5.setTime(+o), P5.setTime(+a), e(k5), e(P5), Math.floor(n(k5, P5))), i.every = (o) => (o = Math.floor(o), !isFinite(o) || !(o > 0) ? null : o > 1 ? i.filter(r ? (a) => r(a) % o === 0 : (a) => i.count(0, a) % o === 0) : i)), i;
}
const Dm = In(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
Dm.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? In((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, n) => {
  t.setTime(+t + n * e);
}, (t, n) => (n - t) / e) : Dm);
Dm.range;
const Na = 1e3, Ti = Na * 60, Aa = Ti * 60, ja = Aa * 24, s_ = ja * 7, OD = ja * 30, T5 = ja * 365, Tl = In((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * Na);
}, (e, t) => (t - e) / Na, (e) => e.getUTCSeconds());
Tl.range;
const l_ = In((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Na);
}, (e, t) => {
  e.setTime(+e + t * Ti);
}, (e, t) => (t - e) / Ti, (e) => e.getMinutes());
l_.range;
const u_ = In((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * Ti);
}, (e, t) => (t - e) / Ti, (e) => e.getUTCMinutes());
u_.range;
const c_ = In((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Na - e.getMinutes() * Ti);
}, (e, t) => {
  e.setTime(+e + t * Aa);
}, (e, t) => (t - e) / Aa, (e) => e.getHours());
c_.range;
const d_ = In((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * Aa);
}, (e, t) => (t - e) / Aa, (e) => e.getUTCHours());
d_.range;
const Ip = In(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * Ti) / ja,
  (e) => e.getDate() - 1
);
Ip.range;
const lv = In((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / ja, (e) => e.getUTCDate() - 1);
lv.range;
const fX = In((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / ja, (e) => Math.floor(e / ja));
fX.range;
function pu(e) {
  return In((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setDate(t.getDate() + n * 7);
  }, (t, n) => (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * Ti) / s_);
}
const uv = pu(0), Im = pu(1), ePe = pu(2), tPe = pu(3), zc = pu(4), nPe = pu(5), rPe = pu(6);
uv.range;
Im.range;
ePe.range;
tPe.range;
zc.range;
nPe.range;
rPe.range;
function mu(e) {
  return In((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, (t, n) => (n - t) / s_);
}
const cv = mu(0), $m = mu(1), iPe = mu(2), oPe = mu(3), Wc = mu(4), aPe = mu(5), sPe = mu(6);
cv.range;
$m.range;
iPe.range;
oPe.range;
Wc.range;
aPe.range;
sPe.range;
const f_ = In((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
f_.range;
const h_ = In((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
h_.range;
const Va = In((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Va.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : In((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, n) => {
  t.setFullYear(t.getFullYear() + n * e);
});
Va.range;
const qa = In((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
qa.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : In((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, n) => {
  t.setUTCFullYear(t.getUTCFullYear() + n * e);
});
qa.range;
function hX(e, t, n, r, i, o) {
  const a = [
    [Tl, 1, Na],
    [Tl, 5, 5 * Na],
    [Tl, 15, 15 * Na],
    [Tl, 30, 30 * Na],
    [o, 1, Ti],
    [o, 5, 5 * Ti],
    [o, 15, 15 * Ti],
    [o, 30, 30 * Ti],
    [i, 1, Aa],
    [i, 3, 3 * Aa],
    [i, 6, 6 * Aa],
    [i, 12, 12 * Aa],
    [r, 1, ja],
    [r, 2, 2 * ja],
    [n, 1, s_],
    [t, 1, OD],
    [t, 3, 3 * OD],
    [e, 1, T5]
  ];
  function s(u, c, f) {
    const h = c < u;
    h && ([u, c] = [c, u]);
    const m = f && typeof f.range == "function" ? f : l(u, c, f), v = m ? m.range(u, +c + 1) : [];
    return h ? v.reverse() : v;
  }
  function l(u, c, f) {
    const h = Math.abs(c - u) / f, m = YS(([, , y]) => y).right(a, h);
    if (m === a.length) return e.every(W7(u / T5, c / T5, f));
    if (m === 0) return Dm.every(Math.max(W7(u, c, f), 1));
    const [v, g] = a[h / a[m - 1][2] < a[m][2] / h ? m - 1 : m];
    return v.every(g);
  }
  return [s, l];
}
const [lPe, uPe] = hX(qa, h_, cv, fX, d_, u_), [cPe, dPe] = hX(Va, f_, uv, Ip, c_, l_);
function M5(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function R5(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function pf(e, t, n) {
  return { y: e, m: t, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function fPe(e) {
  var t = e.dateTime, n = e.date, r = e.time, i = e.periods, o = e.days, a = e.shortDays, s = e.months, l = e.shortMonths, u = mf(i), c = gf(i), f = mf(o), h = gf(o), m = mf(a), v = gf(a), g = mf(s), y = gf(s), w = mf(l), C = gf(l), S = {
    a: V,
    A: H,
    b: Z,
    B: de,
    c: null,
    d: DD,
    e: DD,
    f: IPe,
    g: HPe,
    G: GPe,
    H: MPe,
    I: RPe,
    j: DPe,
    L: pX,
    m: $Pe,
    M: LPe,
    p: ne,
    q: Y,
    Q: LD,
    s: FD,
    S: FPe,
    u: BPe,
    U: jPe,
    V: VPe,
    w: qPe,
    W: zPe,
    x: null,
    X: null,
    y: WPe,
    Y: UPe,
    Z: KPe,
    "%": $D
  }, N = {
    a: le,
    A: be,
    b: pe,
    B: Ee,
    c: null,
    d: ID,
    e: ID,
    f: JPe,
    g: lTe,
    G: cTe,
    H: YPe,
    I: ZPe,
    j: XPe,
    L: gX,
    m: QPe,
    M: eTe,
    p: ge,
    q: Ce,
    Q: LD,
    s: FD,
    S: tTe,
    u: nTe,
    U: rTe,
    V: iTe,
    w: oTe,
    W: aTe,
    x: null,
    X: null,
    y: sTe,
    Y: uTe,
    Z: dTe,
    "%": $D
  }, E = {
    a: L,
    A: I,
    b: j,
    B,
    c: q,
    d: MD,
    e: MD,
    f: OPe,
    g: TD,
    G: PD,
    H: RD,
    I: RD,
    j: _Pe,
    L: APe,
    m: SPe,
    M: EPe,
    p: M,
    q: CPe,
    Q: PPe,
    s: TPe,
    S: NPe,
    u: vPe,
    U: yPe,
    V: bPe,
    w: gPe,
    W: xPe,
    x: G,
    X: U,
    y: TD,
    Y: PD,
    Z: wPe,
    "%": kPe
  };
  S.x = A(n, S), S.X = A(r, S), S.c = A(t, S), N.x = A(n, N), N.X = A(r, N), N.c = A(t, N);
  function A(ie, ye) {
    return function(ve) {
      var Q = [], Oe = -1, se = 0, nt = ie.length, ut, st, Nn;
      for (ve instanceof Date || (ve = /* @__PURE__ */ new Date(+ve)); ++Oe < nt; )
        ie.charCodeAt(Oe) === 37 && (Q.push(ie.slice(se, Oe)), (st = kD[ut = ie.charAt(++Oe)]) != null ? ut = ie.charAt(++Oe) : st = ut === "e" ? " " : "0", (Nn = ye[ut]) && (ut = Nn(ve, st)), Q.push(ut), se = Oe + 1);
      return Q.push(ie.slice(se, Oe)), Q.join("");
    };
  }
  function O(ie, ye) {
    return function(ve) {
      var Q = pf(1900, void 0, 1), Oe = T(Q, ie, ve += "", 0), se, nt;
      if (Oe != ve.length) return null;
      if ("Q" in Q) return new Date(Q.Q);
      if ("s" in Q) return new Date(Q.s * 1e3 + ("L" in Q ? Q.L : 0));
      if (ye && !("Z" in Q) && (Q.Z = 0), "p" in Q && (Q.H = Q.H % 12 + Q.p * 12), Q.m === void 0 && (Q.m = "q" in Q ? Q.q : 0), "V" in Q) {
        if (Q.V < 1 || Q.V > 53) return null;
        "w" in Q || (Q.w = 1), "Z" in Q ? (se = R5(pf(Q.y, 0, 1)), nt = se.getUTCDay(), se = nt > 4 || nt === 0 ? $m.ceil(se) : $m(se), se = lv.offset(se, (Q.V - 1) * 7), Q.y = se.getUTCFullYear(), Q.m = se.getUTCMonth(), Q.d = se.getUTCDate() + (Q.w + 6) % 7) : (se = M5(pf(Q.y, 0, 1)), nt = se.getDay(), se = nt > 4 || nt === 0 ? Im.ceil(se) : Im(se), se = Ip.offset(se, (Q.V - 1) * 7), Q.y = se.getFullYear(), Q.m = se.getMonth(), Q.d = se.getDate() + (Q.w + 6) % 7);
      } else ("W" in Q || "U" in Q) && ("w" in Q || (Q.w = "u" in Q ? Q.u % 7 : "W" in Q ? 1 : 0), nt = "Z" in Q ? R5(pf(Q.y, 0, 1)).getUTCDay() : M5(pf(Q.y, 0, 1)).getDay(), Q.m = 0, Q.d = "W" in Q ? (Q.w + 6) % 7 + Q.W * 7 - (nt + 5) % 7 : Q.w + Q.U * 7 - (nt + 6) % 7);
      return "Z" in Q ? (Q.H += Q.Z / 100 | 0, Q.M += Q.Z % 100, R5(Q)) : M5(Q);
    };
  }
  function T(ie, ye, ve, Q) {
    for (var Oe = 0, se = ye.length, nt = ve.length, ut, st; Oe < se; ) {
      if (Q >= nt) return -1;
      if (ut = ye.charCodeAt(Oe++), ut === 37) {
        if (ut = ye.charAt(Oe++), st = E[ut in kD ? ye.charAt(Oe++) : ut], !st || (Q = st(ie, ve, Q)) < 0) return -1;
      } else if (ut != ve.charCodeAt(Q++))
        return -1;
    }
    return Q;
  }
  function M(ie, ye, ve) {
    var Q = u.exec(ye.slice(ve));
    return Q ? (ie.p = c.get(Q[0].toLowerCase()), ve + Q[0].length) : -1;
  }
  function L(ie, ye, ve) {
    var Q = m.exec(ye.slice(ve));
    return Q ? (ie.w = v.get(Q[0].toLowerCase()), ve + Q[0].length) : -1;
  }
  function I(ie, ye, ve) {
    var Q = f.exec(ye.slice(ve));
    return Q ? (ie.w = h.get(Q[0].toLowerCase()), ve + Q[0].length) : -1;
  }
  function j(ie, ye, ve) {
    var Q = w.exec(ye.slice(ve));
    return Q ? (ie.m = C.get(Q[0].toLowerCase()), ve + Q[0].length) : -1;
  }
  function B(ie, ye, ve) {
    var Q = g.exec(ye.slice(ve));
    return Q ? (ie.m = y.get(Q[0].toLowerCase()), ve + Q[0].length) : -1;
  }
  function q(ie, ye, ve) {
    return T(ie, t, ye, ve);
  }
  function G(ie, ye, ve) {
    return T(ie, n, ye, ve);
  }
  function U(ie, ye, ve) {
    return T(ie, r, ye, ve);
  }
  function V(ie) {
    return a[ie.getDay()];
  }
  function H(ie) {
    return o[ie.getDay()];
  }
  function Z(ie) {
    return l[ie.getMonth()];
  }
  function de(ie) {
    return s[ie.getMonth()];
  }
  function ne(ie) {
    return i[+(ie.getHours() >= 12)];
  }
  function Y(ie) {
    return 1 + ~~(ie.getMonth() / 3);
  }
  function le(ie) {
    return a[ie.getUTCDay()];
  }
  function be(ie) {
    return o[ie.getUTCDay()];
  }
  function pe(ie) {
    return l[ie.getUTCMonth()];
  }
  function Ee(ie) {
    return s[ie.getUTCMonth()];
  }
  function ge(ie) {
    return i[+(ie.getUTCHours() >= 12)];
  }
  function Ce(ie) {
    return 1 + ~~(ie.getUTCMonth() / 3);
  }
  return {
    format: function(ie) {
      var ye = A(ie += "", S);
      return ye.toString = function() {
        return ie;
      }, ye;
    },
    parse: function(ie) {
      var ye = O(ie += "", !1);
      return ye.toString = function() {
        return ie;
      }, ye;
    },
    utcFormat: function(ie) {
      var ye = A(ie += "", N);
      return ye.toString = function() {
        return ie;
      }, ye;
    },
    utcParse: function(ie) {
      var ye = O(ie += "", !0);
      return ye.toString = function() {
        return ie;
      }, ye;
    }
  };
}
var kD = { "-": "", _: " ", 0: "0" }, Kn = /^\s*\d+/, hPe = /^%/, pPe = /[\\^$*+?|[\]().{}]/g;
function xt(e, t, n) {
  var r = e < 0 ? "-" : "", i = (r ? -e : e) + "", o = i.length;
  return r + (o < n ? new Array(n - o + 1).join(t) + i : i);
}
function mPe(e) {
  return e.replace(pPe, "\\$&");
}
function mf(e) {
  return new RegExp("^(?:" + e.map(mPe).join("|") + ")", "i");
}
function gf(e) {
  return new Map(e.map((t, n) => [t.toLowerCase(), n]));
}
function gPe(e, t, n) {
  var r = Kn.exec(t.slice(n, n + 1));
  return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function vPe(e, t, n) {
  var r = Kn.exec(t.slice(n, n + 1));
  return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function yPe(e, t, n) {
  var r = Kn.exec(t.slice(n, n + 2));
  return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function bPe(e, t, n) {
  var r = Kn.exec(t.slice(n, n + 2));
  return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function xPe(e, t, n) {
  var r = Kn.exec(t.slice(n, n + 2));
  return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function PD(e, t, n) {
  var r = Kn.exec(t.slice(n, n + 4));
  return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function TD(e, t, n) {
  var r = Kn.exec(t.slice(n, n + 2));
  return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function wPe(e, t, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
  return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function CPe(e, t, n) {
  var r = Kn.exec(t.slice(n, n + 1));
  return r ? (e.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function SPe(e, t, n) {
  var r = Kn.exec(t.slice(n, n + 2));
  return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function MD(e, t, n) {
  var r = Kn.exec(t.slice(n, n + 2));
  return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function _Pe(e, t, n) {
  var r = Kn.exec(t.slice(n, n + 3));
  return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function RD(e, t, n) {
  var r = Kn.exec(t.slice(n, n + 2));
  return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function EPe(e, t, n) {
  var r = Kn.exec(t.slice(n, n + 2));
  return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function NPe(e, t, n) {
  var r = Kn.exec(t.slice(n, n + 2));
  return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function APe(e, t, n) {
  var r = Kn.exec(t.slice(n, n + 3));
  return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function OPe(e, t, n) {
  var r = Kn.exec(t.slice(n, n + 6));
  return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function kPe(e, t, n) {
  var r = hPe.exec(t.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function PPe(e, t, n) {
  var r = Kn.exec(t.slice(n));
  return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function TPe(e, t, n) {
  var r = Kn.exec(t.slice(n));
  return r ? (e.s = +r[0], n + r[0].length) : -1;
}
function DD(e, t) {
  return xt(e.getDate(), t, 2);
}
function MPe(e, t) {
  return xt(e.getHours(), t, 2);
}
function RPe(e, t) {
  return xt(e.getHours() % 12 || 12, t, 2);
}
function DPe(e, t) {
  return xt(1 + Ip.count(Va(e), e), t, 3);
}
function pX(e, t) {
  return xt(e.getMilliseconds(), t, 3);
}
function IPe(e, t) {
  return pX(e, t) + "000";
}
function $Pe(e, t) {
  return xt(e.getMonth() + 1, t, 2);
}
function LPe(e, t) {
  return xt(e.getMinutes(), t, 2);
}
function FPe(e, t) {
  return xt(e.getSeconds(), t, 2);
}
function BPe(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function jPe(e, t) {
  return xt(uv.count(Va(e) - 1, e), t, 2);
}
function mX(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? zc(e) : zc.ceil(e);
}
function VPe(e, t) {
  return e = mX(e), xt(zc.count(Va(e), e) + (Va(e).getDay() === 4), t, 2);
}
function qPe(e) {
  return e.getDay();
}
function zPe(e, t) {
  return xt(Im.count(Va(e) - 1, e), t, 2);
}
function WPe(e, t) {
  return xt(e.getFullYear() % 100, t, 2);
}
function HPe(e, t) {
  return e = mX(e), xt(e.getFullYear() % 100, t, 2);
}
function UPe(e, t) {
  return xt(e.getFullYear() % 1e4, t, 4);
}
function GPe(e, t) {
  var n = e.getDay();
  return e = n >= 4 || n === 0 ? zc(e) : zc.ceil(e), xt(e.getFullYear() % 1e4, t, 4);
}
function KPe(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + xt(t / 60 | 0, "0", 2) + xt(t % 60, "0", 2);
}
function ID(e, t) {
  return xt(e.getUTCDate(), t, 2);
}
function YPe(e, t) {
  return xt(e.getUTCHours(), t, 2);
}
function ZPe(e, t) {
  return xt(e.getUTCHours() % 12 || 12, t, 2);
}
function XPe(e, t) {
  return xt(1 + lv.count(qa(e), e), t, 3);
}
function gX(e, t) {
  return xt(e.getUTCMilliseconds(), t, 3);
}
function JPe(e, t) {
  return gX(e, t) + "000";
}
function QPe(e, t) {
  return xt(e.getUTCMonth() + 1, t, 2);
}
function eTe(e, t) {
  return xt(e.getUTCMinutes(), t, 2);
}
function tTe(e, t) {
  return xt(e.getUTCSeconds(), t, 2);
}
function nTe(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function rTe(e, t) {
  return xt(cv.count(qa(e) - 1, e), t, 2);
}
function vX(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? Wc(e) : Wc.ceil(e);
}
function iTe(e, t) {
  return e = vX(e), xt(Wc.count(qa(e), e) + (qa(e).getUTCDay() === 4), t, 2);
}
function oTe(e) {
  return e.getUTCDay();
}
function aTe(e, t) {
  return xt($m.count(qa(e) - 1, e), t, 2);
}
function sTe(e, t) {
  return xt(e.getUTCFullYear() % 100, t, 2);
}
function lTe(e, t) {
  return e = vX(e), xt(e.getUTCFullYear() % 100, t, 2);
}
function uTe(e, t) {
  return xt(e.getUTCFullYear() % 1e4, t, 4);
}
function cTe(e, t) {
  var n = e.getUTCDay();
  return e = n >= 4 || n === 0 ? Wc(e) : Wc.ceil(e), xt(e.getUTCFullYear() % 1e4, t, 4);
}
function dTe() {
  return "+0000";
}
function $D() {
  return "%";
}
function LD(e) {
  return +e;
}
function FD(e) {
  return Math.floor(+e / 1e3);
}
var Yu, yX, bX;
fTe({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function fTe(e) {
  return Yu = fPe(e), yX = Yu.format, Yu.parse, bX = Yu.utcFormat, Yu.utcParse, Yu;
}
function hTe(e) {
  return new Date(e);
}
function pTe(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function p_(e, t, n, r, i, o, a, s, l, u) {
  var c = e_(), f = c.invert, h = c.domain, m = u(".%L"), v = u(":%S"), g = u("%I:%M"), y = u("%I %p"), w = u("%a %d"), C = u("%b %d"), S = u("%B"), N = u("%Y");
  function E(A) {
    return (l(A) < A ? m : s(A) < A ? v : a(A) < A ? g : o(A) < A ? y : r(A) < A ? i(A) < A ? w : C : n(A) < A ? S : N)(A);
  }
  return c.invert = function(A) {
    return new Date(f(A));
  }, c.domain = function(A) {
    return arguments.length ? h(Array.from(A, pTe)) : h().map(hTe);
  }, c.ticks = function(A) {
    var O = h();
    return e(O[0], O[O.length - 1], A ?? 10);
  }, c.tickFormat = function(A, O) {
    return O == null ? E : u(O);
  }, c.nice = function(A) {
    var O = h();
    return (!A || typeof A.range != "function") && (A = t(O[0], O[O.length - 1], A ?? 10)), A ? h(oX(O, A)) : c;
  }, c.copy = function() {
    return Dp(c, p_(e, t, n, r, i, o, a, s, l, u));
  }, c;
}
function mTe() {
  return zi.apply(p_(cPe, dPe, Va, f_, uv, Ip, c_, l_, Tl, yX).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function gTe() {
  return zi.apply(p_(lPe, uPe, qa, h_, cv, lv, d_, u_, Tl, bX).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function dv() {
  var e = 0, t = 1, n, r, i, o, a = kr, s = !1, l;
  function u(f) {
    return f == null || isNaN(f = +f) ? l : a(i === 0 ? 0.5 : (f = (o(f) - n) * i, s ? Math.max(0, Math.min(1, f)) : f));
  }
  u.domain = function(f) {
    return arguments.length ? ([e, t] = f, n = o(e = +e), r = o(t = +t), i = n === r ? 0 : 1 / (r - n), u) : [e, t];
  }, u.clamp = function(f) {
    return arguments.length ? (s = !!f, u) : s;
  }, u.interpolator = function(f) {
    return arguments.length ? (a = f, u) : a;
  };
  function c(f) {
    return function(h) {
      var m, v;
      return arguments.length ? ([m, v] = h, a = f(m, v), u) : [a(0), a(1)];
    };
  }
  return u.range = c(Dd), u.rangeRound = c(QS), u.unknown = function(f) {
    return arguments.length ? (l = f, u) : l;
  }, function(f) {
    return o = f, n = f(e), r = f(t), i = n === r ? 0 : 1 / (r - n), u;
  };
}
function nl(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function xX() {
  var e = tl(dv()(kr));
  return e.copy = function() {
    return nl(e, xX());
  }, Ja.apply(e, arguments);
}
function wX() {
  var e = r_(dv()).domain([1, 10]);
  return e.copy = function() {
    return nl(e, wX()).base(e.base());
  }, Ja.apply(e, arguments);
}
function CX() {
  var e = i_(dv());
  return e.copy = function() {
    return nl(e, CX()).constant(e.constant());
  }, Ja.apply(e, arguments);
}
function m_() {
  var e = o_(dv());
  return e.copy = function() {
    return nl(e, m_()).exponent(e.exponent());
  }, Ja.apply(e, arguments);
}
function vTe() {
  return m_.apply(null, arguments).exponent(0.5);
}
function SX() {
  var e = [], t = kr;
  function n(r) {
    if (r != null && !isNaN(r = +r)) return t((Mp(e, r, 1) - 1) / (e.length - 1));
  }
  return n.domain = function(r) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let i of r) i != null && !isNaN(i = +i) && e.push(i);
    return e.sort(Ds), n;
  }, n.interpolator = function(r) {
    return arguments.length ? (t = r, n) : t;
  }, n.range = function() {
    return e.map((r, i) => t(i / (e.length - 1)));
  }, n.quantiles = function(r) {
    return Array.from({ length: r + 1 }, (i, o) => rke(e, o / r));
  }, n.copy = function() {
    return SX(t).domain(e);
  }, Ja.apply(n, arguments);
}
function fv() {
  var e = 0, t = 0.5, n = 1, r = 1, i, o, a, s, l, u = kr, c, f = !1, h;
  function m(g) {
    return isNaN(g = +g) ? h : (g = 0.5 + ((g = +c(g)) - o) * (r * g < r * o ? s : l), u(f ? Math.max(0, Math.min(1, g)) : g));
  }
  m.domain = function(g) {
    return arguments.length ? ([e, t, n] = g, i = c(e = +e), o = c(t = +t), a = c(n = +n), s = i === o ? 0 : 0.5 / (o - i), l = o === a ? 0 : 0.5 / (a - o), r = o < i ? -1 : 1, m) : [e, t, n];
  }, m.clamp = function(g) {
    return arguments.length ? (f = !!g, m) : f;
  }, m.interpolator = function(g) {
    return arguments.length ? (u = g, m) : u;
  };
  function v(g) {
    return function(y) {
      var w, C, S;
      return arguments.length ? ([w, C, S] = y, u = kke(g, [w, C, S]), m) : [u(0), u(0.5), u(1)];
    };
  }
  return m.range = v(Dd), m.rangeRound = v(QS), m.unknown = function(g) {
    return arguments.length ? (h = g, m) : h;
  }, function(g) {
    return c = g, i = g(e), o = g(t), a = g(n), s = i === o ? 0 : 0.5 / (o - i), l = o === a ? 0 : 0.5 / (a - o), r = o < i ? -1 : 1, m;
  };
}
function _X() {
  var e = tl(fv()(kr));
  return e.copy = function() {
    return nl(e, _X());
  }, Ja.apply(e, arguments);
}
function EX() {
  var e = r_(fv()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return nl(e, EX()).base(e.base());
  }, Ja.apply(e, arguments);
}
function NX() {
  var e = i_(fv());
  return e.copy = function() {
    return nl(e, NX()).constant(e.constant());
  }, Ja.apply(e, arguments);
}
function g_() {
  var e = o_(fv());
  return e.copy = function() {
    return nl(e, g_()).exponent(e.exponent());
  }, Ja.apply(e, arguments);
}
function yTe() {
  return g_.apply(null, arguments).exponent(0.5);
}
const BD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: hh,
  scaleDiverging: _X,
  scaleDivergingLog: EX,
  scaleDivergingPow: g_,
  scaleDivergingSqrt: yTe,
  scaleDivergingSymlog: NX,
  scaleIdentity: iX,
  scaleImplicit: H7,
  scaleLinear: Rm,
  scaleLog: aX,
  scaleOrdinal: ZS,
  scalePoint: jf,
  scalePow: a_,
  scaleQuantile: uX,
  scaleQuantize: cX,
  scaleRadial: lX,
  scaleSequential: xX,
  scaleSequentialLog: wX,
  scaleSequentialPow: m_,
  scaleSequentialQuantile: SX,
  scaleSequentialSqrt: vTe,
  scaleSequentialSymlog: CX,
  scaleSqrt: Jke,
  scaleSymlog: sX,
  scaleThreshold: dX,
  scaleTime: mTe,
  scaleUtc: gTe,
  tickFormat: rX
}, Symbol.toStringTag, { value: "Module" }));
var D5, jD;
function hv() {
  if (jD) return D5;
  jD = 1;
  var e = Pd();
  function t(n, r, i) {
    for (var o = -1, a = n.length; ++o < a; ) {
      var s = n[o], l = r(s);
      if (l != null && (u === void 0 ? l === l && !e(l) : i(l, u)))
        var u = l, c = s;
    }
    return c;
  }
  return D5 = t, D5;
}
var I5, VD;
function AX() {
  if (VD) return I5;
  VD = 1;
  function e(t, n) {
    return t > n;
  }
  return I5 = e, I5;
}
var $5, qD;
function bTe() {
  if (qD) return $5;
  qD = 1;
  var e = hv(), t = AX(), n = Md();
  function r(i) {
    return i && i.length ? e(i, n, t) : void 0;
  }
  return $5 = r, $5;
}
var xTe = bTe();
const pv = /* @__PURE__ */ Rt(xTe);
var L5, zD;
function OX() {
  if (zD) return L5;
  zD = 1;
  function e(t, n) {
    return t < n;
  }
  return L5 = e, L5;
}
var F5, WD;
function wTe() {
  if (WD) return F5;
  WD = 1;
  var e = hv(), t = OX(), n = Md();
  function r(i) {
    return i && i.length ? e(i, n, t) : void 0;
  }
  return F5 = r, F5;
}
var CTe = wTe();
const mv = /* @__PURE__ */ Rt(CTe);
var B5, HD;
function STe() {
  if (HD) return B5;
  HD = 1;
  var e = MS(), t = na(), n = IZ(), r = ei();
  function i(o, a) {
    var s = r(o) ? e : n;
    return s(o, t(a, 3));
  }
  return B5 = i, B5;
}
var j5, UD;
function _Te() {
  if (UD) return j5;
  UD = 1;
  var e = RZ(), t = STe();
  function n(r, i) {
    return e(t(r, i), 1);
  }
  return j5 = n, j5;
}
var ETe = _Te();
const NTe = /* @__PURE__ */ Rt(ETe);
var V5, GD;
function ATe() {
  if (GD) return V5;
  GD = 1;
  var e = HS();
  function t(n, r) {
    return e(n, r);
  }
  return V5 = t, V5;
}
var OTe = ATe();
const gv = /* @__PURE__ */ Rt(OTe);
var Id = 1e9, kTe = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, y_, on = !0, Li = "[DecimalError] ", Fl = Li + "Invalid argument: ", v_ = Li + "Exponent out of range: ", $d = Math.floor, wl = Math.pow, PTe = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ci, Bn = 1e7, Jt = 7, kX = 9007199254740991, Lm = $d(kX / Jt), Ae = {};
Ae.absoluteValue = Ae.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
Ae.comparedTo = Ae.cmp = function(e) {
  var t, n, r, i, o = this;
  if (e = new o.constructor(e), o.s !== e.s) return o.s || -e.s;
  if (o.e !== e.e) return o.e > e.e ^ o.s < 0 ? 1 : -1;
  for (r = o.d.length, i = e.d.length, t = 0, n = r < i ? r : i; t < n; ++t)
    if (o.d[t] !== e.d[t]) return o.d[t] > e.d[t] ^ o.s < 0 ? 1 : -1;
  return r === i ? 0 : r > i ^ o.s < 0 ? 1 : -1;
};
Ae.decimalPlaces = Ae.dp = function() {
  var e = this, t = e.d.length - 1, n = (t - e.e) * Jt;
  if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) n--;
  return n < 0 ? 0 : n;
};
Ae.dividedBy = Ae.div = function(e) {
  return Ra(this, new this.constructor(e));
};
Ae.dividedToIntegerBy = Ae.idiv = function(e) {
  var t = this, n = t.constructor;
  return Wt(Ra(t, new n(e), 0, 1), n.precision);
};
Ae.equals = Ae.eq = function(e) {
  return !this.cmp(e);
};
Ae.exponent = function() {
  return xn(this);
};
Ae.greaterThan = Ae.gt = function(e) {
  return this.cmp(e) > 0;
};
Ae.greaterThanOrEqualTo = Ae.gte = function(e) {
  return this.cmp(e) >= 0;
};
Ae.isInteger = Ae.isint = function() {
  return this.e > this.d.length - 2;
};
Ae.isNegative = Ae.isneg = function() {
  return this.s < 0;
};
Ae.isPositive = Ae.ispos = function() {
  return this.s > 0;
};
Ae.isZero = function() {
  return this.s === 0;
};
Ae.lessThan = Ae.lt = function(e) {
  return this.cmp(e) < 0;
};
Ae.lessThanOrEqualTo = Ae.lte = function(e) {
  return this.cmp(e) < 1;
};
Ae.logarithm = Ae.log = function(e) {
  var t, n = this, r = n.constructor, i = r.precision, o = i + 5;
  if (e === void 0)
    e = new r(10);
  else if (e = new r(e), e.s < 1 || e.eq(ci)) throw Error(Li + "NaN");
  if (n.s < 1) throw Error(Li + (n.s ? "NaN" : "-Infinity"));
  return n.eq(ci) ? new r(0) : (on = !1, t = Ra(yh(n, o), yh(e, o), o), on = !0, Wt(t, i));
};
Ae.minus = Ae.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? MX(t, e) : PX(t, (e.s = -e.s, e));
};
Ae.modulo = Ae.mod = function(e) {
  var t, n = this, r = n.constructor, i = r.precision;
  if (e = new r(e), !e.s) throw Error(Li + "NaN");
  return n.s ? (on = !1, t = Ra(n, e, 0, 1).times(e), on = !0, n.minus(t)) : Wt(new r(n), i);
};
Ae.naturalExponential = Ae.exp = function() {
  return TX(this);
};
Ae.naturalLogarithm = Ae.ln = function() {
  return yh(this);
};
Ae.negated = Ae.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
Ae.plus = Ae.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? PX(t, e) : MX(t, (e.s = -e.s, e));
};
Ae.precision = Ae.sd = function(e) {
  var t, n, r, i = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(Fl + e);
  if (t = xn(i) + 1, r = i.d.length - 1, n = r * Jt + 1, r = i.d[r], r) {
    for (; r % 10 == 0; r /= 10) n--;
    for (r = i.d[0]; r >= 10; r /= 10) n++;
  }
  return e && t > n ? t : n;
};
Ae.squareRoot = Ae.sqrt = function() {
  var e, t, n, r, i, o, a, s = this, l = s.constructor;
  if (s.s < 1) {
    if (!s.s) return new l(0);
    throw Error(Li + "NaN");
  }
  for (e = xn(s), on = !1, i = Math.sqrt(+s), i == 0 || i == 1 / 0 ? (t = Do(s.d), (t.length + e) % 2 == 0 && (t += "0"), i = Math.sqrt(t), e = $d((e + 1) / 2) - (e < 0 || e % 2), i == 1 / 0 ? t = "5e" + e : (t = i.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), r = new l(t)) : r = new l(i.toString()), n = l.precision, i = a = n + 3; ; )
    if (o = r, r = o.plus(Ra(s, o, a + 2)).times(0.5), Do(o.d).slice(0, a) === (t = Do(r.d)).slice(0, a)) {
      if (t = t.slice(a - 3, a + 1), i == a && t == "4999") {
        if (Wt(o, n + 1, 0), o.times(o).eq(s)) {
          r = o;
          break;
        }
      } else if (t != "9999")
        break;
      a += 4;
    }
  return on = !0, Wt(r, n);
};
Ae.times = Ae.mul = function(e) {
  var t, n, r, i, o, a, s, l, u, c = this, f = c.constructor, h = c.d, m = (e = new f(e)).d;
  if (!c.s || !e.s) return new f(0);
  for (e.s *= c.s, n = c.e + e.e, l = h.length, u = m.length, l < u && (o = h, h = m, m = o, a = l, l = u, u = a), o = [], a = l + u, r = a; r--; ) o.push(0);
  for (r = u; --r >= 0; ) {
    for (t = 0, i = l + r; i > r; )
      s = o[i] + m[r] * h[i - r - 1] + t, o[i--] = s % Bn | 0, t = s / Bn | 0;
    o[i] = (o[i] + t) % Bn | 0;
  }
  for (; !o[--a]; ) o.pop();
  return t ? ++n : o.shift(), e.d = o, e.e = n, on ? Wt(e, f.precision) : e;
};
Ae.toDecimalPlaces = Ae.todp = function(e, t) {
  var n = this, r = n.constructor;
  return n = new r(n), e === void 0 ? n : (Uo(e, 0, Id), t === void 0 ? t = r.rounding : Uo(t, 0, 8), Wt(n, e + xn(n) + 1, t));
};
Ae.toExponential = function(e, t) {
  var n, r = this, i = r.constructor;
  return e === void 0 ? n = tu(r, !0) : (Uo(e, 0, Id), t === void 0 ? t = i.rounding : Uo(t, 0, 8), r = Wt(new i(r), e + 1, t), n = tu(r, !0, e + 1)), n;
};
Ae.toFixed = function(e, t) {
  var n, r, i = this, o = i.constructor;
  return e === void 0 ? tu(i) : (Uo(e, 0, Id), t === void 0 ? t = o.rounding : Uo(t, 0, 8), r = Wt(new o(i), e + xn(i) + 1, t), n = tu(r.abs(), !1, e + xn(r) + 1), i.isneg() && !i.isZero() ? "-" + n : n);
};
Ae.toInteger = Ae.toint = function() {
  var e = this, t = e.constructor;
  return Wt(new t(e), xn(e) + 1, t.rounding);
};
Ae.toNumber = function() {
  return +this;
};
Ae.toPower = Ae.pow = function(e) {
  var t, n, r, i, o, a, s = this, l = s.constructor, u = 12, c = +(e = new l(e));
  if (!e.s) return new l(ci);
  if (s = new l(s), !s.s) {
    if (e.s < 1) throw Error(Li + "Infinity");
    return s;
  }
  if (s.eq(ci)) return s;
  if (r = l.precision, e.eq(ci)) return Wt(s, r);
  if (t = e.e, n = e.d.length - 1, a = t >= n, o = s.s, a) {
    if ((n = c < 0 ? -c : c) <= kX) {
      for (i = new l(ci), t = Math.ceil(r / Jt + 4), on = !1; n % 2 && (i = i.times(s), YD(i.d, t)), n = $d(n / 2), n !== 0; )
        s = s.times(s), YD(s.d, t);
      return on = !0, e.s < 0 ? new l(ci).div(i) : Wt(i, r);
    }
  } else if (o < 0) throw Error(Li + "NaN");
  return o = o < 0 && e.d[Math.max(t, n)] & 1 ? -1 : 1, s.s = 1, on = !1, i = e.times(yh(s, r + u)), on = !0, i = TX(i), i.s = o, i;
};
Ae.toPrecision = function(e, t) {
  var n, r, i = this, o = i.constructor;
  return e === void 0 ? (n = xn(i), r = tu(i, n <= o.toExpNeg || n >= o.toExpPos)) : (Uo(e, 1, Id), t === void 0 ? t = o.rounding : Uo(t, 0, 8), i = Wt(new o(i), e, t), n = xn(i), r = tu(i, e <= n || n <= o.toExpNeg, e)), r;
};
Ae.toSignificantDigits = Ae.tosd = function(e, t) {
  var n = this, r = n.constructor;
  return e === void 0 ? (e = r.precision, t = r.rounding) : (Uo(e, 1, Id), t === void 0 ? t = r.rounding : Uo(t, 0, 8)), Wt(new r(n), e, t);
};
Ae.toString = Ae.valueOf = Ae.val = Ae.toJSON = Ae[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = xn(e), n = e.constructor;
  return tu(e, t <= n.toExpNeg || t >= n.toExpPos);
};
function PX(e, t) {
  var n, r, i, o, a, s, l, u, c = e.constructor, f = c.precision;
  if (!e.s || !t.s)
    return t.s || (t = new c(e)), on ? Wt(t, f) : t;
  if (l = e.d, u = t.d, a = e.e, i = t.e, l = l.slice(), o = a - i, o) {
    for (o < 0 ? (r = l, o = -o, s = u.length) : (r = u, i = a, s = l.length), a = Math.ceil(f / Jt), s = a > s ? a + 1 : s + 1, o > s && (o = s, r.length = 1), r.reverse(); o--; ) r.push(0);
    r.reverse();
  }
  for (s = l.length, o = u.length, s - o < 0 && (o = s, r = u, u = l, l = r), n = 0; o; )
    n = (l[--o] = l[o] + u[o] + n) / Bn | 0, l[o] %= Bn;
  for (n && (l.unshift(n), ++i), s = l.length; l[--s] == 0; ) l.pop();
  return t.d = l, t.e = i, on ? Wt(t, f) : t;
}
function Uo(e, t, n) {
  if (e !== ~~e || e < t || e > n)
    throw Error(Fl + e);
}
function Do(e) {
  var t, n, r, i = e.length - 1, o = "", a = e[0];
  if (i > 0) {
    for (o += a, t = 1; t < i; t++)
      r = e[t] + "", n = Jt - r.length, n && (o += ys(n)), o += r;
    a = e[t], r = a + "", n = Jt - r.length, n && (o += ys(n));
  } else if (a === 0)
    return "0";
  for (; a % 10 === 0; ) a /= 10;
  return o + a;
}
var Ra = /* @__PURE__ */ function() {
  function e(r, i) {
    var o, a = 0, s = r.length;
    for (r = r.slice(); s--; )
      o = r[s] * i + a, r[s] = o % Bn | 0, a = o / Bn | 0;
    return a && r.unshift(a), r;
  }
  function t(r, i, o, a) {
    var s, l;
    if (o != a)
      l = o > a ? 1 : -1;
    else
      for (s = l = 0; s < o; s++)
        if (r[s] != i[s]) {
          l = r[s] > i[s] ? 1 : -1;
          break;
        }
    return l;
  }
  function n(r, i, o) {
    for (var a = 0; o--; )
      r[o] -= a, a = r[o] < i[o] ? 1 : 0, r[o] = a * Bn + r[o] - i[o];
    for (; !r[0] && r.length > 1; ) r.shift();
  }
  return function(r, i, o, a) {
    var s, l, u, c, f, h, m, v, g, y, w, C, S, N, E, A, O, T, M = r.constructor, L = r.s == i.s ? 1 : -1, I = r.d, j = i.d;
    if (!r.s) return new M(r);
    if (!i.s) throw Error(Li + "Division by zero");
    for (l = r.e - i.e, O = j.length, E = I.length, m = new M(L), v = m.d = [], u = 0; j[u] == (I[u] || 0); ) ++u;
    if (j[u] > (I[u] || 0) && --l, o == null ? C = o = M.precision : a ? C = o + (xn(r) - xn(i)) + 1 : C = o, C < 0) return new M(0);
    if (C = C / Jt + 2 | 0, u = 0, O == 1)
      for (c = 0, j = j[0], C++; (u < E || c) && C--; u++)
        S = c * Bn + (I[u] || 0), v[u] = S / j | 0, c = S % j | 0;
    else {
      for (c = Bn / (j[0] + 1) | 0, c > 1 && (j = e(j, c), I = e(I, c), O = j.length, E = I.length), N = O, g = I.slice(0, O), y = g.length; y < O; ) g[y++] = 0;
      T = j.slice(), T.unshift(0), A = j[0], j[1] >= Bn / 2 && ++A;
      do
        c = 0, s = t(j, g, O, y), s < 0 ? (w = g[0], O != y && (w = w * Bn + (g[1] || 0)), c = w / A | 0, c > 1 ? (c >= Bn && (c = Bn - 1), f = e(j, c), h = f.length, y = g.length, s = t(f, g, h, y), s == 1 && (c--, n(f, O < h ? T : j, h))) : (c == 0 && (s = c = 1), f = j.slice()), h = f.length, h < y && f.unshift(0), n(g, f, y), s == -1 && (y = g.length, s = t(j, g, O, y), s < 1 && (c++, n(g, O < y ? T : j, y))), y = g.length) : s === 0 && (c++, g = [0]), v[u++] = c, s && g[0] ? g[y++] = I[N] || 0 : (g = [I[N]], y = 1);
      while ((N++ < E || g[0] !== void 0) && C--);
    }
    return v[0] || v.shift(), m.e = l, Wt(m, a ? o + xn(m) + 1 : o);
  };
}();
function TX(e, t) {
  var n, r, i, o, a, s, l = 0, u = 0, c = e.constructor, f = c.precision;
  if (xn(e) > 16) throw Error(v_ + xn(e));
  if (!e.s) return new c(ci);
  for (on = !1, s = f, a = new c(0.03125); e.abs().gte(0.1); )
    e = e.times(a), u += 5;
  for (r = Math.log(wl(2, u)) / Math.LN10 * 2 + 5 | 0, s += r, n = i = o = new c(ci), c.precision = s; ; ) {
    if (i = Wt(i.times(e), s), n = n.times(++l), a = o.plus(Ra(i, n, s)), Do(a.d).slice(0, s) === Do(o.d).slice(0, s)) {
      for (; u--; ) o = Wt(o.times(o), s);
      return c.precision = f, t == null ? (on = !0, Wt(o, f)) : o;
    }
    o = a;
  }
}
function xn(e) {
  for (var t = e.e * Jt, n = e.d[0]; n >= 10; n /= 10) t++;
  return t;
}
function q5(e, t, n) {
  if (t > e.LN10.sd())
    throw on = !0, n && (e.precision = n), Error(Li + "LN10 precision limit exceeded");
  return Wt(new e(e.LN10), t);
}
function ys(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function yh(e, t) {
  var n, r, i, o, a, s, l, u, c, f = 1, h = 10, m = e, v = m.d, g = m.constructor, y = g.precision;
  if (m.s < 1) throw Error(Li + (m.s ? "NaN" : "-Infinity"));
  if (m.eq(ci)) return new g(0);
  if (t == null ? (on = !1, u = y) : u = t, m.eq(10))
    return t == null && (on = !0), q5(g, u);
  if (u += h, g.precision = u, n = Do(v), r = n.charAt(0), o = xn(m), Math.abs(o) < 15e14) {
    for (; r < 7 && r != 1 || r == 1 && n.charAt(1) > 3; )
      m = m.times(e), n = Do(m.d), r = n.charAt(0), f++;
    o = xn(m), r > 1 ? (m = new g("0." + n), o++) : m = new g(r + "." + n.slice(1));
  } else
    return l = q5(g, u + 2, y).times(o + ""), m = yh(new g(r + "." + n.slice(1)), u - h).plus(l), g.precision = y, t == null ? (on = !0, Wt(m, y)) : m;
  for (s = a = m = Ra(m.minus(ci), m.plus(ci), u), c = Wt(m.times(m), u), i = 3; ; ) {
    if (a = Wt(a.times(c), u), l = s.plus(Ra(a, new g(i), u)), Do(l.d).slice(0, u) === Do(s.d).slice(0, u))
      return s = s.times(2), o !== 0 && (s = s.plus(q5(g, u + 2, y).times(o + ""))), s = Ra(s, new g(f), u), g.precision = y, t == null ? (on = !0, Wt(s, y)) : s;
    s = l, i += 2;
  }
}
function KD(e, t) {
  var n, r, i;
  for ((n = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (r = t.search(/e/i)) > 0 ? (n < 0 && (n = r), n += +t.slice(r + 1), t = t.substring(0, r)) : n < 0 && (n = t.length), r = 0; t.charCodeAt(r) === 48; ) ++r;
  for (i = t.length; t.charCodeAt(i - 1) === 48; ) --i;
  if (t = t.slice(r, i), t) {
    if (i -= r, n = n - r - 1, e.e = $d(n / Jt), e.d = [], r = (n + 1) % Jt, n < 0 && (r += Jt), r < i) {
      for (r && e.d.push(+t.slice(0, r)), i -= Jt; r < i; ) e.d.push(+t.slice(r, r += Jt));
      t = t.slice(r), r = Jt - t.length;
    } else
      r -= i;
    for (; r--; ) t += "0";
    if (e.d.push(+t), on && (e.e > Lm || e.e < -Lm)) throw Error(v_ + n);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function Wt(e, t, n) {
  var r, i, o, a, s, l, u, c, f = e.d;
  for (a = 1, o = f[0]; o >= 10; o /= 10) a++;
  if (r = t - a, r < 0)
    r += Jt, i = t, u = f[c = 0];
  else {
    if (c = Math.ceil((r + 1) / Jt), o = f.length, c >= o) return e;
    for (u = o = f[c], a = 1; o >= 10; o /= 10) a++;
    r %= Jt, i = r - Jt + a;
  }
  if (n !== void 0 && (o = wl(10, a - i - 1), s = u / o % 10 | 0, l = t < 0 || f[c + 1] !== void 0 || u % o, l = n < 4 ? (s || l) && (n == 0 || n == (e.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (n == 4 || l || n == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (r > 0 ? i > 0 ? u / wl(10, a - i) : 0 : f[c - 1]) % 10 & 1 || n == (e.s < 0 ? 8 : 7))), t < 1 || !f[0])
    return l ? (o = xn(e), f.length = 1, t = t - o - 1, f[0] = wl(10, (Jt - t % Jt) % Jt), e.e = $d(-t / Jt) || 0) : (f.length = 1, f[0] = e.e = e.s = 0), e;
  if (r == 0 ? (f.length = c, o = 1, c--) : (f.length = c + 1, o = wl(10, Jt - r), f[c] = i > 0 ? (u / wl(10, a - i) % wl(10, i) | 0) * o : 0), l)
    for (; ; )
      if (c == 0) {
        (f[0] += o) == Bn && (f[0] = 1, ++e.e);
        break;
      } else {
        if (f[c] += o, f[c] != Bn) break;
        f[c--] = 0, o = 1;
      }
  for (r = f.length; f[--r] === 0; ) f.pop();
  if (on && (e.e > Lm || e.e < -Lm))
    throw Error(v_ + xn(e));
  return e;
}
function MX(e, t) {
  var n, r, i, o, a, s, l, u, c, f, h = e.constructor, m = h.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new h(e), on ? Wt(t, m) : t;
  if (l = e.d, f = t.d, r = t.e, u = e.e, l = l.slice(), a = u - r, a) {
    for (c = a < 0, c ? (n = l, a = -a, s = f.length) : (n = f, r = u, s = l.length), i = Math.max(Math.ceil(m / Jt), s) + 2, a > i && (a = i, n.length = 1), n.reverse(), i = a; i--; ) n.push(0);
    n.reverse();
  } else {
    for (i = l.length, s = f.length, c = i < s, c && (s = i), i = 0; i < s; i++)
      if (l[i] != f[i]) {
        c = l[i] < f[i];
        break;
      }
    a = 0;
  }
  for (c && (n = l, l = f, f = n, t.s = -t.s), s = l.length, i = f.length - s; i > 0; --i) l[s++] = 0;
  for (i = f.length; i > a; ) {
    if (l[--i] < f[i]) {
      for (o = i; o && l[--o] === 0; ) l[o] = Bn - 1;
      --l[o], l[i] += Bn;
    }
    l[i] -= f[i];
  }
  for (; l[--s] === 0; ) l.pop();
  for (; l[0] === 0; l.shift()) --r;
  return l[0] ? (t.d = l, t.e = r, on ? Wt(t, m) : t) : new h(0);
}
function tu(e, t, n) {
  var r, i = xn(e), o = Do(e.d), a = o.length;
  return t ? (n && (r = n - a) > 0 ? o = o.charAt(0) + "." + o.slice(1) + ys(r) : a > 1 && (o = o.charAt(0) + "." + o.slice(1)), o = o + (i < 0 ? "e" : "e+") + i) : i < 0 ? (o = "0." + ys(-i - 1) + o, n && (r = n - a) > 0 && (o += ys(r))) : i >= a ? (o += ys(i + 1 - a), n && (r = n - i - 1) > 0 && (o = o + "." + ys(r))) : ((r = i + 1) < a && (o = o.slice(0, r) + "." + o.slice(r)), n && (r = n - a) > 0 && (i + 1 === a && (o += "."), o += ys(r))), e.s < 0 ? "-" + o : o;
}
function YD(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function RX(e) {
  var t, n, r;
  function i(o) {
    var a = this;
    if (!(a instanceof i)) return new i(o);
    if (a.constructor = i, o instanceof i) {
      a.s = o.s, a.e = o.e, a.d = (o = o.d) ? o.slice() : o;
      return;
    }
    if (typeof o == "number") {
      if (o * 0 !== 0)
        throw Error(Fl + o);
      if (o > 0)
        a.s = 1;
      else if (o < 0)
        o = -o, a.s = -1;
      else {
        a.s = 0, a.e = 0, a.d = [0];
        return;
      }
      if (o === ~~o && o < 1e7) {
        a.e = 0, a.d = [o];
        return;
      }
      return KD(a, o.toString());
    } else if (typeof o != "string")
      throw Error(Fl + o);
    if (o.charCodeAt(0) === 45 ? (o = o.slice(1), a.s = -1) : a.s = 1, PTe.test(o)) KD(a, o);
    else throw Error(Fl + o);
  }
  if (i.prototype = Ae, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.clone = RX, i.config = i.set = TTe, e === void 0 && (e = {}), e)
    for (r = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < r.length; ) e.hasOwnProperty(n = r[t++]) || (e[n] = this[n]);
  return i.config(e), i;
}
function TTe(e) {
  if (!e || typeof e != "object")
    throw Error(Li + "Object expected");
  var t, n, r, i = [
    "precision",
    1,
    Id,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < i.length; t += 3)
    if ((r = e[n = i[t]]) !== void 0)
      if ($d(r) === r && r >= i[t + 1] && r <= i[t + 2]) this[n] = r;
      else throw Error(Fl + n + ": " + r);
  if ((r = e[n = "LN10"]) !== void 0)
    if (r == Math.LN10) this[n] = new this(r);
    else throw Error(Fl + n + ": " + r);
  return this;
}
var y_ = RX(kTe);
ci = new y_(1);
const It = y_;
function MTe(e) {
  return $Te(e) || ITe(e) || DTe(e) || RTe();
}
function RTe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function DTe(e, t) {
  if (e) {
    if (typeof e == "string") return Y7(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Y7(e, t);
  }
}
function ITe(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function $Te(e) {
  if (Array.isArray(e)) return Y7(e);
}
function Y7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var LTe = function(t) {
  return t;
}, DX = {}, IX = function(t) {
  return t === DX;
}, ZD = function(t) {
  return function n() {
    return arguments.length === 0 || arguments.length === 1 && IX(arguments.length <= 0 ? void 0 : arguments[0]) ? n : t.apply(void 0, arguments);
  };
}, FTe = function e(t, n) {
  return t === 1 ? n : ZD(function() {
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    var a = i.filter(function(s) {
      return s !== DX;
    }).length;
    return a >= t ? n.apply(void 0, i) : e(t - a, ZD(function() {
      for (var s = arguments.length, l = new Array(s), u = 0; u < s; u++)
        l[u] = arguments[u];
      var c = i.map(function(f) {
        return IX(f) ? l.shift() : f;
      });
      return n.apply(void 0, MTe(c).concat(l));
    }));
  });
}, vv = function(t) {
  return FTe(t.length, t);
}, Z7 = function(t, n) {
  for (var r = [], i = t; i < n; ++i)
    r[i - t] = i;
  return r;
}, BTe = vv(function(e, t) {
  return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(n) {
    return t[n];
  }).map(e);
}), jTe = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  if (!n.length)
    return LTe;
  var i = n.reverse(), o = i[0], a = i.slice(1);
  return function() {
    return a.reduce(function(s, l) {
      return l(s);
    }, o.apply(void 0, arguments));
  };
}, X7 = function(t) {
  return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
}, $X = function(t) {
  var n = null, r = null;
  return function() {
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return n && o.every(function(s, l) {
      return s === n[l];
    }) || (n = o, r = t.apply(void 0, o)), r;
  };
};
function VTe(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new It(e).abs().log(10).toNumber()) + 1, t;
}
function qTe(e, t, n) {
  for (var r = new It(e), i = 0, o = []; r.lt(t) && i < 1e5; )
    o.push(r.toNumber()), r = r.add(n), i++;
  return o;
}
var zTe = vv(function(e, t, n) {
  var r = +e, i = +t;
  return r + n * (i - r);
}), WTe = vv(function(e, t, n) {
  var r = t - +e;
  return r = r || 1 / 0, (n - e) / r;
}), HTe = vv(function(e, t, n) {
  var r = t - +e;
  return r = r || 1 / 0, Math.max(0, Math.min(1, (n - e) / r));
});
const yv = {
  rangeStep: qTe,
  getDigitCount: VTe,
  interpolateNumber: zTe,
  uninterpolateNumber: WTe,
  uninterpolateTruncation: HTe
};
function J7(e) {
  return KTe(e) || GTe(e) || LX(e) || UTe();
}
function UTe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function GTe(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function KTe(e) {
  if (Array.isArray(e)) return Q7(e);
}
function bh(e, t) {
  return XTe(e) || ZTe(e, t) || LX(e, t) || YTe();
}
function YTe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function LX(e, t) {
  if (e) {
    if (typeof e == "string") return Q7(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Q7(e, t);
  }
}
function Q7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function ZTe(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var n = [], r = !0, i = !1, o = void 0;
    try {
      for (var a = e[Symbol.iterator](), s; !(r = (s = a.next()).done) && (n.push(s.value), !(t && n.length === t)); r = !0)
        ;
    } catch (l) {
      i = !0, o = l;
    } finally {
      try {
        !r && a.return != null && a.return();
      } finally {
        if (i) throw o;
      }
    }
    return n;
  }
}
function XTe(e) {
  if (Array.isArray(e)) return e;
}
function FX(e) {
  var t = bh(e, 2), n = t[0], r = t[1], i = n, o = r;
  return n > r && (i = r, o = n), [i, o];
}
function BX(e, t, n) {
  if (e.lte(0))
    return new It(0);
  var r = yv.getDigitCount(e.toNumber()), i = new It(10).pow(r), o = e.div(i), a = r !== 1 ? 0.05 : 0.1, s = new It(Math.ceil(o.div(a).toNumber())).add(n).mul(a), l = s.mul(i);
  return t ? l : new It(Math.ceil(l));
}
function JTe(e, t, n) {
  var r = 1, i = new It(e);
  if (!i.isint() && n) {
    var o = Math.abs(e);
    o < 1 ? (r = new It(10).pow(yv.getDigitCount(e) - 1), i = new It(Math.floor(i.div(r).toNumber())).mul(r)) : o > 1 && (i = new It(Math.floor(e)));
  } else e === 0 ? i = new It(Math.floor((t - 1) / 2)) : n || (i = new It(Math.floor(e)));
  var a = Math.floor((t - 1) / 2), s = jTe(BTe(function(l) {
    return i.add(new It(l - a).mul(r)).toNumber();
  }), Z7);
  return s(0, t);
}
function jX(e, t, n, r) {
  var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((t - e) / (n - 1)))
    return {
      step: new It(0),
      tickMin: new It(0),
      tickMax: new It(0)
    };
  var o = BX(new It(t).sub(e).div(n - 1), r, i), a;
  e <= 0 && t >= 0 ? a = new It(0) : (a = new It(e).add(t).div(2), a = a.sub(new It(a).mod(o)));
  var s = Math.ceil(a.sub(e).div(o).toNumber()), l = Math.ceil(new It(t).sub(a).div(o).toNumber()), u = s + l + 1;
  return u > n ? jX(e, t, n, r, i + 1) : (u < n && (l = t > 0 ? l + (n - u) : l, s = t > 0 ? s : s + (n - u)), {
    step: o,
    tickMin: a.sub(new It(s).mul(o)),
    tickMax: a.add(new It(l).mul(o))
  });
}
function QTe(e) {
  var t = bh(e, 2), n = t[0], r = t[1], i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, a = Math.max(i, 2), s = FX([n, r]), l = bh(s, 2), u = l[0], c = l[1];
  if (u === -1 / 0 || c === 1 / 0) {
    var f = c === 1 / 0 ? [u].concat(J7(Z7(0, i - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(J7(Z7(0, i - 1).map(function() {
      return -1 / 0;
    })), [c]);
    return n > r ? X7(f) : f;
  }
  if (u === c)
    return JTe(u, i, o);
  var h = jX(u, c, a, o), m = h.step, v = h.tickMin, g = h.tickMax, y = yv.rangeStep(v, g.add(new It(0.1).mul(m)), m);
  return n > r ? X7(y) : y;
}
function eMe(e, t) {
  var n = bh(e, 2), r = n[0], i = n[1], o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, a = FX([r, i]), s = bh(a, 2), l = s[0], u = s[1];
  if (l === -1 / 0 || u === 1 / 0)
    return [r, i];
  if (l === u)
    return [l];
  var c = Math.max(t, 2), f = BX(new It(u).sub(l).div(c - 1), o, 0), h = [].concat(J7(yv.rangeStep(new It(l), new It(u).sub(new It(0.99).mul(f)), f)), [u]);
  return r > i ? X7(h) : h;
}
var tMe = $X(QTe), nMe = $X(eMe), rMe = process.env.NODE_ENV === "production", z5 = "Invariant failed";
function zr(e, t) {
  if (rMe)
    throw new Error(z5);
  var n = typeof t == "function" ? t() : t, r = n ? "".concat(z5, ": ").concat(n) : z5;
  throw new Error(r);
}
var iMe = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function Hc(e) {
  "@babel/helpers - typeof";
  return Hc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Hc(e);
}
function Fm() {
  return Fm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fm.apply(this, arguments);
}
function oMe(e, t) {
  return uMe(e) || lMe(e, t) || sMe(e, t) || aMe();
}
function aMe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function sMe(e, t) {
  if (e) {
    if (typeof e == "string") return XD(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return XD(e, t);
  }
}
function XD(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function lMe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, u = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (c) {
      u = !0, i = c;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw i;
      }
    }
    return s;
  }
}
function uMe(e) {
  if (Array.isArray(e)) return e;
}
function cMe(e, t) {
  if (e == null) return {};
  var n = dMe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function dMe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function fMe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function hMe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, zX(r.key), r);
  }
}
function pMe(e, t, n) {
  return t && hMe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function mMe(e, t, n) {
  return t = Bm(t), gMe(e, VX() ? Reflect.construct(t, n || [], Bm(e).constructor) : t.apply(e, n));
}
function gMe(e, t) {
  if (t && (Hc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return vMe(e);
}
function vMe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function VX() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (VX = function() {
    return !!e;
  })();
}
function Bm(e) {
  return Bm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Bm(e);
}
function yMe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && e9(e, t);
}
function e9(e, t) {
  return e9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, e9(e, t);
}
function qX(e, t, n) {
  return t = zX(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function zX(e) {
  var t = bMe(e, "string");
  return Hc(t) == "symbol" ? t : t + "";
}
function bMe(e, t) {
  if (Hc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Hc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var bv = /* @__PURE__ */ function(e) {
  function t() {
    return fMe(this, t), mMe(this, t, arguments);
  }
  return yMe(t, e), pMe(t, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.offset, o = r.layout, a = r.width, s = r.dataKey, l = r.data, u = r.dataPointFormatter, c = r.xAxis, f = r.yAxis, h = cMe(r, iMe), m = qe(h, !1);
      this.props.direction === "x" && c.type !== "number" && (process.env.NODE_ENV !== "production" ? zr(!1, 'ErrorBar requires Axis type property to be "number".') : zr());
      var v = l.map(function(g) {
        var y = u(g, s), w = y.x, C = y.y, S = y.value, N = y.errorVal;
        if (!N)
          return null;
        var E = [], A, O;
        if (Array.isArray(N)) {
          var T = oMe(N, 2);
          A = T[0], O = T[1];
        } else
          A = O = N;
        if (o === "vertical") {
          var M = c.scale, L = C + i, I = L + a, j = L - a, B = M(S - A), q = M(S + O);
          E.push({
            x1: q,
            y1: I,
            x2: q,
            y2: j
          }), E.push({
            x1: B,
            y1: L,
            x2: q,
            y2: L
          }), E.push({
            x1: B,
            y1: I,
            x2: B,
            y2: j
          });
        } else if (o === "horizontal") {
          var G = f.scale, U = w + i, V = U - a, H = U + a, Z = G(S - A), de = G(S + O);
          E.push({
            x1: V,
            y1: de,
            x2: H,
            y2: de
          }), E.push({
            x1: U,
            y1: Z,
            x2: U,
            y2: de
          }), E.push({
            x1: V,
            y1: Z,
            x2: H,
            y2: Z
          });
        }
        return /* @__PURE__ */ F.createElement(zt, Fm({
          className: "recharts-errorBar",
          key: "bar-".concat(E.map(function(ne) {
            return "".concat(ne.x1, "-").concat(ne.x2, "-").concat(ne.y1, "-").concat(ne.y2);
          }))
        }, m), E.map(function(ne) {
          return /* @__PURE__ */ F.createElement("line", Fm({}, ne, {
            key: "line-".concat(ne.x1, "-").concat(ne.x2, "-").concat(ne.y1, "-").concat(ne.y2)
          }));
        }));
      });
      return /* @__PURE__ */ F.createElement(zt, {
        className: "recharts-errorBars"
      }, v);
    }
  }]);
}(F.Component);
qX(bv, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
qX(bv, "displayName", "ErrorBar");
function xh(e) {
  "@babel/helpers - typeof";
  return xh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xh(e);
}
function JD(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function gl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? JD(Object(n), !0).forEach(function(r) {
      xMe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : JD(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function xMe(e, t, n) {
  return t = wMe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function wMe(e) {
  var t = CMe(e, "string");
  return xh(t) == "symbol" ? t : t + "";
}
function CMe(e, t) {
  if (xh(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (xh(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var WX = function(t) {
  var n = t.children, r = t.formattedGraphicalItems, i = t.legendWidth, o = t.legendContent, a = li(n, Ur);
  if (!a)
    return null;
  var s = Ur.defaultProps, l = s !== void 0 ? gl(gl({}, s), a.props) : {}, u;
  return a.props && a.props.payload ? u = a.props && a.props.payload : o === "children" ? u = (r || []).reduce(function(c, f) {
    var h = f.item, m = f.props, v = m.sectors || m.data || [];
    return c.concat(v.map(function(g) {
      return {
        type: a.props.iconType || h.props.legendType,
        value: g.name,
        color: g.fill,
        payload: g
      };
    }));
  }, []) : u = (r || []).map(function(c) {
    var f = c.item, h = f.type.defaultProps, m = h !== void 0 ? gl(gl({}, h), f.props) : {}, v = m.dataKey, g = m.name, y = m.legendType, w = m.hide;
    return {
      inactive: w,
      dataKey: v,
      type: l.iconType || y || "square",
      color: b_(f),
      value: g || v,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: m
    };
  }), gl(gl(gl({}, l), Ur.getWithHeight(a, i)), {}, {
    payload: u,
    item: a
  });
};
function wh(e) {
  "@babel/helpers - typeof";
  return wh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wh(e);
}
function QD(e) {
  return NMe(e) || EMe(e) || _Me(e) || SMe();
}
function SMe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _Me(e, t) {
  if (e) {
    if (typeof e == "string") return t9(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return t9(e, t);
  }
}
function EMe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function NMe(e) {
  if (Array.isArray(e)) return t9(e);
}
function t9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function eI(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function dn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? eI(Object(n), !0).forEach(function(r) {
      wc(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : eI(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function wc(e, t, n) {
  return t = AMe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function AMe(e) {
  var t = OMe(e, "string");
  return wh(t) == "symbol" ? t : t + "";
}
function OMe(e, t) {
  if (wh(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (wh(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Fi(e, t, n) {
  return yt(e) || yt(t) ? n : Dn(t) ? Di(e, t, n) : Ye(t) ? t(e) : n;
}
function Vf(e, t, n, r) {
  var i = NTe(e, function(s) {
    return Fi(s, t);
  });
  if (n === "number") {
    var o = i.filter(function(s) {
      return we(s) || parseFloat(s);
    });
    return o.length ? [mv(o), pv(o)] : [1 / 0, -1 / 0];
  }
  var a = r ? i.filter(function(s) {
    return !yt(s);
  }) : i;
  return a.map(function(s) {
    return Dn(s) || s instanceof Date ? s : "";
  });
}
var kMe = function(t) {
  var n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = arguments.length > 2 ? arguments[2] : void 0, o = arguments.length > 3 ? arguments[3] : void 0, a = -1, s = (n = r == null ? void 0 : r.length) !== null && n !== void 0 ? n : 0;
  if (s <= 1)
    return 0;
  if (o && o.axisType === "angleAxis" && Math.abs(Math.abs(o.range[1] - o.range[0]) - 360) <= 1e-6)
    for (var l = o.range, u = 0; u < s; u++) {
      var c = u > 0 ? i[u - 1].coordinate : i[s - 1].coordinate, f = i[u].coordinate, h = u >= s - 1 ? i[0].coordinate : i[u + 1].coordinate, m = void 0;
      if (no(f - c) !== no(h - f)) {
        var v = [];
        if (no(h - f) === no(l[1] - l[0])) {
          m = h;
          var g = f + l[1] - l[0];
          v[0] = Math.min(g, (g + c) / 2), v[1] = Math.max(g, (g + c) / 2);
        } else {
          m = c;
          var y = h + l[1] - l[0];
          v[0] = Math.min(f, (y + f) / 2), v[1] = Math.max(f, (y + f) / 2);
        }
        var w = [Math.min(f, (m + f) / 2), Math.max(f, (m + f) / 2)];
        if (t > w[0] && t <= w[1] || t >= v[0] && t <= v[1]) {
          a = i[u].index;
          break;
        }
      } else {
        var C = Math.min(c, h), S = Math.max(c, h);
        if (t > (C + f) / 2 && t <= (S + f) / 2) {
          a = i[u].index;
          break;
        }
      }
    }
  else
    for (var N = 0; N < s; N++)
      if (N === 0 && t <= (r[N].coordinate + r[N + 1].coordinate) / 2 || N > 0 && N < s - 1 && t > (r[N].coordinate + r[N - 1].coordinate) / 2 && t <= (r[N].coordinate + r[N + 1].coordinate) / 2 || N === s - 1 && t > (r[N].coordinate + r[N - 1].coordinate) / 2) {
        a = r[N].index;
        break;
      }
  return a;
}, b_ = function(t) {
  var n, r = t, i = r.type.displayName, o = (n = t.type) !== null && n !== void 0 && n.defaultProps ? dn(dn({}, t.type.defaultProps), t.props) : t.props, a = o.stroke, s = o.fill, l;
  switch (i) {
    case "Line":
      l = a;
      break;
    case "Area":
    case "Radar":
      l = a && a !== "none" ? a : s;
      break;
    default:
      l = s;
      break;
  }
  return l;
}, PMe = function(t) {
  var n = t.barSize, r = t.totalSize, i = t.stackGroups, o = i === void 0 ? {} : i;
  if (!o)
    return {};
  for (var a = {}, s = Object.keys(o), l = 0, u = s.length; l < u; l++)
    for (var c = o[s[l]].stackGroups, f = Object.keys(c), h = 0, m = f.length; h < m; h++) {
      var v = c[f[h]], g = v.items, y = v.cateAxisId, w = g.filter(function(O) {
        return Ta(O.type).indexOf("Bar") >= 0;
      });
      if (w && w.length) {
        var C = w[0].type.defaultProps, S = C !== void 0 ? dn(dn({}, C), w[0].props) : w[0].props, N = S.barSize, E = S[y];
        a[E] || (a[E] = []);
        var A = yt(N) ? n : N;
        a[E].push({
          item: w[0],
          stackList: w.slice(1),
          barSize: yt(A) ? void 0 : ro(A, r, 0)
        });
      }
    }
  return a;
}, TMe = function(t) {
  var n = t.barGap, r = t.barCategoryGap, i = t.bandSize, o = t.sizeList, a = o === void 0 ? [] : o, s = t.maxBarSize, l = a.length;
  if (l < 1) return null;
  var u = ro(n, i, 0, !0), c, f = [];
  if (a[0].barSize === +a[0].barSize) {
    var h = !1, m = i / l, v = a.reduce(function(N, E) {
      return N + E.barSize || 0;
    }, 0);
    v += (l - 1) * u, v >= i && (v -= (l - 1) * u, u = 0), v >= i && m > 0 && (h = !0, m *= 0.9, v = l * m);
    var g = (i - v) / 2 >> 0, y = {
      offset: g - u,
      size: 0
    };
    c = a.reduce(function(N, E) {
      var A = {
        item: E.item,
        position: {
          offset: y.offset + y.size + u,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: h ? m : E.barSize
        }
      }, O = [].concat(QD(N), [A]);
      return y = O[O.length - 1].position, E.stackList && E.stackList.length && E.stackList.forEach(function(T) {
        O.push({
          item: T,
          position: y
        });
      }), O;
    }, f);
  } else {
    var w = ro(r, i, 0, !0);
    i - 2 * w - (l - 1) * u <= 0 && (u = 0);
    var C = (i - 2 * w - (l - 1) * u) / l;
    C > 1 && (C >>= 0);
    var S = s === +s ? Math.min(C, s) : C;
    c = a.reduce(function(N, E, A) {
      var O = [].concat(QD(N), [{
        item: E.item,
        position: {
          offset: w + (C + u) * A + (C - S) / 2,
          size: S
        }
      }]);
      return E.stackList && E.stackList.length && E.stackList.forEach(function(T) {
        O.push({
          item: T,
          position: O[O.length - 1].position
        });
      }), O;
    }, f);
  }
  return c;
}, MMe = function(t, n, r, i) {
  var o = r.children, a = r.width, s = r.margin, l = a - (s.left || 0) - (s.right || 0), u = WX({
    children: o,
    legendWidth: l
  });
  if (u) {
    var c = i || {}, f = c.width, h = c.height, m = u.align, v = u.verticalAlign, g = u.layout;
    if ((g === "vertical" || g === "horizontal" && v === "middle") && m !== "center" && we(t[m]))
      return dn(dn({}, t), {}, wc({}, m, t[m] + (f || 0)));
    if ((g === "horizontal" || g === "vertical" && m === "center") && v !== "middle" && we(t[v]))
      return dn(dn({}, t), {}, wc({}, v, t[v] + (h || 0)));
  }
  return t;
}, RMe = function(t, n, r) {
  return yt(n) ? !0 : t === "horizontal" ? n === "yAxis" : t === "vertical" || r === "x" ? n === "xAxis" : r === "y" ? n === "yAxis" : !0;
}, HX = function(t, n, r, i, o) {
  var a = n.props.children, s = oo(a, bv).filter(function(u) {
    return RMe(i, o, u.props.direction);
  });
  if (s && s.length) {
    var l = s.map(function(u) {
      return u.props.dataKey;
    });
    return t.reduce(function(u, c) {
      var f = Fi(c, r);
      if (yt(f)) return u;
      var h = Array.isArray(f) ? [mv(f), pv(f)] : [f, f], m = l.reduce(function(v, g) {
        var y = Fi(c, g, 0), w = h[0] - Math.abs(Array.isArray(y) ? y[0] : y), C = h[1] + Math.abs(Array.isArray(y) ? y[1] : y);
        return [Math.min(w, v[0]), Math.max(C, v[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(m[0], u[0]), Math.max(m[1], u[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, DMe = function(t, n, r, i, o) {
  var a = n.map(function(s) {
    return HX(t, s, r, o, i);
  }).filter(function(s) {
    return !yt(s);
  });
  return a && a.length ? a.reduce(function(s, l) {
    return [Math.min(s[0], l[0]), Math.max(s[1], l[1])];
  }, [1 / 0, -1 / 0]) : null;
}, UX = function(t, n, r, i, o) {
  var a = n.map(function(l) {
    var u = l.props.dataKey;
    return r === "number" && u && HX(t, l, u, i) || Vf(t, u, r, o);
  });
  if (r === "number")
    return a.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(l, u) {
        return [Math.min(l[0], u[0]), Math.max(l[1], u[1])];
      },
      [1 / 0, -1 / 0]
    );
  var s = {};
  return a.reduce(function(l, u) {
    for (var c = 0, f = u.length; c < f; c++)
      s[u[c]] || (s[u[c]] = !0, l.push(u[c]));
    return l;
  }, []);
}, GX = function(t, n) {
  return t === "horizontal" && n === "xAxis" || t === "vertical" && n === "yAxis" || t === "centric" && n === "angleAxis" || t === "radial" && n === "radiusAxis";
}, KX = function(t, n, r, i) {
  if (i)
    return t.map(function(l) {
      return l.coordinate;
    });
  var o, a, s = t.map(function(l) {
    return l.coordinate === n && (o = !0), l.coordinate === r && (a = !0), l.coordinate;
  });
  return o || s.push(n), a || s.push(r), s;
}, Oa = function(t, n, r) {
  if (!t) return null;
  var i = t.scale, o = t.duplicateDomain, a = t.type, s = t.range, l = t.realScaleType === "scaleBand" ? i.bandwidth() / 2 : 2, u = (n || r) && a === "category" && i.bandwidth ? i.bandwidth() / l : 0;
  if (u = t.axisType === "angleAxis" && (s == null ? void 0 : s.length) >= 2 ? no(s[0] - s[1]) * 2 * u : u, n && (t.ticks || t.niceTicks)) {
    var c = (t.ticks || t.niceTicks).map(function(f) {
      var h = o ? o.indexOf(f) : f;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: i(h) + u,
        value: f,
        offset: u
      };
    });
    return c.filter(function(f) {
      return !Pp(f.coordinate);
    });
  }
  return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(f, h) {
    return {
      coordinate: i(f) + u,
      value: f,
      index: h,
      offset: u
    };
  }) : i.ticks && !r ? i.ticks(t.tickCount).map(function(f) {
    return {
      coordinate: i(f) + u,
      value: f,
      offset: u
    };
  }) : i.domain().map(function(f, h) {
    return {
      coordinate: i(f) + u,
      value: o ? o[f] : f,
      index: h,
      offset: u
    };
  });
}, W5 = /* @__PURE__ */ new WeakMap(), y1 = function(t, n) {
  if (typeof n != "function")
    return t;
  W5.has(t) || W5.set(t, /* @__PURE__ */ new WeakMap());
  var r = W5.get(t);
  if (r.has(n))
    return r.get(n);
  var i = function() {
    t.apply(void 0, arguments), n.apply(void 0, arguments);
  };
  return r.set(n, i), i;
}, YX = function(t, n, r) {
  var i = t.scale, o = t.type, a = t.layout, s = t.axisType;
  if (i === "auto")
    return a === "radial" && s === "radiusAxis" ? {
      scale: hh(),
      realScaleType: "band"
    } : a === "radial" && s === "angleAxis" ? {
      scale: Rm(),
      realScaleType: "linear"
    } : o === "category" && n && (n.indexOf("LineChart") >= 0 || n.indexOf("AreaChart") >= 0 || n.indexOf("ComposedChart") >= 0 && !r) ? {
      scale: jf(),
      realScaleType: "point"
    } : o === "category" ? {
      scale: hh(),
      realScaleType: "band"
    } : {
      scale: Rm(),
      realScaleType: "linear"
    };
  if (kp(i)) {
    var l = "scale".concat(ev(i));
    return {
      scale: (BD[l] || jf)(),
      realScaleType: BD[l] ? l : "point"
    };
  }
  return Ye(i) ? {
    scale: i
  } : {
    scale: jf(),
    realScaleType: "point"
  };
}, tI = 1e-4, ZX = function(t) {
  var n = t.domain();
  if (!(!n || n.length <= 2)) {
    var r = n.length, i = t.range(), o = Math.min(i[0], i[1]) - tI, a = Math.max(i[0], i[1]) + tI, s = t(n[0]), l = t(n[r - 1]);
    (s < o || s > a || l < o || l > a) && t.domain([n[0], n[r - 1]]);
  }
}, IMe = function(t, n) {
  if (!t)
    return null;
  for (var r = 0, i = t.length; r < i; r++)
    if (t[r].item === n)
      return t[r].position;
  return null;
}, $Me = function(t, n) {
  if (!n || n.length !== 2 || !we(n[0]) || !we(n[1]))
    return t;
  var r = Math.min(n[0], n[1]), i = Math.max(n[0], n[1]), o = [t[0], t[1]];
  return (!we(t[0]) || t[0] < r) && (o[0] = r), (!we(t[1]) || t[1] > i) && (o[1] = i), o[0] > i && (o[0] = i), o[1] < r && (o[1] = r), o;
}, LMe = function(t) {
  var n = t.length;
  if (!(n <= 0))
    for (var r = 0, i = t[0].length; r < i; ++r)
      for (var o = 0, a = 0, s = 0; s < n; ++s) {
        var l = Pp(t[s][r][1]) ? t[s][r][0] : t[s][r][1];
        l >= 0 ? (t[s][r][0] = o, t[s][r][1] = o + l, o = t[s][r][1]) : (t[s][r][0] = a, t[s][r][1] = a + l, a = t[s][r][1]);
      }
}, FMe = function(t) {
  var n = t.length;
  if (!(n <= 0))
    for (var r = 0, i = t[0].length; r < i; ++r)
      for (var o = 0, a = 0; a < n; ++a) {
        var s = Pp(t[a][r][1]) ? t[a][r][0] : t[a][r][1];
        s >= 0 ? (t[a][r][0] = o, t[a][r][1] = o + s, o = t[a][r][1]) : (t[a][r][0] = 0, t[a][r][1] = 0);
      }
}, BMe = {
  sign: LMe,
  // @ts-expect-error definitelytyped types are incorrect
  expand: EEe,
  // @ts-expect-error definitelytyped types are incorrect
  none: $c,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: NEe,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: AEe,
  positive: FMe
}, jMe = function(t, n, r) {
  var i = n.map(function(s) {
    return s.props.dataKey;
  }), o = BMe[r], a = _Ee().keys(i).value(function(s, l) {
    return +Fi(s, l, 0);
  }).order(T7).offset(o);
  return a(t);
}, VMe = function(t, n, r, i, o, a) {
  if (!t)
    return null;
  var s = a ? n.reverse() : n, l = {}, u = s.reduce(function(f, h) {
    var m, v = (m = h.type) !== null && m !== void 0 && m.defaultProps ? dn(dn({}, h.type.defaultProps), h.props) : h.props, g = v.stackId, y = v.hide;
    if (y)
      return f;
    var w = v[r], C = f[w] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (Dn(g)) {
      var S = C.stackGroups[g] || {
        numericAxisId: r,
        cateAxisId: i,
        items: []
      };
      S.items.push(h), C.hasStack = !0, C.stackGroups[g] = S;
    } else
      C.stackGroups[Q2("_stackId_")] = {
        numericAxisId: r,
        cateAxisId: i,
        items: [h]
      };
    return dn(dn({}, f), {}, wc({}, w, C));
  }, l), c = {};
  return Object.keys(u).reduce(function(f, h) {
    var m = u[h];
    if (m.hasStack) {
      var v = {};
      m.stackGroups = Object.keys(m.stackGroups).reduce(function(g, y) {
        var w = m.stackGroups[y];
        return dn(dn({}, g), {}, wc({}, y, {
          numericAxisId: r,
          cateAxisId: i,
          items: w.items,
          stackedData: jMe(t, w.items, o)
        }));
      }, v);
    }
    return dn(dn({}, f), {}, wc({}, h, m));
  }, c);
}, XX = function(t, n) {
  var r = n.realScaleType, i = n.type, o = n.tickCount, a = n.originalDomain, s = n.allowDecimals, l = r || n.scale;
  if (l !== "auto" && l !== "linear")
    return null;
  if (o && i === "number" && a && (a[0] === "auto" || a[1] === "auto")) {
    var u = t.domain();
    if (!u.length)
      return null;
    var c = tMe(u, o, s);
    return t.domain([mv(c), pv(c)]), {
      niceTicks: c
    };
  }
  if (o && i === "number") {
    var f = t.domain(), h = nMe(f, o, s);
    return {
      niceTicks: h
    };
  }
  return null;
}, nI = function(t) {
  var n = t.axis, r = t.ticks, i = t.offset, o = t.bandSize, a = t.entry, s = t.index;
  if (n.type === "category")
    return r[s] ? r[s].coordinate + i : null;
  var l = Fi(a, n.dataKey, n.domain[s]);
  return yt(l) ? null : n.scale(l) - o / 2 + i;
}, qMe = function(t) {
  var n = t.numericAxis, r = n.scale.domain();
  if (n.type === "number") {
    var i = Math.min(r[0], r[1]), o = Math.max(r[0], r[1]);
    return i <= 0 && o >= 0 ? 0 : o < 0 ? o : i;
  }
  return r[0];
}, zMe = function(t, n) {
  var r, i = (r = t.type) !== null && r !== void 0 && r.defaultProps ? dn(dn({}, t.type.defaultProps), t.props) : t.props, o = i.stackId;
  if (Dn(o)) {
    var a = n[o];
    if (a) {
      var s = a.items.indexOf(t);
      return s >= 0 ? a.stackedData[s] : null;
    }
  }
  return null;
}, WMe = function(t) {
  return t.reduce(function(n, r) {
    return [mv(r.concat([n[0]]).filter(we)), pv(r.concat([n[1]]).filter(we))];
  }, [1 / 0, -1 / 0]);
}, JX = function(t, n, r) {
  return Object.keys(t).reduce(function(i, o) {
    var a = t[o], s = a.stackedData, l = s.reduce(function(u, c) {
      var f = WMe(c.slice(n, r + 1));
      return [Math.min(u[0], f[0]), Math.max(u[1], f[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(l[0], i[0]), Math.max(l[1], i[1])];
  }, [1 / 0, -1 / 0]).map(function(i) {
    return i === 1 / 0 || i === -1 / 0 ? 0 : i;
  });
}, rI = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, iI = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, n9 = function(t, n, r) {
  if (Ye(t))
    return t(n, r);
  if (!Array.isArray(t))
    return n;
  var i = [];
  if (we(t[0]))
    i[0] = r ? t[0] : Math.min(t[0], n[0]);
  else if (rI.test(t[0])) {
    var o = +rI.exec(t[0])[1];
    i[0] = n[0] - o;
  } else Ye(t[0]) ? i[0] = t[0](n[0]) : i[0] = n[0];
  if (we(t[1]))
    i[1] = r ? t[1] : Math.max(t[1], n[1]);
  else if (iI.test(t[1])) {
    var a = +iI.exec(t[1])[1];
    i[1] = n[1] + a;
  } else Ye(t[1]) ? i[1] = t[1](n[1]) : i[1] = n[1];
  return i;
}, jm = function(t, n, r) {
  if (t && t.scale && t.scale.bandwidth) {
    var i = t.scale.bandwidth();
    if (!r || i > 0)
      return i;
  }
  if (t && n && n.length >= 2) {
    for (var o = GS(n, function(f) {
      return f.coordinate;
    }), a = 1 / 0, s = 1, l = o.length; s < l; s++) {
      var u = o[s], c = o[s - 1];
      a = Math.min((u.coordinate || 0) - (c.coordinate || 0), a);
    }
    return a === 1 / 0 ? 0 : a;
  }
  return r ? void 0 : 0;
}, oI = function(t, n, r) {
  return !t || !t.length || gv(t, Di(r, "type.defaultProps.domain")) ? n : t;
}, QX = function(t, n) {
  var r = t.type.defaultProps ? dn(dn({}, t.type.defaultProps), t.props) : t.props, i = r.dataKey, o = r.name, a = r.unit, s = r.formatter, l = r.tooltipType, u = r.chartType, c = r.hide;
  return dn(dn({}, qe(t, !1)), {}, {
    dataKey: i,
    unit: a,
    formatter: s,
    name: o || i,
    color: b_(t),
    value: Fi(n, i),
    type: l,
    payload: n,
    chartType: u,
    hide: c
  });
};
function Ch(e) {
  "@babel/helpers - typeof";
  return Ch = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ch(e);
}
function aI(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function wa(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? aI(Object(n), !0).forEach(function(r) {
      eJ(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : aI(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function eJ(e, t, n) {
  return t = HMe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function HMe(e) {
  var t = UMe(e, "string");
  return Ch(t) == "symbol" ? t : t + "";
}
function UMe(e, t) {
  if (Ch(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ch(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function GMe(e, t) {
  return XMe(e) || ZMe(e, t) || YMe(e, t) || KMe();
}
function KMe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function YMe(e, t) {
  if (e) {
    if (typeof e == "string") return sI(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sI(e, t);
  }
}
function sI(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function ZMe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, u = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (c) {
      u = !0, i = c;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw i;
      }
    }
    return s;
  }
}
function XMe(e) {
  if (Array.isArray(e)) return e;
}
var Vm = Math.PI / 180, JMe = function(t) {
  return t * 180 / Math.PI;
}, $t = function(t, n, r, i) {
  return {
    x: t + Math.cos(-Vm * i) * r,
    y: n + Math.sin(-Vm * i) * r
  };
}, QMe = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(t - (r.left || 0) - (r.right || 0)), Math.abs(n - (r.top || 0) - (r.bottom || 0))) / 2;
}, eRe = function(t, n, r, i, o) {
  var a = t.width, s = t.height, l = t.startAngle, u = t.endAngle, c = ro(t.cx, a, a / 2), f = ro(t.cy, s, s / 2), h = QMe(a, s, r), m = ro(t.innerRadius, h, 0), v = ro(t.outerRadius, h, h * 0.8), g = Object.keys(n);
  return g.reduce(function(y, w) {
    var C = n[w], S = C.domain, N = C.reversed, E;
    if (yt(C.range))
      i === "angleAxis" ? E = [l, u] : i === "radiusAxis" && (E = [m, v]), N && (E = [E[1], E[0]]);
    else {
      E = C.range;
      var A = E, O = GMe(A, 2);
      l = O[0], u = O[1];
    }
    var T = YX(C, o), M = T.realScaleType, L = T.scale;
    L.domain(S).range(E), ZX(L);
    var I = XX(L, wa(wa({}, C), {}, {
      realScaleType: M
    })), j = wa(wa(wa({}, C), I), {}, {
      range: E,
      radius: v,
      realScaleType: M,
      scale: L,
      cx: c,
      cy: f,
      innerRadius: m,
      outerRadius: v,
      startAngle: l,
      endAngle: u
    });
    return wa(wa({}, y), {}, eJ({}, w, j));
  }, {});
}, tRe = function(t, n) {
  var r = t.x, i = t.y, o = n.x, a = n.y;
  return Math.sqrt(Math.pow(r - o, 2) + Math.pow(i - a, 2));
}, nRe = function(t, n) {
  var r = t.x, i = t.y, o = n.cx, a = n.cy, s = tRe({
    x: r,
    y: i
  }, {
    x: o,
    y: a
  });
  if (s <= 0)
    return {
      radius: s
    };
  var l = (r - o) / s, u = Math.acos(l);
  return i > a && (u = 2 * Math.PI - u), {
    radius: s,
    angle: JMe(u),
    angleInRadian: u
  };
}, rRe = function(t) {
  var n = t.startAngle, r = t.endAngle, i = Math.floor(n / 360), o = Math.floor(r / 360), a = Math.min(i, o);
  return {
    startAngle: n - a * 360,
    endAngle: r - a * 360
  };
}, iRe = function(t, n) {
  var r = n.startAngle, i = n.endAngle, o = Math.floor(r / 360), a = Math.floor(i / 360), s = Math.min(o, a);
  return t + s * 360;
}, lI = function(t, n) {
  var r = t.x, i = t.y, o = nRe({
    x: r,
    y: i
  }, n), a = o.radius, s = o.angle, l = n.innerRadius, u = n.outerRadius;
  if (a < l || a > u)
    return !1;
  if (a === 0)
    return !0;
  var c = rRe(n), f = c.startAngle, h = c.endAngle, m = s, v;
  if (f <= h) {
    for (; m > h; )
      m -= 360;
    for (; m < f; )
      m += 360;
    v = m >= f && m <= h;
  } else {
    for (; m > f; )
      m -= 360;
    for (; m < h; )
      m += 360;
    v = m >= h && m <= f;
  }
  return v ? wa(wa({}, n), {}, {
    radius: a,
    angle: iRe(m, n)
  }) : null;
}, tJ = function(t) {
  return !/* @__PURE__ */ Pr(t) && !Ye(t) && typeof t != "boolean" ? t.className : "";
};
function Sh(e) {
  "@babel/helpers - typeof";
  return Sh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Sh(e);
}
var oRe = ["offset"];
function aRe(e) {
  return cRe(e) || uRe(e) || lRe(e) || sRe();
}
function sRe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lRe(e, t) {
  if (e) {
    if (typeof e == "string") return r9(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return r9(e, t);
  }
}
function uRe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function cRe(e) {
  if (Array.isArray(e)) return r9(e);
}
function r9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function dRe(e, t) {
  if (e == null) return {};
  var n = fRe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function fRe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function uI(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Pn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? uI(Object(n), !0).forEach(function(r) {
      hRe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : uI(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function hRe(e, t, n) {
  return t = pRe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function pRe(e) {
  var t = mRe(e, "string");
  return Sh(t) == "symbol" ? t : t + "";
}
function mRe(e, t) {
  if (Sh(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Sh(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function _h() {
  return _h = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _h.apply(this, arguments);
}
var gRe = function(t) {
  var n = t.value, r = t.formatter, i = yt(t.children) ? n : t.children;
  return Ye(r) ? r(i) : i;
}, vRe = function(t, n) {
  var r = no(n - t), i = Math.min(Math.abs(n - t), 360);
  return r * i;
}, yRe = function(t, n, r) {
  var i = t.position, o = t.viewBox, a = t.offset, s = t.className, l = o, u = l.cx, c = l.cy, f = l.innerRadius, h = l.outerRadius, m = l.startAngle, v = l.endAngle, g = l.clockWise, y = (f + h) / 2, w = vRe(m, v), C = w >= 0 ? 1 : -1, S, N;
  i === "insideStart" ? (S = m + C * a, N = g) : i === "insideEnd" ? (S = v - C * a, N = !g) : i === "end" && (S = v + C * a, N = g), N = w <= 0 ? N : !N;
  var E = $t(u, c, y, S), A = $t(u, c, y, S + (N ? 1 : -1) * 359), O = "M".concat(E.x, ",").concat(E.y, `
    A`).concat(y, ",").concat(y, ",0,1,").concat(N ? 0 : 1, `,
    `).concat(A.x, ",").concat(A.y), T = yt(t.id) ? Q2("recharts-radial-line-") : t.id;
  return /* @__PURE__ */ F.createElement("text", _h({}, r, {
    dominantBaseline: "central",
    className: at("recharts-radial-bar-label", s)
  }), /* @__PURE__ */ F.createElement("defs", null, /* @__PURE__ */ F.createElement("path", {
    id: T,
    d: O
  })), /* @__PURE__ */ F.createElement("textPath", {
    xlinkHref: "#".concat(T)
  }, n));
}, bRe = function(t) {
  var n = t.viewBox, r = t.offset, i = t.position, o = n, a = o.cx, s = o.cy, l = o.innerRadius, u = o.outerRadius, c = o.startAngle, f = o.endAngle, h = (c + f) / 2;
  if (i === "outside") {
    var m = $t(a, s, u + r, h), v = m.x, g = m.y;
    return {
      x: v,
      y: g,
      textAnchor: v >= a ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (i === "center")
    return {
      x: a,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (i === "centerTop")
    return {
      x: a,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (i === "centerBottom")
    return {
      x: a,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var y = (l + u) / 2, w = $t(a, s, y, h), C = w.x, S = w.y;
  return {
    x: C,
    y: S,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, xRe = function(t) {
  var n = t.viewBox, r = t.parentViewBox, i = t.offset, o = t.position, a = n, s = a.x, l = a.y, u = a.width, c = a.height, f = c >= 0 ? 1 : -1, h = f * i, m = f > 0 ? "end" : "start", v = f > 0 ? "start" : "end", g = u >= 0 ? 1 : -1, y = g * i, w = g > 0 ? "end" : "start", C = g > 0 ? "start" : "end";
  if (o === "top") {
    var S = {
      x: s + u / 2,
      y: l - f * i,
      textAnchor: "middle",
      verticalAnchor: m
    };
    return Pn(Pn({}, S), r ? {
      height: Math.max(l - r.y, 0),
      width: u
    } : {});
  }
  if (o === "bottom") {
    var N = {
      x: s + u / 2,
      y: l + c + h,
      textAnchor: "middle",
      verticalAnchor: v
    };
    return Pn(Pn({}, N), r ? {
      height: Math.max(r.y + r.height - (l + c), 0),
      width: u
    } : {});
  }
  if (o === "left") {
    var E = {
      x: s - y,
      y: l + c / 2,
      textAnchor: w,
      verticalAnchor: "middle"
    };
    return Pn(Pn({}, E), r ? {
      width: Math.max(E.x - r.x, 0),
      height: c
    } : {});
  }
  if (o === "right") {
    var A = {
      x: s + u + y,
      y: l + c / 2,
      textAnchor: C,
      verticalAnchor: "middle"
    };
    return Pn(Pn({}, A), r ? {
      width: Math.max(r.x + r.width - A.x, 0),
      height: c
    } : {});
  }
  var O = r ? {
    width: u,
    height: c
  } : {};
  return o === "insideLeft" ? Pn({
    x: s + y,
    y: l + c / 2,
    textAnchor: C,
    verticalAnchor: "middle"
  }, O) : o === "insideRight" ? Pn({
    x: s + u - y,
    y: l + c / 2,
    textAnchor: w,
    verticalAnchor: "middle"
  }, O) : o === "insideTop" ? Pn({
    x: s + u / 2,
    y: l + h,
    textAnchor: "middle",
    verticalAnchor: v
  }, O) : o === "insideBottom" ? Pn({
    x: s + u / 2,
    y: l + c - h,
    textAnchor: "middle",
    verticalAnchor: m
  }, O) : o === "insideTopLeft" ? Pn({
    x: s + y,
    y: l + h,
    textAnchor: C,
    verticalAnchor: v
  }, O) : o === "insideTopRight" ? Pn({
    x: s + u - y,
    y: l + h,
    textAnchor: w,
    verticalAnchor: v
  }, O) : o === "insideBottomLeft" ? Pn({
    x: s + y,
    y: l + c - h,
    textAnchor: C,
    verticalAnchor: m
  }, O) : o === "insideBottomRight" ? Pn({
    x: s + u - y,
    y: l + c - h,
    textAnchor: w,
    verticalAnchor: m
  }, O) : Td(o) && (we(o.x) || kl(o.x)) && (we(o.y) || kl(o.y)) ? Pn({
    x: s + ro(o.x, u),
    y: l + ro(o.y, c),
    textAnchor: "end",
    verticalAnchor: "end"
  }, O) : Pn({
    x: s + u / 2,
    y: l + c / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, O);
}, wRe = function(t) {
  return "cx" in t && we(t.cx);
};
function er(e) {
  var t = e.offset, n = t === void 0 ? 5 : t, r = dRe(e, oRe), i = Pn({
    offset: n
  }, r), o = i.viewBox, a = i.position, s = i.value, l = i.children, u = i.content, c = i.className, f = c === void 0 ? "" : c, h = i.textBreakAll;
  if (!o || yt(s) && yt(l) && !/* @__PURE__ */ Pr(u) && !Ye(u))
    return null;
  if (/* @__PURE__ */ Pr(u))
    return /* @__PURE__ */ cn(u, i);
  var m;
  if (Ye(u)) {
    if (m = /* @__PURE__ */ dt(u, i), /* @__PURE__ */ Pr(m))
      return m;
  } else
    m = gRe(i);
  var v = wRe(o), g = qe(i, !0);
  if (v && (a === "insideStart" || a === "insideEnd" || a === "end"))
    return yRe(i, m, g);
  var y = v ? bRe(i) : xRe(i);
  return /* @__PURE__ */ F.createElement(Vc, _h({
    className: at("recharts-label", f)
  }, g, y, {
    breakAll: h
  }), m);
}
er.displayName = "Label";
var nJ = function(t) {
  var n = t.cx, r = t.cy, i = t.angle, o = t.startAngle, a = t.endAngle, s = t.r, l = t.radius, u = t.innerRadius, c = t.outerRadius, f = t.x, h = t.y, m = t.top, v = t.left, g = t.width, y = t.height, w = t.clockWise, C = t.labelViewBox;
  if (C)
    return C;
  if (we(g) && we(y)) {
    if (we(f) && we(h))
      return {
        x: f,
        y: h,
        width: g,
        height: y
      };
    if (we(m) && we(v))
      return {
        x: m,
        y: v,
        width: g,
        height: y
      };
  }
  return we(f) && we(h) ? {
    x: f,
    y: h,
    width: 0,
    height: 0
  } : we(n) && we(r) ? {
    cx: n,
    cy: r,
    startAngle: o || i || 0,
    endAngle: a || i || 0,
    innerRadius: u || 0,
    outerRadius: c || l || s || 0,
    clockWise: w
  } : t.viewBox ? t.viewBox : {};
}, CRe = function(t, n) {
  return t ? t === !0 ? /* @__PURE__ */ F.createElement(er, {
    key: "label-implicit",
    viewBox: n
  }) : Dn(t) ? /* @__PURE__ */ F.createElement(er, {
    key: "label-implicit",
    viewBox: n,
    value: t
  }) : /* @__PURE__ */ Pr(t) ? t.type === er ? /* @__PURE__ */ cn(t, {
    key: "label-implicit",
    viewBox: n
  }) : /* @__PURE__ */ F.createElement(er, {
    key: "label-implicit",
    content: t,
    viewBox: n
  }) : Ye(t) ? /* @__PURE__ */ F.createElement(er, {
    key: "label-implicit",
    content: t,
    viewBox: n
  }) : Td(t) ? /* @__PURE__ */ F.createElement(er, _h({
    viewBox: n
  }, t, {
    key: "label-implicit"
  })) : null : null;
}, SRe = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && r && !t.label)
    return null;
  var i = t.children, o = nJ(t), a = oo(i, er).map(function(l, u) {
    return /* @__PURE__ */ cn(l, {
      viewBox: n || o,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(u)
    });
  });
  if (!r)
    return a;
  var s = CRe(t.label, n || o);
  return [s].concat(aRe(a));
};
er.parseViewBox = nJ;
er.renderCallByParent = SRe;
var H5, cI;
function _Re() {
  if (cI) return H5;
  cI = 1;
  function e(t) {
    var n = t == null ? 0 : t.length;
    return n ? t[n - 1] : void 0;
  }
  return H5 = e, H5;
}
var ERe = _Re();
const rJ = /* @__PURE__ */ Rt(ERe);
function Eh(e) {
  "@babel/helpers - typeof";
  return Eh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Eh(e);
}
var NRe = ["valueAccessor"], ARe = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function ORe(e) {
  return MRe(e) || TRe(e) || PRe(e) || kRe();
}
function kRe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function PRe(e, t) {
  if (e) {
    if (typeof e == "string") return i9(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return i9(e, t);
  }
}
function TRe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function MRe(e) {
  if (Array.isArray(e)) return i9(e);
}
function i9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function qm() {
  return qm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qm.apply(this, arguments);
}
function dI(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fI(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dI(Object(n), !0).forEach(function(r) {
      RRe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : dI(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function RRe(e, t, n) {
  return t = DRe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function DRe(e) {
  var t = IRe(e, "string");
  return Eh(t) == "symbol" ? t : t + "";
}
function IRe(e, t) {
  if (Eh(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Eh(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function hI(e, t) {
  if (e == null) return {};
  var n = $Re(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function $Re(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var LRe = function(t) {
  return Array.isArray(t.value) ? rJ(t.value) : t.value;
};
function Is(e) {
  var t = e.valueAccessor, n = t === void 0 ? LRe : t, r = hI(e, NRe), i = r.data, o = r.dataKey, a = r.clockWise, s = r.id, l = r.textBreakAll, u = hI(r, ARe);
  return !i || !i.length ? null : /* @__PURE__ */ F.createElement(zt, {
    className: "recharts-label-list"
  }, i.map(function(c, f) {
    var h = yt(o) ? n(c, f) : Fi(c && c.payload, o), m = yt(s) ? {} : {
      id: "".concat(s, "-").concat(f)
    };
    return /* @__PURE__ */ F.createElement(er, qm({}, qe(c, !0), u, m, {
      parentViewBox: c.parentViewBox,
      value: h,
      textBreakAll: l,
      viewBox: er.parseViewBox(yt(a) ? c : fI(fI({}, c), {}, {
        clockWise: a
      })),
      key: "label-".concat(f),
      index: f
    }));
  }));
}
Is.displayName = "LabelList";
function FRe(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ F.createElement(Is, {
    key: "labelList-implicit",
    data: t
  }) : /* @__PURE__ */ F.isValidElement(e) || Ye(e) ? /* @__PURE__ */ F.createElement(Is, {
    key: "labelList-implicit",
    data: t,
    content: e
  }) : Td(e) ? /* @__PURE__ */ F.createElement(Is, qm({
    data: t
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function BRe(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && n && !e.label)
    return null;
  var r = e.children, i = oo(r, Is).map(function(a, s) {
    return /* @__PURE__ */ cn(a, {
      data: t,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(s)
    });
  });
  if (!n)
    return i;
  var o = FRe(e.label, t);
  return [o].concat(ORe(i));
}
Is.renderCallByParent = BRe;
function Nh(e) {
  "@babel/helpers - typeof";
  return Nh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Nh(e);
}
function o9() {
  return o9 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, o9.apply(this, arguments);
}
function pI(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function mI(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pI(Object(n), !0).forEach(function(r) {
      jRe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pI(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function jRe(e, t, n) {
  return t = VRe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function VRe(e) {
  var t = qRe(e, "string");
  return Nh(t) == "symbol" ? t : t + "";
}
function qRe(e, t) {
  if (Nh(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Nh(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var zRe = function(t, n) {
  var r = no(n - t), i = Math.min(Math.abs(n - t), 359.999);
  return r * i;
}, b1 = function(t) {
  var n = t.cx, r = t.cy, i = t.radius, o = t.angle, a = t.sign, s = t.isExternal, l = t.cornerRadius, u = t.cornerIsExternal, c = l * (s ? 1 : -1) + i, f = Math.asin(l / c) / Vm, h = u ? o : o + a * f, m = $t(n, r, c, h), v = $t(n, r, i, h), g = u ? o - a * f : o, y = $t(n, r, c * Math.cos(f * Vm), g);
  return {
    center: m,
    circleTangency: v,
    lineTangency: y,
    theta: f
  };
}, iJ = function(t) {
  var n = t.cx, r = t.cy, i = t.innerRadius, o = t.outerRadius, a = t.startAngle, s = t.endAngle, l = zRe(a, s), u = a + l, c = $t(n, r, o, a), f = $t(n, r, o, u), h = "M ".concat(c.x, ",").concat(c.y, `
    A `).concat(o, ",").concat(o, `,0,
    `).concat(+(Math.abs(l) > 180), ",").concat(+(a > u), `,
    `).concat(f.x, ",").concat(f.y, `
  `);
  if (i > 0) {
    var m = $t(n, r, i, a), v = $t(n, r, i, u);
    h += "L ".concat(v.x, ",").concat(v.y, `
            A `).concat(i, ",").concat(i, `,0,
            `).concat(+(Math.abs(l) > 180), ",").concat(+(a <= u), `,
            `).concat(m.x, ",").concat(m.y, " Z");
  } else
    h += "L ".concat(n, ",").concat(r, " Z");
  return h;
}, WRe = function(t) {
  var n = t.cx, r = t.cy, i = t.innerRadius, o = t.outerRadius, a = t.cornerRadius, s = t.forceCornerRadius, l = t.cornerIsExternal, u = t.startAngle, c = t.endAngle, f = no(c - u), h = b1({
    cx: n,
    cy: r,
    radius: o,
    angle: u,
    sign: f,
    cornerRadius: a,
    cornerIsExternal: l
  }), m = h.circleTangency, v = h.lineTangency, g = h.theta, y = b1({
    cx: n,
    cy: r,
    radius: o,
    angle: c,
    sign: -f,
    cornerRadius: a,
    cornerIsExternal: l
  }), w = y.circleTangency, C = y.lineTangency, S = y.theta, N = l ? Math.abs(u - c) : Math.abs(u - c) - g - S;
  if (N < 0)
    return s ? "M ".concat(v.x, ",").concat(v.y, `
        a`).concat(a, ",").concat(a, ",0,0,1,").concat(a * 2, `,0
        a`).concat(a, ",").concat(a, ",0,0,1,").concat(-a * 2, `,0
      `) : iJ({
      cx: n,
      cy: r,
      innerRadius: i,
      outerRadius: o,
      startAngle: u,
      endAngle: c
    });
  var E = "M ".concat(v.x, ",").concat(v.y, `
    A`).concat(a, ",").concat(a, ",0,0,").concat(+(f < 0), ",").concat(m.x, ",").concat(m.y, `
    A`).concat(o, ",").concat(o, ",0,").concat(+(N > 180), ",").concat(+(f < 0), ",").concat(w.x, ",").concat(w.y, `
    A`).concat(a, ",").concat(a, ",0,0,").concat(+(f < 0), ",").concat(C.x, ",").concat(C.y, `
  `);
  if (i > 0) {
    var A = b1({
      cx: n,
      cy: r,
      radius: i,
      angle: u,
      sign: f,
      isExternal: !0,
      cornerRadius: a,
      cornerIsExternal: l
    }), O = A.circleTangency, T = A.lineTangency, M = A.theta, L = b1({
      cx: n,
      cy: r,
      radius: i,
      angle: c,
      sign: -f,
      isExternal: !0,
      cornerRadius: a,
      cornerIsExternal: l
    }), I = L.circleTangency, j = L.lineTangency, B = L.theta, q = l ? Math.abs(u - c) : Math.abs(u - c) - M - B;
    if (q < 0 && a === 0)
      return "".concat(E, "L").concat(n, ",").concat(r, "Z");
    E += "L".concat(j.x, ",").concat(j.y, `
      A`).concat(a, ",").concat(a, ",0,0,").concat(+(f < 0), ",").concat(I.x, ",").concat(I.y, `
      A`).concat(i, ",").concat(i, ",0,").concat(+(q > 180), ",").concat(+(f > 0), ",").concat(O.x, ",").concat(O.y, `
      A`).concat(a, ",").concat(a, ",0,0,").concat(+(f < 0), ",").concat(T.x, ",").concat(T.y, "Z");
  } else
    E += "L".concat(n, ",").concat(r, "Z");
  return E;
}, HRe = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, oJ = function(t) {
  var n = mI(mI({}, HRe), t), r = n.cx, i = n.cy, o = n.innerRadius, a = n.outerRadius, s = n.cornerRadius, l = n.forceCornerRadius, u = n.cornerIsExternal, c = n.startAngle, f = n.endAngle, h = n.className;
  if (a < o || c === f)
    return null;
  var m = at("recharts-sector", h), v = a - o, g = ro(s, v, 0, !0), y;
  return g > 0 && Math.abs(c - f) < 360 ? y = WRe({
    cx: r,
    cy: i,
    innerRadius: o,
    outerRadius: a,
    cornerRadius: Math.min(g, v / 2),
    forceCornerRadius: l,
    cornerIsExternal: u,
    startAngle: c,
    endAngle: f
  }) : y = iJ({
    cx: r,
    cy: i,
    innerRadius: o,
    outerRadius: a,
    startAngle: c,
    endAngle: f
  }), /* @__PURE__ */ F.createElement("path", o9({}, qe(n, !0), {
    className: m,
    d: y,
    role: "img"
  }));
};
function Ah(e) {
  "@babel/helpers - typeof";
  return Ah = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ah(e);
}
function a9() {
  return a9 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, a9.apply(this, arguments);
}
function gI(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function vI(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gI(Object(n), !0).forEach(function(r) {
      URe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gI(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function URe(e, t, n) {
  return t = GRe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function GRe(e) {
  var t = KRe(e, "string");
  return Ah(t) == "symbol" ? t : t + "";
}
function KRe(e, t) {
  if (Ah(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ah(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var yI = {
  curveBasisClosed: hEe,
  curveBasisOpen: pEe,
  curveBasis: fEe,
  curveBumpX: J_e,
  curveBumpY: Q_e,
  curveLinearClosed: mEe,
  curveLinear: nv,
  curveMonotoneX: gEe,
  curveMonotoneY: vEe,
  curveNatural: yEe,
  curveStep: bEe,
  curveStepAfter: wEe,
  curveStepBefore: xEe
}, x1 = function(t) {
  return t.x === +t.x && t.y === +t.y;
}, vf = function(t) {
  return t.x;
}, yf = function(t) {
  return t.y;
}, YRe = function(t, n) {
  if (Ye(t))
    return t;
  var r = "curve".concat(ev(t));
  return (r === "curveMonotone" || r === "curveBump") && n ? yI["".concat(r).concat(n === "vertical" ? "Y" : "X")] : yI[r] || nv;
}, ZRe = function(t) {
  var n = t.type, r = n === void 0 ? "linear" : n, i = t.points, o = i === void 0 ? [] : i, a = t.baseLine, s = t.layout, l = t.connectNulls, u = l === void 0 ? !1 : l, c = YRe(r, s), f = u ? o.filter(function(g) {
    return x1(g);
  }) : o, h;
  if (Array.isArray(a)) {
    var m = u ? a.filter(function(g) {
      return x1(g);
    }) : a, v = f.map(function(g, y) {
      return vI(vI({}, g), {}, {
        base: m[y]
      });
    });
    return s === "vertical" ? h = d1().y(yf).x1(vf).x0(function(g) {
      return g.base.x;
    }) : h = d1().x(vf).y1(yf).y0(function(g) {
      return g.base.y;
    }), h.defined(x1).curve(c), h(v);
  }
  return s === "vertical" && we(a) ? h = d1().y(yf).x1(vf).x0(a) : we(a) ? h = d1().x(vf).y1(yf).y0(a) : h = nZ().x(vf).y(yf), h.defined(x1).curve(c), h(f);
}, bI = function(t) {
  var n = t.className, r = t.points, i = t.path, o = t.pathRef;
  if ((!r || !r.length) && !i)
    return null;
  var a = r && r.length ? ZRe(t) : i;
  return /* @__PURE__ */ F.createElement("path", a9({}, qe(t, !1), gm(t), {
    className: at("recharts-curve", n),
    d: a,
    ref: o
  }));
}, XRe = Object.getOwnPropertyNames, JRe = Object.getOwnPropertySymbols, QRe = Object.prototype.hasOwnProperty;
function xI(e, t) {
  return function(r, i, o) {
    return e(r, i, o) && t(r, i, o);
  };
}
function w1(e) {
  return function(n, r, i) {
    if (!n || !r || typeof n != "object" || typeof r != "object")
      return e(n, r, i);
    var o = i.cache, a = o.get(n), s = o.get(r);
    if (a && s)
      return a === r && s === n;
    o.set(n, r), o.set(r, n);
    var l = e(n, r, i);
    return o.delete(n), o.delete(r), l;
  };
}
function wI(e) {
  return XRe(e).concat(JRe(e));
}
var eDe = Object.hasOwn || function(e, t) {
  return QRe.call(e, t);
};
function gu(e, t) {
  return e === t || !e && !t && e !== e && t !== t;
}
var tDe = "__v", nDe = "__o", rDe = "_owner", CI = Object.getOwnPropertyDescriptor, SI = Object.keys;
function iDe(e, t, n) {
  var r = e.length;
  if (t.length !== r)
    return !1;
  for (; r-- > 0; )
    if (!n.equals(e[r], t[r], r, r, e, t, n))
      return !1;
  return !0;
}
function oDe(e, t) {
  return gu(e.getTime(), t.getTime());
}
function aDe(e, t) {
  return e.name === t.name && e.message === t.message && e.cause === t.cause && e.stack === t.stack;
}
function sDe(e, t) {
  return e === t;
}
function _I(e, t, n) {
  var r = e.size;
  if (r !== t.size)
    return !1;
  if (!r)
    return !0;
  for (var i = new Array(r), o = e.entries(), a, s, l = 0; (a = o.next()) && !a.done; ) {
    for (var u = t.entries(), c = !1, f = 0; (s = u.next()) && !s.done; ) {
      if (i[f]) {
        f++;
        continue;
      }
      var h = a.value, m = s.value;
      if (n.equals(h[0], m[0], l, f, e, t, n) && n.equals(h[1], m[1], h[0], m[0], e, t, n)) {
        c = i[f] = !0;
        break;
      }
      f++;
    }
    if (!c)
      return !1;
    l++;
  }
  return !0;
}
var lDe = gu;
function uDe(e, t, n) {
  var r = SI(e), i = r.length;
  if (SI(t).length !== i)
    return !1;
  for (; i-- > 0; )
    if (!aJ(e, t, n, r[i]))
      return !1;
  return !0;
}
function bf(e, t, n) {
  var r = wI(e), i = r.length;
  if (wI(t).length !== i)
    return !1;
  for (var o, a, s; i-- > 0; )
    if (o = r[i], !aJ(e, t, n, o) || (a = CI(e, o), s = CI(t, o), (a || s) && (!a || !s || a.configurable !== s.configurable || a.enumerable !== s.enumerable || a.writable !== s.writable)))
      return !1;
  return !0;
}
function cDe(e, t) {
  return gu(e.valueOf(), t.valueOf());
}
function dDe(e, t) {
  return e.source === t.source && e.flags === t.flags;
}
function EI(e, t, n) {
  var r = e.size;
  if (r !== t.size)
    return !1;
  if (!r)
    return !0;
  for (var i = new Array(r), o = e.values(), a, s; (a = o.next()) && !a.done; ) {
    for (var l = t.values(), u = !1, c = 0; (s = l.next()) && !s.done; ) {
      if (!i[c] && n.equals(a.value, s.value, a.value, s.value, e, t, n)) {
        u = i[c] = !0;
        break;
      }
      c++;
    }
    if (!u)
      return !1;
  }
  return !0;
}
function fDe(e, t) {
  var n = e.length;
  if (t.length !== n)
    return !1;
  for (; n-- > 0; )
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function hDe(e, t) {
  return e.hostname === t.hostname && e.pathname === t.pathname && e.protocol === t.protocol && e.port === t.port && e.hash === t.hash && e.username === t.username && e.password === t.password;
}
function aJ(e, t, n, r) {
  return (r === rDe || r === nDe || r === tDe) && (e.$$typeof || t.$$typeof) ? !0 : eDe(t, r) && n.equals(e[r], t[r], r, r, e, t, n);
}
var pDe = "[object Arguments]", mDe = "[object Boolean]", gDe = "[object Date]", vDe = "[object Error]", yDe = "[object Map]", bDe = "[object Number]", xDe = "[object Object]", wDe = "[object RegExp]", CDe = "[object Set]", SDe = "[object String]", _De = "[object URL]", EDe = Array.isArray, NI = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, AI = Object.assign, NDe = Object.prototype.toString.call.bind(Object.prototype.toString);
function ADe(e) {
  var t = e.areArraysEqual, n = e.areDatesEqual, r = e.areErrorsEqual, i = e.areFunctionsEqual, o = e.areMapsEqual, a = e.areNumbersEqual, s = e.areObjectsEqual, l = e.arePrimitiveWrappersEqual, u = e.areRegExpsEqual, c = e.areSetsEqual, f = e.areTypedArraysEqual, h = e.areUrlsEqual;
  return function(v, g, y) {
    if (v === g)
      return !0;
    if (v == null || g == null)
      return !1;
    var w = typeof v;
    if (w !== typeof g)
      return !1;
    if (w !== "object")
      return w === "number" ? a(v, g, y) : w === "function" ? i(v, g, y) : !1;
    var C = v.constructor;
    if (C !== g.constructor)
      return !1;
    if (C === Object)
      return s(v, g, y);
    if (EDe(v))
      return t(v, g, y);
    if (NI != null && NI(v))
      return f(v, g, y);
    if (C === Date)
      return n(v, g, y);
    if (C === RegExp)
      return u(v, g, y);
    if (C === Map)
      return o(v, g, y);
    if (C === Set)
      return c(v, g, y);
    var S = NDe(v);
    return S === gDe ? n(v, g, y) : S === wDe ? u(v, g, y) : S === yDe ? o(v, g, y) : S === CDe ? c(v, g, y) : S === xDe ? typeof v.then != "function" && typeof g.then != "function" && s(v, g, y) : S === _De ? h(v, g, y) : S === vDe ? r(v, g, y) : S === pDe ? s(v, g, y) : S === mDe || S === bDe || S === SDe ? l(v, g, y) : !1;
  };
}
function ODe(e) {
  var t = e.circular, n = e.createCustomConfig, r = e.strict, i = {
    areArraysEqual: r ? bf : iDe,
    areDatesEqual: oDe,
    areErrorsEqual: aDe,
    areFunctionsEqual: sDe,
    areMapsEqual: r ? xI(_I, bf) : _I,
    areNumbersEqual: lDe,
    areObjectsEqual: r ? bf : uDe,
    arePrimitiveWrappersEqual: cDe,
    areRegExpsEqual: dDe,
    areSetsEqual: r ? xI(EI, bf) : EI,
    areTypedArraysEqual: r ? bf : fDe,
    areUrlsEqual: hDe
  };
  if (n && (i = AI({}, i, n(i))), t) {
    var o = w1(i.areArraysEqual), a = w1(i.areMapsEqual), s = w1(i.areObjectsEqual), l = w1(i.areSetsEqual);
    i = AI({}, i, {
      areArraysEqual: o,
      areMapsEqual: a,
      areObjectsEqual: s,
      areSetsEqual: l
    });
  }
  return i;
}
function kDe(e) {
  return function(t, n, r, i, o, a, s) {
    return e(t, n, s);
  };
}
function PDe(e) {
  var t = e.circular, n = e.comparator, r = e.createState, i = e.equals, o = e.strict;
  if (r)
    return function(l, u) {
      var c = r(), f = c.cache, h = f === void 0 ? t ? /* @__PURE__ */ new WeakMap() : void 0 : f, m = c.meta;
      return n(l, u, {
        cache: h,
        equals: i,
        meta: m,
        strict: o
      });
    };
  if (t)
    return function(l, u) {
      return n(l, u, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: i,
        meta: void 0,
        strict: o
      });
    };
  var a = {
    cache: void 0,
    equals: i,
    meta: void 0,
    strict: o
  };
  return function(l, u) {
    return n(l, u, a);
  };
}
var TDe = rl();
rl({ strict: !0 });
rl({ circular: !0 });
rl({
  circular: !0,
  strict: !0
});
rl({
  createInternalComparator: function() {
    return gu;
  }
});
rl({
  strict: !0,
  createInternalComparator: function() {
    return gu;
  }
});
rl({
  circular: !0,
  createInternalComparator: function() {
    return gu;
  }
});
rl({
  circular: !0,
  createInternalComparator: function() {
    return gu;
  },
  strict: !0
});
function rl(e) {
  e === void 0 && (e = {});
  var t = e.circular, n = t === void 0 ? !1 : t, r = e.createInternalComparator, i = e.createState, o = e.strict, a = o === void 0 ? !1 : o, s = ODe(e), l = ADe(s), u = r ? r(l) : kDe(l);
  return PDe({ circular: n, comparator: l, createState: i, equals: u, strict: a });
}
function MDe(e) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
}
function OI(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = -1, r = function i(o) {
    n < 0 && (n = o), o - n > t ? (e(o), n = -1) : MDe(i);
  };
  requestAnimationFrame(r);
}
function s9(e) {
  "@babel/helpers - typeof";
  return s9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, s9(e);
}
function RDe(e) {
  return LDe(e) || $De(e) || IDe(e) || DDe();
}
function DDe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function IDe(e, t) {
  if (e) {
    if (typeof e == "string") return kI(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return kI(e, t);
  }
}
function kI(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function $De(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function LDe(e) {
  if (Array.isArray(e)) return e;
}
function FDe() {
  var e = {}, t = function() {
    return null;
  }, n = !1, r = function i(o) {
    if (!n) {
      if (Array.isArray(o)) {
        if (!o.length)
          return;
        var a = o, s = RDe(a), l = s[0], u = s.slice(1);
        if (typeof l == "number") {
          OI(i.bind(null, u), l);
          return;
        }
        i(l), OI(i.bind(null, u));
        return;
      }
      s9(o) === "object" && (e = o, t(e)), typeof o == "function" && o();
    }
  };
  return {
    stop: function() {
      n = !0;
    },
    start: function(o) {
      n = !1, r(o);
    },
    subscribe: function(o) {
      return t = o, function() {
        t = function() {
          return null;
        };
      };
    }
  };
}
function Oh(e) {
  "@babel/helpers - typeof";
  return Oh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Oh(e);
}
function PI(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function TI(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? PI(Object(n), !0).forEach(function(r) {
      sJ(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : PI(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function sJ(e, t, n) {
  return t = BDe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function BDe(e) {
  var t = jDe(e, "string");
  return Oh(t) === "symbol" ? t : String(t);
}
function jDe(e, t) {
  if (Oh(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Oh(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var VDe = function(t, n) {
  return [Object.keys(t), Object.keys(n)].reduce(function(r, i) {
    return r.filter(function(o) {
      return i.includes(o);
    });
  });
}, qDe = function(t) {
  return t;
}, zDe = function(t) {
  return t.replace(/([A-Z])/g, function(n) {
    return "-".concat(n.toLowerCase());
  });
}, qf = function(t, n) {
  return Object.keys(n).reduce(function(r, i) {
    return TI(TI({}, r), {}, sJ({}, i, t(i, n[i])));
  }, {});
}, MI = function(t, n, r) {
  return t.map(function(i) {
    return "".concat(zDe(i), " ").concat(n, "ms ").concat(r);
  }).join(",");
}, WDe = process.env.NODE_ENV !== "production", zm = function(t, n, r, i, o, a, s, l) {
  if (WDe && typeof console < "u" && console.warn && (n === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (n === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var u = [r, i, o, a, s, l], c = 0;
      console.warn(n.replace(/%s/g, function() {
        return u[c++];
      }));
    }
};
function HDe(e, t) {
  return KDe(e) || GDe(e, t) || lJ(e, t) || UDe();
}
function UDe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function GDe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, u = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (c) {
      u = !0, i = c;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw i;
      }
    }
    return s;
  }
}
function KDe(e) {
  if (Array.isArray(e)) return e;
}
function YDe(e) {
  return JDe(e) || XDe(e) || lJ(e) || ZDe();
}
function ZDe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lJ(e, t) {
  if (e) {
    if (typeof e == "string") return l9(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return l9(e, t);
  }
}
function XDe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function JDe(e) {
  if (Array.isArray(e)) return l9(e);
}
function l9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var Wm = 1e-4, uJ = function(t, n) {
  return [0, 3 * t, 3 * n - 6 * t, 3 * t - 3 * n + 1];
}, cJ = function(t, n) {
  return t.map(function(r, i) {
    return r * Math.pow(n, i);
  }).reduce(function(r, i) {
    return r + i;
  });
}, RI = function(t, n) {
  return function(r) {
    var i = uJ(t, n);
    return cJ(i, r);
  };
}, QDe = function(t, n) {
  return function(r) {
    var i = uJ(t, n), o = [].concat(YDe(i.map(function(a, s) {
      return a * s;
    }).slice(1)), [0]);
    return cJ(o, r);
  };
}, DI = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var i = n[0], o = n[1], a = n[2], s = n[3];
  if (n.length === 1)
    switch (n[0]) {
      case "linear":
        i = 0, o = 0, a = 1, s = 1;
        break;
      case "ease":
        i = 0.25, o = 0.1, a = 0.25, s = 1;
        break;
      case "ease-in":
        i = 0.42, o = 0, a = 1, s = 1;
        break;
      case "ease-out":
        i = 0.42, o = 0, a = 0.58, s = 1;
        break;
      case "ease-in-out":
        i = 0, o = 0, a = 0.58, s = 1;
        break;
      default: {
        var l = n[0].split("(");
        if (l[0] === "cubic-bezier" && l[1].split(")")[0].split(",").length === 4) {
          var u = l[1].split(")")[0].split(",").map(function(y) {
            return parseFloat(y);
          }), c = HDe(u, 4);
          i = c[0], o = c[1], a = c[2], s = c[3];
        } else
          zm(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", n);
      }
    }
  zm([i, a, o, s].every(function(y) {
    return typeof y == "number" && y >= 0 && y <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", n);
  var f = RI(i, a), h = RI(o, s), m = QDe(i, a), v = function(w) {
    return w > 1 ? 1 : w < 0 ? 0 : w;
  }, g = function(w) {
    for (var C = w > 1 ? 1 : w, S = C, N = 0; N < 8; ++N) {
      var E = f(S) - C, A = m(S);
      if (Math.abs(E - C) < Wm || A < Wm)
        return h(S);
      S = v(S - E / A);
    }
    return h(S);
  };
  return g.isStepper = !1, g;
}, eIe = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.stiff, r = n === void 0 ? 100 : n, i = t.damping, o = i === void 0 ? 8 : i, a = t.dt, s = a === void 0 ? 17 : a, l = function(c, f, h) {
    var m = -(c - f) * r, v = h * o, g = h + (m - v) * s / 1e3, y = h * s / 1e3 + c;
    return Math.abs(y - f) < Wm && Math.abs(g) < Wm ? [f, 0] : [y, g];
  };
  return l.isStepper = !0, l.dt = s, l;
}, tIe = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var i = n[0];
  if (typeof i == "string")
    switch (i) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return DI(i);
      case "spring":
        return eIe();
      default:
        if (i.split("(")[0] === "cubic-bezier")
          return DI(i);
        zm(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", n);
    }
  return typeof i == "function" ? i : (zm(!1, "[configEasing]: first argument type should be function or string, instead received %s", n), null);
};
function kh(e) {
  "@babel/helpers - typeof";
  return kh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, kh(e);
}
function II(e) {
  return iIe(e) || rIe(e) || dJ(e) || nIe();
}
function nIe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rIe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function iIe(e) {
  if (Array.isArray(e)) return c9(e);
}
function $I(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Jn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $I(Object(n), !0).forEach(function(r) {
      u9(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $I(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function u9(e, t, n) {
  return t = oIe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function oIe(e) {
  var t = aIe(e, "string");
  return kh(t) === "symbol" ? t : String(t);
}
function aIe(e, t) {
  if (kh(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (kh(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function sIe(e, t) {
  return cIe(e) || uIe(e, t) || dJ(e, t) || lIe();
}
function lIe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function dJ(e, t) {
  if (e) {
    if (typeof e == "string") return c9(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return c9(e, t);
  }
}
function c9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function uIe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, u = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (c) {
      u = !0, i = c;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw i;
      }
    }
    return s;
  }
}
function cIe(e) {
  if (Array.isArray(e)) return e;
}
var Hm = function(t, n, r) {
  return t + (n - t) * r;
}, d9 = function(t) {
  var n = t.from, r = t.to;
  return n !== r;
}, dIe = function e(t, n, r) {
  var i = qf(function(o, a) {
    if (d9(a)) {
      var s = t(a.from, a.to, a.velocity), l = sIe(s, 2), u = l[0], c = l[1];
      return Jn(Jn({}, a), {}, {
        from: u,
        velocity: c
      });
    }
    return a;
  }, n);
  return r < 1 ? qf(function(o, a) {
    return d9(a) ? Jn(Jn({}, a), {}, {
      velocity: Hm(a.velocity, i[o].velocity, r),
      from: Hm(a.from, i[o].from, r)
    }) : a;
  }, n) : e(t, i, r - 1);
};
const fIe = function(e, t, n, r, i) {
  var o = VDe(e, t), a = o.reduce(function(y, w) {
    return Jn(Jn({}, y), {}, u9({}, w, [e[w], t[w]]));
  }, {}), s = o.reduce(function(y, w) {
    return Jn(Jn({}, y), {}, u9({}, w, {
      from: e[w],
      velocity: 0,
      to: t[w]
    }));
  }, {}), l = -1, u, c, f = function() {
    return null;
  }, h = function() {
    return qf(function(w, C) {
      return C.from;
    }, s);
  }, m = function() {
    return !Object.values(s).filter(d9).length;
  }, v = function(w) {
    u || (u = w);
    var C = w - u, S = C / n.dt;
    s = dIe(n, s, S), i(Jn(Jn(Jn({}, e), t), h())), u = w, m() || (l = requestAnimationFrame(f));
  }, g = function(w) {
    c || (c = w);
    var C = (w - c) / r, S = qf(function(E, A) {
      return Hm.apply(void 0, II(A).concat([n(C)]));
    }, a);
    if (i(Jn(Jn(Jn({}, e), t), S)), C < 1)
      l = requestAnimationFrame(f);
    else {
      var N = qf(function(E, A) {
        return Hm.apply(void 0, II(A).concat([n(1)]));
      }, a);
      i(Jn(Jn(Jn({}, e), t), N));
    }
  };
  return f = n.isStepper ? v : g, function() {
    return requestAnimationFrame(f), function() {
      cancelAnimationFrame(l);
    };
  };
};
function Uc(e) {
  "@babel/helpers - typeof";
  return Uc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Uc(e);
}
var hIe = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function pIe(e, t) {
  if (e == null) return {};
  var n = mIe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function mIe(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function U5(e) {
  return bIe(e) || yIe(e) || vIe(e) || gIe();
}
function gIe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vIe(e, t) {
  if (e) {
    if (typeof e == "string") return f9(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return f9(e, t);
  }
}
function yIe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function bIe(e) {
  if (Array.isArray(e)) return f9(e);
}
function f9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function LI(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Zi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? LI(Object(n), !0).forEach(function(r) {
      Tf(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : LI(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Tf(e, t, n) {
  return t = fJ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function xIe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function wIe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, fJ(r.key), r);
  }
}
function CIe(e, t, n) {
  return t && wIe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function fJ(e) {
  var t = SIe(e, "string");
  return Uc(t) === "symbol" ? t : String(t);
}
function SIe(e, t) {
  if (Uc(e) !== "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Uc(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function _Ie(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && h9(e, t);
}
function h9(e, t) {
  return h9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, h9(e, t);
}
function EIe(e) {
  var t = NIe();
  return function() {
    var r = Um(e), i;
    if (t) {
      var o = Um(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return p9(this, i);
  };
}
function p9(e, t) {
  if (t && (Uc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return m9(e);
}
function m9(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function NIe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Um(e) {
  return Um = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Um(e);
}
var za = /* @__PURE__ */ function(e) {
  _Ie(n, e);
  var t = EIe(n);
  function n(r, i) {
    var o;
    xIe(this, n), o = t.call(this, r, i);
    var a = o.props, s = a.isActive, l = a.attributeName, u = a.from, c = a.to, f = a.steps, h = a.children, m = a.duration;
    if (o.handleStyleChange = o.handleStyleChange.bind(m9(o)), o.changeStyle = o.changeStyle.bind(m9(o)), !s || m <= 0)
      return o.state = {
        style: {}
      }, typeof h == "function" && (o.state = {
        style: c
      }), p9(o);
    if (f && f.length)
      o.state = {
        style: f[0].style
      };
    else if (u) {
      if (typeof h == "function")
        return o.state = {
          style: u
        }, p9(o);
      o.state = {
        style: l ? Tf({}, l, u) : u
      };
    } else
      o.state = {
        style: {}
      };
    return o;
  }
  return CIe(n, [{
    key: "componentDidMount",
    value: function() {
      var i = this.props, o = i.isActive, a = i.canBegin;
      this.mounted = !0, !(!o || !a) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      var o = this.props, a = o.isActive, s = o.canBegin, l = o.attributeName, u = o.shouldReAnimate, c = o.to, f = o.from, h = this.state.style;
      if (s) {
        if (!a) {
          var m = {
            style: l ? Tf({}, l, c) : c
          };
          this.state && h && (l && h[l] !== c || !l && h !== c) && this.setState(m);
          return;
        }
        if (!(TDe(i.to, c) && i.canBegin && i.isActive)) {
          var v = !i.canBegin || !i.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var g = v || u ? f : i.to;
          if (this.state && h) {
            var y = {
              style: l ? Tf({}, l, g) : g
            };
            (l && h[l] !== g || !l && h !== g) && this.setState(y);
          }
          this.runAnimation(Zi(Zi({}, this.props), {}, {
            from: g,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var i = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), i && i();
    }
  }, {
    key: "handleStyleChange",
    value: function(i) {
      this.changeStyle(i);
    }
  }, {
    key: "changeStyle",
    value: function(i) {
      this.mounted && this.setState({
        style: i
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(i) {
      var o = this, a = i.from, s = i.to, l = i.duration, u = i.easing, c = i.begin, f = i.onAnimationEnd, h = i.onAnimationStart, m = fIe(a, s, tIe(u), l, this.changeStyle), v = function() {
        o.stopJSAnimation = m();
      };
      this.manager.start([h, c, v, l, f]);
    }
  }, {
    key: "runStepAnimation",
    value: function(i) {
      var o = this, a = i.steps, s = i.begin, l = i.onAnimationStart, u = a[0], c = u.style, f = u.duration, h = f === void 0 ? 0 : f, m = function(g, y, w) {
        if (w === 0)
          return g;
        var C = y.duration, S = y.easing, N = S === void 0 ? "ease" : S, E = y.style, A = y.properties, O = y.onAnimationEnd, T = w > 0 ? a[w - 1] : y, M = A || Object.keys(E);
        if (typeof N == "function" || N === "spring")
          return [].concat(U5(g), [o.runJSAnimation.bind(o, {
            from: T.style,
            to: E,
            duration: C,
            easing: N
          }), C]);
        var L = MI(M, C, N), I = Zi(Zi(Zi({}, T.style), E), {}, {
          transition: L
        });
        return [].concat(U5(g), [I, C, O]).filter(qDe);
      };
      return this.manager.start([l].concat(U5(a.reduce(m, [c, Math.max(h, s)])), [i.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(i) {
      this.manager || (this.manager = FDe());
      var o = i.begin, a = i.duration, s = i.attributeName, l = i.to, u = i.easing, c = i.onAnimationStart, f = i.onAnimationEnd, h = i.steps, m = i.children, v = this.manager;
      if (this.unSubscribe = v.subscribe(this.handleStyleChange), typeof u == "function" || typeof m == "function" || u === "spring") {
        this.runJSAnimation(i);
        return;
      }
      if (h.length > 1) {
        this.runStepAnimation(i);
        return;
      }
      var g = s ? Tf({}, s, l) : l, y = MI(Object.keys(g), a, u);
      v.start([c, o, Zi(Zi({}, g), {}, {
        transition: y
      }), a, f]);
    }
  }, {
    key: "render",
    value: function() {
      var i = this.props, o = i.children;
      i.begin;
      var a = i.duration;
      i.attributeName, i.easing;
      var s = i.isActive;
      i.steps, i.from, i.to, i.canBegin, i.onAnimationEnd, i.shouldReAnimate, i.onAnimationReStart;
      var l = pIe(i, hIe), u = Wr.count(o), c = this.state.style;
      if (typeof o == "function")
        return o(c);
      if (!s || u === 0 || a <= 0)
        return o;
      var f = function(m) {
        var v = m.props, g = v.style, y = g === void 0 ? {} : g, w = v.className, C = /* @__PURE__ */ cn(m, Zi(Zi({}, l), {}, {
          style: Zi(Zi({}, y), c),
          className: w
        }));
        return C;
      };
      return u === 1 ? f(Wr.only(o)) : /* @__PURE__ */ F.createElement("div", null, Wr.map(o, function(h) {
        return f(h);
      }));
    }
  }]), n;
}(Yo);
za.displayName = "Animate";
za.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
za.propTypes = {
  from: St.oneOfType([St.object, St.string]),
  to: St.oneOfType([St.object, St.string]),
  attributeName: St.string,
  // animation duration
  duration: St.number,
  begin: St.number,
  easing: St.oneOfType([St.string, St.func]),
  steps: St.arrayOf(St.shape({
    duration: St.number.isRequired,
    style: St.object.isRequired,
    easing: St.oneOfType([St.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), St.func]),
    // transition css properties(dash case), optional
    properties: St.arrayOf("string"),
    onAnimationEnd: St.func
  })),
  children: St.oneOfType([St.node, St.func]),
  isActive: St.bool,
  canBegin: St.bool,
  onAnimationEnd: St.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: St.bool,
  onAnimationStart: St.func,
  onAnimationReStart: St.func
};
function Ph(e) {
  "@babel/helpers - typeof";
  return Ph = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ph(e);
}
function Gm() {
  return Gm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gm.apply(this, arguments);
}
function AIe(e, t) {
  return TIe(e) || PIe(e, t) || kIe(e, t) || OIe();
}
function OIe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kIe(e, t) {
  if (e) {
    if (typeof e == "string") return FI(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return FI(e, t);
  }
}
function FI(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function PIe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, u = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (c) {
      u = !0, i = c;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw i;
      }
    }
    return s;
  }
}
function TIe(e) {
  if (Array.isArray(e)) return e;
}
function BI(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function jI(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? BI(Object(n), !0).forEach(function(r) {
      MIe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : BI(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function MIe(e, t, n) {
  return t = RIe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function RIe(e) {
  var t = DIe(e, "string");
  return Ph(t) == "symbol" ? t : t + "";
}
function DIe(e, t) {
  if (Ph(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ph(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var VI = function(t, n, r, i, o) {
  var a = Math.min(Math.abs(r) / 2, Math.abs(i) / 2), s = i >= 0 ? 1 : -1, l = r >= 0 ? 1 : -1, u = i >= 0 && r >= 0 || i < 0 && r < 0 ? 1 : 0, c;
  if (a > 0 && o instanceof Array) {
    for (var f = [0, 0, 0, 0], h = 0, m = 4; h < m; h++)
      f[h] = o[h] > a ? a : o[h];
    c = "M".concat(t, ",").concat(n + s * f[0]), f[0] > 0 && (c += "A ".concat(f[0], ",").concat(f[0], ",0,0,").concat(u, ",").concat(t + l * f[0], ",").concat(n)), c += "L ".concat(t + r - l * f[1], ",").concat(n), f[1] > 0 && (c += "A ".concat(f[1], ",").concat(f[1], ",0,0,").concat(u, `,
        `).concat(t + r, ",").concat(n + s * f[1])), c += "L ".concat(t + r, ",").concat(n + i - s * f[2]), f[2] > 0 && (c += "A ".concat(f[2], ",").concat(f[2], ",0,0,").concat(u, `,
        `).concat(t + r - l * f[2], ",").concat(n + i)), c += "L ".concat(t + l * f[3], ",").concat(n + i), f[3] > 0 && (c += "A ".concat(f[3], ",").concat(f[3], ",0,0,").concat(u, `,
        `).concat(t, ",").concat(n + i - s * f[3])), c += "Z";
  } else if (a > 0 && o === +o && o > 0) {
    var v = Math.min(a, o);
    c = "M ".concat(t, ",").concat(n + s * v, `
            A `).concat(v, ",").concat(v, ",0,0,").concat(u, ",").concat(t + l * v, ",").concat(n, `
            L `).concat(t + r - l * v, ",").concat(n, `
            A `).concat(v, ",").concat(v, ",0,0,").concat(u, ",").concat(t + r, ",").concat(n + s * v, `
            L `).concat(t + r, ",").concat(n + i - s * v, `
            A `).concat(v, ",").concat(v, ",0,0,").concat(u, ",").concat(t + r - l * v, ",").concat(n + i, `
            L `).concat(t + l * v, ",").concat(n + i, `
            A `).concat(v, ",").concat(v, ",0,0,").concat(u, ",").concat(t, ",").concat(n + i - s * v, " Z");
  } else
    c = "M ".concat(t, ",").concat(n, " h ").concat(r, " v ").concat(i, " h ").concat(-r, " Z");
  return c;
}, IIe = function(t, n) {
  if (!t || !n)
    return !1;
  var r = t.x, i = t.y, o = n.x, a = n.y, s = n.width, l = n.height;
  if (Math.abs(s) > 0 && Math.abs(l) > 0) {
    var u = Math.min(o, o + s), c = Math.max(o, o + s), f = Math.min(a, a + l), h = Math.max(a, a + l);
    return r >= u && r <= c && i >= f && i <= h;
  }
  return !1;
}, $Ie = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, x_ = function(t) {
  var n = jI(jI({}, $Ie), t), r = vt(), i = re(-1), o = AIe(i, 2), a = o[0], s = o[1];
  Pe(function() {
    if (r.current && r.current.getTotalLength)
      try {
        var N = r.current.getTotalLength();
        N && s(N);
      } catch {
      }
  }, []);
  var l = n.x, u = n.y, c = n.width, f = n.height, h = n.radius, m = n.className, v = n.animationEasing, g = n.animationDuration, y = n.animationBegin, w = n.isAnimationActive, C = n.isUpdateAnimationActive;
  if (l !== +l || u !== +u || c !== +c || f !== +f || c === 0 || f === 0)
    return null;
  var S = at("recharts-rectangle", m);
  return C ? /* @__PURE__ */ F.createElement(za, {
    canBegin: a > 0,
    from: {
      width: c,
      height: f,
      x: l,
      y: u
    },
    to: {
      width: c,
      height: f,
      x: l,
      y: u
    },
    duration: g,
    animationEasing: v,
    isActive: C
  }, function(N) {
    var E = N.width, A = N.height, O = N.x, T = N.y;
    return /* @__PURE__ */ F.createElement(za, {
      canBegin: a > 0,
      from: "0px ".concat(a === -1 ? 1 : a, "px"),
      to: "".concat(a, "px 0px"),
      attributeName: "strokeDasharray",
      begin: y,
      duration: g,
      isActive: w,
      easing: v
    }, /* @__PURE__ */ F.createElement("path", Gm({}, qe(n, !0), {
      className: S,
      d: VI(O, T, E, A, h),
      ref: r
    })));
  }) : /* @__PURE__ */ F.createElement("path", Gm({}, qe(n, !0), {
    className: S,
    d: VI(l, u, c, f, h)
  }));
}, LIe = ["points", "className", "baseLinePoints", "connectNulls"];
function ic() {
  return ic = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ic.apply(this, arguments);
}
function FIe(e, t) {
  if (e == null) return {};
  var n = BIe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function BIe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function qI(e) {
  return zIe(e) || qIe(e) || VIe(e) || jIe();
}
function jIe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function VIe(e, t) {
  if (e) {
    if (typeof e == "string") return g9(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return g9(e, t);
  }
}
function qIe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function zIe(e) {
  if (Array.isArray(e)) return g9(e);
}
function g9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var zI = function(t) {
  return t && t.x === +t.x && t.y === +t.y;
}, WIe = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = [[]];
  return t.forEach(function(r) {
    zI(r) ? n[n.length - 1].push(r) : n[n.length - 1].length > 0 && n.push([]);
  }), zI(t[0]) && n[n.length - 1].push(t[0]), n[n.length - 1].length <= 0 && (n = n.slice(0, -1)), n;
}, zf = function(t, n) {
  var r = WIe(t);
  n && (r = [r.reduce(function(o, a) {
    return [].concat(qI(o), qI(a));
  }, [])]);
  var i = r.map(function(o) {
    return o.reduce(function(a, s, l) {
      return "".concat(a).concat(l === 0 ? "M" : "L").concat(s.x, ",").concat(s.y);
    }, "");
  }).join("");
  return r.length === 1 ? "".concat(i, "Z") : i;
}, HIe = function(t, n, r) {
  var i = zf(t, r);
  return "".concat(i.slice(-1) === "Z" ? i.slice(0, -1) : i, "L").concat(zf(n.reverse(), r).slice(1));
}, hJ = function(t) {
  var n = t.points, r = t.className, i = t.baseLinePoints, o = t.connectNulls, a = FIe(t, LIe);
  if (!n || !n.length)
    return null;
  var s = at("recharts-polygon", r);
  if (i && i.length) {
    var l = a.stroke && a.stroke !== "none", u = HIe(n, i, o);
    return /* @__PURE__ */ F.createElement("g", {
      className: s
    }, /* @__PURE__ */ F.createElement("path", ic({}, qe(a, !0), {
      fill: u.slice(-1) === "Z" ? a.fill : "none",
      stroke: "none",
      d: u
    })), l ? /* @__PURE__ */ F.createElement("path", ic({}, qe(a, !0), {
      fill: "none",
      d: zf(n, o)
    })) : null, l ? /* @__PURE__ */ F.createElement("path", ic({}, qe(a, !0), {
      fill: "none",
      d: zf(i, o)
    })) : null);
  }
  var c = zf(n, o);
  return /* @__PURE__ */ F.createElement("path", ic({}, qe(a, !0), {
    fill: c.slice(-1) === "Z" ? a.fill : "none",
    className: s,
    d: c
  }));
};
function v9() {
  return v9 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, v9.apply(this, arguments);
}
var xv = function(t) {
  var n = t.cx, r = t.cy, i = t.r, o = t.className, a = at("recharts-dot", o);
  return n === +n && r === +r && i === +i ? /* @__PURE__ */ F.createElement("circle", v9({}, qe(t, !1), gm(t), {
    className: a,
    cx: n,
    cy: r,
    r: i
  })) : null;
};
function Th(e) {
  "@babel/helpers - typeof";
  return Th = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Th(e);
}
var UIe = ["x", "y", "top", "left", "width", "height", "className"];
function y9() {
  return y9 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, y9.apply(this, arguments);
}
function WI(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function GIe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? WI(Object(n), !0).forEach(function(r) {
      KIe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : WI(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function KIe(e, t, n) {
  return t = YIe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function YIe(e) {
  var t = ZIe(e, "string");
  return Th(t) == "symbol" ? t : t + "";
}
function ZIe(e, t) {
  if (Th(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Th(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function XIe(e, t) {
  if (e == null) return {};
  var n = JIe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function JIe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var QIe = function(t, n, r, i, o, a) {
  return "M".concat(t, ",").concat(o, "v").concat(i, "M").concat(a, ",").concat(n, "h").concat(r);
}, e$e = function(t) {
  var n = t.x, r = n === void 0 ? 0 : n, i = t.y, o = i === void 0 ? 0 : i, a = t.top, s = a === void 0 ? 0 : a, l = t.left, u = l === void 0 ? 0 : l, c = t.width, f = c === void 0 ? 0 : c, h = t.height, m = h === void 0 ? 0 : h, v = t.className, g = XIe(t, UIe), y = GIe({
    x: r,
    y: o,
    top: s,
    left: u,
    width: f,
    height: m
  }, g);
  return !we(r) || !we(o) || !we(f) || !we(m) || !we(s) || !we(u) ? null : /* @__PURE__ */ F.createElement("path", y9({}, qe(y, !0), {
    className: at("recharts-cross", v),
    d: QIe(r, o, f, m, s, u)
  }));
}, t$e = ["cx", "cy", "innerRadius", "outerRadius", "gridType", "radialLines"];
function Mh(e) {
  "@babel/helpers - typeof";
  return Mh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mh(e);
}
function n$e(e, t) {
  if (e == null) return {};
  var n = r$e(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function r$e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Wa() {
  return Wa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wa.apply(this, arguments);
}
function HI(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Rh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? HI(Object(n), !0).forEach(function(r) {
      i$e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : HI(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function i$e(e, t, n) {
  return t = o$e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function o$e(e) {
  var t = a$e(e, "string");
  return Mh(t) == "symbol" ? t : t + "";
}
function a$e(e, t) {
  if (Mh(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Mh(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var s$e = function(t, n, r, i) {
  var o = "";
  return i.forEach(function(a, s) {
    var l = $t(n, r, t, a);
    s ? o += "L ".concat(l.x, ",").concat(l.y) : o += "M ".concat(l.x, ",").concat(l.y);
  }), o += "Z", o;
}, l$e = function(t) {
  var n = t.cx, r = t.cy, i = t.innerRadius, o = t.outerRadius, a = t.polarAngles, s = t.radialLines;
  if (!a || !a.length || !s)
    return null;
  var l = Rh({
    stroke: "#ccc"
  }, qe(t, !1));
  return /* @__PURE__ */ F.createElement("g", {
    className: "recharts-polar-grid-angle"
  }, a.map(function(u) {
    var c = $t(n, r, i, u), f = $t(n, r, o, u);
    return /* @__PURE__ */ F.createElement("line", Wa({}, l, {
      key: "line-".concat(u),
      x1: c.x,
      y1: c.y,
      x2: f.x,
      y2: f.y
    }));
  }));
}, u$e = function(t) {
  var n = t.cx, r = t.cy, i = t.radius, o = t.index, a = Rh(Rh({
    stroke: "#ccc"
  }, qe(t, !1)), {}, {
    fill: "none"
  });
  return /* @__PURE__ */ F.createElement("circle", Wa({}, a, {
    className: at("recharts-polar-grid-concentric-circle", t.className),
    key: "circle-".concat(o),
    cx: n,
    cy: r,
    r: i
  }));
}, c$e = function(t) {
  var n = t.radius, r = t.index, i = Rh(Rh({
    stroke: "#ccc"
  }, qe(t, !1)), {}, {
    fill: "none"
  });
  return /* @__PURE__ */ F.createElement("path", Wa({}, i, {
    className: at("recharts-polar-grid-concentric-polygon", t.className),
    key: "path-".concat(r),
    d: s$e(n, t.cx, t.cy, t.polarAngles)
  }));
}, d$e = function(t) {
  var n = t.polarRadius, r = t.gridType;
  return !n || !n.length ? null : /* @__PURE__ */ F.createElement("g", {
    className: "recharts-polar-grid-concentric"
  }, n.map(function(i, o) {
    var a = o;
    return r === "circle" ? /* @__PURE__ */ F.createElement(u$e, Wa({
      key: a
    }, t, {
      radius: i,
      index: o
    })) : /* @__PURE__ */ F.createElement(c$e, Wa({
      key: a
    }, t, {
      radius: i,
      index: o
    }));
  }));
}, w_ = function(t) {
  var n = t.cx, r = n === void 0 ? 0 : n, i = t.cy, o = i === void 0 ? 0 : i, a = t.innerRadius, s = a === void 0 ? 0 : a, l = t.outerRadius, u = l === void 0 ? 0 : l, c = t.gridType, f = c === void 0 ? "polygon" : c, h = t.radialLines, m = h === void 0 ? !0 : h, v = n$e(t, t$e);
  return u <= 0 ? null : /* @__PURE__ */ F.createElement("g", {
    className: "recharts-polar-grid"
  }, /* @__PURE__ */ F.createElement(l$e, Wa({
    cx: r,
    cy: o,
    innerRadius: s,
    outerRadius: u,
    gridType: f,
    radialLines: m
  }, v)), /* @__PURE__ */ F.createElement(d$e, Wa({
    cx: r,
    cy: o,
    innerRadius: s,
    outerRadius: u,
    gridType: f,
    radialLines: m
  }, v)));
};
w_.displayName = "PolarGrid";
var G5, UI;
function f$e() {
  if (UI) return G5;
  UI = 1;
  var e = hv(), t = AX(), n = na();
  function r(i, o) {
    return i && i.length ? e(i, n(o, 2), t) : void 0;
  }
  return G5 = r, G5;
}
var h$e = f$e();
const p$e = /* @__PURE__ */ Rt(h$e);
var K5, GI;
function m$e() {
  if (GI) return K5;
  GI = 1;
  var e = hv(), t = na(), n = OX();
  function r(i, o) {
    return i && i.length ? e(i, t(o, 2), n) : void 0;
  }
  return K5 = r, K5;
}
var g$e = m$e();
const v$e = /* @__PURE__ */ Rt(g$e);
var y$e = ["cx", "cy", "angle", "ticks", "axisLine"], b$e = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function Gc(e) {
  "@babel/helpers - typeof";
  return Gc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gc(e);
}
function Wf() {
  return Wf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wf.apply(this, arguments);
}
function KI(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function vl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? KI(Object(n), !0).forEach(function(r) {
      wv(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : KI(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function YI(e, t) {
  if (e == null) return {};
  var n = x$e(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function x$e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function w$e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ZI(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, mJ(r.key), r);
  }
}
function C$e(e, t, n) {
  return t && ZI(e.prototype, t), n && ZI(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function S$e(e, t, n) {
  return t = Km(t), _$e(e, pJ() ? Reflect.construct(t, n || [], Km(e).constructor) : t.apply(e, n));
}
function _$e(e, t) {
  if (t && (Gc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return E$e(e);
}
function E$e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function pJ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (pJ = function() {
    return !!e;
  })();
}
function Km(e) {
  return Km = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Km(e);
}
function N$e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && b9(e, t);
}
function b9(e, t) {
  return b9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, b9(e, t);
}
function wv(e, t, n) {
  return t = mJ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function mJ(e) {
  var t = A$e(e, "string");
  return Gc(t) == "symbol" ? t : t + "";
}
function A$e(e, t) {
  if (Gc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Gc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Cv = /* @__PURE__ */ function(e) {
  function t() {
    return w$e(this, t), S$e(this, t, arguments);
  }
  return N$e(t, e), C$e(t, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      function(r) {
        var i = r.coordinate, o = this.props, a = o.angle, s = o.cx, l = o.cy;
        return $t(s, l, i, a);
      }
    )
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var r = this.props.orientation, i;
      switch (r) {
        case "left":
          i = "end";
          break;
        case "right":
          i = "start";
          break;
        default:
          i = "middle";
          break;
      }
      return i;
    }
  }, {
    key: "getViewBox",
    value: function() {
      var r = this.props, i = r.cx, o = r.cy, a = r.angle, s = r.ticks, l = p$e(s, function(c) {
        return c.coordinate || 0;
      }), u = v$e(s, function(c) {
        return c.coordinate || 0;
      });
      return {
        cx: i,
        cy: o,
        startAngle: a,
        endAngle: a,
        innerRadius: u.coordinate || 0,
        outerRadius: l.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var r = this.props, i = r.cx, o = r.cy, a = r.angle, s = r.ticks, l = r.axisLine, u = YI(r, y$e), c = s.reduce(function(v, g) {
        return [Math.min(v[0], g.coordinate), Math.max(v[1], g.coordinate)];
      }, [1 / 0, -1 / 0]), f = $t(i, o, c[0], a), h = $t(i, o, c[1], a), m = vl(vl(vl({}, qe(u, !1)), {}, {
        fill: "none"
      }, qe(l, !1)), {}, {
        x1: f.x,
        y1: f.y,
        x2: h.x,
        y2: h.y
      });
      return /* @__PURE__ */ F.createElement("line", Wf({
        className: "recharts-polar-radius-axis-line"
      }, m));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var r = this, i = this.props, o = i.ticks, a = i.tick, s = i.angle, l = i.tickFormatter, u = i.stroke, c = YI(i, b$e), f = this.getTickTextAnchor(), h = qe(c, !1), m = qe(a, !1), v = o.map(function(g, y) {
        var w = r.getTickValueCoord(g), C = vl(vl(vl(vl({
          textAnchor: f,
          transform: "rotate(".concat(90 - s, ", ").concat(w.x, ", ").concat(w.y, ")")
        }, h), {}, {
          stroke: "none",
          fill: u
        }, m), {}, {
          index: y
        }, w), {}, {
          payload: g
        });
        return /* @__PURE__ */ F.createElement(zt, Wf({
          className: at("recharts-polar-radius-axis-tick", tJ(a)),
          key: "tick-".concat(g.coordinate)
        }, Ic(r.props, g, y)), t.renderTickItem(a, C, l ? l(g.value, y) : g.value));
      });
      return /* @__PURE__ */ F.createElement(zt, {
        className: "recharts-polar-radius-axis-ticks"
      }, v);
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.ticks, o = r.axisLine, a = r.tick;
      return !i || !i.length ? null : /* @__PURE__ */ F.createElement(zt, {
        className: at("recharts-polar-radius-axis", this.props.className)
      }, o && this.renderAxisLine(), a && this.renderTicks(), er.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function(r, i, o) {
      var a;
      return /* @__PURE__ */ F.isValidElement(r) ? a = /* @__PURE__ */ F.cloneElement(r, i) : Ye(r) ? a = r(i) : a = /* @__PURE__ */ F.createElement(Vc, Wf({}, i, {
        className: "recharts-polar-radius-axis-tick-value"
      }), o), a;
    }
  }]);
}(Yo);
wv(Cv, "displayName", "PolarRadiusAxis");
wv(Cv, "axisType", "radiusAxis");
wv(Cv, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: !0,
  tick: !0,
  tickCount: 5,
  allowDataOverflow: !1,
  scale: "auto",
  allowDuplicatedCategory: !0
});
function Kc(e) {
  "@babel/helpers - typeof";
  return Kc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Kc(e);
}
function Sl() {
  return Sl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sl.apply(this, arguments);
}
function XI(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function yl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? XI(Object(n), !0).forEach(function(r) {
      Sv(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : XI(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function O$e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function JI(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, vJ(r.key), r);
  }
}
function k$e(e, t, n) {
  return t && JI(e.prototype, t), n && JI(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function P$e(e, t, n) {
  return t = Ym(t), T$e(e, gJ() ? Reflect.construct(t, n || [], Ym(e).constructor) : t.apply(e, n));
}
function T$e(e, t) {
  if (t && (Kc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return M$e(e);
}
function M$e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function gJ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (gJ = function() {
    return !!e;
  })();
}
function Ym(e) {
  return Ym = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ym(e);
}
function R$e(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && x9(e, t);
}
function x9(e, t) {
  return x9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, x9(e, t);
}
function Sv(e, t, n) {
  return t = vJ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function vJ(e) {
  var t = D$e(e, "string");
  return Kc(t) == "symbol" ? t : t + "";
}
function D$e(e, t) {
  if (Kc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Kc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var I$e = Math.PI / 180, $$e = 1e-5, Ld = /* @__PURE__ */ function(e) {
  function t() {
    return O$e(this, t), P$e(this, t, arguments);
  }
  return R$e(t, e), k$e(t, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function(r) {
        var i = this.props, o = i.cx, a = i.cy, s = i.radius, l = i.orientation, u = i.tickSize, c = u || 8, f = $t(o, a, s, r.coordinate), h = $t(o, a, s + (l === "inner" ? -1 : 1) * c, r.coordinate);
        return {
          x1: f.x,
          y1: f.y,
          x2: h.x,
          y2: h.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function(r) {
      var i = this.props.orientation, o = Math.cos(-r.coordinate * I$e), a;
      return o > $$e ? a = i === "outer" ? "start" : "end" : o < -1e-5 ? a = i === "outer" ? "end" : "start" : a = "middle", a;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var r = this.props, i = r.cx, o = r.cy, a = r.radius, s = r.axisLine, l = r.axisLineType, u = yl(yl({}, qe(this.props, !1)), {}, {
        fill: "none"
      }, qe(s, !1));
      if (l === "circle")
        return /* @__PURE__ */ F.createElement(xv, Sl({
          className: "recharts-polar-angle-axis-line"
        }, u, {
          cx: i,
          cy: o,
          r: a
        }));
      var c = this.props.ticks, f = c.map(function(h) {
        return $t(i, o, a, h.coordinate);
      });
      return /* @__PURE__ */ F.createElement(hJ, Sl({
        className: "recharts-polar-angle-axis-line"
      }, u, {
        points: f
      }));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var r = this, i = this.props, o = i.ticks, a = i.tick, s = i.tickLine, l = i.tickFormatter, u = i.stroke, c = qe(this.props, !1), f = qe(a, !1), h = yl(yl({}, c), {}, {
        fill: "none"
      }, qe(s, !1)), m = o.map(function(v, g) {
        var y = r.getTickLineCoord(v), w = r.getTickTextAnchor(v), C = yl(yl(yl({
          textAnchor: w
        }, c), {}, {
          stroke: "none",
          fill: u
        }, f), {}, {
          index: g,
          payload: v,
          x: y.x2,
          y: y.y2
        });
        return /* @__PURE__ */ F.createElement(zt, Sl({
          className: at("recharts-polar-angle-axis-tick", tJ(a)),
          key: "tick-".concat(v.coordinate)
        }, Ic(r.props, v, g)), s && /* @__PURE__ */ F.createElement("line", Sl({
          className: "recharts-polar-angle-axis-tick-line"
        }, h, y)), a && t.renderTickItem(a, C, l ? l(v.value, g) : v.value));
      });
      return /* @__PURE__ */ F.createElement(zt, {
        className: "recharts-polar-angle-axis-ticks"
      }, m);
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.ticks, o = r.radius, a = r.axisLine;
      return o <= 0 || !i || !i.length ? null : /* @__PURE__ */ F.createElement(zt, {
        className: at("recharts-polar-angle-axis", this.props.className)
      }, a && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function(r, i, o) {
      var a;
      return /* @__PURE__ */ F.isValidElement(r) ? a = /* @__PURE__ */ F.cloneElement(r, i) : Ye(r) ? a = r(i) : a = /* @__PURE__ */ F.createElement(Vc, Sl({}, i, {
        className: "recharts-polar-angle-axis-tick-value"
      }), o), a;
    }
  }]);
}(Yo);
Sv(Ld, "displayName", "PolarAngleAxis");
Sv(Ld, "axisType", "angleAxis");
Sv(Ld, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
});
var Y5, QI;
function L$e() {
  if (QI) return Y5;
  QI = 1;
  var e = EZ(), t = e(Object.getPrototypeOf, Object);
  return Y5 = t, Y5;
}
var Z5, e$;
function F$e() {
  if (e$) return Z5;
  e$ = 1;
  var e = Za(), t = L$e(), n = Xa(), r = "[object Object]", i = Function.prototype, o = Object.prototype, a = i.toString, s = o.hasOwnProperty, l = a.call(Object);
  function u(c) {
    if (!n(c) || e(c) != r)
      return !1;
    var f = t(c);
    if (f === null)
      return !0;
    var h = s.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && a.call(h) == l;
  }
  return Z5 = u, Z5;
}
var B$e = F$e();
const j$e = /* @__PURE__ */ Rt(B$e);
var X5, t$;
function V$e() {
  if (t$) return X5;
  t$ = 1;
  var e = Za(), t = Xa(), n = "[object Boolean]";
  function r(i) {
    return i === !0 || i === !1 || t(i) && e(i) == n;
  }
  return X5 = r, X5;
}
var q$e = V$e();
const z$e = /* @__PURE__ */ Rt(q$e);
function Dh(e) {
  "@babel/helpers - typeof";
  return Dh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Dh(e);
}
function Zm() {
  return Zm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zm.apply(this, arguments);
}
function W$e(e, t) {
  return K$e(e) || G$e(e, t) || U$e(e, t) || H$e();
}
function H$e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function U$e(e, t) {
  if (e) {
    if (typeof e == "string") return n$(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return n$(e, t);
  }
}
function n$(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function G$e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, u = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (c) {
      u = !0, i = c;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw i;
      }
    }
    return s;
  }
}
function K$e(e) {
  if (Array.isArray(e)) return e;
}
function r$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function i$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? r$(Object(n), !0).forEach(function(r) {
      Y$e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Y$e(e, t, n) {
  return t = Z$e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Z$e(e) {
  var t = X$e(e, "string");
  return Dh(t) == "symbol" ? t : t + "";
}
function X$e(e, t) {
  if (Dh(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Dh(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var o$ = function(t, n, r, i, o) {
  var a = r - i, s;
  return s = "M ".concat(t, ",").concat(n), s += "L ".concat(t + r, ",").concat(n), s += "L ".concat(t + r - a / 2, ",").concat(n + o), s += "L ".concat(t + r - a / 2 - i, ",").concat(n + o), s += "L ".concat(t, ",").concat(n, " Z"), s;
}, J$e = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Q$e = function(t) {
  var n = i$(i$({}, J$e), t), r = vt(), i = re(-1), o = W$e(i, 2), a = o[0], s = o[1];
  Pe(function() {
    if (r.current && r.current.getTotalLength)
      try {
        var S = r.current.getTotalLength();
        S && s(S);
      } catch {
      }
  }, []);
  var l = n.x, u = n.y, c = n.upperWidth, f = n.lowerWidth, h = n.height, m = n.className, v = n.animationEasing, g = n.animationDuration, y = n.animationBegin, w = n.isUpdateAnimationActive;
  if (l !== +l || u !== +u || c !== +c || f !== +f || h !== +h || c === 0 && f === 0 || h === 0)
    return null;
  var C = at("recharts-trapezoid", m);
  return w ? /* @__PURE__ */ F.createElement(za, {
    canBegin: a > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: h,
      x: l,
      y: u
    },
    to: {
      upperWidth: c,
      lowerWidth: f,
      height: h,
      x: l,
      y: u
    },
    duration: g,
    animationEasing: v,
    isActive: w
  }, function(S) {
    var N = S.upperWidth, E = S.lowerWidth, A = S.height, O = S.x, T = S.y;
    return /* @__PURE__ */ F.createElement(za, {
      canBegin: a > 0,
      from: "0px ".concat(a === -1 ? 1 : a, "px"),
      to: "".concat(a, "px 0px"),
      attributeName: "strokeDasharray",
      begin: y,
      duration: g,
      easing: v
    }, /* @__PURE__ */ F.createElement("path", Zm({}, qe(n, !0), {
      className: C,
      d: o$(O, T, N, E, A),
      ref: r
    })));
  }) : /* @__PURE__ */ F.createElement("g", null, /* @__PURE__ */ F.createElement("path", Zm({}, qe(n, !0), {
    className: C,
    d: o$(l, u, c, f, h)
  })));
}, eLe = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function Ih(e) {
  "@babel/helpers - typeof";
  return Ih = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ih(e);
}
function tLe(e, t) {
  if (e == null) return {};
  var n = nLe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function nLe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function a$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Xm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? a$(Object(n), !0).forEach(function(r) {
      rLe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : a$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function rLe(e, t, n) {
  return t = iLe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function iLe(e) {
  var t = oLe(e, "string");
  return Ih(t) == "symbol" ? t : t + "";
}
function oLe(e, t) {
  if (Ih(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ih(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function aLe(e, t) {
  return Xm(Xm({}, t), e);
}
function sLe(e, t) {
  return e === "symbols";
}
function s$(e) {
  var t = e.shapeType, n = e.elementProps;
  switch (t) {
    case "rectangle":
      return /* @__PURE__ */ F.createElement(x_, n);
    case "trapezoid":
      return /* @__PURE__ */ F.createElement(Q$e, n);
    case "sector":
      return /* @__PURE__ */ F.createElement(oJ, n);
    case "symbols":
      if (sLe(t))
        return /* @__PURE__ */ F.createElement(BS, n);
      break;
    default:
      return null;
  }
}
function lLe(e) {
  return /* @__PURE__ */ Pr(e) ? e.props : e;
}
function uLe(e) {
  var t = e.option, n = e.shapeType, r = e.propTransformer, i = r === void 0 ? aLe : r, o = e.activeClassName, a = o === void 0 ? "recharts-active-shape" : o, s = e.isActive, l = tLe(e, eLe), u;
  if (/* @__PURE__ */ Pr(t))
    u = /* @__PURE__ */ cn(t, Xm(Xm({}, l), lLe(t)));
  else if (Ye(t))
    u = t(l);
  else if (j$e(t) && !z$e(t)) {
    var c = i(t, l);
    u = /* @__PURE__ */ F.createElement(s$, {
      shapeType: n,
      elementProps: c
    });
  } else {
    var f = l;
    u = /* @__PURE__ */ F.createElement(s$, {
      shapeType: n,
      elementProps: f
    });
  }
  return s ? /* @__PURE__ */ F.createElement(zt, {
    className: a
  }, u) : u;
}
function _v(e, t) {
  return t != null && "trapezoids" in e.props;
}
function Ev(e, t) {
  return t != null && "sectors" in e.props;
}
function $h(e, t) {
  return t != null && "points" in e.props;
}
function cLe(e, t) {
  var n, r, i = e.x === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.x) || e.x === t.x, o = e.y === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.y) || e.y === t.y;
  return i && o;
}
function dLe(e, t) {
  var n = e.endAngle === t.endAngle, r = e.startAngle === t.startAngle;
  return n && r;
}
function fLe(e, t) {
  var n = e.x === t.x, r = e.y === t.y, i = e.z === t.z;
  return n && r && i;
}
function hLe(e, t) {
  var n;
  return _v(e, t) ? n = cLe : Ev(e, t) ? n = dLe : $h(e, t) && (n = fLe), n;
}
function pLe(e, t) {
  var n;
  return _v(e, t) ? n = "trapezoids" : Ev(e, t) ? n = "sectors" : $h(e, t) && (n = "points"), n;
}
function mLe(e, t) {
  if (_v(e, t)) {
    var n;
    return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  if (Ev(e, t)) {
    var r;
    return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  return $h(e, t) ? t.payload : {};
}
function gLe(e) {
  var t = e.activeTooltipItem, n = e.graphicalItem, r = e.itemData, i = pLe(n, t), o = mLe(n, t), a = r.filter(function(l, u) {
    var c = gv(o, l), f = n.props[i].filter(function(v) {
      var g = hLe(n, t);
      return g(v, t);
    }), h = n.props[i].indexOf(f[f.length - 1]), m = u === h;
    return c && m;
  }), s = r.indexOf(a[a.length - 1]);
  return s;
}
var J5, l$;
function vLe() {
  if (l$) return J5;
  l$ = 1;
  function e(t) {
    return t && t.length ? t[0] : void 0;
  }
  return J5 = e, J5;
}
var Q5, u$;
function yLe() {
  return u$ || (u$ = 1, Q5 = vLe()), Q5;
}
var bLe = yLe();
const xLe = /* @__PURE__ */ Rt(bLe);
var wLe = ["key"];
function Yc(e) {
  "@babel/helpers - typeof";
  return Yc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yc(e);
}
function CLe(e, t) {
  if (e == null) return {};
  var n = SLe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function SLe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Jm() {
  return Jm = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Jm.apply(this, arguments);
}
function c$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ar(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? c$(Object(n), !0).forEach(function(r) {
      _a(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function _Le(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function d$(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, bJ(r.key), r);
  }
}
function ELe(e, t, n) {
  return t && d$(e.prototype, t), n && d$(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function NLe(e, t, n) {
  return t = Qm(t), ALe(e, yJ() ? Reflect.construct(t, n || [], Qm(e).constructor) : t.apply(e, n));
}
function ALe(e, t) {
  if (t && (Yc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return OLe(e);
}
function OLe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function yJ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (yJ = function() {
    return !!e;
  })();
}
function Qm(e) {
  return Qm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Qm(e);
}
function kLe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && w9(e, t);
}
function w9(e, t) {
  return w9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, w9(e, t);
}
function _a(e, t, n) {
  return t = bJ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function bJ(e) {
  var t = PLe(e, "string");
  return Yc(t) == "symbol" ? t : t + "";
}
function PLe(e, t) {
  if (Yc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Yc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Fd = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    _Le(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = NLe(this, t, [].concat(i)), _a(n, "state", {
      isAnimationFinished: !1
    }), _a(n, "handleAnimationEnd", function() {
      var a = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), Ye(a) && a();
    }), _a(n, "handleAnimationStart", function() {
      var a = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), Ye(a) && a();
    }), _a(n, "handleMouseEnter", function(a) {
      var s = n.props.onMouseEnter;
      s && s(n.props, a);
    }), _a(n, "handleMouseLeave", function(a) {
      var s = n.props.onMouseLeave;
      s && s(n.props, a);
    }), n;
  }
  return kLe(t, e), ELe(t, [{
    key: "renderDots",
    value: function(r) {
      var i = this.props, o = i.dot, a = i.dataKey, s = qe(this.props, !1), l = qe(o, !0), u = r.map(function(c, f) {
        var h = Ar(Ar(Ar({
          key: "dot-".concat(f),
          r: 3
        }, s), l), {}, {
          dataKey: a,
          cx: c.x,
          cy: c.y,
          index: f,
          payload: c
        });
        return t.renderDotItem(o, h);
      });
      return /* @__PURE__ */ F.createElement(zt, {
        className: "recharts-radar-dots"
      }, u);
    }
  }, {
    key: "renderPolygonStatically",
    value: function(r) {
      var i = this.props, o = i.shape, a = i.dot, s = i.isRange, l = i.baseLinePoints, u = i.connectNulls, c;
      return /* @__PURE__ */ F.isValidElement(o) ? c = /* @__PURE__ */ F.cloneElement(o, Ar(Ar({}, this.props), {}, {
        points: r
      })) : Ye(o) ? c = o(Ar(Ar({}, this.props), {}, {
        points: r
      })) : c = /* @__PURE__ */ F.createElement(hJ, Jm({}, qe(this.props, !0), {
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        points: r,
        baseLinePoints: s ? l : null,
        connectNulls: u
      })), /* @__PURE__ */ F.createElement(zt, {
        className: "recharts-radar-polygon"
      }, c, a ? this.renderDots(r) : null);
    }
  }, {
    key: "renderPolygonWithAnimation",
    value: function() {
      var r = this, i = this.props, o = i.points, a = i.isAnimationActive, s = i.animationBegin, l = i.animationDuration, u = i.animationEasing, c = i.animationId, f = this.state.prevPoints;
      return /* @__PURE__ */ F.createElement(za, {
        begin: s,
        duration: l,
        isActive: a,
        easing: u,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "radar-".concat(c),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(h) {
        var m = h.t, v = f && f.length / o.length, g = o.map(function(y, w) {
          var C = f && f[Math.floor(w * v)];
          if (C) {
            var S = ko(C.x, y.x), N = ko(C.y, y.y);
            return Ar(Ar({}, y), {}, {
              x: S(m),
              y: N(m)
            });
          }
          var E = ko(y.cx, y.x), A = ko(y.cy, y.y);
          return Ar(Ar({}, y), {}, {
            x: E(m),
            y: A(m)
          });
        });
        return r.renderPolygonStatically(g);
      });
    }
  }, {
    key: "renderPolygon",
    value: function() {
      var r = this.props, i = r.points, o = r.isAnimationActive, a = r.isRange, s = this.state.prevPoints;
      return o && i && i.length && !a && (!s || !gv(s, i)) ? this.renderPolygonWithAnimation() : this.renderPolygonStatically(i);
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.hide, o = r.className, a = r.points, s = r.isAnimationActive;
      if (i || !a || !a.length)
        return null;
      var l = this.state.isAnimationFinished, u = at("recharts-radar", o);
      return /* @__PURE__ */ F.createElement(zt, {
        className: u
      }, this.renderPolygon(), (!s || l) && Is.renderCallByParent(this.props, a));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return r.animationId !== i.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curPoints: r.points,
        prevPoints: i.curPoints
      } : r.points !== i.curPoints ? {
        curPoints: r.points
      } : null;
    }
  }, {
    key: "renderDotItem",
    value: function(r, i) {
      var o;
      if (/* @__PURE__ */ F.isValidElement(r))
        o = /* @__PURE__ */ F.cloneElement(r, i);
      else if (Ye(r))
        o = r(i);
      else {
        var a = i.key, s = CLe(i, wLe);
        o = /* @__PURE__ */ F.createElement(xv, Jm({}, s, {
          key: a,
          className: at("recharts-radar-dot", typeof r != "boolean" ? r.className : "")
        }));
      }
      return o;
    }
  }]);
}(Yo);
_a(Fd, "displayName", "Radar");
_a(Fd, "defaultProps", {
  angleAxisId: 0,
  radiusAxisId: 0,
  hide: !1,
  activeDot: !0,
  dot: !1,
  legendType: "rect",
  isAnimationActive: !Rd.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
_a(Fd, "getComposedData", function(e) {
  var t = e.radiusAxis, n = e.angleAxis, r = e.displayedData, i = e.dataKey, o = e.bandSize, a = n.cx, s = n.cy, l = !1, u = [], c = n.type !== "number" ? o ?? 0 : 0;
  r.forEach(function(h, m) {
    var v = Fi(h, n.dataKey, m), g = Fi(h, i), y = n.scale(v) + c, w = Array.isArray(g) ? rJ(g) : g, C = yt(w) ? void 0 : t.scale(w);
    Array.isArray(g) && g.length >= 2 && (l = !0), u.push(Ar(Ar({}, $t(a, s, C, y)), {}, {
      name: v,
      value: g,
      cx: a,
      cy: s,
      radius: C,
      angle: y,
      payload: h
    }));
  });
  var f = [];
  return l && u.forEach(function(h) {
    if (Array.isArray(h.value)) {
      var m = xLe(h.value), v = yt(m) ? void 0 : t.scale(m);
      f.push(Ar(Ar({}, h), {}, {
        radius: v
      }, $t(a, s, v, h.angle)));
    } else
      f.push(h);
  }), {
    points: u,
    isRange: l,
    baseLinePoints: f
  };
});
var e8, f$;
function TLe() {
  if (f$) return e8;
  f$ = 1;
  var e = Math.ceil, t = Math.max;
  function n(r, i, o, a) {
    for (var s = -1, l = t(e((i - r) / (o || 1)), 0), u = Array(l); l--; )
      u[a ? l : ++s] = r, r += o;
    return u;
  }
  return e8 = n, e8;
}
var t8, h$;
function xJ() {
  if (h$) return t8;
  h$ = 1;
  var e = VZ(), t = 1 / 0, n = 17976931348623157e292;
  function r(i) {
    if (!i)
      return i === 0 ? i : 0;
    if (i = e(i), i === t || i === -1 / 0) {
      var o = i < 0 ? -1 : 1;
      return o * n;
    }
    return i === i ? i : 0;
  }
  return t8 = r, t8;
}
var n8, p$;
function MLe() {
  if (p$) return n8;
  p$ = 1;
  var e = TLe(), t = av(), n = xJ();
  function r(i) {
    return function(o, a, s) {
      return s && typeof s != "number" && t(o, a, s) && (a = s = void 0), o = n(o), a === void 0 ? (a = o, o = 0) : a = n(a), s = s === void 0 ? o < a ? 1 : -1 : n(s), e(o, a, s, i);
    };
  }
  return n8 = r, n8;
}
var r8, m$;
function RLe() {
  if (m$) return r8;
  m$ = 1;
  var e = MLe(), t = e();
  return r8 = t, r8;
}
var DLe = RLe();
const eg = /* @__PURE__ */ Rt(DLe);
function Lh(e) {
  "@babel/helpers - typeof";
  return Lh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Lh(e);
}
function g$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function v$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? g$(Object(n), !0).forEach(function(r) {
      wJ(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : g$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function wJ(e, t, n) {
  return t = ILe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ILe(e) {
  var t = $Le(e, "string");
  return Lh(t) == "symbol" ? t : t + "";
}
function $Le(e, t) {
  if (Lh(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Lh(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var LLe = ["Webkit", "Moz", "O", "ms"], FLe = function(t, n) {
  var r = t.replace(/(\w)/, function(o) {
    return o.toUpperCase();
  }), i = LLe.reduce(function(o, a) {
    return v$(v$({}, o), {}, wJ({}, a + r, n));
  }, {});
  return i[t] = n, i;
};
function Zc(e) {
  "@babel/helpers - typeof";
  return Zc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zc(e);
}
function tg() {
  return tg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, tg.apply(this, arguments);
}
function y$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function i8(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? y$(Object(n), !0).forEach(function(r) {
      si(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : y$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function BLe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function b$(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, SJ(r.key), r);
  }
}
function jLe(e, t, n) {
  return t && b$(e.prototype, t), n && b$(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function VLe(e, t, n) {
  return t = ng(t), qLe(e, CJ() ? Reflect.construct(t, n || [], ng(e).constructor) : t.apply(e, n));
}
function qLe(e, t) {
  if (t && (Zc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return zLe(e);
}
function zLe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function CJ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (CJ = function() {
    return !!e;
  })();
}
function ng(e) {
  return ng = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ng(e);
}
function WLe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && C9(e, t);
}
function C9(e, t) {
  return C9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, C9(e, t);
}
function si(e, t, n) {
  return t = SJ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function SJ(e) {
  var t = HLe(e, "string");
  return Zc(t) == "symbol" ? t : t + "";
}
function HLe(e, t) {
  if (Zc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Zc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var ULe = function(t) {
  var n = t.data, r = t.startIndex, i = t.endIndex, o = t.x, a = t.width, s = t.travellerWidth;
  if (!n || !n.length)
    return {};
  var l = n.length, u = jf().domain(eg(0, l)).range([o, o + a - s]), c = u.domain().map(function(f) {
    return u(f);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: u(r),
    endX: u(i),
    scale: u,
    scaleValues: c
  };
}, x$ = function(t) {
  return t.changedTouches && !!t.changedTouches.length;
}, Xc = /* @__PURE__ */ function(e) {
  function t(n) {
    var r;
    return BLe(this, t), r = VLe(this, t, [n]), si(r, "handleDrag", function(i) {
      r.leaveTimer && (clearTimeout(r.leaveTimer), r.leaveTimer = null), r.state.isTravellerMoving ? r.handleTravellerMove(i) : r.state.isSlideMoving && r.handleSlideDrag(i);
    }), si(r, "handleTouchMove", function(i) {
      i.changedTouches != null && i.changedTouches.length > 0 && r.handleDrag(i.changedTouches[0]);
    }), si(r, "handleDragEnd", function() {
      r.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var i = r.props, o = i.endIndex, a = i.onDragEnd, s = i.startIndex;
        a == null || a({
          endIndex: o,
          startIndex: s
        });
      }), r.detachDragEndListener();
    }), si(r, "handleLeaveWrapper", function() {
      (r.state.isTravellerMoving || r.state.isSlideMoving) && (r.leaveTimer = window.setTimeout(r.handleDragEnd, r.props.leaveTimeOut));
    }), si(r, "handleEnterSlideOrTraveller", function() {
      r.setState({
        isTextActive: !0
      });
    }), si(r, "handleLeaveSlideOrTraveller", function() {
      r.setState({
        isTextActive: !1
      });
    }), si(r, "handleSlideDragStart", function(i) {
      var o = x$(i) ? i.changedTouches[0] : i;
      r.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: o.pageX
      }), r.attachDragEndListener();
    }), r.travellerDragStartHandlers = {
      startX: r.handleTravellerDragStart.bind(r, "startX"),
      endX: r.handleTravellerDragStart.bind(r, "endX")
    }, r.state = {}, r;
  }
  return WLe(t, e), jLe(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(r) {
      var i = r.startX, o = r.endX, a = this.state.scaleValues, s = this.props, l = s.gap, u = s.data, c = u.length - 1, f = Math.min(i, o), h = Math.max(i, o), m = t.getIndexInRange(a, f), v = t.getIndexInRange(a, h);
      return {
        startIndex: m - m % l,
        endIndex: v === c ? c : v - v % l
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(r) {
      var i = this.props, o = i.data, a = i.tickFormatter, s = i.dataKey, l = Fi(o[r], s, r);
      return Ye(a) ? a(l, r) : l;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(r) {
      var i = this.state, o = i.slideMoveStartX, a = i.startX, s = i.endX, l = this.props, u = l.x, c = l.width, f = l.travellerWidth, h = l.startIndex, m = l.endIndex, v = l.onChange, g = r.pageX - o;
      g > 0 ? g = Math.min(g, u + c - f - s, u + c - f - a) : g < 0 && (g = Math.max(g, u - a, u - s));
      var y = this.getIndex({
        startX: a + g,
        endX: s + g
      });
      (y.startIndex !== h || y.endIndex !== m) && v && v(y), this.setState({
        startX: a + g,
        endX: s + g,
        slideMoveStartX: r.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(r, i) {
      var o = x$(i) ? i.changedTouches[0] : i;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: r,
        brushMoveStartX: o.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(r) {
      var i = this.state, o = i.brushMoveStartX, a = i.movingTravellerId, s = i.endX, l = i.startX, u = this.state[a], c = this.props, f = c.x, h = c.width, m = c.travellerWidth, v = c.onChange, g = c.gap, y = c.data, w = {
        startX: this.state.startX,
        endX: this.state.endX
      }, C = r.pageX - o;
      C > 0 ? C = Math.min(C, f + h - m - u) : C < 0 && (C = Math.max(C, f - u)), w[a] = u + C;
      var S = this.getIndex(w), N = S.startIndex, E = S.endIndex, A = function() {
        var T = y.length - 1;
        return a === "startX" && (s > l ? N % g === 0 : E % g === 0) || s < l && E === T || a === "endX" && (s > l ? E % g === 0 : N % g === 0) || s > l && E === T;
      };
      this.setState(si(si({}, a, u + C), "brushMoveStartX", r.pageX), function() {
        v && A() && v(S);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(r, i) {
      var o = this, a = this.state, s = a.scaleValues, l = a.startX, u = a.endX, c = this.state[i], f = s.indexOf(c);
      if (f !== -1) {
        var h = f + r;
        if (!(h === -1 || h >= s.length)) {
          var m = s[h];
          i === "startX" && m >= u || i === "endX" && m <= l || this.setState(si({}, i, m), function() {
            o.props.onChange(o.getIndex({
              startX: o.state.startX,
              endX: o.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var r = this.props, i = r.x, o = r.y, a = r.width, s = r.height, l = r.fill, u = r.stroke;
      return /* @__PURE__ */ F.createElement("rect", {
        stroke: u,
        fill: l,
        x: i,
        y: o,
        width: a,
        height: s
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var r = this.props, i = r.x, o = r.y, a = r.width, s = r.height, l = r.data, u = r.children, c = r.padding, f = Wr.only(u);
      return f ? /* @__PURE__ */ F.cloneElement(f, {
        x: i,
        y: o,
        width: a,
        height: s,
        margin: c,
        compact: !0,
        data: l
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(r, i) {
      var o, a, s = this, l = this.props, u = l.y, c = l.travellerWidth, f = l.height, h = l.traveller, m = l.ariaLabel, v = l.data, g = l.startIndex, y = l.endIndex, w = Math.max(r, this.props.x), C = i8(i8({}, qe(this.props, !1)), {}, {
        x: w,
        y: u,
        width: c,
        height: f
      }), S = m || "Min value: ".concat((o = v[g]) === null || o === void 0 ? void 0 : o.name, ", Max value: ").concat((a = v[y]) === null || a === void 0 ? void 0 : a.name);
      return /* @__PURE__ */ F.createElement(zt, {
        tabIndex: 0,
        role: "slider",
        "aria-label": S,
        "aria-valuenow": r,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[i],
        onTouchStart: this.travellerDragStartHandlers[i],
        onKeyDown: function(E) {
          ["ArrowLeft", "ArrowRight"].includes(E.key) && (E.preventDefault(), E.stopPropagation(), s.handleTravellerMoveKeyboard(E.key === "ArrowRight" ? 1 : -1, i));
        },
        onFocus: function() {
          s.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          s.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, t.renderTraveller(h, C));
    }
  }, {
    key: "renderSlide",
    value: function(r, i) {
      var o = this.props, a = o.y, s = o.height, l = o.stroke, u = o.travellerWidth, c = Math.min(r, i) + u, f = Math.max(Math.abs(i - r) - u, 0);
      return /* @__PURE__ */ F.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: l,
        fillOpacity: 0.2,
        x: c,
        y: a,
        width: f,
        height: s
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var r = this.props, i = r.startIndex, o = r.endIndex, a = r.y, s = r.height, l = r.travellerWidth, u = r.stroke, c = this.state, f = c.startX, h = c.endX, m = 5, v = {
        pointerEvents: "none",
        fill: u
      };
      return /* @__PURE__ */ F.createElement(zt, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ F.createElement(Vc, tg({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(f, h) - m,
        y: a + s / 2
      }, v), this.getTextOfTick(i)), /* @__PURE__ */ F.createElement(Vc, tg({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(f, h) + l + m,
        y: a + s / 2
      }, v), this.getTextOfTick(o)));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.data, o = r.className, a = r.children, s = r.x, l = r.y, u = r.width, c = r.height, f = r.alwaysShowText, h = this.state, m = h.startX, v = h.endX, g = h.isTextActive, y = h.isSlideMoving, w = h.isTravellerMoving, C = h.isTravellerFocused;
      if (!i || !i.length || !we(s) || !we(l) || !we(u) || !we(c) || u <= 0 || c <= 0)
        return null;
      var S = at("recharts-brush", o), N = F.Children.count(a) === 1, E = FLe("userSelect", "none");
      return /* @__PURE__ */ F.createElement(zt, {
        className: S,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: E
      }, this.renderBackground(), N && this.renderPanorama(), this.renderSlide(m, v), this.renderTravellerLayer(m, "startX"), this.renderTravellerLayer(v, "endX"), (g || y || w || C || f) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(r) {
      var i = r.x, o = r.y, a = r.width, s = r.height, l = r.stroke, u = Math.floor(o + s / 2) - 1;
      return /* @__PURE__ */ F.createElement(F.Fragment, null, /* @__PURE__ */ F.createElement("rect", {
        x: i,
        y: o,
        width: a,
        height: s,
        fill: l,
        stroke: "none"
      }), /* @__PURE__ */ F.createElement("line", {
        x1: i + 1,
        y1: u,
        x2: i + a - 1,
        y2: u,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ F.createElement("line", {
        x1: i + 1,
        y1: u + 2,
        x2: i + a - 1,
        y2: u + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(r, i) {
      var o;
      return /* @__PURE__ */ F.isValidElement(r) ? o = /* @__PURE__ */ F.cloneElement(r, i) : Ye(r) ? o = r(i) : o = t.renderDefaultTraveller(i), o;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      var o = r.data, a = r.width, s = r.x, l = r.travellerWidth, u = r.updateId, c = r.startIndex, f = r.endIndex;
      if (o !== i.prevData || u !== i.prevUpdateId)
        return i8({
          prevData: o,
          prevTravellerWidth: l,
          prevUpdateId: u,
          prevX: s,
          prevWidth: a
        }, o && o.length ? ULe({
          data: o,
          width: a,
          x: s,
          travellerWidth: l,
          startIndex: c,
          endIndex: f
        }) : {
          scale: null,
          scaleValues: null
        });
      if (i.scale && (a !== i.prevWidth || s !== i.prevX || l !== i.prevTravellerWidth)) {
        i.scale.range([s, s + a - l]);
        var h = i.scale.domain().map(function(m) {
          return i.scale(m);
        });
        return {
          prevData: o,
          prevTravellerWidth: l,
          prevUpdateId: u,
          prevX: s,
          prevWidth: a,
          startX: i.scale(r.startIndex),
          endX: i.scale(r.endIndex),
          scaleValues: h
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(r, i) {
      for (var o = r.length, a = 0, s = o - 1; s - a > 1; ) {
        var l = Math.floor((a + s) / 2);
        r[l] > i ? s = l : a = l;
      }
      return i >= r[s] ? s : a;
    }
  }]);
}(Yo);
si(Xc, "displayName", "Brush");
si(Xc, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var o8, w$;
function GLe() {
  if (w$) return o8;
  w$ = 1;
  var e = US();
  function t(n, r) {
    var i;
    return e(n, function(o, a, s) {
      return i = r(o, a, s), !i;
    }), !!i;
  }
  return o8 = t, o8;
}
var a8, C$;
function KLe() {
  if (C$) return a8;
  C$ = 1;
  var e = yZ(), t = na(), n = GLe(), r = ei(), i = av();
  function o(a, s, l) {
    var u = r(a) ? e : n;
    return l && i(a, s, l) && (s = void 0), u(a, t(s, 3));
  }
  return a8 = o, a8;
}
var YLe = KLe();
const ZLe = /* @__PURE__ */ Rt(YLe);
var Bo = function(t, n) {
  var r = t.alwaysShow, i = t.ifOverflow;
  return r && (i = "extendDomain"), i === n;
}, s8, S$;
function XLe() {
  if (S$) return s8;
  S$ = 1;
  var e = $Z();
  function t(n, r, i) {
    r == "__proto__" && e ? e(n, r, {
      configurable: !0,
      enumerable: !0,
      value: i,
      writable: !0
    }) : n[r] = i;
  }
  return s8 = t, s8;
}
var l8, _$;
function JLe() {
  if (_$) return l8;
  _$ = 1;
  var e = XLe(), t = DZ(), n = na();
  function r(i, o) {
    var a = {};
    return o = n(o, 3), t(i, function(s, l, u) {
      e(a, l, o(s, l, u));
    }), a;
  }
  return l8 = r, l8;
}
var QLe = JLe();
const eFe = /* @__PURE__ */ Rt(QLe);
var u8, E$;
function tFe() {
  if (E$) return u8;
  E$ = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length; ++r < i; )
      if (!n(t[r], r, t))
        return !1;
    return !0;
  }
  return u8 = e, u8;
}
var c8, N$;
function nFe() {
  if (N$) return c8;
  N$ = 1;
  var e = US();
  function t(n, r) {
    var i = !0;
    return e(n, function(o, a, s) {
      return i = !!r(o, a, s), i;
    }), i;
  }
  return c8 = t, c8;
}
var d8, A$;
function rFe() {
  if (A$) return d8;
  A$ = 1;
  var e = tFe(), t = nFe(), n = na(), r = ei(), i = av();
  function o(a, s, l) {
    var u = r(a) ? e : t;
    return l && i(a, s, l) && (s = void 0), u(a, n(s, 3));
  }
  return d8 = o, d8;
}
var iFe = rFe();
const _J = /* @__PURE__ */ Rt(iFe);
var oFe = ["x", "y"];
function Jc(e) {
  "@babel/helpers - typeof";
  return Jc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Jc(e);
}
function S9() {
  return S9 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, S9.apply(this, arguments);
}
function O$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function xf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? O$(Object(n), !0).forEach(function(r) {
      aFe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : O$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function aFe(e, t, n) {
  return t = sFe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function sFe(e) {
  var t = lFe(e, "string");
  return Jc(t) == "symbol" ? t : t + "";
}
function lFe(e, t) {
  if (Jc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Jc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function uFe(e, t) {
  if (e == null) return {};
  var n = cFe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function cFe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function dFe(e, t) {
  var n = e.x, r = e.y, i = uFe(e, oFe), o = "".concat(n), a = parseInt(o, 10), s = "".concat(r), l = parseInt(s, 10), u = "".concat(t.height || i.height), c = parseInt(u, 10), f = "".concat(t.width || i.width), h = parseInt(f, 10);
  return xf(xf(xf(xf(xf({}, t), i), a ? {
    x: a
  } : {}), l ? {
    y: l
  } : {}), {}, {
    height: c,
    width: h,
    name: t.name,
    radius: t.radius
  });
}
function k$(e) {
  return /* @__PURE__ */ F.createElement(uLe, S9({
    shapeType: "rectangle",
    propTransformer: dFe,
    activeClassName: "recharts-active-bar"
  }, e));
}
var fFe = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(r, i) {
    if (typeof t == "number") return t;
    var o = typeof r == "number";
    return o ? t(r, i) : (o || (process.env.NODE_ENV !== "production" ? zr(!1, "minPointSize callback function received a value with type of ".concat(Jc(r), ". Currently only numbers are supported.")) : zr()), n);
  };
}, hFe = ["value", "background"], EJ;
function Qc(e) {
  "@babel/helpers - typeof";
  return Qc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Qc(e);
}
function pFe(e, t) {
  if (e == null) return {};
  var n = mFe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function mFe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function rg() {
  return rg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, rg.apply(this, arguments);
}
function P$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function vn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? P$(Object(n), !0).forEach(function(r) {
      Os(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : P$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function gFe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function T$(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, AJ(r.key), r);
  }
}
function vFe(e, t, n) {
  return t && T$(e.prototype, t), n && T$(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function yFe(e, t, n) {
  return t = ig(t), bFe(e, NJ() ? Reflect.construct(t, n || [], ig(e).constructor) : t.apply(e, n));
}
function bFe(e, t) {
  if (t && (Qc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return xFe(e);
}
function xFe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function NJ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (NJ = function() {
    return !!e;
  })();
}
function ig(e) {
  return ig = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ig(e);
}
function wFe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && _9(e, t);
}
function _9(e, t) {
  return _9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, _9(e, t);
}
function Os(e, t, n) {
  return t = AJ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function AJ(e) {
  var t = CFe(e, "string");
  return Qc(t) == "symbol" ? t : t + "";
}
function CFe(e, t) {
  if (Qc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Qc(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var bt = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    gFe(this, t);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return n = yFe(this, t, [].concat(i)), Os(n, "state", {
      isAnimationFinished: !1
    }), Os(n, "id", Q2("recharts-bar-")), Os(n, "handleAnimationEnd", function() {
      var a = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), a && a();
    }), Os(n, "handleAnimationStart", function() {
      var a = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), a && a();
    }), n;
  }
  return wFe(t, e), vFe(t, [{
    key: "renderRectanglesStatically",
    value: function(r) {
      var i = this, o = this.props, a = o.shape, s = o.dataKey, l = o.activeIndex, u = o.activeBar, c = qe(this.props, !1);
      return r && r.map(function(f, h) {
        var m = h === l, v = m ? u : a, g = vn(vn(vn({}, c), f), {}, {
          isActive: m,
          option: v,
          index: h,
          dataKey: s,
          onAnimationStart: i.handleAnimationStart,
          onAnimationEnd: i.handleAnimationEnd
        });
        return /* @__PURE__ */ F.createElement(zt, rg({
          className: "recharts-bar-rectangle"
        }, Ic(i.props, f, h), {
          key: "rectangle-".concat(f == null ? void 0 : f.x, "-").concat(f == null ? void 0 : f.y, "-").concat(f == null ? void 0 : f.value)
        }), /* @__PURE__ */ F.createElement(k$, g));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var r = this, i = this.props, o = i.data, a = i.layout, s = i.isAnimationActive, l = i.animationBegin, u = i.animationDuration, c = i.animationEasing, f = i.animationId, h = this.state.prevData;
      return /* @__PURE__ */ F.createElement(za, {
        begin: l,
        duration: u,
        isActive: s,
        easing: c,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(f),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(m) {
        var v = m.t, g = o.map(function(y, w) {
          var C = h && h[w];
          if (C) {
            var S = ko(C.x, y.x), N = ko(C.y, y.y), E = ko(C.width, y.width), A = ko(C.height, y.height);
            return vn(vn({}, y), {}, {
              x: S(v),
              y: N(v),
              width: E(v),
              height: A(v)
            });
          }
          if (a === "horizontal") {
            var O = ko(0, y.height), T = O(v);
            return vn(vn({}, y), {}, {
              y: y.y + y.height - T,
              height: T
            });
          }
          var M = ko(0, y.width), L = M(v);
          return vn(vn({}, y), {}, {
            width: L
          });
        });
        return /* @__PURE__ */ F.createElement(zt, null, r.renderRectanglesStatically(g));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var r = this.props, i = r.data, o = r.isAnimationActive, a = this.state.prevData;
      return o && i && i.length && (!a || !gv(a, i)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(i);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var r = this, i = this.props, o = i.data, a = i.dataKey, s = i.activeIndex, l = qe(this.props.background, !1);
      return o.map(function(u, c) {
        u.value;
        var f = u.background, h = pFe(u, hFe);
        if (!f)
          return null;
        var m = vn(vn(vn(vn(vn({}, h), {}, {
          fill: "#eee"
        }, f), l), Ic(r.props, u, c)), {}, {
          onAnimationStart: r.handleAnimationStart,
          onAnimationEnd: r.handleAnimationEnd,
          dataKey: a,
          index: c,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ F.createElement(k$, rg({
          key: "background-bar-".concat(c),
          option: r.props.background,
          isActive: c === s
        }, m));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(r, i) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var o = this.props, a = o.data, s = o.xAxis, l = o.yAxis, u = o.layout, c = o.children, f = oo(c, bv);
      if (!f)
        return null;
      var h = u === "vertical" ? a[0].height / 2 : a[0].width / 2, m = function(y, w) {
        var C = Array.isArray(y.value) ? y.value[1] : y.value;
        return {
          x: y.x,
          y: y.y,
          value: C,
          errorVal: Fi(y, w)
        };
      }, v = {
        clipPath: r ? "url(#clipPath-".concat(i, ")") : null
      };
      return /* @__PURE__ */ F.createElement(zt, v, f.map(function(g) {
        return /* @__PURE__ */ F.cloneElement(g, {
          key: "error-bar-".concat(i, "-").concat(g.props.dataKey),
          data: a,
          xAxis: s,
          yAxis: l,
          layout: u,
          offset: h,
          dataPointFormatter: m
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.hide, o = r.data, a = r.className, s = r.xAxis, l = r.yAxis, u = r.left, c = r.top, f = r.width, h = r.height, m = r.isAnimationActive, v = r.background, g = r.id;
      if (i || !o || !o.length)
        return null;
      var y = this.state.isAnimationFinished, w = at("recharts-bar", a), C = s && s.allowDataOverflow, S = l && l.allowDataOverflow, N = C || S, E = yt(g) ? this.id : g;
      return /* @__PURE__ */ F.createElement(zt, {
        className: w
      }, C || S ? /* @__PURE__ */ F.createElement("defs", null, /* @__PURE__ */ F.createElement("clipPath", {
        id: "clipPath-".concat(E)
      }, /* @__PURE__ */ F.createElement("rect", {
        x: C ? u : u - f / 2,
        y: S ? c : c - h / 2,
        width: C ? f : f * 2,
        height: S ? h : h * 2
      }))) : null, /* @__PURE__ */ F.createElement(zt, {
        className: "recharts-bar-rectangles",
        clipPath: N ? "url(#clipPath-".concat(E, ")") : null
      }, v ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(N, E), (!m || y) && Is.renderCallByParent(this.props, o));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return r.animationId !== i.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curData: r.data,
        prevData: i.curData
      } : r.data !== i.curData ? {
        curData: r.data
      } : null;
    }
  }]);
}(Yo);
EJ = bt;
Os(bt, "displayName", "Bar");
Os(bt, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !Rd.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
Os(bt, "getComposedData", function(e) {
  var t = e.props, n = e.item, r = e.barPosition, i = e.bandSize, o = e.xAxis, a = e.yAxis, s = e.xAxisTicks, l = e.yAxisTicks, u = e.stackedData, c = e.dataStartIndex, f = e.displayedData, h = e.offset, m = IMe(r, n);
  if (!m)
    return null;
  var v = t.layout, g = n.type.defaultProps, y = g !== void 0 ? vn(vn({}, g), n.props) : n.props, w = y.dataKey, C = y.children, S = y.minPointSize, N = v === "horizontal" ? a : o, E = u ? N.scale.domain() : null, A = qMe({
    numericAxis: N
  }), O = oo(C, zZ), T = f.map(function(M, L) {
    var I, j, B, q, G, U;
    u ? I = $Me(u[c + L], E) : (I = Fi(M, w), Array.isArray(I) || (I = [A, I]));
    var V = fFe(S, EJ.defaultProps.minPointSize)(I[1], L);
    if (v === "horizontal") {
      var H, Z = [a.scale(I[0]), a.scale(I[1])], de = Z[0], ne = Z[1];
      j = nI({
        axis: o,
        ticks: s,
        bandSize: i,
        offset: m.offset,
        entry: M,
        index: L
      }), B = (H = ne ?? de) !== null && H !== void 0 ? H : void 0, q = m.size;
      var Y = de - ne;
      if (G = Number.isNaN(Y) ? 0 : Y, U = {
        x: j,
        y: a.y,
        width: q,
        height: a.height
      }, Math.abs(V) > 0 && Math.abs(G) < Math.abs(V)) {
        var le = no(G || V) * (Math.abs(V) - Math.abs(G));
        B -= le, G += le;
      }
    } else {
      var be = [o.scale(I[0]), o.scale(I[1])], pe = be[0], Ee = be[1];
      if (j = pe, B = nI({
        axis: a,
        ticks: l,
        bandSize: i,
        offset: m.offset,
        entry: M,
        index: L
      }), q = Ee - pe, G = m.size, U = {
        x: o.x,
        y: B,
        width: o.width,
        height: G
      }, Math.abs(V) > 0 && Math.abs(q) < Math.abs(V)) {
        var ge = no(q || V) * (Math.abs(V) - Math.abs(q));
        q += ge;
      }
    }
    return vn(vn(vn({}, M), {}, {
      x: j,
      y: B,
      width: q,
      height: G,
      value: u ? I : I[1],
      payload: M,
      background: U
    }, O && O[L] && O[L].props), {}, {
      tooltipPayload: [QX(n, M)],
      tooltipPosition: {
        x: j + q / 2,
        y: B + G / 2
      }
    });
  });
  return vn({
    data: T,
    layout: v
  }, h);
});
function Fh(e) {
  "@babel/helpers - typeof";
  return Fh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Fh(e);
}
function SFe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function M$(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, OJ(r.key), r);
  }
}
function _Fe(e, t, n) {
  return t && M$(e.prototype, t), n && M$(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function R$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ji(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? R$(Object(n), !0).forEach(function(r) {
      Nv(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : R$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Nv(e, t, n) {
  return t = OJ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function OJ(e) {
  var t = EFe(e, "string");
  return Fh(t) == "symbol" ? t : t + "";
}
function EFe(e, t) {
  if (Fh(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Fh(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var NFe = function(t, n, r, i, o) {
  var a = t.width, s = t.height, l = t.layout, u = t.children, c = Object.keys(n), f = {
    left: r.left,
    leftMirror: r.left,
    right: a - r.right,
    rightMirror: a - r.right,
    top: r.top,
    topMirror: r.top,
    bottom: s - r.bottom,
    bottomMirror: s - r.bottom
  }, h = !!li(u, bt);
  return c.reduce(function(m, v) {
    var g = n[v], y = g.orientation, w = g.domain, C = g.padding, S = C === void 0 ? {} : C, N = g.mirror, E = g.reversed, A = "".concat(y).concat(N ? "Mirror" : ""), O, T, M, L, I;
    if (g.type === "number" && (g.padding === "gap" || g.padding === "no-gap")) {
      var j = w[1] - w[0], B = 1 / 0, q = g.categoricalDomain.sort();
      if (q.forEach(function(be, pe) {
        pe > 0 && (B = Math.min((be || 0) - (q[pe - 1] || 0), B));
      }), Number.isFinite(B)) {
        var G = B / j, U = g.layout === "vertical" ? r.height : r.width;
        if (g.padding === "gap" && (O = G * U / 2), g.padding === "no-gap") {
          var V = ro(t.barCategoryGap, G * U), H = G * U / 2;
          O = H - V - (H - V) / U * V;
        }
      }
    }
    i === "xAxis" ? T = [r.left + (S.left || 0) + (O || 0), r.left + r.width - (S.right || 0) - (O || 0)] : i === "yAxis" ? T = l === "horizontal" ? [r.top + r.height - (S.bottom || 0), r.top + (S.top || 0)] : [r.top + (S.top || 0) + (O || 0), r.top + r.height - (S.bottom || 0) - (O || 0)] : T = g.range, E && (T = [T[1], T[0]]);
    var Z = YX(g, o, h), de = Z.scale, ne = Z.realScaleType;
    de.domain(w).range(T), ZX(de);
    var Y = XX(de, Ji(Ji({}, g), {}, {
      realScaleType: ne
    }));
    i === "xAxis" ? (I = y === "top" && !N || y === "bottom" && N, M = r.left, L = f[A] - I * g.height) : i === "yAxis" && (I = y === "left" && !N || y === "right" && N, M = f[A] - I * g.width, L = r.top);
    var le = Ji(Ji(Ji({}, g), Y), {}, {
      realScaleType: ne,
      x: M,
      y: L,
      scale: de,
      width: i === "xAxis" ? r.width : g.width,
      height: i === "yAxis" ? r.height : g.height
    });
    return le.bandSize = jm(le, Y), !g.hide && i === "xAxis" ? f[A] += (I ? -1 : 1) * le.height : g.hide || (f[A] += (I ? -1 : 1) * le.width), Ji(Ji({}, m), {}, Nv({}, v, le));
  }, {});
}, kJ = function(t, n) {
  var r = t.x, i = t.y, o = n.x, a = n.y;
  return {
    x: Math.min(r, o),
    y: Math.min(i, a),
    width: Math.abs(o - r),
    height: Math.abs(a - i)
  };
}, AFe = function(t) {
  var n = t.x1, r = t.y1, i = t.x2, o = t.y2;
  return kJ({
    x: n,
    y: r
  }, {
    x: i,
    y: o
  });
}, PJ = /* @__PURE__ */ function() {
  function e(t) {
    SFe(this, e), this.scale = t;
  }
  return _Fe(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = r.bandAware, o = r.position;
      if (n !== void 0) {
        if (o)
          switch (o) {
            case "start":
              return this.scale(n);
            case "middle": {
              var a = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(n) + a;
            }
            case "end": {
              var s = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(n) + s;
            }
            default:
              return this.scale(n);
          }
        if (i) {
          var l = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(n) + l;
        }
        return this.scale(n);
      }
    }
  }, {
    key: "isInRange",
    value: function(n) {
      var r = this.range(), i = r[0], o = r[r.length - 1];
      return i <= o ? n >= i && n <= o : n >= o && n <= i;
    }
  }], [{
    key: "create",
    value: function(n) {
      return new e(n);
    }
  }]);
}();
Nv(PJ, "EPS", 1e-4);
var C_ = function(t) {
  var n = Object.keys(t).reduce(function(r, i) {
    return Ji(Ji({}, r), {}, Nv({}, i, PJ.create(t[i])));
  }, {});
  return Ji(Ji({}, n), {}, {
    apply: function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = o.bandAware, s = o.position;
      return eFe(i, function(l, u) {
        return n[u].apply(l, {
          bandAware: a,
          position: s
        });
      });
    },
    isInRange: function(i) {
      return _J(i, function(o, a) {
        return n[a].isInRange(o);
      });
    }
  });
};
function OFe(e) {
  return (e % 180 + 180) % 180;
}
var kFe = function(t) {
  var n = t.width, r = t.height, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o = OFe(i), a = o * Math.PI / 180, s = Math.atan(r / n), l = a > s && a < Math.PI - s ? r / Math.sin(a) : n / Math.cos(a);
  return Math.abs(l);
}, f8, D$;
function PFe() {
  if (D$) return f8;
  D$ = 1;
  var e = na(), t = Tp(), n = iv();
  function r(i) {
    return function(o, a, s) {
      var l = Object(o);
      if (!t(o)) {
        var u = e(a, 3);
        o = n(o), a = function(f) {
          return u(l[f], f, l);
        };
      }
      var c = i(o, a, s);
      return c > -1 ? l[u ? o[c] : c] : void 0;
    };
  }
  return f8 = r, f8;
}
var h8, I$;
function TFe() {
  if (I$) return h8;
  I$ = 1;
  var e = xJ();
  function t(n) {
    var r = e(n), i = r % 1;
    return r === r ? i ? r - i : r : 0;
  }
  return h8 = t, h8;
}
var p8, $$;
function MFe() {
  if ($$) return p8;
  $$ = 1;
  var e = kZ(), t = na(), n = TFe(), r = Math.max;
  function i(o, a, s) {
    var l = o == null ? 0 : o.length;
    if (!l)
      return -1;
    var u = s == null ? 0 : n(s);
    return u < 0 && (u = r(l + u, 0)), e(o, t(a, 3), u);
  }
  return p8 = i, p8;
}
var m8, L$;
function RFe() {
  if (L$) return m8;
  L$ = 1;
  var e = PFe(), t = MFe(), n = e(t);
  return m8 = n, m8;
}
var DFe = RFe();
const IFe = /* @__PURE__ */ Rt(DFe);
var $Fe = HY();
const LFe = /* @__PURE__ */ Rt($Fe);
var FFe = LFe(function(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width,
    height: e.height
  };
}, function(e) {
  return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
});
function og(e) {
  "@babel/helpers - typeof";
  return og = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, og(e);
}
var S_ = /* @__PURE__ */ Qt(void 0), __ = /* @__PURE__ */ Qt(void 0), TJ = /* @__PURE__ */ Qt(void 0), MJ = /* @__PURE__ */ Qt({}), RJ = /* @__PURE__ */ Qt(void 0), DJ = /* @__PURE__ */ Qt(0), IJ = /* @__PURE__ */ Qt(0), F$ = function(t) {
  var n = t.state, r = n.xAxisMap, i = n.yAxisMap, o = n.offset, a = t.clipPathId, s = t.children, l = t.width, u = t.height, c = FFe(o);
  return /* @__PURE__ */ F.createElement(S_.Provider, {
    value: r
  }, /* @__PURE__ */ F.createElement(__.Provider, {
    value: i
  }, /* @__PURE__ */ F.createElement(MJ.Provider, {
    value: o
  }, /* @__PURE__ */ F.createElement(TJ.Provider, {
    value: c
  }, /* @__PURE__ */ F.createElement(RJ.Provider, {
    value: a
  }, /* @__PURE__ */ F.createElement(DJ.Provider, {
    value: u
  }, /* @__PURE__ */ F.createElement(IJ.Provider, {
    value: l
  }, s)))))));
}, BFe = function() {
  return en(RJ);
};
function $J(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
}
var LJ = function(t) {
  var n = en(S_);
  n == null && (process.env.NODE_ENV !== "production" ? zr(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : zr());
  var r = n[t];
  return r == null && (process.env.NODE_ENV !== "production" ? zr(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(og(t), "]. ").concat($J(n))) : zr()), r;
}, jFe = function() {
  var t = en(S_);
  return Cs(t);
}, VFe = function() {
  var t = en(__), n = IFe(t, function(r) {
    return _J(r.domain, Number.isFinite);
  });
  return n || Cs(t);
}, FJ = function(t) {
  var n = en(__);
  n == null && (process.env.NODE_ENV !== "production" ? zr(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : zr());
  var r = n[t];
  return r == null && (process.env.NODE_ENV !== "production" ? zr(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(og(t), "]. ").concat($J(n))) : zr()), r;
}, qFe = function() {
  var t = en(TJ);
  return t;
}, zFe = function() {
  return en(MJ);
}, E_ = function() {
  return en(IJ);
}, N_ = function() {
  return en(DJ);
};
function ed(e) {
  "@babel/helpers - typeof";
  return ed = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ed(e);
}
function WFe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function HFe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, jJ(r.key), r);
  }
}
function UFe(e, t, n) {
  return t && HFe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function GFe(e, t, n) {
  return t = ag(t), KFe(e, BJ() ? Reflect.construct(t, n || [], ag(e).constructor) : t.apply(e, n));
}
function KFe(e, t) {
  if (t && (ed(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return YFe(e);
}
function YFe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function BJ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (BJ = function() {
    return !!e;
  })();
}
function ag(e) {
  return ag = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ag(e);
}
function ZFe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && E9(e, t);
}
function E9(e, t) {
  return E9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, E9(e, t);
}
function B$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function j$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? B$(Object(n), !0).forEach(function(r) {
      A_(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : B$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function A_(e, t, n) {
  return t = jJ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function jJ(e) {
  var t = XFe(e, "string");
  return ed(t) == "symbol" ? t : t + "";
}
function XFe(e, t) {
  if (ed(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ed(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function JFe(e, t) {
  return nBe(e) || tBe(e, t) || eBe(e, t) || QFe();
}
function QFe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function eBe(e, t) {
  if (e) {
    if (typeof e == "string") return V$(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return V$(e, t);
  }
}
function V$(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function tBe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, u = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (c) {
      u = !0, i = c;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw i;
      }
    }
    return s;
  }
}
function nBe(e) {
  if (Array.isArray(e)) return e;
}
function N9() {
  return N9 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, N9.apply(this, arguments);
}
var rBe = function(t, n) {
  var r;
  return /* @__PURE__ */ F.isValidElement(t) ? r = /* @__PURE__ */ F.cloneElement(t, n) : Ye(t) ? r = t(n) : r = /* @__PURE__ */ F.createElement("line", N9({}, n, {
    className: "recharts-reference-line-line"
  })), r;
}, iBe = function(t, n, r, i, o, a, s, l, u) {
  var c = o.x, f = o.y, h = o.width, m = o.height;
  if (r) {
    var v = u.y, g = t.y.apply(v, {
      position: a
    });
    if (Bo(u, "discard") && !t.y.isInRange(g))
      return null;
    var y = [{
      x: c + h,
      y: g
    }, {
      x: c,
      y: g
    }];
    return l === "left" ? y.reverse() : y;
  }
  if (n) {
    var w = u.x, C = t.x.apply(w, {
      position: a
    });
    if (Bo(u, "discard") && !t.x.isInRange(C))
      return null;
    var S = [{
      x: C,
      y: f + m
    }, {
      x: C,
      y: f
    }];
    return s === "top" ? S.reverse() : S;
  }
  if (i) {
    var N = u.segment, E = N.map(function(A) {
      return t.apply(A, {
        position: a
      });
    });
    return Bo(u, "discard") && ZLe(E, function(A) {
      return !t.isInRange(A);
    }) ? null : E;
  }
  return null;
};
function oBe(e) {
  var t = e.x, n = e.y, r = e.segment, i = e.xAxisId, o = e.yAxisId, a = e.shape, s = e.className, l = e.alwaysShow, u = BFe(), c = LJ(i), f = FJ(o), h = qFe();
  if (!u || !h)
    return null;
  Ma(l === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var m = C_({
    x: c.scale,
    y: f.scale
  }), v = Dn(t), g = Dn(n), y = r && r.length === 2, w = iBe(m, v, g, y, h, e.position, c.orientation, f.orientation, e);
  if (!w)
    return null;
  var C = JFe(w, 2), S = C[0], N = S.x, E = S.y, A = C[1], O = A.x, T = A.y, M = Bo(e, "hidden") ? "url(#".concat(u, ")") : void 0, L = j$(j$({
    clipPath: M
  }, qe(e, !0)), {}, {
    x1: N,
    y1: E,
    x2: O,
    y2: T
  });
  return /* @__PURE__ */ F.createElement(zt, {
    className: at("recharts-reference-line", s)
  }, rBe(a, L), er.renderCallByParent(e, AFe({
    x1: N,
    y1: E,
    x2: O,
    y2: T
  })));
}
var O_ = /* @__PURE__ */ function(e) {
  function t() {
    return WFe(this, t), GFe(this, t, arguments);
  }
  return ZFe(t, e), UFe(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ F.createElement(oBe, this.props);
    }
  }]);
}(F.Component);
A_(O_, "displayName", "ReferenceLine");
A_(O_, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function A9() {
  return A9 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, A9.apply(this, arguments);
}
function td(e) {
  "@babel/helpers - typeof";
  return td = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, td(e);
}
function q$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function z$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? q$(Object(n), !0).forEach(function(r) {
      Av(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : q$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function aBe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function sBe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, qJ(r.key), r);
  }
}
function lBe(e, t, n) {
  return t && sBe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function uBe(e, t, n) {
  return t = sg(t), cBe(e, VJ() ? Reflect.construct(t, n || [], sg(e).constructor) : t.apply(e, n));
}
function cBe(e, t) {
  if (t && (td(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return dBe(e);
}
function dBe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function VJ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (VJ = function() {
    return !!e;
  })();
}
function sg(e) {
  return sg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, sg(e);
}
function fBe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && O9(e, t);
}
function O9(e, t) {
  return O9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, O9(e, t);
}
function Av(e, t, n) {
  return t = qJ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function qJ(e) {
  var t = hBe(e, "string");
  return td(t) == "symbol" ? t : t + "";
}
function hBe(e, t) {
  if (td(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (td(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var pBe = function(t) {
  var n = t.x, r = t.y, i = t.xAxis, o = t.yAxis, a = C_({
    x: i.scale,
    y: o.scale
  }), s = a.apply({
    x: n,
    y: r
  }, {
    bandAware: !0
  });
  return Bo(t, "discard") && !a.isInRange(s) ? null : s;
}, Ov = /* @__PURE__ */ function(e) {
  function t() {
    return aBe(this, t), uBe(this, t, arguments);
  }
  return fBe(t, e), lBe(t, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.x, o = r.y, a = r.r, s = r.alwaysShow, l = r.clipPathId, u = Dn(i), c = Dn(o);
      if (Ma(s === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !u || !c)
        return null;
      var f = pBe(this.props);
      if (!f)
        return null;
      var h = f.x, m = f.y, v = this.props, g = v.shape, y = v.className, w = Bo(this.props, "hidden") ? "url(#".concat(l, ")") : void 0, C = z$(z$({
        clipPath: w
      }, qe(this.props, !0)), {}, {
        cx: h,
        cy: m
      });
      return /* @__PURE__ */ F.createElement(zt, {
        className: at("recharts-reference-dot", y)
      }, t.renderDot(g, C), er.renderCallByParent(this.props, {
        x: h - a,
        y: m - a,
        width: 2 * a,
        height: 2 * a
      }));
    }
  }]);
}(F.Component);
Av(Ov, "displayName", "ReferenceDot");
Av(Ov, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
Av(Ov, "renderDot", function(e, t) {
  var n;
  return /* @__PURE__ */ F.isValidElement(e) ? n = /* @__PURE__ */ F.cloneElement(e, t) : Ye(e) ? n = e(t) : n = /* @__PURE__ */ F.createElement(xv, A9({}, t, {
    cx: t.cx,
    cy: t.cy,
    className: "recharts-reference-dot-dot"
  })), n;
});
function k9() {
  return k9 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, k9.apply(this, arguments);
}
function nd(e) {
  "@babel/helpers - typeof";
  return nd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, nd(e);
}
function W$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function H$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? W$(Object(n), !0).forEach(function(r) {
      kv(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : W$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function mBe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function gBe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, WJ(r.key), r);
  }
}
function vBe(e, t, n) {
  return t && gBe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function yBe(e, t, n) {
  return t = lg(t), bBe(e, zJ() ? Reflect.construct(t, n || [], lg(e).constructor) : t.apply(e, n));
}
function bBe(e, t) {
  if (t && (nd(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return xBe(e);
}
function xBe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function zJ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (zJ = function() {
    return !!e;
  })();
}
function lg(e) {
  return lg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, lg(e);
}
function wBe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && P9(e, t);
}
function P9(e, t) {
  return P9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, P9(e, t);
}
function kv(e, t, n) {
  return t = WJ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function WJ(e) {
  var t = CBe(e, "string");
  return nd(t) == "symbol" ? t : t + "";
}
function CBe(e, t) {
  if (nd(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (nd(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var SBe = function(t, n, r, i, o) {
  var a = o.x1, s = o.x2, l = o.y1, u = o.y2, c = o.xAxis, f = o.yAxis;
  if (!c || !f) return null;
  var h = C_({
    x: c.scale,
    y: f.scale
  }), m = {
    x: t ? h.x.apply(a, {
      position: "start"
    }) : h.x.rangeMin,
    y: r ? h.y.apply(l, {
      position: "start"
    }) : h.y.rangeMin
  }, v = {
    x: n ? h.x.apply(s, {
      position: "end"
    }) : h.x.rangeMax,
    y: i ? h.y.apply(u, {
      position: "end"
    }) : h.y.rangeMax
  };
  return Bo(o, "discard") && (!h.isInRange(m) || !h.isInRange(v)) ? null : kJ(m, v);
}, Pv = /* @__PURE__ */ function(e) {
  function t() {
    return mBe(this, t), yBe(this, t, arguments);
  }
  return wBe(t, e), vBe(t, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.x1, o = r.x2, a = r.y1, s = r.y2, l = r.className, u = r.alwaysShow, c = r.clipPathId;
      Ma(u === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var f = Dn(i), h = Dn(o), m = Dn(a), v = Dn(s), g = this.props.shape;
      if (!f && !h && !m && !v && !g)
        return null;
      var y = SBe(f, h, m, v, this.props);
      if (!y && !g)
        return null;
      var w = Bo(this.props, "hidden") ? "url(#".concat(c, ")") : void 0;
      return /* @__PURE__ */ F.createElement(zt, {
        className: at("recharts-reference-area", l)
      }, t.renderRect(g, H$(H$({
        clipPath: w
      }, qe(this.props, !0)), y)), er.renderCallByParent(this.props, y));
    }
  }]);
}(F.Component);
kv(Pv, "displayName", "ReferenceArea");
kv(Pv, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
kv(Pv, "renderRect", function(e, t) {
  var n;
  return /* @__PURE__ */ F.isValidElement(e) ? n = /* @__PURE__ */ F.cloneElement(e, t) : Ye(e) ? n = e(t) : n = /* @__PURE__ */ F.createElement(x_, k9({}, t, {
    className: "recharts-reference-area-rect"
  })), n;
});
function HJ(e, t, n) {
  if (t < 1)
    return [];
  if (t === 1 && n === void 0)
    return e;
  for (var r = [], i = 0; i < e.length; i += t)
    r.push(e[i]);
  return r;
}
function _Be(e, t, n) {
  var r = {
    width: e.width + t.width,
    height: e.height + t.height
  };
  return kFe(r, n);
}
function EBe(e, t, n) {
  var r = n === "width", i = e.x, o = e.y, a = e.width, s = e.height;
  return t === 1 ? {
    start: r ? i : o,
    end: r ? i + a : o + s
  } : {
    start: r ? i + a : o + s,
    end: r ? i : o
  };
}
function ug(e, t, n, r, i) {
  if (e * t < e * r || e * t > e * i)
    return !1;
  var o = n();
  return e * (t - e * o / 2 - r) >= 0 && e * (t + e * o / 2 - i) <= 0;
}
function NBe(e, t) {
  return HJ(e, t + 1);
}
function ABe(e, t, n, r, i) {
  for (var o = (r || []).slice(), a = t.start, s = t.end, l = 0, u = 1, c = a, f = function() {
    var v = r == null ? void 0 : r[l];
    if (v === void 0)
      return {
        v: HJ(r, u)
      };
    var g = l, y, w = function() {
      return y === void 0 && (y = n(v, g)), y;
    }, C = v.coordinate, S = l === 0 || ug(e, C, w, c, s);
    S || (l = 0, c = a, u += 1), S && (c = C + e * (w() / 2 + i), l += u);
  }, h; u <= o.length; )
    if (h = f(), h) return h.v;
  return [];
}
function Bh(e) {
  "@babel/helpers - typeof";
  return Bh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bh(e);
}
function U$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? U$(Object(n), !0).forEach(function(r) {
      OBe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : U$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function OBe(e, t, n) {
  return t = kBe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function kBe(e) {
  var t = PBe(e, "string");
  return Bh(t) == "symbol" ? t : t + "";
}
function PBe(e, t) {
  if (Bh(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Bh(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function TBe(e, t, n, r, i) {
  for (var o = (r || []).slice(), a = o.length, s = t.start, l = t.end, u = function(h) {
    var m = o[h], v, g = function() {
      return v === void 0 && (v = n(m, h)), v;
    };
    if (h === a - 1) {
      var y = e * (m.coordinate + e * g() / 2 - l);
      o[h] = m = fr(fr({}, m), {}, {
        tickCoord: y > 0 ? m.coordinate - y * e : m.coordinate
      });
    } else
      o[h] = m = fr(fr({}, m), {}, {
        tickCoord: m.coordinate
      });
    var w = ug(e, m.tickCoord, g, s, l);
    w && (l = m.tickCoord - e * (g() / 2 + i), o[h] = fr(fr({}, m), {}, {
      isShow: !0
    }));
  }, c = a - 1; c >= 0; c--)
    u(c);
  return o;
}
function MBe(e, t, n, r, i, o) {
  var a = (r || []).slice(), s = a.length, l = t.start, u = t.end;
  if (o) {
    var c = r[s - 1], f = n(c, s - 1), h = e * (c.coordinate + e * f / 2 - u);
    a[s - 1] = c = fr(fr({}, c), {}, {
      tickCoord: h > 0 ? c.coordinate - h * e : c.coordinate
    });
    var m = ug(e, c.tickCoord, function() {
      return f;
    }, l, u);
    m && (u = c.tickCoord - e * (f / 2 + i), a[s - 1] = fr(fr({}, c), {}, {
      isShow: !0
    }));
  }
  for (var v = o ? s - 1 : s, g = function(C) {
    var S = a[C], N, E = function() {
      return N === void 0 && (N = n(S, C)), N;
    };
    if (C === 0) {
      var A = e * (S.coordinate - e * E() / 2 - l);
      a[C] = S = fr(fr({}, S), {}, {
        tickCoord: A < 0 ? S.coordinate - A * e : S.coordinate
      });
    } else
      a[C] = S = fr(fr({}, S), {}, {
        tickCoord: S.coordinate
      });
    var O = ug(e, S.tickCoord, E, l, u);
    O && (l = S.tickCoord + e * (E() / 2 + i), a[C] = fr(fr({}, S), {}, {
      isShow: !0
    }));
  }, y = 0; y < v; y++)
    g(y);
  return a;
}
function k_(e, t, n) {
  var r = e.tick, i = e.ticks, o = e.viewBox, a = e.minTickGap, s = e.orientation, l = e.interval, u = e.tickFormatter, c = e.unit, f = e.angle;
  if (!i || !i.length || !r)
    return [];
  if (we(l) || Rd.isSsr)
    return NBe(i, typeof l == "number" && we(l) ? l : 0);
  var h = [], m = s === "top" || s === "bottom" ? "width" : "height", v = c && m === "width" ? Bf(c, {
    fontSize: t,
    letterSpacing: n
  }) : {
    width: 0,
    height: 0
  }, g = function(S, N) {
    var E = Ye(u) ? u(S.value, N) : S.value;
    return m === "width" ? _Be(Bf(E, {
      fontSize: t,
      letterSpacing: n
    }), v, f) : Bf(E, {
      fontSize: t,
      letterSpacing: n
    })[m];
  }, y = i.length >= 2 ? no(i[1].coordinate - i[0].coordinate) : 1, w = EBe(o, y, m);
  return l === "equidistantPreserveStart" ? ABe(y, w, g, i, a) : (l === "preserveStart" || l === "preserveStartEnd" ? h = MBe(y, w, g, i, a, l === "preserveStartEnd") : h = TBe(y, w, g, i, a), h.filter(function(C) {
    return C.isShow;
  }));
}
var RBe = ["viewBox"], DBe = ["viewBox"], IBe = ["ticks"];
function rd(e) {
  "@babel/helpers - typeof";
  return rd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, rd(e);
}
function oc() {
  return oc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, oc.apply(this, arguments);
}
function G$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Nr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? G$(Object(n), !0).forEach(function(r) {
      P_(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : G$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function g8(e, t) {
  if (e == null) return {};
  var n = $Be(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function $Be(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function LBe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function K$(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, GJ(r.key), r);
  }
}
function FBe(e, t, n) {
  return t && K$(e.prototype, t), n && K$(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function BBe(e, t, n) {
  return t = cg(t), jBe(e, UJ() ? Reflect.construct(t, n || [], cg(e).constructor) : t.apply(e, n));
}
function jBe(e, t) {
  if (t && (rd(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return VBe(e);
}
function VBe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function UJ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (UJ = function() {
    return !!e;
  })();
}
function cg(e) {
  return cg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, cg(e);
}
function qBe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && T9(e, t);
}
function T9(e, t) {
  return T9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, T9(e, t);
}
function P_(e, t, n) {
  return t = GJ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function GJ(e) {
  var t = zBe(e, "string");
  return rd(t) == "symbol" ? t : t + "";
}
function zBe(e, t) {
  if (rd(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (rd(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Bd = /* @__PURE__ */ function(e) {
  function t(n) {
    var r;
    return LBe(this, t), r = BBe(this, t, [n]), r.state = {
      fontSize: "",
      letterSpacing: ""
    }, r;
  }
  return qBe(t, e), FBe(t, [{
    key: "shouldComponentUpdate",
    value: function(r, i) {
      var o = r.viewBox, a = g8(r, RBe), s = this.props, l = s.viewBox, u = g8(s, DBe);
      return !bc(o, l) || !bc(a, u) || !bc(i, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var r = this.layerReference;
      if (r) {
        var i = r.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        i && this.setState({
          fontSize: window.getComputedStyle(i).fontSize,
          letterSpacing: window.getComputedStyle(i).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(r) {
      var i = this.props, o = i.x, a = i.y, s = i.width, l = i.height, u = i.orientation, c = i.tickSize, f = i.mirror, h = i.tickMargin, m, v, g, y, w, C, S = f ? -1 : 1, N = r.tickSize || c, E = we(r.tickCoord) ? r.tickCoord : r.coordinate;
      switch (u) {
        case "top":
          m = v = r.coordinate, y = a + +!f * l, g = y - S * N, C = g - S * h, w = E;
          break;
        case "left":
          g = y = r.coordinate, v = o + +!f * s, m = v - S * N, w = m - S * h, C = E;
          break;
        case "right":
          g = y = r.coordinate, v = o + +f * s, m = v + S * N, w = m + S * h, C = E;
          break;
        default:
          m = v = r.coordinate, y = a + +f * l, g = y + S * N, C = g + S * h, w = E;
          break;
      }
      return {
        line: {
          x1: m,
          y1: g,
          x2: v,
          y2: y
        },
        tick: {
          x: w,
          y: C
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var r = this.props, i = r.orientation, o = r.mirror, a;
      switch (i) {
        case "left":
          a = o ? "start" : "end";
          break;
        case "right":
          a = o ? "end" : "start";
          break;
        default:
          a = "middle";
          break;
      }
      return a;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var r = this.props, i = r.orientation, o = r.mirror, a = "end";
      switch (i) {
        case "left":
        case "right":
          a = "middle";
          break;
        case "top":
          a = o ? "start" : "end";
          break;
        default:
          a = o ? "end" : "start";
          break;
      }
      return a;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var r = this.props, i = r.x, o = r.y, a = r.width, s = r.height, l = r.orientation, u = r.mirror, c = r.axisLine, f = Nr(Nr(Nr({}, qe(this.props, !1)), qe(c, !1)), {}, {
        fill: "none"
      });
      if (l === "top" || l === "bottom") {
        var h = +(l === "top" && !u || l === "bottom" && u);
        f = Nr(Nr({}, f), {}, {
          x1: i,
          y1: o + h * s,
          x2: i + a,
          y2: o + h * s
        });
      } else {
        var m = +(l === "left" && !u || l === "right" && u);
        f = Nr(Nr({}, f), {}, {
          x1: i + m * a,
          y1: o,
          x2: i + m * a,
          y2: o + s
        });
      }
      return /* @__PURE__ */ F.createElement("line", oc({}, f, {
        className: at("recharts-cartesian-axis-line", Di(c, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(r, i, o) {
        var a = this, s = this.props, l = s.tickLine, u = s.stroke, c = s.tick, f = s.tickFormatter, h = s.unit, m = k_(Nr(Nr({}, this.props), {}, {
          ticks: r
        }), i, o), v = this.getTickTextAnchor(), g = this.getTickVerticalAnchor(), y = qe(this.props, !1), w = qe(c, !1), C = Nr(Nr({}, y), {}, {
          fill: "none"
        }, qe(l, !1)), S = m.map(function(N, E) {
          var A = a.getTickLineCoord(N), O = A.line, T = A.tick, M = Nr(Nr(Nr(Nr({
            textAnchor: v,
            verticalAnchor: g
          }, y), {}, {
            stroke: "none",
            fill: u
          }, w), T), {}, {
            index: E,
            payload: N,
            visibleTicksCount: m.length,
            tickFormatter: f
          });
          return /* @__PURE__ */ F.createElement(zt, oc({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(N.value, "-").concat(N.coordinate, "-").concat(N.tickCoord)
          }, Ic(a.props, N, E)), l && /* @__PURE__ */ F.createElement("line", oc({}, C, O, {
            className: at("recharts-cartesian-axis-tick-line", Di(l, "className"))
          })), c && t.renderTickItem(c, M, "".concat(Ye(f) ? f(N.value, E) : N.value).concat(h || "")));
        });
        return /* @__PURE__ */ F.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, S);
      }
    )
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, o = i.axisLine, a = i.width, s = i.height, l = i.ticksGenerator, u = i.className, c = i.hide;
      if (c)
        return null;
      var f = this.props, h = f.ticks, m = g8(f, IBe), v = h;
      return Ye(l) && (v = h && h.length > 0 ? l(this.props) : l(m)), a <= 0 || s <= 0 || !v || !v.length ? null : /* @__PURE__ */ F.createElement(zt, {
        className: at("recharts-cartesian-axis", u),
        ref: function(y) {
          r.layerReference = y;
        }
      }, o && this.renderAxisLine(), this.renderTicks(v, this.state.fontSize, this.state.letterSpacing), er.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(r, i, o) {
      var a;
      return /* @__PURE__ */ F.isValidElement(r) ? a = /* @__PURE__ */ F.cloneElement(r, i) : Ye(r) ? a = r(i) : a = /* @__PURE__ */ F.createElement(Vc, oc({}, i, {
        className: "recharts-cartesian-axis-tick-value"
      }), o), a;
    }
  }]);
}(rB);
P_(Bd, "displayName", "CartesianAxis");
P_(Bd, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var WBe = ["x1", "y1", "x2", "y2", "key"], HBe = ["offset"];
function nu(e) {
  "@babel/helpers - typeof";
  return nu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, nu(e);
}
function Y$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function pr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Y$(Object(n), !0).forEach(function(r) {
      UBe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Y$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function UBe(e, t, n) {
  return t = GBe(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function GBe(e) {
  var t = KBe(e, "string");
  return nu(t) == "symbol" ? t : t + "";
}
function KBe(e, t) {
  if (nu(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (nu(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ml() {
  return Ml = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ml.apply(this, arguments);
}
function Z$(e, t) {
  if (e == null) return {};
  var n = YBe(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function YBe(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
var ZBe = function(t) {
  var n = t.fill;
  if (!n || n === "none")
    return null;
  var r = t.fillOpacity, i = t.x, o = t.y, a = t.width, s = t.height, l = t.ry;
  return /* @__PURE__ */ F.createElement("rect", {
    x: i,
    y: o,
    ry: l,
    width: a,
    height: s,
    stroke: "none",
    fill: n,
    fillOpacity: r,
    className: "recharts-cartesian-grid-bg"
  });
};
function KJ(e, t) {
  var n;
  if (/* @__PURE__ */ F.isValidElement(e))
    n = /* @__PURE__ */ F.cloneElement(e, t);
  else if (Ye(e))
    n = e(t);
  else {
    var r = t.x1, i = t.y1, o = t.x2, a = t.y2, s = t.key, l = Z$(t, WBe), u = qe(l, !1);
    u.offset;
    var c = Z$(u, HBe);
    n = /* @__PURE__ */ F.createElement("line", Ml({}, c, {
      x1: r,
      y1: i,
      x2: o,
      y2: a,
      fill: "none",
      key: s
    }));
  }
  return n;
}
function XBe(e) {
  var t = e.x, n = e.width, r = e.horizontal, i = r === void 0 ? !0 : r, o = e.horizontalPoints;
  if (!i || !o || !o.length)
    return null;
  var a = o.map(function(s, l) {
    var u = pr(pr({}, e), {}, {
      x1: t,
      y1: s,
      x2: t + n,
      y2: s,
      key: "line-".concat(l),
      index: l
    });
    return KJ(i, u);
  });
  return /* @__PURE__ */ F.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, a);
}
function JBe(e) {
  var t = e.y, n = e.height, r = e.vertical, i = r === void 0 ? !0 : r, o = e.verticalPoints;
  if (!i || !o || !o.length)
    return null;
  var a = o.map(function(s, l) {
    var u = pr(pr({}, e), {}, {
      x1: s,
      y1: t,
      x2: s,
      y2: t + n,
      key: "line-".concat(l),
      index: l
    });
    return KJ(i, u);
  });
  return /* @__PURE__ */ F.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, a);
}
function QBe(e) {
  var t = e.horizontalFill, n = e.fillOpacity, r = e.x, i = e.y, o = e.width, a = e.height, s = e.horizontalPoints, l = e.horizontal, u = l === void 0 ? !0 : l;
  if (!u || !t || !t.length)
    return null;
  var c = s.map(function(h) {
    return Math.round(h + i - i);
  }).sort(function(h, m) {
    return h - m;
  });
  i !== c[0] && c.unshift(0);
  var f = c.map(function(h, m) {
    var v = !c[m + 1], g = v ? i + a - h : c[m + 1] - h;
    if (g <= 0)
      return null;
    var y = m % t.length;
    return /* @__PURE__ */ F.createElement("rect", {
      key: "react-".concat(m),
      y: h,
      x: r,
      height: g,
      width: o,
      stroke: "none",
      fill: t[y],
      fillOpacity: n,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ F.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, f);
}
function eje(e) {
  var t = e.vertical, n = t === void 0 ? !0 : t, r = e.verticalFill, i = e.fillOpacity, o = e.x, a = e.y, s = e.width, l = e.height, u = e.verticalPoints;
  if (!n || !r || !r.length)
    return null;
  var c = u.map(function(h) {
    return Math.round(h + o - o);
  }).sort(function(h, m) {
    return h - m;
  });
  o !== c[0] && c.unshift(0);
  var f = c.map(function(h, m) {
    var v = !c[m + 1], g = v ? o + s - h : c[m + 1] - h;
    if (g <= 0)
      return null;
    var y = m % r.length;
    return /* @__PURE__ */ F.createElement("rect", {
      key: "react-".concat(m),
      x: h,
      y: a,
      width: g,
      height: l,
      stroke: "none",
      fill: r[y],
      fillOpacity: i,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ F.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, f);
}
var tje = function(t, n) {
  var r = t.xAxis, i = t.width, o = t.height, a = t.offset;
  return KX(k_(pr(pr(pr({}, Bd.defaultProps), r), {}, {
    ticks: Oa(r, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: i,
      height: o
    }
  })), a.left, a.left + a.width, n);
}, nje = function(t, n) {
  var r = t.yAxis, i = t.width, o = t.height, a = t.offset;
  return KX(k_(pr(pr(pr({}, Bd.defaultProps), r), {}, {
    ticks: Oa(r, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: i,
      height: o
    }
  })), a.top, a.top + a.height, n);
}, Zu = {
  horizontal: !0,
  vertical: !0,
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function Yn(e) {
  var t, n, r, i, o, a, s = E_(), l = N_(), u = zFe(), c = pr(pr({}, e), {}, {
    stroke: (t = e.stroke) !== null && t !== void 0 ? t : Zu.stroke,
    fill: (n = e.fill) !== null && n !== void 0 ? n : Zu.fill,
    horizontal: (r = e.horizontal) !== null && r !== void 0 ? r : Zu.horizontal,
    horizontalFill: (i = e.horizontalFill) !== null && i !== void 0 ? i : Zu.horizontalFill,
    vertical: (o = e.vertical) !== null && o !== void 0 ? o : Zu.vertical,
    verticalFill: (a = e.verticalFill) !== null && a !== void 0 ? a : Zu.verticalFill,
    x: we(e.x) ? e.x : u.left,
    y: we(e.y) ? e.y : u.top,
    width: we(e.width) ? e.width : u.width,
    height: we(e.height) ? e.height : u.height
  }), f = c.x, h = c.y, m = c.width, v = c.height, g = c.syncWithTicks, y = c.horizontalValues, w = c.verticalValues, C = jFe(), S = VFe();
  if (!we(m) || m <= 0 || !we(v) || v <= 0 || !we(f) || f !== +f || !we(h) || h !== +h)
    return null;
  var N = c.verticalCoordinatesGenerator || tje, E = c.horizontalCoordinatesGenerator || nje, A = c.horizontalPoints, O = c.verticalPoints;
  if ((!A || !A.length) && Ye(E)) {
    var T = y && y.length, M = E({
      yAxis: S ? pr(pr({}, S), {}, {
        ticks: T ? y : S.ticks
      }) : void 0,
      width: s,
      height: l,
      offset: u
    }, T ? !0 : g);
    Ma(Array.isArray(M), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(nu(M), "]")), Array.isArray(M) && (A = M);
  }
  if ((!O || !O.length) && Ye(N)) {
    var L = w && w.length, I = N({
      xAxis: C ? pr(pr({}, C), {}, {
        ticks: L ? w : C.ticks
      }) : void 0,
      width: s,
      height: l,
      offset: u
    }, L ? !0 : g);
    Ma(Array.isArray(I), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(nu(I), "]")), Array.isArray(I) && (O = I);
  }
  return /* @__PURE__ */ F.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ F.createElement(ZBe, {
    fill: c.fill,
    fillOpacity: c.fillOpacity,
    x: c.x,
    y: c.y,
    width: c.width,
    height: c.height,
    ry: c.ry
  }), /* @__PURE__ */ F.createElement(XBe, Ml({}, c, {
    offset: u,
    horizontalPoints: A,
    xAxis: C,
    yAxis: S
  })), /* @__PURE__ */ F.createElement(JBe, Ml({}, c, {
    offset: u,
    verticalPoints: O,
    xAxis: C,
    yAxis: S
  })), /* @__PURE__ */ F.createElement(QBe, Ml({}, c, {
    horizontalPoints: A
  })), /* @__PURE__ */ F.createElement(eje, Ml({}, c, {
    verticalPoints: O
  })));
}
Yn.displayName = "CartesianGrid";
function id(e) {
  "@babel/helpers - typeof";
  return id = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, id(e);
}
function rje(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ije(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, XJ(r.key), r);
  }
}
function oje(e, t, n) {
  return t && ije(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function aje(e, t, n) {
  return t = dg(t), sje(e, YJ() ? Reflect.construct(t, n || [], dg(e).constructor) : t.apply(e, n));
}
function sje(e, t) {
  if (t && (id(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return lje(e);
}
function lje(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function YJ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (YJ = function() {
    return !!e;
  })();
}
function dg(e) {
  return dg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, dg(e);
}
function uje(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && M9(e, t);
}
function M9(e, t) {
  return M9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, M9(e, t);
}
function ZJ(e, t, n) {
  return t = XJ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function XJ(e) {
  var t = cje(e, "string");
  return id(t) == "symbol" ? t : t + "";
}
function cje(e, t) {
  if (id(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (id(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function R9() {
  return R9 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, R9.apply(this, arguments);
}
function dje(e) {
  var t = e.xAxisId, n = E_(), r = N_(), i = LJ(t);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ F.createElement(Bd, R9({}, i, {
      className: at("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: r
      },
      ticksGenerator: function(a) {
        return Oa(a, !0);
      }
    }))
  );
}
var Cn = /* @__PURE__ */ function(e) {
  function t() {
    return rje(this, t), aje(this, t, arguments);
  }
  return uje(t, e), oje(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ F.createElement(dje, this.props);
    }
  }]);
}(F.Component);
ZJ(Cn, "displayName", "XAxis");
ZJ(Cn, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function od(e) {
  "@babel/helpers - typeof";
  return od = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, od(e);
}
function fje(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function hje(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, eQ(r.key), r);
  }
}
function pje(e, t, n) {
  return t && hje(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function mje(e, t, n) {
  return t = fg(t), gje(e, JJ() ? Reflect.construct(t, n || [], fg(e).constructor) : t.apply(e, n));
}
function gje(e, t) {
  if (t && (od(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return vje(e);
}
function vje(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function JJ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (JJ = function() {
    return !!e;
  })();
}
function fg(e) {
  return fg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, fg(e);
}
function yje(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && D9(e, t);
}
function D9(e, t) {
  return D9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, D9(e, t);
}
function QJ(e, t, n) {
  return t = eQ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function eQ(e) {
  var t = bje(e, "string");
  return od(t) == "symbol" ? t : t + "";
}
function bje(e, t) {
  if (od(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (od(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function I9() {
  return I9 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, I9.apply(this, arguments);
}
var xje = function(t) {
  var n = t.yAxisId, r = E_(), i = N_(), o = FJ(n);
  return o == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ F.createElement(Bd, I9({}, o, {
      className: at("recharts-".concat(o.axisType, " ").concat(o.axisType), o.className),
      viewBox: {
        x: 0,
        y: 0,
        width: r,
        height: i
      },
      ticksGenerator: function(s) {
        return Oa(s, !0);
      }
    }))
  );
}, Sn = /* @__PURE__ */ function(e) {
  function t() {
    return fje(this, t), mje(this, t, arguments);
  }
  return yje(t, e), pje(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ F.createElement(xje, this.props);
    }
  }]);
}(F.Component);
QJ(Sn, "displayName", "YAxis");
QJ(Sn, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function X$(e) {
  return _je(e) || Sje(e) || Cje(e) || wje();
}
function wje() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Cje(e, t) {
  if (e) {
    if (typeof e == "string") return $9(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9(e, t);
  }
}
function Sje(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function _je(e) {
  if (Array.isArray(e)) return $9(e);
}
function $9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var L9 = function(t, n, r, i, o) {
  var a = oo(t, O_), s = oo(t, Ov), l = [].concat(X$(a), X$(s)), u = oo(t, Pv), c = "".concat(i, "Id"), f = i[0], h = n;
  if (l.length && (h = l.reduce(function(g, y) {
    if (y.props[c] === r && Bo(y.props, "extendDomain") && we(y.props[f])) {
      var w = y.props[f];
      return [Math.min(g[0], w), Math.max(g[1], w)];
    }
    return g;
  }, h)), u.length) {
    var m = "".concat(f, "1"), v = "".concat(f, "2");
    h = u.reduce(function(g, y) {
      if (y.props[c] === r && Bo(y.props, "extendDomain") && we(y.props[m]) && we(y.props[v])) {
        var w = y.props[m], C = y.props[v];
        return [Math.min(g[0], w, C), Math.max(g[1], w, C)];
      }
      return g;
    }, h);
  }
  return o && o.length && (h = o.reduce(function(g, y) {
    return we(y) ? [Math.min(g[0], y), Math.max(g[1], y)] : g;
  }, h)), h;
}, v8 = { exports: {} }, J$;
function Eje() {
  return J$ || (J$ = 1, function(e) {
    var t = Object.prototype.hasOwnProperty, n = "~";
    function r() {
    }
    Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (n = !1));
    function i(l, u, c) {
      this.fn = l, this.context = u, this.once = c || !1;
    }
    function o(l, u, c, f, h) {
      if (typeof c != "function")
        throw new TypeError("The listener must be a function");
      var m = new i(c, f || l, h), v = n ? n + u : u;
      return l._events[v] ? l._events[v].fn ? l._events[v] = [l._events[v], m] : l._events[v].push(m) : (l._events[v] = m, l._eventsCount++), l;
    }
    function a(l, u) {
      --l._eventsCount === 0 ? l._events = new r() : delete l._events[u];
    }
    function s() {
      this._events = new r(), this._eventsCount = 0;
    }
    s.prototype.eventNames = function() {
      var u = [], c, f;
      if (this._eventsCount === 0) return u;
      for (f in c = this._events)
        t.call(c, f) && u.push(n ? f.slice(1) : f);
      return Object.getOwnPropertySymbols ? u.concat(Object.getOwnPropertySymbols(c)) : u;
    }, s.prototype.listeners = function(u) {
      var c = n ? n + u : u, f = this._events[c];
      if (!f) return [];
      if (f.fn) return [f.fn];
      for (var h = 0, m = f.length, v = new Array(m); h < m; h++)
        v[h] = f[h].fn;
      return v;
    }, s.prototype.listenerCount = function(u) {
      var c = n ? n + u : u, f = this._events[c];
      return f ? f.fn ? 1 : f.length : 0;
    }, s.prototype.emit = function(u, c, f, h, m, v) {
      var g = n ? n + u : u;
      if (!this._events[g]) return !1;
      var y = this._events[g], w = arguments.length, C, S;
      if (y.fn) {
        switch (y.once && this.removeListener(u, y.fn, void 0, !0), w) {
          case 1:
            return y.fn.call(y.context), !0;
          case 2:
            return y.fn.call(y.context, c), !0;
          case 3:
            return y.fn.call(y.context, c, f), !0;
          case 4:
            return y.fn.call(y.context, c, f, h), !0;
          case 5:
            return y.fn.call(y.context, c, f, h, m), !0;
          case 6:
            return y.fn.call(y.context, c, f, h, m, v), !0;
        }
        for (S = 1, C = new Array(w - 1); S < w; S++)
          C[S - 1] = arguments[S];
        y.fn.apply(y.context, C);
      } else {
        var N = y.length, E;
        for (S = 0; S < N; S++)
          switch (y[S].once && this.removeListener(u, y[S].fn, void 0, !0), w) {
            case 1:
              y[S].fn.call(y[S].context);
              break;
            case 2:
              y[S].fn.call(y[S].context, c);
              break;
            case 3:
              y[S].fn.call(y[S].context, c, f);
              break;
            case 4:
              y[S].fn.call(y[S].context, c, f, h);
              break;
            default:
              if (!C) for (E = 1, C = new Array(w - 1); E < w; E++)
                C[E - 1] = arguments[E];
              y[S].fn.apply(y[S].context, C);
          }
      }
      return !0;
    }, s.prototype.on = function(u, c, f) {
      return o(this, u, c, f, !1);
    }, s.prototype.once = function(u, c, f) {
      return o(this, u, c, f, !0);
    }, s.prototype.removeListener = function(u, c, f, h) {
      var m = n ? n + u : u;
      if (!this._events[m]) return this;
      if (!c)
        return a(this, m), this;
      var v = this._events[m];
      if (v.fn)
        v.fn === c && (!h || v.once) && (!f || v.context === f) && a(this, m);
      else {
        for (var g = 0, y = [], w = v.length; g < w; g++)
          (v[g].fn !== c || h && !v[g].once || f && v[g].context !== f) && y.push(v[g]);
        y.length ? this._events[m] = y.length === 1 ? y[0] : y : a(this, m);
      }
      return this;
    }, s.prototype.removeAllListeners = function(u) {
      var c;
      return u ? (c = n ? n + u : u, this._events[c] && a(this, c)) : (this._events = new r(), this._eventsCount = 0), this;
    }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = n, s.EventEmitter = s, e.exports = s;
  }(v8)), v8.exports;
}
var Nje = Eje();
const Aje = /* @__PURE__ */ Rt(Nje);
var y8 = new Aje(), b8 = "recharts.syncMouseEvents";
function jh(e) {
  "@babel/helpers - typeof";
  return jh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, jh(e);
}
function Oje(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function kje(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, tQ(r.key), r);
  }
}
function Pje(e, t, n) {
  return t && kje(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function x8(e, t, n) {
  return t = tQ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function tQ(e) {
  var t = Tje(e, "string");
  return jh(t) == "symbol" ? t : t + "";
}
function Tje(e, t) {
  if (jh(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (jh(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Mje = /* @__PURE__ */ function() {
  function e() {
    Oje(this, e), x8(this, "activeIndex", 0), x8(this, "coordinateList", []), x8(this, "layout", "horizontal");
  }
  return Pje(e, [{
    key: "setDetails",
    value: function(n) {
      var r, i = n.coordinateList, o = i === void 0 ? null : i, a = n.container, s = a === void 0 ? null : a, l = n.layout, u = l === void 0 ? null : l, c = n.offset, f = c === void 0 ? null : c, h = n.mouseHandlerCallback, m = h === void 0 ? null : h;
      this.coordinateList = (r = o ?? this.coordinateList) !== null && r !== void 0 ? r : [], this.container = s ?? this.container, this.layout = u ?? this.layout, this.offset = f ?? this.offset, this.mouseHandlerCallback = m ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(n) {
      if (this.coordinateList.length !== 0)
        switch (n.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(n) {
      this.activeIndex = n;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var n, r;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var i = this.container.getBoundingClientRect(), o = i.x, a = i.y, s = i.height, l = this.coordinateList[this.activeIndex].coordinate, u = ((n = window) === null || n === void 0 ? void 0 : n.scrollX) || 0, c = ((r = window) === null || r === void 0 ? void 0 : r.scrollY) || 0, f = o + l + u, h = a + this.offset.top + s / 2 + c;
        this.mouseHandlerCallback({
          pageX: f,
          pageY: h
        });
      }
    }
  }]);
}();
function Rje(e, t, n) {
  if (n === "number" && t === !0 && Array.isArray(e)) {
    var r = e == null ? void 0 : e[0], i = e == null ? void 0 : e[1];
    if (r && i && we(r) && we(i))
      return !0;
  }
  return !1;
}
function Dje(e, t, n, r) {
  var i = r / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - i : n.left + 0.5,
    y: e === "horizontal" ? n.top + 0.5 : t.y - i,
    width: e === "horizontal" ? r : n.width - 1,
    height: e === "horizontal" ? n.height - 1 : r
  };
}
function nQ(e) {
  var t = e.cx, n = e.cy, r = e.radius, i = e.startAngle, o = e.endAngle, a = $t(t, n, r, i), s = $t(t, n, r, o);
  return {
    points: [a, s],
    cx: t,
    cy: n,
    radius: r,
    startAngle: i,
    endAngle: o
  };
}
function Ije(e, t, n) {
  var r, i, o, a;
  if (e === "horizontal")
    r = t.x, o = r, i = n.top, a = n.top + n.height;
  else if (e === "vertical")
    i = t.y, a = i, r = n.left, o = n.left + n.width;
  else if (t.cx != null && t.cy != null)
    if (e === "centric") {
      var s = t.cx, l = t.cy, u = t.innerRadius, c = t.outerRadius, f = t.angle, h = $t(s, l, u, f), m = $t(s, l, c, f);
      r = h.x, i = h.y, o = m.x, a = m.y;
    } else
      return nQ(t);
  return [{
    x: r,
    y: i
  }, {
    x: o,
    y: a
  }];
}
function Vh(e) {
  "@babel/helpers - typeof";
  return Vh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Vh(e);
}
function Q$(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function C1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q$(Object(n), !0).forEach(function(r) {
      $je(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Q$(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function $je(e, t, n) {
  return t = Lje(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Lje(e) {
  var t = Fje(e, "string");
  return Vh(t) == "symbol" ? t : t + "";
}
function Fje(e, t) {
  if (Vh(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Vh(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Bje(e) {
  var t, n, r = e.element, i = e.tooltipEventType, o = e.isActive, a = e.activeCoordinate, s = e.activePayload, l = e.offset, u = e.activeTooltipIndex, c = e.tooltipAxisBandSize, f = e.layout, h = e.chartName, m = (t = r.props.cursor) !== null && t !== void 0 ? t : (n = r.type.defaultProps) === null || n === void 0 ? void 0 : n.cursor;
  if (!r || !m || !o || !a || h !== "ScatterChart" && i !== "axis")
    return null;
  var v, g = bI;
  if (h === "ScatterChart")
    v = a, g = e$e;
  else if (h === "BarChart")
    v = Dje(f, a, l, c), g = x_;
  else if (f === "radial") {
    var y = nQ(a), w = y.cx, C = y.cy, S = y.radius, N = y.startAngle, E = y.endAngle;
    v = {
      cx: w,
      cy: C,
      startAngle: N,
      endAngle: E,
      innerRadius: S,
      outerRadius: S
    }, g = oJ;
  } else
    v = {
      points: Ije(f, a, l)
    }, g = bI;
  var A = C1(C1(C1(C1({
    stroke: "#ccc",
    pointerEvents: "none"
  }, l), v), qe(m, !1)), {}, {
    payload: s,
    payloadIndex: u,
    className: at("recharts-tooltip-cursor", m.className)
  });
  return /* @__PURE__ */ Pr(m) ? /* @__PURE__ */ cn(m, A) : /* @__PURE__ */ dt(g, A);
}
var jje = ["item"], Vje = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function ad(e) {
  "@babel/helpers - typeof";
  return ad = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ad(e);
}
function ac() {
  return ac = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ac.apply(this, arguments);
}
function eL(e, t) {
  return Wje(e) || zje(e, t) || iQ(e, t) || qje();
}
function qje() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zje(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], l = !0, u = !1;
    try {
      if (o = (n = n.call(e)).next, t !== 0) for (; !(l = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); l = !0) ;
    } catch (c) {
      u = !0, i = c;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw i;
      }
    }
    return s;
  }
}
function Wje(e) {
  if (Array.isArray(e)) return e;
}
function tL(e, t) {
  if (e == null) return {};
  var n = Hje(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Hje(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0) continue;
      n[r] = e[r];
    }
  return n;
}
function Uje(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Gje(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, oQ(r.key), r);
  }
}
function Kje(e, t, n) {
  return t && Gje(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Yje(e, t, n) {
  return t = hg(t), Zje(e, rQ() ? Reflect.construct(t, n || [], hg(e).constructor) : t.apply(e, n));
}
function Zje(e, t) {
  if (t && (ad(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Xje(e);
}
function Xje(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function rQ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (rQ = function() {
    return !!e;
  })();
}
function hg(e) {
  return hg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, hg(e);
}
function Jje(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && F9(e, t);
}
function F9(e, t) {
  return F9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, F9(e, t);
}
function sd(e) {
  return tVe(e) || eVe(e) || iQ(e) || Qje();
}
function Qje() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iQ(e, t) {
  if (e) {
    if (typeof e == "string") return B9(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return B9(e, t);
  }
}
function eVe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function tVe(e) {
  if (Array.isArray(e)) return B9(e);
}
function B9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function nL(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function oe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? nL(Object(n), !0).forEach(function(r) {
      Ve(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nL(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ve(e, t, n) {
  return t = oQ(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function oQ(e) {
  var t = nVe(e, "string");
  return ad(t) == "symbol" ? t : t + "";
}
function nVe(e, t) {
  if (ad(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ad(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var rVe = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, iVe = {
  width: "100%",
  height: "100%"
}, aQ = {
  x: 0,
  y: 0
};
function S1(e) {
  return e;
}
var oVe = function(t, n) {
  return n === "horizontal" ? t.x : n === "vertical" ? t.y : n === "centric" ? t.angle : t.radius;
}, aVe = function(t, n, r, i) {
  var o = n.find(function(c) {
    return c && c.index === r;
  });
  if (o) {
    if (t === "horizontal")
      return {
        x: o.coordinate,
        y: i.y
      };
    if (t === "vertical")
      return {
        x: i.x,
        y: o.coordinate
      };
    if (t === "centric") {
      var a = o.coordinate, s = i.radius;
      return oe(oe(oe({}, i), $t(i.cx, i.cy, s, a)), {}, {
        angle: a,
        radius: s
      });
    }
    var l = o.coordinate, u = i.angle;
    return oe(oe(oe({}, i), $t(i.cx, i.cy, l, u)), {}, {
      angle: u,
      radius: l
    });
  }
  return aQ;
}, Tv = function(t, n) {
  var r = n.graphicalItems, i = n.dataStartIndex, o = n.dataEndIndex, a = (r ?? []).reduce(function(s, l) {
    var u = l.props.data;
    return u && u.length ? [].concat(sd(s), sd(u)) : s;
  }, []);
  return a.length > 0 ? a : t && t.length && we(i) && we(o) ? t.slice(i, o + 1) : [];
};
function sQ(e) {
  return e === "number" ? [0, "auto"] : void 0;
}
var j9 = function(t, n, r, i) {
  var o = t.graphicalItems, a = t.tooltipAxis, s = Tv(n, t);
  return r < 0 || !o || !o.length || r >= s.length ? null : o.reduce(function(l, u) {
    var c, f = (c = u.props.data) !== null && c !== void 0 ? c : n;
    f && t.dataStartIndex + t.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    t.dataEndIndex - t.dataStartIndex >= r && (f = f.slice(t.dataStartIndex, t.dataEndIndex + 1));
    var h;
    if (a.dataKey && !a.allowDuplicatedCategory) {
      var m = f === void 0 ? s : f;
      h = C7(m, a.dataKey, i);
    } else
      h = f && f[r] || s[r];
    return h ? [].concat(sd(l), [QX(u, h)]) : l;
  }, []);
}, rL = function(t, n, r, i) {
  var o = i || {
    x: t.chartX,
    y: t.chartY
  }, a = oVe(o, r), s = t.orderedTooltipTicks, l = t.tooltipAxis, u = t.tooltipTicks, c = kMe(a, s, u, l);
  if (c >= 0 && u) {
    var f = u[c] && u[c].value, h = j9(t, n, c, f), m = aVe(r, s, c, o);
    return {
      activeTooltipIndex: c,
      activeLabel: f,
      activePayload: h,
      activeCoordinate: m
    };
  }
  return null;
}, sVe = function(t, n) {
  var r = n.axes, i = n.graphicalItems, o = n.axisType, a = n.axisIdKey, s = n.stackGroups, l = n.dataStartIndex, u = n.dataEndIndex, c = t.layout, f = t.children, h = t.stackOffset, m = GX(c, o);
  return r.reduce(function(v, g) {
    var y, w = g.type.defaultProps !== void 0 ? oe(oe({}, g.type.defaultProps), g.props) : g.props, C = w.type, S = w.dataKey, N = w.allowDataOverflow, E = w.allowDuplicatedCategory, A = w.scale, O = w.ticks, T = w.includeHidden, M = w[a];
    if (v[M])
      return v;
    var L = Tv(t.data, {
      graphicalItems: i.filter(function(Y) {
        var le, be = a in Y.props ? Y.props[a] : (le = Y.type.defaultProps) === null || le === void 0 ? void 0 : le[a];
        return be === M;
      }),
      dataStartIndex: l,
      dataEndIndex: u
    }), I = L.length, j, B, q;
    Rje(w.domain, N, C) && (j = n9(w.domain, null, N), m && (C === "number" || A !== "auto") && (q = Vf(L, S, "category")));
    var G = sQ(C);
    if (!j || j.length === 0) {
      var U, V = (U = w.domain) !== null && U !== void 0 ? U : G;
      if (S) {
        if (j = Vf(L, S, C), C === "category" && m) {
          var H = C_e(j);
          E && H ? (B = j, j = eg(0, I)) : E || (j = oI(V, j, g).reduce(function(Y, le) {
            return Y.indexOf(le) >= 0 ? Y : [].concat(sd(Y), [le]);
          }, []));
        } else if (C === "category")
          E ? j = j.filter(function(Y) {
            return Y !== "" && !yt(Y);
          }) : j = oI(V, j, g).reduce(function(Y, le) {
            return Y.indexOf(le) >= 0 || le === "" || yt(le) ? Y : [].concat(sd(Y), [le]);
          }, []);
        else if (C === "number") {
          var Z = DMe(L, i.filter(function(Y) {
            var le, be, pe = a in Y.props ? Y.props[a] : (le = Y.type.defaultProps) === null || le === void 0 ? void 0 : le[a], Ee = "hide" in Y.props ? Y.props.hide : (be = Y.type.defaultProps) === null || be === void 0 ? void 0 : be.hide;
            return pe === M && (T || !Ee);
          }), S, o, c);
          Z && (j = Z);
        }
        m && (C === "number" || A !== "auto") && (q = Vf(L, S, "category"));
      } else m ? j = eg(0, I) : s && s[M] && s[M].hasStack && C === "number" ? j = h === "expand" ? [0, 1] : JX(s[M].stackGroups, l, u) : j = UX(L, i.filter(function(Y) {
        var le = a in Y.props ? Y.props[a] : Y.type.defaultProps[a], be = "hide" in Y.props ? Y.props.hide : Y.type.defaultProps.hide;
        return le === M && (T || !be);
      }), C, c, !0);
      if (C === "number")
        j = L9(f, j, M, o, O), V && (j = n9(V, j, N));
      else if (C === "category" && V) {
        var de = V, ne = j.every(function(Y) {
          return de.indexOf(Y) >= 0;
        });
        ne && (j = de);
      }
    }
    return oe(oe({}, v), {}, Ve({}, M, oe(oe({}, w), {}, {
      axisType: o,
      domain: j,
      categoricalDomain: q,
      duplicateDomain: B,
      originalDomain: (y = w.domain) !== null && y !== void 0 ? y : G,
      isCategorical: m,
      layout: c
    })));
  }, {});
}, lVe = function(t, n) {
  var r = n.graphicalItems, i = n.Axis, o = n.axisType, a = n.axisIdKey, s = n.stackGroups, l = n.dataStartIndex, u = n.dataEndIndex, c = t.layout, f = t.children, h = Tv(t.data, {
    graphicalItems: r,
    dataStartIndex: l,
    dataEndIndex: u
  }), m = h.length, v = GX(c, o), g = -1;
  return r.reduce(function(y, w) {
    var C = w.type.defaultProps !== void 0 ? oe(oe({}, w.type.defaultProps), w.props) : w.props, S = C[a], N = sQ("number");
    if (!y[S]) {
      g++;
      var E;
      return v ? E = eg(0, m) : s && s[S] && s[S].hasStack ? (E = JX(s[S].stackGroups, l, u), E = L9(f, E, S, o)) : (E = n9(N, UX(h, r.filter(function(A) {
        var O, T, M = a in A.props ? A.props[a] : (O = A.type.defaultProps) === null || O === void 0 ? void 0 : O[a], L = "hide" in A.props ? A.props.hide : (T = A.type.defaultProps) === null || T === void 0 ? void 0 : T.hide;
        return M === S && !L;
      }), "number", c), i.defaultProps.allowDataOverflow), E = L9(f, E, S, o)), oe(oe({}, y), {}, Ve({}, S, oe(oe({
        axisType: o
      }, i.defaultProps), {}, {
        hide: !0,
        orientation: Di(rVe, "".concat(o, ".").concat(g % 2), null),
        domain: E,
        originalDomain: N,
        isCategorical: v,
        layout: c
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return y;
  }, {});
}, uVe = function(t, n) {
  var r = n.axisType, i = r === void 0 ? "xAxis" : r, o = n.AxisComp, a = n.graphicalItems, s = n.stackGroups, l = n.dataStartIndex, u = n.dataEndIndex, c = t.children, f = "".concat(i, "Id"), h = oo(c, o), m = {};
  return h && h.length ? m = sVe(t, {
    axes: h,
    graphicalItems: a,
    axisType: i,
    axisIdKey: f,
    stackGroups: s,
    dataStartIndex: l,
    dataEndIndex: u
  }) : a && a.length && (m = lVe(t, {
    Axis: o,
    graphicalItems: a,
    axisType: i,
    axisIdKey: f,
    stackGroups: s,
    dataStartIndex: l,
    dataEndIndex: u
  })), m;
}, cVe = function(t) {
  var n = Cs(t), r = Oa(n, !1, !0);
  return {
    tooltipTicks: r,
    orderedTooltipTicks: GS(r, function(i) {
      return i.coordinate;
    }),
    tooltipAxis: n,
    tooltipAxisBandSize: jm(n, r)
  };
}, iL = function(t) {
  var n = t.children, r = t.defaultShowTooltip, i = li(n, Xc), o = 0, a = 0;
  return t.data && t.data.length !== 0 && (a = t.data.length - 1), i && i.props && (i.props.startIndex >= 0 && (o = i.props.startIndex), i.props.endIndex >= 0 && (a = i.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: o,
    dataEndIndex: a,
    activeTooltipIndex: -1,
    isTooltipActive: !!r
  };
}, dVe = function(t) {
  return !t || !t.length ? !1 : t.some(function(n) {
    var r = Ta(n && n.type);
    return r && r.indexOf("Bar") >= 0;
  });
}, oL = function(t) {
  return t === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : t === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : t === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, fVe = function(t, n) {
  var r = t.props, i = t.graphicalItems, o = t.xAxisMap, a = o === void 0 ? {} : o, s = t.yAxisMap, l = s === void 0 ? {} : s, u = r.width, c = r.height, f = r.children, h = r.margin || {}, m = li(f, Xc), v = li(f, Ur), g = Object.keys(l).reduce(function(E, A) {
    var O = l[A], T = O.orientation;
    return !O.mirror && !O.hide ? oe(oe({}, E), {}, Ve({}, T, E[T] + O.width)) : E;
  }, {
    left: h.left || 0,
    right: h.right || 0
  }), y = Object.keys(a).reduce(function(E, A) {
    var O = a[A], T = O.orientation;
    return !O.mirror && !O.hide ? oe(oe({}, E), {}, Ve({}, T, Di(E, "".concat(T)) + O.height)) : E;
  }, {
    top: h.top || 0,
    bottom: h.bottom || 0
  }), w = oe(oe({}, y), g), C = w.bottom;
  m && (w.bottom += m.props.height || Xc.defaultProps.height), v && n && (w = MMe(w, i, r, n));
  var S = u - w.left - w.right, N = c - w.top - w.bottom;
  return oe(oe({
    brushBottom: C
  }, w), {}, {
    // never return negative values for height and width
    width: Math.max(S, 0),
    height: Math.max(N, 0)
  });
}, hVe = function(t, n) {
  if (n === "xAxis")
    return t[n].width;
  if (n === "yAxis")
    return t[n].height;
}, lQ = function(t) {
  var n = t.chartName, r = t.GraphicalChild, i = t.defaultTooltipEventType, o = i === void 0 ? "axis" : i, a = t.validateTooltipEventTypes, s = a === void 0 ? ["axis"] : a, l = t.axisComponents, u = t.legendContent, c = t.formatAxisMap, f = t.defaultProps, h = function(w, C) {
    var S = C.graphicalItems, N = C.stackGroups, E = C.offset, A = C.updateId, O = C.dataStartIndex, T = C.dataEndIndex, M = w.barSize, L = w.layout, I = w.barGap, j = w.barCategoryGap, B = w.maxBarSize, q = oL(L), G = q.numericAxisName, U = q.cateAxisName, V = dVe(S), H = [];
    return S.forEach(function(Z, de) {
      var ne = Tv(w.data, {
        graphicalItems: [Z],
        dataStartIndex: O,
        dataEndIndex: T
      }), Y = Z.type.defaultProps !== void 0 ? oe(oe({}, Z.type.defaultProps), Z.props) : Z.props, le = Y.dataKey, be = Y.maxBarSize, pe = Y["".concat(G, "Id")], Ee = Y["".concat(U, "Id")], ge = {}, Ce = l.reduce(function(An, wr) {
        var Qa, qd, sa = C["".concat(wr.axisType, "Map")], qp = Y["".concat(wr.axisType, "Id")];
        sa && sa[qp] || wr.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? zr(!1, "Specifying a(n) ".concat(wr.axisType, "Id requires a corresponding ").concat(
          wr.axisType,
          "Id on the targeted graphical component "
        ).concat((Qa = Z == null || (qd = Z.type) === null || qd === void 0 ? void 0 : qd.displayName) !== null && Qa !== void 0 ? Qa : "")) : zr());
        var es = sa[qp];
        return oe(oe({}, An), {}, Ve(Ve({}, wr.axisType, es), "".concat(wr.axisType, "Ticks"), Oa(es)));
      }, ge), ie = Ce[U], ye = Ce["".concat(U, "Ticks")], ve = N && N[pe] && N[pe].hasStack && zMe(Z, N[pe].stackGroups), Q = Ta(Z.type).indexOf("Bar") >= 0, Oe = jm(ie, ye), se = [], nt = V && PMe({
        barSize: M,
        stackGroups: N,
        totalSize: hVe(Ce, U)
      });
      if (Q) {
        var ut, st, Nn = yt(be) ? B : be, Dt = (ut = (st = jm(ie, ye, !0)) !== null && st !== void 0 ? st : Nn) !== null && ut !== void 0 ? ut : 0;
        se = TMe({
          barGap: I,
          barCategoryGap: j,
          bandSize: Dt !== Oe ? Dt : Oe,
          sizeList: nt[Ee],
          maxBarSize: Nn
        }), Dt !== Oe && (se = se.map(function(An) {
          return oe(oe({}, An), {}, {
            position: oe(oe({}, An.position), {}, {
              offset: An.position.offset - Dt / 2
            })
          });
        }));
      }
      var Co = Z && Z.type && Z.type.getComposedData;
      Co && H.push({
        props: oe(oe({}, Co(oe(oe({}, Ce), {}, {
          displayedData: ne,
          props: w,
          dataKey: le,
          item: Z,
          bandSize: Oe,
          barPosition: se,
          offset: E,
          stackedData: ve,
          layout: L,
          dataStartIndex: O,
          dataEndIndex: T
        }))), {}, Ve(Ve(Ve({
          key: Z.key || "item-".concat(de)
        }, G, Ce[G]), U, Ce[U]), "animationId", A)),
        childIndex: R_e(Z, w.children),
        item: Z
      });
    }), H;
  }, m = function(w, C) {
    var S = w.props, N = w.dataStartIndex, E = w.dataEndIndex, A = w.updateId;
    if (!xT({
      props: S
    }))
      return null;
    var O = S.children, T = S.layout, M = S.stackOffset, L = S.data, I = S.reverseStackOrder, j = oL(T), B = j.numericAxisName, q = j.cateAxisName, G = oo(O, r), U = VMe(L, G, "".concat(B, "Id"), "".concat(q, "Id"), M, I), V = l.reduce(function(Y, le) {
      var be = "".concat(le.axisType, "Map");
      return oe(oe({}, Y), {}, Ve({}, be, uVe(S, oe(oe({}, le), {}, {
        graphicalItems: G,
        stackGroups: le.axisType === B && U,
        dataStartIndex: N,
        dataEndIndex: E
      }))));
    }, {}), H = fVe(oe(oe({}, V), {}, {
      props: S,
      graphicalItems: G
    }), C == null ? void 0 : C.legendBBox);
    Object.keys(V).forEach(function(Y) {
      V[Y] = c(S, V[Y], H, Y.replace("Map", ""), n);
    });
    var Z = V["".concat(q, "Map")], de = cVe(Z), ne = h(S, oe(oe({}, V), {}, {
      dataStartIndex: N,
      dataEndIndex: E,
      updateId: A,
      graphicalItems: G,
      stackGroups: U,
      offset: H
    }));
    return oe(oe({
      formattedGraphicalItems: ne,
      graphicalItems: G,
      offset: H,
      stackGroups: U
    }, de), V);
  }, v = /* @__PURE__ */ function(y) {
    function w(C) {
      var S, N, E;
      return Uje(this, w), E = Yje(this, w, [C]), Ve(E, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), Ve(E, "accessibilityManager", new Mje()), Ve(E, "handleLegendBBoxUpdate", function(A) {
        if (A) {
          var O = E.state, T = O.dataStartIndex, M = O.dataEndIndex, L = O.updateId;
          E.setState(oe({
            legendBBox: A
          }, m({
            props: E.props,
            dataStartIndex: T,
            dataEndIndex: M,
            updateId: L
          }, oe(oe({}, E.state), {}, {
            legendBBox: A
          }))));
        }
      }), Ve(E, "handleReceiveSyncEvent", function(A, O, T) {
        if (E.props.syncId === A) {
          if (T === E.eventEmitterSymbol && typeof E.props.syncMethod != "function")
            return;
          E.applySyncEvent(O);
        }
      }), Ve(E, "handleBrushChange", function(A) {
        var O = A.startIndex, T = A.endIndex;
        if (O !== E.state.dataStartIndex || T !== E.state.dataEndIndex) {
          var M = E.state.updateId;
          E.setState(function() {
            return oe({
              dataStartIndex: O,
              dataEndIndex: T
            }, m({
              props: E.props,
              dataStartIndex: O,
              dataEndIndex: T,
              updateId: M
            }, E.state));
          }), E.triggerSyncEvent({
            dataStartIndex: O,
            dataEndIndex: T
          });
        }
      }), Ve(E, "handleMouseEnter", function(A) {
        var O = E.getMouseInfo(A);
        if (O) {
          var T = oe(oe({}, O), {}, {
            isTooltipActive: !0
          });
          E.setState(T), E.triggerSyncEvent(T);
          var M = E.props.onMouseEnter;
          Ye(M) && M(T, A);
        }
      }), Ve(E, "triggeredAfterMouseMove", function(A) {
        var O = E.getMouseInfo(A), T = O ? oe(oe({}, O), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        E.setState(T), E.triggerSyncEvent(T);
        var M = E.props.onMouseMove;
        Ye(M) && M(T, A);
      }), Ve(E, "handleItemMouseEnter", function(A) {
        E.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: A,
            activePayload: A.tooltipPayload,
            activeCoordinate: A.tooltipPosition || {
              x: A.cx,
              y: A.cy
            }
          };
        });
      }), Ve(E, "handleItemMouseLeave", function() {
        E.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), Ve(E, "handleMouseMove", function(A) {
        A.persist(), E.throttleTriggeredAfterMouseMove(A);
      }), Ve(E, "handleMouseLeave", function(A) {
        E.throttleTriggeredAfterMouseMove.cancel();
        var O = {
          isTooltipActive: !1
        };
        E.setState(O), E.triggerSyncEvent(O);
        var T = E.props.onMouseLeave;
        Ye(T) && T(O, A);
      }), Ve(E, "handleOuterEvent", function(A) {
        var O = M_e(A), T = Di(E.props, "".concat(O));
        if (O && Ye(T)) {
          var M, L;
          /.*touch.*/i.test(O) ? L = E.getMouseInfo(A.changedTouches[0]) : L = E.getMouseInfo(A), T((M = L) !== null && M !== void 0 ? M : {}, A);
        }
      }), Ve(E, "handleClick", function(A) {
        var O = E.getMouseInfo(A);
        if (O) {
          var T = oe(oe({}, O), {}, {
            isTooltipActive: !0
          });
          E.setState(T), E.triggerSyncEvent(T);
          var M = E.props.onClick;
          Ye(M) && M(T, A);
        }
      }), Ve(E, "handleMouseDown", function(A) {
        var O = E.props.onMouseDown;
        if (Ye(O)) {
          var T = E.getMouseInfo(A);
          O(T, A);
        }
      }), Ve(E, "handleMouseUp", function(A) {
        var O = E.props.onMouseUp;
        if (Ye(O)) {
          var T = E.getMouseInfo(A);
          O(T, A);
        }
      }), Ve(E, "handleTouchMove", function(A) {
        A.changedTouches != null && A.changedTouches.length > 0 && E.throttleTriggeredAfterMouseMove(A.changedTouches[0]);
      }), Ve(E, "handleTouchStart", function(A) {
        A.changedTouches != null && A.changedTouches.length > 0 && E.handleMouseDown(A.changedTouches[0]);
      }), Ve(E, "handleTouchEnd", function(A) {
        A.changedTouches != null && A.changedTouches.length > 0 && E.handleMouseUp(A.changedTouches[0]);
      }), Ve(E, "handleDoubleClick", function(A) {
        var O = E.props.onDoubleClick;
        if (Ye(O)) {
          var T = E.getMouseInfo(A);
          O(T, A);
        }
      }), Ve(E, "handleContextMenu", function(A) {
        var O = E.props.onContextMenu;
        if (Ye(O)) {
          var T = E.getMouseInfo(A);
          O(T, A);
        }
      }), Ve(E, "triggerSyncEvent", function(A) {
        E.props.syncId !== void 0 && y8.emit(b8, E.props.syncId, A, E.eventEmitterSymbol);
      }), Ve(E, "applySyncEvent", function(A) {
        var O = E.props, T = O.layout, M = O.syncMethod, L = E.state.updateId, I = A.dataStartIndex, j = A.dataEndIndex;
        if (A.dataStartIndex !== void 0 || A.dataEndIndex !== void 0)
          E.setState(oe({
            dataStartIndex: I,
            dataEndIndex: j
          }, m({
            props: E.props,
            dataStartIndex: I,
            dataEndIndex: j,
            updateId: L
          }, E.state)));
        else if (A.activeTooltipIndex !== void 0) {
          var B = A.chartX, q = A.chartY, G = A.activeTooltipIndex, U = E.state, V = U.offset, H = U.tooltipTicks;
          if (!V)
            return;
          if (typeof M == "function")
            G = M(H, A);
          else if (M === "value") {
            G = -1;
            for (var Z = 0; Z < H.length; Z++)
              if (H[Z].value === A.activeLabel) {
                G = Z;
                break;
              }
          }
          var de = oe(oe({}, V), {}, {
            x: V.left,
            y: V.top
          }), ne = Math.min(B, de.x + de.width), Y = Math.min(q, de.y + de.height), le = H[G] && H[G].value, be = j9(E.state, E.props.data, G), pe = H[G] ? {
            x: T === "horizontal" ? H[G].coordinate : ne,
            y: T === "horizontal" ? Y : H[G].coordinate
          } : aQ;
          E.setState(oe(oe({}, A), {}, {
            activeLabel: le,
            activeCoordinate: pe,
            activePayload: be,
            activeTooltipIndex: G
          }));
        } else
          E.setState(A);
      }), Ve(E, "renderCursor", function(A) {
        var O, T = E.state, M = T.isTooltipActive, L = T.activeCoordinate, I = T.activePayload, j = T.offset, B = T.activeTooltipIndex, q = T.tooltipAxisBandSize, G = E.getTooltipEventType(), U = (O = A.props.active) !== null && O !== void 0 ? O : M, V = E.props.layout, H = A.key || "_recharts-cursor";
        return /* @__PURE__ */ F.createElement(Bje, {
          key: H,
          activeCoordinate: L,
          activePayload: I,
          activeTooltipIndex: B,
          chartName: n,
          element: A,
          isActive: U,
          layout: V,
          offset: j,
          tooltipAxisBandSize: q,
          tooltipEventType: G
        });
      }), Ve(E, "renderPolarAxis", function(A, O, T) {
        var M = Di(A, "type.axisType"), L = Di(E.state, "".concat(M, "Map")), I = A.type.defaultProps, j = I !== void 0 ? oe(oe({}, I), A.props) : A.props, B = L && L[j["".concat(M, "Id")]];
        return /* @__PURE__ */ cn(A, oe(oe({}, B), {}, {
          className: at(M, B.className),
          key: A.key || "".concat(O, "-").concat(T),
          ticks: Oa(B, !0)
        }));
      }), Ve(E, "renderPolarGrid", function(A) {
        var O = A.props, T = O.radialLines, M = O.polarAngles, L = O.polarRadius, I = E.state, j = I.radiusAxisMap, B = I.angleAxisMap, q = Cs(j), G = Cs(B), U = G.cx, V = G.cy, H = G.innerRadius, Z = G.outerRadius;
        return /* @__PURE__ */ cn(A, {
          polarAngles: Array.isArray(M) ? M : Oa(G, !0).map(function(de) {
            return de.coordinate;
          }),
          polarRadius: Array.isArray(L) ? L : Oa(q, !0).map(function(de) {
            return de.coordinate;
          }),
          cx: U,
          cy: V,
          innerRadius: H,
          outerRadius: Z,
          key: A.key || "polar-grid",
          radialLines: T
        });
      }), Ve(E, "renderLegend", function() {
        var A = E.state.formattedGraphicalItems, O = E.props, T = O.children, M = O.width, L = O.height, I = E.props.margin || {}, j = M - (I.left || 0) - (I.right || 0), B = WX({
          children: T,
          formattedGraphicalItems: A,
          legendWidth: j,
          legendContent: u
        });
        if (!B)
          return null;
        var q = B.item, G = tL(B, jje);
        return /* @__PURE__ */ cn(q, oe(oe({}, G), {}, {
          chartWidth: M,
          chartHeight: L,
          margin: I,
          onBBoxUpdate: E.handleLegendBBoxUpdate
        }));
      }), Ve(E, "renderTooltip", function() {
        var A, O = E.props, T = O.children, M = O.accessibilityLayer, L = li(T, Oo);
        if (!L)
          return null;
        var I = E.state, j = I.isTooltipActive, B = I.activeCoordinate, q = I.activePayload, G = I.activeLabel, U = I.offset, V = (A = L.props.active) !== null && A !== void 0 ? A : j;
        return /* @__PURE__ */ cn(L, {
          viewBox: oe(oe({}, U), {}, {
            x: U.left,
            y: U.top
          }),
          active: V,
          label: G,
          payload: V ? q : [],
          coordinate: B,
          accessibilityLayer: M
        });
      }), Ve(E, "renderBrush", function(A) {
        var O = E.props, T = O.margin, M = O.data, L = E.state, I = L.offset, j = L.dataStartIndex, B = L.dataEndIndex, q = L.updateId;
        return /* @__PURE__ */ cn(A, {
          key: A.key || "_recharts-brush",
          onChange: y1(E.handleBrushChange, A.props.onChange),
          data: M,
          x: we(A.props.x) ? A.props.x : I.left,
          y: we(A.props.y) ? A.props.y : I.top + I.height + I.brushBottom - (T.bottom || 0),
          width: we(A.props.width) ? A.props.width : I.width,
          startIndex: j,
          endIndex: B,
          updateId: "brush-".concat(q)
        });
      }), Ve(E, "renderReferenceElement", function(A, O, T) {
        if (!A)
          return null;
        var M = E, L = M.clipPathId, I = E.state, j = I.xAxisMap, B = I.yAxisMap, q = I.offset, G = A.type.defaultProps || {}, U = A.props, V = U.xAxisId, H = V === void 0 ? G.xAxisId : V, Z = U.yAxisId, de = Z === void 0 ? G.yAxisId : Z;
        return /* @__PURE__ */ cn(A, {
          key: A.key || "".concat(O, "-").concat(T),
          xAxis: j[H],
          yAxis: B[de],
          viewBox: {
            x: q.left,
            y: q.top,
            width: q.width,
            height: q.height
          },
          clipPathId: L
        });
      }), Ve(E, "renderActivePoints", function(A) {
        var O = A.item, T = A.activePoint, M = A.basePoint, L = A.childIndex, I = A.isRange, j = [], B = O.props.key, q = O.item.type.defaultProps !== void 0 ? oe(oe({}, O.item.type.defaultProps), O.item.props) : O.item.props, G = q.activeDot, U = q.dataKey, V = oe(oe({
          index: L,
          dataKey: U,
          cx: T.x,
          cy: T.y,
          r: 4,
          fill: b_(O.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: T.payload,
          value: T.value
        }, qe(G, !1)), gm(G));
        return j.push(w.renderActiveDot(G, V, "".concat(B, "-activePoint-").concat(L))), M ? j.push(w.renderActiveDot(G, oe(oe({}, V), {}, {
          cx: M.x,
          cy: M.y
        }), "".concat(B, "-basePoint-").concat(L))) : I && j.push(null), j;
      }), Ve(E, "renderGraphicChild", function(A, O, T) {
        var M = E.filterFormatItem(A, O, T);
        if (!M)
          return null;
        var L = E.getTooltipEventType(), I = E.state, j = I.isTooltipActive, B = I.tooltipAxis, q = I.activeTooltipIndex, G = I.activeLabel, U = E.props.children, V = li(U, Oo), H = M.props, Z = H.points, de = H.isRange, ne = H.baseLine, Y = M.item.type.defaultProps !== void 0 ? oe(oe({}, M.item.type.defaultProps), M.item.props) : M.item.props, le = Y.activeDot, be = Y.hide, pe = Y.activeBar, Ee = Y.activeShape, ge = !!(!be && j && V && (le || pe || Ee)), Ce = {};
        L !== "axis" && V && V.props.trigger === "click" ? Ce = {
          onClick: y1(E.handleItemMouseEnter, A.props.onClick)
        } : L !== "axis" && (Ce = {
          onMouseLeave: y1(E.handleItemMouseLeave, A.props.onMouseLeave),
          onMouseEnter: y1(E.handleItemMouseEnter, A.props.onMouseEnter)
        });
        var ie = /* @__PURE__ */ cn(A, oe(oe({}, M.props), Ce));
        function ye(wr) {
          return typeof B.dataKey == "function" ? B.dataKey(wr.payload) : null;
        }
        if (ge)
          if (q >= 0) {
            var ve, Q;
            if (B.dataKey && !B.allowDuplicatedCategory) {
              var Oe = typeof B.dataKey == "function" ? ye : "payload.".concat(B.dataKey.toString());
              ve = C7(Z, Oe, G), Q = de && ne && C7(ne, Oe, G);
            } else
              ve = Z == null ? void 0 : Z[q], Q = de && ne && ne[q];
            if (Ee || pe) {
              var se = A.props.activeIndex !== void 0 ? A.props.activeIndex : q;
              return [/* @__PURE__ */ cn(A, oe(oe(oe({}, M.props), Ce), {}, {
                activeIndex: se
              })), null, null];
            }
            if (!yt(ve))
              return [ie].concat(sd(E.renderActivePoints({
                item: M,
                activePoint: ve,
                basePoint: Q,
                childIndex: q,
                isRange: de
              })));
          } else {
            var nt, ut = (nt = E.getItemByXY(E.state.activeCoordinate)) !== null && nt !== void 0 ? nt : {
              graphicalItem: ie
            }, st = ut.graphicalItem, Nn = st.item, Dt = Nn === void 0 ? A : Nn, Co = st.childIndex, An = oe(oe(oe({}, M.props), Ce), {}, {
              activeIndex: Co
            });
            return [/* @__PURE__ */ cn(Dt, An), null, null];
          }
        return de ? [ie, null, null] : [ie, null];
      }), Ve(E, "renderCustomized", function(A, O, T) {
        return /* @__PURE__ */ cn(A, oe(oe({
          key: "recharts-customized-".concat(T)
        }, E.props), E.state));
      }), Ve(E, "renderMap", {
        CartesianGrid: {
          handler: S1,
          once: !0
        },
        ReferenceArea: {
          handler: E.renderReferenceElement
        },
        ReferenceLine: {
          handler: S1
        },
        ReferenceDot: {
          handler: E.renderReferenceElement
        },
        XAxis: {
          handler: S1
        },
        YAxis: {
          handler: S1
        },
        Brush: {
          handler: E.renderBrush,
          once: !0
        },
        Bar: {
          handler: E.renderGraphicChild
        },
        Line: {
          handler: E.renderGraphicChild
        },
        Area: {
          handler: E.renderGraphicChild
        },
        Radar: {
          handler: E.renderGraphicChild
        },
        RadialBar: {
          handler: E.renderGraphicChild
        },
        Scatter: {
          handler: E.renderGraphicChild
        },
        Pie: {
          handler: E.renderGraphicChild
        },
        Funnel: {
          handler: E.renderGraphicChild
        },
        Tooltip: {
          handler: E.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: E.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: E.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: E.renderPolarAxis
        },
        Customized: {
          handler: E.renderCustomized
        }
      }), E.clipPathId = "".concat((S = C.id) !== null && S !== void 0 ? S : Q2("recharts"), "-clip"), E.throttleTriggeredAfterMouseMove = qZ(E.triggeredAfterMouseMove, (N = C.throttleDelay) !== null && N !== void 0 ? N : 1e3 / 60), E.state = {}, E;
    }
    return Jje(w, y), Kje(w, [{
      key: "componentDidMount",
      value: function() {
        var S, N;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (S = this.props.margin.left) !== null && S !== void 0 ? S : 0,
            top: (N = this.props.margin.top) !== null && N !== void 0 ? N : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var S = this.props, N = S.children, E = S.data, A = S.height, O = S.layout, T = li(N, Oo);
        if (T) {
          var M = T.props.defaultIndex;
          if (!(typeof M != "number" || M < 0 || M > this.state.tooltipTicks.length - 1)) {
            var L = this.state.tooltipTicks[M] && this.state.tooltipTicks[M].value, I = j9(this.state, E, M, L), j = this.state.tooltipTicks[M].coordinate, B = (this.state.offset.top + A) / 2, q = O === "horizontal", G = q ? {
              x: j,
              y: B
            } : {
              y: j,
              x: B
            }, U = this.state.formattedGraphicalItems.find(function(H) {
              var Z = H.item;
              return Z.type.name === "Scatter";
            });
            U && (G = oe(oe({}, G), U.props.points[M].tooltipPosition), I = U.props.points[M].tooltipPayload);
            var V = {
              activeTooltipIndex: M,
              isTooltipActive: !0,
              activeLabel: L,
              activePayload: I,
              activeCoordinate: G
            };
            this.setState(V), this.renderCursor(T), this.accessibilityManager.setIndex(M);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(S, N) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== N.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== S.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== S.margin) {
          var E, A;
          this.accessibilityManager.setDetails({
            offset: {
              left: (E = this.props.margin.left) !== null && E !== void 0 ? E : 0,
              top: (A = this.props.margin.top) !== null && A !== void 0 ? A : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(S) {
        _7([li(S.children, Oo)], [li(this.props.children, Oo)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var S = li(this.props.children, Oo);
        if (S && typeof S.props.shared == "boolean") {
          var N = S.props.shared ? "axis" : "item";
          return s.indexOf(N) >= 0 ? N : o;
        }
        return o;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(S) {
        if (!this.container)
          return null;
        var N = this.container, E = N.getBoundingClientRect(), A = wOe(E), O = {
          chartX: Math.round(S.pageX - A.left),
          chartY: Math.round(S.pageY - A.top)
        }, T = E.width / N.offsetWidth || 1, M = this.inRange(O.chartX, O.chartY, T);
        if (!M)
          return null;
        var L = this.state, I = L.xAxisMap, j = L.yAxisMap, B = this.getTooltipEventType();
        if (B !== "axis" && I && j) {
          var q = Cs(I).scale, G = Cs(j).scale, U = q && q.invert ? q.invert(O.chartX) : null, V = G && G.invert ? G.invert(O.chartY) : null;
          return oe(oe({}, O), {}, {
            xValue: U,
            yValue: V
          });
        }
        var H = rL(this.state, this.props.data, this.props.layout, M);
        return H ? oe(oe({}, O), H) : null;
      }
    }, {
      key: "inRange",
      value: function(S, N) {
        var E = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, A = this.props.layout, O = S / E, T = N / E;
        if (A === "horizontal" || A === "vertical") {
          var M = this.state.offset, L = O >= M.left && O <= M.left + M.width && T >= M.top && T <= M.top + M.height;
          return L ? {
            x: O,
            y: T
          } : null;
        }
        var I = this.state, j = I.angleAxisMap, B = I.radiusAxisMap;
        if (j && B) {
          var q = Cs(j);
          return lI({
            x: O,
            y: T
          }, q);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var S = this.props.children, N = this.getTooltipEventType(), E = li(S, Oo), A = {};
        E && N === "axis" && (E.props.trigger === "click" ? A = {
          onClick: this.handleClick
        } : A = {
          onMouseEnter: this.handleMouseEnter,
          onDoubleClick: this.handleDoubleClick,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd,
          onContextMenu: this.handleContextMenu
        });
        var O = gm(this.props, this.handleOuterEvent);
        return oe(oe({}, O), A);
      }
    }, {
      key: "addListener",
      value: function() {
        y8.on(b8, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        y8.removeListener(b8, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(S, N, E) {
        for (var A = this.state.formattedGraphicalItems, O = 0, T = A.length; O < T; O++) {
          var M = A[O];
          if (M.item === S || M.props.key === S.key || N === Ta(M.item.type) && E === M.childIndex)
            return M;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var S = this.clipPathId, N = this.state.offset, E = N.left, A = N.top, O = N.height, T = N.width;
        return /* @__PURE__ */ F.createElement("defs", null, /* @__PURE__ */ F.createElement("clipPath", {
          id: S
        }, /* @__PURE__ */ F.createElement("rect", {
          x: E,
          y: A,
          height: O,
          width: T
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var S = this.state.xAxisMap;
        return S ? Object.entries(S).reduce(function(N, E) {
          var A = eL(E, 2), O = A[0], T = A[1];
          return oe(oe({}, N), {}, Ve({}, O, T.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var S = this.state.yAxisMap;
        return S ? Object.entries(S).reduce(function(N, E) {
          var A = eL(E, 2), O = A[0], T = A[1];
          return oe(oe({}, N), {}, Ve({}, O, T.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(S) {
        var N;
        return (N = this.state.xAxisMap) === null || N === void 0 || (N = N[S]) === null || N === void 0 ? void 0 : N.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(S) {
        var N;
        return (N = this.state.yAxisMap) === null || N === void 0 || (N = N[S]) === null || N === void 0 ? void 0 : N.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(S) {
        var N = this.state, E = N.formattedGraphicalItems, A = N.activeItem;
        if (E && E.length)
          for (var O = 0, T = E.length; O < T; O++) {
            var M = E[O], L = M.props, I = M.item, j = I.type.defaultProps !== void 0 ? oe(oe({}, I.type.defaultProps), I.props) : I.props, B = Ta(I.type);
            if (B === "Bar") {
              var q = (L.data || []).find(function(H) {
                return IIe(S, H);
              });
              if (q)
                return {
                  graphicalItem: M,
                  payload: q
                };
            } else if (B === "RadialBar") {
              var G = (L.data || []).find(function(H) {
                return lI(S, H);
              });
              if (G)
                return {
                  graphicalItem: M,
                  payload: G
                };
            } else if (_v(M, A) || Ev(M, A) || $h(M, A)) {
              var U = gLe({
                graphicalItem: M,
                activeTooltipItem: A,
                itemData: j.data
              }), V = j.activeIndex === void 0 ? U : j.activeIndex;
              return {
                graphicalItem: oe(oe({}, M), {}, {
                  childIndex: V
                }),
                payload: $h(M, A) ? j.data[U] : M.props.data[U]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var S = this;
        if (!xT(this))
          return null;
        var N = this.props, E = N.children, A = N.className, O = N.width, T = N.height, M = N.style, L = N.compact, I = N.title, j = N.desc, B = tL(N, Vje), q = qe(B, !1);
        if (L)
          return /* @__PURE__ */ F.createElement(F$, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ F.createElement(N7, ac({}, q, {
            width: O,
            height: T,
            title: I,
            desc: j
          }), this.renderClipPath(), CT(E, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var G, U;
          q.tabIndex = (G = this.props.tabIndex) !== null && G !== void 0 ? G : 0, q.role = (U = this.props.role) !== null && U !== void 0 ? U : "application", q.onKeyDown = function(H) {
            S.accessibilityManager.keyboardEvent(H);
          }, q.onFocus = function() {
            S.accessibilityManager.focus();
          };
        }
        var V = this.parseEventsOfWrapper();
        return /* @__PURE__ */ F.createElement(F$, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ F.createElement("div", ac({
          className: at("recharts-wrapper", A),
          style: oe({
            position: "relative",
            cursor: "default",
            width: O,
            height: T
          }, M)
        }, V, {
          ref: function(Z) {
            S.container = Z;
          }
        }), /* @__PURE__ */ F.createElement(N7, ac({}, q, {
          width: O,
          height: T,
          title: I,
          desc: j,
          style: iVe
        }), this.renderClipPath(), CT(E, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  }(rB);
  Ve(v, "displayName", n), Ve(v, "defaultProps", oe({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, f)), Ve(v, "getDerivedStateFromProps", function(y, w) {
    var C = y.dataKey, S = y.data, N = y.children, E = y.width, A = y.height, O = y.layout, T = y.stackOffset, M = y.margin, L = w.dataStartIndex, I = w.dataEndIndex;
    if (w.updateId === void 0) {
      var j = iL(y);
      return oe(oe(oe({}, j), {}, {
        updateId: 0
      }, m(oe(oe({
        props: y
      }, j), {}, {
        updateId: 0
      }), w)), {}, {
        prevDataKey: C,
        prevData: S,
        prevWidth: E,
        prevHeight: A,
        prevLayout: O,
        prevStackOffset: T,
        prevMargin: M,
        prevChildren: N
      });
    }
    if (C !== w.prevDataKey || S !== w.prevData || E !== w.prevWidth || A !== w.prevHeight || O !== w.prevLayout || T !== w.prevStackOffset || !bc(M, w.prevMargin)) {
      var B = iL(y), q = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: w.chartX,
        chartY: w.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: w.isTooltipActive
      }, G = oe(oe({}, rL(w, S, O)), {}, {
        updateId: w.updateId + 1
      }), U = oe(oe(oe({}, B), q), G);
      return oe(oe(oe({}, U), m(oe({
        props: y
      }, U), w)), {}, {
        prevDataKey: C,
        prevData: S,
        prevWidth: E,
        prevHeight: A,
        prevLayout: O,
        prevStackOffset: T,
        prevMargin: M,
        prevChildren: N
      });
    }
    if (!_7(N, w.prevChildren)) {
      var V, H, Z, de, ne = li(N, Xc), Y = ne && (V = (H = ne.props) === null || H === void 0 ? void 0 : H.startIndex) !== null && V !== void 0 ? V : L, le = ne && (Z = (de = ne.props) === null || de === void 0 ? void 0 : de.endIndex) !== null && Z !== void 0 ? Z : I, be = Y !== L || le !== I, pe = !yt(S), Ee = pe && !be ? w.updateId : w.updateId + 1;
      return oe(oe({
        updateId: Ee
      }, m(oe(oe({
        props: y
      }, w), {}, {
        updateId: Ee,
        dataStartIndex: Y,
        dataEndIndex: le
      }), w)), {}, {
        prevChildren: N,
        dataStartIndex: Y,
        dataEndIndex: le
      });
    }
    return null;
  }), Ve(v, "renderActiveDot", function(y, w, C) {
    var S;
    return /* @__PURE__ */ Pr(y) ? S = /* @__PURE__ */ cn(y, w) : Ye(y) ? S = y(w) : S = /* @__PURE__ */ F.createElement(xv, w), /* @__PURE__ */ F.createElement(zt, {
      className: "recharts-active-dot",
      key: C
    }, S);
  });
  var g = /* @__PURE__ */ te(function(w, C) {
    return /* @__PURE__ */ F.createElement(v, ac({}, w, {
      ref: C
    }));
  });
  return g.displayName = v.displayName, g;
}, lr = lQ({
  chartName: "BarChart",
  GraphicalChild: bt,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: Cn
  }, {
    axisType: "yAxis",
    AxisComp: Sn
  }],
  formatAxisMap: NFe
}), uQ = lQ({
  chartName: "RadarChart",
  GraphicalChild: Fd,
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: Ld
  }, {
    axisType: "radiusAxis",
    AxisComp: Cv
  }],
  formatAxisMap: eRe,
  defaultProps: {
    layout: "centric",
    startAngle: 90,
    endAngle: -270,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
});
const pVe = { light: "", dark: ".dark" }, cQ = x.createContext(null);
function dQ() {
  const e = x.useContext(cQ);
  if (!e)
    throw new Error("useChart must be used within a <ChartContainer />");
  return e;
}
const _n = x.forwardRef(({ id: e, className: t, children: n, config: r, ...i }, o) => {
  const a = x.useId(), s = `chart-${e || a.replace(/:/g, "")}`;
  return /* @__PURE__ */ d(cQ.Provider, { value: { config: r }, children: /* @__PURE__ */ k(
    "div",
    {
      "data-chart": s,
      ref: o,
      className: z(
        "flex aspect-video justify-center text-bodysm [&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-none [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-sector]:outline-none [&_.recharts-surface]:outline-none",
        t
      ),
      ...i,
      children: [
        /* @__PURE__ */ d(mVe, { id: s, config: r }),
        /* @__PURE__ */ d(pOe, { children: n })
      ]
    }
  ) });
});
_n.displayName = "Chart";
const mVe = ({ id: e, config: t }) => {
  const n = Object.entries(t).filter(
    ([, r]) => r.theme || r.color
  );
  return n.length ? /* @__PURE__ */ d(
    "style",
    {
      dangerouslySetInnerHTML: {
        __html: Object.entries(pVe).map(
          ([r, i]) => `
${i} [data-chart=${e}] {
${n.map(([o, a]) => {
            var l;
            const s = ((l = a.theme) == null ? void 0 : l[r]) || a.color;
            return s ? `  --color-${o}: ${s};` : null;
          }).join(`
`)}
}
`
        ).join(`
`)
      }
    }
  ) : null;
}, $n = Oo, En = x.forwardRef(
  ({
    active: e,
    payload: t,
    className: n,
    indicator: r = "dot",
    hideLabel: i = !1,
    hideIndicator: o = !1,
    label: a,
    labelFormatter: s,
    labelClassName: l,
    formatter: u,
    color: c,
    nameKey: f,
    labelKey: h
  }, m) => {
    const { config: v } = dQ(), g = x.useMemo(() => {
      var E;
      if (i || !(t != null && t.length))
        return null;
      const [w] = t, C = `${h || (w == null ? void 0 : w.dataKey) || (w == null ? void 0 : w.name) || "value"}`, S = V9(v, w, C), N = !h && typeof a == "string" ? ((E = v[a]) == null ? void 0 : E.label) || a : S == null ? void 0 : S.label;
      return s ? /* @__PURE__ */ d("div", { className: z("font-medium", l), children: s(N, t) }) : N ? /* @__PURE__ */ d("div", { className: z("font-medium", l), children: N }) : null;
    }, [
      a,
      s,
      t,
      i,
      l,
      v,
      h
    ]);
    if (!e || !(t != null && t.length))
      return null;
    const y = t.length === 1 && r !== "dot";
    return /* @__PURE__ */ k(
      "div",
      {
        ref: m,
        className: z(
          "grid min-w-[8rem] items-start gap-1.5 rounded-lg border border-border/50 bg-background px-2.5 py-1.5 text-bodysm shadow-xl",
          n
        ),
        children: [
          y ? null : g,
          /* @__PURE__ */ d("div", { className: "grid gap-1.5", children: t.map((w, C) => {
            const S = `${f || w.name || w.dataKey || "value"}`, N = V9(v, w, S), E = c || w.payload.fill || w.color;
            return /* @__PURE__ */ d(
              "div",
              {
                className: z(
                  "flex w-full flex-wrap items-stretch gap-2 [&>svg]:h-2.5 [&>svg]:w-2.5 [&>svg]:text-muted-foreground",
                  r === "dot" && "items-center"
                ),
                children: u && (w == null ? void 0 : w.value) !== void 0 && w.name ? u(w.value, w.name, w, C, w.payload) : /* @__PURE__ */ k(xe, { children: [
                  N != null && N.icon ? /* @__PURE__ */ d(N.icon, {}) : !o && /* @__PURE__ */ d(
                    "div",
                    {
                      className: z(
                        "shrink-0 rounded-[2px] border-[--color-border] bg-[--color-bg]",
                        {
                          "h-2.5 w-2.5": r === "dot",
                          "w-1": r === "line",
                          "w-0 border-[1.5px] border-dashed bg-transparent": r === "dashed",
                          "my-0.5": y && r === "dashed"
                        }
                      ),
                      style: {
                        "--color-bg": E,
                        "--color-border": E
                      }
                    }
                  ),
                  /* @__PURE__ */ k(
                    "div",
                    {
                      className: z(
                        "flex flex-1 justify-between leading-none",
                        y ? "items-end" : "items-center"
                      ),
                      children: [
                        /* @__PURE__ */ k("div", { className: "grid gap-1.5", children: [
                          y ? g : null,
                          /* @__PURE__ */ d("span", { className: "text-muted-foreground", children: (N == null ? void 0 : N.label) || w.name })
                        ] }),
                        w.value && /* @__PURE__ */ d("span", { className: "font-mono font-medium tabular-nums text-foreground", children: w.value.toLocaleString() })
                      ]
                    }
                  )
                ] })
              },
              w.dataKey
            );
          }) })
        ]
      }
    );
  }
);
En.displayName = "ChartTooltip";
const fQ = Ur, ra = x.forwardRef(
  ({ className: e, hideIcon: t = !1, payload: n, verticalAlign: r = "bottom", nameKey: i }, o) => {
    const { config: a } = dQ();
    return n != null && n.length ? /* @__PURE__ */ d(
      "div",
      {
        ref: o,
        className: z(
          "flex items-center justify-center gap-4",
          r === "top" ? "pb-3" : "pt-3",
          e
        ),
        children: n.map((s) => {
          const l = `${i || s.dataKey || "value"}`, u = V9(a, s, l);
          return /* @__PURE__ */ k(
            "div",
            {
              className: z(
                "flex items-center gap-1.5 [&>svg]:h-3 [&>svg]:w-3 [&>svg]:text-muted-foreground"
              ),
              children: [
                u != null && u.icon && !t ? /* @__PURE__ */ d(u.icon, {}) : /* @__PURE__ */ d(
                  "div",
                  {
                    className: "h-2 w-2 shrink-0 rounded-[2px]",
                    style: {
                      backgroundColor: s.color
                    }
                  }
                ),
                u == null ? void 0 : u.label
              ]
            },
            s.value
          );
        })
      }
    ) : null;
  }
);
ra.displayName = "ChartLegend";
function V9(e, t, n) {
  if (typeof t != "object" || t === null)
    return;
  const r = "payload" in t && typeof t.payload == "object" && t.payload !== null ? t.payload : void 0;
  let i = n;
  return n in t && typeof t[n] == "string" ? i = t[n] : r && n in r && typeof r[n] == "string" && (i = r[n]), i in e ? e[i] : e[n];
}
const aL = [
  "hsl(var(--chart-1))",
  "hsl(var(--chart-2))",
  "hsl(var(--chart-3))",
  "hsl(var(--chart-4))",
  "hsl(var(--chart-5))"
], gVe = {
  count: {
    label: "Count",
    color: "var(--color-redDefault)"
    // Default color
  }
};
function vVe({
  data: e,
  groupType: t,
  loading: n = !1
}) {
  const r = e.map((i, o) => ({
    name: i.error_type || "Unknown Error",
    value: i.count,
    fill: aL[o % aL.length]
    // Cycle through colors
  }));
  return /* @__PURE__ */ k(Pt, { className: "h-full w-full", children: [
    /* @__PURE__ */ k(Tt, { className: "items-center", children: [
      /* @__PURE__ */ d(Lt, { children: "Error Types" }),
      t && /* @__PURE__ */ k(ir, { children: [
        "by ",
        t.toLowerCase()
      ] })
    ] }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: n ? /* @__PURE__ */ k("div", { className: "flex h-[400px] items-end justify-between px-12 pb-16", children: [
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ d(_n, { config: gVe, className: "max-h-[400px] w-full", children: /* @__PURE__ */ k(
      lr,
      {
        accessibilityLayer: !0,
        data: r,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ d(Yn, { vertical: !1 }),
          /* @__PURE__ */ d(
            Cn,
            {
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ d(Sn, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ d($n, { content: /* @__PURE__ */ d(En, {}) }),
          /* @__PURE__ */ d(bt, { dataKey: "value", radius: [4, 4, 4, 4] })
        ]
      }
    ) }) })
  ] });
}
const w8 = {
  count: {
    label: "Count",
    color: "hsl(var(--chart-1))"
  }
};
function yVe({
  data: e,
  loading: t = !1
}) {
  const n = e.map((r) => {
    var o;
    const i = (o = r.name) == null ? void 0 : o.split(" ").map((a) => a.charAt(0).toUpperCase() + a.slice(1).toLowerCase()).join(" ");
    return {
      ...r,
      name: i
    };
  });
  return /* @__PURE__ */ k(Pt, { className: "h-full w-full", children: [
    /* @__PURE__ */ k(Tt, { className: "items-center", children: [
      /* @__PURE__ */ d(Lt, { children: "Conversation Overlays" }),
      /* @__PURE__ */ d(ir, { children: "Distribution by Overlay Type" })
    ] }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: t ? /* @__PURE__ */ k("div", { className: "relative mx-auto flex aspect-square max-h-[400px] items-center justify-center", children: [
      /* @__PURE__ */ d(me, { className: "absolute h-[80%] w-[80%] rounded-full opacity-20" }),
      /* @__PURE__ */ d(me, { className: "absolute h-[60%] w-[60%] rounded-full opacity-40" }),
      /* @__PURE__ */ d(me, { className: "absolute h-[40%] w-[40%] rounded-full opacity-60" })
    ] }) : /* @__PURE__ */ d(
      _n,
      {
        config: w8,
        className: "mx-auto aspect-square max-h-[400px]",
        children: /* @__PURE__ */ k(
          uQ,
          {
            data: n,
            margin: { top: 20, right: 40, bottom: 20, left: 40 },
            children: [
              /* @__PURE__ */ d($n, { cursor: !1, content: /* @__PURE__ */ d(En, {}) }),
              /* @__PURE__ */ d(
                Ld,
                {
                  dataKey: "name",
                  tick: { fontSize: 10 },
                  tickLine: !1,
                  style: { fontSize: 10 },
                  tickFormatter: (r) => r.length > 30 ? r.substring(0, 27) + "..." : r
                }
              ),
              /* @__PURE__ */ d(w_, {}),
              /* @__PURE__ */ d(
                Fd,
                {
                  name: "Count",
                  dataKey: "count",
                  stroke: w8.count.color,
                  fill: w8.count.color,
                  fillOpacity: 0.6,
                  dot: {
                    r: 4,
                    fillOpacity: 1
                  }
                }
              )
            ]
          }
        )
      }
    ) }),
    /* @__PURE__ */ d(tC, { className: "flex-col gap-2 text-bodysm", children: /* @__PURE__ */ d("div", { className: "text-muted-foreground flex items-center gap-2 leading-none", children: "Overlay Type Distribution Analysis" }) })
  ] });
}
const C8 = {
  in_progress: {
    label: "In Progress",
    color: "hsl(var(--chart-1))"
  },
  done: {
    label: "Done",
    color: "var(--color-greenDefault)"
  },
  off_topic: {
    label: "Off Topic",
    color: "var(--color-yellowDefault)"
  },
  errors: {
    label: "Error",
    color: "var(--color-redDefault)"
  }
};
function bVe({
  data: e,
  groupType: t,
  loading: n = !1
}) {
  const r = Object.entries(e).map(([i, o]) => ({
    name: C8[i].label,
    value: o,
    fill: C8[i].color
  }));
  return /* @__PURE__ */ k(Pt, { className: "h-full w-full", children: [
    /* @__PURE__ */ k(Tt, { className: "items-center", children: [
      /* @__PURE__ */ d(Lt, { children: "Conversation Phases" }),
      t && /* @__PURE__ */ k(ir, { children: [
        "by ",
        t.toLowerCase()
      ] })
    ] }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: n ? /* @__PURE__ */ k("div", { className: "flex h-[400px] items-end justify-between px-12 pb-16", children: [
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ d(_n, { config: C8, className: "max-h-[400px] w-full", children: /* @__PURE__ */ k(
      lr,
      {
        accessibilityLayer: !0,
        data: r,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ d(Yn, { vertical: !1 }),
          /* @__PURE__ */ d(
            Cn,
            {
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1
            }
          ),
          /* @__PURE__ */ d(Sn, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ d($n, { content: /* @__PURE__ */ d(En, {}) }),
          /* @__PURE__ */ d(bt, { dataKey: "value", radius: [4, 4, 4, 4] })
        ]
      }
    ) }) })
  ] });
}
function xVe({
  data: e,
  from: t,
  groupType: n,
  loading: r
}) {
  const i = Je(() => e.done + e.errors + e.off_topic + e.in_progress, [e]), o = Je(() => e.done, [e]), a = Je(() => e.errors + e.off_topic + e.in_progress, [e]);
  return /* @__PURE__ */ k("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ k("div", { className: "flex gap-4", children: [
      /* @__PURE__ */ d(
        Vr,
        {
          title: "Attempted",
          subtitle: "Since " + sn(To(t), "dd MMM, yyyy"),
          children: r ? "..." : i
        }
      ),
      /* @__PURE__ */ d(
        Vr,
        {
          title: "Completed",
          subtitle: "Since " + sn(To(t), "dd MMM, yyyy"),
          children: r ? "..." : o
        }
      ),
      /* @__PURE__ */ d(
        Vr,
        {
          title: "Not completed",
          subtitle: "Since " + sn(To(t), "dd MMM, yyyy"),
          children: r ? "..." : a
        }
      )
    ] }),
    /* @__PURE__ */ d(
      bVe,
      {
        data: e,
        groupType: n,
        loading: r
      }
    )
  ] });
}
const S8 = {
  abandoned: {
    label: "Abandoned",
    color: "var(--color-yellowDefault)"
  },
  completed: {
    label: "Complete",
    color: "var(--color-greenDefault)"
  },
  discarded: {
    label: "Discarded",
    color: "var(--color-yellowDefault)"
  },
  draft: {
    label: "Draft",
    color: "hsl(var(--chart-1))"
  },
  error: {
    label: "Error",
    color: "var(--color-redDefault)"
  },
  in_progress: {
    label: "In Progress",
    color: "hsl(var(--chart-1))"
  },
  off_topic: {
    label: "Blocked",
    color: "var(--color-yellowDefault)"
  },
  stuck: {
    label: "Stuck",
    color: "var(--color-redDefault)"
  }
};
function wVe({
  data: e,
  groupType: t,
  loading: n = !1
}) {
  const r = Object.entries(e).map(([i, o]) => ({
    name: S8[i].label,
    value: o,
    fill: S8[i].color
  }));
  return /* @__PURE__ */ k(Pt, { className: "h-full w-full", children: [
    /* @__PURE__ */ k(Tt, { className: "items-center", children: [
      /* @__PURE__ */ d(Lt, { children: "Conversation States" }),
      t && /* @__PURE__ */ k(ir, { children: [
        "by ",
        t.toLowerCase()
      ] })
    ] }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: n ? /* @__PURE__ */ k("div", { className: "flex h-[400px] items-end justify-between px-12 pb-16", children: [
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ d(_n, { config: S8, className: "max-h-[400px] w-full", children: /* @__PURE__ */ k(
      lr,
      {
        accessibilityLayer: !0,
        data: r,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ d(Yn, { vertical: !1 }),
          /* @__PURE__ */ d(
            Cn,
            {
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1
            }
          ),
          /* @__PURE__ */ d(Sn, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ d($n, { content: /* @__PURE__ */ d(En, {}) }),
          /* @__PURE__ */ d(bt, { dataKey: "value", radius: [4, 4, 4, 4] })
        ]
      }
    ) }) })
  ] });
}
function CVe({
  data: e,
  from: t,
  groupType: n,
  loading: r
}) {
  const i = Je(() => Object.keys(e).reduce(
    (l, u) => l + (e[u] || 0),
    0
  ), [e]), o = Je(() => e.draft, [e]), a = Je(() => e.completed, [e]), s = Je(() => e.abandoned + e.discarded + e.draft + e.error + e.off_topic + e.in_progress + e.stuck, [e]);
  return /* @__PURE__ */ k("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ k("div", { className: "flex gap-4", children: [
      /* @__PURE__ */ d(
        Vr,
        {
          title: "Attempted",
          subtitle: "Since " + sn(To(t), "dd MMM, yyyy"),
          children: r ? "..." : i
        }
      ),
      /* @__PURE__ */ d(
        Vr,
        {
          title: "Draft",
          subtitle: "Since " + sn(To(t), "dd MMM, yyyy"),
          children: r ? "..." : o
        }
      ),
      /* @__PURE__ */ d(
        Vr,
        {
          title: "Completed",
          subtitle: "Since " + sn(To(t), "dd MMM, yyyy"),
          children: r ? "..." : a
        }
      ),
      /* @__PURE__ */ d(
        Vr,
        {
          title: "Not completed",
          subtitle: "Since " + sn(To(t), "dd MMM, yyyy"),
          children: r ? "..." : s
        }
      )
    ] }),
    /* @__PURE__ */ d(
      wVe,
      {
        data: e,
        groupType: n,
        loading: r
      }
    )
  ] });
}
const wf = {
  completed: {
    label: "Complete",
    color: "var(--color-greenDefault)"
  },
  off_topic: {
    label: "Blocked",
    color: "var(--color-purpleDefault)"
  },
  abandoned: {
    label: "Abandoned",
    color: "var(--color-yellowDefault)"
  },
  address_out_of_scope: {
    label: "Out of scope",
    color: "var(--color-redDefault)"
  }
};
function SVe({
  data: e,
  groupType: t,
  loading: n = !1
}) {
  return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
    /* @__PURE__ */ k(Tt, { children: [
      /* @__PURE__ */ d(Lt, { children: "Conversation volume" }),
      t && /* @__PURE__ */ k(ir, { children: [
        "by ",
        t.toLowerCase()
      ] })
    ] }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: n ? /* @__PURE__ */ k("div", { className: "flex h-[400px] items-end justify-between gap-2 px-12 pb-16", children: [
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ d(_n, { config: wf, className: "h-[400px] w-full", children: /* @__PURE__ */ k(
      lr,
      {
        accessibilityLayer: !0,
        data: e,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ d(Yn, { vertical: !1 }),
          /* @__PURE__ */ d(
            Cn,
            {
              dataKey: "week_start",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ d(Sn, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ d($n, { content: /* @__PURE__ */ d(En, {}) }),
          /* @__PURE__ */ d(
            Ur,
            {
              content: /* @__PURE__ */ d(ra, {}),
              verticalAlign: "top",
              align: "right"
            }
          ),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "completed",
              stackId: "a",
              fill: wf.completed.color,
              radius: [0, 0, 4, 4],
              name: "Completed"
            }
          ),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "off_topic",
              stackId: "a",
              fill: wf.off_topic.color,
              radius: [0, 0, 0, 0],
              name: "Off Topic"
            }
          ),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "abandoned",
              stackId: "a",
              fill: wf.abandoned.color,
              radius: [0, 0, 0, 0],
              name: "Abandoned"
            }
          ),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "address_out_of_scope",
              stackId: "a",
              fill: wf.address_out_of_scope.color,
              radius: [4, 4, 0, 0],
              name: "Out of scope"
            }
          )
        ]
      }
    ) }) })
  ] });
}
function _Ve({
  data: e,
  from: t,
  groupType: n,
  loading: r
}) {
  const i = Je(() => e.reduce((c, f) => c + (f.completed || 0) + (f.off_topic || 0) + (f.abandoned || 0) + (f.address_out_of_scope || 0), 0), [e]), o = Je(() => e.reduce((c, f) => c + (f.completed || 0), 0), [e]), a = Je(() => e.reduce((c, f) => c + (f.off_topic || 0), 0), [e]), s = Je(() => e.reduce((c, f) => c + (f.abandoned || 0), 0), [e]), l = Je(() => e.reduce((c, f) => c + (f.address_out_of_scope || 0), 0), [e]), u = (c) => {
    try {
      return sn(To(c), "dd MMM, yyyy");
    } catch {
      return "na";
    }
  };
  return /* @__PURE__ */ k("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ k("div", { className: "flex gap-4", children: [
      /* @__PURE__ */ d(
        Vr,
        {
          title: "Total conversations",
          subtitle: "Since " + u(t),
          children: r ? "..." : i
        }
      ),
      /* @__PURE__ */ d(Vr, { title: "Completed", subtitle: "Since " + u(t), children: r ? "..." : o }),
      /* @__PURE__ */ d(Vr, { title: "Off topic", subtitle: "Since " + u(t), children: r ? "..." : a }),
      /* @__PURE__ */ d(Vr, { title: "Abandoned", subtitle: "Since " + u(t), children: r ? "..." : s }),
      /* @__PURE__ */ d(
        Vr,
        {
          title: "Addresses offboarded",
          subtitle: "Since " + u(t),
          children: r ? "..." : l
        }
      )
    ] }),
    /* @__PURE__ */ d(
      SVe,
      {
        data: e,
        groupType: n,
        loading: r
      }
    )
  ] });
}
const _8 = {
  count: {
    label: "Count",
    color: "hsl(var(--chart-1))"
  }
};
function EVe({
  data: e,
  loading: t = !1
}) {
  const n = e.map((r) => {
    var o;
    const i = (o = r.name) == null ? void 0 : o.replace(/\bZONE\b/gi, "").trim().split(" ").map((a) => a.charAt(0).toUpperCase() + a.slice(1).toLowerCase()).join(" ");
    return {
      ...r,
      name: `${i} (${r.percentage.toFixed(1)}%)`
    };
  });
  return /* @__PURE__ */ k(Pt, { className: "h-full w-full", children: [
    /* @__PURE__ */ k(Tt, { className: "items-center", children: [
      /* @__PURE__ */ d(Lt, { children: "Conversation Zones" }),
      /* @__PURE__ */ d(ir, { children: "Distribution by Zone Type" })
    ] }),
    /* @__PURE__ */ d(Mt, { className: "pb-0", children: t ? /* @__PURE__ */ k("div", { className: "relative mx-auto flex aspect-square max-h-[400px] items-center justify-center", children: [
      /* @__PURE__ */ d(me, { className: "absolute h-[80%] w-[80%] rounded-full opacity-20" }),
      /* @__PURE__ */ d(me, { className: "absolute h-[60%] w-[60%] rounded-full opacity-40" }),
      /* @__PURE__ */ d(me, { className: "absolute h-[40%] w-[40%] rounded-full opacity-60" })
    ] }) : /* @__PURE__ */ d(
      _n,
      {
        config: _8,
        className: "mx-auto aspect-square max-h-[400px]",
        children: /* @__PURE__ */ k(
          uQ,
          {
            data: n,
            margin: { top: 20, right: 40, bottom: 20, left: 40 },
            children: [
              /* @__PURE__ */ d($n, { cursor: !1, content: /* @__PURE__ */ d(En, {}) }),
              /* @__PURE__ */ d(
                Ld,
                {
                  dataKey: "name",
                  tick: { fontSize: 10 },
                  tickLine: !1,
                  style: { fontSize: 10 },
                  tickFormatter: (r) => r.length > 30 ? r.substring(0, 27) + "..." : r
                }
              ),
              /* @__PURE__ */ d(w_, {}),
              /* @__PURE__ */ d(
                Fd,
                {
                  name: "Count",
                  dataKey: "count",
                  stroke: _8.count.color,
                  fill: _8.count.color,
                  fillOpacity: 0.6,
                  dot: {
                    r: 4,
                    fillOpacity: 1
                  }
                }
              )
            ]
          }
        )
      }
    ) }),
    /* @__PURE__ */ d(tC, { className: "flex-col gap-2 text-bodysm", children: /* @__PURE__ */ d("div", { className: "text-muted-foreground flex items-center gap-2 leading-none", children: "Zone Type Distribution Analysis" }) })
  ] });
}
const NVe = (e) => e.length > 30 ? e.substring(0, 30) + "..." : e, AVe = (e) => {
  const t = e.toLowerCase();
  return t.includes("residential") ? "bg-blue-50 text-blue-700 border-blue-200" : t.includes("green") || t.includes("wedge") ? "bg-green-50 text-green-700 border-green-200" : t.includes("conservation") || t.includes("rural") ? "bg-amber-50 text-amber-700 border-amber-200" : t.includes("general") ? "bg-purple-50 text-purple-700 border-purple-200" : "bg-gray-50 text-gray-700 border-gray-200";
};
function OVe({
  data: e,
  title: t = "Outcome by Zone",
  loading: n = !1
}) {
  const r = F.useMemo(() => e.reduce(
    (f, h) => ({
      permitRequired: f.permitRequired + h.permitRequired,
      noPermitRequired: f.noPermitRequired + h.noPermitRequired,
      moreInformationRequired: f.moreInformationRequired + h.moreInformationRequired,
      prohibited: f.prohibited + h.prohibited,
      accepted: f.accepted + h.accepted,
      selfAssess: f.selfAssess + h.selfAssess,
      code: f.code + h.code,
      impact: f.impact + h.impact,
      total: f.total + h.total
    }),
    {
      permitRequired: 0,
      noPermitRequired: 0,
      moreInformationRequired: 0,
      prohibited: 0,
      total: 0,
      selfAssess: 0,
      accepted: 0,
      code: 0,
      impact: 0
    }
  ), [e]);
  if (n)
    return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
      /* @__PURE__ */ d(Tt, { className: "pb-3", children: /* @__PURE__ */ d(Lt, { className: "text-bodylg font-semibold", children: t }) }),
      /* @__PURE__ */ d(Mt, { children: /* @__PURE__ */ d("div", { className: "space-y-2", children: [...Array(5)].map((f, h) => /* @__PURE__ */ d("div", { className: "h-12 animate-pulse rounded bg-gray-100" }, h)) }) })
    ] });
  const i = e.some((f) => f.noPermitRequired > 0), o = e.some(
    (f) => f.moreInformationRequired > 0
  ), a = e.some((f) => f.prohibited > 0), s = e.some((f) => f.accepted > 0), l = e.some((f) => f.selfAssess > 0), u = e.some((f) => f.code > 0), c = e.some((f) => f.impact > 0);
  return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
    /* @__PURE__ */ d(Tt, { className: "pb-3", children: /* @__PURE__ */ d(Lt, { className: "text-bodylg font-semibold text-gray-900", children: t }) }),
    /* @__PURE__ */ d(Mt, { children: /* @__PURE__ */ k(wd, { children: [
      /* @__PURE__ */ d(Cd, { children: /* @__PURE__ */ k(rr, { className: "bg-gray-50", children: [
        /* @__PURE__ */ d(jt, { className: "w-1/3 font-medium text-gray-700", children: "Zone name, outcome" }),
        /* @__PURE__ */ d(jt, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ d(
          Tn,
          {
            variant: "default",
            className: "border-amber-200 bg-amber-100 text-amber-800 hover:bg-amber-100",
            children: "Permit required"
          }
        ) }),
        i && /* @__PURE__ */ d(jt, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ d(
          Tn,
          {
            variant: "secondary",
            className: "border-green-200 bg-green-100 text-green-800 hover:bg-green-100",
            children: "No permit required"
          }
        ) }),
        o && /* @__PURE__ */ d(jt, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ d(
          Tn,
          {
            variant: "outline",
            className: "border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-50",
            children: "More information required"
          }
        ) }),
        a && /* @__PURE__ */ d(jt, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ d(
          Tn,
          {
            variant: "destructive",
            className: "border-red-200 bg-red-100 text-red-800 hover:bg-red-100",
            children: "Prohibited"
          }
        ) }),
        s && /* @__PURE__ */ d(jt, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ d(
          Tn,
          {
            variant: "destructive",
            className: "border-green-200 bg-green-100 text-green-800 hover:bg-green-100",
            children: "Accepted"
          }
        ) }),
        l && /* @__PURE__ */ d(jt, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ d(
          Tn,
          {
            variant: "destructive",
            className: "border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-50",
            children: "Self assess"
          }
        ) }),
        u && /* @__PURE__ */ d(jt, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ d(
          Tn,
          {
            variant: "destructive",
            className: "border-amber-200 bg-amber-100 text-amber-800 hover:bg-amber-100",
            children: "Code"
          }
        ) }),
        c && /* @__PURE__ */ d(jt, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ d(
          Tn,
          {
            variant: "destructive",
            className: "border-amber-200 bg-amber-100 text-amber-800 hover:bg-amber-100",
            children: "Impact"
          }
        ) }),
        /* @__PURE__ */ d(jt, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ d("strong", { children: "Total" }) })
      ] }) }),
      /* @__PURE__ */ k(Sd, { children: [
        e.map((f, h) => /* @__PURE__ */ k(rr, { className: "hover:bg-gray-50", children: [
          /* @__PURE__ */ d(Fe, { className: "font-medium", children: /* @__PURE__ */ d(
            Tn,
            {
              variant: "outline",
              className: `${AVe(f.zone)} font-normal`,
              children: NVe(f.zone)
            }
          ) }),
          /* @__PURE__ */ d(Fe, { className: "text-center", children: f.permitRequired }),
          i && /* @__PURE__ */ d(Fe, { className: "text-center", children: f.noPermitRequired }),
          o && /* @__PURE__ */ d(Fe, { className: "text-center", children: f.moreInformationRequired }),
          a && /* @__PURE__ */ d(Fe, { className: "text-center", children: f.prohibited }),
          s && /* @__PURE__ */ d(Fe, { className: "text-center", children: f.accepted }),
          l && /* @__PURE__ */ d(Fe, { className: "text-center", children: f.selfAssess }),
          u && /* @__PURE__ */ d(Fe, { className: "text-center", children: f.code }),
          c && /* @__PURE__ */ d(Fe, { className: "text-center", children: f.impact }),
          /* @__PURE__ */ d(Fe, { className: "text-center font-semibold", children: f.total })
        ] }, h)),
        /* @__PURE__ */ k(rr, { className: "border-t-2 bg-gray-50 font-semibold", children: [
          /* @__PURE__ */ d(Fe, { className: "font-bold", children: "Total" }),
          /* @__PURE__ */ d(Fe, { className: "text-center font-bold", children: r.permitRequired }),
          i && /* @__PURE__ */ d(Fe, { className: "text-center font-bold", children: r.noPermitRequired }),
          o && /* @__PURE__ */ d(Fe, { className: "text-center font-bold", children: r.moreInformationRequired }),
          a && /* @__PURE__ */ d(Fe, { className: "text-center font-bold", children: r.prohibited }),
          s && /* @__PURE__ */ d(Fe, { className: "text-center font-bold", children: r.accepted }),
          l && /* @__PURE__ */ d(Fe, { className: "text-center font-bold", children: r.selfAssess }),
          u && /* @__PURE__ */ d(Fe, { className: "text-center font-bold", children: r.code }),
          c && /* @__PURE__ */ d(Fe, { className: "text-center font-bold", children: r.impact }),
          /* @__PURE__ */ d(Fe, { className: "text-center font-bold", children: r.total })
        ] })
      ] })
    ] }) })
  ] });
}
const kVe = (e) => e.length > 30 ? e.substring(0, 30) + "..." : e, PVe = (e) => {
  const t = e.toLowerCase();
  return t.includes("residential") ? "bg-blue-50 text-blue-700 border-blue-200" : t.includes("green") || t.includes("wedge") ? "bg-green-50 text-green-700 border-green-200" : t.includes("conservation") || t.includes("rural") ? "bg-amber-50 text-amber-700 border-amber-200" : t.includes("general") ? "bg-purple-50 text-purple-700 border-purple-200" : "bg-gray-50 text-gray-700 border-gray-200";
};
function TVe({
  data: e,
  title: t = "Outcome by Overlay",
  loading: n = !1
}) {
  const r = F.useMemo(() => e.reduce(
    (f, h) => ({
      permitRequired: f.permitRequired + h.permitRequired,
      noPermitRequired: f.noPermitRequired + h.noPermitRequired,
      moreInformationRequired: f.moreInformationRequired + h.moreInformationRequired,
      prohibited: f.prohibited + h.prohibited,
      accepted: f.accepted + (h.accepted || 0),
      selfAssess: f.selfAssess + (h.selfAssess || 0),
      code: f.code + (h.code || 0),
      impact: f.impact + (h.impact || 0),
      total: f.total + h.total
    }),
    {
      permitRequired: 0,
      noPermitRequired: 0,
      moreInformationRequired: 0,
      prohibited: 0,
      accepted: 0,
      selfAssess: 0,
      code: 0,
      impact: 0,
      total: 0
    }
  ), [e]);
  if (n)
    return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
      /* @__PURE__ */ d(Tt, { className: "pb-3", children: /* @__PURE__ */ d(Lt, { className: "text-bodylg font-semibold", children: t }) }),
      /* @__PURE__ */ d(Mt, { children: /* @__PURE__ */ d("div", { className: "space-y-2", children: [...Array(5)].map((f, h) => /* @__PURE__ */ d("div", { className: "h-12 animate-pulse rounded bg-gray-100" }, h)) }) })
    ] });
  const i = e.some((f) => f.noPermitRequired > 0), o = e.some(
    (f) => f.moreInformationRequired > 0
  ), a = e.some((f) => f.prohibited > 0), s = e.some((f) => f.accepted > 0), l = e.some((f) => f.selfAssess > 0), u = e.some((f) => f.code > 0), c = e.some((f) => f.impact > 0);
  return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
    /* @__PURE__ */ d(Tt, { className: "pb-3", children: /* @__PURE__ */ d(Lt, { className: "text-bodylg font-semibold text-gray-900", children: t }) }),
    /* @__PURE__ */ d(Mt, { children: /* @__PURE__ */ k(wd, { children: [
      /* @__PURE__ */ d(Cd, { children: /* @__PURE__ */ k(rr, { className: "bg-gray-50", children: [
        /* @__PURE__ */ d(jt, { className: "w-1/3 font-medium text-gray-700", children: "Overlay name, outcome" }),
        /* @__PURE__ */ d(jt, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ d(
          Tn,
          {
            variant: "default",
            className: "border-amber-200 bg-amber-100 text-amber-800 hover:bg-amber-100",
            children: "Permit required"
          }
        ) }),
        i && /* @__PURE__ */ d(jt, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ d(
          Tn,
          {
            variant: "secondary",
            className: "border-green-200 bg-green-100 text-green-800 hover:bg-green-100",
            children: "No permit required"
          }
        ) }),
        o && /* @__PURE__ */ d(jt, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ d(
          Tn,
          {
            variant: "outline",
            className: "border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-50",
            children: "More information required"
          }
        ) }),
        a && /* @__PURE__ */ d(jt, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ d(
          Tn,
          {
            variant: "destructive",
            className: "border-red-200 bg-red-100 text-red-800 hover:bg-red-100",
            children: "Prohibited"
          }
        ) }),
        s && /* @__PURE__ */ d(jt, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ d(
          Tn,
          {
            variant: "destructive",
            className: "border-green-200 bg-green-100 text-green-800 hover:bg-green-100",
            children: "Accepted"
          }
        ) }),
        l && /* @__PURE__ */ d(jt, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ d(
          Tn,
          {
            variant: "destructive",
            className: "border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-50",
            children: "Self assess"
          }
        ) }),
        u && /* @__PURE__ */ d(jt, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ d(
          Tn,
          {
            variant: "destructive",
            className: "border-amber-200 bg-amber-100 text-amber-800 hover:bg-amber-100",
            children: "Code"
          }
        ) }),
        c && /* @__PURE__ */ d(jt, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ d(
          Tn,
          {
            variant: "destructive",
            className: "border-amber-200 bg-amber-100 text-amber-800 hover:bg-amber-100",
            children: "Impact"
          }
        ) }),
        /* @__PURE__ */ d(jt, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ d("strong", { children: "Total" }) })
      ] }) }),
      /* @__PURE__ */ k(Sd, { children: [
        e.map((f, h) => /* @__PURE__ */ k(rr, { className: "hover:bg-gray-50", children: [
          /* @__PURE__ */ d(Fe, { className: "font-medium", children: /* @__PURE__ */ d(
            Tn,
            {
              title: f.overlay,
              variant: "outline",
              className: `${PVe(f.overlay)} font-normal`,
              children: kVe(f.overlay)
            }
          ) }),
          /* @__PURE__ */ d(Fe, { className: "text-center", children: f.permitRequired }),
          i && /* @__PURE__ */ d(Fe, { className: "text-center", children: f.noPermitRequired }),
          o && /* @__PURE__ */ d(Fe, { className: "text-center", children: f.moreInformationRequired }),
          a && /* @__PURE__ */ d(Fe, { className: "text-center", children: f.prohibited }),
          s && /* @__PURE__ */ d(Fe, { className: "text-center", children: f.accepted || 0 }),
          l && /* @__PURE__ */ d(Fe, { className: "text-center", children: f.selfAssess || 0 }),
          u && /* @__PURE__ */ d(Fe, { className: "text-center", children: f.code || 0 }),
          c && /* @__PURE__ */ d(Fe, { className: "text-center", children: f.impact || 0 }),
          /* @__PURE__ */ d(Fe, { className: "text-center font-semibold", children: f.total })
        ] }, h)),
        /* @__PURE__ */ k(rr, { className: "border-t-2 bg-gray-50 font-semibold", children: [
          /* @__PURE__ */ d(Fe, { className: "font-bold", children: "Total" }),
          /* @__PURE__ */ d(Fe, { className: "text-center font-bold", children: r.permitRequired }),
          i && /* @__PURE__ */ d(Fe, { className: "text-center font-bold", children: r.noPermitRequired }),
          o && /* @__PURE__ */ d(Fe, { className: "text-center font-bold", children: r.moreInformationRequired }),
          a && /* @__PURE__ */ d(Fe, { className: "text-center font-bold", children: r.prohibited }),
          s && /* @__PURE__ */ d(Fe, { className: "text-center font-bold", children: r.accepted }),
          l && /* @__PURE__ */ d(Fe, { className: "text-center font-bold", children: r.selfAssess }),
          u && /* @__PURE__ */ d(Fe, { className: "text-center font-bold", children: r.code }),
          c && /* @__PURE__ */ d(Fe, { className: "text-center font-bold", children: r.impact }),
          /* @__PURE__ */ d(Fe, { className: "text-center font-bold", children: r.total })
        ] })
      ] })
    ] }) })
  ] });
}
const q9 = [
  "hsl(var(--chart-1))",
  "hsl(var(--chart-2))",
  "hsl(var(--chart-3))",
  "hsl(var(--chart-4))",
  "hsl(var(--chart-5))"
], MVe = {
  count: {
    label: "Avg cost",
    color: q9[0]
  }
};
function RVe({
  data: e,
  loading: t = !1
}) {
  const n = e.map((r, i) => ({
    name: r.identifier,
    value: r.average_cost,
    fill: q9[i % q9.length]
    // Cycle through colors
  }));
  return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
    /* @__PURE__ */ d(Tt, { children: /* @__PURE__ */ d(Lt, { children: "Average cost" }) }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: t ? /* @__PURE__ */ k("div", { className: "flex h-[400px] items-end justify-between px-12 pb-16", children: [
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ d(_n, { config: MVe, className: "h-[400px] w-full", children: /* @__PURE__ */ k(
      lr,
      {
        accessibilityLayer: !0,
        data: n,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ d(Yn, { vertical: !1 }),
          /* @__PURE__ */ d(
            Cn,
            {
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ d(Sn, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ d($n, { content: /* @__PURE__ */ d(En, {}) }),
          /* @__PURE__ */ d(bt, { dataKey: "value", radius: [4, 4, 4, 4] })
        ]
      }
    ) }) })
  ] });
}
const z9 = [
  "hsl(var(--chart-1))",
  "hsl(var(--chart-2))",
  "hsl(var(--chart-3))",
  "hsl(var(--chart-4))",
  "hsl(var(--chart-5))"
], DVe = {
  count: {
    label: "Avg cost",
    color: z9[0]
  }
};
function IVe({
  data: e,
  loading: t = !1
}) {
  const n = e.map((r, i) => ({
    name: r.identifier,
    value: r.average_cost,
    fill: z9[i % z9.length]
    // Cycle through colors
  }));
  return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
    /* @__PURE__ */ d(Tt, { children: /* @__PURE__ */ d(Lt, { children: "Average cost pre report" }) }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: t ? /* @__PURE__ */ k("div", { className: "flex h-[400px] items-end justify-between px-12 pb-16", children: [
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ d(_n, { config: DVe, className: "h-[400px] w-full", children: /* @__PURE__ */ k(
      lr,
      {
        accessibilityLayer: !0,
        data: n,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ d(Yn, { vertical: !1 }),
          /* @__PURE__ */ d(
            Cn,
            {
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ d(Sn, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ d($n, { content: /* @__PURE__ */ d(En, {}) }),
          /* @__PURE__ */ d(bt, { dataKey: "value", radius: [4, 4, 4, 4] })
        ]
      }
    ) }) })
  ] });
}
const W9 = [
  "hsl(var(--chart-1))",
  "hsl(var(--chart-2))",
  "hsl(var(--chart-3))",
  "hsl(var(--chart-4))",
  "hsl(var(--chart-5))"
], $Ve = {
  count: {
    label: "Avg cost",
    color: W9[0]
  }
};
function LVe({
  data: e,
  loading: t = !1
}) {
  const n = e.map((r, i) => ({
    name: r.identifier,
    value: r.average_cost,
    fill: W9[i % W9.length]
    // Cycle through colors
  }));
  return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
    /* @__PURE__ */ d(Tt, { children: /* @__PURE__ */ d(Lt, { children: "Average cost report" }) }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: t ? /* @__PURE__ */ k("div", { className: "flex h-[400px] items-end justify-between px-12 pb-16", children: [
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ d(_n, { config: $Ve, className: "h-[400px] w-full", children: /* @__PURE__ */ k(
      lr,
      {
        accessibilityLayer: !0,
        data: n,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ d(Yn, { vertical: !1 }),
          /* @__PURE__ */ d(
            Cn,
            {
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ d(Sn, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ d($n, { content: /* @__PURE__ */ d(En, {}) }),
          /* @__PURE__ */ d(bt, { dataKey: "value", radius: [4, 4, 4, 4] })
        ]
      }
    ) }) })
  ] });
}
const H9 = [
  "hsl(var(--chart-1))",
  "hsl(var(--chart-2))",
  "hsl(var(--chart-3))",
  "hsl(var(--chart-4))",
  "hsl(var(--chart-5))"
], FVe = {
  count: {
    label: "Avg cost",
    color: H9[0]
  }
};
function BVe({
  data: e,
  loading: t = !1
}) {
  const n = e.map((r, i) => ({
    name: r.identifier,
    value: r.average_cost,
    fill: H9[i % H9.length]
    // Cycle through colors
  }));
  return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
    /* @__PURE__ */ d(Tt, { children: /* @__PURE__ */ d(Lt, { children: "Average cost report" }) }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: t ? /* @__PURE__ */ k("div", { className: "flex h-[400px] items-end justify-between px-12 pb-16", children: [
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ d(_n, { config: FVe, className: "h-[400px] w-full", children: /* @__PURE__ */ k(
      lr,
      {
        accessibilityLayer: !0,
        data: n,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ d(Yn, { vertical: !1 }),
          /* @__PURE__ */ d(
            Cn,
            {
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ d(Sn, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ d($n, { content: /* @__PURE__ */ d(En, {}) }),
          /* @__PURE__ */ d(bt, { dataKey: "value", radius: [4, 4, 4, 4] })
        ]
      }
    ) }) })
  ] });
}
const E8 = {
  flagged_for_council_reviewed: {
    label: "Flagged, reviewed",
    color: "hsl(var(--chart-1))"
  },
  flagged_for_council_not_reviewed: {
    label: "Flagged, not reviewed",
    color: "var(--color-yellowDefault)"
  }
  // not_flagged: {
  //   label: "Not flagged",
  //   color: "hsl(var(--chart-3))",
  // },
};
function jVe({
  data: e,
  groupType: t,
  loading: n = !1
}) {
  return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
    /* @__PURE__ */ k(Tt, { children: [
      /* @__PURE__ */ d(Lt, { children: "Conversations flagged for review" }),
      t && /* @__PURE__ */ k(ir, { children: [
        "by ",
        t.toLowerCase()
      ] })
    ] }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: n ? /* @__PURE__ */ k("div", { className: "flex h-[400px] items-end justify-between gap-2 px-12 pb-16", children: [
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ d(_n, { config: E8, className: "h-[400px] w-full", children: /* @__PURE__ */ k(
      lr,
      {
        accessibilityLayer: !0,
        data: e,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ d(Yn, { vertical: !1 }),
          /* @__PURE__ */ d(
            Cn,
            {
              dataKey: "time",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ d(Sn, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ d($n, { content: /* @__PURE__ */ d(En, {}) }),
          /* @__PURE__ */ d(
            Ur,
            {
              content: /* @__PURE__ */ d(ra, {}),
              verticalAlign: "top",
              align: "right"
            }
          ),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "flagged_for_council_reviewed",
              stackId: "a",
              fill: E8.flagged_for_council_reviewed.color,
              radius: [0, 0, 4, 4],
              name: "Flagged, reviewed"
            }
          ),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "flagged_for_council_not_reviewed",
              stackId: "a",
              fill: E8.flagged_for_council_not_reviewed.color,
              radius: [4, 4, 0, 0],
              name: "Flagged, not reviewed"
            }
          )
        ]
      }
    ) }) })
  ] });
}
const Cf = {
  completed: {
    label: "Completed",
    color: "var(--color-greenDefault)"
  },
  reviewed: {
    label: "Reviewed",
    color: "hsl(var(--chart-1))"
  },
  review_needed: {
    label: "Flagged",
    color: "var(--color-yellowDefault)"
  },
  report_correct: {
    label: "Report correct",
    color: "var(--color-blueDefault)"
  },
  report_incorrect: {
    label: "Report incorrect",
    color: "var(--color-redDefault)"
  }
};
function VVe({
  data: e,
  groupType: t,
  loading: n = !1
}) {
  return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
    /* @__PURE__ */ k(Tt, { children: [
      /* @__PURE__ */ d(Lt, { children: "Conversations flagged for review" }),
      t && /* @__PURE__ */ k(ir, { children: [
        "by ",
        t.toLowerCase()
      ] })
    ] }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: n ? /* @__PURE__ */ k("div", { className: "flex h-[400px] items-end justify-between gap-2 px-12 pb-16", children: [
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ d(_n, { config: Cf, className: "h-[400px] w-full", children: /* @__PURE__ */ k(
      lr,
      {
        accessibilityLayer: !0,
        data: e,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ d(Yn, { vertical: !1 }),
          /* @__PURE__ */ d(
            Cn,
            {
              dataKey: "week_start",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ d(Sn, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ d($n, { content: /* @__PURE__ */ d(En, {}) }),
          /* @__PURE__ */ d(
            Ur,
            {
              content: /* @__PURE__ */ d(ra, {}),
              verticalAlign: "top",
              align: "right"
            }
          ),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "completed",
              fill: Cf.completed.color,
              radius: [4, 4, 0, 0],
              name: "Completed"
            }
          ),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "review_needed",
              fill: Cf.review_needed.color,
              radius: [4, 4, 0, 0],
              name: "Flagged"
            }
          ),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "reviewed",
              fill: Cf.reviewed.color,
              radius: [4, 4, 0, 0],
              name: "Reviewed"
            }
          ),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "report_correct",
              fill: Cf.report_correct.color,
              radius: [4, 4, 0, 0],
              name: "Report correct"
            }
          )
        ]
      }
    ) }) })
  ] });
}
function qVe({
  data: e = [],
  loading: t = !1
}) {
  const n = Je(() => [...e].sort(
    (r, i) => i.reviewed_last_week - r.reviewed_last_week
  ), [e]);
  return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
    /* @__PURE__ */ k(Tt, { children: [
      /* @__PURE__ */ d(Lt, { children: "Review Leaderboard" }),
      /* @__PURE__ */ d(ir, { children: "Planner review activity" })
    ] }),
    /* @__PURE__ */ d(Mt, { children: /* @__PURE__ */ k(wd, { children: [
      /* @__PURE__ */ d(Cd, { children: /* @__PURE__ */ k(rr, { children: [
        /* @__PURE__ */ d(jt, { className: "w-[200px]", children: "Name" }),
        /* @__PURE__ */ d(jt, { className: "text-center", children: "Reviews this week" }),
        /* @__PURE__ */ d(jt, { className: "text-center", children: "Reviews all time" })
      ] }) }),
      /* @__PURE__ */ d(Sd, { children: t ? /* @__PURE__ */ d(rr, { children: /* @__PURE__ */ d(Fe, { colSpan: 3, className: "py-8 text-center", children: "Loading..." }) }) : n.length === 0 ? /* @__PURE__ */ d(rr, { children: /* @__PURE__ */ d(Fe, { colSpan: 3, className: "py-8 text-center", children: "No review data available" }) }) : n.map((r) => /* @__PURE__ */ k(
        rr,
        {
          className: "border-interfaceBorder",
          children: [
            /* @__PURE__ */ d(Fe, { children: r.reviewer }),
            /* @__PURE__ */ d(Fe, { className: "text-center", children: r.reviewed_last_week }),
            /* @__PURE__ */ d(Fe, { className: "text-center", children: r.reviewed_all_time })
          ]
        },
        r.reviewer
      )) })
    ] }) })
  ] });
}
function zVe({
  data: e = [],
  loading: t = !1
}) {
  return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
    /* @__PURE__ */ k(Tt, { className: "pb-3", children: [
      /* @__PURE__ */ d(Lt, { children: "Review Leaderboard" }),
      /* @__PURE__ */ d(ir, { children: "Planner review activity" })
    ] }),
    /* @__PURE__ */ k(Mt, { className: "flex flex-col gap-2", children: [
      t && /* @__PURE__ */ d("p", { children: "Loading..." }),
      !t && e.length === 0 && /* @__PURE__ */ d("p", { children: "No review data available" }),
      !t && e.length > 0 && e.map((n) => {
        const r = Object.entries(n.reviewers);
        return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
          /* @__PURE__ */ d(Tt, { className: "p-3 pb-0", children: /* @__PURE__ */ k(ir, { children: [
            "Reviews for week of:",
            " ",
            /* @__PURE__ */ k("span", { className: "font-medium", children: [
              n.week_start,
              " to ",
              n.week_end
            ] })
          ] }) }),
          /* @__PURE__ */ d(Mt, { className: "p-3 pt-0", children: /* @__PURE__ */ k(wd, { children: [
            /* @__PURE__ */ d(Cd, { children: /* @__PURE__ */ k(rr, { children: [
              /* @__PURE__ */ d(jt, { className: "w-[200px]", children: "Email" }),
              /* @__PURE__ */ d(jt, { children: "Conversations reviewed" })
            ] }) }),
            /* @__PURE__ */ k(Sd, { children: [
              r.length > 0 && r.map(([i, o]) => /* @__PURE__ */ k(
                rr,
                {
                  className: "border-interfaceBorder",
                  children: [
                    /* @__PURE__ */ d(Fe, { children: i }),
                    /* @__PURE__ */ d(Fe, { children: o })
                  ]
                },
                i
              )),
              r.length === 0 && /* @__PURE__ */ d(rr, { className: "border-interfaceBorder", children: /* @__PURE__ */ d(
                Fe,
                {
                  className: "text-bodyxs text-textSubdued",
                  colSpan: 2,
                  children: "No reviews for this period"
                }
              ) })
            ] })
          ] }) })
        ] });
      })
    ] })
  ] });
}
const N8 = {
  sent_to_council: {
    label: "Complete",
    color: "hsl(var(--chart-1))"
  },
  off_topic: {
    label: "Off Topic",
    color: "var(--color-yellowDefault)"
  }
};
function WVe({
  data: e,
  groupType: t,
  loading: n = !1
}) {
  return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
    /* @__PURE__ */ k(Tt, { children: [
      /* @__PURE__ */ d(Lt, { children: "Conversation volume" }),
      t && /* @__PURE__ */ k(ir, { children: [
        "by ",
        t.toLowerCase()
      ] })
    ] }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: n ? /* @__PURE__ */ k("div", { className: "flex h-[400px] items-end justify-between gap-2 px-12 pb-16", children: [
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ d(_n, { config: N8, className: "h-[400px] w-full", children: /* @__PURE__ */ k(
      lr,
      {
        accessibilityLayer: !0,
        data: e,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ d(Yn, { vertical: !1 }),
          /* @__PURE__ */ d(
            Cn,
            {
              dataKey: "time",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ d(Sn, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ d($n, { content: /* @__PURE__ */ d(En, {}) }),
          /* @__PURE__ */ d(
            Ur,
            {
              content: /* @__PURE__ */ d(ra, {}),
              verticalAlign: "top",
              align: "right"
            }
          ),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "sent_to_council",
              stackId: "a",
              fill: N8.sent_to_council.color,
              radius: [0, 0, 4, 4],
              name: "Complete"
            }
          ),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "off_topic",
              stackId: "a",
              fill: N8.off_topic.color,
              radius: [4, 4, 0, 0],
              name: "Off Topic"
            }
          )
        ]
      }
    ) }) })
  ] });
}
function HVe({
  data: e,
  from: t,
  groupType: n,
  loading: r
}) {
  const i = Je(() => e.reduce((a, s) => a + (s.sent_to_council || 0), 0), [e]), o = Je(() => e.reduce((a, s) => a + (s.off_topic || 0), 0), [e]);
  return /* @__PURE__ */ k("div", { className: "space-y-4", children: [
    /* @__PURE__ */ k("div", { className: "grid grid-cols-1 gap-4 md:grid-cols-2", children: [
      /* @__PURE__ */ d(
        Vr,
        {
          title: "Complete Conversations",
          subtitle: "Since " + sn(To(t), "dd MMM, yyyy"),
          children: r ? "..." : i
        }
      ),
      /* @__PURE__ */ d(
        Vr,
        {
          title: "Off-Topic Conversations",
          subtitle: "Since " + sn(To(t), "dd MMM, yyyy"),
          children: r ? "..." : o
        }
      )
    ] }),
    /* @__PURE__ */ d(
      WVe,
      {
        data: e,
        groupType: n,
        loading: r
      }
    )
  ] });
}
const UVe = {
  abandoned: {
    label: "Abandoned",
    color: "hsl(var(--chart-2))"
  },
  completed: {
    label: "Completed",
    color: "hsl(var(--chart-1))"
  }
};
function GVe({
  data: e,
  loading: t = !1
}) {
  const n = e.map((r) => ({
    name: r.council_name,
    abandoned: r.in_progress + r.off_topic + r.error + r.discarded,
    completed: r.done
  }));
  return /* @__PURE__ */ k(Pt, { className: "h-full w-full", children: [
    /* @__PURE__ */ d(Tt, { className: "items-center", children: /* @__PURE__ */ d(Lt, { children: "Customer Completeness" }) }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: t ? /* @__PURE__ */ k("div", { className: "flex h-[400px] flex-col justify-between gap-4 px-12", children: [
      /* @__PURE__ */ d(me, { className: "h-16 w-[90%] rounded-lg" }),
      /* @__PURE__ */ d(me, { className: "h-16 w-[70%] rounded-lg" }),
      /* @__PURE__ */ d(me, { className: "h-16 w-[80%] rounded-lg" })
    ] }) : /* @__PURE__ */ d(_n, { config: UVe, className: "w-full", children: /* @__PURE__ */ k(
      lr,
      {
        accessibilityLayer: !0,
        data: n,
        width: 100,
        height: 100,
        layout: "vertical",
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ d(Yn, { horizontal: !0, vertical: !1 }),
          /* @__PURE__ */ d(Cn, { type: "number", tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ d(
            Sn,
            {
              interval: 0,
              type: "category",
              dataKey: "name",
              tickLine: !1,
              axisLine: !1,
              width: 150
            }
          ),
          /* @__PURE__ */ d($n, { content: /* @__PURE__ */ d(En, {}) }),
          /* @__PURE__ */ d(
            Ur,
            {
              content: /* @__PURE__ */ d(ra, {}),
              verticalAlign: "bottom",
              align: "center"
            }
          ),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "abandoned",
              name: "Abandoned",
              fill: "hsl(var(--chart-2))",
              radius: [0, 0, 0, 0],
              stackId: "a"
            }
          ),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "completed",
              name: "Completed",
              fill: "hsl(var(--chart-1))",
              radius: [0, 0, 0, 0],
              stackId: "a"
            }
          )
        ]
      }
    ) }) })
  ] });
}
function KVe(e) {
  const [t, n] = re(!0), [r, i] = re(null), [o, a] = re(!1), s = () => {
    n(!1), a(!0);
  };
  return Pe(() => {
    if (!document) {
      const f = new Error(`[ScriptLoadingError] document not defined when attempting to load ${e}`);
      i(f);
      return;
    }
    const l = document.querySelector(`script[src="${e}"]`);
    if (l != null && l.dataset.loaded) {
      s();
      return;
    }
    const u = l || document.createElement("script");
    l || (u.src = e);
    const c = () => {
      u.dataset.loaded = "1", s();
    };
    u.addEventListener("load", c), u.addEventListener("error", (f) => {
      console.error("Failed to load script:", e, f);
      const h = new Error(`[ScriptLoadingError] Failed to load script: ${e}`);
      i(h);
    }), l || document.head.append(u);
  }, []), {
    isLoading: t,
    error: r,
    isSuccess: o
  };
}
const YVe = (e) => e && e.charts, sL = (e, t) => {
  const { controls: n, toolbarItems: r, getChartEditor: i } = e;
  return t && t.charts && t.visualization && t.visualization.ChartWrapper && t.visualization.Dashboard && (!n || t.visualization.ChartWrapper) && (!i || t.visualization.ChartEditor) && (!r || t.visualization.drawToolbar);
}, ZVe = (e) => window.google;
function XVe(e) {
  const { chartVersion: t = "current", chartPackages: n = [
    "corechart",
    "controls"
  ], chartLanguage: r = "en", mapsApiKey: i } = e, [o, a] = re(null), [s, l] = re(null), [u, c] = re(null), { isLoading: f, error: h, isSuccess: m } = KVe(e.chartLoaderScriptUrl || "https://www.gstatic.com/charts/loader.js");
  return Pe(() => {
    if (!m)
      return;
    const v = ZVe();
    if (!YVe(v)) {
      const g = new Error("[ScriptInitializationError] Script loaded but Google not attached to window.");
      l(g);
      return;
    }
    if (sL(e, v)) {
      a(v);
      return;
    }
    v.charts.load(t, {
      packages: n,
      language: r,
      mapsApiKey: i
    }), v.charts.setOnLoadCallback(() => {
      if (!sL(e, v)) {
        const g = new Error("[GoogleChartsInitializationError] Google Charts not ready after load callback.");
        console.error(g), c(g);
        return;
      }
      a(v);
    });
  }, [
    m
  ]), {
    error: h || s || u,
    isLoading: f,
    google: o
  };
}
const hQ = {
  // <DEPRECATED_PROPS>
  legend_toggle: !1,
  // </DEPRECATED_PROPS>
  options: {},
  legendToggle: !1,
  getChartWrapper: () => {
  },
  spreadSheetQueryParameters: {
    headers: 1,
    gid: 1
  },
  rootProps: {},
  chartWrapperParams: {},
  chartLoaderScriptUrl: "https://www.gstatic.com/charts/loader.js"
}, JVe = (e) => {
  const { isReady: t, chartControls: n, filter: r } = e;
  return !t || !n || !(n != null && n.length) ? null : /* @__PURE__ */ F.createElement(F.Fragment, null, n.filter((i) => {
    let { controlProp: o, control: a } = i;
    return r ? r({
      control: a,
      controlProp: o
    }) : !0;
  }).map((i) => {
    let { control: o } = i;
    return /* @__PURE__ */ F.createElement("div", {
      key: o.getContainerId(),
      id: o.getContainerId()
    });
  }));
};
let lL = 0;
const pQ = () => (lL += 1, `reactgooglegraph-${lL}`), Ao = class Ao {
};
/**
* Initialize the controls once chart is ready
*/
Ki(Ao, "initializeControls", (t) => {
  for (let n = 0; n < t.length; n += 1) {
    const { controlType: r, options: i, controlWrapperParams: o } = t[n].controlProp;
    o && "state" in o && t[n].control.setState(o.state), t[n].control.setOptions(i), t[n].control.setControlType(r);
  }
}), /**
* listen to the control events (ready, statechange, error) specified in the controlEvents prop
*/
Ki(Ao, "listenToControlEvents", (t, n) => {
  const { google: r } = n;
  return t.flatMap((i) => {
    const { control: o, controlProp: a } = i, { controlEvents: s = [] } = a;
    return s.map((l) => {
      const { callback: u, eventName: c } = l;
      return r.visualization.events.addListener(o, c, function() {
        for (var f = arguments.length, h = new Array(f), m = 0; m < f; m++)
          h[m] = arguments[m];
        u({
          chartWrapper: null,
          controlWrapper: o,
          props: n,
          google: r,
          eventArgs: h
        });
      });
    });
  });
}), /**
* If controlID is not provided, generate a unique controlID
*/
Ki(Ao, "createControlId", (t) => {
  let n;
  return typeof t > "u" ? n = `googlechart-control-${pQ()}` : n = t, n;
}), /**
* Map the control props to Google Chart Controls
*/
Ki(Ao, "createChartControls", (t) => {
  const { controls: n, google: r } = t;
  return n ? n.map((i, o) => {
    const { controlID: a, controlType: s, options: l, controlWrapperParams: u } = i, c = Ao.createControlId(a);
    return {
      controlProp: i,
      control: new r.visualization.ControlWrapper({
        containerId: c,
        controlType: s,
        options: l,
        ...u
      })
    };
  }) : null;
}), Ki(Ao, "addControls", (t) => {
  const { chartWrapper: n, chartDashboard: r } = t, i = Ao.createChartControls(t);
  return !i || !r || !n ? null : (r.bind(i.map((o) => {
    let { control: a } = o;
    return a;
  }), n), Ao.initializeControls(i), i);
});
let pg = Ao;
const QVe = (e) => {
  const [t, n] = x.useState(null);
  return [
    x.useMemo(() => !t || !e ? null : e.map((i, o) => {
      const a = t[o];
      return a ? {
        controlProp: i,
        control: a
      } : void 0;
    }).flatMap((i) => i ? [
      i
    ] : []), [
      t,
      e
    ]),
    n
  ];
}, eqe = (e, t) => {
  x.useEffect(() => {
    const n = pg.listenToControlEvents(e ?? [], t);
    return () => {
      n.forEach((r) => {
        t.google.visualization.events.removeListener(r);
      });
    };
  }, [
    e,
    t
  ]);
}, tqe = (e) => {
  const [t, n] = QVe(e.controls);
  return eqe(t ?? [], e), {
    addControls: (i) => {
      const o = pg.addControls(i);
      n((o == null ? void 0 : o.map((a) => a.control)) ?? null);
    },
    renderControl: (i) => {
      const { chartWrapper: o, chartDashboard: a } = e;
      return /* @__PURE__ */ x.createElement(JVe, {
        ...e,
        isReady: !!(o && a),
        chartControls: t,
        filter: i
      });
    }
  };
}, nqe = (e) => {
  const t = x.useRef(null);
  return {
    chartId: (() => {
      const { graphID: i, graph_id: o } = e, a = i || o;
      let s;
      return a ? s = a : s = t.current || pQ(), t.current = s, t.current;
    })()
  };
}, rqe = [
  "#3366CC",
  "#DC3912",
  "#FF9900",
  "#109618",
  "#990099",
  "#3B3EAC",
  "#0099C6",
  "#DD4477",
  "#66AA00",
  "#B82E2E",
  "#316395",
  "#994499",
  "#22AA99",
  "#AAAA11",
  "#6633CC",
  "#E67300",
  "#8B0707",
  "#329262",
  "#5574A6",
  "#3B3EAC"
], iqe = async function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return new Promise((r, i) => {
    const o = `${n.headers ? `headers=${n.headers}` : "headers=0"}`, a = `${n.query ? `&tq=${encodeURIComponent(n.query)}` : ""}`, s = `${n.gid ? `&gid=${n.gid}` : ""}`, l = `${n.sheet ? `&sheet=${n.sheet}` : ""}`, u = `${n.access_token ? `&access_token=${n.access_token}` : ""}`, c = `${o}${s}${l}${a}${u}`, f = `${t}/gviz/tq?${c}`;
    new e.visualization.Query(f).send((m) => {
      m.isError() ? i(`Error in query:  ${m.getMessage()} ${m.getDetailedMessage()}`) : r(m.getDataTable());
    });
  });
}, oqe = "#CCCCCC", Oi = class Oi {
};
Ki(Oi, "grayOutHiddenColumnsLabel", (t, n) => {
  const { googleChartWrapper: r, options: i } = t;
  if (!r) {
    console.error("googleChartWrapper is not defined");
    return;
  }
  const o = r.getDataTable();
  if (!o) return;
  const a = o.getNumberOfColumns();
  if (n.length > 0 === !1) return;
  const l = Array.from({
    length: a - 1
  }).map((u, c) => {
    const f = Oi.getColumnId(o, c + 1);
    return n.includes(f) ? oqe : i && i.colors ? i.colors[c] : rqe[c];
  });
  r.setOptions({
    ...i,
    colors: l
  }), r.draw();
}), /**
* Listens to user clicking on the legend to toggle the visibility of a column.
* When a user clicks on a legend item, the column id is added to / removed from the hiddenColumns state.
*/
Ki(Oi, "listenToLegendToggle", (t, n) => {
  const [r, i] = n, { google: o, googleChartWrapper: a } = t;
  if (!a) {
    console.error("googleChartWrapper is not defined");
    return;
  }
  return o.visualization.events.addListener(a, "select", () => {
    const l = a.getChart().getSelection(), u = a.getDataTable();
    if (l.length === 0 || // We want to listen to when a whole row is selected. This is the case only when row === null
    l[0].row !== null || !u)
      return;
    const c = l[0].column, f = Oi.getColumnId(u, c);
    r != null && r.includes(f) ? i((h) => [
      ...h.filter((m) => m !== f)
    ]) : i((h) => [
      ...h,
      f
    ]);
  });
}), /**
* (Re-)Draw a Google Chart with the given data, options, and chart type.
*/
Ki(Oi, "draw", async (t) => {
  const { data: n, diffdata: r, rows: i, columns: o, options: a, chartType: s, formatters: l, spreadSheetUrl: u, spreadSheetQueryParameters: c, googleChartDashboard: f, googleChartWrapper: h, google: m, hiddenColumns: v, legendToggle: g, legend_toggle: y } = t;
  if (!h) {
    console.error("draw was called with googleChartWrapper = null");
    return;
  }
  let w, C = null;
  if (r) {
    const O = m.visualization.arrayToDataTable(r.old), T = m.visualization.arrayToDataTable(r.new);
    C = m.visualization[s].prototype.computeDiff(O, T);
  }
  n ? n instanceof m.visualization.DataTable ? w = n : Array.isArray(n) ? w = m.visualization.arrayToDataTable(n) : w = new m.visualization.DataTable(n) : i && o ? w = m.visualization.arrayToDataTable([
    o,
    ...i
  ]) : u ? w = await iqe(m, u, c) : w = m.visualization.arrayToDataTable([]);
  const S = w.getNumberOfColumns(), N = Array(S).fill(0).map((O, T) => {
    const M = Oi.getColumnId(w, T);
    return v.includes(M) ? {
      label: w.getColumnLabel(T),
      type: w.getColumnType(T),
      calc: () => null
    } : T;
  }), E = h.getChart();
  h.getChartType() === "Timeline" && E && E.clearChart(), h.setChartType(s), h.setOptions(a || {});
  const A = new m.visualization.DataView(w);
  A.setColumns(N), h.setDataTable(A), h.draw(), f && f.draw(w), C && (h.setDataTable(C), h.draw()), l && (Oi.applyFormatters({
    dataTable: w,
    formatters: l,
    google: m
  }), h.setDataTable(w), h.draw()), (g === !0 || y === !0) && Oi.grayOutHiddenColumnsLabel(t, v);
}), /**
* Get the column ID of a column in a GoogleDataTable.
* If the column has an ID, return the ID, otherwise return the label.
*/
Ki(Oi, "getColumnId", (t, n) => t.getColumnId(n) || t.getColumnLabel(n)), /**
* Apply Chart Formatters passed under the formatters prop to the GoogleDataTable
*/
Ki(Oi, "applyFormatters", (t) => {
  let { dataTable: n, formatters: r, google: i } = t;
  for (let o of r)
    switch (o.type) {
      case "ArrowFormat": {
        new i.visualization.ArrowFormat(o.options).format(n, o.column);
        return;
      }
      case "BarFormat": {
        new i.visualization.BarFormat(o.options).format(n, o.column);
        return;
      }
      case "ColorFormat": {
        const a = new i.visualization.ColorFormat(o.options), { ranges: s } = o;
        if (s)
          for (let l of s)
            a.addRange(...l);
        a.format(n, o.column);
        return;
      }
      case "DateFormat": {
        new i.visualization.DateFormat(o.options).format(n, o.column);
        return;
      }
      case "NumberFormat": {
        new i.visualization.NumberFormat(o.options).format(n, o.column);
        return;
      }
      case "PatternFormat": {
        new i.visualization.PatternFormat(o.options).format(n, o.column);
        return;
      }
      default: {
        console.warn(`Unknown formatter type: ${o.type}`);
        return;
      }
    }
});
let Hf = Oi;
const aqe = (e) => {
  const { google: t, googleChartWrapper: n, googleChartDashboard: r } = e, [i, o] = x.useState([]);
  x.useEffect(() => {
    n && Hf.draw({
      ...e,
      hiddenColumns: i,
      googleChartWrapper: n,
      googleChartDashboard: r,
      google: t
    });
  }, [
    i,
    e.data,
    e.rows,
    e.columns,
    e.options,
    e.chartLoaderScriptUrl,
    e.chartType,
    e.formatters,
    e.spreadSheetUrl,
    e.spreadSheetQueryParameters,
    e.legendToggle,
    e.legend_toggle
  ]);
  const a = () => {
    const { googleChartWrapper: u } = e;
    u && u.draw();
  }, s = (u) => {
    const c = [], { legendToggle: f, legend_toggle: h } = e;
    if (Hf.draw({
      ...e,
      hiddenColumns: i,
      googleChartWrapper: u,
      googleChartDashboard: r,
      google: t
    }), window.addEventListener("resize", a), h || f) {
      const m = Hf.listenToLegendToggle(e, [
        i,
        o
      ]);
      m && c.push(m);
    }
    return c;
  }, l = (u, c) => {
    window.removeEventListener("resize", a), c.forEach((f) => {
      t.visualization.events.removeListener(f);
    }), u.getChartType() === "Timeline" && u.getChart() && u.getChart().clearChart();
  };
  x.useEffect(() => {
    if (!n)
      return;
    const u = s(n);
    return () => {
      l(n, u);
    };
  }, [
    n,
    s,
    l
  ]);
}, sqe = (e) => {
  const { chartEvents: t, google: n, googleChartWrapper: r } = e;
  if (t) {
    if (!r) {
      console.warn("listenToEvents was called before chart wrapper ready.");
      return;
    }
    return t.map((i) => {
      let { eventName: o, callback: a } = i;
      return n.visualization.events.addListener(r, o, function() {
        for (var s = arguments.length, l = new Array(s), u = 0; u < s; u++)
          l[u] = arguments[u];
        a({
          chartWrapper: r,
          props: e,
          google: n,
          eventArgs: l
        });
      });
    });
  }
}, lqe = (e) => {
  Pe(() => {
    if (!e.googleChartWrapper) return;
    const t = sqe(e);
    return () => {
      t == null || t.forEach((n) => {
        e.google.visualization.events.removeListener(n);
      });
    };
  }, [
    e
  ]);
}, uqe = (e) => {
  const [t, n] = x.useState(null), [r, i] = x.useState(null), { addControls: o, renderControl: a } = tqe({
    ...e,
    chartDashboard: r,
    chartWrapper: t
  });
  lqe({
    ...e,
    googleChartWrapper: t
  });
  const { chartId: s } = nqe(e), l = x.useRef(null), u = x.useRef(null);
  x.useEffect(() => {
    const { options: w, google: C, chartType: S, chartWrapperParams: N, toolbarItems: E, getChartEditor: A, getChartWrapper: O, onLoad: T } = e, M = {
      chartType: S,
      options: w,
      containerId: s,
      ...N
    }, L = new C.visualization.ChartWrapper(M);
    L.setOptions(w || {}), O == null || O(L, C);
    const I = new C.visualization.Dashboard(l.current);
    E && C.visualization.drawToolbar(u.current, E);
    let j = null;
    A && (j = new C.visualization.ChartEditor(), A({
      chartEditor: j,
      chartWrapper: L,
      google: C
    })), o({
      ...e,
      chartDashboard: I,
      chartWrapper: L
    }), n(L), i(I), T == null || T(C, {
      google: C,
      chartWrapper: L,
      chartEditor: j,
      chartDashboard: I
    });
  }, []), aqe({
    ...e,
    googleChartWrapper: t,
    googleChartDashboard: r
  });
  const c = () => {
    const { width: w, height: C, options: S, style: N, className: E, rootProps: A, google: O } = e, T = {
      height: C || S && S.height,
      width: w || S && S.width,
      ...N
    };
    return /* @__PURE__ */ x.createElement("div", {
      id: s,
      style: T,
      className: E,
      ...A
    });
  }, f = () => e.toolbarItems ? /* @__PURE__ */ x.createElement("div", {
    ref: u
  }) : null, { width: h, height: m, options: v, style: g } = e, y = {
    height: m || v && v.height,
    width: h || v && v.width,
    ...g
  };
  return e.render ? /* @__PURE__ */ x.createElement("div", {
    ref: l,
    style: y
  }, /* @__PURE__ */ x.createElement("div", {
    ref: u,
    id: "toolbar"
  }), e.render({
    renderChart: c,
    renderControl: a,
    renderToolbar: f
  })) : /* @__PURE__ */ x.createElement("div", {
    ref: l,
    style: y
  }, a((w) => {
    let { controlProp: C } = w;
    return C.controlPosition !== "bottom";
  }), c(), a((w) => {
    let { controlProp: C } = w;
    return C.controlPosition === "bottom";
  }), f());
}, cqe = /* @__PURE__ */ x.createContext(hQ), dqe = (e) => {
  let { children: t, value: n } = e;
  return /* @__PURE__ */ x.createElement(cqe.Provider, {
    value: n
  }, t);
}, fqe = (e) => {
  const { google: t, isLoading: n, error: r } = XVe(e);
  return n ? e.loader ?? null : r ? e.errorElement ?? null : t ? /* @__PURE__ */ F.createElement(uqe, {
    google: t,
    ...e
  }) : null;
}, hqe = (e) => {
  const t = {
    ...hQ,
    ...e
  };
  return /* @__PURE__ */ F.createElement(dqe, {
    value: t
  }, /* @__PURE__ */ F.createElement(fqe, t));
};
var uL;
(function(e) {
  e.annotation = "annotation", e.annotationText = "annotationText", e.certainty = "certainty", e.emphasis = "emphasis", e.interval = "interval", e.scope = "scope", e.style = "style", e.tooltip = "tooltip", e.domain = "domain";
})(uL || (uL = {}));
function pqe({
  className: e,
  data: t,
  title: n = "Sankey Chart",
  loading: r = !1,
  options: i = {},
  height: o,
  width: a
}) {
  const [s, l] = re(null), u = [...t], c = {
    sankey: {
      node: {
        colors: ["#2d5de8", "#6ec6ff", "#53a6f7", "#b9e6fd", "#e5f5ff"],
        label: {
          fontSize: 14,
          color: "#03045F"
        },
        nodePadding: 20
      },
      link: {
        colorMode: "gradient",
        colors: ["#2d5de8", "#6ec6ff", "#53a6f7", "#b9e6fd", "#e5f5ff"]
      }
    },
    tooltip: {
      textStyle: {
        fontSize: 12
      },
      showColorCode: !0,
      isHtml: !0
    },
    backgroundColor: "transparent"
  }, f = XG.merge(c, i);
  return Pe(() => {
    const h = (m) => {
      (m.message.includes("google") || m.message.includes("chart")) && (console.error("Sankey Chart Error:", m), l(new Error(m.message)));
    };
    return window.addEventListener("error", h), () => window.removeEventListener("error", h);
  }, []), /* @__PURE__ */ k(Pt, { className: "h-full w-full", children: [
    /* @__PURE__ */ d(Tt, { children: /* @__PURE__ */ d(Lt, { children: n }) }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: r ? /* @__PURE__ */ k("div", { className: "flex h-[400px] flex-col justify-between gap-4 px-12", children: [
      /* @__PURE__ */ d(me, { className: "h-16 w-[90%] rounded-lg" }),
      /* @__PURE__ */ d(me, { className: "h-16 w-[70%] rounded-lg" }),
      /* @__PURE__ */ d(me, { className: "h-16 w-[80%] rounded-lg" })
    ] }) : s ? /* @__PURE__ */ k("div", { className: "text-destructive flex h-[400px] items-center justify-center", children: [
      "Error loading chart: ",
      s.message
    ] }) : /* @__PURE__ */ d(
      hqe,
      {
        className: z("w-full", e),
        chartType: "Sankey",
        width: a,
        height: o,
        data: u,
        options: f
      }
    ) })
  ] });
}
const cL = {
  average_response_time_seconds: {
    label: "average_response_time_seconds",
    color: "hsl(var(--chart-1))"
  }
};
function mqe({
  data: e,
  groupType: t,
  loading: n = !1
}) {
  return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
    /* @__PURE__ */ k(Tt, { children: [
      /* @__PURE__ */ d(Lt, { children: "Conversation Average Assistant Response Time" }),
      t && /* @__PURE__ */ k(ir, { children: [
        "by ",
        t.toLowerCase()
      ] })
    ] }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: n ? /* @__PURE__ */ k("div", { className: "flex h-[400px] items-end justify-between gap-2 px-12 pb-16", children: [
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ d(_n, { config: cL, className: "h-[400px] w-full", children: /* @__PURE__ */ k(
      lr,
      {
        accessibilityLayer: !0,
        data: e,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ d(Yn, { vertical: !1 }),
          /* @__PURE__ */ d(
            Cn,
            {
              dataKey: "time",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ d(Sn, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ d($n, { content: /* @__PURE__ */ d(En, {}) }),
          /* @__PURE__ */ d(
            Ur,
            {
              content: /* @__PURE__ */ d(ra, {}),
              verticalAlign: "top",
              align: "right"
            }
          ),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "average_response_time_seconds",
              stackId: "a",
              fill: cL.average_response_time_seconds.color,
              radius: [4, 4, 4, 4],
              name: "average_response_time_seconds"
            }
          )
        ]
      }
    ) }) })
  ] });
}
const dL = {
  average_time_seconds: {
    label: "average_time_seconds",
    color: "hsl(var(--chart-1))"
  }
};
function gqe({
  data: e,
  groupType: t,
  loading: n = !1
}) {
  return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
    /* @__PURE__ */ k(Tt, { children: [
      /* @__PURE__ */ d(Lt, { children: "Conversation Average Report Time" }),
      t && /* @__PURE__ */ k(ir, { children: [
        "by ",
        t.toLowerCase()
      ] })
    ] }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: n ? /* @__PURE__ */ k("div", { className: "flex h-[400px] items-end justify-between gap-2 px-12 pb-16", children: [
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ d(_n, { config: dL, className: "h-[400px] w-full", children: /* @__PURE__ */ k(
      lr,
      {
        accessibilityLayer: !0,
        data: e,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ d(Yn, { vertical: !1 }),
          /* @__PURE__ */ d(
            Cn,
            {
              dataKey: "time",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ d(Sn, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ d($n, { content: /* @__PURE__ */ d(En, {}) }),
          /* @__PURE__ */ d(
            Ur,
            {
              content: /* @__PURE__ */ d(ra, {}),
              verticalAlign: "top",
              align: "right"
            }
          ),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "average_time_seconds",
              stackId: "a",
              fill: dL.average_time_seconds.color,
              radius: [4, 4, 4, 4],
              name: "average_time_seconds"
            }
          )
        ]
      }
    ) }) })
  ] });
}
const vqe = {
  in_hours: {
    label: "In Hours",
    color: "#B0AFAC"
  },
  out_of_hours: {
    label: "Out of Hours",
    color: "hsl(var(--chart-1))"
  }
};
function yqe({
  data: e,
  loading: t = !1
}) {
  const n = e.map((r) => ({
    name: r.week_start,
    in_hours: r.in_hours,
    out_of_hours: r.out_of_hours,
    total: r.in_hours + r.out_of_hours
  }));
  return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
    /* @__PURE__ */ d(Tt, { children: /* @__PURE__ */ d(Lt, { children: "Conversations by Operating Hours" }) }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: t ? /* @__PURE__ */ k("div", { className: "flex h-[400px] items-end justify-between px-12 pb-16", children: [
      /* @__PURE__ */ d(me, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[60%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ d(me, { className: "h-[80%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ d(_n, { config: vqe, className: "h-[400px] w-full", children: /* @__PURE__ */ k(
      lr,
      {
        accessibilityLayer: !0,
        data: n,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 60 },
        children: [
          /* @__PURE__ */ d(Yn, { vertical: !1 }),
          /* @__PURE__ */ d(
            Cn,
            {
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ d(Sn, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ d($n, { content: /* @__PURE__ */ d(En, {}) }),
          /* @__PURE__ */ d(fQ, { content: /* @__PURE__ */ d(ra, {}) }),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "in_hours",
              stackId: "operating_hours",
              fill: "var(--color-in_hours)",
              radius: [0, 0, 4, 4]
            }
          ),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "out_of_hours",
              stackId: "operating_hours",
              fill: "var(--color-out_of_hours)",
              radius: [4, 4, 0, 0]
            }
          )
        ]
      }
    ) }) })
  ] });
}
const mQ = [
  "hsl(var(--chart-1))",
  "hsl(var(--chart-2))",
  "hsl(var(--chart-3))",
  "hsl(var(--chart-4))",
  "hsl(var(--chart-5))"
], bqe = {
  count: {
    label: "Count",
    color: mQ[0]
  }
};
function xqe({
  data: e,
  loading: t = !1
}) {
  const n = Object.entries(e).map(([r, i]) => ({
    name: r,
    count: i
  })).sort((r, i) => i.count - r.count);
  return console.log("<ConversationByOutOfScopeItemsBarChart> chartData", n), /* @__PURE__ */ k(Pt, { className: "w-full", children: [
    /* @__PURE__ */ k(Tt, { children: [
      /* @__PURE__ */ d(Lt, { children: "Conversations by Out of Scope Items" }),
      /* @__PURE__ */ d(ir, { children: "Distribution of conversations by planning zones and overlays" })
    ] }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: t ? /* @__PURE__ */ k("div", { className: "flex h-[600px] flex-col justify-between py-8 pl-16", children: [
      /* @__PURE__ */ d(me, { className: "h-6 w-[60%] rounded" }),
      /* @__PURE__ */ d(me, { className: "h-6 w-[80%] rounded" }),
      /* @__PURE__ */ d(me, { className: "h-6 w-[40%] rounded" }),
      /* @__PURE__ */ d(me, { className: "h-6 w-[70%] rounded" }),
      /* @__PURE__ */ d(me, { className: "h-6 w-[90%] rounded" }),
      /* @__PURE__ */ d(me, { className: "h-6 w-[50%] rounded" }),
      /* @__PURE__ */ d(me, { className: "h-6 w-[65%] rounded" }),
      /* @__PURE__ */ d(me, { className: "h-6 w-[35%] rounded" })
    ] }) : /* @__PURE__ */ d(_n, { config: bqe, className: "h-[600px] w-full", children: /* @__PURE__ */ k(
      lr,
      {
        accessibilityLayer: !0,
        data: n,
        layout: "vertical",
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 200, bottom: 5 },
        children: [
          /* @__PURE__ */ d(Yn, { horizontal: !1 }),
          /* @__PURE__ */ d(
            Cn,
            {
              type: "number",
              tickLine: !1,
              axisLine: !1
            }
          ),
          /* @__PURE__ */ d(
            Sn,
            {
              type: "category",
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              width: 180,
              tick: { fontSize: 12 }
            }
          ),
          /* @__PURE__ */ d($n, { content: /* @__PURE__ */ d(En, {}) }),
          /* @__PURE__ */ d(
            bt,
            {
              dataKey: "count",
              fill: mQ[0],
              radius: [0, 4, 4, 0]
            }
          )
        ]
      }
    ) }) })
  ] });
}
const _1 = [
  "hsl(var(--chart-1))",
  "hsl(var(--chart-2))",
  "hsl(var(--chart-3))",
  "hsl(var(--chart-4))",
  "hsl(var(--chart-5))",
  "hsl(var(--chart-6))"
];
function wqe({
  data: e,
  loading: t = !1
}) {
  const n = e.length ? Object.keys(e[0]).filter(
    (o) => o !== "week_start" && o !== "week_end"
  ) : [], r = Object.fromEntries(
    n.map((o, a) => [
      o,
      {
        label: o,
        color: _1[a % _1.length]
      }
    ])
  ), i = e.map((o) => {
    const a = { name: o.week_start };
    return n.forEach((s) => {
      a[s] = o[s];
    }), a;
  });
  return /* @__PURE__ */ k(Pt, { className: "w-full", children: [
    /* @__PURE__ */ d(Tt, { children: /* @__PURE__ */ d(Lt, { children: "Conversations by Language" }) }),
    /* @__PURE__ */ d(Mt, { className: "w-full", children: t ? /* @__PURE__ */ d("div", { className: "flex h-[400px] items-end justify-between px-12 pb-16", children: n.map((o, a) => /* @__PURE__ */ d(me, { className: `h-[${60 + a * 10}%] w-16 rounded-t-lg` }, a)) }) : /* @__PURE__ */ d(_n, { config: r, className: "h-[400px] w-full", children: /* @__PURE__ */ k(
      lr,
      {
        accessibilityLayer: !0,
        data: i,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 60 },
        children: [
          /* @__PURE__ */ d(Yn, { vertical: !1 }),
          /* @__PURE__ */ d(
            Cn,
            {
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ d(Sn, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ d($n, { content: /* @__PURE__ */ d(En, {}) }),
          /* @__PURE__ */ d(fQ, { content: /* @__PURE__ */ d(ra, {}) }),
          n.map((o, a) => /* @__PURE__ */ d(
            bt,
            {
              dataKey: o,
              stackId: "languages",
              fill: _1[a % _1.length],
              radius: a === 0 ? [0, 0, 4, 4] : a === n.length - 1 ? [4, 4, 0, 0] : [0, 0, 0, 0],
              name: o
            },
            o
          ))
        ]
      }
    ) }) })
  ] });
}
function Cqe({
  chartType: e,
  council: t,
  groupType: n,
  from: r,
  to: i,
  includeInternalUsers: o
}) {
  switch (e) {
    case "CONVERSATION_CUSTOMER_COMPLETENESS":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_CUSTOMER_COMPLETENESS",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            GVe,
            {
              data: a || [],
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_ERRORS":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_ERRORS",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            vVe,
            {
              data: a || [],
              groupType: n,
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_BY_OVERLAY":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_BY_OVERLAY",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            yVe,
            {
              data: a || [],
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_BY_PHASE":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_BY_PHASE",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            xVe,
            {
              data: a || [],
              from: r,
              groupType: n,
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_BY_STATE":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_BY_STATE",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            CVe,
            {
              data: a || [],
              from: r,
              groupType: n,
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_BY_STATE_COUNCIL":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_BY_STATE_COUNCIL",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            _Ve,
            {
              data: a || [],
              from: r,
              groupType: n,
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_BY_ZONE":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_BY_ZONE",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            EVe,
            {
              data: a || [],
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_BY_ZONE_OUTCOME":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_BY_ZONE_OUTCOME",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            OVe,
            {
              data: a || [],
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_BY_OVERLAY_OUTCOME":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_BY_OVERLAY_OUTCOME",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            TVe,
            {
              data: a || [],
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_COST":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_COST",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            RVe,
            {
              data: a || [],
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_COST_PRE_REPORT":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_COST_PRE_REPORT",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            IVe,
            {
              data: a || [],
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_COST_REPORT":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_COST_REPORT",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            LVe,
            {
              data: a || [],
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_VOLUME_BY_STAGE":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_VOLUME_BY_STAGE",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            HVe,
            {
              data: a || [],
              from: r,
              groupType: n,
              loading: s
            }
          )
        }
      );
    case "CONVERSATIONS_FLAGGED_FOR_REVIEW":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATIONS_FLAGGED_FOR_REVIEW",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            jVe,
            {
              data: a || [],
              groupType: n,
              loading: s
            }
          )
        }
      );
    case "CONVERSATIONS_BY_REVIEW_COUNCIL":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATIONS_BY_REVIEW_COUNCIL",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            VVe,
            {
              data: a || [],
              groupType: n,
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_REVIEW_LEADERBOARD":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_REVIEW_LEADERBOARD",
          council: t,
          groupType: void 0,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            qVe,
            {
              data: a || [],
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_REVIEW_LEADERBOARD_COUNCIL":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_REVIEW_LEADERBOARD_COUNCIL",
          council: t,
          groupType: void 0,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            zVe,
            {
              data: a || [],
              loading: s
            }
          )
        }
      );
    case "APPLICATIONS_REJECTED_REASONS":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "APPLICATIONS_REJECTED_REASONS",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            BVe,
            {
              data: a || [],
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_SANKEY":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_SANKEY",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            pqe,
            {
              data: a || [],
              title: "Conversation Flow",
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_AVERAGE_ASSISTANT_RESPONSE_TIME":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_AVERAGE_ASSISTANT_RESPONSE_TIME",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            mqe,
            {
              data: a || [],
              groupType: n,
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_AVERAGE_REPORT_TIME":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_AVERAGE_REPORT_TIME",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            gqe,
            {
              data: a || [],
              groupType: n,
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_BY_OPERATING_HOURS":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_BY_OPERATING_HOURS",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            yqe,
            {
              data: a || [],
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_BY_OUT_OF_SCOPE_ITEMS":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_BY_OUT_OF_SCOPE_ITEMS",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            xqe,
            {
              data: a || {},
              loading: s
            }
          )
        }
      );
    case "CONVERSATION_BY_LANGUAGE":
      return /* @__PURE__ */ d(
        rn,
        {
          chartType: "CONVERSATION_BY_LANGUAGE",
          council: t,
          groupType: n,
          from: r,
          to: i,
          includeInternalUsers: o,
          children: ({ data: a, isLoading: s }) => /* @__PURE__ */ d(
            wqe,
            {
              data: a || [],
              loading: s
            }
          )
        }
      );
  }
}
const Sqe = [
  {
    label: "Week",
    value: "WEEK"
  },
  {
    label: "Month",
    value: "MONTH"
  },
  {
    label: "Year",
    value: "YEAR"
  },
  {
    label: "Hour",
    value: "HOUR"
  },
  {
    label: "Day",
    value: "DAY"
  },
  {
    label: "All",
    value: "ALL"
  }
];
function _qe({ onChange: e, values: t }) {
  return /* @__PURE__ */ d(
    TH,
    {
      allowMultiSelect: !1,
      onChange: e,
      options: Sqe,
      placeholder: "Group by",
      values: t
    }
  );
}
function Cet({
  allowSelectingCouncils: e,
  allowSelectingInternal: t,
  allowSelectingGroupType: n = !0,
  defaultCouncil: r,
  defaultDateRange: i,
  chartTypes: o,
  forceIncludeInternal: a
}) {
  const s = /* @__PURE__ */ new Date();
  s.setHours(23, 59, 59, 999);
  const [l, u] = re(() => i || {
    from: Ul(gn(s, -1)),
    to: UA(gn(s, -1))
  }), [c, f] = re([
    { label: "Week", value: "WEEK" }
  ]), [h, m] = re(() => r || [
    {
      label: "All councils",
      value: ""
    }
  ]), [v, g] = re(!!a), y = (S) => {
    u(S);
  }, w = l != null && l.from ? $f(l.from) : "", C = Je(() => {
    if (!(l != null && l.to)) return "";
    if (Gde(l.to)) {
      const S = /* @__PURE__ */ new Date();
      return $f(
        ufe(l.to, {
          hours: S.getHours(),
          minutes: S.getMinutes(),
          seconds: S.getSeconds(),
          milliseconds: S.getMilliseconds()
        })
      );
    } else
      return $f(UA(l.to));
  }, [l == null ? void 0 : l.to]);
  return /* @__PURE__ */ k("div", { className: "container mx-auto space-y-4 p-4", children: [
    /* @__PURE__ */ k("div", { className: "mb-8 flex flex-wrap gap-4", children: [
      /* @__PURE__ */ d("div", { children: /* @__PURE__ */ d(
        vbe,
        {
          className: "flex-1",
          onChange: y,
          dateRange: l
        }
      ) }),
      n && /* @__PURE__ */ d("div", { children: /* @__PURE__ */ d(_qe, { onChange: f, values: c }) }),
      e && /* @__PURE__ */ d("div", { className: "md:max-w-[400px]", children: /* @__PURE__ */ d(
        Eqe,
        {
          onChange: m,
          values: h
        }
      ) }),
      t && /* @__PURE__ */ k("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ k("label", { className: "text-bodysm font-medium", children: [
          "Include internal:",
          " "
        ] }),
        /* @__PURE__ */ d(
          Np,
          {
            checked: v,
            onCheckedChange: g
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ d("div", { className: "flex flex-wrap gap-2", children: o.map((S) => {
      var A, O;
      const N = typeof S == "string" ? S : S.chartType, E = typeof S == "object" ? S.fullWidth : !1;
      return /* @__PURE__ */ d(
        "div",
        {
          className: z("w-full", {
            "md:max-w-[calc(50%_-_theme(spacing.2))] md:min-w-[400px]": !E,
            "md:max-w-[calc(100%_-_theme(spacing.2))] md:min-w-[400px]": E
          }),
          children: /* @__PURE__ */ d(
            Cqe,
            {
              chartType: N,
              council: ((A = h[0]) == null ? void 0 : A.value) || "",
              groupType: (O = c[0]) == null ? void 0 : O.value,
              from: w,
              to: C,
              includeInternalUsers: v
            }
          )
        },
        N
      );
    }) })
  ] });
}
function Eqe({ onChange: e, values: t }) {
  const [n, r] = re([
    {
      label: "All councils",
      value: ""
    }
  ]), { data: i, isLoading: o } = Bue({
    query: {
      page: 1,
      page_size: 9999
    }
  });
  return Pe(() => {
    var a;
    if ((a = i == null ? void 0 : i.data) != null && a.results) {
      const s = i.data.results.sort(
        (l, u) => l.name.localeCompare(u.name)
      );
      r(
        [
          {
            label: "All councils",
            value: ""
          }
        ].concat(
          s.map((l) => ({
            label: `${l.code}: ${l.name}`,
            keywords: [
              `${l.code.toLowerCase()}: ${l.name.toLowerCase()}`
            ],
            value: l.code
          }))
        )
      );
    }
  }, [i]), /* @__PURE__ */ d(
    TH,
    {
      allowMultiSelect: !1,
      disabled: o,
      onChange: e,
      options: n,
      placeholder: "Select a council",
      values: t
    }
  );
}
function _et({
  className: e,
  currentStage: t,
  stages: n
}) {
  const r = Mue(), i = vt(null), o = vt(null), [a, s] = re(!1), [l] = Rue();
  Pe(() => {
    o.current && l(o.current);
  }, [l]), Pe(() => {
    i.current && o.current && s(
      o.current.scrollWidth > i.current.offsetWidth
    );
  }, []), Pe(() => {
    if (o.current) {
      const h = o.current.querySelector(
        `[data-stage="${t}"]`
      );
      h && h.scrollIntoView({ behavior: "smooth", inline: "start" });
    }
  }, [t]);
  const u = Je(() => n.findIndex((h) => h.key === t), [t, n]), c = (h) => /* @__PURE__ */ d(
    "div",
    {
      className: z(
        "h-1 min-w-8 max-w-16 grow rounded-full border-b",
        h < u ? "border-blueDisabled" : "border-textDisabled"
      )
    }
  ), f = (h, m, v) => m < u ? /* @__PURE__ */ k(
    "div",
    {
      className: "text-blueDisabled flex items-center gap-1 whitespace-nowrap",
      "data-stage": h.key,
      children: [
        /* @__PURE__ */ d(Gs, { className: "h-3 w-3" }),
        h.label,
        v ? /* @__PURE__ */ d("div", { className: "w-16" }) : null
      ]
    },
    h.key
  ) : m > u ? /* @__PURE__ */ k(
    "div",
    {
      className: "text-textSubdued flex items-center gap-1 whitespace-nowrap",
      "data-stage": h.key,
      children: [
        h.icon || /* @__PURE__ */ d(Yf, { className: "h-3 w-3" }),
        h.label,
        v ? /* @__PURE__ */ d("div", { className: "w-16" }) : null
      ]
    },
    h.key
  ) : /* @__PURE__ */ k(
    "div",
    {
      className: "text-textLink flex items-center gap-1 whitespace-nowrap",
      "data-stage": h.key,
      children: [
        h.icon || /* @__PURE__ */ d(Yf, { className: "h-3 w-3" }),
        h.label,
        v ? /* @__PURE__ */ d("div", { className: "w-16" }) : null
      ]
    },
    h.key
  );
  return /* @__PURE__ */ d(
    "div",
    {
      className: z("relative h-7 w-full overflow-hidden", e),
      style: {
        ...a ? {
          maskImage: r ? "linear-gradient(to left, black 80%, transparent 100%)" : "linear-gradient(to right, black 80%, transparent 100%)"
        } : {}
      },
      ref: i,
      children: /* @__PURE__ */ d(
        "div",
        {
          className: "absolute inset-0 bottom-[-20px] box-content overflow-x-scroll",
          ref: o,
          children: /* @__PURE__ */ d("div", { className: "text-bodysm flex items-center gap-3", children: n.map((h, m) => {
            const v = m === n.length - 1;
            return /* @__PURE__ */ k(Bs, { children: [
              f(h, m, v),
              v ? null : c(m)
            ] }, h.key);
          }) })
        }
      )
    }
  );
}
function Nqe({
  filter: e,
  filterDescriptor: t,
  onChangeFilter: n,
  renderingInHeader: r
}) {
  const i = e != null && e.from ? mt(e.from) : void 0, o = e != null && e.to ? mt(e.to) : void 0;
  return /* @__PURE__ */ k(
    "div",
    {
      className: z(
        "flex flex-col gap-1",
        r ? t.headerClassName : ""
      ),
      children: [
        r ? null : /* @__PURE__ */ d(qt, { className: "text-headingsm text-textPrimary", children: t.label }),
        /* @__PURE__ */ k(g2, { children: [
          /* @__PURE__ */ d(v2, { asChild: !0, children: /* @__PURE__ */ k(
            et,
            {
              id: "date",
              variant: "outline",
              className: z(
                "text-bodysm placeholder:text-textSubdued text-textPrimary focus:border-interactiveBorderSelect w-[230px] justify-start",
                (!i || !o) && "text-muted-foreground",
                e != null && e.to || e != null && e.from ? "border-interactiveBorderSelect" : "!border-interactiveBorder"
              ),
              children: [
                /* @__PURE__ */ d(pB, {}),
                i ? sn(i, "dd/MM/yyyy") : "",
                i && o ? /* @__PURE__ */ d("span", { children: " - " }) : null,
                o ? sn(o, "dd/MM/yyyy") : "",
                !i && !o ? /* @__PURE__ */ d("span", { children: t.placeholder }) : ""
              ]
            }
          ) }),
          /* @__PURE__ */ d(mp, { align: "start", className: "w-auto p-0", usePortal: !1, children: /* @__PURE__ */ d(
            eC,
            {
              className: "text-bodysm",
              defaultMonth: i,
              mode: "range",
              id: t.key,
              numberOfMonths: 2,
              onSelect: (a) => {
                n({
                  from: a != null && a.from ? $f(a.from) : "",
                  to: a != null && a.to ? $f(a.to) : ""
                });
              },
              selected: { from: i, to: o }
            }
          ) })
        ] })
      ]
    }
  );
}
function Aqe({
  filter: e,
  filterDescriptor: t,
  onChangeFilter: n,
  renderingInHeader: r
}) {
  const i = Je(() => !e || (e == null ? void 0 : e.length) === 0 ? t.options.filter((o) => o.value === "") : t.options.filter(
    (o) => e.includes(o.value)
  ), [e, t]);
  return /* @__PURE__ */ k(
    "div",
    {
      className: z(
        "flex flex-col",
        r ? t.headerClassName : null
      ),
      children: [
        r ? null : /* @__PURE__ */ d(qt, { className: "text-headingsm text-textPrimary", children: t.label }),
        /* @__PURE__ */ d(
          cU,
          {
            allowMultiSelect: !t.singleSelect,
            className: z(
              "text-textSubdued border-interactiveBorder text-bodymd",
              (e == null ? void 0 : e.length) === 1 && e[0] !== "" ? "text-textPrimary border-interactiveBorderSelect" : "",
              (e == null ? void 0 : e.length) > 1 ? "text-textPrimary border-interactiveBorderSelect" : ""
            ),
            filter: (o, a, s) => {
              var l;
              return (l = s == null ? void 0 : s[0]) != null && l.includes(a.toLowerCase()) ? 1 : 0;
            },
            hideHeader: !r,
            hideSearch: !0,
            options: t.options,
            onChange: (o) => {
              o.length > 0 ? n(o.map((a) => a.value)) : n([]);
            },
            placeholder: t.placeholder,
            renderInline: !r,
            values: i
          }
        )
      ]
    }
  );
}
function Oqe({
  filter: e,
  filterDescriptor: t,
  onChangeFilter: n,
  renderingInHeader: r
}) {
  const i = Je(() => !e || (e == null ? void 0 : e.length) === 0 ? t.options.filter((o) => o.value === "") : t.options.filter(
    (o) => e.includes(o.value) && o.value !== ""
  ), [e, t]);
  return /* @__PURE__ */ k(
    "div",
    {
      className: z(
        "flex flex-col gap-1",
        r ? t.headerClassName : null
      ),
      children: [
        r ? null : /* @__PURE__ */ d(qt, { className: "text-headingsm text-textPrimary", children: t.label }),
        /* @__PURE__ */ d(
          cU,
          {
            allowMultiSelect: !t.singleSelect,
            className: z(
              "text-bodymd text-textSubdued border-interactiveBorder",
              (e == null ? void 0 : e.length) === 1 && e[0] !== "" ? "text-textPrimary border-interactiveBorderSelect" : "",
              (e == null ? void 0 : e.length) > 1 ? "text-textPrimary border-interactiveBorderSelect" : ""
            ),
            filter: (o, a, s) => {
              var l;
              return (l = s == null ? void 0 : s[0]) != null && l.includes(a.toLowerCase()) ? 1 : 0;
            },
            options: t.options,
            onChange: (o) => {
              if (o.length > 0) {
                const a = i.some(
                  (u) => u.value === ""
                ), s = o.some((u) => u.value === ""), l = o.filter(
                  (u) => u.value !== ""
                );
                !a && s ? n([]) : a && l.length > 0 ? n(l.map((u) => u.value)) : n(o.map((u) => u.value));
              } else
                n([]);
            },
            placeholder: t.placeholder,
            values: i
          }
        )
      ]
    }
  );
}
function kqe({
  filter: e,
  filterDescriptor: t,
  onChangeFilter: n,
  renderingInHeader: r
}) {
  return /* @__PURE__ */ k(
    "div",
    {
      className: z(
        "flex flex-col gap-1",
        r ? t.headerClassName : ""
      ),
      children: [
        r ? null : /* @__PURE__ */ d(qt, { className: "text-headingsm text-textPrimary", children: t.label }),
        /* @__PURE__ */ d(
          YC,
          {
            className: z(
              "placeholder:text-textSubdued text-textPrimary focus:border-interactiveBorderSelect text-bodysm",
              e ? "border-interactiveBorderSelect" : "!border-interactiveBorder"
            ),
            onChange: (i) => {
              n(i.target.value);
            },
            placeholder: t.placeholder,
            value: e ?? ""
          }
        )
      ]
    }
  );
}
function Eet({
  filters: e,
  filterDescriptors: t,
  onChangeFilter: n,
  onClearFilters: r
}) {
  const [i, o] = re(!1), a = vt(null);
  Pe(() => {
    i && a.current && a.current.scroll({ top: 0, behavior: "instant" });
  }, [i]);
  const s = Je(() => Object.values(e).filter((h) => Array.isArray(h) && h.length === 1 && h[0] !== "" || Array.isArray(h) && h.length > 1 ? !0 : typeof h == "object" ? !!h.from || !!h.to : typeof h == "string" ? h.length > 0 : !1).length, [e]), l = (h) => {
    n(h);
  }, u = (h, m) => {
    switch (h.type) {
      case E1.DATERANGE:
        return /* @__PURE__ */ d(
          Nqe,
          {
            filter: e[h.key],
            filterDescriptor: h,
            onChangeFilter: (v) => {
              l({
                ...e,
                [h.key]: v
              });
            },
            renderingInHeader: m
          }
        );
      case E1.OPTIONS:
        return /* @__PURE__ */ d(
          Aqe,
          {
            filter: e[h.key],
            filterDescriptor: h,
            onChangeFilter: (v) => {
              l({
                ...e,
                [h.key]: v
              });
            },
            renderingInHeader: m
          }
        );
      case E1.SEARCHABLE_OPTIONS:
        return /* @__PURE__ */ d(
          Oqe,
          {
            filter: e[h.key],
            filterDescriptor: h,
            onChangeFilter: (v) => {
              l({
                ...e,
                [h.key]: v
              });
            },
            renderingInHeader: m
          }
        );
      case E1.STRING:
        return /* @__PURE__ */ d(
          kqe,
          {
            filter: e[h.key],
            filterDescriptor: h,
            onChangeFilter: (v) => {
              l({
                ...e,
                [h.key]: v
              });
            },
            renderingInHeader: m
          }
        );
    }
  }, c = () => t.filter(
    (m) => m.alwaysShow
  ).map((m) => /* @__PURE__ */ d(Bs, { children: u(m, !0) }, m.key)), f = () => t.map((h) => /* @__PURE__ */ d(Bs, { children: u(h) }, h.key));
  return /* @__PURE__ */ k("div", { className: "flex grow flex-wrap gap-3", children: [
    c(),
    /* @__PURE__ */ k(GG, { onOpenChange: o, children: [
      /* @__PURE__ */ d(y9e, { asChild: !0, children: /* @__PURE__ */ k(
        et,
        {
          className: z(
            "text-textPrimary !border-interactiveBorder !rounded",
            s === 0 ? "!border-interactiveBorder" : "!border-blueBorder bg-blueBgDefault"
          ),
          variant: "outline",
          children: [
            /* @__PURE__ */ d(Ace, { className: "h-4 w-4" }),
            " ",
            s > 0 ? `${s} filter${s > 1 ? "s" : ""} applied` : "All filters"
          ]
        }
      ) }),
      /* @__PURE__ */ k(
        fS,
        {
          className: "border-interactiveBorder flex flex-col gap-0 border-l !bg-[#FCFCF9] !p-0 xl:max-w-[720px]",
          onOpenAutoFocus: (h) => {
            h.preventDefault();
          },
          showOverlay: !1,
          children: [
            /* @__PURE__ */ d(ZG, { className: "hidden" }),
            /* @__PURE__ */ d(
              "div",
              {
                className: "flex h-full flex-col gap-3 overflow-y-auto px-8 py-6",
                ref: a,
                children: f()
              }
            ),
            /* @__PURE__ */ d(YG, { className: "border-interactiveBorder border-t bg-[#F3F3EE] px-5 py-2", children: /* @__PURE__ */ d(
              et,
              {
                className: "!text-bodysm !border-interactiveBorder text-textPrimary !h-min w-full py-2",
                onClick: r,
                variant: "outline",
                children: "Clear filters"
              }
            ) })
          ]
        }
      )
    ] })
  ] });
}
const E1 = {
  DATERANGE: "DATERANGE",
  OPTIONS: "OPTIONS",
  SEARCHABLE_OPTIONS: "SEARCHABLE_OPTIONS",
  STRING: "STRING"
};
function Net(e) {
  return /* @__PURE__ */ k(
    "svg",
    {
      width: "208px",
      height: "66px",
      viewBox: "0 0 208 66",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      preserveAspectRatio: "none",
      ...e,
      children: [
        /* @__PURE__ */ d("title", { children: "Bayside_City_Council_Logo_Landscape_-_RGB" }),
        /* @__PURE__ */ d(
          "g",
          {
            id: "Styleguide",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /* @__PURE__ */ d(
              "g",
              {
                id: "Artboard",
                transform: "translate(-227.000000, -185.000000)",
                fillRule: "nonzero",
                children: /* @__PURE__ */ k(
                  "g",
                  {
                    id: "Bayside_City_Council_Logo_Landscape_-_RGB",
                    transform: "translate(227.000000, 185.000000)",
                    children: [
                      /* @__PURE__ */ k(
                        "g",
                        {
                          id: "Group",
                          transform: "translate(27.000000, 1.000000)",
                          fill: "#2954A2",
                          children: [
                            /* @__PURE__ */ d(
                              "path",
                              {
                                d: "M29.0985052,23.8258427 C29.036701,21.2247191 28.6321649,19.7865169 28.0984021,17.988764 C29.8626289,15.8314607 30.3795361,13.6460674 29.7671134,10.8707865 C30.963866,9.08988764 31.1717526,6.57865169 30.2727835,4.53932584 C30.7840722,2.87078652 30.1885052,1.34831461 29.3681959,0.516853933 L27.845567,2.09550562 C28.0534536,2.29213483 28.682732,3.04494382 28.1939175,4.20224719 L27.9916495,4.66853933 L28.2220103,5.11235955 C29.0423196,6.63483146 28.8737629,8.7247191 27.845567,9.98314607 L27.5084536,10.3876404 L27.6376804,10.9044944 C28.2950515,13.4550562 27.896134,15.1179775 26.1712371,17.0561798 L25.7779381,17.5 L25.9521134,18.0505618 C26.5364433,19.9438202 27.0926804,21.4494382 27.0758247,24.011236 L27.0870619,24.011236 C27.0364948,28.9325843 26.1319072,36.7640449 20.5807732,41.8820225 C14.563299,47.3595506 9.19757732,48.3483146 0.219123711,49.9494382 C8.82113402,49.7022472 16.8725258,49.9550562 23.777732,44.5674157 C31.3515464,38.6348315 32.1999485,29.1348315 32.1999485,23.8370787 L29.0985052,23.8370787 L29.0985052,23.8258427 Z",
                                id: "Path"
                              }
                            ),
                            /* @__PURE__ */ d(
                              "path",
                              {
                                d: "M108.814588,42.1179775 C107.79201,41.752809 106.926753,41.5449438 105.965979,41.5449438 C104.066907,41.5449438 102.662268,42.4719101 102.662268,43.747191 C102.662268,45.1516854 104.027577,46.0224719 106.005309,46.0224719 C106.949227,46.0224719 107.966186,45.7808989 108.893247,45.3202247 L108.893247,46.3089888 C108.095412,46.6292135 107.196443,46.7921348 105.909794,46.7921348 C102.802732,46.7921348 101.437423,45.1573034 101.437423,43.8314607 C101.437423,42.0617978 103.336495,40.7191011 105.971598,40.7191011 C106.825619,40.7191011 107.685258,40.8707865 108.808969,41.2303371 L108.808969,42.1179775 L108.814588,42.1179775 Z",
                                id: "Path"
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ d(
                        "rect",
                        {
                          id: "Rectangle",
                          fill: "#2954A2",
                          x: "137",
                          y: "42",
                          width: "1",
                          height: "6"
                        }
                      ),
                      /* @__PURE__ */ d(
                        "polygon",
                        {
                          id: "Path",
                          fill: "#2954A2",
                          points: "146 42.8225352 143.100895 42.8225352 143.100895 48 141.882018 48 141.882018 42.8225352 139 42.8225352 139 42 146 42"
                        }
                      ),
                      /* @__PURE__ */ d(
                        "polygon",
                        {
                          id: "Path",
                          fill: "#2954A2",
                          points: "151.423313 42 153 42 149.650307 44.828169 149.650307 48 148.349693 48 148.349693 44.828169 145 42 146.558282 42 148.981595 44.0788732"
                        }
                      ),
                      /* @__PURE__ */ k(
                        "g",
                        {
                          id: "Group",
                          transform: "translate(156.000000, 42.000000)",
                          fill: "#2954A2",
                          children: [
                            /* @__PURE__ */ d(
                              "path",
                              {
                                d: "M7.50608696,1.7325 C6.4773913,1.35333333 5.60130435,1.1375 4.64043478,1.1375 C2.72434783,1.1375 1.30565217,2.1 1.30565217,3.42416667 C1.30565217,4.8825 2.67913043,5.78666667 4.68,5.78666667 C5.62391304,5.78666667 6.64695652,5.53583333 7.57956522,5.0575 L7.57956522,6.08416667 C6.76,6.41666667 5.88391304,6.58583333 4.57826087,6.58583333 C1.44695652,6.58583333 0.0904347826,4.88833333 0.0904347826,3.51166667 C0.0904347826,1.67416667 2.00086957,0.28 4.64043478,0.28 C5.49956522,0.28 6.35869565,0.4375 7.50608696,0.810833333 L7.50608696,1.7325 L7.50608696,1.7325 Z",
                                id: "Path"
                              }
                            ),
                            /* @__PURE__ */ d(
                              "path",
                              {
                                d: "M12.8982609,5.78666667 C14.7691304,5.78666667 16.1482609,4.84166667 16.1482609,3.40666667 C16.1482609,2.0825 14.7747826,1.1375 12.8982609,1.1375 C11.05,1.1375 9.65954805,2.07666667 9.65954805,3.40666667 C9.65391304,4.84166667 11.0443478,5.78666667 12.8982609,5.78666667 M12.8982609,0.28 C15.6565217,0.28 17.3747826,1.72666667 17.3747826,3.4125 C17.3747826,5.075 15.6904348,6.59166667 12.8756522,6.59166667 C10.1682609,6.59166667 8.43868223,5.0925 8.43868223,3.4125 C8.43304348,1.7325 10.2134783,0.28 12.8982609,0.28",
                                id: "Shape"
                              }
                            ),
                            /* @__PURE__ */ d(
                              "path",
                              {
                                d: "M25.5873913,4.1125 C25.5873913,5.60583333 24.3665217,6.58583333 21.8965217,6.58583333 C20.1386957,6.58583333 18.4373913,5.88583333 18.4373913,4.2175 L18.4373913,0.361666667 L19.6243478,0.361666667 L19.6243478,4.01333333 C19.6243478,4.74833333 19.7486957,4.94666667 20.1330435,5.23833333 C20.5908696,5.6175 21.2069565,5.7925 21.9191304,5.7925 C22.8291304,5.7925 23.4847826,5.57083333 23.8691304,5.27333333 C24.2930435,4.94666667 24.3891304,4.5675 24.3891304,3.955 L24.3891304,0.361666667 L25.5817391,0.361666667 L25.5817391,4.1125 L25.5873913,4.1125 Z",
                                id: "Path"
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ d(
                        "polygon",
                        {
                          id: "Path",
                          fill: "#2954A2",
                          points: "191 48 189.921612 48 184.154579 43.3577465 184.154579 48 183 48 183 42 183.972894 42 189.821978 46.5802817 189.821978 42 191 42"
                        }
                      ),
                      /* @__PURE__ */ d(
                        "path",
                        {
                          d: "M198.909228,43.3820537 C197.844175,43.0212766 196.906203,42.8159112 195.859304,42.8159112 C193.813918,42.8159112 192.301059,43.7317299 192.301059,44.9916744 C192.301059,46.3792784 193.77761,47.239593 195.901664,47.239593 C196.93646,47.239593 198.037821,47.0009251 199,46.5457909 L199,47.5226642 C198.170953,47.8390379 197.19062,48 195.792738,48 C192.446293,48 191,46.3848289 191,45.0749306 C191,43.3265495 193.075643,42 195.865356,42 C196.827534,42 197.723147,42.1498612 198.91528,42.5050879 L198.91528,43.3820537 L198.909228,43.3820537 Z",
                          id: "Path",
                          fill: "#2954A2"
                        }
                      ),
                      /* @__PURE__ */ d(
                        "rect",
                        {
                          id: "Rectangle",
                          fill: "#2954A2",
                          x: "200",
                          y: "42",
                          width: "1",
                          height: "6"
                        }
                      ),
                      /* @__PURE__ */ d(
                        "polygon",
                        {
                          id: "Path",
                          fill: "#2954A2",
                          points: "203 42 203 48 208 48 208 47.1943662 204.190205 47.1943662 204.190205 42"
                        }
                      ),
                      /* @__PURE__ */ k("g", { id: "Group", children: [
                        /* @__PURE__ */ d(
                          "path",
                          {
                            d: "M77.238973,23.8830508 C77.238973,24.8562712 77.2893243,24.9122034 79.9243784,24.8562712 C85.2112703,24.7108475 88.0533243,23.6816949 88.0533243,20.4432203 C88.0533243,17.0649153 84.2881622,15.7840678 80.343973,15.7840678 C79.2082703,15.7840678 78.4362162,15.8455932 77.9662703,15.9854237 C77.4515676,16.0916949 77.238973,16.2650847 77.238973,16.8915254 L77.238973,23.8830508 Z M77.238973,31.9037288 C77.238973,33.1454237 77.3396757,34.9184746 78.3299189,35.6288136 C79.3145676,36.4733898 80.8698649,36.6244068 82.4083784,36.6244068 C87.0183243,36.6244068 90.5429189,35.2261017 90.5429189,31.7862712 C90.5429189,29.0511864 88.4841081,25.8798305 80.2432703,25.8798305 C77.4571622,25.8798305 77.238973,26.0923729 77.238973,26.7915254 L77.238973,31.9037288 Z M72.9870811,19.2910169 C72.9870811,16.7516949 72.7856757,16.119661 70.4527297,15.940678 L68.8023243,15.84 C68.3827297,15.6498305 68.4386757,15.129661 68.8526757,14.9898305 C71.6443784,14.8164407 75.168973,14.7045763 79.9747297,14.7045763 C83.2363784,14.7045763 86.346973,14.8779661 88.6799189,15.6722034 C90.9065676,16.399322 92.6073243,17.7808475 92.6073243,19.9845763 C92.6073243,22.4735593 90.431027,23.7432203 87.326027,24.7052542 C87.326027,25.0520339 87.7344324,25.1694915 88.3050811,25.2366102 C91.107973,25.5722034 95.2535676,27.2949153 95.2535676,30.969661 C95.2535676,35.0079661 90.8002703,37.6927119 81.4852703,37.6927119 C79.9747297,37.6927119 77.4515676,37.5752542 75.2696757,37.5752542 C72.9870811,37.5752542 71.235973,37.6647458 69.3114324,37.6927119 C69.0093243,37.5752542 68.8918378,36.9935593 69.2107297,36.8089831 L70.1394324,36.7138983 C72.891973,36.4677966 72.9870811,36.0259322 72.9870811,32.390339 L72.9870811,19.2910169 Z",
                            id: "Shape",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ d(
                          "path",
                          {
                            d: "M104.663676,36.5349153 C105.709865,36.5349153 107.309919,35.9979661 107.830216,35.6344068 C108.462405,35.2316949 108.507162,34.7730508 108.507162,34.0123729 L108.60227,32.0044068 C108.60227,31.629661 108.39527,31.5625424 108.098757,31.5625424 C107.779865,31.5625424 106.890324,31.7079661 105.956027,31.909322 C102.912568,32.5637288 101.407622,33.1174576 101.407622,34.4486441 C101.407622,35.0415254 102.034216,36.5349153 104.663676,36.5349153 M107.880568,30.4438983 C108.658216,30.2816949 108.702973,29.979661 108.758919,29.4315254 L108.80927,27.8486441 C108.859622,26.5845763 108.238622,24.8562712 105.038514,24.8562712 C103.583919,24.8562712 101.821622,25.3484746 101.726514,26.4055932 C101.664973,26.959322 101.625811,27.3732203 101.195027,27.5689831 C100.434162,27.9828814 99.0243243,28.2401695 98.2578649,28.2401695 C97.7879189,28.2401695 97.5193784,28.0555932 97.5193784,27.7535593 C97.5193784,25.9637288 103.376919,23.5083051 107.15327,23.5083051 C110.884865,23.5083051 112.697514,24.9625424 112.546459,27.5410169 L112.221973,33.5537288 C112.132459,35.1477966 112.602405,36.5628814 114.610865,36.5628814 C115.131162,36.5628814 115.595514,36.4789831 115.903216,36.3783051 C116.154973,36.2608475 116.423514,36.1210169 116.580162,36.1210169 C116.781568,36.1210169 116.949405,36.3223729 116.949405,36.5628814 C116.949405,36.7250847 115.131162,38.0954237 112.596811,38.0954237 C111.343622,38.0954237 110.107216,37.7766102 109.217676,36.9767797 C109.01627,36.7866102 108.702973,36.5405085 108.39527,36.5405085 C108.037216,36.5405085 107.405027,36.8201695 106.381216,37.1837288 C105.22873,37.6144068 104.093027,38.0954237 102.644027,38.0954237 C101.139081,38.0954237 99.9082703,37.8101695 99.0187297,37.2620339 C98.0396757,36.6915254 97.4186757,35.8133898 97.4186757,34.879322 C97.4186757,33.5201695 98.4089189,32.7035593 101.726514,31.9316949 L107.880568,30.4438983 Z",
                            id: "Shape",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ d(
                          "path",
                          {
                            d: "M115.690622,44.6450847 C115.690622,43.7557627 116.630514,43.2747458 117.755027,43.2747458 L118.74527,43.2747458 C119.567676,43.2747458 120.093568,43.0398305 120.457216,42.7210169 C121.950973,41.1661017 122.991568,39.7118644 123.455919,38.8449153 C123.606973,38.5484746 123.970622,37.8772881 123.970622,37.3627119 C123.970622,36.6915254 123.758027,36.2944068 123.097865,35.0135593 L119.041784,27.6137288 C118.180216,25.9916949 117.799784,25.1750847 115.998324,24.9122034 L114.705973,24.7444068 C114.387081,24.5766102 114.448622,23.9949153 114.857027,23.8830508 C116.513027,23.9613559 118.06273,23.9949153 119.774676,23.9949153 C121.16773,23.9949153 122.622324,23.9613559 124.278324,23.8830508 C124.692324,23.9949153 124.742676,24.5766102 124.384622,24.7444068 L123.09227,24.9122034 C122.359378,25.0184746 121.945378,25.130339 121.945378,25.3708475 C121.945378,25.7847458 123.137027,28.0164407 123.450324,28.6261017 L125.10073,31.7918644 C125.408432,32.3288136 126.398676,34.1466102 126.605676,34.2305085 C126.751135,34.1466102 127.595919,33.1174576 128.519027,31.7079661 L130.281324,28.9616949 C131.417027,27.1774576 132.088378,25.8854237 132.088378,25.5162712 C132.088378,25.2757627 131.78627,25.0240678 130.851973,24.9177966 L129.24073,24.75 C128.871486,24.5822034 128.927432,24.0005085 129.335838,23.8886441 C131.008622,23.9669492 132.55273,24.0005085 133.901027,24.0005085 C135.198973,24.0005085 136.390622,23.9669492 137.828432,23.8886441 C138.253622,24.0340678 138.309568,24.5430508 137.945919,24.75 L137.056378,24.8618644 C135.344432,25.0632203 134.426919,26.0644068 132.664622,28.5254237 L129.766622,32.4686441 C128.06027,34.8177966 123.813973,40.8137288 121.285216,44.55 C120.384486,45.9147458 119.148081,46.1328814 117.956432,46.1328814 C116.46827,46.1272881 115.690622,45.5679661 115.690622,44.6450847",
                            id: "Path",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ d(
                          "path",
                          {
                            d: "M151.305811,24.1235593 C151.781351,24.8786441 152.122622,25.9861017 152.122622,26.9313559 C151.921216,27.1718644 151.137973,27.2333898 150.886216,27.0320339 C150.019054,25.510678 148.458162,24.5038983 146.332216,24.5038983 C144.306973,24.5038983 143.014622,25.3652542 143.014622,26.6069492 C143.014622,28.0052542 145.202108,28.7827119 147.014757,29.4483051 C149.761703,30.4998305 152.284865,31.6967797 152.284865,34.1074576 C152.284865,36.7474576 148.659568,38.0842373 144.832865,38.0842373 C142.404811,38.0842373 140.592162,37.720678 139.294216,36.9935593 C138.885811,36.3950847 138.578108,34.6891525 138.673216,33.5425424 C138.936162,33.3411864 139.607514,33.3188136 139.870459,33.5089831 C140.737622,35.3771186 142.404811,37.0327119 145.364351,37.0327119 C147.221757,37.0327119 148.827405,36.3671186 148.827405,34.8737288 C148.827405,33.279661 146.746216,32.390339 144.832865,31.7023729 C141.834162,30.5389831 139.708216,29.3252542 139.708216,27.4347458 C139.708216,24.9122034 142.807622,23.5027119 146.746216,23.5027119 C148.916919,23.5027119 150.83027,23.8494915 151.305811,24.1235593",
                            id: "Path",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ d(
                          "path",
                          {
                            d: "M161.085162,16.5 C161.085162,17.7137288 159.798405,18.2618644 158.399757,18.2618644 C156.788514,18.2618644 155.753514,17.4955932 155.753514,16.5727119 C155.753514,15.4428814 157.051459,14.7381356 158.550811,14.7381356 C160.106108,14.7381356 161.085162,15.5379661 161.085162,16.5 M156.838865,27.6752542 C156.838865,26.3272881 156.838865,26.1594915 155.445811,25.5442373 L154.987054,25.3428814 C154.785649,25.2030508 154.785649,24.8115254 155.031811,24.7052542 C156.223459,24.4423729 159.177405,23.5362712 160.363459,23.0272881 C160.632,23.0272881 160.822216,23.0888136 160.889351,23.2286441 C160.777459,24.4423729 160.682351,26.0867797 160.682351,27.5018644 L160.682351,33.710339 C160.682351,36.2161017 160.783054,36.5516949 162.646054,36.7138983 L163.737,36.8089831 C164.089459,36.9655932 163.988757,37.5808475 163.619514,37.6927119 C162.075405,37.6032203 160.576054,37.5752542 158.757811,37.5752542 C156.900405,37.5752542 155.345108,37.6032203 153.896108,37.6927119 C153.526865,37.5752542 153.431757,36.9655932 153.784216,36.8089831 L154.869568,36.7138983 C156.788514,36.5516949 156.838865,36.2161017 156.838865,33.710339 L156.838865,27.6752542 L156.838865,27.6752542 Z",
                            id: "Shape",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ d(
                          "path",
                          {
                            d: "M181.113811,27.3732203 C181.113811,26.679661 180.906811,26.3608475 180.548757,26.0252542 C179.776703,25.3149153 178.221405,24.5766102 176.196162,24.5766102 C171.485514,24.5766102 169.040676,27.3061017 169.040676,30.3152542 C169.040676,33.4474576 171.67573,36.4342373 176.772405,36.4342373 C178.159865,36.4342373 179.922162,35.9979661 180.761351,35.4274576 C181.05227,35.2372881 181.113811,34.7450847 181.113811,34.1466102 L181.113811,27.3732203 Z M184.946108,32.5245763 C184.946108,35.2652542 184.990865,36.5572881 186.456649,36.5572881 C187.004919,36.5572881 187.888865,36.4062712 188.677703,36.2216949 C189.041351,36.2888136 189.097297,37.1054237 188.616162,37.2955932 C186.456649,37.5249153 183.228568,38.0618644 181.796351,38.4030508 C181.471865,38.4030508 181.225703,38.3079661 181.225703,38.1513559 L181.225703,37.5472881 C181.225703,36.9991525 181.225703,36.6244068 181.113811,36.4957627 L180.906811,36.4957627 C178.629811,37.5137288 176.861919,38.0842373 174.394703,38.0842373 C168.637865,38.0842373 164.816757,35.0694915 164.816757,31.4450847 C164.816757,26.6069492 170.282676,23.4971186 177.331865,23.4971186 C179.099757,23.4971186 180.235459,23.6761017 180.800514,23.8159322 C181.046676,23.8159322 181.113811,23.6033898 181.113811,23.3237288 L181.113811,18.1108475 C181.113811,16.0805085 181.05227,15.8735593 179.502568,15.2694915 L178.98227,15.0457627 C178.719324,14.9450847 178.719324,14.4584746 178.98227,14.3522034 C180.291405,14.0837288 182.713865,13.5691525 184.576865,12.9035593 C184.789459,12.9035593 184.98527,12.9762712 185.097162,13.1105085 C185.046811,14.1620339 184.940514,15.8735593 184.940514,17.3949153 L184.940514,32.5245763 L184.946108,32.5245763 Z",
                            id: "Shape",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ d(
                          "path",
                          {
                            d: "M197.19827,27.7144068 C201.030568,27.7144068 202.138297,27.5633898 202.574676,27.3676271 C202.742514,27.2949153 202.910351,27.1662712 202.910351,26.7132203 C202.910351,25.7455932 201.908919,24.5318644 198.899027,24.5318644 C195.844378,24.5318644 193.214919,26.4055932 193.153378,27.5354237 C193.153378,27.6081356 193.153378,27.7144068 193.539405,27.7144068 L197.19827,27.7144068 Z M194.009351,28.7547458 C192.649865,28.7547458 192.599514,28.810678 192.599514,29.6776271 C192.599514,33.1901695 195.648568,36.1433898 201.192811,36.1433898 C202.910351,36.1433898 204.364946,35.7686441 205.959405,34.4374576 C206.507676,34.3367797 206.798595,34.549322 206.854541,34.8737288 C205.137,37.1781356 201.466946,38.0842373 198.759162,38.0842373 C195.419189,38.0842373 192.744973,37.060678 191.245622,35.7686441 C189.68473,34.4374576 189.086108,32.8154237 189.086108,31.2940678 C189.086108,27.0655932 193.259676,23.5027119 199.47527,23.5027119 C203.917378,23.5027119 206.798595,25.5442373 206.798595,27.6081356 C206.798595,28.0835593 206.697892,28.38 206.586,28.5142373 C206.507676,28.7155932 205.741216,28.7547458 203.542541,28.7547458 L194.009351,28.7547458 L194.009351,28.7547458 Z",
                            id: "Shape",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ d(
                          "path",
                          {
                            d: "M43.47,63.4215254 C36.9019459,63.8801695 28.9296486,59.3049153 23.0329459,57.6828814 C14.1263514,55.2889831 8.32475676,58.2254237 4.75540541,62.5657627 C7.70375676,60.4067797 12.5207027,59.5062712 20.4818108,61.5925424 C26.3952973,63.1530508 32.4822162,66.3579661 39.0670541,65.899322 C48.5722703,65.1945763 50.5863243,61.9952542 50.5863243,61.9952542 C50.5863243,61.9952542 49.6128649,62.9852542 43.47,63.4215254",
                            id: "Path",
                            fill: "#009CCD"
                          }
                        ),
                        /* @__PURE__ */ d(
                          "path",
                          {
                            d: "M25.8134595,56.5194915 C31.698973,58.1750847 37.7243514,61.810678 44.3315676,61.7155932 C52.8409459,61.5869492 57.4005405,56.6928814 57.4005405,56.6928814 L57.4117297,56.3349153 C57.4117297,56.3349153 55.0955676,58.3372881 48.4883514,58.8854237 C41.9202973,59.4894915 33.9424054,54.7967797 28.0401081,53.1635593 C20.051027,50.9262712 14.1431351,55.6413559 14.1431351,55.6413559 C14.1431351,55.6413559 16.4984595,53.9018644 25.8134595,56.5194915",
                            id: "Path",
                            fill: "#009CCD"
                          }
                        ),
                        /* @__PURE__ */ d(
                          "path",
                          {
                            d: "M51.4590811,1.10745763 C47.2687297,-0.285254237 44.6112973,0.945254237 41.5286757,3.40067797 C36.5998378,3.10983051 33.4612703,4.53610169 31.0332162,6.5440678 C23.0665135,6.3259322 15.9837568,9.06661017 9.36535135,15.6722034 C-2.80289189,27.8318644 -1.48256757,44.7569492 4.16237838,53.6837288 C4.16237838,53.6837288 5.10786486,50.9933898 8.04502703,47.3354237 C16.8788919,36.0427119 25.9477297,33.9788136 29.2373514,42.2008475 C29.9366757,37.6927119 29.187,36.0762712 27.4135135,34.6947458 C24.0679459,32.0827119 17.774027,32.3120339 10.2101351,42.2455932 C8.15132432,44.9079661 7.93313514,45.1316949 6.94848649,46.6698305 C2.18748649,38.5037288 4.11202703,26.5733898 12.1906216,18.4408475 C18.2495676,12.310678 24.3700541,9.51966102 31.436027,9.41898305 C31.436027,9.41898305 36.2921351,8.87084746 45.2211081,12.6910169 L35.576027,7.52847458 C39.7663784,5.12338983 46.1833784,6.19169492 50.2338649,7.75779661 L44.8798378,4.77661017 C46.8379459,3.32237288 47.9792432,2.41627119 51.6548919,3.46220339 L52.0912703,3.53491525 L52.5108649,3.36711864 C53.5962162,2.9140678 54.3458919,2.98118644 54.6032432,3.22169492 L56.1417568,1.63881356 C55.2466216,0.749491525 53.4899189,-0.00559322034 51.4590811,1.10745763",
                            id: "Path",
                            fill: "#F7941E"
                          }
                        )
                      ] })
                    ]
                  }
                )
              }
            )
          }
        )
      ]
    }
  );
}
function Aet(e) {
  return /* @__PURE__ */ k(
    "svg",
    {
      version: "1.1",
      id: "Layer_1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      viewBox: "0 0 229.4 57.2",
      ...e,
      children: [
        /* @__PURE__ */ d(
          "path",
          {
            fill: "#F58220",
            d: `M5.5,33.3c0-8.3,5.5-16.4,10.2-21c1.9-2.3,3.5-4.6,3.5-12c0-0.4-0.5-0.4-0.7,0.1c-1,3.3-2,4.4-3.2,5.6
	c-3.1,2.6-4.7,2.8-6.6,5.1c-1.3,1.5-1.5,3.7-3.1,7.3c-1.3,2.9-5,5.5-5.5,10c-0.4,3.9,1.7,7.3,2.1,10.8`
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            fill: "#084323",
            d: `M19.4,27.5c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3s-3.3,1.5-3.3,3.3C16,26.1,17.5,27.5,19.4,27.5 M32.8,33
	c0,10.7-8.9,20.7-13.5,23.7V9.4C24,12.3,32.8,22.3,32.8,33`
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            fill: "#F58220",
            d: `M2.3,39.1c0.4,3.5-0.2,5.4,1.8,8.5c2.1,3.5,13.2,9.1,13.9,9.5c0.7,0.4,0.8-0.2,0.5-0.3
	c-4.7-3.3-13-13.1-13-23.5`
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            fill: "#084323",
            d: `M43.6,30.1h1c3.1,0,5.2-1.3,5.2-3.9c0-2.7-1.5-4.1-4-4.1c-1.9,0-2.2,0.5-2.2,1.7V30.1z M43.6,38
	c0,1.9,1,2.3,2.8,2.3c2.9,0,4.8-1.5,4.8-4.5c0-3.4-2.6-4.7-5.6-4.7c-0.7,0-1.4,0.1-2,0.2C43.6,31.3,43.6,38,43.6,38z M41.1,24
	c0-1.7-1.1-1.7-2.9-1.8c-0.3,0-0.3-0.1-0.3-0.5s0.2-0.4,0.6-0.4c1.1,0,2.2,0.1,3.3,0.1s2.2-0.1,3.3-0.1c3.4,0,7.5,0.6,7.5,5
	c0,3.1-3.1,3.6-4.4,4v0.1c0.6,0,5.9,0.8,5.9,5.3c0,4.3-3.6,5.8-7.4,5.8c-2,0-3.3-0.1-4.5-0.1s-2.3,0.1-3.7,0.1
	c-0.5,0-0.6-0.1-0.6-0.3v-0.3c0-0.2,0.2-0.3,0.3-0.3c2.9,0,2.9-0.6,2.9-2.7C41.1,37.9,41.1,24,41.1,24z`
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            fill: "#084323",
            d: `M73.1,33.1c0-4-2.7-8.1-7-8.1c-4.4,0-6.5,3.5-6.5,7.5c0,4.1,2.5,8.3,6.9,8.3C70.9,40.8,73.1,37.2,73.1,33.1
	 M57.1,33.3c0-5,4.3-9.1,9.2-9.1c5,0,9.4,3.4,9.4,8.4c0,4.8-4.6,9.1-9.3,9.1C61.4,41.8,57.1,38.5,57.1,33.3`
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            fill: "#084323",
            d: `M81.3,32.2c0.3,0,0.6,0,0.9,0c1.9,0,4.3-0.7,4.3-3.5c0-2.1-1.4-3.5-3.5-3.5c-1.6,0-1.7,0.4-1.7,1.1
	C81.3,26.3,81.3,32.2,81.3,32.2z M79.1,27.2c0-1.2,0-1.8-1.5-1.8h-1c-0.1,0-0.2-0.3-0.2-0.5c0-0.1,0.1-0.3,0.2-0.3
	c1.4,0,2.8,0.1,4.2,0.1c1.1,0,2.2-0.1,3.3-0.1c2.4,0,4.8,1.6,4.8,4.1c0,2.2-2,3.6-3.8,3.9l0,0c0.9,0.2,1.9,2,2.1,2.3l2.6,4
	c0.8,1.3,1.4,1.5,2.8,1.6l0.1,0.1v0.5c0,0.2-0.2,0.2-0.3,0.2c-0.5,0-1.2-0.1-1.6-0.1c-0.6,0-1.1,0.1-1.7,0.1c-0.5,0-1.6-1.6-3-4.1
	c-1.5-2.7-2.4-4.2-4-4.2c-0.2,0-0.5,0-0.8,0v5.8c0,0.9,0,1.7,1.2,1.7c0.9,0,1.3,0,1.3,0.2c0,0.5-0.1,0.6-0.4,0.6
	c-1.2,0-2.3-0.1-3.3-0.1c-0.4,0-3,0.1-3.4,0.1c-0.1,0-0.2-0.3-0.2-0.5s0.1-0.3,0.6-0.3c1.6-0.1,2.1-0.3,2.1-2L79.1,27.2L79.1,27.2z`
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            fill: "#084323",
            d: `M109.1,33.1c0-4-2.7-8.1-7-8.1c-4.4,0-6.5,3.5-6.5,7.5c0,4.1,2.5,8.3,6.9,8.3C106.8,40.8,109.1,37.2,109.1,33.1
	 M93,33.3c0-5,4.3-9.1,9.2-9.1c5,0,9.4,3.4,9.4,8.4c0,4.8-4.6,9.1-9.3,9.1C97.3,41.8,93,38.5,93,33.3`
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            fill: "#084323",
            d: `M130.5,33.1c0-4-2.7-8.1-7-8.1c-4.4,0-6.5,3.5-6.5,7.5c0,4.1,2.5,8.3,6.9,8.3C128.2,40.8,130.5,37.2,130.5,33.1
	 M114.4,33.3c0-5,4.3-9.1,9.2-9.1c5,0,9.4,3.4,9.4,8.4c0,4.8-4.6,9.1-9.3,9.1C118.7,41.8,114.4,38.5,114.4,33.3`
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            fill: "#084323",
            d: `M137.7,27.5c0-0.5,0-0.6-0.1-0.8c-0.2-0.4-1.3-1.3-1.7-1.3l-1.3-0.1c-0.1,0-0.1-0.2-0.1-0.4
	c0-0.1,0-0.3,0.1-0.3c0.7,0,1.3,0,1.9,0c1.1,0,2.8,0.1,3.3,0.1l7.2,8.7c1.1,1.3,2.2,2.6,3.9,4.3h0.1V27.3c0-1.6-0.6-1.8-1.3-1.8h-1
	c-0.1,0-0.1-0.2-0.1-0.4c0-0.1,0.1-0.4,0.2-0.4c0.5,0,1.8,0.1,2.9,0.1c1.1,0,2.2-0.1,2.9-0.1c0.1,0,0.1,0.1,0.1,0.2v0.5
	c0,0.1,0,0.1-0.2,0.1h-0.6c-1.6,0-1.6,0.8-1.6,2.9v13.8h-0.6l-12.8-14.7v10.9c0,2.1,0.3,2.3,2.3,2.4c0.1,0,0.2,0.2,0.2,0.4
	s0,0.4-0.1,0.4c-0.5,0-2-0.1-3-0.1c-1.2,0-1.7,0.1-2.8,0.1c-0.1,0-0.2-0.2-0.2-0.5c0-0.2,0-0.3,0.3-0.3c1,0,2.1-0.2,2.1-1.5
	L137.7,27.5L137.7,27.5z`
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            fill: "#084323",
            d: `M161.8,38c0,2.6,2.7,2.6,3.7,2.6c3.3,0,6.7-2.7,6.7-7.7c0-4.2-2.3-6.3-3.9-7.3c-1.1-0.5-2.6-0.6-3.7-0.6
	c-1.9,0-2.9,0.1-2.9,1.7L161.8,38L161.8,38z M159.7,27.4c0-0.9-0.2-1.8-1.1-1.8c-0.3,0-1,0.1-1.5,0.1c-0.1,0-0.1-0.4-0.1-0.5
	s0-0.2,0.4-0.3c1.6-0.3,5.4-0.6,7.4-0.6c1.3,0,2.5,0.1,3.7,0.4c3.2,0.9,6.3,3.8,6.3,8.2c0,5.9-4.9,8.6-9.4,8.6
	c-2.3,0-3.4-0.1-4.6-0.1c-1.2,0-2.4,0.1-3.6,0.1c-0.1,0-0.1-0.2-0.1-0.4s0.1-0.4,0.2-0.4c0.8-0.1,1.4-0.1,1.8-0.4
	c0.4-0.2,0.6-0.6,0.6-1.4L159.7,27.4L159.7,27.4z`
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            fill: "#084323",
            d: `M185.8,33.8l-2.6-6.8l0,0l-2.3,6.8H185.8z M180.5,34.7l-1,3.4c-0.2,0.6-0.3,1.2-0.3,1.5c0,0.8,1.1,1,1.8,1
	c0.2,0,0.3,0.1,0.3,0.5c0,0.2,0,0.3-0.2,0.3c-0.5,0-2.3-0.1-2.9-0.1c-0.6,0-1.6,0.1-2.4,0.1c-0.5,0-0.5-0.1-0.5-0.4v-0.3
	c0-0.1,0.2-0.2,0.8-0.2c1.2-0.1,1.4-0.4,1.9-1.7l4.7-13.7c0.5-0.4,1-1,1.6-1.1l6,15.1c0.4,1,0.8,1.5,2.2,1.5c0.3,0,0.3,0.3,0.3,0.5
	c0,0.3-0.2,0.3-0.5,0.3c-0.4,0-1.9-0.1-2.8-0.1c-1,0-1.9,0-2.9,0.1c-0.4,0-0.4-0.1-0.4-0.4c0-0.3,0.1-0.4,0.5-0.4s1.5-0.1,1.5-0.6
	c0-0.2-0.1-0.6-0.4-1.4l-1.5-3.8L180.5,34.7L180.5,34.7z`
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            fill: "#084323",
            d: `M199.5,32.2c0.3,0,0.6,0,0.9,0c1.9,0,4.3-0.7,4.3-3.5c0-2.1-1.4-3.5-3.5-3.5c-1.6,0-1.7,0.4-1.7,1.1V32.2z
	 M197.3,27.2c0-1.2,0-1.8-1.5-1.8h-1c-0.1,0-0.2-0.3-0.2-0.5c0-0.1,0.1-0.3,0.2-0.3c1.4,0,2.8,0.1,4.2,0.1c1.1,0,2.2-0.1,3.3-0.1
	c2.4,0,4.8,1.6,4.8,4.1c0,2.2-2,3.6-3.8,3.9l0,0c0.9,0.2,1.9,2,2.1,2.3l2.6,4c0.8,1.3,1.4,1.5,2.8,1.6l0.1,0.1v0.5
	c0,0.2-0.2,0.2-0.3,0.2c-0.5,0-1.2-0.1-1.6-0.1c-0.6,0-1.1,0.1-1.7,0.1c-0.5,0-1.6-1.6-3-4.1c-1.5-2.7-2.5-4.2-4-4.2
	c-0.2,0-0.5,0-0.8,0v5.8c0,0.9,0,1.7,1.2,1.7c0.9,0,1.3,0,1.3,0.2c0,0.5-0.1,0.6-0.4,0.6c-1.2,0-2.3-0.1-3.3-0.1
	c-0.4,0-3,0.1-3.4,0.1c-0.1,0-0.2-0.3-0.2-0.5s0.1-0.3,0.6-0.3c1.6-0.1,2.1-0.3,2.1-2V27.2H197.3z`
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            fill: "#084323",
            d: `M222.4,33.8l-2.6-6.8l0,0l-2.3,6.8H222.4z M217.1,34.7l-1,3.4c-0.2,0.6-0.3,1.2-0.3,1.5c0,0.8,1.1,1,1.8,1
	c0.2,0,0.3,0.1,0.3,0.5c0,0.2,0,0.3-0.2,0.3c-0.5,0-2.3-0.1-2.9-0.1c-0.6,0-1.6,0.1-2.4,0.1c-0.5,0-0.5-0.1-0.5-0.4v-0.3
	c0-0.1,0.2-0.2,0.8-0.2c1.2-0.1,1.4-0.4,1.9-1.7l4.7-13.7c0.5-0.4,1-1,1.6-1.1l6,15.1c0.4,1,0.8,1.5,2.2,1.5c0.3,0,0.3,0.3,0.3,0.5
	c0,0.3-0.2,0.3-0.5,0.3c-0.4,0-1.9-0.1-2.8-0.1c-1,0-1.9,0-2.9,0.1c-0.4,0-0.4-0.1-0.4-0.4c0-0.3,0.1-0.4,0.5-0.4s1.5-0.1,1.5-0.6
	c0-0.2-0.1-0.6-0.4-1.4l-1.5-3.8L217.1,34.7L217.1,34.7z`
          }
        )
      ]
    }
  );
}
function Oet({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      className: z("h-4 w-4", e),
      viewBox: "0 0 256 256",
      ...t,
      children: /* @__PURE__ */ d("path", { d: "M224 104a8 8 0 0 1-16 0V59.32l-66.33 66.34a8 8 0 0 1-11.32-11.32L196.68 48H152a8 8 0 0 1 0-16h64a8 8 0 0 1 8 8Zm-40 24a8 8 0 0 0-8 8v72H48V80h72a8 8 0 0 0 0-16H48a16 16 0 0 0-16 16v128a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-72a8 8 0 0 0-8-8Z" })
    }
  );
}
function Pqe() {
  return /* @__PURE__ */ k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      children: [
        /* @__PURE__ */ d(
          "mask",
          {
            id: "mask0_7106_5812",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "20",
            height: "20",
            children: /* @__PURE__ */ d("path", { d: "M20 0H0V20H20V0Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ k("g", { mask: "url(#mask0_7106_5812)", children: [
          /* @__PURE__ */ d(
            "path",
            {
              d: "M19.6 10.2274C19.6 9.51828 19.5364 8.83648 19.4182 8.18188H10V12.0501H15.3818C15.15 13.3001 14.4455 14.3592 13.3864 15.0683V17.5774H16.6182C18.5091 15.8365 19.6 13.2728 19.6 10.2274Z",
              fill: "#4285F4"
            }
          ),
          /* @__PURE__ */ d(
            "path",
            {
              d: "M9.99988 19.9999C12.6999 19.9999 14.9635 19.1044 16.618 17.5772L13.3862 15.0681C12.4908 15.6681 11.3453 16.0226 9.99988 16.0226C7.39528 16.0226 5.19078 14.2635 4.40438 11.8999H1.06348V14.4908C2.70898 17.759 6.09078 19.9999 9.99988 19.9999Z",
              fill: "#34A853"
            }
          ),
          /* @__PURE__ */ d(
            "path",
            {
              d: "M4.4045 11.8999C4.2045 11.2999 4.0909 10.659 4.0909 9.99993C4.0909 9.34083 4.2045 8.69993 4.4045 8.09993V5.50903H1.0636C0.3864 6.85903 0 8.38633 0 9.99993C0 11.6135 0.3864 13.1408 1.0636 14.4908L4.4045 11.8999Z",
              fill: "#FBBC04"
            }
          ),
          /* @__PURE__ */ d(
            "path",
            {
              d: "M9.99988 3.9773C11.468 3.9773 12.7862 4.4818 13.8226 5.4727L16.6908 2.6045C14.959 0.9909 12.6953 0 9.99988 0C6.09078 0 2.70898 2.2409 1.06348 5.5091L4.40438 8.1C5.19078 5.7364 7.39528 3.9773 9.99988 3.9773Z",
              fill: "#E94235"
            }
          )
        ] })
      ]
    }
  );
}
function Tqe() {
  return /* @__PURE__ */ k("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", children: [
    /* @__PURE__ */ k("g", { clipPath: "url(#clip0_7106_5805)", children: [
      /* @__PURE__ */ d("path", { d: "M9.52358 0.952393H0.952148V9.52382H9.52358V0.952393Z", fill: "#F25022" }),
      /* @__PURE__ */ d("path", { d: "M9.52358 10.4761H0.952148V19.0475H9.52358V10.4761Z", fill: "#00A4EF" }),
      /* @__PURE__ */ d("path", { d: "M19.048 0.952393H10.4766V9.52382H19.048V0.952393Z", fill: "#7FBA00" }),
      /* @__PURE__ */ d("path", { d: "M19.048 10.4761H10.4766V19.0475H19.048V10.4761Z", fill: "#FFB900" })
    ] }),
    /* @__PURE__ */ d("defs", { children: /* @__PURE__ */ d("clipPath", { id: "clip0_7106_5805", children: /* @__PURE__ */ d("rect", { width: "20", height: "20", fill: "white" }) }) })
  ] });
}
function ket(e) {
  return /* @__PURE__ */ k(
    "svg",
    {
      width: "188",
      height: "142",
      viewBox: "0 0 188 142",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ d(
          "path",
          {
            d: "M46.6052 16.0616C47.2546 16.3283 48.4722 16.6762 49.6782 16.6646C51.754 19.3201 55.7663 21.6162 58.3986 21.9409C58.7581 21.9757 59.1176 21.9757 59.4191 21.9525C62.0514 25.9184 67.722 29.9423 71.7111 30.3597C72.3488 30.4177 72.8939 30.3829 73.3693 30.3134C76.825 36.6449 85.2322 43.3707 90.8912 43.9273C91.9696 44.0201 92.8394 43.9041 93.5699 43.6606C93.6047 43.9389 93.6395 44.2056 93.7091 44.4955C93.8019 45.6899 94.3005 46.7568 95.1238 47.5337C96.0051 48.3687 97.1763 48.7977 98.4171 48.7514C98.8114 48.7514 99.0086 48.9137 99.0202 49.2964L99.0317 49.5399L99.1017 49.795C99.4377 51.0126 100.226 51.9867 101.282 52.5781C102.337 53.1695 103.555 53.2855 104.784 52.9376C105.155 52.81 105.398 52.9608 105.491 53.3203L105.549 53.5638L105.688 53.8073C106.326 54.8742 107.323 55.6511 108.483 55.9526C109.643 56.2425 110.895 56.057 111.985 55.4076C112.321 55.2104 112.565 55.2916 112.774 55.6163L112.901 55.8134L113.063 56.0106C113.968 56.8919 115.104 57.3905 116.31 57.3905C117.505 57.3905 118.676 56.9035 119.581 56.0106C119.847 55.7207 120.137 55.7207 120.415 55.999L120.589 56.1729L120.81 56.3005C123.036 57.6225 125.831 56.8919 127.13 54.6538C127.327 54.3059 127.617 54.2364 127.941 54.4219L128.173 54.5611L128.417 54.6538C129.623 54.9785 130.887 54.851 131.931 54.2596C132.997 53.6566 133.774 52.6593 134.111 51.4301C134.157 51.2909 134.238 51.117 134.389 51.0358C134.551 50.943 134.737 50.9894 134.853 51.001L135.108 51.0822L135.363 51.0938C137.961 51.1286 140.013 49.1572 140.071 46.5365C140.094 46.1422 140.303 45.9219 140.674 45.9451H140.941L141.184 45.8871C143.295 45.3884 144.768 43.5446 144.744 41.3877L144.733 36.5057L144.721 35.207L143.515 34.6619C136.986 31.8093 132.835 26.6721 128.672 16.3515C125.506 8.48927 120.74 3.41012 114.525 1.20684C106.465 -1.65743 98.6723 1.21844 94.7064 3.21299C89.7432 -0.880489 80.9532 -0.915277 74.3782 3.21299C70.7486 0.916929 64.8577 0.928519 60.3236 3.35214C57.6796 2.04177 53.7137 2.05336 50.5248 3.52608C48.5418 2.76073 45.376 2.49402 43.138 3.57247C41.3058 4.46538 40.3085 6.10045 40.3085 8.15298C40.3085 12.2465 43.5438 14.9136 46.6052 16.0616Z",
            fill: "#FFF1CC"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M44.831 7.26007C45.7703 6.72664 47.4518 6.8426 48.5418 7.10932L48.507 12.4436C47.7185 12.2117 46.7212 11.771 45.8283 11.0173C44.8194 10.1707 44.3208 9.20823 44.3208 8.14138C44.3324 7.63115 44.5063 7.41082 44.831 7.26007ZM52.6005 7.01655C54.5602 6.2512 56.8911 6.27439 58.2594 6.8426L58.2942 17.8242C56.6476 17.3836 53.6557 15.5282 52.6005 13.8351V7.01655ZM62.3645 6.8542C65.797 5.06838 70.1456 5.25392 72.2909 6.69185V26.3591C71.943 26.3359 71.3052 26.2315 70.4587 25.8836C67.2697 24.6196 63.6169 21.5002 62.3645 19.0302V6.8542ZM76.3379 6.74983C81.4983 3.44491 88.8039 3.34055 92.3407 6.52951V39.7875C92.1436 39.8571 91.8305 39.9266 91.2739 39.8686C86.9369 39.4628 78.634 32.8877 76.3148 27.1708L76.3379 6.74983ZM96.3646 6.90058C102.07 4.01313 108.286 3.29416 113.179 5.022C118.259 6.81941 122.236 11.1448 124.938 17.8706C129.252 28.5623 133.879 34.4648 140.697 37.8393C140.697 39.2656 140.72 41.4109 140.72 41.4341C140.732 41.724 140.547 41.8632 140.384 41.9444C137.972 42.0719 136.094 43.9969 136.036 46.4669C136.024 46.8844 135.78 47.0235 135.56 47.0351C134.482 46.8264 133.368 46.9887 132.429 47.5221C131.351 48.102 130.574 49.1108 130.237 50.3284C130.191 50.4676 130.122 50.6415 129.959 50.7227C129.866 50.7923 129.762 50.8039 129.623 50.7923C127.454 49.7022 124.892 50.4792 123.651 52.6013C123.43 52.9724 123.152 52.9724 122.943 52.8912C121.111 51.3025 118.444 51.3953 116.693 53.1347C116.6 53.2275 116.45 53.355 116.276 53.355C116.171 53.355 116.079 53.2855 115.997 53.2391C114.594 51.2329 112.055 50.6415 109.909 51.9287C109.793 51.9867 109.619 52.0795 109.469 52.0331C109.364 51.9983 109.272 51.9287 109.225 51.8359C108.355 49.5399 106.036 48.3687 103.636 49.0528C103.52 49.0876 103.334 49.1108 103.183 49.0297C103.091 48.9833 103.033 48.9021 102.986 48.7977C102.731 46.3393 100.771 44.6115 98.2896 44.6927C98.0925 44.6927 97.9649 44.6463 97.8605 44.5535C97.7562 44.4723 97.6982 44.2984 97.6982 44.0897V43.9041L97.6518 43.6954C97.5822 43.3475 97.5126 42.9532 97.4547 42.5938C97.3387 41.6777 97.1648 40.4601 96.3762 39.5555V6.90058H96.3646ZM46.6052 16.0616C47.2546 16.3283 48.4722 16.6762 49.6782 16.6646C51.754 19.3201 55.7663 21.6162 58.3986 21.9409C58.7581 21.9757 59.1176 21.9757 59.4191 21.9525C62.0514 25.9184 67.722 29.9423 71.7111 30.3597C72.3488 30.4177 72.8939 30.3829 73.3693 30.3134C76.825 36.6449 85.2322 43.3707 90.8912 43.9273C91.9696 44.0201 92.8394 43.9041 93.5699 43.6606C93.6047 43.9389 93.6395 44.2056 93.7091 44.4955C93.8019 45.6899 94.3005 46.7568 95.1238 47.5337C96.0051 48.3687 97.1763 48.7977 98.4171 48.7514C98.8114 48.7514 99.0086 48.9137 99.0202 49.2964L99.0317 49.5399L99.1017 49.795C99.4377 51.0126 100.226 51.9867 101.282 52.5781C102.337 53.1695 103.555 53.2855 104.784 52.9376C105.155 52.81 105.398 52.9608 105.491 53.3203L105.549 53.5638L105.688 53.8073C106.326 54.8742 107.323 55.6511 108.483 55.9526C109.643 56.2425 110.895 56.057 111.985 55.4076C112.321 55.2104 112.565 55.2916 112.774 55.6163L112.901 55.8134L113.063 56.0106C113.968 56.8919 115.104 57.3905 116.31 57.3905C117.505 57.3905 118.676 56.9035 119.581 56.0106C119.847 55.7207 120.137 55.7207 120.415 55.999L120.589 56.1729L120.81 56.3005C123.036 57.6225 125.831 56.8919 127.13 54.6538C127.327 54.3059 127.617 54.2364 127.941 54.4219L128.173 54.5611L128.417 54.6538C129.623 54.9785 130.887 54.851 131.931 54.2596C132.997 53.6566 133.774 52.6593 134.111 51.4301C134.157 51.2909 134.238 51.117 134.389 51.0358C134.551 50.943 134.737 50.9894 134.853 51.001L135.108 51.0822L135.363 51.0938C137.961 51.1286 140.013 49.1572 140.071 46.5365C140.094 46.1422 140.303 45.9219 140.674 45.9451H140.941L141.184 45.8871C143.295 45.3884 144.768 43.5446 144.744 41.3877L144.733 36.5057L144.721 35.207L143.515 34.6619C136.986 31.8093 132.835 26.6721 128.672 16.3515C125.506 8.48927 120.74 3.41012 114.525 1.20684C106.465 -1.65743 98.6723 1.21844 94.7064 3.21299C89.7432 -0.880489 80.9532 -0.915277 74.3782 3.21299C70.7486 0.916929 64.8577 0.928519 60.3236 3.35214C57.6796 2.04177 53.7137 2.05336 50.5248 3.52608C48.5418 2.76073 45.376 2.49402 43.138 3.57247C41.3058 4.46538 40.3085 6.10045 40.3085 8.15298C40.3085 12.2465 43.5438 14.9136 46.6052 16.0616Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M98.7998 10.3982C98.4867 10.5722 98.2896 10.9317 98.2896 11.3027C98.2896 11.9057 98.7766 12.3928 99.3797 12.3928C99.9597 12.3928 100.458 11.8941 100.458 11.3027C100.458 10.8621 100.168 10.491 99.8087 10.3171C100.11 10.1431 100.331 9.78361 100.331 9.38936C100.331 8.78636 99.8437 8.29932 99.2407 8.29932C98.6491 8.29932 98.1504 8.78636 98.1504 9.38936C98.1504 9.84161 98.4287 10.2243 98.7998 10.3982Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M78.8427 10.1917C79.4457 10.1917 79.9328 9.70464 79.9328 9.09004C79.9328 8.49864 79.4457 8 78.8427 8C78.2513 8 77.7759 8.48704 77.7759 9.09004C77.7759 9.70464 78.2513 10.1917 78.8427 10.1917Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M64.7649 9.6953C65.3563 9.6953 65.8434 9.20825 65.8434 8.60524C65.8434 7.99064 65.3563 7.5152 64.7649 7.5152C64.1619 7.5152 63.6633 7.99064 63.6633 8.60524C63.6633 9.20825 64.1503 9.6953 64.7649 9.6953Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M54.6646 9.81116C55.2676 9.81116 55.7547 9.32416 55.7547 8.70956C55.7547 8.10655 55.2676 7.61951 54.6646 7.61951C54.0616 7.61951 53.5746 8.11815 53.5746 8.70956C53.5746 9.32416 54.0616 9.81116 54.6646 9.81116Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M54.5718 13.6844C54.6762 13.6844 54.7806 13.6728 54.8849 13.638C54.8965 14.2294 55.3836 14.7165 55.9866 14.7165C56.5664 14.7165 57.065 14.2294 57.065 13.638C57.065 13.0234 56.5664 12.5364 55.9866 12.5364C55.8706 12.5364 55.7662 12.548 55.6619 12.5827C55.6503 12.2928 55.5227 12.0145 55.3256 11.8058C55.5923 11.6203 55.7662 11.284 55.7662 10.9245C55.7662 10.3331 55.2908 9.83435 54.6878 9.83435C54.0964 9.83435 53.6094 10.3215 53.6094 10.9245C53.6094 11.226 53.7253 11.5043 53.934 11.713C53.6673 11.887 53.4934 12.2117 53.4934 12.5943C53.505 13.1858 53.9804 13.6844 54.5718 13.6844Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M65.5651 19.8304C65.7274 19.8304 65.8666 19.784 65.9941 19.7376V19.784C65.9941 20.3754 66.4812 20.874 67.0726 20.874L67.1421 20.8624C67.1653 21.4423 67.6524 21.9061 68.209 21.9061C68.325 21.9061 68.4525 21.8713 68.5453 21.8365V21.9525C68.5453 22.5555 69.0323 23.0425 69.6237 23.0425C70.2267 23.0425 70.7138 22.5671 70.7138 21.9525C70.7138 21.3379 69.5889 20.8624 69.7629 20.8624C70.3543 20.8624 70.8413 20.3638 70.8413 19.7724C70.8413 19.181 70.3543 18.6824 69.7629 18.6824L69.5658 18.7171C69.5542 18.1373 69.0787 17.6619 68.4989 17.6619C68.2438 17.6619 68.0119 17.7431 67.8379 17.9054C67.6408 17.7199 67.3857 17.5923 67.0958 17.5923C66.7943 17.5923 66.5276 17.7199 66.3188 17.917L66.1681 17.8126C66.2145 17.6967 66.226 17.2444 66.226 17.1285L66.2145 17.0125C66.4 17.1401 66.5971 17.2212 66.8406 17.2212C67.4437 17.2212 67.9191 16.8154 67.9191 16.2124C67.9191 15.5978 67.4321 15.3542 66.8406 15.3542C66.7363 15.3542 66.6551 15.3658 66.5623 15.4006C66.4928 15.2847 66.4116 15.1919 66.2956 15.0991C66.5971 14.902 66.8059 14.5541 66.8059 14.1598C66.8059 13.7192 66.516 13.3365 66.1449 13.1742C66.0637 12.9306 65.8782 12.7567 65.6462 12.6407C65.9941 12.4552 66.226 12.1073 66.226 11.6782C66.226 11.0752 65.7506 10.5882 65.136 10.5882C64.533 10.5882 64.0576 11.0752 64.0576 11.6782C64.0576 12.1073 64.3011 12.4552 64.6374 12.6407C64.3011 12.8263 64.0576 13.1857 64.0576 13.6032C64.0576 13.9047 64.1967 14.2062 64.3938 14.4149C63.9068 14.5077 63.5473 14.9484 63.5473 15.4586C63.5473 16.05 63.988 16.5023 64.533 16.5487C64.2547 16.7342 64.0692 17.0705 64.0692 17.4648C64.0692 17.8358 64.2663 18.1721 64.5562 18.3693C64.5214 18.4968 64.4982 18.6012 64.4982 18.7287C64.4866 19.3317 64.9737 19.8304 65.5651 19.8304Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M81.3011 30.0003C81.2316 30.1742 81.1736 30.3481 81.1736 30.4989C81.1736 30.9975 81.4983 31.3918 81.9389 31.5542C81.8925 31.6585 81.8577 31.7977 81.8577 31.9484C81.8577 32.5514 82.3564 33.0385 82.9594 33.0385C83.1333 33.0385 83.3305 32.9805 83.4928 32.8877V32.9457C83.4928 33.5487 83.9567 34.0126 84.5713 34.0126C84.7684 34.0126 84.9655 33.9662 85.1395 33.8734L85.1163 34.0937C85.1163 34.6967 85.5917 35.207 86.2179 35.207L86.4035 35.1722C86.6122 35.3461 86.8557 35.4621 87.1224 35.4621C87.679 35.4621 88.1545 35.033 88.2009 34.488L88.2704 34.4532C88.3748 34.6272 88.514 34.8127 88.6763 34.9287C88.3168 35.1142 88.0849 35.4737 88.0849 35.8911C88.0849 36.5173 88.572 37.0044 89.175 37.0044C89.7664 37.0044 90.2418 36.5173 90.2418 35.8911C90.2418 35.5433 90.0679 35.2186 89.7896 35.0098C90.1259 34.8243 90.3694 34.4648 90.3694 34.0241C90.3694 33.4559 89.9055 32.9805 89.3141 32.9573V32.9457C89.8939 32.9225 90.3694 32.4587 90.3694 31.8673C90.3694 31.2642 89.8823 30.754 89.2909 30.754C88.8039 30.754 88.4096 31.0787 88.2589 31.5194L88.1893 31.4846C88.2589 31.3338 88.3284 31.1483 88.3284 30.9627C88.3284 30.3597 87.8414 29.8727 87.2616 29.8727C86.9833 29.8727 86.7745 29.9655 86.589 30.1162C86.6702 29.9423 86.7513 29.7567 86.7513 29.5712C86.7513 28.945 86.2643 28.4812 85.6729 28.4812C85.3366 28.4812 85.0583 28.6087 84.8612 28.8406C84.896 28.7363 84.9076 28.6435 84.9076 28.5275C84.9076 27.9477 84.4205 27.4259 83.8059 27.4259L83.7363 27.4491C83.8059 27.3215 83.8639 27.1708 83.8639 27.0084C84.0262 27.1128 84.235 27.194 84.4321 27.194C85.0351 27.194 85.5222 26.6953 85.5222 26.0807C85.5222 25.4545 85.0351 24.9907 84.4321 24.9907C83.8755 24.9907 83.4232 25.4429 83.3653 25.988C83.2029 25.8836 82.9942 25.8256 82.7854 25.8256C82.5071 25.8256 82.0085 26.0228 81.9737 25.9996C82.1824 25.8024 82.2984 25.5357 82.2984 25.2458C82.2984 24.6428 81.7998 24.1442 81.22 24.1442C81.1272 24.1442 81.1852 23.7731 81.1852 23.518C81.1852 22.915 80.7097 22.4279 80.1067 22.4279C80.0487 22.4279 81.0692 21.9525 81.0692 21.3495C81.0692 20.7697 80.6169 20.2942 80.0255 20.2594L80.0371 20.2478C80.0371 19.8536 79.8052 19.5173 79.5037 19.3085C79.782 19.1114 79.9444 18.8099 79.9444 18.4272C79.9444 18.2533 79.898 18.1141 79.8284 17.9402C80.1995 17.7547 80.4662 17.4068 80.4662 16.9661C80.4662 16.6066 80.3038 16.2819 80.0371 16.0848C80.3154 15.8761 80.5474 15.5514 80.5474 15.1571C80.5474 14.7048 80.2691 14.3222 79.8864 14.1598C79.782 13.9163 79.5965 13.7424 79.3877 13.6148C79.724 13.4177 79.9676 13.0698 79.9676 12.6523C79.9676 12.0493 79.4805 11.5739 78.8775 11.5739C78.2861 11.5739 77.8107 12.0377 77.8107 12.6523C77.8107 13.0698 78.031 13.4177 78.3905 13.6148C78.031 13.8119 77.8107 14.1598 77.8107 14.5657C77.8107 14.8904 77.9382 15.1803 78.147 15.3658C77.6483 15.4586 77.2888 15.8993 77.2888 16.4327C77.2888 17.0125 77.7295 17.4647 78.2745 17.5111C77.9846 17.7083 77.8107 18.0446 77.8107 18.4156C77.8107 18.8099 78.0078 19.1694 78.3093 19.3549C78.0426 19.5521 77.8802 19.8768 77.8802 20.2246C77.8802 20.6769 78.1701 21.0712 78.5644 21.2335C78.1238 21.3727 77.7991 21.7669 77.7991 22.2772C77.7991 22.7642 78.1238 23.1817 78.5644 23.3208C78.4021 23.4948 78.3093 23.7267 78.3093 24.0282C78.3093 24.4921 78.6224 24.9095 79.0631 25.0487V25.0603L78.8427 25.0255C78.2513 25.0255 77.7759 25.5473 77.7759 26.1387C77.7759 26.6953 78.2049 27.194 78.7732 27.2172L78.75 27.4259C78.75 28.0405 79.237 28.5275 79.8284 28.5275L80.0023 28.5159C79.9328 28.6551 79.9096 28.8058 79.9096 28.9914C79.9096 29.5944 80.3966 30.0814 80.9996 30.0814C81.104 30.0698 81.2084 30.035 81.3011 30.0003Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M89.2909 30.0003C89.8823 30.0003 90.3694 29.5364 90.3694 28.9218C90.3694 28.3188 89.8823 27.8434 89.2909 27.8434C88.6879 27.8434 88.2125 28.3188 88.2125 28.9218C88.2125 29.5248 88.6879 30.0003 89.2909 30.0003Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M98.765 24.8007C98.4635 24.9863 98.278 25.3342 98.278 25.7052C98.278 26.2966 98.7187 26.7489 99.2757 26.7953V27.062C98.765 27.1548 98.3476 27.5954 98.3476 28.152C98.3476 28.4188 98.4287 28.6275 98.5679 28.8014C98.3824 29.0102 98.2664 29.2653 98.2664 29.5668C98.2664 30.0654 98.5911 30.4481 99.0317 30.5873C98.8694 30.796 98.7766 31.0279 98.7766 31.283C98.7766 31.6425 98.9274 31.944 99.1827 32.1411V32.3499C98.6491 32.4311 98.2664 32.8717 98.2664 33.4283C98.2664 33.8342 98.4983 34.1937 98.8462 34.3908C98.5099 34.5763 98.2664 34.9358 98.2664 35.3301C98.2664 35.6548 98.4171 35.9679 98.6375 36.1534C98.2316 36.3158 97.9533 36.6985 97.9533 37.1739C97.9533 37.6957 98.336 38.1364 98.8346 38.2408C98.4983 38.4263 98.278 38.7858 98.278 39.1916C98.278 39.7831 98.765 40.2817 99.3677 40.2817L99.5647 40.2585C99.6467 40.7803 100.087 41.1862 100.644 41.1862C100.911 41.1862 101.166 41.0934 101.351 40.9079L101.34 41.0586C101.34 41.6732 101.827 42.1603 102.418 42.1603C102.905 42.1603 103.323 41.8356 103.439 41.3833C103.589 41.8008 103.995 42.0907 104.447 42.0907C104.819 42.0907 105.155 41.8936 105.364 41.6384C105.503 42.0443 105.897 42.3458 106.372 42.3458C106.581 42.3458 106.778 42.2878 106.941 42.1835C106.964 42.7749 107.428 43.2503 108.019 43.2503C108.622 43.2503 109.109 42.7517 109.109 42.1603C109.109 42.0791 109.643 42.6357 110.095 42.6357C110.246 42.6357 110.396 42.6009 110.512 42.5545C110.709 42.7749 110.999 42.9256 111.347 42.9256C111.834 42.9256 112.24 42.5893 112.368 42.1255C112.542 42.5082 112.924 42.8097 113.388 42.8097C113.968 42.8097 114.467 42.3226 114.467 41.708C114.467 41.6269 115 42.4154 115.545 42.4154C115.789 42.4154 116.009 42.3342 116.183 42.2183C116.38 42.485 116.705 42.6705 117.064 42.6705C117.54 42.6705 117.945 42.369 118.073 41.9515C118.27 42.0907 118.491 42.1719 118.722 42.1719C119.325 42.1719 119.812 41.6848 119.812 41.0702L119.952 40.9543C119.952 41.5573 120.415 42.0443 121.018 42.0443C121.575 42.0443 122.016 41.6384 122.097 41.1166C122.294 41.2906 122.549 41.3949 122.816 41.3949C123.268 41.3949 123.651 41.1166 123.802 40.7339C124.103 40.5716 124.312 40.2585 124.358 39.9222C124.509 40.3165 124.892 40.618 125.355 40.618C125.947 40.618 126.434 40.1425 126.434 39.5279C126.434 38.9365 125.947 38.4379 125.355 38.4379C124.81 38.4379 124.358 38.8554 124.277 39.3772C124.184 39.1453 124.01 38.9597 123.813 38.8322C123.651 38.4263 123.257 38.1132 122.793 38.1132C122.375 38.1132 122.004 38.3683 121.83 38.7046C121.645 38.4727 121.343 38.3335 120.984 38.3335C120.903 38.3335 120.787 38.3567 120.671 38.3915C120.671 38.2292 120.636 38.0784 120.601 37.9393C120.937 37.7653 121.192 37.4058 121.192 36.9768C121.192 36.3622 120.694 35.8635 120.114 35.8635C119.499 35.8635 119.012 36.3622 119.012 36.9768C119.012 37.1159 119.059 37.2783 119.117 37.4058C118.757 37.5914 118.409 38.4263 118.375 38.4263L118.398 38.2639C118.398 37.6378 117.911 37.1855 117.296 37.1855C117.18 37.1855 117.076 37.1855 116.96 37.2319C116.902 36.6985 116.45 36.2578 115.893 36.2578C115.487 36.2578 115.139 36.5013 114.942 36.8492C114.757 36.5013 114.409 36.2578 113.98 36.2578C113.539 36.2578 113.145 36.5477 112.982 36.9304C112.843 36.4665 112.449 36.1302 111.927 36.1302C111.544 36.1302 110.965 36.6521 110.941 36.6521C111.046 36.4665 111.104 36.2694 111.104 36.0955C111.104 35.4693 110.628 34.9938 110.025 34.9938C109.469 34.9938 109.19 35.3881 109.19 35.0518L109.179 34.8547C109.701 34.7503 110.106 34.3096 110.106 33.7762C110.106 33.1848 109.608 32.663 109.005 32.663C108.413 32.663 107.926 33.1848 107.926 33.7762L107.95 33.9965H107.602L107.683 33.6023C107.683 32.7905 106.859 32.7094 106.755 32.6746C106.314 32.6862 105.967 32.9529 105.781 33.3356C105.688 32.8369 105.271 32.4658 104.772 32.4658C104.935 32.2687 105.027 32.0136 105.027 31.7353C105.027 31.1207 104.552 30.6452 103.949 30.6452C103.752 30.6452 103.589 30.7032 103.439 30.7612C103.485 30.6684 103.497 30.5641 103.497 30.4481L103.485 30.251H103.694C104.285 30.251 104.772 29.7639 104.772 29.1493C104.772 28.5695 104.517 28.1752 103.926 28.1752C103.334 28.1752 102.812 28.4304 102.812 29.0218L102.673 29.5668L102.349 29.648C101.977 29.648 101.827 29.8335 101.63 30.0886C101.572 29.9842 101.456 29.5784 101.398 29.474L101.514 29.4972C102.128 29.4972 102.615 29.0102 102.615 28.3956C102.615 27.781 102.128 27.3171 101.514 27.3171L101.363 27.3287C101.653 27.1896 101.873 26.9228 101.931 26.5866C102.337 26.4242 102.615 26.0299 102.615 25.5777C102.615 24.9631 102.128 24.4644 101.514 24.4644C101.27 24.4644 101.05 24.5688 100.876 24.708C100.922 24.5804 100.957 24.4413 100.957 24.2905C100.957 23.931 100.783 23.6295 100.528 23.3976C100.725 23.27 100.887 23.0729 100.957 22.8294C101.189 22.6438 101.351 22.3539 101.351 22.0176C101.351 21.403 100.853 20.916 100.261 20.916C100.145 20.916 100.029 20.9392 99.9127 20.974L99.8667 20.9508C100.215 20.7537 100.458 20.4058 100.458 19.9767C100.458 19.5824 100.261 19.2461 99.9477 19.049C100.458 18.9446 100.841 18.5156 100.841 17.9822C100.841 17.4951 100.516 17.0893 100.076 16.9501C100.308 16.7298 100.47 16.4399 100.47 16.1152C100.47 15.6977 100.226 15.3382 99.8787 15.1759C100.226 14.9787 100.47 14.6077 100.47 14.2134C100.47 13.5872 99.9707 13.1233 99.3917 13.1233C98.7882 13.1233 98.3012 13.5872 98.3012 14.2134C98.3012 14.6077 98.5331 14.9787 98.881 15.1759C98.5447 15.3498 98.3012 15.6977 98.3012 16.1152C98.3012 16.6254 98.6259 17.0197 99.0667 17.1472C98.823 17.3792 98.6839 17.6575 98.6839 17.9822C98.6839 18.3532 98.881 18.7011 99.1827 18.8983C98.6839 19.0026 98.3128 19.4201 98.3128 19.9767C98.3128 20.3942 98.5447 20.7421 98.8926 20.9508C98.5563 21.1247 98.3128 21.4958 98.3128 21.9133C98.3128 22.2264 98.4403 22.5047 98.6491 22.6902C98.162 22.7946 97.8025 23.2352 97.8025 23.7571C97.7678 24.2673 98.22 24.7428 98.765 24.8007Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M128.208 39.4468C128.811 39.4468 129.275 38.9597 129.275 38.3451C129.275 37.7537 128.811 37.2551 128.208 37.2551C127.605 37.2551 127.13 37.7421 127.13 38.3451C127.13 38.9597 127.605 39.4468 128.208 39.4468Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M125.854 44.0041L125.866 44.12C125.773 44.236 125.703 44.3404 125.645 44.4911C125.471 44.3404 125.263 44.2476 125.019 44.2476C124.521 44.2476 124.103 44.5955 123.964 45.0709C123.778 44.897 123.512 44.781 123.222 44.781C122.851 44.781 122.549 44.955 122.34 45.2333C122.143 45.0361 121.865 44.9086 121.564 44.9086C120.972 44.9086 120.473 45.3956 120.473 45.987C120.473 46.59 120.972 47.0887 121.564 47.0887C121.935 47.0887 122.248 46.9147 122.456 46.6248C122.642 46.822 122.92 46.9611 123.222 46.9611C123.72 46.9611 124.138 46.6016 124.277 46.1494C124.474 46.3233 124.729 46.4393 125.019 46.4393C125.471 46.4393 125.889 46.1378 126.028 45.7087C126.214 45.8595 126.434 45.9291 126.666 45.9291C127.107 45.9291 127.478 45.6739 127.652 45.2913C127.837 45.4536 128.081 45.5348 128.336 45.5348C128.881 45.5348 129.321 45.1289 129.403 44.5955C129.565 44.6998 129.762 44.781 130.006 44.781C130.516 44.781 130.98 44.3752 131.061 43.8533C131.246 44.0157 131.501 44.1316 131.791 44.1316C132.394 44.1316 132.87 43.6446 132.87 43.0416L132.835 42.7981C133.009 42.914 133.218 42.9836 133.438 42.9836C134.029 42.9836 134.516 42.4966 134.516 41.9168C134.69 42.0211 134.888 42.0791 135.108 42.0791C135.699 42.0791 136.186 41.5921 136.186 41.0007L136.175 40.8151C136.302 40.8731 136.465 40.9311 136.627 40.9311C137.23 40.9311 137.729 40.444 137.729 39.841C137.729 39.2148 137.23 38.7278 136.627 38.7278C136.349 38.7278 136.105 38.8438 135.896 39.0293C135.699 38.7046 135.363 38.4959 134.969 38.4959C134.366 38.4959 133.879 38.9829 133.879 39.5627C133.879 39.8874 134.006 40.1541 134.215 40.3629L134.134 40.5136C134.041 39.9802 133.612 39.5627 133.067 39.5627C132.452 39.5627 131.965 40.0614 131.965 40.6644C131.965 40.7455 131.977 40.8267 132.012 40.9311C131.815 40.7919 131.629 40.7339 131.386 40.7339C130.794 40.7339 130.307 41.221 130.307 41.824C130.307 42.2067 130.493 42.4966 130.759 42.7053L130.701 42.8792C130.585 42.7981 130.469 42.7169 130.33 42.6705C130.145 42.2878 129.785 42.0327 129.345 42.0327C128.742 42.0327 128.266 42.5198 128.266 43.1344L128.301 43.3895C128.15 43.4011 127.999 43.4243 127.86 43.4822C127.686 43.1576 127.315 42.9372 126.909 42.9372C126.33 42.914 125.854 43.3895 125.854 44.0041Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M113.527 35.0054C114.119 35.0054 114.606 34.5184 114.606 33.927C114.606 33.324 114.119 32.8369 113.527 32.8369C112.901 32.8369 112.426 33.3356 112.426 33.927C112.414 34.5184 112.901 35.0054 113.527 35.0054Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M106.755 31.0859C107.381 31.0859 107.868 30.5989 107.868 30.0074C107.868 29.3928 107.381 28.9174 106.755 28.9174C106.164 28.9174 105.677 29.3928 105.677 30.0074C105.677 30.5989 106.164 31.0859 106.755 31.0859Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M103.578 24.4065C104.181 24.4065 104.656 23.931 104.656 23.328C104.656 22.725 104.169 22.238 103.578 22.238C102.986 22.238 102.511 22.725 102.511 23.328C102.499 23.931 102.986 24.4065 103.578 24.4065Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M119.267 45.0361C118.676 45.0361 118.189 45.5348 118.189 46.1262C118.189 46.7292 118.676 47.2162 119.267 47.2162C119.87 47.2162 120.358 46.7292 120.358 46.1262C120.358 45.5348 119.87 45.0361 119.267 45.0361Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M116.461 45.0361C115.87 45.0361 115.383 45.5348 115.383 46.1262C115.383 46.7292 115.881 47.2162 116.461 47.2162C117.076 47.2162 117.551 46.7292 117.551 46.1262C117.551 45.5348 117.076 45.0361 116.461 45.0361Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M112.507 45.1637C111.904 45.1637 111.417 45.6391 111.417 46.2422C111.417 46.8452 111.892 47.3322 112.507 47.3322C113.121 47.3322 113.585 46.8452 113.585 46.2422C113.585 45.6276 113.121 45.1637 112.507 45.1637Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M66.829 41.7008C66.829 41.0978 66.3304 40.6224 65.7506 40.6224C65.1476 40.6224 64.649 41.0978 64.649 41.7008C64.649 42.3038 65.136 42.7909 65.7506 42.7909C66.3304 42.7909 66.829 42.3038 66.829 41.7008Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M69.9948 45.1101C69.9948 44.5303 69.5078 44.0201 68.8932 44.0201C68.3018 44.0201 67.8147 44.5187 67.8147 45.1101C67.8147 45.7247 68.3134 46.2234 68.8932 46.2234C69.5078 46.2234 69.9948 45.7363 69.9948 45.1101Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M80.7097 49.0761C80.7097 48.473 80.2111 47.9744 79.6197 47.9744C79.0051 47.9744 78.5412 48.473 78.5412 49.0761C78.5412 49.6791 79.0051 50.1661 79.6197 50.1661C80.2111 50.1661 80.7097 49.6791 80.7097 49.0761Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M85.5801 54.2828C85.5801 53.6797 85.1047 53.1927 84.4901 53.1927C83.8871 53.1927 83.4116 53.6913 83.4116 54.2828C83.4116 54.8742 83.8987 55.3612 84.4901 55.3612C85.1047 55.3728 85.5801 54.8742 85.5801 54.2828Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M87.9342 62.3885C88.5488 62.3885 89.0242 61.9015 89.0242 61.3101C89.0242 60.7071 88.5488 60.1968 87.9342 60.1968C87.3428 60.1968 86.8557 60.6955 86.8557 61.3101C86.8557 61.9015 87.3428 62.3885 87.9342 62.3885Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M78.9239 46.2234C78.9703 46.7916 79.4225 47.2438 80.0139 47.2438C80.2923 47.2438 80.559 47.1395 80.7445 46.9307V47.0351C80.7445 47.6497 81.2315 48.1367 81.8114 48.1367C82.2984 48.1367 82.6927 47.8121 82.8318 47.383L82.8898 47.4758C82.8086 47.6497 82.7391 47.8352 82.7391 48.044C82.7391 48.6354 83.2145 49.134 83.8175 49.134C84.4089 49.134 84.9076 48.647 84.9076 48.044C84.9076 47.9396 84.9887 47.4642 84.9539 47.383C85.1279 47.7657 85.3946 48.4151 85.8468 48.4151C86.2527 48.4151 86.6006 48.2063 86.7861 47.8932C86.9601 48.2411 87.3312 48.473 87.7486 48.473C88.0965 48.473 88.398 48.3107 88.6067 48.0556V48.4846C88.6067 48.6354 88.6183 48.7629 88.6879 48.8905C88.1777 48.9949 87.8066 49.4355 87.8066 49.9689C87.8066 50.0269 87.737 50.3632 87.7022 50.4792C87.5979 50.4096 87.4819 50.4096 87.3544 50.4096C87.0181 50.4096 86.7166 50.5604 86.5194 50.8039L86.3803 50.7923C85.8005 50.7923 85.3018 51.2793 85.3018 51.9055C85.3018 52.4969 85.8005 52.9724 86.3803 52.9724C86.7282 52.9724 86.8673 52.5781 87.0644 52.3346L87.3544 52.2998C87.4703 52.2998 87.5747 52.5781 87.6675 52.5549C87.6559 52.6129 87.6443 52.7868 87.2036 52.8448C86.7282 52.9144 86.6006 53.0767 86.6006 53.6797C86.6006 54.0508 86.589 54.5031 86.8673 54.7234C86.589 54.9089 86.3803 55.2452 86.3803 55.6163C86.3803 55.8598 86.473 56.0918 86.6238 56.2889L86.3803 56.2541C85.7889 56.2541 85.3018 56.7411 85.3018 57.3557C85.3018 57.9587 85.7889 58.4458 86.3803 58.4458C86.7977 58.4458 87.134 58.2255 87.3312 57.9124C87.5167 58.1327 87.8182 58.2602 88.1197 58.2602C88.2473 58.2602 88.3632 58.2255 88.4792 58.2023C88.456 58.295 88.4444 58.3646 88.4444 58.4458C88.4444 59.0488 88.9314 59.5474 89.5112 59.5474C90.1142 59.5474 90.6129 59.0488 90.6129 58.4458L90.5897 58.353C90.7057 58.4226 91.1231 58.5386 91.2507 58.6197C90.9608 58.8169 90.752 59.1532 90.752 59.5474C90.752 60.1504 90.9492 60.5911 91.5522 60.5911C91.7725 60.5911 91.9696 60.5215 92.132 60.4171C92.2132 60.939 92.6654 61.3448 93.2104 61.3448C93.4772 61.3448 93.7091 61.2637 93.9178 61.0897C94.0222 61.1825 94.1497 61.2637 94.2657 61.2869C93.7091 61.3332 93.2684 61.8087 93.2684 62.4001C93.2684 62.9915 93.7439 63.4785 94.3469 63.4785C94.9267 63.4785 95.4253 62.9915 95.4253 62.4001C95.4253 61.9015 95.1006 61.484 94.6948 61.3564C94.8455 61.3448 94.9847 61.3217 95.1238 61.2405C95.3094 61.5536 95.6457 61.7391 96.0283 61.7391C96.4342 61.7391 96.7937 61.5188 96.9792 61.1825V61.1941C96.9792 61.7855 97.4779 62.2841 98.0693 62.2841C98.6839 62.2841 99.1477 61.7855 99.1477 61.1941V61.1825L99.2867 61.1941V61.2985C99.2867 61.8203 99.6467 62.2493 100.11 62.3769C99.8317 62.574 99.6577 62.9103 99.6577 63.2698C99.6577 63.8612 100.134 64.3599 100.748 64.3599C101.351 64.3599 101.815 63.8612 101.815 63.2698C101.815 63.1423 101.815 63.0263 101.769 62.9219C101.92 63.0031 102.093 63.0495 102.291 63.0495C102.847 63.0495 103.311 62.6204 103.346 62.0638C103.485 62.4929 103.891 62.8292 104.378 62.8292C104.749 62.8292 105.074 62.6552 105.271 62.3421C105.271 62.9451 105.758 63.4438 106.361 63.4438L106.419 63.4322C106.523 63.9424 106.952 64.3367 107.497 64.3367C108.089 64.3367 108.576 63.8496 108.576 63.2466L108.564 63.0495C109.144 63.0379 109.596 62.5508 109.596 61.971C109.596 61.7971 109.561 61.6463 109.503 61.4956H109.654C109.759 61.9015 110.13 62.2262 110.559 62.2725C110.512 62.3769 110.501 62.4813 110.501 62.6088C110.501 63.2118 110.988 63.6989 111.591 63.6989C112.194 63.6989 112.681 63.2002 112.681 62.6088L112.623 62.3421L112.75 62.3537C113.295 62.3537 113.771 61.9478 113.84 61.4144C114.038 61.6347 114.327 61.7739 114.652 61.7739C115.116 61.7739 115.522 61.484 115.661 61.0549C115.835 61.484 116.229 61.7739 116.705 61.7739C117.203 61.7739 117.632 61.4376 117.737 60.9854C117.934 61.1593 118.201 61.2753 118.479 61.2753C119.001 61.2753 119.43 60.9042 119.534 60.4519C119.696 60.5679 119.905 60.6491 120.149 60.6491C120.729 60.6491 121.227 60.1504 121.227 59.5474C121.227 58.9444 120.729 58.4458 120.149 58.4458C119.639 58.4458 119.209 58.7937 119.094 59.2923C118.92 59.1532 118.711 59.1068 118.479 59.1068C117.992 59.1068 117.551 59.4547 117.447 59.8953C117.238 59.7098 116.971 59.6054 116.705 59.6054C116.229 59.6054 115.835 59.9185 115.661 60.3592C115.522 59.9185 115.128 59.6054 114.652 59.6054C114.385 59.6054 114.119 59.7098 113.922 59.8953C113.852 59.3967 113.411 58.9676 112.855 58.9676L112.774 58.9792C112.704 58.4806 112.24 58.0863 111.695 58.0863C111.347 58.0863 111.057 58.2371 110.849 58.4922C110.767 58.4922 110.663 58.4458 110.559 58.4458C109.967 58.4458 109.492 58.9328 109.492 59.5242C109.48 58.9328 108.993 58.4458 108.39 58.4458C107.903 58.4458 107.497 58.7937 107.358 59.2111L107.138 59.13L107.184 58.898C107.184 58.295 106.674 57.8196 106.083 57.8196C105.688 57.8196 105.34 58.0399 105.132 58.3762C105.213 58.2139 105.259 58.0399 105.259 57.8776C105.259 57.263 104.772 56.7875 104.181 56.7875C104.204 56.6832 104.227 56.5672 104.227 56.4512C104.227 55.8598 103.74 55.3612 103.149 55.3612C102.557 55.3612 102.465 55.7671 102.465 56.3701C102.465 56.602 102.151 56.9035 102.279 57.1006C102.151 57.031 102.024 56.9615 101.908 56.9035C102.024 56.7411 102.082 56.544 102.082 56.3237C102.082 55.7207 101.583 55.2336 100.992 55.2336C100.76 55.2336 100.551 55.3264 100.389 55.4424C100.273 54.9437 99.8317 54.5958 99.3447 54.5958L99.1247 54.619C99.0317 54.1088 98.6143 53.7029 98.0577 53.7029C97.7678 53.7029 97.5126 53.8421 97.3039 54.016C97.4894 53.8189 97.6054 53.5522 97.6054 53.2739C97.6054 52.7868 97.2923 52.3694 96.8401 52.2186C96.9096 52.0679 96.956 51.8939 96.956 51.7084C96.956 51.117 96.4806 50.6183 95.8776 50.6183C95.5877 50.6183 95.3094 50.7575 95.1006 50.9314C94.9383 50.5256 94.5556 50.2357 94.0918 50.2357L93.883 50.2705C93.8019 49.737 93.3496 49.3428 92.8046 49.3428L92.5611 49.3891C92.677 49.2036 92.7582 48.9949 92.7582 48.7629C92.7582 48.1715 92.2712 47.7077 91.6913 47.6845C91.7957 47.5105 91.8653 47.325 91.8653 47.1047C91.8653 46.4785 91.3666 46.0146 90.7868 46.0146C90.2882 46.0146 89.8591 46.3509 89.72 46.8148H89.6736L89.6852 46.7104C89.6852 46.1074 89.2213 45.632 88.6067 45.632C88.4444 45.632 88.2705 45.6783 88.1313 45.7363C87.9226 45.4348 87.5863 45.2261 87.2268 45.2261C86.9833 45.2261 86.7977 45.2957 86.6122 45.4116C86.5658 44.8666 86.102 44.4607 85.5569 44.4607C85.267 44.4607 85.0003 44.5767 84.8148 44.7507C84.6872 44.2984 84.2698 43.9505 83.7595 43.9505C83.5624 43.9505 83.3421 44.0201 83.1797 44.1245L83.1913 44.0201C83.1913 43.4171 82.7043 42.93 82.1013 42.93C81.823 42.93 81.5678 43.0228 81.3823 43.1852C81.3011 42.6865 80.8837 42.3386 80.3618 42.2807L80.3734 42.2111C80.3734 41.6081 79.8748 41.1326 79.295 41.1326L79.0515 41.1558C79.0862 41.0631 79.0862 40.9587 79.0862 40.8543C79.0862 40.2397 78.6224 39.7527 78.0078 39.7527C77.4976 39.7527 77.4396 39.8918 77.4396 39.4396C77.4396 38.825 76.9525 38.3611 76.3611 38.3611C76.2336 38.3611 76.1408 38.3843 76.048 38.4075C76.1292 38.2568 76.1756 38.0828 76.1756 37.9089C76.1756 37.3059 75.6886 36.8304 75.0971 36.8304C74.958 36.8304 74.8072 36.842 74.6913 36.9C74.7377 36.7956 74.7609 36.6449 74.7609 36.5057C74.7609 35.9027 74.2738 35.3925 73.6824 35.3925L73.6128 35.4157V35.207C73.6128 34.604 73.1258 34.0937 72.546 34.0937H72.5112C72.5344 34.0357 72.5576 33.9546 72.5576 33.8502C72.5576 33.2588 72.0589 32.737 71.4559 32.737C71.2008 32.737 70.9573 32.8645 70.7718 33.0153C70.6326 32.563 70.2267 32.2499 69.7513 32.2499C69.5426 32.2499 69.357 32.3195 69.1947 32.3891C69.0555 32.3195 68.87 32.2499 68.6729 32.2499C68.4989 31.8673 68.1394 31.6121 67.6872 31.6121C67.2581 31.6121 66.8522 31.8788 66.6899 32.2847H66.6783C66.8059 32.0876 66.8522 31.8788 66.8522 31.6585C66.8522 31.0555 66.3768 30.5685 65.7738 30.5685C65.6346 30.5685 65.4723 30.6265 65.3447 30.696C65.1708 30.325 64.7997 30.0582 64.3822 30.0582C64.0807 30.0582 63.8024 30.1858 63.6053 30.4061C63.6517 30.2786 63.6749 30.151 63.6749 30.0003C63.6749 29.3857 63.1994 28.8986 62.5848 28.8986C62.2717 28.8986 61.9818 29.0726 61.7963 29.2929L61.7383 29.2581C61.8311 29.0842 61.8891 28.8986 61.8891 28.7015C61.8891 28.0985 61.402 27.6114 60.8106 27.6114C60.6831 27.6114 60.5787 27.6346 60.4511 27.6694L60.4859 27.4143C60.4859 26.8113 59.9989 26.3127 59.4075 26.3127L59.3495 26.3243L59.3263 26.2431C59.3263 25.8372 59.1176 25.4893 58.7697 25.3038C58.8045 25.211 58.8393 25.0835 58.8393 24.9675C58.8393 24.3645 58.3522 23.8891 57.7492 23.8891C57.3433 23.8891 56.9723 24.1326 56.7983 24.4689C56.6012 24.1326 56.2533 23.8891 55.8358 23.8891C55.6271 23.8891 55.4068 23.9354 55.256 24.0514C55.1864 23.518 54.7458 23.1121 54.1892 23.1121C53.8645 23.1121 53.563 23.2629 53.3426 23.5064C53.3195 23.0077 52.9484 22.5787 52.4497 22.4743C52.4381 21.9061 51.9511 21.4423 51.3713 21.4423C51.2321 21.4423 51.0698 21.4886 50.9306 21.5466V21.5002C50.9306 20.8972 50.4436 20.4218 49.8406 20.4218C49.6898 20.4218 49.5739 20.4334 49.4695 20.4914L49.4811 20.3174C49.4811 19.7028 48.9941 19.2158 48.4027 19.2158C48.1939 19.2158 48.0432 19.2622 47.8924 19.3433C47.7533 18.8911 47.3474 18.5896 46.8604 18.5896C46.5009 18.5896 46.1994 18.7635 45.9906 19.007C45.9559 18.462 45.492 18.0098 44.9122 18.0098L44.7383 18.0214C44.6223 17.5227 44.1932 17.1516 43.6598 17.1516C43.3235 17.1516 42.9988 17.3256 42.8133 17.6039C42.8249 17.5227 42.8365 17.4416 42.8365 17.3372C42.8365 16.7226 42.361 16.2355 41.758 16.2355C41.6305 16.2355 41.4913 16.2819 41.3638 16.3283C41.4101 16.224 41.4217 16.1196 41.4217 16.0036C41.4217 15.4006 40.9347 14.902 40.3317 14.902L40.1809 14.9136L40.2157 14.7048C40.2157 14.2758 39.949 13.8815 39.5547 13.7076C39.5084 13.151 39.0445 12.7219 38.4763 12.7219C38.0356 12.7219 37.6414 12.9886 37.4906 13.3829C37.3051 13.1857 37.0268 13.0698 36.7253 13.0698C36.1339 13.0698 35.6352 13.5684 35.6352 14.1714C35.6352 14.4961 35.7744 14.7744 35.9947 14.9716C35.8324 15.1571 35.728 15.389 35.728 15.6789C35.728 16.2819 36.215 16.769 36.8064 16.769C36.9456 16.769 37.05 16.7342 37.1775 16.6878L37.2007 16.8617C36.7137 16.9777 36.3658 17.4068 36.3658 17.9054C36.3658 18.5084 36.8644 18.9954 37.4558 18.9954C38.0588 18.9954 38.5459 18.52 38.5459 17.9054L38.5227 17.7199C38.6618 17.6735 38.7894 17.6387 38.917 17.5227C38.9633 18.0909 39.4272 18.52 39.9838 18.52C40.3781 18.52 40.7144 18.3229 40.9115 18.0098C41.097 18.2649 41.4101 18.4156 41.7464 18.4156C42.0943 18.4156 42.4074 18.2533 42.6045 17.975L42.5814 18.2533C42.5814 18.8447 43.0568 19.3433 43.6598 19.3433L43.8453 19.3317C43.9381 19.7956 44.344 20.1319 44.8194 20.1899L44.7035 20.3174C44.1584 20.3638 43.7178 20.8045 43.7178 21.3843C43.7178 21.9409 44.1584 22.4163 44.7035 22.4627L44.6687 22.7294C44.6687 23.3208 45.1673 23.8195 45.7471 23.8195C46.1414 23.8195 46.4777 23.6223 46.6632 23.3092C46.7212 23.8659 47.1735 24.3065 47.7417 24.3065C48.2287 24.3065 48.623 23.9934 48.7737 23.5528L49.0057 23.7151L48.9593 23.9818C48.9593 24.5964 49.4347 25.0603 50.0493 25.0603C50.3276 25.0603 50.5943 24.9559 50.7915 24.782H50.919C51.0118 24.782 51.1046 24.782 51.2089 24.7356C51.3249 25.2226 51.754 25.5589 52.2642 25.5589C52.7512 25.5589 53.1455 25.2342 53.2731 24.7936C53.4818 25.1067 53.8297 25.3154 54.2124 25.3154C54.4211 25.3154 54.6298 25.2342 54.7806 25.1183C54.8038 25.3038 54.8733 25.4545 54.9545 25.5705C54.8386 25.5125 54.6994 25.4893 54.5603 25.4893C54.0268 25.4893 53.5862 25.872 53.4818 26.3822C52.9832 26.475 52.6121 26.9273 52.6121 27.4491C52.6121 28.0405 53.0991 28.5623 53.7021 28.5623L53.9225 28.5275C53.8529 28.6783 53.8297 28.7943 53.8297 28.9682C53.8297 29.5828 54.3167 30.0466 54.9081 30.0466C55.1633 30.0466 55.4068 29.9539 55.5923 29.8147L55.5691 29.8727C55.5691 30.4641 56.0678 30.9512 56.6708 30.9512C56.8331 30.9512 56.9839 30.9048 57.123 30.8584L57.1114 30.9396C57.1114 31.0439 57.1462 31.1599 57.181 31.2874C57.0766 31.2526 56.9607 31.2063 56.8331 31.2063C56.2301 31.2063 55.7547 31.7049 55.7547 32.3195C55.7547 32.9109 56.2417 33.398 56.8331 33.398C57.4245 33.398 57.9232 32.9109 57.9232 32.3195C57.9232 32.1803 57.8884 32.076 57.8536 31.9484C57.9579 32.0064 58.0739 32.018 58.1899 32.018C58.5493 32.018 58.8856 31.8441 59.0828 31.5426C59.1524 31.7513 59.2799 31.96 59.477 32.0876C59.3611 32.2383 59.3147 32.4471 59.3147 32.6558C59.3147 33.2588 59.8017 33.7458 60.3931 33.7458C60.857 33.7458 61.2513 33.4559 61.402 33.0385C61.5528 33.1196 61.7267 33.166 61.9238 33.166C62.2601 33.166 62.5616 33.0037 62.7704 32.7602L62.7472 32.8529C62.7472 33.4559 63.2458 33.943 63.8372 33.943C64.0692 33.943 64.2779 33.885 64.4634 33.7458C64.6606 33.9778 64.9505 34.1285 65.2752 34.1285C65.4259 34.1285 65.5767 34.0821 65.6926 34.0357C65.9014 34.2793 66.1913 34.4184 66.5275 34.4184C66.9682 34.4184 67.3625 34.1633 67.5248 33.7574L67.7104 33.769C67.8727 34.1517 68.2438 34.4068 68.696 34.4068C68.8932 34.4068 69.0787 34.3488 69.2295 34.2445C69.3454 34.3141 69.4498 34.372 69.5774 34.3836C69.5542 34.4764 69.5426 34.5692 69.5426 34.6619L69.299 34.6387C68.754 34.6387 68.3018 35.0446 68.2206 35.578L68.0003 35.5548C67.3973 35.5548 66.9102 36.0303 66.9102 36.6333C66.9102 36.8072 66.945 36.9696 67.0262 37.0971C66.829 36.8768 66.5159 36.7145 66.2028 36.7145C65.5998 36.7145 65.1128 37.2015 65.1128 37.8045C65.1128 38.4191 65.5998 38.8946 66.2028 38.8946C66.4464 38.8946 66.6899 38.8018 66.8754 38.6394C66.9102 38.8946 66.9914 39.1149 67.1769 39.2772C66.7827 39.4396 66.5044 39.8223 66.5044 40.2861C66.5044 40.8891 66.9914 41.3877 67.5828 41.3877C67.7452 41.3877 67.9075 41.3414 68.0582 41.2834C67.9655 41.4341 67.9191 41.6197 67.9191 41.7936C67.9191 42.3966 68.4061 42.8953 68.9975 42.8953C69.1367 42.8953 69.2643 42.8373 69.3802 42.8257C69.4846 43.3359 69.9136 43.707 70.4587 43.707C70.621 43.707 70.795 43.6722 70.9457 43.6026C70.9457 44.0317 71.1892 44.4144 71.5719 44.5767L71.5487 44.7854C71.5487 45.3884 72.0358 45.8755 72.6388 45.8755C73.0098 45.8755 73.3345 45.6899 73.5433 45.4C73.7056 45.516 73.8564 45.4116 74.0767 45.4116C74.297 45.4116 74.3898 45.3884 74.5637 45.2725L74.6449 45.6436L74.5637 45.6204C73.9607 45.6204 73.4737 46.0958 73.4737 46.6988C73.4737 47.3018 73.9607 47.812 74.5637 47.812C75.0856 47.812 75.5146 47.4294 75.6306 46.9307L75.7118 46.9423C76.3032 46.9423 76.7902 46.4553 76.7902 45.8291L76.7554 45.574L77.1265 45.6088C77.0917 45.7131 76.9757 45.8755 76.9757 45.9914C76.9757 46.606 77.312 47.0467 77.8918 47.0467C78.3789 46.9887 78.7963 46.664 78.9239 46.2234Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M123.802 59.9881C123.802 59.3851 123.303 58.8864 122.7 58.8864C122.109 58.8864 121.633 59.3851 121.633 59.9881C121.633 60.5911 122.109 61.0665 122.7 61.0665C123.303 61.0665 123.802 60.6027 123.802 59.9881Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M127.246 59.0836C127.246 58.4922 126.759 58.0051 126.144 58.0051C125.564 58.0051 125.077 58.4922 125.077 59.0836C125.077 59.6982 125.564 60.1852 126.144 60.1852C126.759 60.1852 127.246 59.6982 127.246 59.0836Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M53.389 30.209C53.389 29.5944 52.902 29.1074 52.3106 29.1074C51.7192 29.1074 51.2437 29.5944 51.2437 30.209C51.2437 30.8004 51.7308 31.2874 52.3106 31.2874C52.902 31.2874 53.389 30.7888 53.389 30.209Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M48.8201 26.046C48.8201 25.443 48.3447 24.9675 47.7533 24.9675C47.1503 24.9675 46.6516 25.4546 46.6516 26.046C46.6516 26.6606 47.1387 27.136 47.7533 27.136C48.3447 27.136 48.8201 26.649 48.8201 26.046Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M43.2887 22.5671C43.2887 21.9525 42.8017 21.4539 42.2103 21.4539C41.6189 21.4539 41.1202 21.9409 41.1202 22.5671C41.1202 23.1585 41.6189 23.6455 42.2103 23.6455C42.7901 23.6455 43.2887 23.1585 43.2887 22.5671Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M34.1741 16.4559C34.7655 16.4559 35.2525 15.9688 35.2525 15.3542C35.2525 14.7512 34.7655 14.2758 34.1741 14.2758C33.5711 14.2758 33.0724 14.7512 33.0724 15.3542C33.0724 15.9688 33.5595 16.4559 34.1741 16.4559Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M71.9778 124.266C69.0787 124.266 67.1305 126.04 67.1305 128.696C67.1305 130.992 68.6497 132.059 70.9341 132.963C73.1142 133.821 74.4362 134.482 74.4362 136.477C74.4362 138.564 72.9982 139.863 70.6906 139.863C68.0582 139.863 66.7247 138.471 66.7247 135.735V135.41H65.3911V135.955C65.3911 139.26 67.2697 141.162 70.563 141.162C73.81 141.162 75.8161 139.364 75.8161 136.477C75.8161 134.447 74.7841 133.137 72.3604 132.105L71.7922 131.861C69.8093 131.027 68.5105 130.482 68.5105 128.649C68.5105 126.748 69.8673 125.565 72.0473 125.565C74.3434 125.565 75.6074 126.794 75.6074 129.044V129.519H76.6394L76.9641 129.461V129.136C76.9525 126.075 75.0972 124.266 71.9778 124.266Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M87.3196 128.73C85.9396 128.73 84.7336 129.218 83.7363 130.18L84.9191 124.591H83.5972L80.1647 140.814H81.4867L82.7275 134.9C83.4116 131.63 84.9539 129.971 87.308 129.971C88.7575 129.971 89.4881 130.644 89.4881 131.966C89.4881 132.244 89.4533 132.557 89.3837 132.917L87.7254 140.814H89.0474L90.5201 133.763L90.5433 133.636C90.6709 133.021 90.7868 132.43 90.7868 131.873C90.7868 129.902 89.4881 128.73 87.3196 128.73Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M97.3619 128.904L94.8455 140.814H96.1675L98.6955 128.904H97.3619Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M97.675 127.061H99.1477L99.6697 124.591H98.1968L97.675 127.061Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M107.892 128.754C107.103 128.754 106.384 129.055 105.793 129.612L105.943 128.904H104.61L102.105 140.802H103.404L104.842 134.042C105.375 131.502 106.488 130.052 107.868 130.052C108.089 130.052 108.355 130.11 108.692 130.192L109.005 130.273L109.306 128.997L109.005 128.916C108.587 128.812 108.239 128.754 107.892 128.754Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M117.98 129.948C120.613 129.948 121.169 132.024 121.169 133.763C121.169 133.81 121.169 133.868 121.169 133.914H113.864C114.536 131.49 116.113 129.948 117.98 129.948ZM118.108 128.684C114.745 128.684 112.205 131.885 112.205 136.117C112.205 139.132 113.933 141.08 116.624 141.08C118.954 141.08 120.949 139.538 121.842 137.045L121.993 136.616H120.578L120.497 136.825C119.754 138.703 118.259 139.828 116.508 139.828C114.745 139.828 113.551 138.379 113.551 136.222C113.551 136.024 113.551 135.677 113.585 135.155H122.41L122.433 134.853C122.48 134.227 122.48 133.856 122.48 133.728C122.48 130.574 120.845 128.684 118.108 128.684Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M15.6201 75.701L9.65967 88.8743L3.84994 75.701H0V92.0052H2.80629L2.69032 79.203L8.32609 92.0052H10.9816L16.7334 79.1798L16.6174 92.0052H19.4121V75.701H15.6201Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M38.4067 83.8531C38.4067 87.5639 36.2498 89.686 32.5042 89.686C28.7355 89.686 26.5786 87.5639 26.5786 83.8531C26.5786 80.1423 28.7355 78.0202 32.4926 78.0202C36.2382 78.0086 38.4067 80.1423 38.4067 83.8531ZM41.329 83.8531C41.329 78.6464 37.8617 75.2835 32.4926 75.2835C27.0308 75.2835 23.6331 78.5652 23.6331 83.8531C23.6331 89.0598 27.1004 92.4227 32.4694 92.4227C37.9313 92.4111 41.329 89.1294 41.329 83.8531Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M48.3679 78.2289H53.0064C56.1489 78.2289 57.065 78.7276 57.065 80.467C57.065 82.1369 56.0909 82.7051 53.2035 82.7051H48.3795V78.2289H48.3679ZM48.3679 85.2794H53.8877C55.975 85.2794 56.5316 85.7665 56.6939 87.761L56.8911 90.0803C56.9259 90.6949 56.9955 91.3211 57.1926 91.8081L57.2738 92.0052H60.6715L60.312 91.495C59.9177 90.95 59.8713 90.3354 59.8133 89.6164L59.6162 87.0769C59.5002 85.465 58.9784 84.5141 57.9 84.0618C59.2335 83.3313 59.8945 82.0673 59.8945 80.2931C59.8945 77.3244 57.8188 75.701 54.0616 75.701H45.55V92.0052H48.3679V85.2794Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M77.486 88.3988L68.1626 75.701H64.7069V92.0052H67.5016V79.3074L76.8018 92.0052H80.2575V75.701H77.486V88.3988Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M88.3516 75.701H85.5106V92.0052H88.3516V75.701Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M96.3878 79.3074L105.688 92.0052H109.144V75.701H106.372V88.3988L97.0488 75.701H93.5931V92.0052H96.3878V79.3074Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M121.714 92.4111C124.207 92.4111 126.19 91.5646 127.501 89.9527L127.663 92.0053H129.808V82.9602H122.19V85.6621H127.083C126.677 88.1089 124.613 89.6744 121.737 89.6744C118.363 89.6744 116.264 87.4363 116.264 83.8415C116.264 80.2467 118.386 78.0086 121.807 78.0086C124.474 78.0086 126.248 79.0871 126.805 81.0468L126.875 81.2788H129.716L129.681 80.9193C129.356 77.6491 126.121 75.2719 121.993 75.2719C116.705 75.2719 113.423 78.5536 113.423 83.8415C113.388 88.9786 116.739 92.4111 121.714 92.4111Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M141.393 92.0052V78.3797H147.319V75.701H132.649V78.3797H138.564V92.0052H141.393Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M158.509 89.686C154.74 89.686 152.583 87.5639 152.583 83.8531C152.583 80.1423 154.74 78.0202 158.497 78.0202C162.266 78.0202 164.423 80.1423 164.423 83.8531C164.412 87.5639 162.255 89.686 158.509 89.686ZM167.334 83.8531C167.334 78.6464 163.867 75.2835 158.497 75.2835C153.036 75.2835 149.638 78.5652 149.638 83.8531C149.638 89.0598 153.105 92.4227 158.474 92.4227C163.948 92.4111 167.334 89.1294 167.334 83.8531Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M184.345 75.701V88.3988L175.022 75.701H171.566V92.0052H174.361V79.3074L183.661 92.0052H187.117V75.701H184.345Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M28.434 104.796C28.434 106.605 27.4483 107.185 24.3637 107.185H20.5833V102.384H24.5028C27.4831 102.384 28.434 102.975 28.434 104.796ZM25.245 99.786H17.7422V116.091H20.5833V109.666H25.245C29.3037 109.666 31.275 108.054 31.275 104.726C31.275 101.398 29.3037 99.786 25.245 99.786Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M38.1052 109.11H47.6489V106.408H38.1052V102.43H48.2751V99.786H35.2641V116.091H48.4258V113.342H38.1052V109.11Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M65.5187 112.496L56.1953 99.786H52.728V116.091H55.5343V103.393L64.8345 116.091H68.2902V99.786H65.5187V112.496Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M76.3843 99.786H73.5433V116.091H76.3843V99.786Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M94.4048 112.496L85.0815 99.786H81.6258V116.091H84.4205V103.393L93.7207 116.091H97.1879V99.786H94.4048V112.496Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M110.965 106.709L107.532 106.037C105.642 105.666 105.039 105.225 105.039 104.228C105.039 102.43 107.08 102.059 108.784 102.059C111.324 102.059 112.507 102.871 112.646 104.692L112.669 104.993H115.487V104.668C115.441 101.259 113.121 99.3804 108.958 99.3804C104.575 99.3804 102.07 101.224 102.07 104.436C102.07 106.895 103.589 108.321 106.836 108.901L110.698 109.597C112.704 109.956 113.11 110.582 113.11 111.487C113.11 112.96 111.66 113.806 109.121 113.806C106.083 113.806 104.633 112.751 104.552 110.478L104.54 110.165H101.572L101.583 110.49C101.653 114.49 104.146 116.508 108.993 116.508C113.481 116.508 116.055 114.606 116.055 111.29C116.055 108.286 114.107 107.312 110.965 106.709Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M131.919 109.005C131.919 112.322 130.62 113.737 127.559 113.737C124.544 113.737 123.21 112.275 123.21 109.005V99.786H120.369V109.933C120.369 114.166 122.92 116.508 127.559 116.508C132.197 116.508 134.76 114.177 134.76 109.933V99.786H131.919V109.005Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M142.286 99.786H139.456V116.091H151.818V113.342H142.286V99.786Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M165.154 108.947H160.04L162.672 103.358L165.154 108.947ZM161.397 99.786L153.697 116.091H156.735L158.811 111.626H166.348L168.331 116.091H171.323L164.11 99.786H161.397Z",
            fill: "#182281"
          }
        )
      ]
    }
  );
}
function Pet(e) {
  return /* @__PURE__ */ k(
    "svg",
    {
      width: "82",
      height: "22",
      viewBox: "0 0 82 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ k("g", { clipPath: "url(#clip0_982_12)", children: [
          /* @__PURE__ */ d(
            "path",
            {
              d: "M7.63302 5.31663C7.92132 5.31663 8.15502 5.08292 8.15502 4.79463C8.15502 4.50634 7.92132 4.27263 7.63302 4.27263C7.34473 4.27263 7.11102 4.50634 7.11102 4.79463C7.11102 5.08292 7.34473 5.31663 7.63302 5.31663Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ d(
            "path",
            {
              d: "M7.63299 0C6.09197 0.00187383 4.61459 0.614874 3.52492 1.70454C2.43525 2.79421 1.82225 4.27159 1.82038 5.81261C1.81856 7.07197 2.22998 8.29715 2.99152 9.30018C2.99152 9.30018 3.15004 9.50864 3.17551 9.53887L7.63299 14.5648L12.0923 9.53659C12.1158 9.50843 12.2745 9.29997 12.2745 9.29997L12.2753 9.2987C13.0363 8.29605 13.4475 7.0714 13.4456 5.81261C13.4437 4.27159 12.8307 2.79421 11.7411 1.70454C10.6514 0.614874 9.17402 0.00187383 7.63299 0ZM7.63299 3.17052C7.94652 3.17052 8.25302 3.26349 8.51371 3.43768C8.77441 3.61187 8.97759 3.85945 9.09758 4.14912C9.21756 4.43879 9.24895 4.75753 9.18779 5.06504C9.12662 5.37255 8.97564 5.65502 8.75394 5.87672C8.53223 6.09842 8.24977 6.2494 7.94226 6.31057C7.63475 6.37174 7.31601 6.34034 7.02634 6.22036C6.73667 6.10038 6.48909 5.89719 6.3149 5.63649C6.14071 5.3758 6.04773 5.06931 6.04773 4.75577C6.04819 4.33548 6.21536 3.93253 6.51255 3.63534C6.80975 3.33814 7.2127 3.17098 7.63299 3.17052ZM9.74667 8.98313H8.68983V7.92629H6.57615V8.98313H5.51931V7.92629C5.51964 7.64609 5.63108 7.37747 5.82921 7.17935C6.02734 6.98122 6.29596 6.86977 6.57615 6.86945H8.68983C8.97002 6.86977 9.23865 6.98122 9.43677 7.17935C9.6349 7.37747 9.74635 7.64609 9.74667 7.92629V8.98313Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ d(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M1.52294 13.5965L3.7864 12.3947L2.69125 11.8508L0.256336 13.1713C0.0978611 13.2566 -0.000691396 13.4224 3.65235e-06 13.6023C0.00069873 13.7823 0.100528 13.9473 0.259658 14.0314L7.39761 17.8038C7.54122 17.8797 7.71321 17.879 7.85626 17.8021L14.8684 14.0297C15.0262 13.9448 15.1247 13.7801 15.1248 13.6009C15.125 13.4217 15.0268 13.2568 14.8691 13.1716L12.5084 11.8508L11.4315 12.447L13.6103 13.5996L7.62331 16.8205L1.52294 13.5965Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ d(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M1.51805 17.1073L2.27632 16.6897L1.19879 16.1181L0.254173 16.6859C0.0965182 16.7718 -0.00113655 16.9375 9.98623e-06 17.117C0.00115652 17.2965 0.100919 17.4609 0.259658 17.5448L7.39761 21.3172C7.54122 21.3931 7.71321 21.3924 7.85626 21.3155L14.8684 17.5431C15.0257 17.4585 15.1241 17.2945 15.1248 17.1159C15.1256 16.9372 15.0285 16.7725 14.8718 16.6865L13.9965 16.1573L12.9404 16.739L13.6164 17.1097L7.6233 20.3339L1.51805 17.1073Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ d(
            "path",
            {
              d: "M80.1641 16.5194C79.6219 16.5194 79.1195 16.4317 78.657 16.2563C78.2105 16.0649 77.8198 15.7938 77.4848 15.4429C77.1659 15.0921 76.9107 14.6774 76.7193 14.199C76.5439 13.7205 76.4562 13.1783 76.4562 12.5723V7.90753H74.7817V5.63495H75.4993C76.3765 5.63495 76.815 5.19639 76.815 4.31925V2.76433H79.2072V5.39573H81.5994V7.90753H79.2072V12.4527C79.2072 12.9311 79.3428 13.3139 79.6139 13.6009C79.901 13.8721 80.2837 14.0076 80.7621 14.0076C80.8897 14.0076 80.9934 14.0076 81.0731 14.0076C81.1529 13.9917 81.2246 13.9757 81.2884 13.9598C81.3522 13.9438 81.416 13.9199 81.4798 13.888V16.2802C81.3682 16.328 81.2406 16.3679 81.0971 16.3998C80.8259 16.4795 80.515 16.5194 80.1641 16.5194Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ d(
            "path",
            {
              d: "M68.5733 16.5194C67.8238 16.5194 67.1141 16.3758 66.4443 16.0888C65.7904 15.7857 65.2083 15.3791 64.698 14.8687C64.2036 14.3584 63.8049 13.7683 63.5019 13.0985C63.2148 12.4128 63.0713 11.6792 63.0713 10.8977C63.0713 10.1163 63.2148 9.39064 63.5019 8.72083C63.8049 8.03507 64.2036 7.43702 64.698 6.92669C65.2083 6.41635 65.7904 6.01766 66.4443 5.73059C67.1141 5.42758 67.8238 5.27608 68.5733 5.27608C69.3229 5.27608 70.0246 5.42758 70.6784 5.73059C71.3483 6.01766 71.9304 6.41635 72.4247 6.92669C72.9351 7.43702 73.3338 8.03507 73.6208 8.72083C73.9238 9.39064 74.0753 10.1163 74.0753 10.8977C74.0753 11.6792 73.9238 12.4128 73.6208 13.0985C73.3338 13.7683 72.9351 14.3584 72.4247 14.8687C71.9304 15.3791 71.3483 15.7857 70.6784 16.0888C70.0246 16.3758 69.3229 16.5194 68.5733 16.5194ZM68.5733 13.8879C69.3548 13.8879 70.0086 13.6168 70.5349 13.0746C71.0612 12.5324 71.3243 11.8067 71.3243 10.8977C71.3243 9.98869 71.0612 9.26306 70.5349 8.72083C70.0086 8.1786 69.3548 7.90748 68.5733 7.90748C67.7919 7.90748 67.138 8.1786 66.6117 8.72083C66.0854 9.26306 65.8223 9.98869 65.8223 10.8977C65.8223 11.8067 66.0854 12.5324 66.6117 13.0746C67.138 13.6168 67.7919 13.8879 68.5733 13.8879Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ d(
            "path",
            {
              d: "M54.5894 1.32898H57.46V13.6487H61.6473C61.6473 13.6487 62.5017 15.5454 63.6408 16.3998C63.356 16.3998 54.5894 16.3998 54.5894 16.3998V1.32898Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ d(
            "path",
            {
              d: "M45.1468 20.347C45.0192 20.347 44.8916 20.339 44.764 20.323C44.6524 20.323 44.5567 20.3151 44.477 20.2991C44.3653 20.2832 44.2696 20.2593 44.1899 20.2274V17.9548C44.7959 17.9548 45.2584 17.8192 45.5774 17.5481C45.9123 17.277 46.1674 16.9341 46.3429 16.5195L46.5821 15.9214L42.3958 5.3958H45.2664L48.0174 12.5724L50.5292 5.3958H53.3998C52.6184 7.40523 51.9087 9.2233 51.2708 10.85C50.9997 11.5517 50.7285 12.2375 50.4574 12.9073C50.2023 13.5771 49.971 14.1911 49.7637 14.7492C49.5564 15.2915 49.3809 15.746 49.2374 16.1128C49.0939 16.4796 49.0062 16.6949 48.9743 16.7587C48.7032 17.4126 48.432 17.9628 48.1609 18.4093C47.9058 18.8718 47.6267 19.2466 47.3237 19.5336C47.0206 19.8207 46.6937 20.028 46.3429 20.1556C45.992 20.2832 45.5933 20.347 45.1468 20.347Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ d(
            "path",
            {
              d: "M26.1289 5.39569H28.1623L28.6407 6.47217C28.864 6.2489 29.1112 6.04955 29.3823 5.87412C29.6056 5.73059 29.8767 5.59504 30.1956 5.46745C30.5146 5.33987 30.8734 5.27608 31.2721 5.27608C31.8303 5.27608 32.3087 5.35582 32.7074 5.5153C33.1061 5.65883 33.4331 5.81831 33.6882 5.99373C33.9753 6.20106 34.2065 6.44028 34.382 6.71139C34.6371 6.44028 34.9322 6.20106 35.2671 5.99373C35.5541 5.81831 35.897 5.65883 36.2957 5.5153C36.6944 5.35582 37.133 5.27608 37.6114 5.27608C38.8075 5.27608 39.7644 5.65883 40.482 6.42433C41.1997 7.18983 41.5585 8.32213 41.5585 9.82123V16.3997H38.8075V10.0605C38.8075 9.39064 38.6241 8.86436 38.2573 8.48161C37.9064 8.09886 37.4918 7.90748 37.0134 7.90748C36.5349 7.90748 36.1123 8.09886 35.7455 8.48161C35.3946 8.86436 35.2192 9.39064 35.2192 10.0605V16.3997H32.4682V10.0605C32.4682 9.39064 32.2848 8.86436 31.918 8.48161C31.5671 8.09886 31.1525 7.90748 30.6741 7.90748C30.1956 7.90748 29.773 8.09886 29.4062 8.48161C29.0553 8.86436 28.8799 9.39064 28.8799 10.0605V16.3997H26.1289V5.39569Z",
              fill: "#0157FF"
            }
          )
        ] }),
        /* @__PURE__ */ d("defs", { children: /* @__PURE__ */ d("clipPath", { id: "clip0_982_12", children: /* @__PURE__ */ d("rect", { width: "81.5994", height: "21.3736", fill: "white" }) }) })
      ]
    }
  );
}
function Tet(e) {
  return /* @__PURE__ */ k(
    "svg",
    {
      width: "153",
      height: "41",
      viewBox: "0 0 153 41",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ d(
          "path",
          {
            d: "M32.1542 22.2731C31.2427 25.0948 27.5786 34.3816 26.0593 33.7565C23.7714 32.8279 23.1637 11.1289 24.54 1.64571C24.7902 0.0562428 24.8617 -0.908154 24.1647 1.48498C19.0349 19.237 21.984 37.2748 25.6839 38.2928C28.1684 38.9714 30.9746 32.0421 32.5475 23.1125C33.0658 20.7908 32.7262 20.0407 32.1542 22.2552V22.2731Z",
            fill: "url(#paint0_radial_16047_22228)"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M17.6235 16.8249C15.8004 12.1279 12.9227 13.5209 12.8333 16.7356C12.6546 22.5756 15.0318 30.1479 9.18708 20.0395C3.05636 9.43118 1.75158 7.43095 0.857885 5.89506C-0.0358053 4.37703 -0.19667 4.41275 0.518283 6.14509C9.91991 28.5405 11.5464 30.1479 13.8343 30.0943C14.871 30.0764 15.7289 28.987 15.5859 26.2903C15.4429 23.5935 15.3893 21.504 15.2642 20.2539C15.1391 19.0037 15.7825 18.7358 16.4081 20.5932C17.0337 22.4505 18.6066 25.433 20.7336 36.8093C20.9838 37.5951 21.1268 37.5416 21.0374 36.2736C20.948 34.9877 20.6442 23.9686 17.6414 16.8428L17.6235 16.8249Z",
            fill: "url(#paint1_radial_16047_22228)"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M32.1553 38.1496C32.7273 33.2383 37.7319 26.3625 40.985 22.5228C41.6642 21.7192 41.8787 21.2905 40.7169 22.2371C33.621 27.827 28.8665 36.5959 29.8853 39.3462C30.3501 40.632 31.9587 39.7569 32.1553 38.1496Z",
            fill: "url(#paint2_radial_16047_22228)"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M129.243 23.7546C129.243 24.469 129.136 25.1298 128.922 25.737C128.707 26.3263 128.403 26.8442 128.01 27.2729C127.617 27.7015 127.134 28.0229 126.58 28.2551C126.026 28.4873 125.4 28.6123 124.721 28.6123C124.042 28.6123 123.434 28.4873 122.88 28.2551C122.326 28.0229 121.844 27.7015 121.45 27.2729C121.057 26.8442 120.753 26.3442 120.521 25.737C120.306 25.1476 120.199 24.4868 120.199 23.7546C120.199 23.0224 120.306 22.3794 120.539 21.7901C120.771 21.2007 121.075 20.6828 121.486 20.2721C121.897 19.8613 122.362 19.522 122.916 19.2898C123.47 19.0576 124.078 18.9326 124.721 18.9326C125.365 18.9326 125.99 19.0576 126.544 19.2898C127.099 19.522 127.563 19.8434 127.974 20.2721C128.368 20.6828 128.671 21.2007 128.904 21.7901C129.118 22.3794 129.243 23.0402 129.243 23.7546ZM126.598 23.7546C126.598 22.9509 126.437 22.3259 126.115 21.8615C125.794 21.3972 125.347 21.165 124.739 21.165C124.131 21.165 123.685 21.3972 123.363 21.8615C123.041 22.3259 122.88 22.9509 122.88 23.7546C122.88 24.5583 123.041 25.2012 123.363 25.6655C123.685 26.1299 124.149 26.362 124.739 26.362C125.329 26.362 125.794 26.1299 126.115 25.6655C126.437 25.2012 126.598 24.5583 126.598 23.7546Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M133.766 18.9326C134.535 18.9326 135.178 19.0219 135.696 19.2005C136.215 19.3791 136.626 19.6291 136.93 19.9506C137.233 20.2721 137.466 20.6828 137.591 21.1472C137.716 21.6115 137.788 22.1294 137.788 22.7009V28.1301C137.412 28.2194 136.894 28.3087 136.233 28.4158C135.571 28.523 134.767 28.5766 133.82 28.5766C133.23 28.5766 132.676 28.523 132.193 28.4158C131.71 28.3087 131.281 28.1301 130.942 27.8979C130.584 27.6658 130.316 27.3443 130.138 26.9693C129.959 26.5764 129.852 26.112 129.852 25.5584C129.852 25.0047 129.959 24.5761 130.173 24.2011C130.388 23.826 130.674 23.5224 131.049 23.3081C131.407 23.0938 131.818 22.9331 132.3 22.8259C132.765 22.7188 133.248 22.683 133.748 22.683C134.088 22.683 134.392 22.683 134.66 22.7188C134.928 22.7545 135.142 22.7902 135.303 22.8259V22.5759C135.303 22.1294 135.16 21.7722 134.892 21.5043C134.624 21.2365 134.159 21.0936 133.498 21.0936C133.051 21.0936 132.64 21.1472 132.318 21.2722L130.727 19.3612C130.87 19.3077 131.067 19.2719 131.299 19.2184C131.532 19.1648 131.782 19.1112 132.05 19.0755C132.318 19.0398 132.604 19.0041 132.908 18.9683C133.212 18.9326 133.498 18.9326 133.82 18.9326H133.766ZM133.98 26.5764C134.231 26.5764 134.481 26.5764 134.713 26.5585C134.946 26.5585 135.142 26.5228 135.267 26.5049V24.5225C135.16 24.5047 134.999 24.469 134.785 24.4511C134.57 24.4332 134.392 24.4154 134.213 24.4154C133.963 24.4154 133.73 24.4154 133.516 24.4511C133.301 24.4868 133.105 24.5404 132.944 24.6118C132.783 24.7011 132.658 24.8083 132.551 24.9512C132.461 25.094 132.408 25.2726 132.408 25.4691C132.408 25.8798 132.551 26.1656 132.819 26.3085C133.087 26.4692 133.462 26.5406 133.945 26.5406L133.98 26.5764Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M144.652 21.4876L148.62 16.7549V19.0766H151.301V21.4697H148.62V24.6486C148.62 25.1844 148.71 25.613 148.906 25.9345C149.103 26.256 149.478 26.4167 150.05 26.4167C150.318 26.4167 150.604 26.3631 150.604 26.3631L152.07 28.1133C151.766 28.2383 151.409 28.3455 151.033 28.4348C150.658 28.5241 150.193 28.5777 149.639 28.5777C148.942 28.5777 148.352 28.4884 147.905 28.2919C147.441 28.0955 147.083 27.8454 146.797 27.5061C146.511 27.1668 146.332 26.756 146.225 26.2738C146.118 25.7916 146.064 25.2559 146.064 24.6844V21.4697H144.67L144.652 21.4876Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M119.164 25.7366C118.986 25.8259 118.771 25.8973 118.521 25.9509C118.271 26.0224 118.003 26.0759 117.681 26.1116C117.359 26.1652 117.02 26.1831 116.626 26.1831C116.001 26.1831 115.465 26.0759 115.018 25.8795C114.571 25.683 114.213 25.3973 113.945 25.058C113.677 24.7186 113.481 24.29 113.355 23.8078C113.23 23.3256 113.177 22.8077 113.177 22.2541C113.177 21.5576 113.266 20.9682 113.463 20.486C113.641 20.0038 113.892 19.593 114.195 19.2894C114.499 18.9858 114.857 18.7537 115.268 18.6286C115.661 18.4858 116.036 18.4143 116.519 18.4143C117.145 18.4143 117.592 18.4679 118.181 18.6286C118.503 18.7179 118.789 18.8251 119.057 18.9323C119.343 18.6108 120.576 17.1463 120.576 17.1463C120.398 17.0392 120.183 16.8784 119.826 16.7177C119.611 16.6106 119.361 16.5213 119.039 16.4141C118.718 16.3069 118.36 16.2355 117.949 16.1462C117.538 16.0569 117.073 16.0391 116.555 16.0391C115.679 16.0391 114.857 16.1819 114.106 16.4498C113.355 16.7356 112.694 17.1463 112.158 17.6821C111.604 18.2179 111.175 18.8787 110.871 19.6645C110.549 20.4503 110.406 21.3432 110.406 22.3434C110.406 24.3436 110.925 25.8973 111.943 26.9867C112.98 28.0762 114.464 28.6298 116.43 28.6298C117.341 28.6298 118.163 28.5405 118.861 28.344C119.558 28.1655 120.094 27.9511 120.487 27.719L119.433 25.683C119.433 25.683 119.29 25.7366 119.218 25.7723L119.164 25.7366Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M141.506 26.4692C141.988 26.4692 142.328 26.4156 142.525 26.3263C142.721 26.237 142.828 26.0584 142.828 25.7905C142.828 25.5762 142.703 25.3976 142.435 25.2369C142.185 25.0762 141.792 24.8976 141.273 24.7011C140.862 24.5583 140.505 24.3975 140.165 24.2368C139.843 24.0761 139.558 23.8796 139.325 23.6474C139.093 23.4153 138.914 23.1474 138.789 22.8438C138.664 22.5223 138.592 22.1473 138.592 21.7187C138.592 20.8614 138.914 20.1828 139.558 19.6827C140.201 19.1826 141.077 18.9326 142.185 18.9326C142.739 18.9326 143.275 18.9862 143.794 19.0755C144.312 19.1648 144.705 19.2898 145.009 19.397L143.526 21.165C143.043 21.04 142.811 21.0221 142.364 21.0221C141.542 21.0221 141.148 21.2543 141.148 21.7008C141.148 21.8079 141.148 21.8972 141.202 21.9865C141.238 22.0758 141.309 22.1473 141.416 22.2187C141.524 22.2901 141.667 22.3794 141.845 22.4687C142.024 22.558 142.256 22.6473 142.525 22.7545C143.097 22.9688 143.561 23.1652 143.937 23.3796C144.312 23.576 144.598 23.8082 144.812 24.0403C145.027 24.2725 145.17 24.5404 145.259 24.8262C145.349 25.1119 145.384 25.4512 145.384 25.8263C145.384 26.7371 145.045 27.4157 144.366 27.8801C143.686 28.3444 142.721 28.5766 141.488 28.5766C140.666 28.5766 140.004 28.5051 139.45 28.3623C138.914 28.2194 138.539 28.1122 138.324 28.0051L139.808 26.237C140.451 26.4156 141.041 26.4513 141.506 26.4513V26.4692Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M86.5078 15.9316V18.5212H89.0995L86.5078 15.9316Z",
            fill: "#006DA4"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M48.5248 18.6835C48.0422 18.4692 47.2379 18.3263 46.666 18.3263C46.0225 18.3263 45.5399 18.4156 45.2718 18.5942C44.9858 18.7728 44.8428 19.0407 44.8428 19.4157C44.8428 19.63 44.8964 19.8265 45.0037 19.9693C45.1109 20.1122 45.2539 20.2551 45.4505 20.3801C45.6471 20.5051 45.8616 20.6123 46.1119 20.7194C46.3621 20.8266 46.6302 20.9159 46.9341 21.023C47.5596 21.2552 48.1137 21.4874 48.5784 21.7195C49.0432 21.9517 49.4364 22.2017 49.7402 22.5054C50.0441 22.809 50.2765 23.1661 50.4195 23.559C50.5624 23.9698 50.6518 24.452 50.6518 25.0414C50.6518 26.1665 50.2586 27.0416 49.4721 27.6488C48.6857 28.2739 47.4881 28.5775 45.8974 28.5775C45.3612 28.5775 44.8786 28.5418 44.4496 28.4882C44.0206 28.4167 43.6453 28.3453 43.3057 28.256C42.9839 28.1667 42.698 28.0596 42.4477 27.9524C42.2154 27.8453 42.1081 27.8095 41.9473 27.7202L43.4844 25.8807C43.4844 25.8807 43.6274 25.9343 43.9313 26.0415C44.4675 26.2022 45.1109 26.2736 45.8795 26.2736C46.2549 26.2736 46.5766 26.2379 46.8268 26.1843C47.077 26.1129 47.2737 26.0415 47.4345 25.9165C47.5775 25.8093 47.6848 25.6843 47.7384 25.5236C47.792 25.3807 47.8278 25.2021 47.8278 25.0235C47.8278 24.6306 47.649 24.3091 47.2737 24.0412C46.8983 23.7734 46.2549 23.5055 45.3612 23.2019C44.9679 23.059 44.5747 22.8983 44.1815 22.7197C43.7883 22.5411 43.4308 22.3089 43.1269 22.041C42.8052 21.7731 42.555 21.4338 42.3584 21.0409C42.1618 20.648 42.0545 20.1837 42.0545 19.63C42.0545 19.0764 42.1618 18.5763 42.3584 18.1298C42.5728 17.6834 42.8588 17.3083 43.2521 16.9869C43.6274 16.6833 44.0921 16.4332 44.6462 16.2725C45.2003 16.1118 45.808 16.0225 46.4872 16.0225C47.3094 16.0225 48.0065 16.1118 48.5963 16.2903C49.1862 16.4689 49.6688 16.6475 50.062 16.8618L48.5248 18.7013V18.6835Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M72.7089 26.4692C73.1915 26.4692 73.5132 26.4156 73.7098 26.3263C73.9064 26.237 74.0137 26.0584 74.0137 25.7905C74.0137 25.5762 73.8886 25.3976 73.6383 25.2369C73.3881 25.0762 72.9949 24.8976 72.4765 24.7011C72.0654 24.5583 71.7079 24.3975 71.3683 24.2368C71.0287 24.0761 70.7606 23.8796 70.5283 23.6474C70.2959 23.4153 70.1172 23.1474 69.9921 22.8438C69.8669 22.5223 69.7955 22.1473 69.7955 21.7187C69.7955 20.8614 70.1172 20.1828 70.7606 19.6827C71.4041 19.1826 72.2799 18.9326 73.3881 18.9326C73.9422 18.9326 74.4784 18.9862 74.9967 19.0755C75.5151 19.1648 75.9083 19.2898 76.2121 19.397L74.7286 21.165C74.246 21.04 74.0137 21.0221 73.5668 21.0221C72.7625 21.0221 72.3514 21.2543 72.3514 21.7008C72.3514 21.8079 72.3514 21.8972 72.405 21.9865C72.4408 22.0758 72.5123 22.1473 72.6195 22.2187C72.7268 22.2901 72.8697 22.3794 73.0485 22.4687C73.2272 22.558 73.4596 22.6473 73.7277 22.7545C74.2996 22.9688 74.7644 23.1652 75.1397 23.3796C75.5151 23.576 75.8011 23.8082 76.0155 24.0403C76.23 24.2725 76.3909 24.5404 76.4624 24.8262C76.5518 25.1119 76.5875 25.4512 76.5875 25.8263C76.5875 26.7371 76.2479 27.4157 75.5687 27.8801C74.8895 28.3444 73.9243 28.5766 72.691 28.5766C71.8688 28.5766 71.2075 28.5051 70.6534 28.3623C70.1172 28.2194 69.7418 28.1122 69.5273 28.0051L71.0109 26.237C71.6543 26.4156 72.2442 26.4513 72.7089 26.4513V26.4692Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M77.4277 28.3438V15.9316H80.0194V19.2356C80.1982 19.182 80.4127 19.1284 80.6986 19.0749C80.9668 19.0213 81.2349 19.0034 81.4851 19.0034C82.2358 19.0034 82.8435 19.1106 83.344 19.307C83.8444 19.5035 84.2377 19.7892 84.5236 20.1643C84.8096 20.5393 85.0241 20.9858 85.1492 21.4859C85.2743 22.0038 85.328 22.5574 85.328 23.1825V28.3438H82.7363V23.4861C82.7363 22.6467 82.629 22.0573 82.4145 21.718C82.2 21.3787 81.8068 21.2001 81.217 21.2001C80.9846 21.2001 80.7701 21.218 80.5735 21.2537C80.3769 21.2894 80.1803 21.343 80.0194 21.3787V28.3259H77.4277V28.3438Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M89.0995 28.3441H86.5078V19.2002H89.0995V28.3441Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M90.3496 19.5052C90.7965 19.3802 91.3684 19.2552 92.0655 19.148C92.7626 19.0409 93.4954 18.9873 94.264 18.9873C95.0325 18.9873 95.6939 19.0945 96.2122 19.2909C96.7306 19.4874 97.1417 19.7731 97.4455 20.1482C97.7494 20.5232 97.9638 20.9697 98.089 21.4697C98.2141 21.9877 98.2856 22.5413 98.2856 23.1664V28.3277H95.6939V23.47C95.6939 22.6306 95.5866 22.0412 95.3543 21.7019C95.1398 21.3626 94.7287 21.184 94.121 21.184C93.9422 21.184 93.7456 21.184 93.5311 21.2018C93.3167 21.2197 93.1379 21.2376 92.9771 21.2554V28.3098H90.3854V19.4695L90.3496 19.5052Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M60.7852 19.5052C61.232 19.3802 61.804 19.2552 62.501 19.148C63.1981 19.0409 63.9309 18.9873 64.6995 18.9873C65.4681 18.9873 66.1294 19.0945 66.6478 19.2909C67.1661 19.4874 67.5772 19.7731 67.8811 20.1482C68.1849 20.5232 68.3994 20.9697 68.5245 21.4697C68.6496 21.9877 68.7211 22.5413 68.7211 23.1664V28.3277H66.1294V23.47C66.1294 22.6306 66.0222 22.0412 65.8077 21.7019C65.5932 21.3626 65.1821 21.184 64.5744 21.184C64.3957 21.184 64.1991 21.184 63.9846 21.2018C63.7701 21.2197 63.5913 21.2376 63.4305 21.2554V28.3098H60.8388V19.4695L60.7852 19.5052Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M59.4806 28.0588C59.0338 28.1838 58.4797 28.3088 57.7826 28.416C57.0855 28.5231 56.3527 28.5767 55.5841 28.5767C54.8155 28.5767 54.1542 28.4695 53.6359 28.2731C53.1175 28.0766 52.7064 27.7909 52.4026 27.4158C52.0987 27.0408 51.8842 26.6122 51.7591 26.0943C51.634 25.5763 51.5625 25.0227 51.5625 24.3976V19.2363H54.1542V24.094C54.1542 24.9334 54.2614 25.5228 54.4759 25.8621C54.6904 26.2014 55.1015 26.38 55.7092 26.38C55.888 26.38 56.0846 26.38 56.2991 26.3443C56.5135 26.3443 56.6923 26.3086 56.8531 26.2907V19.2363H59.4449V28.0766L59.4806 28.0588Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M103.861 28.5766C104.165 28.5766 104.487 28.5766 104.791 28.523L107.132 25.737C106.685 25.9691 106.077 26.1299 105.613 26.2192C105.148 26.3085 104.683 26.3442 104.219 26.3442C103.468 26.3442 102.878 26.1834 102.449 25.8798C102.002 25.5584 101.752 25.1476 101.698 24.6118H107.579C107.579 24.469 107.597 24.3082 107.615 24.1296C107.615 23.9511 107.615 23.7903 107.615 23.6296C107.615 22.0937 107.239 20.915 106.489 20.1292C105.738 19.3434 104.701 18.9326 103.414 18.9326C102.86 18.9326 102.306 19.0398 101.788 19.2541C101.252 19.4684 100.787 19.772 100.394 20.1828C99.9825 20.5935 99.6607 21.0936 99.4105 21.7008C99.1603 22.308 99.0352 23.0224 99.0352 23.826C99.0352 24.5047 99.1245 25.1298 99.3211 25.7013C99.5177 26.2906 99.8037 26.7728 100.215 27.2014C100.608 27.63 101.126 27.9515 101.734 28.2015C102.342 28.4516 103.057 28.5587 103.879 28.5587L103.861 28.5766ZM101.841 22.2009C101.913 21.9865 102.02 21.7901 102.163 21.6294C102.306 21.4686 102.485 21.3436 102.681 21.2365C102.896 21.1472 103.146 21.0936 103.432 21.0936C103.718 21.0936 103.986 21.1472 104.183 21.2543C104.379 21.3615 104.558 21.4865 104.683 21.6472C104.808 21.8079 104.916 21.9865 104.987 22.2009C105.059 22.4152 105.094 22.6295 105.094 22.8438H101.663C101.698 22.6295 101.752 22.3973 101.823 22.183L101.841 22.2009Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M46.185 40.025C45.613 40.025 45.0768 39.9357 44.6121 39.7392C44.1473 39.5428 43.7363 39.2749 43.3966 38.9177C43.057 38.5605 42.7889 38.114 42.6102 37.5783C42.4315 37.0425 42.3242 36.4353 42.3242 35.7566C42.3242 35.078 42.4315 34.4708 42.6459 33.935C42.8604 33.3992 43.1285 32.9527 43.486 32.5956C43.8435 32.2384 44.2546 31.9526 44.7193 31.774C45.184 31.5776 45.7024 31.4883 46.2386 31.4883C46.5782 31.4883 46.882 31.5061 47.1501 31.5597C47.4183 31.6133 47.6506 31.6669 47.8651 31.7205C48.0617 31.7919 48.2226 31.8455 48.3477 31.9169C48.4728 31.9883 48.5622 32.0241 48.6158 32.0598L48.2762 33.0063C48.2762 33.0063 48.0975 32.917 47.9723 32.8456C47.8294 32.792 47.6864 32.7384 47.5076 32.6848C47.3468 32.6313 47.1501 32.5777 46.9535 32.542C46.7569 32.5063 46.5424 32.4884 46.3458 32.4884C45.9169 32.4884 45.5236 32.5598 45.184 32.7206C44.8444 32.8634 44.5406 33.0778 44.2903 33.3635C44.0401 33.6492 43.8614 33.9886 43.7363 34.3993C43.6111 34.8101 43.5396 35.2566 43.5396 35.7566C43.5396 36.2567 43.5933 36.6853 43.7184 37.0961C43.8256 37.489 44.0044 37.8462 44.2367 38.1319C44.4691 38.4177 44.7551 38.632 45.0947 38.7927C45.4343 38.9534 45.8454 39.0249 46.2922 39.0249C46.8284 39.0249 47.2574 38.9713 47.597 38.8641C47.9366 38.757 48.2047 38.6498 48.3834 38.5784L48.6694 39.5249C48.6694 39.5249 48.5086 39.6142 48.3834 39.6678C48.2404 39.7214 48.0617 39.7749 47.8472 39.8464C47.6327 39.9 47.3825 39.9535 47.0965 39.9893C46.8105 40.025 46.5067 40.0428 46.1671 40.0428L46.185 40.025Z",
            fill: "#838187"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M49.0078 35.7566C49.0078 35.0601 49.1151 34.435 49.3295 33.8993C49.544 33.3635 49.83 32.917 50.1875 32.5598C50.545 32.2026 50.9561 31.9348 51.4387 31.7562C51.9212 31.5776 52.4217 31.4883 52.9579 31.4883C53.4941 31.4883 53.9767 31.5776 54.4593 31.7562C54.924 31.9348 55.3351 32.2026 55.6926 32.5598C56.0501 32.917 56.3361 33.3635 56.5327 33.8993C56.7472 34.435 56.8544 35.0601 56.8544 35.7566C56.8544 36.4531 56.7472 37.0782 56.5327 37.614C56.3182 38.1498 56.0501 38.5962 55.6926 38.9534C55.3351 39.3106 54.924 39.5785 54.4593 39.7571C53.9946 39.9357 53.4941 40.025 52.9579 40.025C52.4217 40.025 51.9212 39.9357 51.4387 39.7571C50.9561 39.5785 50.545 39.3106 50.1875 38.9534C49.83 38.5962 49.544 38.1498 49.3295 37.614C49.1151 37.0782 49.0078 36.4531 49.0078 35.7566ZM50.2054 35.7566C50.2054 36.2567 50.2769 36.7032 50.402 37.1139C50.5271 37.5247 50.7058 37.864 50.9382 38.1498C51.1705 38.4355 51.4565 38.6498 51.7961 38.8106C52.1357 38.9713 52.5111 39.0427 52.9222 39.0427C53.3333 39.0427 53.7086 38.9713 54.0482 38.8106C54.3878 38.6498 54.6559 38.4355 54.8883 38.1498C55.1207 37.864 55.2994 37.5247 55.4245 37.1139C55.5496 36.7032 55.6211 36.2567 55.6211 35.7566C55.6211 35.2566 55.5496 34.8101 55.4245 34.3993C55.2994 33.9886 55.1207 33.6492 54.8883 33.3635C54.6559 33.0778 54.37 32.8634 54.0482 32.7027C53.7265 32.542 53.3511 32.4705 52.9222 32.4705C52.4932 32.4705 52.1357 32.542 51.7961 32.7027C51.4565 32.8634 51.1705 33.0778 50.9382 33.3635C50.7058 33.6492 50.5271 33.9886 50.402 34.3993C50.2769 34.8101 50.2054 35.2566 50.2054 35.7566Z",
            fill: "#838187"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M61.1273 40.0241C60.5911 40.0241 60.1264 39.9348 59.7332 39.7741C59.3399 39.6134 59.0182 39.3812 58.768 39.0954C58.5177 38.8097 58.3211 38.4704 58.2139 38.0775C58.0888 37.6846 58.0352 37.2559 58.0352 36.8095V31.666H59.1791V36.6666C59.1791 37.4881 59.3578 38.0775 59.7153 38.4525C60.0728 38.8276 60.5554 39.0061 61.1273 39.0061C61.4133 39.0061 61.6814 38.9704 61.9316 38.8633C62.164 38.774 62.3785 38.6311 62.5572 38.4525C62.736 38.2561 62.8611 38.0239 62.9683 37.7203C63.0577 37.4167 63.1113 37.0774 63.1113 36.6666V31.666H64.2552V36.8095C64.2552 37.2738 64.2016 37.6846 64.0765 38.0775C63.9514 38.4704 63.7727 38.8097 63.5045 39.0954C63.2543 39.3812 62.9326 39.6134 62.5394 39.7741C62.1461 39.9348 61.6814 40.0241 61.1452 40.0241H61.1273Z",
            fill: "#838187"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M71.5128 39.8455C71.334 39.5598 71.1374 39.2205 70.9229 38.8633C70.6906 38.5061 70.4582 38.131 70.1901 37.7381C69.9399 37.3452 69.6539 36.9523 69.3858 36.5416C69.0998 36.1487 68.8317 35.7558 68.5457 35.3807C68.2776 35.0057 68.0095 34.6485 67.7414 34.327C67.4733 34.0056 67.2409 33.702 67.0264 33.4519V39.8455H65.9004V31.666H66.812C67.1873 32.0589 67.5805 32.5233 67.9916 33.0412C68.4206 33.5591 68.8317 34.1127 69.2428 34.6664C69.6539 35.22 70.0471 35.7736 70.4046 36.3094C70.7799 36.8452 71.0838 37.3274 71.334 37.7381V31.6839H72.4601V39.8634H71.4949L71.5128 39.8455Z",
            fill: "#838187"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M77.5697 40.025C76.9978 40.025 76.4615 39.9357 75.9968 39.7392C75.5321 39.5428 75.121 39.2749 74.7814 38.9177C74.4418 38.5605 74.1737 38.114 73.995 37.5783C73.8162 37.0425 73.709 36.4353 73.709 35.7566C73.709 35.078 73.8162 34.4708 74.0307 33.935C74.2452 33.3992 74.5133 32.9527 74.8708 32.5956C75.2283 32.2384 75.6394 31.9526 76.1041 31.774C76.5688 31.5776 77.0871 31.4883 77.6233 31.4883C77.9629 31.4883 78.2668 31.5061 78.5349 31.5597C78.803 31.6133 79.0354 31.6669 79.2499 31.7205C79.4465 31.7919 79.6073 31.8455 79.7325 31.9169C79.8576 31.9883 79.9469 32.0241 80.0006 32.0598L79.6788 33.0063C79.6788 33.0063 79.5001 32.917 79.375 32.8456C79.2499 32.792 79.089 32.7384 78.9281 32.6848C78.7494 32.6313 78.5707 32.5777 78.374 32.542C78.1774 32.5063 77.963 32.4884 77.7663 32.4884C77.3374 32.4884 76.9441 32.5598 76.6045 32.7206C76.2649 32.8634 75.9611 33.0778 75.7108 33.3635C75.4606 33.6492 75.2819 33.9886 75.1568 34.3993C75.0316 34.8101 74.9602 35.2566 74.9602 35.7566C74.9602 36.2567 75.0138 36.6853 75.1389 37.0961C75.2461 37.489 75.4249 37.8462 75.6572 38.1319C75.8896 38.4177 76.1756 38.632 76.5152 38.7927C76.8548 38.9534 77.248 39.0249 77.7127 39.0249C78.2489 39.0249 78.6779 38.9713 79.0175 38.8641C79.3571 38.757 79.6252 38.6498 79.804 38.5784L80.1078 39.5249C80.1078 39.5249 79.9469 39.6142 79.804 39.6678C79.661 39.7214 79.4822 39.7749 79.2677 39.8464C79.0533 39.9 78.803 39.9535 78.517 39.9893C78.2311 40.025 77.9272 40.0428 77.5876 40.0428L77.5697 40.025Z",
            fill: "#838187"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M81.3047 31.666H82.4486V39.8455H81.3047V31.666Z",
            fill: "#838187"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M89.1011 38.863V39.8631H84.168V31.6836H85.3119V38.8809H89.1011V38.863Z",
            fill: "#838187"
          }
        ),
        /* @__PURE__ */ k("defs", { children: [
          /* @__PURE__ */ k(
            "radialGradient",
            {
              id: "paint0_radial_16047_22228",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(29.3663 -11.3693 11.3786 29.3422 17.3514 38.2764)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ d("stop", { stopColor: "#009189" }),
                /* @__PURE__ */ d("stop", { offset: "0.11", stopColor: "#1D6676" }),
                /* @__PURE__ */ d("stop", { offset: "0.21", stopColor: "#205C69" }),
                /* @__PURE__ */ d("stop", { offset: "0.38", stopColor: "#006CA3" }),
                /* @__PURE__ */ d("stop", { offset: "0.61", stopColor: "#229FBC" }),
                /* @__PURE__ */ d("stop", { offset: "0.8", stopColor: "#1DA997" }),
                /* @__PURE__ */ d("stop", { offset: "0.91", stopColor: "#2FB691" }),
                /* @__PURE__ */ d("stop", { offset: "1", stopColor: "#00B5AF" })
              ]
            }
          ),
          /* @__PURE__ */ k(
            "radialGradient",
            {
              id: "paint1_radial_16047_22228",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(30.6902 -7.06268 7.06846 30.6651 16.7167 34.9008)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ d("stop", { stopColor: "#009189" }),
                /* @__PURE__ */ d("stop", { offset: "0.11", stopColor: "#1D6676" }),
                /* @__PURE__ */ d("stop", { offset: "0.21", stopColor: "#205C69" }),
                /* @__PURE__ */ d("stop", { offset: "0.38", stopColor: "#006CA3" }),
                /* @__PURE__ */ d("stop", { offset: "0.61", stopColor: "#229FBC" }),
                /* @__PURE__ */ d("stop", { offset: "0.8", stopColor: "#1DA997" }),
                /* @__PURE__ */ d("stop", { offset: "0.91", stopColor: "#2FB691" }),
                /* @__PURE__ */ d("stop", { offset: "1", stopColor: "#00B5AF" })
              ]
            }
          ),
          /* @__PURE__ */ k(
            "radialGradient",
            {
              id: "paint2_radial_16047_22228",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(-27.8457 -0.72857 -0.681905 26.0196 20.8487 45.827)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ d("stop", { stopColor: "#009189" }),
                /* @__PURE__ */ d("stop", { offset: "0.11", stopColor: "#1D6676" }),
                /* @__PURE__ */ d("stop", { offset: "0.21", stopColor: "#205C69" }),
                /* @__PURE__ */ d("stop", { offset: "0.38", stopColor: "#006CA3" }),
                /* @__PURE__ */ d("stop", { offset: "0.61", stopColor: "#229FBC" }),
                /* @__PURE__ */ d("stop", { offset: "0.8", stopColor: "#1DA997" }),
                /* @__PURE__ */ d("stop", { offset: "0.91", stopColor: "#2FB691" }),
                /* @__PURE__ */ d("stop", { offset: "1", stopColor: "#00B5AF" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
function Met(e) {
  return /* @__PURE__ */ d(
    "svg",
    {
      width: "25",
      height: "24",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ d("g", { id: "Remove", children: /* @__PURE__ */ d(
        "path",
        {
          id: "Union",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.233 2.3189C13.0438 2.11552 12.7786 2 12.5008 2C12.223 2 11.9578 2.11552 11.7686 2.3189L7.77758 6.60925C7.49607 6.89854 7.30858 7.26638 7.23999 7.66446C7.17035 8.06867 7.22667 8.48451 7.40132 8.85564C7.49728 9.05956 7.62642 9.24456 7.78233 9.4037L5.77137 11.6158C5.50571 11.8928 5.32525 12.2405 5.25177 12.6175C5.17689 13.0018 5.21643 13.3996 5.36549 13.7616C5.46384 14.0005 5.60703 14.2168 5.78607 14.3996L3.77137 16.6158C3.50571 16.8928 3.32525 17.2405 3.25177 17.6175C3.19115 17.9286 3.20552 18.2486 3.29228 18.5512L8.3582 13.4853C8.17912 13.1868 7.85486 13 7.5008 13H7.21494C7.22371 12.9911 7.23231 12.9819 7.24074 12.9727L10.2407 9.67267C10.507 9.37979 10.5754 8.95743 10.4153 8.59545C10.2552 8.23347 9.89662 8 9.5008 8H9.3008C9.27081 8 9.24083 8.00135 9.21096 8.00404C9.21842 7.99651 9.22576 7.98887 9.23299 7.9811L12.5008 4.4682L14.85 6.99355L16.2651 5.57841L13.233 2.3189ZM11.5 20L7.50034 20L9.50036 18H12.5H19.7867C19.7779 17.9911 19.7693 17.9819 19.7609 17.9727L16.7609 14.6727C16.4946 14.3798 16.4262 13.9574 16.5863 13.5954C16.7464 13.2335 17.105 13 17.5008 13H17.7867C17.7779 12.9911 17.7693 12.9819 17.7609 12.9727L16.2213 11.2791L17.6371 9.86329L19.2302 11.6158C19.4959 11.8928 19.6763 12.2405 19.7498 12.6175C19.8247 13.0018 19.7852 13.3996 19.6361 13.7616C19.5378 14.0005 19.3946 14.2168 19.2155 14.3996L21.2302 16.6158C21.4959 16.8928 21.6763 17.2405 21.7498 17.6175C21.8247 18.0018 21.7852 18.3996 21.6361 18.7616C21.487 19.1236 21.235 19.4339 20.9113 19.654C20.5875 19.8741 20.2063 19.9944 19.8148 19.9999L19.8008 20.0001L13.5 20.0001V22C13.5 22.5523 13.0523 23 12.5 23C11.9477 23 11.5 22.5523 11.5 22V20ZM19.1337 6.90097C19.4836 6.55101 19.4836 5.98362 19.1337 5.63366C18.7837 5.2837 18.2163 5.2837 17.8663 5.63366L4.13366 19.3663C3.7837 19.7163 3.7837 20.2837 4.13366 20.6337C4.48362 20.9836 5.05101 20.9836 5.40097 20.6337L19.1337 6.90097Z",
          fill: "currentcolor"
        }
      ) })
    }
  );
}
function Ret(e) {
  return /* @__PURE__ */ k(
    "svg",
    {
      width: "25",
      height: "24",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ d("g", { id: "Duplicate", clipPath: "url(#clip0_10111_17814)", children: /* @__PURE__ */ d(
          "path",
          {
            id: "Union",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.9008 2C15.1783 2.00023 15.4432 2.11574 15.6322 2.3189L19.6232 6.60925C19.9047 6.89854 20.0922 7.26638 20.1608 7.66446C20.2304 8.06867 20.1741 8.48452 19.9995 8.85564C19.9035 9.05956 19.7744 9.24456 19.6185 9.4037L21.6294 11.6158C21.8951 11.8928 22.0756 12.2405 22.149 12.6175C22.2239 13.0018 22.1844 13.3996 22.0353 13.7616C21.937 14.0005 21.7938 14.2168 21.6147 14.3996L23.6294 16.6158C23.8951 16.8928 24.0756 17.2405 24.149 17.6175C24.2239 18.0018 24.1844 18.3996 24.0353 18.7616C23.8863 19.1236 23.6342 19.4339 23.3105 19.654C22.9867 19.8741 22.6055 19.9944 22.214 19.9999L22.2 20.0001V20H17.093L17.086 20.0001L15.9004 20.0001V22C15.9004 22.5523 15.4527 23 14.9004 23C14.3481 23 13.9004 22.5523 13.9004 22V20.0001L10.7852 20.0001V22C10.7852 22.5523 10.3374 23 9.78516 23C9.23287 23 8.78516 22.5523 8.78516 22V20L2.47191 20C2.08046 19.9945 1.69923 19.8741 1.37548 19.654C1.05173 19.4339 0.799704 19.1236 0.650645 18.7616C0.501584 18.3996 0.462046 18.0018 0.536929 17.6175C0.610403 17.2405 0.790861 16.8928 1.05652 16.6158L3.07122 14.3996C2.89219 14.2168 2.749 14.0005 2.65064 13.7616C2.50159 13.3996 2.46204 13.0018 2.53693 12.6175C2.6104 12.2405 2.79086 11.8928 3.05652 11.6158L5.06749 9.4037C4.91157 9.24456 4.78244 9.05956 4.68647 8.85564C4.51183 8.48452 4.45551 8.06867 4.52515 7.66446C4.59374 7.26638 4.78123 6.89855 5.06274 6.60925L9.05377 2.3189C9.24295 2.11553 9.5082 2 9.78595 2C10.0637 2 10.329 2.11553 10.5181 2.3189L12.5012 4.45068C12.5123 4.22282 12.6011 3.99753 12.7689 3.81768L14.1689 2.31768C14.3583 2.11484 14.6234 1.99977 14.9008 2ZM13.4771 5.49975L14.5092 6.60923C14.7907 6.89853 14.9782 7.26637 15.0468 7.66446C15.1164 8.06867 15.0601 8.48452 14.8854 8.85564C14.7895 9.05956 14.6603 9.24456 14.5044 9.4037L16.5154 11.6158C16.781 11.8928 16.9615 12.2405 17.035 12.6175C17.1099 13.0018 17.0703 13.3996 16.9213 13.7616C16.8229 14.0005 16.6797 14.2168 16.5007 14.3996L18.5154 16.6158C18.781 16.8928 18.9615 17.2405 19.035 17.6175C19.0597 17.7441 19.0719 17.8722 19.0719 18H22.1859C22.1771 17.9911 22.1685 17.9819 22.1601 17.9727L19.1601 14.6727C18.8938 14.3798 18.8254 13.9574 18.9855 13.5954C19.1456 13.2335 19.5042 13 19.9 13H20.1859C20.1771 12.9911 20.1685 12.9819 20.1601 12.9727L17.1601 9.67267C16.8938 9.37979 16.8254 8.95743 16.9855 8.59545C17.1456 8.23347 17.5042 8 17.9 8H18.1C18.13 8 18.16 8.00135 18.1898 8.00405C18.1824 7.99652 18.175 7.98887 18.1678 7.9811L14.8988 4.4669L14.2311 5.18232C14.0286 5.39929 13.7521 5.50596 13.4771 5.49975ZM17.0718 18C17.063 17.9911 17.0544 17.9819 17.046 17.9727L14.046 14.6727C13.7798 14.3798 13.7113 13.9574 13.8714 13.5954C14.0316 13.2335 14.3901 13 14.786 13H15.0718C15.063 12.9911 15.0544 12.9819 15.046 12.9727L12.046 9.67267C11.7798 9.37979 11.7113 8.95743 11.8714 8.59545C12.0316 8.23347 12.3901 8 12.786 8H12.986C13.0159 8 13.0459 8.00135 13.0758 8.00405C13.0683 7.99652 13.061 7.98887 13.0538 7.9811L9.78595 4.4682L6.51814 7.9811C6.51092 7.98887 6.50358 7.99652 6.49611 8.00404C6.52598 8.00135 6.55596 8 6.58596 8H6.78595C7.18177 8 7.54034 8.23347 7.70047 8.59545C7.8606 8.95743 7.79215 9.37979 7.5259 9.67267L4.52589 12.9727C4.51747 12.9819 4.50887 12.9911 4.5001 13H4.78595C5.18177 13 5.54034 13.2335 5.70047 13.5954C5.8606 13.9574 5.79215 14.3798 5.52589 14.6727L2.52589 17.9727C2.51747 17.9819 2.50887 17.9911 2.5001 18H9.78516H13.9H14.9004H17.0718Z",
            fill: "currentcolor"
          }
        ) }),
        /* @__PURE__ */ d("defs", { children: /* @__PURE__ */ d("clipPath", { id: "clip0_10111_17814", children: /* @__PURE__ */ d(
          "rect",
          {
            width: "24",
            height: "24",
            fill: "transparent",
            transform: "translate(0.5)"
          }
        ) }) })
      ]
    }
  );
}
function Mv({ className: e, ...t }) {
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      className: z("h-4 w-4", e),
      ...t,
      children: /* @__PURE__ */ d(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
        }
      )
    }
  );
}
function hi({ className: e }) {
  return /* @__PURE__ */ k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      className: e,
      children: [
        /* @__PURE__ */ d(
          "mask",
          {
            id: "mask0_4938_6991",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "24",
            height: "24",
            children: /* @__PURE__ */ d("rect", { width: "24", height: "24", fill: "#D9D9D9" })
          }
        ),
        /* @__PURE__ */ d("g", { mask: "url(#mask0_4938_6991)", children: /* @__PURE__ */ d(
          "path",
          {
            d: "M14 21L12.575 19.575L16.175 16H5V4H7V14H16.175L12.575 10.4L13.975 8.975L20 15L14 21Z",
            fill: "currentcolor"
          }
        ) })
      ]
    }
  );
}
function Mqe(e) {
  return /* @__PURE__ */ k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      ...e,
      children: [
        /* @__PURE__ */ d(
          "mask",
          {
            id: "mask0_13737_12564",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "20",
            height: "20",
            children: /* @__PURE__ */ d("rect", { width: "20", height: "20", fill: "#D9D9D9" })
          }
        ),
        /* @__PURE__ */ d("g", { mask: "url(#mask0_13737_12564)", children: /* @__PURE__ */ d(
          "path",
          {
            d: "M7.25 13.9167L6.08333 12.75L9.66667 9.16667H6.66667V7.5H12.5V13.3333H10.8333V10.3333L7.25 13.9167ZM15.8333 10V4.16667H10V2.5H17.5V10H15.8333ZM4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V2.5H4.16667V15.8333H17.5V17.5H4.16667Z",
            fill: "#0157FF"
          }
        ) })
      ]
    }
  );
}
function Det(e) {
  return /* @__PURE__ */ k(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ d("circle", { cx: "12", cy: "12", r: "10", fill: "#039469" }),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M6.01074 5.2832C4.6392 6.50705 3.64672 8.14462 3.22559 10H5L5.2959 10.0146C5.98282 10.0828 6.62871 10.3865 7.12109 10.8789C7.68364 11.4415 8 12.2044 8 13V14L8.00488 14.0986C8.02758 14.3276 8.12883 14.5429 8.29297 14.707C8.45715 14.8712 8.67234 14.9725 8.90137 14.9951L9.2959 15.0146C9.98282 15.0828 10.6287 15.3865 11.1211 15.8789C11.6836 16.4415 12 17.2044 12 18V21C12.6877 21 13.3565 20.9195 14 20.7734V17C14 16.2043 14.3163 15.4415 14.8789 14.8789C15.4415 14.3163 16.2043 14 17 14H20.7744C20.9205 13.3566 21 12.6876 21 12C21 10.9479 20.8181 9.93847 20.4863 9H18C17.4524 9 17.0001 9.45239 17 10C17 10.7955 16.6836 11.5585 16.1211 12.1211C15.5585 12.6837 14.7956 13 14 13C12.3478 13 11.0001 11.6522 11 10C10.9999 9.73491 10.8945 9.48044 10.707 9.29297C10.5195 9.10551 10.2652 9 10 9C8.93917 9 7.92201 8.57822 7.17188 7.82812C6.48883 7.14502 6.07869 6.2405 6.01074 5.2832Z",
            fill: "#373530"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 1C16.4781 1 20.3276 3.67753 22.0439 7.51758C22.0695 7.56373 22.0913 7.61186 22.1094 7.66211C22.6813 8.99331 23 10.4593 23 12C23 18.0751 18.0751 23 12 23C11.6309 23 11.2661 22.9808 10.9062 22.9453C10.902 22.9449 10.8978 22.9448 10.8936 22.9443C5.33802 22.3894 1 17.7017 1 12C1 7.93868 3.20232 4.39373 6.47656 2.48828C6.49603 2.47629 6.51581 2.46476 6.53613 2.4541C8.14622 1.53053 10.0107 1 12 1ZM3.22559 10C3.64672 8.14462 4.6392 6.50705 6.01074 5.2832C6.07869 6.2405 6.48883 7.14502 7.17188 7.82812C7.92201 8.57822 8.93917 9 10 9C10.2652 9 10.5195 9.10551 10.707 9.29297C10.8945 9.48044 10.9999 9.73491 11 10C11.0001 11.6522 12.3478 13 14 13C14.7956 13 15.5585 12.6837 16.1211 12.1211C16.6836 11.5585 17 10.7955 17 10C17.0001 9.45239 17.4524 9 18 9H20.4863C20.8181 9.93847 21 10.9479 21 12C21 12.6876 20.9205 13.3566 20.7744 14H17C16.2043 14 15.4415 14.3163 14.8789 14.8789C14.3163 15.4415 14 16.2043 14 17V20.7734C13.3565 20.9195 12.6877 21 12 21V18C12 17.2044 11.6836 16.4415 11.1211 15.8789C10.6287 15.3865 9.98282 15.0828 9.2959 15.0146L8.90137 14.9951C8.67234 14.9725 8.45715 14.8712 8.29297 14.707C8.12883 14.5429 8.02758 14.3276 8.00488 14.0986L8 14V13C8 12.2044 7.68364 11.4415 7.12109 10.8789C6.62871 10.3865 5.98282 10.0828 5.2959 10.0146L5 10H3.22559ZM10 20.7734C5.99241 19.8637 3 16.2829 3 12H5L5.09863 12.0049C5.32756 12.0276 5.54293 12.1289 5.70703 12.293C5.89451 12.4805 6 12.7348 6 13V14C6 14.7957 6.3163 15.5585 6.87891 16.1211C7.44151 16.6836 8.2044 17 9 17C9.26515 17.0001 9.51954 17.1055 9.70703 17.293C9.89451 17.4805 10 17.7348 10 18V20.7734ZM16.293 16.293C16.4805 16.1054 16.7348 16 17 16H20.0625C19.1888 17.7577 17.7577 19.1877 16 20.0615V17C16 16.7348 16.1054 16.4805 16.293 16.293ZM8 3.9375C9.20516 3.33844 10.5628 3 12 3C15.1202 3 17.8688 4.5883 19.4834 7H18C16.3478 7 15.0001 8.34783 15 10C15 10.2651 14.8945 10.5195 14.707 10.707C14.5195 10.8945 14.2652 11 14 11C13.4523 11 13.0001 10.5476 13 10C12.9999 9.20447 12.6836 8.44145 12.1211 7.87891C11.5585 7.31637 10.7956 7 10 7C9.4696 7 8.961 6.78909 8.58594 6.41406C8.21098 6.03904 8.00004 5.53032 8 5V3.9375Z",
            fill: "#373530"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M6.01074 5.2832C4.6392 6.50705 3.64672 8.14462 3.22559 10H5L5.2959 10.0146C5.98282 10.0828 6.62871 10.3865 7.12109 10.8789C7.68364 11.4415 8 12.2044 8 13V14L8.00488 14.0986C8.02758 14.3276 8.12883 14.5429 8.29297 14.707C8.45715 14.8712 8.67234 14.9725 8.90137 14.9951L9.2959 15.0146C9.98282 15.0828 10.6287 15.3865 11.1211 15.8789C11.6836 16.4415 12 17.2044 12 18V21C12.6877 21 13.3565 20.9195 14 20.7734V17C14 16.2043 14.3163 15.4415 14.8789 14.8789C15.4415 14.3163 16.2043 14 17 14H20.7744C20.9205 13.3566 21 12.6876 21 12C21 10.9479 20.8181 9.93847 20.4863 9H18C17.4524 9 17.0001 9.45239 17 10C17 10.7955 16.6836 11.5585 16.1211 12.1211C15.5585 12.6837 14.7956 13 14 13C12.3478 13 11.0001 11.6522 11 10C10.9999 9.73491 10.8945 9.48044 10.707 9.29297C10.5195 9.10551 10.2652 9 10 9C8.93917 9 7.92201 8.57822 7.17188 7.82812C6.48883 7.14502 6.07869 6.2405 6.01074 5.2832Z",
            fill: "#77AAF4"
          }
        )
      ]
    }
  );
}
function Rqe() {
  return /* @__PURE__ */ k(
    "svg",
    {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 145.3 109.9",
      xmlSpace: "preserve",
      children: [
        /* @__PURE__ */ d("style", { type: "text/css", children: `.st0{fill:#502D3C;}
        .st1{display:none;}
        .st2{display:inline;fill:none;stroke:#2DAAE1;stroke-width:0.25;stroke-miterlimit:10;}
        .st3{display:inline;}
        .st4{fill:none;stroke:#2DAAE1;stroke-width:0.25;stroke-miterlimit:10;}` }),
        /* @__PURE__ */ d("g", { id: "Layer_1", children: /* @__PURE__ */ d(
          "path",
          {
            className: "st0",
            d: `M17.5,30.5C17.5,18.4,11.4,8.4,0,0h26.5c9.3,7.2,15,18.2,15,30.5c0,12.3-5.7,23.3-15,30.5
          c8.6,3.6,13.5,12.4,13.5,25v24H16v-24c0-12-5.7-20.4-16-25C11.4,52.5,17.5,42.6,17.5,30.5 M69.4,30.5c0-12.1-6.1-22.1-17.5-30.5
          h26.5c9.3,7.2,15,18.2,15,30.5c0,12.3-5.7,23.3-15,30.5c8.6,3.6,13.5,12.4,13.5,25v24h-24v-24c0-12-5.7-20.4-16-25
          C63.3,52.5,69.4,42.6,69.4,30.5 M121.4,30.5c0-12.1-6.1-22.1-17.5-30.5h26.5c9.3,7.2,15,18.2,15,30.5c0,12.3-5.7,23.3-15,30.5
          c8.6,3.6,13.5,12.4,13.5,25v24h-24v-24c0-12-5.7-20.4-16-25C115.3,52.5,121.4,42.6,121.4,30.5`
          }
        ) }),
        /* @__PURE__ */ k("g", { id: "grid_for_exports", className: "st1", children: [
          /* @__PURE__ */ d("line", { className: "st2", x1: "215.7", y1: "181.8", x2: "-71.9", y2: "181.8" }),
          /* @__PURE__ */ d("line", { className: "st2", x1: "215.7", y1: "0", x2: "-71.9", y2: "0" }),
          /* @__PURE__ */ d("line", { className: "st2", x1: "215.7", y1: "109.8", x2: "-71.9", y2: "109.8" }),
          /* @__PURE__ */ d("line", { className: "st2", x1: "143.7", y1: "181.6", x2: "143.7", y2: "-72" }),
          /* @__PURE__ */ d("line", { className: "st2", x1: "0", y1: "-71.2", x2: "0", y2: "181.6" }),
          /* @__PURE__ */ d("rect", { x: "15.7", y: "85.8", className: "st2", width: "24", height: "24" }),
          /* @__PURE__ */ d("rect", { x: "-24", y: "-24", className: "st2", width: "24", height: "24" }),
          /* @__PURE__ */ d("rect", { x: "-48", y: "-48", className: "st2", width: "24", height: "24" }),
          /* @__PURE__ */ d("rect", { x: "-72", y: "-72", className: "st2", width: "24", height: "24" }),
          /* @__PURE__ */ k("g", { className: "st3", children: [
            /* @__PURE__ */ d(
              "rect",
              {
                x: "-72",
                y: "157.8",
                transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -120 339.6799)",
                className: "st4",
                width: "24",
                height: "24"
              }
            ),
            /* @__PURE__ */ d(
              "rect",
              {
                x: "-48",
                y: "133.8",
                transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -72 291.6799)",
                className: "st4",
                width: "24",
                height: "24"
              }
            ),
            /* @__PURE__ */ d(
              "rect",
              {
                x: "-24",
                y: "109.8",
                transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -24 243.6799)",
                className: "st4",
                width: "24",
                height: "24"
              }
            )
          ] }),
          /* @__PURE__ */ k("g", { className: "st3", children: [
            /* @__PURE__ */ d("rect", { x: "191.7", y: "157.8", className: "st4", width: "24", height: "24" }),
            /* @__PURE__ */ d("rect", { x: "167.7", y: "133.8", className: "st4", width: "24", height: "24" }),
            /* @__PURE__ */ d("rect", { x: "143.7", y: "109.8", className: "st4", width: "24", height: "24" })
          ] }),
          /* @__PURE__ */ k("g", { className: "st3", children: [
            /* @__PURE__ */ d(
              "rect",
              {
                x: "143.7",
                y: "-24",
                transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 311.4358 -24)",
                className: "st4",
                width: "24",
                height: "24"
              }
            ),
            /* @__PURE__ */ d(
              "rect",
              {
                x: "167.7",
                y: "-48",
                transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 359.4358 -72)",
                className: "st4",
                width: "24",
                height: "24"
              }
            ),
            /* @__PURE__ */ d(
              "rect",
              {
                x: "191.7",
                y: "-72",
                transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 407.4358 -120)",
                className: "st4",
                width: "24",
                height: "24"
              }
            )
          ] }),
          /* @__PURE__ */ d("rect", { x: "-72", y: "-72", className: "st2", width: "287.7", height: "253.8" })
        ] })
      ]
    }
  );
}
function Iet({ className: e }) {
  return /* @__PURE__ */ d("div", { className: z("grid-loader relative h-[160px]", e), children: /* @__PURE__ */ d("div", { className: "absolute inset-0 flex flex-col", children: Array.from({ length: 8 }).map((t, n) => /* @__PURE__ */ d("div", { className: "flex grow", children: Array.from({ length: 24 }).map((r, i) => /* @__PURE__ */ d(
    "div",
    {
      className: "grow border-2 border-[#FCFCF9]"
    },
    i
  )) }, n)) }) });
}
function Qn(e) {
  this.content = e;
}
Qn.prototype = {
  constructor: Qn,
  find: function(e) {
    for (var t = 0; t < this.content.length; t += 2)
      if (this.content[t] === e) return t;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(e) {
    var t = this.find(e);
    return t == -1 ? void 0 : this.content[t + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(e, t, n) {
    var r = n && n != e ? this.remove(n) : this, i = r.find(e), o = r.content.slice();
    return i == -1 ? o.push(n || e, t) : (o[i + 1] = t, n && (o[i] = n)), new Qn(o);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(e) {
    var t = this.find(e);
    if (t == -1) return this;
    var n = this.content.slice();
    return n.splice(t, 2), new Qn(n);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(e, t) {
    return new Qn([e, t].concat(this.remove(e).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(e, t) {
    var n = this.remove(e).content.slice();
    return n.push(e, t), new Qn(n);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(e, t, n) {
    var r = this.remove(t), i = r.content.slice(), o = r.find(e);
    return i.splice(o == -1 ? i.length : o, 0, t, n), new Qn(i);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(e) {
    for (var t = 0; t < this.content.length; t += 2)
      e(this.content[t], this.content[t + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(e) {
    return e = Qn.from(e), e.size ? new Qn(e.content.concat(this.subtract(e).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(e) {
    return e = Qn.from(e), e.size ? new Qn(this.subtract(e).content.concat(e.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(e) {
    var t = this;
    e = Qn.from(e);
    for (var n = 0; n < e.content.length; n += 2)
      t = t.remove(e.content[n]);
    return t;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var e = {};
    return this.forEach(function(t, n) {
      e[t] = n;
    }), e;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
Qn.from = function(e) {
  if (e instanceof Qn) return e;
  var t = [];
  if (e) for (var n in e) t.push(n, e[n]);
  return new Qn(t);
};
function gQ(e, t, n) {
  for (let r = 0; ; r++) {
    if (r == e.childCount || r == t.childCount)
      return e.childCount == t.childCount ? null : n;
    let i = e.child(r), o = t.child(r);
    if (i == o) {
      n += i.nodeSize;
      continue;
    }
    if (!i.sameMarkup(o))
      return n;
    if (i.isText && i.text != o.text) {
      for (let a = 0; i.text[a] == o.text[a]; a++)
        n++;
      return n;
    }
    if (i.content.size || o.content.size) {
      let a = gQ(i.content, o.content, n + 1);
      if (a != null)
        return a;
    }
    n += i.nodeSize;
  }
}
function vQ(e, t, n, r) {
  for (let i = e.childCount, o = t.childCount; ; ) {
    if (i == 0 || o == 0)
      return i == o ? null : { a: n, b: r };
    let a = e.child(--i), s = t.child(--o), l = a.nodeSize;
    if (a == s) {
      n -= l, r -= l;
      continue;
    }
    if (!a.sameMarkup(s))
      return { a: n, b: r };
    if (a.isText && a.text != s.text) {
      let u = 0, c = Math.min(a.text.length, s.text.length);
      for (; u < c && a.text[a.text.length - u - 1] == s.text[s.text.length - u - 1]; )
        u++, n--, r--;
      return { a: n, b: r };
    }
    if (a.content.size || s.content.size) {
      let u = vQ(a.content, s.content, n - 1, r - 1);
      if (u)
        return u;
    }
    n -= l, r -= l;
  }
}
class he {
  /**
  @internal
  */
  constructor(t, n) {
    if (this.content = t, this.size = n || 0, n == null)
      for (let r = 0; r < t.length; r++)
        this.size += t[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(t, n, r, i = 0, o) {
    for (let a = 0, s = 0; s < n; a++) {
      let l = this.content[a], u = s + l.nodeSize;
      if (u > t && r(l, i + s, o || null, a) !== !1 && l.content.size) {
        let c = s + 1;
        l.nodesBetween(Math.max(0, t - c), Math.min(l.content.size, n - c), r, i + c);
      }
      s = u;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(t) {
    this.nodesBetween(0, this.size, t);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(t, n, r, i) {
    let o = "", a = !0;
    return this.nodesBetween(t, n, (s, l) => {
      let u = s.isText ? s.text.slice(Math.max(t, l) - l, n - l) : s.isLeaf ? i ? typeof i == "function" ? i(s) : i : s.type.spec.leafText ? s.type.spec.leafText(s) : "" : "";
      s.isBlock && (s.isLeaf && u || s.isTextblock) && r && (a ? a = !1 : o += r), o += u;
    }, 0), o;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(t) {
    if (!t.size)
      return this;
    if (!this.size)
      return t;
    let n = this.lastChild, r = t.firstChild, i = this.content.slice(), o = 0;
    for (n.isText && n.sameMarkup(r) && (i[i.length - 1] = n.withText(n.text + r.text), o = 1); o < t.content.length; o++)
      i.push(t.content[o]);
    return new he(i, this.size + t.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(t, n = this.size) {
    if (t == 0 && n == this.size)
      return this;
    let r = [], i = 0;
    if (n > t)
      for (let o = 0, a = 0; a < n; o++) {
        let s = this.content[o], l = a + s.nodeSize;
        l > t && ((a < t || l > n) && (s.isText ? s = s.cut(Math.max(0, t - a), Math.min(s.text.length, n - a)) : s = s.cut(Math.max(0, t - a - 1), Math.min(s.content.size, n - a - 1))), r.push(s), i += s.nodeSize), a = l;
      }
    return new he(r, i);
  }
  /**
  @internal
  */
  cutByIndex(t, n) {
    return t == n ? he.empty : t == 0 && n == this.content.length ? this : new he(this.content.slice(t, n));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(t, n) {
    let r = this.content[t];
    if (r == n)
      return this;
    let i = this.content.slice(), o = this.size + n.nodeSize - r.nodeSize;
    return i[t] = n, new he(i, o);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(t) {
    return new he([t].concat(this.content), this.size + t.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(t) {
    return new he(this.content.concat(t), this.size + t.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(t) {
    if (this.content.length != t.content.length)
      return !1;
    for (let n = 0; n < this.content.length; n++)
      if (!this.content[n].eq(t.content[n]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(t) {
    let n = this.content[t];
    if (!n)
      throw new RangeError("Index " + t + " out of range for " + this);
    return n;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(t) {
    return this.content[t] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(t) {
    for (let n = 0, r = 0; n < this.content.length; n++) {
      let i = this.content[n];
      t(i, r, n), r += i.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(t, n = 0) {
    return gQ(this, t, n);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(t, n = this.size, r = t.size) {
    return vQ(this, t, n, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(t, n = -1) {
    if (t == 0)
      return N1(0, t);
    if (t == this.size)
      return N1(this.content.length, t);
    if (t > this.size || t < 0)
      throw new RangeError(`Position ${t} outside of fragment (${this})`);
    for (let r = 0, i = 0; ; r++) {
      let o = this.child(r), a = i + o.nodeSize;
      if (a >= t)
        return a == t || n > 0 ? N1(r + 1, a) : N1(r, i);
      i = a;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((t) => t.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      return he.empty;
    if (!Array.isArray(n))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new he(n.map(t.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(t) {
    if (!t.length)
      return he.empty;
    let n, r = 0;
    for (let i = 0; i < t.length; i++) {
      let o = t[i];
      r += o.nodeSize, i && o.isText && t[i - 1].sameMarkup(o) ? (n || (n = t.slice(0, i)), n[n.length - 1] = o.withText(n[n.length - 1].text + o.text)) : n && n.push(o);
    }
    return new he(n || t, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(t) {
    if (!t)
      return he.empty;
    if (t instanceof he)
      return t;
    if (Array.isArray(t))
      return this.fromArray(t);
    if (t.attrs)
      return new he([t], t.nodeSize);
    throw new RangeError("Can not convert " + t + " to a Fragment" + (t.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
he.empty = new he([], 0);
const A8 = { index: 0, offset: 0 };
function N1(e, t) {
  return A8.index = e, A8.offset = t, A8;
}
function mg(e, t) {
  if (e === t)
    return !0;
  if (!(e && typeof e == "object") || !(t && typeof t == "object"))
    return !1;
  let n = Array.isArray(e);
  if (Array.isArray(t) != n)
    return !1;
  if (n) {
    if (e.length != t.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!mg(e[r], t[r]))
        return !1;
  } else {
    for (let r in e)
      if (!(r in t) || !mg(e[r], t[r]))
        return !1;
    for (let r in t)
      if (!(r in e))
        return !1;
  }
  return !0;
}
let Ot = class U9 {
  /**
  @internal
  */
  constructor(t, n) {
    this.type = t, this.attrs = n;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(t) {
    let n, r = !1;
    for (let i = 0; i < t.length; i++) {
      let o = t[i];
      if (this.eq(o))
        return t;
      if (this.type.excludes(o.type))
        n || (n = t.slice(0, i));
      else {
        if (o.type.excludes(this.type))
          return t;
        !r && o.type.rank > this.type.rank && (n || (n = t.slice(0, i)), n.push(this), r = !0), n && n.push(o);
      }
    }
    return n || (n = t.slice()), r || n.push(this), n;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(t) {
    for (let n = 0; n < t.length; n++)
      if (this.eq(t[n]))
        return t.slice(0, n).concat(t.slice(n + 1));
    return t;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(t) {
    for (let n = 0; n < t.length; n++)
      if (this.eq(t[n]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(t) {
    return this == t || this.type == t.type && mg(this.attrs, t.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let t = { type: this.type.name };
    for (let n in this.attrs) {
      t.attrs = this.attrs;
      break;
    }
    return t;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(t, n) {
    if (!n)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = t.marks[n.type];
    if (!r)
      throw new RangeError(`There is no mark type ${n.type} in this schema`);
    let i = r.create(n.attrs);
    return r.checkAttrs(i.attrs), i;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(t, n) {
    if (t == n)
      return !0;
    if (t.length != n.length)
      return !1;
    for (let r = 0; r < t.length; r++)
      if (!t[r].eq(n[r]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(t) {
    if (!t || Array.isArray(t) && t.length == 0)
      return U9.none;
    if (t instanceof U9)
      return [t];
    let n = t.slice();
    return n.sort((r, i) => r.type.rank - i.type.rank), n;
  }
};
Ot.none = [];
class gg extends Error {
}
class _e {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(t, n, r) {
    this.content = t, this.openStart = n, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(t, n) {
    let r = bQ(this.content, t + this.openStart, n);
    return r && new _e(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(t, n) {
    return new _e(yQ(this.content, t + this.openStart, n + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(t) {
    return this.content.eq(t.content) && this.openStart == t.openStart && this.openEnd == t.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let t = { content: this.content.toJSON() };
    return this.openStart > 0 && (t.openStart = this.openStart), this.openEnd > 0 && (t.openEnd = this.openEnd), t;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      return _e.empty;
    let r = n.openStart || 0, i = n.openEnd || 0;
    if (typeof r != "number" || typeof i != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new _e(he.fromJSON(t, n.content), r, i);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(t, n = !0) {
    let r = 0, i = 0;
    for (let o = t.firstChild; o && !o.isLeaf && (n || !o.type.spec.isolating); o = o.firstChild)
      r++;
    for (let o = t.lastChild; o && !o.isLeaf && (n || !o.type.spec.isolating); o = o.lastChild)
      i++;
    return new _e(t, r, i);
  }
}
_e.empty = new _e(he.empty, 0, 0);
function yQ(e, t, n) {
  let { index: r, offset: i } = e.findIndex(t), o = e.maybeChild(r), { index: a, offset: s } = e.findIndex(n);
  if (i == t || o.isText) {
    if (s != n && !e.child(a).isText)
      throw new RangeError("Removing non-flat range");
    return e.cut(0, t).append(e.cut(n));
  }
  if (r != a)
    throw new RangeError("Removing non-flat range");
  return e.replaceChild(r, o.copy(yQ(o.content, t - i - 1, n - i - 1)));
}
function bQ(e, t, n, r) {
  let { index: i, offset: o } = e.findIndex(t), a = e.maybeChild(i);
  if (o == t || a.isText)
    return e.cut(0, t).append(n).append(e.cut(t));
  let s = bQ(a.content, t - o - 1, n);
  return s && e.replaceChild(i, a.copy(s));
}
function Dqe(e, t, n) {
  if (n.openStart > e.depth)
    throw new gg("Inserted content deeper than insertion position");
  if (e.depth - n.openStart != t.depth - n.openEnd)
    throw new gg("Inconsistent open depths");
  return xQ(e, t, n, 0);
}
function xQ(e, t, n, r) {
  let i = e.index(r), o = e.node(r);
  if (i == t.index(r) && r < e.depth - n.openStart) {
    let a = xQ(e, t, n, r + 1);
    return o.copy(o.content.replaceChild(i, a));
  } else if (n.content.size)
    if (!n.openStart && !n.openEnd && e.depth == r && t.depth == r) {
      let a = e.parent, s = a.content;
      return jl(a, s.cut(0, e.parentOffset).append(n.content).append(s.cut(t.parentOffset)));
    } else {
      let { start: a, end: s } = Iqe(n, e);
      return jl(o, CQ(e, a, s, t, r));
    }
  else return jl(o, vg(e, t, r));
}
function wQ(e, t) {
  if (!t.type.compatibleContent(e.type))
    throw new gg("Cannot join " + t.type.name + " onto " + e.type.name);
}
function G9(e, t, n) {
  let r = e.node(n);
  return wQ(r, t.node(n)), r;
}
function Bl(e, t) {
  let n = t.length - 1;
  n >= 0 && e.isText && e.sameMarkup(t[n]) ? t[n] = e.withText(t[n].text + e.text) : t.push(e);
}
function Uf(e, t, n, r) {
  let i = (t || e).node(n), o = 0, a = t ? t.index(n) : i.childCount;
  e && (o = e.index(n), e.depth > n ? o++ : e.textOffset && (Bl(e.nodeAfter, r), o++));
  for (let s = o; s < a; s++)
    Bl(i.child(s), r);
  t && t.depth == n && t.textOffset && Bl(t.nodeBefore, r);
}
function jl(e, t) {
  return e.type.checkContent(t), e.copy(t);
}
function CQ(e, t, n, r, i) {
  let o = e.depth > i && G9(e, t, i + 1), a = r.depth > i && G9(n, r, i + 1), s = [];
  return Uf(null, e, i, s), o && a && t.index(i) == n.index(i) ? (wQ(o, a), Bl(jl(o, CQ(e, t, n, r, i + 1)), s)) : (o && Bl(jl(o, vg(e, t, i + 1)), s), Uf(t, n, i, s), a && Bl(jl(a, vg(n, r, i + 1)), s)), Uf(r, null, i, s), new he(s);
}
function vg(e, t, n) {
  let r = [];
  if (Uf(null, e, n, r), e.depth > n) {
    let i = G9(e, t, n + 1);
    Bl(jl(i, vg(e, t, n + 1)), r);
  }
  return Uf(t, null, n, r), new he(r);
}
function Iqe(e, t) {
  let n = t.depth - e.openStart, i = t.node(n).copy(e.content);
  for (let o = n - 1; o >= 0; o--)
    i = t.node(o).copy(he.from(i));
  return {
    start: i.resolveNoCache(e.openStart + n),
    end: i.resolveNoCache(i.content.size - e.openEnd - n)
  };
}
class qh {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.pos = t, this.path = n, this.parentOffset = r, this.depth = n.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(t) {
    return t == null ? this.depth : t < 0 ? this.depth + t : t;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(t) {
    return this.path[this.resolveDepth(t) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(t) {
    return this.path[this.resolveDepth(t) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(t) {
    return t = this.resolveDepth(t), this.index(t) + (t == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(t) {
    return t = this.resolveDepth(t), t == 0 ? 0 : this.path[t * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(t) {
    return t = this.resolveDepth(t), this.start(t) + this.node(t).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(t) {
    if (t = this.resolveDepth(t), !t)
      throw new RangeError("There is no position before the top-level node");
    return t == this.depth + 1 ? this.pos : this.path[t * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(t) {
    if (t = this.resolveDepth(t), !t)
      throw new RangeError("There is no position after the top-level node");
    return t == this.depth + 1 ? this.pos : this.path[t * 3 - 1] + this.path[t * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let t = this.parent, n = this.index(this.depth);
    if (n == t.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], i = t.child(n);
    return r ? t.child(n).cut(r) : i;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let t = this.index(this.depth), n = this.pos - this.path[this.path.length - 1];
    return n ? this.parent.child(t).cut(0, n) : t == 0 ? null : this.parent.child(t - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(t, n) {
    n = this.resolveDepth(n);
    let r = this.path[n * 3], i = n == 0 ? 0 : this.path[n * 3 - 1] + 1;
    for (let o = 0; o < t; o++)
      i += r.child(o).nodeSize;
    return i;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let t = this.parent, n = this.index();
    if (t.content.size == 0)
      return Ot.none;
    if (this.textOffset)
      return t.child(n).marks;
    let r = t.maybeChild(n - 1), i = t.maybeChild(n);
    if (!r) {
      let s = r;
      r = i, i = s;
    }
    let o = r.marks;
    for (var a = 0; a < o.length; a++)
      o[a].type.spec.inclusive === !1 && (!i || !o[a].isInSet(i.marks)) && (o = o[a--].removeFromSet(o));
    return o;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(t) {
    let n = this.parent.maybeChild(this.index());
    if (!n || !n.isInline)
      return null;
    let r = n.marks, i = t.parent.maybeChild(t.index());
    for (var o = 0; o < r.length; o++)
      r[o].type.spec.inclusive === !1 && (!i || !r[o].isInSet(i.marks)) && (r = r[o--].removeFromSet(r));
    return r;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(t) {
    for (let n = this.depth; n > 0; n--)
      if (this.start(n) <= t && this.end(n) >= t)
        return n;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(t = this, n) {
    if (t.pos < this.pos)
      return t.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == t.pos ? 1 : 0); r >= 0; r--)
      if (t.pos <= this.end(r) && (!n || n(this.node(r))))
        return new yg(this, t, r);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(t) {
    return this.pos - this.parentOffset == t.pos - t.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(t) {
    return t.pos > this.pos ? t : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(t) {
    return t.pos < this.pos ? t : this;
  }
  /**
  @internal
  */
  toString() {
    let t = "";
    for (let n = 1; n <= this.depth; n++)
      t += (t ? "/" : "") + this.node(n).type.name + "_" + this.index(n - 1);
    return t + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(t, n) {
    if (!(n >= 0 && n <= t.content.size))
      throw new RangeError("Position " + n + " out of range");
    let r = [], i = 0, o = n;
    for (let a = t; ; ) {
      let { index: s, offset: l } = a.content.findIndex(o), u = o - l;
      if (r.push(a, s, i + l), !u || (a = a.child(s), a.isText))
        break;
      o = u - 1, i += l + 1;
    }
    return new qh(n, r, o);
  }
  /**
  @internal
  */
  static resolveCached(t, n) {
    let r = fL.get(t);
    if (r)
      for (let o = 0; o < r.elts.length; o++) {
        let a = r.elts[o];
        if (a.pos == n)
          return a;
      }
    else
      fL.set(t, r = new $qe());
    let i = r.elts[r.i] = qh.resolve(t, n);
    return r.i = (r.i + 1) % Lqe, i;
  }
}
class $qe {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const Lqe = 12, fL = /* @__PURE__ */ new WeakMap();
class yg {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(t, n, r) {
    this.$from = t, this.$to = n, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const Fqe = /* @__PURE__ */ Object.create(null);
let Vl = class K9 {
  /**
  @internal
  */
  constructor(t, n, r, i = Ot.none) {
    this.type = t, this.attrs = n, this.marks = i, this.content = r || he.empty;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(t) {
    return this.content.child(t);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(t) {
    return this.content.maybeChild(t);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(t) {
    this.content.forEach(t);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(t, n, r, i = 0) {
    this.content.nodesBetween(t, n, r, i, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(t) {
    this.nodesBetween(0, this.content.size, t);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(t, n, r, i) {
    return this.content.textBetween(t, n, r, i);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(t) {
    return this == t || this.sameMarkup(t) && this.content.eq(t.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(t) {
    return this.hasMarkup(t.type, t.attrs, t.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(t, n, r) {
    return this.type == t && mg(this.attrs, n || t.defaultAttrs || Fqe) && Ot.sameSet(this.marks, r || Ot.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(t = null) {
    return t == this.content ? this : new K9(this.type, this.attrs, t, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(t) {
    return t == this.marks ? this : new K9(this.type, this.attrs, this.content, t);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(t, n = this.content.size) {
    return t == 0 && n == this.content.size ? this : this.copy(this.content.cut(t, n));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(t, n = this.content.size, r = !1) {
    if (t == n)
      return _e.empty;
    let i = this.resolve(t), o = this.resolve(n), a = r ? 0 : i.sharedDepth(n), s = i.start(a), u = i.node(a).content.cut(i.pos - s, o.pos - s);
    return new _e(u, i.depth - a, o.depth - a);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(t, n, r) {
    return Dqe(this.resolve(t), this.resolve(n), r);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(t) {
    for (let n = this; ; ) {
      let { index: r, offset: i } = n.content.findIndex(t);
      if (n = n.maybeChild(r), !n)
        return null;
      if (i == t || n.isText)
        return n;
      t -= i + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(t) {
    let { index: n, offset: r } = this.content.findIndex(t);
    return { node: this.content.maybeChild(n), index: n, offset: r };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(t) {
    if (t == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: n, offset: r } = this.content.findIndex(t);
    if (r < t)
      return { node: this.content.child(n), index: n, offset: r };
    let i = this.content.child(n - 1);
    return { node: i, index: n - 1, offset: r - i.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(t) {
    return qh.resolveCached(this, t);
  }
  /**
  @internal
  */
  resolveNoCache(t) {
    return qh.resolve(this, t);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(t, n, r) {
    let i = !1;
    return n > t && this.nodesBetween(t, n, (o) => (r.isInSet(o.marks) && (i = !0), !i)), i;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let t = this.type.name;
    return this.content.size && (t += "(" + this.content.toStringInner() + ")"), SQ(this.marks, t);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(t) {
    let n = this.type.contentMatch.matchFragment(this.content, 0, t);
    if (!n)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return n;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(t, n, r = he.empty, i = 0, o = r.childCount) {
    let a = this.contentMatchAt(t).matchFragment(r, i, o), s = a && a.matchFragment(this.content, n);
    if (!s || !s.validEnd)
      return !1;
    for (let l = i; l < o; l++)
      if (!this.type.allowsMarks(r.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(t, n, r, i) {
    if (i && !this.type.allowsMarks(i))
      return !1;
    let o = this.contentMatchAt(t).matchType(r), a = o && o.matchFragment(this.content, n);
    return a ? a.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(t) {
    return t.content.size ? this.canReplace(this.childCount, this.childCount, t.content) : this.type.compatibleContent(t.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let t = Ot.none;
    for (let n = 0; n < this.marks.length; n++) {
      let r = this.marks[n];
      r.type.checkAttrs(r.attrs), t = r.addToSet(t);
    }
    if (!Ot.sameSet(t, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((n) => n.type.name)}`);
    this.content.forEach((n) => n.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let t = { type: this.type.name };
    for (let n in this.attrs) {
      t.attrs = this.attrs;
      break;
    }
    return this.content.size && (t.content = this.content.toJSON()), this.marks.length && (t.marks = this.marks.map((n) => n.toJSON())), t;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r;
    if (n.marks) {
      if (!Array.isArray(n.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = n.marks.map(t.markFromJSON);
    }
    if (n.type == "text") {
      if (typeof n.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return t.text(n.text, r);
    }
    let i = he.fromJSON(t, n.content), o = t.nodeType(n.type).create(n.attrs, i, r);
    return o.type.checkAttrs(o.attrs), o;
  }
};
Vl.prototype.text = void 0;
class bg extends Vl {
  /**
  @internal
  */
  constructor(t, n, r, i) {
    if (super(t, n, null, i), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : SQ(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(t, n) {
    return this.text.slice(t, n);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(t) {
    return t == this.marks ? this : new bg(this.type, this.attrs, this.text, t);
  }
  withText(t) {
    return t == this.text ? this : new bg(this.type, this.attrs, t, this.marks);
  }
  cut(t = 0, n = this.text.length) {
    return t == 0 && n == this.text.length ? this : this.withText(this.text.slice(t, n));
  }
  eq(t) {
    return this.sameMarkup(t) && this.text == t.text;
  }
  toJSON() {
    let t = super.toJSON();
    return t.text = this.text, t;
  }
}
function SQ(e, t) {
  for (let n = e.length - 1; n >= 0; n--)
    t = e[n].type.name + "(" + t + ")";
  return t;
}
class ru {
  /**
  @internal
  */
  constructor(t) {
    this.validEnd = t, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(t, n) {
    let r = new Bqe(t, n);
    if (r.next == null)
      return ru.empty;
    let i = _Q(r);
    r.next && r.err("Unexpected trailing text");
    let o = Uqe(Hqe(i));
    return Gqe(o, r), o;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(t) {
    for (let n = 0; n < this.next.length; n++)
      if (this.next[n].type == t)
        return this.next[n].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(t, n = 0, r = t.childCount) {
    let i = this;
    for (let o = n; i && o < r; o++)
      i = i.matchType(t.child(o).type);
    return i;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let t = 0; t < this.next.length; t++) {
      let { type: n } = this.next[t];
      if (!(n.isText || n.hasRequiredAttrs()))
        return n;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(t) {
    for (let n = 0; n < this.next.length; n++)
      for (let r = 0; r < t.next.length; r++)
        if (this.next[n].type == t.next[r].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(t, n = !1, r = 0) {
    let i = [this];
    function o(a, s) {
      let l = a.matchFragment(t, r);
      if (l && (!n || l.validEnd))
        return he.from(s.map((u) => u.createAndFill()));
      for (let u = 0; u < a.next.length; u++) {
        let { type: c, next: f } = a.next[u];
        if (!(c.isText || c.hasRequiredAttrs()) && i.indexOf(f) == -1) {
          i.push(f);
          let h = o(f, s.concat(c));
          if (h)
            return h;
        }
      }
      return null;
    }
    return o(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(t) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == t)
        return this.wrapCache[r + 1];
    let n = this.computeWrapping(t);
    return this.wrapCache.push(t, n), n;
  }
  /**
  @internal
  */
  computeWrapping(t) {
    let n = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let i = r.shift(), o = i.match;
      if (o.matchType(t)) {
        let a = [];
        for (let s = i; s.type; s = s.via)
          a.push(s.type);
        return a.reverse();
      }
      for (let a = 0; a < o.next.length; a++) {
        let { type: s, next: l } = o.next[a];
        !s.isLeaf && !s.hasRequiredAttrs() && !(s.name in n) && (!i.type || l.validEnd) && (r.push({ match: s.contentMatch, type: s, via: i }), n[s.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(t) {
    if (t >= this.next.length)
      throw new RangeError(`There's no ${t}th edge in this content match`);
    return this.next[t];
  }
  /**
  @internal
  */
  toString() {
    let t = [];
    function n(r) {
      t.push(r);
      for (let i = 0; i < r.next.length; i++)
        t.indexOf(r.next[i].next) == -1 && n(r.next[i].next);
    }
    return n(this), t.map((r, i) => {
      let o = i + (r.validEnd ? "*" : " ") + " ";
      for (let a = 0; a < r.next.length; a++)
        o += (a ? ", " : "") + r.next[a].type.name + "->" + t.indexOf(r.next[a].next);
      return o;
    }).join(`
`);
  }
}
ru.empty = new ru(!0);
class Bqe {
  constructor(t, n) {
    this.string = t, this.nodeTypes = n, this.inline = null, this.pos = 0, this.tokens = t.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(t) {
    return this.next == t && (this.pos++ || !0);
  }
  err(t) {
    throw new SyntaxError(t + " (in content expression '" + this.string + "')");
  }
}
function _Q(e) {
  let t = [];
  do
    t.push(jqe(e));
  while (e.eat("|"));
  return t.length == 1 ? t[0] : { type: "choice", exprs: t };
}
function jqe(e) {
  let t = [];
  do
    t.push(Vqe(e));
  while (e.next && e.next != ")" && e.next != "|");
  return t.length == 1 ? t[0] : { type: "seq", exprs: t };
}
function Vqe(e) {
  let t = Wqe(e);
  for (; ; )
    if (e.eat("+"))
      t = { type: "plus", expr: t };
    else if (e.eat("*"))
      t = { type: "star", expr: t };
    else if (e.eat("?"))
      t = { type: "opt", expr: t };
    else if (e.eat("{"))
      t = qqe(e, t);
    else
      break;
  return t;
}
function hL(e) {
  /\D/.test(e.next) && e.err("Expected number, got '" + e.next + "'");
  let t = Number(e.next);
  return e.pos++, t;
}
function qqe(e, t) {
  let n = hL(e), r = n;
  return e.eat(",") && (e.next != "}" ? r = hL(e) : r = -1), e.eat("}") || e.err("Unclosed braced range"), { type: "range", min: n, max: r, expr: t };
}
function zqe(e, t) {
  let n = e.nodeTypes, r = n[t];
  if (r)
    return [r];
  let i = [];
  for (let o in n) {
    let a = n[o];
    a.isInGroup(t) && i.push(a);
  }
  return i.length == 0 && e.err("No node type or group '" + t + "' found"), i;
}
function Wqe(e) {
  if (e.eat("(")) {
    let t = _Q(e);
    return e.eat(")") || e.err("Missing closing paren"), t;
  } else if (/\W/.test(e.next))
    e.err("Unexpected token '" + e.next + "'");
  else {
    let t = zqe(e, e.next).map((n) => (e.inline == null ? e.inline = n.isInline : e.inline != n.isInline && e.err("Mixing inline and block content"), { type: "name", value: n }));
    return e.pos++, t.length == 1 ? t[0] : { type: "choice", exprs: t };
  }
}
function Hqe(e) {
  let t = [[]];
  return i(o(e, 0), n()), t;
  function n() {
    return t.push([]) - 1;
  }
  function r(a, s, l) {
    let u = { term: l, to: s };
    return t[a].push(u), u;
  }
  function i(a, s) {
    a.forEach((l) => l.to = s);
  }
  function o(a, s) {
    if (a.type == "choice")
      return a.exprs.reduce((l, u) => l.concat(o(u, s)), []);
    if (a.type == "seq")
      for (let l = 0; ; l++) {
        let u = o(a.exprs[l], s);
        if (l == a.exprs.length - 1)
          return u;
        i(u, s = n());
      }
    else if (a.type == "star") {
      let l = n();
      return r(s, l), i(o(a.expr, l), l), [r(l)];
    } else if (a.type == "plus") {
      let l = n();
      return i(o(a.expr, s), l), i(o(a.expr, l), l), [r(l)];
    } else {
      if (a.type == "opt")
        return [r(s)].concat(o(a.expr, s));
      if (a.type == "range") {
        let l = s;
        for (let u = 0; u < a.min; u++) {
          let c = n();
          i(o(a.expr, l), c), l = c;
        }
        if (a.max == -1)
          i(o(a.expr, l), l);
        else
          for (let u = a.min; u < a.max; u++) {
            let c = n();
            r(l, c), i(o(a.expr, l), c), l = c;
          }
        return [r(l)];
      } else {
        if (a.type == "name")
          return [r(s, void 0, a.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function EQ(e, t) {
  return t - e;
}
function pL(e, t) {
  let n = [];
  return r(t), n.sort(EQ);
  function r(i) {
    let o = e[i];
    if (o.length == 1 && !o[0].term)
      return r(o[0].to);
    n.push(i);
    for (let a = 0; a < o.length; a++) {
      let { term: s, to: l } = o[a];
      !s && n.indexOf(l) == -1 && r(l);
    }
  }
}
function Uqe(e) {
  let t = /* @__PURE__ */ Object.create(null);
  return n(pL(e, 0));
  function n(r) {
    let i = [];
    r.forEach((a) => {
      e[a].forEach(({ term: s, to: l }) => {
        if (!s)
          return;
        let u;
        for (let c = 0; c < i.length; c++)
          i[c][0] == s && (u = i[c][1]);
        pL(e, l).forEach((c) => {
          u || i.push([s, u = []]), u.indexOf(c) == -1 && u.push(c);
        });
      });
    });
    let o = t[r.join(",")] = new ru(r.indexOf(e.length - 1) > -1);
    for (let a = 0; a < i.length; a++) {
      let s = i[a][1].sort(EQ);
      o.next.push({ type: i[a][0], next: t[s.join(",")] || n(s) });
    }
    return o;
  }
}
function Gqe(e, t) {
  for (let n = 0, r = [e]; n < r.length; n++) {
    let i = r[n], o = !i.validEnd, a = [];
    for (let s = 0; s < i.next.length; s++) {
      let { type: l, next: u } = i.next[s];
      a.push(l.name), o && !(l.isText || l.hasRequiredAttrs()) && (o = !1), r.indexOf(u) == -1 && r.push(u);
    }
    o && t.err("Only non-generatable nodes (" + a.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function NQ(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n in e) {
    let r = e[n];
    if (!r.hasDefault)
      return null;
    t[n] = r.default;
  }
  return t;
}
function AQ(e, t) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let r in e) {
    let i = t && t[r];
    if (i === void 0) {
      let o = e[r];
      if (o.hasDefault)
        i = o.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    n[r] = i;
  }
  return n;
}
function OQ(e, t, n, r) {
  for (let i in t)
    if (!(i in e))
      throw new RangeError(`Unsupported attribute ${i} for ${n} of type ${i}`);
  for (let i in e) {
    let o = e[i];
    o.validate && o.validate(t[i]);
  }
}
function kQ(e, t) {
  let n = /* @__PURE__ */ Object.create(null);
  if (t)
    for (let r in t)
      n[r] = new Yqe(e, r, t[r]);
  return n;
}
let mL = class PQ {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.name = t, this.schema = n, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = kQ(t, r.attrs), this.defaultAttrs = NQ(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || t == "text"), this.isText = t == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == ru.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(t) {
    return this.groups.indexOf(t) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let t in this.attrs)
      if (this.attrs[t].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(t) {
    return this == t || this.contentMatch.compatible(t.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(t) {
    return !t && this.defaultAttrs ? this.defaultAttrs : AQ(this.attrs, t);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(t = null, n, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new Vl(this, this.computeAttrs(t), he.from(n), Ot.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(t = null, n, r) {
    return n = he.from(n), this.checkContent(n), new Vl(this, this.computeAttrs(t), n, Ot.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(t = null, n, r) {
    if (t = this.computeAttrs(t), n = he.from(n), n.size) {
      let a = this.contentMatch.fillBefore(n);
      if (!a)
        return null;
      n = a.append(n);
    }
    let i = this.contentMatch.matchFragment(n), o = i && i.fillBefore(he.empty, !0);
    return o ? new Vl(this, t, n.append(o), Ot.setFrom(r)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(t) {
    let n = this.contentMatch.matchFragment(t);
    if (!n || !n.validEnd)
      return !1;
    for (let r = 0; r < t.childCount; r++)
      if (!this.allowsMarks(t.child(r).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(t) {
    if (!this.validContent(t))
      throw new RangeError(`Invalid content for node ${this.name}: ${t.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(t) {
    OQ(this.attrs, t, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(t) {
    return this.markSet == null || this.markSet.indexOf(t) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(t) {
    if (this.markSet == null)
      return !0;
    for (let n = 0; n < t.length; n++)
      if (!this.allowsMarkType(t[n].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(t) {
    if (this.markSet == null)
      return t;
    let n;
    for (let r = 0; r < t.length; r++)
      this.allowsMarkType(t[r].type) ? n && n.push(t[r]) : n || (n = t.slice(0, r));
    return n ? n.length ? n : Ot.none : t;
  }
  /**
  @internal
  */
  static compile(t, n) {
    let r = /* @__PURE__ */ Object.create(null);
    t.forEach((o, a) => r[o] = new PQ(o, n, a));
    let i = n.spec.topNode || "doc";
    if (!r[i])
      throw new RangeError("Schema is missing its top node type ('" + i + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let o in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
};
function Kqe(e, t, n) {
  let r = n.split("|");
  return (i) => {
    let o = i === null ? "null" : typeof i;
    if (r.indexOf(o) < 0)
      throw new RangeError(`Expected value of type ${r} for attribute ${t} on type ${e}, got ${o}`);
  };
}
class Yqe {
  constructor(t, n, r) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(r, "default"), this.default = r.default, this.validate = typeof r.validate == "string" ? Kqe(t, n, r.validate) : r.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Rv {
  /**
  @internal
  */
  constructor(t, n, r, i) {
    this.name = t, this.rank = n, this.schema = r, this.spec = i, this.attrs = kQ(t, i.attrs), this.excluded = null;
    let o = NQ(this.attrs);
    this.instance = o ? new Ot(this, o) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(t = null) {
    return !t && this.instance ? this.instance : new Ot(this, AQ(this.attrs, t));
  }
  /**
  @internal
  */
  static compile(t, n) {
    let r = /* @__PURE__ */ Object.create(null), i = 0;
    return t.forEach((o, a) => r[o] = new Rv(o, i++, n, a)), r;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(t) {
    for (var n = 0; n < t.length; n++)
      t[n].type == this && (t = t.slice(0, n).concat(t.slice(n + 1)), n--);
    return t;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(t) {
    for (let n = 0; n < t.length; n++)
      if (t[n].type == this)
        return t[n];
  }
  /**
  @internal
  */
  checkAttrs(t) {
    OQ(this.attrs, t, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(t) {
    return this.excluded.indexOf(t) > -1;
  }
}
class T_ {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(t) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let n = this.spec = {};
    for (let i in t)
      n[i] = t[i];
    n.nodes = Qn.from(t.nodes), n.marks = Qn.from(t.marks || {}), this.nodes = mL.compile(this.spec.nodes, this), this.marks = Rv.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let i in this.nodes) {
      if (i in this.marks)
        throw new RangeError(i + " can not be both a node and a mark");
      let o = this.nodes[i], a = o.spec.content || "", s = o.spec.marks;
      if (o.contentMatch = r[a] || (r[a] = ru.parse(a, this.nodes)), o.inlineContent = o.contentMatch.inlineContent, o.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!o.isInline || !o.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = o;
      }
      o.markSet = s == "_" ? null : s ? gL(this, s.split(" ")) : s == "" || !o.inlineContent ? [] : null;
    }
    for (let i in this.marks) {
      let o = this.marks[i], a = o.spec.excludes;
      o.excluded = a == null ? [o] : a == "" ? [] : gL(this, a.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(t, n = null, r, i) {
    if (typeof t == "string")
      t = this.nodeType(t);
    else if (t instanceof mL) {
      if (t.schema != this)
        throw new RangeError("Node type from different schema used (" + t.name + ")");
    } else throw new RangeError("Invalid node type: " + t);
    return t.createChecked(n, r, i);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(t, n) {
    let r = this.nodes.text;
    return new bg(r, r.defaultAttrs, t, Ot.setFrom(n));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(t, n) {
    return typeof t == "string" && (t = this.marks[t]), t.create(n);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(t) {
    return Vl.fromJSON(this, t);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(t) {
    return Ot.fromJSON(this, t);
  }
  /**
  @internal
  */
  nodeType(t) {
    let n = this.nodes[t];
    if (!n)
      throw new RangeError("Unknown node type: " + t);
    return n;
  }
}
function gL(e, t) {
  let n = [];
  for (let r = 0; r < t.length; r++) {
    let i = t[r], o = e.marks[i], a = o;
    if (o)
      n.push(o);
    else
      for (let s in e.marks) {
        let l = e.marks[s];
        (i == "_" || l.spec.group && l.spec.group.split(" ").indexOf(i) > -1) && n.push(a = l);
      }
    if (!a)
      throw new SyntaxError("Unknown mark type: '" + t[r] + "'");
  }
  return n;
}
function Zqe(e) {
  return e.tag != null;
}
function Xqe(e) {
  return e.style != null;
}
class Da {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(t, n) {
    this.schema = t, this.rules = n, this.tags = [], this.styles = [];
    let r = this.matchedStyles = [];
    n.forEach((i) => {
      if (Zqe(i))
        this.tags.push(i);
      else if (Xqe(i)) {
        let o = /[^=]*/.exec(i.style)[0];
        r.indexOf(o) < 0 && r.push(o), this.styles.push(i);
      }
    }), this.normalizeLists = !this.tags.some((i) => {
      if (!/^(ul|ol)\b/.test(i.tag) || !i.node)
        return !1;
      let o = t.nodes[i.node];
      return o.contentMatch.matchType(o);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(t, n = {}) {
    let r = new yL(this, n, !1);
    return r.addAll(t, Ot.none, n.from, n.to), r.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(t, n = {}) {
    let r = new yL(this, n, !0);
    return r.addAll(t, Ot.none, n.from, n.to), _e.maxOpen(r.finish());
  }
  /**
  @internal
  */
  matchTag(t, n, r) {
    for (let i = r ? this.tags.indexOf(r) + 1 : 0; i < this.tags.length; i++) {
      let o = this.tags[i];
      if (eze(t, o.tag) && (o.namespace === void 0 || t.namespaceURI == o.namespace) && (!o.context || n.matchesContext(o.context))) {
        if (o.getAttrs) {
          let a = o.getAttrs(t);
          if (a === !1)
            continue;
          o.attrs = a || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(t, n, r, i) {
    for (let o = i ? this.styles.indexOf(i) + 1 : 0; o < this.styles.length; o++) {
      let a = this.styles[o], s = a.style;
      if (!(s.indexOf(t) != 0 || a.context && !r.matchesContext(a.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      s.length > t.length && (s.charCodeAt(t.length) != 61 || s.slice(t.length + 1) != n))) {
        if (a.getAttrs) {
          let l = a.getAttrs(n);
          if (l === !1)
            continue;
          a.attrs = l || void 0;
        }
        return a;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(t) {
    let n = [];
    function r(i) {
      let o = i.priority == null ? 50 : i.priority, a = 0;
      for (; a < n.length; a++) {
        let s = n[a];
        if ((s.priority == null ? 50 : s.priority) < o)
          break;
      }
      n.splice(a, 0, i);
    }
    for (let i in t.marks) {
      let o = t.marks[i].spec.parseDOM;
      o && o.forEach((a) => {
        r(a = bL(a)), a.mark || a.ignore || a.clearMark || (a.mark = i);
      });
    }
    for (let i in t.nodes) {
      let o = t.nodes[i].spec.parseDOM;
      o && o.forEach((a) => {
        r(a = bL(a)), a.node || a.ignore || a.mark || (a.node = i);
      });
    }
    return n;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(t) {
    return t.cached.domParser || (t.cached.domParser = new Da(t, Da.schemaRules(t)));
  }
}
const TQ = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, Jqe = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, MQ = { ol: !0, ul: !0 }, xg = 1, wg = 2, U1 = 4;
function vL(e, t, n) {
  return t != null ? (t ? xg : 0) | (t === "full" ? wg : 0) : e && e.whitespace == "pre" ? xg | wg : n & -5;
}
class A1 {
  constructor(t, n, r, i, o, a) {
    this.type = t, this.attrs = n, this.marks = r, this.solid = i, this.options = a, this.content = [], this.activeMarks = Ot.none, this.match = o || (a & U1 ? null : t.contentMatch);
  }
  findWrapping(t) {
    if (!this.match) {
      if (!this.type)
        return [];
      let n = this.type.contentMatch.fillBefore(he.from(t));
      if (n)
        this.match = this.type.contentMatch.matchFragment(n);
      else {
        let r = this.type.contentMatch, i;
        return (i = r.findWrapping(t.type)) ? (this.match = r, i) : null;
      }
    }
    return this.match.findWrapping(t.type);
  }
  finish(t) {
    if (!(this.options & xg)) {
      let r = this.content[this.content.length - 1], i;
      if (r && r.isText && (i = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let o = r;
        r.text.length == i[0].length ? this.content.pop() : this.content[this.content.length - 1] = o.withText(o.text.slice(0, o.text.length - i[0].length));
      }
    }
    let n = he.from(this.content);
    return !t && this.match && (n = n.append(this.match.fillBefore(he.empty, !0))), this.type ? this.type.create(this.attrs, n, this.marks) : n;
  }
  inlineContext(t) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : t.parentNode && !TQ.hasOwnProperty(t.parentNode.nodeName.toLowerCase());
  }
}
class yL {
  constructor(t, n, r) {
    this.parser = t, this.options = n, this.isOpen = r, this.open = 0;
    let i = n.topNode, o, a = vL(null, n.preserveWhitespace, 0) | (r ? U1 : 0);
    i ? o = new A1(i.type, i.attrs, Ot.none, !0, n.topMatch || i.type.contentMatch, a) : r ? o = new A1(null, null, Ot.none, !0, null, a) : o = new A1(t.schema.topNodeType, null, Ot.none, !0, null, a), this.nodes = [o], this.find = n.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(t, n) {
    t.nodeType == 3 ? this.addTextNode(t, n) : t.nodeType == 1 && this.addElement(t, n);
  }
  addTextNode(t, n) {
    let r = t.nodeValue, i = this.top;
    if (i.options & wg || i.inlineContext(t) || /[^ \t\r\n\u000c]/.test(r)) {
      if (i.options & xg)
        i.options & wg ? r = r.replace(/\r\n?/g, `
`) : r = r.replace(/\r?\n|\r/g, " ");
      else if (r = r.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(r) && this.open == this.nodes.length - 1) {
        let o = i.content[i.content.length - 1], a = t.previousSibling;
        (!o || a && a.nodeName == "BR" || o.isText && /[ \t\r\n\u000c]$/.test(o.text)) && (r = r.slice(1));
      }
      r && this.insertNode(this.parser.schema.text(r), n), this.findInText(t);
    } else
      this.findInside(t);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(t, n, r) {
    let i = t.nodeName.toLowerCase(), o;
    MQ.hasOwnProperty(i) && this.parser.normalizeLists && Qqe(t);
    let a = this.options.ruleFromNode && this.options.ruleFromNode(t) || (o = this.parser.matchTag(t, this, r));
    if (a ? a.ignore : Jqe.hasOwnProperty(i))
      this.findInside(t), this.ignoreFallback(t, n);
    else if (!a || a.skip || a.closeParent) {
      a && a.closeParent ? this.open = Math.max(0, this.open - 1) : a && a.skip.nodeType && (t = a.skip);
      let s, l = this.top, u = this.needsBlock;
      if (TQ.hasOwnProperty(i))
        l.content.length && l.content[0].isInline && this.open && (this.open--, l = this.top), s = !0, l.type || (this.needsBlock = !0);
      else if (!t.firstChild) {
        this.leafFallback(t, n);
        return;
      }
      let c = a && a.skip ? n : this.readStyles(t, n);
      c && this.addAll(t, c), s && this.sync(l), this.needsBlock = u;
    } else {
      let s = this.readStyles(t, n);
      s && this.addElementByRule(t, a, s, a.consuming === !1 ? o : void 0);
    }
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(t, n) {
    t.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(t.ownerDocument.createTextNode(`
`), n);
  }
  // Called for ignored nodes
  ignoreFallback(t, n) {
    t.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), n);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(t, n) {
    let r = t.style;
    if (r && r.length)
      for (let i = 0; i < this.parser.matchedStyles.length; i++) {
        let o = this.parser.matchedStyles[i], a = r.getPropertyValue(o);
        if (a)
          for (let s = void 0; ; ) {
            let l = this.parser.matchStyle(o, a, this, s);
            if (!l)
              break;
            if (l.ignore)
              return null;
            if (l.clearMark ? n = n.filter((u) => !l.clearMark(u)) : n = n.concat(this.parser.schema.marks[l.mark].create(l.attrs)), l.consuming === !1)
              s = l;
            else
              break;
          }
      }
    return n;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(t, n, r, i) {
    let o, a;
    if (n.node)
      if (a = this.parser.schema.nodes[n.node], a.isLeaf)
        this.insertNode(a.create(n.attrs), r) || this.leafFallback(t, r);
      else {
        let l = this.enter(a, n.attrs || null, r, n.preserveWhitespace);
        l && (o = !0, r = l);
      }
    else {
      let l = this.parser.schema.marks[n.mark];
      r = r.concat(l.create(n.attrs));
    }
    let s = this.top;
    if (a && a.isLeaf)
      this.findInside(t);
    else if (i)
      this.addElement(t, r, i);
    else if (n.getContent)
      this.findInside(t), n.getContent(t, this.parser.schema).forEach((l) => this.insertNode(l, r));
    else {
      let l = t;
      typeof n.contentElement == "string" ? l = t.querySelector(n.contentElement) : typeof n.contentElement == "function" ? l = n.contentElement(t) : n.contentElement && (l = n.contentElement), this.findAround(t, l, !0), this.addAll(l, r), this.findAround(t, l, !1);
    }
    o && this.sync(s) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(t, n, r, i) {
    let o = r || 0;
    for (let a = r ? t.childNodes[r] : t.firstChild, s = i == null ? null : t.childNodes[i]; a != s; a = a.nextSibling, ++o)
      this.findAtPoint(t, o), this.addDOM(a, n);
    this.findAtPoint(t, o);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(t, n) {
    let r, i;
    for (let o = this.open; o >= 0; o--) {
      let a = this.nodes[o], s = a.findWrapping(t);
      if (s && (!r || r.length > s.length) && (r = s, i = a, !s.length) || a.solid)
        break;
    }
    if (!r)
      return null;
    this.sync(i);
    for (let o = 0; o < r.length; o++)
      n = this.enterInner(r[o], null, n, !1);
    return n;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(t, n) {
    if (t.isInline && this.needsBlock && !this.top.type) {
      let i = this.textblockFromContext();
      i && (n = this.enterInner(i, null, n));
    }
    let r = this.findPlace(t, n);
    if (r) {
      this.closeExtra();
      let i = this.top;
      i.match && (i.match = i.match.matchType(t.type));
      let o = Ot.none;
      for (let a of r.concat(t.marks))
        (i.type ? i.type.allowsMarkType(a.type) : xL(a.type, t.type)) && (o = a.addToSet(o));
      return i.content.push(t.mark(o)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(t, n, r, i) {
    let o = this.findPlace(t.create(n), r);
    return o && (o = this.enterInner(t, n, r, !0, i)), o;
  }
  // Open a node of the given type
  enterInner(t, n, r, i = !1, o) {
    this.closeExtra();
    let a = this.top;
    a.match = a.match && a.match.matchType(t);
    let s = vL(t, o, a.options);
    a.options & U1 && a.content.length == 0 && (s |= U1);
    let l = Ot.none;
    return r = r.filter((u) => (a.type ? a.type.allowsMarkType(u.type) : xL(u.type, t)) ? (l = u.addToSet(l), !1) : !0), this.nodes.push(new A1(t, n, l, i, null, s)), this.open++, r;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(t = !1) {
    let n = this.nodes.length - 1;
    if (n > this.open) {
      for (; n > this.open; n--)
        this.nodes[n - 1].content.push(this.nodes[n].finish(t));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(this.isOpen || this.options.topOpen);
  }
  sync(t) {
    for (let n = this.open; n >= 0; n--)
      if (this.nodes[n] == t)
        return this.open = n, !0;
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let t = 0;
    for (let n = this.open; n >= 0; n--) {
      let r = this.nodes[n].content;
      for (let i = r.length - 1; i >= 0; i--)
        t += r[i].nodeSize;
      n && t++;
    }
    return t;
  }
  findAtPoint(t, n) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == t && this.find[r].offset == n && (this.find[r].pos = this.currentPos);
  }
  findInside(t) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].pos == null && t.nodeType == 1 && t.contains(this.find[n].node) && (this.find[n].pos = this.currentPos);
  }
  findAround(t, n, r) {
    if (t != n && this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].pos == null && t.nodeType == 1 && t.contains(this.find[i].node) && n.compareDocumentPosition(this.find[i].node) & (r ? 2 : 4) && (this.find[i].pos = this.currentPos);
  }
  findInText(t) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == t && (this.find[n].pos = this.currentPos - (t.nodeValue.length - this.find[n].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(t) {
    if (t.indexOf("|") > -1)
      return t.split(/\s*\|\s*/).some(this.matchesContext, this);
    let n = t.split("/"), r = this.options.context, i = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), o = -(r ? r.depth + 1 : 0) + (i ? 0 : 1), a = (s, l) => {
      for (; s >= 0; s--) {
        let u = n[s];
        if (u == "") {
          if (s == n.length - 1 || s == 0)
            continue;
          for (; l >= o; l--)
            if (a(s - 1, l))
              return !0;
          return !1;
        } else {
          let c = l > 0 || l == 0 && i ? this.nodes[l].type : r && l >= o ? r.node(l - o).type : null;
          if (!c || c.name != u && !c.isInGroup(u))
            return !1;
          l--;
        }
      }
      return !0;
    };
    return a(n.length - 1, this.open);
  }
  textblockFromContext() {
    let t = this.options.context;
    if (t)
      for (let n = t.depth; n >= 0; n--) {
        let r = t.node(n).contentMatchAt(t.indexAfter(n)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let n in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[n];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
}
function Qqe(e) {
  for (let t = e.firstChild, n = null; t; t = t.nextSibling) {
    let r = t.nodeType == 1 ? t.nodeName.toLowerCase() : null;
    r && MQ.hasOwnProperty(r) && n ? (n.appendChild(t), t = n) : r == "li" ? n = t : r && (n = null);
  }
}
function eze(e, t) {
  return (e.matches || e.msMatchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector).call(e, t);
}
function bL(e) {
  let t = {};
  for (let n in e)
    t[n] = e[n];
  return t;
}
function xL(e, t) {
  let n = t.schema.nodes;
  for (let r in n) {
    let i = n[r];
    if (!i.allowsMarkType(e))
      continue;
    let o = [], a = (s) => {
      o.push(s);
      for (let l = 0; l < s.edgeCount; l++) {
        let { type: u, next: c } = s.edge(l);
        if (u == t || o.indexOf(c) < 0 && a(c))
          return !0;
      }
    };
    if (a(i.contentMatch))
      return !0;
  }
}
class vu {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(t, n) {
    this.nodes = t, this.marks = n;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(t, n = {}, r) {
    r || (r = O8(n).createDocumentFragment());
    let i = r, o = [];
    return t.forEach((a) => {
      if (o.length || a.marks.length) {
        let s = 0, l = 0;
        for (; s < o.length && l < a.marks.length; ) {
          let u = a.marks[l];
          if (!this.marks[u.type.name]) {
            l++;
            continue;
          }
          if (!u.eq(o[s][0]) || u.type.spec.spanning === !1)
            break;
          s++, l++;
        }
        for (; s < o.length; )
          i = o.pop()[1];
        for (; l < a.marks.length; ) {
          let u = a.marks[l++], c = this.serializeMark(u, a.isInline, n);
          c && (o.push([u, i]), i.appendChild(c.dom), i = c.contentDOM || c.dom);
        }
      }
      i.appendChild(this.serializeNodeInner(a, n));
    }), r;
  }
  /**
  @internal
  */
  serializeNodeInner(t, n) {
    let { dom: r, contentDOM: i } = G1(O8(n), this.nodes[t.type.name](t), null, t.attrs);
    if (i) {
      if (t.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(t.content, n, i);
    }
    return r;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(t, n = {}) {
    let r = this.serializeNodeInner(t, n);
    for (let i = t.marks.length - 1; i >= 0; i--) {
      let o = this.serializeMark(t.marks[i], t.isInline, n);
      o && ((o.contentDOM || o.dom).appendChild(r), r = o.dom);
    }
    return r;
  }
  /**
  @internal
  */
  serializeMark(t, n, r = {}) {
    let i = this.marks[t.type.name];
    return i && G1(O8(r), i(t, n), null, t.attrs);
  }
  static renderSpec(t, n, r = null, i) {
    return G1(t, n, r, i);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(t) {
    return t.cached.domSerializer || (t.cached.domSerializer = new vu(this.nodesFromSchema(t), this.marksFromSchema(t)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(t) {
    let n = wL(t.nodes);
    return n.text || (n.text = (r) => r.text), n;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(t) {
    return wL(t.marks);
  }
}
function wL(e) {
  let t = {};
  for (let n in e) {
    let r = e[n].spec.toDOM;
    r && (t[n] = r);
  }
  return t;
}
function O8(e) {
  return e.document || window.document;
}
const CL = /* @__PURE__ */ new WeakMap();
function tze(e) {
  let t = CL.get(e);
  return t === void 0 && CL.set(e, t = nze(e)), t;
}
function nze(e) {
  let t = null;
  function n(r) {
    if (r && typeof r == "object")
      if (Array.isArray(r))
        if (typeof r[0] == "string")
          t || (t = []), t.push(r);
        else
          for (let i = 0; i < r.length; i++)
            n(r[i]);
      else
        for (let i in r)
          n(r[i]);
  }
  return n(e), t;
}
function G1(e, t, n, r) {
  if (typeof t == "string")
    return { dom: e.createTextNode(t) };
  if (t.nodeType != null)
    return { dom: t };
  if (t.dom && t.dom.nodeType != null)
    return t;
  let i = t[0], o;
  if (typeof i != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (r && (o = tze(r)) && o.indexOf(t) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let a = i.indexOf(" ");
  a > 0 && (n = i.slice(0, a), i = i.slice(a + 1));
  let s, l = n ? e.createElementNS(n, i) : e.createElement(i), u = t[1], c = 1;
  if (u && typeof u == "object" && u.nodeType == null && !Array.isArray(u)) {
    c = 2;
    for (let f in u)
      if (u[f] != null) {
        let h = f.indexOf(" ");
        h > 0 ? l.setAttributeNS(f.slice(0, h), f.slice(h + 1), u[f]) : l.setAttribute(f, u[f]);
      }
  }
  for (let f = c; f < t.length; f++) {
    let h = t[f];
    if (h === 0) {
      if (f < t.length - 1 || f > c)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: l, contentDOM: l };
    } else {
      let { dom: m, contentDOM: v } = G1(e, h, n, r);
      if (l.appendChild(m), v) {
        if (s)
          throw new RangeError("Multiple content holes");
        s = v;
      }
    }
  }
  return { dom: l, contentDOM: s };
}
const RQ = 65535, DQ = Math.pow(2, 16);
function rze(e, t) {
  return e + t * DQ;
}
function SL(e) {
  return e & RQ;
}
function ize(e) {
  return (e - (e & RQ)) / DQ;
}
const IQ = 1, $Q = 2, K1 = 4, LQ = 8;
class Y9 {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.pos = t, this.delInfo = n, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & LQ) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (IQ | K1)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & ($Q | K1)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & K1) > 0;
  }
}
class di {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(t, n = !1) {
    if (this.ranges = t, this.inverted = n, !t.length && di.empty)
      return di.empty;
  }
  /**
  @internal
  */
  recover(t) {
    let n = 0, r = SL(t);
    if (!this.inverted)
      for (let i = 0; i < r; i++)
        n += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
    return this.ranges[r * 3] + n + ize(t);
  }
  mapResult(t, n = 1) {
    return this._map(t, n, !1);
  }
  map(t, n = 1) {
    return this._map(t, n, !0);
  }
  /**
  @internal
  */
  _map(t, n, r) {
    let i = 0, o = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? i : 0);
      if (l > t)
        break;
      let u = this.ranges[s + o], c = this.ranges[s + a], f = l + u;
      if (t <= f) {
        let h = u ? t == l ? -1 : t == f ? 1 : n : n, m = l + i + (h < 0 ? 0 : c);
        if (r)
          return m;
        let v = t == (n < 0 ? l : f) ? null : rze(s / 3, t - l), g = t == l ? $Q : t == f ? IQ : K1;
        return (n < 0 ? t != l : t != f) && (g |= LQ), new Y9(m, g, v);
      }
      i += c - u;
    }
    return r ? t + i : new Y9(t + i, 0, null);
  }
  /**
  @internal
  */
  touches(t, n) {
    let r = 0, i = SL(n), o = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? r : 0);
      if (l > t)
        break;
      let u = this.ranges[s + o], c = l + u;
      if (t <= c && s == i * 3)
        return !0;
      r += this.ranges[s + a] - u;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(t) {
    let n = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let i = 0, o = 0; i < this.ranges.length; i += 3) {
      let a = this.ranges[i], s = a - (this.inverted ? o : 0), l = a + (this.inverted ? 0 : o), u = this.ranges[i + n], c = this.ranges[i + r];
      t(s, s + u, l, l + c), o += c - u;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new di(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(t) {
    return t == 0 ? di.empty : new di(t < 0 ? [0, -t, 0] : [0, 0, t]);
  }
}
di.empty = new di([]);
class Cc {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(t = [], n, r = 0, i = t.length) {
    this.maps = t, this.mirror = n, this.from = r, this.to = i;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(t = 0, n = this.maps.length) {
    return new Cc(this.maps, this.mirror, t, n);
  }
  /**
  @internal
  */
  copy() {
    return new Cc(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(t, n) {
    this.to = this.maps.push(t), n != null && this.setMirror(this.maps.length - 1, n);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(t) {
    for (let n = 0, r = this.maps.length; n < t.maps.length; n++) {
      let i = t.getMirror(n);
      this.appendMap(t.maps[n], i != null && i < n ? r + i : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(t) {
    if (this.mirror) {
      for (let n = 0; n < this.mirror.length; n++)
        if (this.mirror[n] == t)
          return this.mirror[n + (n % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(t, n) {
    this.mirror || (this.mirror = []), this.mirror.push(t, n);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(t) {
    for (let n = t.maps.length - 1, r = this.maps.length + t.maps.length; n >= 0; n--) {
      let i = t.getMirror(n);
      this.appendMap(t.maps[n].invert(), i != null && i > n ? r - i - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let t = new Cc();
    return t.appendMappingInverted(this), t;
  }
  /**
  Map a position through this mapping.
  */
  map(t, n = 1) {
    if (this.mirror)
      return this._map(t, n, !0);
    for (let r = this.from; r < this.to; r++)
      t = this.maps[r].map(t, n);
    return t;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(t, n = 1) {
    return this._map(t, n, !1);
  }
  /**
  @internal
  */
  _map(t, n, r) {
    let i = 0;
    for (let o = this.from; o < this.to; o++) {
      let a = this.maps[o], s = a.mapResult(t, n);
      if (s.recover != null) {
        let l = this.getMirror(o);
        if (l != null && l > o && l < this.to) {
          o = l, t = this.maps[l].recover(s.recover);
          continue;
        }
      }
      i |= s.delInfo, t = s.pos;
    }
    return r ? t : new Y9(t, i, null);
  }
}
const k8 = /* @__PURE__ */ Object.create(null);
class xr {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return di.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(t) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(t, n) {
    if (!n || !n.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = k8[n.stepType];
    if (!r)
      throw new RangeError(`No step type ${n.stepType} defined`);
    return r.fromJSON(t, n);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(t, n) {
    if (t in k8)
      throw new RangeError("Duplicate use of step JSON ID " + t);
    return k8[t] = n, n.prototype.jsonID = t, n;
  }
}
class bn {
  /**
  @internal
  */
  constructor(t, n) {
    this.doc = t, this.failed = n;
  }
  /**
  Create a successful step result.
  */
  static ok(t) {
    return new bn(t, null);
  }
  /**
  Create a failed step result.
  */
  static fail(t) {
    return new bn(null, t);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(t, n, r, i) {
    try {
      return bn.ok(t.replace(n, r, i));
    } catch (o) {
      if (o instanceof gg)
        return bn.fail(o.message);
      throw o;
    }
  }
}
function M_(e, t, n) {
  let r = [];
  for (let i = 0; i < e.childCount; i++) {
    let o = e.child(i);
    o.content.size && (o = o.copy(M_(o.content, t, o))), o.isInline && (o = t(o, n, i)), r.push(o);
  }
  return he.fromArray(r);
}
class ks extends xr {
  /**
  Create a mark step.
  */
  constructor(t, n, r) {
    super(), this.from = t, this.to = n, this.mark = r;
  }
  apply(t) {
    let n = t.slice(this.from, this.to), r = t.resolve(this.from), i = r.node(r.sharedDepth(this.to)), o = new _e(M_(n.content, (a, s) => !a.isAtom || !s.type.allowsMarkType(this.mark.type) ? a : a.mark(this.mark.addToSet(a.marks)), i), n.openStart, n.openEnd);
    return bn.fromReplace(t, this.from, this.to, o);
  }
  invert() {
    return new Io(this.from, this.to, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new ks(n.pos, r.pos, this.mark);
  }
  merge(t) {
    return t instanceof ks && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new ks(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new ks(n.from, n.to, t.markFromJSON(n.mark));
  }
}
xr.jsonID("addMark", ks);
class Io extends xr {
  /**
  Create a mark-removing step.
  */
  constructor(t, n, r) {
    super(), this.from = t, this.to = n, this.mark = r;
  }
  apply(t) {
    let n = t.slice(this.from, this.to), r = new _e(M_(n.content, (i) => i.mark(this.mark.removeFromSet(i.marks)), t), n.openStart, n.openEnd);
    return bn.fromReplace(t, this.from, this.to, r);
  }
  invert() {
    return new ks(this.from, this.to, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new Io(n.pos, r.pos, this.mark);
  }
  merge(t) {
    return t instanceof Io && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new Io(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new Io(n.from, n.to, t.markFromJSON(n.mark));
  }
}
xr.jsonID("removeMark", Io);
class Ps extends xr {
  /**
  Create a node mark step.
  */
  constructor(t, n) {
    super(), this.pos = t, this.mark = n;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return bn.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.addToSet(n.marks));
    return bn.fromReplace(t, this.pos, this.pos + 1, new _e(he.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(t) {
    let n = t.nodeAt(this.pos);
    if (n) {
      let r = this.mark.addToSet(n.marks);
      if (r.length == n.marks.length) {
        for (let i = 0; i < n.marks.length; i++)
          if (!n.marks[i].isInSet(r))
            return new Ps(this.pos, n.marks[i]);
        return new Ps(this.pos, this.mark);
      }
    }
    return new ld(this.pos, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Ps(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Ps(n.pos, t.markFromJSON(n.mark));
  }
}
xr.jsonID("addNodeMark", Ps);
class ld extends xr {
  /**
  Create a mark-removing step.
  */
  constructor(t, n) {
    super(), this.pos = t, this.mark = n;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return bn.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.removeFromSet(n.marks));
    return bn.fromReplace(t, this.pos, this.pos + 1, new _e(he.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(t) {
    let n = t.nodeAt(this.pos);
    return !n || !this.mark.isInSet(n.marks) ? this : new Ps(this.pos, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new ld(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new ld(n.pos, t.markFromJSON(n.mark));
  }
}
xr.jsonID("removeNodeMark", ld);
class Vn extends xr {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(t, n, r, i = !1) {
    super(), this.from = t, this.to = n, this.slice = r, this.structure = i;
  }
  apply(t) {
    return this.structure && Z9(t, this.from, this.to) ? bn.fail("Structure replace would overwrite content") : bn.fromReplace(t, this.from, this.to, this.slice);
  }
  getMap() {
    return new di([this.from, this.to - this.from, this.slice.size]);
  }
  invert(t) {
    return new Vn(this.from, this.from + this.slice.size, t.slice(this.from, this.to));
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1);
    return n.deletedAcross && r.deletedAcross ? null : new Vn(n.pos, Math.max(n.pos, r.pos), this.slice);
  }
  merge(t) {
    if (!(t instanceof Vn) || t.structure || this.structure)
      return null;
    if (this.from + this.slice.size == t.from && !this.slice.openEnd && !t.slice.openStart) {
      let n = this.slice.size + t.slice.size == 0 ? _e.empty : new _e(this.slice.content.append(t.slice.content), this.slice.openStart, t.slice.openEnd);
      return new Vn(this.from, this.to + (t.to - t.from), n, this.structure);
    } else if (t.to == this.from && !this.slice.openStart && !t.slice.openEnd) {
      let n = this.slice.size + t.slice.size == 0 ? _e.empty : new _e(t.slice.content.append(this.slice.content), t.slice.openStart, this.slice.openEnd);
      return new Vn(t.from, this.to, n, this.structure);
    } else
      return null;
  }
  toJSON() {
    let t = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (t.slice = this.slice.toJSON()), this.structure && (t.structure = !0), t;
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new Vn(n.from, n.to, _e.fromJSON(t, n.slice), !!n.structure);
  }
}
xr.jsonID("replace", Vn);
class Wn extends xr {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(t, n, r, i, o, a, s = !1) {
    super(), this.from = t, this.to = n, this.gapFrom = r, this.gapTo = i, this.slice = o, this.insert = a, this.structure = s;
  }
  apply(t) {
    if (this.structure && (Z9(t, this.from, this.gapFrom) || Z9(t, this.gapTo, this.to)))
      return bn.fail("Structure gap-replace would overwrite content");
    let n = t.slice(this.gapFrom, this.gapTo);
    if (n.openStart || n.openEnd)
      return bn.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, n.content);
    return r ? bn.fromReplace(t, this.from, this.to, r) : bn.fail("Content does not fit in gap");
  }
  getMap() {
    return new di([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(t) {
    let n = this.gapTo - this.gapFrom;
    return new Wn(this.from, this.from + this.slice.size + n, this.from + this.insert, this.from + this.insert + n, t.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1), i = this.from == this.gapFrom ? n.pos : t.map(this.gapFrom, -1), o = this.to == this.gapTo ? r.pos : t.map(this.gapTo, 1);
    return n.deletedAcross && r.deletedAcross || i < n.pos || o > r.pos ? null : new Wn(n.pos, r.pos, i, o, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let t = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (t.slice = this.slice.toJSON()), this.structure && (t.structure = !0), t;
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number" || typeof n.gapFrom != "number" || typeof n.gapTo != "number" || typeof n.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new Wn(n.from, n.to, n.gapFrom, n.gapTo, _e.fromJSON(t, n.slice), n.insert, !!n.structure);
  }
}
xr.jsonID("replaceAround", Wn);
function Z9(e, t, n) {
  let r = e.resolve(t), i = n - t, o = r.depth;
  for (; i > 0 && o > 0 && r.indexAfter(o) == r.node(o).childCount; )
    o--, i--;
  if (i > 0) {
    let a = r.node(o).maybeChild(r.indexAfter(o));
    for (; i > 0; ) {
      if (!a || a.isLeaf)
        return !0;
      a = a.firstChild, i--;
    }
  }
  return !1;
}
function oze(e, t, n, r) {
  let i = [], o = [], a, s;
  e.doc.nodesBetween(t, n, (l, u, c) => {
    if (!l.isInline)
      return;
    let f = l.marks;
    if (!r.isInSet(f) && c.type.allowsMarkType(r.type)) {
      let h = Math.max(u, t), m = Math.min(u + l.nodeSize, n), v = r.addToSet(f);
      for (let g = 0; g < f.length; g++)
        f[g].isInSet(v) || (a && a.to == h && a.mark.eq(f[g]) ? a.to = m : i.push(a = new Io(h, m, f[g])));
      s && s.to == h ? s.to = m : o.push(s = new ks(h, m, r));
    }
  }), i.forEach((l) => e.step(l)), o.forEach((l) => e.step(l));
}
function aze(e, t, n, r) {
  let i = [], o = 0;
  e.doc.nodesBetween(t, n, (a, s) => {
    if (!a.isInline)
      return;
    o++;
    let l = null;
    if (r instanceof Rv) {
      let u = a.marks, c;
      for (; c = r.isInSet(u); )
        (l || (l = [])).push(c), u = c.removeFromSet(u);
    } else r ? r.isInSet(a.marks) && (l = [r]) : l = a.marks;
    if (l && l.length) {
      let u = Math.min(s + a.nodeSize, n);
      for (let c = 0; c < l.length; c++) {
        let f = l[c], h;
        for (let m = 0; m < i.length; m++) {
          let v = i[m];
          v.step == o - 1 && f.eq(i[m].style) && (h = v);
        }
        h ? (h.to = u, h.step = o) : i.push({ style: f, from: Math.max(s, t), to: u, step: o });
      }
    }
  }), i.forEach((a) => e.step(new Io(a.from, a.to, a.style)));
}
function R_(e, t, n, r = n.contentMatch, i = !0) {
  let o = e.doc.nodeAt(t), a = [], s = t + 1;
  for (let l = 0; l < o.childCount; l++) {
    let u = o.child(l), c = s + u.nodeSize, f = r.matchType(u.type);
    if (!f)
      a.push(new Vn(s, c, _e.empty));
    else {
      r = f;
      for (let h = 0; h < u.marks.length; h++)
        n.allowsMarkType(u.marks[h].type) || e.step(new Io(s, c, u.marks[h]));
      if (i && u.isText && n.whitespace != "pre") {
        let h, m = /\r?\n|\r/g, v;
        for (; h = m.exec(u.text); )
          v || (v = new _e(he.from(n.schema.text(" ", n.allowedMarks(u.marks))), 0, 0)), a.push(new Vn(s + h.index, s + h.index + h[0].length, v));
      }
    }
    s = c;
  }
  if (!r.validEnd) {
    let l = r.fillBefore(he.empty, !0);
    e.replace(s, s, new _e(l, 0, 0));
  }
  for (let l = a.length - 1; l >= 0; l--)
    e.step(a[l]);
}
function sze(e, t, n) {
  return (t == 0 || e.canReplace(t, e.childCount)) && (n == e.childCount || e.canReplace(0, n));
}
function jd(e) {
  let n = e.parent.content.cutByIndex(e.startIndex, e.endIndex);
  for (let r = e.depth; ; --r) {
    let i = e.$from.node(r), o = e.$from.index(r), a = e.$to.indexAfter(r);
    if (r < e.depth && i.canReplace(o, a, n))
      return r;
    if (r == 0 || i.type.spec.isolating || !sze(i, o, a))
      break;
  }
  return null;
}
function lze(e, t, n) {
  let { $from: r, $to: i, depth: o } = t, a = r.before(o + 1), s = i.after(o + 1), l = a, u = s, c = he.empty, f = 0;
  for (let v = o, g = !1; v > n; v--)
    g || r.index(v) > 0 ? (g = !0, c = he.from(r.node(v).copy(c)), f++) : l--;
  let h = he.empty, m = 0;
  for (let v = o, g = !1; v > n; v--)
    g || i.after(v + 1) < i.end(v) ? (g = !0, h = he.from(i.node(v).copy(h)), m++) : u++;
  e.step(new Wn(l, u, a, s, new _e(c.append(h), f, m), c.size - f, !0));
}
function D_(e, t, n = null, r = e) {
  let i = uze(e, t), o = i && cze(r, t);
  return o ? i.map(_L).concat({ type: t, attrs: n }).concat(o.map(_L)) : null;
}
function _L(e) {
  return { type: e, attrs: null };
}
function uze(e, t) {
  let { parent: n, startIndex: r, endIndex: i } = e, o = n.contentMatchAt(r).findWrapping(t);
  if (!o)
    return null;
  let a = o.length ? o[0] : t;
  return n.canReplaceWith(r, i, a) ? o : null;
}
function cze(e, t) {
  let { parent: n, startIndex: r, endIndex: i } = e, o = n.child(r), a = t.contentMatch.findWrapping(o.type);
  if (!a)
    return null;
  let l = (a.length ? a[a.length - 1] : t).contentMatch;
  for (let u = r; l && u < i; u++)
    l = l.matchType(n.child(u).type);
  return !l || !l.validEnd ? null : a;
}
function dze(e, t, n) {
  let r = he.empty;
  for (let a = n.length - 1; a >= 0; a--) {
    if (r.size) {
      let s = n[a].type.contentMatch.matchFragment(r);
      if (!s || !s.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = he.from(n[a].type.create(n[a].attrs, r));
  }
  let i = t.start, o = t.end;
  e.step(new Wn(i, o, i, o, new _e(r, 0, 0), n.length, !0));
}
function fze(e, t, n, r, i) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let o = e.steps.length;
  e.doc.nodesBetween(t, n, (a, s) => {
    let l = typeof i == "function" ? i(a) : i;
    if (a.isTextblock && !a.hasMarkup(r, l) && hze(e.doc, e.mapping.slice(o).map(s), r)) {
      let u = null;
      if (r.schema.linebreakReplacement) {
        let m = r.whitespace == "pre", v = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
        m && !v ? u = !1 : !m && v && (u = !0);
      }
      u === !1 && BQ(e, a, s, o), R_(e, e.mapping.slice(o).map(s, 1), r, void 0, u === null);
      let c = e.mapping.slice(o), f = c.map(s, 1), h = c.map(s + a.nodeSize, 1);
      return e.step(new Wn(f, h, f + 1, h - 1, new _e(he.from(r.create(l, null, a.marks)), 0, 0), 1, !0)), u === !0 && FQ(e, a, s, o), !1;
    }
  });
}
function FQ(e, t, n, r) {
  t.forEach((i, o) => {
    if (i.isText) {
      let a, s = /\r?\n|\r/g;
      for (; a = s.exec(i.text); ) {
        let l = e.mapping.slice(r).map(n + 1 + o + a.index);
        e.replaceWith(l, l + 1, t.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function BQ(e, t, n, r) {
  t.forEach((i, o) => {
    if (i.type == i.type.schema.linebreakReplacement) {
      let a = e.mapping.slice(r).map(n + 1 + o);
      e.replaceWith(a, a + 1, t.type.schema.text(`
`));
    }
  });
}
function hze(e, t, n) {
  let r = e.resolve(t), i = r.index();
  return r.parent.canReplaceWith(i, i + 1, n);
}
function pze(e, t, n, r, i) {
  let o = e.doc.nodeAt(t);
  if (!o)
    throw new RangeError("No node at given position");
  n || (n = o.type);
  let a = n.create(r, null, i || o.marks);
  if (o.isLeaf)
    return e.replaceWith(t, t + o.nodeSize, a);
  if (!n.validContent(o.content))
    throw new RangeError("Invalid content for node type " + n.name);
  e.step(new Wn(t, t + o.nodeSize, t + 1, t + o.nodeSize - 1, new _e(he.from(a), 0, 0), 1, !0));
}
function Ia(e, t, n = 1, r) {
  let i = e.resolve(t), o = i.depth - n, a = r && r[r.length - 1] || i.parent;
  if (o < 0 || i.parent.type.spec.isolating || !i.parent.canReplace(i.index(), i.parent.childCount) || !a.type.validContent(i.parent.content.cutByIndex(i.index(), i.parent.childCount)))
    return !1;
  for (let u = i.depth - 1, c = n - 2; u > o; u--, c--) {
    let f = i.node(u), h = i.index(u);
    if (f.type.spec.isolating)
      return !1;
    let m = f.content.cutByIndex(h, f.childCount), v = r && r[c + 1];
    v && (m = m.replaceChild(0, v.type.create(v.attrs)));
    let g = r && r[c] || f;
    if (!f.canReplace(h + 1, f.childCount) || !g.type.validContent(m))
      return !1;
  }
  let s = i.indexAfter(o), l = r && r[0];
  return i.node(o).canReplaceWith(s, s, l ? l.type : i.node(o + 1).type);
}
function mze(e, t, n = 1, r) {
  let i = e.doc.resolve(t), o = he.empty, a = he.empty;
  for (let s = i.depth, l = i.depth - n, u = n - 1; s > l; s--, u--) {
    o = he.from(i.node(s).copy(o));
    let c = r && r[u];
    a = he.from(c ? c.type.create(c.attrs, a) : i.node(s).copy(a));
  }
  e.step(new Vn(t, t, new _e(o.append(a), n, n), !0));
}
function il(e, t) {
  let n = e.resolve(t), r = n.index();
  return jQ(n.nodeBefore, n.nodeAfter) && n.parent.canReplace(r, r + 1);
}
function gze(e, t) {
  t.content.size || e.type.compatibleContent(t.type);
  let n = e.contentMatchAt(e.childCount), { linebreakReplacement: r } = e.type.schema;
  for (let i = 0; i < t.childCount; i++) {
    let o = t.child(i), a = o.type == r ? e.type.schema.nodes.text : o.type;
    if (n = n.matchType(a), !n || !e.type.allowsMarks(o.marks))
      return !1;
  }
  return n.validEnd;
}
function jQ(e, t) {
  return !!(e && t && !e.isLeaf && gze(e, t));
}
function Dv(e, t, n = -1) {
  let r = e.resolve(t);
  for (let i = r.depth; ; i--) {
    let o, a, s = r.index(i);
    if (i == r.depth ? (o = r.nodeBefore, a = r.nodeAfter) : n > 0 ? (o = r.node(i + 1), s++, a = r.node(i).maybeChild(s)) : (o = r.node(i).maybeChild(s - 1), a = r.node(i + 1)), o && !o.isTextblock && jQ(o, a) && r.node(i).canReplace(s, s + 1))
      return t;
    if (i == 0)
      break;
    t = n < 0 ? r.before(i) : r.after(i);
  }
}
function vze(e, t, n) {
  let r = null, { linebreakReplacement: i } = e.doc.type.schema, o = e.doc.resolve(t - n), a = o.node().type;
  if (i && a.inlineContent) {
    let c = a.whitespace == "pre", f = !!a.contentMatch.matchType(i);
    c && !f ? r = !1 : !c && f && (r = !0);
  }
  let s = e.steps.length;
  if (r === !1) {
    let c = e.doc.resolve(t + n);
    BQ(e, c.node(), c.before(), s);
  }
  a.inlineContent && R_(e, t + n - 1, a, o.node().contentMatchAt(o.index()), r == null);
  let l = e.mapping.slice(s), u = l.map(t - n);
  if (e.step(new Vn(u, l.map(t + n, -1), _e.empty, !0)), r === !0) {
    let c = e.doc.resolve(u);
    FQ(e, c.node(), c.before(), e.steps.length);
  }
  return e;
}
function yze(e, t, n) {
  let r = e.resolve(t);
  if (r.parent.canReplaceWith(r.index(), r.index(), n))
    return t;
  if (r.parentOffset == 0)
    for (let i = r.depth - 1; i >= 0; i--) {
      let o = r.index(i);
      if (r.node(i).canReplaceWith(o, o, n))
        return r.before(i + 1);
      if (o > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let i = r.depth - 1; i >= 0; i--) {
      let o = r.indexAfter(i);
      if (r.node(i).canReplaceWith(o, o, n))
        return r.after(i + 1);
      if (o < r.node(i).childCount)
        return null;
    }
  return null;
}
function VQ(e, t, n) {
  let r = e.resolve(t);
  if (!n.content.size)
    return t;
  let i = n.content;
  for (let o = 0; o < n.openStart; o++)
    i = i.firstChild.content;
  for (let o = 1; o <= (n.openStart == 0 && n.size ? 2 : 1); o++)
    for (let a = r.depth; a >= 0; a--) {
      let s = a == r.depth ? 0 : r.pos <= (r.start(a + 1) + r.end(a + 1)) / 2 ? -1 : 1, l = r.index(a) + (s > 0 ? 1 : 0), u = r.node(a), c = !1;
      if (o == 1)
        c = u.canReplace(l, l, i);
      else {
        let f = u.contentMatchAt(l).findWrapping(i.firstChild.type);
        c = f && u.canReplaceWith(l, l, f[0]);
      }
      if (c)
        return s == 0 ? r.pos : s < 0 ? r.before(a + 1) : r.after(a + 1);
    }
  return null;
}
function Iv(e, t, n = t, r = _e.empty) {
  if (t == n && !r.size)
    return null;
  let i = e.resolve(t), o = e.resolve(n);
  return qQ(i, o, r) ? new Vn(t, n, r) : new bze(i, o, r).fit();
}
function qQ(e, t, n) {
  return !n.openStart && !n.openEnd && e.start() == t.start() && e.parent.canReplace(e.index(), t.index(), n.content);
}
class bze {
  constructor(t, n, r) {
    this.$from = t, this.$to = n, this.unplaced = r, this.frontier = [], this.placed = he.empty;
    for (let i = 0; i <= t.depth; i++) {
      let o = t.node(i);
      this.frontier.push({
        type: o.type,
        match: o.contentMatchAt(t.indexAfter(i))
      });
    }
    for (let i = t.depth; i > 0; i--)
      this.placed = he.from(t.node(i).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let u = this.findFittable();
      u ? this.placeNodes(u) : this.openMore() || this.dropNode();
    }
    let t = this.mustMoveInline(), n = this.placed.size - this.depth - this.$from.depth, r = this.$from, i = this.close(t < 0 ? this.$to : r.doc.resolve(t));
    if (!i)
      return null;
    let o = this.placed, a = r.depth, s = i.depth;
    for (; a && s && o.childCount == 1; )
      o = o.firstChild.content, a--, s--;
    let l = new _e(o, a, s);
    return t > -1 ? new Wn(r.pos, t, this.$to.pos, this.$to.end(), l, n) : l.size || r.pos != this.$to.pos ? new Vn(r.pos, i.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let t = this.unplaced.openStart;
    for (let n = this.unplaced.content, r = 0, i = this.unplaced.openEnd; r < t; r++) {
      let o = n.firstChild;
      if (n.childCount > 1 && (i = 0), o.type.spec.isolating && i <= r) {
        t = r;
        break;
      }
      n = o.content;
    }
    for (let n = 1; n <= 2; n++)
      for (let r = n == 1 ? t : this.unplaced.openStart; r >= 0; r--) {
        let i, o = null;
        r ? (o = P8(this.unplaced.content, r - 1).firstChild, i = o.content) : i = this.unplaced.content;
        let a = i.firstChild;
        for (let s = this.depth; s >= 0; s--) {
          let { type: l, match: u } = this.frontier[s], c, f = null;
          if (n == 1 && (a ? u.matchType(a.type) || (f = u.fillBefore(he.from(a), !1)) : o && l.compatibleContent(o.type)))
            return { sliceDepth: r, frontierDepth: s, parent: o, inject: f };
          if (n == 2 && a && (c = u.findWrapping(a.type)))
            return { sliceDepth: r, frontierDepth: s, parent: o, wrap: c };
          if (o && u.matchType(o.type))
            break;
        }
      }
  }
  openMore() {
    let { content: t, openStart: n, openEnd: r } = this.unplaced, i = P8(t, n);
    return !i.childCount || i.firstChild.isLeaf ? !1 : (this.unplaced = new _e(t, n + 1, Math.max(r, i.size + n >= t.size - r ? n + 1 : 0)), !0);
  }
  dropNode() {
    let { content: t, openStart: n, openEnd: r } = this.unplaced, i = P8(t, n);
    if (i.childCount <= 1 && n > 0) {
      let o = t.size - n <= n + i.size;
      this.unplaced = new _e(Mf(t, n - 1, 1), n - 1, o ? n - 1 : r);
    } else
      this.unplaced = new _e(Mf(t, n, 1), n, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: t, frontierDepth: n, parent: r, inject: i, wrap: o }) {
    for (; this.depth > n; )
      this.closeFrontierNode();
    if (o)
      for (let g = 0; g < o.length; g++)
        this.openFrontierNode(o[g]);
    let a = this.unplaced, s = r ? r.content : a.content, l = a.openStart - t, u = 0, c = [], { match: f, type: h } = this.frontier[n];
    if (i) {
      for (let g = 0; g < i.childCount; g++)
        c.push(i.child(g));
      f = f.matchFragment(i);
    }
    let m = s.size + t - (a.content.size - a.openEnd);
    for (; u < s.childCount; ) {
      let g = s.child(u), y = f.matchType(g.type);
      if (!y)
        break;
      u++, (u > 1 || l == 0 || g.content.size) && (f = y, c.push(zQ(g.mark(h.allowedMarks(g.marks)), u == 1 ? l : 0, u == s.childCount ? m : -1)));
    }
    let v = u == s.childCount;
    v || (m = -1), this.placed = Rf(this.placed, n, he.from(c)), this.frontier[n].match = f, v && m < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let g = 0, y = s; g < m; g++) {
      let w = y.lastChild;
      this.frontier.push({ type: w.type, match: w.contentMatchAt(w.childCount) }), y = w.content;
    }
    this.unplaced = v ? t == 0 ? _e.empty : new _e(Mf(a.content, t - 1, 1), t - 1, m < 0 ? a.openEnd : t - 1) : new _e(Mf(a.content, t, u), a.openStart, a.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let t = this.frontier[this.depth], n;
    if (!t.type.isTextblock || !T8(this.$to, this.$to.depth, t.type, t.match, !1) || this.$to.depth == this.depth && (n = this.findCloseLevel(this.$to)) && n.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, i = this.$to.after(r);
    for (; r > 1 && i == this.$to.end(--r); )
      ++i;
    return i;
  }
  findCloseLevel(t) {
    e: for (let n = Math.min(this.depth, t.depth); n >= 0; n--) {
      let { match: r, type: i } = this.frontier[n], o = n < t.depth && t.end(n + 1) == t.pos + (t.depth - (n + 1)), a = T8(t, n, i, r, o);
      if (a) {
        for (let s = n - 1; s >= 0; s--) {
          let { match: l, type: u } = this.frontier[s], c = T8(t, s, u, l, !0);
          if (!c || c.childCount)
            continue e;
        }
        return { depth: n, fit: a, move: o ? t.doc.resolve(t.after(n + 1)) : t };
      }
    }
  }
  close(t) {
    let n = this.findCloseLevel(t);
    if (!n)
      return null;
    for (; this.depth > n.depth; )
      this.closeFrontierNode();
    n.fit.childCount && (this.placed = Rf(this.placed, n.depth, n.fit)), t = n.move;
    for (let r = n.depth + 1; r <= t.depth; r++) {
      let i = t.node(r), o = i.type.contentMatch.fillBefore(i.content, !0, t.index(r));
      this.openFrontierNode(i.type, i.attrs, o);
    }
    return t;
  }
  openFrontierNode(t, n = null, r) {
    let i = this.frontier[this.depth];
    i.match = i.match.matchType(t), this.placed = Rf(this.placed, this.depth, he.from(t.create(n, r))), this.frontier.push({ type: t, match: t.contentMatch });
  }
  closeFrontierNode() {
    let n = this.frontier.pop().match.fillBefore(he.empty, !0);
    n.childCount && (this.placed = Rf(this.placed, this.frontier.length, n));
  }
}
function Mf(e, t, n) {
  return t == 0 ? e.cutByIndex(n, e.childCount) : e.replaceChild(0, e.firstChild.copy(Mf(e.firstChild.content, t - 1, n)));
}
function Rf(e, t, n) {
  return t == 0 ? e.append(n) : e.replaceChild(e.childCount - 1, e.lastChild.copy(Rf(e.lastChild.content, t - 1, n)));
}
function P8(e, t) {
  for (let n = 0; n < t; n++)
    e = e.firstChild.content;
  return e;
}
function zQ(e, t, n) {
  if (t <= 0)
    return e;
  let r = e.content;
  return t > 1 && (r = r.replaceChild(0, zQ(r.firstChild, t - 1, r.childCount == 1 ? n - 1 : 0))), t > 0 && (r = e.type.contentMatch.fillBefore(r).append(r), n <= 0 && (r = r.append(e.type.contentMatch.matchFragment(r).fillBefore(he.empty, !0)))), e.copy(r);
}
function T8(e, t, n, r, i) {
  let o = e.node(t), a = i ? e.indexAfter(t) : e.index(t);
  if (a == o.childCount && !n.compatibleContent(o.type))
    return null;
  let s = r.fillBefore(o.content, !0, a);
  return s && !xze(n, o.content, a) ? s : null;
}
function xze(e, t, n) {
  for (let r = n; r < t.childCount; r++)
    if (!e.allowsMarks(t.child(r).marks))
      return !0;
  return !1;
}
function wze(e) {
  return e.spec.defining || e.spec.definingForContent;
}
function Cze(e, t, n, r) {
  if (!r.size)
    return e.deleteRange(t, n);
  let i = e.doc.resolve(t), o = e.doc.resolve(n);
  if (qQ(i, o, r))
    return e.step(new Vn(t, n, r));
  let a = HQ(i, e.doc.resolve(n));
  a[a.length - 1] == 0 && a.pop();
  let s = -(i.depth + 1);
  a.unshift(s);
  for (let h = i.depth, m = i.pos - 1; h > 0; h--, m--) {
    let v = i.node(h).type.spec;
    if (v.defining || v.definingAsContext || v.isolating)
      break;
    a.indexOf(h) > -1 ? s = h : i.before(h) == m && a.splice(1, 0, -h);
  }
  let l = a.indexOf(s), u = [], c = r.openStart;
  for (let h = r.content, m = 0; ; m++) {
    let v = h.firstChild;
    if (u.push(v), m == r.openStart)
      break;
    h = v.content;
  }
  for (let h = c - 1; h >= 0; h--) {
    let m = u[h], v = wze(m.type);
    if (v && !m.sameMarkup(i.node(Math.abs(s) - 1)))
      c = h;
    else if (v || !m.type.isTextblock)
      break;
  }
  for (let h = r.openStart; h >= 0; h--) {
    let m = (h + c + 1) % (r.openStart + 1), v = u[m];
    if (v)
      for (let g = 0; g < a.length; g++) {
        let y = a[(g + l) % a.length], w = !0;
        y < 0 && (w = !1, y = -y);
        let C = i.node(y - 1), S = i.index(y - 1);
        if (C.canReplaceWith(S, S, v.type, v.marks))
          return e.replace(i.before(y), w ? o.after(y) : n, new _e(WQ(r.content, 0, r.openStart, m), m, r.openEnd));
      }
  }
  let f = e.steps.length;
  for (let h = a.length - 1; h >= 0 && (e.replace(t, n, r), !(e.steps.length > f)); h--) {
    let m = a[h];
    m < 0 || (t = i.before(m), n = o.after(m));
  }
}
function WQ(e, t, n, r, i) {
  if (t < n) {
    let o = e.firstChild;
    e = e.replaceChild(0, o.copy(WQ(o.content, t + 1, n, r, o)));
  }
  if (t > r) {
    let o = i.contentMatchAt(0), a = o.fillBefore(e).append(e);
    e = a.append(o.matchFragment(a).fillBefore(he.empty, !0));
  }
  return e;
}
function Sze(e, t, n, r) {
  if (!r.isInline && t == n && e.doc.resolve(t).parent.content.size) {
    let i = yze(e.doc, t, r.type);
    i != null && (t = n = i);
  }
  e.replaceRange(t, n, new _e(he.from(r), 0, 0));
}
function _ze(e, t, n) {
  let r = e.doc.resolve(t), i = e.doc.resolve(n), o = HQ(r, i);
  for (let a = 0; a < o.length; a++) {
    let s = o[a], l = a == o.length - 1;
    if (l && s == 0 || r.node(s).type.contentMatch.validEnd)
      return e.delete(r.start(s), i.end(s));
    if (s > 0 && (l || r.node(s - 1).canReplace(r.index(s - 1), i.indexAfter(s - 1))))
      return e.delete(r.before(s), i.after(s));
  }
  for (let a = 1; a <= r.depth && a <= i.depth; a++)
    if (t - r.start(a) == r.depth - a && n > r.end(a) && i.end(a) - n != i.depth - a && r.start(a - 1) == i.start(a - 1) && r.node(a - 1).canReplace(r.index(a - 1), i.index(a - 1)))
      return e.delete(r.before(a), n);
  e.delete(t, n);
}
function HQ(e, t) {
  let n = [], r = Math.min(e.depth, t.depth);
  for (let i = r; i >= 0; i--) {
    let o = e.start(i);
    if (o < e.pos - (e.depth - i) || t.end(i) > t.pos + (t.depth - i) || e.node(i).type.spec.isolating || t.node(i).type.spec.isolating)
      break;
    (o == t.start(i) || i == e.depth && i == t.depth && e.parent.inlineContent && t.parent.inlineContent && i && t.start(i - 1) == o - 1) && n.push(i);
  }
  return n;
}
class Sc extends xr {
  /**
  Construct an attribute step.
  */
  constructor(t, n, r) {
    super(), this.pos = t, this.attr = n, this.value = r;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return bn.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let o in n.attrs)
      r[o] = n.attrs[o];
    r[this.attr] = this.value;
    let i = n.type.create(r, null, n.marks);
    return bn.fromReplace(t, this.pos, this.pos + 1, new _e(he.from(i), 0, n.isLeaf ? 0 : 1));
  }
  getMap() {
    return di.empty;
  }
  invert(t) {
    return new Sc(this.pos, this.attr, t.nodeAt(this.pos).attrs[this.attr]);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Sc(n.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(t, n) {
    if (typeof n.pos != "number" || typeof n.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new Sc(n.pos, n.attr, n.value);
  }
}
xr.jsonID("attr", Sc);
class zh extends xr {
  /**
  Construct an attribute step.
  */
  constructor(t, n) {
    super(), this.attr = t, this.value = n;
  }
  apply(t) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let i in t.attrs)
      n[i] = t.attrs[i];
    n[this.attr] = this.value;
    let r = t.type.create(n, t.content, t.marks);
    return bn.ok(r);
  }
  getMap() {
    return di.empty;
  }
  invert(t) {
    return new zh(this.attr, t.attrs[this.attr]);
  }
  map(t) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(t, n) {
    if (typeof n.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new zh(n.attr, n.value);
  }
}
xr.jsonID("docAttr", zh);
let ud = class extends Error {
};
ud = function e(t) {
  let n = Error.call(this, t);
  return n.__proto__ = e.prototype, n;
};
ud.prototype = Object.create(Error.prototype);
ud.prototype.constructor = ud;
ud.prototype.name = "TransformError";
class Eze {
  /**
  Create a transform that starts with the given document.
  */
  constructor(t) {
    this.doc = t, this.steps = [], this.docs = [], this.mapping = new Cc();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(t) {
    let n = this.maybeStep(t);
    if (n.failed)
      throw new ud(n.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(t) {
    let n = t.apply(this.doc);
    return n.failed || this.addStep(t, n.doc), n;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(t, n) {
    this.docs.push(this.doc), this.steps.push(t), this.mapping.appendMap(t.getMap()), this.doc = n;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(t, n = t, r = _e.empty) {
    let i = Iv(this.doc, t, n, r);
    return i && this.step(i), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(t, n, r) {
    return this.replace(t, n, new _e(he.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(t, n) {
    return this.replace(t, n, _e.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(t, n) {
    return this.replaceWith(t, t, n);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(t, n, r) {
    return Cze(this, t, n, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(t, n, r) {
    return Sze(this, t, n, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(t, n) {
    return _ze(this, t, n), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(t, n) {
    return lze(this, t, n), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(t, n = 1) {
    return vze(this, t, n), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(t, n) {
    return dze(this, t, n), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(t, n = t, r, i = null) {
    return fze(this, t, n, r, i), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(t, n, r = null, i) {
    return pze(this, t, n, r, i), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(t, n, r) {
    return this.step(new Sc(t, n, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(t, n) {
    return this.step(new zh(t, n)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(t, n) {
    return this.step(new Ps(t, n)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(t, n) {
    if (!(n instanceof Ot)) {
      let r = this.doc.nodeAt(t);
      if (!r)
        throw new RangeError("No node at position " + t);
      if (n = n.isInSet(r.marks), !n)
        return this;
    }
    return this.step(new ld(t, n)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split.
  */
  split(t, n = 1, r) {
    return mze(this, t, n, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(t, n, r) {
    return oze(this, t, n, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(t, n, r) {
    return aze(this, t, n, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(t, n, r) {
    return R_(this, t, n, r), this;
  }
}
const M8 = /* @__PURE__ */ Object.create(null);
class it {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(t, n, r) {
    this.$anchor = t, this.$head = n, this.ranges = r || [new Nze(t.min(n), t.max(n))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let t = this.ranges;
    for (let n = 0; n < t.length; n++)
      if (t[n].$from.pos != t[n].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(t, n = _e.empty) {
    let r = n.content.lastChild, i = null;
    for (let s = 0; s < n.openEnd; s++)
      i = r, r = r.lastChild;
    let o = t.steps.length, a = this.ranges;
    for (let s = 0; s < a.length; s++) {
      let { $from: l, $to: u } = a[s], c = t.mapping.slice(o);
      t.replaceRange(c.map(l.pos), c.map(u.pos), s ? _e.empty : n), s == 0 && AL(t, o, (r ? r.isInline : i && i.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(t, n) {
    let r = t.steps.length, i = this.ranges;
    for (let o = 0; o < i.length; o++) {
      let { $from: a, $to: s } = i[o], l = t.mapping.slice(r), u = l.map(a.pos), c = l.map(s.pos);
      o ? t.deleteRange(u, c) : (t.replaceRangeWith(u, c, n), AL(t, r, n.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(t, n, r = !1) {
    let i = t.parent.inlineContent ? new Ze(t) : tc(t.node(0), t.parent, t.pos, t.index(), n, r);
    if (i)
      return i;
    for (let o = t.depth - 1; o >= 0; o--) {
      let a = n < 0 ? tc(t.node(0), t.node(o), t.before(o + 1), t.index(o), n, r) : tc(t.node(0), t.node(o), t.after(o + 1), t.index(o) + 1, n, r);
      if (a)
        return a;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(t, n = 1) {
    return this.findFrom(t, n) || this.findFrom(t, -n) || new Ii(t.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(t) {
    return tc(t, t, 0, 0, 1) || new Ii(t);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(t) {
    return tc(t, t, t.content.size, t.childCount, -1) || new Ii(t);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(t, n) {
    if (!n || !n.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = M8[n.type];
    if (!r)
      throw new RangeError(`No selection type ${n.type} defined`);
    return r.fromJSON(t, n);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(t, n) {
    if (t in M8)
      throw new RangeError("Duplicate use of selection JSON ID " + t);
    return M8[t] = n, n.prototype.jsonID = t, n;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Ze.between(this.$anchor, this.$head).getBookmark();
  }
}
it.prototype.visible = !0;
class Nze {
  /**
  Create a range.
  */
  constructor(t, n) {
    this.$from = t, this.$to = n;
  }
}
let EL = !1;
function NL(e) {
  !EL && !e.parent.inlineContent && (EL = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + e.parent.type.name + ")"));
}
class Ze extends it {
  /**
  Construct a text selection between the given points.
  */
  constructor(t, n = t) {
    NL(t), NL(n), super(t, n);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(t, n) {
    let r = t.resolve(n.map(this.head));
    if (!r.parent.inlineContent)
      return it.near(r);
    let i = t.resolve(n.map(this.anchor));
    return new Ze(i.parent.inlineContent ? i : r, r);
  }
  replace(t, n = _e.empty) {
    if (super.replace(t, n), n == _e.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && t.ensureMarks(r);
    }
  }
  eq(t) {
    return t instanceof Ze && t.anchor == this.anchor && t.head == this.head;
  }
  getBookmark() {
    return new $v(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.anchor != "number" || typeof n.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Ze(t.resolve(n.anchor), t.resolve(n.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(t, n, r = n) {
    let i = t.resolve(n);
    return new this(i, r == n ? i : t.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(t, n, r) {
    let i = t.pos - n.pos;
    if ((!r || i) && (r = i >= 0 ? 1 : -1), !n.parent.inlineContent) {
      let o = it.findFrom(n, r, !0) || it.findFrom(n, -r, !0);
      if (o)
        n = o.$head;
      else
        return it.near(n, r);
    }
    return t.parent.inlineContent || (i == 0 ? t = n : (t = (it.findFrom(t, -r, !0) || it.findFrom(t, r, !0)).$anchor, t.pos < n.pos != i < 0 && (t = n))), new Ze(t, n);
  }
}
it.jsonID("text", Ze);
class $v {
  constructor(t, n) {
    this.anchor = t, this.head = n;
  }
  map(t) {
    return new $v(t.map(this.anchor), t.map(this.head));
  }
  resolve(t) {
    return Ze.between(t.resolve(this.anchor), t.resolve(this.head));
  }
}
class $e extends it {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(t) {
    let n = t.nodeAfter, r = t.node(0).resolve(t.pos + n.nodeSize);
    super(t, r), this.node = n;
  }
  map(t, n) {
    let { deleted: r, pos: i } = n.mapResult(this.anchor), o = t.resolve(i);
    return r ? it.near(o) : new $e(o);
  }
  content() {
    return new _e(he.from(this.node), 0, 0);
  }
  eq(t) {
    return t instanceof $e && t.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new I_(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new $e(t.resolve(n.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(t, n) {
    return new $e(t.resolve(n));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(t) {
    return !t.isText && t.type.spec.selectable !== !1;
  }
}
$e.prototype.visible = !1;
it.jsonID("node", $e);
class I_ {
  constructor(t) {
    this.anchor = t;
  }
  map(t) {
    let { deleted: n, pos: r } = t.mapResult(this.anchor);
    return n ? new $v(r, r) : new I_(r);
  }
  resolve(t) {
    let n = t.resolve(this.anchor), r = n.nodeAfter;
    return r && $e.isSelectable(r) ? new $e(n) : it.near(n);
  }
}
class Ii extends it {
  /**
  Create an all-selection over the given document.
  */
  constructor(t) {
    super(t.resolve(0), t.resolve(t.content.size));
  }
  replace(t, n = _e.empty) {
    if (n == _e.empty) {
      t.delete(0, t.doc.content.size);
      let r = it.atStart(t.doc);
      r.eq(t.selection) || t.setSelection(r);
    } else
      super.replace(t, n);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(t) {
    return new Ii(t);
  }
  map(t) {
    return new Ii(t);
  }
  eq(t) {
    return t instanceof Ii;
  }
  getBookmark() {
    return Aze;
  }
}
it.jsonID("all", Ii);
const Aze = {
  map() {
    return this;
  },
  resolve(e) {
    return new Ii(e);
  }
};
function tc(e, t, n, r, i, o = !1) {
  if (t.inlineContent)
    return Ze.create(e, n);
  for (let a = r - (i > 0 ? 0 : 1); i > 0 ? a < t.childCount : a >= 0; a += i) {
    let s = t.child(a);
    if (s.isAtom) {
      if (!o && $e.isSelectable(s))
        return $e.create(e, n - (i < 0 ? s.nodeSize : 0));
    } else {
      let l = tc(e, s, n + i, i < 0 ? s.childCount : 0, i, o);
      if (l)
        return l;
    }
    n += s.nodeSize * i;
  }
  return null;
}
function AL(e, t, n) {
  let r = e.steps.length - 1;
  if (r < t)
    return;
  let i = e.steps[r];
  if (!(i instanceof Vn || i instanceof Wn))
    return;
  let o = e.mapping.maps[r], a;
  o.forEach((s, l, u, c) => {
    a == null && (a = c);
  }), e.setSelection(it.near(e.doc.resolve(a), n));
}
const OL = 1, kL = 2, PL = 4;
class Oze extends Eze {
  /**
  @internal
  */
  constructor(t) {
    super(t.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = t.selection, this.storedMarks = t.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(t) {
    if (t.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = t, this.curSelectionFor = this.steps.length, this.updated = (this.updated | OL) & -3, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & OL) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(t) {
    return this.storedMarks = t, this.updated |= kL, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(t) {
    return Ot.sameSet(this.storedMarks || this.selection.$from.marks(), t) || this.setStoredMarks(t), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(t) {
    return this.ensureMarks(t.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(t) {
    return this.ensureMarks(t.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & kL) > 0;
  }
  /**
  @internal
  */
  addStep(t, n) {
    super.addStep(t, n), this.updated = this.updated & -3, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(t) {
    return this.time = t, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(t) {
    return this.selection.replace(this, t), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(t, n = !0) {
    let r = this.selection;
    return n && (t = t.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || Ot.none))), r.replaceWith(this, t), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(t, n, r) {
    let i = this.doc.type.schema;
    if (n == null)
      return t ? this.replaceSelectionWith(i.text(t), !0) : this.deleteSelection();
    {
      if (r == null && (r = n), r = r ?? n, !t)
        return this.deleteRange(n, r);
      let o = this.storedMarks;
      if (!o) {
        let a = this.doc.resolve(n);
        o = r == n ? a.marks() : a.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(n, r, i.text(t, o)), this.selection.empty || this.setSelection(it.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(t, n) {
    return this.meta[typeof t == "string" ? t : t.key] = n, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(t) {
    return this.meta[typeof t == "string" ? t : t.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let t in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= PL, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & PL) > 0;
  }
}
function TL(e, t) {
  return !t || !e ? e : e.bind(t);
}
class Df {
  constructor(t, n, r) {
    this.name = t, this.init = TL(n.init, r), this.apply = TL(n.apply, r);
  }
}
const kze = [
  new Df("doc", {
    init(e) {
      return e.doc || e.schema.topNodeType.createAndFill();
    },
    apply(e) {
      return e.doc;
    }
  }),
  new Df("selection", {
    init(e, t) {
      return e.selection || it.atStart(t.doc);
    },
    apply(e) {
      return e.selection;
    }
  }),
  new Df("storedMarks", {
    init(e) {
      return e.storedMarks || null;
    },
    apply(e, t, n, r) {
      return r.selection.$cursor ? e.storedMarks : null;
    }
  }),
  new Df("scrollToSelection", {
    init() {
      return 0;
    },
    apply(e, t) {
      return e.scrolledIntoView ? t + 1 : t;
    }
  })
];
class R8 {
  constructor(t, n) {
    this.schema = t, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = kze.slice(), n && n.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new Df(r.key, r.spec.state, r));
    });
  }
}
class sc {
  /**
  @internal
  */
  constructor(t) {
    this.config = t;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(t) {
    return this.applyTransaction(t).state;
  }
  /**
  @internal
  */
  filterTransaction(t, n = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != n) {
        let i = this.config.plugins[r];
        if (i.spec.filterTransaction && !i.spec.filterTransaction.call(i, t, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(t) {
    if (!this.filterTransaction(t))
      return { state: this, transactions: [] };
    let n = [t], r = this.applyInner(t), i = null;
    for (; ; ) {
      let o = !1;
      for (let a = 0; a < this.config.plugins.length; a++) {
        let s = this.config.plugins[a];
        if (s.spec.appendTransaction) {
          let l = i ? i[a].n : 0, u = i ? i[a].state : this, c = l < n.length && s.spec.appendTransaction.call(s, l ? n.slice(l) : n, u, r);
          if (c && r.filterTransaction(c, a)) {
            if (c.setMeta("appendedTransaction", t), !i) {
              i = [];
              for (let f = 0; f < this.config.plugins.length; f++)
                i.push(f < a ? { state: r, n: n.length } : { state: this, n: 0 });
            }
            n.push(c), r = r.applyInner(c), o = !0;
          }
          i && (i[a] = { state: r, n: n.length });
        }
      }
      if (!o)
        return { state: r, transactions: n };
    }
  }
  /**
  @internal
  */
  applyInner(t) {
    if (!t.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let n = new sc(this.config), r = this.config.fields;
    for (let i = 0; i < r.length; i++) {
      let o = r[i];
      n[o.name] = o.apply(t, this[o.name], this, n);
    }
    return n;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new Oze(this);
  }
  /**
  Create a new state.
  */
  static create(t) {
    let n = new R8(t.doc ? t.doc.type.schema : t.schema, t.plugins), r = new sc(n);
    for (let i = 0; i < n.fields.length; i++)
      r[n.fields[i].name] = n.fields[i].init(t, r);
    return r;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(t) {
    let n = new R8(this.schema, t.plugins), r = n.fields, i = new sc(n);
    for (let o = 0; o < r.length; o++) {
      let a = r[o].name;
      i[a] = this.hasOwnProperty(a) ? this[a] : r[o].init(t, i);
    }
    return i;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(t) {
    let n = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (n.storedMarks = this.storedMarks.map((r) => r.toJSON())), t && typeof t == "object")
      for (let r in t) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let i = t[r], o = i.spec.state;
        o && o.toJSON && (n[r] = o.toJSON.call(i, this[i.key]));
      }
    return n;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(t, n, r) {
    if (!n)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!t.schema)
      throw new RangeError("Required config field 'schema' missing");
    let i = new R8(t.schema, t.plugins), o = new sc(i);
    return i.fields.forEach((a) => {
      if (a.name == "doc")
        o.doc = Vl.fromJSON(t.schema, n.doc);
      else if (a.name == "selection")
        o.selection = it.fromJSON(o.doc, n.selection);
      else if (a.name == "storedMarks")
        n.storedMarks && (o.storedMarks = n.storedMarks.map(t.schema.markFromJSON));
      else {
        if (r)
          for (let s in r) {
            let l = r[s], u = l.spec.state;
            if (l.key == a.name && u && u.fromJSON && Object.prototype.hasOwnProperty.call(n, s)) {
              o[a.name] = u.fromJSON.call(l, t, n[s], o);
              return;
            }
          }
        o[a.name] = a.init(t, o);
      }
    }), o;
  }
}
function UQ(e, t, n) {
  for (let r in e) {
    let i = e[r];
    i instanceof Function ? i = i.bind(t) : r == "handleDOMEvents" && (i = UQ(i, t, {})), n[r] = i;
  }
  return n;
}
class $r {
  /**
  Create a plugin.
  */
  constructor(t) {
    this.spec = t, this.props = {}, t.props && UQ(t.props, this, this.props), this.key = t.key ? t.key.key : GQ("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(t) {
    return t[this.key];
  }
}
const D8 = /* @__PURE__ */ Object.create(null);
function GQ(e) {
  return e in D8 ? e + "$" + ++D8[e] : (D8[e] = 0, e + "$");
}
class xo {
  /**
  Create a plugin key.
  */
  constructor(t = "key") {
    this.key = GQ(t);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(t) {
    return t.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(t) {
    return t[this.key];
  }
}
const tr = function(e) {
  for (var t = 0; ; t++)
    if (e = e.previousSibling, !e)
      return t;
}, Wh = function(e) {
  let t = e.assignedSlot || e.parentNode;
  return t && t.nodeType == 11 ? t.host : t;
};
let X9 = null;
const Ca = function(e, t, n) {
  let r = X9 || (X9 = document.createRange());
  return r.setEnd(e, n ?? e.nodeValue.length), r.setStart(e, t || 0), r;
}, Pze = function() {
  X9 = null;
}, iu = function(e, t, n, r) {
  return n && (ML(e, t, n, r, -1) || ML(e, t, n, r, 1));
}, Tze = /^(img|br|input|textarea|hr)$/i;
function ML(e, t, n, r, i) {
  for (; ; ) {
    if (e == n && t == r)
      return !0;
    if (t == (i < 0 ? 0 : Pi(e))) {
      let o = e.parentNode;
      if (!o || o.nodeType != 1 || $p(e) || Tze.test(e.nodeName) || e.contentEditable == "false")
        return !1;
      t = tr(e) + (i < 0 ? 0 : 1), e = o;
    } else if (e.nodeType == 1) {
      if (e = e.childNodes[t + (i < 0 ? -1 : 0)], e.contentEditable == "false")
        return !1;
      t = i < 0 ? Pi(e) : 0;
    } else
      return !1;
  }
}
function Pi(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function Mze(e, t) {
  for (; ; ) {
    if (e.nodeType == 3 && t)
      return e;
    if (e.nodeType == 1 && t > 0) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[t - 1], t = Pi(e);
    } else if (e.parentNode && !$p(e))
      t = tr(e), e = e.parentNode;
    else
      return null;
  }
}
function Rze(e, t) {
  for (; ; ) {
    if (e.nodeType == 3 && t < e.nodeValue.length)
      return e;
    if (e.nodeType == 1 && t < e.childNodes.length) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[t], t = 0;
    } else if (e.parentNode && !$p(e))
      t = tr(e) + 1, e = e.parentNode;
    else
      return null;
  }
}
function Dze(e, t, n) {
  for (let r = t == 0, i = t == Pi(e); r || i; ) {
    if (e == n)
      return !0;
    let o = tr(e);
    if (e = e.parentNode, !e)
      return !1;
    r = r && o == 0, i = i && o == Pi(e);
  }
}
function $p(e) {
  let t;
  for (let n = e; n && !(t = n.pmViewDesc); n = n.parentNode)
    ;
  return t && t.node && t.node.isBlock && (t.dom == e || t.contentDOM == e);
}
const Lv = function(e) {
  return e.focusNode && iu(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset);
};
function _l(e, t) {
  let n = document.createEvent("Event");
  return n.initEvent("keydown", !0, !0), n.keyCode = e, n.key = n.code = t, n;
}
function Ize(e) {
  let t = e.activeElement;
  for (; t && t.shadowRoot; )
    t = t.shadowRoot.activeElement;
  return t;
}
function $ze(e, t, n) {
  if (e.caretPositionFromPoint)
    try {
      let r = e.caretPositionFromPoint(t, n);
      if (r)
        return { node: r.offsetNode, offset: Math.min(Pi(r.offsetNode), r.offset) };
    } catch {
    }
  if (e.caretRangeFromPoint) {
    let r = e.caretRangeFromPoint(t, n);
    if (r)
      return { node: r.startContainer, offset: Math.min(Pi(r.startContainer), r.startOffset) };
  }
}
const Go = typeof navigator < "u" ? navigator : null, RL = typeof document < "u" ? document : null, ol = Go && Go.userAgent || "", J9 = /Edge\/(\d+)/.exec(ol), KQ = /MSIE \d/.exec(ol), Q9 = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(ol), Gr = !!(KQ || Q9 || J9), $s = KQ ? document.documentMode : Q9 ? +Q9[1] : J9 ? +J9[1] : 0, mo = !Gr && /gecko\/(\d+)/i.test(ol);
mo && +(/Firefox\/(\d+)/.exec(ol) || [0, 0])[1];
const ew = !Gr && /Chrome\/(\d+)/.exec(ol), vr = !!ew, YQ = ew ? +ew[1] : 0, Mr = !Gr && !!Go && /Apple Computer/.test(Go.vendor), cd = Mr && (/Mobile\/\w+/.test(ol) || !!Go && Go.maxTouchPoints > 2), ki = cd || (Go ? /Mac/.test(Go.platform) : !1), Lze = Go ? /Win/.test(Go.platform) : !1, Qi = /Android \d/.test(ol), Lp = !!RL && "webkitFontSmoothing" in RL.documentElement.style, Fze = Lp ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function Bze(e) {
  let t = e.defaultView && e.defaultView.visualViewport;
  return t ? {
    left: 0,
    right: t.width,
    top: 0,
    bottom: t.height
  } : {
    left: 0,
    right: e.documentElement.clientWidth,
    top: 0,
    bottom: e.documentElement.clientHeight
  };
}
function ba(e, t) {
  return typeof e == "number" ? e : e[t];
}
function jze(e) {
  let t = e.getBoundingClientRect(), n = t.width / e.offsetWidth || 1, r = t.height / e.offsetHeight || 1;
  return {
    left: t.left,
    right: t.left + e.clientWidth * n,
    top: t.top,
    bottom: t.top + e.clientHeight * r
  };
}
function DL(e, t, n) {
  let r = e.someProp("scrollThreshold") || 0, i = e.someProp("scrollMargin") || 5, o = e.dom.ownerDocument;
  for (let a = n || e.dom; a; a = Wh(a)) {
    if (a.nodeType != 1)
      continue;
    let s = a, l = s == o.body, u = l ? Bze(o) : jze(s), c = 0, f = 0;
    if (t.top < u.top + ba(r, "top") ? f = -(u.top - t.top + ba(i, "top")) : t.bottom > u.bottom - ba(r, "bottom") && (f = t.bottom - t.top > u.bottom - u.top ? t.top + ba(i, "top") - u.top : t.bottom - u.bottom + ba(i, "bottom")), t.left < u.left + ba(r, "left") ? c = -(u.left - t.left + ba(i, "left")) : t.right > u.right - ba(r, "right") && (c = t.right - u.right + ba(i, "right")), c || f)
      if (l)
        o.defaultView.scrollBy(c, f);
      else {
        let h = s.scrollLeft, m = s.scrollTop;
        f && (s.scrollTop += f), c && (s.scrollLeft += c);
        let v = s.scrollLeft - h, g = s.scrollTop - m;
        t = { left: t.left - v, top: t.top - g, right: t.right - v, bottom: t.bottom - g };
      }
    if (l || /^(fixed|sticky)$/.test(getComputedStyle(a).position))
      break;
  }
}
function Vze(e) {
  let t = e.dom.getBoundingClientRect(), n = Math.max(0, t.top), r, i;
  for (let o = (t.left + t.right) / 2, a = n + 1; a < Math.min(innerHeight, t.bottom); a += 5) {
    let s = e.root.elementFromPoint(o, a);
    if (!s || s == e.dom || !e.dom.contains(s))
      continue;
    let l = s.getBoundingClientRect();
    if (l.top >= n - 20) {
      r = s, i = l.top;
      break;
    }
  }
  return { refDOM: r, refTop: i, stack: ZQ(e.dom) };
}
function ZQ(e) {
  let t = [], n = e.ownerDocument;
  for (let r = e; r && (t.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), e != n); r = Wh(r))
    ;
  return t;
}
function qze({ refDOM: e, refTop: t, stack: n }) {
  let r = e ? e.getBoundingClientRect().top : 0;
  XQ(n, r == 0 ? 0 : r - t);
}
function XQ(e, t) {
  for (let n = 0; n < e.length; n++) {
    let { dom: r, top: i, left: o } = e[n];
    r.scrollTop != i + t && (r.scrollTop = i + t), r.scrollLeft != o && (r.scrollLeft = o);
  }
}
let Xu = null;
function zze(e) {
  if (e.setActive)
    return e.setActive();
  if (Xu)
    return e.focus(Xu);
  let t = ZQ(e);
  e.focus(Xu == null ? {
    get preventScroll() {
      return Xu = { preventScroll: !0 }, !0;
    }
  } : void 0), Xu || (Xu = !1, XQ(t, 0));
}
function JQ(e, t) {
  let n, r = 2e8, i, o = 0, a = t.top, s = t.top, l, u;
  for (let c = e.firstChild, f = 0; c; c = c.nextSibling, f++) {
    let h;
    if (c.nodeType == 1)
      h = c.getClientRects();
    else if (c.nodeType == 3)
      h = Ca(c).getClientRects();
    else
      continue;
    for (let m = 0; m < h.length; m++) {
      let v = h[m];
      if (v.top <= a && v.bottom >= s) {
        a = Math.max(v.bottom, a), s = Math.min(v.top, s);
        let g = v.left > t.left ? v.left - t.left : v.right < t.left ? t.left - v.right : 0;
        if (g < r) {
          n = c, r = g, i = g && n.nodeType == 3 ? {
            left: v.right < t.left ? v.right : v.left,
            top: t.top
          } : t, c.nodeType == 1 && g && (o = f + (t.left >= (v.left + v.right) / 2 ? 1 : 0));
          continue;
        }
      } else v.top > t.top && !l && v.left <= t.left && v.right >= t.left && (l = c, u = { left: Math.max(v.left, Math.min(v.right, t.left)), top: v.top });
      !n && (t.left >= v.right && t.top >= v.top || t.left >= v.left && t.top >= v.bottom) && (o = f + 1);
    }
  }
  return !n && l && (n = l, i = u, r = 0), n && n.nodeType == 3 ? Wze(n, i) : !n || r && n.nodeType == 1 ? { node: e, offset: o } : JQ(n, i);
}
function Wze(e, t) {
  let n = e.nodeValue.length, r = document.createRange();
  for (let i = 0; i < n; i++) {
    r.setEnd(e, i + 1), r.setStart(e, i);
    let o = vs(r, 1);
    if (o.top != o.bottom && $_(t, o))
      return { node: e, offset: i + (t.left >= (o.left + o.right) / 2 ? 1 : 0) };
  }
  return { node: e, offset: 0 };
}
function $_(e, t) {
  return e.left >= t.left - 1 && e.left <= t.right + 1 && e.top >= t.top - 1 && e.top <= t.bottom + 1;
}
function Hze(e, t) {
  let n = e.parentNode;
  return n && /^li$/i.test(n.nodeName) && t.left < e.getBoundingClientRect().left ? n : e;
}
function Uze(e, t, n) {
  let { node: r, offset: i } = JQ(t, n), o = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let a = r.getBoundingClientRect();
    o = a.left != a.right && n.left > (a.left + a.right) / 2 ? 1 : -1;
  }
  return e.docView.posFromDOM(r, i, o);
}
function Gze(e, t, n, r) {
  let i = -1;
  for (let o = t, a = !1; o != e.dom; ) {
    let s = e.docView.nearestDesc(o, !0);
    if (!s)
      return null;
    if (s.dom.nodeType == 1 && (s.node.isBlock && s.parent || !s.contentDOM)) {
      let l = s.dom.getBoundingClientRect();
      if (s.node.isBlock && s.parent && (!a && l.left > r.left || l.top > r.top ? i = s.posBefore : (!a && l.right < r.left || l.bottom < r.top) && (i = s.posAfter), a = !0), !s.contentDOM && i < 0 && !s.node.isText)
        return (s.node.isBlock ? r.top < (l.top + l.bottom) / 2 : r.left < (l.left + l.right) / 2) ? s.posBefore : s.posAfter;
    }
    o = s.dom.parentNode;
  }
  return i > -1 ? i : e.docView.posFromDOM(t, n, -1);
}
function QQ(e, t, n) {
  let r = e.childNodes.length;
  if (r && n.top < n.bottom)
    for (let i = Math.max(0, Math.min(r - 1, Math.floor(r * (t.top - n.top) / (n.bottom - n.top)) - 2)), o = i; ; ) {
      let a = e.childNodes[o];
      if (a.nodeType == 1) {
        let s = a.getClientRects();
        for (let l = 0; l < s.length; l++) {
          let u = s[l];
          if ($_(t, u))
            return QQ(a, t, u);
        }
      }
      if ((o = (o + 1) % r) == i)
        break;
    }
  return e;
}
function Kze(e, t) {
  let n = e.dom.ownerDocument, r, i = 0, o = $ze(n, t.left, t.top);
  o && ({ node: r, offset: i } = o);
  let a = (e.root.elementFromPoint ? e.root : n).elementFromPoint(t.left, t.top), s;
  if (!a || !e.dom.contains(a.nodeType != 1 ? a.parentNode : a)) {
    let u = e.dom.getBoundingClientRect();
    if (!$_(t, u) || (a = QQ(e.dom, t, u), !a))
      return null;
  }
  if (Mr)
    for (let u = a; r && u; u = Wh(u))
      u.draggable && (r = void 0);
  if (a = Hze(a, t), r) {
    if (mo && r.nodeType == 1 && (i = Math.min(i, r.childNodes.length), i < r.childNodes.length)) {
      let c = r.childNodes[i], f;
      c.nodeName == "IMG" && (f = c.getBoundingClientRect()).right <= t.left && f.bottom > t.top && i++;
    }
    let u;
    Lp && i && r.nodeType == 1 && (u = r.childNodes[i - 1]).nodeType == 1 && u.contentEditable == "false" && u.getBoundingClientRect().top >= t.top && i--, r == e.dom && i == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && t.top > r.lastChild.getBoundingClientRect().bottom ? s = e.state.doc.content.size : (i == 0 || r.nodeType != 1 || r.childNodes[i - 1].nodeName != "BR") && (s = Gze(e, r, i, t));
  }
  s == null && (s = Uze(e, a, t));
  let l = e.docView.nearestDesc(a, !0);
  return { pos: s, inside: l ? l.posAtStart - l.border : -1 };
}
function IL(e) {
  return e.top < e.bottom || e.left < e.right;
}
function vs(e, t) {
  let n = e.getClientRects();
  if (n.length) {
    let r = n[t < 0 ? 0 : n.length - 1];
    if (IL(r))
      return r;
  }
  return Array.prototype.find.call(n, IL) || e.getBoundingClientRect();
}
const Yze = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function eee(e, t, n) {
  let { node: r, offset: i, atom: o } = e.docView.domFromPos(t, n < 0 ? -1 : 1), a = Lp || mo;
  if (r.nodeType == 3)
    if (a && (Yze.test(r.nodeValue) || (n < 0 ? !i : i == r.nodeValue.length))) {
      let l = vs(Ca(r, i, i), n);
      if (mo && i && /\s/.test(r.nodeValue[i - 1]) && i < r.nodeValue.length) {
        let u = vs(Ca(r, i - 1, i - 1), -1);
        if (u.top == l.top) {
          let c = vs(Ca(r, i, i + 1), -1);
          if (c.top != l.top)
            return Sf(c, c.left < u.left);
        }
      }
      return l;
    } else {
      let l = i, u = i, c = n < 0 ? 1 : -1;
      return n < 0 && !i ? (u++, c = -1) : n >= 0 && i == r.nodeValue.length ? (l--, c = 1) : n < 0 ? l-- : u++, Sf(vs(Ca(r, l, u), c), c < 0);
    }
  if (!e.state.doc.resolve(t - (o || 0)).parent.inlineContent) {
    if (o == null && i && (n < 0 || i == Pi(r))) {
      let l = r.childNodes[i - 1];
      if (l.nodeType == 1)
        return I8(l.getBoundingClientRect(), !1);
    }
    if (o == null && i < Pi(r)) {
      let l = r.childNodes[i];
      if (l.nodeType == 1)
        return I8(l.getBoundingClientRect(), !0);
    }
    return I8(r.getBoundingClientRect(), n >= 0);
  }
  if (o == null && i && (n < 0 || i == Pi(r))) {
    let l = r.childNodes[i - 1], u = l.nodeType == 3 ? Ca(l, Pi(l) - (a ? 0 : 1)) : l.nodeType == 1 && (l.nodeName != "BR" || !l.nextSibling) ? l : null;
    if (u)
      return Sf(vs(u, 1), !1);
  }
  if (o == null && i < Pi(r)) {
    let l = r.childNodes[i];
    for (; l.pmViewDesc && l.pmViewDesc.ignoreForCoords; )
      l = l.nextSibling;
    let u = l ? l.nodeType == 3 ? Ca(l, 0, a ? 0 : 1) : l.nodeType == 1 ? l : null : null;
    if (u)
      return Sf(vs(u, -1), !0);
  }
  return Sf(vs(r.nodeType == 3 ? Ca(r) : r, -n), n >= 0);
}
function Sf(e, t) {
  if (e.width == 0)
    return e;
  let n = t ? e.left : e.right;
  return { top: e.top, bottom: e.bottom, left: n, right: n };
}
function I8(e, t) {
  if (e.height == 0)
    return e;
  let n = t ? e.top : e.bottom;
  return { top: n, bottom: n, left: e.left, right: e.right };
}
function tee(e, t, n) {
  let r = e.state, i = e.root.activeElement;
  r != t && e.updateState(t), i != e.dom && e.focus();
  try {
    return n();
  } finally {
    r != t && e.updateState(r), i != e.dom && i && i.focus();
  }
}
function Zze(e, t, n) {
  let r = t.selection, i = n == "up" ? r.$from : r.$to;
  return tee(e, t, () => {
    let { node: o } = e.docView.domFromPos(i.pos, n == "up" ? -1 : 1);
    for (; ; ) {
      let s = e.docView.nearestDesc(o, !0);
      if (!s)
        break;
      if (s.node.isBlock) {
        o = s.contentDOM || s.dom;
        break;
      }
      o = s.dom.parentNode;
    }
    let a = eee(e, i.pos, 1);
    for (let s = o.firstChild; s; s = s.nextSibling) {
      let l;
      if (s.nodeType == 1)
        l = s.getClientRects();
      else if (s.nodeType == 3)
        l = Ca(s, 0, s.nodeValue.length).getClientRects();
      else
        continue;
      for (let u = 0; u < l.length; u++) {
        let c = l[u];
        if (c.bottom > c.top + 1 && (n == "up" ? a.top - c.top > (c.bottom - a.top) * 2 : c.bottom - a.bottom > (a.bottom - c.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const Xze = /[\u0590-\u08ac]/;
function Jze(e, t, n) {
  let { $head: r } = t.selection;
  if (!r.parent.isTextblock)
    return !1;
  let i = r.parentOffset, o = !i, a = i == r.parent.content.size, s = e.domSelection();
  return s ? !Xze.test(r.parent.textContent) || !s.modify ? n == "left" || n == "backward" ? o : a : tee(e, t, () => {
    let { focusNode: l, focusOffset: u, anchorNode: c, anchorOffset: f } = e.domSelectionRange(), h = s.caretBidiLevel;
    s.modify("move", n, "character");
    let m = r.depth ? e.docView.domAfterPos(r.before()) : e.dom, { focusNode: v, focusOffset: g } = e.domSelectionRange(), y = v && !m.contains(v.nodeType == 1 ? v : v.parentNode) || l == v && u == g;
    try {
      s.collapse(c, f), l && (l != c || u != f) && s.extend && s.extend(l, u);
    } catch {
    }
    return h != null && (s.caretBidiLevel = h), y;
  }) : r.pos == r.start() || r.pos == r.end();
}
let $L = null, LL = null, FL = !1;
function Qze(e, t, n) {
  return $L == t && LL == n ? FL : ($L = t, LL = n, FL = n == "up" || n == "down" ? Zze(e, t, n) : Jze(e, t, n));
}
const $i = 0, BL = 1, Rl = 2, Ko = 3;
class Fp {
  constructor(t, n, r, i) {
    this.parent = t, this.children = n, this.dom = r, this.contentDOM = i, this.dirty = $i, r.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(t) {
    return !1;
  }
  matchesMark(t) {
    return !1;
  }
  matchesNode(t, n, r) {
    return !1;
  }
  matchesHack(t) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(t) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let t = 0;
    for (let n = 0; n < this.children.length; n++)
      t += this.children[n].size;
    return t;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let t = 0; t < this.children.length; t++)
      this.children[t].destroy();
  }
  posBeforeChild(t) {
    for (let n = 0, r = this.posAtStart; ; n++) {
      let i = this.children[n];
      if (i == t)
        return r;
      r += i.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(t, n, r) {
    if (this.contentDOM && this.contentDOM.contains(t.nodeType == 1 ? t : t.parentNode))
      if (r < 0) {
        let o, a;
        if (t == this.contentDOM)
          o = t.childNodes[n - 1];
        else {
          for (; t.parentNode != this.contentDOM; )
            t = t.parentNode;
          o = t.previousSibling;
        }
        for (; o && !((a = o.pmViewDesc) && a.parent == this); )
          o = o.previousSibling;
        return o ? this.posBeforeChild(a) + a.size : this.posAtStart;
      } else {
        let o, a;
        if (t == this.contentDOM)
          o = t.childNodes[n];
        else {
          for (; t.parentNode != this.contentDOM; )
            t = t.parentNode;
          o = t.nextSibling;
        }
        for (; o && !((a = o.pmViewDesc) && a.parent == this); )
          o = o.nextSibling;
        return o ? this.posBeforeChild(a) : this.posAtEnd;
      }
    let i;
    if (t == this.dom && this.contentDOM)
      i = n > tr(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      i = t.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (n == 0)
        for (let o = t; ; o = o.parentNode) {
          if (o == this.dom) {
            i = !1;
            break;
          }
          if (o.previousSibling)
            break;
        }
      if (i == null && n == t.childNodes.length)
        for (let o = t; ; o = o.parentNode) {
          if (o == this.dom) {
            i = !0;
            break;
          }
          if (o.nextSibling)
            break;
        }
    }
    return i ?? r > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(t, n = !1) {
    for (let r = !0, i = t; i; i = i.parentNode) {
      let o = this.getDesc(i), a;
      if (o && (!n || o.node))
        if (r && (a = o.nodeDOM) && !(a.nodeType == 1 ? a.contains(t.nodeType == 1 ? t : t.parentNode) : a == t))
          r = !1;
        else
          return o;
    }
  }
  getDesc(t) {
    let n = t.pmViewDesc;
    for (let r = n; r; r = r.parent)
      if (r == this)
        return n;
  }
  posFromDOM(t, n, r) {
    for (let i = t; i; i = i.parentNode) {
      let o = this.getDesc(i);
      if (o)
        return o.localPosFromDOM(t, n, r);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(t) {
    for (let n = 0, r = 0; n < this.children.length; n++) {
      let i = this.children[n], o = r + i.size;
      if (r == t && o != r) {
        for (; !i.border && i.children.length; )
          i = i.children[0];
        return i;
      }
      if (t < o)
        return i.descAt(t - r - i.border);
      r = o;
    }
  }
  domFromPos(t, n) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: t + 1 };
    let r = 0, i = 0;
    for (let o = 0; r < this.children.length; r++) {
      let a = this.children[r], s = o + a.size;
      if (s > t || a instanceof ree) {
        i = t - o;
        break;
      }
      o = s;
    }
    if (i)
      return this.children[r].domFromPos(i - this.children[r].border, n);
    for (let o; r && !(o = this.children[r - 1]).size && o instanceof nee && o.side >= 0; r--)
      ;
    if (n <= 0) {
      let o, a = !0;
      for (; o = r ? this.children[r - 1] : null, !(!o || o.dom.parentNode == this.contentDOM); r--, a = !1)
        ;
      return o && n && a && !o.border && !o.domAtom ? o.domFromPos(o.size, n) : { node: this.contentDOM, offset: o ? tr(o.dom) + 1 : 0 };
    } else {
      let o, a = !0;
      for (; o = r < this.children.length ? this.children[r] : null, !(!o || o.dom.parentNode == this.contentDOM); r++, a = !1)
        ;
      return o && a && !o.border && !o.domAtom ? o.domFromPos(0, n) : { node: this.contentDOM, offset: o ? tr(o.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(t, n, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: t, to: n, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let i = -1, o = -1;
    for (let a = r, s = 0; ; s++) {
      let l = this.children[s], u = a + l.size;
      if (i == -1 && t <= u) {
        let c = a + l.border;
        if (t >= c && n <= u - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
          return l.parseRange(t, n, c);
        t = a;
        for (let f = s; f > 0; f--) {
          let h = this.children[f - 1];
          if (h.size && h.dom.parentNode == this.contentDOM && !h.emptyChildAt(1)) {
            i = tr(h.dom) + 1;
            break;
          }
          t -= h.size;
        }
        i == -1 && (i = 0);
      }
      if (i > -1 && (u > n || s == this.children.length - 1)) {
        n = u;
        for (let c = s + 1; c < this.children.length; c++) {
          let f = this.children[c];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(-1)) {
            o = tr(f.dom);
            break;
          }
          n += f.size;
        }
        o == -1 && (o = this.contentDOM.childNodes.length);
        break;
      }
      a = u;
    }
    return { node: this.contentDOM, from: t, to: n, fromOffset: i, toOffset: o };
  }
  emptyChildAt(t) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let n = this.children[t < 0 ? 0 : this.children.length - 1];
    return n.size == 0 || n.emptyChildAt(t);
  }
  domAfterPos(t) {
    let { node: n, offset: r } = this.domFromPos(t, 0);
    if (n.nodeType != 1 || r == n.childNodes.length)
      throw new RangeError("No node after pos " + t);
    return n.childNodes[r];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(t, n, r, i = !1) {
    let o = Math.min(t, n), a = Math.max(t, n);
    for (let h = 0, m = 0; h < this.children.length; h++) {
      let v = this.children[h], g = m + v.size;
      if (o > m && a < g)
        return v.setSelection(t - m - v.border, n - m - v.border, r, i);
      m = g;
    }
    let s = this.domFromPos(t, t ? -1 : 1), l = n == t ? s : this.domFromPos(n, n ? -1 : 1), u = r.getSelection(), c = !1;
    if ((mo || Mr) && t == n) {
      let { node: h, offset: m } = s;
      if (h.nodeType == 3) {
        if (c = !!(m && h.nodeValue[m - 1] == `
`), c && m == h.nodeValue.length)
          for (let v = h, g; v; v = v.parentNode) {
            if (g = v.nextSibling) {
              g.nodeName == "BR" && (s = l = { node: g.parentNode, offset: tr(g) + 1 });
              break;
            }
            let y = v.pmViewDesc;
            if (y && y.node && y.node.isBlock)
              break;
          }
      } else {
        let v = h.childNodes[m - 1];
        c = v && (v.nodeName == "BR" || v.contentEditable == "false");
      }
    }
    if (mo && u.focusNode && u.focusNode != l.node && u.focusNode.nodeType == 1) {
      let h = u.focusNode.childNodes[u.focusOffset];
      h && h.contentEditable == "false" && (i = !0);
    }
    if (!(i || c && Mr) && iu(s.node, s.offset, u.anchorNode, u.anchorOffset) && iu(l.node, l.offset, u.focusNode, u.focusOffset))
      return;
    let f = !1;
    if ((u.extend || t == n) && !c) {
      u.collapse(s.node, s.offset);
      try {
        t != n && u.extend(l.node, l.offset), f = !0;
      } catch {
      }
    }
    if (!f) {
      if (t > n) {
        let m = s;
        s = l, l = m;
      }
      let h = document.createRange();
      h.setEnd(l.node, l.offset), h.setStart(s.node, s.offset), u.removeAllRanges(), u.addRange(h);
    }
  }
  ignoreMutation(t) {
    return !this.contentDOM && t.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(t, n) {
    for (let r = 0, i = 0; i < this.children.length; i++) {
      let o = this.children[i], a = r + o.size;
      if (r == a ? t <= a && n >= r : t < a && n > r) {
        let s = r + o.border, l = a - o.border;
        if (t >= s && n <= l) {
          this.dirty = t == r || n == a ? Rl : BL, t == s && n == l && (o.contentLost || o.dom.parentNode != this.contentDOM) ? o.dirty = Ko : o.markDirty(t - s, n - s);
          return;
        } else
          o.dirty = o.dom == o.contentDOM && o.dom.parentNode == this.contentDOM && !o.children.length ? Rl : Ko;
      }
      r = a;
    }
    this.dirty = Rl;
  }
  markParentsDirty() {
    let t = 1;
    for (let n = this.parent; n; n = n.parent, t++) {
      let r = t == 1 ? Rl : BL;
      n.dirty < r && (n.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  isText(t) {
    return !1;
  }
}
class nee extends Fp {
  constructor(t, n, r, i) {
    let o, a = n.type.toDOM;
    if (typeof a == "function" && (a = a(r, () => {
      if (!o)
        return i;
      if (o.parent)
        return o.parent.posBeforeChild(o);
    })), !n.type.spec.raw) {
      if (a.nodeType != 1) {
        let s = document.createElement("span");
        s.appendChild(a), a = s;
      }
      a.contentEditable = "false", a.classList.add("ProseMirror-widget");
    }
    super(t, [], a, null), this.widget = n, this.widget = n, o = this;
  }
  matchesWidget(t) {
    return this.dirty == $i && t.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(t) {
    let n = this.widget.spec.stopEvent;
    return n ? n(t) : !1;
  }
  ignoreMutation(t) {
    return t.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get side() {
    return this.widget.type.side;
  }
}
class eWe extends Fp {
  constructor(t, n, r, i) {
    super(t, [], n, null), this.textDOM = r, this.text = i;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(t, n) {
    return t != this.textDOM ? this.posAtStart + (n ? this.size : 0) : this.posAtStart + n;
  }
  domFromPos(t) {
    return { node: this.textDOM, offset: t };
  }
  ignoreMutation(t) {
    return t.type === "characterData" && t.target.nodeValue == t.oldValue;
  }
}
class ou extends Fp {
  constructor(t, n, r, i, o) {
    super(t, [], r, i), this.mark = n, this.spec = o;
  }
  static create(t, n, r, i) {
    let o = i.nodeViews[n.type.name], a = o && o(n, i, r);
    return (!a || !a.dom) && (a = vu.renderSpec(document, n.type.spec.toDOM(n, r), null, n.attrs)), new ou(t, n, a.dom, a.contentDOM || a.dom, a);
  }
  parseRule() {
    return this.dirty & Ko || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(t) {
    return this.dirty != Ko && this.mark.eq(t);
  }
  markDirty(t, n) {
    if (super.markDirty(t, n), this.dirty != $i) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = $i;
    }
  }
  slice(t, n, r) {
    let i = ou.create(this.parent, this.mark, !0, r), o = this.children, a = this.size;
    n < a && (o = nw(o, n, a, r)), t > 0 && (o = nw(o, 0, t, r));
    for (let s = 0; s < o.length; s++)
      o[s].parent = i;
    return i.children = o, i;
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class Ls extends Fp {
  constructor(t, n, r, i, o, a, s, l, u) {
    super(t, [], o, a), this.node = n, this.outerDeco = r, this.innerDeco = i, this.nodeDOM = s;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(t, n, r, i, o, a) {
    let s = o.nodeViews[n.type.name], l, u = s && s(n, o, () => {
      if (!l)
        return a;
      if (l.parent)
        return l.parent.posBeforeChild(l);
    }, r, i), c = u && u.dom, f = u && u.contentDOM;
    if (n.isText) {
      if (!c)
        c = document.createTextNode(n.text);
      else if (c.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else c || ({ dom: c, contentDOM: f } = vu.renderSpec(document, n.type.spec.toDOM(n), null, n.attrs));
    !f && !n.isText && c.nodeName != "BR" && (c.hasAttribute("contenteditable") || (c.contentEditable = "false"), n.type.spec.draggable && (c.draggable = !0));
    let h = c;
    return c = aee(c, r, n), u ? l = new tWe(t, n, r, i, c, f || null, h, u, o, a + 1) : n.isText ? new Fv(t, n, r, i, c, h, o) : new Ls(t, n, r, i, c, f || null, h, o, a + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let t = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (t.preserveWhitespace = "full"), !this.contentDOM)
      t.getContent = () => this.node.content;
    else if (!this.contentLost)
      t.contentElement = this.contentDOM;
    else {
      for (let n = this.children.length - 1; n >= 0; n--) {
        let r = this.children[n];
        if (this.dom.contains(r.dom.parentNode)) {
          t.contentElement = r.dom.parentNode;
          break;
        }
      }
      t.contentElement || (t.getContent = () => he.empty);
    }
    return t;
  }
  matchesNode(t, n, r) {
    return this.dirty == $i && t.eq(this.node) && Cg(n, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(t, n) {
    let r = this.node.inlineContent, i = n, o = t.composing ? this.localCompositionInfo(t, n) : null, a = o && o.pos > -1 ? o : null, s = o && o.pos < 0, l = new rWe(this, a && a.node, t);
    aWe(this.node, this.innerDeco, (u, c, f) => {
      u.spec.marks ? l.syncToMarks(u.spec.marks, r, t) : u.type.side >= 0 && !f && l.syncToMarks(c == this.node.childCount ? Ot.none : this.node.child(c).marks, r, t), l.placeWidget(u, t, i);
    }, (u, c, f, h) => {
      l.syncToMarks(u.marks, r, t);
      let m;
      l.findNodeMatch(u, c, f, h) || s && t.state.selection.from > i && t.state.selection.to < i + u.nodeSize && (m = l.findIndexWithChild(o.node)) > -1 && l.updateNodeAt(u, c, f, m, t) || l.updateNextNode(u, c, f, t, h, i) || l.addNode(u, c, f, t, i), i += u.nodeSize;
    }), l.syncToMarks([], r, t), this.node.isTextblock && l.addTextblockHacks(), l.destroyRest(), (l.changed || this.dirty == Rl) && (a && this.protectLocalComposition(t, a), iee(this.contentDOM, this.children, t), cd && sWe(this.dom));
  }
  localCompositionInfo(t, n) {
    let { from: r, to: i } = t.state.selection;
    if (!(t.state.selection instanceof Ze) || r < n || i > n + this.node.content.size)
      return null;
    let o = t.input.compositionNode;
    if (!o || !this.dom.contains(o.parentNode))
      return null;
    if (this.node.inlineContent) {
      let a = o.nodeValue, s = lWe(this.node.content, a, r - n, i - n);
      return s < 0 ? null : { node: o, pos: s, text: a };
    } else
      return { node: o, pos: -1, text: "" };
  }
  protectLocalComposition(t, { node: n, pos: r, text: i }) {
    if (this.getDesc(n))
      return;
    let o = n;
    for (; o.parentNode != this.contentDOM; o = o.parentNode) {
      for (; o.previousSibling; )
        o.parentNode.removeChild(o.previousSibling);
      for (; o.nextSibling; )
        o.parentNode.removeChild(o.nextSibling);
      o.pmViewDesc && (o.pmViewDesc = void 0);
    }
    let a = new eWe(this, o, n, i);
    t.input.compositionNodes.push(a), this.children = nw(this.children, r, r + i.length, t, a);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(t, n, r, i) {
    return this.dirty == Ko || !t.sameMarkup(this.node) ? !1 : (this.updateInner(t, n, r, i), !0);
  }
  updateInner(t, n, r, i) {
    this.updateOuterDeco(n), this.node = t, this.innerDeco = r, this.contentDOM && this.updateChildren(i, this.posAtStart), this.dirty = $i;
  }
  updateOuterDeco(t) {
    if (Cg(t, this.outerDeco))
      return;
    let n = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = oee(this.dom, this.nodeDOM, tw(this.outerDeco, this.node, n), tw(t, this.node, n)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = t;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function jL(e, t, n, r, i) {
  aee(r, t, e);
  let o = new Ls(void 0, e, t, n, r, r, r, i, 0);
  return o.contentDOM && o.updateChildren(i, 0), o;
}
class Fv extends Ls {
  constructor(t, n, r, i, o, a, s) {
    super(t, n, r, i, o, null, a, s, 0);
  }
  parseRule() {
    let t = this.nodeDOM.parentNode;
    for (; t && t != this.dom && !t.pmIsDeco; )
      t = t.parentNode;
    return { skip: t || !0 };
  }
  update(t, n, r, i) {
    return this.dirty == Ko || this.dirty != $i && !this.inParent() || !t.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(n), (this.dirty != $i || t.text != this.node.text) && t.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = t.text, i.trackWrites == this.nodeDOM && (i.trackWrites = null)), this.node = t, this.dirty = $i, !0);
  }
  inParent() {
    let t = this.parent.contentDOM;
    for (let n = this.nodeDOM; n; n = n.parentNode)
      if (n == t)
        return !0;
    return !1;
  }
  domFromPos(t) {
    return { node: this.nodeDOM, offset: t };
  }
  localPosFromDOM(t, n, r) {
    return t == this.nodeDOM ? this.posAtStart + Math.min(n, this.node.text.length) : super.localPosFromDOM(t, n, r);
  }
  ignoreMutation(t) {
    return t.type != "characterData" && t.type != "selection";
  }
  slice(t, n, r) {
    let i = this.node.cut(t, n), o = document.createTextNode(i.text);
    return new Fv(this.parent, i, this.outerDeco, this.innerDeco, o, o, r);
  }
  markDirty(t, n) {
    super.markDirty(t, n), this.dom != this.nodeDOM && (t == 0 || n == this.nodeDOM.nodeValue.length) && (this.dirty = Ko);
  }
  get domAtom() {
    return !1;
  }
  isText(t) {
    return this.node.text == t;
  }
}
class ree extends Fp {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(t) {
    return this.dirty == $i && this.dom.nodeName == t;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class tWe extends Ls {
  constructor(t, n, r, i, o, a, s, l, u, c) {
    super(t, n, r, i, o, a, s, u, c), this.spec = l;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(t, n, r, i) {
    if (this.dirty == Ko)
      return !1;
    if (this.spec.update && (this.node.type == t.type || this.spec.multiType)) {
      let o = this.spec.update(t, n, r);
      return o && this.updateInner(t, n, r, i), o;
    } else return !this.contentDOM && !t.isLeaf ? !1 : super.update(t, n, r, i);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(t, n, r, i) {
    this.spec.setSelection ? this.spec.setSelection(t, n, r) : super.setSelection(t, n, r, i);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(t) {
    return this.spec.stopEvent ? this.spec.stopEvent(t) : !1;
  }
  ignoreMutation(t) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(t) : super.ignoreMutation(t);
  }
}
function iee(e, t, n) {
  let r = e.firstChild, i = !1;
  for (let o = 0; o < t.length; o++) {
    let a = t[o], s = a.dom;
    if (s.parentNode == e) {
      for (; s != r; )
        r = VL(r), i = !0;
      r = r.nextSibling;
    } else
      i = !0, e.insertBefore(s, r);
    if (a instanceof ou) {
      let l = r ? r.previousSibling : e.lastChild;
      iee(a.contentDOM, a.children, n), r = l ? l.nextSibling : e.firstChild;
    }
  }
  for (; r; )
    r = VL(r), i = !0;
  i && n.trackWrites == e && (n.trackWrites = null);
}
const Gf = function(e) {
  e && (this.nodeName = e);
};
Gf.prototype = /* @__PURE__ */ Object.create(null);
const Dl = [new Gf()];
function tw(e, t, n) {
  if (e.length == 0)
    return Dl;
  let r = n ? Dl[0] : new Gf(), i = [r];
  for (let o = 0; o < e.length; o++) {
    let a = e[o].type.attrs;
    if (a) {
      a.nodeName && i.push(r = new Gf(a.nodeName));
      for (let s in a) {
        let l = a[s];
        l != null && (n && i.length == 1 && i.push(r = new Gf(t.isInline ? "span" : "div")), s == "class" ? r.class = (r.class ? r.class + " " : "") + l : s == "style" ? r.style = (r.style ? r.style + ";" : "") + l : s != "nodeName" && (r[s] = l));
      }
    }
  }
  return i;
}
function oee(e, t, n, r) {
  if (n == Dl && r == Dl)
    return t;
  let i = t;
  for (let o = 0; o < r.length; o++) {
    let a = r[o], s = n[o];
    if (o) {
      let l;
      s && s.nodeName == a.nodeName && i != e && (l = i.parentNode) && l.nodeName.toLowerCase() == a.nodeName || (l = document.createElement(a.nodeName), l.pmIsDeco = !0, l.appendChild(i), s = Dl[0]), i = l;
    }
    nWe(i, s || Dl[0], a);
  }
  return i;
}
function nWe(e, t, n) {
  for (let r in t)
    r != "class" && r != "style" && r != "nodeName" && !(r in n) && e.removeAttribute(r);
  for (let r in n)
    r != "class" && r != "style" && r != "nodeName" && n[r] != t[r] && e.setAttribute(r, n[r]);
  if (t.class != n.class) {
    let r = t.class ? t.class.split(" ").filter(Boolean) : [], i = n.class ? n.class.split(" ").filter(Boolean) : [];
    for (let o = 0; o < r.length; o++)
      i.indexOf(r[o]) == -1 && e.classList.remove(r[o]);
    for (let o = 0; o < i.length; o++)
      r.indexOf(i[o]) == -1 && e.classList.add(i[o]);
    e.classList.length == 0 && e.removeAttribute("class");
  }
  if (t.style != n.style) {
    if (t.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, i;
      for (; i = r.exec(t.style); )
        e.style.removeProperty(i[1]);
    }
    n.style && (e.style.cssText += n.style);
  }
}
function aee(e, t, n) {
  return oee(e, e, Dl, tw(t, n, e.nodeType != 1));
}
function Cg(e, t) {
  if (e.length != t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (!e[n].type.eq(t[n].type))
      return !1;
  return !0;
}
function VL(e) {
  let t = e.nextSibling;
  return e.parentNode.removeChild(e), t;
}
class rWe {
  constructor(t, n, r) {
    this.lock = n, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = t, this.preMatch = iWe(t.node.content, t);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(t, n) {
    if (t != n) {
      for (let r = t; r < n; r++)
        this.top.children[r].destroy();
      this.top.children.splice(t, n - t), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(t, n, r) {
    let i = 0, o = this.stack.length >> 1, a = Math.min(o, t.length);
    for (; i < a && (i == o - 1 ? this.top : this.stack[i + 1 << 1]).matchesMark(t[i]) && t[i].type.spec.spanning !== !1; )
      i++;
    for (; i < o; )
      this.destroyRest(), this.top.dirty = $i, this.index = this.stack.pop(), this.top = this.stack.pop(), o--;
    for (; o < t.length; ) {
      this.stack.push(this.top, this.index + 1);
      let s = -1;
      for (let l = this.index; l < Math.min(this.index + 3, this.top.children.length); l++) {
        let u = this.top.children[l];
        if (u.matchesMark(t[o]) && !this.isLocked(u.dom)) {
          s = l;
          break;
        }
      }
      if (s > -1)
        s > this.index && (this.changed = !0, this.destroyBetween(this.index, s)), this.top = this.top.children[this.index];
      else {
        let l = ou.create(this.top, t[o], n, r);
        this.top.children.splice(this.index, 0, l), this.top = l, this.changed = !0;
      }
      this.index = 0, o++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(t, n, r, i) {
    let o = -1, a;
    if (i >= this.preMatch.index && (a = this.preMatch.matches[i - this.preMatch.index]).parent == this.top && a.matchesNode(t, n, r))
      o = this.top.children.indexOf(a, this.index);
    else
      for (let s = this.index, l = Math.min(this.top.children.length, s + 5); s < l; s++) {
        let u = this.top.children[s];
        if (u.matchesNode(t, n, r) && !this.preMatch.matched.has(u)) {
          o = s;
          break;
        }
      }
    return o < 0 ? !1 : (this.destroyBetween(this.index, o), this.index++, !0);
  }
  updateNodeAt(t, n, r, i, o) {
    let a = this.top.children[i];
    return a.dirty == Ko && a.dom == a.contentDOM && (a.dirty = Rl), a.update(t, n, r, o) ? (this.destroyBetween(this.index, i), this.index++, !0) : !1;
  }
  findIndexWithChild(t) {
    for (; ; ) {
      let n = t.parentNode;
      if (!n)
        return -1;
      if (n == this.top.contentDOM) {
        let r = t.pmViewDesc;
        if (r) {
          for (let i = this.index; i < this.top.children.length; i++)
            if (this.top.children[i] == r)
              return i;
        }
        return -1;
      }
      t = n;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(t, n, r, i, o, a) {
    for (let s = this.index; s < this.top.children.length; s++) {
      let l = this.top.children[s];
      if (l instanceof Ls) {
        let u = this.preMatch.matched.get(l);
        if (u != null && u != o)
          return !1;
        let c = l.dom, f, h = this.isLocked(c) && !(t.isText && l.node && l.node.isText && l.nodeDOM.nodeValue == t.text && l.dirty != Ko && Cg(n, l.outerDeco));
        if (!h && l.update(t, n, r, i))
          return this.destroyBetween(this.index, s), l.dom != c && (this.changed = !0), this.index++, !0;
        if (!h && (f = this.recreateWrapper(l, t, n, r, i, a)))
          return this.destroyBetween(this.index, s), this.top.children[this.index] = f, f.contentDOM && (f.dirty = Rl, f.updateChildren(i, a + 1), f.dirty = $i), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(t, n, r, i, o, a) {
    if (t.dirty || n.isAtom || !t.children.length || !t.node.content.eq(n.content) || !Cg(r, t.outerDeco) || !i.eq(t.innerDeco))
      return null;
    let s = Ls.create(this.top, n, r, i, o, a);
    if (s.contentDOM) {
      s.children = t.children, t.children = [];
      for (let l of s.children)
        l.parent = s;
    }
    return t.destroy(), s;
  }
  // Insert the node as a newly created node desc.
  addNode(t, n, r, i, o) {
    let a = Ls.create(this.top, t, n, r, i, o);
    a.contentDOM && a.updateChildren(i, o + 1), this.top.children.splice(this.index++, 0, a), this.changed = !0;
  }
  placeWidget(t, n, r) {
    let i = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (i && i.matchesWidget(t) && (t == i.widget || !i.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let o = new nee(this.top, t, n, r);
      this.top.children.splice(this.index++, 0, o), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let t = this.top.children[this.index - 1], n = this.top;
    for (; t instanceof ou; )
      n = t, t = n.children[n.children.length - 1];
    (!t || // Empty textblock
    !(t instanceof Fv) || /\n$/.test(t.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(t.node.text)) && ((Mr || vr) && t && t.dom.contentEditable == "false" && this.addHackNode("IMG", n), this.addHackNode("BR", this.top));
  }
  addHackNode(t, n) {
    if (n == this.top && this.index < n.children.length && n.children[this.index].matchesHack(t))
      this.index++;
    else {
      let r = document.createElement(t);
      t == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), t == "BR" && (r.className = "ProseMirror-trailingBreak");
      let i = new ree(this.top, [], r, null);
      n != this.top ? n.children.push(i) : n.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  isLocked(t) {
    return this.lock && (t == this.lock || t.nodeType == 1 && t.contains(this.lock.parentNode));
  }
}
function iWe(e, t) {
  let n = t, r = n.children.length, i = e.childCount, o = /* @__PURE__ */ new Map(), a = [];
  e: for (; i > 0; ) {
    let s;
    for (; ; )
      if (r) {
        let u = n.children[r - 1];
        if (u instanceof ou)
          n = u, r = u.children.length;
        else {
          s = u, r--;
          break;
        }
      } else {
        if (n == t)
          break e;
        r = n.parent.children.indexOf(n), n = n.parent;
      }
    let l = s.node;
    if (l) {
      if (l != e.child(i - 1))
        break;
      --i, o.set(s, i), a.push(s);
    }
  }
  return { index: i, matched: o, matches: a.reverse() };
}
function oWe(e, t) {
  return e.type.side - t.type.side;
}
function aWe(e, t, n, r) {
  let i = t.locals(e), o = 0;
  if (i.length == 0) {
    for (let u = 0; u < e.childCount; u++) {
      let c = e.child(u);
      r(c, i, t.forChild(o, c), u), o += c.nodeSize;
    }
    return;
  }
  let a = 0, s = [], l = null;
  for (let u = 0; ; ) {
    let c, f;
    for (; a < i.length && i[a].to == o; ) {
      let y = i[a++];
      y.widget && (c ? (f || (f = [c])).push(y) : c = y);
    }
    if (c)
      if (f) {
        f.sort(oWe);
        for (let y = 0; y < f.length; y++)
          n(f[y], u, !!l);
      } else
        n(c, u, !!l);
    let h, m;
    if (l)
      m = -1, h = l, l = null;
    else if (u < e.childCount)
      m = u, h = e.child(u++);
    else
      break;
    for (let y = 0; y < s.length; y++)
      s[y].to <= o && s.splice(y--, 1);
    for (; a < i.length && i[a].from <= o && i[a].to > o; )
      s.push(i[a++]);
    let v = o + h.nodeSize;
    if (h.isText) {
      let y = v;
      a < i.length && i[a].from < y && (y = i[a].from);
      for (let w = 0; w < s.length; w++)
        s[w].to < y && (y = s[w].to);
      y < v && (l = h.cut(y - o), h = h.cut(0, y - o), v = y, m = -1);
    } else
      for (; a < i.length && i[a].to < v; )
        a++;
    let g = h.isInline && !h.isLeaf ? s.filter((y) => !y.inline) : s.slice();
    r(h, g, t.forChild(o, h), m), o = v;
  }
}
function sWe(e) {
  if (e.nodeName == "UL" || e.nodeName == "OL") {
    let t = e.style.cssText;
    e.style.cssText = t + "; list-style: square !important", window.getComputedStyle(e).listStyle, e.style.cssText = t;
  }
}
function lWe(e, t, n, r) {
  for (let i = 0, o = 0; i < e.childCount && o <= r; ) {
    let a = e.child(i++), s = o;
    if (o += a.nodeSize, !a.isText)
      continue;
    let l = a.text;
    for (; i < e.childCount; ) {
      let u = e.child(i++);
      if (o += u.nodeSize, !u.isText)
        break;
      l += u.text;
    }
    if (o >= n) {
      if (o >= r && l.slice(r - t.length - s, r - s) == t)
        return r - t.length;
      let u = s < r ? l.lastIndexOf(t, r - s - 1) : -1;
      if (u >= 0 && u + t.length + s >= n)
        return s + u;
      if (n == r && l.length >= r + t.length - s && l.slice(r - s, r - s + t.length) == t)
        return r;
    }
  }
  return -1;
}
function nw(e, t, n, r, i) {
  let o = [];
  for (let a = 0, s = 0; a < e.length; a++) {
    let l = e[a], u = s, c = s += l.size;
    u >= n || c <= t ? o.push(l) : (u < t && o.push(l.slice(0, t - u, r)), i && (o.push(i), i = void 0), c > n && o.push(l.slice(n - u, l.size, r)));
  }
  return o;
}
function L_(e, t = null) {
  let n = e.domSelectionRange(), r = e.state.doc;
  if (!n.focusNode)
    return null;
  let i = e.docView.nearestDesc(n.focusNode), o = i && i.size == 0, a = e.docView.posFromDOM(n.focusNode, n.focusOffset, 1);
  if (a < 0)
    return null;
  let s = r.resolve(a), l, u;
  if (Lv(n)) {
    for (l = a; i && !i.node; )
      i = i.parent;
    let f = i.node;
    if (i && f.isAtom && $e.isSelectable(f) && i.parent && !(f.isInline && Dze(n.focusNode, n.focusOffset, i.dom))) {
      let h = i.posBefore;
      u = new $e(a == h ? s : r.resolve(h));
    }
  } else {
    if (n instanceof e.dom.ownerDocument.defaultView.Selection && n.rangeCount > 1) {
      let f = a, h = a;
      for (let m = 0; m < n.rangeCount; m++) {
        let v = n.getRangeAt(m);
        f = Math.min(f, e.docView.posFromDOM(v.startContainer, v.startOffset, 1)), h = Math.max(h, e.docView.posFromDOM(v.endContainer, v.endOffset, -1));
      }
      if (f < 0)
        return null;
      [l, a] = h == e.state.selection.anchor ? [h, f] : [f, h], s = r.resolve(a);
    } else
      l = e.docView.posFromDOM(n.anchorNode, n.anchorOffset, 1);
    if (l < 0)
      return null;
  }
  let c = r.resolve(l);
  if (!u) {
    let f = t == "pointer" || e.state.selection.head < s.pos && !o ? 1 : -1;
    u = F_(e, c, s, f);
  }
  return u;
}
function see(e) {
  return e.editable ? e.hasFocus() : uee(e) && document.activeElement && document.activeElement.contains(e.dom);
}
function $a(e, t = !1) {
  let n = e.state.selection;
  if (lee(e, n), !!see(e)) {
    if (!t && e.input.mouseDown && e.input.mouseDown.allowDefault && vr) {
      let r = e.domSelectionRange(), i = e.domObserver.currentSelection;
      if (r.anchorNode && i.anchorNode && iu(r.anchorNode, r.anchorOffset, i.anchorNode, i.anchorOffset)) {
        e.input.mouseDown.delayedSelectionSync = !0, e.domObserver.setCurSelection();
        return;
      }
    }
    if (e.domObserver.disconnectSelection(), e.cursorWrapper)
      cWe(e);
    else {
      let { anchor: r, head: i } = n, o, a;
      qL && !(n instanceof Ze) && (n.$from.parent.inlineContent || (o = zL(e, n.from)), !n.empty && !n.$from.parent.inlineContent && (a = zL(e, n.to))), e.docView.setSelection(r, i, e.root, t), qL && (o && WL(o), a && WL(a)), n.visible ? e.dom.classList.remove("ProseMirror-hideselection") : (e.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && uWe(e));
    }
    e.domObserver.setCurSelection(), e.domObserver.connectSelection();
  }
}
const qL = Mr || vr && YQ < 63;
function zL(e, t) {
  let { node: n, offset: r } = e.docView.domFromPos(t, 0), i = r < n.childNodes.length ? n.childNodes[r] : null, o = r ? n.childNodes[r - 1] : null;
  if (Mr && i && i.contentEditable == "false")
    return $8(i);
  if ((!i || i.contentEditable == "false") && (!o || o.contentEditable == "false")) {
    if (i)
      return $8(i);
    if (o)
      return $8(o);
  }
}
function $8(e) {
  return e.contentEditable = "true", Mr && e.draggable && (e.draggable = !1, e.wasDraggable = !0), e;
}
function WL(e) {
  e.contentEditable = "false", e.wasDraggable && (e.draggable = !0, e.wasDraggable = null);
}
function uWe(e) {
  let t = e.dom.ownerDocument;
  t.removeEventListener("selectionchange", e.input.hideSelectionGuard);
  let n = e.domSelectionRange(), r = n.anchorNode, i = n.anchorOffset;
  t.addEventListener("selectionchange", e.input.hideSelectionGuard = () => {
    (n.anchorNode != r || n.anchorOffset != i) && (t.removeEventListener("selectionchange", e.input.hideSelectionGuard), setTimeout(() => {
      (!see(e) || e.state.selection.visible) && e.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function cWe(e) {
  let t = e.domSelection(), n = document.createRange();
  if (!t)
    return;
  let r = e.cursorWrapper.dom, i = r.nodeName == "IMG";
  i ? n.setStart(r.parentNode, tr(r) + 1) : n.setStart(r, 0), n.collapse(!0), t.removeAllRanges(), t.addRange(n), !i && !e.state.selection.visible && Gr && $s <= 11 && (r.disabled = !0, r.disabled = !1);
}
function lee(e, t) {
  if (t instanceof $e) {
    let n = e.docView.descAt(t.from);
    n != e.lastSelectedViewDesc && (HL(e), n && n.selectNode(), e.lastSelectedViewDesc = n);
  } else
    HL(e);
}
function HL(e) {
  e.lastSelectedViewDesc && (e.lastSelectedViewDesc.parent && e.lastSelectedViewDesc.deselectNode(), e.lastSelectedViewDesc = void 0);
}
function F_(e, t, n, r) {
  return e.someProp("createSelectionBetween", (i) => i(e, t, n)) || Ze.between(t, n, r);
}
function UL(e) {
  return e.editable && !e.hasFocus() ? !1 : uee(e);
}
function uee(e) {
  let t = e.domSelectionRange();
  if (!t.anchorNode)
    return !1;
  try {
    return e.dom.contains(t.anchorNode.nodeType == 3 ? t.anchorNode.parentNode : t.anchorNode) && (e.editable || e.dom.contains(t.focusNode.nodeType == 3 ? t.focusNode.parentNode : t.focusNode));
  } catch {
    return !1;
  }
}
function dWe(e) {
  let t = e.docView.domFromPos(e.state.selection.anchor, 0), n = e.domSelectionRange();
  return iu(t.node, t.offset, n.anchorNode, n.anchorOffset);
}
function rw(e, t) {
  let { $anchor: n, $head: r } = e.selection, i = t > 0 ? n.max(r) : n.min(r), o = i.parent.inlineContent ? i.depth ? e.doc.resolve(t > 0 ? i.after() : i.before()) : null : i;
  return o && it.findFrom(o, t);
}
function bs(e, t) {
  return e.dispatch(e.state.tr.setSelection(t).scrollIntoView()), !0;
}
function GL(e, t, n) {
  let r = e.state.selection;
  if (r instanceof Ze)
    if (n.indexOf("s") > -1) {
      let { $head: i } = r, o = i.textOffset ? null : t < 0 ? i.nodeBefore : i.nodeAfter;
      if (!o || o.isText || !o.isLeaf)
        return !1;
      let a = e.state.doc.resolve(i.pos + o.nodeSize * (t < 0 ? -1 : 1));
      return bs(e, new Ze(r.$anchor, a));
    } else if (r.empty) {
      if (e.endOfTextblock(t > 0 ? "forward" : "backward")) {
        let i = rw(e.state, t);
        return i && i instanceof $e ? bs(e, i) : !1;
      } else if (!(ki && n.indexOf("m") > -1)) {
        let i = r.$head, o = i.textOffset ? null : t < 0 ? i.nodeBefore : i.nodeAfter, a;
        if (!o || o.isText)
          return !1;
        let s = t < 0 ? i.pos - o.nodeSize : i.pos;
        return o.isAtom || (a = e.docView.descAt(s)) && !a.contentDOM ? $e.isSelectable(o) ? bs(e, new $e(t < 0 ? e.state.doc.resolve(i.pos - o.nodeSize) : i)) : Lp ? bs(e, new Ze(e.state.doc.resolve(t < 0 ? s : s + o.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (r instanceof $e && r.node.isInline)
      return bs(e, new Ze(t > 0 ? r.$to : r.$from));
    {
      let i = rw(e.state, t);
      return i ? bs(e, i) : !1;
    }
  }
}
function Sg(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function Kf(e, t) {
  let n = e.pmViewDesc;
  return n && n.size == 0 && (t < 0 || e.nextSibling || e.nodeName != "BR");
}
function Ju(e, t) {
  return t < 0 ? fWe(e) : hWe(e);
}
function fWe(e) {
  let t = e.domSelectionRange(), n = t.focusNode, r = t.focusOffset;
  if (!n)
    return;
  let i, o, a = !1;
  for (mo && n.nodeType == 1 && r < Sg(n) && Kf(n.childNodes[r], -1) && (a = !0); ; )
    if (r > 0) {
      if (n.nodeType != 1)
        break;
      {
        let s = n.childNodes[r - 1];
        if (Kf(s, -1))
          i = n, o = --r;
        else if (s.nodeType == 3)
          n = s, r = n.nodeValue.length;
        else
          break;
      }
    } else {
      if (cee(n))
        break;
      {
        let s = n.previousSibling;
        for (; s && Kf(s, -1); )
          i = n.parentNode, o = tr(s), s = s.previousSibling;
        if (s)
          n = s, r = Sg(n);
        else {
          if (n = n.parentNode, n == e.dom)
            break;
          r = 0;
        }
      }
    }
  a ? iw(e, n, r) : i && iw(e, i, o);
}
function hWe(e) {
  let t = e.domSelectionRange(), n = t.focusNode, r = t.focusOffset;
  if (!n)
    return;
  let i = Sg(n), o, a;
  for (; ; )
    if (r < i) {
      if (n.nodeType != 1)
        break;
      let s = n.childNodes[r];
      if (Kf(s, 1))
        o = n, a = ++r;
      else
        break;
    } else {
      if (cee(n))
        break;
      {
        let s = n.nextSibling;
        for (; s && Kf(s, 1); )
          o = s.parentNode, a = tr(s) + 1, s = s.nextSibling;
        if (s)
          n = s, r = 0, i = Sg(n);
        else {
          if (n = n.parentNode, n == e.dom)
            break;
          r = i = 0;
        }
      }
    }
  o && iw(e, o, a);
}
function cee(e) {
  let t = e.pmViewDesc;
  return t && t.node && t.node.isBlock;
}
function pWe(e, t) {
  for (; e && t == e.childNodes.length && !$p(e); )
    t = tr(e) + 1, e = e.parentNode;
  for (; e && t < e.childNodes.length; ) {
    let n = e.childNodes[t];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    e = n, t = 0;
  }
}
function mWe(e, t) {
  for (; e && !t && !$p(e); )
    t = tr(e), e = e.parentNode;
  for (; e && t; ) {
    let n = e.childNodes[t - 1];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    e = n, t = e.childNodes.length;
  }
}
function iw(e, t, n) {
  if (t.nodeType != 3) {
    let o, a;
    (a = pWe(t, n)) ? (t = a, n = 0) : (o = mWe(t, n)) && (t = o, n = o.nodeValue.length);
  }
  let r = e.domSelection();
  if (!r)
    return;
  if (Lv(r)) {
    let o = document.createRange();
    o.setEnd(t, n), o.setStart(t, n), r.removeAllRanges(), r.addRange(o);
  } else r.extend && r.extend(t, n);
  e.domObserver.setCurSelection();
  let { state: i } = e;
  setTimeout(() => {
    e.state == i && $a(e);
  }, 50);
}
function KL(e, t) {
  let n = e.state.doc.resolve(t);
  if (!(vr || Lze) && n.parent.inlineContent) {
    let i = e.coordsAtPos(t);
    if (t > n.start()) {
      let o = e.coordsAtPos(t - 1), a = (o.top + o.bottom) / 2;
      if (a > i.top && a < i.bottom && Math.abs(o.left - i.left) > 1)
        return o.left < i.left ? "ltr" : "rtl";
    }
    if (t < n.end()) {
      let o = e.coordsAtPos(t + 1), a = (o.top + o.bottom) / 2;
      if (a > i.top && a < i.bottom && Math.abs(o.left - i.left) > 1)
        return o.left > i.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(e.dom).direction == "rtl" ? "rtl" : "ltr";
}
function YL(e, t, n) {
  let r = e.state.selection;
  if (r instanceof Ze && !r.empty || n.indexOf("s") > -1 || ki && n.indexOf("m") > -1)
    return !1;
  let { $from: i, $to: o } = r;
  if (!i.parent.inlineContent || e.endOfTextblock(t < 0 ? "up" : "down")) {
    let a = rw(e.state, t);
    if (a && a instanceof $e)
      return bs(e, a);
  }
  if (!i.parent.inlineContent) {
    let a = t < 0 ? i : o, s = r instanceof Ii ? it.near(a, t) : it.findFrom(a, t);
    return s ? bs(e, s) : !1;
  }
  return !1;
}
function ZL(e, t) {
  if (!(e.state.selection instanceof Ze))
    return !0;
  let { $head: n, $anchor: r, empty: i } = e.state.selection;
  if (!n.sameParent(r))
    return !0;
  if (!i)
    return !1;
  if (e.endOfTextblock(t > 0 ? "forward" : "backward"))
    return !0;
  let o = !n.textOffset && (t < 0 ? n.nodeBefore : n.nodeAfter);
  if (o && !o.isText) {
    let a = e.state.tr;
    return t < 0 ? a.delete(n.pos - o.nodeSize, n.pos) : a.delete(n.pos, n.pos + o.nodeSize), e.dispatch(a), !0;
  }
  return !1;
}
function XL(e, t, n) {
  e.domObserver.stop(), t.contentEditable = n, e.domObserver.start();
}
function gWe(e) {
  if (!Mr || e.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: t, focusOffset: n } = e.domSelectionRange();
  if (t && t.nodeType == 1 && n == 0 && t.firstChild && t.firstChild.contentEditable == "false") {
    let r = t.firstChild;
    XL(e, r, "true"), setTimeout(() => XL(e, r, "false"), 20);
  }
  return !1;
}
function vWe(e) {
  let t = "";
  return e.ctrlKey && (t += "c"), e.metaKey && (t += "m"), e.altKey && (t += "a"), e.shiftKey && (t += "s"), t;
}
function yWe(e, t) {
  let n = t.keyCode, r = vWe(t);
  if (n == 8 || ki && n == 72 && r == "c")
    return ZL(e, -1) || Ju(e, -1);
  if (n == 46 && !t.shiftKey || ki && n == 68 && r == "c")
    return ZL(e, 1) || Ju(e, 1);
  if (n == 13 || n == 27)
    return !0;
  if (n == 37 || ki && n == 66 && r == "c") {
    let i = n == 37 ? KL(e, e.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return GL(e, i, r) || Ju(e, i);
  } else if (n == 39 || ki && n == 70 && r == "c") {
    let i = n == 39 ? KL(e, e.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return GL(e, i, r) || Ju(e, i);
  } else {
    if (n == 38 || ki && n == 80 && r == "c")
      return YL(e, -1, r) || Ju(e, -1);
    if (n == 40 || ki && n == 78 && r == "c")
      return gWe(e) || YL(e, 1, r) || Ju(e, 1);
    if (r == (ki ? "m" : "c") && (n == 66 || n == 73 || n == 89 || n == 90))
      return !0;
  }
  return !1;
}
function dee(e, t) {
  e.someProp("transformCopied", (m) => {
    t = m(t, e);
  });
  let n = [], { content: r, openStart: i, openEnd: o } = t;
  for (; i > 1 && o > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    i--, o--;
    let m = r.firstChild;
    n.push(m.type.name, m.attrs != m.type.defaultAttrs ? m.attrs : null), r = m.content;
  }
  let a = e.someProp("clipboardSerializer") || vu.fromSchema(e.state.schema), s = vee(), l = s.createElement("div");
  l.appendChild(a.serializeFragment(r, { document: s }));
  let u = l.firstChild, c, f = 0;
  for (; u && u.nodeType == 1 && (c = gee[u.nodeName.toLowerCase()]); ) {
    for (let m = c.length - 1; m >= 0; m--) {
      let v = s.createElement(c[m]);
      for (; l.firstChild; )
        v.appendChild(l.firstChild);
      l.appendChild(v), f++;
    }
    u = l.firstChild;
  }
  u && u.nodeType == 1 && u.setAttribute("data-pm-slice", `${i} ${o}${f ? ` -${f}` : ""} ${JSON.stringify(n)}`);
  let h = e.someProp("clipboardTextSerializer", (m) => m(t, e)) || t.content.textBetween(0, t.content.size, `

`);
  return { dom: l, text: h, slice: t };
}
function fee(e, t, n, r, i) {
  let o = i.parent.type.spec.code, a, s;
  if (!n && !t)
    return null;
  let l = t && (r || o || !n);
  if (l) {
    if (e.someProp("transformPastedText", (h) => {
      t = h(t, o || r, e);
    }), o)
      return t ? new _e(he.from(e.state.schema.text(t.replace(/\r\n?/g, `
`))), 0, 0) : _e.empty;
    let f = e.someProp("clipboardTextParser", (h) => h(t, i, r, e));
    if (f)
      s = f;
    else {
      let h = i.marks(), { schema: m } = e.state, v = vu.fromSchema(m);
      a = document.createElement("div"), t.split(/(?:\r\n?|\n)+/).forEach((g) => {
        let y = a.appendChild(document.createElement("p"));
        g && y.appendChild(v.serializeNode(m.text(g, h)));
      });
    }
  } else
    e.someProp("transformPastedHTML", (f) => {
      n = f(n, e);
    }), a = CWe(n), Lp && SWe(a);
  let u = a && a.querySelector("[data-pm-slice]"), c = u && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(u.getAttribute("data-pm-slice") || "");
  if (c && c[3])
    for (let f = +c[3]; f > 0; f--) {
      let h = a.firstChild;
      for (; h && h.nodeType != 1; )
        h = h.nextSibling;
      if (!h)
        break;
      a = h;
    }
  if (s || (s = (e.someProp("clipboardParser") || e.someProp("domParser") || Da.fromSchema(e.state.schema)).parseSlice(a, {
    preserveWhitespace: !!(l || c),
    context: i,
    ruleFromNode(h) {
      return h.nodeName == "BR" && !h.nextSibling && h.parentNode && !bWe.test(h.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), c)
    s = _We(JL(s, +c[1], +c[2]), c[4]);
  else if (s = _e.maxOpen(xWe(s.content, i), !0), s.openStart || s.openEnd) {
    let f = 0, h = 0;
    for (let m = s.content.firstChild; f < s.openStart && !m.type.spec.isolating; f++, m = m.firstChild)
      ;
    for (let m = s.content.lastChild; h < s.openEnd && !m.type.spec.isolating; h++, m = m.lastChild)
      ;
    s = JL(s, f, h);
  }
  return e.someProp("transformPasted", (f) => {
    s = f(s, e);
  }), s;
}
const bWe = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function xWe(e, t) {
  if (e.childCount < 2)
    return e;
  for (let n = t.depth; n >= 0; n--) {
    let i = t.node(n).contentMatchAt(t.index(n)), o, a = [];
    if (e.forEach((s) => {
      if (!a)
        return;
      let l = i.findWrapping(s.type), u;
      if (!l)
        return a = null;
      if (u = a.length && o.length && pee(l, o, s, a[a.length - 1], 0))
        a[a.length - 1] = u;
      else {
        a.length && (a[a.length - 1] = mee(a[a.length - 1], o.length));
        let c = hee(s, l);
        a.push(c), i = i.matchType(c.type), o = l;
      }
    }), a)
      return he.from(a);
  }
  return e;
}
function hee(e, t, n = 0) {
  for (let r = t.length - 1; r >= n; r--)
    e = t[r].create(null, he.from(e));
  return e;
}
function pee(e, t, n, r, i) {
  if (i < e.length && i < t.length && e[i] == t[i]) {
    let o = pee(e, t, n, r.lastChild, i + 1);
    if (o)
      return r.copy(r.content.replaceChild(r.childCount - 1, o));
    if (r.contentMatchAt(r.childCount).matchType(i == e.length - 1 ? n.type : e[i + 1]))
      return r.copy(r.content.append(he.from(hee(n, e, i + 1))));
  }
}
function mee(e, t) {
  if (t == 0)
    return e;
  let n = e.content.replaceChild(e.childCount - 1, mee(e.lastChild, t - 1)), r = e.contentMatchAt(e.childCount).fillBefore(he.empty, !0);
  return e.copy(n.append(r));
}
function ow(e, t, n, r, i, o) {
  let a = t < 0 ? e.firstChild : e.lastChild, s = a.content;
  return e.childCount > 1 && (o = 0), i < r - 1 && (s = ow(s, t, n, r, i + 1, o)), i >= n && (s = t < 0 ? a.contentMatchAt(0).fillBefore(s, o <= i).append(s) : s.append(a.contentMatchAt(a.childCount).fillBefore(he.empty, !0))), e.replaceChild(t < 0 ? 0 : e.childCount - 1, a.copy(s));
}
function JL(e, t, n) {
  return t < e.openStart && (e = new _e(ow(e.content, -1, t, e.openStart, 0, e.openEnd), t, e.openEnd)), n < e.openEnd && (e = new _e(ow(e.content, 1, n, e.openEnd, 0, 0), e.openStart, n)), e;
}
const gee = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let QL = null;
function vee() {
  return QL || (QL = document.implementation.createHTMLDocument("title"));
}
let L8 = null;
function wWe(e) {
  let t = window.trustedTypes;
  return t ? (L8 || (L8 = t.createPolicy("ProseMirrorClipboard", { createHTML: (n) => n })), L8.createHTML(e)) : e;
}
function CWe(e) {
  let t = /^(\s*<meta [^>]*>)*/.exec(e);
  t && (e = e.slice(t[0].length));
  let n = vee().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(e), i;
  if ((i = r && gee[r[1].toLowerCase()]) && (e = i.map((o) => "<" + o + ">").join("") + e + i.map((o) => "</" + o + ">").reverse().join("")), n.innerHTML = wWe(e), i)
    for (let o = 0; o < i.length; o++)
      n = n.querySelector(i[o]) || n;
  return n;
}
function SWe(e) {
  let t = e.querySelectorAll(vr ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let n = 0; n < t.length; n++) {
    let r = t[n];
    r.childNodes.length == 1 && r.textContent == " " && r.parentNode && r.parentNode.replaceChild(e.ownerDocument.createTextNode(" "), r);
  }
}
function _We(e, t) {
  if (!e.size)
    return e;
  let n = e.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(t);
  } catch {
    return e;
  }
  let { content: i, openStart: o, openEnd: a } = e;
  for (let s = r.length - 2; s >= 0; s -= 2) {
    let l = n.nodes[r[s]];
    if (!l || l.hasRequiredAttrs())
      break;
    i = he.from(l.create(r[s + 1], i)), o++, a++;
  }
  return new _e(i, o, a);
}
const Rr = {}, Dr = {}, EWe = { touchstart: !0, touchmove: !0 };
class NWe {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "" }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastAndroidDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function AWe(e) {
  for (let t in Rr) {
    let n = Rr[t];
    e.dom.addEventListener(t, e.input.eventHandlers[t] = (r) => {
      kWe(e, r) && !B_(e, r) && (e.editable || !(r.type in Dr)) && n(e, r);
    }, EWe[t] ? { passive: !0 } : void 0);
  }
  Mr && e.dom.addEventListener("input", () => null), aw(e);
}
function Ts(e, t) {
  e.input.lastSelectionOrigin = t, e.input.lastSelectionTime = Date.now();
}
function OWe(e) {
  e.domObserver.stop();
  for (let t in e.input.eventHandlers)
    e.dom.removeEventListener(t, e.input.eventHandlers[t]);
  clearTimeout(e.input.composingTimeout), clearTimeout(e.input.lastIOSEnterFallbackTimeout);
}
function aw(e) {
  e.someProp("handleDOMEvents", (t) => {
    for (let n in t)
      e.input.eventHandlers[n] || e.dom.addEventListener(n, e.input.eventHandlers[n] = (r) => B_(e, r));
  });
}
function B_(e, t) {
  return e.someProp("handleDOMEvents", (n) => {
    let r = n[t.type];
    return r ? r(e, t) || t.defaultPrevented : !1;
  });
}
function kWe(e, t) {
  if (!t.bubbles)
    return !0;
  if (t.defaultPrevented)
    return !1;
  for (let n = t.target; n != e.dom; n = n.parentNode)
    if (!n || n.nodeType == 11 || n.pmViewDesc && n.pmViewDesc.stopEvent(t))
      return !1;
  return !0;
}
function PWe(e, t) {
  !B_(e, t) && Rr[t.type] && (e.editable || !(t.type in Dr)) && Rr[t.type](e, t);
}
Dr.keydown = (e, t) => {
  let n = t;
  if (e.input.shiftKey = n.keyCode == 16 || n.shiftKey, !bee(e, n) && (e.input.lastKeyCode = n.keyCode, e.input.lastKeyCodeTime = Date.now(), !(Qi && vr && n.keyCode == 13)))
    if (n.keyCode != 229 && e.domObserver.forceFlush(), cd && n.keyCode == 13 && !n.ctrlKey && !n.altKey && !n.metaKey) {
      let r = Date.now();
      e.input.lastIOSEnter = r, e.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        e.input.lastIOSEnter == r && (e.someProp("handleKeyDown", (i) => i(e, _l(13, "Enter"))), e.input.lastIOSEnter = 0);
      }, 200);
    } else e.someProp("handleKeyDown", (r) => r(e, n)) || yWe(e, n) ? n.preventDefault() : Ts(e, "key");
};
Dr.keyup = (e, t) => {
  t.keyCode == 16 && (e.input.shiftKey = !1);
};
Dr.keypress = (e, t) => {
  let n = t;
  if (bee(e, n) || !n.charCode || n.ctrlKey && !n.altKey || ki && n.metaKey)
    return;
  if (e.someProp("handleKeyPress", (i) => i(e, n))) {
    n.preventDefault();
    return;
  }
  let r = e.state.selection;
  if (!(r instanceof Ze) || !r.$from.sameParent(r.$to)) {
    let i = String.fromCharCode(n.charCode);
    !/[\r\n]/.test(i) && !e.someProp("handleTextInput", (o) => o(e, r.$from.pos, r.$to.pos, i)) && e.dispatch(e.state.tr.insertText(i).scrollIntoView()), n.preventDefault();
  }
};
function Bv(e) {
  return { left: e.clientX, top: e.clientY };
}
function TWe(e, t) {
  let n = t.x - e.clientX, r = t.y - e.clientY;
  return n * n + r * r < 100;
}
function j_(e, t, n, r, i) {
  if (r == -1)
    return !1;
  let o = e.state.doc.resolve(r);
  for (let a = o.depth + 1; a > 0; a--)
    if (e.someProp(t, (s) => a > o.depth ? s(e, n, o.nodeAfter, o.before(a), i, !0) : s(e, n, o.node(a), o.before(a), i, !1)))
      return !0;
  return !1;
}
function _c(e, t, n) {
  if (e.focused || e.focus(), e.state.selection.eq(t))
    return;
  let r = e.state.tr.setSelection(t);
  r.setMeta("pointer", !0), e.dispatch(r);
}
function MWe(e, t) {
  if (t == -1)
    return !1;
  let n = e.state.doc.resolve(t), r = n.nodeAfter;
  return r && r.isAtom && $e.isSelectable(r) ? (_c(e, new $e(n)), !0) : !1;
}
function RWe(e, t) {
  if (t == -1)
    return !1;
  let n = e.state.selection, r, i;
  n instanceof $e && (r = n.node);
  let o = e.state.doc.resolve(t);
  for (let a = o.depth + 1; a > 0; a--) {
    let s = a > o.depth ? o.nodeAfter : o.node(a);
    if ($e.isSelectable(s)) {
      r && n.$from.depth > 0 && a >= n.$from.depth && o.before(n.$from.depth + 1) == n.$from.pos ? i = o.before(n.$from.depth) : i = o.before(a);
      break;
    }
  }
  return i != null ? (_c(e, $e.create(e.state.doc, i)), !0) : !1;
}
function DWe(e, t, n, r, i) {
  return j_(e, "handleClickOn", t, n, r) || e.someProp("handleClick", (o) => o(e, t, r)) || (i ? RWe(e, n) : MWe(e, n));
}
function IWe(e, t, n, r) {
  return j_(e, "handleDoubleClickOn", t, n, r) || e.someProp("handleDoubleClick", (i) => i(e, t, r));
}
function $We(e, t, n, r) {
  return j_(e, "handleTripleClickOn", t, n, r) || e.someProp("handleTripleClick", (i) => i(e, t, r)) || LWe(e, n, r);
}
function LWe(e, t, n) {
  if (n.button != 0)
    return !1;
  let r = e.state.doc;
  if (t == -1)
    return r.inlineContent ? (_c(e, Ze.create(r, 0, r.content.size)), !0) : !1;
  let i = r.resolve(t);
  for (let o = i.depth + 1; o > 0; o--) {
    let a = o > i.depth ? i.nodeAfter : i.node(o), s = i.before(o);
    if (a.inlineContent)
      _c(e, Ze.create(r, s + 1, s + 1 + a.content.size));
    else if ($e.isSelectable(a))
      _c(e, $e.create(r, s));
    else
      continue;
    return !0;
  }
}
function V_(e) {
  return _g(e);
}
const yee = ki ? "metaKey" : "ctrlKey";
Rr.mousedown = (e, t) => {
  let n = t;
  e.input.shiftKey = n.shiftKey;
  let r = V_(e), i = Date.now(), o = "singleClick";
  i - e.input.lastClick.time < 500 && TWe(n, e.input.lastClick) && !n[yee] && (e.input.lastClick.type == "singleClick" ? o = "doubleClick" : e.input.lastClick.type == "doubleClick" && (o = "tripleClick")), e.input.lastClick = { time: i, x: n.clientX, y: n.clientY, type: o };
  let a = e.posAtCoords(Bv(n));
  a && (o == "singleClick" ? (e.input.mouseDown && e.input.mouseDown.done(), e.input.mouseDown = new FWe(e, a, n, !!r)) : (o == "doubleClick" ? IWe : $We)(e, a.pos, a.inside, n) ? n.preventDefault() : Ts(e, "pointer"));
};
class FWe {
  constructor(t, n, r, i) {
    this.view = t, this.pos = n, this.event = r, this.flushed = i, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = t.state.doc, this.selectNode = !!r[yee], this.allowDefault = r.shiftKey;
    let o, a;
    if (n.inside > -1)
      o = t.state.doc.nodeAt(n.inside), a = n.inside;
    else {
      let c = t.state.doc.resolve(n.pos);
      o = c.parent, a = c.depth ? c.before() : 0;
    }
    const s = i ? null : r.target, l = s ? t.docView.nearestDesc(s, !0) : null;
    this.target = l && l.dom.nodeType == 1 ? l.dom : null;
    let { selection: u } = t.state;
    (r.button == 0 && o.type.spec.draggable && o.type.spec.selectable !== !1 || u instanceof $e && u.from <= a && u.to > a) && (this.mightDrag = {
      node: o,
      pos: a,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && mo && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), t.root.addEventListener("mouseup", this.up = this.up.bind(this)), t.root.addEventListener("mousemove", this.move = this.move.bind(this)), Ts(t, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => $a(this.view)), this.view.input.mouseDown = null;
  }
  up(t) {
    if (this.done(), !this.view.dom.contains(t.target))
      return;
    let n = this.pos;
    this.view.state.doc != this.startDoc && (n = this.view.posAtCoords(Bv(t))), this.updateAllowDefault(t), this.allowDefault || !n ? Ts(this.view, "pointer") : DWe(this.view, n.pos, n.inside, t, this.selectNode) ? t.preventDefault() : t.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    Mr && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    vr && !this.view.state.selection.visible && Math.min(Math.abs(n.pos - this.view.state.selection.from), Math.abs(n.pos - this.view.state.selection.to)) <= 2) ? (_c(this.view, it.near(this.view.state.doc.resolve(n.pos))), t.preventDefault()) : Ts(this.view, "pointer");
  }
  move(t) {
    this.updateAllowDefault(t), Ts(this.view, "pointer"), t.buttons == 0 && this.done();
  }
  updateAllowDefault(t) {
    !this.allowDefault && (Math.abs(this.event.x - t.clientX) > 4 || Math.abs(this.event.y - t.clientY) > 4) && (this.allowDefault = !0);
  }
}
Rr.touchstart = (e) => {
  e.input.lastTouch = Date.now(), V_(e), Ts(e, "pointer");
};
Rr.touchmove = (e) => {
  e.input.lastTouch = Date.now(), Ts(e, "pointer");
};
Rr.contextmenu = (e) => V_(e);
function bee(e, t) {
  return e.composing ? !0 : Mr && Math.abs(t.timeStamp - e.input.compositionEndedAt) < 500 ? (e.input.compositionEndedAt = -2e8, !0) : !1;
}
const BWe = Qi ? 5e3 : -1;
Dr.compositionstart = Dr.compositionupdate = (e) => {
  if (!e.composing) {
    e.domObserver.flush();
    let { state: t } = e, n = t.selection.$to;
    if (t.selection instanceof Ze && (t.storedMarks || !n.textOffset && n.parentOffset && n.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1)))
      e.markCursor = e.state.storedMarks || n.marks(), _g(e, !0), e.markCursor = null;
    else if (_g(e, !t.selection.empty), mo && t.selection.empty && n.parentOffset && !n.textOffset && n.nodeBefore.marks.length) {
      let r = e.domSelectionRange();
      for (let i = r.focusNode, o = r.focusOffset; i && i.nodeType == 1 && o != 0; ) {
        let a = o < 0 ? i.lastChild : i.childNodes[o - 1];
        if (!a)
          break;
        if (a.nodeType == 3) {
          let s = e.domSelection();
          s && s.collapse(a, a.nodeValue.length);
          break;
        } else
          i = a, o = -1;
      }
    }
    e.input.composing = !0;
  }
  xee(e, BWe);
};
Dr.compositionend = (e, t) => {
  e.composing && (e.input.composing = !1, e.input.compositionEndedAt = t.timeStamp, e.input.compositionPendingChanges = e.domObserver.pendingRecords().length ? e.input.compositionID : 0, e.input.compositionNode = null, e.input.compositionPendingChanges && Promise.resolve().then(() => e.domObserver.flush()), e.input.compositionID++, xee(e, 20));
};
function xee(e, t) {
  clearTimeout(e.input.composingTimeout), t > -1 && (e.input.composingTimeout = setTimeout(() => _g(e), t));
}
function wee(e) {
  for (e.composing && (e.input.composing = !1, e.input.compositionEndedAt = VWe()); e.input.compositionNodes.length > 0; )
    e.input.compositionNodes.pop().markParentsDirty();
}
function jWe(e) {
  let t = e.domSelectionRange();
  if (!t.focusNode)
    return null;
  let n = Mze(t.focusNode, t.focusOffset), r = Rze(t.focusNode, t.focusOffset);
  if (n && r && n != r) {
    let i = r.pmViewDesc, o = e.domObserver.lastChangedTextNode;
    if (n == o || r == o)
      return o;
    if (!i || !i.isText(r.nodeValue))
      return r;
    if (e.input.compositionNode == r) {
      let a = n.pmViewDesc;
      if (!(!a || !a.isText(n.nodeValue)))
        return r;
    }
  }
  return n || r;
}
function VWe() {
  let e = document.createEvent("Event");
  return e.initEvent("event", !0, !0), e.timeStamp;
}
function _g(e, t = !1) {
  if (!(Qi && e.domObserver.flushingSoon >= 0)) {
    if (e.domObserver.forceFlush(), wee(e), t || e.docView && e.docView.dirty) {
      let n = L_(e);
      return n && !n.eq(e.state.selection) ? e.dispatch(e.state.tr.setSelection(n)) : (e.markCursor || t) && !e.state.selection.empty ? e.dispatch(e.state.tr.deleteSelection()) : e.updateState(e.state), !0;
    }
    return !1;
  }
}
function qWe(e, t) {
  if (!e.dom.parentNode)
    return;
  let n = e.dom.parentNode.appendChild(document.createElement("div"));
  n.appendChild(t), n.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), i = document.createRange();
  i.selectNodeContents(t), e.dom.blur(), r.removeAllRanges(), r.addRange(i), setTimeout(() => {
    n.parentNode && n.parentNode.removeChild(n), e.focus();
  }, 50);
}
const Hh = Gr && $s < 15 || cd && Fze < 604;
Rr.copy = Dr.cut = (e, t) => {
  let n = t, r = e.state.selection, i = n.type == "cut";
  if (r.empty)
    return;
  let o = Hh ? null : n.clipboardData, a = r.content(), { dom: s, text: l } = dee(e, a);
  o ? (n.preventDefault(), o.clearData(), o.setData("text/html", s.innerHTML), o.setData("text/plain", l)) : qWe(e, s), i && e.dispatch(e.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function zWe(e) {
  return e.openStart == 0 && e.openEnd == 0 && e.content.childCount == 1 ? e.content.firstChild : null;
}
function WWe(e, t) {
  if (!e.dom.parentNode)
    return;
  let n = e.input.shiftKey || e.state.selection.$from.parent.type.spec.code, r = e.dom.parentNode.appendChild(document.createElement(n ? "textarea" : "div"));
  n || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let i = e.input.shiftKey && e.input.lastKeyCode != 45;
  setTimeout(() => {
    e.focus(), r.parentNode && r.parentNode.removeChild(r), n ? Uh(e, r.value, null, i, t) : Uh(e, r.textContent, r.innerHTML, i, t);
  }, 50);
}
function Uh(e, t, n, r, i) {
  let o = fee(e, t, n, r, e.state.selection.$from);
  if (e.someProp("handlePaste", (l) => l(e, i, o || _e.empty)))
    return !0;
  if (!o)
    return !1;
  let a = zWe(o), s = a ? e.state.tr.replaceSelectionWith(a, r) : e.state.tr.replaceSelection(o);
  return e.dispatch(s.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function Cee(e) {
  let t = e.getData("text/plain") || e.getData("Text");
  if (t)
    return t;
  let n = e.getData("text/uri-list");
  return n ? n.replace(/\r?\n/g, " ") : "";
}
Dr.paste = (e, t) => {
  let n = t;
  if (e.composing && !Qi)
    return;
  let r = Hh ? null : n.clipboardData, i = e.input.shiftKey && e.input.lastKeyCode != 45;
  r && Uh(e, Cee(r), r.getData("text/html"), i, n) ? n.preventDefault() : WWe(e, n);
};
class See {
  constructor(t, n, r) {
    this.slice = t, this.move = n, this.node = r;
  }
}
const _ee = ki ? "altKey" : "ctrlKey";
Rr.dragstart = (e, t) => {
  let n = t, r = e.input.mouseDown;
  if (r && r.done(), !n.dataTransfer)
    return;
  let i = e.state.selection, o = i.empty ? null : e.posAtCoords(Bv(n)), a;
  if (!(o && o.pos >= i.from && o.pos <= (i instanceof $e ? i.to - 1 : i.to))) {
    if (r && r.mightDrag)
      a = $e.create(e.state.doc, r.mightDrag.pos);
    else if (n.target && n.target.nodeType == 1) {
      let f = e.docView.nearestDesc(n.target, !0);
      f && f.node.type.spec.draggable && f != e.docView && (a = $e.create(e.state.doc, f.posBefore));
    }
  }
  let s = (a || e.state.selection).content(), { dom: l, text: u, slice: c } = dee(e, s);
  (!n.dataTransfer.files.length || !vr || YQ > 120) && n.dataTransfer.clearData(), n.dataTransfer.setData(Hh ? "Text" : "text/html", l.innerHTML), n.dataTransfer.effectAllowed = "copyMove", Hh || n.dataTransfer.setData("text/plain", u), e.dragging = new See(c, !n[_ee], a);
};
Rr.dragend = (e) => {
  let t = e.dragging;
  window.setTimeout(() => {
    e.dragging == t && (e.dragging = null);
  }, 50);
};
Dr.dragover = Dr.dragenter = (e, t) => t.preventDefault();
Dr.drop = (e, t) => {
  let n = t, r = e.dragging;
  if (e.dragging = null, !n.dataTransfer)
    return;
  let i = e.posAtCoords(Bv(n));
  if (!i)
    return;
  let o = e.state.doc.resolve(i.pos), a = r && r.slice;
  a ? e.someProp("transformPasted", (v) => {
    a = v(a, e);
  }) : a = fee(e, Cee(n.dataTransfer), Hh ? null : n.dataTransfer.getData("text/html"), !1, o);
  let s = !!(r && !n[_ee]);
  if (e.someProp("handleDrop", (v) => v(e, n, a || _e.empty, s))) {
    n.preventDefault();
    return;
  }
  if (!a)
    return;
  n.preventDefault();
  let l = a ? VQ(e.state.doc, o.pos, a) : o.pos;
  l == null && (l = o.pos);
  let u = e.state.tr;
  if (s) {
    let { node: v } = r;
    v ? v.replace(u) : u.deleteSelection();
  }
  let c = u.mapping.map(l), f = a.openStart == 0 && a.openEnd == 0 && a.content.childCount == 1, h = u.doc;
  if (f ? u.replaceRangeWith(c, c, a.content.firstChild) : u.replaceRange(c, c, a), u.doc.eq(h))
    return;
  let m = u.doc.resolve(c);
  if (f && $e.isSelectable(a.content.firstChild) && m.nodeAfter && m.nodeAfter.sameMarkup(a.content.firstChild))
    u.setSelection(new $e(m));
  else {
    let v = u.mapping.map(l);
    u.mapping.maps[u.mapping.maps.length - 1].forEach((g, y, w, C) => v = C), u.setSelection(F_(e, m, u.doc.resolve(v)));
  }
  e.focus(), e.dispatch(u.setMeta("uiEvent", "drop"));
};
Rr.focus = (e) => {
  e.input.lastFocus = Date.now(), e.focused || (e.domObserver.stop(), e.dom.classList.add("ProseMirror-focused"), e.domObserver.start(), e.focused = !0, setTimeout(() => {
    e.docView && e.hasFocus() && !e.domObserver.currentSelection.eq(e.domSelectionRange()) && $a(e);
  }, 20));
};
Rr.blur = (e, t) => {
  let n = t;
  e.focused && (e.domObserver.stop(), e.dom.classList.remove("ProseMirror-focused"), e.domObserver.start(), n.relatedTarget && e.dom.contains(n.relatedTarget) && e.domObserver.currentSelection.clear(), e.focused = !1);
};
Rr.beforeinput = (e, t) => {
  if (vr && Qi && t.inputType == "deleteContentBackward") {
    e.domObserver.flushSoon();
    let { domChangeCount: r } = e.input;
    setTimeout(() => {
      if (e.input.domChangeCount != r || (e.dom.blur(), e.focus(), e.someProp("handleKeyDown", (o) => o(e, _l(8, "Backspace")))))
        return;
      let { $cursor: i } = e.state.selection;
      i && i.pos > 0 && e.dispatch(e.state.tr.delete(i.pos - 1, i.pos).scrollIntoView());
    }, 50);
  }
};
for (let e in Dr)
  Rr[e] = Dr[e];
function Gh(e, t) {
  if (e == t)
    return !0;
  for (let n in e)
    if (e[n] !== t[n])
      return !1;
  for (let n in t)
    if (!(n in e))
      return !1;
  return !0;
}
class Eg {
  constructor(t, n) {
    this.toDOM = t, this.spec = n || ql, this.side = this.spec.side || 0;
  }
  map(t, n, r, i) {
    let { pos: o, deleted: a } = t.mapResult(n.from + i, this.side < 0 ? -1 : 1);
    return a ? null : new Mi(o - r, o - r, this);
  }
  valid() {
    return !0;
  }
  eq(t) {
    return this == t || t instanceof Eg && (this.spec.key && this.spec.key == t.spec.key || this.toDOM == t.toDOM && Gh(this.spec, t.spec));
  }
  destroy(t) {
    this.spec.destroy && this.spec.destroy(t);
  }
}
class Fs {
  constructor(t, n) {
    this.attrs = t, this.spec = n || ql;
  }
  map(t, n, r, i) {
    let o = t.map(n.from + i, this.spec.inclusiveStart ? -1 : 1) - r, a = t.map(n.to + i, this.spec.inclusiveEnd ? 1 : -1) - r;
    return o >= a ? null : new Mi(o, a, this);
  }
  valid(t, n) {
    return n.from < n.to;
  }
  eq(t) {
    return this == t || t instanceof Fs && Gh(this.attrs, t.attrs) && Gh(this.spec, t.spec);
  }
  static is(t) {
    return t.type instanceof Fs;
  }
  destroy() {
  }
}
class q_ {
  constructor(t, n) {
    this.attrs = t, this.spec = n || ql;
  }
  map(t, n, r, i) {
    let o = t.mapResult(n.from + i, 1);
    if (o.deleted)
      return null;
    let a = t.mapResult(n.to + i, -1);
    return a.deleted || a.pos <= o.pos ? null : new Mi(o.pos - r, a.pos - r, this);
  }
  valid(t, n) {
    let { index: r, offset: i } = t.content.findIndex(n.from), o;
    return i == n.from && !(o = t.child(r)).isText && i + o.nodeSize == n.to;
  }
  eq(t) {
    return this == t || t instanceof q_ && Gh(this.attrs, t.attrs) && Gh(this.spec, t.spec);
  }
  destroy() {
  }
}
class Mi {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.from = t, this.to = n, this.type = r;
  }
  /**
  @internal
  */
  copy(t, n) {
    return new Mi(t, n, this.type);
  }
  /**
  @internal
  */
  eq(t, n = 0) {
    return this.type.eq(t.type) && this.from + n == t.from && this.to + n == t.to;
  }
  /**
  @internal
  */
  map(t, n, r) {
    return this.type.map(t, this, n, r);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(t, n, r) {
    return new Mi(t, t, new Eg(n, r));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(t, n, r, i) {
    return new Mi(t, n, new Fs(r, i));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(t, n, r, i) {
    return new Mi(t, n, new q_(r, i));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof Fs;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof Eg;
  }
}
const nc = [], ql = {};
class Rn {
  /**
  @internal
  */
  constructor(t, n) {
    this.local = t.length ? t : nc, this.children = n.length ? n : nc;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(t, n) {
    return n.length ? Ng(n, t, 0, ql) : hr;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(t, n, r) {
    let i = [];
    return this.findInner(t ?? 0, n ?? 1e9, i, 0, r), i;
  }
  findInner(t, n, r, i, o) {
    for (let a = 0; a < this.local.length; a++) {
      let s = this.local[a];
      s.from <= n && s.to >= t && (!o || o(s.spec)) && r.push(s.copy(s.from + i, s.to + i));
    }
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] < n && this.children[a + 1] > t) {
        let s = this.children[a] + 1;
        this.children[a + 2].findInner(t - s, n - s, r, i + s, o);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(t, n, r) {
    return this == hr || t.maps.length == 0 ? this : this.mapInner(t, n, 0, 0, r || ql);
  }
  /**
  @internal
  */
  mapInner(t, n, r, i, o) {
    let a;
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s].map(t, r, i);
      l && l.type.valid(n, l) ? (a || (a = [])).push(l) : o.onRemove && o.onRemove(this.local[s].spec);
    }
    return this.children.length ? HWe(this.children, a || [], t, n, r, i, o) : a ? new Rn(a.sort(zl), nc) : hr;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(t, n) {
    return n.length ? this == hr ? Rn.create(t, n) : this.addInner(t, n, 0) : this;
  }
  addInner(t, n, r) {
    let i, o = 0;
    t.forEach((s, l) => {
      let u = l + r, c;
      if (c = Nee(n, s, u)) {
        for (i || (i = this.children.slice()); o < i.length && i[o] < l; )
          o += 3;
        i[o] == l ? i[o + 2] = i[o + 2].addInner(s, c, u + 1) : i.splice(o, 0, l, l + s.nodeSize, Ng(c, s, u + 1, ql)), o += 3;
      }
    });
    let a = Eee(o ? Aee(n) : n, -r);
    for (let s = 0; s < a.length; s++)
      a[s].type.valid(t, a[s]) || a.splice(s--, 1);
    return new Rn(a.length ? this.local.concat(a).sort(zl) : this.local, i || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(t) {
    return t.length == 0 || this == hr ? this : this.removeInner(t, 0);
  }
  removeInner(t, n) {
    let r = this.children, i = this.local;
    for (let o = 0; o < r.length; o += 3) {
      let a, s = r[o] + n, l = r[o + 1] + n;
      for (let c = 0, f; c < t.length; c++)
        (f = t[c]) && f.from > s && f.to < l && (t[c] = null, (a || (a = [])).push(f));
      if (!a)
        continue;
      r == this.children && (r = this.children.slice());
      let u = r[o + 2].removeInner(a, s + 1);
      u != hr ? r[o + 2] = u : (r.splice(o, 3), o -= 3);
    }
    if (i.length) {
      for (let o = 0, a; o < t.length; o++)
        if (a = t[o])
          for (let s = 0; s < i.length; s++)
            i[s].eq(a, n) && (i == this.local && (i = this.local.slice()), i.splice(s--, 1));
    }
    return r == this.children && i == this.local ? this : i.length || r.length ? new Rn(i, r) : hr;
  }
  forChild(t, n) {
    if (this == hr)
      return this;
    if (n.isLeaf)
      return Rn.empty;
    let r, i;
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] >= t) {
        this.children[s] == t && (r = this.children[s + 2]);
        break;
      }
    let o = t + 1, a = o + n.content.size;
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s];
      if (l.from < a && l.to > o && l.type instanceof Fs) {
        let u = Math.max(o, l.from) - o, c = Math.min(a, l.to) - o;
        u < c && (i || (i = [])).push(l.copy(u, c));
      }
    }
    if (i) {
      let s = new Rn(i.sort(zl), nc);
      return r ? new Ss([s, r]) : s;
    }
    return r || hr;
  }
  /**
  @internal
  */
  eq(t) {
    if (this == t)
      return !0;
    if (!(t instanceof Rn) || this.local.length != t.local.length || this.children.length != t.children.length)
      return !1;
    for (let n = 0; n < this.local.length; n++)
      if (!this.local[n].eq(t.local[n]))
        return !1;
    for (let n = 0; n < this.children.length; n += 3)
      if (this.children[n] != t.children[n] || this.children[n + 1] != t.children[n + 1] || !this.children[n + 2].eq(t.children[n + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(t) {
    return z_(this.localsInner(t));
  }
  /**
  @internal
  */
  localsInner(t) {
    if (this == hr)
      return nc;
    if (t.inlineContent || !this.local.some(Fs.is))
      return this.local;
    let n = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof Fs || n.push(this.local[r]);
    return n;
  }
  forEachSet(t) {
    t(this);
  }
}
Rn.empty = new Rn([], []);
Rn.removeOverlap = z_;
const hr = Rn.empty;
class Ss {
  constructor(t) {
    this.members = t;
  }
  map(t, n) {
    const r = this.members.map((i) => i.map(t, n, ql));
    return Ss.from(r);
  }
  forChild(t, n) {
    if (n.isLeaf)
      return Rn.empty;
    let r = [];
    for (let i = 0; i < this.members.length; i++) {
      let o = this.members[i].forChild(t, n);
      o != hr && (o instanceof Ss ? r = r.concat(o.members) : r.push(o));
    }
    return Ss.from(r);
  }
  eq(t) {
    if (!(t instanceof Ss) || t.members.length != this.members.length)
      return !1;
    for (let n = 0; n < this.members.length; n++)
      if (!this.members[n].eq(t.members[n]))
        return !1;
    return !0;
  }
  locals(t) {
    let n, r = !0;
    for (let i = 0; i < this.members.length; i++) {
      let o = this.members[i].localsInner(t);
      if (o.length)
        if (!n)
          n = o;
        else {
          r && (n = n.slice(), r = !1);
          for (let a = 0; a < o.length; a++)
            n.push(o[a]);
        }
    }
    return n ? z_(r ? n : n.sort(zl)) : nc;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(t) {
    switch (t.length) {
      case 0:
        return hr;
      case 1:
        return t[0];
      default:
        return new Ss(t.every((n) => n instanceof Rn) ? t : t.reduce((n, r) => n.concat(r instanceof Rn ? r : r.members), []));
    }
  }
  forEachSet(t) {
    for (let n = 0; n < this.members.length; n++)
      this.members[n].forEachSet(t);
  }
}
function HWe(e, t, n, r, i, o, a) {
  let s = e.slice();
  for (let u = 0, c = o; u < n.maps.length; u++) {
    let f = 0;
    n.maps[u].forEach((h, m, v, g) => {
      let y = g - v - (m - h);
      for (let w = 0; w < s.length; w += 3) {
        let C = s[w + 1];
        if (C < 0 || h > C + c - f)
          continue;
        let S = s[w] + c - f;
        m >= S ? s[w + 1] = h <= S ? -2 : -1 : h >= c && y && (s[w] += y, s[w + 1] += y);
      }
      f += y;
    }), c = n.maps[u].map(c, -1);
  }
  let l = !1;
  for (let u = 0; u < s.length; u += 3)
    if (s[u + 1] < 0) {
      if (s[u + 1] == -2) {
        l = !0, s[u + 1] = -1;
        continue;
      }
      let c = n.map(e[u] + o), f = c - i;
      if (f < 0 || f >= r.content.size) {
        l = !0;
        continue;
      }
      let h = n.map(e[u + 1] + o, -1), m = h - i, { index: v, offset: g } = r.content.findIndex(f), y = r.maybeChild(v);
      if (y && g == f && g + y.nodeSize == m) {
        let w = s[u + 2].mapInner(n, y, c + 1, e[u] + o + 1, a);
        w != hr ? (s[u] = f, s[u + 1] = m, s[u + 2] = w) : (s[u + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let u = UWe(s, e, t, n, i, o, a), c = Ng(u, r, 0, a);
    t = c.local;
    for (let f = 0; f < s.length; f += 3)
      s[f + 1] < 0 && (s.splice(f, 3), f -= 3);
    for (let f = 0, h = 0; f < c.children.length; f += 3) {
      let m = c.children[f];
      for (; h < s.length && s[h] < m; )
        h += 3;
      s.splice(h, 0, c.children[f], c.children[f + 1], c.children[f + 2]);
    }
  }
  return new Rn(t.sort(zl), s);
}
function Eee(e, t) {
  if (!t || !e.length)
    return e;
  let n = [];
  for (let r = 0; r < e.length; r++) {
    let i = e[r];
    n.push(new Mi(i.from + t, i.to + t, i.type));
  }
  return n;
}
function UWe(e, t, n, r, i, o, a) {
  function s(l, u) {
    for (let c = 0; c < l.local.length; c++) {
      let f = l.local[c].map(r, i, u);
      f ? n.push(f) : a.onRemove && a.onRemove(l.local[c].spec);
    }
    for (let c = 0; c < l.children.length; c += 3)
      s(l.children[c + 2], l.children[c] + u + 1);
  }
  for (let l = 0; l < e.length; l += 3)
    e[l + 1] == -1 && s(e[l + 2], t[l] + o + 1);
  return n;
}
function Nee(e, t, n) {
  if (t.isLeaf)
    return null;
  let r = n + t.nodeSize, i = null;
  for (let o = 0, a; o < e.length; o++)
    (a = e[o]) && a.from > n && a.to < r && ((i || (i = [])).push(a), e[o] = null);
  return i;
}
function Aee(e) {
  let t = [];
  for (let n = 0; n < e.length; n++)
    e[n] != null && t.push(e[n]);
  return t;
}
function Ng(e, t, n, r) {
  let i = [], o = !1;
  t.forEach((s, l) => {
    let u = Nee(e, s, l + n);
    if (u) {
      o = !0;
      let c = Ng(u, s, n + l + 1, r);
      c != hr && i.push(l, l + s.nodeSize, c);
    }
  });
  let a = Eee(o ? Aee(e) : e, -n).sort(zl);
  for (let s = 0; s < a.length; s++)
    a[s].type.valid(t, a[s]) || (r.onRemove && r.onRemove(a[s].spec), a.splice(s--, 1));
  return a.length || i.length ? new Rn(a, i) : hr;
}
function zl(e, t) {
  return e.from - t.from || e.to - t.to;
}
function z_(e) {
  let t = e;
  for (let n = 0; n < t.length - 1; n++) {
    let r = t[n];
    if (r.from != r.to)
      for (let i = n + 1; i < t.length; i++) {
        let o = t[i];
        if (o.from == r.from) {
          o.to != r.to && (t == e && (t = e.slice()), t[i] = o.copy(o.from, r.to), eF(t, i + 1, o.copy(r.to, o.to)));
          continue;
        } else {
          o.from < r.to && (t == e && (t = e.slice()), t[n] = r.copy(r.from, o.from), eF(t, i, r.copy(o.from, r.to)));
          break;
        }
      }
  }
  return t;
}
function eF(e, t, n) {
  for (; t < e.length && zl(n, e[t]) > 0; )
    t++;
  e.splice(t, 0, n);
}
function F8(e) {
  let t = [];
  return e.someProp("decorations", (n) => {
    let r = n(e.state);
    r && r != hr && t.push(r);
  }), e.cursorWrapper && t.push(Rn.create(e.state.doc, [e.cursorWrapper.deco])), Ss.from(t);
}
const GWe = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, KWe = Gr && $s <= 11;
class YWe {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(t) {
    this.anchorNode = t.anchorNode, this.anchorOffset = t.anchorOffset, this.focusNode = t.focusNode, this.focusOffset = t.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(t) {
    return t.anchorNode == this.anchorNode && t.anchorOffset == this.anchorOffset && t.focusNode == this.focusNode && t.focusOffset == this.focusOffset;
  }
}
class ZWe {
  constructor(t, n) {
    this.view = t, this.handleDOMChange = n, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new YWe(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let i = 0; i < r.length; i++)
        this.queue.push(r[i]);
      Gr && $s <= 11 && r.some((i) => i.type == "childList" && i.removedNodes.length || i.type == "characterData" && i.oldValue.length > i.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), KWe && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, GWe)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let t = this.observer.takeRecords();
      if (t.length) {
        for (let n = 0; n < t.length; n++)
          this.queue.push(t[n]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (UL(this.view)) {
      if (this.suppressingSelectionUpdates)
        return $a(this.view);
      if (Gr && $s <= 11 && !this.view.state.selection.empty) {
        let t = this.view.domSelectionRange();
        if (t.focusNode && iu(t.focusNode, t.focusOffset, t.anchorNode, t.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(t) {
    if (!t.focusNode)
      return !0;
    let n = /* @__PURE__ */ new Set(), r;
    for (let o = t.focusNode; o; o = Wh(o))
      n.add(o);
    for (let o = t.anchorNode; o; o = Wh(o))
      if (n.has(o)) {
        r = o;
        break;
      }
    let i = r && this.view.docView.nearestDesc(r);
    if (i && i.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let t of this.observer.takeRecords())
        this.queue.push(t);
    return this.queue;
  }
  flush() {
    let { view: t } = this;
    if (!t.docView || this.flushingSoon > -1)
      return;
    let n = this.pendingRecords();
    n.length && (this.queue = []);
    let r = t.domSelectionRange(), i = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && UL(t) && !this.ignoreSelectionChange(r), o = -1, a = -1, s = !1, l = [];
    if (t.editable)
      for (let c = 0; c < n.length; c++) {
        let f = this.registerMutation(n[c], l);
        f && (o = o < 0 ? f.from : Math.min(f.from, o), a = a < 0 ? f.to : Math.max(f.to, a), f.typeOver && (s = !0));
      }
    if (mo && l.length) {
      let c = l.filter((f) => f.nodeName == "BR");
      if (c.length == 2) {
        let [f, h] = c;
        f.parentNode && f.parentNode.parentNode == h.parentNode ? h.remove() : f.remove();
      } else {
        let { focusNode: f } = this.currentSelection;
        for (let h of c) {
          let m = h.parentNode;
          m && m.nodeName == "LI" && (!f || QWe(t, f) != m) && h.remove();
        }
      }
    }
    let u = null;
    o < 0 && i && t.input.lastFocus > Date.now() - 200 && Math.max(t.input.lastTouch, t.input.lastClick.time) < Date.now() - 300 && Lv(r) && (u = L_(t)) && u.eq(it.near(t.state.doc.resolve(0), 1)) ? (t.input.lastFocus = 0, $a(t), this.currentSelection.set(r), t.scrollToSelection()) : (o > -1 || i) && (o > -1 && (t.docView.markDirty(o, a), XWe(t)), this.handleDOMChange(o, a, s, l), t.docView && t.docView.dirty ? t.updateState(t.state) : this.currentSelection.eq(r) || $a(t), this.currentSelection.set(r));
  }
  registerMutation(t, n) {
    if (n.indexOf(t.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(t.target);
    if (t.type == "attributes" && (r == this.view.docView || t.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    t.attributeName == "style" && !t.oldValue && !t.target.getAttribute("style")) || !r || r.ignoreMutation(t))
      return null;
    if (t.type == "childList") {
      for (let c = 0; c < t.addedNodes.length; c++) {
        let f = t.addedNodes[c];
        n.push(f), f.nodeType == 3 && (this.lastChangedTextNode = f);
      }
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(t.target))
        return { from: r.posBefore, to: r.posAfter };
      let i = t.previousSibling, o = t.nextSibling;
      if (Gr && $s <= 11 && t.addedNodes.length)
        for (let c = 0; c < t.addedNodes.length; c++) {
          let { previousSibling: f, nextSibling: h } = t.addedNodes[c];
          (!f || Array.prototype.indexOf.call(t.addedNodes, f) < 0) && (i = f), (!h || Array.prototype.indexOf.call(t.addedNodes, h) < 0) && (o = h);
        }
      let a = i && i.parentNode == t.target ? tr(i) + 1 : 0, s = r.localPosFromDOM(t.target, a, -1), l = o && o.parentNode == t.target ? tr(o) : t.target.childNodes.length, u = r.localPosFromDOM(t.target, l, 1);
      return { from: s, to: u };
    } else return t.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : (this.lastChangedTextNode = t.target, {
      from: r.posAtStart,
      to: r.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: t.target.nodeValue == t.oldValue
    });
  }
}
let tF = /* @__PURE__ */ new WeakMap(), nF = !1;
function XWe(e) {
  if (!tF.has(e) && (tF.set(e, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(e.dom).whiteSpace) !== -1)) {
    if (e.requiresGeckoHackNode = mo, nF)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), nF = !0;
  }
}
function rF(e, t) {
  let n = t.startContainer, r = t.startOffset, i = t.endContainer, o = t.endOffset, a = e.domAtPos(e.state.selection.anchor);
  return iu(a.node, a.offset, i, o) && ([n, r, i, o] = [i, o, n, r]), { anchorNode: n, anchorOffset: r, focusNode: i, focusOffset: o };
}
function JWe(e, t) {
  if (t.getComposedRanges) {
    let i = t.getComposedRanges(e.root)[0];
    if (i)
      return rF(e, i);
  }
  let n;
  function r(i) {
    i.preventDefault(), i.stopImmediatePropagation(), n = i.getTargetRanges()[0];
  }
  return e.dom.addEventListener("beforeinput", r, !0), document.execCommand("indent"), e.dom.removeEventListener("beforeinput", r, !0), n ? rF(e, n) : null;
}
function QWe(e, t) {
  for (let n = t.parentNode; n && n != e.dom; n = n.parentNode) {
    let r = e.docView.nearestDesc(n, !0);
    if (r && r.node.isBlock)
      return n;
  }
  return null;
}
function eHe(e, t, n) {
  let { node: r, fromOffset: i, toOffset: o, from: a, to: s } = e.docView.parseRange(t, n), l = e.domSelectionRange(), u, c = l.anchorNode;
  if (c && e.dom.contains(c.nodeType == 1 ? c : c.parentNode) && (u = [{ node: c, offset: l.anchorOffset }], Lv(l) || u.push({ node: l.focusNode, offset: l.focusOffset })), vr && e.input.lastKeyCode === 8)
    for (let y = o; y > i; y--) {
      let w = r.childNodes[y - 1], C = w.pmViewDesc;
      if (w.nodeName == "BR" && !C) {
        o = y;
        break;
      }
      if (!C || C.size)
        break;
    }
  let f = e.state.doc, h = e.someProp("domParser") || Da.fromSchema(e.state.schema), m = f.resolve(a), v = null, g = h.parse(r, {
    topNode: m.parent,
    topMatch: m.parent.contentMatchAt(m.index()),
    topOpen: !0,
    from: i,
    to: o,
    preserveWhitespace: m.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: u,
    ruleFromNode: tHe,
    context: m
  });
  if (u && u[0].pos != null) {
    let y = u[0].pos, w = u[1] && u[1].pos;
    w == null && (w = y), v = { anchor: y + a, head: w + a };
  }
  return { doc: g, sel: v, from: a, to: s };
}
function tHe(e) {
  let t = e.pmViewDesc;
  if (t)
    return t.parseRule();
  if (e.nodeName == "BR" && e.parentNode) {
    if (Mr && /^(ul|ol)$/i.test(e.parentNode.nodeName)) {
      let n = document.createElement("div");
      return n.appendChild(document.createElement("li")), { skip: n };
    } else if (e.parentNode.lastChild == e || Mr && /^(tr|table)$/i.test(e.parentNode.nodeName))
      return { ignore: !0 };
  } else if (e.nodeName == "IMG" && e.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const nHe = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function rHe(e, t, n, r, i) {
  let o = e.input.compositionPendingChanges || (e.composing ? e.input.compositionID : 0);
  if (e.input.compositionPendingChanges = 0, t < 0) {
    let M = e.input.lastSelectionTime > Date.now() - 50 ? e.input.lastSelectionOrigin : null, L = L_(e, M);
    if (L && !e.state.selection.eq(L)) {
      if (vr && Qi && e.input.lastKeyCode === 13 && Date.now() - 100 < e.input.lastKeyCodeTime && e.someProp("handleKeyDown", (j) => j(e, _l(13, "Enter"))))
        return;
      let I = e.state.tr.setSelection(L);
      M == "pointer" ? I.setMeta("pointer", !0) : M == "key" && I.scrollIntoView(), o && I.setMeta("composition", o), e.dispatch(I);
    }
    return;
  }
  let a = e.state.doc.resolve(t), s = a.sharedDepth(n);
  t = a.before(s + 1), n = e.state.doc.resolve(n).after(s + 1);
  let l = e.state.selection, u = eHe(e, t, n), c = e.state.doc, f = c.slice(u.from, u.to), h, m;
  e.input.lastKeyCode === 8 && Date.now() - 100 < e.input.lastKeyCodeTime ? (h = e.state.selection.to, m = "end") : (h = e.state.selection.from, m = "start"), e.input.lastKeyCode = null;
  let v = aHe(f.content, u.doc.content, u.from, h, m);
  if (v && e.input.domChangeCount++, (cd && e.input.lastIOSEnter > Date.now() - 225 || Qi) && i.some((M) => M.nodeType == 1 && !nHe.test(M.nodeName)) && (!v || v.endA >= v.endB) && e.someProp("handleKeyDown", (M) => M(e, _l(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (!v)
    if (r && l instanceof Ze && !l.empty && l.$head.sameParent(l.$anchor) && !e.composing && !(u.sel && u.sel.anchor != u.sel.head))
      v = { start: l.from, endA: l.to, endB: l.to };
    else {
      if (u.sel) {
        let M = iF(e, e.state.doc, u.sel);
        if (M && !M.eq(e.state.selection)) {
          let L = e.state.tr.setSelection(M);
          o && L.setMeta("composition", o), e.dispatch(L);
        }
      }
      return;
    }
  e.state.selection.from < e.state.selection.to && v.start == v.endB && e.state.selection instanceof Ze && (v.start > e.state.selection.from && v.start <= e.state.selection.from + 2 && e.state.selection.from >= u.from ? v.start = e.state.selection.from : v.endA < e.state.selection.to && v.endA >= e.state.selection.to - 2 && e.state.selection.to <= u.to && (v.endB += e.state.selection.to - v.endA, v.endA = e.state.selection.to)), Gr && $s <= 11 && v.endB == v.start + 1 && v.endA == v.start && v.start > u.from && u.doc.textBetween(v.start - u.from - 1, v.start - u.from + 1) == "  " && (v.start--, v.endA--, v.endB--);
  let g = u.doc.resolveNoCache(v.start - u.from), y = u.doc.resolveNoCache(v.endB - u.from), w = c.resolve(v.start), C = g.sameParent(y) && g.parent.inlineContent && w.end() >= v.endA, S;
  if ((cd && e.input.lastIOSEnter > Date.now() - 225 && (!C || i.some((M) => M.nodeName == "DIV" || M.nodeName == "P")) || !C && g.pos < u.doc.content.size && !g.sameParent(y) && (S = it.findFrom(u.doc.resolve(g.pos + 1), 1, !0)) && S.head == y.pos) && e.someProp("handleKeyDown", (M) => M(e, _l(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (e.state.selection.anchor > v.start && oHe(c, v.start, v.endA, g, y) && e.someProp("handleKeyDown", (M) => M(e, _l(8, "Backspace")))) {
    Qi && vr && e.domObserver.suppressSelectionUpdates();
    return;
  }
  vr && Qi && v.endB == v.start && (e.input.lastAndroidDelete = Date.now()), Qi && !C && g.start() != y.start() && y.parentOffset == 0 && g.depth == y.depth && u.sel && u.sel.anchor == u.sel.head && u.sel.head == v.endA && (v.endB -= 2, y = u.doc.resolveNoCache(v.endB - u.from), setTimeout(() => {
    e.someProp("handleKeyDown", function(M) {
      return M(e, _l(13, "Enter"));
    });
  }, 20));
  let N = v.start, E = v.endA, A, O, T;
  if (C) {
    if (g.pos == y.pos)
      Gr && $s <= 11 && g.parentOffset == 0 && (e.domObserver.suppressSelectionUpdates(), setTimeout(() => $a(e), 20)), A = e.state.tr.delete(N, E), O = c.resolve(v.start).marksAcross(c.resolve(v.endA));
    else if (
      // Adding or removing a mark
      v.endA == v.endB && (T = iHe(g.parent.content.cut(g.parentOffset, y.parentOffset), w.parent.content.cut(w.parentOffset, v.endA - w.start())))
    )
      A = e.state.tr, T.type == "add" ? A.addMark(N, E, T.mark) : A.removeMark(N, E, T.mark);
    else if (g.parent.child(g.index()).isText && g.index() == y.index() - (y.textOffset ? 0 : 1)) {
      let M = g.parent.textBetween(g.parentOffset, y.parentOffset);
      if (e.someProp("handleTextInput", (L) => L(e, N, E, M)))
        return;
      A = e.state.tr.insertText(M, N, E);
    }
  }
  if (A || (A = e.state.tr.replace(N, E, u.doc.slice(v.start - u.from, v.endB - u.from))), u.sel) {
    let M = iF(e, A.doc, u.sel);
    M && !(vr && Qi && e.composing && M.empty && (v.start != v.endB || e.input.lastAndroidDelete < Date.now() - 100) && (M.head == N || M.head == A.mapping.map(E) - 1) || Gr && M.empty && M.head == N) && A.setSelection(M);
  }
  O && A.ensureMarks(O), o && A.setMeta("composition", o), e.dispatch(A.scrollIntoView());
}
function iF(e, t, n) {
  return Math.max(n.anchor, n.head) > t.content.size ? null : F_(e, t.resolve(n.anchor), t.resolve(n.head));
}
function iHe(e, t) {
  let n = e.firstChild.marks, r = t.firstChild.marks, i = n, o = r, a, s, l;
  for (let c = 0; c < r.length; c++)
    i = r[c].removeFromSet(i);
  for (let c = 0; c < n.length; c++)
    o = n[c].removeFromSet(o);
  if (i.length == 1 && o.length == 0)
    s = i[0], a = "add", l = (c) => c.mark(s.addToSet(c.marks));
  else if (i.length == 0 && o.length == 1)
    s = o[0], a = "remove", l = (c) => c.mark(s.removeFromSet(c.marks));
  else
    return null;
  let u = [];
  for (let c = 0; c < t.childCount; c++)
    u.push(l(t.child(c)));
  if (he.from(u).eq(e))
    return { mark: s, type: a };
}
function oHe(e, t, n, r, i) {
  if (
    // The content must have shrunk
    n - t <= i.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
    B8(r, !0, !1) < i.pos
  )
    return !1;
  let o = e.resolve(t);
  if (!r.parent.isTextblock) {
    let s = o.nodeAfter;
    return s != null && n == t + s.nodeSize;
  }
  if (o.parentOffset < o.parent.content.size || !o.parent.isTextblock)
    return !1;
  let a = e.resolve(B8(o, !0, !0));
  return !a.parent.isTextblock || a.pos > n || B8(a, !0, !1) < n ? !1 : r.parent.content.cut(r.parentOffset).eq(a.parent.content);
}
function B8(e, t, n) {
  let r = e.depth, i = t ? e.end() : e.pos;
  for (; r > 0 && (t || e.indexAfter(r) == e.node(r).childCount); )
    r--, i++, t = !1;
  if (n) {
    let o = e.node(r).maybeChild(e.indexAfter(r));
    for (; o && !o.isLeaf; )
      o = o.firstChild, i++;
  }
  return i;
}
function aHe(e, t, n, r, i) {
  let o = e.findDiffStart(t, n);
  if (o == null)
    return null;
  let { a, b: s } = e.findDiffEnd(t, n + e.size, n + t.size);
  if (i == "end") {
    let l = Math.max(0, o - Math.min(a, s));
    r -= a + l - o;
  }
  if (a < o && e.size < t.size) {
    let l = r <= o && r >= a ? o - r : 0;
    o -= l, o && o < t.size && oF(t.textBetween(o - 1, o + 1)) && (o += l ? 1 : -1), s = o + (s - a), a = o;
  } else if (s < o) {
    let l = r <= o && r >= s ? o - r : 0;
    o -= l, o && o < e.size && oF(e.textBetween(o - 1, o + 1)) && (o += l ? 1 : -1), a = o + (a - s), s = o;
  }
  return { start: o, endA: a, endB: s };
}
function oF(e) {
  if (e.length != 2)
    return !1;
  let t = e.charCodeAt(0), n = e.charCodeAt(1);
  return t >= 56320 && t <= 57343 && n >= 55296 && n <= 56319;
}
class sHe {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(t, n) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new NWe(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = n, this.state = n.state, this.directPlugins = n.plugins || [], this.directPlugins.forEach(cF), this.dispatch = this.dispatch.bind(this), this.dom = t && t.mount || document.createElement("div"), t && (t.appendChild ? t.appendChild(this.dom) : typeof t == "function" ? t(this.dom) : t.mount && (this.mounted = !0)), this.editable = lF(this), sF(this), this.nodeViews = uF(this), this.docView = jL(this.state.doc, aF(this), F8(this), this.dom, this), this.domObserver = new ZWe(this, (r, i, o, a) => rHe(this, r, i, o, a)), this.domObserver.start(), AWe(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let t = this._props;
      this._props = {};
      for (let n in t)
        this._props[n] = t[n];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(t) {
    t.handleDOMEvents != this._props.handleDOMEvents && aw(this);
    let n = this._props;
    this._props = t, t.plugins && (t.plugins.forEach(cF), this.directPlugins = t.plugins), this.updateStateInner(t.state, n);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(t) {
    let n = {};
    for (let r in this._props)
      n[r] = this._props[r];
    n.state = this.state;
    for (let r in t)
      n[r] = t[r];
    this.update(n);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(t) {
    this.updateStateInner(t, this._props);
  }
  updateStateInner(t, n) {
    var r;
    let i = this.state, o = !1, a = !1;
    t.storedMarks && this.composing && (wee(this), a = !0), this.state = t;
    let s = i.plugins != t.plugins || this._props.plugins != n.plugins;
    if (s || this._props.plugins != n.plugins || this._props.nodeViews != n.nodeViews) {
      let m = uF(this);
      uHe(m, this.nodeViews) && (this.nodeViews = m, o = !0);
    }
    (s || n.handleDOMEvents != this._props.handleDOMEvents) && aw(this), this.editable = lF(this), sF(this);
    let l = F8(this), u = aF(this), c = i.plugins != t.plugins && !i.doc.eq(t.doc) ? "reset" : t.scrollToSelection > i.scrollToSelection ? "to selection" : "preserve", f = o || !this.docView.matchesNode(t.doc, u, l);
    (f || !t.selection.eq(i.selection)) && (a = !0);
    let h = c == "preserve" && a && this.dom.style.overflowAnchor == null && Vze(this);
    if (a) {
      this.domObserver.stop();
      let m = f && (Gr || vr) && !this.composing && !i.selection.empty && !t.selection.empty && lHe(i.selection, t.selection);
      if (f) {
        let v = vr ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = jWe(this)), (o || !this.docView.update(t.doc, u, l, this)) && (this.docView.updateOuterDeco(u), this.docView.destroy(), this.docView = jL(t.doc, u, l, this.dom, this)), v && !this.trackWrites && (m = !0);
      }
      m || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && dWe(this)) ? $a(this, m) : (lee(this, t.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(i), !((r = this.dragging) === null || r === void 0) && r.node && !i.doc.eq(t.doc) && this.updateDraggedNode(this.dragging, i), c == "reset" ? this.dom.scrollTop = 0 : c == "to selection" ? this.scrollToSelection() : h && qze(h);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let t = this.domSelectionRange().focusNode;
    if (!this.someProp("handleScrollToSelection", (n) => n(this))) if (this.state.selection instanceof $e) {
      let n = this.docView.domAfterPos(this.state.selection.from);
      n.nodeType == 1 && DL(this, n.getBoundingClientRect(), t);
    } else
      DL(this, this.coordsAtPos(this.state.selection.head, 1), t);
  }
  destroyPluginViews() {
    let t;
    for (; t = this.pluginViews.pop(); )
      t.destroy && t.destroy();
  }
  updatePluginViews(t) {
    if (!t || t.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let n = 0; n < this.directPlugins.length; n++) {
        let r = this.directPlugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let n = 0; n < this.state.plugins.length; n++) {
        let r = this.state.plugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let n = 0; n < this.pluginViews.length; n++) {
        let r = this.pluginViews[n];
        r.update && r.update(this, t);
      }
  }
  updateDraggedNode(t, n) {
    let r = t.node, i = -1;
    if (this.state.doc.nodeAt(r.from) == r.node)
      i = r.from;
    else {
      let o = r.from + (this.state.doc.content.size - n.doc.content.size);
      (o > 0 && this.state.doc.nodeAt(o)) == r.node && (i = o);
    }
    this.dragging = new See(t.slice, t.move, i < 0 ? void 0 : $e.create(this.state.doc, i));
  }
  someProp(t, n) {
    let r = this._props && this._props[t], i;
    if (r != null && (i = n ? n(r) : r))
      return i;
    for (let a = 0; a < this.directPlugins.length; a++) {
      let s = this.directPlugins[a].props[t];
      if (s != null && (i = n ? n(s) : s))
        return i;
    }
    let o = this.state.plugins;
    if (o)
      for (let a = 0; a < o.length; a++) {
        let s = o[a].props[t];
        if (s != null && (i = n ? n(s) : s))
          return i;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (Gr) {
      let t = this.root.activeElement;
      if (t == this.dom)
        return !0;
      if (!t || !this.dom.contains(t))
        return !1;
      for (; t && this.dom != t && this.dom.contains(t); ) {
        if (t.contentEditable == "false")
          return !1;
        t = t.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && zze(this.dom), $a(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let t = this._root;
    if (t == null) {
      for (let n = this.dom.parentNode; n; n = n.parentNode)
        if (n.nodeType == 9 || n.nodeType == 11 && n.host)
          return n.getSelection || (Object.getPrototypeOf(n).getSelection = () => n.ownerDocument.getSelection()), this._root = n;
    }
    return t || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(t) {
    return Kze(this, t);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(t, n = 1) {
    return eee(this, t, n);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(t, n = 0) {
    return this.docView.domFromPos(t, n);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(t) {
    let n = this.docView.descAt(t);
    return n ? n.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(t, n, r = -1) {
    let i = this.docView.posFromDOM(t, n, r);
    if (i == null)
      throw new RangeError("DOM position not inside the editor");
    return i;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(t, n) {
    return Qze(this, n || this.state, t);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(t, n) {
    return Uh(this, "", t, !1, n || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(t, n) {
    return Uh(this, t, null, !0, n || new ClipboardEvent("paste"));
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (OWe(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], F8(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, Pze());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(t) {
    return PWe(this, t);
  }
  /**
  Dispatch a transaction. Will call
  [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
  when given, and otherwise defaults to applying the transaction to
  the current state and calling
  [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
  This method is bound to the view instance, so that it can be
  easily passed around.
  */
  dispatch(t) {
    let n = this._props.dispatchTransaction;
    n ? n.call(this, t) : this.updateState(this.state.apply(t));
  }
  /**
  @internal
  */
  domSelectionRange() {
    let t = this.domSelection();
    return t ? Mr && this.root.nodeType === 11 && Ize(this.dom.ownerDocument) == this.dom && JWe(this, t) || t : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
function aF(e) {
  let t = /* @__PURE__ */ Object.create(null);
  return t.class = "ProseMirror", t.contenteditable = String(e.editable), e.someProp("attributes", (n) => {
    if (typeof n == "function" && (n = n(e.state)), n)
      for (let r in n)
        r == "class" ? t.class += " " + n[r] : r == "style" ? t.style = (t.style ? t.style + ";" : "") + n[r] : !t[r] && r != "contenteditable" && r != "nodeName" && (t[r] = String(n[r]));
  }), t.translate || (t.translate = "no"), [Mi.node(0, e.state.doc.content.size, t)];
}
function sF(e) {
  if (e.markCursor) {
    let t = document.createElement("img");
    t.className = "ProseMirror-separator", t.setAttribute("mark-placeholder", "true"), t.setAttribute("alt", ""), e.cursorWrapper = { dom: t, deco: Mi.widget(e.state.selection.from, t, { raw: !0, marks: e.markCursor }) };
  } else
    e.cursorWrapper = null;
}
function lF(e) {
  return !e.someProp("editable", (t) => t(e.state) === !1);
}
function lHe(e, t) {
  let n = Math.min(e.$anchor.sharedDepth(e.head), t.$anchor.sharedDepth(t.head));
  return e.$anchor.start(n) != t.$anchor.start(n);
}
function uF(e) {
  let t = /* @__PURE__ */ Object.create(null);
  function n(r) {
    for (let i in r)
      Object.prototype.hasOwnProperty.call(t, i) || (t[i] = r[i]);
  }
  return e.someProp("nodeViews", n), e.someProp("markViews", n), t;
}
function uHe(e, t) {
  let n = 0, r = 0;
  for (let i in e) {
    if (e[i] != t[i])
      return !0;
    n++;
  }
  for (let i in t)
    r++;
  return n != r;
}
function cF(e) {
  if (e.spec.state || e.spec.filterTransaction || e.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var Hs = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Ag = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, cHe = typeof navigator < "u" && /Mac/.test(navigator.platform), dHe = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var nr = 0; nr < 10; nr++) Hs[48 + nr] = Hs[96 + nr] = String(nr);
for (var nr = 1; nr <= 24; nr++) Hs[nr + 111] = "F" + nr;
for (var nr = 65; nr <= 90; nr++)
  Hs[nr] = String.fromCharCode(nr + 32), Ag[nr] = String.fromCharCode(nr);
for (var j8 in Hs) Ag.hasOwnProperty(j8) || (Ag[j8] = Hs[j8]);
function fHe(e) {
  var t = cHe && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || dHe && e.shiftKey && e.key && e.key.length == 1 || e.key == "Unidentified", n = !t && e.key || (e.shiftKey ? Ag : Hs)[e.keyCode] || e.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
const hHe = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function pHe(e) {
  let t = e.split(/-(?!$)/), n = t[t.length - 1];
  n == "Space" && (n = " ");
  let r, i, o, a;
  for (let s = 0; s < t.length - 1; s++) {
    let l = t[s];
    if (/^(cmd|meta|m)$/i.test(l))
      a = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      o = !0;
    else if (/^mod$/i.test(l))
      hHe ? a = !0 : i = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return r && (n = "Alt-" + n), i && (n = "Ctrl-" + n), a && (n = "Meta-" + n), o && (n = "Shift-" + n), n;
}
function mHe(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n in e)
    t[pHe(n)] = e[n];
  return t;
}
function V8(e, t, n = !0) {
  return t.altKey && (e = "Alt-" + e), t.ctrlKey && (e = "Ctrl-" + e), t.metaKey && (e = "Meta-" + e), n && t.shiftKey && (e = "Shift-" + e), e;
}
function gHe(e) {
  return new $r({ props: { handleKeyDown: Oee(e) } });
}
function Oee(e) {
  let t = mHe(e);
  return function(n, r) {
    let i = fHe(r), o, a = t[V8(i, r)];
    if (a && a(n.state, n.dispatch, n))
      return !0;
    if (i.length == 1 && i != " ") {
      if (r.shiftKey) {
        let s = t[V8(i, r, !1)];
        if (s && s(n.state, n.dispatch, n))
          return !0;
      }
      if ((r.shiftKey || r.altKey || r.metaKey || i.charCodeAt(0) > 127) && (o = Hs[r.keyCode]) && o != i) {
        let s = t[V8(o, r)];
        if (s && s(n.state, n.dispatch, n))
          return !0;
      }
    }
    return !1;
  };
}
const W_ = (e, t) => e.selection.empty ? !1 : (t && t(e.tr.deleteSelection().scrollIntoView()), !0);
function kee(e, t) {
  let { $cursor: n } = e.selection;
  return !n || (t ? !t.endOfTextblock("backward", e) : n.parentOffset > 0) ? null : n;
}
const Pee = (e, t, n) => {
  let r = kee(e, n);
  if (!r)
    return !1;
  let i = H_(r);
  if (!i) {
    let a = r.blockRange(), s = a && jd(a);
    return s == null ? !1 : (t && t(e.tr.lift(a, s).scrollIntoView()), !0);
  }
  let o = i.nodeBefore;
  if (Bee(e, i, t, -1))
    return !0;
  if (r.parent.content.size == 0 && (dd(o, "end") || $e.isSelectable(o)))
    for (let a = r.depth; ; a--) {
      let s = Iv(e.doc, r.before(a), r.after(a), _e.empty);
      if (s && s.slice.size < s.to - s.from) {
        if (t) {
          let l = e.tr.step(s);
          l.setSelection(dd(o, "end") ? it.findFrom(l.doc.resolve(l.mapping.map(i.pos, -1)), -1) : $e.create(l.doc, i.pos - o.nodeSize)), t(l.scrollIntoView());
        }
        return !0;
      }
      if (a == 1 || r.node(a - 1).childCount > 1)
        break;
    }
  return o.isAtom && i.depth == r.depth - 1 ? (t && t(e.tr.delete(i.pos - o.nodeSize, i.pos).scrollIntoView()), !0) : !1;
}, vHe = (e, t, n) => {
  let r = kee(e, n);
  if (!r)
    return !1;
  let i = H_(r);
  return i ? Tee(e, i, t) : !1;
}, yHe = (e, t, n) => {
  let r = Ree(e, n);
  if (!r)
    return !1;
  let i = U_(r);
  return i ? Tee(e, i, t) : !1;
};
function Tee(e, t, n) {
  let r = t.nodeBefore, i = r, o = t.pos - 1;
  for (; !i.isTextblock; o--) {
    if (i.type.spec.isolating)
      return !1;
    let c = i.lastChild;
    if (!c)
      return !1;
    i = c;
  }
  let a = t.nodeAfter, s = a, l = t.pos + 1;
  for (; !s.isTextblock; l++) {
    if (s.type.spec.isolating)
      return !1;
    let c = s.firstChild;
    if (!c)
      return !1;
    s = c;
  }
  let u = Iv(e.doc, o, l, _e.empty);
  if (!u || u.from != o || u instanceof Vn && u.slice.size >= l - o)
    return !1;
  if (n) {
    let c = e.tr.step(u);
    c.setSelection(Ze.create(c.doc, o)), n(c.scrollIntoView());
  }
  return !0;
}
function dd(e, t, n = !1) {
  for (let r = e; r; r = t == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (n && r.childCount != 1)
      return !1;
  }
  return !1;
}
const Mee = (e, t, n) => {
  let { $head: r, empty: i } = e.selection, o = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("backward", e) : r.parentOffset > 0)
      return !1;
    o = H_(r);
  }
  let a = o && o.nodeBefore;
  return !a || !$e.isSelectable(a) ? !1 : (t && t(e.tr.setSelection($e.create(e.doc, o.pos - a.nodeSize)).scrollIntoView()), !0);
};
function H_(e) {
  if (!e.parent.type.spec.isolating)
    for (let t = e.depth - 1; t >= 0; t--) {
      if (e.index(t) > 0)
        return e.doc.resolve(e.before(t + 1));
      if (e.node(t).type.spec.isolating)
        break;
    }
  return null;
}
function Ree(e, t) {
  let { $cursor: n } = e.selection;
  return !n || (t ? !t.endOfTextblock("forward", e) : n.parentOffset < n.parent.content.size) ? null : n;
}
const Dee = (e, t, n) => {
  let r = Ree(e, n);
  if (!r)
    return !1;
  let i = U_(r);
  if (!i)
    return !1;
  let o = i.nodeAfter;
  if (Bee(e, i, t, 1))
    return !0;
  if (r.parent.content.size == 0 && (dd(o, "start") || $e.isSelectable(o))) {
    let a = Iv(e.doc, r.before(), r.after(), _e.empty);
    if (a && a.slice.size < a.to - a.from) {
      if (t) {
        let s = e.tr.step(a);
        s.setSelection(dd(o, "start") ? it.findFrom(s.doc.resolve(s.mapping.map(i.pos)), 1) : $e.create(s.doc, s.mapping.map(i.pos))), t(s.scrollIntoView());
      }
      return !0;
    }
  }
  return o.isAtom && i.depth == r.depth - 1 ? (t && t(e.tr.delete(i.pos, i.pos + o.nodeSize).scrollIntoView()), !0) : !1;
}, Iee = (e, t, n) => {
  let { $head: r, empty: i } = e.selection, o = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("forward", e) : r.parentOffset < r.parent.content.size)
      return !1;
    o = U_(r);
  }
  let a = o && o.nodeAfter;
  return !a || !$e.isSelectable(a) ? !1 : (t && t(e.tr.setSelection($e.create(e.doc, o.pos)).scrollIntoView()), !0);
};
function U_(e) {
  if (!e.parent.type.spec.isolating)
    for (let t = e.depth - 1; t >= 0; t--) {
      let n = e.node(t);
      if (e.index(t) + 1 < n.childCount)
        return e.doc.resolve(e.after(t + 1));
      if (n.type.spec.isolating)
        break;
    }
  return null;
}
const bHe = (e, t) => {
  let n = e.selection, r = n instanceof $e, i;
  if (r) {
    if (n.node.isTextblock || !il(e.doc, n.from))
      return !1;
    i = n.from;
  } else if (i = Dv(e.doc, n.from, -1), i == null)
    return !1;
  if (t) {
    let o = e.tr.join(i);
    r && o.setSelection($e.create(o.doc, i - e.doc.resolve(i).nodeBefore.nodeSize)), t(o.scrollIntoView());
  }
  return !0;
}, xHe = (e, t) => {
  let n = e.selection, r;
  if (n instanceof $e) {
    if (n.node.isTextblock || !il(e.doc, n.to))
      return !1;
    r = n.to;
  } else if (r = Dv(e.doc, n.to, 1), r == null)
    return !1;
  return t && t(e.tr.join(r).scrollIntoView()), !0;
}, wHe = (e, t) => {
  let { $from: n, $to: r } = e.selection, i = n.blockRange(r), o = i && jd(i);
  return o == null ? !1 : (t && t(e.tr.lift(i, o).scrollIntoView()), !0);
}, $ee = (e, t) => {
  let { $head: n, $anchor: r } = e.selection;
  return !n.parent.type.spec.code || !n.sameParent(r) ? !1 : (t && t(e.tr.insertText(`
`).scrollIntoView()), !0);
};
function G_(e) {
  for (let t = 0; t < e.edgeCount; t++) {
    let { type: n } = e.edge(t);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
const CHe = (e, t) => {
  let { $head: n, $anchor: r } = e.selection;
  if (!n.parent.type.spec.code || !n.sameParent(r))
    return !1;
  let i = n.node(-1), o = n.indexAfter(-1), a = G_(i.contentMatchAt(o));
  if (!a || !i.canReplaceWith(o, o, a))
    return !1;
  if (t) {
    let s = n.after(), l = e.tr.replaceWith(s, s, a.createAndFill());
    l.setSelection(it.near(l.doc.resolve(s), 1)), t(l.scrollIntoView());
  }
  return !0;
}, Lee = (e, t) => {
  let n = e.selection, { $from: r, $to: i } = n;
  if (n instanceof Ii || r.parent.inlineContent || i.parent.inlineContent)
    return !1;
  let o = G_(i.parent.contentMatchAt(i.indexAfter()));
  if (!o || !o.isTextblock)
    return !1;
  if (t) {
    let a = (!r.parentOffset && i.index() < i.parent.childCount ? r : i).pos, s = e.tr.insert(a, o.createAndFill());
    s.setSelection(Ze.create(s.doc, a + 1)), t(s.scrollIntoView());
  }
  return !0;
}, Fee = (e, t) => {
  let { $cursor: n } = e.selection;
  if (!n || n.parent.content.size)
    return !1;
  if (n.depth > 1 && n.after() != n.end(-1)) {
    let o = n.before();
    if (Ia(e.doc, o))
      return t && t(e.tr.split(o).scrollIntoView()), !0;
  }
  let r = n.blockRange(), i = r && jd(r);
  return i == null ? !1 : (t && t(e.tr.lift(r, i).scrollIntoView()), !0);
};
function SHe(e) {
  return (t, n) => {
    let { $from: r, $to: i } = t.selection;
    if (t.selection instanceof $e && t.selection.node.isBlock)
      return !r.parentOffset || !Ia(t.doc, r.pos) ? !1 : (n && n(t.tr.split(r.pos).scrollIntoView()), !0);
    if (!r.depth)
      return !1;
    let o = [], a, s, l = !1, u = !1;
    for (let m = r.depth; ; m--)
      if (r.node(m).isBlock) {
        l = r.end(m) == r.pos + (r.depth - m), u = r.start(m) == r.pos - (r.depth - m), s = G_(r.node(m - 1).contentMatchAt(r.indexAfter(m - 1))), o.unshift(l && s ? { type: s } : null), a = m;
        break;
      } else {
        if (m == 1)
          return !1;
        o.unshift(null);
      }
    let c = t.tr;
    (t.selection instanceof Ze || t.selection instanceof Ii) && c.deleteSelection();
    let f = c.mapping.map(r.pos), h = Ia(c.doc, f, o.length, o);
    if (h || (o[0] = s ? { type: s } : null, h = Ia(c.doc, f, o.length, o)), c.split(f, o.length, o), !l && u && r.node(a).type != s) {
      let m = c.mapping.map(r.before(a)), v = c.doc.resolve(m);
      s && r.node(a - 1).canReplaceWith(v.index(), v.index() + 1, s) && c.setNodeMarkup(c.mapping.map(r.before(a)), s);
    }
    return n && n(c.scrollIntoView()), !0;
  };
}
const _He = SHe(), EHe = (e, t) => {
  let { $from: n, to: r } = e.selection, i, o = n.sharedDepth(r);
  return o == 0 ? !1 : (i = n.before(o), t && t(e.tr.setSelection($e.create(e.doc, i))), !0);
};
function NHe(e, t, n) {
  let r = t.nodeBefore, i = t.nodeAfter, o = t.index();
  return !r || !i || !r.type.compatibleContent(i.type) ? !1 : !r.content.size && t.parent.canReplace(o - 1, o) ? (n && n(e.tr.delete(t.pos - r.nodeSize, t.pos).scrollIntoView()), !0) : !t.parent.canReplace(o, o + 1) || !(i.isTextblock || il(e.doc, t.pos)) ? !1 : (n && n(e.tr.join(t.pos).scrollIntoView()), !0);
}
function Bee(e, t, n, r) {
  let i = t.nodeBefore, o = t.nodeAfter, a, s, l = i.type.spec.isolating || o.type.spec.isolating;
  if (!l && NHe(e, t, n))
    return !0;
  let u = !l && t.parent.canReplace(t.index(), t.index() + 1);
  if (u && (a = (s = i.contentMatchAt(i.childCount)).findWrapping(o.type)) && s.matchType(a[0] || o.type).validEnd) {
    if (n) {
      let m = t.pos + o.nodeSize, v = he.empty;
      for (let w = a.length - 1; w >= 0; w--)
        v = he.from(a[w].create(null, v));
      v = he.from(i.copy(v));
      let g = e.tr.step(new Wn(t.pos - 1, m, t.pos, m, new _e(v, 1, 0), a.length, !0)), y = g.doc.resolve(m + 2 * a.length);
      y.nodeAfter && y.nodeAfter.type == i.type && il(g.doc, y.pos) && g.join(y.pos), n(g.scrollIntoView());
    }
    return !0;
  }
  let c = o.type.spec.isolating || r > 0 && l ? null : it.findFrom(t, 1), f = c && c.$from.blockRange(c.$to), h = f && jd(f);
  if (h != null && h >= t.depth)
    return n && n(e.tr.lift(f, h).scrollIntoView()), !0;
  if (u && dd(o, "start", !0) && dd(i, "end")) {
    let m = i, v = [];
    for (; v.push(m), !m.isTextblock; )
      m = m.lastChild;
    let g = o, y = 1;
    for (; !g.isTextblock; g = g.firstChild)
      y++;
    if (m.canReplace(m.childCount, m.childCount, g.content)) {
      if (n) {
        let w = he.empty;
        for (let S = v.length - 1; S >= 0; S--)
          w = he.from(v[S].copy(w));
        let C = e.tr.step(new Wn(t.pos - v.length, t.pos + o.nodeSize, t.pos + y, t.pos + o.nodeSize - y, new _e(w, v.length, 0), 0, !0));
        n(C.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function jee(e) {
  return function(t, n) {
    let r = t.selection, i = e < 0 ? r.$from : r.$to, o = i.depth;
    for (; i.node(o).isInline; ) {
      if (!o)
        return !1;
      o--;
    }
    return i.node(o).isTextblock ? (n && n(t.tr.setSelection(Ze.create(t.doc, e < 0 ? i.start(o) : i.end(o)))), !0) : !1;
  };
}
const AHe = jee(-1), OHe = jee(1);
function kHe(e, t = null) {
  return function(n, r) {
    let { $from: i, $to: o } = n.selection, a = i.blockRange(o), s = a && D_(a, e, t);
    return s ? (r && r(n.tr.wrap(a, s).scrollIntoView()), !0) : !1;
  };
}
function dF(e, t = null) {
  return function(n, r) {
    let i = !1;
    for (let o = 0; o < n.selection.ranges.length && !i; o++) {
      let { $from: { pos: a }, $to: { pos: s } } = n.selection.ranges[o];
      n.doc.nodesBetween(a, s, (l, u) => {
        if (i)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(e, t)))
          if (l.type == e)
            i = !0;
          else {
            let c = n.doc.resolve(u), f = c.index();
            i = c.parent.canReplaceWith(f, f + 1, e);
          }
      });
    }
    if (!i)
      return !1;
    if (r) {
      let o = n.tr;
      for (let a = 0; a < n.selection.ranges.length; a++) {
        let { $from: { pos: s }, $to: { pos: l } } = n.selection.ranges[a];
        o.setBlockType(s, l, e, t);
      }
      r(o.scrollIntoView());
    }
    return !0;
  };
}
function K_(...e) {
  return function(t, n, r) {
    for (let i = 0; i < e.length; i++)
      if (e[i](t, n, r))
        return !0;
    return !1;
  };
}
K_(W_, Pee, Mee);
K_(W_, Dee, Iee);
K_($ee, Lee, Fee, _He);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function PHe(e, t = null) {
  return function(n, r) {
    let { $from: i, $to: o } = n.selection, a = i.blockRange(o), s = !1, l = a;
    if (!a)
      return !1;
    if (a.depth >= 2 && i.node(a.depth - 1).type.compatibleContent(e) && a.startIndex == 0) {
      if (i.index(a.depth - 1) == 0)
        return !1;
      let c = n.doc.resolve(a.start - 2);
      l = new yg(c, c, a.depth), a.endIndex < a.parent.childCount && (a = new yg(i, n.doc.resolve(o.end(a.depth)), a.depth)), s = !0;
    }
    let u = D_(l, e, t, a);
    return u ? (r && r(THe(n.tr, a, u, s, e).scrollIntoView()), !0) : !1;
  };
}
function THe(e, t, n, r, i) {
  let o = he.empty;
  for (let c = n.length - 1; c >= 0; c--)
    o = he.from(n[c].type.create(n[c].attrs, o));
  e.step(new Wn(t.start - (r ? 2 : 0), t.end, t.start, t.end, new _e(o, 0, 0), n.length, !0));
  let a = 0;
  for (let c = 0; c < n.length; c++)
    n[c].type == i && (a = c + 1);
  let s = n.length - a, l = t.start + n.length - (r ? 2 : 0), u = t.parent;
  for (let c = t.startIndex, f = t.endIndex, h = !0; c < f; c++, h = !1)
    !h && Ia(e.doc, l, s) && (e.split(l, s), l += 2 * s), l += u.child(c).nodeSize;
  return e;
}
function MHe(e) {
  return function(t, n) {
    let { $from: r, $to: i } = t.selection, o = r.blockRange(i, (a) => a.childCount > 0 && a.firstChild.type == e);
    return o ? n ? r.node(o.depth - 1).type == e ? RHe(t, n, e, o) : DHe(t, n, o) : !0 : !1;
  };
}
function RHe(e, t, n, r) {
  let i = e.tr, o = r.end, a = r.$to.end(r.depth);
  o < a && (i.step(new Wn(o - 1, a, o, a, new _e(he.from(n.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new yg(i.doc.resolve(r.$from.pos), i.doc.resolve(a), r.depth));
  const s = jd(r);
  if (s == null)
    return !1;
  i.lift(r, s);
  let l = i.mapping.map(o, -1) - 1;
  return il(i.doc, l) && i.join(l), t(i.scrollIntoView()), !0;
}
function DHe(e, t, n) {
  let r = e.tr, i = n.parent;
  for (let m = n.end, v = n.endIndex - 1, g = n.startIndex; v > g; v--)
    m -= i.child(v).nodeSize, r.delete(m - 1, m + 1);
  let o = r.doc.resolve(n.start), a = o.nodeAfter;
  if (r.mapping.map(n.end) != n.start + o.nodeAfter.nodeSize)
    return !1;
  let s = n.startIndex == 0, l = n.endIndex == i.childCount, u = o.node(-1), c = o.index(-1);
  if (!u.canReplace(c + (s ? 0 : 1), c + 1, a.content.append(l ? he.empty : he.from(i))))
    return !1;
  let f = o.pos, h = f + a.nodeSize;
  return r.step(new Wn(f - (s ? 1 : 0), h + (l ? 1 : 0), f + 1, h - 1, new _e((s ? he.empty : he.from(i.copy(he.empty))).append(l ? he.empty : he.from(i.copy(he.empty))), s ? 0 : 1, l ? 0 : 1), s ? 0 : 1)), t(r.scrollIntoView()), !0;
}
function IHe(e) {
  return function(t, n) {
    let { $from: r, $to: i } = t.selection, o = r.blockRange(i, (u) => u.childCount > 0 && u.firstChild.type == e);
    if (!o)
      return !1;
    let a = o.startIndex;
    if (a == 0)
      return !1;
    let s = o.parent, l = s.child(a - 1);
    if (l.type != e)
      return !1;
    if (n) {
      let u = l.lastChild && l.lastChild.type == s.type, c = he.from(u ? e.create() : null), f = new _e(he.from(e.create(null, he.from(s.type.create(null, c)))), u ? 3 : 1, 0), h = o.start, m = o.end;
      n(t.tr.step(new Wn(h - (u ? 3 : 1), m, h, m, f, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function jv(e) {
  const { state: t, transaction: n } = e;
  let { selection: r } = n, { doc: i } = n, { storedMarks: o } = n;
  return {
    ...t,
    apply: t.apply.bind(t),
    applyTransaction: t.applyTransaction.bind(t),
    plugins: t.plugins,
    schema: t.schema,
    reconfigure: t.reconfigure.bind(t),
    toJSON: t.toJSON.bind(t),
    get storedMarks() {
      return o;
    },
    get selection() {
      return r;
    },
    get doc() {
      return i;
    },
    get tr() {
      return r = n.selection, i = n.doc, o = n.storedMarks, n;
    }
  };
}
class Vv {
  constructor(t) {
    this.editor = t.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = t.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: t, editor: n, state: r } = this, { view: i } = n, { tr: o } = r, a = this.buildProps(o);
    return Object.fromEntries(Object.entries(t).map(([s, l]) => [s, (...c) => {
      const f = l(...c)(a);
      return !o.getMeta("preventDispatch") && !this.hasCustomState && i.dispatch(o), f;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(t, n = !0) {
    const { rawCommands: r, editor: i, state: o } = this, { view: a } = i, s = [], l = !!t, u = t || o.tr, c = () => (!l && n && !u.getMeta("preventDispatch") && !this.hasCustomState && a.dispatch(u), s.every((h) => h === !0)), f = {
      ...Object.fromEntries(Object.entries(r).map(([h, m]) => [h, (...g) => {
        const y = this.buildProps(u, n), w = m(...g)(y);
        return s.push(w), f;
      }])),
      run: c
    };
    return f;
  }
  createCan(t) {
    const { rawCommands: n, state: r } = this, i = !1, o = t || r.tr, a = this.buildProps(o, i);
    return {
      ...Object.fromEntries(Object.entries(n).map(([l, u]) => [l, (...c) => u(...c)({ ...a, dispatch: void 0 })])),
      chain: () => this.createChain(o, i)
    };
  }
  buildProps(t, n = !0) {
    const { rawCommands: r, editor: i, state: o } = this, { view: a } = i, s = {
      tr: t,
      editor: i,
      view: a,
      state: jv({
        state: o,
        transaction: t
      }),
      dispatch: n ? () => {
      } : void 0,
      chain: () => this.createChain(t, n),
      can: () => this.createCan(t),
      get commands() {
        return Object.fromEntries(Object.entries(r).map(([l, u]) => [l, (...c) => u(...c)(s)]));
      }
    };
    return s;
  }
}
class $He {
  constructor() {
    this.callbacks = {};
  }
  on(t, n) {
    return this.callbacks[t] || (this.callbacks[t] = []), this.callbacks[t].push(n), this;
  }
  emit(t, ...n) {
    const r = this.callbacks[t];
    return r && r.forEach((i) => i.apply(this, n)), this;
  }
  off(t, n) {
    const r = this.callbacks[t];
    return r && (n ? this.callbacks[t] = r.filter((i) => i !== n) : delete this.callbacks[t]), this;
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function ke(e, t, n) {
  return e.config[t] === void 0 && e.parent ? ke(e.parent, t, n) : typeof e.config[t] == "function" ? e.config[t].bind({
    ...n,
    parent: e.parent ? ke(e.parent, t, n) : null
  }) : e.config[t];
}
function qv(e) {
  const t = e.filter((i) => i.type === "extension"), n = e.filter((i) => i.type === "node"), r = e.filter((i) => i.type === "mark");
  return {
    baseExtensions: t,
    nodeExtensions: n,
    markExtensions: r
  };
}
function Vee(e) {
  const t = [], { nodeExtensions: n, markExtensions: r } = qv(e), i = [...n, ...r], o = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return e.forEach((a) => {
    const s = {
      name: a.name,
      options: a.options,
      storage: a.storage,
      extensions: i
    }, l = ke(a, "addGlobalAttributes", s);
    if (!l)
      return;
    l().forEach((c) => {
      c.types.forEach((f) => {
        Object.entries(c.attributes).forEach(([h, m]) => {
          t.push({
            type: f,
            name: h,
            attribute: {
              ...o,
              ...m
            }
          });
        });
      });
    });
  }), i.forEach((a) => {
    const s = {
      name: a.name,
      options: a.options,
      storage: a.storage
    }, l = ke(a, "addAttributes", s);
    if (!l)
      return;
    const u = l();
    Object.entries(u).forEach(([c, f]) => {
      const h = {
        ...o,
        ...f
      };
      typeof (h == null ? void 0 : h.default) == "function" && (h.default = h.default()), h != null && h.isRequired && (h == null ? void 0 : h.default) === void 0 && delete h.default, t.push({
        type: a.name,
        name: c,
        attribute: h
      });
    });
  }), t;
}
function Un(e, t) {
  if (typeof e == "string") {
    if (!t.nodes[e])
      throw Error(`There is no node type named '${e}'. Maybe you forgot to add the extension?`);
    return t.nodes[e];
  }
  return e;
}
function Ir(...e) {
  return e.filter((t) => !!t).reduce((t, n) => {
    const r = { ...t };
    return Object.entries(n).forEach(([i, o]) => {
      if (!r[i]) {
        r[i] = o;
        return;
      }
      if (i === "class") {
        const s = o ? o.split(" ") : [], l = r[i] ? r[i].split(" ") : [], u = s.filter((c) => !l.includes(c));
        r[i] = [...l, ...u].join(" ");
      } else if (i === "style") {
        const s = o ? o.split(";").map((c) => c.trim()).filter(Boolean) : [], l = r[i] ? r[i].split(";").map((c) => c.trim()).filter(Boolean) : [], u = /* @__PURE__ */ new Map();
        l.forEach((c) => {
          const [f, h] = c.split(":").map((m) => m.trim());
          u.set(f, h);
        }), s.forEach((c) => {
          const [f, h] = c.split(":").map((m) => m.trim());
          u.set(f, h);
        }), r[i] = Array.from(u.entries()).map(([c, f]) => `${c}: ${f}`).join("; ");
      } else
        r[i] = o;
    }), r;
  }, {});
}
function sw(e, t) {
  return t.filter((n) => n.type === e.type.name).filter((n) => n.attribute.rendered).map((n) => n.attribute.renderHTML ? n.attribute.renderHTML(e.attrs) || {} : {
    [n.name]: e.attrs[n.name]
  }).reduce((n, r) => Ir(n, r), {});
}
function qee(e) {
  return typeof e == "function";
}
function ct(e, t = void 0, ...n) {
  return qee(e) ? t ? e.bind(t)(...n) : e(...n) : e;
}
function LHe(e = {}) {
  return Object.keys(e).length === 0 && e.constructor === Object;
}
function FHe(e) {
  return typeof e != "string" ? e : e.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(e) : e === "true" ? !0 : e === "false" ? !1 : e;
}
function fF(e, t) {
  return "style" in e ? e : {
    ...e,
    getAttrs: (n) => {
      const r = e.getAttrs ? e.getAttrs(n) : e.attrs;
      if (r === !1)
        return !1;
      const i = t.reduce((o, a) => {
        const s = a.attribute.parseHTML ? a.attribute.parseHTML(n) : FHe(n.getAttribute(a.name));
        return s == null ? o : {
          ...o,
          [a.name]: s
        };
      }, {});
      return { ...r, ...i };
    }
  };
}
function hF(e) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(e).filter(([t, n]) => t === "attrs" && LHe(n) ? !1 : n != null)
  );
}
function BHe(e, t) {
  var n;
  const r = Vee(e), { nodeExtensions: i, markExtensions: o } = qv(e), a = (n = i.find((u) => ke(u, "topNode"))) === null || n === void 0 ? void 0 : n.name, s = Object.fromEntries(i.map((u) => {
    const c = r.filter((w) => w.type === u.name), f = {
      name: u.name,
      options: u.options,
      storage: u.storage,
      editor: t
    }, h = e.reduce((w, C) => {
      const S = ke(C, "extendNodeSchema", f);
      return {
        ...w,
        ...S ? S(u) : {}
      };
    }, {}), m = hF({
      ...h,
      content: ct(ke(u, "content", f)),
      marks: ct(ke(u, "marks", f)),
      group: ct(ke(u, "group", f)),
      inline: ct(ke(u, "inline", f)),
      atom: ct(ke(u, "atom", f)),
      selectable: ct(ke(u, "selectable", f)),
      draggable: ct(ke(u, "draggable", f)),
      code: ct(ke(u, "code", f)),
      whitespace: ct(ke(u, "whitespace", f)),
      defining: ct(ke(u, "defining", f)),
      isolating: ct(ke(u, "isolating", f)),
      attrs: Object.fromEntries(c.map((w) => {
        var C;
        return [w.name, { default: (C = w == null ? void 0 : w.attribute) === null || C === void 0 ? void 0 : C.default }];
      }))
    }), v = ct(ke(u, "parseHTML", f));
    v && (m.parseDOM = v.map((w) => fF(w, c)));
    const g = ke(u, "renderHTML", f);
    g && (m.toDOM = (w) => g({
      node: w,
      HTMLAttributes: sw(w, c)
    }));
    const y = ke(u, "renderText", f);
    return y && (m.toText = y), [u.name, m];
  })), l = Object.fromEntries(o.map((u) => {
    const c = r.filter((y) => y.type === u.name), f = {
      name: u.name,
      options: u.options,
      storage: u.storage,
      editor: t
    }, h = e.reduce((y, w) => {
      const C = ke(w, "extendMarkSchema", f);
      return {
        ...y,
        ...C ? C(u) : {}
      };
    }, {}), m = hF({
      ...h,
      inclusive: ct(ke(u, "inclusive", f)),
      excludes: ct(ke(u, "excludes", f)),
      group: ct(ke(u, "group", f)),
      spanning: ct(ke(u, "spanning", f)),
      code: ct(ke(u, "code", f)),
      attrs: Object.fromEntries(c.map((y) => {
        var w;
        return [y.name, { default: (w = y == null ? void 0 : y.attribute) === null || w === void 0 ? void 0 : w.default }];
      }))
    }), v = ct(ke(u, "parseHTML", f));
    v && (m.parseDOM = v.map((y) => fF(y, c)));
    const g = ke(u, "renderHTML", f);
    return g && (m.toDOM = (y) => g({
      mark: y,
      HTMLAttributes: sw(y, c)
    })), [u.name, m];
  }));
  return new T_({
    topNode: a,
    nodes: s,
    marks: l
  });
}
function q8(e, t) {
  return t.nodes[e] || t.marks[e] || null;
}
function pF(e, t) {
  return Array.isArray(t) ? t.some((n) => (typeof n == "string" ? n : n.name) === e.name) : t;
}
const jHe = (e, t = 500) => {
  let n = "";
  const r = e.parentOffset;
  return e.parent.nodesBetween(Math.max(0, r - t), r, (i, o, a, s) => {
    var l, u;
    const c = ((u = (l = i.type.spec).toText) === null || u === void 0 ? void 0 : u.call(l, {
      node: i,
      pos: o,
      parent: a,
      index: s
    })) || i.textContent || "%leaf%";
    n += i.isAtom && !i.isText ? c : c.slice(0, Math.max(0, r - o));
  }), n;
};
function Y_(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}
class zv {
  constructor(t) {
    this.find = t.find, this.handler = t.handler;
  }
}
const VHe = (e, t) => {
  if (Y_(t))
    return t.exec(e);
  const n = t(e);
  if (!n)
    return null;
  const r = [n.text];
  return r.index = n.index, r.input = e, r.data = n.data, n.replaceWith && (n.text.includes(n.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(n.replaceWith)), r;
};
function O1(e) {
  var t;
  const { editor: n, from: r, to: i, text: o, rules: a, plugin: s } = e, { view: l } = n;
  if (l.composing)
    return !1;
  const u = l.state.doc.resolve(r);
  if (
    // check for code node
    u.parent.type.spec.code || !((t = u.nodeBefore || u.nodeAfter) === null || t === void 0) && t.marks.find((h) => h.type.spec.code)
  )
    return !1;
  let c = !1;
  const f = jHe(u) + o;
  return a.forEach((h) => {
    if (c)
      return;
    const m = VHe(f, h.find);
    if (!m)
      return;
    const v = l.state.tr, g = jv({
      state: l.state,
      transaction: v
    }), y = {
      from: r - (m[0].length - o.length),
      to: i
    }, { commands: w, chain: C, can: S } = new Vv({
      editor: n,
      state: g
    });
    h.handler({
      state: g,
      range: y,
      match: m,
      commands: w,
      chain: C,
      can: S
    }) === null || !v.steps.length || (v.setMeta(s, {
      transform: v,
      from: r,
      to: i,
      text: o
    }), l.dispatch(v), c = !0);
  }), c;
}
function qHe(e) {
  const { editor: t, rules: n } = e, r = new $r({
    state: {
      init() {
        return null;
      },
      apply(i, o) {
        const a = i.getMeta(r);
        if (a)
          return a;
        const s = i.getMeta("applyInputRules");
        return !!s && setTimeout(() => {
          const { from: u, text: c } = s, f = u + c.length;
          O1({
            editor: t,
            from: u,
            to: f,
            text: c,
            rules: n,
            plugin: r
          });
        }), i.selectionSet || i.docChanged ? null : o;
      }
    },
    props: {
      handleTextInput(i, o, a, s) {
        return O1({
          editor: t,
          from: o,
          to: a,
          text: s,
          rules: n,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (i) => (setTimeout(() => {
          const { $cursor: o } = i.state.selection;
          o && O1({
            editor: t,
            from: o.pos,
            to: o.pos,
            text: "",
            rules: n,
            plugin: r
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(i, o) {
        if (o.key !== "Enter")
          return !1;
        const { $cursor: a } = i.state.selection;
        return a ? O1({
          editor: t,
          from: a.pos,
          to: a.pos,
          text: `
`,
          rules: n,
          plugin: r
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return r;
}
function zHe(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function k1(e) {
  return zHe(e) !== "Object" ? !1 : e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}
function Wv(e, t) {
  const n = { ...e };
  return k1(e) && k1(t) && Object.keys(t).forEach((r) => {
    k1(t[r]) && k1(e[r]) ? n[r] = Wv(e[r], t[r]) : n[r] = t[r];
  }), n;
}
class Zr {
  constructor(t = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name, t.defaultOptions && Object.keys(t.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = ct(ke(this, "addOptions", {
      name: this.name
    }))), this.storage = ct(ke(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(t = {}) {
    return new Zr(t);
  }
  configure(t = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => Wv(this.options, t)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(t = {}) {
    const n = new Zr(t);
    return n.parent = this, this.child = n, n.name = t.name ? t.name : n.parent.name, t.defaultOptions && Object.keys(t.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = ct(ke(n, "addOptions", {
      name: n.name
    })), n.storage = ct(ke(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  static handleExit({ editor: t, mark: n }) {
    const { tr: r } = t.state, i = t.state.selection.$from;
    if (i.pos === i.end()) {
      const a = i.marks();
      if (!!!a.find((u) => (u == null ? void 0 : u.type.name) === n.name))
        return !1;
      const l = a.find((u) => (u == null ? void 0 : u.type.name) === n.name);
      return l && r.removeStoredMark(l), r.insertText(" ", i.pos), t.view.dispatch(r), !0;
    }
    return !1;
  }
}
function WHe(e) {
  return typeof e == "number";
}
class HHe {
  constructor(t) {
    this.find = t.find, this.handler = t.handler;
  }
}
const UHe = (e, t, n) => {
  if (Y_(t))
    return [...e.matchAll(t)];
  const r = t(e, n);
  return r ? r.map((i) => {
    const o = [i.text];
    return o.index = i.index, o.input = e, o.data = i.data, i.replaceWith && (i.text.includes(i.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), o.push(i.replaceWith)), o;
  }) : [];
};
function GHe(e) {
  const { editor: t, state: n, from: r, to: i, rule: o, pasteEvent: a, dropEvent: s } = e, { commands: l, chain: u, can: c } = new Vv({
    editor: t,
    state: n
  }), f = [];
  return n.doc.nodesBetween(r, i, (m, v) => {
    if (!m.isTextblock || m.type.spec.code)
      return;
    const g = Math.max(r, v), y = Math.min(i, v + m.content.size), w = m.textBetween(g - v, y - v, void 0, "￼");
    UHe(w, o.find, a).forEach((S) => {
      if (S.index === void 0)
        return;
      const N = g + S.index + 1, E = N + S[0].length, A = {
        from: n.tr.mapping.map(N),
        to: n.tr.mapping.map(E)
      }, O = o.handler({
        state: n,
        range: A,
        match: S,
        commands: l,
        chain: u,
        can: c,
        pasteEvent: a,
        dropEvent: s
      });
      f.push(O);
    });
  }), f.every((m) => m !== null);
}
const KHe = (e) => {
  var t;
  const n = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (t = n.clipboardData) === null || t === void 0 || t.setData("text/html", e), n;
};
function YHe(e) {
  const { editor: t, rules: n } = e;
  let r = null, i = !1, o = !1, a = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, s = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  const l = ({ state: c, from: f, to: h, rule: m, pasteEvt: v }) => {
    const g = c.tr, y = jv({
      state: c,
      transaction: g
    });
    if (!(!GHe({
      editor: t,
      state: y,
      from: Math.max(f - 1, 0),
      to: h.b - 1,
      rule: m,
      pasteEvent: v,
      dropEvent: s
    }) || !g.steps.length))
      return s = typeof DragEvent < "u" ? new DragEvent("drop") : null, a = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, g;
  };
  return n.map((c) => new $r({
    // we register a global drag handler to track the current drag source element
    view(f) {
      const h = (m) => {
        var v;
        r = !((v = f.dom.parentElement) === null || v === void 0) && v.contains(m.target) ? f.dom.parentElement : null;
      };
      return window.addEventListener("dragstart", h), {
        destroy() {
          window.removeEventListener("dragstart", h);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (f, h) => (o = r === f.dom.parentElement, s = h, !1),
        paste: (f, h) => {
          var m;
          const v = (m = h.clipboardData) === null || m === void 0 ? void 0 : m.getData("text/html");
          return a = h, i = !!(v != null && v.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (f, h, m) => {
      const v = f[0], g = v.getMeta("uiEvent") === "paste" && !i, y = v.getMeta("uiEvent") === "drop" && !o, w = v.getMeta("applyPasteRules"), C = !!w;
      if (!g && !y && !C)
        return;
      if (C) {
        const { from: E, text: A } = w, O = E + A.length, T = KHe(A);
        return l({
          rule: c,
          state: m,
          from: E,
          to: { b: O },
          pasteEvt: T
        });
      }
      const S = h.doc.content.findDiffStart(m.doc.content), N = h.doc.content.findDiffEnd(m.doc.content);
      if (!(!WHe(S) || !N || S === N.b))
        return l({
          rule: c,
          state: m,
          from: S,
          to: N,
          pasteEvt: a
        });
    }
  }));
}
function ZHe(e) {
  const t = e.filter((n, r) => e.indexOf(n) !== r);
  return Array.from(new Set(t));
}
class lc {
  constructor(t, n) {
    this.splittableMarks = [], this.editor = n, this.extensions = lc.resolve(t), this.schema = BHe(this.extensions, n), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(t) {
    const n = lc.sort(lc.flatten(t)), r = ZHe(n.map((i) => i.name));
    return r.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${r.map((i) => `'${i}'`).join(", ")}]. This can lead to issues.`), n;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(t) {
    return t.map((n) => {
      const r = {
        name: n.name,
        options: n.options,
        storage: n.storage
      }, i = ke(n, "addExtensions", r);
      return i ? [n, ...this.flatten(i())] : n;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(t) {
    return t.sort((r, i) => {
      const o = ke(r, "priority") || 100, a = ke(i, "priority") || 100;
      return o > a ? -1 : o < a ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((t, n) => {
      const r = {
        name: n.name,
        options: n.options,
        storage: n.storage,
        editor: this.editor,
        type: q8(n.name, this.schema)
      }, i = ke(n, "addCommands", r);
      return i ? {
        ...t,
        ...i()
      } : t;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: t } = this, n = lc.sort([...this.extensions].reverse()), r = [], i = [], o = n.map((a) => {
      const s = {
        name: a.name,
        options: a.options,
        storage: a.storage,
        editor: t,
        type: q8(a.name, this.schema)
      }, l = [], u = ke(a, "addKeyboardShortcuts", s);
      let c = {};
      if (a.type === "mark" && ke(a, "exitable", s) && (c.ArrowRight = () => Zr.handleExit({ editor: t, mark: a })), u) {
        const g = Object.fromEntries(Object.entries(u()).map(([y, w]) => [y, () => w({ editor: t })]));
        c = { ...c, ...g };
      }
      const f = gHe(c);
      l.push(f);
      const h = ke(a, "addInputRules", s);
      pF(a, t.options.enableInputRules) && h && r.push(...h());
      const m = ke(a, "addPasteRules", s);
      pF(a, t.options.enablePasteRules) && m && i.push(...m());
      const v = ke(a, "addProseMirrorPlugins", s);
      if (v) {
        const g = v();
        l.push(...g);
      }
      return l;
    }).flat();
    return [
      qHe({
        editor: t,
        rules: r
      }),
      ...YHe({
        editor: t,
        rules: i
      }),
      ...o
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return Vee(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: t } = this, { nodeExtensions: n } = qv(this.extensions);
    return Object.fromEntries(n.filter((r) => !!ke(r, "addNodeView")).map((r) => {
      const i = this.attributes.filter((l) => l.type === r.name), o = {
        name: r.name,
        options: r.options,
        storage: r.storage,
        editor: t,
        type: Un(r.name, this.schema)
      }, a = ke(r, "addNodeView", o);
      if (!a)
        return [];
      const s = (l, u, c, f, h) => {
        const m = sw(l, i);
        return a()({
          // pass-through
          node: l,
          view: u,
          getPos: c,
          decorations: f,
          innerDecorations: h,
          // tiptap-specific
          editor: t,
          extension: r,
          HTMLAttributes: m
        });
      };
      return [r.name, s];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((t) => {
      var n;
      this.editor.extensionStorage[t.name] = t.storage;
      const r = {
        name: t.name,
        options: t.options,
        storage: t.storage,
        editor: this.editor,
        type: q8(t.name, this.schema)
      };
      t.type === "mark" && (!((n = ct(ke(t, "keepOnSplit", r))) !== null && n !== void 0) || n) && this.splittableMarks.push(t.name);
      const i = ke(t, "onBeforeCreate", r), o = ke(t, "onCreate", r), a = ke(t, "onUpdate", r), s = ke(t, "onSelectionUpdate", r), l = ke(t, "onTransaction", r), u = ke(t, "onFocus", r), c = ke(t, "onBlur", r), f = ke(t, "onDestroy", r);
      i && this.editor.on("beforeCreate", i), o && this.editor.on("create", o), a && this.editor.on("update", a), s && this.editor.on("selectionUpdate", s), l && this.editor.on("transaction", l), u && this.editor.on("focus", u), c && this.editor.on("blur", c), f && this.editor.on("destroy", f);
    });
  }
}
class Gn {
  constructor(t = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name, t.defaultOptions && Object.keys(t.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = ct(ke(this, "addOptions", {
      name: this.name
    }))), this.storage = ct(ke(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(t = {}) {
    return new Gn(t);
  }
  configure(t = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => Wv(this.options, t)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(t = {}) {
    const n = new Gn({ ...this.config, ...t });
    return n.parent = this, this.child = n, n.name = t.name ? t.name : n.parent.name, t.defaultOptions && Object.keys(t.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = ct(ke(n, "addOptions", {
      name: n.name
    })), n.storage = ct(ke(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
}
function zee(e, t, n) {
  const { from: r, to: i } = t, { blockSeparator: o = `

`, textSerializers: a = {} } = n || {};
  let s = "";
  return e.nodesBetween(r, i, (l, u, c, f) => {
    var h;
    l.isBlock && u > r && (s += o);
    const m = a == null ? void 0 : a[l.type.name];
    if (m)
      return c && (s += m({
        node: l,
        pos: u,
        parent: c,
        index: f,
        range: t
      })), !1;
    l.isText && (s += (h = l == null ? void 0 : l.text) === null || h === void 0 ? void 0 : h.slice(Math.max(r, u) - u, i - u));
  }), s;
}
function Wee(e) {
  return Object.fromEntries(Object.entries(e.nodes).filter(([, t]) => t.spec.toText).map(([t, n]) => [t, n.spec.toText]));
}
const Hee = Gn.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new $r({
        key: new xo("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: e } = this, { state: t, schema: n } = e, { doc: r, selection: i } = t, { ranges: o } = i, a = Math.min(...o.map((c) => c.$from.pos)), s = Math.max(...o.map((c) => c.$to.pos)), l = Wee(n);
            return zee(r, { from: a, to: s }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
}), XHe = () => ({ editor: e, view: t }) => (requestAnimationFrame(() => {
  var n;
  e.isDestroyed || (t.dom.blur(), (n = window == null ? void 0 : window.getSelection()) === null || n === void 0 || n.removeAllRanges());
}), !0), JHe = (e = !1) => ({ commands: t }) => t.setContent("", e), QHe = () => ({ state: e, tr: t, dispatch: n }) => {
  const { selection: r } = t, { ranges: i } = r;
  return n && i.forEach(({ $from: o, $to: a }) => {
    e.doc.nodesBetween(o.pos, a.pos, (s, l) => {
      if (s.type.isText)
        return;
      const { doc: u, mapping: c } = t, f = u.resolve(c.map(l)), h = u.resolve(c.map(l + s.nodeSize)), m = f.blockRange(h);
      if (!m)
        return;
      const v = jd(m);
      if (s.type.isTextblock) {
        const { defaultType: g } = f.parent.contentMatchAt(f.index());
        t.setNodeMarkup(m.start, g);
      }
      (v || v === 0) && t.lift(m, v);
    });
  }), !0;
}, eUe = (e) => (t) => e(t), tUe = () => ({ state: e, dispatch: t }) => Lee(e, t), nUe = (e, t) => ({ editor: n, tr: r }) => {
  const { state: i } = n, o = i.doc.slice(e.from, e.to);
  r.deleteRange(e.from, e.to);
  const a = r.mapping.map(t);
  return r.insert(a, o.content), r.setSelection(new Ze(r.doc.resolve(a - 1))), !0;
}, rUe = () => ({ tr: e, dispatch: t }) => {
  const { selection: n } = e, r = n.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const i = e.selection.$anchor;
  for (let o = i.depth; o > 0; o -= 1)
    if (i.node(o).type === r.type) {
      if (t) {
        const s = i.before(o), l = i.after(o);
        e.delete(s, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, iUe = (e) => ({ tr: t, state: n, dispatch: r }) => {
  const i = Un(e, n.schema), o = t.selection.$anchor;
  for (let a = o.depth; a > 0; a -= 1)
    if (o.node(a).type === i) {
      if (r) {
        const l = o.before(a), u = o.after(a);
        t.delete(l, u).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, oUe = (e) => ({ tr: t, dispatch: n }) => {
  const { from: r, to: i } = e;
  return n && t.delete(r, i), !0;
}, aUe = () => ({ state: e, dispatch: t }) => W_(e, t), sUe = () => ({ commands: e }) => e.keyboardShortcut("Enter"), lUe = () => ({ state: e, dispatch: t }) => CHe(e, t);
function Og(e, t, n = { strict: !0 }) {
  const r = Object.keys(t);
  return r.length ? r.every((i) => n.strict ? t[i] === e[i] : Y_(t[i]) ? t[i].test(e[i]) : t[i] === e[i]) : !0;
}
function lw(e, t, n = {}) {
  return e.find((r) => r.type === t && Og(r.attrs, n));
}
function uUe(e, t, n = {}) {
  return !!lw(e, t, n);
}
function Z_(e, t, n = {}) {
  if (!e || !t)
    return;
  let r = e.parent.childAfter(e.parentOffset);
  if ((!r.node || !r.node.marks.some((u) => u.type === t)) && (r = e.parent.childBefore(e.parentOffset)), !r.node || !r.node.marks.some((u) => u.type === t))
    return;
  const i = lw([...r.node.marks], t, n);
  if (!i)
    return;
  let o = r.index, a = e.start() + r.offset, s = o + 1, l = a + r.node.nodeSize;
  for (lw([...r.node.marks], t, n); o > 0 && i.isInSet(e.parent.child(o - 1).marks); )
    o -= 1, a -= e.parent.child(o).nodeSize;
  for (; s < e.parent.childCount && uUe([...e.parent.child(s).marks], t, n); )
    l += e.parent.child(s).nodeSize, s += 1;
  return {
    from: a,
    to: l
  };
}
function al(e, t) {
  if (typeof e == "string") {
    if (!t.marks[e])
      throw Error(`There is no mark type named '${e}'. Maybe you forgot to add the extension?`);
    return t.marks[e];
  }
  return e;
}
const cUe = (e, t = {}) => ({ tr: n, state: r, dispatch: i }) => {
  const o = al(e, r.schema), { doc: a, selection: s } = n, { $from: l, from: u, to: c } = s;
  if (i) {
    const f = Z_(l, o, t);
    if (f && f.from <= u && f.to >= c) {
      const h = Ze.create(a, f.from, f.to);
      n.setSelection(h);
    }
  }
  return !0;
}, dUe = (e) => (t) => {
  const n = typeof e == "function" ? e(t) : e;
  for (let r = 0; r < n.length; r += 1)
    if (n[r](t))
      return !0;
  return !1;
};
function Uee(e) {
  return e instanceof Ze;
}
function Il(e = 0, t = 0, n = 0) {
  return Math.min(Math.max(e, t), n);
}
function Gee(e, t = null) {
  if (!t)
    return null;
  const n = it.atStart(e), r = it.atEnd(e);
  if (t === "start" || t === !0)
    return n;
  if (t === "end")
    return r;
  const i = n.from, o = r.to;
  return t === "all" ? Ze.create(e, Il(0, i, o), Il(e.content.size, i, o)) : Ze.create(e, Il(t, i, o), Il(t, i, o));
}
function X_() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const fUe = (e = null, t = {}) => ({ editor: n, view: r, tr: i, dispatch: o }) => {
  t = {
    scrollIntoView: !0,
    ...t
  };
  const a = () => {
    X_() && r.dom.focus(), requestAnimationFrame(() => {
      n.isDestroyed || (r.focus(), t != null && t.scrollIntoView && n.commands.scrollIntoView());
    });
  };
  if (r.hasFocus() && e === null || e === !1)
    return !0;
  if (o && e === null && !Uee(n.state.selection))
    return a(), !0;
  const s = Gee(i.doc, e) || n.state.selection, l = n.state.selection.eq(s);
  return o && (l || i.setSelection(s), l && i.storedMarks && i.setStoredMarks(i.storedMarks), a()), !0;
}, hUe = (e, t) => (n) => e.every((r, i) => t(r, { ...n, index: i })), pUe = (e, t) => ({ tr: n, commands: r }) => r.insertContentAt({ from: n.selection.from, to: n.selection.to }, e, t), Kee = (e) => {
  const t = e.childNodes;
  for (let n = t.length - 1; n >= 0; n -= 1) {
    const r = t[n];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? e.removeChild(r) : r.nodeType === 1 && Kee(r);
  }
  return e;
};
function P1(e) {
  const t = `<body>${e}</body>`, n = new window.DOMParser().parseFromString(t, "text/html").body;
  return Kee(n);
}
function kg(e, t, n) {
  n = {
    slice: !0,
    parseOptions: {},
    ...n
  };
  const r = typeof e == "object" && e !== null, i = typeof e == "string";
  if (r)
    try {
      if (Array.isArray(e) && e.length > 0)
        return he.fromArray(e.map((s) => t.nodeFromJSON(s)));
      const a = t.nodeFromJSON(e);
      return n.errorOnInvalidContent && a.check(), a;
    } catch (o) {
      if (n.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: o });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", e, "Error:", o), kg("", t, n);
    }
  if (i) {
    if (n.errorOnInvalidContent) {
      let a = !1, s = "";
      const l = new T_({
        topNode: t.spec.topNode,
        marks: t.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: t.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (u) => (a = !0, s = typeof u == "string" ? u : u.outerHTML, null)
              }
            ]
          }
        })
      });
      if (n.slice ? Da.fromSchema(l).parseSlice(P1(e), n.parseOptions) : Da.fromSchema(l).parse(P1(e), n.parseOptions), n.errorOnInvalidContent && a)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${s}`) });
    }
    const o = Da.fromSchema(t);
    return n.slice ? o.parseSlice(P1(e), n.parseOptions).content : o.parse(P1(e), n.parseOptions);
  }
  return kg("", t, n);
}
function mUe(e, t, n) {
  const r = e.steps.length - 1;
  if (r < t)
    return;
  const i = e.steps[r];
  if (!(i instanceof Vn || i instanceof Wn))
    return;
  const o = e.mapping.maps[r];
  let a = 0;
  o.forEach((s, l, u, c) => {
    a === 0 && (a = c);
  }), e.setSelection(it.near(e.doc.resolve(a), n));
}
const gUe = (e) => !("type" in e), vUe = (e, t, n) => ({ tr: r, dispatch: i, editor: o }) => {
  var a;
  if (i) {
    n = {
      parseOptions: o.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...n
    };
    let s;
    try {
      s = kg(t, o.schema, {
        parseOptions: {
          preserveWhitespace: "full",
          ...n.parseOptions
        },
        errorOnInvalidContent: (a = n.errorOnInvalidContent) !== null && a !== void 0 ? a : o.options.enableContentCheck
      });
    } catch (v) {
      return o.emit("contentError", {
        editor: o,
        error: v,
        disableCollaboration: () => {
          o.storage.collaboration && (o.storage.collaboration.isDisabled = !0);
        }
      }), !1;
    }
    let { from: l, to: u } = typeof e == "number" ? { from: e, to: e } : { from: e.from, to: e.to }, c = !0, f = !0;
    if ((gUe(s) ? s : [s]).forEach((v) => {
      v.check(), c = c ? v.isText && v.marks.length === 0 : !1, f = f ? v.isBlock : !1;
    }), l === u && f) {
      const { parent: v } = r.doc.resolve(l);
      v.isTextblock && !v.type.spec.code && !v.childCount && (l -= 1, u += 1);
    }
    let m;
    c ? (Array.isArray(t) ? m = t.map((v) => v.text || "").join("") : typeof t == "object" && t && t.text ? m = t.text : m = t, r.insertText(m, l, u)) : (m = s, r.replaceWith(l, u, m)), n.updateSelection && mUe(r, r.steps.length - 1, -1), n.applyInputRules && r.setMeta("applyInputRules", { from: l, text: m }), n.applyPasteRules && r.setMeta("applyPasteRules", { from: l, text: m });
  }
  return !0;
}, yUe = () => ({ state: e, dispatch: t }) => bHe(e, t), bUe = () => ({ state: e, dispatch: t }) => xHe(e, t), xUe = () => ({ state: e, dispatch: t }) => Pee(e, t), wUe = () => ({ state: e, dispatch: t }) => Dee(e, t), CUe = () => ({ state: e, dispatch: t, tr: n }) => {
  try {
    const r = Dv(e.doc, e.selection.$from.pos, -1);
    return r == null ? !1 : (n.join(r, 2), t && t(n), !0);
  } catch {
    return !1;
  }
}, SUe = () => ({ state: e, dispatch: t, tr: n }) => {
  try {
    const r = Dv(e.doc, e.selection.$from.pos, 1);
    return r == null ? !1 : (n.join(r, 2), t && t(n), !0);
  } catch {
    return !1;
  }
}, _Ue = () => ({ state: e, dispatch: t }) => vHe(e, t), EUe = () => ({ state: e, dispatch: t }) => yHe(e, t);
function Yee() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function NUe(e) {
  const t = e.split(/-(?!$)/);
  let n = t[t.length - 1];
  n === "Space" && (n = " ");
  let r, i, o, a;
  for (let s = 0; s < t.length - 1; s += 1) {
    const l = t[s];
    if (/^(cmd|meta|m)$/i.test(l))
      a = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      o = !0;
    else if (/^mod$/i.test(l))
      X_() || Yee() ? a = !0 : i = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return r && (n = `Alt-${n}`), i && (n = `Ctrl-${n}`), a && (n = `Meta-${n}`), o && (n = `Shift-${n}`), n;
}
const AUe = (e) => ({ editor: t, view: n, tr: r, dispatch: i }) => {
  const o = NUe(e).split(/-(?!$)/), a = o.find((u) => !["Alt", "Ctrl", "Meta", "Shift"].includes(u)), s = new KeyboardEvent("keydown", {
    key: a === "Space" ? " " : a,
    altKey: o.includes("Alt"),
    ctrlKey: o.includes("Ctrl"),
    metaKey: o.includes("Meta"),
    shiftKey: o.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = t.captureTransaction(() => {
    n.someProp("handleKeyDown", (u) => u(n, s));
  });
  return l == null || l.steps.forEach((u) => {
    const c = u.map(r.mapping);
    c && i && r.maybeStep(c);
  }), !0;
};
function Kh(e, t, n = {}) {
  const { from: r, to: i, empty: o } = e.selection, a = t ? Un(t, e.schema) : null, s = [];
  e.doc.nodesBetween(r, i, (f, h) => {
    if (f.isText)
      return;
    const m = Math.max(r, h), v = Math.min(i, h + f.nodeSize);
    s.push({
      node: f,
      from: m,
      to: v
    });
  });
  const l = i - r, u = s.filter((f) => a ? a.name === f.node.type.name : !0).filter((f) => Og(f.node.attrs, n, { strict: !1 }));
  return o ? !!u.length : u.reduce((f, h) => f + h.to - h.from, 0) >= l;
}
const OUe = (e, t = {}) => ({ state: n, dispatch: r }) => {
  const i = Un(e, n.schema);
  return Kh(n, i, t) ? wHe(n, r) : !1;
}, kUe = () => ({ state: e, dispatch: t }) => Fee(e, t), PUe = (e) => ({ state: t, dispatch: n }) => {
  const r = Un(e, t.schema);
  return MHe(r)(t, n);
}, TUe = () => ({ state: e, dispatch: t }) => $ee(e, t);
function Hv(e, t) {
  return t.nodes[e] ? "node" : t.marks[e] ? "mark" : null;
}
function mF(e, t) {
  const n = typeof t == "string" ? [t] : t;
  return Object.keys(e).reduce((r, i) => (n.includes(i) || (r[i] = e[i]), r), {});
}
const MUe = (e, t) => ({ tr: n, state: r, dispatch: i }) => {
  let o = null, a = null;
  const s = Hv(typeof e == "string" ? e : e.name, r.schema);
  return s ? (s === "node" && (o = Un(e, r.schema)), s === "mark" && (a = al(e, r.schema)), i && n.selection.ranges.forEach((l) => {
    r.doc.nodesBetween(l.$from.pos, l.$to.pos, (u, c) => {
      o && o === u.type && n.setNodeMarkup(c, void 0, mF(u.attrs, t)), a && u.marks.length && u.marks.forEach((f) => {
        a === f.type && n.addMark(c, c + u.nodeSize, a.create(mF(f.attrs, t)));
      });
    });
  }), !0) : !1;
}, RUe = () => ({ tr: e, dispatch: t }) => (t && e.scrollIntoView(), !0), DUe = () => ({ tr: e, commands: t }) => t.setTextSelection({
  from: 0,
  to: e.doc.content.size
}), IUe = () => ({ state: e, dispatch: t }) => Mee(e, t), $Ue = () => ({ state: e, dispatch: t }) => Iee(e, t), LUe = () => ({ state: e, dispatch: t }) => EHe(e, t), FUe = () => ({ state: e, dispatch: t }) => OHe(e, t), BUe = () => ({ state: e, dispatch: t }) => AHe(e, t);
function uw(e, t, n = {}, r = {}) {
  return kg(e, t, {
    slice: !1,
    parseOptions: n,
    errorOnInvalidContent: r.errorOnInvalidContent
  });
}
const jUe = (e, t = !1, n = {}, r = {}) => ({ editor: i, tr: o, dispatch: a, commands: s }) => {
  var l, u;
  const { doc: c } = o;
  if (n.preserveWhitespace !== "full") {
    const f = uw(e, i.schema, n, {
      errorOnInvalidContent: (l = r.errorOnInvalidContent) !== null && l !== void 0 ? l : i.options.enableContentCheck
    });
    return a && o.replaceWith(0, c.content.size, f).setMeta("preventUpdate", !t), !0;
  }
  return a && o.setMeta("preventUpdate", !t), s.insertContentAt({ from: 0, to: c.content.size }, e, {
    parseOptions: n,
    errorOnInvalidContent: (u = r.errorOnInvalidContent) !== null && u !== void 0 ? u : i.options.enableContentCheck
  });
};
function Zee(e, t) {
  const n = al(t, e.schema), { from: r, to: i, empty: o } = e.selection, a = [];
  o ? (e.storedMarks && a.push(...e.storedMarks), a.push(...e.selection.$head.marks())) : e.doc.nodesBetween(r, i, (l) => {
    a.push(...l.marks);
  });
  const s = a.find((l) => l.type.name === n.name);
  return s ? { ...s.attrs } : {};
}
function VUe(e) {
  for (let t = 0; t < e.edgeCount; t += 1) {
    const { type: n } = e.edge(t);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
function qUe(e, t) {
  for (let n = e.depth; n > 0; n -= 1) {
    const r = e.node(n);
    if (t(r))
      return {
        pos: n > 0 ? e.before(n) : 0,
        start: e.start(n),
        depth: n,
        node: r
      };
  }
}
function J_(e) {
  return (t) => qUe(t.$from, e);
}
function Q_(e, t) {
  const n = vu.fromSchema(t).serializeFragment(e), i = document.implementation.createHTMLDocument().createElement("div");
  return i.appendChild(n), i.innerHTML;
}
function zUe(e, t) {
  const n = {
    from: 0,
    to: e.content.size
  };
  return zee(e, n, t);
}
function WUe(e, t) {
  const n = Un(t, e.schema), { from: r, to: i } = e.selection, o = [];
  e.doc.nodesBetween(r, i, (s) => {
    o.push(s);
  });
  const a = o.reverse().find((s) => s.type.name === n.name);
  return a ? { ...a.attrs } : {};
}
function HUe(e, t) {
  const n = Hv(typeof t == "string" ? t : t.name, e.schema);
  return n === "node" ? WUe(e, t) : n === "mark" ? Zee(e, t) : {};
}
function Xee(e, t, n) {
  const r = [];
  return e === t ? n.resolve(e).marks().forEach((i) => {
    const o = n.resolve(e), a = Z_(o, i.type);
    a && r.push({
      mark: i,
      ...a
    });
  }) : n.nodesBetween(e, t, (i, o) => {
    !i || (i == null ? void 0 : i.nodeSize) === void 0 || r.push(...i.marks.map((a) => ({
      from: o,
      to: o + i.nodeSize,
      mark: a
    })));
  }), r;
}
function Y1(e, t, n) {
  return Object.fromEntries(Object.entries(n).filter(([r]) => {
    const i = e.find((o) => o.type === t && o.name === r);
    return i ? i.attribute.keepOnSplit : !1;
  }));
}
function cw(e, t, n = {}) {
  const { empty: r, ranges: i } = e.selection, o = t ? al(t, e.schema) : null;
  if (r)
    return !!(e.storedMarks || e.selection.$from.marks()).filter((f) => o ? o.name === f.type.name : !0).find((f) => Og(f.attrs, n, { strict: !1 }));
  let a = 0;
  const s = [];
  if (i.forEach(({ $from: f, $to: h }) => {
    const m = f.pos, v = h.pos;
    e.doc.nodesBetween(m, v, (g, y) => {
      if (!g.isText && !g.marks.length)
        return;
      const w = Math.max(m, y), C = Math.min(v, y + g.nodeSize), S = C - w;
      a += S, s.push(...g.marks.map((N) => ({
        mark: N,
        from: w,
        to: C
      })));
    });
  }), a === 0)
    return !1;
  const l = s.filter((f) => o ? o.name === f.mark.type.name : !0).filter((f) => Og(f.mark.attrs, n, { strict: !1 })).reduce((f, h) => f + h.to - h.from, 0), u = s.filter((f) => o ? f.mark.type !== o && f.mark.type.excludes(o) : !0).reduce((f, h) => f + h.to - h.from, 0);
  return (l > 0 ? l + u : l) >= a;
}
function UUe(e, t, n = {}) {
  if (!t)
    return Kh(e, null, n) || cw(e, null, n);
  const r = Hv(t, e.schema);
  return r === "node" ? Kh(e, t, n) : r === "mark" ? cw(e, t, n) : !1;
}
function gF(e, t) {
  const { nodeExtensions: n } = qv(t), r = n.find((a) => a.name === e);
  if (!r)
    return !1;
  const i = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, o = ct(ke(r, "group", i));
  return typeof o != "string" ? !1 : o.split(" ").includes("list");
}
function eE(e, { checkChildren: t = !0, ignoreWhitespace: n = !1 } = {}) {
  var r;
  if (n) {
    if (e.type.name === "hardBreak")
      return !0;
    if (e.isText)
      return /^\s*$/m.test((r = e.text) !== null && r !== void 0 ? r : "");
  }
  if (e.isText)
    return !e.text;
  if (e.isAtom || e.isLeaf)
    return !1;
  if (e.content.childCount === 0)
    return !0;
  if (t) {
    let i = !0;
    return e.content.forEach((o) => {
      i !== !1 && (eE(o, { ignoreWhitespace: n, checkChildren: t }) || (i = !1));
    }), i;
  }
  return !1;
}
function GUe(e) {
  return e instanceof $e;
}
function KUe(e, t, n) {
  var r;
  const { selection: i } = t;
  let o = null;
  if (Uee(i) && (o = i.$cursor), o) {
    const s = (r = e.storedMarks) !== null && r !== void 0 ? r : o.marks();
    return !!n.isInSet(s) || !s.some((l) => l.type.excludes(n));
  }
  const { ranges: a } = i;
  return a.some(({ $from: s, $to: l }) => {
    let u = s.depth === 0 ? e.doc.inlineContent && e.doc.type.allowsMarkType(n) : !1;
    return e.doc.nodesBetween(s.pos, l.pos, (c, f, h) => {
      if (u)
        return !1;
      if (c.isInline) {
        const m = !h || h.type.allowsMarkType(n), v = !!n.isInSet(c.marks) || !c.marks.some((g) => g.type.excludes(n));
        u = m && v;
      }
      return !u;
    }), u;
  });
}
const YUe = (e, t = {}) => ({ tr: n, state: r, dispatch: i }) => {
  const { selection: o } = n, { empty: a, ranges: s } = o, l = al(e, r.schema);
  if (i)
    if (a) {
      const u = Zee(r, l);
      n.addStoredMark(l.create({
        ...u,
        ...t
      }));
    } else
      s.forEach((u) => {
        const c = u.$from.pos, f = u.$to.pos;
        r.doc.nodesBetween(c, f, (h, m) => {
          const v = Math.max(m, c), g = Math.min(m + h.nodeSize, f);
          h.marks.find((w) => w.type === l) ? h.marks.forEach((w) => {
            l === w.type && n.addMark(v, g, l.create({
              ...w.attrs,
              ...t
            }));
          }) : n.addMark(v, g, l.create(t));
        });
      });
  return KUe(r, n, l);
}, ZUe = (e, t) => ({ tr: n }) => (n.setMeta(e, t), !0), XUe = (e, t = {}) => ({ state: n, dispatch: r, chain: i }) => {
  const o = Un(e, n.schema);
  return o.isTextblock ? i().command(({ commands: a }) => dF(o, t)(n) ? !0 : a.clearNodes()).command(({ state: a }) => dF(o, t)(a, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, JUe = (e) => ({ tr: t, dispatch: n }) => {
  if (n) {
    const { doc: r } = t, i = Il(e, 0, r.content.size), o = $e.create(r, i);
    t.setSelection(o);
  }
  return !0;
}, QUe = (e) => ({ tr: t, dispatch: n }) => {
  if (n) {
    const { doc: r } = t, { from: i, to: o } = typeof e == "number" ? { from: e, to: e } : e, a = Ze.atStart(r).from, s = Ze.atEnd(r).to, l = Il(i, a, s), u = Il(o, a, s), c = Ze.create(r, l, u);
    t.setSelection(c);
  }
  return !0;
}, eGe = (e) => ({ state: t, dispatch: n }) => {
  const r = Un(e, t.schema);
  return IHe(r)(t, n);
};
function vF(e, t) {
  const n = e.storedMarks || e.selection.$to.parentOffset && e.selection.$from.marks();
  if (n) {
    const r = n.filter((i) => t == null ? void 0 : t.includes(i.type.name));
    e.tr.ensureMarks(r);
  }
}
const tGe = ({ keepMarks: e = !0 } = {}) => ({ tr: t, state: n, dispatch: r, editor: i }) => {
  const { selection: o, doc: a } = t, { $from: s, $to: l } = o, u = i.extensionManager.attributes, c = Y1(u, s.node().type.name, s.node().attrs);
  if (o instanceof $e && o.node.isBlock)
    return !s.parentOffset || !Ia(a, s.pos) ? !1 : (r && (e && vF(n, i.extensionManager.splittableMarks), t.split(s.pos).scrollIntoView()), !0);
  if (!s.parent.isBlock)
    return !1;
  const f = l.parentOffset === l.parent.content.size, h = s.depth === 0 ? void 0 : VUe(s.node(-1).contentMatchAt(s.indexAfter(-1)));
  let m = f && h ? [
    {
      type: h,
      attrs: c
    }
  ] : void 0, v = Ia(t.doc, t.mapping.map(s.pos), 1, m);
  if (!m && !v && Ia(t.doc, t.mapping.map(s.pos), 1, h ? [{ type: h }] : void 0) && (v = !0, m = h ? [
    {
      type: h,
      attrs: c
    }
  ] : void 0), r) {
    if (v && (o instanceof Ze && t.deleteSelection(), t.split(t.mapping.map(s.pos), 1, m), h && !f && !s.parentOffset && s.parent.type !== h)) {
      const g = t.mapping.map(s.before()), y = t.doc.resolve(g);
      s.node(-1).canReplaceWith(y.index(), y.index() + 1, h) && t.setNodeMarkup(t.mapping.map(s.before()), h);
    }
    e && vF(n, i.extensionManager.splittableMarks), t.scrollIntoView();
  }
  return v;
}, nGe = (e, t = {}) => ({ tr: n, state: r, dispatch: i, editor: o }) => {
  var a;
  const s = Un(e, r.schema), { $from: l, $to: u } = r.selection, c = r.selection.node;
  if (c && c.isBlock || l.depth < 2 || !l.sameParent(u))
    return !1;
  const f = l.node(-1);
  if (f.type !== s)
    return !1;
  const h = o.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== s || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (i) {
      let w = he.empty;
      const C = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let T = l.depth - C; T >= l.depth - 3; T -= 1)
        w = he.from(l.node(T).copy(w));
      const S = l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3, N = {
        ...Y1(h, l.node().type.name, l.node().attrs),
        ...t
      }, E = ((a = s.contentMatch.defaultType) === null || a === void 0 ? void 0 : a.createAndFill(N)) || void 0;
      w = w.append(he.from(s.createAndFill(null, E) || void 0));
      const A = l.before(l.depth - (C - 1));
      n.replace(A, l.after(-S), new _e(w, 4 - C, 0));
      let O = -1;
      n.doc.nodesBetween(A, n.doc.content.size, (T, M) => {
        if (O > -1)
          return !1;
        T.isTextblock && T.content.size === 0 && (O = M + 1);
      }), O > -1 && n.setSelection(Ze.near(n.doc.resolve(O))), n.scrollIntoView();
    }
    return !0;
  }
  const m = u.pos === l.end() ? f.contentMatchAt(0).defaultType : null, v = {
    ...Y1(h, f.type.name, f.attrs),
    ...t
  }, g = {
    ...Y1(h, l.node().type.name, l.node().attrs),
    ...t
  };
  n.delete(l.pos, u.pos);
  const y = m ? [
    { type: s, attrs: v },
    { type: m, attrs: g }
  ] : [{ type: s, attrs: v }];
  if (!Ia(n.doc, l.pos, 2))
    return !1;
  if (i) {
    const { selection: w, storedMarks: C } = r, { splittableMarks: S } = o.extensionManager, N = C || w.$to.parentOffset && w.$from.marks();
    if (n.split(l.pos, 2, y).scrollIntoView(), !N || !i)
      return !0;
    const E = N.filter((A) => S.includes(A.type.name));
    n.ensureMarks(E);
  }
  return !0;
}, z8 = (e, t) => {
  const n = J_((a) => a.type === t)(e.selection);
  if (!n)
    return !0;
  const r = e.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
  if (r === void 0)
    return !0;
  const i = e.doc.nodeAt(r);
  return n.node.type === (i == null ? void 0 : i.type) && il(e.doc, n.pos) && e.join(n.pos), !0;
}, W8 = (e, t) => {
  const n = J_((a) => a.type === t)(e.selection);
  if (!n)
    return !0;
  const r = e.doc.resolve(n.start).after(n.depth);
  if (r === void 0)
    return !0;
  const i = e.doc.nodeAt(r);
  return n.node.type === (i == null ? void 0 : i.type) && il(e.doc, r) && e.join(r), !0;
}, rGe = (e, t, n, r = {}) => ({ editor: i, tr: o, state: a, dispatch: s, chain: l, commands: u, can: c }) => {
  const { extensions: f, splittableMarks: h } = i.extensionManager, m = Un(e, a.schema), v = Un(t, a.schema), { selection: g, storedMarks: y } = a, { $from: w, $to: C } = g, S = w.blockRange(C), N = y || g.$to.parentOffset && g.$from.marks();
  if (!S)
    return !1;
  const E = J_((A) => gF(A.type.name, f))(g);
  if (S.depth >= 1 && E && S.depth - E.depth <= 1) {
    if (E.node.type === m)
      return u.liftListItem(v);
    if (gF(E.node.type.name, f) && m.validContent(E.node.content) && s)
      return l().command(() => (o.setNodeMarkup(E.pos, m), !0)).command(() => z8(o, m)).command(() => W8(o, m)).run();
  }
  return !n || !N || !s ? l().command(() => c().wrapInList(m, r) ? !0 : u.clearNodes()).wrapInList(m, r).command(() => z8(o, m)).command(() => W8(o, m)).run() : l().command(() => {
    const A = c().wrapInList(m, r), O = N.filter((T) => h.includes(T.type.name));
    return o.ensureMarks(O), A ? !0 : u.clearNodes();
  }).wrapInList(m, r).command(() => z8(o, m)).command(() => W8(o, m)).run();
}, iGe = (e, t = {}, n = {}) => ({ state: r, commands: i }) => {
  const { extendEmptyMarkRange: o = !1 } = n, a = al(e, r.schema);
  return cw(r, a, t) ? i.unsetMark(a, { extendEmptyMarkRange: o }) : i.setMark(a, t);
}, oGe = (e, t, n = {}) => ({ state: r, commands: i }) => {
  const o = Un(e, r.schema), a = Un(t, r.schema), s = Kh(r, o, n);
  let l;
  return r.selection.$anchor.sameParent(r.selection.$head) && (l = r.selection.$anchor.parent.attrs), s ? i.setNode(a, l) : i.setNode(o, { ...l, ...n });
}, aGe = (e, t = {}) => ({ state: n, commands: r }) => {
  const i = Un(e, n.schema);
  return Kh(n, i, t) ? r.lift(i) : r.wrapIn(i, t);
}, sGe = () => ({ state: e, dispatch: t }) => {
  const n = e.plugins;
  for (let r = 0; r < n.length; r += 1) {
    const i = n[r];
    let o;
    if (i.spec.isInputRules && (o = i.getState(e))) {
      if (t) {
        const a = e.tr, s = o.transform;
        for (let l = s.steps.length - 1; l >= 0; l -= 1)
          a.step(s.steps[l].invert(s.docs[l]));
        if (o.text) {
          const l = a.doc.resolve(o.from).marks();
          a.replaceWith(o.from, o.to, e.schema.text(o.text, l));
        } else
          a.delete(o.from, o.to);
      }
      return !0;
    }
  }
  return !1;
}, lGe = () => ({ tr: e, dispatch: t }) => {
  const { selection: n } = e, { empty: r, ranges: i } = n;
  return r || t && i.forEach((o) => {
    e.removeMark(o.$from.pos, o.$to.pos);
  }), !0;
}, uGe = (e, t = {}) => ({ tr: n, state: r, dispatch: i }) => {
  var o;
  const { extendEmptyMarkRange: a = !1 } = t, { selection: s } = n, l = al(e, r.schema), { $from: u, empty: c, ranges: f } = s;
  if (!i)
    return !0;
  if (c && a) {
    let { from: h, to: m } = s;
    const v = (o = u.marks().find((y) => y.type === l)) === null || o === void 0 ? void 0 : o.attrs, g = Z_(u, l, v);
    g && (h = g.from, m = g.to), n.removeMark(h, m, l);
  } else
    f.forEach((h) => {
      n.removeMark(h.$from.pos, h.$to.pos, l);
    });
  return n.removeStoredMark(l), !0;
}, cGe = (e, t = {}) => ({ tr: n, state: r, dispatch: i }) => {
  let o = null, a = null;
  const s = Hv(typeof e == "string" ? e : e.name, r.schema);
  return s ? (s === "node" && (o = Un(e, r.schema)), s === "mark" && (a = al(e, r.schema)), i && n.selection.ranges.forEach((l) => {
    const u = l.$from.pos, c = l.$to.pos;
    r.doc.nodesBetween(u, c, (f, h) => {
      o && o === f.type && n.setNodeMarkup(h, void 0, {
        ...f.attrs,
        ...t
      }), a && f.marks.length && f.marks.forEach((m) => {
        if (a === m.type) {
          const v = Math.max(h, u), g = Math.min(h + f.nodeSize, c);
          n.addMark(v, g, a.create({
            ...m.attrs,
            ...t
          }));
        }
      });
    });
  }), !0) : !1;
}, dGe = (e, t = {}) => ({ state: n, dispatch: r }) => {
  const i = Un(e, n.schema);
  return kHe(i, t)(n, r);
}, fGe = (e, t = {}) => ({ state: n, dispatch: r }) => {
  const i = Un(e, n.schema);
  return PHe(i, t)(n, r);
};
var hGe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: XHe,
  clearContent: JHe,
  clearNodes: QHe,
  command: eUe,
  createParagraphNear: tUe,
  cut: nUe,
  deleteCurrentNode: rUe,
  deleteNode: iUe,
  deleteRange: oUe,
  deleteSelection: aUe,
  enter: sUe,
  exitCode: lUe,
  extendMarkRange: cUe,
  first: dUe,
  focus: fUe,
  forEach: hUe,
  insertContent: pUe,
  insertContentAt: vUe,
  joinBackward: xUe,
  joinDown: bUe,
  joinForward: wUe,
  joinItemBackward: CUe,
  joinItemForward: SUe,
  joinTextblockBackward: _Ue,
  joinTextblockForward: EUe,
  joinUp: yUe,
  keyboardShortcut: AUe,
  lift: OUe,
  liftEmptyBlock: kUe,
  liftListItem: PUe,
  newlineInCode: TUe,
  resetAttributes: MUe,
  scrollIntoView: RUe,
  selectAll: DUe,
  selectNodeBackward: IUe,
  selectNodeForward: $Ue,
  selectParentNode: LUe,
  selectTextblockEnd: FUe,
  selectTextblockStart: BUe,
  setContent: jUe,
  setMark: YUe,
  setMeta: ZUe,
  setNode: XUe,
  setNodeSelection: JUe,
  setTextSelection: QUe,
  sinkListItem: eGe,
  splitBlock: tGe,
  splitListItem: nGe,
  toggleList: rGe,
  toggleMark: iGe,
  toggleNode: oGe,
  toggleWrap: aGe,
  undoInputRule: sGe,
  unsetAllMarks: lGe,
  unsetMark: uGe,
  updateAttributes: cGe,
  wrapIn: dGe,
  wrapInList: fGe
});
const Jee = Gn.create({
  name: "commands",
  addCommands() {
    return {
      ...hGe
    };
  }
}), Qee = Gn.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new $r({
        key: new xo("tiptapDrop"),
        props: {
          handleDrop: (e, t, n, r) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: t,
              slice: n,
              moved: r
            });
          }
        }
      })
    ];
  }
}), ete = Gn.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new $r({
        key: new xo("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), tte = Gn.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: e } = this;
    return [
      new $r({
        key: new xo("focusEvents"),
        props: {
          handleDOMEvents: {
            focus: (t, n) => {
              e.isFocused = !0;
              const r = e.state.tr.setMeta("focus", { event: n }).setMeta("addToHistory", !1);
              return t.dispatch(r), !1;
            },
            blur: (t, n) => {
              e.isFocused = !1;
              const r = e.state.tr.setMeta("blur", { event: n }).setMeta("addToHistory", !1);
              return t.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), nte = Gn.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const e = () => this.editor.commands.first(({ commands: a }) => [
      () => a.undoInputRule(),
      // maybe convert first text block node to default node
      () => a.command(({ tr: s }) => {
        const { selection: l, doc: u } = s, { empty: c, $anchor: f } = l, { pos: h, parent: m } = f, v = f.parent.isTextblock && h > 0 ? s.doc.resolve(h - 1) : f, g = v.parent.type.spec.isolating, y = f.pos - f.parentOffset, w = g && v.parent.childCount === 1 ? y === f.pos : it.atStart(u).from === h;
        return !c || !m.type.isTextblock || m.textContent.length || !w || w && f.parent.type.name === "paragraph" ? !1 : a.clearNodes();
      }),
      () => a.deleteSelection(),
      () => a.joinBackward(),
      () => a.selectNodeBackward()
    ]), t = () => this.editor.commands.first(({ commands: a }) => [
      () => a.deleteSelection(),
      () => a.deleteCurrentNode(),
      () => a.joinForward(),
      () => a.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: a }) => [
        () => a.newlineInCode(),
        () => a.createParagraphNear(),
        () => a.liftEmptyBlock(),
        () => a.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: e,
      "Mod-Backspace": e,
      "Shift-Backspace": e,
      Delete: t,
      "Mod-Delete": t,
      "Mod-a": () => this.editor.commands.selectAll()
    }, i = {
      ...r
    }, o = {
      ...r,
      "Ctrl-h": e,
      "Alt-Backspace": e,
      "Ctrl-d": t,
      "Ctrl-Alt-Backspace": t,
      "Alt-Delete": t,
      "Alt-d": t,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return X_() || Yee() ? o : i;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new $r({
        key: new xo("clearDocument"),
        appendTransaction: (e, t, n) => {
          const r = e.some((g) => g.docChanged) && !t.doc.eq(n.doc), i = e.some((g) => g.getMeta("preventClearDocument"));
          if (!r || i)
            return;
          const { empty: o, from: a, to: s } = t.selection, l = it.atStart(t.doc).from, u = it.atEnd(t.doc).to;
          if (o || !(a === l && s === u) || !eE(n.doc))
            return;
          const h = n.tr, m = jv({
            state: n,
            transaction: h
          }), { commands: v } = new Vv({
            editor: this.editor,
            state: m
          });
          if (v.clearNodes(), !!h.steps.length)
            return h;
        }
      })
    ];
  }
}), rte = Gn.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new $r({
        key: new xo("tiptapPaste"),
        props: {
          handlePaste: (e, t, n) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: t,
              slice: n
            });
          }
        }
      })
    ];
  }
}), ite = Gn.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new $r({
        key: new xo("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
var pGe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ClipboardTextSerializer: Hee,
  Commands: Jee,
  Drop: Qee,
  Editable: ete,
  FocusEvents: tte,
  Keymap: nte,
  Paste: rte,
  Tabindex: ite
});
class El {
  get name() {
    return this.node.type.name;
  }
  constructor(t, n, r = !1, i = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = r, this.resolvedPos = t, this.editor = n, this.currentNode = i;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var t;
    return (t = this.actualDepth) !== null && t !== void 0 ? t : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(t) {
    let n = this.from, r = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      n = this.from + 1, r = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: n, to: r }, t);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const t = this.resolvedPos.start(this.resolvedPos.depth - 1), n = this.resolvedPos.doc.resolve(t);
    return new El(n, this.editor);
  }
  get before() {
    let t = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return t.depth !== this.depth && (t = this.resolvedPos.doc.resolve(this.from - 3)), new El(t, this.editor);
  }
  get after() {
    let t = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return t.depth !== this.depth && (t = this.resolvedPos.doc.resolve(this.to + 3)), new El(t, this.editor);
  }
  get children() {
    const t = [];
    return this.node.content.forEach((n, r) => {
      const i = n.isBlock && !n.isTextblock, o = n.isAtom && !n.isText, a = this.pos + r + (o ? 0 : 1), s = this.resolvedPos.doc.resolve(a);
      if (!i && s.depth <= this.depth)
        return;
      const l = new El(s, this.editor, i, i ? n : null);
      i && (l.actualDepth = this.depth + 1), t.push(new El(s, this.editor, i, i ? n : null));
    }), t;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const t = this.children;
    return t[t.length - 1] || null;
  }
  closest(t, n = {}) {
    let r = null, i = this.parent;
    for (; i && !r; ) {
      if (i.node.type.name === t)
        if (Object.keys(n).length > 0) {
          const o = i.node.attrs, a = Object.keys(n);
          for (let s = 0; s < a.length; s += 1) {
            const l = a[s];
            if (o[l] !== n[l])
              break;
          }
        } else
          r = i;
      i = i.parent;
    }
    return r;
  }
  querySelector(t, n = {}) {
    return this.querySelectorAll(t, n, !0)[0] || null;
  }
  querySelectorAll(t, n = {}, r = !1) {
    let i = [];
    if (!this.children || this.children.length === 0)
      return i;
    const o = Object.keys(n);
    return this.children.forEach((a) => {
      r && i.length > 0 || (a.node.type.name === t && o.every((l) => n[l] === a.node.attrs[l]) && i.push(a), !(r && i.length > 0) && (i = i.concat(a.querySelectorAll(t, n, r))));
    }), i;
  }
  setAttribute(t) {
    const { tr: n } = this.editor.state;
    n.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...t
    }), this.editor.view.dispatch(n);
  }
}
const mGe = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function gGe(e, t, n) {
  const r = document.querySelector("style[data-tiptap-style]");
  if (r !== null)
    return r;
  const i = document.createElement("style");
  return t && i.setAttribute("nonce", t), i.setAttribute("data-tiptap-style", ""), i.innerHTML = e, document.getElementsByTagName("head")[0].appendChild(i), i;
}
class vGe extends $He {
  constructor(t = {}) {
    super(), this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: n }) => {
        throw n;
      },
      onPaste: () => null,
      onDrop: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(t), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("contentError", this.options.onContentError), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: n, slice: r, moved: i }) => this.options.onDrop(n, r, i)), this.on("paste", ({ event: n, slice: r }) => this.options.onPaste(n, r)), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = gGe(mGe, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(t = {}) {
    this.options = {
      ...this.options,
      ...t
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(t, n = !0) {
    this.setOptions({ editable: t }), n && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(t, n) {
    const r = qee(n) ? n(t, [...this.state.plugins]) : [...this.state.plugins, t], i = this.state.reconfigure({ plugins: r });
    return this.view.updateState(i), i;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(t) {
    if (this.isDestroyed)
      return;
    const n = this.state.plugins;
    let r = n;
    if ([].concat(t).forEach((o) => {
      const a = typeof o == "string" ? `${o}$` : o.key;
      r = n.filter((s) => !s.key.startsWith(a));
    }), n.length === r.length)
      return;
    const i = this.state.reconfigure({
      plugins: r
    });
    return this.view.updateState(i), i;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var t, n;
    const i = [...this.options.enableCoreExtensions ? [
      ete,
      Hee.configure({
        blockSeparator: (n = (t = this.options.coreExtensionOptions) === null || t === void 0 ? void 0 : t.clipboardTextSerializer) === null || n === void 0 ? void 0 : n.blockSeparator
      }),
      Jee,
      tte,
      nte,
      ite,
      Qee,
      rte
    ].filter((o) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[o.name] !== !1 : !0) : [], ...this.options.extensions].filter((o) => ["extension", "node", "mark"].includes(o == null ? void 0 : o.type));
    this.extensionManager = new lc(i, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new Vv({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    let t;
    try {
      t = uw(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
    } catch (o) {
      if (!(o instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(o.message))
        throw o;
      this.emit("contentError", {
        editor: this,
        error: o,
        disableCollaboration: () => {
          this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((a) => a.name !== "collaboration"), this.createExtensionManager();
        }
      }), t = uw(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: !1 });
    }
    const n = Gee(t, this.options.autofocus);
    this.view = new sHe(this.options.element, {
      ...this.options.editorProps,
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: sc.create({
        doc: t,
        selection: n || void 0
      })
    }), this.view.dom.setAttribute("role", "textbox"), this.view.dom.getAttribute("aria-label") || this.view.dom.setAttribute("aria-label", "Rich-Text Editor");
    const r = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(r), this.createNodeViews(), this.prependClass();
    const i = this.view.dom;
    i.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(t) {
    this.isCapturingTransaction = !0, t(), this.isCapturingTransaction = !1;
    const n = this.capturedTransaction;
    return this.capturedTransaction = null, n;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(t) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = t;
        return;
      }
      t.steps.forEach((a) => {
        var s;
        return (s = this.capturedTransaction) === null || s === void 0 ? void 0 : s.step(a);
      });
      return;
    }
    const n = this.state.apply(t), r = !this.state.selection.eq(n.selection);
    this.emit("beforeTransaction", {
      editor: this,
      transaction: t,
      nextState: n
    }), this.view.updateState(n), this.emit("transaction", {
      editor: this,
      transaction: t
    }), r && this.emit("selectionUpdate", {
      editor: this,
      transaction: t
    });
    const i = t.getMeta("focus"), o = t.getMeta("blur");
    i && this.emit("focus", {
      editor: this,
      event: i.event,
      transaction: t
    }), o && this.emit("blur", {
      editor: this,
      event: o.event,
      transaction: t
    }), !(!t.docChanged || t.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: t
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(t) {
    return HUe(this.state, t);
  }
  isActive(t, n) {
    const r = typeof t == "string" ? t : null, i = typeof t == "string" ? n : t;
    return UUe(this.state, r, i);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return Q_(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(t) {
    const { blockSeparator: n = `

`, textSerializers: r = {} } = t || {};
    return zUe(this.state.doc, {
      blockSeparator: n,
      textSerializers: {
        ...Wee(this.schema),
        ...r
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return eE(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    if (this.emit("destroy"), this.view) {
      const t = this.view.dom;
      t && t.editor && delete t.editor, this.view.destroy();
    }
    this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var t;
    return !(!((t = this.view) === null || t === void 0) && t.docView);
  }
  $node(t, n) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelector(t, n)) || null;
  }
  $nodes(t, n) {
    var r;
    return ((r = this.$doc) === null || r === void 0 ? void 0 : r.querySelectorAll(t, n)) || null;
  }
  $pos(t) {
    const n = this.state.doc.resolve(t);
    return new El(n, this);
  }
  get $doc() {
    return this.$pos(0);
  }
}
function fd(e) {
  return new zv({
    find: e.find,
    handler: ({ state: t, range: n, match: r }) => {
      const i = ct(e.getAttributes, void 0, r);
      if (i === !1 || i === null)
        return null;
      const { tr: o } = t, a = r[r.length - 1], s = r[0];
      if (a) {
        const l = s.search(/\S/), u = n.from + s.indexOf(a), c = u + a.length;
        if (Xee(n.from, n.to, t.doc).filter((m) => m.mark.type.excluded.find((g) => g === e.type && g !== m.mark.type)).filter((m) => m.to > u).length)
          return null;
        c < n.to && o.delete(c, n.to), u > n.from && o.delete(n.from + l, u);
        const h = n.from + l + a.length;
        o.addMark(n.from + l, h, e.type.create(i || {})), o.removeStoredMark(e.type);
      }
    }
  });
}
function yGe(e) {
  return new zv({
    find: e.find,
    handler: ({ state: t, range: n, match: r }) => {
      const i = ct(e.getAttributes, void 0, r) || {}, { tr: o } = t, a = n.from;
      let s = n.to;
      const l = e.type.create(i);
      if (r[1]) {
        const u = r[0].lastIndexOf(r[1]);
        let c = a + u;
        c > s ? c = s : s = c + r[1].length;
        const f = r[0][r[0].length - 1];
        o.insertText(f, a + r[0].length - 1), o.replaceWith(c, s, l);
      } else if (r[0]) {
        const u = e.type.isInline ? a : a - 1;
        o.insert(u, e.type.create(i)).delete(o.mapping.map(a), o.mapping.map(s));
      }
      o.scrollIntoView();
    }
  });
}
function dw(e) {
  return new zv({
    find: e.find,
    handler: ({ state: t, range: n, match: r }) => {
      const i = t.doc.resolve(n.from), o = ct(e.getAttributes, void 0, r) || {};
      if (!i.node(-1).canReplaceWith(i.index(-1), i.indexAfter(-1), e.type))
        return null;
      t.tr.delete(n.from, n.to).setBlockType(n.from, n.from, e.type, o);
    }
  });
}
function Yh(e) {
  return new zv({
    find: e.find,
    handler: ({ state: t, range: n, match: r, chain: i }) => {
      const o = ct(e.getAttributes, void 0, r) || {}, a = t.tr.delete(n.from, n.to), l = a.doc.resolve(n.from).blockRange(), u = l && D_(l, e.type, o);
      if (!u)
        return null;
      if (a.wrap(l, u), e.keepMarks && e.editor) {
        const { selection: f, storedMarks: h } = t, { splittableMarks: m } = e.editor.extensionManager, v = h || f.$to.parentOffset && f.$from.marks();
        if (v) {
          const g = v.filter((y) => m.includes(y.type.name));
          a.ensureMarks(g);
        }
      }
      if (e.keepAttributes) {
        const f = e.type.name === "bulletList" || e.type.name === "orderedList" ? "listItem" : "taskList";
        i().updateAttributes(f, o).run();
      }
      const c = a.doc.resolve(n.from - 1).nodeBefore;
      c && c.type === e.type && il(a.doc, n.from - 1) && (!e.joinPredicate || e.joinPredicate(r, c)) && a.join(n.from - 1);
    }
  });
}
let Zt = class fw {
  constructor(t = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name, t.defaultOptions && Object.keys(t.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = ct(ke(this, "addOptions", {
      name: this.name
    }))), this.storage = ct(ke(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(t = {}) {
    return new fw(t);
  }
  configure(t = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => Wv(this.options, t)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(t = {}) {
    const n = new fw(t);
    return n.parent = this, this.child = n, n.name = t.name ? t.name : n.parent.name, t.defaultOptions && Object.keys(t.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = ct(ke(n, "addOptions", {
      name: n.name
    })), n.storage = ct(ke(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
};
function hd(e) {
  return new HHe({
    find: e.find,
    handler: ({ state: t, range: n, match: r, pasteEvent: i }) => {
      const o = ct(e.getAttributes, void 0, r, i);
      if (o === !1 || o === null)
        return null;
      const { tr: a } = t, s = r[r.length - 1], l = r[0];
      let u = n.to;
      if (s) {
        const c = l.search(/\S/), f = n.from + l.indexOf(s), h = f + s.length;
        if (Xee(n.from, n.to, t.doc).filter((v) => v.mark.type.excluded.find((y) => y === e.type && y !== v.mark.type)).filter((v) => v.to > f).length)
          return null;
        h < n.to && a.delete(h, n.to), f > n.from && a.delete(n.from + c, f), u = n.from + c + s.length, a.addMark(n.from + c, u, e.type.create(o || {})), a.removeStoredMark(e.type);
      }
    }
  });
}
function bGe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var hw = { exports: {} }, H8 = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yF;
function xGe() {
  if (yF) return H8;
  yF = 1;
  var e = F;
  function t(f, h) {
    return f === h && (f !== 0 || 1 / f === 1 / h) || f !== f && h !== h;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, i = e.useEffect, o = e.useLayoutEffect, a = e.useDebugValue;
  function s(f, h) {
    var m = h(), v = r({ inst: { value: m, getSnapshot: h } }), g = v[0].inst, y = v[1];
    return o(function() {
      g.value = m, g.getSnapshot = h, l(g) && y({ inst: g });
    }, [f, m, h]), i(function() {
      return l(g) && y({ inst: g }), f(function() {
        l(g) && y({ inst: g });
      });
    }, [f]), a(m), m;
  }
  function l(f) {
    var h = f.getSnapshot;
    f = f.value;
    try {
      var m = h();
      return !n(f, m);
    } catch {
      return !0;
    }
  }
  function u(f, h) {
    return h();
  }
  var c = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : s;
  return H8.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : c, H8;
}
var U8 = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bF;
function wGe() {
  return bF || (bF = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = F, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(S) {
      {
        for (var N = arguments.length, E = new Array(N > 1 ? N - 1 : 0), A = 1; A < N; A++)
          E[A - 1] = arguments[A];
        r("error", S, E);
      }
    }
    function r(S, N, E) {
      {
        var A = t.ReactDebugCurrentFrame, O = A.getStackAddendum();
        O !== "" && (N += "%s", E = E.concat([O]));
        var T = E.map(function(M) {
          return String(M);
        });
        T.unshift("Warning: " + N), Function.prototype.apply.call(console[S], console, T);
      }
    }
    function i(S, N) {
      return S === N && (S !== 0 || 1 / S === 1 / N) || S !== S && N !== N;
    }
    var o = typeof Object.is == "function" ? Object.is : i, a = e.useState, s = e.useEffect, l = e.useLayoutEffect, u = e.useDebugValue, c = !1, f = !1;
    function h(S, N, E) {
      c || e.startTransition !== void 0 && (c = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var A = N();
      if (!f) {
        var O = N();
        o(A, O) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), f = !0);
      }
      var T = a({
        inst: {
          value: A,
          getSnapshot: N
        }
      }), M = T[0].inst, L = T[1];
      return l(function() {
        M.value = A, M.getSnapshot = N, m(M) && L({
          inst: M
        });
      }, [S, A, N]), s(function() {
        m(M) && L({
          inst: M
        });
        var I = function() {
          m(M) && L({
            inst: M
          });
        };
        return S(I);
      }, [S]), u(A), A;
    }
    function m(S) {
      var N = S.getSnapshot, E = S.value;
      try {
        var A = N();
        return !o(E, A);
      } catch {
        return !0;
      }
    }
    function v(S, N, E) {
      return N();
    }
    var g = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", y = !g, w = y ? v : h, C = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : w;
    U8.useSyncExternalStore = C, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), U8;
}
process.env.NODE_ENV === "production" ? hw.exports = xGe() : hw.exports = wGe();
var Uv = hw.exports;
const CGe = (...e) => (t) => {
  e.forEach((n) => {
    typeof n == "function" ? n(t) : n && (n.current = t);
  });
}, SGe = ({ contentComponent: e }) => {
  const t = Uv.useSyncExternalStore(e.subscribe, e.getSnapshot, e.getServerSnapshot);
  return F.createElement(F.Fragment, null, Object.values(t));
};
function _Ge() {
  const e = /* @__PURE__ */ new Set();
  let t = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(n) {
      return e.add(n), () => {
        e.delete(n);
      };
    },
    getSnapshot() {
      return t;
    },
    getServerSnapshot() {
      return t;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(n, r) {
      t = {
        ...t,
        [n]: Zo.createPortal(r.reactElement, r.element, n)
      }, e.forEach((i) => i());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(n) {
      const r = { ...t };
      delete r[n], t = r, e.forEach((i) => i());
    }
  };
}
class EGe extends F.Component {
  constructor(t) {
    var n;
    super(t), this.editorContentRef = F.createRef(), this.initialized = !1, this.state = {
      hasContentComponentInitialized: !!(!((n = t.editor) === null || n === void 0) && n.contentComponent)
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    const t = this.props.editor;
    if (t && !t.isDestroyed && t.options.element) {
      if (t.contentComponent)
        return;
      const n = this.editorContentRef.current;
      n.append(...t.options.element.childNodes), t.setOptions({
        element: n
      }), t.contentComponent = _Ge(), this.state.hasContentComponentInitialized || (this.unsubscribeToContentComponent = t.contentComponent.subscribe(() => {
        this.setState((r) => r.hasContentComponentInitialized ? r : {
          hasContentComponentInitialized: !0
        }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent();
      })), t.createNodeViews(), this.initialized = !0;
    }
  }
  componentWillUnmount() {
    const t = this.props.editor;
    if (!t || (this.initialized = !1, t.isDestroyed || t.view.setProps({
      nodeViews: {}
    }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent(), t.contentComponent = null, !t.options.element.firstChild))
      return;
    const n = document.createElement("div");
    n.append(...t.options.element.childNodes), t.setOptions({
      element: n
    });
  }
  render() {
    const { editor: t, innerRef: n, ...r } = this.props;
    return F.createElement(
      F.Fragment,
      null,
      F.createElement("div", { ref: CGe(n, this.editorContentRef), ...r }),
      (t == null ? void 0 : t.contentComponent) && F.createElement(SGe, { contentComponent: t.contentComponent })
    );
  }
}
const NGe = te((e, t) => {
  const n = F.useMemo(() => Math.floor(Math.random() * 4294967295).toString(), [e.editor]);
  return F.createElement(EGe, {
    key: n,
    innerRef: t,
    ...e
  });
}), AGe = F.memo(NGe);
var OGe = function e(t, n) {
  if (t === n) return !0;
  if (t && n && typeof t == "object" && typeof n == "object") {
    if (t.constructor !== n.constructor) return !1;
    var r, i, o;
    if (Array.isArray(t)) {
      if (r = t.length, r != n.length) return !1;
      for (i = r; i-- !== 0; )
        if (!e(t[i], n[i])) return !1;
      return !0;
    }
    if (t instanceof Map && n instanceof Map) {
      if (t.size !== n.size) return !1;
      for (i of t.entries())
        if (!n.has(i[0])) return !1;
      for (i of t.entries())
        if (!e(i[1], n.get(i[0]))) return !1;
      return !0;
    }
    if (t instanceof Set && n instanceof Set) {
      if (t.size !== n.size) return !1;
      for (i of t.entries())
        if (!n.has(i[0])) return !1;
      return !0;
    }
    if (ArrayBuffer.isView(t) && ArrayBuffer.isView(n)) {
      if (r = t.length, r != n.length) return !1;
      for (i = r; i-- !== 0; )
        if (t[i] !== n[i]) return !1;
      return !0;
    }
    if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
    if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
    if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
    if (o = Object.keys(t), r = o.length, r !== Object.keys(n).length) return !1;
    for (i = r; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, o[i])) return !1;
    for (i = r; i-- !== 0; ) {
      var a = o[i];
      if (!(a === "_owner" && t.$$typeof) && !e(t[a], n[a]))
        return !1;
    }
    return !0;
  }
  return t !== t && n !== n;
}, kGe = /* @__PURE__ */ bGe(OGe), pw = { exports: {} }, G8 = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xF;
function PGe() {
  if (xF) return G8;
  xF = 1;
  var e = F, t = Uv;
  function n(u, c) {
    return u === c && (u !== 0 || 1 / u === 1 / c) || u !== u && c !== c;
  }
  var r = typeof Object.is == "function" ? Object.is : n, i = t.useSyncExternalStore, o = e.useRef, a = e.useEffect, s = e.useMemo, l = e.useDebugValue;
  return G8.useSyncExternalStoreWithSelector = function(u, c, f, h, m) {
    var v = o(null);
    if (v.current === null) {
      var g = { hasValue: !1, value: null };
      v.current = g;
    } else g = v.current;
    v = s(function() {
      function w(A) {
        if (!C) {
          if (C = !0, S = A, A = h(A), m !== void 0 && g.hasValue) {
            var O = g.value;
            if (m(O, A)) return N = O;
          }
          return N = A;
        }
        if (O = N, r(S, A)) return O;
        var T = h(A);
        return m !== void 0 && m(O, T) ? O : (S = A, N = T);
      }
      var C = !1, S, N, E = f === void 0 ? null : f;
      return [function() {
        return w(c());
      }, E === null ? void 0 : function() {
        return w(E());
      }];
    }, [c, f, h, m]);
    var y = i(u, v[0], v[1]);
    return a(function() {
      g.hasValue = !0, g.value = y;
    }, [y]), l(y), y;
  }, G8;
}
var K8 = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wF;
function TGe() {
  return wF || (wF = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = F, t = Uv;
    function n(c, f) {
      return c === f && (c !== 0 || 1 / c === 1 / f) || c !== c && f !== f;
    }
    var r = typeof Object.is == "function" ? Object.is : n, i = t.useSyncExternalStore, o = e.useRef, a = e.useEffect, s = e.useMemo, l = e.useDebugValue;
    function u(c, f, h, m, v) {
      var g = o(null), y;
      g.current === null ? (y = {
        hasValue: !1,
        value: null
      }, g.current = y) : y = g.current;
      var w = s(function() {
        var E = !1, A, O, T = function(j) {
          if (!E) {
            E = !0, A = j;
            var B = m(j);
            if (v !== void 0 && y.hasValue) {
              var q = y.value;
              if (v(q, B))
                return O = q, q;
            }
            return O = B, B;
          }
          var G = A, U = O;
          if (r(G, j))
            return U;
          var V = m(j);
          return v !== void 0 && v(U, V) ? U : (A = j, O = V, V);
        }, M = h === void 0 ? null : h, L = function() {
          return T(f());
        }, I = M === null ? void 0 : function() {
          return T(M());
        };
        return [L, I];
      }, [f, h, m, v]), C = w[0], S = w[1], N = i(c, C, S);
      return a(function() {
        y.hasValue = !0, y.value = N;
      }, [N]), l(N), N;
    }
    K8.useSyncExternalStoreWithSelector = u, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), K8;
}
process.env.NODE_ENV === "production" ? pw.exports = PGe() : pw.exports = TGe();
var MGe = pw.exports;
class RGe {
  constructor(t) {
    this.transactionNumber = 0, this.lastTransactionNumber = 0, this.subscribers = /* @__PURE__ */ new Set(), this.editor = t, this.lastSnapshot = { editor: t, transactionNumber: 0 }, this.getSnapshot = this.getSnapshot.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.watch = this.watch.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  /**
   * Get the current editor instance.
   */
  getSnapshot() {
    return this.transactionNumber === this.lastTransactionNumber ? this.lastSnapshot : (this.lastTransactionNumber = this.transactionNumber, this.lastSnapshot = { editor: this.editor, transactionNumber: this.transactionNumber }, this.lastSnapshot);
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return { editor: null, transactionNumber: 0 };
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(t) {
    return this.subscribers.add(t), () => {
      this.subscribers.delete(t);
    };
  }
  /**
   * Watch the editor instance for changes.
   */
  watch(t) {
    if (this.editor = t, this.editor) {
      const n = () => {
        this.transactionNumber += 1, this.subscribers.forEach((i) => i());
      }, r = this.editor;
      return r.on("transaction", n), () => {
        r.off("transaction", n);
      };
    }
  }
}
function DGe(e) {
  var t;
  const [n] = re(() => new RGe(e.editor)), r = MGe.useSyncExternalStoreWithSelector(n.subscribe, n.getSnapshot, n.getServerSnapshot, e.selector, (t = e.equalityFn) !== null && t !== void 0 ? t : kGe);
  return Pe(() => n.watch(e.editor), [e.editor, n]), iB(r), r;
}
const CF = process.env.NODE_ENV !== "production", mw = typeof window > "u", IGe = mw || !!(typeof window < "u" && window.next);
class $Ge {
  constructor(t) {
    this.editor = null, this.subscriptions = /* @__PURE__ */ new Set(), this.isComponentMounted = !1, this.previousDeps = null, this.instanceId = "", this.options = t, this.subscriptions = /* @__PURE__ */ new Set(), this.setEditor(this.getInitialEditor()), this.scheduleDestroy(), this.getEditor = this.getEditor.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.subscribe = this.subscribe.bind(this), this.refreshEditorInstance = this.refreshEditorInstance.bind(this), this.scheduleDestroy = this.scheduleDestroy.bind(this), this.onRender = this.onRender.bind(this), this.createEditor = this.createEditor.bind(this);
  }
  setEditor(t) {
    this.editor = t, this.instanceId = Math.random().toString(36).slice(2, 9), this.subscriptions.forEach((n) => n());
  }
  getInitialEditor() {
    if (this.options.current.immediatelyRender === void 0)
      return mw || IGe ? (CF && console.warn("Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches."), null) : this.createEditor();
    if (this.options.current.immediatelyRender && mw && CF)
      throw new Error("Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches.");
    return this.options.current.immediatelyRender ? this.createEditor() : null;
  }
  /**
   * Create a new editor instance. And attach event listeners.
   */
  createEditor() {
    const t = {
      ...this.options.current,
      // Always call the most recent version of the callback function by default
      onBeforeCreate: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onBeforeCreate) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onBlur: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onBlur) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onCreate: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onCreate) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onDestroy: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onDestroy) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onFocus: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onFocus) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onSelectionUpdate: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onSelectionUpdate) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onTransaction: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onTransaction) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onUpdate: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onUpdate) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onContentError: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onContentError) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onDrop: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onDrop) === null || o === void 0 ? void 0 : o.call(i, ...r);
      },
      onPaste: (...r) => {
        var i, o;
        return (o = (i = this.options.current).onPaste) === null || o === void 0 ? void 0 : o.call(i, ...r);
      }
    };
    return new vGe(t);
  }
  /**
   * Get the current editor instance.
   */
  getEditor() {
    return this.editor;
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return null;
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(t) {
    return this.subscriptions.add(t), () => {
      this.subscriptions.delete(t);
    };
  }
  /**
   * On each render, we will create, update, or destroy the editor instance.
   * @param deps The dependencies to watch for changes
   * @returns A cleanup function
   */
  onRender(t) {
    return () => (this.isComponentMounted = !0, clearTimeout(this.scheduledDestructionTimeout), this.editor && !this.editor.isDestroyed && t.length === 0 ? this.editor.setOptions({
      ...this.options.current,
      editable: this.editor.isEditable
    }) : this.refreshEditorInstance(t), () => {
      this.isComponentMounted = !1, this.scheduleDestroy();
    });
  }
  /**
   * Recreate the editor instance if the dependencies have changed.
   */
  refreshEditorInstance(t) {
    if (this.editor && !this.editor.isDestroyed) {
      if (this.previousDeps === null) {
        this.previousDeps = t;
        return;
      }
      if (this.previousDeps.length === t.length && this.previousDeps.every((r, i) => r === t[i]))
        return;
    }
    this.editor && !this.editor.isDestroyed && this.editor.destroy(), this.setEditor(this.createEditor()), this.previousDeps = t;
  }
  /**
   * Schedule the destruction of the editor instance.
   * This will only destroy the editor if it was not mounted on the next tick.
   * This is to avoid destroying the editor instance when it's actually still mounted.
   */
  scheduleDestroy() {
    const t = this.instanceId, n = this.editor;
    this.scheduledDestructionTimeout = setTimeout(() => {
      if (this.isComponentMounted && this.instanceId === t) {
        n && n.setOptions(this.options.current);
        return;
      }
      n && !n.isDestroyed && (n.destroy(), this.instanceId === t && this.setEditor(null));
    }, 1);
  }
}
function LGe(e = {}, t = []) {
  const n = vt(e);
  n.current = e;
  const [r] = re(() => new $Ge(n)), i = Uv.useSyncExternalStore(r.subscribe, r.getEditor, r.getServerSnapshot);
  return iB(i), Pe(r.onRender(t)), DGe({
    editor: i,
    selector: ({ transactionNumber: o }) => e.shouldRerenderOnTransaction === !1 ? null : e.immediatelyRender && o === 0 ? 0 : o + 1
  }), i;
}
const FGe = Qt({
  editor: null
});
FGe.Consumer;
const BGe = Qt({
  onDragStart: void 0
}), jGe = () => en(BGe);
F.forwardRef((e, t) => {
  const { onDragStart: n } = jGe(), r = e.as || "div";
  return (
    // @ts-ignore
    F.createElement(r, { ...e, ref: t, "data-node-view-wrapper": "", onDragStart: n, style: {
      whiteSpace: "normal",
      ...e.style
    } })
  );
});
const VGe = /^\s*>\s$/, qGe = Zt.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["blockquote", Ir(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: e }) => e.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: e }) => e.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: e }) => e.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      Yh({
        find: VGe,
        type: this.type
      })
    ];
  }
}), zGe = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, WGe = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, HGe = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, UGe = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, GGe = Zr.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (e) => e.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (e) => e.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (e) => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["strong", Ir(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: e }) => e.setMark(this.name),
      toggleBold: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetBold: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      fd({
        find: zGe,
        type: this.type
      }),
      fd({
        find: HGe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      hd({
        find: WGe,
        type: this.type
      }),
      hd({
        find: UGe,
        type: this.type
      })
    ];
  }
}), KGe = "listItem", SF = "textStyle", _F = /^\s*([-+*])\s$/, YGe = Zt.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["ul", Ir(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: e, chain: t }) => this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(KGe, this.editor.getAttributes(SF)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let e = Yh({
      find: _F,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = Yh({
      find: _F,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(SF),
      editor: this.editor
    })), [
      e
    ];
  }
}), ZGe = /(?:^|\s)(`(?!\s+`)((?:[^`]+))`(?!\s+`))$/, XGe = /(?:^|\s)(`(?!\s+`)((?:[^`]+))`(?!\s+`))/g, JGe = Zr.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["code", Ir(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: e }) => e.setMark(this.name),
      toggleCode: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetCode: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      fd({
        find: ZGe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      hd({
        find: XGe,
        type: this.type
      })
    ];
  }
}), QGe = /^```([a-z]+)?[\s\n]$/, eKe = /^~~~([a-z]+)?[\s\n]$/, tKe = Zt.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (e) => {
          var t;
          const { languageClassPrefix: n } = this.options, o = [...((t = e.firstElementChild) === null || t === void 0 ? void 0 : t.classList) || []].filter((a) => a.startsWith(n)).map((a) => a.replace(n, ""))[0];
          return o || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    return [
      "pre",
      Ir(this.options.HTMLAttributes, t),
      [
        "code",
        {
          class: e.attrs.language ? this.options.languageClassPrefix + e.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (e) => ({ commands: t }) => t.setNode(this.name, e),
      toggleCodeBlock: (e) => ({ commands: t }) => t.toggleNode(this.name, "paragraph", e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: e, $anchor: t } = this.editor.state.selection, n = t.pos === 1;
        return !e || t.parent.type.name !== this.name ? !1 : n || !t.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: e }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: t } = e, { selection: n } = t, { $from: r, empty: i } = n;
        if (!i || r.parent.type !== this.type)
          return !1;
        const o = r.parentOffset === r.parent.nodeSize - 2, a = r.parent.textContent.endsWith(`

`);
        return !o || !a ? !1 : e.chain().command(({ tr: s }) => (s.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: e }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: t } = e, { selection: n, doc: r } = t, { $from: i, empty: o } = n;
        if (!o || i.parent.type !== this.type || !(i.parentOffset === i.parent.nodeSize - 2))
          return !1;
        const s = i.after();
        return s === void 0 ? !1 : r.nodeAt(s) ? e.commands.command(({ tr: u }) => (u.setSelection(it.near(r.resolve(s))), !0)) : e.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      dw({
        find: QGe,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      }),
      dw({
        find: eKe,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new $r({
        key: new xo("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (e, t) => {
            if (!t.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const n = t.clipboardData.getData("text/plain"), r = t.clipboardData.getData("vscode-editor-data"), i = r ? JSON.parse(r) : void 0, o = i == null ? void 0 : i.mode;
            if (!n || !o)
              return !1;
            const { tr: a, schema: s } = e.state, l = s.text(n.replace(/\r\n?/g, `
`));
            return a.replaceSelectionWith(this.type.create({ language: o }, l)), a.selection.$from.parent.type !== this.type && a.setSelection(Ze.near(a.doc.resolve(Math.max(0, a.selection.from - 2)))), a.setMeta("paste", !0), e.dispatch(a), !0;
          }
        }
      })
    ];
  }
}), nKe = Zt.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function rKe(e = {}) {
  return new $r({
    view(t) {
      return new iKe(t, e);
    }
  });
}
class iKe {
  constructor(t, n) {
    var r;
    this.editorView = t, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = n.width) !== null && r !== void 0 ? r : 1, this.color = n.color === !1 ? void 0 : n.color || "black", this.class = n.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((i) => {
      let o = (a) => {
        this[i](a);
      };
      return t.dom.addEventListener(i, o), { name: i, handler: o };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: t, handler: n }) => this.editorView.dom.removeEventListener(t, n));
  }
  update(t, n) {
    this.cursorPos != null && n.doc != t.state.doc && (this.cursorPos > t.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(t) {
    t != this.cursorPos && (this.cursorPos = t, t == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let t = this.editorView.state.doc.resolve(this.cursorPos), n = !t.parent.inlineContent, r;
    if (n) {
      let s = t.nodeBefore, l = t.nodeAfter;
      if (s || l) {
        let u = this.editorView.nodeDOM(this.cursorPos - (s ? s.nodeSize : 0));
        if (u) {
          let c = u.getBoundingClientRect(), f = s ? c.bottom : c.top;
          s && l && (f = (f + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2), r = { left: c.left, right: c.right, top: f - this.width / 2, bottom: f + this.width / 2 };
        }
      }
    }
    if (!r) {
      let s = this.editorView.coordsAtPos(this.cursorPos);
      r = { left: s.left - this.width / 2, right: s.left + this.width / 2, top: s.top, bottom: s.bottom };
    }
    let i = this.editorView.dom.offsetParent;
    this.element || (this.element = i.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", n), this.element.classList.toggle("prosemirror-dropcursor-inline", !n);
    let o, a;
    if (!i || i == document.body && getComputedStyle(i).position == "static")
      o = -pageXOffset, a = -pageYOffset;
    else {
      let s = i.getBoundingClientRect();
      o = s.left - i.scrollLeft, a = s.top - i.scrollTop;
    }
    this.element.style.left = r.left - o + "px", this.element.style.top = r.top - a + "px", this.element.style.width = r.right - r.left + "px", this.element.style.height = r.bottom - r.top + "px";
  }
  scheduleRemoval(t) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), t);
  }
  dragover(t) {
    if (!this.editorView.editable)
      return;
    let n = this.editorView.posAtCoords({ left: t.clientX, top: t.clientY }), r = n && n.inside >= 0 && this.editorView.state.doc.nodeAt(n.inside), i = r && r.type.spec.disableDropCursor, o = typeof i == "function" ? i(this.editorView, n, t) : i;
    if (n && !o) {
      let a = n.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let s = VQ(this.editorView.state.doc, a, this.editorView.dragging.slice);
        s != null && (a = s);
      }
      this.setCursor(a), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(t) {
    (t.target == this.editorView.dom || !this.editorView.dom.contains(t.relatedTarget)) && this.setCursor(null);
  }
}
const oKe = Gn.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      rKe(this.options)
    ];
  }
});
class fn extends it {
  /**
  Create a gap cursor.
  */
  constructor(t) {
    super(t, t);
  }
  map(t, n) {
    let r = t.resolve(n.map(this.head));
    return fn.valid(r) ? new fn(r) : it.near(r);
  }
  content() {
    return _e.empty;
  }
  eq(t) {
    return t instanceof fn && t.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new fn(t.resolve(n.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new tE(this.anchor);
  }
  /**
  @internal
  */
  static valid(t) {
    let n = t.parent;
    if (n.isTextblock || !aKe(t) || !sKe(t))
      return !1;
    let r = n.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let i = n.contentMatchAt(t.index()).defaultType;
    return i && i.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(t, n, r = !1) {
    e: for (; ; ) {
      if (!r && fn.valid(t))
        return t;
      let i = t.pos, o = null;
      for (let a = t.depth; ; a--) {
        let s = t.node(a);
        if (n > 0 ? t.indexAfter(a) < s.childCount : t.index(a) > 0) {
          o = s.child(n > 0 ? t.indexAfter(a) : t.index(a) - 1);
          break;
        } else if (a == 0)
          return null;
        i += n;
        let l = t.doc.resolve(i);
        if (fn.valid(l))
          return l;
      }
      for (; ; ) {
        let a = n > 0 ? o.firstChild : o.lastChild;
        if (!a) {
          if (o.isAtom && !o.isText && !$e.isSelectable(o)) {
            t = t.doc.resolve(i + o.nodeSize * n), r = !1;
            continue e;
          }
          break;
        }
        o = a, i += n;
        let s = t.doc.resolve(i);
        if (fn.valid(s))
          return s;
      }
      return null;
    }
  }
}
fn.prototype.visible = !1;
fn.findFrom = fn.findGapCursorFrom;
it.jsonID("gapcursor", fn);
class tE {
  constructor(t) {
    this.pos = t;
  }
  map(t) {
    return new tE(t.map(this.pos));
  }
  resolve(t) {
    let n = t.resolve(this.pos);
    return fn.valid(n) ? new fn(n) : it.near(n);
  }
}
function aKe(e) {
  for (let t = e.depth; t >= 0; t--) {
    let n = e.index(t), r = e.node(t);
    if (n == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(n - 1); ; i = i.lastChild) {
      if (i.childCount == 0 && !i.inlineContent || i.isAtom || i.type.spec.isolating)
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function sKe(e) {
  for (let t = e.depth; t >= 0; t--) {
    let n = e.indexAfter(t), r = e.node(t);
    if (n == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(n); ; i = i.firstChild) {
      if (i.childCount == 0 && !i.inlineContent || i.isAtom || i.type.spec.isolating)
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function lKe() {
  return new $r({
    props: {
      decorations: fKe,
      createSelectionBetween(e, t, n) {
        return t.pos == n.pos && fn.valid(n) ? new fn(n) : null;
      },
      handleClick: cKe,
      handleKeyDown: uKe,
      handleDOMEvents: { beforeinput: dKe }
    }
  });
}
const uKe = Oee({
  ArrowLeft: T1("horiz", -1),
  ArrowRight: T1("horiz", 1),
  ArrowUp: T1("vert", -1),
  ArrowDown: T1("vert", 1)
});
function T1(e, t) {
  const n = e == "vert" ? t > 0 ? "down" : "up" : t > 0 ? "right" : "left";
  return function(r, i, o) {
    let a = r.selection, s = t > 0 ? a.$to : a.$from, l = a.empty;
    if (a instanceof Ze) {
      if (!o.endOfTextblock(n) || s.depth == 0)
        return !1;
      l = !1, s = r.doc.resolve(t > 0 ? s.after() : s.before());
    }
    let u = fn.findGapCursorFrom(s, t, l);
    return u ? (i && i(r.tr.setSelection(new fn(u))), !0) : !1;
  };
}
function cKe(e, t, n) {
  if (!e || !e.editable)
    return !1;
  let r = e.state.doc.resolve(t);
  if (!fn.valid(r))
    return !1;
  let i = e.posAtCoords({ left: n.clientX, top: n.clientY });
  return i && i.inside > -1 && $e.isSelectable(e.state.doc.nodeAt(i.inside)) ? !1 : (e.dispatch(e.state.tr.setSelection(new fn(r))), !0);
}
function dKe(e, t) {
  if (t.inputType != "insertCompositionText" || !(e.state.selection instanceof fn))
    return !1;
  let { $from: n } = e.state.selection, r = n.parent.contentMatchAt(n.index()).findWrapping(e.state.schema.nodes.text);
  if (!r)
    return !1;
  let i = he.empty;
  for (let a = r.length - 1; a >= 0; a--)
    i = he.from(r[a].createAndFill(null, i));
  let o = e.state.tr.replace(n.pos, n.pos, new _e(i, 0, 0));
  return o.setSelection(Ze.near(o.doc.resolve(n.pos + 1))), e.dispatch(o), !1;
}
function fKe(e) {
  if (!(e.selection instanceof fn))
    return null;
  let t = document.createElement("div");
  return t.className = "ProseMirror-gapcursor", Rn.create(e.doc, [Mi.widget(e.selection.head, t, { key: "gapcursor" })]);
}
const hKe = Gn.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      lKe()
    ];
  },
  extendNodeSchema(e) {
    var t;
    const n = {
      name: e.name,
      options: e.options,
      storage: e.storage
    };
    return {
      allowGapCursor: (t = ct(ke(e, "allowGapCursor", n))) !== null && t !== void 0 ? t : null
    };
  }
}), pKe = Zt.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["br", Ir(this.options.HTMLAttributes, e)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: e, chain: t, state: n, editor: r }) => e.first([
        () => e.exitCode(),
        () => e.command(() => {
          const { selection: i, storedMarks: o } = n;
          if (i.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: a } = this.options, { splittableMarks: s } = r.extensionManager, l = o || i.$to.parentOffset && i.$from.marks();
          return t().insertContent({ type: this.name }).command(({ tr: u, dispatch: c }) => {
            if (c && l && a) {
              const f = l.filter((h) => s.includes(h.type.name));
              u.ensureMarks(f);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), mKe = Zt.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((e) => ({
      tag: `h${e}`,
      attrs: { level: e }
    }));
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    return [`h${this.options.levels.includes(e.attrs.level) ? e.attrs.level : this.options.levels[0]}`, Ir(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setHeading: (e) => ({ commands: t }) => this.options.levels.includes(e.level) ? t.setNode(this.name, e) : !1,
      toggleHeading: (e) => ({ commands: t }) => this.options.levels.includes(e.level) ? t.toggleNode(this.name, "paragraph", e) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((e, t) => ({
      ...e,
      [`Mod-Alt-${t}`]: () => this.editor.commands.toggleHeading({ level: t })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((e) => dw({
      find: new RegExp(`^(#{1,${e}})\\s$`),
      type: this.type,
      getAttributes: {
        level: e
      }
    }));
  }
});
var Pg = 200, Hn = function() {
};
Hn.prototype.append = function(t) {
  return t.length ? (t = Hn.from(t), !this.length && t || t.length < Pg && this.leafAppend(t) || this.length < Pg && t.leafPrepend(this) || this.appendInner(t)) : this;
};
Hn.prototype.prepend = function(t) {
  return t.length ? Hn.from(t).append(this) : this;
};
Hn.prototype.appendInner = function(t) {
  return new gKe(this, t);
};
Hn.prototype.slice = function(t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = this.length), t >= n ? Hn.empty : this.sliceInner(Math.max(0, t), Math.min(this.length, n));
};
Hn.prototype.get = function(t) {
  if (!(t < 0 || t >= this.length))
    return this.getInner(t);
};
Hn.prototype.forEach = function(t, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length), n <= r ? this.forEachInner(t, n, r, 0) : this.forEachInvertedInner(t, n, r, 0);
};
Hn.prototype.map = function(t, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length);
  var i = [];
  return this.forEach(function(o, a) {
    return i.push(t(o, a));
  }, n, r), i;
};
Hn.from = function(t) {
  return t instanceof Hn ? t : t && t.length ? new ote(t) : Hn.empty;
};
var ote = /* @__PURE__ */ function(e) {
  function t(r) {
    e.call(this), this.values = r;
  }
  e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t;
  var n = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return t.prototype.flatten = function() {
    return this.values;
  }, t.prototype.sliceInner = function(i, o) {
    return i == 0 && o == this.length ? this : new t(this.values.slice(i, o));
  }, t.prototype.getInner = function(i) {
    return this.values[i];
  }, t.prototype.forEachInner = function(i, o, a, s) {
    for (var l = o; l < a; l++)
      if (i(this.values[l], s + l) === !1)
        return !1;
  }, t.prototype.forEachInvertedInner = function(i, o, a, s) {
    for (var l = o - 1; l >= a; l--)
      if (i(this.values[l], s + l) === !1)
        return !1;
  }, t.prototype.leafAppend = function(i) {
    if (this.length + i.length <= Pg)
      return new t(this.values.concat(i.flatten()));
  }, t.prototype.leafPrepend = function(i) {
    if (this.length + i.length <= Pg)
      return new t(i.flatten().concat(this.values));
  }, n.length.get = function() {
    return this.values.length;
  }, n.depth.get = function() {
    return 0;
  }, Object.defineProperties(t.prototype, n), t;
}(Hn);
Hn.empty = new ote([]);
var gKe = /* @__PURE__ */ function(e) {
  function t(n, r) {
    e.call(this), this.left = n, this.right = r, this.length = n.length + r.length, this.depth = Math.max(n.depth, r.depth) + 1;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, t.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, t.prototype.forEachInner = function(r, i, o, a) {
    var s = this.left.length;
    if (i < s && this.left.forEachInner(r, i, Math.min(o, s), a) === !1 || o > s && this.right.forEachInner(r, Math.max(i - s, 0), Math.min(this.length, o) - s, a + s) === !1)
      return !1;
  }, t.prototype.forEachInvertedInner = function(r, i, o, a) {
    var s = this.left.length;
    if (i > s && this.right.forEachInvertedInner(r, i - s, Math.max(o, s) - s, a + s) === !1 || o < s && this.left.forEachInvertedInner(r, Math.min(i, s), o, a) === !1)
      return !1;
  }, t.prototype.sliceInner = function(r, i) {
    if (r == 0 && i == this.length)
      return this;
    var o = this.left.length;
    return i <= o ? this.left.slice(r, i) : r >= o ? this.right.slice(r - o, i - o) : this.left.slice(r, o).append(this.right.slice(0, i - o));
  }, t.prototype.leafAppend = function(r) {
    var i = this.right.leafAppend(r);
    if (i)
      return new t(this.left, i);
  }, t.prototype.leafPrepend = function(r) {
    var i = this.left.leafPrepend(r);
    if (i)
      return new t(i, this.right);
  }, t.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new t(this.left, new t(this.right, r)) : new t(this, r);
  }, t;
}(Hn);
const vKe = 500;
class to {
  constructor(t, n) {
    this.items = t, this.eventCount = n;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(t, n) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let i, o;
    n && (i = this.remapping(r, this.items.length), o = i.maps.length);
    let a = t.tr, s, l, u = [], c = [];
    return this.items.forEach((f, h) => {
      if (!f.step) {
        i || (i = this.remapping(r, h + 1), o = i.maps.length), o--, c.push(f);
        return;
      }
      if (i) {
        c.push(new No(f.map));
        let m = f.step.map(i.slice(o)), v;
        m && a.maybeStep(m).doc && (v = a.mapping.maps[a.mapping.maps.length - 1], u.push(new No(v, void 0, void 0, u.length + c.length))), o--, v && i.appendMap(v, o);
      } else
        a.maybeStep(f.step);
      if (f.selection)
        return s = i ? f.selection.map(i.slice(o)) : f.selection, l = new to(this.items.slice(0, r).append(c.reverse().concat(u)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: a, selection: s };
  }
  // Create a new branch with the given transform added.
  addTransform(t, n, r, i) {
    let o = [], a = this.eventCount, s = this.items, l = !i && s.length ? s.get(s.length - 1) : null;
    for (let c = 0; c < t.steps.length; c++) {
      let f = t.steps[c].invert(t.docs[c]), h = new No(t.mapping.maps[c], f, n), m;
      (m = l && l.merge(h)) && (h = m, c ? o.pop() : s = s.slice(0, s.length - 1)), o.push(h), n && (a++, n = void 0), i || (l = h);
    }
    let u = a - r.depth;
    return u > bKe && (s = yKe(s, u), a -= u), new to(s.append(o), a);
  }
  remapping(t, n) {
    let r = new Cc();
    return this.items.forEach((i, o) => {
      let a = i.mirrorOffset != null && o - i.mirrorOffset >= t ? r.maps.length - i.mirrorOffset : void 0;
      r.appendMap(i.map, a);
    }, t, n), r;
  }
  addMaps(t) {
    return this.eventCount == 0 ? this : new to(this.items.append(t.map((n) => new No(n))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(t, n) {
    if (!this.eventCount)
      return this;
    let r = [], i = Math.max(0, this.items.length - n), o = t.mapping, a = t.steps.length, s = this.eventCount;
    this.items.forEach((h) => {
      h.selection && s--;
    }, i);
    let l = n;
    this.items.forEach((h) => {
      let m = o.getMirror(--l);
      if (m == null)
        return;
      a = Math.min(a, m);
      let v = o.maps[m];
      if (h.step) {
        let g = t.steps[m].invert(t.docs[m]), y = h.selection && h.selection.map(o.slice(l + 1, m));
        y && s++, r.push(new No(v, g, y));
      } else
        r.push(new No(v));
    }, i);
    let u = [];
    for (let h = n; h < a; h++)
      u.push(new No(o.maps[h]));
    let c = this.items.slice(0, i).append(u).append(r), f = new to(c, s);
    return f.emptyItemCount() > vKe && (f = f.compress(this.items.length - r.length)), f;
  }
  emptyItemCount() {
    let t = 0;
    return this.items.forEach((n) => {
      n.step || t++;
    }), t;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(t = this.items.length) {
    let n = this.remapping(0, t), r = n.maps.length, i = [], o = 0;
    return this.items.forEach((a, s) => {
      if (s >= t)
        i.push(a), a.selection && o++;
      else if (a.step) {
        let l = a.step.map(n.slice(r)), u = l && l.getMap();
        if (r--, u && n.appendMap(u, r), l) {
          let c = a.selection && a.selection.map(n.slice(r));
          c && o++;
          let f = new No(u.invert(), l, c), h, m = i.length - 1;
          (h = i.length && i[m].merge(f)) ? i[m] = h : i.push(f);
        }
      } else a.map && r--;
    }, this.items.length, 0), new to(Hn.from(i.reverse()), o);
  }
}
to.empty = new to(Hn.empty, 0);
function yKe(e, t) {
  let n;
  return e.forEach((r, i) => {
    if (r.selection && t-- == 0)
      return n = i, !1;
  }), e.slice(n);
}
class No {
  constructor(t, n, r, i) {
    this.map = t, this.step = n, this.selection = r, this.mirrorOffset = i;
  }
  merge(t) {
    if (this.step && t.step && !t.selection) {
      let n = t.step.merge(this.step);
      if (n)
        return new No(n.getMap().invert(), n, this.selection);
    }
  }
}
class xs {
  constructor(t, n, r, i, o) {
    this.done = t, this.undone = n, this.prevRanges = r, this.prevTime = i, this.prevComposition = o;
  }
}
const bKe = 20;
function xKe(e, t, n, r) {
  let i = n.getMeta(Wl), o;
  if (i)
    return i.historyState;
  n.getMeta(SKe) && (e = new xs(e.done, e.undone, null, 0, -1));
  let a = n.getMeta("appendedTransaction");
  if (n.steps.length == 0)
    return e;
  if (a && a.getMeta(Wl))
    return a.getMeta(Wl).redo ? new xs(e.done.addTransform(n, void 0, r, Z1(t)), e.undone, EF(n.mapping.maps), e.prevTime, e.prevComposition) : new xs(e.done, e.undone.addTransform(n, void 0, r, Z1(t)), null, e.prevTime, e.prevComposition);
  if (n.getMeta("addToHistory") !== !1 && !(a && a.getMeta("addToHistory") === !1)) {
    let s = n.getMeta("composition"), l = e.prevTime == 0 || !a && e.prevComposition != s && (e.prevTime < (n.time || 0) - r.newGroupDelay || !wKe(n, e.prevRanges)), u = a ? Y8(e.prevRanges, n.mapping) : EF(n.mapping.maps);
    return new xs(e.done.addTransform(n, l ? t.selection.getBookmark() : void 0, r, Z1(t)), to.empty, u, n.time, s ?? e.prevComposition);
  } else return (o = n.getMeta("rebased")) ? new xs(e.done.rebased(n, o), e.undone.rebased(n, o), Y8(e.prevRanges, n.mapping), e.prevTime, e.prevComposition) : new xs(e.done.addMaps(n.mapping.maps), e.undone.addMaps(n.mapping.maps), Y8(e.prevRanges, n.mapping), e.prevTime, e.prevComposition);
}
function wKe(e, t) {
  if (!t)
    return !1;
  if (!e.docChanged)
    return !0;
  let n = !1;
  return e.mapping.maps[0].forEach((r, i) => {
    for (let o = 0; o < t.length; o += 2)
      r <= t[o + 1] && i >= t[o] && (n = !0);
  }), n;
}
function EF(e) {
  let t = [];
  for (let n = e.length - 1; n >= 0 && t.length == 0; n--)
    e[n].forEach((r, i, o, a) => t.push(o, a));
  return t;
}
function Y8(e, t) {
  if (!e)
    return null;
  let n = [];
  for (let r = 0; r < e.length; r += 2) {
    let i = t.map(e[r], 1), o = t.map(e[r + 1], -1);
    i <= o && n.push(i, o);
  }
  return n;
}
function CKe(e, t, n) {
  let r = Z1(t), i = Wl.get(t).spec.config, o = (n ? e.undone : e.done).popEvent(t, r);
  if (!o)
    return null;
  let a = o.selection.resolve(o.transform.doc), s = (n ? e.done : e.undone).addTransform(o.transform, t.selection.getBookmark(), i, r), l = new xs(n ? s : o.remaining, n ? o.remaining : s, null, 0, -1);
  return o.transform.setSelection(a).setMeta(Wl, { redo: n, historyState: l });
}
let Z8 = !1, NF = null;
function Z1(e) {
  let t = e.plugins;
  if (NF != t) {
    Z8 = !1, NF = t;
    for (let n = 0; n < t.length; n++)
      if (t[n].spec.historyPreserveItems) {
        Z8 = !0;
        break;
      }
  }
  return Z8;
}
const Wl = new xo("history"), SKe = new xo("closeHistory");
function _Ke(e = {}) {
  return e = {
    depth: e.depth || 100,
    newGroupDelay: e.newGroupDelay || 500
  }, new $r({
    key: Wl,
    state: {
      init() {
        return new xs(to.empty, to.empty, null, 0, -1);
      },
      apply(t, n, r) {
        return xKe(n, r, t, e);
      }
    },
    config: e,
    props: {
      handleDOMEvents: {
        beforeinput(t, n) {
          let r = n.inputType, i = r == "historyUndo" ? ste : r == "historyRedo" ? lte : null;
          return i ? (n.preventDefault(), i(t.state, t.dispatch)) : !1;
        }
      }
    }
  });
}
function ate(e, t) {
  return (n, r) => {
    let i = Wl.getState(n);
    if (!i || (e ? i.undone : i.done).eventCount == 0)
      return !1;
    if (r) {
      let o = CKe(i, n, e);
      o && r(t ? o.scrollIntoView() : o);
    }
    return !0;
  };
}
const ste = ate(!1, !0), lte = ate(!0, !0), EKe = Gn.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: e, dispatch: t }) => ste(e, t),
      redo: () => ({ state: e, dispatch: t }) => lte(e, t)
    };
  },
  addProseMirrorPlugins() {
    return [
      _Ke(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), NKe = Zt.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["hr", Ir(this.options.HTMLAttributes, e)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: e, state: t }) => {
        const { selection: n } = t, { $from: r, $to: i } = n, o = e();
        return r.parentOffset === 0 ? o.insertContentAt({
          from: Math.max(r.pos - 1, 0),
          to: i.pos
        }, {
          type: this.name
        }) : GUe(n) ? o.insertContentAt(i.pos, {
          type: this.name
        }) : o.insertContent({ type: this.name }), o.command(({ tr: a, dispatch: s }) => {
          var l;
          if (s) {
            const { $to: u } = a.selection, c = u.end();
            if (u.nodeAfter)
              u.nodeAfter.isTextblock ? a.setSelection(Ze.create(a.doc, u.pos + 1)) : u.nodeAfter.isBlock ? a.setSelection($e.create(a.doc, u.pos)) : a.setSelection(Ze.create(a.doc, u.pos));
            else {
              const f = (l = u.parent.type.contentMatch.defaultType) === null || l === void 0 ? void 0 : l.create();
              f && (a.insert(c, f), a.setSelection(Ze.create(a.doc, c + 1)));
            }
            a.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      yGe({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), AKe = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, OKe = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, kKe = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, PKe = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, TKe = Zr.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (e) => e.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (e) => e.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["em", Ir(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: e }) => e.setMark(this.name),
      toggleItalic: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetItalic: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      fd({
        find: AKe,
        type: this.type
      }),
      fd({
        find: kKe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      hd({
        find: OKe,
        type: this.type
      }),
      hd({
        find: PKe,
        type: this.type
      })
    ];
  }
}), MKe = Zt.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", Ir(this.options.HTMLAttributes, e), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), RKe = "listItem", AF = "textStyle", OF = /^(\d+)\.\s$/, DKe = Zt.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (e) => e.hasAttribute("start") ? parseInt(e.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: void 0,
        parseHTML: (e) => e.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    const { start: t, ...n } = e;
    return t === 1 ? ["ol", Ir(this.options.HTMLAttributes, n), 0] : ["ol", Ir(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: e, chain: t }) => this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(RKe, this.editor.getAttributes(AF)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let e = Yh({
      find: OF,
      type: this.type,
      getAttributes: (t) => ({ start: +t[1] }),
      joinPredicate: (t, n) => n.childCount + n.attrs.start === +t[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = Yh({
      find: OF,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (t) => ({ start: +t[1], ...this.editor.getAttributes(AF) }),
      joinPredicate: (t, n) => n.childCount + n.attrs.start === +t[1],
      editor: this.editor
    })), [
      e
    ];
  }
}), IKe = Zt.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["p", Ir(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: e }) => e.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), $Ke = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, LKe = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, FKe = Zr.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["s", Ir(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: e }) => e.setMark(this.name),
      toggleStrike: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetStrike: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      fd({
        find: $Ke,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      hd({
        find: LKe,
        type: this.type
      })
    ];
  }
}), BKe = Zt.create({
  name: "text",
  group: "inline"
}), jKe = Gn.create({
  name: "starterKit",
  addExtensions() {
    var e, t, n, r, i, o, a, s, l, u, c, f, h, m, v, g, y, w;
    const C = [];
    return this.options.bold !== !1 && C.push(GGe.configure((e = this.options) === null || e === void 0 ? void 0 : e.bold)), this.options.blockquote !== !1 && C.push(qGe.configure((t = this.options) === null || t === void 0 ? void 0 : t.blockquote)), this.options.bulletList !== !1 && C.push(YGe.configure((n = this.options) === null || n === void 0 ? void 0 : n.bulletList)), this.options.code !== !1 && C.push(JGe.configure((r = this.options) === null || r === void 0 ? void 0 : r.code)), this.options.codeBlock !== !1 && C.push(tKe.configure((i = this.options) === null || i === void 0 ? void 0 : i.codeBlock)), this.options.document !== !1 && C.push(nKe.configure((o = this.options) === null || o === void 0 ? void 0 : o.document)), this.options.dropcursor !== !1 && C.push(oKe.configure((a = this.options) === null || a === void 0 ? void 0 : a.dropcursor)), this.options.gapcursor !== !1 && C.push(hKe.configure((s = this.options) === null || s === void 0 ? void 0 : s.gapcursor)), this.options.hardBreak !== !1 && C.push(pKe.configure((l = this.options) === null || l === void 0 ? void 0 : l.hardBreak)), this.options.heading !== !1 && C.push(mKe.configure((u = this.options) === null || u === void 0 ? void 0 : u.heading)), this.options.history !== !1 && C.push(EKe.configure((c = this.options) === null || c === void 0 ? void 0 : c.history)), this.options.horizontalRule !== !1 && C.push(NKe.configure((f = this.options) === null || f === void 0 ? void 0 : f.horizontalRule)), this.options.italic !== !1 && C.push(TKe.configure((h = this.options) === null || h === void 0 ? void 0 : h.italic)), this.options.listItem !== !1 && C.push(MKe.configure((m = this.options) === null || m === void 0 ? void 0 : m.listItem)), this.options.orderedList !== !1 && C.push(DKe.configure((v = this.options) === null || v === void 0 ? void 0 : v.orderedList)), this.options.paragraph !== !1 && C.push(IKe.configure((g = this.options) === null || g === void 0 ? void 0 : g.paragraph)), this.options.strike !== !1 && C.push(FKe.configure((y = this.options) === null || y === void 0 ? void 0 : y.strike)), this.options.text !== !1 && C.push(BKe.configure((w = this.options) === null || w === void 0 ? void 0 : w.text)), C;
  }
}), kF = {};
function VKe(e) {
  let t = kF[e];
  if (t)
    return t;
  t = kF[e] = [];
  for (let n = 0; n < 128; n++) {
    const r = String.fromCharCode(n);
    t.push(r);
  }
  for (let n = 0; n < e.length; n++) {
    const r = e.charCodeAt(n);
    t[r] = "%" + ("0" + r.toString(16).toUpperCase()).slice(-2);
  }
  return t;
}
function pd(e, t) {
  typeof t != "string" && (t = pd.defaultChars);
  const n = VKe(t);
  return e.replace(/(%[a-f0-9]{2})+/gi, function(r) {
    let i = "";
    for (let o = 0, a = r.length; o < a; o += 3) {
      const s = parseInt(r.slice(o + 1, o + 3), 16);
      if (s < 128) {
        i += n[s];
        continue;
      }
      if ((s & 224) === 192 && o + 3 < a) {
        const l = parseInt(r.slice(o + 4, o + 6), 16);
        if ((l & 192) === 128) {
          const u = s << 6 & 1984 | l & 63;
          u < 128 ? i += "��" : i += String.fromCharCode(u), o += 3;
          continue;
        }
      }
      if ((s & 240) === 224 && o + 6 < a) {
        const l = parseInt(r.slice(o + 4, o + 6), 16), u = parseInt(r.slice(o + 7, o + 9), 16);
        if ((l & 192) === 128 && (u & 192) === 128) {
          const c = s << 12 & 61440 | l << 6 & 4032 | u & 63;
          c < 2048 || c >= 55296 && c <= 57343 ? i += "���" : i += String.fromCharCode(c), o += 6;
          continue;
        }
      }
      if ((s & 248) === 240 && o + 9 < a) {
        const l = parseInt(r.slice(o + 4, o + 6), 16), u = parseInt(r.slice(o + 7, o + 9), 16), c = parseInt(r.slice(o + 10, o + 12), 16);
        if ((l & 192) === 128 && (u & 192) === 128 && (c & 192) === 128) {
          let f = s << 18 & 1835008 | l << 12 & 258048 | u << 6 & 4032 | c & 63;
          f < 65536 || f > 1114111 ? i += "����" : (f -= 65536, i += String.fromCharCode(55296 + (f >> 10), 56320 + (f & 1023))), o += 9;
          continue;
        }
      }
      i += "�";
    }
    return i;
  });
}
pd.defaultChars = ";/?:@&=+$,#";
pd.componentChars = "";
const PF = {};
function qKe(e) {
  let t = PF[e];
  if (t)
    return t;
  t = PF[e] = [];
  for (let n = 0; n < 128; n++) {
    const r = String.fromCharCode(n);
    /^[0-9a-z]$/i.test(r) ? t.push(r) : t.push("%" + ("0" + n.toString(16).toUpperCase()).slice(-2));
  }
  for (let n = 0; n < e.length; n++)
    t[e.charCodeAt(n)] = e[n];
  return t;
}
function Bp(e, t, n) {
  typeof t != "string" && (n = t, t = Bp.defaultChars), typeof n > "u" && (n = !0);
  const r = qKe(t);
  let i = "";
  for (let o = 0, a = e.length; o < a; o++) {
    const s = e.charCodeAt(o);
    if (n && s === 37 && o + 2 < a && /^[0-9a-f]{2}$/i.test(e.slice(o + 1, o + 3))) {
      i += e.slice(o, o + 3), o += 2;
      continue;
    }
    if (s < 128) {
      i += r[s];
      continue;
    }
    if (s >= 55296 && s <= 57343) {
      if (s >= 55296 && s <= 56319 && o + 1 < a) {
        const l = e.charCodeAt(o + 1);
        if (l >= 56320 && l <= 57343) {
          i += encodeURIComponent(e[o] + e[o + 1]), o++;
          continue;
        }
      }
      i += "%EF%BF%BD";
      continue;
    }
    i += encodeURIComponent(e[o]);
  }
  return i;
}
Bp.defaultChars = ";/?:@&=+$,-_.!~*'()#";
Bp.componentChars = "-_.!~*'()";
function nE(e) {
  let t = "";
  return t += e.protocol || "", t += e.slashes ? "//" : "", t += e.auth ? e.auth + "@" : "", e.hostname && e.hostname.indexOf(":") !== -1 ? t += "[" + e.hostname + "]" : t += e.hostname || "", t += e.port ? ":" + e.port : "", t += e.pathname || "", t += e.search || "", t += e.hash || "", t;
}
function Tg() {
  this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
}
const zKe = /^([a-z0-9.+-]+:)/i, WKe = /:[0-9]*$/, HKe = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, UKe = ["<", ">", '"', "`", " ", "\r", `
`, "	"], GKe = ["{", "}", "|", "\\", "^", "`"].concat(UKe), KKe = ["'"].concat(GKe), TF = ["%", "/", "?", ";", "#"].concat(KKe), MF = ["/", "?", "#"], YKe = 255, RF = /^[+a-z0-9A-Z_-]{0,63}$/, ZKe = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, DF = {
  javascript: !0,
  "javascript:": !0
}, IF = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
};
function rE(e, t) {
  if (e && e instanceof Tg) return e;
  const n = new Tg();
  return n.parse(e, t), n;
}
Tg.prototype.parse = function(e, t) {
  let n, r, i, o = e;
  if (o = o.trim(), !t && e.split("#").length === 1) {
    const u = HKe.exec(o);
    if (u)
      return this.pathname = u[1], u[2] && (this.search = u[2]), this;
  }
  let a = zKe.exec(o);
  if (a && (a = a[0], n = a.toLowerCase(), this.protocol = a, o = o.substr(a.length)), (t || a || o.match(/^\/\/[^@\/]+@[^@\/]+/)) && (i = o.substr(0, 2) === "//", i && !(a && DF[a]) && (o = o.substr(2), this.slashes = !0)), !DF[a] && (i || a && !IF[a])) {
    let u = -1;
    for (let v = 0; v < MF.length; v++)
      r = o.indexOf(MF[v]), r !== -1 && (u === -1 || r < u) && (u = r);
    let c, f;
    u === -1 ? f = o.lastIndexOf("@") : f = o.lastIndexOf("@", u), f !== -1 && (c = o.slice(0, f), o = o.slice(f + 1), this.auth = c), u = -1;
    for (let v = 0; v < TF.length; v++)
      r = o.indexOf(TF[v]), r !== -1 && (u === -1 || r < u) && (u = r);
    u === -1 && (u = o.length), o[u - 1] === ":" && u--;
    const h = o.slice(0, u);
    o = o.slice(u), this.parseHost(h), this.hostname = this.hostname || "";
    const m = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!m) {
      const v = this.hostname.split(/\./);
      for (let g = 0, y = v.length; g < y; g++) {
        const w = v[g];
        if (w && !w.match(RF)) {
          let C = "";
          for (let S = 0, N = w.length; S < N; S++)
            w.charCodeAt(S) > 127 ? C += "x" : C += w[S];
          if (!C.match(RF)) {
            const S = v.slice(0, g), N = v.slice(g + 1), E = w.match(ZKe);
            E && (S.push(E[1]), N.unshift(E[2])), N.length && (o = N.join(".") + o), this.hostname = S.join(".");
            break;
          }
        }
      }
    }
    this.hostname.length > YKe && (this.hostname = ""), m && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
  }
  const s = o.indexOf("#");
  s !== -1 && (this.hash = o.substr(s), o = o.slice(0, s));
  const l = o.indexOf("?");
  return l !== -1 && (this.search = o.substr(l), o = o.slice(0, l)), o && (this.pathname = o), IF[n] && this.hostname && !this.pathname && (this.pathname = ""), this;
};
Tg.prototype.parseHost = function(e) {
  let t = WKe.exec(e);
  t && (t = t[0], t !== ":" && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e);
};
const XKe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: pd,
  encode: Bp,
  format: nE,
  parse: rE
}, Symbol.toStringTag, { value: "Module" })), ute = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, cte = /[\0-\x1F\x7F-\x9F]/, JKe = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/, iE = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, dte = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/, fte = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/, QKe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Any: ute,
  Cc: cte,
  Cf: JKe,
  P: iE,
  S: dte,
  Z: fte
}, Symbol.toStringTag, { value: "Module" })), eYe = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((e) => e.charCodeAt(0))
), tYe = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((e) => e.charCodeAt(0))
);
var X8;
const nYe = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), rYe = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (X8 = String.fromCodePoint) !== null && X8 !== void 0 ? X8 : function(e) {
    let t = "";
    return e > 65535 && (e -= 65536, t += String.fromCharCode(e >>> 10 & 1023 | 55296), e = 56320 | e & 1023), t += String.fromCharCode(e), t;
  }
);
function iYe(e) {
  var t;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (t = nYe.get(e)) !== null && t !== void 0 ? t : e;
}
var zn;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})(zn || (zn = {}));
const oYe = 32;
var Ms;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(Ms || (Ms = {}));
function gw(e) {
  return e >= zn.ZERO && e <= zn.NINE;
}
function aYe(e) {
  return e >= zn.UPPER_A && e <= zn.UPPER_F || e >= zn.LOWER_A && e <= zn.LOWER_F;
}
function sYe(e) {
  return e >= zn.UPPER_A && e <= zn.UPPER_Z || e >= zn.LOWER_A && e <= zn.LOWER_Z || gw(e);
}
function lYe(e) {
  return e === zn.EQUALS || sYe(e);
}
var Fn;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(Fn || (Fn = {}));
var _s;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(_s || (_s = {}));
class uYe {
  constructor(t, n, r) {
    this.decodeTree = t, this.emitCodePoint = n, this.errors = r, this.state = Fn.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = _s.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(t) {
    this.decodeMode = t, this.state = Fn.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(t, n) {
    switch (this.state) {
      case Fn.EntityStart:
        return t.charCodeAt(n) === zn.NUM ? (this.state = Fn.NumericStart, this.consumed += 1, this.stateNumericStart(t, n + 1)) : (this.state = Fn.NamedEntity, this.stateNamedEntity(t, n));
      case Fn.NumericStart:
        return this.stateNumericStart(t, n);
      case Fn.NumericDecimal:
        return this.stateNumericDecimal(t, n);
      case Fn.NumericHex:
        return this.stateNumericHex(t, n);
      case Fn.NamedEntity:
        return this.stateNamedEntity(t, n);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(t, n) {
    return n >= t.length ? -1 : (t.charCodeAt(n) | oYe) === zn.LOWER_X ? (this.state = Fn.NumericHex, this.consumed += 1, this.stateNumericHex(t, n + 1)) : (this.state = Fn.NumericDecimal, this.stateNumericDecimal(t, n));
  }
  addToNumericResult(t, n, r, i) {
    if (n !== r) {
      const o = r - n;
      this.result = this.result * Math.pow(i, o) + parseInt(t.substr(n, o), i), this.consumed += o;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(t, n) {
    const r = n;
    for (; n < t.length; ) {
      const i = t.charCodeAt(n);
      if (gw(i) || aYe(i))
        n += 1;
      else
        return this.addToNumericResult(t, r, n, 16), this.emitNumericEntity(i, 3);
    }
    return this.addToNumericResult(t, r, n, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(t, n) {
    const r = n;
    for (; n < t.length; ) {
      const i = t.charCodeAt(n);
      if (gw(i))
        n += 1;
      else
        return this.addToNumericResult(t, r, n, 10), this.emitNumericEntity(i, 2);
    }
    return this.addToNumericResult(t, r, n, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(t, n) {
    var r;
    if (this.consumed <= n)
      return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === zn.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === _s.Strict)
      return 0;
    return this.emitCodePoint(iYe(this.result), this.consumed), this.errors && (t !== zn.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(t, n) {
    const { decodeTree: r } = this;
    let i = r[this.treeIndex], o = (i & Ms.VALUE_LENGTH) >> 14;
    for (; n < t.length; n++, this.excess++) {
      const a = t.charCodeAt(n);
      if (this.treeIndex = cYe(r, i, this.treeIndex + Math.max(1, o), a), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === _s.Attribute && // We shouldn't have consumed any characters after the entity,
        (o === 0 || // And there should be no invalid characters.
        lYe(a)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (i = r[this.treeIndex], o = (i & Ms.VALUE_LENGTH) >> 14, o !== 0) {
        if (a === zn.SEMI)
          return this.emitNamedEntityData(this.treeIndex, o, this.consumed + this.excess);
        this.decodeMode !== _s.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var t;
    const { result: n, decodeTree: r } = this, i = (r[n] & Ms.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, i, this.consumed), (t = this.errors) === null || t === void 0 || t.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(t, n, r) {
    const { decodeTree: i } = this;
    return this.emitCodePoint(n === 1 ? i[t] & ~Ms.VALUE_LENGTH : i[t + 1], r), n === 3 && this.emitCodePoint(i[t + 2], r), r;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var t;
    switch (this.state) {
      case Fn.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== _s.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case Fn.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case Fn.NumericHex:
        return this.emitNumericEntity(0, 3);
      case Fn.NumericStart:
        return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case Fn.EntityStart:
        return 0;
    }
  }
}
function hte(e) {
  let t = "";
  const n = new uYe(e, (r) => t += rYe(r));
  return function(i, o) {
    let a = 0, s = 0;
    for (; (s = i.indexOf("&", s)) >= 0; ) {
      t += i.slice(a, s), n.startEntity(o);
      const u = n.write(
        i,
        // Skip the "&"
        s + 1
      );
      if (u < 0) {
        a = s + n.end();
        break;
      }
      a = s + u, s = u === 0 ? a + 1 : a;
    }
    const l = t + i.slice(a);
    return t = "", l;
  };
}
function cYe(e, t, n, r) {
  const i = (t & Ms.BRANCH_LENGTH) >> 7, o = t & Ms.JUMP_TABLE;
  if (i === 0)
    return o !== 0 && r === o ? n : -1;
  if (o) {
    const l = r - o;
    return l < 0 || l >= i ? -1 : e[n + l] - 1;
  }
  let a = n, s = a + i - 1;
  for (; a <= s; ) {
    const l = a + s >>> 1, u = e[l];
    if (u < r)
      a = l + 1;
    else if (u > r)
      s = l - 1;
    else
      return e[l + i];
  }
  return -1;
}
const dYe = hte(eYe);
hte(tYe);
function pte(e, t = _s.Legacy) {
  return dYe(e, t);
}
function fYe(e) {
  return Object.prototype.toString.call(e);
}
function oE(e) {
  return fYe(e) === "[object String]";
}
const hYe = Object.prototype.hasOwnProperty;
function pYe(e, t) {
  return hYe.call(e, t);
}
function Gv(e) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(n) {
    if (n) {
      if (typeof n != "object")
        throw new TypeError(n + "must be object");
      Object.keys(n).forEach(function(r) {
        e[r] = n[r];
      });
    }
  }), e;
}
function mte(e, t, n) {
  return [].concat(e.slice(0, t), n, e.slice(t + 1));
}
function aE(e) {
  return !(e >= 55296 && e <= 57343 || e >= 64976 && e <= 65007 || (e & 65535) === 65535 || (e & 65535) === 65534 || e >= 0 && e <= 8 || e === 11 || e >= 14 && e <= 31 || e >= 127 && e <= 159 || e > 1114111);
}
function Mg(e) {
  if (e > 65535) {
    e -= 65536;
    const t = 55296 + (e >> 10), n = 56320 + (e & 1023);
    return String.fromCharCode(t, n);
  }
  return String.fromCharCode(e);
}
const gte = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g, mYe = /&([a-z#][a-z0-9]{1,31});/gi, gYe = new RegExp(gte.source + "|" + mYe.source, "gi"), vYe = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function yYe(e, t) {
  if (t.charCodeAt(0) === 35 && vYe.test(t)) {
    const r = t[1].toLowerCase() === "x" ? parseInt(t.slice(2), 16) : parseInt(t.slice(1), 10);
    return aE(r) ? Mg(r) : e;
  }
  const n = pte(e);
  return n !== e ? n : e;
}
function bYe(e) {
  return e.indexOf("\\") < 0 ? e : e.replace(gte, "$1");
}
function md(e) {
  return e.indexOf("\\") < 0 && e.indexOf("&") < 0 ? e : e.replace(gYe, function(t, n, r) {
    return n || yYe(t, r);
  });
}
const xYe = /[&<>"]/, wYe = /[&<>"]/g, CYe = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;"
};
function SYe(e) {
  return CYe[e];
}
function Us(e) {
  return xYe.test(e) ? e.replace(wYe, SYe) : e;
}
const _Ye = /[.?*+^$[\]\\(){}|-]/g;
function EYe(e) {
  return e.replace(_Ye, "\\$&");
}
function Gt(e) {
  switch (e) {
    case 9:
    case 32:
      return !0;
  }
  return !1;
}
function Zh(e) {
  if (e >= 8192 && e <= 8202)
    return !0;
  switch (e) {
    case 9:
    // \t
    case 10:
    // \n
    case 11:
    // \v
    case 12:
    // \f
    case 13:
    // \r
    case 32:
    case 160:
    case 5760:
    case 8239:
    case 8287:
    case 12288:
      return !0;
  }
  return !1;
}
function Xh(e) {
  return iE.test(e) || dte.test(e);
}
function Jh(e) {
  switch (e) {
    case 33:
    case 34:
    case 35:
    case 36:
    case 37:
    case 38:
    case 39:
    case 40:
    case 41:
    case 42:
    case 43:
    case 44:
    case 45:
    case 46:
    case 47:
    case 58:
    case 59:
    case 60:
    case 61:
    case 62:
    case 63:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 124:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function Kv(e) {
  return e = e.trim().replace(/\s+/g, " "), "ẞ".toLowerCase() === "Ṿ" && (e = e.replace(/ẞ/g, "ß")), e.toLowerCase().toUpperCase();
}
const NYe = { mdurl: XKe, ucmicro: QKe }, AYe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrayReplaceAt: mte,
  assign: Gv,
  escapeHtml: Us,
  escapeRE: EYe,
  fromCodePoint: Mg,
  has: pYe,
  isMdAsciiPunct: Jh,
  isPunctChar: Xh,
  isSpace: Gt,
  isString: oE,
  isValidEntityCode: aE,
  isWhiteSpace: Zh,
  lib: NYe,
  normalizeReference: Kv,
  unescapeAll: md,
  unescapeMd: bYe
}, Symbol.toStringTag, { value: "Module" }));
function OYe(e, t, n) {
  let r, i, o, a;
  const s = e.posMax, l = e.pos;
  for (e.pos = t + 1, r = 1; e.pos < s; ) {
    if (o = e.src.charCodeAt(e.pos), o === 93 && (r--, r === 0)) {
      i = !0;
      break;
    }
    if (a = e.pos, e.md.inline.skipToken(e), o === 91) {
      if (a === e.pos - 1)
        r++;
      else if (n)
        return e.pos = l, -1;
    }
  }
  let u = -1;
  return i && (u = e.pos), e.pos = l, u;
}
function kYe(e, t, n) {
  let r, i = t;
  const o = {
    ok: !1,
    pos: 0,
    str: ""
  };
  if (e.charCodeAt(i) === 60) {
    for (i++; i < n; ) {
      if (r = e.charCodeAt(i), r === 10 || r === 60)
        return o;
      if (r === 62)
        return o.pos = i + 1, o.str = md(e.slice(t + 1, i)), o.ok = !0, o;
      if (r === 92 && i + 1 < n) {
        i += 2;
        continue;
      }
      i++;
    }
    return o;
  }
  let a = 0;
  for (; i < n && (r = e.charCodeAt(i), !(r === 32 || r < 32 || r === 127)); ) {
    if (r === 92 && i + 1 < n) {
      if (e.charCodeAt(i + 1) === 32)
        break;
      i += 2;
      continue;
    }
    if (r === 40 && (a++, a > 32))
      return o;
    if (r === 41) {
      if (a === 0)
        break;
      a--;
    }
    i++;
  }
  return t === i || a !== 0 || (o.str = md(e.slice(t, i)), o.pos = i, o.ok = !0), o;
}
function PYe(e, t, n, r) {
  let i, o = t;
  const a = {
    // if `true`, this is a valid link title
    ok: !1,
    // if `true`, this link can be continued on the next line
    can_continue: !1,
    // if `ok`, it's the position of the first character after the closing marker
    pos: 0,
    // if `ok`, it's the unescaped title
    str: "",
    // expected closing marker character code
    marker: 0
  };
  if (r)
    a.str = r.str, a.marker = r.marker;
  else {
    if (o >= n)
      return a;
    let s = e.charCodeAt(o);
    if (s !== 34 && s !== 39 && s !== 40)
      return a;
    t++, o++, s === 40 && (s = 41), a.marker = s;
  }
  for (; o < n; ) {
    if (i = e.charCodeAt(o), i === a.marker)
      return a.pos = o + 1, a.str += md(e.slice(t, o)), a.ok = !0, a;
    if (i === 40 && a.marker === 41)
      return a;
    i === 92 && o + 1 < n && o++, o++;
  }
  return a.can_continue = !0, a.str += md(e.slice(t, o)), a;
}
const TYe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  parseLinkDestination: kYe,
  parseLinkLabel: OYe,
  parseLinkTitle: PYe
}, Symbol.toStringTag, { value: "Module" })), ia = {};
ia.code_inline = function(e, t, n, r, i) {
  const o = e[t];
  return "<code" + i.renderAttrs(o) + ">" + Us(o.content) + "</code>";
};
ia.code_block = function(e, t, n, r, i) {
  const o = e[t];
  return "<pre" + i.renderAttrs(o) + "><code>" + Us(e[t].content) + `</code></pre>
`;
};
ia.fence = function(e, t, n, r, i) {
  const o = e[t], a = o.info ? md(o.info).trim() : "";
  let s = "", l = "";
  if (a) {
    const c = a.split(/(\s+)/g);
    s = c[0], l = c.slice(2).join("");
  }
  let u;
  if (n.highlight ? u = n.highlight(o.content, s, l) || Us(o.content) : u = Us(o.content), u.indexOf("<pre") === 0)
    return u + `
`;
  if (a) {
    const c = o.attrIndex("class"), f = o.attrs ? o.attrs.slice() : [];
    c < 0 ? f.push(["class", n.langPrefix + s]) : (f[c] = f[c].slice(), f[c][1] += " " + n.langPrefix + s);
    const h = {
      attrs: f
    };
    return `<pre><code${i.renderAttrs(h)}>${u}</code></pre>
`;
  }
  return `<pre><code${i.renderAttrs(o)}>${u}</code></pre>
`;
};
ia.image = function(e, t, n, r, i) {
  const o = e[t];
  return o.attrs[o.attrIndex("alt")][1] = i.renderInlineAsText(o.children, n, r), i.renderToken(e, t, n);
};
ia.hardbreak = function(e, t, n) {
  return n.xhtmlOut ? `<br />
` : `<br>
`;
};
ia.softbreak = function(e, t, n) {
  return n.breaks ? n.xhtmlOut ? `<br />
` : `<br>
` : `
`;
};
ia.text = function(e, t) {
  return Us(e[t].content);
};
ia.html_block = function(e, t) {
  return e[t].content;
};
ia.html_inline = function(e, t) {
  return e[t].content;
};
function Vd() {
  this.rules = Gv({}, ia);
}
Vd.prototype.renderAttrs = function(t) {
  let n, r, i;
  if (!t.attrs)
    return "";
  for (i = "", n = 0, r = t.attrs.length; n < r; n++)
    i += " " + Us(t.attrs[n][0]) + '="' + Us(t.attrs[n][1]) + '"';
  return i;
};
Vd.prototype.renderToken = function(t, n, r) {
  const i = t[n];
  let o = "";
  if (i.hidden)
    return "";
  i.block && i.nesting !== -1 && n && t[n - 1].hidden && (o += `
`), o += (i.nesting === -1 ? "</" : "<") + i.tag, o += this.renderAttrs(i), i.nesting === 0 && r.xhtmlOut && (o += " /");
  let a = !1;
  if (i.block && (a = !0, i.nesting === 1 && n + 1 < t.length)) {
    const s = t[n + 1];
    (s.type === "inline" || s.hidden || s.nesting === -1 && s.tag === i.tag) && (a = !1);
  }
  return o += a ? `>
` : ">", o;
};
Vd.prototype.renderInline = function(e, t, n) {
  let r = "";
  const i = this.rules;
  for (let o = 0, a = e.length; o < a; o++) {
    const s = e[o].type;
    typeof i[s] < "u" ? r += i[s](e, o, t, n, this) : r += this.renderToken(e, o, t);
  }
  return r;
};
Vd.prototype.renderInlineAsText = function(e, t, n) {
  let r = "";
  for (let i = 0, o = e.length; i < o; i++)
    switch (e[i].type) {
      case "text":
        r += e[i].content;
        break;
      case "image":
        r += this.renderInlineAsText(e[i].children, t, n);
        break;
      case "html_inline":
      case "html_block":
        r += e[i].content;
        break;
      case "softbreak":
      case "hardbreak":
        r += `
`;
        break;
    }
  return r;
};
Vd.prototype.render = function(e, t, n) {
  let r = "";
  const i = this.rules;
  for (let o = 0, a = e.length; o < a; o++) {
    const s = e[o].type;
    s === "inline" ? r += this.renderInline(e[o].children, t, n) : typeof i[s] < "u" ? r += i[s](e, o, t, n, this) : r += this.renderToken(e, o, t, n);
  }
  return r;
};
function Xr() {
  this.__rules__ = [], this.__cache__ = null;
}
Xr.prototype.__find__ = function(e) {
  for (let t = 0; t < this.__rules__.length; t++)
    if (this.__rules__[t].name === e)
      return t;
  return -1;
};
Xr.prototype.__compile__ = function() {
  const e = this, t = [""];
  e.__rules__.forEach(function(n) {
    n.enabled && n.alt.forEach(function(r) {
      t.indexOf(r) < 0 && t.push(r);
    });
  }), e.__cache__ = {}, t.forEach(function(n) {
    e.__cache__[n] = [], e.__rules__.forEach(function(r) {
      r.enabled && (n && r.alt.indexOf(n) < 0 || e.__cache__[n].push(r.fn));
    });
  });
};
Xr.prototype.at = function(e, t, n) {
  const r = this.__find__(e), i = n || {};
  if (r === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__[r].fn = t, this.__rules__[r].alt = i.alt || [], this.__cache__ = null;
};
Xr.prototype.before = function(e, t, n, r) {
  const i = this.__find__(e), o = r || {};
  if (i === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(i, 0, {
    name: t,
    enabled: !0,
    fn: n,
    alt: o.alt || []
  }), this.__cache__ = null;
};
Xr.prototype.after = function(e, t, n, r) {
  const i = this.__find__(e), o = r || {};
  if (i === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(i + 1, 0, {
    name: t,
    enabled: !0,
    fn: n,
    alt: o.alt || []
  }), this.__cache__ = null;
};
Xr.prototype.push = function(e, t, n) {
  const r = n || {};
  this.__rules__.push({
    name: e,
    enabled: !0,
    fn: t,
    alt: r.alt || []
  }), this.__cache__ = null;
};
Xr.prototype.enable = function(e, t) {
  Array.isArray(e) || (e = [e]);
  const n = [];
  return e.forEach(function(r) {
    const i = this.__find__(r);
    if (i < 0) {
      if (t)
        return;
      throw new Error("Rules manager: invalid rule name " + r);
    }
    this.__rules__[i].enabled = !0, n.push(r);
  }, this), this.__cache__ = null, n;
};
Xr.prototype.enableOnly = function(e, t) {
  Array.isArray(e) || (e = [e]), this.__rules__.forEach(function(n) {
    n.enabled = !1;
  }), this.enable(e, t);
};
Xr.prototype.disable = function(e, t) {
  Array.isArray(e) || (e = [e]);
  const n = [];
  return e.forEach(function(r) {
    const i = this.__find__(r);
    if (i < 0) {
      if (t)
        return;
      throw new Error("Rules manager: invalid rule name " + r);
    }
    this.__rules__[i].enabled = !1, n.push(r);
  }, this), this.__cache__ = null, n;
};
Xr.prototype.getRules = function(e) {
  return this.__cache__ === null && this.__compile__(), this.__cache__[e] || [];
};
function wo(e, t, n) {
  this.type = e, this.tag = t, this.attrs = null, this.map = null, this.nesting = n, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
wo.prototype.attrIndex = function(t) {
  if (!this.attrs)
    return -1;
  const n = this.attrs;
  for (let r = 0, i = n.length; r < i; r++)
    if (n[r][0] === t)
      return r;
  return -1;
};
wo.prototype.attrPush = function(t) {
  this.attrs ? this.attrs.push(t) : this.attrs = [t];
};
wo.prototype.attrSet = function(t, n) {
  const r = this.attrIndex(t), i = [t, n];
  r < 0 ? this.attrPush(i) : this.attrs[r] = i;
};
wo.prototype.attrGet = function(t) {
  const n = this.attrIndex(t);
  let r = null;
  return n >= 0 && (r = this.attrs[n][1]), r;
};
wo.prototype.attrJoin = function(t, n) {
  const r = this.attrIndex(t);
  r < 0 ? this.attrPush([t, n]) : this.attrs[r][1] = this.attrs[r][1] + " " + n;
};
function vte(e, t, n) {
  this.src = e, this.env = n, this.tokens = [], this.inlineMode = !1, this.md = t;
}
vte.prototype.Token = wo;
const MYe = /\r\n?|\n/g, RYe = /\0/g;
function DYe(e) {
  let t;
  t = e.src.replace(MYe, `
`), t = t.replace(RYe, "�"), e.src = t;
}
function IYe(e) {
  let t;
  e.inlineMode ? (t = new e.Token("inline", "", 0), t.content = e.src, t.map = [0, 1], t.children = [], e.tokens.push(t)) : e.md.block.parse(e.src, e.md, e.env, e.tokens);
}
function $Ye(e) {
  const t = e.tokens;
  for (let n = 0, r = t.length; n < r; n++) {
    const i = t[n];
    i.type === "inline" && e.md.inline.parse(i.content, e.md, e.env, i.children);
  }
}
function LYe(e) {
  return /^<a[>\s]/i.test(e);
}
function FYe(e) {
  return /^<\/a\s*>/i.test(e);
}
function BYe(e) {
  const t = e.tokens;
  if (e.md.options.linkify)
    for (let n = 0, r = t.length; n < r; n++) {
      if (t[n].type !== "inline" || !e.md.linkify.pretest(t[n].content))
        continue;
      let i = t[n].children, o = 0;
      for (let a = i.length - 1; a >= 0; a--) {
        const s = i[a];
        if (s.type === "link_close") {
          for (a--; i[a].level !== s.level && i[a].type !== "link_open"; )
            a--;
          continue;
        }
        if (s.type === "html_inline" && (LYe(s.content) && o > 0 && o--, FYe(s.content) && o++), !(o > 0) && s.type === "text" && e.md.linkify.test(s.content)) {
          const l = s.content;
          let u = e.md.linkify.match(l);
          const c = [];
          let f = s.level, h = 0;
          u.length > 0 && u[0].index === 0 && a > 0 && i[a - 1].type === "text_special" && (u = u.slice(1));
          for (let m = 0; m < u.length; m++) {
            const v = u[m].url, g = e.md.normalizeLink(v);
            if (!e.md.validateLink(g))
              continue;
            let y = u[m].text;
            u[m].schema ? u[m].schema === "mailto:" && !/^mailto:/i.test(y) ? y = e.md.normalizeLinkText("mailto:" + y).replace(/^mailto:/, "") : y = e.md.normalizeLinkText(y) : y = e.md.normalizeLinkText("http://" + y).replace(/^http:\/\//, "");
            const w = u[m].index;
            if (w > h) {
              const E = new e.Token("text", "", 0);
              E.content = l.slice(h, w), E.level = f, c.push(E);
            }
            const C = new e.Token("link_open", "a", 1);
            C.attrs = [["href", g]], C.level = f++, C.markup = "linkify", C.info = "auto", c.push(C);
            const S = new e.Token("text", "", 0);
            S.content = y, S.level = f, c.push(S);
            const N = new e.Token("link_close", "a", -1);
            N.level = --f, N.markup = "linkify", N.info = "auto", c.push(N), h = u[m].lastIndex;
          }
          if (h < l.length) {
            const m = new e.Token("text", "", 0);
            m.content = l.slice(h), m.level = f, c.push(m);
          }
          t[n].children = i = mte(i, a, c);
        }
      }
    }
}
const yte = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, jYe = /\((c|tm|r)\)/i, VYe = /\((c|tm|r)\)/ig, qYe = {
  c: "©",
  r: "®",
  tm: "™"
};
function zYe(e, t) {
  return qYe[t.toLowerCase()];
}
function WYe(e) {
  let t = 0;
  for (let n = e.length - 1; n >= 0; n--) {
    const r = e[n];
    r.type === "text" && !t && (r.content = r.content.replace(VYe, zYe)), r.type === "link_open" && r.info === "auto" && t--, r.type === "link_close" && r.info === "auto" && t++;
  }
}
function HYe(e) {
  let t = 0;
  for (let n = e.length - 1; n >= 0; n--) {
    const r = e[n];
    r.type === "text" && !t && yte.test(r.content) && (r.content = r.content.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/mg, "$1—").replace(/(^|\s)--(?=\s|$)/mg, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1–")), r.type === "link_open" && r.info === "auto" && t--, r.type === "link_close" && r.info === "auto" && t++;
  }
}
function UYe(e) {
  let t;
  if (e.md.options.typographer)
    for (t = e.tokens.length - 1; t >= 0; t--)
      e.tokens[t].type === "inline" && (jYe.test(e.tokens[t].content) && WYe(e.tokens[t].children), yte.test(e.tokens[t].content) && HYe(e.tokens[t].children));
}
const GYe = /['"]/, $F = /['"]/g, LF = "’";
function M1(e, t, n) {
  return e.slice(0, t) + n + e.slice(t + 1);
}
function KYe(e, t) {
  let n;
  const r = [];
  for (let i = 0; i < e.length; i++) {
    const o = e[i], a = e[i].level;
    for (n = r.length - 1; n >= 0 && !(r[n].level <= a); n--)
      ;
    if (r.length = n + 1, o.type !== "text")
      continue;
    let s = o.content, l = 0, u = s.length;
    e:
      for (; l < u; ) {
        $F.lastIndex = l;
        const c = $F.exec(s);
        if (!c)
          break;
        let f = !0, h = !0;
        l = c.index + 1;
        const m = c[0] === "'";
        let v = 32;
        if (c.index - 1 >= 0)
          v = s.charCodeAt(c.index - 1);
        else
          for (n = i - 1; n >= 0 && !(e[n].type === "softbreak" || e[n].type === "hardbreak"); n--)
            if (e[n].content) {
              v = e[n].content.charCodeAt(e[n].content.length - 1);
              break;
            }
        let g = 32;
        if (l < u)
          g = s.charCodeAt(l);
        else
          for (n = i + 1; n < e.length && !(e[n].type === "softbreak" || e[n].type === "hardbreak"); n++)
            if (e[n].content) {
              g = e[n].content.charCodeAt(0);
              break;
            }
        const y = Jh(v) || Xh(String.fromCharCode(v)), w = Jh(g) || Xh(String.fromCharCode(g)), C = Zh(v), S = Zh(g);
        if (S ? f = !1 : w && (C || y || (f = !1)), C ? h = !1 : y && (S || w || (h = !1)), g === 34 && c[0] === '"' && v >= 48 && v <= 57 && (h = f = !1), f && h && (f = y, h = w), !f && !h) {
          m && (o.content = M1(o.content, c.index, LF));
          continue;
        }
        if (h)
          for (n = r.length - 1; n >= 0; n--) {
            let N = r[n];
            if (r[n].level < a)
              break;
            if (N.single === m && r[n].level === a) {
              N = r[n];
              let E, A;
              m ? (E = t.md.options.quotes[2], A = t.md.options.quotes[3]) : (E = t.md.options.quotes[0], A = t.md.options.quotes[1]), o.content = M1(o.content, c.index, A), e[N.token].content = M1(
                e[N.token].content,
                N.pos,
                E
              ), l += A.length - 1, N.token === i && (l += E.length - 1), s = o.content, u = s.length, r.length = n;
              continue e;
            }
          }
        f ? r.push({
          token: i,
          pos: c.index,
          single: m,
          level: a
        }) : h && m && (o.content = M1(o.content, c.index, LF));
      }
  }
}
function YYe(e) {
  if (e.md.options.typographer)
    for (let t = e.tokens.length - 1; t >= 0; t--)
      e.tokens[t].type !== "inline" || !GYe.test(e.tokens[t].content) || KYe(e.tokens[t].children, e);
}
function ZYe(e) {
  let t, n;
  const r = e.tokens, i = r.length;
  for (let o = 0; o < i; o++) {
    if (r[o].type !== "inline") continue;
    const a = r[o].children, s = a.length;
    for (t = 0; t < s; t++)
      a[t].type === "text_special" && (a[t].type = "text");
    for (t = n = 0; t < s; t++)
      a[t].type === "text" && t + 1 < s && a[t + 1].type === "text" ? a[t + 1].content = a[t].content + a[t + 1].content : (t !== n && (a[n] = a[t]), n++);
    t !== n && (a.length = n);
  }
}
const J8 = [
  ["normalize", DYe],
  ["block", IYe],
  ["inline", $Ye],
  ["linkify", BYe],
  ["replacements", UYe],
  ["smartquotes", YYe],
  // `text_join` finds `text_special` tokens (for escape sequences)
  // and joins them with the rest of the text
  ["text_join", ZYe]
];
function sE() {
  this.ruler = new Xr();
  for (let e = 0; e < J8.length; e++)
    this.ruler.push(J8[e][0], J8[e][1]);
}
sE.prototype.process = function(e) {
  const t = this.ruler.getRules("");
  for (let n = 0, r = t.length; n < r; n++)
    t[n](e);
};
sE.prototype.State = vte;
function oa(e, t, n, r) {
  this.src = e, this.md = t, this.env = n, this.tokens = r, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0;
  const i = this.src;
  for (let o = 0, a = 0, s = 0, l = 0, u = i.length, c = !1; a < u; a++) {
    const f = i.charCodeAt(a);
    if (!c)
      if (Gt(f)) {
        s++, f === 9 ? l += 4 - l % 4 : l++;
        continue;
      } else
        c = !0;
    (f === 10 || a === u - 1) && (f !== 10 && a++, this.bMarks.push(o), this.eMarks.push(a), this.tShift.push(s), this.sCount.push(l), this.bsCount.push(0), c = !1, s = 0, l = 0, o = a + 1);
  }
  this.bMarks.push(i.length), this.eMarks.push(i.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
}
oa.prototype.push = function(e, t, n) {
  const r = new wo(e, t, n);
  return r.block = !0, n < 0 && this.level--, r.level = this.level, n > 0 && this.level++, this.tokens.push(r), r;
};
oa.prototype.isEmpty = function(t) {
  return this.bMarks[t] + this.tShift[t] >= this.eMarks[t];
};
oa.prototype.skipEmptyLines = function(t) {
  for (let n = this.lineMax; t < n && !(this.bMarks[t] + this.tShift[t] < this.eMarks[t]); t++)
    ;
  return t;
};
oa.prototype.skipSpaces = function(t) {
  for (let n = this.src.length; t < n; t++) {
    const r = this.src.charCodeAt(t);
    if (!Gt(r))
      break;
  }
  return t;
};
oa.prototype.skipSpacesBack = function(t, n) {
  if (t <= n)
    return t;
  for (; t > n; )
    if (!Gt(this.src.charCodeAt(--t)))
      return t + 1;
  return t;
};
oa.prototype.skipChars = function(t, n) {
  for (let r = this.src.length; t < r && this.src.charCodeAt(t) === n; t++)
    ;
  return t;
};
oa.prototype.skipCharsBack = function(t, n, r) {
  if (t <= r)
    return t;
  for (; t > r; )
    if (n !== this.src.charCodeAt(--t))
      return t + 1;
  return t;
};
oa.prototype.getLines = function(t, n, r, i) {
  if (t >= n)
    return "";
  const o = new Array(n - t);
  for (let a = 0, s = t; s < n; s++, a++) {
    let l = 0;
    const u = this.bMarks[s];
    let c = u, f;
    for (s + 1 < n || i ? f = this.eMarks[s] + 1 : f = this.eMarks[s]; c < f && l < r; ) {
      const h = this.src.charCodeAt(c);
      if (Gt(h))
        h === 9 ? l += 4 - (l + this.bsCount[s]) % 4 : l++;
      else if (c - u < this.tShift[s])
        l++;
      else
        break;
      c++;
    }
    l > r ? o[a] = new Array(l - r + 1).join(" ") + this.src.slice(c, f) : o[a] = this.src.slice(c, f);
  }
  return o.join("");
};
oa.prototype.Token = wo;
const XYe = 65536;
function Q8(e, t) {
  const n = e.bMarks[t] + e.tShift[t], r = e.eMarks[t];
  return e.src.slice(n, r);
}
function FF(e) {
  const t = [], n = e.length;
  let r = 0, i = e.charCodeAt(r), o = !1, a = 0, s = "";
  for (; r < n; )
    i === 124 && (o ? (s += e.substring(a, r - 1), a = r) : (t.push(s + e.substring(a, r)), s = "", a = r + 1)), o = i === 92, r++, i = e.charCodeAt(r);
  return t.push(s + e.substring(a)), t;
}
function JYe(e, t, n, r) {
  if (t + 2 > n)
    return !1;
  let i = t + 1;
  if (e.sCount[i] < e.blkIndent || e.sCount[i] - e.blkIndent >= 4)
    return !1;
  let o = e.bMarks[i] + e.tShift[i];
  if (o >= e.eMarks[i])
    return !1;
  const a = e.src.charCodeAt(o++);
  if (a !== 124 && a !== 45 && a !== 58 || o >= e.eMarks[i])
    return !1;
  const s = e.src.charCodeAt(o++);
  if (s !== 124 && s !== 45 && s !== 58 && !Gt(s) || a === 45 && Gt(s))
    return !1;
  for (; o < e.eMarks[i]; ) {
    const N = e.src.charCodeAt(o);
    if (N !== 124 && N !== 45 && N !== 58 && !Gt(N))
      return !1;
    o++;
  }
  let l = Q8(e, t + 1), u = l.split("|");
  const c = [];
  for (let N = 0; N < u.length; N++) {
    const E = u[N].trim();
    if (!E) {
      if (N === 0 || N === u.length - 1)
        continue;
      return !1;
    }
    if (!/^:?-+:?$/.test(E))
      return !1;
    E.charCodeAt(E.length - 1) === 58 ? c.push(E.charCodeAt(0) === 58 ? "center" : "right") : E.charCodeAt(0) === 58 ? c.push("left") : c.push("");
  }
  if (l = Q8(e, t).trim(), l.indexOf("|") === -1 || e.sCount[t] - e.blkIndent >= 4)
    return !1;
  u = FF(l), u.length && u[0] === "" && u.shift(), u.length && u[u.length - 1] === "" && u.pop();
  const f = u.length;
  if (f === 0 || f !== c.length)
    return !1;
  if (r)
    return !0;
  const h = e.parentType;
  e.parentType = "table";
  const m = e.md.block.ruler.getRules("blockquote"), v = e.push("table_open", "table", 1), g = [t, 0];
  v.map = g;
  const y = e.push("thead_open", "thead", 1);
  y.map = [t, t + 1];
  const w = e.push("tr_open", "tr", 1);
  w.map = [t, t + 1];
  for (let N = 0; N < u.length; N++) {
    const E = e.push("th_open", "th", 1);
    c[N] && (E.attrs = [["style", "text-align:" + c[N]]]);
    const A = e.push("inline", "", 0);
    A.content = u[N].trim(), A.children = [], e.push("th_close", "th", -1);
  }
  e.push("tr_close", "tr", -1), e.push("thead_close", "thead", -1);
  let C, S = 0;
  for (i = t + 2; i < n && !(e.sCount[i] < e.blkIndent); i++) {
    let N = !1;
    for (let A = 0, O = m.length; A < O; A++)
      if (m[A](e, i, n, !0)) {
        N = !0;
        break;
      }
    if (N || (l = Q8(e, i).trim(), !l) || e.sCount[i] - e.blkIndent >= 4 || (u = FF(l), u.length && u[0] === "" && u.shift(), u.length && u[u.length - 1] === "" && u.pop(), S += f - u.length, S > XYe))
      break;
    if (i === t + 2) {
      const A = e.push("tbody_open", "tbody", 1);
      A.map = C = [t + 2, 0];
    }
    const E = e.push("tr_open", "tr", 1);
    E.map = [i, i + 1];
    for (let A = 0; A < f; A++) {
      const O = e.push("td_open", "td", 1);
      c[A] && (O.attrs = [["style", "text-align:" + c[A]]]);
      const T = e.push("inline", "", 0);
      T.content = u[A] ? u[A].trim() : "", T.children = [], e.push("td_close", "td", -1);
    }
    e.push("tr_close", "tr", -1);
  }
  return C && (e.push("tbody_close", "tbody", -1), C[1] = i), e.push("table_close", "table", -1), g[1] = i, e.parentType = h, e.line = i, !0;
}
function QYe(e, t, n) {
  if (e.sCount[t] - e.blkIndent < 4)
    return !1;
  let r = t + 1, i = r;
  for (; r < n; ) {
    if (e.isEmpty(r)) {
      r++;
      continue;
    }
    if (e.sCount[r] - e.blkIndent >= 4) {
      r++, i = r;
      continue;
    }
    break;
  }
  e.line = i;
  const o = e.push("code_block", "code", 0);
  return o.content = e.getLines(t, i, 4 + e.blkIndent, !1) + `
`, o.map = [t, e.line], !0;
}
function eZe(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t], o = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4 || i + 3 > o)
    return !1;
  const a = e.src.charCodeAt(i);
  if (a !== 126 && a !== 96)
    return !1;
  let s = i;
  i = e.skipChars(i, a);
  let l = i - s;
  if (l < 3)
    return !1;
  const u = e.src.slice(s, i), c = e.src.slice(i, o);
  if (a === 96 && c.indexOf(String.fromCharCode(a)) >= 0)
    return !1;
  if (r)
    return !0;
  let f = t, h = !1;
  for (; f++, !(f >= n || (i = s = e.bMarks[f] + e.tShift[f], o = e.eMarks[f], i < o && e.sCount[f] < e.blkIndent)); )
    if (e.src.charCodeAt(i) === a && !(e.sCount[f] - e.blkIndent >= 4) && (i = e.skipChars(i, a), !(i - s < l) && (i = e.skipSpaces(i), !(i < o)))) {
      h = !0;
      break;
    }
  l = e.sCount[t], e.line = f + (h ? 1 : 0);
  const m = e.push("fence", "code", 0);
  return m.info = c, m.content = e.getLines(t + 1, f, l, !0), m.markup = u, m.map = [t, e.line], !0;
}
function tZe(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t], o = e.eMarks[t];
  const a = e.lineMax;
  if (e.sCount[t] - e.blkIndent >= 4 || e.src.charCodeAt(i) !== 62)
    return !1;
  if (r)
    return !0;
  const s = [], l = [], u = [], c = [], f = e.md.block.ruler.getRules("blockquote"), h = e.parentType;
  e.parentType = "blockquote";
  let m = !1, v;
  for (v = t; v < n; v++) {
    const S = e.sCount[v] < e.blkIndent;
    if (i = e.bMarks[v] + e.tShift[v], o = e.eMarks[v], i >= o)
      break;
    if (e.src.charCodeAt(i++) === 62 && !S) {
      let E = e.sCount[v] + 1, A, O;
      e.src.charCodeAt(i) === 32 ? (i++, E++, O = !1, A = !0) : e.src.charCodeAt(i) === 9 ? (A = !0, (e.bsCount[v] + E) % 4 === 3 ? (i++, E++, O = !1) : O = !0) : A = !1;
      let T = E;
      for (s.push(e.bMarks[v]), e.bMarks[v] = i; i < o; ) {
        const M = e.src.charCodeAt(i);
        if (Gt(M))
          M === 9 ? T += 4 - (T + e.bsCount[v] + (O ? 1 : 0)) % 4 : T++;
        else
          break;
        i++;
      }
      m = i >= o, l.push(e.bsCount[v]), e.bsCount[v] = e.sCount[v] + 1 + (A ? 1 : 0), u.push(e.sCount[v]), e.sCount[v] = T - E, c.push(e.tShift[v]), e.tShift[v] = i - e.bMarks[v];
      continue;
    }
    if (m)
      break;
    let N = !1;
    for (let E = 0, A = f.length; E < A; E++)
      if (f[E](e, v, n, !0)) {
        N = !0;
        break;
      }
    if (N) {
      e.lineMax = v, e.blkIndent !== 0 && (s.push(e.bMarks[v]), l.push(e.bsCount[v]), c.push(e.tShift[v]), u.push(e.sCount[v]), e.sCount[v] -= e.blkIndent);
      break;
    }
    s.push(e.bMarks[v]), l.push(e.bsCount[v]), c.push(e.tShift[v]), u.push(e.sCount[v]), e.sCount[v] = -1;
  }
  const g = e.blkIndent;
  e.blkIndent = 0;
  const y = e.push("blockquote_open", "blockquote", 1);
  y.markup = ">";
  const w = [t, 0];
  y.map = w, e.md.block.tokenize(e, t, v);
  const C = e.push("blockquote_close", "blockquote", -1);
  C.markup = ">", e.lineMax = a, e.parentType = h, w[1] = e.line;
  for (let S = 0; S < c.length; S++)
    e.bMarks[S + t] = s[S], e.tShift[S + t] = c[S], e.sCount[S + t] = u[S], e.bsCount[S + t] = l[S];
  return e.blkIndent = g, !0;
}
function nZe(e, t, n, r) {
  const i = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4)
    return !1;
  let o = e.bMarks[t] + e.tShift[t];
  const a = e.src.charCodeAt(o++);
  if (a !== 42 && a !== 45 && a !== 95)
    return !1;
  let s = 1;
  for (; o < i; ) {
    const u = e.src.charCodeAt(o++);
    if (u !== a && !Gt(u))
      return !1;
    u === a && s++;
  }
  if (s < 3)
    return !1;
  if (r)
    return !0;
  e.line = t + 1;
  const l = e.push("hr", "hr", 0);
  return l.map = [t, e.line], l.markup = Array(s + 1).join(String.fromCharCode(a)), !0;
}
function BF(e, t) {
  const n = e.eMarks[t];
  let r = e.bMarks[t] + e.tShift[t];
  const i = e.src.charCodeAt(r++);
  if (i !== 42 && i !== 45 && i !== 43)
    return -1;
  if (r < n) {
    const o = e.src.charCodeAt(r);
    if (!Gt(o))
      return -1;
  }
  return r;
}
function jF(e, t) {
  const n = e.bMarks[t] + e.tShift[t], r = e.eMarks[t];
  let i = n;
  if (i + 1 >= r)
    return -1;
  let o = e.src.charCodeAt(i++);
  if (o < 48 || o > 57)
    return -1;
  for (; ; ) {
    if (i >= r)
      return -1;
    if (o = e.src.charCodeAt(i++), o >= 48 && o <= 57) {
      if (i - n >= 10)
        return -1;
      continue;
    }
    if (o === 41 || o === 46)
      break;
    return -1;
  }
  return i < r && (o = e.src.charCodeAt(i), !Gt(o)) ? -1 : i;
}
function rZe(e, t) {
  const n = e.level + 2;
  for (let r = t + 2, i = e.tokens.length - 2; r < i; r++)
    e.tokens[r].level === n && e.tokens[r].type === "paragraph_open" && (e.tokens[r + 2].hidden = !0, e.tokens[r].hidden = !0, r += 2);
}
function iZe(e, t, n, r) {
  let i, o, a, s, l = t, u = !0;
  if (e.sCount[l] - e.blkIndent >= 4 || e.listIndent >= 0 && e.sCount[l] - e.listIndent >= 4 && e.sCount[l] < e.blkIndent)
    return !1;
  let c = !1;
  r && e.parentType === "paragraph" && e.sCount[l] >= e.blkIndent && (c = !0);
  let f, h, m;
  if ((m = jF(e, l)) >= 0) {
    if (f = !0, a = e.bMarks[l] + e.tShift[l], h = Number(e.src.slice(a, m - 1)), c && h !== 1) return !1;
  } else if ((m = BF(e, l)) >= 0)
    f = !1;
  else
    return !1;
  if (c && e.skipSpaces(m) >= e.eMarks[l])
    return !1;
  if (r)
    return !0;
  const v = e.src.charCodeAt(m - 1), g = e.tokens.length;
  f ? (s = e.push("ordered_list_open", "ol", 1), h !== 1 && (s.attrs = [["start", h]])) : s = e.push("bullet_list_open", "ul", 1);
  const y = [l, 0];
  s.map = y, s.markup = String.fromCharCode(v);
  let w = !1;
  const C = e.md.block.ruler.getRules("list"), S = e.parentType;
  for (e.parentType = "list"; l < n; ) {
    o = m, i = e.eMarks[l];
    const N = e.sCount[l] + m - (e.bMarks[l] + e.tShift[l]);
    let E = N;
    for (; o < i; ) {
      const G = e.src.charCodeAt(o);
      if (G === 9)
        E += 4 - (E + e.bsCount[l]) % 4;
      else if (G === 32)
        E++;
      else
        break;
      o++;
    }
    const A = o;
    let O;
    A >= i ? O = 1 : O = E - N, O > 4 && (O = 1);
    const T = N + O;
    s = e.push("list_item_open", "li", 1), s.markup = String.fromCharCode(v);
    const M = [l, 0];
    s.map = M, f && (s.info = e.src.slice(a, m - 1));
    const L = e.tight, I = e.tShift[l], j = e.sCount[l], B = e.listIndent;
    if (e.listIndent = e.blkIndent, e.blkIndent = T, e.tight = !0, e.tShift[l] = A - e.bMarks[l], e.sCount[l] = E, A >= i && e.isEmpty(l + 1) ? e.line = Math.min(e.line + 2, n) : e.md.block.tokenize(e, l, n, !0), (!e.tight || w) && (u = !1), w = e.line - l > 1 && e.isEmpty(e.line - 1), e.blkIndent = e.listIndent, e.listIndent = B, e.tShift[l] = I, e.sCount[l] = j, e.tight = L, s = e.push("list_item_close", "li", -1), s.markup = String.fromCharCode(v), l = e.line, M[1] = l, l >= n || e.sCount[l] < e.blkIndent || e.sCount[l] - e.blkIndent >= 4)
      break;
    let q = !1;
    for (let G = 0, U = C.length; G < U; G++)
      if (C[G](e, l, n, !0)) {
        q = !0;
        break;
      }
    if (q)
      break;
    if (f) {
      if (m = jF(e, l), m < 0)
        break;
      a = e.bMarks[l] + e.tShift[l];
    } else if (m = BF(e, l), m < 0)
      break;
    if (v !== e.src.charCodeAt(m - 1))
      break;
  }
  return f ? s = e.push("ordered_list_close", "ol", -1) : s = e.push("bullet_list_close", "ul", -1), s.markup = String.fromCharCode(v), y[1] = l, e.line = l, e.parentType = S, u && rZe(e, g), !0;
}
function oZe(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t], o = e.eMarks[t], a = t + 1;
  if (e.sCount[t] - e.blkIndent >= 4 || e.src.charCodeAt(i) !== 91)
    return !1;
  function s(C) {
    const S = e.lineMax;
    if (C >= S || e.isEmpty(C))
      return null;
    let N = !1;
    if (e.sCount[C] - e.blkIndent > 3 && (N = !0), e.sCount[C] < 0 && (N = !0), !N) {
      const O = e.md.block.ruler.getRules("reference"), T = e.parentType;
      e.parentType = "reference";
      let M = !1;
      for (let L = 0, I = O.length; L < I; L++)
        if (O[L](e, C, S, !0)) {
          M = !0;
          break;
        }
      if (e.parentType = T, M)
        return null;
    }
    const E = e.bMarks[C] + e.tShift[C], A = e.eMarks[C];
    return e.src.slice(E, A + 1);
  }
  let l = e.src.slice(i, o + 1);
  o = l.length;
  let u = -1;
  for (i = 1; i < o; i++) {
    const C = l.charCodeAt(i);
    if (C === 91)
      return !1;
    if (C === 93) {
      u = i;
      break;
    } else if (C === 10) {
      const S = s(a);
      S !== null && (l += S, o = l.length, a++);
    } else if (C === 92 && (i++, i < o && l.charCodeAt(i) === 10)) {
      const S = s(a);
      S !== null && (l += S, o = l.length, a++);
    }
  }
  if (u < 0 || l.charCodeAt(u + 1) !== 58)
    return !1;
  for (i = u + 2; i < o; i++) {
    const C = l.charCodeAt(i);
    if (C === 10) {
      const S = s(a);
      S !== null && (l += S, o = l.length, a++);
    } else if (!Gt(C)) break;
  }
  const c = e.md.helpers.parseLinkDestination(l, i, o);
  if (!c.ok)
    return !1;
  const f = e.md.normalizeLink(c.str);
  if (!e.md.validateLink(f))
    return !1;
  i = c.pos;
  const h = i, m = a, v = i;
  for (; i < o; i++) {
    const C = l.charCodeAt(i);
    if (C === 10) {
      const S = s(a);
      S !== null && (l += S, o = l.length, a++);
    } else if (!Gt(C)) break;
  }
  let g = e.md.helpers.parseLinkTitle(l, i, o);
  for (; g.can_continue; ) {
    const C = s(a);
    if (C === null) break;
    l += C, i = o, o = l.length, a++, g = e.md.helpers.parseLinkTitle(l, i, o, g);
  }
  let y;
  for (i < o && v !== i && g.ok ? (y = g.str, i = g.pos) : (y = "", i = h, a = m); i < o; ) {
    const C = l.charCodeAt(i);
    if (!Gt(C))
      break;
    i++;
  }
  if (i < o && l.charCodeAt(i) !== 10 && y)
    for (y = "", i = h, a = m; i < o; ) {
      const C = l.charCodeAt(i);
      if (!Gt(C))
        break;
      i++;
    }
  if (i < o && l.charCodeAt(i) !== 10)
    return !1;
  const w = Kv(l.slice(1, u));
  return w ? (r || (typeof e.env.references > "u" && (e.env.references = {}), typeof e.env.references[w] > "u" && (e.env.references[w] = { title: y, href: f }), e.line = a), !0) : !1;
}
const aZe = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], sZe = "[a-zA-Z_:][a-zA-Z0-9:._-]*", lZe = "[^\"'=<>`\\x00-\\x20]+", uZe = "'[^']*'", cZe = '"[^"]*"', dZe = "(?:" + lZe + "|" + uZe + "|" + cZe + ")", fZe = "(?:\\s+" + sZe + "(?:\\s*=\\s*" + dZe + ")?)", bte = "<[A-Za-z][A-Za-z0-9\\-]*" + fZe + "*\\s*\\/?>", xte = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", hZe = "<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->", pZe = "<[?][\\s\\S]*?[?]>", mZe = "<![A-Za-z][^>]*>", gZe = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", vZe = new RegExp("^(?:" + bte + "|" + xte + "|" + hZe + "|" + pZe + "|" + mZe + "|" + gZe + ")"), yZe = new RegExp("^(?:" + bte + "|" + xte + ")"), Qu = [
  [/^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, !0],
  [/^<!--/, /-->/, !0],
  [/^<\?/, /\?>/, !0],
  [/^<![A-Z]/, />/, !0],
  [/^<!\[CDATA\[/, /\]\]>/, !0],
  [new RegExp("^</?(" + aZe.join("|") + ")(?=(\\s|/?>|$))", "i"), /^$/, !0],
  [new RegExp(yZe.source + "\\s*$"), /^$/, !1]
];
function bZe(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t], o = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4 || !e.md.options.html || e.src.charCodeAt(i) !== 60)
    return !1;
  let a = e.src.slice(i, o), s = 0;
  for (; s < Qu.length && !Qu[s][0].test(a); s++)
    ;
  if (s === Qu.length)
    return !1;
  if (r)
    return Qu[s][2];
  let l = t + 1;
  if (!Qu[s][1].test(a)) {
    for (; l < n && !(e.sCount[l] < e.blkIndent); l++)
      if (i = e.bMarks[l] + e.tShift[l], o = e.eMarks[l], a = e.src.slice(i, o), Qu[s][1].test(a)) {
        a.length !== 0 && l++;
        break;
      }
  }
  e.line = l;
  const u = e.push("html_block", "", 0);
  return u.map = [t, l], u.content = e.getLines(t, l, e.blkIndent, !0), !0;
}
function xZe(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t], o = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4)
    return !1;
  let a = e.src.charCodeAt(i);
  if (a !== 35 || i >= o)
    return !1;
  let s = 1;
  for (a = e.src.charCodeAt(++i); a === 35 && i < o && s <= 6; )
    s++, a = e.src.charCodeAt(++i);
  if (s > 6 || i < o && !Gt(a))
    return !1;
  if (r)
    return !0;
  o = e.skipSpacesBack(o, i);
  const l = e.skipCharsBack(o, 35, i);
  l > i && Gt(e.src.charCodeAt(l - 1)) && (o = l), e.line = t + 1;
  const u = e.push("heading_open", "h" + String(s), 1);
  u.markup = "########".slice(0, s), u.map = [t, e.line];
  const c = e.push("inline", "", 0);
  c.content = e.src.slice(i, o).trim(), c.map = [t, e.line], c.children = [];
  const f = e.push("heading_close", "h" + String(s), -1);
  return f.markup = "########".slice(0, s), !0;
}
function wZe(e, t, n) {
  const r = e.md.block.ruler.getRules("paragraph");
  if (e.sCount[t] - e.blkIndent >= 4)
    return !1;
  const i = e.parentType;
  e.parentType = "paragraph";
  let o = 0, a, s = t + 1;
  for (; s < n && !e.isEmpty(s); s++) {
    if (e.sCount[s] - e.blkIndent > 3)
      continue;
    if (e.sCount[s] >= e.blkIndent) {
      let m = e.bMarks[s] + e.tShift[s];
      const v = e.eMarks[s];
      if (m < v && (a = e.src.charCodeAt(m), (a === 45 || a === 61) && (m = e.skipChars(m, a), m = e.skipSpaces(m), m >= v))) {
        o = a === 61 ? 1 : 2;
        break;
      }
    }
    if (e.sCount[s] < 0)
      continue;
    let h = !1;
    for (let m = 0, v = r.length; m < v; m++)
      if (r[m](e, s, n, !0)) {
        h = !0;
        break;
      }
    if (h)
      break;
  }
  if (!o)
    return !1;
  const l = e.getLines(t, s, e.blkIndent, !1).trim();
  e.line = s + 1;
  const u = e.push("heading_open", "h" + String(o), 1);
  u.markup = String.fromCharCode(a), u.map = [t, e.line];
  const c = e.push("inline", "", 0);
  c.content = l, c.map = [t, e.line - 1], c.children = [];
  const f = e.push("heading_close", "h" + String(o), -1);
  return f.markup = String.fromCharCode(a), e.parentType = i, !0;
}
function CZe(e, t, n) {
  const r = e.md.block.ruler.getRules("paragraph"), i = e.parentType;
  let o = t + 1;
  for (e.parentType = "paragraph"; o < n && !e.isEmpty(o); o++) {
    if (e.sCount[o] - e.blkIndent > 3 || e.sCount[o] < 0)
      continue;
    let u = !1;
    for (let c = 0, f = r.length; c < f; c++)
      if (r[c](e, o, n, !0)) {
        u = !0;
        break;
      }
    if (u)
      break;
  }
  const a = e.getLines(t, o, e.blkIndent, !1).trim();
  e.line = o;
  const s = e.push("paragraph_open", "p", 1);
  s.map = [t, e.line];
  const l = e.push("inline", "", 0);
  return l.content = a, l.map = [t, e.line], l.children = [], e.push("paragraph_close", "p", -1), e.parentType = i, !0;
}
const R1 = [
  // First 2 params - rule name & source. Secondary array - list of rules,
  // which can be terminated by this one.
  ["table", JYe, ["paragraph", "reference"]],
  ["code", QYe],
  ["fence", eZe, ["paragraph", "reference", "blockquote", "list"]],
  ["blockquote", tZe, ["paragraph", "reference", "blockquote", "list"]],
  ["hr", nZe, ["paragraph", "reference", "blockquote", "list"]],
  ["list", iZe, ["paragraph", "reference", "blockquote"]],
  ["reference", oZe],
  ["html_block", bZe, ["paragraph", "reference", "blockquote"]],
  ["heading", xZe, ["paragraph", "reference", "blockquote"]],
  ["lheading", wZe],
  ["paragraph", CZe]
];
function Yv() {
  this.ruler = new Xr();
  for (let e = 0; e < R1.length; e++)
    this.ruler.push(R1[e][0], R1[e][1], { alt: (R1[e][2] || []).slice() });
}
Yv.prototype.tokenize = function(e, t, n) {
  const r = this.ruler.getRules(""), i = r.length, o = e.md.options.maxNesting;
  let a = t, s = !1;
  for (; a < n && (e.line = a = e.skipEmptyLines(a), !(a >= n || e.sCount[a] < e.blkIndent)); ) {
    if (e.level >= o) {
      e.line = n;
      break;
    }
    const l = e.line;
    let u = !1;
    for (let c = 0; c < i; c++)
      if (u = r[c](e, a, n, !1), u) {
        if (l >= e.line)
          throw new Error("block rule didn't increment state.line");
        break;
      }
    if (!u) throw new Error("none of the block rules matched");
    e.tight = !s, e.isEmpty(e.line - 1) && (s = !0), a = e.line, a < n && e.isEmpty(a) && (s = !0, a++, e.line = a);
  }
};
Yv.prototype.parse = function(e, t, n, r) {
  if (!e)
    return;
  const i = new this.State(e, t, n, r);
  this.tokenize(i, i.line, i.lineMax);
};
Yv.prototype.State = oa;
function jp(e, t, n, r) {
  this.src = e, this.env = n, this.md = t, this.tokens = r, this.tokens_meta = Array(r.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
}
jp.prototype.pushPending = function() {
  const e = new wo("text", "", 0);
  return e.content = this.pending, e.level = this.pendingLevel, this.tokens.push(e), this.pending = "", e;
};
jp.prototype.push = function(e, t, n) {
  this.pending && this.pushPending();
  const r = new wo(e, t, n);
  let i = null;
  return n < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), r.level = this.level, n > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], i = { delimiters: this.delimiters }), this.pendingLevel = this.level, this.tokens.push(r), this.tokens_meta.push(i), r;
};
jp.prototype.scanDelims = function(e, t) {
  const n = this.posMax, r = this.src.charCodeAt(e), i = e > 0 ? this.src.charCodeAt(e - 1) : 32;
  let o = e;
  for (; o < n && this.src.charCodeAt(o) === r; )
    o++;
  const a = o - e, s = o < n ? this.src.charCodeAt(o) : 32, l = Jh(i) || Xh(String.fromCharCode(i)), u = Jh(s) || Xh(String.fromCharCode(s)), c = Zh(i), f = Zh(s), h = !f && (!u || c || l), m = !c && (!l || f || u);
  return { can_open: h && (t || !m || l), can_close: m && (t || !h || u), length: a };
};
jp.prototype.Token = wo;
function SZe(e) {
  switch (e) {
    case 10:
    case 33:
    case 35:
    case 36:
    case 37:
    case 38:
    case 42:
    case 43:
    case 45:
    case 58:
    case 60:
    case 61:
    case 62:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function _Ze(e, t) {
  let n = e.pos;
  for (; n < e.posMax && !SZe(e.src.charCodeAt(n)); )
    n++;
  return n === e.pos ? !1 : (t || (e.pending += e.src.slice(e.pos, n)), e.pos = n, !0);
}
const EZe = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function NZe(e, t) {
  if (!e.md.options.linkify || e.linkLevel > 0) return !1;
  const n = e.pos, r = e.posMax;
  if (n + 3 > r || e.src.charCodeAt(n) !== 58 || e.src.charCodeAt(n + 1) !== 47 || e.src.charCodeAt(n + 2) !== 47) return !1;
  const i = e.pending.match(EZe);
  if (!i) return !1;
  const o = i[1], a = e.md.linkify.matchAtStart(e.src.slice(n - o.length));
  if (!a) return !1;
  let s = a.url;
  if (s.length <= o.length) return !1;
  s = s.replace(/\*+$/, "");
  const l = e.md.normalizeLink(s);
  if (!e.md.validateLink(l)) return !1;
  if (!t) {
    e.pending = e.pending.slice(0, -o.length);
    const u = e.push("link_open", "a", 1);
    u.attrs = [["href", l]], u.markup = "linkify", u.info = "auto";
    const c = e.push("text", "", 0);
    c.content = e.md.normalizeLinkText(s);
    const f = e.push("link_close", "a", -1);
    f.markup = "linkify", f.info = "auto";
  }
  return e.pos += s.length - o.length, !0;
}
function AZe(e, t) {
  let n = e.pos;
  if (e.src.charCodeAt(n) !== 10)
    return !1;
  const r = e.pending.length - 1, i = e.posMax;
  if (!t)
    if (r >= 0 && e.pending.charCodeAt(r) === 32)
      if (r >= 1 && e.pending.charCodeAt(r - 1) === 32) {
        let o = r - 1;
        for (; o >= 1 && e.pending.charCodeAt(o - 1) === 32; ) o--;
        e.pending = e.pending.slice(0, o), e.push("hardbreak", "br", 0);
      } else
        e.pending = e.pending.slice(0, -1), e.push("softbreak", "br", 0);
    else
      e.push("softbreak", "br", 0);
  for (n++; n < i && Gt(e.src.charCodeAt(n)); )
    n++;
  return e.pos = n, !0;
}
const lE = [];
for (let e = 0; e < 256; e++)
  lE.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(e) {
  lE[e.charCodeAt(0)] = 1;
});
function OZe(e, t) {
  let n = e.pos;
  const r = e.posMax;
  if (e.src.charCodeAt(n) !== 92 || (n++, n >= r)) return !1;
  let i = e.src.charCodeAt(n);
  if (i === 10) {
    for (t || e.push("hardbreak", "br", 0), n++; n < r && (i = e.src.charCodeAt(n), !!Gt(i)); )
      n++;
    return e.pos = n, !0;
  }
  let o = e.src[n];
  if (i >= 55296 && i <= 56319 && n + 1 < r) {
    const s = e.src.charCodeAt(n + 1);
    s >= 56320 && s <= 57343 && (o += e.src[n + 1], n++);
  }
  const a = "\\" + o;
  if (!t) {
    const s = e.push("text_special", "", 0);
    i < 256 && lE[i] !== 0 ? s.content = o : s.content = a, s.markup = a, s.info = "escape";
  }
  return e.pos = n + 1, !0;
}
function kZe(e, t) {
  let n = e.pos;
  if (e.src.charCodeAt(n) !== 96)
    return !1;
  const i = n;
  n++;
  const o = e.posMax;
  for (; n < o && e.src.charCodeAt(n) === 96; )
    n++;
  const a = e.src.slice(i, n), s = a.length;
  if (e.backticksScanned && (e.backticks[s] || 0) <= i)
    return t || (e.pending += a), e.pos += s, !0;
  let l = n, u;
  for (; (u = e.src.indexOf("`", l)) !== -1; ) {
    for (l = u + 1; l < o && e.src.charCodeAt(l) === 96; )
      l++;
    const c = l - u;
    if (c === s) {
      if (!t) {
        const f = e.push("code_inline", "code", 0);
        f.markup = a, f.content = e.src.slice(n, u).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
      }
      return e.pos = l, !0;
    }
    e.backticks[c] = u;
  }
  return e.backticksScanned = !0, t || (e.pending += a), e.pos += s, !0;
}
function PZe(e, t) {
  const n = e.pos, r = e.src.charCodeAt(n);
  if (t || r !== 126)
    return !1;
  const i = e.scanDelims(e.pos, !0);
  let o = i.length;
  const a = String.fromCharCode(r);
  if (o < 2)
    return !1;
  let s;
  o % 2 && (s = e.push("text", "", 0), s.content = a, o--);
  for (let l = 0; l < o; l += 2)
    s = e.push("text", "", 0), s.content = a + a, e.delimiters.push({
      marker: r,
      length: 0,
      // disable "rule of 3" length checks meant for emphasis
      token: e.tokens.length - 1,
      end: -1,
      open: i.can_open,
      close: i.can_close
    });
  return e.pos += i.length, !0;
}
function VF(e, t) {
  let n;
  const r = [], i = t.length;
  for (let o = 0; o < i; o++) {
    const a = t[o];
    if (a.marker !== 126 || a.end === -1)
      continue;
    const s = t[a.end];
    n = e.tokens[a.token], n.type = "s_open", n.tag = "s", n.nesting = 1, n.markup = "~~", n.content = "", n = e.tokens[s.token], n.type = "s_close", n.tag = "s", n.nesting = -1, n.markup = "~~", n.content = "", e.tokens[s.token - 1].type === "text" && e.tokens[s.token - 1].content === "~" && r.push(s.token - 1);
  }
  for (; r.length; ) {
    const o = r.pop();
    let a = o + 1;
    for (; a < e.tokens.length && e.tokens[a].type === "s_close"; )
      a++;
    a--, o !== a && (n = e.tokens[a], e.tokens[a] = e.tokens[o], e.tokens[o] = n);
  }
}
function TZe(e) {
  const t = e.tokens_meta, n = e.tokens_meta.length;
  VF(e, e.delimiters);
  for (let r = 0; r < n; r++)
    t[r] && t[r].delimiters && VF(e, t[r].delimiters);
}
const wte = {
  tokenize: PZe,
  postProcess: TZe
};
function MZe(e, t) {
  const n = e.pos, r = e.src.charCodeAt(n);
  if (t || r !== 95 && r !== 42)
    return !1;
  const i = e.scanDelims(e.pos, r === 42);
  for (let o = 0; o < i.length; o++) {
    const a = e.push("text", "", 0);
    a.content = String.fromCharCode(r), e.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: r,
      // Total length of these series of delimiters.
      //
      length: i.length,
      // A position of the token this delimiter corresponds to.
      //
      token: e.tokens.length - 1,
      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end: -1,
      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open: i.can_open,
      close: i.can_close
    });
  }
  return e.pos += i.length, !0;
}
function qF(e, t) {
  const n = t.length;
  for (let r = n - 1; r >= 0; r--) {
    const i = t[r];
    if (i.marker !== 95 && i.marker !== 42 || i.end === -1)
      continue;
    const o = t[i.end], a = r > 0 && t[r - 1].end === i.end + 1 && // check that first two markers match and adjacent
    t[r - 1].marker === i.marker && t[r - 1].token === i.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
    t[i.end + 1].token === o.token + 1, s = String.fromCharCode(i.marker), l = e.tokens[i.token];
    l.type = a ? "strong_open" : "em_open", l.tag = a ? "strong" : "em", l.nesting = 1, l.markup = a ? s + s : s, l.content = "";
    const u = e.tokens[o.token];
    u.type = a ? "strong_close" : "em_close", u.tag = a ? "strong" : "em", u.nesting = -1, u.markup = a ? s + s : s, u.content = "", a && (e.tokens[t[r - 1].token].content = "", e.tokens[t[i.end + 1].token].content = "", r--);
  }
}
function RZe(e) {
  const t = e.tokens_meta, n = e.tokens_meta.length;
  qF(e, e.delimiters);
  for (let r = 0; r < n; r++)
    t[r] && t[r].delimiters && qF(e, t[r].delimiters);
}
const Cte = {
  tokenize: MZe,
  postProcess: RZe
};
function DZe(e, t) {
  let n, r, i, o, a = "", s = "", l = e.pos, u = !0;
  if (e.src.charCodeAt(e.pos) !== 91)
    return !1;
  const c = e.pos, f = e.posMax, h = e.pos + 1, m = e.md.helpers.parseLinkLabel(e, e.pos, !0);
  if (m < 0)
    return !1;
  let v = m + 1;
  if (v < f && e.src.charCodeAt(v) === 40) {
    for (u = !1, v++; v < f && (n = e.src.charCodeAt(v), !(!Gt(n) && n !== 10)); v++)
      ;
    if (v >= f)
      return !1;
    if (l = v, i = e.md.helpers.parseLinkDestination(e.src, v, e.posMax), i.ok) {
      for (a = e.md.normalizeLink(i.str), e.md.validateLink(a) ? v = i.pos : a = "", l = v; v < f && (n = e.src.charCodeAt(v), !(!Gt(n) && n !== 10)); v++)
        ;
      if (i = e.md.helpers.parseLinkTitle(e.src, v, e.posMax), v < f && l !== v && i.ok)
        for (s = i.str, v = i.pos; v < f && (n = e.src.charCodeAt(v), !(!Gt(n) && n !== 10)); v++)
          ;
    }
    (v >= f || e.src.charCodeAt(v) !== 41) && (u = !0), v++;
  }
  if (u) {
    if (typeof e.env.references > "u")
      return !1;
    if (v < f && e.src.charCodeAt(v) === 91 ? (l = v + 1, v = e.md.helpers.parseLinkLabel(e, v), v >= 0 ? r = e.src.slice(l, v++) : v = m + 1) : v = m + 1, r || (r = e.src.slice(h, m)), o = e.env.references[Kv(r)], !o)
      return e.pos = c, !1;
    a = o.href, s = o.title;
  }
  if (!t) {
    e.pos = h, e.posMax = m;
    const g = e.push("link_open", "a", 1), y = [["href", a]];
    g.attrs = y, s && y.push(["title", s]), e.linkLevel++, e.md.inline.tokenize(e), e.linkLevel--, e.push("link_close", "a", -1);
  }
  return e.pos = v, e.posMax = f, !0;
}
function IZe(e, t) {
  let n, r, i, o, a, s, l, u, c = "";
  const f = e.pos, h = e.posMax;
  if (e.src.charCodeAt(e.pos) !== 33 || e.src.charCodeAt(e.pos + 1) !== 91)
    return !1;
  const m = e.pos + 2, v = e.md.helpers.parseLinkLabel(e, e.pos + 1, !1);
  if (v < 0)
    return !1;
  if (o = v + 1, o < h && e.src.charCodeAt(o) === 40) {
    for (o++; o < h && (n = e.src.charCodeAt(o), !(!Gt(n) && n !== 10)); o++)
      ;
    if (o >= h)
      return !1;
    for (u = o, s = e.md.helpers.parseLinkDestination(e.src, o, e.posMax), s.ok && (c = e.md.normalizeLink(s.str), e.md.validateLink(c) ? o = s.pos : c = ""), u = o; o < h && (n = e.src.charCodeAt(o), !(!Gt(n) && n !== 10)); o++)
      ;
    if (s = e.md.helpers.parseLinkTitle(e.src, o, e.posMax), o < h && u !== o && s.ok)
      for (l = s.str, o = s.pos; o < h && (n = e.src.charCodeAt(o), !(!Gt(n) && n !== 10)); o++)
        ;
    else
      l = "";
    if (o >= h || e.src.charCodeAt(o) !== 41)
      return e.pos = f, !1;
    o++;
  } else {
    if (typeof e.env.references > "u")
      return !1;
    if (o < h && e.src.charCodeAt(o) === 91 ? (u = o + 1, o = e.md.helpers.parseLinkLabel(e, o), o >= 0 ? i = e.src.slice(u, o++) : o = v + 1) : o = v + 1, i || (i = e.src.slice(m, v)), a = e.env.references[Kv(i)], !a)
      return e.pos = f, !1;
    c = a.href, l = a.title;
  }
  if (!t) {
    r = e.src.slice(m, v);
    const g = [];
    e.md.inline.parse(
      r,
      e.md,
      e.env,
      g
    );
    const y = e.push("image", "img", 0), w = [["src", c], ["alt", ""]];
    y.attrs = w, y.children = g, y.content = r, l && w.push(["title", l]);
  }
  return e.pos = o, e.posMax = h, !0;
}
const $Ze = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/, LZe = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function FZe(e, t) {
  let n = e.pos;
  if (e.src.charCodeAt(n) !== 60)
    return !1;
  const r = e.pos, i = e.posMax;
  for (; ; ) {
    if (++n >= i) return !1;
    const a = e.src.charCodeAt(n);
    if (a === 60) return !1;
    if (a === 62) break;
  }
  const o = e.src.slice(r + 1, n);
  if (LZe.test(o)) {
    const a = e.md.normalizeLink(o);
    if (!e.md.validateLink(a))
      return !1;
    if (!t) {
      const s = e.push("link_open", "a", 1);
      s.attrs = [["href", a]], s.markup = "autolink", s.info = "auto";
      const l = e.push("text", "", 0);
      l.content = e.md.normalizeLinkText(o);
      const u = e.push("link_close", "a", -1);
      u.markup = "autolink", u.info = "auto";
    }
    return e.pos += o.length + 2, !0;
  }
  if ($Ze.test(o)) {
    const a = e.md.normalizeLink("mailto:" + o);
    if (!e.md.validateLink(a))
      return !1;
    if (!t) {
      const s = e.push("link_open", "a", 1);
      s.attrs = [["href", a]], s.markup = "autolink", s.info = "auto";
      const l = e.push("text", "", 0);
      l.content = e.md.normalizeLinkText(o);
      const u = e.push("link_close", "a", -1);
      u.markup = "autolink", u.info = "auto";
    }
    return e.pos += o.length + 2, !0;
  }
  return !1;
}
function BZe(e) {
  return /^<a[>\s]/i.test(e);
}
function jZe(e) {
  return /^<\/a\s*>/i.test(e);
}
function VZe(e) {
  const t = e | 32;
  return t >= 97 && t <= 122;
}
function qZe(e, t) {
  if (!e.md.options.html)
    return !1;
  const n = e.posMax, r = e.pos;
  if (e.src.charCodeAt(r) !== 60 || r + 2 >= n)
    return !1;
  const i = e.src.charCodeAt(r + 1);
  if (i !== 33 && i !== 63 && i !== 47 && !VZe(i))
    return !1;
  const o = e.src.slice(r).match(vZe);
  if (!o)
    return !1;
  if (!t) {
    const a = e.push("html_inline", "", 0);
    a.content = o[0], BZe(a.content) && e.linkLevel++, jZe(a.content) && e.linkLevel--;
  }
  return e.pos += o[0].length, !0;
}
const zZe = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i, WZe = /^&([a-z][a-z0-9]{1,31});/i;
function HZe(e, t) {
  const n = e.pos, r = e.posMax;
  if (e.src.charCodeAt(n) !== 38 || n + 1 >= r) return !1;
  if (e.src.charCodeAt(n + 1) === 35) {
    const o = e.src.slice(n).match(zZe);
    if (o) {
      if (!t) {
        const a = o[1][0].toLowerCase() === "x" ? parseInt(o[1].slice(1), 16) : parseInt(o[1], 10), s = e.push("text_special", "", 0);
        s.content = aE(a) ? Mg(a) : Mg(65533), s.markup = o[0], s.info = "entity";
      }
      return e.pos += o[0].length, !0;
    }
  } else {
    const o = e.src.slice(n).match(WZe);
    if (o) {
      const a = pte(o[0]);
      if (a !== o[0]) {
        if (!t) {
          const s = e.push("text_special", "", 0);
          s.content = a, s.markup = o[0], s.info = "entity";
        }
        return e.pos += o[0].length, !0;
      }
    }
  }
  return !1;
}
function zF(e) {
  const t = {}, n = e.length;
  if (!n) return;
  let r = 0, i = -2;
  const o = [];
  for (let a = 0; a < n; a++) {
    const s = e[a];
    if (o.push(0), (e[r].marker !== s.marker || i !== s.token - 1) && (r = a), i = s.token, s.length = s.length || 0, !s.close) continue;
    t.hasOwnProperty(s.marker) || (t[s.marker] = [-1, -1, -1, -1, -1, -1]);
    const l = t[s.marker][(s.open ? 3 : 0) + s.length % 3];
    let u = r - o[r] - 1, c = u;
    for (; u > l; u -= o[u] + 1) {
      const f = e[u];
      if (f.marker === s.marker && f.open && f.end < 0) {
        let h = !1;
        if ((f.close || s.open) && (f.length + s.length) % 3 === 0 && (f.length % 3 !== 0 || s.length % 3 !== 0) && (h = !0), !h) {
          const m = u > 0 && !e[u - 1].open ? o[u - 1] + 1 : 0;
          o[a] = a - u + m, o[u] = m, s.open = !1, f.end = a, f.close = !1, c = -1, i = -2;
          break;
        }
      }
    }
    c !== -1 && (t[s.marker][(s.open ? 3 : 0) + (s.length || 0) % 3] = c);
  }
}
function UZe(e) {
  const t = e.tokens_meta, n = e.tokens_meta.length;
  zF(e.delimiters);
  for (let r = 0; r < n; r++)
    t[r] && t[r].delimiters && zF(t[r].delimiters);
}
function GZe(e) {
  let t, n, r = 0;
  const i = e.tokens, o = e.tokens.length;
  for (t = n = 0; t < o; t++)
    i[t].nesting < 0 && r--, i[t].level = r, i[t].nesting > 0 && r++, i[t].type === "text" && t + 1 < o && i[t + 1].type === "text" ? i[t + 1].content = i[t].content + i[t + 1].content : (t !== n && (i[n] = i[t]), n++);
  t !== n && (i.length = n);
}
const ex = [
  ["text", _Ze],
  ["linkify", NZe],
  ["newline", AZe],
  ["escape", OZe],
  ["backticks", kZe],
  ["strikethrough", wte.tokenize],
  ["emphasis", Cte.tokenize],
  ["link", DZe],
  ["image", IZe],
  ["autolink", FZe],
  ["html_inline", qZe],
  ["entity", HZe]
], tx = [
  ["balance_pairs", UZe],
  ["strikethrough", wte.postProcess],
  ["emphasis", Cte.postProcess],
  // rules for pairs separate '**' into its own text tokens, which may be left unused,
  // rule below merges unused segments back with the rest of the text
  ["fragments_join", GZe]
];
function Vp() {
  this.ruler = new Xr();
  for (let e = 0; e < ex.length; e++)
    this.ruler.push(ex[e][0], ex[e][1]);
  this.ruler2 = new Xr();
  for (let e = 0; e < tx.length; e++)
    this.ruler2.push(tx[e][0], tx[e][1]);
}
Vp.prototype.skipToken = function(e) {
  const t = e.pos, n = this.ruler.getRules(""), r = n.length, i = e.md.options.maxNesting, o = e.cache;
  if (typeof o[t] < "u") {
    e.pos = o[t];
    return;
  }
  let a = !1;
  if (e.level < i) {
    for (let s = 0; s < r; s++)
      if (e.level++, a = n[s](e, !0), e.level--, a) {
        if (t >= e.pos)
          throw new Error("inline rule didn't increment state.pos");
        break;
      }
  } else
    e.pos = e.posMax;
  a || e.pos++, o[t] = e.pos;
};
Vp.prototype.tokenize = function(e) {
  const t = this.ruler.getRules(""), n = t.length, r = e.posMax, i = e.md.options.maxNesting;
  for (; e.pos < r; ) {
    const o = e.pos;
    let a = !1;
    if (e.level < i) {
      for (let s = 0; s < n; s++)
        if (a = t[s](e, !1), a) {
          if (o >= e.pos)
            throw new Error("inline rule didn't increment state.pos");
          break;
        }
    }
    if (a) {
      if (e.pos >= r)
        break;
      continue;
    }
    e.pending += e.src[e.pos++];
  }
  e.pending && e.pushPending();
};
Vp.prototype.parse = function(e, t, n, r) {
  const i = new this.State(e, t, n, r);
  this.tokenize(i);
  const o = this.ruler2.getRules(""), a = o.length;
  for (let s = 0; s < a; s++)
    o[s](i);
};
Vp.prototype.State = jp;
function KZe(e) {
  const t = {};
  e = e || {}, t.src_Any = ute.source, t.src_Cc = cte.source, t.src_Z = fte.source, t.src_P = iE.source, t.src_ZPCc = [t.src_Z, t.src_P, t.src_Cc].join("|"), t.src_ZCc = [t.src_Z, t.src_Cc].join("|");
  const n = "[><｜]";
  return t.src_pseudo_letter = "(?:(?!" + n + "|" + t.src_ZPCc + ")" + t.src_Any + ")", t.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", t.src_auth = "(?:(?:(?!" + t.src_ZCc + "|[@/\\[\\]()]).)+@)?", t.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", t.src_host_terminator = "(?=$|" + n + "|" + t.src_ZPCc + ")(?!" + (e["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + t.src_ZPCc + "))", t.src_path = "(?:[/?#](?:(?!" + t.src_ZCc + "|" + n + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + t.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + t.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + t.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + t.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + t.src_ZCc + "|[']).)+\\'|\\'(?=" + t.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + t.src_ZCc + "|[.]|$)|" + (e["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + // allow `,,,` in paths
  ",(?!" + t.src_ZCc + "|$)|;(?!" + t.src_ZCc + "|$)|\\!+(?!" + t.src_ZCc + "|[!]|$)|\\?(?!" + t.src_ZCc + "|[?]|$))+|\\/)?", t.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', t.src_xn = "xn--[a-z0-9\\-]{1,59}", t.src_domain_root = // Allow letters & digits (http://test1)
  "(?:" + t.src_xn + "|" + t.src_pseudo_letter + "{1,63})", t.src_domain = "(?:" + t.src_xn + "|(?:" + t.src_pseudo_letter + ")|(?:" + t.src_pseudo_letter + "(?:-|" + t.src_pseudo_letter + "){0,61}" + t.src_pseudo_letter + "))", t.src_host = "(?:(?:(?:(?:" + t.src_domain + ")\\.)*" + t.src_domain + "))", t.tpl_host_fuzzy = "(?:" + t.src_ip4 + "|(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%)))", t.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%))", t.src_host_strict = t.src_host + t.src_host_terminator, t.tpl_host_fuzzy_strict = t.tpl_host_fuzzy + t.src_host_terminator, t.src_host_port_strict = t.src_host + t.src_port + t.src_host_terminator, t.tpl_host_port_fuzzy_strict = t.tpl_host_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_port_no_ip_fuzzy_strict = t.tpl_host_no_ip_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + t.src_ZPCc + "|>|$))", t.tpl_email_fuzzy = "(^|" + n + '|"|\\(|' + t.src_ZCc + ")(" + t.src_email_name + "@" + t.tpl_host_fuzzy_strict + ")", t.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_fuzzy_strict + t.src_path + ")", t.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_no_ip_fuzzy_strict + t.src_path + ")", t;
}
function vw(e) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(n) {
    n && Object.keys(n).forEach(function(r) {
      e[r] = n[r];
    });
  }), e;
}
function Zv(e) {
  return Object.prototype.toString.call(e);
}
function YZe(e) {
  return Zv(e) === "[object String]";
}
function ZZe(e) {
  return Zv(e) === "[object Object]";
}
function XZe(e) {
  return Zv(e) === "[object RegExp]";
}
function WF(e) {
  return Zv(e) === "[object Function]";
}
function JZe(e) {
  return e.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
const Ste = {
  fuzzyLink: !0,
  fuzzyEmail: !0,
  fuzzyIP: !1
};
function QZe(e) {
  return Object.keys(e || {}).reduce(function(t, n) {
    return t || Ste.hasOwnProperty(n);
  }, !1);
}
const eXe = {
  "http:": {
    validate: function(e, t, n) {
      const r = e.slice(t);
      return n.re.http || (n.re.http = new RegExp(
        "^\\/\\/" + n.re.src_auth + n.re.src_host_port_strict + n.re.src_path,
        "i"
      )), n.re.http.test(r) ? r.match(n.re.http)[0].length : 0;
    }
  },
  "https:": "http:",
  "ftp:": "http:",
  "//": {
    validate: function(e, t, n) {
      const r = e.slice(t);
      return n.re.no_http || (n.re.no_http = new RegExp(
        "^" + n.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
        // with code comments
        "(?:localhost|(?:(?:" + n.re.src_domain + ")\\.)+" + n.re.src_domain_root + ")" + n.re.src_port + n.re.src_host_terminator + n.re.src_path,
        "i"
      )), n.re.no_http.test(r) ? t >= 3 && e[t - 3] === ":" || t >= 3 && e[t - 3] === "/" ? 0 : r.match(n.re.no_http)[0].length : 0;
    }
  },
  "mailto:": {
    validate: function(e, t, n) {
      const r = e.slice(t);
      return n.re.mailto || (n.re.mailto = new RegExp(
        "^" + n.re.src_email_name + "@" + n.re.src_host_strict,
        "i"
      )), n.re.mailto.test(r) ? r.match(n.re.mailto)[0].length : 0;
    }
  }
}, tXe = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", nXe = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
function rXe(e) {
  e.__index__ = -1, e.__text_cache__ = "";
}
function iXe(e) {
  return function(t, n) {
    const r = t.slice(n);
    return e.test(r) ? r.match(e)[0].length : 0;
  };
}
function HF() {
  return function(e, t) {
    t.normalize(e);
  };
}
function Rg(e) {
  const t = e.re = KZe(e.__opts__), n = e.__tlds__.slice();
  e.onCompile(), e.__tlds_replaced__ || n.push(tXe), n.push(t.src_xn), t.src_tlds = n.join("|");
  function r(s) {
    return s.replace("%TLDS%", t.src_tlds);
  }
  t.email_fuzzy = RegExp(r(t.tpl_email_fuzzy), "i"), t.link_fuzzy = RegExp(r(t.tpl_link_fuzzy), "i"), t.link_no_ip_fuzzy = RegExp(r(t.tpl_link_no_ip_fuzzy), "i"), t.host_fuzzy_test = RegExp(r(t.tpl_host_fuzzy_test), "i");
  const i = [];
  e.__compiled__ = {};
  function o(s, l) {
    throw new Error('(LinkifyIt) Invalid schema "' + s + '": ' + l);
  }
  Object.keys(e.__schemas__).forEach(function(s) {
    const l = e.__schemas__[s];
    if (l === null)
      return;
    const u = { validate: null, link: null };
    if (e.__compiled__[s] = u, ZZe(l)) {
      XZe(l.validate) ? u.validate = iXe(l.validate) : WF(l.validate) ? u.validate = l.validate : o(s, l), WF(l.normalize) ? u.normalize = l.normalize : l.normalize ? o(s, l) : u.normalize = HF();
      return;
    }
    if (YZe(l)) {
      i.push(s);
      return;
    }
    o(s, l);
  }), i.forEach(function(s) {
    e.__compiled__[e.__schemas__[s]] && (e.__compiled__[s].validate = e.__compiled__[e.__schemas__[s]].validate, e.__compiled__[s].normalize = e.__compiled__[e.__schemas__[s]].normalize);
  }), e.__compiled__[""] = { validate: null, normalize: HF() };
  const a = Object.keys(e.__compiled__).filter(function(s) {
    return s.length > 0 && e.__compiled__[s];
  }).map(JZe).join("|");
  e.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + a + ")", "i"), e.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + a + ")", "ig"), e.re.schema_at_start = RegExp("^" + e.re.schema_search.source, "i"), e.re.pretest = RegExp(
    "(" + e.re.schema_test.source + ")|(" + e.re.host_fuzzy_test.source + ")|@",
    "i"
  ), rXe(e);
}
function oXe(e, t) {
  const n = e.__index__, r = e.__last_index__, i = e.__text_cache__.slice(n, r);
  this.schema = e.__schema__.toLowerCase(), this.index = n + t, this.lastIndex = r + t, this.raw = i, this.text = i, this.url = i;
}
function yw(e, t) {
  const n = new oXe(e, t);
  return e.__compiled__[n.schema].normalize(n, e), n;
}
function gi(e, t) {
  if (!(this instanceof gi))
    return new gi(e, t);
  t || QZe(e) && (t = e, e = {}), this.__opts__ = vw({}, Ste, t), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = vw({}, eXe, e), this.__compiled__ = {}, this.__tlds__ = nXe, this.__tlds_replaced__ = !1, this.re = {}, Rg(this);
}
gi.prototype.add = function(t, n) {
  return this.__schemas__[t] = n, Rg(this), this;
};
gi.prototype.set = function(t) {
  return this.__opts__ = vw(this.__opts__, t), this;
};
gi.prototype.test = function(t) {
  if (this.__text_cache__ = t, this.__index__ = -1, !t.length)
    return !1;
  let n, r, i, o, a, s, l, u, c;
  if (this.re.schema_test.test(t)) {
    for (l = this.re.schema_search, l.lastIndex = 0; (n = l.exec(t)) !== null; )
      if (o = this.testSchemaAt(t, n[2], l.lastIndex), o) {
        this.__schema__ = n[2], this.__index__ = n.index + n[1].length, this.__last_index__ = n.index + n[0].length + o;
        break;
      }
  }
  return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (u = t.search(this.re.host_fuzzy_test), u >= 0 && (this.__index__ < 0 || u < this.__index__) && (r = t.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (a = r.index + r[1].length, (this.__index__ < 0 || a < this.__index__) && (this.__schema__ = "", this.__index__ = a, this.__last_index__ = r.index + r[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (c = t.indexOf("@"), c >= 0 && (i = t.match(this.re.email_fuzzy)) !== null && (a = i.index + i[1].length, s = i.index + i[0].length, (this.__index__ < 0 || a < this.__index__ || a === this.__index__ && s > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = a, this.__last_index__ = s))), this.__index__ >= 0;
};
gi.prototype.pretest = function(t) {
  return this.re.pretest.test(t);
};
gi.prototype.testSchemaAt = function(t, n, r) {
  return this.__compiled__[n.toLowerCase()] ? this.__compiled__[n.toLowerCase()].validate(t, r, this) : 0;
};
gi.prototype.match = function(t) {
  const n = [];
  let r = 0;
  this.__index__ >= 0 && this.__text_cache__ === t && (n.push(yw(this, r)), r = this.__last_index__);
  let i = r ? t.slice(r) : t;
  for (; this.test(i); )
    n.push(yw(this, r)), i = i.slice(this.__last_index__), r += this.__last_index__;
  return n.length ? n : null;
};
gi.prototype.matchAtStart = function(t) {
  if (this.__text_cache__ = t, this.__index__ = -1, !t.length) return null;
  const n = this.re.schema_at_start.exec(t);
  if (!n) return null;
  const r = this.testSchemaAt(t, n[2], n[0].length);
  return r ? (this.__schema__ = n[2], this.__index__ = n.index + n[1].length, this.__last_index__ = n.index + n[0].length + r, yw(this, 0)) : null;
};
gi.prototype.tlds = function(t, n) {
  return t = Array.isArray(t) ? t : [t], n ? (this.__tlds__ = this.__tlds__.concat(t).sort().filter(function(r, i, o) {
    return r !== o[i - 1];
  }).reverse(), Rg(this), this) : (this.__tlds__ = t.slice(), this.__tlds_replaced__ = !0, Rg(this), this);
};
gi.prototype.normalize = function(t) {
  t.schema || (t.url = "http://" + t.url), t.schema === "mailto:" && !/^mailto:/i.test(t.url) && (t.url = "mailto:" + t.url);
};
gi.prototype.onCompile = function() {
};
const Ec = 2147483647, $o = 36, uE = 1, Qh = 26, aXe = 38, sXe = 700, _te = 72, Ete = 128, Nte = "-", lXe = /^xn--/, uXe = /[^\0-\x7F]/, cXe = /[\x2E\u3002\uFF0E\uFF61]/g, dXe = {
  overflow: "Overflow: input needs wider integers to process",
  "not-basic": "Illegal input >= 0x80 (not a basic code point)",
  "invalid-input": "Invalid input"
}, nx = $o - uE, Lo = Math.floor, rx = String.fromCharCode;
function ws(e) {
  throw new RangeError(dXe[e]);
}
function fXe(e, t) {
  const n = [];
  let r = e.length;
  for (; r--; )
    n[r] = t(e[r]);
  return n;
}
function Ate(e, t) {
  const n = e.split("@");
  let r = "";
  n.length > 1 && (r = n[0] + "@", e = n[1]), e = e.replace(cXe, ".");
  const i = e.split("."), o = fXe(i, t).join(".");
  return r + o;
}
function Ote(e) {
  const t = [];
  let n = 0;
  const r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n++);
    if (i >= 55296 && i <= 56319 && n < r) {
      const o = e.charCodeAt(n++);
      (o & 64512) == 56320 ? t.push(((i & 1023) << 10) + (o & 1023) + 65536) : (t.push(i), n--);
    } else
      t.push(i);
  }
  return t;
}
const hXe = (e) => String.fromCodePoint(...e), pXe = function(e) {
  return e >= 48 && e < 58 ? 26 + (e - 48) : e >= 65 && e < 91 ? e - 65 : e >= 97 && e < 123 ? e - 97 : $o;
}, UF = function(e, t) {
  return e + 22 + 75 * (e < 26) - ((t != 0) << 5);
}, kte = function(e, t, n) {
  let r = 0;
  for (e = n ? Lo(e / sXe) : e >> 1, e += Lo(e / t); e > nx * Qh >> 1; r += $o)
    e = Lo(e / nx);
  return Lo(r + (nx + 1) * e / (e + aXe));
}, Pte = function(e) {
  const t = [], n = e.length;
  let r = 0, i = Ete, o = _te, a = e.lastIndexOf(Nte);
  a < 0 && (a = 0);
  for (let s = 0; s < a; ++s)
    e.charCodeAt(s) >= 128 && ws("not-basic"), t.push(e.charCodeAt(s));
  for (let s = a > 0 ? a + 1 : 0; s < n; ) {
    const l = r;
    for (let c = 1, f = $o; ; f += $o) {
      s >= n && ws("invalid-input");
      const h = pXe(e.charCodeAt(s++));
      h >= $o && ws("invalid-input"), h > Lo((Ec - r) / c) && ws("overflow"), r += h * c;
      const m = f <= o ? uE : f >= o + Qh ? Qh : f - o;
      if (h < m)
        break;
      const v = $o - m;
      c > Lo(Ec / v) && ws("overflow"), c *= v;
    }
    const u = t.length + 1;
    o = kte(r - l, u, l == 0), Lo(r / u) > Ec - i && ws("overflow"), i += Lo(r / u), r %= u, t.splice(r++, 0, i);
  }
  return String.fromCodePoint(...t);
}, Tte = function(e) {
  const t = [];
  e = Ote(e);
  const n = e.length;
  let r = Ete, i = 0, o = _te;
  for (const l of e)
    l < 128 && t.push(rx(l));
  const a = t.length;
  let s = a;
  for (a && t.push(Nte); s < n; ) {
    let l = Ec;
    for (const c of e)
      c >= r && c < l && (l = c);
    const u = s + 1;
    l - r > Lo((Ec - i) / u) && ws("overflow"), i += (l - r) * u, r = l;
    for (const c of e)
      if (c < r && ++i > Ec && ws("overflow"), c === r) {
        let f = i;
        for (let h = $o; ; h += $o) {
          const m = h <= o ? uE : h >= o + Qh ? Qh : h - o;
          if (f < m)
            break;
          const v = f - m, g = $o - m;
          t.push(
            rx(UF(m + v % g, 0))
          ), f = Lo(v / g);
        }
        t.push(rx(UF(f, 0))), o = kte(i, u, s === a), i = 0, ++s;
      }
    ++i, ++r;
  }
  return t.join("");
}, mXe = function(e) {
  return Ate(e, function(t) {
    return lXe.test(t) ? Pte(t.slice(4).toLowerCase()) : t;
  });
}, gXe = function(e) {
  return Ate(e, function(t) {
    return uXe.test(t) ? "xn--" + Tte(t) : t;
  });
}, Mte = {
  /**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
  version: "2.3.1",
  /**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
  ucs2: {
    decode: Ote,
    encode: hXe
  },
  decode: Pte,
  encode: Tte,
  toASCII: gXe,
  toUnicode: mXe
}, vXe = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 100
  },
  components: {
    core: {},
    block: {},
    inline: {}
  }
}, yXe = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "text"
      ],
      rules2: [
        "balance_pairs",
        "fragments_join"
      ]
    }
  }
}, bXe = {
  options: {
    // Enable HTML tags in source
    html: !0,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !0,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "blockquote",
        "code",
        "fence",
        "heading",
        "hr",
        "html_block",
        "lheading",
        "list",
        "reference",
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "autolink",
        "backticks",
        "emphasis",
        "entity",
        "escape",
        "html_inline",
        "image",
        "link",
        "newline",
        "text"
      ],
      rules2: [
        "balance_pairs",
        "emphasis",
        "fragments_join"
      ]
    }
  }
}, xXe = {
  default: vXe,
  zero: yXe,
  commonmark: bXe
}, wXe = /^(vbscript|javascript|file|data):/, CXe = /^data:image\/(gif|png|jpeg|webp);/;
function SXe(e) {
  const t = e.trim().toLowerCase();
  return wXe.test(t) ? CXe.test(t) : !0;
}
const Rte = ["http:", "https:", "mailto:"];
function _Xe(e) {
  const t = rE(e, !0);
  if (t.hostname && (!t.protocol || Rte.indexOf(t.protocol) >= 0))
    try {
      t.hostname = Mte.toASCII(t.hostname);
    } catch {
    }
  return Bp(nE(t));
}
function EXe(e) {
  const t = rE(e, !0);
  if (t.hostname && (!t.protocol || Rte.indexOf(t.protocol) >= 0))
    try {
      t.hostname = Mte.toUnicode(t.hostname);
    } catch {
    }
  return pd(nE(t), pd.defaultChars + "%");
}
function Jr(e, t) {
  if (!(this instanceof Jr))
    return new Jr(e, t);
  t || oE(e) || (t = e || {}, e = "default"), this.inline = new Vp(), this.block = new Yv(), this.core = new sE(), this.renderer = new Vd(), this.linkify = new gi(), this.validateLink = SXe, this.normalizeLink = _Xe, this.normalizeLinkText = EXe, this.utils = AYe, this.helpers = Gv({}, TYe), this.options = {}, this.configure(e), t && this.set(t);
}
Jr.prototype.set = function(e) {
  return Gv(this.options, e), this;
};
Jr.prototype.configure = function(e) {
  const t = this;
  if (oE(e)) {
    const n = e;
    if (e = xXe[n], !e)
      throw new Error('Wrong `markdown-it` preset "' + n + '", check name');
  }
  if (!e)
    throw new Error("Wrong `markdown-it` preset, can't be empty");
  return e.options && t.set(e.options), e.components && Object.keys(e.components).forEach(function(n) {
    e.components[n].rules && t[n].ruler.enableOnly(e.components[n].rules), e.components[n].rules2 && t[n].ruler2.enableOnly(e.components[n].rules2);
  }), this;
};
Jr.prototype.enable = function(e, t) {
  let n = [];
  Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function(i) {
    n = n.concat(this[i].ruler.enable(e, !0));
  }, this), n = n.concat(this.inline.ruler2.enable(e, !0));
  const r = e.filter(function(i) {
    return n.indexOf(i) < 0;
  });
  if (r.length && !t)
    throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + r);
  return this;
};
Jr.prototype.disable = function(e, t) {
  let n = [];
  Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function(i) {
    n = n.concat(this[i].ruler.disable(e, !0));
  }, this), n = n.concat(this.inline.ruler2.disable(e, !0));
  const r = e.filter(function(i) {
    return n.indexOf(i) < 0;
  });
  if (r.length && !t)
    throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + r);
  return this;
};
Jr.prototype.use = function(e) {
  const t = [this].concat(Array.prototype.slice.call(arguments, 1));
  return e.apply(e, t), this;
};
Jr.prototype.parse = function(e, t) {
  if (typeof e != "string")
    throw new Error("Input data should be a String");
  const n = new this.core.State(e, this, t);
  return this.core.process(n), n.tokens;
};
Jr.prototype.render = function(e, t) {
  return t = t || {}, this.renderer.render(this.parse(e, t), this.options, t);
};
Jr.prototype.parseInline = function(e, t) {
  const n = new this.core.State(e, this, t);
  return n.inlineMode = !0, this.core.process(n), n.tokens;
};
Jr.prototype.renderInline = function(e, t) {
  return t = t || {}, this.renderer.render(this.parseInline(e, t), this.options, t);
};
const NXe = new T_({
  nodes: {
    doc: {
      content: "block+"
    },
    paragraph: {
      content: "inline*",
      group: "block",
      parseDOM: [{ tag: "p" }],
      toDOM() {
        return ["p", 0];
      }
    },
    blockquote: {
      content: "block+",
      group: "block",
      parseDOM: [{ tag: "blockquote" }],
      toDOM() {
        return ["blockquote", 0];
      }
    },
    horizontal_rule: {
      group: "block",
      parseDOM: [{ tag: "hr" }],
      toDOM() {
        return ["div", ["hr"]];
      }
    },
    heading: {
      attrs: { level: { default: 1 } },
      content: "(text | image)*",
      group: "block",
      defining: !0,
      parseDOM: [
        { tag: "h1", attrs: { level: 1 } },
        { tag: "h2", attrs: { level: 2 } },
        { tag: "h3", attrs: { level: 3 } },
        { tag: "h4", attrs: { level: 4 } },
        { tag: "h5", attrs: { level: 5 } },
        { tag: "h6", attrs: { level: 6 } }
      ],
      toDOM(e) {
        return ["h" + e.attrs.level, 0];
      }
    },
    code_block: {
      content: "text*",
      group: "block",
      code: !0,
      defining: !0,
      marks: "",
      attrs: { params: { default: "" } },
      parseDOM: [{ tag: "pre", preserveWhitespace: "full", getAttrs: (e) => ({ params: e.getAttribute("data-params") || "" }) }],
      toDOM(e) {
        return ["pre", e.attrs.params ? { "data-params": e.attrs.params } : {}, ["code", 0]];
      }
    },
    ordered_list: {
      content: "list_item+",
      group: "block",
      attrs: { order: { default: 1 }, tight: { default: !1 } },
      parseDOM: [{ tag: "ol", getAttrs(e) {
        return {
          order: e.hasAttribute("start") ? +e.getAttribute("start") : 1,
          tight: e.hasAttribute("data-tight")
        };
      } }],
      toDOM(e) {
        return ["ol", {
          start: e.attrs.order == 1 ? null : e.attrs.order,
          "data-tight": e.attrs.tight ? "true" : null
        }, 0];
      }
    },
    bullet_list: {
      content: "list_item+",
      group: "block",
      attrs: { tight: { default: !1 } },
      parseDOM: [{ tag: "ul", getAttrs: (e) => ({ tight: e.hasAttribute("data-tight") }) }],
      toDOM(e) {
        return ["ul", { "data-tight": e.attrs.tight ? "true" : null }, 0];
      }
    },
    list_item: {
      content: "block+",
      defining: !0,
      parseDOM: [{ tag: "li" }],
      toDOM() {
        return ["li", 0];
      }
    },
    text: {
      group: "inline"
    },
    image: {
      inline: !0,
      attrs: {
        src: {},
        alt: { default: null },
        title: { default: null }
      },
      group: "inline",
      draggable: !0,
      parseDOM: [{ tag: "img[src]", getAttrs(e) {
        return {
          src: e.getAttribute("src"),
          title: e.getAttribute("title"),
          alt: e.getAttribute("alt")
        };
      } }],
      toDOM(e) {
        return ["img", e.attrs];
      }
    },
    hard_break: {
      inline: !0,
      group: "inline",
      selectable: !1,
      parseDOM: [{ tag: "br" }],
      toDOM() {
        return ["br"];
      }
    }
  },
  marks: {
    em: {
      parseDOM: [
        { tag: "i" },
        { tag: "em" },
        { style: "font-style=italic" },
        { style: "font-style=normal", clearMark: (e) => e.type.name == "em" }
      ],
      toDOM() {
        return ["em"];
      }
    },
    strong: {
      parseDOM: [
        { tag: "strong" },
        { tag: "b", getAttrs: (e) => e.style.fontWeight != "normal" && null },
        { style: "font-weight=400", clearMark: (e) => e.type.name == "strong" },
        { style: "font-weight", getAttrs: (e) => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null }
      ],
      toDOM() {
        return ["strong"];
      }
    },
    link: {
      attrs: {
        href: {},
        title: { default: null }
      },
      inclusive: !1,
      parseDOM: [{ tag: "a[href]", getAttrs(e) {
        return { href: e.getAttribute("href"), title: e.getAttribute("title") };
      } }],
      toDOM(e) {
        return ["a", e.attrs];
      }
    },
    code: {
      parseDOM: [{ tag: "code" }],
      toDOM() {
        return ["code"];
      }
    }
  }
});
function AXe(e, t) {
  if (e.isText && t.isText && Ot.sameSet(e.marks, t.marks))
    return e.withText(e.text + t.text);
}
class OXe {
  constructor(t, n) {
    this.schema = t, this.tokenHandlers = n, this.stack = [{ type: t.topNodeType, attrs: null, content: [], marks: Ot.none }];
  }
  top() {
    return this.stack[this.stack.length - 1];
  }
  push(t) {
    this.stack.length && this.top().content.push(t);
  }
  // Adds the given text to the current position in the document,
  // using the current marks as styling.
  addText(t) {
    if (!t)
      return;
    let n = this.top(), r = n.content, i = r[r.length - 1], o = this.schema.text(t, n.marks), a;
    i && (a = AXe(i, o)) ? r[r.length - 1] = a : r.push(o);
  }
  // Adds the given mark to the set of active marks.
  openMark(t) {
    let n = this.top();
    n.marks = t.addToSet(n.marks);
  }
  // Removes the given mark from the set of active marks.
  closeMark(t) {
    let n = this.top();
    n.marks = t.removeFromSet(n.marks);
  }
  parseTokens(t) {
    for (let n = 0; n < t.length; n++) {
      let r = t[n], i = this.tokenHandlers[r.type];
      if (!i)
        throw new Error("Token type `" + r.type + "` not supported by Markdown parser");
      i(this, r, t, n);
    }
  }
  // Add a node at the current position.
  addNode(t, n, r) {
    let i = this.top(), o = t.createAndFill(n, r, i ? i.marks : []);
    return o ? (this.push(o), o) : null;
  }
  // Wrap subsequent content in a node of the given type.
  openNode(t, n) {
    this.stack.push({ type: t, attrs: n, content: [], marks: Ot.none });
  }
  // Close and return the node that is currently on top of the stack.
  closeNode() {
    let t = this.stack.pop();
    return this.addNode(t.type, t.attrs, t.content);
  }
}
function _f(e, t, n, r) {
  return e.getAttrs ? e.getAttrs(t, n, r) : e.attrs instanceof Function ? e.attrs(t) : e.attrs;
}
function ix(e, t) {
  return e.noCloseToken || t == "code_inline" || t == "code_block" || t == "fence";
}
function GF(e) {
  return e[e.length - 1] == `
` ? e.slice(0, e.length - 1) : e;
}
function ox() {
}
function kXe(e, t) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let r in t) {
    let i = t[r];
    if (i.block) {
      let o = e.nodeType(i.block);
      ix(i, r) ? n[r] = (a, s, l, u) => {
        a.openNode(o, _f(i, s, l, u)), a.addText(GF(s.content)), a.closeNode();
      } : (n[r + "_open"] = (a, s, l, u) => a.openNode(o, _f(i, s, l, u)), n[r + "_close"] = (a) => a.closeNode());
    } else if (i.node) {
      let o = e.nodeType(i.node);
      n[r] = (a, s, l, u) => a.addNode(o, _f(i, s, l, u));
    } else if (i.mark) {
      let o = e.marks[i.mark];
      ix(i, r) ? n[r] = (a, s, l, u) => {
        a.openMark(o.create(_f(i, s, l, u))), a.addText(GF(s.content)), a.closeMark(o);
      } : (n[r + "_open"] = (a, s, l, u) => a.openMark(o.create(_f(i, s, l, u))), n[r + "_close"] = (a) => a.closeMark(o));
    } else if (i.ignore)
      ix(i, r) ? n[r] = ox : (n[r + "_open"] = ox, n[r + "_close"] = ox);
    else
      throw new RangeError("Unrecognized parsing spec " + JSON.stringify(i));
  }
  return n.text = (r, i) => r.addText(i.content), n.inline = (r, i) => r.parseTokens(i.children), n.softbreak = n.softbreak || ((r) => r.addText(" ")), n;
}
let PXe = class {
  /**
  Create a parser with the given configuration. You can configure
  the markdown-it parser to parse the dialect you want, and provide
  a description of the ProseMirror entities those tokens map to in
  the `tokens` object, which maps token names to descriptions of
  what to do with them. Such a description is an object, and may
  have the following properties:
  */
  constructor(t, n, r) {
    this.schema = t, this.tokenizer = n, this.tokens = r, this.tokenHandlers = kXe(t, r);
  }
  /**
  Parse a string as [CommonMark](http://commonmark.org/) markup,
  and create a ProseMirror document as prescribed by this parser's
  rules.
  
  The second argument, when given, is passed through to the
  [Markdown
  parser](https://markdown-it.github.io/markdown-it/#MarkdownIt.parse).
  */
  parse(t, n = {}) {
    let r = new OXe(this.schema, this.tokenHandlers), i;
    r.parseTokens(this.tokenizer.parse(t, n));
    do
      i = r.closeNode();
    while (r.stack.length);
    return i || this.schema.topNodeType.createAndFill();
  }
};
function KF(e, t) {
  for (; ++t < e.length; )
    if (e[t].type != "list_item_open")
      return e[t].hidden;
  return !1;
}
new PXe(NXe, Jr("commonmark", { html: !1 }), {
  blockquote: { block: "blockquote" },
  paragraph: { block: "paragraph" },
  list_item: { block: "list_item" },
  bullet_list: { block: "bullet_list", getAttrs: (e, t, n) => ({ tight: KF(t, n) }) },
  ordered_list: { block: "ordered_list", getAttrs: (e, t, n) => ({
    order: +e.attrGet("start") || 1,
    tight: KF(t, n)
  }) },
  heading: { block: "heading", getAttrs: (e) => ({ level: +e.tag.slice(1) }) },
  code_block: { block: "code_block", noCloseToken: !0 },
  fence: { block: "code_block", getAttrs: (e) => ({ params: e.info || "" }), noCloseToken: !0 },
  hr: { node: "horizontal_rule" },
  image: { node: "image", getAttrs: (e) => ({
    src: e.attrGet("src"),
    title: e.attrGet("title") || null,
    alt: e.children[0] && e.children[0].content || null
  }) },
  hardbreak: { node: "hard_break" },
  em: { mark: "em" },
  strong: { mark: "strong" },
  link: { mark: "link", getAttrs: (e) => ({
    href: e.attrGet("href"),
    title: e.attrGet("title") || null
  }) },
  code_inline: { mark: "code", noCloseToken: !0 }
});
const TXe = { open: "", close: "", mixable: !0 };
let MXe = class {
  /**
  Construct a serializer with the given configuration. The `nodes`
  object should map node names in a given schema to function that
  take a serializer state and such a node, and serialize the node.
  */
  constructor(t, n, r = {}) {
    this.nodes = t, this.marks = n, this.options = r;
  }
  /**
  Serialize the content of the given node to
  [CommonMark](http://commonmark.org/).
  */
  serialize(t, n = {}) {
    n = Object.assign({}, this.options, n);
    let r = new Dte(this.nodes, this.marks, n);
    return r.renderContent(t), r.out;
  }
};
const aa = new MXe({
  blockquote(e, t) {
    e.wrapBlock("> ", null, t, () => e.renderContent(t));
  },
  code_block(e, t) {
    const n = t.textContent.match(/`{3,}/gm), r = n ? n.sort().slice(-1)[0] + "`" : "```";
    e.write(r + (t.attrs.params || "") + `
`), e.text(t.textContent, !1), e.write(`
`), e.write(r), e.closeBlock(t);
  },
  heading(e, t) {
    e.write(e.repeat("#", t.attrs.level) + " "), e.renderInline(t, !1), e.closeBlock(t);
  },
  horizontal_rule(e, t) {
    e.write(t.attrs.markup || "---"), e.closeBlock(t);
  },
  bullet_list(e, t) {
    e.renderList(t, "  ", () => (t.attrs.bullet || "*") + " ");
  },
  ordered_list(e, t) {
    let n = t.attrs.order || 1, r = String(n + t.childCount - 1).length, i = e.repeat(" ", r + 2);
    e.renderList(t, i, (o) => {
      let a = String(n + o);
      return e.repeat(" ", r - a.length) + a + ". ";
    });
  },
  list_item(e, t) {
    e.renderContent(t);
  },
  paragraph(e, t) {
    e.renderInline(t), e.closeBlock(t);
  },
  image(e, t) {
    e.write("![" + e.esc(t.attrs.alt || "") + "](" + t.attrs.src.replace(/[\(\)]/g, "\\$&") + (t.attrs.title ? ' "' + t.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
  },
  hard_break(e, t, n, r) {
    for (let i = r + 1; i < n.childCount; i++)
      if (n.child(i).type != t.type) {
        e.write(`\\
`);
        return;
      }
  },
  text(e, t) {
    e.text(t.text, !e.inAutolink);
  }
}, {
  em: { open: "*", close: "*", mixable: !0, expelEnclosingWhitespace: !0 },
  strong: { open: "**", close: "**", mixable: !0, expelEnclosingWhitespace: !0 },
  link: {
    open(e, t, n, r) {
      return e.inAutolink = RXe(t, n, r), e.inAutolink ? "<" : "[";
    },
    close(e, t, n, r) {
      let { inAutolink: i } = e;
      return e.inAutolink = void 0, i ? ">" : "](" + t.attrs.href.replace(/[\(\)"]/g, "\\$&") + (t.attrs.title ? ` "${t.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
    },
    mixable: !0
  },
  code: {
    open(e, t, n, r) {
      return YF(n.child(r), -1);
    },
    close(e, t, n, r) {
      return YF(n.child(r - 1), 1);
    },
    escape: !1
  }
});
function YF(e, t) {
  let n = /`+/g, r, i = 0;
  if (e.isText)
    for (; r = n.exec(e.text); )
      i = Math.max(i, r[0].length);
  let o = i > 0 && t > 0 ? " `" : "`";
  for (let a = 0; a < i; a++)
    o += "`";
  return i > 0 && t < 0 && (o += " "), o;
}
function RXe(e, t, n) {
  if (e.attrs.title || !/^\w+:/.test(e.attrs.href))
    return !1;
  let r = t.child(n);
  return !r.isText || r.text != e.attrs.href || r.marks[r.marks.length - 1] != e ? !1 : n == t.childCount - 1 || !e.isInSet(t.child(n + 1).marks);
}
let Dte = class {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.nodes = t, this.marks = n, this.options = r, this.delim = "", this.out = "", this.closed = null, this.inAutolink = void 0, this.atBlockStart = !1, this.inTightList = !1, typeof this.options.tightLists > "u" && (this.options.tightLists = !1), typeof this.options.hardBreakNodeName > "u" && (this.options.hardBreakNodeName = "hard_break");
  }
  /**
  @internal
  */
  flushClose(t = 2) {
    if (this.closed) {
      if (this.atBlank() || (this.out += `
`), t > 1) {
        let n = this.delim, r = /\s+$/.exec(n);
        r && (n = n.slice(0, n.length - r[0].length));
        for (let i = 1; i < t; i++)
          this.out += n + `
`;
      }
      this.closed = null;
    }
  }
  /**
  @internal
  */
  getMark(t) {
    let n = this.marks[t];
    if (!n) {
      if (this.options.strict !== !1)
        throw new Error(`Mark type \`${t}\` not supported by Markdown renderer`);
      n = TXe;
    }
    return n;
  }
  /**
  Render a block, prefixing each line with `delim`, and the first
  line in `firstDelim`. `node` should be the node that is closed at
  the end of the block, and `f` is a function that renders the
  content of the block.
  */
  wrapBlock(t, n, r, i) {
    let o = this.delim;
    this.write(n ?? t), this.delim += t, i(), this.delim = o, this.closeBlock(r);
  }
  /**
  @internal
  */
  atBlank() {
    return /(^|\n)$/.test(this.out);
  }
  /**
  Ensure the current content ends with a newline.
  */
  ensureNewLine() {
    this.atBlank() || (this.out += `
`);
  }
  /**
  Prepare the state for writing output (closing closed paragraphs,
  adding delimiters, and so on), and then optionally add content
  (unescaped) to the output.
  */
  write(t) {
    this.flushClose(), this.delim && this.atBlank() && (this.out += this.delim), t && (this.out += t);
  }
  /**
  Close the block for the given node.
  */
  closeBlock(t) {
    this.closed = t;
  }
  /**
  Add the given text to the document. When escape is not `false`,
  it will be escaped.
  */
  text(t, n = !0) {
    let r = t.split(`
`);
    for (let i = 0; i < r.length; i++)
      this.write(), !n && r[i][0] == "[" && /(^|[^\\])\!$/.test(this.out) && (this.out = this.out.slice(0, this.out.length - 1) + "\\!"), this.out += n ? this.esc(r[i], this.atBlockStart) : r[i], i != r.length - 1 && (this.out += `
`);
  }
  /**
  Render the given node as a block.
  */
  render(t, n, r) {
    if (this.nodes[t.type.name])
      this.nodes[t.type.name](this, t, n, r);
    else {
      if (this.options.strict !== !1)
        throw new Error("Token type `" + t.type.name + "` not supported by Markdown renderer");
      t.type.isLeaf || (t.type.inlineContent ? this.renderInline(t) : this.renderContent(t), t.isBlock && this.closeBlock(t));
    }
  }
  /**
  Render the contents of `parent` as block nodes.
  */
  renderContent(t) {
    t.forEach((n, r, i) => this.render(n, t, i));
  }
  /**
  Render the contents of `parent` as inline content.
  */
  renderInline(t, n = !0) {
    this.atBlockStart = n;
    let r = [], i = "", o = (a, s, l) => {
      let u = a ? a.marks : [];
      a && a.type.name === this.options.hardBreakNodeName && (u = u.filter((g) => {
        if (l + 1 == t.childCount)
          return !1;
        let y = t.child(l + 1);
        return g.isInSet(y.marks) && (!y.isText || /\S/.test(y.text));
      }));
      let c = i;
      if (i = "", a && a.isText && u.some((g) => {
        let y = this.getMark(g.type.name);
        return y && y.expelEnclosingWhitespace && !g.isInSet(r);
      })) {
        let [g, y, w] = /^(\s*)(.*)$/m.exec(a.text);
        y && (c += y, a = w ? a.withText(w) : null, a || (u = r));
      }
      if (a && a.isText && u.some((g) => {
        let y = this.getMark(g.type.name);
        return y && y.expelEnclosingWhitespace && (l == t.childCount - 1 || !g.isInSet(t.child(l + 1).marks));
      })) {
        let [g, y, w] = /^(.*?)(\s*)$/m.exec(a.text);
        w && (i = w, a = y ? a.withText(y) : null, a || (u = r));
      }
      let f = u.length ? u[u.length - 1] : null, h = f && this.getMark(f.type.name).escape === !1, m = u.length - (h ? 1 : 0);
      e: for (let g = 0; g < m; g++) {
        let y = u[g];
        if (!this.getMark(y.type.name).mixable)
          break;
        for (let w = 0; w < r.length; w++) {
          let C = r[w];
          if (!this.getMark(C.type.name).mixable)
            break;
          if (y.eq(C)) {
            g > w ? u = u.slice(0, w).concat(y).concat(u.slice(w, g)).concat(u.slice(g + 1, m)) : w > g && (u = u.slice(0, g).concat(u.slice(g + 1, w)).concat(y).concat(u.slice(w, m)));
            continue e;
          }
        }
      }
      let v = 0;
      for (; v < Math.min(r.length, m) && u[v].eq(r[v]); )
        ++v;
      for (; v < r.length; )
        this.text(this.markString(r.pop(), !1, t, l), !1);
      if (c && this.text(c), a) {
        for (; r.length < m; ) {
          let g = u[r.length];
          r.push(g), this.text(this.markString(g, !0, t, l), !1), this.atBlockStart = !1;
        }
        h && a.isText ? this.text(this.markString(f, !0, t, l) + a.text + this.markString(f, !1, t, l + 1), !1) : this.render(a, t, l), this.atBlockStart = !1;
      }
      a != null && a.isText && a.nodeSize > 0 && (this.atBlockStart = !1);
    };
    t.forEach(o), o(null, 0, t.childCount), this.atBlockStart = !1;
  }
  /**
  Render a node's content as a list. `delim` should be the extra
  indentation added to all lines except the first in an item,
  `firstDelim` is a function going from an item index to a
  delimiter for the first line of the item.
  */
  renderList(t, n, r) {
    this.closed && this.closed.type == t.type ? this.flushClose(3) : this.inTightList && this.flushClose(1);
    let i = typeof t.attrs.tight < "u" ? t.attrs.tight : this.options.tightLists, o = this.inTightList;
    this.inTightList = i, t.forEach((a, s, l) => {
      l && i && this.flushClose(1), this.wrapBlock(n, r(l), t, () => this.render(a, t, l));
    }), this.inTightList = o;
  }
  /**
  Escape the given string so that it can safely appear in Markdown
  content. If `startOfLine` is true, also escape characters that
  have special meaning only at the start of the line.
  */
  esc(t, n = !1) {
    return t = t.replace(/[`*\\~\[\]_]/g, (r, i) => r == "_" && i > 0 && i + 1 < t.length && t[i - 1].match(/\w/) && t[i + 1].match(/\w/) ? r : "\\" + r), n && (t = t.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, "$1\\$2$3").replace(/^(\s*\d+)\.\s/, "$1\\. ")), this.options.escapeExtraCharacters && (t = t.replace(this.options.escapeExtraCharacters, "\\$&")), t;
  }
  /**
  @internal
  */
  quote(t) {
    let n = t.indexOf('"') == -1 ? '""' : t.indexOf("'") == -1 ? "''" : "()";
    return n[0] + t + n[1];
  }
  /**
  Repeat the given string `n` times.
  */
  repeat(t, n) {
    let r = "";
    for (let i = 0; i < n; i++)
      r += t;
    return r;
  }
  /**
  Get the markdown string for a given opening or closing mark.
  */
  markString(t, n, r, i) {
    let o = this.getMark(t.type.name), a = n ? o.open : o.close;
    return typeof a == "string" ? a : a(this, t, r, i);
  }
  /**
  Get leading and trailing whitespace from a string. Values of
  leading or trailing property of the return object will be undefined
  if there is no match.
  */
  getEnclosingWhitespace(t) {
    return {
      leading: (t.match(/^(\s+)/) || [void 0])[0],
      trailing: (t.match(/(\s+)$/) || [void 0])[0]
    };
  }
};
var ax, ZF;
function DXe() {
  if (ZF) return ax;
  ZF = 1;
  var e = !0, t = !1, n = !1;
  ax = function(g, y) {
    y && (e = !y.enabled, t = !!y.label, n = !!y.labelAfter), g.core.ruler.after("inline", "github-task-lists", function(w) {
      for (var C = w.tokens, S = 2; S < C.length; S++)
        o(C, S) && (a(C[S], w.Token), r(C[S - 2], "class", "task-list-item" + (e ? "" : " enabled")), r(C[i(C, S - 2)], "class", "contains-task-list"));
    });
  };
  function r(g, y, w) {
    var C = g.attrIndex(y), S = [y, w];
    C < 0 ? g.attrPush(S) : g.attrs[C] = S;
  }
  function i(g, y) {
    for (var w = g[y].level - 1, C = y - 1; C >= 0; C--)
      if (g[C].level === w)
        return C;
    return -1;
  }
  function o(g, y) {
    return f(g[y]) && h(g[y - 1]) && m(g[y - 2]) && v(g[y]);
  }
  function a(g, y) {
    if (g.children.unshift(s(g, y)), g.children[1].content = g.children[1].content.slice(3), g.content = g.content.slice(3), t)
      if (n) {
        g.children.pop();
        var w = "task-item-" + Math.ceil(Math.random() * (1e4 * 1e3) - 1e3);
        g.children[0].content = g.children[0].content.slice(0, -1) + ' id="' + w + '">', g.children.push(c(g.content, w, y));
      } else
        g.children.unshift(l(y)), g.children.push(u(y));
  }
  function s(g, y) {
    var w = new y("html_inline", "", 0), C = e ? ' disabled="" ' : "";
    return g.content.indexOf("[ ] ") === 0 ? w.content = '<input class="task-list-item-checkbox"' + C + 'type="checkbox">' : (g.content.indexOf("[x] ") === 0 || g.content.indexOf("[X] ") === 0) && (w.content = '<input class="task-list-item-checkbox" checked=""' + C + 'type="checkbox">'), w;
  }
  function l(g) {
    var y = new g("html_inline", "", 0);
    return y.content = "<label>", y;
  }
  function u(g) {
    var y = new g("html_inline", "", 0);
    return y.content = "</label>", y;
  }
  function c(g, y, w) {
    var C = new w("html_inline", "", 0);
    return C.content = '<label class="task-list-item-label" for="' + y + '">' + g + "</label>", C.attrs = [{ for: y }], C;
  }
  function f(g) {
    return g.type === "inline";
  }
  function h(g) {
    return g.type === "paragraph_open";
  }
  function m(g) {
    return g.type === "list_item_open";
  }
  function v(g) {
    return g.content.indexOf("[ ] ") === 0 || g.content.indexOf("[x] ") === 0 || g.content.indexOf("[X] ") === 0;
  }
  return ax;
}
var IXe = DXe();
const $Xe = /* @__PURE__ */ Rt(IXe);
var LXe = Object.defineProperty, FXe = (e, t, n) => t in e ? LXe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Dg = (e, t, n) => (FXe(e, typeof t != "symbol" ? t + "" : t, n), n);
const BXe = Gn.create({
  name: "markdownTightLists",
  addOptions: () => ({
    tight: !0,
    tightClass: "tight",
    listTypes: ["bulletList", "orderedList"]
  }),
  addGlobalAttributes() {
    return [{
      types: this.options.listTypes,
      attributes: {
        tight: {
          default: this.options.tight,
          parseHTML: (e) => e.getAttribute("data-tight") === "true" || !e.querySelector("p"),
          renderHTML: (e) => ({
            class: e.tight ? this.options.tightClass : null,
            "data-tight": e.tight ? "true" : null
          })
        }
      }
    }];
  },
  addCommands() {
    var e = this;
    return {
      toggleTight: function() {
        let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        return (n) => {
          let {
            editor: r,
            commands: i
          } = n;
          function o(a) {
            if (!r.isActive(a))
              return !1;
            const s = r.getAttributes(a);
            return i.updateAttributes(a, {
              tight: t ?? !(s != null && s.tight)
            });
          }
          return e.options.listTypes.some((a) => o(a));
        };
      }
    };
  }
}), XF = Jr();
function Ite(e, t) {
  return XF.inline.State.prototype.scanDelims.call({
    src: e,
    posMax: e.length
  }), new XF.inline.State(e, null, null, []).scanDelims(t, !0);
}
function $te(e, t, n, r) {
  let i = e.substring(0, n) + e.substring(n + t.length);
  return i = i.substring(0, n + r) + t + i.substring(n + r), i;
}
function jXe(e, t, n, r) {
  let i = n, o = e;
  for (; i < r && !Ite(o, i).can_open; )
    o = $te(o, t, i, 1), i++;
  return {
    text: o,
    from: i,
    to: r
  };
}
function VXe(e, t, n, r) {
  let i = r, o = e;
  for (; i > n && !Ite(o, i).can_close; )
    o = $te(o, t, i, -1), i--;
  return {
    text: o,
    from: n,
    to: i
  };
}
function qXe(e, t, n, r) {
  let i = {
    text: e,
    from: n,
    to: r
  };
  return i = jXe(i.text, t, i.from, i.to), i = VXe(i.text, t, i.from, i.to), i.to - i.from < t.length + 1 && (i.text = i.text.substring(0, i.from) + i.text.substring(i.to + t.length)), i.text;
}
class zXe extends Dte {
  constructor(t, n, r) {
    super(t, n, r ?? {}), Dg(this, "inTable", !1), this.inlines = [];
  }
  render(t, n, r) {
    super.render(t, n, r);
    const i = this.inlines[this.inlines.length - 1];
    if (i != null && i.start && i !== null && i !== void 0 && i.end) {
      const {
        delimiter: o,
        start: a,
        end: s
      } = this.normalizeInline(i);
      this.out = qXe(this.out, o, a, s), this.inlines.pop();
    }
  }
  markString(t, n, r, i) {
    const o = this.marks[t.type.name];
    if (o.expelEnclosingWhitespace)
      if (n)
        this.inlines.push({
          start: this.out.length,
          delimiter: o.open
        });
      else {
        const a = this.inlines.pop();
        this.inlines.push({
          ...a,
          end: this.out.length
        });
      }
    return super.markString(t, n, r, i);
  }
  normalizeInline(t) {
    let {
      start: n,
      end: r
    } = t;
    for (; this.out.charAt(n).match(/\s/); )
      n++;
    return {
      ...t,
      start: n
    };
  }
}
const Lte = Zr.create({
  name: "markdownHTMLMark",
  /**
   * @return {{markdown: MarkdownMarkSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: {
          open(e, t) {
            var n, r;
            return this.editor.storage.markdown.options.html ? (n = (r = JF(t)) === null || r === void 0 ? void 0 : r[0]) !== null && n !== void 0 ? n : "" : (console.warn(`Tiptap Markdown: "${t.type.name}" mark is only available in html mode`), "");
          },
          close(e, t) {
            var n, r;
            return this.editor.storage.markdown.options.html && (n = (r = JF(t)) === null || r === void 0 ? void 0 : r[1]) !== null && n !== void 0 ? n : "";
          }
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
});
function JF(e) {
  const t = e.type.schema, n = t.text(" ", [e]), i = Q_(he.from(n), t).match(/^(<.*?>) (<\/.*?>)$/);
  return i ? [i[1], i[2]] : null;
}
function cE(e) {
  const t = `<body>${e}</body>`;
  return new window.DOMParser().parseFromString(t, "text/html").body;
}
function WXe(e) {
  return e == null ? void 0 : e.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function HXe(e) {
  const t = e.parentElement, n = t.cloneNode();
  for (; t.firstChild && t.firstChild !== e; )
    n.appendChild(t.firstChild);
  n.childNodes.length > 0 && t.parentElement.insertBefore(n, t), t.parentElement.insertBefore(e, t), t.childNodes.length === 0 && t.remove();
}
function UXe(e) {
  const t = e.parentNode;
  for (; e.firstChild; )
    t.insertBefore(e.firstChild, e);
  t.removeChild(e);
}
const Xv = Zt.create({
  name: "markdownHTMLNode",
  addStorage() {
    return {
      markdown: {
        serialize(e, t, n) {
          this.editor.storage.markdown.options.html ? e.write(GXe(t, n)) : (console.warn(`Tiptap Markdown: "${t.type.name}" node is only available in html mode`), e.write(`[${t.type.name}]`)), t.isBlock && e.closeBlock(t);
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
});
function GXe(e, t) {
  const n = e.type.schema, r = Q_(he.from(e), n);
  return e.isBlock && (t instanceof he || t.type.name === n.topNodeType.name) ? KXe(r) : r;
}
function KXe(e) {
  const n = cE(e).firstElementChild;
  return n.innerHTML = n.innerHTML.trim() ? `
${n.innerHTML}
` : `
`, n.outerHTML;
}
const YXe = Zt.create({
  name: "blockquote"
}), ZXe = YXe.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: aa.nodes.blockquote,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), XXe = Zt.create({
  name: "bulletList"
}), Fte = XXe.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(e, t) {
          return e.renderList(t, "  ", () => (this.editor.storage.markdown.options.bulletListMarker || "-") + " ");
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), JXe = Zt.create({
  name: "codeBlock"
}), QXe = JXe.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(e, t) {
          e.write("```" + (t.attrs.language || "") + `
`), e.text(t.textContent, !1), e.ensureNewLine(), e.write("```"), e.closeBlock(t);
        },
        parse: {
          setup(e) {
            var t;
            e.set({
              langPrefix: (t = this.options.languageClassPrefix) !== null && t !== void 0 ? t : "language-"
            });
          },
          updateDOM(e) {
            e.innerHTML = e.innerHTML.replace(/\n<\/code><\/pre>/g, "</code></pre>");
          }
        }
      }
    };
  }
}), eJe = Zt.create({
  name: "hardBreak"
}), Bte = eJe.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(e, t, n, r) {
          for (let i = r + 1; i < n.childCount; i++)
            if (n.child(i).type != t.type) {
              e.write(e.inTable ? Xv.storage.markdown.serialize.call(this, e, t, n) : `\\
`);
              return;
            }
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), tJe = Zt.create({
  name: "heading"
}), nJe = tJe.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: aa.nodes.heading,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), rJe = Zt.create({
  name: "horizontalRule"
}), iJe = rJe.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: aa.nodes.horizontal_rule,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), oJe = Zt.create({
  name: "image"
}), aJe = oJe.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: aa.nodes.image,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), sJe = Zt.create({
  name: "listItem"
}), lJe = sJe.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: aa.nodes.list_item,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), uJe = Zt.create({
  name: "orderedList"
});
function cJe(e, t, n) {
  let r = 0;
  for (; n - r > 0 && t.child(n - r - 1).type.name === e.type.name; r++)
    ;
  return r;
}
const dJe = uJe.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(e, t, n, r) {
          const i = t.attrs.start || 1, o = String(i + t.childCount - 1).length, a = e.repeat(" ", o + 2), l = cJe(t, n, r) % 2 ? ") " : ". ";
          e.renderList(t, a, (u) => {
            const c = String(i + u);
            return e.repeat(" ", o - c.length) + c + l;
          });
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), fJe = Zt.create({
  name: "paragraph"
}), hJe = fJe.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: aa.nodes.paragraph,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
});
function sx(e) {
  var t, n;
  return (t = e == null || (n = e.content) === null || n === void 0 ? void 0 : n.content) !== null && t !== void 0 ? t : [];
}
const pJe = Zt.create({
  name: "table"
}), mJe = pJe.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(e, t, n) {
          if (!gJe(t)) {
            Xv.storage.markdown.serialize.call(this, e, t, n);
            return;
          }
          e.inTable = !0, t.forEach((r, i, o) => {
            if (e.write("| "), r.forEach((a, s, l) => {
              l && e.write(" | ");
              const u = a.firstChild;
              u.textContent.trim() && e.renderInline(u);
            }), e.write(" |"), e.ensureNewLine(), !o) {
              const a = Array.from({
                length: r.childCount
              }).map(() => "---").join(" | ");
              e.write(`| ${a} |`), e.ensureNewLine();
            }
          }), e.closeBlock(t), e.inTable = !1;
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
});
function QF(e) {
  return e.attrs.colspan > 1 || e.attrs.rowspan > 1;
}
function gJe(e) {
  const t = sx(e), n = t[0], r = t.slice(1);
  return !(sx(n).some((i) => i.type.name !== "tableHeader" || QF(i) || i.childCount > 1) || r.some((i) => sx(i).some((o) => o.type.name === "tableHeader" || QF(o) || o.childCount > 1)));
}
const vJe = Zt.create({
  name: "taskItem"
}), yJe = vJe.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(e, t) {
          const n = t.attrs.checked ? "[x]" : "[ ]";
          e.write(`${n} `), e.renderContent(t);
        },
        parse: {
          updateDOM(e) {
            [...e.querySelectorAll(".task-list-item")].forEach((t) => {
              const n = t.querySelector("input");
              t.setAttribute("data-type", "taskItem"), n && (t.setAttribute("data-checked", n.checked), n.remove());
            });
          }
        }
      }
    };
  }
}), bJe = Zt.create({
  name: "taskList"
}), xJe = bJe.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: Fte.storage.markdown.serialize,
        parse: {
          setup(e) {
            e.use($Xe);
          },
          updateDOM(e) {
            [...e.querySelectorAll(".contains-task-list")].forEach((t) => {
              t.setAttribute("data-type", "taskList");
            });
          }
        }
      }
    };
  }
}), wJe = Zt.create({
  name: "text"
}), CJe = wJe.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(e, t) {
          e.text(WXe(t.text));
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), SJe = Zr.create({
  name: "bold"
}), _Je = SJe.extend({
  /**
   * @return {{markdown: MarkdownMarkSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: aa.marks.strong,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), EJe = Zr.create({
  name: "code"
}), NJe = EJe.extend({
  /**
   * @return {{markdown: MarkdownMarkSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: aa.marks.code,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), AJe = Zr.create({
  name: "italic"
}), OJe = AJe.extend({
  /**
   * @return {{markdown: MarkdownMarkSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: aa.marks.em,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), kJe = Zr.create({
  name: "link"
}), PJe = kJe.extend({
  /**
   * @return {{markdown: MarkdownMarkSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: aa.marks.link,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), TJe = Zr.create({
  name: "strike"
}), MJe = TJe.extend({
  /**
   * @return {{markdown: MarkdownMarkSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: {
          open: "~~",
          close: "~~",
          expelEnclosingWhitespace: !0
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), RJe = [ZXe, Fte, QXe, Bte, nJe, iJe, Xv, aJe, lJe, dJe, hJe, mJe, yJe, xJe, CJe, _Je, NJe, Lte, OJe, PJe, MJe];
function Ig(e) {
  var t, n;
  const r = (t = e.storage) === null || t === void 0 ? void 0 : t.markdown, i = (n = RJe.find((o) => o.name === e.name)) === null || n === void 0 ? void 0 : n.storage.markdown;
  return r || i ? {
    ...i,
    ...r
  } : null;
}
class DJe {
  constructor(t) {
    Dg(this, "editor", null), this.editor = t;
  }
  serialize(t) {
    const n = new zXe(this.nodes, this.marks, {
      hardBreakNodeName: Bte.name
    });
    return n.renderContent(t), n.out;
  }
  get nodes() {
    var t;
    return {
      ...Object.fromEntries(Object.keys(this.editor.schema.nodes).map((n) => [n, this.serializeNode(Xv)])),
      ...Object.fromEntries((t = this.editor.extensionManager.extensions.filter((n) => n.type === "node" && this.serializeNode(n)).map((n) => [n.name, this.serializeNode(n)])) !== null && t !== void 0 ? t : [])
    };
  }
  get marks() {
    var t;
    return {
      ...Object.fromEntries(Object.keys(this.editor.schema.marks).map((n) => [n, this.serializeMark(Lte)])),
      ...Object.fromEntries((t = this.editor.extensionManager.extensions.filter((n) => n.type === "mark" && this.serializeMark(n)).map((n) => [n.name, this.serializeMark(n)])) !== null && t !== void 0 ? t : [])
    };
  }
  serializeNode(t) {
    var n;
    return (n = Ig(t)) === null || n === void 0 || (n = n.serialize) === null || n === void 0 ? void 0 : n.bind({
      editor: this.editor,
      options: t.options
    });
  }
  serializeMark(t) {
    var n;
    const r = (n = Ig(t)) === null || n === void 0 ? void 0 : n.serialize;
    return r ? {
      ...r,
      open: typeof r.open == "function" ? r.open.bind({
        editor: this.editor,
        options: t.options
      }) : r.open,
      close: typeof r.close == "function" ? r.close.bind({
        editor: this.editor,
        options: t.options
      }) : r.close
    } : null;
  }
}
class IJe {
  constructor(t, n) {
    Dg(this, "editor", null), Dg(this, "md", null);
    let {
      html: r,
      linkify: i,
      breaks: o
    } = n;
    this.editor = t, this.md = this.withPatchedRenderer(Jr({
      html: r,
      linkify: i,
      breaks: o
    }));
  }
  parse(t) {
    let {
      inline: n
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (typeof t == "string") {
      this.editor.extensionManager.extensions.forEach((o) => {
        var a;
        return (a = Ig(o)) === null || a === void 0 || (a = a.parse) === null || a === void 0 || (a = a.setup) === null || a === void 0 ? void 0 : a.call({
          editor: this.editor,
          options: o.options
        }, this.md);
      });
      const r = this.md.render(t), i = cE(r);
      return this.editor.extensionManager.extensions.forEach((o) => {
        var a;
        return (a = Ig(o)) === null || a === void 0 || (a = a.parse) === null || a === void 0 || (a = a.updateDOM) === null || a === void 0 ? void 0 : a.call({
          editor: this.editor,
          options: o.options
        }, i);
      }), this.normalizeDOM(i, {
        inline: n,
        content: t
      }), i.innerHTML;
    }
    return t;
  }
  normalizeDOM(t, n) {
    let {
      inline: r,
      content: i
    } = n;
    return this.normalizeBlocks(t), t.querySelectorAll("*").forEach((o) => {
      var a;
      ((a = o.nextSibling) === null || a === void 0 ? void 0 : a.nodeType) === Node.TEXT_NODE && !o.closest("pre") && (o.nextSibling.textContent = o.nextSibling.textContent.replace(/^\n/, ""));
    }), r && this.normalizeInline(t, i), t;
  }
  normalizeBlocks(t) {
    const r = Object.values(this.editor.schema.nodes).filter((i) => i.isBlock).map((i) => {
      var o;
      return (o = i.spec.parseDOM) === null || o === void 0 ? void 0 : o.map((a) => a.tag);
    }).flat().filter(Boolean).join(",");
    r && [...t.querySelectorAll(r)].forEach((i) => {
      i.parentElement.matches("p") && HXe(i);
    });
  }
  normalizeInline(t, n) {
    var r;
    if ((r = t.firstElementChild) !== null && r !== void 0 && r.matches("p")) {
      var i, o, a, s;
      const l = t.firstElementChild, {
        nextElementSibling: u
      } = l, c = (i = (o = n.match(/^\s+/)) === null || o === void 0 ? void 0 : o[0]) !== null && i !== void 0 ? i : "", f = u ? "" : (a = (s = n.match(/\s+$/)) === null || s === void 0 ? void 0 : s[0]) !== null && a !== void 0 ? a : "";
      if (n.match(/^\n\n/)) {
        l.innerHTML = `${l.innerHTML}${f}`;
        return;
      }
      UXe(l), t.innerHTML = `${c}${t.innerHTML}${f}`;
    }
  }
  /**
   * @param {markdownit} md
   */
  withPatchedRenderer(t) {
    const n = (r) => function() {
      const i = r(...arguments);
      return i === `
` ? i : i[i.length - 1] === `
` ? i.slice(0, -1) : i;
    };
    return t.renderer.rules.hardbreak = n(t.renderer.rules.hardbreak), t.renderer.rules.softbreak = n(t.renderer.rules.softbreak), t.renderer.rules.fence = n(t.renderer.rules.fence), t.renderer.rules.code_block = n(t.renderer.rules.code_block), t.renderer.renderToken = n(t.renderer.renderToken.bind(t.renderer)), t;
  }
}
const $Je = Gn.create({
  name: "markdownClipboard",
  addOptions() {
    return {
      transformPastedText: !1,
      transformCopiedText: !1
    };
  },
  addProseMirrorPlugins() {
    return [new $r({
      key: new xo("markdownClipboard"),
      props: {
        clipboardTextParser: (e, t, n) => {
          if (n || !this.options.transformPastedText)
            return null;
          const r = this.editor.storage.markdown.parser.parse(e, {
            inline: !0
          });
          return Da.fromSchema(this.editor.schema).parseSlice(cE(r), {
            preserveWhitespace: !0,
            context: t
          });
        },
        /**
         * @param {import('prosemirror-model').Slice} slice
         */
        clipboardTextSerializer: (e) => this.options.transformCopiedText ? this.editor.storage.markdown.serializer.serialize(e.content) : null
      }
    })];
  }
}), LJe = Gn.create({
  name: "markdown",
  priority: 50,
  addOptions() {
    return {
      html: !0,
      tightLists: !0,
      tightListClass: "tight",
      bulletListMarker: "-",
      linkify: !1,
      breaks: !1,
      transformPastedText: !1,
      transformCopiedText: !1
    };
  },
  addCommands() {
    const e = pGe.Commands.config.addCommands();
    return {
      setContent: (t, n, r) => (i) => e.setContent(i.editor.storage.markdown.parser.parse(t), n, r)(i),
      insertContentAt: (t, n, r) => (i) => e.insertContentAt(t, i.editor.storage.markdown.parser.parse(n, {
        inline: !0
      }), r)(i)
    };
  },
  onBeforeCreate() {
    this.editor.storage.markdown = {
      options: {
        ...this.options
      },
      parser: new IJe(this.editor, this.options),
      serializer: new DJe(this.editor),
      getMarkdown: () => this.editor.storage.markdown.serializer.serialize(this.editor.state.doc)
    }, this.editor.options.initialContent = this.editor.options.content, this.editor.options.content = this.editor.storage.markdown.parser.parse(this.editor.options.content);
  },
  onCreate() {
    this.editor.options.content = this.editor.options.initialContent, delete this.editor.options.initialContent;
  },
  addStorage() {
    return {
      /// storage will be defined in onBeforeCreate() to prevent initial object overriding
    };
  },
  addExtensions() {
    return [BXe.configure({
      tight: this.options.tightLists,
      tightClass: this.options.tightListClass
    }), $Je.configure({
      transformPastedText: this.options.transformPastedText,
      transformCopiedText: this.options.transformCopiedText
    })];
  }
});
function FJe({
  disabled: e,
  editor: t
}) {
  return t ? /* @__PURE__ */ k("div", { className: "bg-interfaceBgLight border-interactiveBorder flex items-center gap-3 rounded-t border-b px-1", children: [
    /* @__PURE__ */ k(
      d9e,
      {
        disabled: e,
        onValueChange: (n) => {
          n === "paragraph" ? t.chain().focus().setParagraph().run() : n === "heading" && t.chain().focus().toggleHeading({ level: 1 }).run();
        },
        value: t.isActive("heading") ? "heading" : "paragraph",
        children: [
          /* @__PURE__ */ d(zG, { className: "bg-interfaceBgLight my-0 h-fit w-fit rounded-none border-0 py-0", children: /* @__PURE__ */ d(f9e, { placeholder: "Text format" }) }),
          /* @__PURE__ */ k(WG, { children: [
            /* @__PURE__ */ d(c7, { value: "paragraph", children: "Normal text" }),
            /* @__PURE__ */ d(c7, { value: "heading", children: "Heading" })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ d("div", { className: "bg-interactiveBorder w-[1px]", children: " " }),
    /* @__PURE__ */ d(
      et,
      {
        className: z(
          "my-0 ml-0 mr-0 h-fit px-2 py-1",
          t.isActive("bulletList") ? "bg-actionBgSelect" : ""
        ),
        disabled: e,
        onClick: () => t.chain().focus().toggleBulletList().run(),
        variant: "ghost",
        children: /* @__PURE__ */ d(wce, { className: "h-4 w-4" })
      }
    ),
    /* @__PURE__ */ d(
      et,
      {
        className: z(
          "my-0 ml-0 mr-0 h-fit px-2 py-1",
          t.isActive("orderedList") ? "bg-actionBgSelect" : ""
        ),
        disabled: e,
        onClick: () => t.chain().focus().toggleOrderedList().run(),
        variant: "ghost",
        children: /* @__PURE__ */ d(yce, { className: "h-4 w-4" })
      }
    ),
    /* @__PURE__ */ d("div", { className: "bg-interactiveBorder w-[1px]", children: " " }),
    /* @__PURE__ */ d(
      et,
      {
        className: "my-0 ml-0 mr-0 h-fit px-2 py-1",
        disabled: e || !t.can().chain().focus().undo().run(),
        onClick: () => t.chain().focus().undo().run(),
        variant: "ghost",
        children: "Undo"
      }
    ),
    /* @__PURE__ */ d(
      et,
      {
        className: "my-0 ml-0 mr-0 h-fit px-2 py-1",
        disabled: e || !t.can().chain().focus().redo().run(),
        onClick: () => t.chain().focus().redo().run(),
        variant: "ghost",
        children: "Redo"
      }
    )
  ] }) : null;
}
const Bet = te(function({ content: t, readonly: n }, r) {
  const [i, o] = re(!0), a = Je(() => [
    jKe.configure({
      heading: {
        HTMLAttributes: {
          class: "text-bodylg font-semibold"
        },
        levels: [1]
      },
      paragraph: {
        HTMLAttributes: {
          class: "text-bodylg"
        }
      },
      bulletList: {
        HTMLAttributes: {
          class: "list-disc ml-6"
        }
      },
      orderedList: {
        HTMLAttributes: {
          class: "list-decimal ml-6"
        }
      },
      listItem: {
        HTMLAttributes: {
          class: "marker:text-bodysm"
        }
      }
    }),
    LJe.configure({
      html: !1,
      breaks: !0,
      tightLists: !0
    })
  ], []), s = LGe({
    content: t,
    extensions: a,
    editorProps: {
      attributes: {
        class: z(
          "prose prose-sm sm:prose-base lg:prose-lg xl:prose-2xl focus:outline-hidden",
          !i && "text-textSubdued bg-interfaceBgLight"
        )
      },
      editable: () => i
    },
    onCreate: ({ editor: l }) => {
      l.view.dom.setAttribute("spellcheck", "true");
    },
    onUpdate({ editor: l }) {
      o(l.isEditable);
    }
  });
  return Pe(() => {
    s && s.commands.setContent(t);
  }, []), Pe(() => {
    o(!n);
  }, [n]), Lg(r, () => ({
    getMarkdown: () => s == null ? void 0 : s.storage.markdown.getMarkdown()
  }), [s]), /* @__PURE__ */ k(
    "div",
    {
      className: z(
        "border-interactiveBorder focus-within:ring-ring flex flex-col overflow-hidden rounded border focus-within:ring-2 focus-within:ring-offset-2",
        !i && "bg-interfaceBgLight"
      ),
      children: [
        /* @__PURE__ */ d(FJe, { disabled: !i, editor: s }),
        /* @__PURE__ */ d("div", { className: "flex grow flex-col overflow-hidden", children: /* @__PURE__ */ d("div", { className: "h-full grow overflow-y-auto px-5 py-4", children: /* @__PURE__ */ d(AGe, { editor: s }) }) })
      ]
    }
  );
});
function jet({
  latitude: e,
  longitude: t,
  addressBoundary: n,
  nearObjects: r,
  className: i
}) {
  const o = vt(null), a = vt([]), s = vt([]), l = vt([]), u = vt([]);
  return Pe(() => {
    if (!o.current) {
      let g;
      if (e != null && t != null)
        g = { lat: e, lng: t };
      else if (n && n.length > 0) {
        const w = n.reduce((S, N) => S + N.latitude, 0) / n.length, C = n.reduce((S, N) => S + N.longitude, 0) / n.length;
        g = { lat: w, lng: C };
      } else {
        console.warn("No latitude, longitude, or addressBoundary provided");
        return;
      }
      const y = {
        zoom: 18,
        // Zoom level to display the area in detail
        center: g,
        mapTypeId: google.maps.MapTypeId.SATELLITE
        // Set to satellite view
      };
      o.current = new google.maps.Map(
        document.getElementById("map"),
        y
      ), console.log("Map initialized with center:", g);
    }
    const c = o.current;
    if (!c) return;
    a.current.forEach((g) => g.setMap(null)), s.current.forEach((g) => g.setMap(null)), l.current.forEach((g) => g.setMap(null)), u.current.forEach((g) => g.close()), a.current = [], s.current = [], l.current = [], u.current = [];
    const f = {
      WATER: {
        strokeColor: "#0000FF",
        fillColor: "#0000FF",
        strokeOpacity: 0.5,
        fillOpacity: 0.05,
        strokeWeight: 2
      },
      // Blue
      ROAD: {
        strokeColor: "#808080",
        fillColor: "#808080",
        strokeOpacity: 0.4,
        fillOpacity: 0.05,
        strokeWeight: 2
      },
      // Gray
      OVERLAY: {
        strokeColor: "#FFFF00",
        fillColor: "#FFFF00",
        strokeOpacity: 0.3,
        fillOpacity: 0.05,
        strokeWeight: 2
      },
      // Yellow
      ZONE: {
        strokeColor: "#800080",
        fillColor: "#800080",
        strokeOpacity: 0.6,
        fillOpacity: 0.05,
        strokeWeight: 2
      },
      // Purple
      BUSHFIRE_PRONE_AREA: {
        strokeColor: "#FF0000",
        fillColor: "#FF0000",
        strokeOpacity: 0.5,
        fillOpacity: 0.05,
        strokeWeight: 2
      },
      // Red
      SIGNIFICANT_TREE: {
        strokeColor: "#228800",
        fillColor: "#228800",
        strokeOpacity: 0.5,
        fillOpacity: 0.05,
        strokeWeight: 2
      }
    }, h = (g, y) => {
      const w = new google.maps.Polygon({
        paths: g,
        strokeColor: y.strokeColor,
        strokeOpacity: y.strokeOpacity,
        strokeWeight: y.strokeWeight,
        fillColor: y.fillColor,
        fillOpacity: y.fillOpacity
      });
      return w.setMap(c), a.current.push(w), w;
    }, m = (g, y) => {
      const w = new google.maps.Polyline({
        path: g,
        geodesic: !0,
        strokeColor: y.strokeColor,
        strokeOpacity: y.strokeOpacity,
        strokeWeight: y.strokeWeight
      });
      return w.setMap(c), s.current.push(w), w;
    }, v = (g, y) => {
      const w = new google.maps.Marker({
        position: g,
        map: c,
        title: y.object_name
      });
      l.current.push(w);
      const C = `
        <div>
          <h3>${y.object_name}</h3>
          <p>Type: ${y.object_type}</p>
          <p>Sub-Type: ${y.object_sub_type}</p>
          <p>Distance: ${y.object_distance} m</p>
        </div>
      `, S = new google.maps.InfoWindow({
        content: C
      });
      u.current.push(S), w.addListener("click", () => {
        console.log(`Marker for ${y.object_name} clicked.`), u.current.forEach((N) => N.close()), S.open(c, w);
      });
    };
    if (n && n.length > 0) {
      const g = n.map(
        (w) => ({
          lat: w.latitude,
          lng: w.longitude
        })
      ), y = new google.maps.LatLngBounds();
      g.forEach((w) => y.extend(w)), c.fitBounds(y), console.log("Map bounds adjusted to boundary polygon:", y), h(g, {
        strokeColor: "#FF0000",
        fillColor: "#FF0000",
        strokeOpacity: 0.8,
        fillOpacity: 0,
        strokeWeight: 2
      });
    }
    return r && r.length > 0 && r.forEach((g, y) => {
      if (console.log(`Processing nearObject ${y}:`, g), !g.geo_data || !Array.isArray(g.geo_data)) {
        console.warn(
          `nearObjects[${y}].geo_data is undefined or not an array.`
        );
        return;
      }
      const w = g.geo_data.length;
      if (w === 1) {
        const C = {
          lat: g.geo_data[0][1],
          lng: g.geo_data[0][0]
        };
        v(C, g);
      } else if (w === 2) {
        const C = g.geo_data.map(
          (N, E) => ({ lat: N[1], lng: N[0] })
        ), S = {
          strokeColor: f[g.object_type].strokeColor,
          strokeOpacity: f[g.object_type].strokeOpacity,
          strokeWeight: 2
        };
        m(C, S);
      } else if (w >= 3) {
        const C = g.geo_data.map(
          (O, T) => ({ lat: O[1], lng: O[0] })
        ), S = f[g.object_type];
        if (!S) {
          console.warn(
            `nearObjects[${y}] has an unknown object_type: ${g.object_type}`
          );
          return;
        }
        const N = h(C, S), E = `
            <div>
              <h3>${g.object_name}</h3>
              <p>Type: ${g.object_type}</p>
              <p>Sub-Type: ${g.object_sub_type}</p>
              <p>Distance: ${g.object_distance} m</p>
            </div>
          `, A = new google.maps.InfoWindow({
          content: E
        });
        u.current.push(A), N.addListener("click", (O) => {
          O.latLng ? (console.log(`Polygon ${y} clicked at:`, {
            lat: O.latLng.lat(),
            lng: O.latLng.lng()
          }), u.current.forEach((T) => T.close()), A.setPosition(O.latLng), A.open(c)) : console.warn(
            `Clicked position is undefined for polygon ${y}.`
          );
        });
      } else
        console.warn(
          `nearObjects[${y}] has invalid geo_data length: ${w}`
        );
    }), () => {
      console.log("Cleaning up map overlays."), a.current.forEach((g) => g.setMap(null)), s.current.forEach((g) => g.setMap(null)), l.current.forEach((g) => g.setMap(null)), u.current.forEach((g) => g.close()), a.current = [], s.current = [], l.current = [], u.current = [];
    };
  }, [e, t, n, r]), /* @__PURE__ */ d(
    "div",
    {
      id: "map",
      className: i,
      style: { width: "100%", height: "500px" },
      children: e == null && t == null && (!n || n.length === 0) ? /* @__PURE__ */ d("p", { children: "Please provide latitude and longitude or an address boundary to display the map." }) : null
    }
  );
}
var X1 = /* @__PURE__ */ ((e) => (e.none = "none", e.loading = "loading", e.done = "done", e))(X1 || {});
function Vet({ items: e }) {
  const t = (n) => {
    switch (n.status) {
      case X1.done:
        return /* @__PURE__ */ k("span", { className: "text-successDefault flex gap-1 text-bodymd", children: [
          /* @__PURE__ */ d("span", { className: "w-6", children: /* @__PURE__ */ d(Gs, {}) }),
          /* @__PURE__ */ d("span", { className: "line-through", children: n.text })
        ] });
      case X1.loading:
        return /* @__PURE__ */ k("span", { className: "flex gap-1 text-bodymd", children: [
          /* @__PURE__ */ d("span", { className: "w-6", children: /* @__PURE__ */ d(Xo, { className: "animate-spin" }) }),
          /* @__PURE__ */ d("span", { className: "text-textPrimary", children: n.text })
        ] });
      case X1.none:
        return /* @__PURE__ */ k("span", { className: "flex gap-1 text-bodymd", children: [
          /* @__PURE__ */ d("span", { className: "w-6", children: n.icon }),
          /* @__PURE__ */ d("span", { className: "text-textDisabled", children: n.text })
        ] });
    }
  };
  return /* @__PURE__ */ d("ul", { className: "flex flex-col space-y-2", children: e.map((n, r) => /* @__PURE__ */ d("li", { children: t(n) }, r)) });
}
function BJe({
  message: e,
  hideTime: t = !1,
  translate: n
}) {
  return /* @__PURE__ */ d(xe, { children: /* @__PURE__ */ k(
    "div",
    {
      className: `flex w-full flex-col ${e.sender_account_type === If.USER ? "justify-start" : "justify-end"}`,
      children: [
        /* @__PURE__ */ d(
          "div",
          {
            hidden: t,
            className: `mb-0.5 flex w-full flex-row items-center ${e.sender_account_type === If.USER ? "justify-end" : "justify-start"}`,
            children: /* @__PURE__ */ d("div", { className: "text-textSubdued text-bodyxs ml-1", children: new Date(e.created_at || "").toLocaleDateString("en-AU", {
              hour: "2-digit",
              minute: "2-digit",
              year: "2-digit",
              month: "2-digit",
              day: "2-digit",
              timeZone: "Australia/Sydney"
            }) })
          }
        ),
        /* @__PURE__ */ d(
          "div",
          {
            className: z(
              "text-textPrimary bg-interfaceTags text-bodylg rounded-lg px-5 py-2",
              e.sender_account_type === If.USER ? "bg-actionDefault text-textWhite self-end" : "self-start",
              e.message_type === ep.PLANNER_MESSAGE && "bg-greenBgDefault text-textPrimary"
            ),
            children: Ge(
              n != null && n.getText ? n.getText(e.text || "") : e.text || "",
              {
                components: {
                  h1({ children: r }) {
                    return /* @__PURE__ */ d(xe, { children: r });
                  },
                  h2({ children: r }) {
                    return /* @__PURE__ */ d(xe, { children: r });
                  },
                  h3({ children: r }) {
                    return /* @__PURE__ */ d(xe, { children: r });
                  },
                  h4({ children: r }) {
                    return /* @__PURE__ */ d(xe, { children: r });
                  },
                  h5({ children: r }) {
                    return /* @__PURE__ */ d(xe, { children: r });
                  },
                  h6({ children: r }) {
                    return /* @__PURE__ */ d(xe, { children: r });
                  },
                  p({ children: r }) {
                    return /* @__PURE__ */ d("p", { children: r });
                  }
                }
              }
            )
          }
        )
      ]
    }
  ) });
}
function qet({
  className: e,
  conversationMessages: t,
  isPublic: n,
  translate: r = vi
}) {
  const i = (t || []).filter((o) => n && o.message_type === ep.PLANNER_MESSAGE ? !1 : [If.USER, If.ASSISTANT].includes(
    o.sender_account_type
  ));
  return /* @__PURE__ */ d("div", { className: z("h-full min-h-0 grow", e), children: i.map((o) => /* @__PURE__ */ d(
    "div",
    {
      className: "message-styles mb-3 last:mb-0",
      "data-testid": o.id,
      children: /* @__PURE__ */ d(BJe, { message: o, translate: r })
    },
    o.id
  )) });
}
const jJe = [
  {
    items: [
      {
        experts: [["existing_landuse_assessor", "existing_landuse_conclusion"]],
        title: "Existing land use"
      },
      {
        experts: [
          ["proposed_land_use_assessor", "proposed_land_use_assessment"]
        ],
        title: "Proposed land use"
      },
      {
        experts: [["land_use_assessor_checker", "output"], "land_use_assessor"],
        title: "Land use"
      },
      {
        experts: ["zone_assessor_checker", "zone_works_report"],
        title: "Buildings and works"
      },
      {
        experts: ["vicsmart_classifier"],
        title: "VicSmart"
      }
    ],
    title: "Zone"
  },
  {
    items: [
      {
        experts: [
          "bmo_overlay_checker",
          ["bmo_overlay_assessor", "final_output"]
        ],
        title: "Bushfire Management Overlay (BMO)"
      },
      {
        experts: [
          "emo_overlay_checker",
          ["emo_overlay_assessor", "final_output"]
        ],
        title: "Erosion Management Overlay (EMO)"
      },
      {
        experts: [
          "LSIO_overlay_checker",
          ["lsio_overlay_assessor", "final_output"]
        ],
        title: "Land Subject To Inundation Overlay (LSIO)"
      },
      {
        experts: [
          "slo_overlay_checker",
          ["slo_overlay_assessor", "final_output"]
        ],
        title: "Significant Landscape Overlay (SLO)"
      },
      {
        experts: [
          "ddo_overlay_checker",
          ["ddo_overlay_assessor", "final_output"]
        ],
        title: "Design and Development Overlay (DDO)"
      },
      {
        experts: [
          "vpo_overlay_checker",
          ["vpo_overlay_assessor", "final_output"]
        ],
        title: "Vegetation Protection Overlay (VPO)"
      },
      {
        experts: [
          "sbo_overlay_checker",
          ["sbo_overlay_assessor", "final_output"]
        ],
        title: "Special Building Overlay (SBO)"
      },
      {
        experts: [["ho_overlay_assessor", "ho_overlay_report"]],
        title: "Heritage Overlay (HO)"
      },
      {
        experts: [["eso_overlay_assessor", "final_output"]],
        title: "Environmental Significance Overlay (ESO)"
      },
      {
        experts: ["slo_vicsmart_classifier"],
        title: "VicSmart Significant Landscape Overlay (SLO)"
      },
      {
        experts: ["emo_vicsmart_classifier"],
        title: "VicSmart Erosion Management Overlay (EMO)"
      },
      {
        experts: ["eso_vicsmart_classifier"],
        title: "VicSmart Environmental Significance Overlay (ESO)"
      },
      {
        experts: ["sbo_vicsmart_classifier"],
        title: "VicSmart Special Building Overlay (SBO)"
      },
      {
        experts: ["ddo_vicsmart_classifier"],
        title: "VicSmart Design and Development Overlay (DDO)"
      },
      {
        experts: ["vpo_vicsmart_classifier"],
        title: "VicSmart Vegetation Protection Overlay (VPO)"
      },
      {
        experts: ["ho_vicsmart_classifier"],
        title: "VicSmart Heritage Overlay (HO)"
      }
    ],
    title: "Overlay"
  },
  {
    items: [
      {
        experts: ["vicsmart_classifier_combined"],
        title: "VicSmart classifier"
      }
    ],
    title: "VicSmart"
  },
  {
    items: [
      {
        experts: ["mandatory_requirements_combined"],
        title: "Combined mandatory requirements"
      },
      {
        experts: ["zone_mandatory_requirements"],
        title: "Zone mandatory requirements"
      },
      {
        experts: ["DDO_mandatory_requirements"],
        title: "DDO mandatory requirements"
      }
    ],
    title: "Mandatory requirements"
  },
  {
    items: [
      {
        experts: ["application_requirements"],
        title: "Application requirements"
      }
    ],
    title: "Application requirements"
  },
  {
    items: [{ experts: ["significant_GIS"], title: "Significant GIS" }],
    title: "GIS Data"
  }
], eB = /^(No).*(at this address)$/;
function VJe({
  allowEditing: e,
  conversation: t,
  experts: n,
  info: r,
  noticeboardData: i,
  title: o
}) {
  const { getLocalisationEntry: a } = ar(t), s = a("councilOrdinanceLink"), l = (y) => {
    if (Array.isArray(y)) {
      const [w, C] = y, S = i == null ? void 0 : i[w].parsed_output, N = (S == null ? void 0 : S[C]) || "";
      return ["", "No content"].includes(N) ? "Not applicable to this address" : N;
    } else if (y) {
      const w = i == null ? void 0 : i[y], C = (w == null ? void 0 : w.raw_output) || "";
      return ["", "No content"].includes(C) ? "Not applicable to this address" : C;
    }
    return "";
  }, u = yr(
    (y) => {
      var w;
      if (Array.isArray(y)) {
        const [C, S] = y;
        return i && C in i && "parsed_output" in i[C] && ((w = i[C].parsed_output) == null ? void 0 : w[S]) && !eB.test(
          i[C].parsed_output[S]
        );
      } else {
        const C = y;
        return i && C in i && i[C].raw_output && !eB.test(i[C].raw_output);
      }
    },
    [i]
  ), c = Je(() => n.find((y) => u(y)), [u, n]), f = Je(() => Array.isArray(c) ? c[0] : c, [c]), h = Je(() => Array.isArray(c) ? c[1] : null, [c]), { hasRevisions: m } = sB({
    expertName: f || "",
    noticeboardData: i
  });
  if (!f)
    return null;
  const v = () => /* @__PURE__ */ d(
    gB,
    {
      conversation: t,
      expertName: f,
      noticeboardData: i,
      outputKey: h,
      subTitle: /* @__PURE__ */ k("p", { className: "text-bodysm font-semibold", children: [
        "Expert:",
        " ",
        /* @__PURE__ */ k("span", { className: "text-textSubdued", children: [
          f,
          h && ` --> ${h}`
        ] })
      ] }),
      title: "Amend expert result",
      children: ({ setOpen: y }) => /* @__PURE__ */ d(
        et,
        {
          className: "text-bodyxs px-1",
          onClick: (w) => {
            w.preventDefault(), w.stopPropagation(), y(!0);
          },
          size: "tight",
          variant: "outline",
          children: "Amend"
        }
      )
    }
  ), g = () => /* @__PURE__ */ d(
    kB,
    {
      expertName: f,
      noticeboardData: i,
      subTitle: /* @__PURE__ */ k("p", { className: "text-bodysm font-semibold", children: [
        "Expert:",
        " ",
        /* @__PURE__ */ k("span", { className: "text-textSubdued", children: [
          f,
          h && ` --> ${h}`
        ] })
      ] }),
      title: "Expert result revisions",
      children: ({ setOpen: y }) => /* @__PURE__ */ d(
        et,
        {
          className: "text-bodyxs px-1",
          onClick: () => y(!0),
          size: "tight",
          variant: "outline",
          children: "Revisions"
        }
      )
    }
  );
  return /* @__PURE__ */ k(lo, { className: "border-interactiveBorder", value: f, children: [
    /* @__PURE__ */ d(uo, { className: "!px-4 !py-3 text-bodylg !font-semibold", children: /* @__PURE__ */ k("span", { className: "flex items-center gap-2", children: [
      o,
      r ? /* @__PURE__ */ k(BY, { children: [
        /* @__PURE__ */ d(jY, { children: /* @__PURE__ */ d(gce, { className: "text-textLink" }) }),
        /* @__PURE__ */ d(VY, { children: r })
      ] }) : null,
      e && v(),
      e && m && g()
    ] }) }),
    /* @__PURE__ */ d(co, { className: "p-5 pt-0", children: Ge(l(c), { ordinanceLink: s }) })
  ] });
}
const tB = /^(No).*(at this address)$/;
function qJe({
  allowEditing: e,
  conversation: t,
  header: n,
  onChange: r,
  noticeboardData: i,
  sections: o
}) {
  const a = (s) => s.some(
    (l) => l.experts.some((u) => {
      var c, f;
      if (Array.isArray(u)) {
        const [h, m] = u;
        return i && h in i && "parsed_output" in i[h] && ((f = (c = i[h]) == null ? void 0 : c.parsed_output) == null ? void 0 : f[m]) && !tB.test(
          i[h].parsed_output[m]
        );
      } else {
        const h = u;
        return i && h in i && i[h].raw_output && !tB.test(i[h].raw_output);
      }
    })
  );
  return /* @__PURE__ */ d(NS, { children: /* @__PURE__ */ k("div", { className: "border-interfaceBorder bg-interfaceWhite flex flex-col gap-6 rounded-lg border px-10 py-8", children: [
    n,
    Array.isArray(o) && o.map((s, l) => {
      if (a(s.items))
        return /* @__PURE__ */ k("div", { children: [
          s.title && /* @__PURE__ */ d("span", { className: "text-textPrimary text-headinglg font-semibold", children: s.title }),
          /* @__PURE__ */ d(
            zo,
            {
              className: "!border-interactiveBorder mt-3 rounded-[4px] border",
              onValueChange: (u) => r == null ? void 0 : r(s == null ? void 0 : s.title, u),
              type: "multiple",
              children: s.items.map((u, c) => /* @__PURE__ */ d(
                VJe,
                {
                  allowEditing: e,
                  conversation: t,
                  experts: u.experts,
                  info: u.info,
                  title: u.title,
                  noticeboardData: i
                },
                c
              ))
            }
          )
        ] }, l);
    })
  ] }) });
}
qJe.defaultReasoningPanelSections = jJe;
function au({ comment: e, spacer: t = /* @__PURE__ */ d("br", {}) }) {
  return e.split(`
`).map((n, r, i) => /* @__PURE__ */ k(Bs, { children: [
    n,
    r < i.length - 1 ? t : null
  ] }, r));
}
function zJe({
  reviews: e,
  conversationId: t,
  onSubmitSuccess: n
}) {
  const r = e.at(-1), [i, o] = re(""), [a, s] = re(""), [l, u] = re(""), [c, f] = re([]), [h, m] = re(""), [v, g] = re(""), [y, w] = re(""), [C, S] = re(!1), {
    mutate: N,
    isPending: E,
    reset: A
  } = Bg({
    onError(B) {
      console.error(
        "<ExistingReviewPanel> useCreateConversationReview() onError()",
        B.message
      );
    },
    onSuccess() {
      console.log(
        "<ExistingReviewPanel> useCreateConversationReview() onSuccess()"
      ), S(!1), o(""), n == null || n();
    }
  });
  Pe(() => {
    r && !La(r.review_data) && (console.log("<ReviewPanelV0> currentReview", r), s(r.review_data.customer_report_status), u(r.review_data.reasoning_correctness), f(r.review_data.reasoning_issues), m(r.review_data.conversation_quality), o(r.review_data.comments), g(r.created_at || ""), w(r.created_by_email || ""));
  }, [e]);
  const O = () => {
    if (!T()) {
      console.log("<ReviewPanelV0> handleClick() Adding review");
      const B = {
        customer_report_status: a,
        reasoning_correctness: l,
        reasoning_issues: c,
        conversation_quality: h,
        comments: i
      };
      A(), N({
        path: { conversation_id: t },
        body: {
          review_data: B
        }
      });
    }
  }, T = () => i !== "" || a !== "" || l !== "" || h !== "" ? !1 : c.length <= 0, M = () => a === "Yes" ? /* @__PURE__ */ k("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ d(gr, { className: "text-successText h-4 w-4" }),
    /* @__PURE__ */ d("p", { className: "text-successText ml-1.5 text-bodysm font-normal", children: "Yes" })
  ] }) : a === "No" ? /* @__PURE__ */ k("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ d(mr, { className: "text-destructiveText h-4 w-4" }),
    /* @__PURE__ */ d("p", { className: "text-destructiveText ml-1.5 text-bodysm font-normal", children: "No" })
  ] }) : /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), L = () => h === "Poor" ? /* @__PURE__ */ k("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ d(qA, { className: "text-destructiveText h-4 w-4" }),
    /* @__PURE__ */ d("p", { className: "text-destructiveText ml-1.5 text-bodysm font-normal", children: "Poor" })
  ] }) : h === "Ok" ? /* @__PURE__ */ k("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ d(zA, { className: "text-warningText h-4 w-4" }),
    /* @__PURE__ */ d("p", { className: "text-warningText ml-1.5 text-bodysm font-normal", children: "Ok" })
  ] }) : h === "Good" ? /* @__PURE__ */ k("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ d(WA, { className: "text-successText h-4 w-4" }),
    /* @__PURE__ */ d("p", { className: "text-successText ml-1.5 text-bodysm font-normal", children: "Good" })
  ] }) : /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), I = () => {
    let B = "";
    switch (l) {
      case "1":
        B = "😃 Mostly/all correct";
        break;
      case "2":
        B = "🙂 Partly correct";
        break;
      case "3":
        B = "😕 Partly incorrect";
        break;
      case "4":
        B = "☹️ Mostly incorrect";
        break;
      case "":
        return /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." });
    }
    return /* @__PURE__ */ d("p", { className: "text-bodysm font-normal", children: B });
  }, j = () => c.length > 0 ? c.map((B, q) => /* @__PURE__ */ k("div", { className: "flex flex-row gap-x-0.5", children: [
    /* @__PURE__ */ d(Gs, { className: "text-actionDefault h-5 w-5 p-[1px]" }),
    /* @__PURE__ */ d("p", { className: "text-actionHover text-bodymd font-normal", children: B })
  ] })) : /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." });
  return /* @__PURE__ */ k("div", { className: "bg-interfaceWhite border-interfaceBorder text-textPrimary flex flex-col rounded-lg border p-8", children: [
    (e.length === 0 || C) && /* @__PURE__ */ k("section", { className: "flex flex-col gap-y-5 text-bodymd font-semibold", children: [
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("h3", { children: "Was the report good enough to send to the customer?" }),
        /* @__PURE__ */ d(
          "h4",
          {
            hidden: a !== "",
            className: "text-textSubdued text-bodysm font-normal",
            children: "If No, follow up with the customer."
          }
        ),
        /* @__PURE__ */ d("div", { className: "mt-2", children: /* @__PURE__ */ d(
          $l,
          {
            radioValue: a,
            setRadioValue: (B) => s(B),
            options: [
              {
                text: "Yes",
                icon: /* @__PURE__ */ d(gr, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              },
              {
                text: "No",
                icon: /* @__PURE__ */ d(mr, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              }
            ]
          }
        ) })
      ] }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("h3", { children: "How correct is the reasoning?" }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: /* @__PURE__ */ d(
          PSe,
          {
            radioValue: l,
            setRadioValue: (B) => u(B)
          }
        ) })
      ] }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("h3", { children: "If there are issues with the reasoning, what are they?" }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: /* @__PURE__ */ d(
          txe,
          {
            options: [
              "Land use term",
              "Zone trigger",
              "Overlay trigger",
              "Provision trigger",
              "Exemption",
              "Other"
            ],
            groupValue: c,
            setGroupValue: (B) => f(B)
          }
        ) })
      ] }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("h3", { children: "How was the quality of the conversation?" }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: /* @__PURE__ */ d(
          $l,
          {
            radioValue: h,
            setRadioValue: (B) => m(B),
            options: [
              {
                text: "Poor",
                icon: /* @__PURE__ */ d(qA, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              },
              {
                text: "Ok",
                icon: /* @__PURE__ */ d(zA, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-warningBgDefault",
                borderColor: "data-[state=checked]:border-warningBorder",
                textColor: "data-[state=checked]:text-warningText"
              },
              {
                text: "Good",
                icon: /* @__PURE__ */ d(WA, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              }
            ]
          }
        ) })
      ] }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("h3", { children: "Comments" }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: /* @__PURE__ */ d(
          Pa,
          {
            value: i,
            onChange: (B) => {
              o(B.target.value);
            },
            className: `${i === "" ? "border-interactiveBorder" : "border-interactiveBorderSelect"} focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-bodymd font-normal focus:outline-0`,
            placeholder: "Enter additional comments"
          }
        ) })
      ] }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ k("div", { className: "flex w-full flex-row justify-end gap-x-2", children: [
          C && /* @__PURE__ */ d(
            "button",
            {
              onClick: () => S(!1),
              className: "text-actionDefault border-actionDefault flex flex-row items-center justify-center rounded border bg-transparent px-4 py-2 text-bodylg font-semibold",
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ k(
            "button",
            {
              onClick: O,
              disabled: T() || E,
              className: "disabled:bg-interactiveBgHover text-textWhite disabled:text-textDisabled bg-actionDefault border-actionDefault flex flex-row items-center justify-center rounded border px-4 py-2 text-bodylg font-semibold disabled:border disabled:border-[#CCCCCB]",
              children: [
                E && /* @__PURE__ */ d(Xo, { className: "mr-2 h-4 w-4 animate-spin" }),
                E ? "Submitting" : C ? "Update review" : "Submit review"
              ]
            }
          )
        ] }),
        C && /* @__PURE__ */ d("div", { className: "mt-2 flex w-full flex-row justify-end", children: /* @__PURE__ */ k("p", { className: "text-textSubdued text-bodysm font-normal", children: [
          "Previously updated by ",
          /* @__PURE__ */ d("span", { className: "text-textPrimary", children: y }),
          " on " + jo(v).replace(",", " at")
        ] }) })
      ] })
    ] }),
    e.length !== 0 && !C && /* @__PURE__ */ k("section", { className: "flex flex-col gap-y-5 text-bodymd font-semibold", children: [
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("h3", { children: "Was the report good enough to send to the customer?" }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: M() })
      ] }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("h3", { children: "How correct is the reasoning?" }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: I() })
      ] }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("h3", { children: "If there are issues with the reasoning, what are they?" }),
        /* @__PURE__ */ d("div", { className: "mt-2 flex flex-row flex-wrap gap-x-3", children: j() })
      ] }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("h3", { children: "How was the quality of the conversation?" }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: L() })
      ] }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("h3", { children: "Comments" }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: i === "" ? /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }) : /* @__PURE__ */ d("p", { className: "text-wrap break-all text-bodymd font-normal", children: /* @__PURE__ */ d(au, { comment: i }) }) })
      ] }),
      /* @__PURE__ */ d("div", { className: "border-interfaceBorder w-full border-t" }),
      /* @__PURE__ */ k("div", { className: "flex flex-col gap-y-1", children: [
        /* @__PURE__ */ k(
          "button",
          {
            onClick: () => S(!0),
            className: "text-textLink flex flex-row items-center text-bodysm font-normal underline",
            children: [
              /* @__PURE__ */ d(Mv, { className: "h-4 w-4" }),
              /* @__PURE__ */ d("p", { className: "ml-1", children: "Edit review" })
            ]
          }
        ),
        /* @__PURE__ */ k("p", { className: "text-textSubdued text-bodysm font-normal", children: [
          "Last updated " + jo(v).replace(",", " at") + " by ",
          /* @__PURE__ */ d("span", { className: "text-textPrimary", children: y })
        ] })
      ] })
    ] })
  ] });
}
function jte({
  outcome: e
}) {
  switch (e) {
    case "Planning permit not required":
      return /* @__PURE__ */ k(xe, { children: [
        "Buildings and works",
        " ",
        /* @__PURE__ */ d("span", { className: "text-actionDefault ml-1", children: "does not trigger a planning permit" }),
        ", is this correct?"
      ] });
    case "Planning permit maybe required":
      return /* @__PURE__ */ k(xe, { children: [
        "Buildings and works",
        " ",
        /* @__PURE__ */ d("span", { className: "text-actionDefault ml-1", children: "does not trigger a planning permit" }),
        ", is this correct?"
      ] });
    case "Planning permit required":
      return /* @__PURE__ */ k(xe, { children: [
        "Buildings and works",
        " ",
        /* @__PURE__ */ d("span", { className: "text-actionDefault ml-1", children: "triggers a planning permit" }),
        ", is this correct?"
      ] });
  }
}
function Vte({ outcome: e }) {
  switch (e) {
    case "Planning permit not required":
      return /* @__PURE__ */ k(xe, { children: [
        "Land use",
        " ",
        /* @__PURE__ */ d("span", { className: "text-actionDefault ml-1", children: "does not trigger a planning permit" }),
        ", is this correct?"
      ] });
    case "Planning permit maybe required":
      return /* @__PURE__ */ k(xe, { children: [
        "Land use",
        " ",
        /* @__PURE__ */ d("span", { className: "text-actionDefault ml-1", children: "does not trigger a planning permit" }),
        ", is this correct?"
      ] });
    case "Planning permit required":
      return /* @__PURE__ */ k(xe, { children: [
        "Land use",
        " ",
        /* @__PURE__ */ d("span", { className: "text-actionDefault ml-1", children: "triggers a planning permit" }),
        ", is this correct?"
      ] });
    case "Prohibited":
      return /* @__PURE__ */ k(xe, { children: [
        "Land use",
        " ",
        /* @__PURE__ */ d("span", { className: "text-actionDefault ml-1", children: "is prohibited" }),
        ", is this correct?"
      ] });
  }
}
function WJe({
  conversation: e,
  noticeboard: t,
  onClickCancel: n,
  onSubmitSuccess: r,
  review: i
}) {
  var H, Z, de;
  const {
    mutate: o,
    isPending: a,
    reset: s
  } = Bg({
    onError(ne) {
      console.error(
        "<ReviewPanelV1EditMode> useCreateConversationReview() onError()",
        ne.message
      );
    },
    onSuccess() {
      console.log(
        "<ReviewPanelV1EditMode> useCreateConversationReview() onSuccess()"
      ), I(""), r();
    }
  }), l = e == null ? void 0 : e.id, u = /* @__PURE__ */ d(
    Vt,
    {
      value: e != null && e.report_outcome ? e.report_outcome : ""
    }
  ), c = ((Z = (H = t == null ? void 0 : t.building_works_assessment_result) == null ? void 0 : H.parsed_output) == null ? void 0 : Z.land_use_assessor_result) ?? "", f = ((de = t == null ? void 0 : t.building_works_assessment_result) == null ? void 0 : de.parsed_output.building_works_assessment_result) ?? "", [h, m] = re(""), [v, g] = re(""), [y, w] = re(""), [C, S] = re(""), [N, E] = re(""), [A, O] = re(""), [T, M] = re(""), [L, I] = re(""), [j, B] = re(""), [q, G] = re("");
  Pe(() => {
    i && La(i.review_data) && i.review_data.version === 1 && (m(i.review_data.report_outcome), g(
      i.review_data.report_outcome_expected
    ), w(i.review_data.land_use_correctness), S(i.review_data.land_use_correctness_comment), E(
      i.review_data.buildings_and_works_correctness
    ), O(
      i.review_data.buildings_and_works_correctness_comment
    ), M(i.review_data.report_good_enough), I(i.review_data.comments), B(i.created_at || ""), G(i.created_by || ""));
  }, [i]);
  const U = () => h !== "" || y !== "" || N !== "" ? !1 : T !== "" ? "" : L === "", V = () => {
    if (!U() && l) {
      console.log("<ReviewPanelV1EditMode> Adding review.");
      const ne = {
        version: 1,
        report_outcome: h,
        report_outcome_expected: v,
        land_use_correctness: y,
        land_use_correctness_comment: C,
        buildings_and_works_correctness: N,
        buildings_and_works_correctness_comment: A,
        report_good_enough: T,
        comments: L
      };
      s(), o({
        path: { conversation_id: l },
        body: {
          review_data: ne
        }
      });
    }
  };
  return /* @__PURE__ */ k("section", { className: "flex flex-col gap-y-5 text-bodymd font-semibold", children: [
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ k("h3", { className: "flex", children: [
        "The result is ",
        /* @__PURE__ */ d("span", { className: "ml-1", children: u }),
        ", is this correct?"
      ] }),
      /* @__PURE__ */ k("div", { className: "mt-2", children: [
        /* @__PURE__ */ d(
          $l,
          {
            radioValue: h,
            setRadioValue: (ne) => m(ne),
            options: [
              {
                text: "Yes",
                icon: /* @__PURE__ */ d(gr, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              },
              {
                text: "No",
                icon: /* @__PURE__ */ d(mr, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              }
            ]
          }
        ),
        h === "No" ? /* @__PURE__ */ k("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ d(hi, {}),
          /* @__PURE__ */ k("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
            /* @__PURE__ */ d(qt, { children: "What should the result be?" }),
            /* @__PURE__ */ d(
              Dc,
              {
                className: "gap-1",
                radioValue: v,
                setRadioValue: (ne) => g(ne),
                options: [
                  {
                    icon: /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ d(Vt, { value: "No permit required" }) }),
                    bgColor: "data-[state=checked]:bg-successBgDefault",
                    borderColor: "data-[state=checked]:border-successBorder",
                    textColor: "data-[state=checked]:text-successText",
                    value: "No permit required"
                  },
                  {
                    icon: /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ d(Vt, { value: "More information required" }) }),
                    bgColor: "data-[state=checked]:bg-actionBgLight",
                    borderColor: "data-[state=checked]:border-actionBorder",
                    textColor: "data-[state=checked]:text-actionDefault",
                    value: "More information required"
                  },
                  {
                    icon: /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ d(Vt, { value: "Permit required" }) }),
                    bgColor: "data-[state=checked]:bg-warningBgLight",
                    borderColor: "data-[state=checked]:border-warningBorder",
                    textColor: "data-[state=checked]:text-warningText",
                    value: "Permit required"
                  },
                  {
                    icon: /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ d(Vt, { value: "Prohibited" }) }),
                    bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                    borderColor: "data-[state=checked]:border-destructiveBorder",
                    textColor: "data-[state=checked]:text-destructiveText",
                    value: "Prohibited"
                  }
                ].filter(
                  (ne) => ne.value !== (e == null ? void 0 : e.report_outcome)
                )
              }
            )
          ] })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ d("h3", { className: "inline", children: /* @__PURE__ */ d(Vte, { outcome: c }) }),
      /* @__PURE__ */ k("div", { className: "mt-2", children: [
        /* @__PURE__ */ d(
          $l,
          {
            radioValue: y,
            setRadioValue: (ne) => w(ne),
            options: [
              {
                text: "Yes",
                icon: /* @__PURE__ */ d(gr, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              },
              {
                text: "No",
                icon: /* @__PURE__ */ d(mr, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              }
            ]
          }
        ),
        y ? /* @__PURE__ */ k("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ d(hi, {}),
          /* @__PURE__ */ k("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
            /* @__PURE__ */ d(qt, { children: y === "Yes" ? "Comments" : "What is incorrect about it?" }),
            /* @__PURE__ */ d(
              Pa,
              {
                className: `${L === "" ? "border-interactiveBorder" : "border-interactiveBorderSelect"} focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-bodymd font-normal focus:outline-0`,
                onChange: (ne) => {
                  S(ne.target.value);
                },
                placeholder: y === "Yes" ? "Enter comments" : "Describe what's incorrect and what it should have been.",
                tabIndex: 1,
                value: C
              }
            )
          ] })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ d("h3", { className: "inline", children: /* @__PURE__ */ d(jte, { outcome: f }) }),
      /* @__PURE__ */ k("div", { className: "mt-2", children: [
        /* @__PURE__ */ d(
          $l,
          {
            radioValue: N,
            setRadioValue: (ne) => E(ne),
            options: [
              {
                text: "Yes",
                icon: /* @__PURE__ */ d(gr, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              },
              {
                text: "No",
                icon: /* @__PURE__ */ d(mr, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              }
            ]
          }
        ),
        N ? /* @__PURE__ */ k("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ d(hi, {}),
          /* @__PURE__ */ k("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
            /* @__PURE__ */ d(qt, { children: N === "Yes" ? "Comments" : "What is incorrect about it?" }),
            /* @__PURE__ */ d(
              Pa,
              {
                className: `${L === "" ? "border-interactiveBorder" : "border-interactiveBorderSelect"} focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-bodymd font-normal focus:outline-0`,
                onChange: (ne) => {
                  O(ne.target.value);
                },
                placeholder: N === "Yes" ? "Enter comments" : "Describe what's incorrect and what it should have been.",
                tabIndex: 1,
                value: A
              }
            )
          ] })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ d("h3", { children: "Is the report good enough, or is a follow-up required?" }),
      /* @__PURE__ */ d("div", { className: "mt-2", children: /* @__PURE__ */ d(
        Dc,
        {
          className: "gap-1",
          radioValue: T,
          setRadioValue: (ne) => M(ne),
          options: [
            {
              icon: /* @__PURE__ */ k("div", { className: "flex items-center py-2 pl-2 pr-3", children: [
                /* @__PURE__ */ d(gr, { className: "mr-2.5 h-4 w-4" }),
                /* @__PURE__ */ d(
                  "span",
                  {
                    className: `text-bodysm ${T === "Yes" ? "text-successText" : "text-textPrimary"} font-normal`,
                    children: "The report is good enough"
                  }
                )
              ] }),
              bgColor: "data-[state=checked]:bg-successBgDefault",
              borderColor: "data-[state=checked]:border-successBorder",
              textColor: "data-[state=checked]:text-successText",
              value: "Yes"
            },
            {
              icon: /* @__PURE__ */ k("div", { className: "flex items-center py-2 pl-2 pr-3", children: [
                /* @__PURE__ */ d(mr, { className: "mr-2.5 h-4 w-4" }),
                /* @__PURE__ */ d(
                  "span",
                  {
                    className: `text-bodysm ${T === "No" ? "text-destructiveText" : "text-textPrimary"} font-normal`,
                    children: "A follow-up with the customer is required"
                  }
                )
              ] }),
              bgColor: "data-[state=checked]:bg-destructiveBgDefault",
              borderColor: "data-[state=checked]:border-destructiveBorder",
              textColor: "data-[state=checked]:text-destructiveText",
              value: "No"
            }
          ]
        }
      ) })
    ] }),
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ d("h3", { children: "Additional comments" }),
      /* @__PURE__ */ d("div", { className: "mt-2", children: /* @__PURE__ */ d(
        Pa,
        {
          className: `${L === "" ? "border-interactiveBorder" : "border-interactiveBorderSelect"} focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-bodymd font-normal focus:outline-0`,
          onChange: (ne) => {
            I(ne.target.value);
          },
          placeholder: "Enter additional comments",
          tabIndex: 1,
          value: L
        }
      ) })
    ] }),
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ k("div", { className: "flex w-full flex-row justify-end gap-x-2", children: [
        j ? /* @__PURE__ */ d(
          et,
          {
            className: "text-actionDefault border-actionDefault",
            onClick: n,
            tabIndex: 1,
            variant: "outline",
            children: "Cancel"
          }
        ) : null,
        /* @__PURE__ */ k(
          et,
          {
            disabled: U() || a,
            onClick: V,
            tabIndex: 1,
            variant: "default",
            children: [
              a && /* @__PURE__ */ d(Xo, { className: "mr-2 h-4 w-4 animate-spin" }),
              a ? "Submitting" : "Submit review"
            ]
          }
        )
      ] }),
      j ? /* @__PURE__ */ d("div", { className: "mt-2 flex w-full flex-row justify-end", children: /* @__PURE__ */ k("p", { className: "text-textSubdued text-bodysm font-normal", children: [
        "Previously updated by ",
        /* @__PURE__ */ d("span", { className: "text-textPrimary", children: q }),
        " on " + jo(j).replace(",", " at")
      ] }) }) : null
    ] })
  ] });
}
function HJe({
  conversation: e,
  noticeboard: t,
  onSubmitSuccess: n
}) {
  const r = Fg({ conversation: e }), i = r.at(-1), [o, a] = re(""), [s, l] = re(""), [u, c] = re(""), [f, h] = re(""), [m, v] = re(""), [g, y] = re(""), [w, C] = re(""), [S, N] = re(""), [E, A] = re(""), [O, T] = re(""), [M, L] = re(r.length === 0);
  Pe(() => {
    r.length > 0 && L(!1);
  }, [r.length]), Pe(() => {
    i && La(i.review_data) && i.review_data.version === 1 && (console.log("<ReviewPanelV1> currentReview:", i), a(i.review_data.report_outcome), l(
      i.review_data.report_outcome_expected
    ), c(i.review_data.land_use_correctness), h(
      i.review_data.land_use_correctness_comment
    ), v(
      i.review_data.buildings_and_works_correctness
    ), y(
      i.review_data.buildings_and_works_correctness_comment
    ), C(
      i.review_data.report_good_enough
    ), N(i.review_data.comments), A(i.created_at || ""), T(i.created_by_email || ""));
  }, [i]);
  const I = (V, H) => /* @__PURE__ */ k("div", { className: "mt-2 flex pl-1", children: [
    /* @__PURE__ */ d(hi, {}),
    /* @__PURE__ */ k("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
      /* @__PURE__ */ d(qt, { children: H ? "Comments" : "What is incorrect about it?" }),
      V ? /* @__PURE__ */ d("span", { className: "text-textSubdued text-bodysm", children: /* @__PURE__ */ d(au, { comment: V }) }) : /* @__PURE__ */ d("span", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." })
    ] })
  ] }), j = () => o === "Yes" ? /* @__PURE__ */ k("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ d(gr, { className: "text-successText h-4 w-4" }),
    /* @__PURE__ */ d("p", { className: "text-successText ml-1.5 text-bodysm font-normal", children: "Yes" })
  ] }) : o === "No" ? /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ k("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ d(mr, { className: "text-destructiveText h-4 w-4" }),
      /* @__PURE__ */ d("p", { className: "text-destructiveText ml-1.5 text-bodysm font-normal", children: "No" })
    ] }),
    /* @__PURE__ */ k("div", { className: "mt-2 flex pl-1", children: [
      /* @__PURE__ */ d(hi, {}),
      /* @__PURE__ */ k("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
        /* @__PURE__ */ d(qt, { children: "What should the result be?" }),
        s ? /* @__PURE__ */ d(Vt, { value: s }) : /* @__PURE__ */ d("span", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." })
      ] })
    ] })
  ] }) : /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), B = () => u === "Yes" ? /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ k("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ d(gr, { className: "text-successText h-4 w-4" }),
      /* @__PURE__ */ d("p", { className: "text-successText ml-1.5 text-bodysm font-normal", children: "Yes" })
    ] }),
    I(f, !0)
  ] }) : u === "No" ? /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ k("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ d(mr, { className: "text-destructiveText h-4 w-4" }),
      /* @__PURE__ */ d("p", { className: "text-destructiveText ml-1.5 text-bodysm font-normal", children: "No" })
    ] }),
    I(f, !1)
  ] }) : /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), q = () => m === "Yes" ? /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ k("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ d(gr, { className: "text-successText h-4 w-4" }),
      /* @__PURE__ */ d("p", { className: "text-successText ml-1.5 text-bodysm font-normal", children: "Yes" })
    ] }),
    I(g, !0)
  ] }) : m === "No" ? /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ k("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ d(mr, { className: "text-destructiveText h-4 w-4" }),
      /* @__PURE__ */ d("p", { className: "text-destructiveText ml-1.5 text-bodysm font-normal", children: "No" })
    ] }),
    I(g, !1)
  ] }) : /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), G = () => w === "Yes" ? /* @__PURE__ */ k("div", { className: "flex items-center", children: [
    /* @__PURE__ */ d(gr, { className: "text-successText mr-2.5 h-4 w-4" }),
    /* @__PURE__ */ d("span", { className: "text-successText text-bodysm font-normal", children: "The report is good enough" })
  ] }) : w === "No" ? /* @__PURE__ */ k("div", { className: "flex items-center", children: [
    /* @__PURE__ */ d(mr, { className: "text-destructiveText mr-2.5 h-4 w-4" }),
    /* @__PURE__ */ d("span", { className: " text-destructiveText text-bodysm font-normal", children: "A follow-up with the customer is required" })
  ] }) : /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), U = () => {
    const V = /* @__PURE__ */ d(
      Vt,
      {
        value: e != null && e.report_outcome ? e.report_outcome : ""
      }
    ), H = (t == null ? void 0 : t.building_works_assessment_result.parsed_output.land_use_assessor_result) ?? "", Z = (t == null ? void 0 : t.building_works_assessment_result.parsed_output.building_works_assessment_result) ?? "";
    return /* @__PURE__ */ k("section", { className: "flex flex-col gap-y-5 text-bodymd font-semibold", children: [
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ k("h3", { className: "flex", children: [
          "The result is ",
          /* @__PURE__ */ d("span", { className: "ml-1", children: V }),
          ", is this correct?"
        ] }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: j() })
      ] }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("h3", { className: "inline", children: /* @__PURE__ */ d(Vte, { outcome: H }) }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: B() })
      ] }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("h3", { className: "inline", children: /* @__PURE__ */ d(jte, { outcome: Z }) }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: q() })
      ] }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("h3", { children: "Is the report good enough, or is a follow-up required?" }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: G() })
      ] }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("h3", { children: "Comments" }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: S === "" ? /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." }) : /* @__PURE__ */ d("p", { className: "text-wrap break-all text-bodymd font-normal", children: /* @__PURE__ */ d(au, { comment: S }) }) })
      ] }),
      /* @__PURE__ */ d("div", { className: "border-interfaceBorder w-full border-t" }),
      /* @__PURE__ */ k("div", { className: "flex flex-col gap-y-1", children: [
        /* @__PURE__ */ k(
          "button",
          {
            onClick: () => L(!0),
            className: "text-textLink flex flex-row items-center text-bodysm font-normal underline",
            children: [
              /* @__PURE__ */ d(Mv, { className: "h-4 w-4" }),
              /* @__PURE__ */ d("p", { className: "ml-1", children: "Edit review" })
            ]
          }
        ),
        /* @__PURE__ */ k("p", { className: "text-textSubdued text-bodysm font-normal", children: [
          "Last updated " + jo(E).replace(",", " at") + " by ",
          /* @__PURE__ */ d("span", { className: "text-textPrimary", children: O })
        ] })
      ] })
    ] });
  };
  return /* @__PURE__ */ k("div", { className: "bg-interfaceWhite border-interfaceBorder text-textPrimary flex flex-col rounded-lg border p-8", children: [
    r.length === 0 || M ? /* @__PURE__ */ d(
      WJe,
      {
        conversation: e,
        noticeboard: t,
        onClickCancel: () => L(!1),
        onSubmitSuccess: () => {
          L(!1), n == null || n();
        },
        review: i
      }
    ) : null,
    r.length > 0 && !M ? U() : null
  ] });
}
function UJe({
  conversation: e,
  onClickCancel: t,
  onSubmitSuccess: n,
  review: r
}) {
  const {
    mutate: i,
    isPending: o,
    reset: a
  } = Bg({
    onError(M) {
      console.error(
        "<ReviewPanelV2EditMode> useCreateConversationReview() onError()",
        M.message
      );
    },
    onSuccess() {
      console.log(
        "<ReviewPanelV2EditMode> useCreateConversationReview() onSuccess()"
      ), C(""), n();
    }
  }), s = e == null ? void 0 : e.id, l = /* @__PURE__ */ d(
    Vt,
    {
      value: e != null && e.report_outcome ? e.report_outcome : ""
    }
  ), [u, c] = re(""), [f, h] = re(""), [m, v] = re(""), [g, y] = re(""), [w, C] = re(""), [S, N] = re(""), [E, A] = re("");
  Pe(() => {
    r && La(r.review_data) && r.review_data.version === 2 && (c(r.review_data.report_outcome), h(
      r.review_data.report_outcome_expected
    ), v(r.review_data.report_good_enough), y(
      r.review_data.report_good_enough_comment
    ), C(r.review_data.comments), N(r.created_at || ""), A(r.created_by || ""));
  }, [r]);
  const O = () => u !== "" ? !1 : m !== "" ? "" : w === "", T = () => {
    if (!O() && s) {
      console.log("<ReviewPanelV2EditMode> Adding review.");
      const M = {
        version: 2,
        report_outcome: u,
        report_outcome_expected: f,
        report_good_enough: m,
        report_good_enough_comment: g,
        comments: w
      };
      a(), i({
        path: { conversation_id: s },
        body: {
          review_data: M
        }
      });
    }
  };
  return /* @__PURE__ */ k("section", { className: "flex flex-col gap-y-5 text-bodymd font-semibold", children: [
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ k("h3", { className: "flex", children: [
        "The result is ",
        /* @__PURE__ */ d("span", { className: "ml-1", children: l }),
        ", is this correct?"
      ] }),
      /* @__PURE__ */ k("div", { className: "mt-2", children: [
        /* @__PURE__ */ d(
          $l,
          {
            radioValue: u,
            setRadioValue: (M) => c(M),
            options: [
              {
                text: "Yes",
                icon: /* @__PURE__ */ d(gr, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              },
              {
                text: "No",
                icon: /* @__PURE__ */ d(mr, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              }
            ]
          }
        ),
        u === "No" ? /* @__PURE__ */ k("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ d(hi, {}),
          /* @__PURE__ */ k("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
            /* @__PURE__ */ d(qt, { children: "What should the result be?" }),
            /* @__PURE__ */ d(
              Dc,
              {
                className: "gap-1",
                radioValue: f,
                setRadioValue: (M) => h(M),
                options: [
                  {
                    icon: /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ d(Vt, { value: "No permit required" }) }),
                    bgColor: "data-[state=checked]:bg-successBgDefault",
                    borderColor: "data-[state=checked]:border-successBorder",
                    textColor: "data-[state=checked]:text-successText",
                    value: "No permit required"
                  },
                  {
                    icon: /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ d(Vt, { value: "More information required" }) }),
                    bgColor: "data-[state=checked]:bg-actionBgLight",
                    borderColor: "data-[state=checked]:border-actionBorder",
                    textColor: "data-[state=checked]:text-actionDefault",
                    value: "More information required"
                  },
                  {
                    icon: /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ d(Vt, { value: "Permit required" }) }),
                    bgColor: "data-[state=checked]:bg-warningBgLight",
                    borderColor: "data-[state=checked]:border-warningBorder",
                    textColor: "data-[state=checked]:text-warningText",
                    value: "Permit required"
                  },
                  {
                    icon: /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ d(Vt, { value: "Prohibited" }) }),
                    bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                    borderColor: "data-[state=checked]:border-destructiveBorder",
                    textColor: "data-[state=checked]:text-destructiveText",
                    value: "Prohibited"
                  }
                ].filter(
                  (M) => M.value !== (e == null ? void 0 : e.report_outcome)
                )
              }
            )
          ] })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ d("h3", { children: "Is the report good enough, or is a follow-up required?" }),
      /* @__PURE__ */ k("div", { className: "mt-2", children: [
        /* @__PURE__ */ d(
          Dc,
          {
            className: "gap-1",
            radioValue: m,
            setRadioValue: (M) => v(M),
            options: [
              {
                icon: /* @__PURE__ */ k("div", { className: "flex items-center py-2 pl-2 pr-3", children: [
                  /* @__PURE__ */ d(gr, { className: "mr-2.5 h-4 w-4" }),
                  /* @__PURE__ */ d(
                    "span",
                    {
                      className: `text-bodysm ${m === "Yes" ? "text-successText" : "text-textPrimary"} font-normal`,
                      children: "The report is good enough"
                    }
                  )
                ] }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText",
                value: "Yes"
              },
              {
                icon: /* @__PURE__ */ k("div", { className: "flex items-center py-2 pl-2 pr-3", children: [
                  /* @__PURE__ */ d(mr, { className: "mr-2.5 h-4 w-4" }),
                  /* @__PURE__ */ d(
                    "span",
                    {
                      className: `text-bodysm ${m === "No" ? "text-destructiveText" : "text-textPrimary"} font-normal`,
                      children: "A follow-up with the customer is required"
                    }
                  )
                ] }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText",
                value: "No"
              }
            ]
          }
        ),
        m === "No" ? /* @__PURE__ */ k("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ d(hi, {}),
          /* @__PURE__ */ k("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
            /* @__PURE__ */ d(qt, { children: "What risk has the report introduced?" }),
            /* @__PURE__ */ d(
              Pa,
              {
                className: "border-interactiveBorder focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-bodymd font-normal focus:outline-0",
                onChange: (M) => {
                  y(M.target.value);
                },
                placeholder: "Describe how the council or customer may be affected due to the report's content.",
                tabIndex: 1,
                value: g
              }
            )
          ] })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ d("h3", { children: "Was the reasoning by zone and overlay correct?" }),
      /* @__PURE__ */ d("span", { className: "text-textSubdued inline-block text-bodysm font-normal", children: "Write your response against each applicable zone and overlay, e.g. “Zone: <comment>, BMO: <comment>, SLO: <comment>”." }),
      /* @__PURE__ */ d("div", { className: "mt-1", children: /* @__PURE__ */ d(
        Pa,
        {
          className: `${w === "" ? "border-interactiveBorder" : "border-interactiveBorderSelect"} focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-bodymd font-normal focus:outline-0`,
          onChange: (M) => {
            C(M.target.value);
          },
          placeholder: "Enter response",
          tabIndex: 1,
          value: w
        }
      ) })
    ] }),
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ k("div", { className: "flex w-full flex-row justify-end gap-x-2", children: [
        S ? /* @__PURE__ */ d(
          et,
          {
            className: "text-actionDefault border-actionDefault",
            onClick: t,
            tabIndex: 1,
            variant: "outline",
            children: "Cancel"
          }
        ) : null,
        /* @__PURE__ */ k(
          et,
          {
            disabled: O() || o,
            onClick: T,
            tabIndex: 1,
            variant: "default",
            children: [
              o && /* @__PURE__ */ d(Xo, { className: "mr-2 h-4 w-4 animate-spin" }),
              o ? "Submitting" : "Submit review"
            ]
          }
        )
      ] }),
      S ? /* @__PURE__ */ d("div", { className: "mt-2 flex w-full flex-row justify-end", children: /* @__PURE__ */ k("p", { className: "text-textSubdued text-bodysm font-normal", children: [
        "Previously updated by ",
        /* @__PURE__ */ d("span", { className: "text-textPrimary", children: E }),
        " on " + jo(S).replace(",", " at")
      ] }) }) : null
    ] })
  ] });
}
function GJe({
  conversation: e,
  onSubmitSuccess: t
}) {
  const n = Fg({ conversation: e }), r = n.at(-1), [i, o] = re(""), [a, s] = re(""), [l, u] = re(""), [c, f] = re(""), [h, m] = re(""), [v, g] = re(""), [y, w] = re(""), [C, S] = re(n.length === 0);
  Pe(() => {
    n.length > 0 && S(!1);
  }, [n.length]), Pe(() => {
    r && La(r.review_data) && r.review_data.version === 2 && (console.log("<ReviewPanelV2> currentReview:", r), o(r.review_data.report_outcome), s(
      r.review_data.report_outcome_expected
    ), u(
      r.review_data.report_good_enough
    ), f(
      r.review_data.report_good_enough_comment
    ), m(r.review_data.comments), g(r.created_at || ""), w(r.created_by_email || ""));
  }, [r]);
  const N = (T, M) => /* @__PURE__ */ k("div", { className: "mt-2 flex pl-1", children: [
    /* @__PURE__ */ d(hi, {}),
    /* @__PURE__ */ k("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
      /* @__PURE__ */ d(qt, { children: "What risk has the report introduced?" }),
      T ? /* @__PURE__ */ d("span", { className: "text-textSubdued text-bodysm", children: /* @__PURE__ */ d(au, { comment: T }) }) : /* @__PURE__ */ d("span", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." })
    ] })
  ] }), E = () => i === "Yes" ? /* @__PURE__ */ k("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ d(gr, { className: "text-successText h-4 w-4" }),
    /* @__PURE__ */ d("p", { className: "text-successText ml-1.5 text-bodysm font-normal", children: "Yes" })
  ] }) : i === "No" ? /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ k("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ d(mr, { className: "text-destructiveText h-4 w-4" }),
      /* @__PURE__ */ d("p", { className: "text-destructiveText ml-1.5 text-bodysm font-normal", children: "No" })
    ] }),
    /* @__PURE__ */ k("div", { className: "mt-2 flex pl-1", children: [
      /* @__PURE__ */ d(hi, {}),
      /* @__PURE__ */ k("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
        /* @__PURE__ */ d(qt, { children: "What should the result be?" }),
        a ? /* @__PURE__ */ d(Vt, { value: a }) : /* @__PURE__ */ d("span", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." })
      ] })
    ] })
  ] }) : /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), A = () => l === "Yes" ? /* @__PURE__ */ k("div", { className: "flex items-center", children: [
    /* @__PURE__ */ d(gr, { className: "text-successText mr-2.5 h-4 w-4" }),
    /* @__PURE__ */ d("span", { className: "text-successText text-bodysm font-normal", children: "The report is good enough" })
  ] }) : l === "No" ? /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ k("div", { className: "flex items-center", children: [
      /* @__PURE__ */ d(mr, { className: "text-destructiveText mr-2.5 h-4 w-4" }),
      /* @__PURE__ */ d("span", { className: " text-destructiveText text-bodysm font-normal", children: "A follow-up with the customer is required" })
    ] }),
    N(c)
  ] }) : /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), O = () => {
    const T = /* @__PURE__ */ d(
      Vt,
      {
        value: e != null && e.report_outcome ? e.report_outcome : ""
      }
    );
    return /* @__PURE__ */ k("section", { className: "flex flex-col gap-y-5 text-bodymd font-semibold", children: [
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ k("h3", { className: "flex", children: [
          "The result is ",
          /* @__PURE__ */ d("span", { className: "ml-1", children: T }),
          ", is this correct?"
        ] }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: E() })
      ] }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("h3", { children: "Is the report good enough, or is a follow-up required?" }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: A() })
      ] }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("h3", { children: "Was the reasoning by zone and overlay correct?" }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: h === "" ? /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." }) : /* @__PURE__ */ d("p", { className: "text-wrap break-all text-bodymd font-normal", children: /* @__PURE__ */ d(au, { comment: h }) }) })
      ] }),
      /* @__PURE__ */ d("div", { className: "border-interfaceBorder w-full border-t" }),
      /* @__PURE__ */ k("div", { className: "flex flex-col gap-y-1", children: [
        /* @__PURE__ */ k(
          "button",
          {
            onClick: () => S(!0),
            className: "text-textLink flex flex-row items-center text-bodysm font-normal underline",
            children: [
              /* @__PURE__ */ d(Mv, { className: "h-4 w-4" }),
              /* @__PURE__ */ d("p", { className: "ml-1", children: "Edit review" })
            ]
          }
        ),
        /* @__PURE__ */ k("p", { className: "text-textSubdued text-bodysm font-normal", children: [
          "Last updated " + jo(v).replace(",", " at") + " by ",
          /* @__PURE__ */ d("span", { className: "text-textPrimary", children: y })
        ] })
      ] })
    ] });
  };
  return /* @__PURE__ */ k("div", { className: "bg-interfaceWhite border-interfaceBorder text-textPrimary flex flex-col rounded-lg border p-8", children: [
    n.length === 0 || C ? /* @__PURE__ */ d(
      UJe,
      {
        conversation: e,
        onClickCancel: () => S(!1),
        onSubmitSuccess: () => {
          S(!1), t == null || t();
        },
        review: r
      }
    ) : null,
    n.length > 0 && !C ? O() : null
  ] });
}
function KJe({ onOpenChange: e, open: t }) {
  return /* @__PURE__ */ d(_2, { open: t, onOpenChange: e, children: /* @__PURE__ */ k(vp, { children: [
    /* @__PURE__ */ d(N2, { children: "Risk types" }),
    /* @__PURE__ */ d("p", { className: "text-bodymd", children: "Risk types are defined as follows:" }),
    /* @__PURE__ */ k("ul", { className: "text-bodymd ml-4 list-outside list-decimal", children: [
      /* @__PURE__ */ k("li", { className: "marker:font-semibold", children: [
        /* @__PURE__ */ d("b", { children: "Monetary:" }),
        " Where as a result of the report they received, the customer may end up spending money unnecessarily, such as commissioning a report they don't actually need."
      ] }),
      /* @__PURE__ */ k("li", { className: "marker:font-semibold", children: [
        /* @__PURE__ */ d("b", { children: "Incorrect or unnecessary design changes:" }),
        " Where the customer may be encouraged to alter their design based on incorrect information provided about permit triggers."
      ] }),
      /* @__PURE__ */ k("li", { className: "marker:font-semibold", children: [
        /* @__PURE__ */ d("b", { children: "Irreversible actions:" }),
        " Where the customer may be encouraged to take a development action that is prohibited or requires a permit, which could have irreversible consequences."
      ] }),
      /* @__PURE__ */ k("li", { className: "marker:font-semibold", children: [
        /* @__PURE__ */ d("b", { children: "Reputational:" }),
        " Where the report includes content that may result in a negative reputational impact to the council."
      ] })
    ] }),
    /* @__PURE__ */ d("p", { className: "text-bodymd", children: "After selecting the risk type(s) you've identified, describe the language or error in the report that has introduced this risk." }),
    /* @__PURE__ */ d(E2, { children: /* @__PURE__ */ d(et, { onClick: () => e(!1), variant: "outline", children: "Close" }) })
  ] }) });
}
function YJe({
  conversation: e,
  onChange: t,
  value: n
}) {
  var i;
  const r = Je(() => {
    var a;
    const o = [];
    return ((a = e == null ? void 0 : e.address_data) == null ? void 0 : a.state) === "QLD" ? o.push(
      {
        icon: /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ d(Vt, { value: "Accepted" }) }),
        bgColor: "data-[state=checked]:bg-successBgDefault",
        borderColor: "data-[state=checked]:border-successBorder",
        textColor: "data-[state=checked]:text-successText",
        value: "Accepted"
      },
      {
        icon: /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ d(Vt, { value: "Self assess" }) }),
        bgColor: "data-[state=checked]:bg-actionBgLight",
        borderColor: "data-[state=checked]:border-actionBorder",
        textColor: "data-[state=checked]:text-actionDefault",
        value: "Self assess"
      },
      {
        icon: /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ d(Vt, { value: "Code" }) }),
        bgColor: "data-[state=checked]:bg-warningBgLight",
        borderColor: "data-[state=checked]:border-warningBorder",
        textColor: "data-[state=checked]:text-warningText",
        value: "Code"
      },
      {
        icon: /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ d(Vt, { value: "Impact" }) }),
        bgColor: "data-[state=checked]:bg-warningBgLight",
        borderColor: "data-[state=checked]:border-warningBorder",
        textColor: "data-[state=checked]:text-warningText",
        value: "Impact"
      },
      {
        icon: /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ d(Vt, { value: "Permit required" }) }),
        bgColor: "data-[state=checked]:bg-warningBgLight",
        borderColor: "data-[state=checked]:border-warningBorder",
        textColor: "data-[state=checked]:text-warningText",
        value: "Permit required"
      },
      {
        icon: /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ d(Vt, { value: "Prohibited" }) }),
        bgColor: "data-[state=checked]:bg-destructiveBgDefault",
        borderColor: "data-[state=checked]:border-destructiveBorder",
        textColor: "data-[state=checked]:text-destructiveText",
        value: "Prohibited"
      }
    ) : o.push(
      {
        icon: /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ d(Vt, { value: "No permit required" }) }),
        bgColor: "data-[state=checked]:bg-successBgDefault",
        borderColor: "data-[state=checked]:border-successBorder",
        textColor: "data-[state=checked]:text-successText",
        value: "No permit required"
      },
      {
        icon: /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ d(Vt, { value: "More information required" }) }),
        bgColor: "data-[state=checked]:bg-actionBgLight",
        borderColor: "data-[state=checked]:border-actionBorder",
        textColor: "data-[state=checked]:text-actionDefault",
        value: "More information required"
      },
      {
        icon: /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ d(Vt, { value: "Permit required" }) }),
        bgColor: "data-[state=checked]:bg-warningBgLight",
        borderColor: "data-[state=checked]:border-warningBorder",
        textColor: "data-[state=checked]:text-warningText",
        value: "Permit required"
      },
      {
        icon: /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ d(Vt, { value: "Prohibited" }) }),
        bgColor: "data-[state=checked]:bg-destructiveBgDefault",
        borderColor: "data-[state=checked]:border-destructiveBorder",
        textColor: "data-[state=checked]:text-destructiveText",
        value: "Prohibited"
      }
    ), o.filter(
      (s) => s.value !== (e == null ? void 0 : e.report_outcome)
    );
  }, [(i = e == null ? void 0 : e.address_data) == null ? void 0 : i.state, e == null ? void 0 : e.report_outcome]);
  return /* @__PURE__ */ d(
    Dc,
    {
      className: "gap-1",
      radioValue: n,
      setRadioValue: t,
      options: r
    }
  );
}
function ZJe({
  conversation: e,
  onClickCancel: t,
  onSubmitSuccess: n,
  review: r
}) {
  const {
    mutate: i,
    isPending: o,
    reset: a
  } = Bg({
    onError(U) {
      console.error(
        "<ReviewPanelV3EditMode> useCreateConversationReview() onError()",
        U.message
      );
    },
    onSuccess() {
      console.log(
        "<ReviewPanelV3EditMode> useCreateConversationReview() onSuccess()"
      ), N(""), n();
    }
  }), s = e == null ? void 0 : e.id, l = /* @__PURE__ */ d(
    Vt,
    {
      value: e != null && e.report_outcome ? e.report_outcome : ""
    }
  ), [u, c] = re(""), [f, h] = re(""), [m, v] = re(""), [g, y] = re({
    monetary: !1,
    incorrectOrUnnecessaryDesignChange: !1,
    irreversibleActions: !1,
    reputational: !1
  }), [w, C] = re(""), [S, N] = re(""), [E, A] = re(""), [O, T] = re(""), [M, L] = re(!1), [I, j] = re({
    reportOutcome: "",
    reportRiskComment: ""
  }), B = () => {
    j({
      reportOutcome: "",
      reportRiskComment: ""
    });
  }, q = () => {
    B();
    let U = !0;
    return u === "" && (j((V) => ({
      ...V,
      reportOutcome: "This field is required"
    })), U = !1), ["Minor", "Yes"].includes(m) && w === "" && (j((V) => ({
      ...V,
      reportRiskComment: "This field is required"
    })), U = !1), U;
  };
  Pe(() => {
    r && La(r.review_data) && r.review_data.version === 3 && (c(r.review_data.report_outcome), h(
      r.review_data.report_outcome_expected
    ), v(r.review_data.report_risk), y(
      r.review_data.report_risk_types || {
        monetary: !1,
        incorrectOrUnnecessaryDesignChange: !1,
        irreversibleActions: !1,
        reputational: !1
      }
    ), C(r.review_data.report_risk_comment), N(r.review_data.comments), A(r.created_at || ""), T(r.created_by || ""));
  }, [r]);
  const G = () => {
    if (s && q()) {
      console.log("<ReviewPanelV3EditMode> Adding review.");
      const U = {
        version: 3,
        report_outcome: u,
        report_outcome_expected: f,
        report_risk: m,
        report_risk_types: g,
        report_risk_comment: w,
        comments: S
      };
      a(), i({
        path: { conversation_id: s },
        body: {
          review_data: U
        }
      });
    }
  };
  return /* @__PURE__ */ k("section", { className: "flex flex-col gap-y-5 text-bodymd font-semibold", children: [
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ k(
        "h3",
        {
          className: z(
            "flex",
            I.reportOutcome && "text-destructiveDefault"
          ),
          children: [
            "The result is ",
            /* @__PURE__ */ d("span", { className: "ml-1", children: l }),
            ", is this correct?"
          ]
        }
      ),
      /* @__PURE__ */ k("div", { className: "mt-2", children: [
        /* @__PURE__ */ d(
          $l,
          {
            radioValue: u,
            setRadioValue: (U) => {
              B(), c(U);
            },
            options: [
              {
                text: "Yes",
                icon: /* @__PURE__ */ d(gr, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              },
              {
                text: "No",
                icon: /* @__PURE__ */ d(mr, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              }
            ]
          }
        ),
        u === "No" ? /* @__PURE__ */ k("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ d(hi, {}),
          /* @__PURE__ */ k("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
            /* @__PURE__ */ d(qt, { children: "What should the result be?" }),
            /* @__PURE__ */ d(
              YJe,
              {
                conversation: e,
                onChange: h,
                value: f
              }
            )
          ] })
        ] }) : null,
        I.reportOutcome ? /* @__PURE__ */ d("div", { className: "text-destructiveDefault mt-2", children: I.reportOutcome }) : null
      ] })
    ] }),
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ d("h3", { children: "Has the report introduced risk to the customer or council?" }),
      /* @__PURE__ */ k("div", { className: "mt-2", children: [
        /* @__PURE__ */ d(
          Dc,
          {
            className: "gap-1",
            radioValue: m,
            setRadioValue: (U) => v(U),
            options: [
              {
                icon: /* @__PURE__ */ d("div", { className: "flex items-center py-2 pl-2 pr-3", children: /* @__PURE__ */ d(
                  "span",
                  {
                    className: `text-bodysm ${m === "No" ? "text-successText" : "text-textPrimary"} font-normal`,
                    children: "✅ No risk"
                  }
                ) }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText",
                value: "No"
              },
              {
                icon: /* @__PURE__ */ d("div", { className: "flex items-center py-2 pl-2 pr-3", children: /* @__PURE__ */ d(
                  "span",
                  {
                    className: `text-bodysm ${m === "Minor" ? "text-warningText" : "text-textPrimary"} font-normal`,
                    children: "⚠️ Yes, but it's only minor"
                  }
                ) }),
                bgColor: "data-[state=checked]:bg-warningBgDefault",
                borderColor: "data-[state=checked]:border-warningBorder",
                textColor: "data-[state=checked]:text-warningText",
                value: "Minor"
              },
              {
                icon: /* @__PURE__ */ d("div", { className: "flex items-center py-2 pl-2 pr-3", children: /* @__PURE__ */ d(
                  "span",
                  {
                    className: `text-bodysm ${m === "Yes" ? "text-destructiveText" : "text-textPrimary"} font-normal`,
                    children: "🚨 Yes, and it's potentially significant"
                  }
                ) }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText",
                value: "Yes"
              }
            ]
          }
        ),
        ["Minor", "Yes"].includes(m) ? /* @__PURE__ */ k("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ d(hi, {}),
          /* @__PURE__ */ k("div", { className: "mt-2 flex w-full flex-col gap-2", children: [
            /* @__PURE__ */ k("div", { className: "flex w-full justify-between", children: [
              /* @__PURE__ */ d(qt, { className: "text-bodymd text-textPrimary", children: "What type of risk has been introduced?" }),
              /* @__PURE__ */ k(
                et,
                {
                  className: "mt-[-4px] h-0 gap-1 pr-0",
                  onClick: () => {
                    L(!0);
                  },
                  variant: "link",
                  children: [
                    /* @__PURE__ */ d(uce, { className: "h-5 w-5" }),
                    "Risk types"
                  ]
                }
              ),
              /* @__PURE__ */ d(
                KJe,
                {
                  onOpenChange: L,
                  open: M
                }
              )
            ] }),
            /* @__PURE__ */ k("div", { className: "flex flex-col gap-1", children: [
              /* @__PURE__ */ k("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ d(
                  Ol,
                  {
                    id: "reportRiskMonetary",
                    checked: g.monetary,
                    onCheckedChange: (U) => {
                      y((V) => ({
                        ...V,
                        monetary: !!U
                      }));
                    },
                    name: "monetary"
                  }
                ),
                /* @__PURE__ */ d(qt, { htmlFor: "reportRiskMonetary", children: "Monetary" })
              ] }),
              /* @__PURE__ */ k("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ d(
                  Ol,
                  {
                    id: "reportRiskIncorrectOrUnnecessaryDesignChange",
                    checked: g.incorrectOrUnnecessaryDesignChange,
                    onCheckedChange: (U) => {
                      y((V) => ({
                        ...V,
                        incorrectOrUnnecessaryDesignChange: !!U
                      }));
                    }
                  }
                ),
                /* @__PURE__ */ d(qt, { htmlFor: "reportRiskIncorrectOrUnnecessaryDesignChange", children: "Incorrect or unnecessary design changes" })
              ] }),
              /* @__PURE__ */ k("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ d(
                  Ol,
                  {
                    id: "reportRiskIrreversibleActions",
                    checked: g.irreversibleActions,
                    onCheckedChange: (U) => {
                      y((V) => ({
                        ...V,
                        irreversibleActions: !!U
                      }));
                    }
                  }
                ),
                /* @__PURE__ */ d(qt, { htmlFor: "reportRiskIrreversibleActions", children: "Irreversible actions" })
              ] }),
              /* @__PURE__ */ k("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ d(
                  Ol,
                  {
                    id: "reportRiskReputational",
                    checked: g.reputational,
                    onCheckedChange: (U) => {
                      y((V) => ({
                        ...V,
                        reputational: !!U
                      }));
                    }
                  }
                ),
                /* @__PURE__ */ d(qt, { htmlFor: "reportRiskReputational", children: "Reputational" })
              ] })
            ] }),
            /* @__PURE__ */ d(
              qt,
              {
                className: z(
                  "mt-1",
                  I.reportRiskComment && "text-destructiveDefault"
                ),
                children: "Describe the risk"
              }
            ),
            /* @__PURE__ */ d(
              Pa,
              {
                className: "border-interactiveBorder focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-bodymd font-normal focus:outline-0",
                onChange: (U) => {
                  B(), C(U.target.value);
                },
                placeholder: "Enter response",
                tabIndex: 1,
                value: w
              }
            ),
            I.reportRiskComment ? /* @__PURE__ */ d("div", { className: "text-destructiveDefault", children: I.reportRiskComment }) : null
          ] })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ d("h3", { children: "Feedback on zone and overlay reasoning" }),
      /* @__PURE__ */ d("span", { className: "text-textSubdued inline-block text-bodysm font-normal", children: "Write your response against each applicable zone and overlay, e.g. “Zone: <comment>, BMO: <comment>, SLO: <comment>”." }),
      /* @__PURE__ */ d("div", { className: "mt-1", children: /* @__PURE__ */ d(
        Pa,
        {
          className: `${S === "" ? "border-interactiveBorder" : "border-interactiveBorderSelect"} focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-bodymd font-normal focus:outline-0`,
          onChange: (U) => {
            N(U.target.value);
          },
          placeholder: "Enter response",
          tabIndex: 1,
          value: S
        }
      ) })
    ] }),
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ k("div", { className: "flex w-full flex-row justify-end gap-x-2", children: [
        E ? /* @__PURE__ */ d(
          et,
          {
            className: "text-actionDefault border-actionDefault",
            onClick: t,
            tabIndex: 1,
            variant: "outline",
            children: "Cancel"
          }
        ) : null,
        /* @__PURE__ */ k(
          et,
          {
            disabled: o,
            onClick: G,
            tabIndex: 1,
            variant: "default",
            children: [
              o && /* @__PURE__ */ d(Xo, { className: "mr-2 h-4 w-4 animate-spin" }),
              o ? "Submitting" : "Submit review"
            ]
          }
        )
      ] }),
      E ? /* @__PURE__ */ d("div", { className: "mt-2 flex w-full flex-row justify-end", children: /* @__PURE__ */ k("p", { className: "text-textSubdued text-bodysm font-normal", children: [
        "Previously updated by ",
        /* @__PURE__ */ d("span", { className: "text-textPrimary", children: O }),
        " on " + jo(E).replace(",", " at")
      ] }) }) : null
    ] })
  ] });
}
function nB({
  conversation: e,
  onSubmitSuccess: t
}) {
  const n = Fg({ conversation: e }), r = n.at(-1), [i, o] = re(""), [a, s] = re(""), [l, u] = re(""), [c, f] = re({
    monetary: !1,
    incorrectOrUnnecessaryDesignChange: !1,
    irreversibleActions: !1,
    reputational: !1
  }), [h, m] = re(""), [v, g] = re(""), [y, w] = re(""), [C, S] = re(""), [N, E] = re(n.length === 0);
  Pe(() => {
    n.length > 0 && E(!1);
  }, [n.length]), Pe(() => {
    r && La(r.review_data) && r.review_data.version === 3 && (console.log("<ReviewPanelV3> currentReview:", r), o(r.review_data.report_outcome), s(
      r.review_data.report_outcome_expected
    ), u(r.review_data.report_risk), f(
      r.review_data.report_risk_types || {
        monetary: !1,
        incorrectOrUnnecessaryDesignChange: !1,
        irreversibleActions: !1,
        reputational: !1
      }
    ), m(r.review_data.report_risk_comment), g(r.review_data.comments), w(r.created_at || ""), S(r.created_by_email || ""));
  }, [r]);
  const A = () => {
    const L = [];
    return c.monetary && L.push("Monetary"), c.incorrectOrUnnecessaryDesignChange && L.push("Incorrect or unnecessary design change"), c.irreversibleActions && L.push("Irreversible actions"), c.reputational && L.push("Reputational"), /* @__PURE__ */ k("div", { className: "mt-2 flex pl-1", children: [
      /* @__PURE__ */ d(hi, {}),
      /* @__PURE__ */ k("div", { className: "mt-2 flex w-full flex-col", children: [
        /* @__PURE__ */ d(qt, { className: "text-bodymd text-textPrimary", children: "What type of risk has been introduced?" }),
        L.length > 0 ? /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm", children: L.join(", ") }) : /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." }),
        /* @__PURE__ */ d(qt, { className: "text-bodymd text-textPrimary mt-3", children: "Describe the risk" }),
        h ? /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm", children: /* @__PURE__ */ d(au, { comment: h }) }) : /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." })
      ] })
    ] });
  }, O = () => i === "Yes" ? /* @__PURE__ */ k("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ d(gr, { className: "text-successText h-4 w-4" }),
    /* @__PURE__ */ d("p", { className: "text-successText ml-1.5 text-bodysm font-normal", children: "Yes" })
  ] }) : i === "No" ? /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ k("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ d(mr, { className: "text-destructiveText h-4 w-4" }),
      /* @__PURE__ */ d("p", { className: "text-destructiveText ml-1.5 text-bodysm font-normal", children: "No" })
    ] }),
    /* @__PURE__ */ k("div", { className: "mt-2 flex pl-1", children: [
      /* @__PURE__ */ d(hi, {}),
      /* @__PURE__ */ k("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
        /* @__PURE__ */ d(qt, { children: "What should the result be?" }),
        a ? /* @__PURE__ */ d(Vt, { value: a }) : /* @__PURE__ */ d("span", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." })
      ] })
    ] })
  ] }) : /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), T = () => l === "No" ? /* @__PURE__ */ d("div", { className: "flex items-center", children: /* @__PURE__ */ d("span", { className: "text-successText text-bodysm font-normal", children: "✅ No risk" }) }) : l === "Minor" ? /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ d("div", { className: "flex items-center", children: /* @__PURE__ */ d("span", { className: " text-warningText text-bodysm font-normal", children: "⚠️ Yes, but it's only minor" }) }),
    A()
  ] }) : l === "Yes" ? /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ d("div", { className: "flex items-center", children: /* @__PURE__ */ d("span", { className: " text-destructiveText text-bodysm font-normal", children: "🚨 Yes, and it's potentially significant" }) }),
    A()
  ] }) : /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), M = () => {
    const L = /* @__PURE__ */ d(
      Vt,
      {
        value: e != null && e.report_outcome ? e.report_outcome : ""
      }
    );
    return /* @__PURE__ */ k("section", { className: "flex flex-col gap-y-5 text-bodymd font-semibold", children: [
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ k("h3", { className: "flex", children: [
          "The result is ",
          /* @__PURE__ */ d("span", { className: "ml-1", children: L }),
          ", is this correct?"
        ] }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: O() })
      ] }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("h3", { children: "Has the report introduced risk to the customer or council?" }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: T() })
      ] }),
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("h3", { children: "Feedback on zone and overlay reasoning" }),
        /* @__PURE__ */ d("div", { className: "mt-2", children: v === "" ? /* @__PURE__ */ d("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." }) : /* @__PURE__ */ d("p", { className: "text-wrap break-all text-bodymd font-normal", children: /* @__PURE__ */ d(au, { comment: v }) }) })
      ] }),
      /* @__PURE__ */ d("div", { className: "border-interfaceBorder w-full border-t" }),
      /* @__PURE__ */ k("div", { className: "flex flex-col gap-y-1", children: [
        /* @__PURE__ */ k(
          "button",
          {
            onClick: () => E(!0),
            className: "text-textLink flex flex-row items-center text-bodysm font-normal underline",
            children: [
              /* @__PURE__ */ d(Mv, { className: "h-4 w-4" }),
              /* @__PURE__ */ d("p", { className: "ml-1", children: "Edit review" })
            ]
          }
        ),
        /* @__PURE__ */ k("p", { className: "text-textSubdued text-bodysm font-normal", children: [
          "Last updated " + jo(y).replace(",", " at") + " by ",
          /* @__PURE__ */ d("span", { className: "text-textPrimary", children: C })
        ] })
      ] })
    ] });
  };
  return /* @__PURE__ */ k("div", { className: "bg-interfaceWhite border-interfaceBorder text-textPrimary flex flex-col rounded-lg border p-8", children: [
    n.length === 0 || N ? /* @__PURE__ */ d(
      ZJe,
      {
        review: r,
        conversation: e,
        onClickCancel: () => E(!1),
        onSubmitSuccess: () => {
          E(!1), t == null || t();
        }
      }
    ) : null,
    n.length > 0 && !N ? M() : null
  ] });
}
function zet({
  conversation: e,
  noticeboard: t,
  onSubmitSuccess: n
}) {
  const r = e == null ? void 0 : e.id, i = Fg({ conversation: e }), o = i.at(-1);
  if (i.length > 0 && o && !La(o == null ? void 0 : o.review_data))
    return /* @__PURE__ */ d(
      zJe,
      {
        conversationId: r || "",
        onSubmitSuccess: n,
        reviews: i
      }
    );
  if (i.length > 0 && o && La(o.review_data))
    switch (console.log("<ReviewPanel> currentReview", o), o.review_data.version) {
      case 1:
        return /* @__PURE__ */ d(
          HJe,
          {
            conversation: e,
            noticeboard: t,
            onSubmitSuccess: n
          }
        );
      case 2:
        return /* @__PURE__ */ d(
          GJe,
          {
            conversation: e,
            onSubmitSuccess: n
          }
        );
      case 3:
        return /* @__PURE__ */ d(
          nB,
          {
            conversation: e,
            onSubmitSuccess: n
          }
        );
    }
  return /* @__PURE__ */ d(
    nB,
    {
      conversation: e,
      onSubmitSuccess: n
    }
  );
}
function Wet({
  checked: e,
  language: t,
  onChange: n
}) {
  return /* @__PURE__ */ k("div", { className: "text-bodymd flex items-center gap-1", children: [
    /* @__PURE__ */ d(
      Np,
      {
        checked: e,
        className: "!data-[state=unchecked]:bg-interactiveBorder !w-5.5 !h-3 border-none",
        onCheckedChange: n,
        thumbClassName: "!h-2 !w-2 data-[state=checked]:!translate-x-3 data-[state=unchecked]:!translate-x-0.5"
      }
    ),
    "View in users selected language (",
    aB(t),
    ")"
  ] });
}
function Het({
  conversation: e,
  publicReportLink: t
}) {
  var a, s, l, u, c;
  const { getLocalisationEntry: n } = ar(e), r = n("councilName"), i = e != null && e.language && (e == null ? void 0 : e.language) !== "en" ? e.language : "", o = () => {
    if (e != null && e.updated_at && (e != null && e.created_at)) {
      const f = Eue(
        new Date(e == null ? void 0 : e.updated_at),
        new Date(e == null ? void 0 : e.created_at)
      );
      let h = "";
      return f.days !== 0 && (h = h + f.days.toString() + " days "), f.minutes !== 0 && (h = h + f.minutes.toString() + " minutes "), h;
    }
    return "N/A";
  };
  return /* @__PURE__ */ k("div", { className: "flex h-full min-h-0 flex-col gap-y-6", children: [
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ d("h3", { className: "mb-0.5 font-semibold", children: "User" }),
      e != null && e.user_email ? /* @__PURE__ */ d(
        "a",
        {
          className: "text-textLink flex cursor-pointer flex-row underline",
          href: `mailto:${e.user_email}?subject=${r}%2planning%2enquiry%2follow-up`,
          rel: "noreferrer",
          tabIndex: 0,
          target: "_blank",
          children: e.user_email
        }
      ) : /* @__PURE__ */ d("p", { children: '"N/A"' })
    ] }),
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ d("h3", { className: "mb-0.5 font-semibold", children: "Feedback consent" }),
      /* @__PURE__ */ d("p", { children: e != null && e.user_consent ? "Yes" : "No" })
    ] }),
    i && /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ d("h3", { className: "mb-0.5 font-semibold", children: "Language" }),
      /* @__PURE__ */ d("p", { children: aB(i) })
    ] }),
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ d("h3", { className: "mb-0.5 font-semibold", children: "ID" }),
      /* @__PURE__ */ d("p", { children: ((a = e == null ? void 0 : e.identifier) == null ? void 0 : a.toUpperCase()) || "N/A" })
    ] }),
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ d("h3", { className: "mb-0.5 font-semibold", children: "State" }),
      /* @__PURE__ */ d(QJe, { value: e != null && e.state ? e.state : "" })
    ] }),
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ d("h3", { className: "mb-0.5 font-semibold", children: "Public report link" }),
      ["report_ready", "saved_report", "sent_to_council"].includes(
        (e == null ? void 0 : e.phase) || ""
      ) ? /* @__PURE__ */ d(
        "a",
        {
          href: `${t}${(s = e == null ? void 0 : e.identifier) == null ? void 0 : s.toUpperCase()}`,
          target: "_blank",
          className: "text-textLink hover:text-textLinkHover flex flex-row underline",
          children: `${t}${(l = e == null ? void 0 : e.identifier) == null ? void 0 : l.toUpperCase()}`
        }
      ) : /* @__PURE__ */ d("p", { children: "---" })
    ] }),
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ d("h3", { className: "mb-1 font-semibold", children: "Time and duration" }),
      /* @__PURE__ */ d("table", { className: "w-full text-left text-bodymd font-normal", children: /* @__PURE__ */ k("tbody", { children: [
        /* @__PURE__ */ k("tr", { className: "border-interfaceBorder w-full border-b", children: [
          /* @__PURE__ */ d("th", { className: "border-interfaceBorder w-1/2 border-r py-2 ", children: "Started" }),
          /* @__PURE__ */ d("td", { className: "w-1/2 py-2 pl-3", children: jo(e == null ? void 0 : e.created_at) })
        ] }),
        /* @__PURE__ */ k("tr", { className: "border-interfaceBorder w-full border-b", children: [
          /* @__PURE__ */ d("th", { className: "border-interfaceBorder w-1/2 border-r py-2 ", children: "Last interaction" }),
          /* @__PURE__ */ d("td", { className: "w-1/2 py-2 pl-3", children: jo(e == null ? void 0 : e.updated_at) })
        ] }),
        /* @__PURE__ */ k("tr", { className: "w-full", children: [
          /* @__PURE__ */ d("th", { className: "border-interfaceBorder w-1/2 border-r py-2 ", children: "Duration" }),
          /* @__PURE__ */ d("td", { className: "w-1/2 py-2 pl-3", children: o() })
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ d("h3", { className: "mb-0.5 font-semibold", children: "Ordinance" }),
      e != null && e.report_ordinance_version ? /* @__PURE__ */ d("p", { className: "text-bodymd", children: "Outcome determined using planning legislation accessed on " + ((u = jA((e == null ? void 0 : e.report_ordinance_version) || "")) == null ? void 0 : u.date) + " (version " + ((c = jA((e == null ? void 0 : e.report_ordinance_version) || "")) == null ? void 0 : c.version) + ")." }) : /* @__PURE__ */ d("p", { children: "---" })
    ] })
  ] });
}
const XJe = {
  microsoft: /* @__PURE__ */ d(Tqe, {}),
  google: /* @__PURE__ */ d(Pqe, {})
};
function Uet({
  disabled: e,
  socialApps: t,
  action: n = "login"
}) {
  const r = n === "signup" ? "Sign up with" : "Log in with";
  return /* @__PURE__ */ d("div", { className: "flex gap-3", children: t.map((i) => {
    const o = XJe[i.provider];
    return /* @__PURE__ */ d("a", { href: i.login_url, className: "grow", children: /* @__PURE__ */ k(
      et,
      {
        className: "text-bodymd mt-1 w-full rounded-sm px-4 py-2 text-black",
        disabled: e,
        variant: "outline",
        children: [
          o ? /* @__PURE__ */ d("span", { className: "mr-2", children: o }) : null,
          " ",
          r,
          " ",
          i.name
        ]
      },
      i.provider
    ) }, i.provider);
  }) });
}
const JJe = {
  rippling: /* @__PURE__ */ d(Rqe, {})
};
function Get({ disabled: e, ssoApp: t }) {
  if (!t)
    return null;
  const n = JJe[t.provider];
  return /* @__PURE__ */ d("div", { className: "flex gap-3", children: /* @__PURE__ */ d("a", { href: t.login_url, className: "grow", children: /* @__PURE__ */ k(
    et,
    {
      className: "text-bodymd mt-1 w-full rounded-sm px-4 py-2 text-black",
      disabled: e,
      variant: "outline",
      children: [
        n ? /* @__PURE__ */ d("span", { className: "mr-2", children: n }) : null,
        " Log in with",
        " ",
        t.name
      ]
    },
    t.provider
  ) }, t.provider) });
}
function Ket({ value: e }) {
  let t = e, n = !1, r = "text-textPrimary", i = "", o = "";
  switch (t) {
    case "Internal":
      r = "text-blueDefault", i = "bg-blueBgLight", o = "border-blueBorder";
      break;
    case "Council":
      r = "text-greenDefault", i = "bg-greenBgLight", o = "border-greenBorder";
      break;
    case null:
      n = !0;
      break;
    case "":
      n = !0;
      break;
  }
  return n ? "---" : /* @__PURE__ */ d(
    "div",
    {
      className: `${r} ${i} ${o} w-min whitespace-nowrap rounded-xl border px-3 text-bodysm font-medium`,
      children: t
    }
  );
}
function Vt({ value: e }) {
  let t = e, n = !1, r = "text-textPrimary", i = "", o = "";
  switch (t) {
    //
    // generic outcomes
    //
    case "No permit required":
      t = "Permit not required", r = "text-successText", i = "bg-successBgLight", o = "border-successBorder";
      break;
    case "More information required":
      t = "Exemptions may apply", r = "text-actionDefault", i = "bg-actionBgLight", o = "border-actionBorder";
      break;
    case "Permit required":
      r = "text-warningText", i = "bg-warningBgLight", o = "border-warningBorder";
      break;
    case "Prohibited":
      r = "text-destructiveText", i = "bg-destructiveBgLight", o = "border-destructiveBorder";
      break;
    //
    // council specific outcomes
    // SSC
    //
    case "Accepted":
      r = "text-successText", i = "bg-successBgLight", o = "border-successBorder";
      break;
    case "Self assess":
      r = "text-actionDefault", i = "bg-actionBgLight", o = "border-actionBorder";
      break;
    case "Code":
      r = "text-warningText", i = "bg-warningBgLight", o = "border-warningBorder";
      break;
    case "Impact":
      r = "text-warningText", i = "bg-warningBgLight", o = "border-warningBorder";
      break;
    case null:
      n = !0;
      break;
    case "":
      n = !0;
  }
  return n ? "---" : /* @__PURE__ */ d(
    "div",
    {
      className: z(
        "w-min rounded-xl border px-3 text-bodysm font-medium whitespace-nowrap",
        r,
        i,
        o
      ),
      children: t
    }
  );
}
function Yet({ value: e }) {
  let t = e, n = !1, r = "text-textPrimary", i = "", o = "";
  switch (t) {
    case "No priority":
      r = "text-gray-500", i = "bg-gray-100", o = "border-gray-300";
      break;
    case "Low":
      r = "text-successText", i = "bg-successBgLight", o = "border-successBorder";
      break;
    case "Medium":
      r = "text-actionDefault", i = "bg-actionBgLight", o = "border-actionBorder";
      break;
    case "High":
      r = "text-warningText", i = "bg-warningBgLight", o = "border-warningBorder";
      break;
    case "Urgent":
      r = "text-destructiveText", i = "bg-destructiveBgLight", o = "border-destructiveBorder";
      break;
    case null:
      n = !0;
      break;
    case "":
      n = !0;
      break;
  }
  return n ? "---" : /* @__PURE__ */ d(
    "div",
    {
      className: `${r} ${i} ${o} w-min whitespace-nowrap rounded-xl border px-3 text-bodysm font-medium`,
      children: t
    }
  );
}
function Zet({ value: e }) {
  let t = e, n = "text-textPrimary", r = "", i = "";
  return t === !0 || t === "True" ? (t = "Yes", n = "text-successText", r = "bg-successBgLight", i = "border-successBorder") : (t = "No", n = "text-textSubdued", r = "bg-interfaceTags", i = "border-interactiveBorder"), /* @__PURE__ */ d(
    "div",
    {
      className: `${n} ${r} ${i} w-min whitespace-nowrap rounded-xl border px-3 text-bodysm font-medium`,
      children: t
    }
  );
}
function Xet({ value: e }) {
  let t = e, n = "text-textPrimary", r = "", i = "";
  return t === !0 || t === "True" ? (t = "🚩 Yes", n = "text-redText", r = "bg-redBgLight", i = "border-redBorder") : (t = "No", n = "text-textSubdued", r = "bg-interfaceTags", i = "border-interactiveBorder"), /* @__PURE__ */ d(
    "div",
    {
      className: `${n} ${r} ${i} w-min whitespace-nowrap rounded-xl border px-3 text-bodysm font-medium`,
      children: t
    }
  );
}
function Jet({ value: e }) {
  let t = e, n = !1, r = "", i = "", o = "";
  return t === "Non-blocking" ? (r = "text-textSubdued", i = "bg-interfaceBgLight", o = "border-interfaceBorder") : t === "Blocking" ? (r = "text-destructiveText", i = "bg-destructiveBgLight", o = "border-destructiveBorder") : t == null ? n = !0 : (r = "text-textPrimary", i = "bg-interfaceBgLight", o = "border-interfaceBorder"), n ? "---" : /* @__PURE__ */ d(
    "div",
    {
      className: `${r} ${i} ${o} w-min rounded-xl border px-3 text-bodysm font-medium whitespace-nowrap`,
      children: t
    }
  );
}
function Qet({ value: e }) {
  let t = e, n = !1, r = "text-textPrimary", i = "", o = "";
  return t === "sent_to_council" ? (t = "Complete", r = "text-successText", i = "bg-successBgLight", o = "border-successBorder") : t === "saved_report" ? (t = "Review requested", r = "text-[#3A0075]", i = "bg-[#F8F3FF]", o = "border-[#D2B7FF]") : ["report_ready"].includes(t) ? (t = "Draft", r = "text-warningText", i = "bg-warningBgLight", o = "border-warningBorder") : t === "discarded" ? (t = "Discarded", r = "text-textSubdued", i = "bg-interfaceTags", o = "border-interactiveBorder") : t === null ? n = !0 : (t = "In progress", r = "text-actionPress", i = "bg-actionBgLight", o = "border-actionBorder"), n ? "---" : /* @__PURE__ */ d(
    "div",
    {
      className: `${r} ${i} ${o} w-min whitespace-nowrap rounded-xl border px-3 text-bodysm font-medium`,
      children: t
    }
  );
}
function QJe({ value: e }) {
  let t = e, n = !1, r = "text-textPrimary", i = "", o = "";
  return e === "in_progress" ? (t = "In progress", r = "text-actionPress", i = "bg-actionBgLight", o = "border-actionBorder") : e === "draft" ? (t = "Draft", r = "text-warningText", i = "bg-warningBgLight", o = "border-warningBorder") : e === "completed" ? (t = "Complete", r = "text-successText", i = "bg-successBgLight", o = "border-successBorder") : e === "error" ? (t = "Error", r = "text-destructiveText", i = "bg-destructiveBgLight", o = "border-destructiveBorder") : e === "stuck" ? (t = "Stuck", r = "text-destructiveText", i = "bg-destructiveBgLight", o = "border-destructiveBorder") : e === "abandoned" ? (t = "Abandoned", r = "text-textPrimary", i = "bg-interfaceBorder", o = "border-interfaceBorder") : e === "discarded" ? (t = "Discarded", r = "text-textPrimary", i = "bg-interfaceTags", o = "border-interfaceTags") : e === "off_topic" ? (t = "Blocked", r = "text-[#3A0075]", i = "bg-[#F8F3FF]", o = "border-[#D2B7FF]") : e ? (t = "In progress", r = "text-actionPress", i = "bg-actionBgLight", o = "border-actionBorder") : n = !0, n ? "---" : /* @__PURE__ */ d(
    "div",
    {
      className: `${r} ${i} ${o} text-bodysm w-min whitespace-nowrap rounded-xl border px-3 font-medium`,
      children: t
    }
  );
}
function ett({ value: e }) {
  let t = e, n = !1, r = "", i = "", o = "";
  return t === "Backlog" ? (r = "text-textSubdued", i = "bg-interfaceBgLight", o = "border-interfaceBorder") : t === "To Do" ? (r = "text-blueText", i = "bg-blueBgLight", o = "border-blueBorder") : t === "In Progress" ? (r = "text-actionPress", i = "bg-actionBgLight", o = "border-actionBorder") : t === "Clarification Required" ? (r = "text-destructiveText", i = "bg-destructiveBgLight", o = "border-destructiveBorder") : t === "Wont Do" ? (r = "text-purpleText", i = "bg-purpleBgLight", o = "border-purpleBorder") : t === "Not An Issue" ? (r = "text-yellowText", i = "bg-yellowBgLight", o = "border-yellowBorder") : t === "Resolved" ? (r = "text-successText", i = "bg-successBgLight", o = "border-successBorder") : t == null ? n = !0 : (r = "text-textPrimary", i = "bg-interfaceBgLight", o = "border-interfaceBorder"), n ? "---" : /* @__PURE__ */ d(
    "div",
    {
      className: `${r} ${i} ${o} w-min whitespace-nowrap rounded-xl border px-3 text-body font-medium`,
      children: t
    }
  );
}
function ttt({ value: e }) {
  let t = "text-textPrimary", n = "", r = "", i;
  return e ? (i = "Yes", t = "text-successText", n = "bg-successBgLight", r = "border-successBorder") : (i = "No", t = "text-destructiveText", n = "bg-destructiveBgLight", r = "border-destructiveBorder"), /* @__PURE__ */ d(
    "div",
    {
      className: `${t} ${n} ${r} w-min whitespace-nowrap rounded-xl border px-3 text-bodysm font-medium`,
      children: i
    }
  );
}
export {
  zo as Accordion,
  co as AccordionContent,
  lo as AccordionItem,
  uo as AccordionTrigger,
  SQe as AddressAutoCompleteInput,
  phe as Alert,
  ghe as AlertDescription,
  Jpe as AlertDialog,
  eV as AlertDialogAction,
  n0e as AlertDialogCancel,
  Xj as AlertDialogContent,
  t0e as AlertDialogDescription,
  Jj as AlertDialogFooter,
  e0e as AlertDialogHeader,
  Zj as AlertDialogOverlay,
  Qpe as AlertDialogPortal,
  Qj as AlertDialogTitle,
  EQe as AlertDialogTrigger,
  mhe as AlertTitle,
  Ew as AnalysisCallout,
  Du as AnalysisCalloutType,
  xQe as AnalysisReport,
  wQe as AnalysisReportAggregated,
  Cet as AnalyticsDashboard,
  NQe as AnimatedText,
  vQe as ApplicationRequirementsReport,
  yet as AssessmentReport,
  bet as AssessmentReportDemo,
  xet as AssessmentReportFastEnquiry,
  tV as AutoResizeTextarea,
  Tn as Badge,
  Net as BaysideCityCouncilLogo,
  Aet as BoroondaraCityCouncilLogo,
  et as Button,
  eC as Calendar,
  AQe as CallOut,
  Pt as Card,
  Mt as CardContent,
  ir as CardDescription,
  tC as CardFooter,
  Tt as CardHeader,
  Lt as CardTitle,
  Ol as Checkbox,
  kQe as CheckboxGroup,
  DQe as Collapsible,
  $Qe as CollapsibleContent,
  IQe as CollapsibleTrigger,
  LQe as ColumnVisibility,
  PQe as Combobox,
  xd as Command,
  MQe as CommandDialog,
  cC as CommandEmpty,
  dp as CommandGroup,
  WV as CommandInput,
  fp as CommandItem,
  cp as CommandList,
  sr as CommandPrimitive,
  v2e as CommandSeparator,
  y2e as CommandShortcut,
  _et as ConversationProgressIndicator,
  Eqe as CouncilsDropdown,
  BQe as DataTable,
  Eve as DataTablePagination,
  Vr as DataTile,
  vbe as DatePickerWithRange,
  Met as DeleteTreeIcon,
  _2 as Dialog,
  GQe as DialogClose,
  vp as DialogContent,
  n3e as DialogDescription,
  E2 as DialogFooter,
  t3e as DialogHeader,
  Az as DialogOverlay,
  e3e as DialogPortal,
  N2 as DialogTitle,
  UQe as DialogTrigger,
  i3e as DraftWatermarkOverlay,
  YQe as DropdownMenu,
  Q6e as DropdownMenuCheckboxItem,
  X6e as DropdownMenuContent,
  XQe as DropdownMenuGroup,
  J6e as DropdownMenuItem,
  t5e as DropdownMenuLabel,
  JQe as DropdownMenuPortal,
  eet as DropdownMenuRadioGroup,
  e5e as DropdownMenuRadioItem,
  n5e as DropdownMenuSeparator,
  r5e as DropdownMenuShortcut,
  QQe as DropdownMenuSub,
  Z6e as DropdownMenuSubContent,
  Y6e as DropdownMenuSubTrigger,
  ZQe as DropdownMenuTrigger,
  Ret as DuplicateTreeIcon,
  wet as EmptyAssessmentReport,
  Oet as ExternalLinkIcon,
  E1 as FilterType,
  Eet as Filters,
  a5e as FormControl,
  s5e as FormDescription,
  tet as FormField,
  sH as FormFieldContext,
  i5e as FormItem,
  lH as FormItemContext,
  o5e as FormLabel,
  l5e as FormMessage,
  itt as FormProvider,
  Pqe as GoogleSocialLoginLogo,
  Iet as GridLoader,
  $l as HorizontalRadioGroup,
  Mv as IconEdit,
  YC as Input,
  D5e as Input2,
  Ket as IssueTypeTag,
  qt as Label,
  jet as MapComponent,
  Bet as MarkdownEditor,
  Tqe as MicrosoftSocialLoginLogo,
  bQe as MissingInformationReport,
  ket as MorningtonPeninsulaShireCouncilLogo,
  TH as MultiSelect,
  Pet as MyLotLogoBlue,
  x8e as NavigationMenu,
  _8e as NavigationMenuContent,
  E8e as NavigationMenuIndicator,
  iet as NavigationMenuItem,
  oet as NavigationMenuLink,
  w8e as NavigationMenuList,
  S8e as NavigationMenuTrigger,
  uU as NavigationMenuViewport,
  Vt as OutcomeTag,
  oq as Pagination,
  aq as PaginationContent,
  uq as PaginationEllipsis,
  Ef as PaginationItem,
  jQe as PaginationLabel,
  r2 as PaginationLink,
  lq as PaginationNext,
  sq as PaginationPrevious,
  yQe as PermitRequirementsReport,
  g2 as Popover,
  zQe as PopoverAnchor,
  mp as PopoverContent,
  v2 as PopoverTrigger,
  Yet as PriorityTag,
  Vet as ProgressIndicatorList,
  X1 as ProgressIndicatorListStatus,
  qet as PublicConversation,
  O8e as RadioBoxCircle,
  N8e as RadioGroup,
  A8e as RadioGroupItem,
  cU as RadioMultiSelect,
  qJe as ReasoningPanel,
  Cqe as RenderChart,
  txe as ReviewCheckboxGroup,
  Xet as ReviewNeededTag,
  zet as ReviewPanel,
  zJe as ReviewPanelV0,
  HJe as ReviewPanelV1,
  Zet as ReviewedTag,
  Rqe as RipplingIcon,
  Get as SSOButton,
  xxe as ScrollArea,
  FU as ScrollBar,
  d9e as Select,
  WG as SelectContent,
  cet as SelectGroup,
  c7 as SelectItem,
  h9e as SelectLabel,
  p9e as SelectSeparator,
  zG as SelectTrigger,
  f9e as SelectValue,
  Wet as SelectedLanguageToggle,
  eu as Separator,
  Het as SessionPanel,
  Jet as SeverityTag,
  GG as Sheet,
  det as SheetClose,
  fS as SheetContent,
  C9e as SheetDescription,
  YG as SheetFooter,
  w9e as SheetHeader,
  KG as SheetOverlay,
  b9e as SheetPortal,
  ZG as SheetTitle,
  y9e as SheetTrigger,
  Nt as ShowMore,
  R9e as Sidebar,
  V9e as SidebarContent,
  B9e as SidebarFooter,
  q9e as SidebarGroup,
  W9e as SidebarGroupAction,
  H9e as SidebarGroupContent,
  z9e as SidebarGroupLabel,
  F9e as SidebarHeader,
  L9e as SidebarInput,
  $9e as SidebarInset,
  U9e as SidebarMenu,
  Z9e as SidebarMenuAction,
  X9e as SidebarMenuBadge,
  Y9e as SidebarMenuButton,
  G9e as SidebarMenuItem,
  J9e as SidebarMenuSkeleton,
  Q9e as SidebarMenuSub,
  twe as SidebarMenuSubButton,
  ewe as SidebarMenuSubItem,
  M9e as SidebarProvider,
  I9e as SidebarRail,
  j9e as SidebarSeparator,
  D9e as SidebarTrigger,
  me as Skeleton,
  Cwe as Slider,
  Uet as SocialLoginButtons,
  Qet as StageTag,
  QJe as StateTag,
  ett as StatusTag,
  hi as SubdirectoryArrowRightIcon,
  Tet as SunshineCoastCouncilLogo,
  Np as Switch,
  wd as Table,
  Sd as TableBody,
  Sve as TableCaption,
  Fe as TableCell,
  Cve as TableFooter,
  jt as TableHead,
  Cd as TableHeader,
  rr as TableRow,
  Ea as Tabs,
  Mn as TabsContent,
  Ro as TabsList,
  jn as TabsTrigger,
  Owe as Tag,
  que as TemplateRenderer,
  Rwe as Textarea,
  kwe as TimeLine,
  iY as Toast,
  cCe as ToastAction,
  oY as ToastClose,
  sY as ToastDescription,
  lCe as ToastProvider,
  aY as ToastTitle,
  rY as ToastViewport,
  get as Toaster,
  yCe as Toggle,
  BY as Tooltip,
  VY as TooltipContent,
  NS as TooltipProvider,
  jY as TooltipTrigger,
  Mqe as UngroupIcon,
  Dc as VerticalRadioGroup,
  PSe as VerticalReasoningCorrectnessRadioGroup,
  Det as WorldIcon,
  ttt as YesNoTag,
  _0e as badgeVariants,
  Ac as buttonVariants,
  FQe as createColumnHelper,
  jJe as defaultReasoningPanelSections,
  R5e as input2Variants,
  C8e as navigationMenuTriggerStyle,
  pCe as reducer,
  mCe as toast,
  vCe as toggleVariants,
  ott as useController,
  VQe as useDataTablePagination,
  bfe as useDesignAndSittingClause,
  att as useFieldArray,
  stt as useForm,
  ltt as useFormContext,
  T2 as useFormField,
  mfe as useGetApplicationRequirements,
  gQe as useGetFeaturesInTesting,
  PB as useGetMandatoryRequirements,
  pfe as useGetMissingInformationText,
  gfe as useGetReportAbstract,
  vfe as useGetReportHeading,
  hfe as useGetVicSmartEligibility,
  yfe as useShowMandatoryRequirements,
  V2 as useSidebar,
  lY as useToast,
  utt as useWatch
};
//# sourceMappingURL=components.js.map
